import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  CreatedAtSortKey: any;
  Date: any;
  ENCODED_CURSOR: any;
  Email: any;
  Float3Array: any;
  Float4Array: any;
  JSON: any;
  URL: any;
  UUID: any;
};

/** Stripe ACH account details */
export type Ach = {
  __typename: 'Ach';
  address: Maybe<Scalars['String']>;
  address2: Maybe<Scalars['String']>;
  addressCity: Maybe<Scalars['String']>;
  addressCountry: Maybe<Scalars['String']>;
  addressState: Maybe<Scalars['String']>;
  addressZip: Maybe<Scalars['String']>;
  bankName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  last4: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

/** Stripe ACH account information */
export type AchAccount = {
  __typename: 'AchAccount';
  achAccount: Maybe<Ach>;
  id: Maybe<Scalars['String']>;
  referenceId: Maybe<Scalars['String']>;
};

/** possible actions for modifyRoleAndCapabilities */
export enum Action {
  CREATE = 'CREATE',
  REMOVE = 'REMOVE'
}

/** Container for relevant objects stemming from activation of a business account member. */
export type ActivateBusinessAccountMemberResult = {
  __typename: 'ActivateBusinessAccountMemberResult';
  /** Invite created as part of activation. Will exist regardless of email verification status. */
  invite: BusinessAccountInvite;
  /** Membership id if it exists. Will only be present if user's email has already been verified, and the user could be activated automatically. */
  membershipId: Maybe<Scalars['String']>;
};

/**
 * Container representing successful only attempts to activate one or more members.
 * Errors will be thrown as "internal server error" because there is no defined UX for them.
 */
export type ActivateBusinessAccountMembersResult = {
  __typename: 'ActivateBusinessAccountMembersResult';
  /** List of invites associated with member activations. */
  activations: Array<ActivateBusinessAccountMemberResult>;
};

/** An AddExceptionHistoryInput object represents a new ExceptionHistory state change, associated to an exception */
export type AddExceptionFailureHistoryInput = {
  contextKey: InputMaybe<Scalars['String']>;
  createdBy: InputMaybe<Scalars['Int']>;
  exceptionId: InputMaybe<Scalars['UUID']>;
  newValue: Scalars['String'];
  oldValue: Scalars['String'];
};

/** An AddExceptionHistoryInput object represents a new ExceptionHistory state change, associated to an exception */
export type AddExceptionHistoryInput = {
  contextKey: InputMaybe<Scalars['String']>;
  createdBy: InputMaybe<Scalars['Int']>;
  exceptionId: InputMaybe<Scalars['UUID']>;
  newValue: Scalars['String'];
  oldValue: Scalars['String'];
};

/** Container for errors when adding a Team membership */
export type AddUserTeamMembershipError = {
  __typename: 'AddUserTeamMembershipError';
  /** UserId attempted to be added */
  email: Scalars['String'];
  error: Scalars['String'];
};

/** Container representing successful and unsuccessful attempts to add Members to a Team */
export type AddUserTeamMembershipResult = {
  __typename: 'AddUserTeamMembershipResult';
  /** List of UserIds that were not added (with reason) */
  errors: Maybe<Array<Maybe<AddUserTeamMembershipError>>>;
  /** Memberships that were successfully added */
  userTeamMemberships: Maybe<Array<Maybe<UserTeamMembership>>>;
  /** List of users/emails that were added in Business Account Requests */
  usersStaged: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Additional input for IM to accept an optional param specifying whether a user needs ‘fictiv guidance’: */
export type AdditionalConfigInput = {
  userNeedsConfigHelp: InputMaybe<Scalars['Boolean']>;
};

/** Input fields for an address */
export type AddressInput = {
  address1: Scalars['String'];
  address2: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  company: InputMaybe<Scalars['String']>;
  country: InputMaybe<Scalars['String']>;
  /**
   * firstName is currently the same as name because we do not save it in shipping_addresses table
   * and the shipping_options endpoint only requires firstName OR lastName validation
   */
  firstName: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  state: Scalars['String'];
  zip: Scalars['String'];
};

/** Admin-only business account request values for cypress tests */
export type AdminBusinessAccountRequestLinks = {
  __typename: 'AdminBusinessAccountRequestLinks';
  businessAccountId: Scalars['UUID'];
  businessAccountSignupUrl: Maybe<Scalars['String']>;
  teamId: Scalars['Int'];
  teamMemberListUrl: Maybe<Scalars['String']>;
  teamMemberManagementUrl: Maybe<Scalars['String']>;
};

/** Input for admin quoted advanced inspection - admin parameters */
export type AdminInspectionPricingParamsInput = {
  numInspectionPoints: Scalars['Int'];
  numSpecialInspectionPoints: Scalars['Int'];
  percentMarkup: Scalars['Float'];
};

/** Input for filtering list of admin job requests */
export type AdminJobRequestFiltersInput = {
  businessUnits: InputMaybe<Array<Scalars['String']>>;
  countryIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  earliestReceiptDateEnd: InputMaybe<Scalars['String']>;
  earliestReceiptDateStart: InputMaybe<Scalars['String']>;
  earliestScheduledDeliveryDateEnd: InputMaybe<Scalars['String']>;
  earliestScheduledDeliveryDateStart: InputMaybe<Scalars['String']>;
  fromDate: InputMaybe<Scalars['Date']>;
  inspectionStatus: InputMaybe<Array<InputMaybe<JobRequestInspectionStatus>>>;
  jobRequestNameLike: InputMaybe<Scalars['String']>;
  jobRequestState: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  jobRequestStatus: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mfgDriUserId: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mfgPartnerIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mpNameLike: InputMaybe<Scalars['String']>;
  payout: InputMaybe<PayoutFilterInput>;
  priority: InputMaybe<Array<InputMaybe<SalesOrderPriority>>>;
  processTypeIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  projectNameLike: InputMaybe<Scalars['String']>;
  requestDateEnd: InputMaybe<Scalars['String']>;
  requestDateStart: InputMaybe<Scalars['String']>;
  riskState: InputMaybe<JobRequestRiskState>;
  salesOrderNameLike: InputMaybe<Scalars['String']>;
  toDate: InputMaybe<Scalars['Date']>;
};

/** Mutations for only admins */
export type AdminOnlyMutations = {
  __typename: 'AdminOnlyMutations';
  /** mutation to add exception action */
  addExceptionAction: ExceptionAction;
  /** mutation to add exception failure root cause */
  addExceptionFailureRootCause: ExceptionFailureRootCause;
  /** mutation to add exception type */
  addExceptionType: ExceptionType;
  /** admin only initiate password reset */
  initiatePwdReset: User;
  /** mutation to add/remove user's role and capabilities */
  modifyRoleAndCapabilities: User;
  /** admin-only to resend an email verification link */
  resendEmailVerification: Maybe<Scalars['String']>;
  /** mutation to reset locked out users */
  resetLockedOutUser: User;
};


/** Mutations for only admins */
export type AdminOnlyMutationsAddExceptionActionArgs = {
  action: Scalars['String'];
};


/** Mutations for only admins */
export type AdminOnlyMutationsAddExceptionFailureRootCauseArgs = {
  description: Scalars['String'];
};


/** Mutations for only admins */
export type AdminOnlyMutationsAddExceptionTypeArgs = {
  name: Scalars['String'];
};


/** Mutations for only admins */
export type AdminOnlyMutationsModifyRoleAndCapabilitiesArgs = {
  action: Action;
  roleOrCapabilities: RoleAndCapabilities;
};


/** Mutations for only admins */
export type AdminOnlyMutationsResetLockedOutUserArgs = {
  notifyUser: InputMaybe<Scalars['Boolean']>;
};

/** Admin Orders material with attributes */
export type AdminOrderMaterialDetails = {
  __typename: 'AdminOrderMaterialDetails';
  additionalSpecifications: Maybe<MaterialAdditionalSpecifications>;
  color: Maybe<Scalars['String']>;
  colorCode: Maybe<Scalars['String']>;
  dfmNotes: Maybe<MaterialDfmNotes>;
  materialGrade: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  shore: Maybe<Scalars['String']>;
};

/** Admin order search field required */
export type AdminOrderResult = {
  __typename: 'AdminOrderResult';
  businessAccountId: Maybe<Scalars['String']>;
  businessAccountName: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isAdminProjectMember: Maybe<Scalars['Boolean']>;
  isErpOrder: Scalars['Boolean'];
  isProjectAdmin: Maybe<Scalars['Boolean']>;
  isSecure: Maybe<Scalars['Boolean']>;
  orderName: Scalars['String'];
  parts: Maybe<Array<Maybe<OrderSearchPart>>>;
  paymentType: Maybe<Scalars['String']>;
  poNumber: Maybe<Scalars['String']>;
  purchaserEmail: Maybe<Scalars['String']>;
  purchaserId: Maybe<Scalars['Int']>;
  quoteId: Maybe<Scalars['String']>;
  quoteName: Maybe<Scalars['String']>;
  saleOrderId: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  totalAmount: Maybe<Scalars['Float']>;
  userEmail: Maybe<Scalars['String']>;
  userId: Maybe<Scalars['Int']>;
};

/** Order Search Type */
export type AdminOrderSearch = {
  __typename: 'AdminOrderSearch';
  items: Array<AdminOrderResult>;
  page: Maybe<Page>;
  totalCount: Scalars['Int'];
};

/** Admin-only values for cypress tests */
export type AdminUserLinks = {
  __typename: 'AdminUserLinks';
  businessAccountInvitationUrl: Maybe<Scalars['String']>;
  emailVerificationUrl: Maybe<Scalars['String']>;
  teamInvitations: Maybe<Array<Maybe<AdminBusinessAccountRequestLinks>>>;
};

/** Generic Search Type */
export type AdminUserOrderSearch = {
  __typename: 'AdminUserOrderSearch';
  items: Array<Maybe<SalesOrderView>>;
  page: Maybe<Page>;
  totalCount: Scalars['Int'];
  userId: Scalars['Int'];
};

/** Input for advanced inspection in the admin quoting page */
export type AdvancedInspectionDataInput = {
  domesticLeadTimeDays: InputMaybe<Scalars['Int']>;
  mpCost: InputMaybe<Scalars['Int']>;
  notes: InputMaybe<Scalars['String']>;
  numInspectionPoints: Scalars['Int'];
  numSpecialInspectionPoints: Scalars['Int'];
  overseasLeadTimeDays: InputMaybe<Scalars['Int']>;
  percentMarkup: Scalars['Float'];
};

/** Enum for admin job request sort */
export enum AllowedAdminJobRequestSort {
  COUNTRY_ASC = 'COUNTRY_ASC',
  COUNTRY_DESC = 'COUNTRY_DESC',
  EARLIEST_DELIVERY_DATE_ASC = 'EARLIEST_DELIVERY_DATE_ASC',
  EARLIEST_DELIVERY_DATE_DESC = 'EARLIEST_DELIVERY_DATE_DESC',
  EARLIEST_RECEIPT_DATE_ASC = 'EARLIEST_RECEIPT_DATE_ASC',
  EARLIEST_RECEIPT_DATE_DESC = 'EARLIEST_RECEIPT_DATE_DESC',
  MP_NAME_ASC = 'MP_NAME_ASC',
  MP_NAME_DESC = 'MP_NAME_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  PRIORITY_ASC = 'PRIORITY_ASC',
  PRIORITY_DESC = 'PRIORITY_DESC',
  PROJECT_NAME_ASC = 'PROJECT_NAME_ASC',
  PROJECT_NAME_DESC = 'PROJECT_NAME_DESC',
  REQUEST_DATE_ASC = 'REQUEST_DATE_ASC',
  REQUEST_DATE_DESC = 'REQUEST_DATE_DESC',
  SALE_ORDER_NAME_ASC = 'SALE_ORDER_NAME_ASC',
  SALE_ORDER_NAME_DESC = 'SALE_ORDER_NAME_DESC',
  STATE_ASC = 'STATE_ASC',
  STATE_DESC = 'STATE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VENDOR_DUE_DATE_ASC = 'VENDOR_DUE_DATE_ASC',
  VENDOR_DUE_DATE_DESC = 'VENDOR_DUE_DATE_DESC'
}

/** Allowed attachment from sources */
export enum AllowedAttachmentSources {
  MP = 'MP',
  QC = 'QC'
}

/** Enum for the allowed sort on Exceptions */
export enum AllowedExceptionsSort {
  ACTION_ASC = 'ACTION_ASC',
  ACTION_DESC = 'ACTION_DESC',
  ASSIGNEE_ASC = 'ASSIGNEE_ASC',
  ASSIGNEE_DESC = 'ASSIGNEE_DESC',
  CAR_NAME_ASC = 'CAR_NAME_ASC',
  CAR_NAME_DESC = 'CAR_NAME_DESC',
  CAR_STATUS_ASC = 'CAR_STATUS_ASC',
  CAR_STATUS_DESC = 'CAR_STATUS_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  EARLIEST_DELIVERY_DATE_ASC = 'EARLIEST_DELIVERY_DATE_ASC',
  EARLIEST_DELIVERY_DATE_DESC = 'EARLIEST_DELIVERY_DATE_DESC',
  EARLIEST_RECEIPT_DATE_ASC = 'EARLIEST_RECEIPT_DATE_ASC',
  EARLIEST_RECEIPT_DATE_DESC = 'EARLIEST_RECEIPT_DATE_DESC',
  EARLIEST_SHIP_DATE_ASC = 'EARLIEST_SHIP_DATE_ASC',
  EARLIEST_SHIP_DATE_DESC = 'EARLIEST_SHIP_DATE_DESC',
  MP_CAR_TURNAROUND_DAYS_ASC = 'MP_CAR_TURNAROUND_DAYS_ASC',
  MP_CAR_TURNAROUND_DAYS_DESC = 'MP_CAR_TURNAROUND_DAYS_DESC',
  MP_NAME_ASC = 'MP_NAME_ASC',
  MP_NAME_DESC = 'MP_NAME_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  SALE_ORDER_NAME_ASC = 'SALE_ORDER_NAME_ASC',
  SALE_ORDER_NAME_DESC = 'SALE_ORDER_NAME_DESC',
  STATUS_ASC = 'STATUS_ASC',
  STATUS_DESC = 'STATUS_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  WORK_ORDER_NAME_ASC = 'WORK_ORDER_NAME_ASC',
  WORK_ORDER_NAME_DESC = 'WORK_ORDER_NAME_DESC',
  WORK_ORDER_REQUEST_DATE_ASC = 'WORK_ORDER_REQUEST_DATE_ASC',
  WORK_ORDER_REQUEST_DATE_DESC = 'WORK_ORDER_REQUEST_DATE_DESC'
}

/** Allowed types for Work Order inspection documents */
export enum AllowedInspectionDocumentType {
  additionalDoc = 'additionalDoc',
  advancedInspection = 'advancedInspection',
  certificateOfConformance = 'certificateOfConformance',
  fictiv5 = 'fictiv5',
  manufacturingDrawing = 'manufacturingDrawing',
  materialCertification = 'materialCertification',
  partPhoto = 'partPhoto',
  unknown = 'unknown'
}

/** Allowed types for inspectionTypes */
export enum AllowedInspectionType {
  dimensional = 'dimensional',
  general = 'general',
  not_applicable = 'not_applicable',
  visual = 'visual'
}

/** Enum for jobs sort */
export enum AllowedJobsSort {
  JOB_DUE_DATE = 'JOB_DUE_DATE',
  LEAD_TIME = 'LEAD_TIME',
  PAYOUT = 'PAYOUT',
  PRIORITY = 'PRIORITY'
}

/** Enum for jobs sort order */
export enum AllowedJobsSortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

/** Allowed MfgPartner Sort Type */
export enum AllowedMfgPartnerLevelsSort {
  ACCEPTANCE_RATIO_ASC = 'ACCEPTANCE_RATIO_ASC',
  ACCEPTANCE_RATIO_DESC = 'ACCEPTANCE_RATIO_DESC',
  CAR_TURNAROUND_DAYS_ASC = 'CAR_TURNAROUND_DAYS_ASC',
  CAR_TURNAROUND_DAYS_DESC = 'CAR_TURNAROUND_DAYS_DESC',
  EXPIRATION_RATIO_ASC = 'EXPIRATION_RATIO_ASC',
  EXPIRATION_RATIO_DESC = 'EXPIRATION_RATIO_DESC',
  IF_RATIO_ASC = 'IF_RATIO_ASC',
  IF_RATIO_DESC = 'IF_RATIO_DESC',
  OT_RATIO_ASC = 'OT_RATIO_ASC',
  OT_RATIO_DESC = 'OT_RATIO_DESC'
}

/** Enum for mfg partners sort */
export enum AllowedMfgPartnerSort {
  ACCEPTANCE_RATIO_ASC = 'ACCEPTANCE_RATIO_ASC',
  ACCEPTANCE_RATIO_DESC = 'ACCEPTANCE_RATIO_DESC',
  CAR_TURNAROUND_DAYS_ASC = 'CAR_TURNAROUND_DAYS_ASC',
  CAR_TURNAROUND_DAYS_DESC = 'CAR_TURNAROUND_DAYS_DESC',
  COUNTRY_ASC = 'COUNTRY_ASC',
  COUNTRY_DESC = 'COUNTRY_DESC',
  EXPIRATION_RATIO_ASC = 'EXPIRATION_RATIO_ASC',
  EXPIRATION_RATIO_DESC = 'EXPIRATION_RATIO_DESC',
  IF_RATIO_ASC = 'IF_RATIO_ASC',
  IF_RATIO_DESC = 'IF_RATIO_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  OPEN_CARS_ASC = 'OPEN_CARS_ASC',
  OPEN_CARS_DESC = 'OPEN_CARS_DESC',
  OPEN_FAILURES_ASC = 'OPEN_FAILURES_ASC',
  OPEN_FAILURES_DESC = 'OPEN_FAILURES_DESC',
  OPEN_JOBS_ASC = 'OPEN_JOBS_ASC',
  OPEN_JOBS_DESC = 'OPEN_JOBS_DESC',
  OT_RATIO_ASC = 'OT_RATIO_ASC',
  OT_RATIO_DESC = 'OT_RATIO_DESC'
}

/** Allowed Quality document types */
export enum AllowedQualityAttachmentTypes {
  ADDITIONAL_DOCS = 'ADDITIONAL_DOCS',
  ADVANCED_INSPECTION = 'ADVANCED_INSPECTION',
  CERTIFICATE_OF_CONFORMANCE = 'CERTIFICATE_OF_CONFORMANCE',
  FICTIV5 = 'FICTIV5',
  MATERIAL_CERTIFICATION = 'MATERIAL_CERTIFICATION',
  PHOTOS = 'PHOTOS'
}

/** Enum for the allowed requirement targets */
export enum AllowedRequirementTarget {
  annotation = 'annotation',
  attachment = 'attachment',
  quote_attachment_revision = 'quote_attachment_revision',
  quote_model_revision = 'quote_model_revision',
  revision = 'revision'
}

/** Enum for the allowed sort on SalesOrders */
export enum AllowedSalesOrderSort {
  CAR_COUNT_ASC = 'CAR_COUNT_ASC',
  CAR_COUNT_DESC = 'CAR_COUNT_DESC',
  COMMITTED_DELIVERY_DATE_ASC = 'COMMITTED_DELIVERY_DATE_ASC',
  COMMITTED_DELIVERY_DATE_DESC = 'COMMITTED_DELIVERY_DATE_DESC',
  EARLIEST_DELIVERY_DATE_ASC = 'EARLIEST_DELIVERY_DATE_ASC',
  EARLIEST_DELIVERY_DATE_DESC = 'EARLIEST_DELIVERY_DATE_DESC',
  EARLIEST_SHIP_DATE_ASC = 'EARLIEST_SHIP_DATE_ASC',
  EARLIEST_SHIP_DATE_DESC = 'EARLIEST_SHIP_DATE_DESC',
  EXCEPTION_COUNT_ASC = 'EXCEPTION_COUNT_ASC',
  EXCEPTION_COUNT_DESC = 'EXCEPTION_COUNT_DESC',
  JOB_COUNT_ASC = 'JOB_COUNT_ASC',
  JOB_COUNT_DESC = 'JOB_COUNT_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  ORDER_DATE_ASC = 'ORDER_DATE_ASC',
  ORDER_DATE_DESC = 'ORDER_DATE_DESC',
  PRIORITY_ASC = 'PRIORITY_ASC',
  PRIORITY_DESC = 'PRIORITY_DESC',
  PROJECT_NAME_ASC = 'PROJECT_NAME_ASC',
  PROJECT_NAME_DESC = 'PROJECT_NAME_DESC',
  REGION_ASC = 'REGION_ASC',
  REGION_DESC = 'REGION_DESC',
  WORK_ORDER_COUNT_ASC = 'WORK_ORDER_COUNT_ASC',
  WORK_ORDER_COUNT_DESC = 'WORK_ORDER_COUNT_DESC'
}

/** Enum for scheduling sales order sort */
export enum AllowedSchedulingSalesOrderSort {
  EARLIST_SCHEDULED_DATE = 'EARLIST_SCHEDULED_DATE',
  PRIORITY = 'PRIORITY',
  UNBUNDLED_PART_PAYOUT = 'UNBUNDLED_PART_PAYOUT'
}

/** Enum for scheduling sales order sort order */
export enum AllowedSchedulingSalesOrderSortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

/** Allowed Subject Types */
export enum AllowedSubjectTypes {
  ADDITIONAL_PHOTOS_NEEDED = 'ADDITIONAL_PHOTOS_NEEDED',
  CAPACITY = 'CAPACITY',
  DUE_DATE = 'DUE_DATE',
  JOB_DELAY = 'JOB_DELAY',
  MATERIAL_SOURCING = 'MATERIAL_SOURCING',
  MISSING_FICTIV5_REPORT = 'MISSING_FICTIV5_REPORT',
  MISSING_PART_PHOTOS = 'MISSING_PART_PHOTOS',
  MISSING_REQUIRED_ADDITIONAL_DOCUMENT = 'MISSING_REQUIRED_ADDITIONAL_DOCUMENT',
  NEED_CLARIFICATION = 'NEED_CLARIFICATION',
  OTHER = 'OTHER',
  OUT_OF_SPEC = 'OUT_OF_SPEC',
  PRICING = 'PRICING',
  PROBLEM_IN_PRODUCTION = 'PROBLEM_IN_PRODUCTION',
  VERIFY_AN_INSPECTION_POINT = 'VERIFY_AN_INSPECTION_POINT',
  WORKFLOW = 'WORKFLOW'
}

/** Allowed States */
export enum AllowedWorkOrderItemInspectionStates {
  completed = 'completed',
  in_progress = 'in_progress',
  not_applicable = 'not_applicable',
  not_started = 'not_started'
}

/** Discount code that is worth a specific amount */
export type AmountBasedDiscount = {
  __typename: 'AmountBasedDiscount';
  code: Maybe<Scalars['String']>;
  dollarAmount: Scalars['Float'];
  expirationDate: Maybe<Scalars['Date']>;
  firstOrderOnly: Maybe<Scalars['Boolean']>;
  impermissibleEmailDomains: Maybe<Array<Scalars['String']>>;
  numUsagesAllowed: Maybe<Scalars['Int']>;
  permissibleEmailDomain: Maybe<Scalars['String']>;
  userSignupCutoffDate: Maybe<Scalars['Date']>;
};

/** A Annotated version of an attachment */
export type AnnotatedAttachment = {
  __typename: 'AnnotatedAttachment';
  createdAt: Scalars['Date'];
  deletedAt: Maybe<Scalars['Date']>;
  downloadUrl: Maybe<Scalars['String']>;
  extension: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  id: Scalars['UUID'];
  mimeType: Maybe<Scalars['String']>;
  sizeInKb: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Date'];
  uploadUrl: Maybe<Scalars['String']>;
};

/** Annotated drawing - this is combination of original pdf and all annotations */
export type AnnotatedDrawingAttachment = {
  __typename: 'AnnotatedDrawingAttachment';
  attachmentId: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  signedDownloadUrl: Maybe<Scalars['String']>;
};

/** Annotation on an estimate */
export type Annotation = {
  __typename: 'Annotation';
  accepted: Scalars['Boolean'];
  createdAt: Scalars['Date'];
  deletedAt: Maybe<Scalars['Date']>;
  feature: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  message: Maybe<Scalars['String']>;
  position: Scalars['JSON'];
  requirements: Array<Requirement>;
  revision: Maybe<Revision>;
  severity: Scalars['String'];
  sortWeight: Maybe<Scalars['Int']>;
  target: Scalars['JSON'];
  threads: Array<Thread>;
  type: Scalars['String'];
  updatedAt: Scalars['Date'];
};


/** Annotation on an estimate */
export type AnnotationThreadsArgs = {
  resolved?: InputMaybe<Scalars['Boolean']>;
};

/** An thickness for anodizing, should eventually be defined with other configuration properties */
export type AnodizingThickness = {
  __typename: 'AnodizingThickness';
  id: Scalars['String'];
};

/** A binary attachment. */
export type Asset = {
  __typename: 'Asset';
  createdAt: Scalars['Date'];
  deletedAt: Maybe<Scalars['Date']>;
  downloadUrl: Maybe<Scalars['String']>;
  extension: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  id: Scalars['UUID'];
  mimeType: Maybe<Scalars['String']>;
  sanitized: Maybe<SanitizedAttachment>;
  sizeInKb: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Date'];
  uploadUrl: Maybe<Scalars['String']>;
};

/** Mapping of an Asset Bundle and Attachment */
export type AssetBundleAttachment = {
  __typename: 'AssetBundleAttachment';
  assetBundleId: Scalars['String'];
  attachmentId: Scalars['String'];
  attachmentType: Scalars['String'];
  attachments: Maybe<Attachment>;
};

/** Allowed assetTypes */
export enum AssetType {
  pdf = 'pdf',
  ppt = 'ppt'
}

/** Enum for Assigned entities */
export enum AssignedEntityType {
  FICTIV = 'FICTIV',
  MP = 'MP'
}

/** A binary attachment. */
export type Attachment = {
  __typename: 'Attachment';
  annotated: Maybe<AnnotatedAttachment>;
  createdAt: Scalars['Date'];
  deletedAt: Maybe<Scalars['Date']>;
  downloadUrl: Maybe<Scalars['String']>;
  extension: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  hasITARRestrictions: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  mimeType: Maybe<Scalars['String']>;
  modelAttachmentSanitizations: Array<ModelAttachmentSelection>;
  modelAttachmentSelections: Array<ModelAttachmentSelection>;
  sanitized: Maybe<SanitizedAttachment>;
  sizeInKb: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Date'];
  uploadUrl: Maybe<Scalars['String']>;
  /** @deprecated Field no longer supported */
  user: BasicUser;
};

/** Enum for allowed Attachment type in AttachmentInput */
export enum AttachmentCreateType {
  annotated = 'annotated',
  auto_generated = 'auto_generated',
  user_auto_generated = 'user_auto_generated',
  user_uploaded = 'user_uploaded'
}

/** Input for creating an attachment */
export type AttachmentInput = {
  extension: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  mimeType: InputMaybe<Scalars['String']>;
  type: InputMaybe<AttachmentCreateType>;
};

/** Possible authorization roles */
export enum AuthRole {
  admin = 'admin',
  user = 'user'
}

/** The full autoConfiguration query response */
export type AutoConfiguration = {
  __typename: 'AutoConfiguration';
  extractedConfiguration: Maybe<AutoconfigurationExtractedConfiguration>;
  filename: Scalars['String'];
  pdfOcrData: Maybe<Scalars['JSON']>;
  quoteModelRevisionId: Scalars['String'];
};

/** output of the autoCorrectMultiPostProcessesOrdering */
export type AutoCorrectedOutput = {
  __typename: 'AutoCorrectedOutput';
  /** list of post processes autocorrected to be in order permitted by the rules engine */
  autoCorrectedPostProcesses: Array<PostProcess>;
  /** list of post processes that needed to be removed in order to form auto corrected list */
  conflictingPostProcesses: Array<PostProcess>;
};

/** Contains the data to configure a part and the corresponding strings that were found in drawing */
export type AutoconfigurationExtractedConfiguration = {
  __typename: 'AutoconfigurationExtractedConfiguration';
  canAutoConfigure: Scalars['Boolean'];
  materialDetections: Array<AutoconfigurationExtractedConfigurationMaterialDetections>;
  primaryProcessConfig: Maybe<AutoconfigurationPrimaryProcessConfig>;
  quoteModelRevisionId: Scalars['String'];
  secondaryProcessConfigs: Array<AutoconfigurationSecondaryProcessDetectionsConfiguration>;
  secondaryProcessDetections: Array<AutoconfigurationSecondaryProcessDetections>;
  tooltipNote: Maybe<Scalars['String']>;
  usableTextFoundInDrawing: Scalars['Boolean'];
};

/** Material detection detected text and corresponding platform id */
export type AutoconfigurationExtractedConfigurationMaterialDetections = {
  __typename: 'AutoconfigurationExtractedConfigurationMaterialDetections';
  displayString: Scalars['String'];
  platformId: Maybe<Scalars['String']>;
  tooltipNote: Maybe<Scalars['String']>;
  valid: Scalars['Boolean'];
};

/** Post process configuration info */
export type AutoconfigurationPrimaryProcessConfig = {
  __typename: 'AutoconfigurationPrimaryProcessConfig';
  colorCode: Maybe<Scalars['String']>;
  materialGrade: Maybe<Scalars['String']>;
  materialId: Scalars['String'];
  priorityId: Maybe<Scalars['String']>;
  processId: Scalars['String'];
  quantity: Scalars['Int'];
  textureCode: Maybe<Scalars['String']>;
};

/** The secondary post process configuration data and strings found in customer drawing */
export type AutoconfigurationSecondaryProcessDetections = {
  __typename: 'AutoconfigurationSecondaryProcessDetections';
  configuration: Maybe<AutoconfigurationSecondaryProcessDetectionsConfiguration>;
  displayString: Scalars['String'];
  hashString: Scalars['String'];
  tooltipNote: Maybe<Scalars['String']>;
  valid: Scalars['Boolean'];
};

/** Secondary post process configuration data */
export type AutoconfigurationSecondaryProcessDetectionsConfiguration = {
  __typename: 'AutoconfigurationSecondaryProcessDetectionsConfiguration';
  processColorId: Maybe<Scalars['String']>;
  processId: Maybe<Scalars['String']>;
  processInspectionCriteria: Maybe<ProcessInspectionCriteria>;
  processNumParts: Maybe<Scalars['Int']>;
  processThicknessInInches: Maybe<Scalars['Int']>;
};

/** setShopProcessAvailability mutation input */
export type AvailabilityInput = {
  accepting: Scalars['Boolean'];
  available: InputMaybe<Scalars['Boolean']>;
  date: Scalars['Date'];
  processId: Scalars['Int'];
};

/** Basic CAR information */
export type BasicCarInfo = {
  __typename: 'BasicCarInfo';
  id: Scalars['UUID'];
  name: Scalars['String'];
  status: Scalars['String'];
  turnaroundDays: Maybe<Scalars['Float']>;
  type: Scalars['String'];
};

/** Basic Discount usage by user */
export type BasicDiscountUsage = {
  __typename: 'BasicDiscountUsage';
  code: Scalars['String'];
  codeReset: Scalars['Boolean'];
  createdAt: Scalars['Date'];
  createdBy: Scalars['Int'];
  id: Scalars['String'];
  quoteId: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy: Scalars['Int'];
};

/** Basic exception details */
export type BasicException = {
  __typename: 'BasicException';
  /** computed field using exception status & otif_is_active */
  exceptionState: Maybe<Scalars['String']>;
  /** Exception ID */
  id: Scalars['String'];
  /** IF failure flag for Fictiv */
  ifFailureFictiv: Maybe<Scalars['Boolean']>;
  /** IF failure flag for MP */
  ifFailureMp: Maybe<Scalars['Boolean']>;
  /** Exception name */
  name: Scalars['String'];
  /** OT failure flag for Fictiv */
  otFailureFictiv: Maybe<Scalars['Boolean']>;
  /** OT failure days for Fictiv */
  otFailureFictivDays: Maybe<Scalars['Int']>;
  /** OT failure flag for MP */
  otFailureMp: Maybe<Scalars['Boolean']>;
  /** OT failure days for MP */
  otFailureMpDays: Maybe<Scalars['Int']>;
};

/** Basic exception details */
export type BasicExceptionFailure = {
  __typename: 'BasicExceptionFailure';
  additionalContext: Maybe<Scalars['String']>;
  assignedEntity: Maybe<Scalars['String']>;
  daysLate: Maybe<Scalars['Int']>;
  exceptionFailureAttachments: Maybe<Array<ExceptionFailureAttachment>>;
  exceptionFailureParts: Maybe<Array<ExceptionPart>>;
  exceptionFailureState: Scalars['String'];
  /** Exception ID */
  id: Scalars['String'];
  isCustomerImpacted: Maybe<Scalars['Boolean']>;
  milestoneType: Maybe<Scalars['String']>;
  /** MP note in case of exception created by MP */
  mpNote: Maybe<Scalars['String']>;
  mpSuggestedDate: Maybe<Scalars['Date']>;
  /** Exception name */
  name: Scalars['String'];
  /** exception type */
  type: Scalars['String'];
};

/** Basic manufacturing partner details */
export type BasicMfgPartner = {
  __typename: 'BasicMfgPartner';
  /** Manufacturing partner ID */
  id: Scalars['Int'];
  /** Manufacturing partner name */
  name: Scalars['String'];
};

/** BasicMoldTool type */
export type BasicMoldTool = {
  __typename: 'BasicMoldTool';
  id: Scalars['String'];
  moldToolRevisionId: Scalars['String'];
  name: Scalars['String'];
  version: Maybe<Scalars['Int']>;
};

/** A minimal subset of Project properties */
export type BasicProject = {
  __typename: 'BasicProject';
  id: Maybe<Scalars['UUID']>;
  isSecurePlus: Scalars['Boolean'];
  name: Scalars['String'];
};

/** type for basic purchase information for a quote */
export type BasicPurchaseInfo = {
  __typename: 'BasicPurchaseInfo';
  purchasedDate: Maybe<Scalars['Date']>;
  purchaserEmail: Maybe<Scalars['String']>;
  purchaserUserId: Maybe<Scalars['Int']>;
};

/** Basic/restricted view of information pertaining to a quote */
export type BasicQuote = {
  __typename: 'BasicQuote';
  id: Scalars['UUID'];
  lastModified: Scalars['Date'];
  name: Scalars['String'];
  project: Maybe<BasicProject>;
};

/** Revision data associated with this digital modal which can be shared with Fictiv partners. */
export type BasicRevision = {
  __typename: 'BasicRevision';
  boundingBox: Maybe<Vector3>;
  images: Maybe<RevisionImages>;
  sceneBundle: Maybe<Scalars['JSON']>;
};

/** Basic/restricted view of information pertaining to a sales order */
export type BasicSalesOrder = {
  __typename: 'BasicSalesOrder';
  /** The date on which the order was placed. */
  createdAt: Scalars['Date'];
  /** The status would be decided based on the line items, and can have ('pending production','in production','shipped'). */
  deliveryStatus: Scalars['String'];
  /** A unique identifier */
  id: Scalars['String'];
  /** Unique, human readable name of this sale order.  Looks like "moose6377". */
  name: Scalars['String'];
  /** Basic meta about parent project, if exists */
  project: Maybe<BasicProject>;
  /** The date computed from the max shipped on date of the delivery order. */
  shippedBy: Maybe<Scalars['Date']>;
  /** The total cost of order placed. */
  totalAmount: Scalars['Int'];
};

/** A Fictiv user less personal details */
export type BasicUser = {
  __typename: 'BasicUser';
  createdAt: Scalars['Date'];
  displayName: Scalars['String'];
  email: Scalars['Email'];
  enabled: Scalars['Boolean'];
  firstName: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
};

/**
 * An operation that is related to more than one part
 * Example use case: lot-based finishing
 */
export type BatchLineItem = {
  __typename: 'BatchLineItem';
  anodizingThickness: Maybe<AnodizingThickness>;
  color: Maybe<Color>;
  id: Scalars['String'];
  memberIds: Array<Scalars['UUID']>;
  perPartUnitPriceInCents: Scalars['Int'];
  postProcess: Maybe<PostProcess>;
  process: Maybe<Process>;
  processType: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
  unitPriceInCents: Scalars['Float'];
};

/** Allowed States */
export enum BidStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  LOST = 'LOST',
  WON = 'WON'
}

/** input fields for editCreditCard */
export type BillingInfoInput = {
  address: InputMaybe<Scalars['String']>;
  address2: InputMaybe<Scalars['String']>;
  addressCity: InputMaybe<Scalars['String']>;
  addressCountry: InputMaybe<Scalars['String']>;
  addressState: InputMaybe<Scalars['String']>;
  addressZip: InputMaybe<Scalars['String']>;
  name: InputMaybe<Scalars['String']>;
};

/** Dimensions of a box */
export type BoundingBox = {
  __typename: 'BoundingBox';
  length: Scalars['Float'];
  thickness: Scalars['Float'];
  width: Scalars['Float'];
};

/** Dimensions of a cylinder */
export type BoundingCylinder = {
  __typename: 'BoundingCylinder';
  diameter: Scalars['Float'];
  length: Scalars['Float'];
};

/** Builder and MP price type */
export type BuilderAndMpPrice = {
  __typename: 'BuilderAndMpPrice';
  builderPrice: Maybe<Price>;
  manufacturingAllowedInRegion: Maybe<Scalars['Boolean']>;
  manufacturingPartnerPrice: Maybe<Price>;
};

/** Connects related members, quotes, and orders to an owning Business */
export type BusinessAccount = {
  __typename: 'BusinessAccount';
  createdAt: Scalars['Date'];
  createdBy: User;
  discount: Maybe<BusinessAccountDiscount>;
  enabledAt: Maybe<Scalars['Date']>;
  enabledBy: Maybe<User>;
  excludedCountries: Maybe<Array<Maybe<BusinessAccountExcludedCountry>>>;
  id: Scalars['UUID'];
  isEnabled: Scalars['Boolean'];
  isTeamsFeatureEnabled: Maybe<Scalars['Boolean']>;
  members: PartialBusinessAccountMembershipResults;
  name: Scalars['String'];
  salesforceAccount: Maybe<SalesforceAccount>;
  salesforceAccountId: Scalars['String'];
  subscription: Maybe<BusinessAccountSubscription>;
  subscriptionHistory: PartialBusinessAccountSubscriptionHistoryResults;
  totalMembers: Scalars['Int'];
  totalTeams: Scalars['Int'];
  updatedAt: Scalars['Date'];
  updatedBy: User;
};


/** Connects related members, quotes, and orders to an owning Business */
export type BusinessAccountMembersArgs = {
  cursor: InputMaybe<Scalars['ENCODED_CURSOR']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['CreatedAtSortKey']>;
};


/** Connects related members, quotes, and orders to an owning Business */
export type BusinessAccountSubscriptionHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** Information about a user who is a salesforce contact of the business account */
export type BusinessAccountContact = {
  __typename: 'BusinessAccountContact';
  lastLoginDate: Maybe<Scalars['Date']>;
  salesforceContactUrl: Maybe<Scalars['String']>;
  status: Maybe<BusinessAccountContactStatus>;
  user: Maybe<BasicUser>;
};

/** Enum of all BusinessAccountContactStatus */
export enum BusinessAccountContactStatus {
  invitation_expired = 'invitation_expired',
  member = 'member',
  not_invited = 'not_invited',
  pending_email_verification = 'pending_email_verification',
  requested = 'requested'
}

/** Input for BusinessAccountContactsQuery */
export type BusinessAccountContactsFilterInput = {
  businessAccountId: Scalars['String'];
  membershipFilters: InputMaybe<Array<BusinessAccountMembershipFilterType>>;
  searchText: InputMaybe<Scalars['String']>;
};

/** Enum for allowed sort in BusinessAccountContactsQuery */
export enum BusinessAccountContactsQuerySortInput {
  EMAIL_ASC = 'EMAIL_ASC',
  EMAIL_DESC = 'EMAIL_DESC',
  FIRST_NAME_ASC = 'FIRST_NAME_ASC',
  FIRST_NAME_DESC = 'FIRST_NAME_DESC',
  LAST_NAME_ASC = 'LAST_NAME_ASC',
  LAST_NAME_DESC = 'LAST_NAME_DESC'
}

/** Enum to dictate the contact attribute by which the target data should be sorted */
export enum BusinessAccountContactsSortAttributeInput {
  email = 'email',
  first_name = 'first_name',
  last_name = 'last_name'
}

/** Input to specify how the target data should be sorted */
export type BusinessAccountContactsSortInput = {
  attribute: InputMaybe<BusinessAccountContactsSortAttributeInput>;
  order: InputMaybe<SortOrderInput>;
};

/** Input for enabling a business account */
export type BusinessAccountDataInput = {
  salesforceAccountId: InputMaybe<Scalars['String']>;
};

/** Field in BusinessAccount, */
export type BusinessAccountDiscount = {
  __typename: 'BusinessAccountDiscount';
  createdAt: Scalars['Date'];
  createdBy: BasicUser;
  deletedAt: Maybe<Scalars['Date']>;
  deletedBy: Maybe<BasicUser>;
  endAt: Scalars['Date'];
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  notes: Maybe<Scalars['String']>;
  percent: Scalars['Float'];
  platformUuid: Scalars['UUID'];
  salesforceOpportunityId: Scalars['String'];
  salesforceOpportunityName: Scalars['String'];
  startAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
  updatedBy: BasicUser;
};

/** Input for business account discount */
export type BusinessAccountDiscountDataInput = {
  endDate: Scalars['Date'];
  notes: InputMaybe<Scalars['String']>;
  percent: Scalars['Float'];
  salesforceOpportunityId: Scalars['String'];
  salesforceOpportunityName: Scalars['String'];
  startDate: Scalars['Date'];
};

/** result of query isBusinessAccountDiscount */
export type BusinessAccountDiscountValidation = {
  __typename: 'BusinessAccountDiscountValidation';
  isValid: Scalars['Boolean'];
  msg: Maybe<Scalars['String']>;
};

/** Enum of allowed country IDs for excluded countries */
export enum BusinessAccountExcludedCountriesInput {
  IN = 'IN',
  MX = 'MX'
}

/** Country that the Business Account excludes its orders from */
export type BusinessAccountExcludedCountry = {
  __typename: 'BusinessAccountExcludedCountry';
  name: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

/** Type representing a Business Account feature enablement. */
export type BusinessAccountFeature = {
  __typename: 'BusinessAccountFeature';
  businessAccountId: Scalars['UUID'];
  featureName: BusinessAccountFeatureInput;
  id: Scalars['UUID'];
  isEnabled: Scalars['Boolean'];
  updatedAt: Scalars['Date'];
};

/** Types of Business Account Features */
export enum BusinessAccountFeatureInput {
  clt_optimizer = 'clt_optimizer',
  consultative_dfm = 'consultative_dfm',
  po_enabled = 'po_enabled',
  tax_exempt = 'tax_exempt',
  teams = 'teams'
}

/** Specialized type of invitation for adding users to a business account */
export type BusinessAccountInvite = {
  __typename: 'BusinessAccountInvite';
  acceptDate: Maybe<Scalars['Date']>;
  email: Scalars['String'];
  id: Scalars['UUID'];
  inviteUrl: Maybe<Scalars['String']>;
  requestedDate: Maybe<Scalars['Date']>;
  sentDate: Maybe<Scalars['Date']>;
  status: BusinessAccountInviteStatus;
};

/** The status of the business account */
export enum BusinessAccountInviteStatus {
  accepted = 'accepted',
  expired = 'expired',
  not_requested = 'not_requested',
  pending_account_creation = 'pending_account_creation',
  pending_email_verification = 'pending_email_verification',
  requested = 'requested'
}

/** Input for BusinessAccountMembersQuery */
export type BusinessAccountMembersFilterInput = {
  businessAccountId: InputMaybe<Scalars['String']>;
  membershipStatus: InputMaybe<BusinessAccountMembershipStatus>;
  membershipStatuses: InputMaybe<Array<BusinessAccountMembershipStatus>>;
  searchText: InputMaybe<Scalars['String']>;
};

/** Enum for allowed sort in BusinessAccountMembersQuery */
export enum BusinessAccountMembersQuerySortInput {
  EMAIL_ASC = 'EMAIL_ASC',
  EMAIL_DESC = 'EMAIL_DESC',
  FIRST_NAME_ASC = 'FIRST_NAME_ASC',
  FIRST_NAME_DESC = 'FIRST_NAME_DESC',
  LAST_NAME_ASC = 'LAST_NAME_ASC',
  LAST_NAME_DESC = 'LAST_NAME_DESC'
}

/** BusinessAccountMembership is represented by a list of users in a BusinessAccount. */
export type BusinessAccountMembership = {
  __typename: 'BusinessAccountMembership';
  businessAccount: BusinessAccount;
  capabilities: Maybe<Array<Scalars['String']>>;
  createdAt: Maybe<Scalars['Date']>;
  createdBy: User;
  id: Scalars['UUID'];
  lastLoginDate: Maybe<Scalars['Date']>;
  salesforceContactUrl: Maybe<Scalars['String']>;
  user: User;
};

/** Enum for membership status filter input */
export enum BusinessAccountMembershipFilterType {
  invited = 'invited',
  member = 'member',
  non_member = 'non_member',
  not_invited = 'not_invited'
}

/** Type for business account request banner for potential businessAccount members */
export type BusinessAccountMembershipRequestBanner = {
  __typename: 'BusinessAccountMembershipRequestBanner';
  businessAccountId: Scalars['UUID'];
  businessAccountName: Scalars['String'];
  description: Scalars['String'];
  message: Scalars['String'];
};

/** Status of business account membership used for filtering */
export enum BusinessAccountMembershipStatus {
  active = 'active',
  deactivated = 'deactivated'
}

/** Summary of order associated with a business account */
export type BusinessAccountOrder = {
  __typename: 'BusinessAccountOrder';
  createdAt: Scalars['Date'];
  id: Scalars['String'];
  name: Maybe<Scalars['String']>;
  purchaserEmail: Scalars['String'];
  purchaserId: Scalars['Int'];
  status: Scalars['String'];
  updatedAt: Scalars['Date'];
};

/** Input container for filters when searching for orders */
export type BusinessAccountOrdersFilterInput = {
  businessAccountId: InputMaybe<Scalars['String']>;
  searchText: InputMaybe<Scalars['String']>;
};

/** Information about a user or invitee who is not yet a member of the business account */
export type BusinessAccountPendingMember = {
  __typename: 'BusinessAccountPendingMember';
  capabilities: Array<Scalars['String']>;
  invite: Maybe<BusinessAccountInvite>;
  lastLoginDate: Maybe<Scalars['Date']>;
  salesforceContactUrl: Maybe<Scalars['String']>;
  user: Maybe<BasicUser>;
};

/** Input for businessAccountPendingMembersQuery */
export type BusinessAccountPendingMembersFilterInput = {
  businessAccountId: InputMaybe<Scalars['String']>;
  inviteStatus: InputMaybe<BusinessAccountInviteStatus>;
  inviteStatuses: InputMaybe<Array<BusinessAccountInviteStatus>>;
  searchText: InputMaybe<Scalars['String']>;
};

/** Enum for allowed sort in businessAccountPendingMembersQuery */
export enum BusinessAccountPendingMembersQuerySortInput {
  EMAIL_ASC = 'EMAIL_ASC',
  EMAIL_DESC = 'EMAIL_DESC'
}

/** Business Account Plan */
export type BusinessAccountPlan = {
  __typename: 'BusinessAccountPlan';
  durationDays: Scalars['Int'];
  id: Scalars['Int'];
  isEnabled: Scalars['Boolean'];
  planId: Scalars['UUID'];
  planName: Scalars['String'];
};

/** Business Account Punchout Feature */
export type BusinessAccountPunchoutFeature = {
  __typename: 'BusinessAccountPunchoutFeature';
  businessAccountId: Scalars['UUID'];
  createdAt: Scalars['Date'];
  createdBy: Scalars['Int'];
  disabledProcesses: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  sharedSecret: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy: Scalars['Int'];
};

/** Summary of quote associated with a business account */
export type BusinessAccountQuote = {
  __typename: 'BusinessAccountQuote';
  createdAt: Scalars['Date'];
  ownerEmail: Scalars['String'];
  ownerEnabled: Scalars['Boolean'];
  ownerId: Scalars['Int'];
  quoteId: Scalars['String'];
  quoteName: Scalars['String'];
  status: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
};

/** Input container for filters when searching for quotes */
export type BusinessAccountQuotesFilterInput = {
  businessAccountId: Scalars['String'];
  searchText: InputMaybe<Scalars['String']>;
};

/** Current status of user in relation to its business account */
export enum BusinessAccountSignupStatus {
  access_requested = 'access_requested',
  activated_member = 'activated_member',
  eligible_to_join = 'eligible_to_join',
  not_eligible = 'not_eligible',
  pending_email_verification = 'pending_email_verification'
}

/** Business Account Subscription */
export type BusinessAccountSubscription = {
  __typename: 'BusinessAccountSubscription';
  businessAccountId: Scalars['UUID'];
  disabledAt: Maybe<Scalars['Date']>;
  disabledBy: Maybe<User>;
  durationDays: Scalars['Int'];
  enabledAt: Scalars['Date'];
  enabledBy: User;
  expiresAt: Scalars['Date'];
  id: Scalars['Int'];
  plan: BusinessAccountPlan;
  planId: Scalars['UUID'];
  status: BusinessAccountSubscriptionStatus;
};

/** Enum for business account subscription enablement status */
export enum BusinessAccountSubscriptionEnablementStatus {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED'
}

/** Enum for business account subscription status */
export enum BusinessAccountSubscriptionStatus {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
  EXPIRED = 'EXPIRED',
  EXPIRES_SOON = 'EXPIRES_SOON',
  NO_SUBSCRIPTION = 'NO_SUBSCRIPTION'
}

/** Input container for filters when searching for business accounts */
export type BusinessAccountsFilterInput = {
  searchText: InputMaybe<Scalars['String']>;
};

/** Pagination container for business accounts */
export type BusinessAccountsResult = {
  __typename: 'BusinessAccountsResult';
  items: Array<BusinessAccount>;
  totalCount: Scalars['Int'];
};

export enum CacheControlScope {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}

/** Enum for possible corrective action request cancellation reasons */
export enum CancellationReasonType {
  de_escalate_failure = 'de_escalate_failure',
  failure_caused_by_carrier = 'failure_caused_by_carrier',
  fault_misassigned = 'fault_misassigned',
  legacy_car = 'legacy_car',
  no_response = 'no_response',
  other_manufacturing_partner = 'other_manufacturing_partner',
  responsibility_unclear = 'responsibility_unclear'
}

/** Stripe credit card details */
export type Card = {
  __typename: 'Card';
  address: Maybe<Scalars['String']>;
  address2: Maybe<Scalars['String']>;
  addressCity: Maybe<Scalars['String']>;
  addressCountry: Maybe<Scalars['String']>;
  addressState: Maybe<Scalars['String']>;
  addressZip: Maybe<Scalars['String']>;
  brand: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  expMonth: Maybe<Scalars['Int']>;
  expYear: Maybe<Scalars['Int']>;
  id: Maybe<Scalars['String']>;
  last4: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

/** This defines the carriers currently supported for carrier account operations */
export enum Carrier {
  DHLExpress = 'DHLExpress',
  FedEx = 'FedEx',
  UPS = 'UPS'
}

/** Type corresponding to all the flags given as input in quote change request */
export type ChangeFlagsInput = {
  configurationChange: Scalars['Boolean'];
  designChange: Scalars['Boolean'];
  otherChange: Scalars['Boolean'];
  quantityChange: Scalars['Boolean'];
};

/** ChangeHistory record */
export type ChangeHistory = {
  __typename: 'ChangeHistory';
  contextKey: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['Date']>;
  createdBy: Maybe<BasicUser>;
  id: Scalars['Int'];
  message: Maybe<Scalars['String']>;
  newValue: Maybe<Scalars['String']>;
  objectId: Scalars['String'];
  objectType: Scalars['String'];
  oldValue: Maybe<Scalars['String']>;
};

/** Enum for Change history object types */
export enum ChangeHistoryObjectType {
  job = 'job',
  job_request = 'job_request',
  scheduling_queue_item = 'scheduling_queue_item'
}

/** Input for quote change request */
export type ChangeRequestInput = {
  changeDescription: Scalars['String'];
  changeTypes: ChangeFlagsInput;
};

/** Response type for claimEmailVerification */
export type ClaimEmailVerificationResponse = {
  __typename: 'ClaimEmailVerificationResponse';
  addedToBusinessAccount: Scalars['Boolean'];
  isPremiumTrialActivated: Maybe<Scalars['Boolean']>;
  user: User;
};

/** possible claimSources for emailVerification */
export enum ClaimSource {
  business_account_activation = 'business_account_activation',
  business_account_signup = 'business_account_signup',
  user_initiated = 'user_initiated'
}

/** Fields for class a pricing output */
export type ClassACalculatorOutput = {
  __typename: 'ClassACalculatorOutput';
  classANonRecurringCostsInCents: ClassAPriceOutput;
  classAProductionCostsInCents: ClassAPriceOutput;
};

/** Fields for class a pricing output */
export type ClassAPriceOutput = {
  __typename: 'ClassAPriceOutput';
  china: Maybe<Scalars['Int']>;
  india: Maybe<Scalars['Int']>;
  usa: Maybe<Scalars['Int']>;
};

/** Input for class a values */
export type ClassATypeInput = {
  nonRecurringCostsInCents: InputMaybe<DomesticAndOverseasCostDataInput>;
  partComplexity: InputMaybe<Scalars['String']>;
  productionCostsInCents: InputMaybe<DomesticAndOverseasCostDataInput>;
  required: InputMaybe<Scalars['Boolean']>;
};

/** type to represent a Cost and Lead Time optimization */
export type CltOptimization = {
  __typename: 'CltOptimization';
  businessAccountMembershipId: Maybe<Scalars['UUID']>;
  createdAt: Scalars['Date'];
  description: Scalars['String'];
  finalCostCents: Scalars['Int'];
  finalQuantity: Scalars['Int'];
  finalTimeDays: Scalars['Int'];
  id: Scalars['UUID'];
  initialCostCents: Scalars['Int'];
  initialQuantity: Scalars['Int'];
  initialTimeDays: Scalars['Int'];
  operation: Scalars['String'];
  quoteId: Scalars['UUID'];
  quoteModelRevisionId: Scalars['UUID'];
  userId: Scalars['Int'];
};

/** type to represent a Cost and Lead Time optimizer report */
export type CltOptimizerReport = {
  __typename: 'CltOptimizerReport';
  businessAccountId: Maybe<Scalars['UUID']>;
  costCentsDelta: Scalars['Int'];
  id: Scalars['UUID'];
  lastViewed: Scalars['Date'];
  quoteId: Scalars['UUID'];
  timeDaysDelta: Scalars['Int'];
  userId: Scalars['Int'];
  viewCount: Scalars['Int'];
};

/** type to represent the view count and last viewed time of the Cost and Lead Time optimizer UI */
export type CltOptimizerView = {
  __typename: 'CltOptimizerView';
  createdAt: Scalars['Date'];
  id: Scalars['UUID'];
  lastViewed: Scalars['Date'];
  quoteId: Scalars['UUID'];
  viewCount: Scalars['Int'];
};

/** Pricing overrides specific to cnc */
export type CncPricingConstantOverridesInput = {
  operatorRateCentsPerHour: Scalars['Int'];
  shopRateCentsPerHour: Scalars['Int'];
  useOverseas: Scalars['Boolean'];
};

/** A manufacturing material color. */
export type Color = {
  __typename: 'Color';
  id: Scalars['String'];
  name: Scalars['String'];
};

/** Comment */
export type Comment = {
  __typename: 'Comment';
  /** null if comment is deleted */
  author: Maybe<BasicUser>;
  /** the raw input that the user passed on create or edit, null if comment is deleted */
  body: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  deletedAt: Maybe<Scalars['Date']>;
  editedAt: Maybe<Scalars['Date']>;
  id: Scalars['UUID'];
  /** the "safe" html that we can inject directly into the DOM, null if comment is deleted */
  safeBody: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
};

/** Input for ModelConfiguration */
export type ConfigInput = {
  colorId: InputMaybe<Scalars['String']>;
  materialId: InputMaybe<Scalars['String']>;
  postProcessColorId: InputMaybe<Scalars['String']>;
  postProcessId: InputMaybe<Scalars['String']>;
  postProcessThickness: InputMaybe<Scalars['Float']>;
  priorityId: InputMaybe<Scalars['String']>;
  processId: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
  shoreId: InputMaybe<Scalars['String']>;
  textureId: InputMaybe<Scalars['String']>;
};

/** A configuration is a set of selections for producing a part */
export type Configuration = {
  __typename: 'Configuration';
  id: Scalars['String'];
  materialId: Maybe<Scalars['String']>;
  priorityId: Maybe<Scalars['String']>;
  processId: Maybe<Scalars['String']>;
  quantity: Maybe<Scalars['Int']>;
};

/** An input for any function requiring a configuration for a part */
export type ConfigurationInput = {
  finish: InputMaybe<Scalars['String']>;
  materialId: InputMaybe<Scalars['String']>;
  priorityId: InputMaybe<Scalars['String']>;
  processId: InputMaybe<Scalars['String']>;
  quantity: InputMaybe<Scalars['Int']>;
};

/** A tree representing the available configurations for a part */
export type ConfigurationOptions = {
  __typename: 'ConfigurationOptions';
  id: Scalars['UUID'];
  processOptions: Array<ProcessOption>;
  quantityMax: Maybe<Scalars['Int']>;
  quantityMin: Maybe<Scalars['Int']>;
};

/** An item represents one option of a DFM consultation request section */
export type ConsultativeDfmConfigOption = {
  __typename: 'ConsultativeDfmConfigOption';
  key: Scalars['String'];
  label: Scalars['String'];
};

/** A section of a DFM consultation request */
export type ConsultativeDfmConfigSection = {
  __typename: 'ConsultativeDfmConfigSection';
  minChecked: Scalars['Int'];
  options: Array<ConsultativeDfmConfigOption>;
  sectionKey: Scalars['String'];
  separatorAfter: Scalars['Boolean'];
  subtitle: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

/** Options of a DFM consultation request */
export type ConsultativeDfmOptions = {
  __typename: 'ConsultativeDfmOptions';
  commentsMaxLength: Scalars['Int'];
  sections: Array<ConsultativeDfmConfigSection>;
};

/** User information that should be updated when the order is placed */
export type ContactDetailsInput = {
  company: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

/** Represents Corrective action request */
export type CorrectiveActionRequest = {
  __typename: 'CorrectiveActionRequest';
  approvedAt: Maybe<Scalars['Date']>;
  /** Fictiv employee details */
  assignee: Maybe<BasicUser>;
  /** Associated exception failure types */
  associatedExceptionFailureTypes: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Associated exceptions */
  associatedExceptionFailures: Maybe<Array<BasicExceptionFailure>>;
  /** Associated exception IDs */
  associatedExceptionNames: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Associated attachments */
  attachments: Maybe<Array<CorrectiveActionRequestAttachment>>;
  /** Business Unit */
  businessUnit: Maybe<Scalars['String']>;
  /** When did we sent cancel notification */
  cancelEmailNotificationSentOn: Maybe<Scalars['Date']>;
  /** Reason of cancelling CAR, submitted by SQE */
  cancelationReason: Maybe<CancellationReasonType>;
  canceledAt: Maybe<Scalars['Date']>;
  closedAt: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  dueAt: Maybe<Scalars['Date']>;
  /** Reference to sales order */
  erpSaleOrderId: Maybe<Scalars['Int']>;
  /** Exception details */
  exception: Maybe<BasicException>;
  /** Associated Exception Full details */
  exceptionDetails: Maybe<Exception>;
  /** First submission date */
  firstSubmittedAt: Maybe<Scalars['Date']>;
  /** History related to corrective action request */
  history: Maybe<Array<ChangeHistory>>;
  /** Unique identifier for corrective action request */
  id: Scalars['UUID'];
  /** Associated job */
  job: Maybe<Job>;
  /**
   * Job id
   * @deprecated Use job.id instead
   */
  jobId: Maybe<Scalars['Int']>;
  /**
   * Job name
   * @deprecated Use job.name instead
   */
  jobName: Maybe<Scalars['String']>;
  /** Associated job request */
  jobRequest: Maybe<JobRequest>;
  /** Job request id */
  jobRequestId: Maybe<Scalars['Int']>;
  /** Job request name */
  jobRequestName: Maybe<Scalars['String']>;
  /** Job request status */
  jobRequestStatus: Maybe<Scalars['String']>;
  /** Manufacturing partner details */
  mfgPartner: Maybe<MfgPartner>;
  /** Generated name for corrective action request */
  name: Scalars['String'];
  /** Last status of corrective action request */
  previousStatus: Maybe<CorrectiveActionRequestStatus>;
  /** Questionnaire with responses */
  questionnaire: Maybe<Array<CorrectiveActionRequestQuestionResponse>>;
  /** Reason to send the corrective action request for rework, added by supplier quality engineer */
  reworkText: Maybe<Scalars['String']>;
  /** Associated SalesOrder Info */
  salesOrder: Maybe<SalesOrder>;
  /** Sales order name */
  salesOrderName: Maybe<Scalars['String']>;
  sentAt: Maybe<Scalars['Date']>;
  sentForReworkAt: Maybe<Scalars['Date']>;
  /** Current status of corrective action request */
  status: CorrectiveActionRequestStatus;
  submittedAt: Maybe<Scalars['Date']>;
  /** Supplier quality engineer details */
  supplierQualityEngineer: Maybe<BasicUser>;
  /** Turnaround working days for corrective action request submission */
  turnaroundDays: Maybe<Scalars['Float']>;
  /** Type of corrective action request */
  type: CorrectiveActionRequestType;
  updatedAt: Scalars['Date'];
  viewedAt: Maybe<Scalars['Date']>;
};

/** Represents Corrective Action Request Attachment */
export type CorrectiveActionRequestAttachment = {
  __typename: 'CorrectiveActionRequestAttachment';
  attachment: Maybe<Asset>;
  correctiveActionRequestId: Scalars['UUID'];
  createdAt: Scalars['Date'];
  createdBy: Maybe<BasicUser>;
  deletedAt: Maybe<Scalars['Date']>;
  exceptionId: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  source: CorrectiveActionRequestAttachmentSourceType;
  updatedAt: Maybe<Scalars['Date']>;
  visibleToCustomer: Maybe<Scalars['Boolean']>;
};

/** Corrective action request attachment input type */
export type CorrectiveActionRequestAttachmentInput = {
  /** Corrective action request attachment */
  attachment: AttachmentInput;
  /** Corrective action request ID */
  correctiveActionRequestId: Scalars['UUID'];
};

/** Enum for possible corrective action request attachment sources */
export enum CorrectiveActionRequestAttachmentSourceType {
  FICTIV = 'FICTIV',
  MP = 'MP'
}

/** Enum for allowed corrective action request failure types */
export enum CorrectiveActionRequestFailureType {
  FICTIV_IF = 'FICTIV_IF',
  FICTIV_OT = 'FICTIV_OT',
  MP_IF = 'MP_IF',
  MP_OT = 'MP_OT'
}

/** Input for corrective action request filters */
export type CorrectiveActionRequestFilterInput = {
  assignees: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  canceledAtEndDate: InputMaybe<Scalars['String']>;
  canceledAtStartDate: InputMaybe<Scalars['String']>;
  correctiveActionRequestNameLike: InputMaybe<Scalars['String']>;
  correctiveActionRequestStatuses: InputMaybe<Array<CorrectiveActionRequestStatus>>;
  createdAtEndDate: InputMaybe<Scalars['String']>;
  createdAtStartDate: InputMaybe<Scalars['String']>;
  dueAtEndDate: InputMaybe<Scalars['String']>;
  dueAtStartDate: InputMaybe<Scalars['String']>;
  exceptionNameLike: InputMaybe<Scalars['String']>;
  exceptionStatuses: InputMaybe<Array<ExceptionStates>>;
  failureTypes: InputMaybe<Array<CorrectiveActionRequestFailureType>>;
  jobRequestNameLike: InputMaybe<Scalars['String']>;
  mfgPartnerNameLike: InputMaybe<Scalars['String']>;
  mfgPartners: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  salesOrderNameLike: InputMaybe<Scalars['String']>;
  sentAtEndDate: InputMaybe<Scalars['String']>;
  sentAtStartDate: InputMaybe<Scalars['String']>;
  sentForReworkAtEndDate: InputMaybe<Scalars['String']>;
  sentForReworkAtStartDate: InputMaybe<Scalars['String']>;
  submittedAtEndDate: InputMaybe<Scalars['String']>;
  submittedAtStartDate: InputMaybe<Scalars['String']>;
  supplierQualityEngineerIds: InputMaybe<Array<Scalars['Int']>>;
  viewedAtEndDate: InputMaybe<Scalars['String']>;
  viewedAtStartDate: InputMaybe<Scalars['String']>;
};

/** Represents corrective action request list */
export type CorrectiveActionRequestList = {
  __typename: 'CorrectiveActionRequestList';
  items: Maybe<Array<CorrectiveActionRequest>>;
  offset: Maybe<Scalars['Int']>;
  totalCount: Maybe<Scalars['Int']>;
};

/** Input for corrective action request list filters */
export type CorrectiveActionRequestListFilterInput = {
  assignedEntities: InputMaybe<Array<AssignedEntityType>>;
  assignees: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  businessUnits: InputMaybe<Array<Scalars['String']>>;
  canceledAtEndDate: InputMaybe<Scalars['Date']>;
  canceledAtStartDate: InputMaybe<Scalars['Date']>;
  correctiveActionRequestNameLike: InputMaybe<Scalars['String']>;
  correctiveActionRequestStatuses: InputMaybe<Array<CorrectiveActionRequestStatus>>;
  createdAtEndDate: InputMaybe<Scalars['Date']>;
  createdAtStartDate: InputMaybe<Scalars['Date']>;
  dueAtEndDate: InputMaybe<Scalars['Date']>;
  dueAtStartDate: InputMaybe<Scalars['Date']>;
  exceptionFailureTypes: InputMaybe<Array<ExceptionFailureType>>;
  exceptionNameLike: InputMaybe<Scalars['String']>;
  jobNameLike: InputMaybe<Scalars['String']>;
  jobRequestNameLike: InputMaybe<Scalars['String']>;
  mfgPartnerNameLike: InputMaybe<Scalars['String']>;
  mfgPartners: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  milestoneTypes: InputMaybe<Array<MilestoneType>>;
  salesOrderNameLike: InputMaybe<Scalars['String']>;
  sentAtEndDate: InputMaybe<Scalars['Date']>;
  sentAtStartDate: InputMaybe<Scalars['Date']>;
  sentForReworkAtEndDate: InputMaybe<Scalars['Date']>;
  sentForReworkAtStartDate: InputMaybe<Scalars['Date']>;
  submittedAtEndDate: InputMaybe<Scalars['Date']>;
  submittedAtStartDate: InputMaybe<Scalars['Date']>;
  supplierQualityEngineerIds: InputMaybe<Array<Scalars['Int']>>;
  viewedAtEndDate: InputMaybe<Scalars['Date']>;
  viewedAtStartDate: InputMaybe<Scalars['Date']>;
};

/** Allowed corrective action request sort options */
export enum CorrectiveActionRequestListSortInput {
  JOB_ID_DESC = 'JOB_ID_DESC'
}

/** Represents Corrective action request question option */
export type CorrectiveActionRequestQuestionOption = {
  __typename: 'CorrectiveActionRequestQuestionOption';
  /** Corrective action request question option description */
  description: Scalars['String'];
  /** Unique identifier for corrective action request question option */
  id: Scalars['Int'];
};

/** Corrective action request questionnaire response data for a question */
export type CorrectiveActionRequestQuestionResponse = {
  __typename: 'CorrectiveActionRequestQuestionResponse';
  id: Scalars['Int'];
  question: CorrectiveActionRequestQuestionType;
  response: Maybe<CorrectiveActionRequestResponse>;
};

/** Selected option for a corrective action request question */
export type CorrectiveActionRequestQuestionSelectedOption = {
  __typename: 'CorrectiveActionRequestQuestionSelectedOption';
  active: Maybe<Scalars['Boolean']>;
  description: Scalars['String'];
  id: Scalars['Int'];
};

/** Enum for allowed corrective action request question types */
export enum CorrectiveActionRequestQuestionType {
  containment_action = 'containment_action',
  corrective_action = 'corrective_action',
  extent_of_condition_and_cause = 'extent_of_condition_and_cause',
  preventive_action = 'preventive_action',
  root_cause_how_caused = 'root_cause_how_caused',
  root_cause_how_escaped = 'root_cause_how_escaped'
}

/** Response for a corrective action request question */
export type CorrectiveActionRequestResponse = {
  __typename: 'CorrectiveActionRequestResponse';
  responseText: Maybe<Scalars['String']>;
  sanitizedResponseText: Maybe<Scalars['String']>;
  selectedOptions: Maybe<Array<CorrectiveActionRequestQuestionSelectedOption>>;
};

/** Enum for allowed corrective action request sort options */
export enum CorrectiveActionRequestSortInput {
  CANCELED_AT_ASC = 'CANCELED_AT_ASC',
  CANCELED_AT_DESC = 'CANCELED_AT_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DUE_AT_ASC = 'DUE_AT_ASC',
  DUE_AT_DESC = 'DUE_AT_DESC',
  SENT_AT_ASC = 'SENT_AT_ASC',
  SENT_AT_DESC = 'SENT_AT_DESC',
  SENT_FOR_REWORK_AT_ASC = 'SENT_FOR_REWORK_AT_ASC',
  SENT_FOR_REWORK_AT_DESC = 'SENT_FOR_REWORK_AT_DESC',
  SUBMITTED_AT_ASC = 'SUBMITTED_AT_ASC',
  SUBMITTED_AT_DESC = 'SUBMITTED_AT_DESC',
  VIEWED_AT_ASC = 'VIEWED_AT_ASC',
  VIEWED_AT_DESC = 'VIEWED_AT_DESC'
}

/** corrective action request statuses */
export enum CorrectiveActionRequestStatus {
  approved = 'approved',
  canceled = 'canceled',
  closed = 'closed',
  in_progress = 'in_progress',
  pending = 'pending',
  rework = 'rework',
  submitted = 'submitted',
  voided = 'voided'
}

/** Enum for allowed corrective action request statuses types */
export enum CorrectiveActionRequestType {
  fictiv = 'fictiv',
  mp = 'mp'
}

/** Represents corrective action request details list */
export type CorrectiveActionRequests = {
  __typename: 'CorrectiveActionRequests';
  items: Maybe<Array<CorrectiveActionRequest>>;
  offset: Maybe<Scalars['Int']>;
  totalCount: Maybe<Scalars['Int']>;
};

/** Cost Driver object. */
export type CostDriver = {
  __typename: 'CostDriver';
  /** count */
  count: Maybe<Scalars['Int']>;
  /** id of cost driver */
  id: Scalars['String'];
  /** material */
  material: Maybe<Scalars['JSON']>;
  /** name of cost driver */
  name: Scalars['String'];
};

/** Fields associated with Country */
export type Country = {
  __typename: 'Country';
  code: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

/** Coupon identifiers to apply to an order when placed */
export type CouponInput = {
  id: InputMaybe<Scalars['String']>;
  type: CouponType;
};

/** Types of coupons that can be applied to an order */
export enum CouponType {
  PREFERRED_USER_COUPON = 'PREFERRED_USER_COUPON',
  USER_COUPON = 'USER_COUPON'
}

/**
 * Cpq Quote attributes
 * deprecated
 */
export type CpqQuote = {
  __typename: 'CpqQuote';
  moldCount: Scalars['Int'];
  orderQuantity: Scalars['Int'];
  orderTotal: Scalars['Float'];
  partsCount: Scalars['Int'];
  platformQuote: Quote;
  quotePdfUrl: Scalars['String'];
  sfdcId: Scalars['UUID'];
};

/** Creates a message/event on the referenced object */
export type CreateHistoryMessageInput = {
  message: Scalars['String'];
  objectId: Scalars['String'];
  objectType: ChangeHistoryObjectType;
};

/** Creates a record of state changing on the referenced object */
export type CreateHistoryStateChangeInput = {
  contextKey: Scalars['String'];
  newValue: InputMaybe<Scalars['String']>;
  objectId: Scalars['String'];
  objectType: ChangeHistoryObjectType;
  oldValue: InputMaybe<Scalars['String']>;
};

/** Input data required for creating job */
export type CreateJobInput = {
  erpSaleOrderId: Scalars['Int'];
  isForJobBoard: InputMaybe<Scalars['Boolean']>;
  jobBoardRegionId: InputMaybe<Scalars['UUID']>;
  lines: Array<CreateJobLineInput>;
  name: Scalars['String'];
  productionCountry: InputMaybe<ProductionCountry>;
  rfqNumber: InputMaybe<Scalars['String']>;
  schedulingType: InputMaybe<SchedulingTypes>;
  vendorNotes: InputMaybe<Scalars['String']>;
};

/** Input data required for creating job line */
export type CreateJobLineInput = {
  erpProductProcessId: Scalars['Int'];
  erpSaleOrderLineId: Scalars['Int'];
  name: Scalars['String'];
  productQty: Scalars['Int'];
};

/** Input data required for creating note */
export type CreateNoteInput = {
  attachments: InputMaybe<Array<Scalars['String']>>;
  description: Scalars['String'];
  objectId: Scalars['Int'];
  objectType: NoteObjectType;
};

/** Input to create a new quality document record */
export type CreateQualityDocumentInput = {
  attachmentId: Scalars['String'];
  fileName: Scalars['String'];
};

/** input obj for the createQueueItem mutation */
export type CreateQueueItemInput = {
  jobExpiryTime: Scalars['Int'];
  jobExtraViewingTime: InputMaybe<Scalars['Int']>;
  overrideMpAcceptingHours: InputMaybe<Scalars['Boolean']>;
  overrideMpUnavailability: InputMaybe<Scalars['Boolean']>;
  partners: Array<JobSchedulingPartnerInput>;
  scheduleNoEarlierThan: InputMaybe<Scalars['Date']>;
  waitTime: InputMaybe<Scalars['Int']>;
};

/** Input data required for creating a scheduling queue */
export type CreateSchedulingQueueInput = {
  jobId: Scalars['Int'];
};

/** output type of Mutation.CreateTeam */
export type CreateTeamOutput = {
  __typename: 'CreateTeamOutput';
  members: Maybe<Array<Scalars['String']>>;
  /** @deprecated Create team does not support adding members */
  membersFailedToAdd: Maybe<Array<Scalars['String']>>;
  team: Team;
};

/** Stripe credit card information */
export type CreditCard = {
  __typename: 'CreditCard';
  card: Maybe<Card>;
  id: Maybe<Scalars['String']>;
  referenceId: Maybe<Scalars['String']>;
};

/** CurrencyExchangeRate */
export type CurrencyExchangeRate = {
  __typename: 'CurrencyExchangeRate';
  /** exchange rate of the currencies */
  exchangeRate: Scalars['Float'];
  /** date of the exchange rate */
  exchangeRateDate: Scalars['Date'];
  /** base currency from which exchange rate is calculated */
  fromCurrency: Scalars['String'];
  /** id primary key */
  id: Scalars['Int'];
  /** currency for which exchange rate is calculated */
  toCurrency: Scalars['String'];
};

/** CurrencyExchangeRate */
export type CurrencyExchangeRateInput = {
  /** exchange rate of the currencies */
  exchangeRate: Scalars['Float'];
  /** date of the exchange rate */
  exchangeRateDate: Scalars['Date'];
  /** base currency from which exchange rate is calculated */
  fromCurrency: Scalars['String'];
  /** currency for which exchange rate is calculated */
  toCurrency: Scalars['String'];
};

/** Next cursor value for a paginated result. Eventually this should be an opaque string */
export type Cursor = {
  __typename: 'Cursor';
  /** Opaque string used to denote the next cursor page */
  next: Maybe<Scalars['ENCODED_CURSOR']>;
  /** Opaque string used to denote the previous cursor page */
  previous: Maybe<Scalars['ENCODED_CURSOR']>;
};

/** Result for Salesforce accounts created by Cypress tests */
export type CypressCreateSalesForceAccount = {
  __typename: 'CypressCreateSalesForceAccount';
  id: Scalars['String'];
  name: Scalars['String'];
};

/** Result for Salesforce account contacts created by Cypress tests */
export type CypressCreateSalesForceAccountContact = {
  __typename: 'CypressCreateSalesForceAccountContact';
  id: Scalars['Int'];
  salesForceAccountId: Scalars['String'];
  userId: Scalars['Int'];
};

/** Input for date range */
export type DateRangeInput = {
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};

/** Default Tolerance Data */
export type DefaultToleranceData = {
  __typename: 'DefaultToleranceData';
  number: Maybe<Scalars['String']>;
  rangeMm: Maybe<Scalars['Float']>;
  toleranceText: Maybe<Scalars['String']>;
  valueMm: Maybe<Scalars['Float']>;
};

/**
 * DFM annotations.
 * TODO: Change the usage of this back to QmrAttachmentAnnotationsInput
 * when frontend is updated to use the new style of annotations
 */
export type DfmAttachmentAnnotationsInput = {
  data: Scalars['String'];
  userId: InputMaybe<Scalars['Int']>;
};

/** Sections and selected option keys for each section from DFMConsultation request form */
export type DfmConsultationRequestSectionInput = {
  optionKeys: Array<Scalars['String']>;
  sectionKey: Scalars['String'];
};

/** DfmFeedback */
export type DfmFeedback = {
  __typename: 'DfmFeedback';
  accepted: Scalars['Boolean'];
  acceptedAt: Maybe<Scalars['Date']>;
  acceptedBy: Maybe<BasicUser>;
  attachment: Maybe<Asset>;
  code: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  createdBy: BasicUser;
  deletedAt: Maybe<Scalars['Date']>;
  deletedBy: Maybe<BasicUser>;
  id: Scalars['UUID'];
  isAutoGeneratedDfm: Scalars['Boolean'];
  isPublished: Scalars['Boolean'];
  isValid: Scalars['Boolean'];
  link: Maybe<Scalars['String']>;
  message: Scalars['String'];
  modelConfiguration: ModelConfiguration;
  modelViewerSnapshots: Array<ModelViewerSnapshot>;
  severity: Scalars['String'];
  sourceType: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  topic: Maybe<Topic>;
  updatedAt: Scalars['Date'];
  updatedBy: BasicUser;
};

/** Input for create DfmFeedback */
export type DfmFeedbackInput = {
  code: InputMaybe<Scalars['String']>;
  link: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  modelConfigurationId: Scalars['UUID'];
  modelViewerSnapshotId: Scalars['UUID'];
  quoteId: InputMaybe<Scalars['UUID']>;
  severity: Scalars['String'];
  title: InputMaybe<Scalars['String']>;
};

/** Editable message and metadata source for dfm feedback */
export type DfmFeedbackMessage = {
  __typename: 'DfmFeedbackMessage';
  code: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy: BasicUser;
  deletedAt: Maybe<Scalars['Date']>;
  deletedBy: Maybe<BasicUser>;
  dfmTopic: Maybe<Topic>;
  disabled: Scalars['Boolean'];
  id: Scalars['UUID'];
  link: Maybe<Scalars['String']>;
  message: Scalars['String'];
  platformProcessId: Scalars['String'];
  severity: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: DfmFeedbackMessageType;
  updatedAt: Scalars['Date'];
  updatedBy: BasicUser;
};

/** Input for editing a dfm feedback message */
export type DfmFeedbackMessageEditInput = {
  disabled: Scalars['Boolean'];
  id: Scalars['UUID'];
  link: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  platformProcessId: Scalars['String'];
  severity: InputMaybe<DfmFeedbackSeverity>;
  title: Scalars['String'];
};

/** Input for creating a dfm feedback message */
export type DfmFeedbackMessageInput = {
  code: Scalars['String'];
  disabled: Scalars['Boolean'];
  link: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  platformProcessId: Scalars['String'];
  severity: InputMaybe<DfmFeedbackSeverity>;
  title: Scalars['String'];
  topicId: InputMaybe<Scalars['UUID']>;
  type: DfmFeedbackMessageType;
};

/** Type of DfmFeedbackMessage. Can be for auto-dfm or for admin manual dfm */
export enum DfmFeedbackMessageType {
  auto = 'auto',
  manual = 'manual'
}

/** Level of severity for a piece of dfm feedback */
export enum DfmFeedbackSeverity {
  cost_driver = 'cost_driver',
  failure = 'failure',
  notice = 'notice',
  warning = 'warning'
}

/** dfm and modelviewer snapshot input for createDfmFeedbackWithSnapshot */
export type DfmFeedbackWithSnapshotInput = {
  code: InputMaybe<Scalars['String']>;
  link: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  severity: InputMaybe<Scalars['String']>;
  snapshotInfo: ViewerSnapshotInput;
  status: InputMaybe<Scalars['String']>;
  title: InputMaybe<Scalars['String']>;
  topicId: Scalars['UUID'];
};

/**
 * The dfmInspection blob changes periodically, and when used with the pricing
 * tool, all fields are always desired. So, the easy, and admittedly lazy, choice was
 * to just stringify the entire data blob in JSON format.
 */
export type DfmInspectionAsString = {
  __typename: 'DfmInspectionAsString';
  jsonString: Scalars['String'];
};

/** Input for create ModelConfigurationDfmInspection */
export type DfmInspectionInput = {
  inspectionData: InspectionDataInput;
  modelConfigurationId: Scalars['UUID'];
  type: Scalars['String'];
};

/** DfmLoadingStatus for frontend to check if a pdf lambda process is in progress */
export type DfmLoadingStatus = {
  __typename: 'DfmLoadingStatus';
  error: Maybe<Scalars['String']>;
  loading: Scalars['Boolean'];
  uploadUrl: Maybe<Scalars['String']>;
};

/** Returns info on Dfm Report loading status */
export type DfmReportLoadingOutput = {
  __typename: 'DfmReportLoadingOutput';
  createdBy: Scalars['Int'];
  targetId: Scalars['UUID'];
  targetType: Scalars['String'];
};

/** Provides the upload status of the IM DFM 3d slides */
export type DfmSlideReadyStatus = {
  __typename: 'DfmSlideReadyStatus';
  error: Maybe<Scalars['String']>;
  feedbackId: Scalars['UUID'];
  loading: Scalars['Boolean'];
  signedUrl: Maybe<Scalars['String']>;
};

/** Enum for allowed DfmStatus filter in QuoteModelRevisionFiltersInput */
export enum DfmStatus {
  awaiting_dfm = 'awaiting_dfm',
  failed_dfm = 'failed_dfm',
  passed_dfm = 'passed_dfm'
}

/** Possible values of dfmTags */
export enum DfmTags {
  AUTO = 'AUTO',
  EDM = 'EDM',
  ENGRAVING = 'ENGRAVING',
  FICTIV_FIVE = 'FICTIV_FIVE',
  FINISHING = 'FINISHING',
  FIVE_AXIS = 'FIVE_AXIS',
  FOUR_AXIS = 'FOUR_AXIS',
  GUN_DRILLING = 'GUN_DRILLING',
  HARDWARE_INSTALLATION = 'HARDWARE_INSTALLATION',
  HOBBING = 'HOBBING',
  LATHE = 'LATHE',
  LEAD_TIME_RESTRICTED = 'LEAD_TIME_RESTRICTED',
  LIVE_TOOLING_LATHE = 'LIVE_TOOLING_LATHE',
  MILL = 'MILL',
  NON_STANDARD_MATERIAL = 'NON_STANDARD_MATERIAL',
  OTS_REWORK = 'OTS_REWORK',
  OVERSEAS = 'OVERSEAS',
  REORDER = 'REORDER',
  REVISION = 'REVISION',
  SHEET_METAL = 'SHEET_METAL',
  SPECIAL_TOOLING = 'SPECIAL_TOOLING',
  STOCK_THICKNESS_APPROVED = 'STOCK_THICKNESS_APPROVED',
  THREE_D_MACHINING = 'THREE_D_MACHINING',
  TIGHT_TOLERANCES = 'TIGHT_TOLERANCES',
  UNDERCUTS = 'UNDERCUTS',
  VENDOR_QUOTED = 'VENDOR_QUOTED',
  WATERJET = 'WATERJET'
}

/** Union type for both discount types */
export type Discount = AmountBasedDiscount | PercentageBasedDiscount;

/** DomainRestrictionInput is to input the permissible ans impermissible domains when creating a new discount code */
export type DomainRestrictionInput = {
  impermissibleEmailDomains: InputMaybe<Array<Scalars['String']>>;
  permissibleEmailDomain: InputMaybe<Scalars['String']>;
};

/** Input for domestic and overseas costs */
export type DomesticAndOverseasCostDataInput = {
  china: InputMaybe<Scalars['Int']>;
  india: InputMaybe<Scalars['Int']>;
  usa: InputMaybe<Scalars['Int']>;
};

/** Input for domestic and overseas manufacturability */
export type DomesticAndOverseasManufacturabilityDataInput = {
  china: InputMaybe<Scalars['Boolean']>;
  india: InputMaybe<Scalars['Boolean']>;
  usa: InputMaybe<Scalars['Boolean']>;
};

/** Input for domestic and overseas costs */
export type DomesticAndOverseasMaterialStockDataInput = {
  china: InputMaybe<Scalars['JSON']>;
  india: InputMaybe<Scalars['JSON']>;
  usa: InputMaybe<Scalars['JSON']>;
};

/** Input for DfmInspection for each regions quoted fixturing methods */
export type DomesticAndOverseasQuotedFixturingMethodsInput = {
  china: InputMaybe<QuotedFixturingMethodsInput>;
  india: InputMaybe<QuotedFixturingMethodsInput>;
  usa: InputMaybe<QuotedFixturingMethodsInput>;
};

/** Images associated with a revision. */
export type DrawingImage = {
  __typename: 'DrawingImage';
  name: Maybe<Scalars['String']>;
  uri: Maybe<Scalars['String']>;
};

/** A user specified option for type of drawing */
export type DrawingType = {
  __typename: 'DrawingType';
  id: Scalars['String'];
  name: Scalars['String'];
};

/** Input used for edm calculator pricing options */
export type EdmCalculatorInput = {
  stepItems: Array<StepItemInput>;
};

/** Fields for edm calculator pricing output */
export type EdmCalculatorOutput = {
  __typename: 'EdmCalculatorOutput';
  stepItems: Array<StepItemOutput>;
};

/** Fields for edm calculator output */
export type EdmPriceOutput = {
  __typename: 'EdmPriceOutput';
  china: Maybe<Scalars['Int']>;
  india: Maybe<Scalars['Int']>;
  usa: Maybe<Scalars['Int']>;
};

/** Input used for  edm calculator pricing options */
export type EdmSinkerKnownRemovalVolumeItemInput = {
  roughness: Scalars['String'];
  setups: Scalars['Int'];
  volumeRemoved: Scalars['Float'];
};

/** Input used for  edm calculator pricing options */
export type EdmSinkerKnownRemovalVolumeItemOutput = {
  __typename: 'EdmSinkerKnownRemovalVolumeItemOutput';
  roughness: Scalars['String'];
  setups: Scalars['Int'];
  volumeRemoved: Scalars['Float'];
};

/** Input used for  edm calculator pricing options */
export type EdmSinkerNoKnownRemovalVolumeItemInput = {
  desiredFilletRadius: Scalars['Float'];
  lengthOfFillet: Scalars['Float'];
  roughness: Scalars['String'];
  setups: Scalars['Int'];
  standardFilletRadius: Scalars['Float'];
};

/** Input used for  edm calculator pricing options */
export type EdmSinkerNoKnownRemovalVolumeItemOutput = {
  __typename: 'EdmSinkerNoKnownRemovalVolumeItemOutput';
  desiredFilletRadius: Scalars['Float'];
  lengthOfFillet: Scalars['Float'];
  roughness: Scalars['String'];
  setups: Scalars['Int'];
  standardFilletRadius: Scalars['Float'];
};

/** Input used for  edm calculator pricing options */
export type EdmWireItemInput = {
  cutPath: Scalars['Float'];
  gear: Scalars['String'];
  plateThickness: Scalars['Float'];
  roughness: Scalars['String'];
};

/** Input used for  edm calculator pricing options */
export type EdmWireItemOutput = {
  __typename: 'EdmWireItemOutput';
  cutPath: Scalars['Float'];
  gear: Scalars['String'];
  plateThickness: Scalars['Float'];
  roughness: Scalars['String'];
};

/** Eligible Follower user */
export type EligibleFollowerUser = {
  __typename: 'EligibleFollowerUser';
  firstName: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName: Maybe<Scalars['String']>;
  odooUserId: Scalars['Int'];
};

/** Input fields for emailAttributes of shareQuote mutation */
export type EmailAttributesInput = {
  forwardToPurchaser: InputMaybe<Scalars['Boolean']>;
  includePdf: InputMaybe<Scalars['Boolean']>;
  sendCopy: InputMaybe<Scalars['Boolean']>;
};

/** Input fields for emailSpecificInput of shareQuote mutation */
export type EmailSpecificInput = {
  note: InputMaybe<Scalars['String']>;
  recipient: Scalars['String'];
  senderId: InputMaybe<Scalars['Int']>;
};

/** Current status of user's email verification */
export enum EmailVerificationStatus {
  not_initiated = 'not_initiated',
  pending = 'pending',
  verified = 'verified'
}

/** Represents a work order for a vendor to manufacture a set of parts. */
export type ErpAttachment = {
  __typename: 'ErpAttachment';
  erpId: Scalars['Int'];
  fileName: Scalars['String'];
  id: Scalars['UUID'];
  mimeType: Scalars['String'];
  putUrl: Maybe<Scalars['String']>;
  sizeInKb: Maybe<Scalars['Int']>;
  url: Scalars['String'];
};

/**
 * Dimensions of a box from ERP data,
 * Used new type as some cases data is missing which need to be fixed in future to use BoundingBox type
 */
export type ErpBoundingBox = {
  __typename: 'ErpBoundingBox';
  length: Maybe<Scalars['Float']>;
  thickness: Maybe<Scalars['Float']>;
  width: Maybe<Scalars['Float']>;
};

/** ERP Mold tool */
export type ErpMoldTool = {
  __typename: 'ErpMoldTool';
  erpMoldId: Scalars['String'];
  id: Scalars['UUID'];
  platformMoldToolRevisionId: Maybe<Scalars['String']>;
  processId: Maybe<Scalars['String']>;
};

/** A collection of models. */
export type EstimateItem = {
  __typename: 'EstimateItem';
  /** An admin-only upload url that bypasses the quoting workflow and allows upload at any time */
  adminSupportingDocUploadUrl: Maybe<Scalars['String']>;
  annotations: Array<Annotation>;
  color: Maybe<Color>;
  configurationOptions: ConfigurationOptions;
  createdAt: Scalars['Date'];
  deletedAt: Maybe<Scalars['Date']>;
  drawingType: Maybe<DrawingType>;
  /** Signed url for fictiv supporting doc template pdf */
  fictivSupportingDocTemplateUrl: Maybe<Scalars['String']>;
  holes: Array<Hole>;
  id: Scalars['UUID'];
  /** @deprecated Field no longer supported */
  material: Maybe<Material>;
  modelAttachmentSanitizations: Array<ModelAttachmentSelection>;
  modelAttachmentSelections: Array<ModelAttachmentSelection>;
  orderedAt: Maybe<Scalars['Date']>;
  owner: BasicUser;
  /** Not implemented yet */
  postProcesses: Maybe<Array<PostProcess>>;
  priorityId: Maybe<Scalars['String']>;
  /** @deprecated Field no longer supported */
  process: Maybe<Process>;
  quantity: Maybe<Scalars['Int']>;
  quoteRequested: Scalars['Boolean'];
  requestForQuote: Array<ModelInspection>;
  revision: Revision;
  sanitizedSupportingDocUploadUrl: Maybe<Scalars['String']>;
  sanitizedSupportingDocUrl: Maybe<Scalars['String']>;
  supportingDocAnalysis: Maybe<SupportingDocAnalysis>;
  supportingDocUploadUrl: Maybe<Scalars['String']>;
  supportingDocUrl: Maybe<Scalars['String']>;
  /** @deprecated Field no longer supported */
  toolCosts: Maybe<ToolCosts>;
  updatedAt: Scalars['Date'];
};

/** the zip mode for estimateItems */
export enum EstimateItemZipMode {
  drawings = 'drawings',
  models = 'models',
  models_and_drawings = 'models_and_drawings',
  models_and_sanitized = 'models_and_sanitized',
  sanitized_drawings = 'sanitized_drawings'
}

/** High and low total and unit price for an item */
export type EstimatedPrice = {
  __typename: 'EstimatedPrice';
  highPriceInCents: Maybe<Scalars['Int']>;
  highUnitPriceInCents: Maybe<Scalars['Int']>;
  lowPriceInCents: Maybe<Scalars['Int']>;
  lowUnitPriceInCents: Maybe<Scalars['Int']>;
};

/** Determined unit and total price for an item */
export type ExactPrice = {
  __typename: 'ExactPrice';
  priceInCents: Maybe<Scalars['Int']>;
  priceInCentsWithoutBusinessAccountDiscount: Maybe<Scalars['Int']>;
  unitPriceInCents: Maybe<Scalars['Int']>;
  unitPriceInCentsWithoutBusinessAccountDiscount: Maybe<Scalars['Int']>;
};

/** An Exception record represents an Exception */
export type Exception = {
  __typename: 'Exception';
  action: Maybe<Scalars['String']>;
  actionId: Scalars['Int'];
  additionalContext: Maybe<Scalars['String']>;
  affectedReceipt: Maybe<JobRequestReceipt>;
  affectedShipment: Maybe<SalesOrderDeliveryOrder>;
  assignee: Maybe<Scalars['String']>;
  correctiveActionRequestForList: Maybe<Array<BasicCarInfo>>;
  /** CARs associated with exception */
  correctiveActionRequests: Maybe<Array<CorrectiveActionRequest>>;
  createdAt: Maybe<Scalars['Date']>;
  createdBy: Maybe<BasicUser>;
  customerName: Maybe<Scalars['String']>;
  earliestPromisedShipDate: Maybe<Scalars['Date']>;
  earliestReceiptDate: Maybe<Scalars['Date']>;
  earliestScheduledDeliveryDate: Maybe<Scalars['Date']>;
  erpSaleOrderId: Scalars['Int'];
  exceptionAttachments: Maybe<Array<ExceptionAttachment>>;
  exceptionParts: Maybe<Array<ExceptionPart>>;
  exceptionState: Scalars['String'];
  failureDiscoveredBy: Maybe<Scalars['String']>;
  failureRootCauseIds: Maybe<Scalars['String']>;
  failureRootCauses: Maybe<Array<ExceptionFailureRootCause>>;
  history: Maybe<Array<ExceptionHistory>>;
  id: Scalars['UUID'];
  ifFailureCustomer: Scalars['Boolean'];
  ifFailureFictiv: Scalars['Boolean'];
  ifFailureMP: Scalars['Boolean'];
  ignoreFailureForMpCalculation: Maybe<Scalars['Boolean']>;
  jobId: Scalars['Int'];
  /** Details of job request which the exception is associated to */
  jobRequest: Maybe<JobRequest>;
  latestNote: Maybe<ExceptionNote>;
  mfgDri: Maybe<User>;
  mfgDriUserId: Maybe<Scalars['Int']>;
  mpName: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** Non conformance attachments associated with the exception */
  nonConformanceAttachments: Maybe<Array<ExceptionAttachment>>;
  nonConformanceEmailSentOn: Maybe<Scalars['Date']>;
  notes: Maybe<Array<ExceptionNote>>;
  otFailureCustomer: Scalars['Boolean'];
  otFailureCustomerDays: Maybe<Scalars['Int']>;
  otFailureFictiv: Scalars['Boolean'];
  otFailureFictivDays: Maybe<Scalars['Int']>;
  otFailureMP: Scalars['Boolean'];
  otFailureMPDays: Maybe<Scalars['Int']>;
  otifIsActive: Scalars['Boolean'];
  /** Basic meta about parent project, if exists */
  project: Maybe<BasicProject>;
  receiptAffected: Maybe<Scalars['Int']>;
  rfqNumber: Maybe<Scalars['String']>;
  salesOrderName: Maybe<Scalars['String']>;
  shipmentAffected: Maybe<Scalars['Int']>;
  status: Scalars['String'];
  type: Maybe<Scalars['String']>;
  typeId: Scalars['Int'];
  updatedAt: Maybe<Scalars['Date']>;
  updatedBy: Maybe<Scalars['Int']>;
  workOrderName: Maybe<Scalars['String']>;
  workOrderRequestDate: Maybe<Scalars['Date']>;
  workOrderRequestId: Scalars['Int'];
};

/** Exception Action */
export type ExceptionAction = {
  __typename: 'ExceptionAction';
  createdAt: Scalars['Date'];
  createdBy: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  updatedAt: Maybe<Scalars['Date']>;
  updatedBy: Maybe<Scalars['String']>;
};

/** Enum for exception Assignee */
export enum ExceptionAssignee {
  fulfillment = 'fulfillment',
  logistics = 'logistics',
  mp = 'mp',
  quality = 'quality',
  tcs = 'tcs'
}

/** Associates an attachment to an exception or exception note attachment */
export type ExceptionAttachment = {
  __typename: 'ExceptionAttachment';
  attachment: Maybe<Asset>;
  createdAt: Scalars['Date'];
  createdBy: Maybe<BasicUser>;
  deletedAt: Scalars['Date'];
  exceptionId: Scalars['String'];
  exceptionNoteId: Maybe<Scalars['Int']>;
  id: Scalars['UUID'];
  isNonConformanceAttachment: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['Date'];
};

/** Exception attachment Input Type */
export type ExceptionAttachmentInput = {
  attachment: AttachmentInput;
  exceptionId: Scalars['UUID'];
  isNonConformanceAttachment: InputMaybe<Scalars['Boolean']>;
};

/** Input data required for creating exception */
export type ExceptionCreateInput = {
  actionId: Scalars['Int'];
  assignee: ExceptionAssignee;
  erpSaleOrderId: Scalars['Int'];
  typeId: Scalars['Int'];
  workOrderRequestId: Scalars['Int'];
};

/** Enum for excpetion creator */
export enum ExceptionCreator {
  auto = 'auto',
  fictiv = 'fictiv',
  mp = 'mp'
}

/** An Exception record represents an Exception */
export type ExceptionFailure = {
  __typename: 'ExceptionFailure';
  action: Maybe<Scalars['String']>;
  actionId: Maybe<Scalars['Int']>;
  additionalContext: Maybe<Scalars['String']>;
  assignedEntity: Maybe<Scalars['String']>;
  assignee: Maybe<Scalars['String']>;
  assigneeId: Maybe<Scalars['Int']>;
  /** Business Unit */
  businessUnit: Maybe<Scalars['String']>;
  correctiveActionRequest: Maybe<CorrectiveActionRequest>;
  correctiveActionRequestId: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['Date']>;
  createdBy: Maybe<BasicUser>;
  creator: Scalars['String'];
  customerDriUserId: Maybe<Scalars['Int']>;
  customerMfgDri: Maybe<User>;
  customerName: Maybe<Scalars['String']>;
  daysLate: Maybe<Scalars['Int']>;
  erpSaleOrderId: Scalars['Int'];
  exceptionFailureAttachments: Maybe<Array<ExceptionFailureAttachment>>;
  exceptionFailureParts: Maybe<Array<ExceptionPart>>;
  exceptionFailureState: Scalars['String'];
  failureDiscoveredBy: Maybe<Scalars['String']>;
  failureRootCauseIds: Maybe<Scalars['String']>;
  history: Maybe<Array<ExceptionFailureHistory>>;
  id: Scalars['UUID'];
  ignoreFailureForMpCalculation: Maybe<Scalars['Boolean']>;
  internalNotes: Maybe<Array<ExceptionFailureNote>>;
  isCustomerImpacted: Scalars['Boolean'];
  isFailure: Scalars['Boolean'];
  jobComputedStatus: Scalars['String'];
  jobId: Scalars['Int'];
  jobName: Scalars['String'];
  jobRequest: Maybe<JobRequest>;
  jobRequestId: Maybe<Scalars['Int']>;
  latestNote: Maybe<ExceptionFailureNote>;
  manufacturingPartnerId: Maybe<Scalars['Int']>;
  manufacturingPartnerName: Maybe<Scalars['String']>;
  milestoneType: Maybe<Scalars['String']>;
  mpMfgDri: Maybe<User>;
  mpMfgDriUserId: Maybe<Scalars['Int']>;
  mpNotes: Maybe<Array<ExceptionFailureNote>>;
  mpSuggestedDate: Maybe<Scalars['Date']>;
  name: Scalars['String'];
  nonConformanceEmailSentOn: Maybe<Scalars['Date']>;
  project: Maybe<BasicProject>;
  qcId: Maybe<Scalars['Int']>;
  receipt: Maybe<InventoryMove>;
  receiptId: Maybe<Scalars['Int']>;
  rfqNumber: Maybe<Scalars['String']>;
  salesOrderName: Scalars['String'];
  shipment: Maybe<SalesOrderDeliveryOrder>;
  shipmentId: Maybe<Scalars['Int']>;
  status: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Maybe<Scalars['Date']>;
  updatedBy: Maybe<BasicUser>;
};

/** Exception Action */
export type ExceptionFailureAction = {
  __typename: 'ExceptionFailureAction';
  createdAt: Scalars['Date'];
  createdBy: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  updatedAt: Maybe<Scalars['Date']>;
  updatedBy: Maybe<Scalars['String']>;
};

/** Enum for all new and old exception Assignee */
export enum ExceptionFailureAssignee {
  customer_mfg_dri = 'customer_mfg_dri',
  fulfillment = 'fulfillment',
  logistics = 'logistics',
  logistics_shipping = 'logistics_shipping',
  manufacture_mfg_dri = 'manufacture_mfg_dri',
  mp = 'mp',
  quality = 'quality',
  sqe = 'sqe',
  tcs = 'tcs'
}

/** Associates an attachment to an exception failure or exception failure note attachment */
export type ExceptionFailureAttachment = {
  __typename: 'ExceptionFailureAttachment';
  attachment: Maybe<Asset>;
  createdAt: Scalars['Date'];
  createdBy: Maybe<BasicUser>;
  deletedAt: Scalars['Date'];
  exceptionId: Scalars['String'];
  exceptionNoteId: Maybe<Scalars['Int']>;
  id: Scalars['UUID'];
  isNonConformanceAttachment: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['Date'];
};

/** Input for Exception failure attachment */
export type ExceptionFailureAttachmentInput = {
  attachment: AttachmentInput;
  exceptionId: Scalars['UUID'];
  isNonConformanceAttachment: InputMaybe<Scalars['Boolean']>;
  source: InputMaybe<ExceptionFailureSource>;
};

/** Job request exceptions created by fictiv */
export type ExceptionFailureCreatedByFictivExist = {
  __typename: 'ExceptionFailureCreatedByFictivExist';
  production: Scalars['Boolean'];
  shipping: Scalars['Boolean'];
};

/** Type for basic exception details */
export type ExceptionFailureDetail = {
  __typename: 'ExceptionFailureDetail';
  /** Exception id */
  id: Scalars['UUID'];
  /** Exception name */
  name: Scalars['String'];
};

/** Enum for failure discovered by */
export enum ExceptionFailureDiscoveredBy {
  auto = 'auto',
  customer = 'customer',
  mp = 'mp',
  mp_mfg_dri = 'mp_mfg_dri',
  qc_feidi = 'qc_feidi',
  qc_hq = 'qc_hq',
  qc_india = 'qc_india'
}

/** An ExceptionHistory record represents a state change in a(n) related Exception */
export type ExceptionFailureHistory = {
  __typename: 'ExceptionFailureHistory';
  contextKey: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['Date']>;
  createdBy: Maybe<BasicUser>;
  id: Maybe<Scalars['Int']>;
  message: Maybe<Scalars['String']>;
  newValue: Maybe<Scalars['String']>;
  objectId: Maybe<Scalars['UUID']>;
  oldValue: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['Date']>;
};

/** Input for List of exception failure id group by new car */
export type ExceptionFailureIdsGroupInput = {
  exceptionFailureIds: InputMaybe<Array<Scalars['UUID']>>;
};

/** Input data required for creating exception failure */
export type ExceptionFailureInput = {
  actionId: InputMaybe<Scalars['Int']>;
  additionalContext: InputMaybe<Scalars['String']>;
  assignedEntity: InputMaybe<AssignedEntityType>;
  assignee: InputMaybe<ExceptionFailureAssignee>;
  assigneeId: InputMaybe<Scalars['Int']>;
  creator: ExceptionCreator;
  daysLate: InputMaybe<Scalars['Int']>;
  erpSaleOrderId: Scalars['Int'];
  exceptionAttachmentIds: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  failureDiscoveredBy: InputMaybe<ExceptionFailureDiscoveredBy>;
  isCustomerImpacted: InputMaybe<Scalars['Boolean']>;
  isFailure: InputMaybe<Scalars['Boolean']>;
  jobId: Scalars['Int'];
  jobRequestId: InputMaybe<Scalars['Int']>;
  milestoneType: InputMaybe<MilestoneType>;
  mpSuggestedDate: InputMaybe<Scalars['Date']>;
  qcId: InputMaybe<Scalars['Int']>;
  receiptId: InputMaybe<Scalars['Int']>;
  shipmentId: InputMaybe<Scalars['Int']>;
  type: ExceptionFailureType;
};

/** Enum for MP exception failure type */
export enum ExceptionFailureMpType {
  IF = 'IF',
  OT = 'OT'
}

/** Exception Note */
export type ExceptionFailureNote = {
  __typename: 'ExceptionFailureNote';
  body: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['Date']>;
  createdBy: Maybe<BasicUser>;
  exceptionFailureNoteAttachments: Maybe<Array<ExceptionAttachment>>;
  id: Scalars['Int'];
  source: ExceptionFailureNoteSource;
};

/** Exception Note Input Type */
export type ExceptionFailureNoteInput = {
  attachments: InputMaybe<Array<Scalars['String']>>;
  body: Scalars['String'];
  exceptionId: Scalars['UUID'];
  source: InputMaybe<ExceptionFailureSource>;
};

/** Enum for excpetion note source */
export enum ExceptionFailureNoteSource {
  FICTIV = 'FICTIV',
  MP = 'MP'
}

/** Represents a Part that has been identified in the exception */
export type ExceptionFailurePart = {
  __typename: 'ExceptionFailurePart';
  createdAt: Scalars['Date'];
  createdBy: Scalars['Int'];
  erpProductId: Scalars['Int'];
  exceptionId: Scalars['UUID'];
  failedQuantity: Scalars['Int'];
  id: Scalars['Int'];
  lines: Maybe<Scalars['String']>;
  orderedQuantity: Maybe<Scalars['Int']>;
  partName: Maybe<Scalars['String']>;
  processes: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['Date']>;
  updatedBy: Maybe<Scalars['Int']>;
};

/** Expected input details for multiple Exception part update */
export type ExceptionFailurePartDetailInput = {
  erpProductId: Scalars['Int'];
  failedQuantity: Scalars['Int'];
};

/** Represents data required for updating multiple Exception parts */
export type ExceptionFailurePartsInput = {
  exceptionId: Scalars['UUID'];
  products: Array<ExceptionFailurePartDetailInput>;
};

/** Exception failure root cause */
export type ExceptionFailureRootCause = {
  __typename: 'ExceptionFailureRootCause';
  createdAt: Scalars['Date'];
  createdBy: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['Int'];
  updatedAt: Maybe<Scalars['Date']>;
  updatedBy: Maybe<Scalars['String']>;
};

/** Exceptin failure source can be FICTIV or MP */
export enum ExceptionFailureSource {
  FICTIV = 'FICTIV',
  MP = 'MP'
}

/** Enum for allowed exception states for CARs filter */
export enum ExceptionFailureStates {
  CLOSED_EXCEPTION = 'CLOSED_EXCEPTION',
  CLOSED_FAILURE = 'CLOSED_FAILURE',
  OPEN_EXCEPTION = 'OPEN_EXCEPTION',
  OPEN_FAILURE = 'OPEN_FAILURE',
  VOIDED_EXCEPTION = 'VOIDED_EXCEPTION'
}

/** Enum for exception status */
export enum ExceptionFailureStatus {
  closed = 'closed',
  open = 'open',
  voided = 'voided'
}

/** Enum for types of exception failure */
export enum ExceptionFailureType {
  IF = 'IF',
  OT = 'OT',
  RFI = 'RFI'
}

/** Input data required for updating exception failure */
export type ExceptionFailureUpdateInput = {
  actionId: InputMaybe<Scalars['Int']>;
  additionalContext: InputMaybe<Scalars['String']>;
  assignedEntity: InputMaybe<AssignedEntityType>;
  assignee: InputMaybe<ExceptionFailureAssignee>;
  assigneeId: InputMaybe<Scalars['Int']>;
  creator: InputMaybe<ExceptionCreator>;
  daysLate: InputMaybe<Scalars['Int']>;
  exceptionAttachmentIds: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  failureDiscoveredBy: InputMaybe<ExceptionFailureDiscoveredBy>;
  isCustomerImpacted: InputMaybe<Scalars['Boolean']>;
  isFailure: InputMaybe<Scalars['Boolean']>;
  jobRequestId: InputMaybe<Scalars['Int']>;
  milestoneType: InputMaybe<MilestoneType>;
  mpSuggestedDate: InputMaybe<Scalars['Date']>;
  qcId: InputMaybe<Scalars['Int']>;
  receiptId: InputMaybe<Scalars['Int']>;
  shipmentId: InputMaybe<Scalars['Int']>;
  type: InputMaybe<ExceptionFailureType>;
};

/** Input for filtering list of exception failures */
export type ExceptionFailuresFilterInput = {
  action: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  assignedEntities: InputMaybe<Array<InputMaybe<AssignedEntityType>>>;
  assignee: InputMaybe<Array<InputMaybe<ExceptionFailureAssignee>>>;
  businessUnits: InputMaybe<Array<Scalars['String']>>;
  correctiveActionRequestNameLike: InputMaybe<Scalars['String']>;
  correctiveActionRequestStatus: InputMaybe<Array<CorrectiveActionRequestStatus>>;
  creator: InputMaybe<Array<InputMaybe<ExceptionCreator>>>;
  customerMfgDriUserIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  exceptionFailureState: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  exceptionNameLike: InputMaybe<Scalars['String']>;
  isFailure: InputMaybe<Scalars['Boolean']>;
  jobComputedStatus: InputMaybe<Array<JobComputedStatus>>;
  jobId: InputMaybe<Scalars['Int']>;
  jobNameLike: InputMaybe<Scalars['String']>;
  jobRequestId: InputMaybe<Scalars['Int']>;
  milestoneTypes: InputMaybe<Array<InputMaybe<MilestoneType>>>;
  mpId: InputMaybe<Scalars['Int']>;
  mpMfgDriUserIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mpNameLike: InputMaybe<Scalars['String']>;
  salesOrderNameLike: InputMaybe<Scalars['String']>;
  status: InputMaybe<Array<ExceptionStatus>>;
  type: InputMaybe<Array<InputMaybe<ExceptionFailureType>>>;
};

/** Enum for the allowed sort on exception failure */
export enum ExceptionFailuresSort {
  ASSIGNEE_ASC = 'ASSIGNEE_ASC',
  ASSIGNEE_DESC = 'ASSIGNEE_DESC',
  CAR_NAME_ASC = 'CAR_NAME_ASC',
  CAR_NAME_DESC = 'CAR_NAME_DESC',
  CAR_STATUS_ASC = 'CAR_STATUS_ASC',
  CAR_STATUS_DESC = 'CAR_STATUS_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  EXCEPTION_ACTION_ASC = 'EXCEPTION_ACTION_ASC',
  EXCEPTION_ACTION_DESC = 'EXCEPTION_ACTION_DESC',
  EXCEPTION_STATUS_ASC = 'EXCEPTION_STATUS_ASC',
  EXCEPTION_STATUS_DESC = 'EXCEPTION_STATUS_DESC',
  JOB_REQUEST_NAME_ASC = 'JOB_REQUEST_NAME_ASC',
  JOB_REQUEST_NAME_DESC = 'JOB_REQUEST_NAME_DESC',
  MP_NAME_ASC = 'MP_NAME_ASC',
  MP_NAME_DESC = 'MP_NAME_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  SALE_ORDER_NAME_ASC = 'SALE_ORDER_NAME_ASC',
  SALE_ORDER_NAME_DESC = 'SALE_ORDER_NAME_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** An ExceptionHistory record represents a state change in a(n) related Exception */
export type ExceptionHistory = {
  __typename: 'ExceptionHistory';
  contextKey: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['Date']>;
  createdBy: Maybe<BasicUser>;
  id: Maybe<Scalars['Int']>;
  newValue: Maybe<Scalars['String']>;
  objectId: Maybe<Scalars['UUID']>;
  oldValue: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['Date']>;
};

/** Exception Note */
export type ExceptionNote = {
  __typename: 'ExceptionNote';
  body: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['Date']>;
  createdBy: Maybe<BasicUser>;
  exceptionNoteAttachments: Maybe<Array<ExceptionAttachment>>;
  id: Scalars['Int'];
};

/** Exception Note Input Type */
export type ExceptionNoteInput = {
  attachments: InputMaybe<Array<Scalars['String']>>;
  body: Scalars['String'];
  exceptionId: Scalars['UUID'];
};

/** Represents a Part that has been identified in the exception */
export type ExceptionPart = {
  __typename: 'ExceptionPart';
  createdAt: Scalars['Date'];
  createdBy: Scalars['Int'];
  erpProductId: Scalars['Int'];
  exceptionId: Scalars['UUID'];
  failedQuantity: Scalars['Int'];
  id: Scalars['Int'];
  lines: Maybe<Scalars['String']>;
  orderedQuantity: Maybe<Scalars['Int']>;
  partName: Maybe<Scalars['String']>;
  processes: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['Date']>;
  updatedBy: Maybe<Scalars['Int']>;
};

/** Expected input details for multiple Exception part update */
export type ExceptionPartDetailInput = {
  erpProductId: Scalars['Int'];
  failedQuantity: Scalars['Int'];
};

/** Represents data required for updating multiple Exception parts */
export type ExceptionPartsInput = {
  exceptionId: Scalars['UUID'];
  products: Array<ExceptionPartDetailInput>;
};

/** Enum for allowed exception states for CARs filter */
export enum ExceptionStates {
  CLOSED_EXCEPTION = 'CLOSED_EXCEPTION',
  CLOSED_FAILURE = 'CLOSED_FAILURE',
  OPEN_EXCEPTION = 'OPEN_EXCEPTION',
  OPEN_FAILURE = 'OPEN_FAILURE',
  VOIDED_EXCEPTION = 'VOIDED_EXCEPTION'
}

/** Enum for exception status */
export enum ExceptionStatus {
  closed = 'closed',
  open = 'open',
  voided = 'voided'
}

/** Exception Type */
export type ExceptionType = {
  __typename: 'ExceptionType';
  createdAt: Scalars['Date'];
  createdBy: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  updatedAt: Maybe<Scalars['Date']>;
  updatedBy: Maybe<Scalars['String']>;
};

/** Input data required for updating exception */
export type ExceptionUpdateInput = {
  actionId: InputMaybe<Scalars['Int']>;
  additionalContext: InputMaybe<Scalars['String']>;
  assignee: InputMaybe<ExceptionAssignee>;
  correctiveActionRequestAssigneeId: InputMaybe<Scalars['Int']>;
  failureDiscoveredBy: InputMaybe<FailureDiscoveredBy>;
  failureRootCauseIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  ifFailureCustomer: InputMaybe<Scalars['Boolean']>;
  ifFailureFictiv: InputMaybe<Scalars['Boolean']>;
  ifFailureMP: InputMaybe<Scalars['Boolean']>;
  ignoreFailureForMpCalculation: InputMaybe<Scalars['Boolean']>;
  otFailureCustomer: InputMaybe<Scalars['Boolean']>;
  otFailureCustomerDays: InputMaybe<Scalars['Int']>;
  otFailureFictiv: InputMaybe<Scalars['Boolean']>;
  otFailureFictivDays: InputMaybe<Scalars['Int']>;
  otFailureMP: InputMaybe<Scalars['Boolean']>;
  otFailureMPDays: InputMaybe<Scalars['Int']>;
  otifIsActive: InputMaybe<Scalars['Boolean']>;
  receiptAffected: InputMaybe<Scalars['Int']>;
  shipmentAffected: InputMaybe<Scalars['Int']>;
  typeId: InputMaybe<Scalars['Int']>;
};

/** Input for filtering list of Work Order Requests */
export type ExceptionsFilterInput = {
  action: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  assignee: InputMaybe<Array<InputMaybe<ExceptionAssignee>>>;
  correctiveActionRequestNameLike: InputMaybe<Scalars['String']>;
  correctiveActionRequestStatuses: InputMaybe<Array<CorrectiveActionRequestStatus>>;
  correctiveActionRequestTypes: InputMaybe<Array<CorrectiveActionRequestType>>;
  createdBy: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  earliestPromisedShipDateEnd: InputMaybe<Scalars['String']>;
  earliestPromisedShipDateStart: InputMaybe<Scalars['String']>;
  earliestReceiptDateEnd: InputMaybe<Scalars['String']>;
  earliestReceiptDateStart: InputMaybe<Scalars['String']>;
  earliestScheduledDeliveryDateEnd: InputMaybe<Scalars['String']>;
  earliestScheduledDeliveryDateStart: InputMaybe<Scalars['String']>;
  exceptionNameLike: InputMaybe<Scalars['String']>;
  failuresType: InputMaybe<Array<FailureTypes>>;
  inFullFailure: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mfgDriUserIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mpNameLike: InputMaybe<Scalars['String']>;
  ontimeFailure: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  partnerId: InputMaybe<Scalars['Int']>;
  salesOrderNameLike: InputMaybe<Scalars['String']>;
  status: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  workOrderNameLike: InputMaybe<Scalars['String']>;
  workOrderRequestDateEnd: InputMaybe<Scalars['String']>;
  workOrderRequestDateStart: InputMaybe<Scalars['String']>;
};

/** Enum for failure discovered by */
export enum FailureDiscoveredBy {
  customer = 'customer',
  mp = 'mp',
  qc_feidi = 'qc_feidi',
  qc_hq = 'qc_hq'
}

/** types of failures */
export enum FailureTypes {
  IF = 'IF',
  OT = 'OT'
}

/** FDM Infill Options for supported FDM materials */
export type FdmInfillOption = {
  __typename: 'FdmInfillOption';
  isDefault: Scalars['Boolean'];
  optionLabelCustomer: Scalars['String'];
  optionLabelMp: Scalars['String'];
  optionName: Scalars['String'];
};

/** FeatureFlag */
export type FeatureFlag = {
  __typename: 'FeatureFlag';
  defaultVariant: Scalars['String'];
  key: Scalars['String'];
  rules: Array<FeatureFlagRule>;
  scope: FeatureFlagScope;
  updatedAt: Maybe<Scalars['Date']>;
};

/** FeatureFlagInput */
export type FeatureFlagInput = {
  defaultVariant: Scalars['String'];
  key: Scalars['String'];
  rules: Array<FeatureFlagRuleInput>;
  scope: FeatureFlagScope;
};

/** FeatureFlagRule */
export type FeatureFlagRule = {
  __typename: 'FeatureFlagRule';
  attribute: Scalars['String'];
  operation: Scalars['String'];
  values: Array<Scalars['String']>;
  variant: Scalars['String'];
};

/** FeatureFlagRuleInput */
export type FeatureFlagRuleInput = {
  attribute: Scalars['String'];
  operation: Scalars['String'];
  values: Array<Scalars['String']>;
  variant: Scalars['String'];
};

/**
 * This defines whether the feature flag
 * will be used to pass to the UI, or for effecting the
 * backend.
 * These are seperate concerns, and for some features, you may
 * end up needing to define 2 separate ones.
 */
export enum FeatureFlagScope {
  SERVER_FLAG = 'SERVER_FLAG',
  UI_FLAG = 'UI_FLAG'
}

/** The FictivFiveCallout represents points on the ManufacturingDrawing that our Manufacturing Partners have to inspect. They're associated with a drawing that could either be linked to an EstimateItem or an Attachment */
export type FictivFiveCallout = {
  __typename: 'FictivFiveCallout';
  attachmentId: Maybe<Scalars['UUID']>;
  calloutNumber: Scalars['String'];
  estimateItemId: Maybe<Scalars['UUID']>;
  label: Scalars['String'];
};

/** Fields associated with FictivHoliday */
export type FictivHoliday = {
  __typename: 'FictivHoliday';
  country: Country;
  date: Scalars['String'];
  holiday: Scalars['String'];
  id: Scalars['String'];
};

/** A finish for injection molding or urethane casting. */
export type Finish = {
  __typename: 'Finish';
  id: Scalars['String'];
  name: Scalars['String'];
};

/** Follower user */
export type FollowerUser = {
  __typename: 'FollowerUser';
  fictivUserId: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  isChannel: Scalars['Boolean'];
  isFictivUser: Scalars['Boolean'];
  name: Scalars['String'];
};

/** input Follower user details */
export type FollowerUserDetailsInput = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** When we automatically GenerateDrawings, this is a reference to the data in S3 */
export type GeneratedDrawing = {
  __typename: 'GeneratedDrawing';
  attachment: Maybe<Attachment>;
  id: Scalars['UUID'];
};

/**
 * This is the expected input from the drawing generator - which provides everything
 * necessary to create the generated drawing and the attachment inside it
 */
export type GeneratedDrawingInput = {
  attachment: AttachmentInput;
  /** The drawing is generated on the server, so we create with the existing id */
  attachmentId: Scalars['UUID'];
  quoteModelRevisionId: Scalars['UUID'];
  uri: Scalars['String'];
  /**
   * UserId needs to be passed through because the drawings are generated by
   * InstantQuoter which is actually an admin user_id - but we want the attachment
   * to be associated with the user who queued the generation
   */
  userId: Scalars['Int'];
};

/** output schema for getInspectionPointCount resolver */
export type GetInspectionPointCountOutput = {
  __typename: 'GetInspectionPointCountOutput';
  autoInspectionPoint: Scalars['Int'];
  db: Scalars['Int'];
  s3: Scalars['Int'];
};

/** Admin only model for granular pricing data */
export type GranularCncPricingData = {
  __typename: 'GranularCncPricingData';
  camTimePricingInCents: Scalars['Int'];
  cncPricingBreakdown: Maybe<Scalars['JSON']>;
  fixturePricingInCents: Scalars['Int'];
  scrapRate: Maybe<Scalars['Float']>;
  setupPricingInCents: Scalars['Int'];
  threadsPricingInCents: Scalars['Int'];
  tightTolerancePricingInCents: Scalars['Int'];
};

/** A typed version of what is currently in the cncPricingBreakdown field of GranularCncPricingData */
export type GranularPricingBreakdownPercentages = {
  __typename: 'GranularPricingBreakdownPercentages';
  camCost: Scalars['Float'];
  fixtureCost: Scalars['Float'];
  machineCost: Scalars['Float'];
  materialCost: Scalars['Float'];
  miscNonRecurringEngineeringCost: Scalars['Float'];
  otherCost: Scalars['Float'];
  setupCost: Scalars['Float'];
  threadCost: Scalars['Float'];
  toleranceCost: Scalars['Float'];
  toolCost: Scalars['Float'];
};

/** Only CNC has granular pricing for now.  Will eventually support more processes' granular pricing data. */
export type GranularPricingData = GranularCncPricingData;

/** Input used for upserting the calculated hardware installation secondary process */
export type HardwareInstallationConfigInput = {
  domesticProductionConfigInput: InputMaybe<ManuallyQuotedSecondaryProcessRegionalInput>;
  internationalProductionConfigInput: InputMaybe<ManuallyQuotedSecondaryProcessRegionalInput>;
  lineItems: Array<HardwareLineItemInput>;
  notes: InputMaybe<Scalars['String']>;
};

/** Fields for hardware installation's manual calculation */
export type HardwareInstallationManualQuoteCalcFields = {
  __typename: 'HardwareInstallationManualQuoteCalcFields';
  domestic: Maybe<ManualQuoteFieldsForSecondaryProcesses>;
  international: Maybe<ManualQuoteFieldsForSecondaryProcesses>;
  lineItems: Maybe<Array<HardwareLineItem>>;
};

/** Input used for calculating pending hardware installation prices */
export type HardwareInstallationPricingInput = {
  domesticProductionConfigInput: InputMaybe<PartialManuallyQuotedSecondaryProcessRegionalInput>;
  internationalProductionConfigInput: InputMaybe<PartialManuallyQuotedSecondaryProcessRegionalInput>;
  lineItems: Array<HardwareLineItemInput>;
};

/** Fields used for hardware installation pricing options */
export type HardwareLineItem = {
  __typename: 'HardwareLineItem';
  partNumber: Maybe<Scalars['String']>;
  pricePerPack: Scalars['Int'];
  qtyPerPack: Scalars['Int'];
  qtyPerPart: Scalars['Int'];
  supplier: Maybe<Scalars['String']>;
};

/** Input used for hardware installation pricing options */
export type HardwareLineItemInput = {
  partNumber: InputMaybe<Scalars['String']>;
  pricePerPack: Scalars['Int'];
  qtyPerPack: Scalars['Int'];
  qtyPerPart: Scalars['Int'];
  supplier: InputMaybe<Scalars['String']>;
};

/** Represents a hole on a model, with a possible tap */
export type Hole = {
  __typename: 'Hole';
  /** from parameters */
  counterboreDepth: Maybe<Scalars['Float']>;
  /** from parameters */
  counterboreDiameter: Maybe<Scalars['Float']>;
  /** from parameters */
  countersinkAngle: Maybe<Scalars['Float']>;
  /** from parameters */
  countersinkDepth: Maybe<Scalars['Float']>;
  /** from parameters */
  countersinkDiameter: Maybe<Scalars['Float']>;
  /** from parameters */
  depth: Maybe<Scalars['Float']>;
  /** from parameters */
  diameter: Maybe<Scalars['Float']>;
  /** from parameters */
  direction: Maybe<Scalars['JSON']>;
  /** from parameters */
  endPoint: Maybe<Array<Scalars['Float']>>;
  /** holes with the same group key are considered similar */
  groupKey: Scalars['String'];
  /** feature mapping json file ID from features index position */
  id: Scalars['String'];
  /** from parameters */
  isBlind: Maybe<Scalars['Boolean']>;
  /** list of geometry patch IDs associated with this feature */
  patches: Array<RevisionPatch>;
  /** from parameters */
  startPoint: Maybe<Array<Scalars['Float']>>;
  tapAnnotation: Maybe<TapAnnotation>;
  tapOptions: Array<TapOption>;
  /** from parameters */
  tipAngle: Maybe<Scalars['Float']>;
  /** Type of hole */
  type: Scalars['String'];
};

/** Input type for updateHts mutation */
export type HtsUpdateInput = {
  application: InputMaybe<Scalars['String']>;
  description: InputMaybe<Scalars['String']>;
  htsCode: InputMaybe<Scalars['String']>;
  htsSubmitted: InputMaybe<Scalars['Boolean']>;
  salesOrderLineId: Scalars['String'];
  usageType: InputMaybe<Scalars['String']>;
};

/** Allowed partTypes values */
export enum HtsUsageType {
  production = 'production',
  prototype = 'prototype',
  unspecified = 'unspecified'
}

/** The granular pricing output for parts in a given tool */
export type ImPartPriceType = {
  __typename: 'ImPartPriceType';
  basePartCostCents: Maybe<Scalars['Int']>;
  colorAndSurfaceFinishDifficultyFactor: Maybe<Scalars['Int']>;
  cycleTimeSecs: Maybe<Scalars['Int']>;
  injectionCostCents: Maybe<Scalars['Int']>;
  materialCostCents: Maybe<Scalars['Int']>;
  packagingCostCents: Maybe<Scalars['Int']>;
  setupCostCents: Maybe<Scalars['Int']>;
  /** Record of type [qmrId: String]: Int */
  totalCustomerPriceInCentsPerQmr: Maybe<Scalars['JSON']>;
  totalPartsWeightGram: Maybe<Scalars['Int']>;
  /** Record of type [qmrId: String]: Int */
  unitCustomerPriceInCentsPerQmr: Maybe<Scalars['JSON']>;
  /** Record of type [qmrId: String]: Int */
  unitMpPayoutInCentsPerQmr: Maybe<Scalars['JSON']>;
};

/** Type that defines a preference option of an IM quote */
export type ImQuotePreference = {
  __typename: 'ImQuotePreference';
  label: Scalars['String'];
  name: Scalars['String'];
  value: Scalars['String'];
};

/** Input fields for IM quote preferences */
export type ImQuotePreferenceInput = {
  name: Scalars['String'];
  value: Scalars['String'];
};

/** Type that defines the requirements of a quote */
export type ImQuoteRequirements = {
  __typename: 'ImQuoteRequirements';
  additionalRequirementNotes: Maybe<Scalars['String']>;
  costAndLeadTimePreferences: Maybe<ImQuotePreference>;
  deliveryDate: Scalars['Date'];
  developmentStage: StageType;
  preferences: Maybe<ImQuotePreference>;
  productionRateForecast: Maybe<ProductionRateForecast>;
  toolLife: Maybe<ToolLifeType>;
  toolTypeNotes: Maybe<Scalars['String']>;
};

/** Input fields for IM quote requirements */
export type ImQuoteRequirementsInput = {
  additionalRequirementNotes: InputMaybe<Scalars['String']>;
  costAndLeadTimePreferences: InputMaybe<ImQuotePreferenceInput>;
  deliveryDate: Scalars['Date'];
  developmentStage: StageType;
  preferences: InputMaybe<ImQuotePreferenceInput>;
  productionRateForecast: InputMaybe<ProductionRateForecastInput>;
  toolLife: InputMaybe<ToolLifeType>;
  toolTypeNotes: InputMaybe<Scalars['String']>;
};

/** Used for Injection Molding Confidence Score */
export type ImScore = {
  __typename: 'ImScore';
  qmrId: Scalars['UUID'];
  score: Scalars['Float'];
};

/** The granular pricing output for a given tool */
export type ImToolingPriceType = {
  __typename: 'ImToolingPriceType';
  baseCostCents: Maybe<Scalars['Int']>;
  customerPrice: Maybe<Scalars['Int']>;
  designCostCents: Maybe<Scalars['Int']>;
  insertMachiningCostCents: Maybe<Scalars['Int']>;
  insertMaterialCostCents: Maybe<Scalars['Int']>;
  leadTimeDays: Maybe<Scalars['Int']>;
  materialCostCents: Maybe<Scalars['Int']>;
  moldAssemblyCostCents: Maybe<Scalars['Int']>;
  moldBaseCostCents: Maybe<Scalars['Int']>;
  moldTrialCostCents: Maybe<Scalars['Int']>;
  mpPayoutCents: Maybe<Scalars['Int']>;
  pressMachineSizeTon: Maybe<Scalars['Int']>;
  standardPartsCostCents: Maybe<Scalars['Int']>;
  structureCostCents: Maybe<Scalars['Int']>;
  surfaceFinishCostCents: Maybe<Scalars['Int']>;
};

/** Input fields for includePdf of shareQuote mutation */
export type IncludePdfInput = {
  carrierAccountId: InputMaybe<Scalars['UUID']>;
  discounts: Array<CouponInput>;
  forResale: InputMaybe<Scalars['Boolean']>;
  isShippingOptionForCarrier: InputMaybe<Scalars['Boolean']>;
  shippingMethods: InputMaybe<Array<ShippingMethodInput>>;
};

/** Input for IM part dimensions */
export type InjectionMoldingDimensionsInput = {
  depth: InputMaybe<Scalars['Float']>;
  length: InputMaybe<Scalars['Float']>;
  width: InputMaybe<Scalars['Float']>;
};

/** Input for DfmInspection im parameters */
export type InjectionMoldingParametersInput = {
  negativeLengthSliderQty: InputMaybe<Scalars['Int']>;
  negativeWidthSliderQty: InputMaybe<Scalars['Int']>;
  negativeZSliderQty: InputMaybe<Scalars['Int']>;
  partProductionDays: InputMaybe<Scalars['Int']>;
  positiveLengthSliderQty: InputMaybe<Scalars['Int']>;
  positiveWidthSliderQty: InputMaybe<Scalars['Int']>;
  positiveZSliderQty: InputMaybe<Scalars['Int']>;
  pricingColor: InputMaybe<Scalars['String']>;
  pricingDimensions: InputMaybe<InjectionMoldingDimensionsInput>;
  pricingFinish: InputMaybe<Scalars['String']>;
  pricingMaterial: InputMaybe<Scalars['String']>;
  pricingMaterialCost: InputMaybe<Scalars['Float']>;
  pricingMaterialDensity: InputMaybe<Scalars['Float']>;
  pricingMaterialDifficultyFactor: InputMaybe<Scalars['Float']>;
  volume: InputMaybe<Scalars['Float']>;
  wallThicknessMean: InputMaybe<Scalars['Float']>;
};

/** Injection Molding quote */
export type InjectionMoldingQuote = {
  __typename: 'InjectionMoldingQuote';
  costDrivers: Array<CostDriver>;
  id: Scalars['UUID'];
  leadTimeDays: Scalars['Int'];
  toolCostAmount: Scalars['Int'];
  unitCostAmount: Scalars['Int'];
};

/** The input to request an IM quote */
export type InjectionMoldingQuoteInput = {
  additionalInstructions: InputMaybe<Scalars['String']>;
  deliveredBy: InputMaybe<Scalars['String']>;
  estimateItemId: Scalars['UUID'];
  finish: InputMaybe<Scalars['String']>;
  material: InputMaybe<Scalars['String']>;
  phoneNumber: InputMaybe<Scalars['String']>;
  quantity: InputMaybe<Scalars['Int']>;
};

/** inspection data */
export type InspectionData = {
  __typename: 'InspectionData';
  numOfSetups: Maybe<Scalars['Int']>;
};

/**
 * Input for InspectionData
 *   miscNonRecurringEngineeringCostInCents ==> scrapMaterial + additionalNreInCents (OLD USE)
 *       - new use no longer rolls up other costs into miscNRE
 *   miscProductionCostInCents ==> threadCostsInCents + otherProductionCostsInCents
 */
export type InspectionDataInput = {
  additionalNreInCents: InputMaybe<Scalars['Int']>;
  advancedInspectionData: InputMaybe<AdvancedInspectionDataInput>;
  allowedInRegion: InputMaybe<DomesticAndOverseasManufacturabilityDataInput>;
  allowedPriorityIds: InputMaybe<Array<Scalars['String']>>;
  baseProductionDayOverridesByPriorityId: InputMaybe<LeadTimeOverridesInput>;
  camSeconds: InputMaybe<Scalars['Int']>;
  classA: InputMaybe<ClassATypeInput>;
  complexityCategory: InputMaybe<Scalars['String']>;
  deepHoleNonRecurringEngineeringCost: InputMaybe<Scalars['Int']>;
  deepHoleProductionCosts: InputMaybe<Scalars['Int']>;
  dfmTags: Array<DfmTags>;
  domesticReamerCosts: InputMaybe<Scalars['Int']>;
  domesticScrapMaterial: InputMaybe<Scalars['Int']>;
  domesticTapToolCosts: InputMaybe<Scalars['Int']>;
  domesticUndercuttingCosts: InputMaybe<Scalars['Int']>;
  edmNonRecurringEngineeringCost: InputMaybe<Scalars['Int']>;
  edmProductionCosts: InputMaybe<Scalars['Int']>;
  edmProductionCostsInCents: InputMaybe<DomesticAndOverseasCostDataInput>;
  edmStepItems: InputMaybe<Array<StepItemInput>>;
  hobbingNonRecurringEngineeringCost: InputMaybe<Scalars['Int']>;
  hobbingProductionCosts: InputMaybe<Scalars['Int']>;
  imParameters: InputMaybe<InjectionMoldingParametersInput>;
  machineTimeMultiplier: Scalars['Float'];
  machiningSeconds: InputMaybe<Scalars['Int']>;
  markupData: InputMaybe<PendingMarkupDataInput>;
  materialCostInCents: InputMaybe<Scalars['Int']>;
  materialCostsInCents: InputMaybe<DomesticAndOverseasCostDataInput>;
  materialStock: InputMaybe<Scalars['JSON']>;
  materialStocks: InputMaybe<DomesticAndOverseasMaterialStockDataInput>;
  minInsideRadius: InputMaybe<Scalars['Float']>;
  miscNonRecurringEngineeringCostInCents: Scalars['Int'];
  miscProductionCostInCents: Scalars['Int'];
  notes: InputMaybe<Scalars['String']>;
  numNonStandardFixtures: InputMaybe<Scalars['Float']>;
  numSetups: InputMaybe<Scalars['Int']>;
  numThreadedFeatures: InputMaybe<Scalars['Int']>;
  numTightTolerances: InputMaybe<Scalars['Int']>;
  numVeryTightTolerances: InputMaybe<Scalars['Int']>;
  otherProductionCostsInCents: InputMaybe<Scalars['Int']>;
  overseasEdmProductionCosts: InputMaybe<Scalars['Int']>;
  overseasMaterialCostInCents: InputMaybe<Scalars['Int']>;
  overseasMaterialStock: InputMaybe<Scalars['JSON']>;
  overseasReamerCosts: InputMaybe<Scalars['Int']>;
  overseasScrapMaterial: InputMaybe<Scalars['Int']>;
  overseasTapToolCosts: InputMaybe<Scalars['Int']>;
  overseasToolCosts: InputMaybe<Scalars['Int']>;
  overseasUndercuttingCosts: InputMaybe<Scalars['Int']>;
  reamerCostsInCents: InputMaybe<DomesticAndOverseasCostDataInput>;
  scrapMaterial: InputMaybe<Scalars['Int']>;
  scrapMaterialCostsInCents: InputMaybe<DomesticAndOverseasCostDataInput>;
  scrapRateData: InputMaybe<ScrapRateDataInput>;
  specialFixturingParameters: InputMaybe<SpecialFixturingParametersInput>;
  supportingDocAnalysis: InputMaybe<Scalars['JSON']>;
  tabbingMachiningSeconds: InputMaybe<Scalars['Int']>;
  tapToolCostsInCents: InputMaybe<DomesticAndOverseasCostDataInput>;
  threadCostsInCents: InputMaybe<Scalars['Int']>;
  threadsDescription: InputMaybe<Scalars['String']>;
  /** deprecated fields: */
  toolCosts: InputMaybe<Scalars['Int']>;
  toolCostsInCents: InputMaybe<DomesticAndOverseasCostDataInput>;
  undercuttingToolCostsInCents: InputMaybe<DomesticAndOverseasCostDataInput>;
};

/** Work Order inspection documents */
export type InspectionDocument = {
  __typename: 'InspectionDocument';
  createdAt: Scalars['Date'];
  downloadUrl: Maybe<Scalars['String']>;
  fileName: Maybe<Scalars['String']>;
  mimeType: Maybe<Scalars['String']>;
  productId: Maybe<Scalars['Int']>;
  type: AllowedInspectionDocumentType;
  updatedAt: Scalars['Date'];
};

/** Return type for result storing mutation */
export type InstantQuoterResponseType = {
  __typename: 'InstantQuoterResponseType';
  partId: Scalars['Int'];
  reason: Maybe<Scalars['String']>;
  status: InstantQuoterStatus;
};

/** Instant quoter result storing operation status */
export enum InstantQuoterStatus {
  failure = 'failure',
  success = 'success'
}

/** Nonconfigurable config information for an part's post process */
export type InvalidPostProcessConfigInfo = {
  __typename: 'InvalidPostProcessConfigInfo';
  color: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

/** Nonconfigurable config information for an part's secondary process */
export type InvalidSecondaryProcessConfigInfo = {
  __typename: 'InvalidSecondaryProcessConfigInfo';
  id: Scalars['String'];
  name: Maybe<Scalars['String']>;
};

/** ODOO Inventory Move record associated to job request (receipt/qc) */
export type InventoryMove = {
  __typename: 'InventoryMove';
  actualDate: Maybe<Scalars['Date']>;
  committedDate: Maybe<Scalars['Date']>;
  computedCommittedDate: Maybe<Scalars['Date']>;
  erpPurchaseOrderId: Scalars['Int'];
  erpWorkOrderRequestId: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
  operationPerformedBy: Maybe<Scalars['Int']>;
  porDate: Maybe<Scalars['Date']>;
  receivedFromMpOn: Maybe<Scalars['Date']>;
  state: Scalars['String'];
  type: Scalars['String'];
  writeDate: Maybe<Scalars['Date']>;
};

/** Invites is represented by a list of users in a folder. */
export type Invite = {
  __typename: 'Invite';
  createdAt: Scalars['Date'];
  deletedAt: Maybe<Scalars['Date']>;
  email: Maybe<Scalars['Email']>;
  id: Scalars['UUID'];
  isOpenEnded: Scalars['Boolean'];
  quoteUrl: Maybe<Scalars['String']>;
  recipient: Maybe<BasicUser>;
  sender: BasicUser;
  status: Scalars['String'];
  token: Scalars['String'];
};

/** An Job record represents a job to schedule */
export type Job = {
  __typename: 'Job';
  /** Actual transaction margin */
  actualTransactionMargin: Maybe<Scalars['Float']>;
  /** Auto OT Exception creation completed date */
  autoOtExceptionCreationAt: Maybe<Scalars['Date']>;
  /** bid count */
  bidCount: Maybe<Scalars['Int']>;
  /** Business Unit */
  businessUnit: Maybe<Scalars['String']>;
  buyNowPrice: Maybe<Scalars['Float']>;
  /** Job production country */
  countryCode: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['Date']>;
  createdBy: Maybe<BasicUser>;
  /** Customer Company Name */
  customerCompanyName: Maybe<Scalars['String']>;
  /** Customer Manufacturing DRI */
  customerMfgDri: Maybe<BasicUser>;
  /** Customer Name */
  customerName: Scalars['String'];
  /** Delivery date */
  deliveryDate: Maybe<Scalars['Date']>;
  /** Auto OT Delivery Exception consolidation completed date */
  deliveryExceptionConsolidationAt: Maybe<Scalars['Date']>;
  /** ERP sales order id for sales associated with job */
  erpSaleOrderId: Scalars['Int'];
  /** ERP work order id associated with job */
  erpWorkOrderId: Maybe<Scalars['Int']>;
  /** Auto OT Exception consolidation completed date */
  exceptionConsolidationAt: Maybe<Scalars['Date']>;
  /** Non-Voided exception count associated with job & job request */
  exceptionCount: Maybe<Scalars['Int']>;
  /** Currency exchange rates for a job */
  exchangeRates: Maybe<Array<JobExchangeRate>>;
  /** Has CNC Process */
  hasCnc: Scalars['Boolean'];
  /** History related to Job */
  history: Maybe<Array<ChangeHistory>>;
  /** Unique identifier for job */
  id: Scalars['Int'];
  isForJobBoard: Scalars['Boolean'];
  jobBoardEligibleMpsCount: Maybe<Scalars['Int']>;
  jobBoardEndDate: Maybe<Scalars['Date']>;
  /** Job board info */
  jobBoardId: Maybe<Scalars['UUID']>;
  jobBoardJobEndTime: Maybe<Scalars['Date']>;
  jobBoardRegion: Maybe<Scalars['String']>;
  jobBoardRegionId: Maybe<Scalars['String']>;
  jobBoardStartDate: Maybe<Scalars['Date']>;
  jobBoardStatus: Maybe<Scalars['String']>;
  /** Status combined of Job and Job request */
  jobComputedStatus: Maybe<Scalars['String']>;
  /** Non-Voided exception count associated with job only */
  jobExceptionCount: Maybe<Scalars['Int']>;
  /** Job Request Id */
  jobRequestId: Maybe<Scalars['Int']>;
  /** Max of lead times of all associated processes in the job */
  leadTime: Maybe<Scalars['Int']>;
  /** Lines associated with job */
  lines: Maybe<Array<JobLine>>;
  /** All materials associated with Job */
  materialNames: Maybe<Array<Scalars['String']>>;
  /** Manufacturing DRI */
  mfgDri: Maybe<BasicUser>;
  /** MP associated with Job request */
  mfgPartner: Maybe<MfgPartner>;
  /** Job Milestones */
  milestones: Maybe<JobMilestones>;
  /** MP Manufacturing DRI */
  mpMfgDri: Maybe<BasicUser>;
  /** Name of the job */
  name: Scalars['String'];
  /** Next milestone to come for Job */
  nextMilestone: Maybe<MilestoneType>;
  /** Notes associated with job */
  notes: Maybe<Array<Note>>;
  /** Jobs original payout */
  originalPayout: Maybe<Scalars['Float']>;
  /** Original transaction margin */
  originalTransactionMargin: Maybe<Scalars['Float']>;
  /** Original vendor due date - date before any updates on due date */
  originalVendorDueDate: Maybe<Scalars['Date']>;
  /** Pause exeception creation */
  pauseException: Scalars['Boolean'];
  /** Total payout of the Job */
  payout: Maybe<Scalars['Float']>;
  /** Total payout in cents of the Job */
  payoutInCents: Maybe<Scalars['Float']>;
  /** Planned schedule date */
  plannedScheduleDate: Maybe<Scalars['Date']>;
  /** Sales order priority associated to the job */
  priority: Maybe<Scalars['String']>;
  /** All processesses associated with Job */
  processNames: Maybe<Array<Scalars['String']>>;
  /** Current position on active item in queue */
  processedQueueItemCount: Maybe<Scalars['Int']>;
  /** Basic meta about parent project, if exists */
  project: Maybe<BasicProject>;
  /** Associated sale order project tags */
  projectTags: Maybe<Array<Scalars['String']>>;
  /** Total MPs assigned to job in queue */
  queueItemCount: Maybe<Scalars['Int']>;
  /** Queue status associated to the job, if no queue created status is 'empty' */
  queueStatus: Maybe<Scalars['String']>;
  /** Sale order quote dfm note */
  quoteDfmNotes: Maybe<Scalars['String']>;
  /** Sale order quote note */
  quoteNotes: Maybe<Scalars['String']>;
  /** Order region */
  region: Maybe<Scalars['String']>;
  /** RFQ Number */
  rfqNumber: Maybe<Scalars['String']>;
  /** Routes: Job used these scheduling types */
  routes: Maybe<Array<JobRoute>>;
  /** Sales DRI */
  salesDri: Maybe<BasicUser>;
  /** ERP sales order date */
  salesOrderCreatedAt: Scalars['Date'];
  /** Associated sales order name */
  salesOrderName: Maybe<Scalars['String']>;
  /** Schedule No earlier than */
  scheduleNoEarlierThan: Maybe<Scalars['Date']>;
  /** Scheduling DRI */
  schedulingDri: Maybe<BasicUser>;
  /** scheduling type for a job */
  schedulingType: Maybe<Scalars['String']>;
  /** Status of job */
  status: Scalars['String'];
  /**
   * Total payout of the Job
   * @deprecated Use payout instead.
   */
  totalPayout: Maybe<Scalars['Float']>;
  /** Does job is ON or OFF track? */
  trackStatus: Maybe<JobTrackStatus>;
  updatedAt: Maybe<Scalars['Date']>;
  updatedBy: Maybe<Scalars['Int']>;
  /** Job due date */
  vendorDueDate: Maybe<Scalars['Date']>;
  /** Notes for vendor */
  vendorNotes: Maybe<Scalars['String']>;
};


/** An Job record represents a job to schedule */
export type JobActualTransactionMarginArgs = {
  mfgPartnerId: InputMaybe<Scalars['Int']>;
  schedulingQueueItemId: InputMaybe<Scalars['Int']>;
};


/** An Job record represents a job to schedule */
export type JobLinesArgs = {
  mfgPartnerId: InputMaybe<Scalars['Int']>;
  schedulingQueueItemId: InputMaybe<Scalars['Int']>;
};


/** An Job record represents a job to schedule */
export type JobPayoutArgs = {
  mfgPartnerId: InputMaybe<Scalars['Int']>;
  schedulingQueueItemId: InputMaybe<Scalars['Int']>;
};

/** Bids for a job */
export type JobBid = {
  __typename: 'JobBid';
  additionalComments: Maybe<Scalars['String']>;
  bidAmount: Maybe<Scalars['Float']>;
  bidOn: Scalars['Date'];
  buyItNow: Maybe<Scalars['Float']>;
  createdAt: Scalars['Date'];
  exceptionCount: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  isCancel: Scalars['Boolean'];
  jobId: Scalars['Int'];
  jobRequestId: Maybe<Scalars['Int']>;
  mpCountry: Maybe<Scalars['String']>;
  mpName: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['Date']>;
  userId: Scalars['Int'];
  wonBid: Maybe<Scalars['Boolean']>;
};

/** A Job Board record */
export type JobBoard = {
  __typename: 'JobBoard';
  /** Accept now multiplier value */
  acceptNowMultiplier: Scalars['Float'];
  /** Job board created at */
  createdAt: Scalars['Date'];
  /** Job board created by */
  createdBy: BasicUser;
  /** End Date of job board */
  endDate: Scalars['Date'];
  /** Unique identifier for job board */
  id: Scalars['String'];
  /** Job board region name */
  jobBoardRegionName: Maybe<Scalars['String']>;
  /** Job board job duration */
  jobDuration: Maybe<Scalars['Int']>;
  /** Max threshold payout value */
  maxThresholdOfPayout: Scalars['Float'];
  /** Start Date of job board */
  startDate: Scalars['Date'];
  /** Status of job board */
  status: Scalars['String'];
  /** Job board updated by */
  updatedAt: Maybe<Scalars['Date']>;
  /** Job board updated by */
  updatedBy: Maybe<BasicUser>;
};

/** Job board job bid */
export type JobBoardBid = {
  __typename: 'JobBoardBid';
  additionalComments: Maybe<Scalars['String']>;
  bidAmount: Maybe<Scalars['Float']>;
  bidStatus: Maybe<BidStatus>;
  id: Scalars['UUID'];
};

/** Job Board Calendar record */
export type JobBoardCalendar = {
  __typename: 'JobBoardCalendar';
  /** Accept now multiplier value */
  acceptNowMultiplier: Maybe<Scalars['Float']>;
  /** Job board active or not */
  active: Maybe<Scalars['Boolean']>;
  /** End time of job board */
  endTime: Maybe<Scalars['String']>;
  /** Job board data allowed to edit or not */
  isEditable: Scalars['Boolean'];
  /** Job board date */
  jobBoardDate: Scalars['Date'];
  /** Job board id */
  jobBoardId: Maybe<Scalars['String']>;
  /** Job board region id */
  jobBoardRegionId: Scalars['UUID'];
  /** Job board region name */
  jobBoardRegionName: Scalars['String'];
  /** job duration */
  jobDuration: Maybe<Scalars['Int']>;
  /** Max threshold payout value */
  maxThresholdOfPayout: Maybe<Scalars['Float']>;
  /** Start time of job board */
  startTime: Maybe<Scalars['String']>;
  /** Job board status */
  status: Maybe<Scalars['String']>;
};

/** Job type for job board */
export type JobBoardJob = {
  __typename: 'JobBoardJob';
  /** current bids */
  bidAmount: Maybe<Scalars['Float']>;
  /** MP comment for bid */
  bidComment: Maybe<Scalars['String']>;
  /** job won or lost */
  bidStatus: BidStatus;
  /** buy now price */
  buyNowPrice: Maybe<Scalars['Float']>;
  /** Job bids */
  currentUserBid: Maybe<JobBoardBid>;
  /** Currency exchange rate for a job based on MP's preferred currency */
  exchangeRate: Maybe<JobExchangeRate>;
  /** Unique identifier for job */
  id: Scalars['Int'];
  /** Is MP interested in job or not */
  isNotInterested: Maybe<Scalars['Boolean']>;
  /** Job board job end time */
  jobBoardJobEndTime: Maybe<Scalars['Date']>;
  /** Lines associated with job */
  lines: Maybe<Array<JobLine>>;
  /** MP manufacturing DRI */
  mpMfgDri: Maybe<BasicUser>;
  /** Name of the job */
  name: Scalars['String'];
  /** Status of job */
  status: Scalars['String'];
  /** Job due date */
  vendorDueDate: Maybe<Scalars['Date']>;
};

/** Job part represents unique job part of no job rquest */
export type JobBoardJobPart = {
  __typename: 'JobBoardJobPart';
  id: Scalars['Int'];
  /** line inspection data */
  lineInspectionData: Maybe<JobLineInspectionData>;
  lines: Maybe<Array<JobLine>>;
  /** Mold tool related info */
  moldTool: Maybe<BasicMoldTool>;
  partProductRevision: Maybe<JobPartProductRevision>;
};

/** A Job participants record */
export type JobBoardParticipant = {
  __typename: 'JobBoardParticipant';
  /** ContactId of MP */
  contactId: Scalars['Int'];
  /** Participation created at */
  createdAt: Maybe<Scalars['Date']>;
  /** Unique identifier of participant */
  id: Scalars['Int'];
  /** Job board Id */
  jobBoardId: Scalars['String'];
  /** Date of participation */
  participatedAt: Maybe<Scalars['Date']>;
  /** is user have yet participated in job board */
  participatedInJobBoard: Maybe<Scalars['Boolean']>;
  /** CompanyId of MP */
  partnerId: Scalars['Int'];
  /** Participation updated at */
  updatedAt: Maybe<Scalars['Date']>;
};

/** Job board region */
export type JobBoardRegion = {
  __typename: 'JobBoardRegion';
  acceptNowMultiplier: Scalars['Float'];
  active: Scalars['Boolean'];
  days: Scalars['JSON'];
  endTime: Scalars['String'];
  id: Scalars['UUID'];
  jobDuration: Maybe<Scalars['Int']>;
  maxThresholdOfPayout: Scalars['Float'];
  name: Scalars['String'];
  nextJobBoard: Maybe<JobBoard>;
  startTime: Scalars['String'];
  timezone: Scalars['String'];
};

/** Job board job rejection reason */
export type JobBoardRejectionReasonInput = {
  additionalComment: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  estimatedDate: InputMaybe<Scalars['Date']>;
  reasonDetails: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
};

/** Job board status enum */
export enum JobBoardStatus {
  completed = 'completed',
  ended = 'ended',
  in_progress = 'in_progress',
  not_started = 'not_started'
}

/** Combined Job and Job request statuses */
export enum JobComputedStatus {
  canceled = 'canceled',
  completed = 'completed',
  in_inspection = 'in_inspection',
  in_primary_processing = 'in_primary_processing',
  in_secondary_processing = 'in_secondary_processing',
  inspection_submitted = 'inspection_submitted',
  unaccepted = 'unaccepted'
}

/** Job Exchange Rate Type */
export type JobExchangeRate = {
  __typename: 'JobExchangeRate';
  exchangeRate: Scalars['Float'];
  fromCurrency: Scalars['String'];
  id: Scalars['Int'];
  toCurrency: Scalars['String'];
};

/** Input for filtering list of jobs */
export type JobFiltersInput = {
  earliestDeliveryDateEnd: InputMaybe<Scalars['String']>;
  earliestDeliveryDateStart: InputMaybe<Scalars['String']>;
  exactMatchSalesOrderName: InputMaybe<Scalars['String']>;
  jobBoardEndDate: InputMaybe<Scalars['String']>;
  jobBoardStartDate: InputMaybe<Scalars['String']>;
  jobBoardStatus: InputMaybe<Array<JobBoardStatus>>;
  jobDueDateEnd: InputMaybe<Scalars['String']>;
  jobDueDateStart: InputMaybe<Scalars['String']>;
  jobName: InputMaybe<Scalars['String']>;
  jobStatus: InputMaybe<Array<InputMaybe<JobStatus>>>;
  leadTimeMax: InputMaybe<Scalars['Int']>;
  leadTimeMin: InputMaybe<Scalars['Int']>;
  manufacturingRegion: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mfgDriIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orderType: InputMaybe<Array<InputMaybe<OrderType>>>;
  payoutMax: InputMaybe<Scalars['Int']>;
  payoutMin: InputMaybe<Scalars['Int']>;
  priority: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  processIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  processTypeIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  projectName: InputMaybe<Scalars['String']>;
  queueStatus: InputMaybe<Array<InputMaybe<SchedulingQueueStatus>>>;
  salesOrderName: InputMaybe<Scalars['String']>;
};

/** An Job line record represents a line associated with job */
export type JobLine = {
  __typename: 'JobLine';
  /** Drawing url for related part */
  drawingUri: Maybe<Scalars['String']>;
  /** ERP work order line id associated with job line */
  erpWorkOrderLineId: Maybe<Scalars['Int']>;
  /** holes of part related to job line */
  holes: Maybe<Array<Hole>>;
  /** Uniqueue id for job line */
  id: Scalars['Int'];
  /** thread configuration details */
  lineInspectionData: Maybe<JobLineInspectionData>;
  /** contains basic part revision data */
  lineProductRevision: Maybe<BasicRevision>;
  /** Name of the job line */
  name: Scalars['String'];
  /** Sale order line processes associated to job line */
  orderLineProcesses: Maybe<Array<OrderProcessDetails>>;
  /** Original unit price */
  originalUnitPrice: Scalars['Float'];
  /** Original Vendor due date */
  originalVendorDueDate: Scalars['Date'];
  /** Payout adjustment reason description */
  payoutAdjDescription: Maybe<Scalars['String']>;
  /** Payout adjustment reason category */
  payoutAdjReasonCategory: Maybe<PayoutAdjustmentReasonCategory>;
  /** Payout adjustment reason sub category */
  payoutAdjReasonSubCategory: Maybe<PayoutAdjustmentReasonSubCategory>;
  /** Payout multiplier associated with MP */
  payoutMultiplier: Scalars['Float'];
  /** platform process type if like cnc, 3dp etc */
  platformProcessTypeId: Maybe<Scalars['String']>;
  /** Sale order line product process associated to job line */
  productProcess: SalesOrderLineProductProcess;
  /** Product quantity associated to job line */
  productQty: Scalars['Int'];
  /** Total payout (Unit Price * Product quantity * payout_multiplier (if applicable)) */
  totalPayout: Scalars['Float'];
  /** Unit price */
  unitPrice: Scalars['Float'];
  /** Unit price in cents */
  unitPriceInCents: Scalars['Float'];
  /** Vendor due date */
  vendorDueDate: Scalars['Date'];
};

/** Represents thread configuration of job */
export type JobLineInspectionData = {
  __typename: 'JobLineInspectionData';
  /** num of configured threads */
  configuredThreads: Maybe<Scalars['Int']>;
  /** total num of holes in part */
  holesTotal: Maybe<Scalars['Int']>;
  /** number of tight tolerances */
  tightTolerances: Maybe<Scalars['Int']>;
  /** num of un configured threads */
  unConfiguredThreads: Maybe<Scalars['Int']>;
  /** number of very tight tolerances */
  veryTightTolerances: Maybe<Scalars['Int']>;
};

/** Input for filtering list of jobs */
export type JobListFiltersInput = {
  businessUnits: InputMaybe<Array<Scalars['String']>>;
  committedCompletionEndDate: InputMaybe<Scalars['String']>;
  committedCompletionStartDate: InputMaybe<Scalars['String']>;
  committedProductionEndDate: InputMaybe<Scalars['String']>;
  committedProductionStartDate: InputMaybe<Scalars['String']>;
  customerCompanyName: InputMaybe<Scalars['String']>;
  customerMfgDriIds: InputMaybe<Array<Scalars['Int']>>;
  customerName: InputMaybe<Scalars['String']>;
  exactMatchSalesOrderName: InputMaybe<Scalars['String']>;
  jobBoardEndDate: InputMaybe<Scalars['String']>;
  jobBoardRegionIds: InputMaybe<Array<Scalars['String']>>;
  jobBoardStartDate: InputMaybe<Scalars['String']>;
  jobBoardStatus: InputMaybe<Array<JobBoardStatus>>;
  jobComputedStatus: InputMaybe<Array<JobComputedStatus>>;
  jobName: InputMaybe<Scalars['String']>;
  jobStatus: InputMaybe<Array<JobStatus>>;
  jobsForAutoOtExceptionsCreations: InputMaybe<Scalars['Boolean']>;
  jobsForDeliverExceptionConsolidation: InputMaybe<Scalars['Boolean']>;
  jobsForExceptionConsolidation: InputMaybe<Scalars['Boolean']>;
  leadTimeMax: InputMaybe<Scalars['Int']>;
  leadTimeMin: InputMaybe<Scalars['Int']>;
  manufacturingRegion: InputMaybe<Array<Scalars['String']>>;
  mfgPartnerIds: InputMaybe<Array<Scalars['Int']>>;
  mpMfgDriIds: InputMaybe<Array<Scalars['Int']>>;
  nextMilestone: InputMaybe<Array<MilestoneType>>;
  orderType: InputMaybe<Array<OrderType>>;
  payoutMax: InputMaybe<Scalars['Int']>;
  payoutMin: InputMaybe<Scalars['Int']>;
  priority: InputMaybe<Array<Scalars['String']>>;
  processIds: InputMaybe<Array<Scalars['Int']>>;
  processTypeIds: InputMaybe<Array<Scalars['Int']>>;
  productionCountry: InputMaybe<Array<JobProductionCountryFilter>>;
  projectName: InputMaybe<Scalars['String']>;
  queueStatus: InputMaybe<Array<SchedulingQueueStatus>>;
  salesOrderName: InputMaybe<Scalars['String']>;
  trackStatus: InputMaybe<Array<JobTrackStatus>>;
};

/** Job Milestones */
export type JobMilestones = {
  __typename: 'JobMilestones';
  customerDelivery: MilestoneDetails;
  deliveryOrder: MilestoneDetails;
  inspection: MilestoneDetails;
  production: MilestoneDetails;
  scheduling: MilestoneDetails;
  shipping: MilestoneDetails;
};

/** Result of Job parts */
export type JobPart = {
  __typename: 'JobPart';
  /** job part line item names suffix like A,B,C */
  lines: Maybe<Scalars['String']>;
  orderedQty: Scalars['Int'];
  partName: Scalars['String'];
  /** process names seperated by comma */
  processes: Maybe<Scalars['String']>;
  productId: Scalars['String'];
};

/** Part Product Revision Type */
export type JobPartProductRevision = {
  __typename: 'JobPartProductRevision';
  /** Revision data associated with this digital modal which can be shared with Fictiv partners. */
  basicRevision: Maybe<BasicRevision>;
  id: Scalars['Int'];
};

/** Job production countries */
export enum JobProductionCountry {
  CN = 'CN',
  IN = 'IN',
  MX = 'MX',
  US = 'US'
}

/** Job production countries for filter */
export enum JobProductionCountryFilter {
  CN = 'CN',
  IN = 'IN',
  MX = 'MX',
  US = 'US',
  Unassigned = 'Unassigned'
}

/** Options for job request rejection reasons */
export enum JobRejectionReason {
  capabilities = 'capabilities',
  low_payout = 'low_payout',
  material_sourcing = 'material_sourcing',
  no_capacity = 'no_capacity',
  other = 'other'
}

/** A Job Reqeust record represents a job request to schedule to MP */
export type JobRequest = {
  __typename: 'JobRequest';
  /** Job request accepted by MP at */
  acceptedAt: Maybe<Scalars['Date']>;
  /** Job request accepted by MP */
  acceptedBy: Maybe<BasicUser>;
  /** Actual transaction margin */
  actualTransactionMargin: Maybe<Scalars['Float']>;
  /** Additonal inspection submitted at */
  additionalInspectionSubmittedAt: Maybe<Scalars['Date']>;
  /** Exception related fields */
  associatedMpExceptionFailures: Maybe<Array<BasicExceptionFailure>>;
  /** Business Unit */
  businessUnit: Maybe<Scalars['String']>;
  /** Job request canceled at */
  canceledAt: Maybe<Scalars['Date']>;
  /** Job request canceled by */
  canceledBy: Maybe<BasicUser>;
  /** Job request completed by MP at */
  completedAt: Maybe<Scalars['Date']>;
  /** Job request completed by MP */
  completedBy: Maybe<BasicUser>;
  /** Job request created date */
  createdAt: Scalars['Date'];
  /** Job request created by user */
  createdBy: BasicUser;
  /** Delivery Orders associated to job request */
  deliveryOrders: Maybe<Array<SalesOrderDeliveryOrder>>;
  /** Earliest delivery order date */
  earliestDeliveryOrderDate: Maybe<Scalars['Date']>;
  /** Earliest receipt date */
  earliestReceiptdate: Maybe<Scalars['Date']>;
  /** Purchase order id of job request generated in ERP */
  erpPurchaseOrderId: Maybe<Scalars['Int']>;
  /** Mapped ERP work order request id */
  erpWorkOrderRequestId: Maybe<Scalars['Int']>;
  /** Count of exceptions associated with Job Request */
  exceptionCount: Scalars['Int'];
  /** Whether a production and shipping exception created by Fictiv */
  exceptionFailureCreatedByFictivExist: Maybe<ExceptionFailureCreatedByFictivExist>;
  /** Currency exchange rate for a job request */
  exchangeRate: Maybe<JobExchangeRate>;
  /** Job request expiry date */
  expiresAt: Scalars['Date'];
  /** Followers set for job request in ERP system */
  followers: Maybe<Array<FollowerUser>>;
  hasPostProcess: Maybe<Scalars['Boolean']>;
  /** History related to Job request */
  history: Maybe<Array<ChangeHistory>>;
  /** Unique identifier for job request */
  id: Scalars['Int'];
  inspectionReportState: Maybe<AllowedWorkOrderItemInspectionStates>;
  /** Job Request Inspection Status */
  inspectionStatus: Maybe<Scalars['String']>;
  /** Job Request Inspection Submitted Date */
  inspectionSubmittedAt: Maybe<Scalars['Date']>;
  /** Return if additional inspection submission allowed or not */
  isAdditionalInspectionSubmissionAllowed: Maybe<Scalars['Boolean']>;
  /** Allowed to report production delay? */
  isReportProductionDelayAllowed: Maybe<Scalars['Boolean']>;
  /** Allowed to report shipping delay? */
  isReportShippingDelayAllowed: Maybe<Scalars['Boolean']>;
  isSecurePlus: Maybe<Scalars['Boolean']>;
  /** Id of associated job */
  jobId: Scalars['Int'];
  jobRequestAttachments: Array<WorkOrderAttachment>;
  /** List of comments associated with job request. */
  jobRequestComments: Array<WorkOrderComment>;
  /** job request state/status used in production job request */
  jobRequestStatus: Maybe<Scalars['String']>;
  /** Lines associated with job request */
  lines: Maybe<Array<JobRequestLine>>;
  linesWithWorkOrderMapping: Maybe<Array<JobRequestLine>>;
  /** Dri of job associated with job request */
  mfgDri: Maybe<User>;
  /** Id of associated MFG DRI */
  mfgDriUserId: Maybe<Scalars['Int']>;
  /** MP associated with Job request */
  mfgPartner: MfgPartner;
  /** List of associated corrective action requests */
  mpCorrectiveActionRequests: Maybe<Array<CorrectiveActionRequest>>;
  /** Total of MP corrective action requests */
  mpCorrectiveActionRequestsCount: Scalars['Int'];
  /** Name of the job request */
  name: Scalars['String'];
  nextProductionStage: Maybe<Scalars['String']>;
  /** Original payout of job request */
  originalPayout: Scalars['Float'];
  /** Original transaction margin */
  originalTransactionMargin: Maybe<Scalars['Float']>;
  /** Original due date of job request */
  originalVendorDueDate: Scalars['Date'];
  partnerMaterial: Maybe<JobRequestMaterialType>;
  /** List of all the unique parts in job request */
  parts: Maybe<Array<JobRequestPartProduct>>;
  /** Payout of job request */
  payout: Scalars['Float'];
  /** Payout in cents of job request */
  payoutInCents: Scalars['Float'];
  /** Flag to check if inspection photos are uploaded by MP */
  photosUploadedByMp: Maybe<Scalars['Boolean']>;
  /** Job Request Priority */
  priority: Maybe<Scalars['String']>;
  process: Maybe<JobRequestProcessType>;
  /** Process names for job request */
  processNames: Maybe<Array<Scalars['String']>>;
  /** Job Request production stage */
  productionStage: Maybe<Scalars['String']>;
  /** Basic meta about parent project, if exists */
  project: Maybe<BasicProject>;
  /** Job request qc type */
  qcType: Maybe<JobRequestQcType>;
  /** Job request associated QC records */
  qualityChecks: Maybe<Array<InventoryMove>>;
  /** Job request associated receipt(s) */
  receipts: Maybe<Array<InventoryMove>>;
  /** Job request rejected by MP at */
  rejectedAt: Maybe<Scalars['Date']>;
  /** Job request rejected by MP */
  rejectedBy: Maybe<BasicUser>;
  /** Comment added while rejection job */
  rejectionComment: Maybe<Scalars['String']>;
  /** Job rejection reason */
  rejectionReason: Maybe<JobRejectionReason>;
  /** Job rejection additional information */
  rejectionReasonAdditionalInfo: Maybe<Scalars['String']>;
  /** RFQ Number */
  rfqNumber: Maybe<Scalars['String']>;
  /** Risk status for job request */
  riskStatus: Maybe<RiskStatus>;
  /** Sale Order Id */
  salesOrderId: Scalars['Int'];
  /** Sale Order Name */
  salesOrderName: Scalars['String'];
  /** Due date of jobs secondary process if available */
  secondaryProcessStartDate: Maybe<Scalars['Date']>;
  /** List of all unique services on the job request */
  services: Maybe<Array<JobRequestLine>>;
  /** Flag to Show or Hide Job request details for MP */
  showDetails: Maybe<Scalars['Boolean']>;
  /** Work order related fields - added while decoupling from odoo */
  state: Scalars['String'];
  /** Current state of job request */
  status: Scalars['String'];
  subjectTypes: Array<SubjectType>;
  /** Job request updated date */
  updatedAt: Maybe<Scalars['Date']>;
  /** Job request updated by user */
  updatedBy: Maybe<BasicUser>;
  /** Due date of job request */
  vendorDueDate: Scalars['Date'];
  /** Notes added for MP */
  vendorNotes: Maybe<Scalars['String']>;
  /** Job request viewed by MP at */
  viewedAt: Maybe<Scalars['Date']>;
  /** Job request viewed by MP */
  viewedBy: Maybe<BasicUser>;
  /** Job request write date */
  writeDate: Maybe<Scalars['Date']>;
};


/** A Job Reqeust record represents a job request to schedule to MP */
export type JobRequestSubjectTypesArgs = {
  category: InputMaybe<SubjectCategory>;
};

/** Represents a job request comment */
export type JobRequestComment = {
  __typename: 'JobRequestComment';
  attachments: Array<ErpAttachment>;
  /** The user object representing the user who authored this comment. */
  author: Maybe<BasicUser>;
  /** Body text of the comment. */
  body: Scalars['String'];
  /** Timestamp for when this job request comment was created. */
  createdAt: Scalars['Date'];
  /** Unique identifier for this job request comment. */
  id: Scalars['Int'];
  /** Subject of the comment */
  subject: Maybe<Scalars['String']>;
  /** Timestamp for when this job request comment was updated. */
  updatedAt: Scalars['Date'];
};

/** Input fields for a creating a JobRequestComment */
export type JobRequestCommentInput = {
  attachmentIds: InputMaybe<Array<Scalars['Int']>>;
  body: Scalars['String'];
  id: Scalars['String'];
  partName: InputMaybe<Scalars['String']>;
  subject: InputMaybe<AllowedSubjectTypes>;
};

/** Options for job request inspection status */
export enum JobRequestInspectionStatus {
  completed = 'completed',
  in_progress = 'in_progress',
  pending = 'pending'
}

/** An Job request line record represents a line associated with job request */
export type JobRequestLine = {
  __typename: 'JobRequestLine';
  color: Maybe<JobRequestLineColor>;
  drawingUri: Maybe<Scalars['String']>;
  /** ERP work order line id associated with job request line */
  erpWorkOrderRequestLineId: Maybe<Scalars['Int']>;
  holes: Maybe<Array<Hole>>;
  /** Uniqueue id for job request line */
  id: Scalars['Int'];
  inspection: Maybe<JobRequestLineInspection>;
  /** Inspection state */
  inspectionState: Maybe<Scalars['String']>;
  /** Inspection submitted at */
  inspectionSubmittedAt: Maybe<Scalars['Date']>;
  /** Inspection submitted by */
  inspectionSubmittedBy: Maybe<BasicUser>;
  /** Inspection type */
  inspectionType: Scalars['String'];
  /** Job request line attachments */
  jobRequestLineAttachments: Array<WorkOrderAttachment>;
  materialColor: Maybe<Scalars['String']>;
  materialName: Maybe<Scalars['String']>;
  moldTool: Maybe<BasicMoldTool>;
  /** Name of the job request line */
  name: Scalars['String'];
  /** Sale order line processes associated to job request line */
  orderLineProcesses: Maybe<Array<OrderProcessDetails>>;
  /** Original unit price */
  originalUnitPrice: Scalars['Float'];
  /** Original Vendor due date */
  originalVendorDueDate: Scalars['Date'];
  partProduct: Maybe<JobRequestLinePartProduct>;
  /** Payout adjustment reason description */
  payoutAdjDescription: Maybe<Scalars['String']>;
  /** Payout adjustment reason category */
  payoutAdjReasonCategory: Maybe<PayoutAdjustmentReasonCategory>;
  /** Payout adjustment reason sub category */
  payoutAdjReasonSubCategory: Maybe<PayoutAdjustmentReasonSubCategory>;
  /** Payout multiplier associated with MP */
  payoutMultiplier: Scalars['Float'];
  platformProcessId: Maybe<Scalars['String']>;
  processColor: Maybe<Scalars['String']>;
  /** Fields added for odoo decouple */
  processName: Maybe<Scalars['String']>;
  processNotes: Maybe<Scalars['String']>;
  processTexture: Maybe<Scalars['String']>;
  processThickness: Maybe<Scalars['String']>;
  processType: Maybe<Scalars['String']>;
  /** Product process associated to job request line */
  productProcess: SalesOrderLineProductProcess;
  /** Product quantity associated to job request line */
  productQty: Scalars['Int'];
  /** Is Quality check complete? */
  qcComplete: Maybe<Scalars['Boolean']>;
  /** Is Receipt complete? */
  receiptComplete: Maybe<Scalars['Boolean']>;
  shoreValue: Maybe<Scalars['String']>;
  /** Job request line payout (Unit Price * Product quantity) */
  totalPayout: Scalars['Float'];
  /** Unit price */
  unitPrice: Scalars['Float'];
  /** Unit price in cents */
  unitPriceInCents: Scalars['Float'];
  /** Vendor due date */
  vendorDueDate: Scalars['Date'];
};

/** Input to create a new JobRequestAttachment for multiple parts */
export type JobRequestLineAttachmentInput = {
  attachment: AttachmentInput;
  jobRequestId: Scalars['String'];
  jobRequestLineIds: Array<Scalars['Int']>;
  source: AllowedAttachmentSources;
  type: InputMaybe<AllowedQualityAttachmentTypes>;
};

/** Job Request Line Color */
export type JobRequestLineColor = {
  __typename: 'JobRequestLineColor';
  id: Maybe<Scalars['Int']>;
  name: Maybe<Scalars['String']>;
};

/** Job Request Line Inspection */
export type JobRequestLineInspection = {
  __typename: 'JobRequestLineInspection';
  id: Scalars['String'];
  state: Maybe<Scalars['String']>;
};

/** Job Request Line Part Product */
export type JobRequestLinePartProduct = {
  __typename: 'JobRequestLinePartProduct';
  colorName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['Int']>;
  partFileName: Maybe<Scalars['String']>;
  partProductRevision: Maybe<JobRequestPartProductRevision>;
};

/** Job request material */
export type JobRequestMaterialType = {
  __typename: 'JobRequestMaterialType';
  name: Scalars['String'];
};

/** Available mutations on individual job request */
export type JobRequestMutation = {
  __typename: 'JobRequestMutation';
  /** Set the production stage for this job request */
  setJobRequestProductionStage: Maybe<JobRequest>;
};


/** Available mutations on individual job request */
export type JobRequestMutationSetJobRequestProductionStageArgs = {
  stage: ProductionStage;
};

/** Result of Job request parts */
export type JobRequestPart = {
  __typename: 'JobRequestPart';
  /** job request line item names suffix like A,B,C */
  lines: Maybe<Scalars['String']>;
  orderedQty: Scalars['Int'];
  partName: Scalars['String'];
  /** process names seperated by comma */
  processes: Maybe<Scalars['String']>;
  productId: Scalars['String'];
};

/** Part Product Type */
export type JobRequestPartProduct = {
  __typename: 'JobRequestPartProduct';
  id: Scalars['Int'];
  jobRequestId: Scalars['Int'];
  linesWithWorkOrderMapping: Maybe<Array<JobRequestLine>>;
  moldTool: Maybe<BasicMoldTool>;
  /** Digital model for this part. */
  partProductRevision: Maybe<JobRequestPartProductRevision>;
  productConfiguration: Maybe<ProductConfiguration>;
};

/** Part Product Revision Type */
export type JobRequestPartProductRevision = {
  __typename: 'JobRequestPartProductRevision';
  /** Revision data associated with this digital modal which can be shared with Fictiv partners. */
  basicRevision: Maybe<BasicRevision>;
  id: Scalars['Int'];
};

/** Job request primary process */
export type JobRequestProcessType = {
  __typename: 'JobRequestProcessType';
  id: Maybe<Scalars['Int']>;
  name: Maybe<Scalars['String']>;
};

/** Job request qc type */
export enum JobRequestQcType {
  physical = 'physical',
  virtual = 'virtual'
}

/** job request receipt */
export type JobRequestReceipt = {
  __typename: 'JobRequestReceipt';
  date: Maybe<Scalars['Date']>;
  id: Scalars['Int'];
  name: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
};

/** input for JobRequest Rejection Reason */
export type JobRequestRejectionInput = {
  rejectionComment: InputMaybe<Scalars['String']>;
  rejectionReason: JobRejectionReason;
  rejectionReasonAdditionalInfo: InputMaybe<Scalars['String']>;
};

/** Result of a paginated list of Job requests. */
export type JobRequestResults = {
  __typename: 'JobRequestResults';
  /** List of Job requests found */
  items: Maybe<Array<JobRequest>>;
  /** Information for the skipping previous records */
  offset: Maybe<Scalars['Int']>;
  /** Count of all results */
  totalCount: Scalars['Int'];
};

/** Job request post process risk status */
export enum JobRequestRiskState {
  at_risk = 'at_risk',
  completed = 'completed',
  not_available = 'not_available',
  not_started = 'not_started',
  on_track = 'on_track'
}

/** Options for job request status */
export enum JobRequestStatus {
  accepted = 'accepted',
  canceled = 'canceled',
  completed = 'completed',
  expired = 'expired',
  rejected = 'rejected',
  sent = 'sent',
  viewed = 'viewed'
}

/** An Job route record represents a single scheduling type details used to route job */
export type JobRoute = {
  __typename: 'JobRoute';
  active: Scalars['Boolean'];
  createdAt: Scalars['Date'];
  createdBy: Maybe<BasicUser>;
  id: Scalars['Int'];
  jobBoardRouteId: Maybe<Scalars['Int']>;
  productionCountry: Scalars['String'];
  schedulingType: Scalars['String'];
};

/** input object for job scheduling partners */
export type JobSchedulingPartnerInput = {
  id: Scalars['Int'];
  isRecommendedMP: InputMaybe<Scalars['Boolean']>;
  recommendedRank: InputMaybe<Scalars['Int']>;
  recommendedRequestId: InputMaybe<Scalars['Int']>;
  schedulingMethod: SchedulingMethod;
  sequenceNo: Scalars['Int'];
};

/** Input type for jobs sort */
export type JobSortInput = {
  name: AllowedJobsSort;
  order: AllowedJobsSortOrder;
};

/** Job statuses */
export enum JobStatus {
  accepted = 'accepted',
  canceled = 'canceled',
  completed = 'completed',
  unaccepted = 'unaccepted'
}

/** Track status for job */
export enum JobTrackStatus {
  off_track = 'off_track',
  on_track = 'on_track'
}

/** Result of a paginated list of jobs. */
export type JobsListResult = {
  __typename: 'JobsListResult';
  /** List of jobs */
  items: Array<Job>;
  /** Count of all jobs */
  totalCount: Scalars['Int'];
};

/** Input for lead time overrides in admin quoting page */
export type LeadTimeOverridesInput = {
  economy: InputMaybe<Scalars['Int']>;
  flex: InputMaybe<Scalars['Int']>;
  overseas: InputMaybe<Scalars['Int']>;
  rush: InputMaybe<Scalars['Int']>;
  saver: InputMaybe<Scalars['Int']>;
  standard: InputMaybe<Scalars['Int']>;
};

/** Represents lifter dimensions */
export type Lifter = {
  __typename: 'Lifter';
  length: Maybe<Scalars['Float']>;
  width: Maybe<Scalars['Float']>;
};

/** Input for lifters */
export type LifterInput = {
  length: InputMaybe<Scalars['Float']>;
  width: InputMaybe<Scalars['Float']>;
};

/** Type for Line Items counts */
export type LineItemsCountType = {
  __typename: 'LineItemsCountType';
  ifCount: Scalars['Int'];
  otCount: Scalars['Int'];
  total: Scalars['Int'];
};

/** ENUM for manual cancel car reasons */
export enum ManualCarCancelationReasons {
  failure_caused_by_carrier = 'failure_caused_by_carrier',
  no_response = 'no_response',
  other_manufacturing_partner = 'other_manufacturing_partner',
  responsibility_unclear = 'responsibility_unclear'
}

/** Fields for manually quoting secondary processes */
export type ManualQuoteFieldsForSecondaryProcesses = {
  __typename: 'ManualQuoteFieldsForSecondaryProcesses';
  leadTimeInDays: Maybe<Scalars['Int']>;
  leadTimePartsLimit: Scalars['Int'];
  markupPercentage: Scalars['Float'];
  mpPayoutInCents: Maybe<Scalars['Float']>;
  mpPayoutPartsLimit: Scalars['Int'];
};

/** Input for manually/admin quoted secondary mfg production process (i.e. processes not yet auto-quotable) */
export type ManuallyQuotedSecondaryProcessConfigInput = {
  domesticProductionConfigInput: InputMaybe<ManuallyQuotedSecondaryProcessRegionalInput>;
  internationalProductionConfigInput: InputMaybe<ManuallyQuotedSecondaryProcessRegionalInput>;
  notes: InputMaybe<Scalars['String']>;
  processId: Scalars['String'];
};

/** Regionally differentiated input for manually/admin quoted secondary mfg production process (i.e. processes not yet auto-quotable) */
export type ManuallyQuotedSecondaryProcessRegionalInput = {
  /** Production time in days */
  leadTime: Scalars['Int'];
  /** 0 indicates a null value essentially; it's just a flat charge in that case */
  leadTimePartsLimit: Scalars['Int'];
  mpPayoutInCents: Scalars['Float'];
  /** 0 indicates a null value essentially; it's just a flat charge in that case */
  mpPayoutPartsLimit: Scalars['Int'];
  percentMarkup: Scalars['Float'];
};

/**
 * The ManufacturingDrawing is the document that gets sent out
 * to the manufacturing partners. It's attached in the following situations:
 *   - Generated automatically based on taps
 *   - An admin creates a SanitizedDrawing through the UI
 *   - An admin directly uploads a SanitizedDrawing
 */
export type ManufacturingDrawing = GeneratedDrawing | SanitizedAttachment;

/** This is a simplified version of ManufacturingDrawing, which is deprecated beacuse it was a difficult to use model. It is the document that gets sent to Manufacturing Partners. */
export type ManufacturingPartnerDrawing = {
  __typename: 'ManufacturingPartnerDrawing';
  fictivFiveCallouts: Array<FictivFiveCallout>;
  signedDownloadUrl: Maybe<Scalars['String']>;
};

/** Data structure for adjusting markups */
export type MarkupData = {
  __typename: 'MarkupData';
  markups: MarkupsByPriority;
  quantityRanges: Array<Scalars['Int']>;
};

/** Input needed to adjust platform markups */
export type MarkupDataInput = {
  markups: MarkupsByPriorityInput;
  quantityRanges: Array<Scalars['Int']>;
};

/** Mapping of priority to markups at different quantity ranges. */
export type MarkupsByPriority = {
  __typename: 'MarkupsByPriority';
  economy: Array<Scalars['Float']>;
  flex: Array<Scalars['Float']>;
  overseas: Array<Scalars['Float']>;
  premium: Array<Scalars['Float']>;
  rush: Array<Scalars['Float']>;
  saver: Array<Scalars['Float']>;
  standard: Array<Scalars['Float']>;
};

/** Mapping of priority to markups at different quantity ranges input. */
export type MarkupsByPriorityInput = {
  economy: Array<Scalars['Float']>;
  flex: Array<Scalars['Float']>;
  overseas: Array<Scalars['Float']>;
  premium: Array<Scalars['Float']>;
  rush: Array<Scalars['Float']>;
  saver: Array<Scalars['Float']>;
  standard: Array<Scalars['Float']>;
};

/** A quotable material. */
export type Material = {
  __typename: 'Material';
  fdmInfillOptions: Maybe<Array<FdmInfillOption>>;
  id: Scalars['String'];
  materialCategory: Maybe<Scalars['String']>;
  name: Scalars['String'];
  processTechnologyId: Maybe<Scalars['String']>;
  processTechnologyName: Maybe<Scalars['String']>;
};

/** distinct categories of additional specifications available on each material */
export type MaterialAdditionalSpecifications = {
  __typename: 'MaterialAdditionalSpecifications';
  color: Maybe<Scalars['String']>;
  material: Maybe<Scalars['String']>;
  shoreValue: Maybe<Scalars['String']>;
};

/** A manufacturing material configuration option. */
export type MaterialConfigurationOption = {
  __typename: 'MaterialConfigurationOption';
  colorId: Maybe<Scalars['String']>;
  colorName: Maybe<Scalars['String']>;
  id: Scalars['String'];
  shoreId: Maybe<Scalars['String']>;
  shoreName: Maybe<Scalars['String']>;
};

/** Density information for a quotable material. */
export type MaterialDensity = {
  __typename: 'MaterialDensity';
  lbsPerCubicInch: Scalars['Float'];
  platformMaterialId: Scalars['String'];
  standardDensityMaterial: Scalars['String'];
};

/** distinct categories of dfm notes available on each material */
export type MaterialDfmNotes = {
  __typename: 'MaterialDfmNotes';
  color: Maybe<Scalars['String']>;
  material: Maybe<Scalars['String']>;
  shoreValue: Maybe<Scalars['String']>;
};

/**
 * A wrapper for a material and the resulting
 * configuration options from selecting it
 */
export type MaterialOption = {
  __typename: 'MaterialOption';
  colorOptions: Maybe<Array<Color>>;
  finishOptions: Maybe<Array<Finish>>;
  id: Scalars['String'];
  material: Material;
  postProcessOptions: Maybe<Array<PostProcess>>;
  priorityOptions: Array<Priority>;
  shoreOptions: Maybe<Array<Shore>>;
  toleranceOptions: Maybe<Array<Tolerance>>;
  toolLifeOptions: Maybe<Array<ToolLife>>;
};

/** Material stock selection for a given part */
export type MaterialStock = {
  __typename: 'MaterialStock';
  boundingBox: Maybe<BoundingBox>;
  boundingCylinder: Maybe<BoundingCylinder>;
  id: Scalars['String'];
  materialId: Maybe<Scalars['String']>;
  partQuantity: Maybe<Scalars['Int']>;
  stockPartNumber: Maybe<Scalars['String']>;
  stockPricePerPartInCents: Maybe<Scalars['Int']>;
  stockPricePerUnitInCents: Maybe<Scalars['Int']>;
  stockPriceTotalInCents: Maybe<Scalars['Int']>;
  stockQuantity: Maybe<Scalars['Int']>;
  stockUnitVolumeInMm: Maybe<Scalars['Int']>;
  supplier: Maybe<Scalars['String']>;
};

/** Membership is represented by a list of users in a folder. */
export type Membership = {
  __typename: 'Membership';
  id: Scalars['UUID'];
  role: Scalars['String'];
  user: BasicUser;
};

/** Status to check if a request for merging downloadable DFM pdf is in progress */
export type MergedDfmReadyStatus = {
  __typename: 'MergedDfmReadyStatus';
  error: Maybe<Scalars['String']>;
  loading: Scalars['Boolean'];
  signedUrl: Maybe<Scalars['String']>;
};

/** Primitive types for conveying geometric data */
export type Metric = {
  __typename: 'Metric';
  count: Scalars['Int'];
};

/** The input for sendMetrics */
export type MetricInput = {
  name: Scalars['String'];
  points: Array<Scalars['Float']>;
  tags: InputMaybe<Array<Scalars['String']>>;
  /** Should be one of ['count', 'gauge', 'rate'] */
  type: InputMaybe<Scalars['String']>;
};

/** Type for mfg partner */
export type MfgPartner = {
  __typename: 'MfgPartner';
  /** Is MP active */
  active: Scalars['Boolean'];
  /** Is mfg partner back stopping MP */
  backstopMp: Maybe<Scalars['Boolean']>;
  /** MP Country */
  countryName: Scalars['String'];
  /** Manufacturing Partner Level */
  currentMpLevelDetails: Maybe<MfgPartnerLevelCalculationRecord>;
  /** MP Display Name */
  displayName: Scalars['String'];
  /** Is mfg partner in fictiv hiatus */
  fictivHiatus: Maybe<Scalars['Boolean']>;
  /** GMLE group of mfg partner */
  gmleGroup: Maybe<Scalars['String']>;
  /** Is mfg partner accepts high touch orders only */
  highTouchOnly: Maybe<Scalars['Boolean']>;
  /** Unique identifier for MP */
  id: Scalars['Int'];
  /** Is Manufacturing Partner approved */
  isApprovedVendor: Scalars['Boolean'];
  /** Is MP eligible for work */
  isEligibleForWork: Maybe<Scalars['Boolean']>;
  /** MP availability */
  isMpAvailable: Scalars['Boolean'];
  /** Is MP a SecurePlus MP */
  isSecurePlusMp: Scalars['Boolean'];
  /** MP Job Acceptance hours */
  jobAcceptanceHours: Array<Maybe<MfgPartnerJobAcceptanceHours>>;
  /** Was Last Scorecard Sent */
  lastScorecardSent: Maybe<Scalars['Boolean']>;
  /** MP Cutoff Time */
  mpCutoffTime: Scalars['String'];
  /** Manufacturing partner level override in effect or not */
  mpLevelOverrideInEffect: Maybe<Scalars['Boolean']>;
  /** MP Name */
  name: Scalars['String'];
  /** Open car count */
  openCarsCount: Maybe<Scalars['Int']>;
  /** Open failures count */
  openFailuresCount: Maybe<Scalars['Int']>;
  /** Open job request count for status like ('sent', 'viewed', 'accepted') */
  openJobsCount: Maybe<Scalars['Int']>;
  /** Preferred carriers of mfg partner */
  preferredCarriers: Maybe<Array<Scalars['String']>>;
  /** Preferred currency of mfg partner */
  preferredCurrency: Maybe<Scalars['String']>;
  /** List of active processes of mfg partner */
  processes: Maybe<Array<MfgPartnerProcess>>;
  /** List of active processes with availability of mfg partner */
  processesWithAvailability: Maybe<Array<MfgPartnerProcessAvailability>>;
  /** Skip or pause scheduling queue */
  skipOrPauseSchedulingQueue: Scalars['String'];
  /** Strategic Sourcing Manager assigned to mfg partner */
  strategicSourcingManager: Maybe<BasicUser>;
  /** Supplier Development Engineer assigned to mfg partner */
  supplierDevelopmentEngineer: Maybe<BasicUser>;
  /** Supplier Quality Engineer assigned to Mfg Partner */
  supplierQualityEngineer: Maybe<BasicUser>;
  /** MP Timezone */
  tz: Scalars['String'];
};


/** Type for mfg partner */
export type MfgPartnerIsMpAvailableArgs = {
  forDate: InputMaybe<Scalars['Date']>;
  jobId: Scalars['Int'];
};


/** Type for mfg partner */
export type MfgPartnerProcessesWithAvailabilityArgs = {
  date: Scalars['Date'];
};

/** Input for filtering list of mfg partners */
export type MfgPartnerFiltersInput = {
  countryIds: InputMaybe<Array<Scalars['Int']>>;
  isApprovedVendor: InputMaybe<Array<Scalars['String']>>;
  isEligibleForWork: InputMaybe<Array<Scalars['String']>>;
  lastScorecardSent: InputMaybe<Array<Scalars['String']>>;
  mpLevelOverrideInEffect: InputMaybe<Array<Scalars['String']>>;
  mpLevels: InputMaybe<Array<MfgPartnerLevelType>>;
  mpNameLike: InputMaybe<Scalars['String']>;
  strategicSourcingManagerIds: InputMaybe<Array<Scalars['Int']>>;
  supplierDevelopmentEngineerIds: InputMaybe<Array<Scalars['Int']>>;
  supplierQualityEngineerIds: InputMaybe<Array<Scalars['Int']>>;
};

/** Type For Mfg Partner Job Acceptance Hours */
export type MfgPartnerJobAcceptanceHours = {
  __typename: 'MfgPartnerJobAcceptanceHours';
  /** Close TIme */
  closeTime: Scalars['String'];
  /** Day Id */
  day: Scalars['Int'];
  /** Day Name */
  dayName: Scalars['String'];
  /** Name */
  name: Maybe<Scalars['String']>;
  /** Open Time */
  openTime: Scalars['String'];
  /** partner id */
  partnerId: Scalars['Int'];
};

/** Type for 1 calculation record for an MP */
export type MfgPartnerLevelCalculationRecord = {
  __typename: 'MfgPartnerLevelCalculationRecord';
  /** Acceptance level of the MP */
  acceptanceLevel: MfgPartnerLevelType;
  /** Acceptance ratio of the MP */
  acceptanceRatio: Scalars['Float'];
  /** Average of CAR turnaround days */
  avgCarTurnaroundDays: Scalars['Float'];
  /** Car turnaround days level of the MP */
  carLevel: MfgPartnerLevelType;
  /** Expiration level of the MP */
  expirationLevel: MfgPartnerLevelType;
  /** Expiration ratio of the MP */
  expirationRatio: Scalars['Float'];
  /** Calculation period start date, converted to the mp's timezone */
  fromDate: Maybe<Scalars['Date']>;
  /** Id of the calculation record */
  id: Scalars['Int'];
  /** In Full level of the MP */
  ifLevel: MfgPartnerLevelType;
  /** In Full ratio of the MP */
  ifRatio: Scalars['Float'];
  /** jobs accepted amount */
  jobAcceptedAmount: Scalars['Float'];
  /** jobs accepted count */
  jobAcceptedCount: Scalars['Int'];
  /** jobs completed amount */
  jobCompletedAmount: Scalars['Float'];
  /** jobs completed count */
  jobCompletedCount: Scalars['Int'];
  /** jobs expired amount */
  jobExpiredAmount: Scalars['Float'];
  /** jobs expired count */
  jobExpiredCount: Scalars['Int'];
  /** jobs rejected amount */
  jobRejectedAmount: Scalars['Float'];
  /** jobs rejected count */
  jobRejectedCount: Scalars['Int'];
  /** Job requests completed in the long term by the MP */
  jobRequestLineItemsCount: Maybe<LineItemsCountType>;
  /** Job requests completed in the long term period */
  jobRequestsCompletedCountLongTerm: Scalars['Int'];
  /** jobs sent amount */
  jobSentAmount: Scalars['Float'];
  /** jobs sent count */
  jobSentCount: Scalars['Int'];
  /** Final MP Level */
  mpLevel: MfgPartnerLevelType;
  /** General configuration used for calculations */
  mpLevelConfiguration: Scalars['Int'];
  /** Mfg partner level override record */
  mpLevelOverrideRecord: Maybe<MfgPartnerLevelOverride>;
  /** On Time level of the MP */
  otLevel: MfgPartnerLevelType;
  /** On Time ratio of the MP */
  otRatio: Scalars['Float'];
  /** Id of the MP */
  partnerId: Scalars['Int'];
  /** date of the record, either scorecard_sent_at or run_date converted to the mp's timezone */
  recordDate: Maybe<Scalars['Date']>;
  /** Type of record */
  recordType: RecordType;
  /** Calculation timestamp */
  runDate: Scalars['Date'];
  /** Scorecard to be shared with the mp or not */
  scoreCardSharedWithMp: Scalars['Boolean'];
  /** Date when the scorecard was sent */
  scorecardSentAt: Maybe<Scalars['Date']>;
  /** Threshold configuration used for calculations */
  thresholdConfiguration: Array<Scalars['Int']>;
  /** Calculation period end date, converted to the mp's timezone */
  toDate: Maybe<Scalars['Date']>;
};

/** Type for MP level corrective action requests contributed to drilldown */
export type MfgPartnerLevelCarsDrilldown = {
  __typename: 'MfgPartnerLevelCarsDrilldown';
  /** Corrective action request canceled date */
  carCanceledAt: Maybe<Scalars['Date']>;
  /** Corrective action request id */
  carId: Scalars['UUID'];
  /** Corrective action request name */
  carName: Scalars['String'];
  /** Corrective action request sent date */
  carSentAt: Maybe<Scalars['Date']>;
  /** Corrective action request status */
  carStatus: Scalars['String'];
  /** Corrective action request submitted date */
  carSubmittedAt: Maybe<Scalars['Date']>;
  /** Corrective action request turn around details */
  carTurnaroundDays: Scalars['Float'];
  /** Job id */
  jobId: Scalars['Int'];
  /** Job request id */
  jobRequestId: Scalars['Int'];
  /** Job request name */
  jobRequestName: Scalars['String'];
};

/** MP level corrective action requests filter input type for snapshot details */
export type MfgPartnerLevelCarsFilterInput = {
  carNameLike: InputMaybe<Scalars['String']>;
  carStatuses: InputMaybe<Array<CorrectiveActionRequestStatus>>;
  exceptionNameLike: InputMaybe<Scalars['String']>;
  jobRequestNameLike: InputMaybe<Scalars['String']>;
};

/** MP level input type for corrective action requests */
export type MfgPartnerLevelCarsInput = {
  filters: InputMaybe<MfgPartnerLevelCarsFilterInput>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  sort: InputMaybe<MfgPartnerLevelCarsSortType>;
};

/** Type for MP level corrective action requests contributed to snapshot calculations */
export type MfgPartnerLevelCarsSnapshotDetail = {
  __typename: 'MfgPartnerLevelCarsSnapshotDetail';
  /** Corrective action request canceled date */
  carCanceledAt: Maybe<Scalars['Date']>;
  /** Corrective action request id */
  carId: Scalars['UUID'];
  /** Corrective action request name */
  carName: Scalars['String'];
  /** Corrective action request sent date */
  carSentAt: Maybe<Scalars['Date']>;
  /** Corrective action request status */
  carStatus: Scalars['String'];
  /** Corrective action request submitted date */
  carSubmittedAt: Maybe<Scalars['Date']>;
  /** Corrective action request turn around details */
  carTurnaroundDays: Scalars['Float'];
  /** Exception id */
  exceptionId: Scalars['UUID'];
  /** Exception name */
  exceptionName: Scalars['String'];
  /** Exceptions details */
  exceptions: Maybe<Array<ExceptionFailureDetail>>;
  /** Job id */
  jobId: Scalars['Int'];
  /** Job request id */
  jobRequestId: Scalars['Int'];
  /** Job request name */
  jobRequestName: Scalars['String'];
};

/** MP level corrective action requests sort type for snapshot details & drilldown */
export enum MfgPartnerLevelCarsSortType {
  CAR_CANCELED_AT_ASC = 'CAR_CANCELED_AT_ASC',
  CAR_CANCELED_AT_DESC = 'CAR_CANCELED_AT_DESC',
  CAR_SENT_AT_ASC = 'CAR_SENT_AT_ASC',
  CAR_SENT_AT_DESC = 'CAR_SENT_AT_DESC',
  CAR_SUBMITTED_AT_ASC = 'CAR_SUBMITTED_AT_ASC',
  CAR_SUBMITTED_AT_DESC = 'CAR_SUBMITTED_AT_DESC',
  CAR_TURNAROUND_DAYS_ASC = 'CAR_TURNAROUND_DAYS_ASC',
  CAR_TURNAROUND_DAYS_DESC = 'CAR_TURNAROUND_DAYS_DESC'
}

/** MP level corrective action requests type for snapshot details */
export type MfgPartnerLevelCarsType = {
  __typename: 'MfgPartnerLevelCarsType';
  items: Maybe<Array<MfgPartnerLevelCarsSnapshotDetail>>;
  totalCount: Maybe<Scalars['Int']>;
};

/** Represents Mfg Partner level configuration request */
export type MfgPartnerLevelConfigurationInput = {
  defaultCountryId: Scalars['Int'];
  minJobRequestsCountForScorecardEmail: Scalars['Int'];
  mpLevelCalculationDays: Scalars['Int'];
  processTypeExclusions: Array<InputMaybe<Scalars['Int']>>;
  trailingDaysForJobRequestsCount: Scalars['Int'];
  trailingDaysForScorecardEmail: Scalars['Int'];
};

/** MP level corrective action requests filter input type for drilldown */
export type MfgPartnerLevelDrilldownCarsFilterInput = {
  carNameLike: InputMaybe<Scalars['String']>;
  carStatuses: InputMaybe<Array<CorrectiveActionRequestStatus>>;
  jobRequestNameLike: InputMaybe<Scalars['String']>;
};

/** MP level input type for corrective action requests contributing to drilldown */
export type MfgPartnerLevelDrilldownCarsInput = {
  filters: InputMaybe<MfgPartnerLevelDrilldownCarsFilterInput>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  sort: InputMaybe<MfgPartnerLevelCarsSortType>;
};

/** MP level corrective action requests type for drilldown */
export type MfgPartnerLevelDrilldownCarsType = {
  __typename: 'MfgPartnerLevelDrilldownCarsType';
  items: Maybe<Array<MfgPartnerLevelCarsDrilldown>>;
  totalCount: Maybe<Scalars['Int']>;
};

/** Return type for MP level drilldown details */
export type MfgPartnerLevelDrilldownDetails = {
  __typename: 'MfgPartnerLevelDrilldownDetails';
  correctiveActionRequests: Maybe<MfgPartnerLevelDrilldownCarsType>;
  jobRequests: Maybe<MfgPartnerLevelDrilldownJobRequestType>;
  mfgPartnerLevel: Maybe<MfgPartnerLevelCalculationRecord>;
};


/** Return type for MP level drilldown details */
export type MfgPartnerLevelDrilldownDetailsCorrectiveActionRequestsArgs = {
  mfgPartnerLevelDrilldownCarsInput: InputMaybe<MfgPartnerLevelDrilldownCarsInput>;
};


/** Return type for MP level drilldown details */
export type MfgPartnerLevelDrilldownDetailsJobRequestsArgs = {
  mfgPartnerLevelDrilldownJobRequestInput: InputMaybe<MfgPartnerLevelDrilldownJobRequestInput>;
};

/** MP level job request filter input type for drilldown */
export type MfgPartnerLevelDrilldownJobRequestFilterInput = {
  failureTypes: InputMaybe<Array<Scalars['String']>>;
  jobAcceptedDateEnd: InputMaybe<Scalars['Date']>;
  jobAcceptedDateStart: InputMaybe<Scalars['Date']>;
  jobCompletedDateEnd: InputMaybe<Scalars['Date']>;
  jobCompletedDateStart: InputMaybe<Scalars['Date']>;
  jobExpiredDateEnd: InputMaybe<Scalars['Date']>;
  jobExpiredDateStart: InputMaybe<Scalars['Date']>;
  jobRejectedDateEnd: InputMaybe<Scalars['Date']>;
  jobRejectedDateStart: InputMaybe<Scalars['Date']>;
  jobRequestNameLike: InputMaybe<Scalars['String']>;
  jobRequestStatuses: InputMaybe<Array<JobRequestStatus>>;
};

/** MP level input type for job requests contributing to drilldown */
export type MfgPartnerLevelDrilldownJobRequestInput = {
  filters: InputMaybe<MfgPartnerLevelDrilldownJobRequestFilterInput>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  sort: InputMaybe<MfgPartnerLevelDrilldownJobRequestSortType>;
};

/** MP level job request sort type for drilldown */
export enum MfgPartnerLevelDrilldownJobRequestSortType {
  JOB_ACCEPTED_AT_ASC = 'JOB_ACCEPTED_AT_ASC',
  JOB_ACCEPTED_AT_DESC = 'JOB_ACCEPTED_AT_DESC',
  JOB_COMPLETED_AT_ASC = 'JOB_COMPLETED_AT_ASC',
  JOB_COMPLETED_AT_DESC = 'JOB_COMPLETED_AT_DESC',
  JOB_DUE_AT_ASC = 'JOB_DUE_AT_ASC',
  JOB_DUE_AT_DESC = 'JOB_DUE_AT_DESC',
  JOB_EXPIRED_AT_ASC = 'JOB_EXPIRED_AT_ASC',
  JOB_EXPIRED_AT_DESC = 'JOB_EXPIRED_AT_DESC',
  JOB_REJECTED_AT_ASC = 'JOB_REJECTED_AT_ASC',
  JOB_REJECTED_AT_DESC = 'JOB_REJECTED_AT_DESC',
  PAYOUT_ASC = 'PAYOUT_ASC',
  PAYOUT_DESC = 'PAYOUT_DESC'
}

/** MP level job request type for drilldown */
export type MfgPartnerLevelDrilldownJobRequestType = {
  __typename: 'MfgPartnerLevelDrilldownJobRequestType';
  items: Maybe<Array<MfgPartnerLevelJobRequestDrilldown>>;
  totalCount: Maybe<Scalars['Int']>;
};

/** Type for MP level exception part contributing to snapshot failures calculations */
export type MfgPartnerLevelExceptionPart = {
  __typename: 'MfgPartnerLevelExceptionPart';
  /** Exception part id */
  id: Maybe<Scalars['Int']>;
  /** Affected line items */
  lines: Maybe<Scalars['String']>;
  /** Exception part name */
  partName: Maybe<Scalars['String']>;
};

/** MP level failure filter input type for snapshot details */
export type MfgPartnerLevelFailureFilterInput = {
  exceptionNameLike: InputMaybe<Scalars['String']>;
  failureTypes: InputMaybe<Array<Scalars['String']>>;
  jobRequestNameLike: InputMaybe<Scalars['String']>;
  saleOrderNameLike: InputMaybe<Scalars['String']>;
};

/** Type for MP level failures contributed to snapshot calculations */
export type MfgPartnerLevelFailureSnapshotDetail = {
  __typename: 'MfgPartnerLevelFailureSnapshotDetail';
  /** Exception created date */
  exceptionCreatedAt: Scalars['Date'];
  /** Exception id */
  exceptionId: Scalars['UUID'];
  /** Exception name */
  exceptionName: Scalars['String'];
  /** Line items affected */
  exceptionParts: Array<MfgPartnerLevelExceptionPart>;
  /** In full MP failure */
  ifFailureMp: Maybe<Scalars['Boolean']>;
  /** Job id */
  jobId: Scalars['Int'];
  /** Job request id */
  jobRequestId: Scalars['Int'];
  /** Job request name */
  jobRequestName: Scalars['String'];
  /** Job request status */
  jobRequestStatus: Scalars['String'];
  /** Over time MP failure */
  otFailureMp: Maybe<Scalars['Boolean']>;
  /** Job RFQ Number */
  rfqNumber: Maybe<Scalars['String']>;
  /** Sale order id */
  saleOrderId: Scalars['Int'];
  /** Sale order name */
  saleOrderName: Scalars['String'];
  /** Exception failure type */
  type: Maybe<ExceptionFailureMpType>;
};

/** MP level failure sort type for snapshot details */
export enum MfgPartnerLevelFailureSortType {
  EXCEPTION_CREATED_AT_ASC = 'EXCEPTION_CREATED_AT_ASC',
  EXCEPTION_CREATED_AT_DESC = 'EXCEPTION_CREATED_AT_DESC'
}

/** MP level failure type for snapshot details */
export type MfgPartnerLevelFailureType = {
  __typename: 'MfgPartnerLevelFailureType';
  items: Maybe<Array<MfgPartnerLevelFailureSnapshotDetail>>;
  totalCount: Maybe<Scalars['Int']>;
};

/** MP level input type for faliures */
export type MfgPartnerLevelFailuresInput = {
  filters: InputMaybe<MfgPartnerLevelFailureFilterInput>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  sort: InputMaybe<MfgPartnerLevelFailureSortType>;
};

/** Type for MP level job requests contributed to drilldown */
export type MfgPartnerLevelJobRequestDrilldown = {
  __typename: 'MfgPartnerLevelJobRequestDrilldown';
  /** Job request accepted date */
  acceptedAt: Maybe<Scalars['Date']>;
  /** Job request completed date */
  completedAt: Maybe<Scalars['Date']>;
  /** Job request due date */
  dueDate: Scalars['Date'];
  /** Exception id */
  exceptionId: Maybe<Scalars['UUID']>;
  /** Line items affected */
  exceptionParts: Maybe<Array<MfgPartnerLevelExceptionPart>>;
  /** Job request expireed date */
  expiresAt: Scalars['Date'];
  /** In full MP failure */
  ifFailureMp: Maybe<Scalars['Boolean']>;
  /** Job id */
  jobId: Scalars['Int'];
  /** Job request id */
  jobRequestId: Scalars['Int'];
  /** Job request name */
  jobRequestName: Scalars['String'];
  /** Job request status */
  jobRequestStatus: Scalars['String'];
  /** Over time MP failure */
  otFailureMp: Maybe<Scalars['Boolean']>;
  /** Payout of job request */
  payout: Scalars['Float'];
  /** Job request rejected date */
  rejectedAt: Maybe<Scalars['Date']>;
};

/** MP level job request filter input type for snapshot details */
export type MfgPartnerLevelJobRequestFilterInput = {
  jobAcceptedDateEnd: InputMaybe<Scalars['Date']>;
  jobAcceptedDateStart: InputMaybe<Scalars['Date']>;
  jobCompletedDateEnd: InputMaybe<Scalars['Date']>;
  jobCompletedDateStart: InputMaybe<Scalars['Date']>;
  jobExpiredDateEnd: InputMaybe<Scalars['Date']>;
  jobExpiredDateStart: InputMaybe<Scalars['Date']>;
  jobRejectedDateEnd: InputMaybe<Scalars['Date']>;
  jobRejectedDateStart: InputMaybe<Scalars['Date']>;
  jobRequestNameLike: InputMaybe<Scalars['String']>;
  jobRequestStatuses: InputMaybe<Array<JobRequestStatus>>;
  priority: InputMaybe<Array<SalesOrderPriority>>;
  saleOrderNameLike: InputMaybe<Scalars['String']>;
};

/** MP level input type for job requests */
export type MfgPartnerLevelJobRequestInput = {
  filters: InputMaybe<MfgPartnerLevelJobRequestFilterInput>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  sort: InputMaybe<MfgPartnerLevelJobRequestSortType>;
};

/** Type for MP level job requests contributed to snapshot calculations */
export type MfgPartnerLevelJobRequestSnapshotDetail = {
  __typename: 'MfgPartnerLevelJobRequestSnapshotDetail';
  /** Job request accepted date */
  acceptedAt: Maybe<Scalars['Date']>;
  /** Job request completed date */
  completedAt: Maybe<Scalars['Date']>;
  /** Job request expireed date */
  expiresAt: Scalars['Date'];
  /** Is secure plus project */
  isSecurePlus: Maybe<Scalars['Boolean']>;
  /** Job id */
  jobId: Scalars['Int'];
  /** Job request id */
  jobRequestId: Scalars['Int'];
  /** Job request name */
  jobRequestName: Scalars['String'];
  /** Job request status */
  jobRequestStatus: Scalars['String'];
  /** Sale order priority */
  priority: Maybe<Scalars['String']>;
  /** Project id */
  projectId: Maybe<Scalars['String']>;
  /** Project name */
  projectName: Maybe<Scalars['String']>;
  /** Job request rejected date */
  rejectedAt: Maybe<Scalars['Date']>;
  /** Sale order id */
  saleOrderId: Scalars['Int'];
  /** Sale order name */
  saleOrderName: Scalars['String'];
};

/** MP level job request sort type for snapshot details */
export enum MfgPartnerLevelJobRequestSortType {
  JOB_ACCEPTED_AT_ASC = 'JOB_ACCEPTED_AT_ASC',
  JOB_ACCEPTED_AT_DESC = 'JOB_ACCEPTED_AT_DESC',
  JOB_COMPLETED_AT_ASC = 'JOB_COMPLETED_AT_ASC',
  JOB_COMPLETED_AT_DESC = 'JOB_COMPLETED_AT_DESC',
  JOB_EXPIRED_AT_ASC = 'JOB_EXPIRED_AT_ASC',
  JOB_EXPIRED_AT_DESC = 'JOB_EXPIRED_AT_DESC',
  JOB_REJECTED_AT_ASC = 'JOB_REJECTED_AT_ASC',
  JOB_REJECTED_AT_DESC = 'JOB_REJECTED_AT_DESC'
}

/** MP level job request type for snapshot details */
export type MfgPartnerLevelJobRequestType = {
  __typename: 'MfgPartnerLevelJobRequestType';
  items: Maybe<Array<MfgPartnerLevelJobRequestSnapshotDetail>>;
  totalCount: Maybe<Scalars['Int']>;
};

/** Mfg partner level override type */
export type MfgPartnerLevelOverride = {
  __typename: 'MfgPartnerLevelOverride';
  expiresAt: Scalars['Date'];
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  mpLevelOverride: MfgPartnerLevelType;
  partnerId: Scalars['Int'];
};

/** MfgPartnerLevels return type */
export type MfgPartnerLevelRecords = {
  __typename: 'MfgPartnerLevelRecords';
  items: Maybe<Array<MfgPartnerLevelCalculationRecord>>;
  mfgPartnerDetails: MfgPartner;
  totalCount: Scalars['Int'];
};

/** Return type for MP level snapshot details */
export type MfgPartnerLevelSnapshotDetails = {
  __typename: 'MfgPartnerLevelSnapshotDetails';
  correctiveActionRequests: Maybe<MfgPartnerLevelCarsType>;
  failures: Maybe<MfgPartnerLevelFailureType>;
  jobRequests: Maybe<MfgPartnerLevelJobRequestType>;
  mfgPartner: BasicMfgPartner;
  mfgPartnerLevel: Maybe<MfgPartnerLevelCalculationRecord>;
};


/** Return type for MP level snapshot details */
export type MfgPartnerLevelSnapshotDetailsCorrectiveActionRequestsArgs = {
  mfgPartnerLevelCarsInput: InputMaybe<MfgPartnerLevelCarsInput>;
};


/** Return type for MP level snapshot details */
export type MfgPartnerLevelSnapshotDetailsFailuresArgs = {
  mfgPartnerLevelFailuresInput: InputMaybe<MfgPartnerLevelFailuresInput>;
};


/** Return type for MP level snapshot details */
export type MfgPartnerLevelSnapshotDetailsJobRequestsArgs = {
  mfgPartnerLevelJobRequestInput: InputMaybe<MfgPartnerLevelJobRequestInput>;
};

/** Represents Mfg Partner level threshold configuration request */
export type MfgPartnerLevelThresholdConfigurationInput = {
  acceptancePercentageMax: Scalars['Float'];
  acceptancePercentageMin: Scalars['Float'];
  carTurnaroundDaysMax: Scalars['Float'];
  carTurnaroundDaysMin: Scalars['Float'];
  countryId: Scalars['Int'];
  expirationPercentageMax: Scalars['Float'];
  expirationPercentageMin: Scalars['Float'];
  ifPercentageMax: Scalars['Float'];
  ifPercentageMin: Scalars['Float'];
  minJobRequestsCount: Scalars['Int'];
  mpLevel: Scalars['String'];
  mpLevelRating: Scalars['Int'];
  otPercentageMax: Scalars['Float'];
  otPercentageMin: Scalars['Float'];
};

/** Enum for MP level */
export enum MfgPartnerLevelType {
  bronze = 'bronze',
  gold = 'gold',
  silver = 'silver',
  suspended = 'suspended'
}

/** MfgPartnerLevels Filters Type */
export type MfgPartnerLevelsFiltersInput = {
  fromDate: InputMaybe<Scalars['Date']>;
  mpLevels: InputMaybe<Array<MfgPartnerLevelType>>;
  toDate: InputMaybe<Scalars['Date']>;
};

/** Machine details for mfg partner for a process */
export type MfgPartnerMachineDetails = {
  __typename: 'MfgPartnerMachineDetails';
  description: Maybe<Scalars['String']>;
  fivePlusAxisCount: Maybe<Scalars['Int']>;
  fourAxisCount: Maybe<Scalars['Int']>;
  /** Unique identifier for MP Machine details */
  id: Scalars['Int'];
  isFiveAxisSupported: Maybe<Scalars['Boolean']>;
  isFourAxisSupported: Maybe<Scalars['Boolean']>;
  isLiveToolingSupported: Maybe<Scalars['Boolean']>;
  liveToolingLatheCount: Maybe<Scalars['Int']>;
  manualLatheCount: Maybe<Scalars['Int']>;
  maxX: Maybe<Scalars['Int']>;
  maxY: Maybe<Scalars['Int']>;
  maxZ: Maybe<Scalars['Int']>;
  minX: Maybe<Scalars['Int']>;
  minY: Maybe<Scalars['Int']>;
  minZ: Maybe<Scalars['Int']>;
  partnerId: Scalars['Int'];
  platformProcessId: Maybe<Scalars['String']>;
  platformProcessTypeId: Maybe<Scalars['String']>;
  processId: Scalars['Int'];
  threeAxisCount: Maybe<Scalars['Int']>;
  totalCount: Maybe<Scalars['Int']>;
};

/** Input for entering machine details for a process */
export type MfgPartnerMachineDetailsInput = {
  description: InputMaybe<Scalars['String']>;
  fivePlusAxisCount: InputMaybe<Scalars['Int']>;
  fourAxisCount: InputMaybe<Scalars['Int']>;
  isFiveAxisSupported: InputMaybe<Scalars['Boolean']>;
  isFourAxisSupported: InputMaybe<Scalars['Boolean']>;
  isLiveToolingSupported: InputMaybe<Scalars['Boolean']>;
  liveToolingLatheCount: InputMaybe<Scalars['Int']>;
  manualLatheCount: InputMaybe<Scalars['Int']>;
  maxX: InputMaybe<Scalars['Int']>;
  maxY: InputMaybe<Scalars['Int']>;
  maxZ: InputMaybe<Scalars['Int']>;
  minX: InputMaybe<Scalars['Int']>;
  minY: InputMaybe<Scalars['Int']>;
  minZ: InputMaybe<Scalars['Int']>;
  partnerId: Scalars['Int'];
  processId: Scalars['Int'];
  threeAxisCount: InputMaybe<Scalars['Int']>;
  totalCount: InputMaybe<Scalars['Int']>;
};

/** Mfg partner material type */
export type MfgPartnerMaterial = {
  __typename: 'MfgPartnerMaterial';
  /** Erp process id */
  erpProcessId: Scalars['Int'];
  /** Mfg partner material status */
  isActive: Scalars['Boolean'];
  /** Erp material id */
  materialId: Scalars['Int'];
  /** Mfg partner material name */
  materialName: Scalars['String'];
  /** Erp platform material id */
  platformMaterialId: Scalars['String'];
};

/** Mfg partner material result type */
export type MfgPartnerMaterialResult = {
  __typename: 'MfgPartnerMaterialResult';
  /** Erp platform process id */
  erpPlatformProcessId: Scalars['String'];
  /** Erp partner material category id */
  materialCategoryId: Maybe<Scalars['String']>;
  /** Erp partner material category name */
  materialCategoryName: Maybe<Scalars['String']>;
  /** Mfg partner materials */
  partnerMaterials: Array<MfgPartnerMaterial>;
};

/** Type for MP's overall statistics */
export type MfgPartnerOverallStatistics = {
  __typename: 'MfgPartnerOverallStatistics';
  /** Mfg partner actual spend */
  actualSpend: Scalars['Float'];
  /** Jobs completed amount */
  jobCompletedAmount: Scalars['Float'];
  /** Jobs completed count */
  jobCompletedCount: Scalars['Int'];
  /** MP level */
  mpLevel: Maybe<MfgPartnerLevelType>;
  /** Mfg partner level override record */
  mpLevelOverrideRecord: Maybe<MfgPartnerLevelOverride>;
  /** Id of the MP */
  partnerId: Scalars['Int'];
  /** count of MP corrective action requests */
  totalCarsCount: Scalars['Int'];
  /** No. of days from MP registration date */
  totalDays: Scalars['Int'];
  /** count of unique parts completed */
  uniquePartsCompletedCount: Scalars['Int'];
};

/** Type For Mfg Partner Process */
export type MfgPartnerProcess = {
  __typename: 'MfgPartnerProcess';
  erpProcessId: Scalars['Int'];
  payoutMultiplier: Scalars['Float'];
  processName: Scalars['String'];
};

/** Shop Process Availability for Mfg Partner */
export type MfgPartnerProcessAvailability = {
  __typename: 'MfgPartnerProcessAvailability';
  availability: Maybe<Array<ShopProcessAvailability>>;
  erpProcessId: Scalars['Int'];
  payoutMultiplier: Scalars['Float'];
  processName: Scalars['String'];
};


/** Shop Process Availability for Mfg Partner */
export type MfgPartnerProcessAvailabilityAvailabilityArgs = {
  date: Scalars['Date'];
};

/** Manufacturing Partner Process Capabilities Input */
export type MfgPartnerProcessCapabilities = {
  __typename: 'MfgPartnerProcessCapabilities';
  backstopMp: Maybe<Scalars['Boolean']>;
  calculatedTargetSpend: Maybe<Scalars['Float']>;
  currentTargetSpend: Maybe<Scalars['Float']>;
  erpProcessId: Scalars['Int'];
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  isMouSigned: Maybe<Scalars['Boolean']>;
  isVeryUrgentSupported: Maybe<Scalars['Boolean']>;
  maxPayout: Maybe<Scalars['Float']>;
  maxSetups: Maybe<Scalars['Int']>;
  minLeadTime: Maybe<Scalars['Int']>;
  minPayout: Maybe<Scalars['Float']>;
  minQuantity: Maybe<Scalars['Int']>;
  minSetups: Maybe<Scalars['Int']>;
  mouExpiresAt: Maybe<Scalars['Date']>;
  mouSpend: Maybe<Scalars['Float']>;
  mouStartsAt: Maybe<Scalars['Date']>;
  openJobRequestsCount: Maybe<Scalars['Int']>;
  openJobRequestsValue: Maybe<Scalars['Float']>;
  overloadSpend: Maybe<Scalars['Float']>;
  overloadSpendJobCount: Maybe<Scalars['Int']>;
  payoutMultiplier: Scalars['Float'];
  supportingCapabilities: Maybe<Array<SupportingCapabilities>>;
  targetSpendOverride: Maybe<Scalars['Float']>;
  targetSpendOverrideExpiresAt: Maybe<Scalars['Date']>;
};

/** Manufacturing Partner Process Capabilities Input */
export type MfgPartnerProcessCapabilitiesInput = {
  backstopMp: InputMaybe<Scalars['Boolean']>;
  erpProcessId: Scalars['Int'];
  isActive: InputMaybe<Scalars['Boolean']>;
  isMouSigned: InputMaybe<Scalars['Boolean']>;
  isVeryUrgentSupported: InputMaybe<Scalars['Boolean']>;
  maxPayout: InputMaybe<Scalars['Float']>;
  maxSetups: InputMaybe<Scalars['Int']>;
  minLeadTime: InputMaybe<Scalars['Int']>;
  minPayout: InputMaybe<Scalars['Float']>;
  minQuantity: InputMaybe<Scalars['Int']>;
  minSetups: InputMaybe<Scalars['Int']>;
  mouExpiresAt: InputMaybe<Scalars['Date']>;
  mouSpend: InputMaybe<Scalars['Float']>;
  mouStartsAt: InputMaybe<Scalars['Date']>;
  overloadSpend: InputMaybe<Scalars['Float']>;
  overloadSpendJobCount: InputMaybe<Scalars['Int']>;
  payoutMultiplier: InputMaybe<Scalars['Float']>;
  supportingCapabilities: InputMaybe<Array<MfgPartnerProcessSupportingCapabilitiesInput>>;
  targetSpendOverride: InputMaybe<Scalars['Float']>;
  targetSpendOverrideExpiresAt: InputMaybe<Scalars['Date']>;
};

/** Manufacturing Partner Process Supporting Capabilities Input */
export type MfgPartnerProcessSupportingCapabilitiesInput = {
  capabilityId: Scalars['String'];
  isSupported: InputMaybe<Scalars['Boolean']>;
};

/** Enum for allowed manufacturing partner sort options */
export enum MfgPartnerSortInput {
  MFG_PARTNER_NAME_ASC = 'MFG_PARTNER_NAME_ASC',
  MFG_PARTNER_NAME_DESC = 'MFG_PARTNER_NAME_DESC'
}

/** Result of a paginated list of Mfg Partners */
export type MfgPartnersResults = {
  __typename: 'MfgPartnersResults';
  /** List of Job requests found */
  items: Maybe<Array<MfgPartner>>;
  /** Information for the skipping previous records */
  offset: Maybe<Scalars['Int']>;
  /** Count of all results */
  totalCount: Scalars['Int'];
};

/** Details of each milestone */
export type MilestoneDetails = {
  __typename: 'MilestoneDetails';
  actualDate: Maybe<Scalars['Date']>;
  committedDate: Maybe<Scalars['Date']>;
  scheduledDate: Maybe<Scalars['Date']>;
};

/** Enum for Milestone types */
export enum MilestoneType {
  customer_delivery = 'customer_delivery',
  delivery_order = 'delivery_order',
  inspection = 'inspection',
  production = 'production',
  scheduling = 'scheduling',
  shipping = 'shipping'
}

/** Material stock exact thickness type */
export enum MillMaterialStockExactThicknessType {
  NO_EXACT_THICKNESS = 'NO_EXACT_THICKNESS',
  ONLY_EXACT_THICKNESS = 'ONLY_EXACT_THICKNESS',
  PRIORITIZE_EXACT_THICKNESS = 'PRIORITIZE_EXACT_THICKNESS'
}

/** Minimum eligibility MP unit payout for job lines */
export type MinimumEligibilityMp = {
  __typename: 'MinimumEligibilityMp';
  jobLines: Array<MinimumEligibilityMpJobLine>;
  mfgPartner: BasicMfgPartner;
};

/** Minimum eligibility MP unit payout for job line */
export type MinimumEligibilityMpJobLine = {
  __typename: 'MinimumEligibilityMpJobLine';
  lineId: Scalars['Int'];
  unitPayoutAmount: Scalars['Float'];
};

/** Representation of a marker (referred to as 'bubbles') admins can create on some model attachments. */
export type ModelAttachmentAnnotation = {
  __typename: 'ModelAttachmentAnnotation';
  documentPage: Scalars['Int'];
  id: Scalars['UUID'];
  label: Scalars['Int'];
  positionX: Scalars['Float'];
  positionY: Scalars['Float'];
  radius: Scalars['Float'];
};

/** Input fields for a model attachment annotation record. */
export type ModelAttachmentAnnotationInput = {
  attachmentId: InputMaybe<Scalars['UUID']>;
  documentPage: Scalars['Int'];
  estimateItemUUID: InputMaybe<Scalars['UUID']>;
  positionX: Scalars['Float'];
  positionY: Scalars['Float'];
  radius: Scalars['Float'];
};

/** Input fields for creating a model attachment callout */
export type ModelAttachmentCalloutInput = {
  modelAttachmentAnnotationInput: ModelAttachmentAnnotationInput;
  modelAttachmentSelectionInput: ModelAttachmentSelectionInput;
};

/** ModelAttachment Pdf Ocr Data */
export type ModelAttachmentOcrData = {
  __typename: 'ModelAttachmentOcrData';
  allReamableOneSidedTolerances: Maybe<Array<Maybe<OneSidedToleranceData>>>;
  allReamableTwoSidedTolerances: Maybe<Array<Maybe<TwoSidedToleranceData>>>;
  autoQuotable: Maybe<Scalars['Boolean']>;
  autoQuotableBlockers: Maybe<Array<Maybe<Scalars['String']>>>;
  callsForAnodizing: Maybe<Scalars['Boolean']>;
  callsForOffPlatformFinish: Maybe<Scalars['Boolean']>;
  certificateOfConformanceNotes: Maybe<Array<Maybe<NoteWithBoundingBox>>>;
  defaultTolerances: Maybe<Array<Maybe<DefaultToleranceData>>>;
  detectionBoundingBoxes: Maybe<Array<Maybe<PdfDetectionBoundingBox>>>;
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  finishingNotes: Maybe<Array<Maybe<Scalars['String']>>>;
  finishingNotesWithBoundingBoxes: Maybe<Array<Maybe<NoteWithBoundingBox>>>;
  foundThreadNames: Maybe<Array<Maybe<Scalars['String']>>>;
  foundThreadsInfo: Maybe<Array<Maybe<ModelAttachmentOcrThreadInfo>>>;
  hardnessDetections: Maybe<Array<Maybe<NoteWithBoundingBox>>>;
  hasHtmlText: Maybe<Scalars['Boolean']>;
  hasText: Maybe<Scalars['Boolean']>;
  heatTreatmentDetections: Maybe<Array<Maybe<NoteWithBoundingBox>>>;
  htmlFilename: Maybe<Scalars['String']>;
  htmlFilenames: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Maybe<Scalars['UUID']>;
  materialCertificateNotes: Maybe<Array<Maybe<NoteWithBoundingBox>>>;
  measurementUnits: Maybe<Scalars['String']>;
  minOneSidedTolerance: Maybe<Scalars['String']>;
  minTwoSidedTolerance: Maybe<Scalars['String']>;
  numTightTolerances: Maybe<Scalars['Float']>;
  numVeryTightTolerances: Maybe<Scalars['Float']>;
  oneSidedTolerances: Maybe<Array<Maybe<OneSidedToleranceData>>>;
  pdfFilename: Maybe<Scalars['String']>;
  rawAnalysis: Maybe<Scalars['JSON']>;
  reamerSizes: Maybe<Array<Maybe<Scalars['Float']>>>;
  requiresArmsExportControlAct: Maybe<Scalars['Boolean']>;
  requiresCertificateOfConformance: Maybe<Scalars['Boolean']>;
  requiresEAR: Maybe<Scalars['Boolean']>;
  requiresECCN: Maybe<Scalars['Boolean']>;
  requiresExportAdministrationAct: Maybe<Scalars['Boolean']>;
  requiresITAR: Maybe<Scalars['Boolean']>;
  requiresMaterialCertificate: Maybe<Scalars['Boolean']>;
  requiresMaterialRoHS: Maybe<Scalars['Boolean']>;
  sanitizedBoundingBoxes: Maybe<Array<Maybe<PdfDetectionBoundingBox>>>;
  standardDimensions: Maybe<Array<Maybe<NoteWithBoundingBox>>>;
  stockDetections: Maybe<Array<Maybe<NoteWithBoundingBox>>>;
  toleranceBlocks: Maybe<Array<Maybe<ToleranceBlockData>>>;
  twoSidedTolerances: Maybe<Array<Maybe<TwoSidedToleranceData>>>;
};

/** ModelAttachment Ocr Thread Info */
export type ModelAttachmentOcrThreadInfo = {
  __typename: 'ModelAttachmentOcrThreadInfo';
  commonName: Maybe<Scalars['String']>;
  count: Maybe<Scalars['Float']>;
  detections: Maybe<Array<Maybe<ThreadInfoDetection>>>;
  diameter: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
};

/** Representation of a rectangular box that admins can draw on some model attachments. */
export type ModelAttachmentSelection = {
  __typename: 'ModelAttachmentSelection';
  documentPage: Scalars['Int'];
  height: Maybe<Scalars['Float']>;
  id: Scalars['UUID'];
  modelAttachmentAnnotation: Maybe<ModelAttachmentAnnotation>;
  positionX: Scalars['Float'];
  positionY: Scalars['Float'];
  rank: Maybe<Scalars['Int']>;
  text: Maybe<Scalars['String']>;
  userAnnotationsId: Maybe<Scalars['UUID']>;
  width: Maybe<Scalars['Float']>;
};

/** Input fields for a model attachment selection record. */
export type ModelAttachmentSelectionInput = {
  attachmentId: InputMaybe<Scalars['UUID']>;
  documentPage: Scalars['Int'];
  estimateItemUUID: InputMaybe<Scalars['UUID']>;
  height: InputMaybe<Scalars['Float']>;
  positionX: Scalars['Float'];
  positionY: Scalars['Float'];
  text: InputMaybe<Scalars['String']>;
  userAnnotationsId: InputMaybe<Scalars['UUID']>;
  width: InputMaybe<Scalars['Float']>;
};

/** ModelConfiguration */
export type ModelConfiguration = {
  __typename: 'ModelConfiguration';
  additionalRequirements: Maybe<Scalars['String']>;
  color: Maybe<Color>;
  colorCode: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  createdBy: BasicUser;
  deletedAt: Maybe<Scalars['Date']>;
  deletedBy: Maybe<BasicUser>;
  dfmInspection: Maybe<ModelConfigurationDfmInspection>;
  dfmInspections: Maybe<Array<Maybe<ModelConfigurationDfmInspection>>>;
  errorCode: Maybe<Scalars['String']>;
  fdmInfillPercentageCategory: Maybe<Scalars['String']>;
  fdmInfillPercentageCategoryLabel: Maybe<Scalars['String']>;
  hasMultipleFinishes: Scalars['Boolean'];
  id: Scalars['UUID'];
  material: Maybe<SelectedMaterial>;
  materialGrade: Maybe<Scalars['String']>;
  postProcess: Maybe<PostProcess>;
  postProcessColor: Maybe<Color>;
  postProcessThickness: Maybe<Thickness>;
  process: Maybe<Process>;
  productionLeadTime: Maybe<ProductionLeadTime>;
  quantity: Maybe<Scalars['Int']>;
  quoteModelRevision: QuoteModelRevision;
  requiresOvermold: Scalars['Boolean'];
  shore: Maybe<Shore>;
  texture: Maybe<Texture>;
  textureCode: Maybe<Scalars['String']>;
  toolDetails: Maybe<ToolCosts>;
  updatedAt: Scalars['Date'];
  updatedBy: BasicUser;
  userNeedsConfigHelp: Scalars['Boolean'];
};

/** DFM Inspection data for a ModelConfiguration */
export type ModelConfigurationDfmInspection = {
  __typename: 'ModelConfigurationDfmInspection';
  autoquoterInspectionData: Maybe<Scalars['JSON']>;
  createdAt: Scalars['Date'];
  createdBy: BasicUser;
  deletedAt: Maybe<Scalars['Date']>;
  deletedBy: Maybe<BasicUser>;
  id: Maybe<Scalars['UUID']>;
  inspectionData: Scalars['JSON'];
  isPublished: Scalars['Boolean'];
  isQuantityRangeAvailable: Maybe<Scalars['Boolean']>;
  manualOverrideMpUnitPayout: Maybe<Scalars['Int']>;
  manualOverrideUnitAmount: Maybe<Scalars['Int']>;
  manualOverrideUnitProductionDays: Maybe<Scalars['Int']>;
  modelConfiguration: ModelConfiguration;
  quantityLowerRange: Maybe<Scalars['Int']>;
  quantityUpperRange: Maybe<Scalars['Int']>;
  quoteUpdatedAt: Maybe<Scalars['Date']>;
  quoteUpdatedBy: Maybe<BasicUser>;
  quotedAt: Maybe<Scalars['Date']>;
  quotedBy: Maybe<BasicUser>;
  type: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy: BasicUser;
};

/** A collection of models. */
export type ModelInspection = {
  __typename: 'ModelInspection';
  createdAt: Scalars['Date'];
  id: Scalars['Int'];
  name: Scalars['String'];
  response: Scalars['JSON'];
  updatedAt: Scalars['Date'];
};

/** Configuration for model viewer annotation */
export type ModelViewerAnnotationConfig = {
  __typename: 'ModelViewerAnnotationConfig';
  /** x, y, z of the position in 3d space */
  position: Array<Scalars['Float']>;
};

/** Configuration for model viewer part annotation visualization */
export type ModelViewerAnnotationConfigInput = {
  /** x, y, z of the position in 3d space */
  position: Array<Scalars['Float']>;
};

/** Configuration for model viewer camera */
export type ModelViewerCameraConfig = {
  __typename: 'ModelViewerCameraConfig';
  /** x, y, z of the position in 3d space */
  position: Array<Scalars['Float']>;
  /** x, y, z of the position in world coordinates that the camera should look at */
  target: Maybe<Array<Scalars['Float']>>;
  /** i, j, k of the camera's up vector */
  up: Maybe<Array<Scalars['Float']>>;
  zoom: Scalars['Float'];
};

/** Configuration for model viewer camera */
export type ModelViewerCameraConfigInput = {
  /** x, y, z of the position in 3d space */
  position: Array<Scalars['Float']>;
  /** x, y, z of the position in world coordinates that the camera should look at */
  target: InputMaybe<Array<Scalars['Float']>>;
  /** i, j, k of the camera's up vector */
  up: InputMaybe<Array<Scalars['Float']>>;
  zoom: Scalars['Float'];
};

/** Configuration for model viewer */
export type ModelViewerConfig = {
  __typename: 'ModelViewerConfig';
  annotations: Array<ModelViewerAnnotationConfig>;
  camera: Maybe<ModelViewerCameraConfig>;
  /** CrossSection information is absent, then it's disabled in the DFM */
  crossSection: Maybe<ModelViewerCrossSectionConfig>;
  dfm: Array<ModelViewerDfmFeatureConfig>;
  part: ModelViewerPartConfig;
  pointToPoint: Maybe<PointToPointConfig>;
  /** Part rotation represented as 16 matrix elements in column-major order */
  rotation: Maybe<Array<Scalars['Float']>>;
};

/** Configuration for model viewer */
export type ModelViewerConfigInput = {
  annotations: Array<ModelViewerAnnotationConfigInput>;
  camera: InputMaybe<ModelViewerCameraConfigInput>;
  crossSection: InputMaybe<ModelViewerCrossSectionConfigInput>;
  dfm: Array<ModelViewerDfmFeatureConfigInput>;
  part: ModelViewerPartConfigInput;
  pointToPoint: InputMaybe<PointToPointConfigInput>;
  /** Part rotation represented as 16 matrix elements in column-major order */
  rotation: InputMaybe<Array<Scalars['Float']>>;
};

/** Representation of the state of the cross section tools in the 3D Viewer */
export type ModelViewerCrossSectionConfig = {
  __typename: 'ModelViewerCrossSectionConfig';
  position: Scalars['Float3Array'];
  rotation: Scalars['Float4Array'];
};

/** Input ofr the state of the cross section tools in the 3D Viewer */
export type ModelViewerCrossSectionConfigInput = {
  position: Scalars['Float3Array'];
  rotation: Scalars['Float4Array'];
};

/** Configuration for model viewer dfm feature visualization */
export type ModelViewerDfmFeatureConfig = {
  __typename: 'ModelViewerDfmFeatureConfig';
  color: Maybe<Scalars['String']>;
  direction: Maybe<Array<Scalars['Float']>>;
  feature: Maybe<Scalars['String']>;
  threshold: Maybe<Scalars['Float']>;
};

/** Configuration for model viewer dfm feature visualization */
export type ModelViewerDfmFeatureConfigInput = {
  color: InputMaybe<Scalars['String']>;
  direction: InputMaybe<Array<Scalars['Float']>>;
  feature: Scalars['String'];
  threshold: InputMaybe<Scalars['Float']>;
};

/** Configuration for model viewer part */
export type ModelViewerPartConfig = {
  __typename: 'ModelViewerPartConfig';
  patches: Array<ModelViewerPatchConfig>;
  transparent: Scalars['Boolean'];
};

/** Configuration for model viewer part visualization */
export type ModelViewerPartConfigInput = {
  patches: Array<ModelViewerPatchConfigInput>;
  transparent: Scalars['Boolean'];
};

/** Configuration for model viewer part patch */
export type ModelViewerPatchConfig = {
  __typename: 'ModelViewerPatchConfig';
  color: Maybe<Scalars['String']>;
  hashcode: Scalars['String'];
};

/** Configuration for model viewer part patch visualization */
export type ModelViewerPatchConfigInput = {
  color: InputMaybe<Scalars['String']>;
  hashcode: Scalars['String'];
};

/** Snapshot of a Scene Map in the Viewer */
export type ModelViewerSnapshot = {
  __typename: 'ModelViewerSnapshot';
  createdAt: Scalars['Date'];
  createdBy: BasicUser;
  deletedAt: Maybe<Scalars['Date']>;
  deletedBy: BasicUser;
  feature: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  position: Scalars['JSON'];
  quoteModelRevision: QuoteModelRevision;
  snapshot: Maybe<ModelViewerConfig>;
  target: Scalars['JSON'];
  type: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy: BasicUser;
};

/** Input for create ModelViewerSnapshot */
export type ModelViewerSnapshotInput = {
  feature: InputMaybe<Scalars['String']>;
  position: Scalars['JSON'];
  quoteModelRevisionId: Scalars['UUID'];
  snapshot: ModelViewerConfigInput;
  target: Scalars['JSON'];
  type: Scalars['String'];
};

/** Platform generated mold name and customer mold Name */
export type MoldName = {
  __typename: 'MoldName';
  customerToolName: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

/** Represents the current "version" of a given injection molding tool */
export type MoldTool = {
  __typename: 'MoldTool';
  createdAt: Scalars['Date'];
  createdBy: User;
  customerToolName: Maybe<Scalars['String']>;
  /** Tooling lead time + EasyPost estimate days + average days of buffer for error */
  estimatedSampleDeliveryDate: Maybe<Scalars['Date']>;
  /** Gate type used for pricing */
  gateType: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  inspectionData: Maybe<Scalars['JSON']>;
  leadTimeDays: Maybe<Scalars['Int']>;
  manualOverrideMpUnitPayout: Maybe<Scalars['Int']>;
  manualOverrideUnitAmount: Maybe<Scalars['Int']>;
  /** Currently the cavity material */
  material: Maybe<Material>;
  moldToolRevision: MoldToolRevision;
  /** Adding new fields for MAAFCO */
  moldToolRevisionId: Scalars['UUID'];
  moldToolRevisionInspection: MoldToolRevisionInspection;
  moldToolRevisionQmr: Array<MoldToolRevisionQmr>;
  name: Scalars['String'];
  ownerId: Maybe<Scalars['Int']>;
  price: Maybe<ExactPrice>;
  published: Scalars['Boolean'];
  publishedAt: Maybe<Scalars['Date']>;
  publishedBy: Maybe<User>;
  quoteModelRevisions: Array<QuoteModelRevision>;
  /** Tool life used for pricing */
  toolLife: Maybe<Scalars['Int']>;
  uiIndex: Scalars['Int'];
  uniqueNameId: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
  updatedBy: User;
};


/** Represents the current "version" of a given injection molding tool */
export type MoldToolEstimatedSampleDeliveryDateArgs = {
  address: InputMaybe<AddressInput>;
};

/** Represents mold inspection data */
export type MoldToolInspectionData = {
  __typename: 'MoldToolInspectionData';
  additionalCostCents: Maybe<Scalars['Int']>;
  automaticThreadInsertQty: Maybe<Scalars['Int']>;
  cavityMaterial: Maybe<Scalars['String']>;
  cavitySharedWithMoldBase: Maybe<Scalars['Boolean']>;
  coreMaterial: Maybe<Scalars['String']>;
  coreSharedWithMoldBase: Maybe<Scalars['Boolean']>;
  customerProvidingMaterial: Maybe<Scalars['Boolean']>;
  ejectionType: Maybe<Scalars['String']>;
  gateType: Maybe<Scalars['String']>;
  leadTimeDaysOverride: Maybe<Scalars['Int']>;
  lifters: Maybe<Array<Lifter>>;
  manualInsertsQty: Maybe<Scalars['Int']>;
  manualThreadInsertQty: Maybe<Scalars['Int']>;
  notes: Maybe<Scalars['String']>;
  partMarkupPercent: Maybe<Scalars['Float']>;
  partingLine: Maybe<Scalars['String']>;
  precisionGrade: Maybe<Scalars['String']>;
  sliders: Maybe<Array<Slider>>;
  specialFeatures: Maybe<Array<Scalars['String']>>;
  surfaceFinish: Maybe<Scalars['String']>;
  toolLife: Maybe<Scalars['Int']>;
  toolMarkupPercent: Maybe<Scalars['Float']>;
  usdToYuanExchangeRateOverride: Maybe<Scalars['Float']>;
  warpType: Maybe<Scalars['String']>;
};

/** Input for mold inspection data */
export type MoldToolInspectionDataInput = {
  additionalCostCents: InputMaybe<Scalars['Int']>;
  automaticThreadInsertQty: InputMaybe<Scalars['Int']>;
  cavityCounts: InputMaybe<Array<Scalars['Int']>>;
  cavityMaterial: InputMaybe<Scalars['String']>;
  cavitySharedWithMoldBase: InputMaybe<Scalars['Boolean']>;
  coreMaterial: InputMaybe<Scalars['String']>;
  coreSharedWithMoldBase: InputMaybe<Scalars['Boolean']>;
  customerProvidingMaterial: InputMaybe<Scalars['Boolean']>;
  ejectionType: InputMaybe<Scalars['String']>;
  gateType: InputMaybe<Scalars['String']>;
  leadTimeDaysOverride: InputMaybe<Scalars['Int']>;
  lifters: InputMaybe<Array<LifterInput>>;
  liftersCount: InputMaybe<Scalars['Int']>;
  manualInsertsQty: InputMaybe<Scalars['Int']>;
  manualThreadInsertQty: InputMaybe<Scalars['Int']>;
  notes: InputMaybe<Scalars['String']>;
  partMarkupPercent: InputMaybe<Scalars['Float']>;
  partingLine: InputMaybe<Scalars['String']>;
  precisionGrade: InputMaybe<Scalars['String']>;
  sliders: InputMaybe<Array<SliderInput>>;
  slidersCount: InputMaybe<Scalars['Int']>;
  specialFeatures: InputMaybe<Array<Scalars['String']>>;
  surfaceFinish: InputMaybe<Scalars['String']>;
  toolLife: InputMaybe<Scalars['Int']>;
  toolMarkupPercent: InputMaybe<Scalars['Float']>;
  usdToYuanExchangeRateOverride: InputMaybe<Scalars['Float']>;
  warpType: InputMaybe<Scalars['String']>;
};

/** Input for mold override data */
export type MoldToolOverrideInput = {
  manualOverrideMpUnitPayout: Scalars['Int'];
  manualOverrideUnitAmount: Scalars['Int'];
};

/** Represents MoldTool configurations */
export type MoldToolRevision = {
  __typename: 'MoldToolRevision';
  cavityMaterialId: Maybe<Scalars['String']>;
  coreMaterialId: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  createdBy: Scalars['Int'];
  gateType: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  moldToolId: Scalars['UUID'];
  numLifter: Maybe<Scalars['Int']>;
  numSlider: Maybe<Scalars['Int']>;
  processId: Maybe<Scalars['String']>;
  toolLife: Maybe<Scalars['Int']>;
  updatedAt: Maybe<Scalars['Date']>;
  updatedBy: Maybe<Scalars['Int']>;
  version: Scalars['Int'];
};

/** Input for mold tool revision */
export type MoldToolRevisionInput = {
  additionalCostCents: InputMaybe<Scalars['Int']>;
  automaticThreadInsertQty: InputMaybe<Scalars['Int']>;
  cavityCounts: InputMaybe<Array<Scalars['Int']>>;
  cavityMaterial: InputMaybe<Scalars['String']>;
  cavitySharedWithMoldBase: InputMaybe<Scalars['Boolean']>;
  coreMaterial: InputMaybe<Scalars['String']>;
  coreSharedWithMoldBase: InputMaybe<Scalars['Boolean']>;
  ejectionType: InputMaybe<Scalars['String']>;
  gateType: InputMaybe<Scalars['String']>;
  leadTimeDaysOverride: InputMaybe<Scalars['Int']>;
  lifters: InputMaybe<Array<LifterInput>>;
  liftersCount: InputMaybe<Scalars['Int']>;
  manualInsertsQty: InputMaybe<Scalars['Int']>;
  manualThreadInsertQty: InputMaybe<Scalars['Int']>;
  partMarkupPercent: InputMaybe<Scalars['Float']>;
  partingLine: InputMaybe<Scalars['String']>;
  precisionGrade: InputMaybe<Scalars['String']>;
  sliders: InputMaybe<Array<SliderInput>>;
  slidersCount: InputMaybe<Scalars['Int']>;
  specialFeatures: InputMaybe<Array<Scalars['String']>>;
  toolLife: InputMaybe<Scalars['Int']>;
  toolMarkupPercent: InputMaybe<Scalars['Float']>;
  usdToYuanExchangeRateOverride: InputMaybe<Scalars['Float']>;
  warpType: InputMaybe<Scalars['String']>;
};

/** Represents MoldTool inspection */
export type MoldToolRevisionInspection = {
  __typename: 'MoldToolRevisionInspection';
  createdAt: Scalars['Date'];
  createdBy: Scalars['Int'];
  id: Scalars['UUID'];
  inspectionData: Maybe<MoldToolInspectionData>;
  leadTimeDays: Maybe<Scalars['Int']>;
  manualOverrideMpUnitPayout: Maybe<Scalars['Int']>;
  manualOverrideUnitAmount: Maybe<Scalars['Int']>;
  moldToolRevisionId: Scalars['UUID'];
  priceCents: Maybe<Scalars['Int']>;
  published: Scalars['Boolean'];
  updatedAt: Maybe<Scalars['Date']>;
  updatedBy: Maybe<Scalars['Int']>;
};

/** Represents MoldTool revision to parts association */
export type MoldToolRevisionQmr = {
  __typename: 'MoldToolRevisionQmr';
  cavityPerPart: Maybe<Scalars['Int']>;
  id: Scalars['UUID'];
  moldToolRevisionId: Scalars['UUID'];
  quoteModelRevisionId: Scalars['String'];
};

/** List of sale order line and mp to find active mp on previous job board */
export type MpActiveOnJobBoardInput = {
  jobIds: InputMaybe<Array<Scalars['Int']>>;
  mpIds: InputMaybe<Array<Scalars['Int']>>;
};

/** Input for mp corrective action request filters */
export type MpCorrectiveActionRequestFilterInput = {
  correctiveActionRequestNameLike: InputMaybe<Scalars['String']>;
  correctiveActionRequestStatuses: InputMaybe<Array<CorrectiveActionRequestStatus>>;
  failureTypes: InputMaybe<Array<CorrectiveActionRequestFailureType>>;
  jobRequestNameLike: InputMaybe<Scalars['String']>;
};

/** Enum for allowed mp corrective action request sort options */
export enum MpCorrectiveActionRequestSortInput {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DUE_AT_ASC = 'DUE_AT_ASC',
  DUE_AT_DESC = 'DUE_AT_DESC',
  JOB_NAME_ASC = 'JOB_NAME_ASC',
  JOB_NAME_DESC = 'JOB_NAME_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  STATUS_ASC = 'STATUS_ASC',
  STATUS_DESC = 'STATUS_DESC'
}

/** Fields associated with country while decoupling */
export type MpCountry = {
  __typename: 'MpCountry';
  id: Scalars['String'];
  name: Scalars['String'];
};

/** An Job record represents a MP job to be fetch in Mp Workbench */
export type MpJob = {
  __typename: 'MpJob';
  buyNowPrice: Maybe<Scalars['Float']>;
  /** Currency exchange rates for a job */
  exchangeRates: Maybe<Array<JobExchangeRate>>;
  /** Unique identifier for job */
  id: Scalars['Int'];
  /** Job board info */
  jobBoardId: Scalars['UUID'];
  /** Job board job end time */
  jobBoardJobEndTime: Maybe<Scalars['Date']>;
  /** Job board region name */
  jobBoardRegion: Maybe<Scalars['String']>;
  /** All materials associated with Job */
  materialNames: Maybe<Array<Scalars['String']>>;
  /** Lines associated with job visible to MP only */
  mpJobLines: Maybe<Array<JobLine>>;
  /** MP manufacturing DRI */
  mpMfgDri: Maybe<BasicUser>;
  /** Name of the job */
  name: Scalars['String'];
  parts: Maybe<Array<JobBoardJobPart>>;
  /** All processesses associated with Job */
  processNames: Maybe<Array<Scalars['String']>>;
  /** List of all unique services on the job */
  services: Maybe<Array<JobRequestLine>>;
  /** Status of job */
  status: Maybe<Scalars['String']>;
  /** Job due date */
  vendorDueDate: Maybe<Scalars['Date']>;
  /** Notes for vendor */
  vendorNotes: Maybe<Scalars['String']>;
};

/** Mutation to change markups */
export type Mutation = {
  __typename: 'Mutation';
  acceptDfmFeedback: DfmFeedback;
  acceptInvite: Invite;
  acceptJobBoardJob: JobBoardJob;
  acceptOpenInvite: Invite;
  acceptWorkspaceOpenInvite: WorkspaceInvite;
  activateBusinessAccountMembers: ActivateBusinessAccountMembersResult;
  addExceptionFailureNote: Maybe<ExceptionFailureNote>;
  addExceptionNote: Maybe<ExceptionNote>;
  addJobToActiveJobBoard: Job;
  addManuallyQuotedSecondaryProcessForBuilder: Array<Scalars['UUID']>;
  addModelConfigurationDfmInspection: ModelConfigurationDfmInspection;
  addMoldToolRevisionToQMRAssociation: Maybe<MoldTool>;
  addProjectMembers: Array<ProjectMembership>;
  addRequirementTargets: Requirement;
  addTeamMembers: AddUserTeamMembershipResult;
  adjustCurrentMarkups: MarkupData;
  adminOnlyMutations: Maybe<AdminOnlyMutations>;
  adminUser: Maybe<UserMutation>;
  approveTeamAccessRequest: Maybe<Scalars['String']>;
  assignSaleOrderLinesProductionCountry: Scalars['Int'];
  attachPdfToDfm: DfmFeedback;
  attachPurchaseOrderOnOrder: Maybe<Order>;
  autoConfigurePart: Scalars['Boolean'];
  /** A base mutation to extend */
  baseMutation: Maybe<Scalars['Boolean']>;
  cancelCorrectiveActionRequest: Scalars['String'];
  cancelJob: Job;
  cancelPlatformOrder: Maybe<Order>;
  claimSalesOrder: Scalars['Boolean'];
  clearHolidaysCache: Scalars['Boolean'];
  clearQuoteProperties: Array<QuoteProperty>;
  computeMfgPartnerLevels: Scalars['Int'];
  createAmountBasedDiscount: AmountBasedDiscount;
  createAsset: Asset;
  createAutoGenerateUserDrawing: QuoteModelRevision;
  createBusinessAccount: Maybe<BusinessAccount>;
  createBusinessAccountDiscount: BusinessAccountDiscount;
  createBusinessAccountSubscription: BusinessAccountSubscription;
  createCarrierAccount: TplCarrierAccount;
  createComment: Comment;
  createCorrectiveActionRequestAttachment: CorrectiveActionRequestAttachment;
  createCorrectiveActionRequests: Scalars['Boolean'];
  createCorrectiveActionRequestsForConsolidatedJob: Scalars['Boolean'];
  createCorrectiveActionRequestsForConsolidation: Scalars['Boolean'];
  createCurrencyExchangeRate: CurrencyExchangeRate;
  createDFMConsultationRequest: Maybe<Scalars['String']>;
  createDfmFeedbackMessage: Maybe<DfmFeedbackMessage>;
  createDfmFeedbackWithSnapshot: DfmSlideReadyStatus;
  createDfmOnQmrForAttachments: Array<Maybe<DfmFeedback>>;
  createErpAttachment: Maybe<ErpAttachment>;
  createErpMoldToolModelConfigurationDfmAssociation: QuoteModelRevision;
  createEstimateItemZipDownload: ZipDownloadJob;
  createException: Exception;
  createExceptionAttachment: ExceptionAttachment;
  createExceptionFailure: ExceptionFailure;
  createExceptionFailureAttachment: ExceptionFailureAttachment;
  createExceptionFailureNoteAttachment: Asset;
  createExceptionNoteAttachment: Asset;
  createHistoryMessage: ChangeHistory;
  createHistoryStateChange: ChangeHistory;
  createInvite: Invite;
  createJobBoards: Maybe<Array<JobBoard>>;
  createJobBundle: ZipDownloadJob;
  createJobBundleForJobBoard: ZipDownloadJob;
  createJobRequest: JobRequest;
  createJobRequestAttachments: Maybe<Array<Maybe<WorkOrderAttachment>>>;
  createJobRequestComment: JobRequestComment;
  createJobRequestZipDownloadJob: Maybe<ZipDownloadJob>;
  createJobs: Maybe<Array<Job>>;
  createMfgPartnerLevelOverride: MfgPartnerLevelOverride;
  createModelAttachmentCallout: ModelAttachmentSelection;
  createModelAttachmentCallouts: Array<ModelAttachmentSelection>;
  createModelAttachmentSanitization: ModelAttachmentSelection;
  createModelConfigurationDfmFeedback: DfmFeedback;
  createModelViewerSnapshot: ModelViewerSnapshot;
  createMoldTool: Maybe<MoldTool>;
  createMoldToolQmrAssociation: Maybe<QuoteModelRevision>;
  createMoldToolRevision: Maybe<MoldTool>;
  createMpLevelConfiguration: Scalars['Boolean'];
  createMpLevelThresholdConfiguration: Scalars['Boolean'];
  createNote: Note;
  createNoteAttachment: Asset;
  createOdooQuote: Quote;
  createOpenInviteOnQuote: Quote;
  createOrUpdateMfgPartnerProcessCapabilities: Maybe<MfgPartnerProcessCapabilities>;
  createOrderPaidEvent: Order;
  createPercentageBasedDiscount: PercentageBasedDiscount;
  createProductAttachmentRevision: ProductAttachmentRevision;
  createProject: Maybe<Project>;
  createPurchaseOrder: PurchaseOrder;
  createQualityDocument: QualityDocument;
  createQuote: Quote;
  createQuoteAttachmentRevision: QuoteAttachmentRevision;
  createQuoteDetailCSVFile: Scalars['String'];
  createQuoteModelRevision: QuoteModelRevision;
  createQuoteModelRevisionAttachment: QuoteModelRevisionAttachment;
  createQuoteMoldTool: MoldTool;
  createReorderQuoteFromOrder: Quote;
  createSaleOrderInspectionDownload: ZipDownloadJob;
  createSanitizedAttachment: SanitizedAttachment;
  createSchedulingQueue: SchedulingQueue;
  createSchedulingQueueItems: Scalars['Boolean'];
  createTeam: Maybe<CreateTeamOutput>;
  createThread: Thread;
  createWorkspaceInvite: WorkspaceInvite;
  createZipDownload: ZipDownloadJob;
  createZipDownloadOrderDetails: ZipDownloadJob;
  cypressCreateSalesforceAccount: Maybe<CypressCreateSalesForceAccount>;
  cypressCreateSalesforceAccountContacts: Maybe<Array<Maybe<CypressCreateSalesForceAccountContact>>>;
  cypressRemoveBusinessAccount: RemoveBusinessAccountResponse;
  deactivateBusinessAccountDiscount: Maybe<BusinessAccountDiscount>;
  deactivateBusinessAccountMember: Scalars['Boolean'];
  deactivateMfgPartnerLevelOverride: Scalars['Boolean'];
  deleteDiscount: Discount;
  deleteFeatureFlag: FeatureFlag;
  deleteMoldTool: MoldTool;
  deleteQuoteMold: Quote;
  deleteQuoteProperty: Maybe<QuoteProperty>;
  deleteTeam: Maybe<Team>;
  denyTeamAccessRequest: Maybe<Scalars['String']>;
  destroyCarrierAccount: TplCarrierAccount;
  destroyComment: Comment;
  destroyDfmFeedback: DfmFeedback;
  destroyERPMoldToolAssociation: Maybe<QuoteModelRevision>;
  destroyInvite: Invite;
  destroyModelAttachmentCallouts: Array<Scalars['UUID']>;
  destroyModelAttachmentSanitizations: Array<Scalars['UUID']>;
  destroyMoldToolRevisionAssociations: Maybe<Array<Maybe<MoldToolRevisionQmr>>>;
  destroyMoldToolRevisionToQMRAssociation: Maybe<MoldTool>;
  destroyQuote: Maybe<Quote>;
  destroyQuoteItems: Array<QuoteItem>;
  destroyQuoteModel: QuoteModel;
  destroyQuoteModelRevisionTapOnHole: UpsertOrDeleteTapResponse;
  destroyQuoteModelRevisionTapOnHoles: UpsertOrDeleteTapsResponse;
  destroyQuoteModels: Array<QuoteModel>;
  destroyTapAnnotationOnHole: Hole;
  disableTeams: BusinessAccountFeature;
  downloadDfmFeedbackForQmr: Maybe<DfmLoadingStatus>;
  duplicateQuoteFromOrder: Quote;
  editComment: Comment;
  editDfmFeedbackMessage: Maybe<DfmFeedbackMessage>;
  enableBusinessAccount: Maybe<BusinessAccount>;
  enableBusinessAccountTrial: Scalars['String'];
  enableTeams: BusinessAccountFeature;
  finalizeUploadAndProcessPart: InstantQuoterResponseType;
  forwardImQuote: Maybe<Scalars['Boolean']>;
  generateCltOptimizerReport: Maybe<CltOptimizerReport>;
  generateJobRequestVisualFictiv5: Scalars['String'];
  generatePdfFor3dDfm: DfmSlideReadyStatus;
  getLogByReqId: Maybe<Scalars['JSON']>;
  invalidateGeneratedDrawing: GeneratedDrawing;
  jobRequest: Maybe<JobRequestMutation>;
  linkUnlinkExceptions: Scalars['Boolean'];
  lockQMRToSingleQuote: QuoteModelRevision;
  lockQuote: Quote;
  logRequestAssistance: Scalars['Boolean'];
  makeJobBoardJobBid: JobBid;
  manuallySyncLastQuoteActivity: Array<QuoteActivityForSyncing>;
  markAsCustomerImpactedForAssociatedExceptionFailures: Array<ExceptionFailure>;
  markCorrectiveActionRequestAttachmentVisibility: Scalars['UUID'];
  markJobBoardParticipantAsParticipated: Maybe<JobBoardParticipant>;
  markProductAttachmentRevisionAsSelected: ProductAttachmentRevision;
  markProductAttachmentRevisionUploaded: ProductAttachmentRevision;
  markProductModelRevisionAsSelected: ProductModelRevision;
  markQuoteAttachmentRevisionUploaded: QuoteAttachmentRevision;
  markQuoteModelRevisionFlags: Maybe<QuoteModelRevision>;
  markUploadedAsset: Asset;
  markUploadedAttachment: Attachment;
  markUploadedSanitizedAttachment: SanitizedAttachment;
  mergedDfmReportForQmrIsReady: Maybe<Scalars['String']>;
  migrateQuoteAndQMRStatus: Maybe<Scalars['String']>;
  moveOrderTeam: Maybe<OrderTeamMembership>;
  moveQuoteTeam: Maybe<QuoteTeamMembership>;
  moveToExistingQuote: Quote;
  moveToNewQuote: Quote;
  notifyAdmin: Maybe<Quote>;
  overrideDfmInspectionPartPricingAndLeadtime: ModelConfigurationDfmInspection;
  placeOrder: Maybe<Order>;
  publishDfmAndInspectionDataForQuote: Quote;
  publishMoldTool: MoldTool;
  publishQuoteModelRevision: QuoteModelRevision;
  reSequenceSchedulingQueueItem: Scalars['Boolean'];
  reactivateBusinessAccountMember: Scalars['Boolean'];
  receivedFromGenerator: GeneratedDrawing;
  recordCltOptimization: CltOptimization;
  recordCltOptimizerView: CltOptimizerView;
  recordSystemEvent: Scalars['Boolean'];
  regenerateOpenInviteOnQuote: Quote;
  rejectJobBoardJob: JobBoardJob;
  releaseDfmReports: Quote;
  releaseRFQQuotesWithNoUnpublishedQMRs: Maybe<Scalars['Boolean']>;
  removeBusinessAccountMembership: BusinessAccountMembership;
  removeCorrectiveActionRequestAttachment: Scalars['UUID'];
  removeExceptionAttachment: Scalars['UUID'];
  removeExceptionFailureAttachment: Scalars['UUID'];
  removeExceptionFailureNoteAttachment: Scalars['UUID'];
  removeExceptionNoteAttachment: Scalars['UUID'];
  removeJobRequestAttachments: Array<Maybe<Scalars['UUID']>>;
  removeManuallyQuotedSecondaryProcess: Array<Scalars['String']>;
  removeMembership: Membership;
  removeNoteAttachment: Scalars['UUID'];
  removeOrderTeamMembership: Maybe<OrderTeamMembership>;
  removeProductAttachment: Maybe<ProductAttachment>;
  removeProductModel: Maybe<ProductModel>;
  removeQuoteAttachment: QuoteAttachment;
  removeQuoteModelRevisionAttachment: Maybe<QuoteModelRevisionAttachment>;
  removeQuoteTeamMembership: Maybe<QuoteTeamMembership>;
  removeRequirementTarget: Requirement;
  removeSanitizedAttachment: SanitizedAttachment;
  removeSanitizedCorrectiveActionResponse: CorrectiveActionRequestResponse;
  removeSchedulingQueueItem: Scalars['Boolean'];
  removeSelectedProductAttachmentRevision: Scalars['UUID'];
  removeSelectedProductModelRevision: Scalars['UUID'];
  removeTeamMember: RemoveUserTeamMemberResult;
  removeTeamMembership: Maybe<UserTeamMembership>;
  renameTeam: Maybe<Team>;
  replaceAllModelAttachmentCallouts: Array<ModelAttachmentSelection>;
  reportDelay: BasicExceptionFailure;
  requestAccessToBusinessAccount: User;
  requestBusinessAccountInvites: Array<RequestInviteResult>;
  requestImEstimateSlackNotification: Maybe<RequestImEstimateSlackNotification>;
  requestImQuote: Maybe<Scalars['Boolean']>;
  requestOdooQuote: Quote;
  requestTeamAccess: Maybe<RequestTeamAccessResult>;
  requestToCloseDelay: BasicExceptionFailure;
  resendBusinessAccountInvite: Maybe<BusinessAccountInvite>;
  resetDiscountCodeForUser: Maybe<Array<Maybe<BasicDiscountUsage>>>;
  resolveThread: Thread;
  restoreComment: Comment;
  restoreProjectMembership: ProjectMembership;
  resyncQuoteToCpq: Maybe<Scalars['String']>;
  revokeBusinessAccountInvites: Array<Maybe<BusinessAccountInvite>>;
  revokeOpenInviteOnQuote: Quote;
  revokeProjectMembership: ProjectMembership;
  /** Update the sanitizedResponseText for a corrective action request response */
  sanitizeCorrectiveActionRequestResponse: CorrectiveActionRequestResponse;
  saveCorrectiveActionRequestResponse: Scalars['Int'];
  sendBusinessAccountInvites: SendBusinessAccountInviteResult;
  sendCorrectiveActionRequestDueReminderEmails: Scalars['Int'];
  sendJobDueReminderEmails: Scalars['Int'];
  sendMetrics: Metric;
  sendMfgPartnerLevelScorecardEmails: Scalars['Int'];
  sendNewCorrectiveActionRequestEmails: Scalars['Int'];
  sendPrivateMessageToDrift: Scalars['Boolean'];
  sendQlltOptimisationNotification: Maybe<ResponseFromEchatApi>;
  sendSecondaryProcessReminderEmails: Scalars['Int'];
  setBusinessAccountExcludedCountries: Maybe<BusinessAccount>;
  setBusinessAccountFeature: Maybe<BusinessAccountFeature>;
  setExceptionFailureParts: Maybe<Array<Maybe<ExceptionFailurePart>>>;
  setExceptionFailureStatus: Maybe<ExceptionFailure>;
  setExceptionParts: Maybe<Array<Maybe<ExceptionPart>>>;
  setExceptionStatus: Maybe<Exception>;
  setFeatureFlag: FeatureFlag;
  setJobRequestLineInspectionState: AllowedWorkOrderItemInspectionStates;
  setMfgPartnerMaterial: Scalars['Boolean'];
  setNeedByDate: Maybe<Scalars['Date']>;
  setQuoteProperty: QuoteProperty;
  setShopProcessAvailability: Scalars['Boolean'];
  shareQuote: Maybe<Invite>;
  skipSchedulingQueueItem: SchedulingQueueItem;
  storeInstantQuoterResults: InstantQuoterResponseType;
  submitQuoteChangeRequest: Quote;
  syncQuoteActivity: QuoteActivityForSyncing;
  unlockQuote: Quote;
  unlockReorderQuote: Quote;
  updateAdditionalRequirementOnQmr: QuoteModelRevision;
  updateBusinessAccount: BusinessAccount;
  updateBusinessAccountDiscount: BusinessAccountDiscount;
  updateBusinessAccountSubscription: BusinessAccountSubscription;
  updateCarSupplierQualityEngineer: CorrectiveActionRequest;
  updateCarrierAccount: TplCarrierAccount;
  updateCorrectiveActionRequestAssignee: CorrectiveActionRequest;
  updateCorrectiveActionRequestStatus: CorrectiveActionRequest;
  updateCustomerToolName: MoldTool;
  updateDfmFeedbackInfo: DfmFeedback;
  updateDfmFeedbackSortOrder: DfmFeedback;
  updateDfmReportingLoadingStatus: Scalars['UUID'];
  updateException: Exception;
  updateExceptionFailure: ExceptionFailure;
  updateExceptionFailureParts: Maybe<Array<Maybe<ExceptionFailurePart>>>;
  updateExceptionParts: Maybe<Array<Maybe<ExceptionPart>>>;
  updateFPQDesignation: Quote;
  updateGeneratedDrawing: GeneratedDrawing;
  updateHts: Scalars['Boolean'];
  updateIMQuoteRequirements: Quote;
  updateJob: Job;
  updateJobAutoOtDates: Job;
  updateJobBoardCalendar: Maybe<Array<Maybe<JobBoardCalendar>>>;
  updateJobBoardRegionConfiguration: JobBoardRegion;
  updateJobLines: Scalars['Boolean'];
  updateJobPauseException: Job;
  updateJobProductionCountry: Job;
  updateJobRequest: JobRequest;
  updateJobRequestFollowers: JobRequest;
  updateJobRequestInspectionStatus: JobRequest;
  updateJobRequestLines: Scalars['Boolean'];
  updateJobRequestQcType: JobRequest;
  updateJobRequestStatus: JobRequest;
  updateJobRequestVendorDueDate: JobRequest;
  updateJobVendorDueDate: Job;
  updateMergedDfmAsset: Maybe<QmrMergedDfmAssets>;
  updateMfgPartnerMachineDetails: Maybe<MfgPartnerMachineDetails>;
  updateModelAttachmentAnnotation: ModelAttachmentAnnotation;
  updateModelConfigurationDfmInspection: ModelConfigurationDfmInspection;
  updateModelViewerSnapshot: ModelViewerSnapshot;
  updateMoldToolInspectionData: MoldTool;
  updateMoldToolInspectionOverrideData: Maybe<MoldTool>;
  updateMoldToolOverrideData: MoldTool;
  updateMoldToolRevision: Maybe<MoldTool>;
  updateMoldToolRevisionToQMRAssociation: Maybe<MoldTool>;
  updateMultiRegionJobBoard: Maybe<Array<Maybe<JobBoard>>>;
  updateNotesToCustomer: Quote;
  updateOrAddUserPreference: UserPreferences;
  updateOvermoldRequirement: QuoteModelRevision;
  updatePdfOcrAutoQuotable: QuoteModelRevisionAttachment;
  updateProcessConfigsOnQuoteModelRevisions: Array<QuoteModelRevision>;
  updateProject: Maybe<Project>;
  updatePurchaseOrder: PurchaseOrder;
  updateQueueStatus: SchedulingQueue;
  updateQuote: Quote;
  updateQuoteLeadTimes: Quote;
  updateQuoteOverviewResponses: Quote;
  updateQuoteStatusToDraft: Quote;
  updateQuoteStatusToPurchased: Quote;
  updateQuoteStatusToSentToPunchout: Quote;
  updateRequirement: Requirement;
  updateRequirementState: Requirement;
  updateSaleOrderLineProductionCountry: SaleOrderExtendedData;
  updateSchedulingDri: SaleOrderExtendedData;
  updateSchedulingQueueItemNoEarlierThan: SchedulingQueueItem;
  updateSlackThreadForQuote: Maybe<Scalars['String']>;
  updateTaxExemptField: Quote;
  updateTurnaroundInfoForOldCars: OldCarsTurnaroundInfoMigrationReturnType;
  updateVisibleToCustomer: Scalars['UUID'];
  uploadQmrDfmReportPdf: DfmLoadingStatus;
  upsertBusinessAccountPunchoutFeature: Maybe<BusinessAccountPunchoutFeature>;
  upsertDfmAttachmentAnnotations: QmrAttachmentAnnotations;
  upsertHardwareInstallationSecondaryProcessWithCalculatedPricing: QuoteModelRevision;
  upsertManuallyQuotedSecondaryProcessesConfig: QuoteModelRevision;
  upsertQmrAttachmentAnnotations: Maybe<QmrAttachmentAnnotations>;
  upsertQuoteModelRevisionTapOnHole: UpsertOrDeleteTapResponse;
  upsertQuoteModelRevisionTapOnHoles: UpsertOrDeleteTapsResponse;
  upsertQuoteSalesRep: Quote;
  upsertTapAnnotationOnHole: Hole;
  user: Maybe<UserMutation>;
};


/** Mutation to change markups */
export type MutationAcceptDfmFeedbackArgs = {
  id: Scalars['UUID'];
  quoteId: InputMaybe<Scalars['UUID']>;
};


/** Mutation to change markups */
export type MutationAcceptInviteArgs = {
  token: Scalars['String'];
};


/** Mutation to change markups */
export type MutationAcceptJobBoardJobArgs = {
  jobId: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationAcceptOpenInviteArgs = {
  token: Scalars['String'];
};


/** Mutation to change markups */
export type MutationAcceptWorkspaceOpenInviteArgs = {
  token: Scalars['String'];
};


/** Mutation to change markups */
export type MutationActivateBusinessAccountMembersArgs = {
  businessAccountId: Scalars['String'];
  userIds: InputMaybe<Array<Scalars['Int']>>;
};


/** Mutation to change markups */
export type MutationAddExceptionFailureNoteArgs = {
  exceptionFailureNoteInput: ExceptionFailureNoteInput;
};


/** Mutation to change markups */
export type MutationAddExceptionNoteArgs = {
  exceptionNoteInput: ExceptionNoteInput;
};


/** Mutation to change markups */
export type MutationAddJobToActiveJobBoardArgs = {
  jobId: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationAddManuallyQuotedSecondaryProcessForBuilderArgs = {
  ids: Array<Scalars['UUID']>;
  processId: Scalars['String'];
};


/** Mutation to change markups */
export type MutationAddModelConfigurationDfmInspectionArgs = {
  inspectionData: InspectionDataInput;
  modelConfigurationId: Scalars['UUID'];
  quantityRangeData: QuantityRangeInput;
};


/** Mutation to change markups */
export type MutationAddMoldToolRevisionToQmrAssociationArgs = {
  moldToolRevisionId: Scalars['UUID'];
  quoteModelRevisionId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationAddProjectMembersArgs = {
  projectId: Scalars['UUID'];
  userEmails: Array<Scalars['String']>;
};


/** Mutation to change markups */
export type MutationAddRequirementTargetsArgs = {
  requirementId: Scalars['UUID'];
  targets: Array<RequirementTargetInput>;
};


/** Mutation to change markups */
export type MutationAddTeamMembersArgs = {
  members: Array<InputMaybe<Scalars['String']>>;
  teamId: Scalars['Int'];
  userId: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationAdjustCurrentMarkupsArgs = {
  newMarkupData: InputMaybe<MarkupDataInput>;
};


/** Mutation to change markups */
export type MutationAdminOnlyMutationsArgs = {
  userId: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationAdminUserArgs = {
  userId: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationApproveTeamAccessRequestArgs = {
  requestId: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationAttachPdfToDfmArgs = {
  assetId: Scalars['UUID'];
  feedbackId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationAttachPurchaseOrderOnOrderArgs = {
  orderName: Scalars['String'];
  poId: Scalars['String'];
};


/** Mutation to change markups */
export type MutationAutoConfigurePartArgs = {
  quoteId: Scalars['UUID'];
  quoteModelRevisionId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationCancelCorrectiveActionRequestArgs = {
  id: Scalars['String'];
  reason: ManualCarCancelationReasons;
  rootCauseReasons: InputMaybe<Array<Scalars['Int']>>;
};


/** Mutation to change markups */
export type MutationCancelJobArgs = {
  id: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationCancelPlatformOrderArgs = {
  orderId: Scalars['String'];
};


/** Mutation to change markups */
export type MutationClaimSalesOrderArgs = {
  claim: Scalars['Boolean'];
  saleOrderId: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationClearQuotePropertiesArgs = {
  quoteId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationComputeMfgPartnerLevelsArgs = {
  mfgPartnerId: InputMaybe<Scalars['Int']>;
  onDemand: InputMaybe<Scalars['Boolean']>;
};


/** Mutation to change markups */
export type MutationCreateAmountBasedDiscountArgs = {
  code: InputMaybe<Scalars['String']>;
  dollarAmount: Scalars['Float'];
  domains: InputMaybe<DomainRestrictionInput>;
  expirationDate: InputMaybe<Scalars['Date']>;
  firstOrderOnly: InputMaybe<Scalars['Boolean']>;
  numUsagesAllowed: InputMaybe<Scalars['Int']>;
  userSignupCutoffDate: InputMaybe<Scalars['Date']>;
};


/** Mutation to change markups */
export type MutationCreateAssetArgs = {
  extension: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  mimeType: InputMaybe<Scalars['String']>;
};


/** Mutation to change markups */
export type MutationCreateAutoGenerateUserDrawingArgs = {
  qmrId: Scalars['UUID'];
  quoteId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationCreateBusinessAccountArgs = {
  enabled: Scalars['Boolean'];
  name: InputMaybe<Scalars['String']>;
  salesforceAccountId: Scalars['String'];
};


/** Mutation to change markups */
export type MutationCreateBusinessAccountDiscountArgs = {
  businessAccountDiscountDataInput: BusinessAccountDiscountDataInput;
  businessAccountId: Scalars['String'];
};


/** Mutation to change markups */
export type MutationCreateBusinessAccountSubscriptionArgs = {
  businessAccountId: Scalars['String'];
  expiration: Scalars['Date'];
  planId: Scalars['String'];
  setActive: InputMaybe<Scalars['Boolean']>;
};


/** Mutation to change markups */
export type MutationCreateCarrierAccountArgs = {
  account: TplCarrierAccountInput;
  userId: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationCreateCommentArgs = {
  body: Scalars['String'];
  threadId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationCreateCorrectiveActionRequestAttachmentArgs = {
  input: CorrectiveActionRequestAttachmentInput;
};


/** Mutation to change markups */
export type MutationCreateCorrectiveActionRequestsArgs = {
  jobId: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationCreateCurrencyExchangeRateArgs = {
  currencyExchangeRate: CurrencyExchangeRateInput;
};


/** Mutation to change markups */
export type MutationCreateDfmConsultationRequestArgs = {
  notes: InputMaybe<Scalars['String']>;
  qmrId: InputMaybe<Scalars['UUID']>;
  quoteId: InputMaybe<Scalars['UUID']>;
  sections: InputMaybe<Array<InputMaybe<DfmConsultationRequestSectionInput>>>;
};


/** Mutation to change markups */
export type MutationCreateDfmFeedbackMessageArgs = {
  messageAttrs: DfmFeedbackMessageInput;
};


/** Mutation to change markups */
export type MutationCreateDfmFeedbackWithSnapshotArgs = {
  dfmInput: DfmFeedbackWithSnapshotInput;
  modelConfigurationId: Scalars['UUID'];
  quoteId: InputMaybe<Scalars['UUID']>;
};


/** Mutation to change markups */
export type MutationCreateDfmOnQmrForAttachmentsArgs = {
  attachmentIds: Array<Scalars['UUID']>;
  qmrId: Scalars['UUID'];
  topicLabels: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Mutation to change markups */
export type MutationCreateErpAttachmentArgs = {
  fileName: Scalars['String'];
  mimeType: Scalars['String'];
  sizeInKb: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationCreateErpMoldToolModelConfigurationDfmAssociationArgs = {
  erpMoldId: Scalars['String'];
  modelConfigurationDfmInspectionId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationCreateEstimateItemZipDownloadArgs = {
  estimateItemIds: Array<Scalars['UUID']>;
  mode: EstimateItemZipMode;
  name: Scalars['String'];
};


/** Mutation to change markups */
export type MutationCreateExceptionArgs = {
  ExceptionInput: InputMaybe<ExceptionCreateInput>;
};


/** Mutation to change markups */
export type MutationCreateExceptionAttachmentArgs = {
  input: ExceptionAttachmentInput;
};


/** Mutation to change markups */
export type MutationCreateExceptionFailureArgs = {
  exceptionFailureInput: ExceptionFailureInput;
};


/** Mutation to change markups */
export type MutationCreateExceptionFailureAttachmentArgs = {
  exceptionFailureAttachmentInput: ExceptionFailureAttachmentInput;
};


/** Mutation to change markups */
export type MutationCreateExceptionFailureNoteAttachmentArgs = {
  attachmentInput: AttachmentInput;
};


/** Mutation to change markups */
export type MutationCreateExceptionNoteAttachmentArgs = {
  input: AttachmentInput;
};


/** Mutation to change markups */
export type MutationCreateHistoryMessageArgs = {
  input: CreateHistoryMessageInput;
};


/** Mutation to change markups */
export type MutationCreateHistoryStateChangeArgs = {
  input: CreateHistoryStateChangeInput;
};


/** Mutation to change markups */
export type MutationCreateInviteArgs = {
  email: Scalars['Email'];
  folderId: Scalars['UUID'];
  sendCopy: InputMaybe<Scalars['Boolean']>;
  senderId: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationCreateJobBoardsArgs = {
  days: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationCreateJobBundleArgs = {
  id: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationCreateJobBundleForJobBoardArgs = {
  jobId: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationCreateJobRequestArgs = {
  jobId: Scalars['Int'];
  mfgPartnerId: Scalars['Int'];
  queueItemId: Scalars['Int'];
  sentDuringMpNonAcceptingHours?: InputMaybe<Scalars['Boolean']>;
  sentDuringMpUnavailability?: InputMaybe<Scalars['Boolean']>;
};


/** Mutation to change markups */
export type MutationCreateJobRequestAttachmentsArgs = {
  input: JobRequestLineAttachmentInput;
};


/** Mutation to change markups */
export type MutationCreateJobRequestCommentArgs = {
  jobRequestCommentInput: JobRequestCommentInput;
};


/** Mutation to change markups */
export type MutationCreateJobRequestZipDownloadJobArgs = {
  jobRequestId: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationCreateJobsArgs = {
  input: Array<CreateJobInput>;
  isForJobBoard: InputMaybe<Scalars['Boolean']>;
  jobBoardRegionId: InputMaybe<Scalars['UUID']>;
  scheduleNoEarlierThan: InputMaybe<Scalars['Date']>;
};


/** Mutation to change markups */
export type MutationCreateMfgPartnerLevelOverrideArgs = {
  expiresAt: Scalars['Date'];
  mpLevelOverride: MfgPartnerLevelType;
  partnerId: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationCreateModelAttachmentCalloutArgs = {
  modelAttachmentAnnotationInput: ModelAttachmentAnnotationInput;
  modelAttachmentSelectionInput: ModelAttachmentSelectionInput;
};


/** Mutation to change markups */
export type MutationCreateModelAttachmentCalloutsArgs = {
  modelAttachmentCalloutInputs: Array<ModelAttachmentCalloutInput>;
};


/** Mutation to change markups */
export type MutationCreateModelAttachmentSanitizationArgs = {
  input: ModelAttachmentSelectionInput;
};


/** Mutation to change markups */
export type MutationCreateModelConfigurationDfmFeedbackArgs = {
  attrs: DfmFeedbackInput;
};


/** Mutation to change markups */
export type MutationCreateModelViewerSnapshotArgs = {
  attrs: ModelViewerSnapshotInput;
};


/** Mutation to change markups */
export type MutationCreateMoldToolArgs = {
  qmrId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationCreateMoldToolQmrAssociationArgs = {
  modelConfigurationDfmInspectionId: Scalars['UUID'];
  moldToolId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationCreateMoldToolRevisionArgs = {
  moldToolRevisionId: Scalars['String'];
  quoteId: Scalars['String'];
};


/** Mutation to change markups */
export type MutationCreateMpLevelConfigurationArgs = {
  mpLevelConfiguration: MfgPartnerLevelConfigurationInput;
};


/** Mutation to change markups */
export type MutationCreateMpLevelThresholdConfigurationArgs = {
  mpLevelThresholdConfiguration: MfgPartnerLevelThresholdConfigurationInput;
};


/** Mutation to change markups */
export type MutationCreateNoteArgs = {
  input: CreateNoteInput;
};


/** Mutation to change markups */
export type MutationCreateNoteAttachmentArgs = {
  input: AttachmentInput;
};


/** Mutation to change markups */
export type MutationCreateOdooQuoteArgs = {
  moldToolRevisionIds: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quoteId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationCreateOpenInviteOnQuoteArgs = {
  quoteId: Scalars['UUID'];
  senderId: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationCreateOrUpdateMfgPartnerProcessCapabilitiesArgs = {
  capabilities: MfgPartnerProcessCapabilitiesInput;
  partnerId: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationCreateOrderPaidEventArgs = {
  orderId: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationCreatePercentageBasedDiscountArgs = {
  code: InputMaybe<Scalars['String']>;
  domains: InputMaybe<DomainRestrictionInput>;
  expirationDate: InputMaybe<Scalars['Date']>;
  firstOrderOnly: InputMaybe<Scalars['Boolean']>;
  maxDollarAmount: InputMaybe<Scalars['Float']>;
  numUsagesAllowed: InputMaybe<Scalars['Int']>;
  percent: Scalars['Float'];
  userSignupCutoffDate: InputMaybe<Scalars['Date']>;
};


/** Mutation to change markups */
export type MutationCreateProductAttachmentRevisionArgs = {
  attachmentType: InputMaybe<Scalars['String']>;
  productAttachmentId: InputMaybe<Scalars['UUID']>;
  productId: Scalars['UUID'];
  setAsSelectedForAttachment: Scalars['Boolean'];
  uploadMetadata: ProductAttachmentRevisionUploadInput;
};


/** Mutation to change markups */
export type MutationCreateProjectArgs = {
  projectInput: ProjectInput;
};


/** Mutation to change markups */
export type MutationCreatePurchaseOrderArgs = {
  input: PurchaseOrderInput;
  userId: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationCreateQualityDocumentArgs = {
  input: CreateQualityDocumentInput;
};


/** Mutation to change markups */
export type MutationCreateQuoteArgs = {
  input: QuoteInput;
  processId: InputMaybe<Scalars['String']>;
  projectId: InputMaybe<Scalars['UUID']>;
  teamId: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<QuoteType>;
  userId: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationCreateQuoteAttachmentRevisionArgs = {
  adminReplaced: InputMaybe<Scalars['Boolean']>;
  attachmentId: InputMaybe<Scalars['UUID']>;
  attachmentType: InputMaybe<Scalars['String']>;
  productAttachmentId: InputMaybe<Scalars['String']>;
  quoteAttachmentId: InputMaybe<Scalars['UUID']>;
  quoteId: Scalars['UUID'];
  uploadMetadata: AttachmentInput;
  userId: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationCreateQuoteDetailCsvFileArgs = {
  fileName: Scalars['String'];
  quoteId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationCreateQuoteModelRevisionArgs = {
  quoteId: Scalars['UUID'];
  quoteModelId: InputMaybe<Scalars['UUID']>;
  revisionNotes: InputMaybe<Scalars['String']>;
  setAsSelectedForQuoteModel: Scalars['Boolean'];
  uploadMetadata: QuoteModelRevisionUploadInput;
  userId: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationCreateQuoteModelRevisionAttachmentArgs = {
  quoteAttachmentRevisionId: Scalars['UUID'];
  quoteModelRevisionId: Scalars['UUID'];
  userId: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationCreateQuoteMoldToolArgs = {
  quoteId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationCreateReorderQuoteFromOrderArgs = {
  orderName: Scalars['String'];
  userId: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationCreateSaleOrderInspectionDownloadArgs = {
  id: Scalars['String'];
};


/** Mutation to change markups */
export type MutationCreateSanitizedAttachmentArgs = {
  attachmentId: Scalars['UUID'];
  quoteModelRevisionId: InputMaybe<Scalars['UUID']>;
  uploadMetadata: AttachmentInput;
};


/** Mutation to change markups */
export type MutationCreateSchedulingQueueArgs = {
  input: CreateSchedulingQueueInput;
};


/** Mutation to change markups */
export type MutationCreateSchedulingQueueItemsArgs = {
  input: CreateQueueItemInput;
  queueId: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationCreateTeamArgs = {
  businessAccountId: Scalars['UUID'];
  name: Scalars['String'];
  userId: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationCreateThreadArgs = {
  targetId: Scalars['String'];
  targetType: Scalars['String'];
};


/** Mutation to change markups */
export type MutationCreateWorkspaceInviteArgs = {
  email: Scalars['Email'];
  workspaceId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationCreateZipDownloadArgs = {
  attachmentIds: InputMaybe<Array<Scalars['UUID']>>;
  estimateItemIds: InputMaybe<Array<Scalars['UUID']>>;
  folderId: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  quoteAttachmentRevisionIds: InputMaybe<Array<Scalars['UUID']>>;
  quoteModelRevisionIds: InputMaybe<Array<Scalars['UUID']>>;
  revisionIds: InputMaybe<Array<Scalars['UUID']>>;
};


/** Mutation to change markups */
export type MutationCreateZipDownloadOrderDetailsArgs = {
  orderName: Scalars['String'];
};


/** Mutation to change markups */
export type MutationCypressCreateSalesforceAccountArgs = {
  name: Scalars['String'];
};


/** Mutation to change markups */
export type MutationCypressCreateSalesforceAccountContactsArgs = {
  emails: Array<Scalars['String']>;
  salesForceAccountId: Scalars['String'];
};


/** Mutation to change markups */
export type MutationCypressRemoveBusinessAccountArgs = {
  businessAccountId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationDeactivateBusinessAccountDiscountArgs = {
  businessAccountId: Scalars['String'];
};


/** Mutation to change markups */
export type MutationDeactivateBusinessAccountMemberArgs = {
  businessAccountId: Scalars['String'];
  userId: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationDeactivateMfgPartnerLevelOverrideArgs = {
  partnerId: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationDeleteDiscountArgs = {
  code: Scalars['String'];
};


/** Mutation to change markups */
export type MutationDeleteFeatureFlagArgs = {
  key: Scalars['String'];
};


/** Mutation to change markups */
export type MutationDeleteMoldToolArgs = {
  id: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationDeleteQuoteMoldArgs = {
  moldId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationDeleteQuotePropertyArgs = {
  name: Scalars['String'];
  quoteId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationDeleteTeamArgs = {
  teamId: Scalars['Int'];
  userId: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationDenyTeamAccessRequestArgs = {
  requestId: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationDestroyCarrierAccountArgs = {
  id: Scalars['UUID'];
  userId: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationDestroyCommentArgs = {
  id: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationDestroyDfmFeedbackArgs = {
  dfmFeedbackId: Scalars['UUID'];
  quoteId: InputMaybe<Scalars['UUID']>;
};


/** Mutation to change markups */
export type MutationDestroyErpMoldToolAssociationArgs = {
  modelConfigurationDfmInspectionId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationDestroyInviteArgs = {
  actorOverrideId: InputMaybe<Scalars['Int']>;
  id: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationDestroyModelAttachmentCalloutsArgs = {
  calloutIds: Array<InputMaybe<Scalars['UUID']>>;
};


/** Mutation to change markups */
export type MutationDestroyModelAttachmentSanitizationsArgs = {
  sanitizationIds: Array<InputMaybe<Scalars['UUID']>>;
};


/** Mutation to change markups */
export type MutationDestroyMoldToolRevisionAssociationsArgs = {
  moldToolRevisionId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationDestroyMoldToolRevisionToQmrAssociationArgs = {
  moldToolRevisionId: Scalars['UUID'];
  quoteModelRevisionId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationDestroyQuoteArgs = {
  id: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationDestroyQuoteItemsArgs = {
  ids: Array<Scalars['UUID']>;
};


/** Mutation to change markups */
export type MutationDestroyQuoteModelArgs = {
  id: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationDestroyQuoteModelRevisionTapOnHoleArgs = {
  holeId: Scalars['String'];
  quoteModelRevisionId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationDestroyQuoteModelRevisionTapOnHolesArgs = {
  holesList: Array<Scalars['String']>;
  quoteModelRevisionId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationDestroyQuoteModelsArgs = {
  ids: Array<Scalars['UUID']>;
};


/** Mutation to change markups */
export type MutationDestroyTapAnnotationOnHoleArgs = {
  estimateItemId: Scalars['UUID'];
  holeId: Scalars['String'];
};


/** Mutation to change markups */
export type MutationDisableTeamsArgs = {
  businessAccountId: Scalars['String'];
};


/** Mutation to change markups */
export type MutationDownloadDfmFeedbackForQmrArgs = {
  format: InputMaybe<Scalars['String']>;
  qmrId: Scalars['UUID'];
  requestedByAdmin: InputMaybe<Scalars['Boolean']>;
};


/** Mutation to change markups */
export type MutationDuplicateQuoteFromOrderArgs = {
  orderName: Scalars['String'];
  userId: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationEditCommentArgs = {
  body: Scalars['String'];
  id: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationEditDfmFeedbackMessageArgs = {
  messageAttrs: InputMaybe<DfmFeedbackMessageEditInput>;
};


/** Mutation to change markups */
export type MutationEnableBusinessAccountArgs = {
  businessAccountDataInput: InputMaybe<BusinessAccountDataInput>;
  businessAccountId: InputMaybe<Scalars['String']>;
};


/** Mutation to change markups */
export type MutationEnableBusinessAccountTrialArgs = {
  isBusinessAccountTrialRequest: InputMaybe<Scalars['Boolean']>;
  isPoVisibility: InputMaybe<Scalars['Boolean']>;
  userId: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationEnableTeamsArgs = {
  businessAccountId: Scalars['String'];
};


/** Mutation to change markups */
export type MutationFinalizeUploadAndProcessPartArgs = {
  partId: Scalars['Int'];
  reprocessParameters: InputMaybe<ReprocessParametersInput>;
};


/** Mutation to change markups */
export type MutationForwardImQuoteArgs = {
  emails: Array<Scalars['Email']>;
  estimateItemId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationGenerateCltOptimizerReportArgs = {
  quoteId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationGenerateJobRequestVisualFictiv5Args = {
  jobRequestId: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationGeneratePdfFor3dDfmArgs = {
  assetId: Scalars['UUID'];
  feedbackId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationGetLogByReqIdArgs = {
  id: Scalars['UUID'];
  includeTraceInWrite?: Scalars['Boolean'];
  writeToS3?: Scalars['Boolean'];
};


/** Mutation to change markups */
export type MutationInvalidateGeneratedDrawingArgs = {
  id: Scalars['String'];
};


/** Mutation to change markups */
export type MutationJobRequestArgs = {
  id: Scalars['String'];
};


/** Mutation to change markups */
export type MutationLinkUnlinkExceptionsArgs = {
  exceptionFailureIdsGroup: InputMaybe<Array<ExceptionFailureIdsGroupInput>>;
};


/** Mutation to change markups */
export type MutationLockQmrToSingleQuoteArgs = {
  flag: Scalars['Boolean'];
  quoteModelRevisionId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationLockQuoteArgs = {
  id: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationLogRequestAssistanceArgs = {
  quoteId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationMakeJobBoardJobBidArgs = {
  additionalComments: InputMaybe<Scalars['String']>;
  bidAmount: InputMaybe<Scalars['Float']>;
  isCancel: Scalars['Boolean'];
  jobId: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationManuallySyncLastQuoteActivityArgs = {
  quoteIds: Array<Scalars['UUID']>;
};


/** Mutation to change markups */
export type MutationMarkAsCustomerImpactedForAssociatedExceptionFailuresArgs = {
  jobId: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationMarkCorrectiveActionRequestAttachmentVisibilityArgs = {
  correctiveActionRequestAttachmentId: Scalars['UUID'];
  correctiveActionRequestId: Scalars['UUID'];
  isVisible: Scalars['Boolean'];
};


/** Mutation to change markups */
export type MutationMarkJobBoardParticipantAsParticipatedArgs = {
  jobBoardId: Scalars['String'];
};


/** Mutation to change markups */
export type MutationMarkProductAttachmentRevisionAsSelectedArgs = {
  id: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationMarkProductAttachmentRevisionUploadedArgs = {
  id: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationMarkProductModelRevisionAsSelectedArgs = {
  id: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationMarkQuoteAttachmentRevisionUploadedArgs = {
  id: Scalars['UUID'];
  userId: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationMarkQuoteModelRevisionFlagsArgs = {
  flags: InputMaybe<Array<InputMaybe<QmrFlag>>>;
  quoteModelRevisionId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationMarkUploadedAssetArgs = {
  id: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationMarkUploadedAttachmentArgs = {
  id: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationMarkUploadedSanitizedAttachmentArgs = {
  id: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationMergedDfmReportForQmrIsReadyArgs = {
  qmrId: Scalars['UUID'];
  requestedByAdmin: InputMaybe<Scalars['Boolean']>;
  timestamp: Scalars['String'];
  userId: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationMigrateQuoteAndQmrStatusArgs = {
  quoteIds: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


/** Mutation to change markups */
export type MutationMoveOrderTeamArgs = {
  erpSaleOrderId: InputMaybe<Scalars['Int']>;
  platformOrderId: InputMaybe<Scalars['Int']>;
  teamId: Scalars['Int'];
  userId: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationMoveQuoteTeamArgs = {
  quoteId: Scalars['UUID'];
  teamId: Scalars['Int'];
  userId: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationMoveToExistingQuoteArgs = {
  destinationQuoteId: Scalars['UUID'];
  quoteModelRevisionIds: Array<InputMaybe<Scalars['UUID']>>;
  userId: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationMoveToNewQuoteArgs = {
  newQuoteName: InputMaybe<Scalars['String']>;
  quoteModelRevisionIds: Array<InputMaybe<Scalars['UUID']>>;
  userId: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationNotifyAdminArgs = {
  orderId: InputMaybe<Scalars['String']>;
  quoteId: InputMaybe<Scalars['UUID']>;
  userId: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationOverrideDfmInspectionPartPricingAndLeadtimeArgs = {
  modelConfigurationDfmInspectionId: Scalars['UUID'];
  pricingLeadTimeInput: OverridePartPricingLeadtimeInput;
};


/** Mutation to change markups */
export type MutationPlaceOrderArgs = {
  orderInput: OrderInput;
  userId: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationPublishDfmAndInspectionDataForQuoteArgs = {
  emailInput: InputMaybe<QuoteReadyEmailInput>;
  quoteId: Scalars['UUID'];
  skipEmails?: InputMaybe<Scalars['Boolean']>;
};


/** Mutation to change markups */
export type MutationPublishMoldToolArgs = {
  id: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationPublishQuoteModelRevisionArgs = {
  quantityLowerRange: InputMaybe<Scalars['Int']>;
  quantityUpperRange: InputMaybe<Scalars['Int']>;
  quoteModelRevisionId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationReSequenceSchedulingQueueItemArgs = {
  id: Scalars['Int'];
  newSequenceNo: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationReactivateBusinessAccountMemberArgs = {
  businessAccountId: Scalars['String'];
  userId: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationReceivedFromGeneratorArgs = {
  generatedDrawing: GeneratedDrawingInput;
};


/** Mutation to change markups */
export type MutationRecordCltOptimizationArgs = {
  description: Scalars['String'];
  finalCostCents: Scalars['Int'];
  finalQuantity: Scalars['Int'];
  finalTimeDays: Scalars['Int'];
  initialCostCents: Scalars['Int'];
  initialQuantity: Scalars['Int'];
  initialTimeDays: Scalars['Int'];
  operation: Scalars['String'];
  quoteModelRevisionId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationRecordCltOptimizerViewArgs = {
  quoteId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationRecordSystemEventArgs = {
  id: Scalars['UUID'];
  name: SystemEventName;
};


/** Mutation to change markups */
export type MutationRegenerateOpenInviteOnQuoteArgs = {
  quoteId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationRejectJobBoardJobArgs = {
  jobId: Scalars['Int'];
  rejectionReason: JobBoardRejectionReasonInput;
};


/** Mutation to change markups */
export type MutationReleaseDfmReportsArgs = {
  emailInput: InputMaybe<QuoteReadyEmailInput>;
  orderId: InputMaybe<Scalars['String']>;
  quoteId: InputMaybe<Scalars['UUID']>;
  skipDfmEmail?: InputMaybe<Scalars['Boolean']>;
};


/** Mutation to change markups */
export type MutationRemoveBusinessAccountMembershipArgs = {
  id: InputMaybe<Scalars['UUID']>;
  userId: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationRemoveCorrectiveActionRequestAttachmentArgs = {
  id: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationRemoveExceptionAttachmentArgs = {
  id: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationRemoveExceptionFailureAttachmentArgs = {
  id: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationRemoveExceptionFailureNoteAttachmentArgs = {
  id: InputMaybe<Scalars['UUID']>;
};


/** Mutation to change markups */
export type MutationRemoveExceptionNoteAttachmentArgs = {
  id: InputMaybe<Scalars['UUID']>;
};


/** Mutation to change markups */
export type MutationRemoveJobRequestAttachmentsArgs = {
  ids: Array<Scalars['UUID']>;
};


/** Mutation to change markups */
export type MutationRemoveManuallyQuotedSecondaryProcessArgs = {
  ids: Array<Scalars['UUID']>;
  processId: InputMaybe<Scalars['String']>;
};


/** Mutation to change markups */
export type MutationRemoveMembershipArgs = {
  actorOverrideId: InputMaybe<Scalars['Int']>;
  id: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationRemoveNoteAttachmentArgs = {
  id: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationRemoveOrderTeamMembershipArgs = {
  erpSaleOrderId: InputMaybe<Scalars['Int']>;
  platformOrderId: InputMaybe<Scalars['Int']>;
  teamId: Scalars['Int'];
  userId: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationRemoveProductAttachmentArgs = {
  id: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationRemoveProductModelArgs = {
  id: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationRemoveQuoteAttachmentArgs = {
  attachmentId: InputMaybe<Scalars['UUID']>;
  quoteAttachmentId: InputMaybe<Scalars['UUID']>;
  quoteId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationRemoveQuoteModelRevisionAttachmentArgs = {
  quoteAttachmentRevisionId: Scalars['UUID'];
  quoteId: InputMaybe<Scalars['UUID']>;
  quoteModelRevisionId: Scalars['UUID'];
  userId: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationRemoveQuoteTeamMembershipArgs = {
  quoteId: Scalars['UUID'];
  teamId: Scalars['Int'];
  userId: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationRemoveRequirementTargetArgs = {
  requirementId: Scalars['UUID'];
  targetId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationRemoveSanitizedAttachmentArgs = {
  id: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationRemoveSanitizedCorrectiveActionResponseArgs = {
  correctiveActionRequestId: Scalars['UUID'];
  id: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationRemoveSchedulingQueueItemArgs = {
  id: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationRemoveSelectedProductAttachmentRevisionArgs = {
  id: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationRemoveSelectedProductModelRevisionArgs = {
  id: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationRemoveTeamMemberArgs = {
  email: Scalars['String'];
  teamId: Scalars['Int'];
  userId: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationRemoveTeamMembershipArgs = {
  memberId: Scalars['Int'];
  teamId: Scalars['Int'];
  userId: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationRenameTeamArgs = {
  name: Scalars['String'];
  teamId: Scalars['Int'];
  userId: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationReplaceAllModelAttachmentCalloutsArgs = {
  attachmentId: InputMaybe<Scalars['UUID']>;
  estimateItemUUID: InputMaybe<Scalars['UUID']>;
  modelAttachmentCalloutInputs: Array<ModelAttachmentCalloutInput>;
};


/** Mutation to change markups */
export type MutationReportDelayArgs = {
  reportDelayInput: ReportDelayInput;
};


/** Mutation to change markups */
export type MutationRequestBusinessAccountInvitesArgs = {
  businessAccountId: Scalars['UUID'];
  emails: Array<Scalars['String']>;
};


/** Mutation to change markups */
export type MutationRequestImEstimateSlackNotificationArgs = {
  qmrId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationRequestImQuoteArgs = {
  body: InjectionMoldingQuoteInput;
};


/** Mutation to change markups */
export type MutationRequestOdooQuoteArgs = {
  isOdooRequest: InputMaybe<Scalars['Boolean']>;
  quoteId: Scalars['UUID'];
  userId: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationRequestTeamAccessArgs = {
  teamId: Scalars['Int'];
  userId: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationRequestToCloseDelayArgs = {
  exceptionId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationResendBusinessAccountInviteArgs = {
  businessAccountInviteId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationResetDiscountCodeForUserArgs = {
  userId: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationResolveThreadArgs = {
  id: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationRestoreCommentArgs = {
  id: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationRestoreProjectMembershipArgs = {
  membershipId: Scalars['String'];
  projectId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationResyncQuoteToCpqArgs = {
  quoteIds: Array<Scalars['UUID']>;
};


/** Mutation to change markups */
export type MutationRevokeBusinessAccountInvitesArgs = {
  inviteIds: Array<Scalars['UUID']>;
};


/** Mutation to change markups */
export type MutationRevokeOpenInviteOnQuoteArgs = {
  quoteId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationRevokeProjectMembershipArgs = {
  membershipId: Scalars['String'];
  projectId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationSanitizeCorrectiveActionRequestResponseArgs = {
  correctiveActionRequestId: Scalars['UUID'];
  id: Scalars['Int'];
  sanitizedResponseText: Scalars['String'];
};


/** Mutation to change markups */
export type MutationSaveCorrectiveActionRequestResponseArgs = {
  correctiveActionRequestId: Scalars['UUID'];
  question: CorrectiveActionRequestQuestionType;
  responseText: InputMaybe<Scalars['String']>;
  selectedOptions: InputMaybe<Array<Scalars['Int']>>;
};


/** Mutation to change markups */
export type MutationSendBusinessAccountInvitesArgs = {
  businessAccountId: Scalars['UUID'];
  emails: Array<Scalars['String']>;
};


/** Mutation to change markups */
export type MutationSendJobDueReminderEmailsArgs = {
  date: InputMaybe<Scalars['String']>;
};


/** Mutation to change markups */
export type MutationSendMetricsArgs = {
  metrics: Array<MetricInput>;
};


/** Mutation to change markups */
export type MutationSendPrivateMessageToDriftArgs = {
  conversationId: Scalars['String'];
  message: Scalars['String'];
  userId: Scalars['String'];
};


/** Mutation to change markups */
export type MutationSendQlltOptimisationNotificationArgs = {
  quoteId: Scalars['UUID'];
  userId: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationSendSecondaryProcessReminderEmailsArgs = {
  date: InputMaybe<Scalars['String']>;
};


/** Mutation to change markups */
export type MutationSetBusinessAccountExcludedCountriesArgs = {
  businessAccountId: Scalars['UUID'];
  excludedCountryIDs: InputMaybe<Array<InputMaybe<BusinessAccountExcludedCountriesInput>>>;
};


/** Mutation to change markups */
export type MutationSetBusinessAccountFeatureArgs = {
  businessAccountId: Scalars['UUID'];
  featureName: BusinessAccountFeatureInput;
  isEnabled: Scalars['Boolean'];
};


/** Mutation to change markups */
export type MutationSetExceptionFailurePartsArgs = {
  inputExceptionFailureParts: ExceptionFailurePartsInput;
};


/** Mutation to change markups */
export type MutationSetExceptionFailureStatusArgs = {
  id: Scalars['UUID'];
  status: ExceptionFailureStatus;
};


/** Mutation to change markups */
export type MutationSetExceptionPartsArgs = {
  inputExceptionParts: ExceptionPartsInput;
};


/** Mutation to change markups */
export type MutationSetExceptionStatusArgs = {
  id: Scalars['UUID'];
  status: ExceptionStatus;
};


/** Mutation to change markups */
export type MutationSetFeatureFlagArgs = {
  input: FeatureFlagInput;
};


/** Mutation to change markups */
export type MutationSetJobRequestLineInspectionStateArgs = {
  jobRequestLineId: Scalars['Int'];
  state: AllowedWorkOrderItemInspectionStates;
};


/** Mutation to change markups */
export type MutationSetMfgPartnerMaterialArgs = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  materialId: Scalars['Int'];
  partnerId: Scalars['Int'];
  processId: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationSetNeedByDateArgs = {
  needByDate: InputMaybe<Scalars['Date']>;
  quoteId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationSetQuotePropertyArgs = {
  name: Scalars['String'];
  quoteId: Scalars['UUID'];
  value: Scalars['String'];
};


/** Mutation to change markups */
export type MutationSetShopProcessAvailabilityArgs = {
  availabilityInput: Array<AvailabilityInput>;
  partnerId: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationShareQuoteArgs = {
  emailAttributes: InputMaybe<EmailAttributesInput>;
  emailSpecificInput: EmailSpecificInput;
  includePdfInput: InputMaybe<IncludePdfInput>;
  quoteId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationSkipSchedulingQueueItemArgs = {
  id: Scalars['Int'];
  reasonToSkip: InputMaybe<ReasonToSkipQueueItem>;
};


/** Mutation to change markups */
export type MutationStoreInstantQuoterResultsArgs = {
  instantQuoterResults: Scalars['JSON'];
  partId: Scalars['Int'];
  reprocessed: Scalars['Boolean'];
};


/** Mutation to change markups */
export type MutationSubmitQuoteChangeRequestArgs = {
  ChangeRequestInput: ChangeRequestInput;
  id: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationSyncQuoteActivityArgs = {
  quoteId: Scalars['UUID'];
  timestamp: Scalars['Date'];
};


/** Mutation to change markups */
export type MutationUnlockQuoteArgs = {
  id: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationUnlockReorderQuoteArgs = {
  quoteId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationUpdateAdditionalRequirementOnQmrArgs = {
  id: Scalars['UUID'];
  notes: Scalars['String'];
};


/** Mutation to change markups */
export type MutationUpdateBusinessAccountArgs = {
  businessAccountId: Scalars['UUID'];
  name: InputMaybe<Scalars['String']>;
};


/** Mutation to change markups */
export type MutationUpdateBusinessAccountDiscountArgs = {
  businessAccountDiscountDataInput: BusinessAccountDiscountDataInput;
  businessAccountId: Scalars['String'];
};


/** Mutation to change markups */
export type MutationUpdateBusinessAccountSubscriptionArgs = {
  expiration: InputMaybe<Scalars['Date']>;
  status: InputMaybe<BusinessAccountSubscriptionEnablementStatus>;
  subscriptionId: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationUpdateCarSupplierQualityEngineerArgs = {
  id: Scalars['String'];
  supplierQualityEngineerId: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationUpdateCarrierAccountArgs = {
  account: TplCarrierAccountUpdateInput;
  id: Scalars['UUID'];
  userId: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationUpdateCorrectiveActionRequestAssigneeArgs = {
  assigneeId: Scalars['Int'];
  id: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationUpdateCorrectiveActionRequestStatusArgs = {
  id: Scalars['UUID'];
  reworkReason: InputMaybe<Scalars['String']>;
  status: CorrectiveActionRequestStatus;
};


/** Mutation to change markups */
export type MutationUpdateCustomerToolNameArgs = {
  customerToolName: InputMaybe<Scalars['String']>;
  moldId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationUpdateDfmFeedbackInfoArgs = {
  code: InputMaybe<Scalars['String']>;
  dfmFeedbackId: Scalars['UUID'];
  isPublished: InputMaybe<Scalars['Boolean']>;
  link: InputMaybe<Scalars['String']>;
  message: InputMaybe<Scalars['String']>;
  severity: InputMaybe<Scalars['String']>;
  status: InputMaybe<Scalars['String']>;
  title: InputMaybe<Scalars['String']>;
  topicId: InputMaybe<Scalars['String']>;
};


/** Mutation to change markups */
export type MutationUpdateDfmFeedbackSortOrderArgs = {
  dfmFeedbackId: Scalars['UUID'];
  ordinalPos: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationUpdateDfmReportingLoadingStatusArgs = {
  errors: Scalars['String'];
  targetId: Scalars['UUID'];
  targetType: Scalars['String'];
  type: Scalars['String'];
  userId: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationUpdateExceptionArgs = {
  id: Scalars['UUID'];
  input: InputMaybe<ExceptionUpdateInput>;
};


/** Mutation to change markups */
export type MutationUpdateExceptionFailureArgs = {
  exceptionFailureInput: ExceptionFailureUpdateInput;
  id: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationUpdateExceptionFailurePartsArgs = {
  inputExceptionFailureParts: ExceptionFailurePartsInput;
};


/** Mutation to change markups */
export type MutationUpdateExceptionPartsArgs = {
  inputExceptionParts: ExceptionPartsInput;
};


/** Mutation to change markups */
export type MutationUpdateFpqDesignationArgs = {
  isFPQ: Scalars['Boolean'];
  quoteId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationUpdateGeneratedDrawingArgs = {
  attachment: AttachmentInput;
  id: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationUpdateHtsArgs = {
  isDdpQualified: Scalars['Boolean'];
  orderId: Scalars['String'];
  orderLinesInput: Array<HtsUpdateInput>;
  userId: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationUpdateImQuoteRequirementsArgs = {
  input: ImQuoteRequirementsInput;
  quoteId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationUpdateJobArgs = {
  id: Scalars['Int'];
  input: UpdateJobInput;
};


/** Mutation to change markups */
export type MutationUpdateJobAutoOtDatesArgs = {
  id: Scalars['Int'];
  updateAutoOtDatesInput: UpdateAutoOtDatesInput;
};


/** Mutation to change markups */
export type MutationUpdateJobBoardCalendarArgs = {
  isApplicableNextSevenDays?: InputMaybe<Scalars['Boolean']>;
  jobBoardId: Scalars['String'];
  updateJobBoardCalendar: UpdateJobBoardCalendarInput;
};


/** Mutation to change markups */
export type MutationUpdateJobBoardRegionConfigurationArgs = {
  configurationInput: UpdateJobBoardRegionConfigurationInput;
  jobBoardRegionId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationUpdateJobLinesArgs = {
  jobId: Scalars['Int'];
  jobLineInput: Array<UpdateJobLineInput>;
};


/** Mutation to change markups */
export type MutationUpdateJobPauseExceptionArgs = {
  jobId: Scalars['Int'];
  pauseException: Scalars['Boolean'];
};


/** Mutation to change markups */
export type MutationUpdateJobProductionCountryArgs = {
  jobId: Scalars['Int'];
  productionCountry: JobProductionCountry;
};


/** Mutation to change markups */
export type MutationUpdateJobRequestArgs = {
  id: Scalars['Int'];
  input: UpdateJobRequestInput;
};


/** Mutation to change markups */
export type MutationUpdateJobRequestFollowersArgs = {
  input: UpdateJobRequestFollowersInput;
  jobRequestId: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationUpdateJobRequestInspectionStatusArgs = {
  id: Scalars['Int'];
  inspectionStatus: JobRequestInspectionStatus;
};


/** Mutation to change markups */
export type MutationUpdateJobRequestLinesArgs = {
  jobRequestId: Scalars['Int'];
  jobRequestLineInput: Array<UpdateJobRequestLineInput>;
};


/** Mutation to change markups */
export type MutationUpdateJobRequestQcTypeArgs = {
  id: Scalars['Int'];
  qcType: JobRequestQcType;
};


/** Mutation to change markups */
export type MutationUpdateJobRequestStatusArgs = {
  id: Scalars['Int'];
  rejectionInfo: InputMaybe<JobRequestRejectionInput>;
  status: JobRequestStatus;
};


/** Mutation to change markups */
export type MutationUpdateJobRequestVendorDueDateArgs = {
  id: Scalars['Int'];
  vendorDueDate: Scalars['Date'];
  vendorDueDateUpdateReason: InputMaybe<Scalars['String']>;
};


/** Mutation to change markups */
export type MutationUpdateJobVendorDueDateArgs = {
  id: Scalars['Int'];
  vendorDueDate: Scalars['Date'];
};


/** Mutation to change markups */
export type MutationUpdateMergedDfmAssetArgs = {
  assetId: Scalars['UUID'];
  assetType: AssetType;
  qmrId: Scalars['UUID'];
  userId: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationUpdateMfgPartnerMachineDetailsArgs = {
  machineDetails: MfgPartnerMachineDetailsInput;
};


/** Mutation to change markups */
export type MutationUpdateModelAttachmentAnnotationArgs = {
  id: Scalars['UUID'];
  input: ModelAttachmentAnnotationInput;
};


/** Mutation to change markups */
export type MutationUpdateModelConfigurationDfmInspectionArgs = {
  inspectionData: InspectionDataInput;
  isQuantityRangeAvailable: InputMaybe<Scalars['Boolean']>;
  lastModifiedAt: InputMaybe<Scalars['Date']>;
  modelConfigurationDfmInspectionId: Scalars['UUID'];
  override: InputMaybe<Scalars['Boolean']>;
};


/** Mutation to change markups */
export type MutationUpdateModelViewerSnapshotArgs = {
  attrs: ModelViewerSnapshotInput;
  dfmSnapshotId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationUpdateMoldToolInspectionDataArgs = {
  id: Scalars['UUID'];
  inspectionData: MoldToolInspectionDataInput;
};


/** Mutation to change markups */
export type MutationUpdateMoldToolInspectionOverrideDataArgs = {
  moldToolOverrideData: InputMaybe<MoldToolOverrideInput>;
  moldToolRevisionId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationUpdateMoldToolOverrideDataArgs = {
  moldId: Scalars['UUID'];
  moldToolOverrideData: MoldToolOverrideInput;
};


/** Mutation to change markups */
export type MutationUpdateMoldToolRevisionArgs = {
  inspectionData: MoldToolRevisionInput;
  moldToolRevisionId: Scalars['String'];
};


/** Mutation to change markups */
export type MutationUpdateMoldToolRevisionToQmrAssociationArgs = {
  cavityPerQmr: Array<InputMaybe<UpdateQmrAssociationInput>>;
  moldToolRevisionId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationUpdateMultiRegionJobBoardArgs = {
  assignJobBoardJobs: InputMaybe<Scalars['Boolean']>;
  changeJobBoardStatus: InputMaybe<Scalars['Boolean']>;
  sendMsgToActiveConnections: InputMaybe<Scalars['Boolean']>;
  sendNotifications: InputMaybe<Scalars['Boolean']>;
};


/** Mutation to change markups */
export type MutationUpdateNotesToCustomerArgs = {
  notes: InputMaybe<Scalars['String']>;
  quoteId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationUpdateOrAddUserPreferenceArgs = {
  name: Scalars['String'];
  preferenceType: PreferenceType;
  userId: Scalars['Int'];
  value: InputMaybe<Scalars['JSON']>;
};


/** Mutation to change markups */
export type MutationUpdateOvermoldRequirementArgs = {
  id: Scalars['UUID'];
  requiresOvermold: Scalars['Boolean'];
};


/** Mutation to change markups */
export type MutationUpdatePdfOcrAutoQuotableArgs = {
  isPdfOcrAutoQuotable: InputMaybe<Scalars['Boolean']>;
  quoteModelRevisionAttachmentId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationUpdateProcessConfigsOnQuoteModelRevisionsArgs = {
  additionalConfig: InputMaybe<AdditionalConfigInput>;
  ids: Array<Scalars['UUID']>;
  isAutoconfig: InputMaybe<Scalars['Boolean']>;
  primaryProcessConfig: PrimaryProcessConfigInput;
  removeManuallyQuotedSecondaryProcesses: InputMaybe<Scalars['Boolean']>;
  secondaryProcessConfigs: Array<SecondaryProcessConfigInput>;
};


/** Mutation to change markups */
export type MutationUpdateProjectArgs = {
  id: Scalars['UUID'];
  projectInput: ProjectUpdateInput;
};


/** Mutation to change markups */
export type MutationUpdatePurchaseOrderArgs = {
  attributes: UpdatePurchaseOrderInput;
  id: Scalars['String'];
};


/** Mutation to change markups */
export type MutationUpdateQueueStatusArgs = {
  id: Scalars['Int'];
  queueStatus: SchedulingQueueStatus;
};


/** Mutation to change markups */
export type MutationUpdateQuoteArgs = {
  id: Scalars['UUID'];
  input: QuoteInput;
};


/** Mutation to change markups */
export type MutationUpdateQuoteLeadTimesArgs = {
  productionDays: Scalars['Int'];
  quoteId: Scalars['UUID'];
  region: QuoteLevelLeadTimesRegion;
};


/** Mutation to change markups */
export type MutationUpdateQuoteOverviewResponsesArgs = {
  quoteId: Scalars['UUID'];
  responses: Scalars['JSON'];
};


/** Mutation to change markups */
export type MutationUpdateQuoteStatusToDraftArgs = {
  id: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationUpdateQuoteStatusToPurchasedArgs = {
  id: Scalars['UUID'];
  orderName: InputMaybe<Scalars['String']>;
};


/** Mutation to change markups */
export type MutationUpdateQuoteStatusToSentToPunchoutArgs = {
  id: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationUpdateRequirementArgs = {
  body: Scalars['String'];
  id: Scalars['UUID'];
  title: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};


/** Mutation to change markups */
export type MutationUpdateRequirementStateArgs = {
  id: Scalars['UUID'];
  state: Scalars['String'];
};


/** Mutation to change markups */
export type MutationUpdateSaleOrderLineProductionCountryArgs = {
  productionCountry: ProductionCountry;
  salesOrderLineId: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationUpdateSchedulingDriArgs = {
  salesOrderId: InputMaybe<Scalars['Int']>;
  salesOrderLineId: InputMaybe<Scalars['Int']>;
  schedulingDriId: Scalars['Int'];
};


/** Mutation to change markups */
export type MutationUpdateSchedulingQueueItemNoEarlierThanArgs = {
  id: Scalars['Int'];
  scheduleNoEarlierThan: Scalars['Date'];
};


/** Mutation to change markups */
export type MutationUpdateSlackThreadForQuoteArgs = {
  channelId: Scalars['String'];
  id: Scalars['UUID'];
  threadId: Scalars['String'];
};


/** Mutation to change markups */
export type MutationUpdateTaxExemptFieldArgs = {
  id: Scalars['UUID'];
  isTaxExempt: Scalars['Boolean'];
  userId: InputMaybe<Scalars['Int']>;
};


/** Mutation to change markups */
export type MutationUpdateVisibleToCustomerArgs = {
  id: Scalars['UUID'];
  visibleToCustomer: Scalars['Boolean'];
};


/** Mutation to change markups */
export type MutationUploadQmrDfmReportPdfArgs = {
  attachment: AttachmentInput;
  qmrId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationUpsertBusinessAccountPunchoutFeatureArgs = {
  businessAccountId: Scalars['UUID'];
  disabledProcesses: InputMaybe<Scalars['String']>;
  isActive: InputMaybe<Scalars['Boolean']>;
};


/** Mutation to change markups */
export type MutationUpsertDfmAttachmentAnnotationsArgs = {
  attachmentId: Scalars['UUID'];
  newAnnotationsAdded: InputMaybe<Scalars['Boolean']>;
  qmrAttachmentAnnotationsInput: InputMaybe<DfmAttachmentAnnotationsInput>;
};


/** Mutation to change markups */
export type MutationUpsertHardwareInstallationSecondaryProcessWithCalculatedPricingArgs = {
  id: Scalars['UUID'];
  quotedProcessConfig: HardwareInstallationConfigInput;
};


/** Mutation to change markups */
export type MutationUpsertManuallyQuotedSecondaryProcessesConfigArgs = {
  id: Scalars['UUID'];
  quotedProcessConfig: ManuallyQuotedSecondaryProcessConfigInput;
};


/** Mutation to change markups */
export type MutationUpsertQmrAttachmentAnnotationsArgs = {
  attachmentId: Scalars['UUID'];
  qmrAttachmentAnnotationsInput: InputMaybe<QmrAttachmentAnnotationsInput>;
  qmrId: InputMaybe<Scalars['UUID']>;
  quoteId: Scalars['UUID'];
};


/** Mutation to change markups */
export type MutationUpsertQuoteModelRevisionTapOnHoleArgs = {
  holeId: Scalars['String'];
  quoteModelRevisionId: Scalars['UUID'];
  tapOptionId: Scalars['String'];
};


/** Mutation to change markups */
export type MutationUpsertQuoteModelRevisionTapOnHolesArgs = {
  holesList: Array<Scalars['String']>;
  quoteModelRevisionId: Scalars['UUID'];
  tapOptionId: Scalars['String'];
};


/** Mutation to change markups */
export type MutationUpsertQuoteSalesRepArgs = {
  quoteId: Scalars['UUID'];
  salesRepEmail: InputMaybe<Scalars['String']>;
};


/** Mutation to change markups */
export type MutationUpsertTapAnnotationOnHoleArgs = {
  estimateItemId: Scalars['UUID'];
  holeId: Scalars['String'];
  tapOptionId: Scalars['String'];
};


/** Mutation to change markups */
export type MutationUserArgs = {
  id: Scalars['Int'];
};

/** The paired cad and pdf file name. It's possible that there was no matching pdf for the cad, or visa versa */
export type NameMatchPairInfo = {
  __typename: 'NameMatchPairInfo';
  cadFileName: Maybe<Scalars['String']>;
  pdfFileName: Maybe<Scalars['String']>;
};

/** Input for DfmInspection nesting parameters */
export type NestingParametersInput = {
  domesticNestingMaterialStock: InputMaybe<Scalars['JSON']>;
  minimumNumberOfNestedParts: InputMaybe<Scalars['Int']>;
  nestingMaterialStocks: InputMaybe<DomesticAndOverseasMaterialStockDataInput>;
  overseasNestingMaterialStock: InputMaybe<Scalars['JSON']>;
};

/** Part & nonconfigurable config information for an order's parts */
export type NonconfigurableOrderLineConfigInfo = {
  __typename: 'NonconfigurableOrderLineConfigInfo';
  fileName: Scalars['String'];
  materials: Array<Material>;
  postProcesses: Array<InvalidPostProcessConfigInfo>;
  processes: Array<Process>;
  secondaryProcesses: Array<InvalidSecondaryProcessConfigInfo>;
};

/** Note record */
export type Note = {
  __typename: 'Note';
  attachments: Maybe<Array<NoteAttachment>>;
  createdAt: Scalars['Date'];
  createdBy: BasicUser;
  description: Scalars['String'];
  id: Scalars['Int'];
  objectId: Scalars['Int'];
  objectType: Scalars['String'];
};

/** Associates an attachment to note attachment */
export type NoteAttachment = {
  __typename: 'NoteAttachment';
  attachment: Maybe<Asset>;
  createdAt: Scalars['Date'];
  createdBy: Maybe<BasicUser>;
  deletedAt: Maybe<Scalars['Date']>;
  deletedBy: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  noteId: Scalars['Int'];
  updatedAt: Scalars['Date'];
};

/** Enum for note object types */
export enum NoteObjectType {
  job = 'job'
}

/** Finishing Notes With Bounding Box */
export type NoteWithBoundingBox = {
  __typename: 'NoteWithBoundingBox';
  boundingBox: Maybe<Scalars['Int']>;
  text: Maybe<Scalars['String']>;
};

/** Corrective action request turnaround info return type */
export type OldCarsTurnaroundInfoMigrationReturnType = {
  __typename: 'OldCarsTurnaroundInfoMigrationReturnType';
  failedUpdates: Array<Scalars['UUID']>;
  failureCount: Scalars['Int'];
  successCount: Scalars['Int'];
  successfulUpdates: Array<Scalars['UUID']>;
};

/** One side Tolerance Data */
export type OneSidedToleranceData = {
  __typename: 'OneSidedToleranceData';
  boundingBox: Maybe<Scalars['Int']>;
  highBound: Maybe<ToleranceBounds>;
  lowBound: Maybe<ToleranceBounds>;
  nominalCoordinate: Maybe<SidedToleranceNominalCoordinate>;
  nominalHoleInfo: Maybe<Scalars['String']>;
  nominalMm: Maybe<Scalars['Float']>;
  nominalRaw: Maybe<Scalars['String']>;
  rangeMm: Maybe<Scalars['Float']>;
  sign: Maybe<Scalars['String']>;
  signedValue: Maybe<Scalars['Float']>;
  unit: Maybe<Scalars['String']>;
  valueMm: Maybe<Scalars['Float']>;
  valueNumberRaw: Maybe<Scalars['Float']>;
  valueRaw: Maybe<Scalars['String']>;
};

/** DB fields associated with an Order */
export type Order = {
  __typename: 'Order';
  allowDelivery: Scalars['Boolean'];
  allowFulfillment: Scalars['Boolean'];
  cartId: Maybe<Scalars['Int']>;
  chargeId: Maybe<Scalars['String']>;
  chargedTaxAmount: Scalars['Int'];
  chargedTaxBasisAmount: Scalars['Int'];
  chargedTotalPrice: Maybe<Scalars['Int']>;
  completed: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['Date'];
  creditAmount: Maybe<Scalars['Int']>;
  deliveryDate: Maybe<Scalars['Date']>;
  discountAmount: Scalars['Int'];
  discountCode: Maybe<Scalars['String']>;
  discountSource: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  instantQuoteInvoiceUri: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  paidAmount: Scalars['Int'];
  priceVersion: Maybe<Scalars['Int']>;
  purchaseOrderId: Maybe<Scalars['Int']>;
  purchaseOrderNumber: Maybe<Scalars['String']>;
  resaleOrder: Maybe<Scalars['Boolean']>;
  salesForceOpportunityId: Maybe<Scalars['String']>;
  salesTaxState: Maybe<Scalars['String']>;
  shipDate: Maybe<Scalars['Date']>;
  shippingAddressId: Maybe<Scalars['Int']>;
  shippingAmount: Maybe<Scalars['Int']>;
  shippingMethod: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  subTotalAmount: Maybe<Scalars['Int']>;
  taxAmount: Maybe<Scalars['Int']>;
  /** Team details if order is part of a Team */
  team: Maybe<Team>;
  totalAmount: Scalars['Int'];
  trackingNumber: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
  useShipAddressAsBilling: Maybe<Scalars['Boolean']>;
  user: Maybe<User>;
  userId: Maybe<Scalars['Int']>;
  zip: Maybe<Scalars['String']>;
};

/** Attributes needed to create an order from a quote */
export type OrderInput = {
  carrierAccountId: InputMaybe<Scalars['UUID']>;
  contactInfo: InputMaybe<ContactDetailsInput>;
  discounts: Array<CouponInput>;
  forResale: InputMaybe<Scalars['Boolean']>;
  paymentMethods: Array<PaymentMethodInput>;
  quoteId: Scalars['UUID'];
  shippingMethods: Array<ShippingMethodInput>;
};

/** Orders material with attributes */
export type OrderMaterialDetails = {
  __typename: 'OrderMaterialDetails';
  additionalSpecifications: Maybe<MaterialAdditionalSpecifications>;
  color: Maybe<Scalars['String']>;
  colorCode: Maybe<Scalars['String']>;
  dfmNotes: Maybe<MaterialDfmNotes>;
  id: Scalars['String'];
  materialGrade: Maybe<Scalars['String']>;
  name: Scalars['String'];
  publicName: Maybe<Scalars['String']>;
  shore: Maybe<Scalars['String']>;
};

/** Orders processes with attributes */
export type OrderProcessDetails = {
  __typename: 'OrderProcessDetails';
  additionalSpecifications: Maybe<ProcessAdditionalSpecifications>;
  color: Maybe<Scalars['String']>;
  dfmNotes: Maybe<ProcessDfmNotes>;
  finish: Maybe<Scalars['String']>;
  id: Scalars['String'];
  platformProcessId: Maybe<Scalars['String']>;
  platformProcessTypeId: Maybe<Scalars['String']>;
  processName: Scalars['String'];
  processNotes: Maybe<Scalars['String']>;
  surfaceFinishCode: Maybe<Scalars['String']>;
  texture: Maybe<Scalars['String']>;
  thickness: Maybe<Scalars['String']>;
  toolLife: Maybe<Scalars['String']>;
};

/** Generic Search Type */
export type OrderSearch = {
  __typename: 'OrderSearch';
  items: Array<Maybe<SalesOrderView>>;
  page: Maybe<Page>;
  totalCount: Scalars['Int'];
};

/** THe partId, modelFileName and revision UUID of a part */
export type OrderSearchPart = {
  __typename: 'OrderSearchPart';
  modelFileName: Maybe<Scalars['String']>;
  partId: Maybe<Scalars['String']>;
  partRevisionId: Maybe<Scalars['String']>;
  thumbnailUri: Maybe<Scalars['String']>;
};

/** Order Team memberships map individual orders to a team in a business account */
export type OrderTeamMembership = {
  __typename: 'OrderTeamMembership';
  createdAt: Scalars['Date'];
  createdBy: BasicUser;
  deletedAt: Maybe<Scalars['Date']>;
  deletedBy: Maybe<BasicUser>;
  erpSaleOrderId: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  platformOrderId: Maybe<Scalars['Int']>;
  teamId: Scalars['Int'];
  updatedAt: Scalars['Date'];
  updatedBy: BasicUser;
};

/** Enum for sales order type */
export enum OrderType {
  high_touch = 'high_touch',
  self_serve = 'self_serve'
}

/** Input for part pricing and lead time */
export type OverridePartPricingLeadtimeInput = {
  manualOverrideMpUnitPayout: Scalars['Int'];
  manualOverrideUnitAmount: Scalars['Int'];
  manualOverrideUnitProductionDays: Scalars['Int'];
};

/** Point to point measurement point */
export type P2PPoint = {
  __typename: 'P2PPoint';
  index: Scalars['Int'];
  type: P2PPointType;
};

/** Input for point to point measurement point */
export type P2PPointInput = {
  index: Scalars['Int'];
  type: P2PPointType;
};

/** Used to determine what kind of point we have */
export enum P2PPointType {
  custom = 'custom',
  geometry = 'geometry'
}

/** The relevant UUIDs, filename, user email, etc. for admins to debug/investigate a part */
export type Page = {
  __typename: 'Page';
  from: Maybe<Scalars['Int']>;
  pageNumber: Maybe<Scalars['Int']>;
  size: Maybe<Scalars['Int']>;
  total: Maybe<Scalars['Int']>;
  totalPages: Maybe<Scalars['Int']>;
};

/** Enum for page order */
export enum PageOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

/** Part type */
export type Part = {
  __typename: 'Part';
  depthX: Maybe<Scalars['Float']>;
  depthY: Maybe<Scalars['Float']>;
  depthZ: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  quoteModelRevisionUuid: Maybe<Scalars['String']>;
  revisionUuid: Maybe<Scalars['String']>;
  thumbnailUri: Maybe<Scalars['String']>;
};

/** for qmr dfm reports */
export type PartDfmReport = {
  __typename: 'PartDfmReport';
  asset: Maybe<Asset>;
  isPublished: Scalars['Boolean'];
  quoteAttachmentRevisionId: Scalars['UUID'];
  source: Maybe<Scalars['String']>;
  uploader: Maybe<User>;
  uploaderEmail: Maybe<Scalars['String']>;
};

/** Estimated part price */
export type PartEstimatedPrices = {
  __typename: 'PartEstimatedPrices';
  partPrice: Maybe<EstimatedPrice>;
  qmrId: Scalars['String'];
};

/** Input for part inspection data */
export type PartInspectionDataInput = {
  inspectionData: InjectionMoldingParametersInput;
  qmrId: Scalars['String'];
};

/** Part Material configuration type */
export type PartMaterialConfiguration = {
  __typename: 'PartMaterialConfiguration';
  additionalSpecifications: Maybe<MaterialAdditionalSpecifications>;
  color: Maybe<Scalars['String']>;
  colorCode: Maybe<Scalars['String']>;
  dfmNotes: Maybe<MaterialDfmNotes>;
  grade: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  shoreValue: Maybe<Scalars['String']>;
};

/** Part Process Attributes type */
export type PartProcessAttributes = {
  __typename: 'PartProcessAttributes';
  color: Maybe<Scalars['String']>;
  /** Associated ERP process id */
  id: Scalars['Int'];
  name: Scalars['String'];
  texture: Maybe<Scalars['String']>;
  thickness: Maybe<Scalars['String']>;
};

/** Provides details of the part on which vendor has to work. */
export type PartProduct = {
  __typename: 'PartProduct';
  /** The color of the material used to manufacture this work order item. */
  colorName: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  /**
   * Work order items related to this part
   * Part file name for this part
   */
  partFileName: Maybe<Scalars['String']>;
  /** Digital model for this part. */
  partProductRevision: Maybe<PartProductRevision>;
};

/** Fictiv digital model for part which has to be created */
export type PartProductRevision = {
  __typename: 'PartProductRevision';
  /** Revision data associated with this digital modal which can be shared with Fictiv partners. */
  basicRevision: Maybe<BasicRevision>;
  /** The pre-signed URI to download the geometry associated with this digital model */
  downloadUri: Maybe<Scalars['String']>;
  /** URL to access the part's drawing. */
  drawingUri: Maybe<Scalars['String']>;
  /** The estimate item associated with this digital model. */
  estimateItem: Maybe<EstimateItem>;
  /** Unique identifier for this digital model. */
  id: Scalars['Int'];
};

/** The relevant UUIDs, filename, user email, etc. for admins to debug/investigate a part */
export type PartSearchInfo = {
  __typename: 'PartSearchInfo';
  eiUuid: Maybe<Scalars['UUID']>;
  email: Maybe<Scalars['String']>;
  hasAttachedPdf: Maybe<Scalars['Boolean']>;
  matchedText: Maybe<Scalars['String']>;
  modelFileName: Maybe<Scalars['String']>;
  orderName: Maybe<Scalars['String']>;
  ownerId: Maybe<Scalars['Int']>;
  partCreatedAt: Maybe<Scalars['String']>;
  partId: Maybe<Scalars['Int']>;
  partRevisionUuid: Maybe<Scalars['UUID']>;
  qmrId: Maybe<Scalars['UUID']>;
  quoteId: Maybe<Scalars['UUID']>;
  quoteItemDeletedAt: Maybe<Scalars['String']>;
  quoteItemId: Maybe<Scalars['UUID']>;
  quoteName: Maybe<Scalars['String']>;
  quoteStatus: Maybe<Scalars['String']>;
  userId: Maybe<Scalars['Int']>;
};

/** Input for admin quoted advanced inspection - setup based parameters */
export type PartSetupsInspectionPricingParamsInput = {
  numSetups: Scalars['Int'];
  numSpecialFixtures: Scalars['Int'];
};

/** Wrapper for Asset Bundle Attachment */
export type PartialAssetBundleResults = {
  __typename: 'PartialAssetBundleResults';
  items: Maybe<Array<AssetBundleAttachment>>;
  totalCount: Scalars['Int'];
};

/** Pagination wrapper for Asset */
export type PartialAssetResults = {
  __typename: 'PartialAssetResults';
  cursor: Maybe<Cursor>;
  items: Array<Asset>;
  totalCount: Scalars['Int'];
};

/** Container for paginated business account contacts results */
export type PartialBusinessAccountContactsResults = {
  __typename: 'PartialBusinessAccountContactsResults';
  items: Array<BusinessAccountContact>;
  totalCount: Scalars['Int'];
};

/** partial business account members query results */
export type PartialBusinessAccountMembersResults = {
  __typename: 'PartialBusinessAccountMembersResults';
  items: Array<Maybe<BusinessAccountMembership>>;
  totalCount: Scalars['Int'];
};

/** Pagination wrapper for BusinessAccountMembers */
export type PartialBusinessAccountMembershipResults = {
  __typename: 'PartialBusinessAccountMembershipResults';
  cursor: Maybe<Cursor>;
  items: Array<BusinessAccountMembership>;
  totalCount: Scalars['Int'];
};

/** Pagination container for business account orders */
export type PartialBusinessAccountOrdersResult = {
  __typename: 'PartialBusinessAccountOrdersResult';
  items: Array<BusinessAccountOrder>;
  totalCount: Scalars['Int'];
};

/** Container for paginated business account pending members results */
export type PartialBusinessAccountPendingMembersResults = {
  __typename: 'PartialBusinessAccountPendingMembersResults';
  items: Array<BusinessAccountPendingMember>;
  totalCount: Scalars['Int'];
};

/** Business account plan list */
export type PartialBusinessAccountPlanResults = {
  __typename: 'PartialBusinessAccountPlanResults';
  items: Maybe<Array<BusinessAccountPlan>>;
  totalCount: Scalars['Int'];
};

/** Pagination container for business account quotes */
export type PartialBusinessAccountQuotesResult = {
  __typename: 'PartialBusinessAccountQuotesResult';
  items: Array<BusinessAccountQuote>;
  totalCount: Scalars['Int'];
};

/** List of subscriptions in history on the business account */
export type PartialBusinessAccountSubscriptionHistoryResults = {
  __typename: 'PartialBusinessAccountSubscriptionHistoryResults';
  count: Scalars['Int'];
  subscriptions: Array<BusinessAccountSubscription>;
};

/** PartialCommentsResults */
export type PartialCommentsResults = {
  __typename: 'PartialCommentsResults';
  items: Array<Comment>;
  totalCount: Scalars['Int'];
};

/** Result of a paginated list of exceptions */
export type PartialExceptionFailureResults = {
  __typename: 'PartialExceptionFailureResults';
  /** List of exceptions found */
  items: Maybe<Array<ExceptionFailure>>;
  /** Information for the skipping previous records */
  offset: Maybe<Scalars['Int']>;
  /** Count of all results */
  totalCount: Scalars['Int'];
};

/** Result of a paginated list of exceptions */
export type PartialExceptionResults = {
  __typename: 'PartialExceptionResults';
  /** List of exceptions found */
  items: Array<Exception>;
  /** Information for the skipping previous records */
  offset: Maybe<Scalars['Int']>;
  /** Count of all results */
  totalCount: Scalars['Int'];
};

/** Result of a paginated list of invites. */
export type PartialInviteResults = {
  __typename: 'PartialInviteResults';
  /** Information for the next cursor page */
  cursor: Maybe<Cursor>;
  /** List of models found */
  items: Array<Invite>;
  /** Count of all results */
  totalCount: Scalars['Int'];
};

/**
 * Used for the hardware installation process regional input. These are optional since the pricing and lead time
 * calculator can handle these on its own. If these are passed in, they override the calculator.
 */
export type PartialManuallyQuotedSecondaryProcessRegionalInput = {
  leadTime: InputMaybe<Scalars['Int']>;
  leadTimePartsLimit: InputMaybe<Scalars['Int']>;
  mpPayoutInCents: InputMaybe<Scalars['Float']>;
  mpPayoutPartsLimit: InputMaybe<Scalars['Int']>;
  percentMarkup: InputMaybe<Scalars['Float']>;
};

/** Result of a paginated list of members. */
export type PartialMembershipResults = {
  __typename: 'PartialMembershipResults';
  /** Information for the next cursor page */
  cursor: Maybe<Cursor>;
  /** List of models found */
  items: Array<Membership>;
  /** Count of all results */
  totalCount: Scalars['Int'];
};

/** Results for partial ProductAttachmentRevisions */
export type PartialProductAttachmentRevisionResults = {
  __typename: 'PartialProductAttachmentRevisionResults';
  /** Information for the next cursor page */
  cursor: Maybe<Scalars['ENCODED_CURSOR']>;
  /** List of ProductAttachmentRevision items found */
  items: Array<ProductAttachmentRevision>;
  /** Count of all results */
  totalCount: Scalars['Int'];
};

/** Results for partial ProductModelRevisions */
export type PartialProductModelRevisionResults = {
  __typename: 'PartialProductModelRevisionResults';
  /** Information for the next cursor page */
  cursor: Maybe<Scalars['ENCODED_CURSOR']>;
  /** List of ProductModelRevision items found */
  items: Array<ProductModelRevision>;
  /** Count of all results */
  totalCount: Scalars['Int'];
};

/** Results for partial products */
export type PartialProductResults = {
  __typename: 'PartialProductResults';
  /** Information for the next cursor page */
  cursor: Maybe<Scalars['ENCODED_CURSOR']>;
  /** List of product items found */
  items: Array<Product>;
  /** Count of all results */
  totalCount: Scalars['Int'];
};

/** Result of a paginated list of project activity. */
export type PartialProjectActivityResults = {
  __typename: 'PartialProjectActivityResults';
  cursor: Maybe<Scalars['ENCODED_CURSOR']>;
  items: Array<ProjectActivity>;
  totalCount: Scalars['Int'];
};

/** Pagination wrapper for ProjectMemberships */
export type PartialProjectMembershipResults = {
  __typename: 'PartialProjectMembershipResults';
  cursor: Maybe<Cursor>;
  items: Array<ProjectMembership>;
  totalCount: Scalars['Int'];
};

/** Results for partial projects */
export type PartialProjectResults = {
  __typename: 'PartialProjectResults';
  cursor: Maybe<Cursor>;
  items: Array<Project>;
  totalCount: Scalars['Int'];
};

/** Pagination wrapper for QuoteAttachment */
export type PartialQuoteAttachmentResults = {
  __typename: 'PartialQuoteAttachmentResults';
  cursor: Maybe<Scalars['ENCODED_CURSOR']>;
  items: Array<QuoteAttachment>;
  totalCount: Scalars['Int'];
};

/** Results for partial QuoteAttachmentRevisions */
export type PartialQuoteAttachmentRevisionResults = {
  __typename: 'PartialQuoteAttachmentRevisionResults';
  /** Information for the next cursor page */
  cursor: Maybe<Scalars['ENCODED_CURSOR']>;
  /** List of QuoteAttachmentRevision items found */
  items: Array<QuoteAttachmentRevision>;
  /** Count of all results */
  totalCount: Scalars['Int'];
};

/** Pagination wrapper for QuoteModel */
export type PartialQuoteItemResults = {
  __typename: 'PartialQuoteItemResults';
  cursor: Maybe<Cursor>;
  items: Array<QuoteItem>;
  totalCount: Scalars['Int'];
};

/** Pagination wrapper for QuoteModel */
export type PartialQuoteModelResults = {
  __typename: 'PartialQuoteModelResults';
  cursor: Maybe<Cursor>;
  items: Array<QuoteModel>;
  totalCount: Scalars['Int'];
};

/** Result of a paginated list of QuoteModelRevisions. */
export type PartialQuoteModelRevisionResults = {
  __typename: 'PartialQuoteModelRevisionResults';
  /** Information for the next cursor page */
  cursor: Maybe<Cursor>;
  /** List of QuoteModelRevisions */
  items: Array<QuoteModelRevision>;
  /** Count of all results */
  totalCount: Scalars['Int'];
};

/** Pagination wrapper for Quote */
export type PartialQuoteResults = {
  __typename: 'PartialQuoteResults';
  cursor: Maybe<Cursor>;
  items: Array<Quote>;
  totalCount: Scalars['Int'];
};

/** Pagination wrapper for QuoteView */
export type PartialQuoteViewResults = {
  __typename: 'PartialQuoteViewResults';
  cursor: Maybe<Cursor>;
  items: Array<QuoteView>;
  totalCount: Scalars['Int'];
};

/** Results for partial requirements */
export type PartialRequirementResults = {
  __typename: 'PartialRequirementResults';
  /** Information for the next cursor page */
  cursor: Maybe<Scalars['ENCODED_CURSOR']>;
  /** List of requirements found */
  items: Array<Requirement>;
  /** Count of all results */
  totalCount: Scalars['Int'];
};

/** Result of a paginated list of revisions. */
export type PartialRevisionResults = {
  __typename: 'PartialRevisionResults';
  /** Information for the next cursor page */
  cursor: Maybe<Cursor>;
  /** List of folder items found */
  items: Array<Revision>;
  /** Count of all results */
  totalCount: Scalars['Int'];
};

/** Result of a paginated list of sale order lines. */
export type PartialSalesOrderLineResults = {
  __typename: 'PartialSalesOrderLineResults';
  /** Information for the next cursor page */
  cursor: Maybe<Cursor>;
  /** List of sale orders */
  items: Array<SalesOrderLine>;
  parts: Maybe<Array<SalesOrderLine>>;
  primaryProductLines: Maybe<Array<SalesOrderLine>>;
  productCount: Maybe<Scalars['Int']>;
  /**
   * Ideally in the future we would use an enum of the possible states but this is not currently supported in our use of typedefs
   * These statuses can be ('pending_production','in_production','shipped', 'canceled').
   */
  statusNotIn: Maybe<Array<Scalars['String']>>;
  /** Count of all results */
  totalCount: Scalars['Int'];
};

/** Result of a paginated list of sale orders. */
export type PartialSalesOrderResults = {
  __typename: 'PartialSalesOrderResults';
  /** Information for the next cursor page */
  cursor: Maybe<Cursor>;
  /** List of sale orders */
  items: Array<SalesOrder>;
  /** Count of all results */
  totalCount: Scalars['Int'];
};

/** Pagination wrapper for SalesOrderView */
export type PartialSalesOrderViewResults = {
  __typename: 'PartialSalesOrderViewResults';
  cursor: Maybe<Cursor>;
  items: Array<SalesOrderView>;
  totalCount: Scalars['Int'];
};

/** Pagination wrapper for adminSearchSalesforceAccounts */
export type PartialSalesforceAccountSearchResults = {
  __typename: 'PartialSalesforceAccountSearchResults';
  items: Array<SalesforceAccount>;
  totalCount: Scalars['Int'];
};

/** Result of a paginated list of shipments. */
export type PartialShipmentLineResults = {
  __typename: 'PartialShipmentLineResults';
  /** Information for the next cursor page */
  cursor: Maybe<Cursor>;
  /** List of sale orders */
  items: Maybe<Array<ShipmentLine>>;
  /** Count of all results */
  totalCount: Scalars['Int'];
};

/** Result of a paginated list of shipments. */
export type PartialShipmentResults = {
  __typename: 'PartialShipmentResults';
  /** Information for the next cursor page */
  cursor: Maybe<Cursor>;
  /** List of sale orders */
  items: Array<Shipment>;
  /** Count of all results */
  totalCount: Scalars['Int'];
};

/** Partial team-quotes query results */
export type PartialTeamQuotesResult = {
  __typename: 'PartialTeamQuotesResult';
  items: Array<Maybe<Quote>>;
  totalCount: Scalars['Int'];
};

/** partial teams query results */
export type PartialTeamsResult = {
  __typename: 'PartialTeamsResult';
  items: Array<Team>;
  totalCount: Scalars['Int'];
};

/** Partial teams result */
export type PartialTeamsResults = {
  __typename: 'PartialTeamsResults';
  items: Array<Team>;
  totalCount: Scalars['Int'];
};

/** partial user-team members query results */
export type PartialUserTeamMembersResult = {
  __typename: 'PartialUserTeamMembersResult';
  items: Array<UserTeamMember>;
  totalCount: Scalars['Int'];
};

/** Result of a paginated list of work. */
export type PartialWorkspaceMembershipResults = {
  __typename: 'PartialWorkspaceMembershipResults';
  /** Information for the next cursor page */
  cursor: Maybe<Cursor>;
  /** Count of all results */
  totalCount: Scalars['Int'];
};

/** Result of a paginated list of workspaces. */
export type PartialWorkspaceResults = {
  __typename: 'PartialWorkspaceResults';
  /** Information for the next cursor page */
  cursor: Maybe<Cursor>;
  /** Count of all results */
  totalCount: Scalars['Int'];
};

/** A material to manufacture in. */
export type PartnerMaterial = {
  __typename: 'PartnerMaterial';
  name: Scalars['String'];
};

/** getShopAvailabilityByPartnerId Query input */
export type PartnerShopAvailabilityInput = {
  endDate: Scalars['Date'];
  partnerId: Scalars['Int'];
  processId: Scalars['Int'];
  startDate: Scalars['Date'];
};

/** Represents a process availability for Manufacturing Partner */
export type PartnerShopProcessAvailability = {
  __typename: 'PartnerShopProcessAvailability';
  availability: Maybe<Array<ShopProcessAvailability>>;
  partnerId: Scalars['Int'];
  processId: Scalars['Int'];
};

/** Represents payment details for the sale order. */
export type PaymentDetails = {
  __typename: 'PaymentDetails';
  /** Billing address is a misnomer. This field is populated with shipping address details and is not related to payment. */
  billingAddress: Maybe<PostalAddress>;
  creditCardLast4: Maybe<Scalars['String']>;
  id: Scalars['String'];
  /** User who made this payment */
  paidBy: Maybe<BasicUser>;
  /** Display name information for the purchasing entity */
  paidByDisplayName: Maybe<Scalars['String']>;
  /** As per the Tim instructions for the reset multi order project */
  paymentType: Maybe<Scalars['String']>;
  /** User provided purchase order number */
  purchaseOrderNumber: Maybe<Scalars['String']>;
  purchaseOrderUri: Maybe<Scalars['String']>;
};

/**
 * Either a purchase order or a credit card identifier to be applied to an order.
 * Providing both is invalid and will result in an error.
 */
export type PaymentMethodInput = {
  creditCardToken: InputMaybe<Scalars['String']>;
  purchaseOrderId: InputMaybe<Scalars['Int']>;
};

/** various Payout Adjustment Reason categories (master data) */
export type PayoutAdjustmentReasonCategory = {
  __typename: 'PayoutAdjustmentReasonCategory';
  active: Scalars['Boolean'];
  id: Scalars['Int'];
  name: Scalars['String'];
  subCategories: Maybe<Array<PayoutAdjustmentReasonSubCategory>>;
};

/** variated sub-categories of specific Payout Adjustment Reasons */
export type PayoutAdjustmentReasonSubCategory = {
  __typename: 'PayoutAdjustmentReasonSubCategory';
  active: Scalars['Boolean'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** Input provided to filter work order by payout */
export type PayoutFilterInput = {
  from: Scalars['Int'];
  to: Scalars['Int'];
};

/** Detection Bounding Box info */
export type PdfDetectionBoundingBox = {
  __typename: 'PdfDetectionBoundingBox';
  pageNumber: Maybe<Scalars['Float']>;
  xmax: Maybe<Scalars['Float']>;
  xmin: Maybe<Scalars['Float']>;
  ymax: Maybe<Scalars['Float']>;
  ymin: Maybe<Scalars['Float']>;
};

/** Advanced inspection pending price object - optional in case things go wrong in calculation */
export type PendingAdvancedInspectionPrice = {
  __typename: 'PendingAdvancedInspectionPrice';
  builderPayoutInCents: Maybe<Scalars['Int']>;
  leadTimeInDays: Maybe<Scalars['Int']>;
  mpPayoutInCents: Maybe<Scalars['Int']>;
};

/** Hypothetical prices for advanced inspection report */
export type PendingAdvancedInspectionPrices = {
  __typename: 'PendingAdvancedInspectionPrices';
  domestic: PendingAdvancedInspectionPrice;
  overseas: PendingAdvancedInspectionPrice;
};

/** Filters for identifying a list of pending business account invites */
export type PendingBusinessAccountInvitesFiltersInput = {
  businessAccountId: Scalars['UUID'];
  searchText: InputMaybe<Scalars['String']>;
  status: InputMaybe<BusinessAccountInviteStatus>;
};

/** Used for returning potential dynamic lead times to admin quoting page given pending pricing parameters */
export type PendingLeadTimeData = {
  __typename: 'PendingLeadTimeData';
  economy: Maybe<Scalars['Int']>;
  flex: Maybe<Scalars['Int']>;
  overseas: Maybe<Scalars['Int']>;
  rush: Maybe<Scalars['Int']>;
  saver: Maybe<Scalars['Int']>;
  standard: Maybe<Scalars['Int']>;
};

/** Used for returning the markup values to the admin panel */
export type PendingMarkupData = {
  __typename: 'PendingMarkupData';
  economy: Maybe<Scalars['Float']>;
  flex: Maybe<Scalars['Float']>;
  overseas: Maybe<Scalars['Float']>;
  rush: Maybe<Scalars['Float']>;
  saver: Maybe<Scalars['Float']>;
  standard: Maybe<Scalars['Float']>;
};

/** Input for markup overrides in admin quoting page */
export type PendingMarkupDataInput = {
  economy: InputMaybe<Scalars['Float']>;
  flex: InputMaybe<Scalars['Float']>;
  overseas: InputMaybe<Scalars['Float']>;
  rush: InputMaybe<Scalars['Float']>;
  saver: InputMaybe<Scalars['Float']>;
  standard: InputMaybe<Scalars['Float']>;
};

/** Admin only model for getting a breakdown of pending price */
export type PendingPriceInformation = {
  __typename: 'PendingPriceInformation';
  builderPrice: Maybe<Price>;
  granularPricingData: Maybe<GranularPricingData>;
  leadTimeData: Maybe<PendingLeadTimeData>;
  manufacturingPartnerPrice: Maybe<Price>;
  markupData: Maybe<PendingMarkupData>;
};

/** Discount code that is based on percentage of subtotal */
export type PercentageBasedDiscount = {
  __typename: 'PercentageBasedDiscount';
  code: Maybe<Scalars['String']>;
  expirationDate: Maybe<Scalars['Date']>;
  firstOrderOnly: Maybe<Scalars['Boolean']>;
  impermissibleEmailDomains: Maybe<Array<Scalars['String']>>;
  maxDollarAmount: Maybe<Scalars['Float']>;
  numUsagesAllowed: Maybe<Scalars['Int']>;
  percent: Scalars['Float'];
  permissibleEmailDomain: Maybe<Scalars['String']>;
  userSignupCutoffDate: Maybe<Scalars['Date']>;
};

/** A material to manufacture in. */
export type PlatformMaterial = {
  __typename: 'PlatformMaterial';
  detailsUrl: Scalars['String'];
  grade: Maybe<Scalars['String']>;
  id: Scalars['String'];
  materialCategory: Scalars['String'];
  minWallThickness: Scalars['String'];
  name: Scalars['String'];
  processId: Scalars['String'];
  resolution: Scalars['String'];
  resolutionCategory: Scalars['String'];
  shortDescription: Scalars['String'];
  vendorMaterialName: Maybe<Scalars['String']>;
  volume: Scalars['String'];
};

/** type for platform Order data for a quote */
export type PlatformOrder = {
  __typename: 'PlatformOrder';
  id: Maybe<Scalars['Int']>;
  name: Maybe<Scalars['String']>;
  purchasedDate: Maybe<Scalars['Date']>;
  purchaserEmail: Maybe<Scalars['String']>;
  purchaserUserId: Maybe<Scalars['Int']>;
};

/**
 * Config for point to point measurement DFM
 * We need the points to draw the line, and any custom points that were added to the model
 */
export type PointToPointConfig = {
  __typename: 'PointToPointConfig';
  customPoints: Array<Scalars['Float3Array']>;
  selectedPoints: Array<P2PPoint>;
};

/** Input config for point to point measurement DFM */
export type PointToPointConfigInput = {
  customPoints: Array<Scalars['Float3Array']>;
  selectedPoints: Array<P2PPointInput>;
};

/** A manufacturing post process. */
export type PostProcess = {
  __typename: 'PostProcess';
  colors: Maybe<Array<Maybe<Color>>>;
  id: Scalars['String'];
  name: Scalars['String'];
  thicknesses: Maybe<Array<Maybe<Thickness>>>;
  typeName: Maybe<Scalars['String']>;
};

/** Represents the address associated to the customer. */
export type PostalAddress = {
  __typename: 'PostalAddress';
  city: Maybe<Scalars['String']>;
  contactType: Maybe<Scalars['String']>;
  country: Scalars['String'];
  id: Scalars['String'];
  name: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  state: Maybe<Scalars['String']>;
  street: Scalars['String'];
  street2: Maybe<Scalars['String']>;
};

/** Enum for allowed sections in preferences object for QuoteModelRevisionFiltersInput */
export enum PreferenceType {
  sectionPreferences = 'sectionPreferences',
  tableViewPreferences = 'tableViewPreferences'
}

/** Previous jobs types */
export type PreviousJobsType = {
  __typename: 'PreviousJobsType';
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** Either an EstimatedPrice or an ExactPrice */
export type Price = EstimatedPrice | ExactPrice;

/** Exact cost/price information */
export type PriceInformation = {
  __typename: 'PriceInformation';
  builderPrice: Maybe<ExactPrice>;
  manufacturingPartnerPrice: Maybe<ExactPrice>;
};

/** Exact cost/price information with corresponding QmrId */
export type PriceInformationWithQmrId = {
  __typename: 'PriceInformationWithQmrId';
  builderPrice: Maybe<ExactPrice>;
  manufacturingPartnerPrice: Maybe<ExactPrice>;
  quoteModelRevisionId: Scalars['UUID'];
};

/** Secondary process pricing and lead time field union */
export type PricingAndLeadTimeFields = HardwareInstallationManualQuoteCalcFields | SecondaryProcessManualQuoteCalcFields;

/** Constant overrides for various pricing algorithms. */
export type PricingConstantOverridesInput = {
  cnc: InputMaybe<CncPricingConstantOverridesInput>;
};

/** Attributes needed to get price info on quote */
export type PricingInput = {
  carrierAccountId: InputMaybe<Scalars['UUID']>;
  discounts: Array<CouponInput>;
  forResale: InputMaybe<Scalars['Boolean']>;
  quoteId: Scalars['UUID'];
  shippingMethods: Array<ShippingMethodInput>;
};

/** Input for calculating price */
export type PricingQuoteFieldsInput = {
  markupPercentage: Scalars['Float'];
  mpPayoutInCents: Scalars['Int'];
  mpPayoutPartsLimit: Scalars['Int'];
};

/** Input for primary mfg production process (cnc, im, 3dp, i.e. processes that manufacture the model) */
export type PrimaryProcessConfigInput = {
  colorCode: InputMaybe<Scalars['String']>;
  colorId: InputMaybe<Scalars['String']>;
  fdmInfillPercentageCategory: InputMaybe<Scalars['String']>;
  materialGrade: InputMaybe<Scalars['String']>;
  materialId: InputMaybe<Scalars['String']>;
  priorityId: InputMaybe<Scalars['String']>;
  processId: InputMaybe<Scalars['String']>;
  quantity: InputMaybe<Scalars['Int']>;
  shoreId: InputMaybe<Scalars['String']>;
  textureCode: InputMaybe<Scalars['String']>;
  textureId: InputMaybe<Scalars['String']>;
};

/** A manufacturing priority that affects shipping time. */
export type Priority = {
  __typename: 'Priority';
  cncPriceMultiplier: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  priorityId: Scalars['String'];
  productionDays: Scalars['Int'];
  shippedByDate: Scalars['Date'];
  tdpPriceExponent: Maybe<Scalars['Float']>;
  validUntilDate: Scalars['Date'];
};

/** A manufacturing process type */
export type Process = {
  __typename: 'Process';
  id: Scalars['String'];
  name: Scalars['String'];
  platformProcessTypeId: Scalars['String'];
};

/** distinct categories of additional specifications available on each line */
export type ProcessAdditionalSpecifications = {
  __typename: 'ProcessAdditionalSpecifications';
  color: Maybe<Scalars['String']>;
  texture: Maybe<Scalars['String']>;
  thickness: Maybe<Scalars['String']>;
};

/** distinct categories of dfm notes available on each line */
export type ProcessDfmNotes = {
  __typename: 'ProcessDfmNotes';
  color: Maybe<Scalars['String']>;
  process: Maybe<Scalars['String']>;
  texture: Maybe<Scalars['String']>;
  thickness: Maybe<Scalars['String']>;
};

/** ProcessInspectionCriteria */
export enum ProcessInspectionCriteria {
  all_dimensions = 'all_dimensions',
  bubbled_dimensions = 'bubbled_dimensions'
}

/**
 * A wrapper for a process and the resulting
 * configuration options from selecting it
 */
export type ProcessOption = {
  __typename: 'ProcessOption';
  id: Scalars['String'];
  materialOptions: Maybe<Array<MaterialOption>>;
  process: Process;
};

/** A manufacturing process type - used for scheduling */
export type ProcessType = {
  __typename: 'ProcessType';
  id: Scalars['String'];
  name: Scalars['String'];
  platformProcessTypeId: Maybe<Scalars['String']>;
};

/** A Product */
export type Product = {
  __typename: 'Product';
  attachmentRevisions: PartialProductAttachmentRevisionResults;
  createdAt: Scalars['Date'];
  deletedAt: Maybe<Scalars['Date']>;
  description: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  modelRevisions: PartialProductModelRevisionResults;
  name: Scalars['String'];
  owner: BasicUser;
  quotes: PartialQuoteResults;
  updatedAt: Scalars['Date'];
  workspaceId: Scalars['UUID'];
};


/** A Product */
export type ProductAttachmentRevisionsArgs = {
  cursor: InputMaybe<Scalars['ENCODED_CURSOR']>;
  limit?: InputMaybe<Scalars['Int']>;
};


/** A Product */
export type ProductModelRevisionsArgs = {
  cursor: InputMaybe<Scalars['ENCODED_CURSOR']>;
  limit?: InputMaybe<Scalars['Int']>;
};


/** A Product */
export type ProductQuotesArgs = {
  cursor: InputMaybe<Scalars['ENCODED_CURSOR']>;
  limit?: InputMaybe<Scalars['Int']>;
};

/** ProductAttachment */
export type ProductAttachment = {
  __typename: 'ProductAttachment';
  attachmentType: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  id: Scalars['UUID'];
  product: Product;
  revisions: Array<ProductAttachmentRevision>;
  selectedAttachmentRevisionId: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
};

/** ProductAttachmentRevision */
export type ProductAttachmentRevision = {
  __typename: 'ProductAttachmentRevision';
  attachment: Maybe<Attachment>;
  id: Scalars['UUID'];
  productAttachment: ProductAttachment;
  version: Scalars['Int'];
};

/** Input for uploading a new attachment */
export type ProductAttachmentRevisionUploadInput = {
  extension: Scalars['String'];
  fileName: Scalars['String'];
  mimeType: Scalars['String'];
};

/** Represents thread configuration of part product */
export type ProductConfiguration = {
  __typename: 'ProductConfiguration';
  /** num of configured threads */
  configuredThreads: Maybe<Scalars['Int']>;
  /** total num of holes in part */
  holesTotal: Maybe<Scalars['Int']>;
  /** part product id */
  productId: Scalars['Int'];
  /** part product quantity */
  productQty: Maybe<Scalars['Int']>;
  /** number of tight tolerances */
  tightTolerances: Maybe<Scalars['Int']>;
  /** num of un configured threads */
  unConfiguredThreads: Maybe<Scalars['Int']>;
  /** number of very tight tolerances */
  veryTightTolerances: Maybe<Scalars['Int']>;
};

/** Metadata resulting from creating a new part in fictiv-made. Should be used for creating a ProductModelRevision. */
export type ProductModel = {
  __typename: 'ProductModel';
  createdAt: Scalars['Date'];
  id: Scalars['UUID'];
  product: Product;
  revisions: Array<ProductModelRevision>;
  selectedModelRevisionId: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
};

/** Metadata resulting from creating a new part in fictiv-made. Should be used for creating a ProductModelRevision. */
export type ProductModelRevision = {
  __typename: 'ProductModelRevision';
  createdAt: Scalars['Date'];
  deletedAt: Maybe<Scalars['Date']>;
  fileName: Scalars['String'];
  id: Scalars['UUID'];
  partRevision: Revision;
  productModel: ProductModel;
  updatedAt: Scalars['Date'];
  uploadUrl: Maybe<Scalars['String']>;
  user: BasicUser;
  version: Scalars['Int'];
};

/** Input for uploading a new file */
export type ProductModelRevisionUploadInput = {
  contentType: Scalars['String'];
  fileName: Scalars['String'];
  fileSize: Scalars['Int'];
  referenceId: Scalars['UUID'];
  units: InputMaybe<Scalars['String']>;
};

/** Allowed filters */
export type ProductProcessFiltersInput = {
  processIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  processTypeIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** Enum for salesorder line production country */
export enum ProductionCountry {
  CN = 'CN',
  IN = 'IN',
  MX = 'MX',
  US = 'US'
}

/** Enum for salesorder line production country filter options */
export enum ProductionCountryFilter {
  CN = 'CN',
  IN = 'IN',
  MX = 'MX',
  US = 'US',
  Unassigned = 'Unassigned'
}

/** The time it will take to machine a physical part. */
export type ProductionLeadTime = {
  __typename: 'ProductionLeadTime';
  id: Scalars['String'];
  primaryProductionDays: Scalars['Int'];
  priorityId: Scalars['String'];
  productionDays: Scalars['Int'];
  shipDateEstimate: ShipDateEstimate;
};

/** Model that forecasts production rate */
export type ProductionRateForecast = {
  __typename: 'ProductionRateForecast';
  quantity: Maybe<Scalars['Int']>;
  timeScale: Maybe<ProductionRateTimeScaleInput>;
};

/** Input fields for production rate forecast */
export type ProductionRateForecastInput = {
  quantity: Scalars['Int'];
  timeScale: ProductionRateTimeScaleInput;
};

/** Types for production rate time scale input field */
export enum ProductionRateTimeScaleInput {
  month = 'month',
  six_months = 'six_months',
  three_months = 'three_months',
  year = 'year'
}

/** Different stages in which a job can exist */
export enum ProductionStage {
  fictiv5 = 'fictiv5',
  post_processing = 'post_processing',
  production = 'production'
}

/** Project and project asset information */
export type Project = {
  __typename: 'Project';
  createdAt: Scalars['Date'];
  createdBy: BasicUser;
  currentUserIsMember: Scalars['Boolean'];
  description: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  isSecurePlus: Scalars['Boolean'];
  memberships: PartialProjectMembershipResults;
  name: Scalars['String'];
  quotes: Maybe<PartialQuoteResults>;
  salesOrders: PartialSalesOrderResults;
  updatedAt: Scalars['Date'];
  updatedBy: BasicUser;
};


/** Project and project asset information */
export type ProjectMembershipsArgs = {
  cursor: InputMaybe<Scalars['ENCODED_CURSOR']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['CreatedAtSortKey']>;
};


/** Project and project asset information */
export type ProjectQuotesArgs = {
  cursor: InputMaybe<Scalars['ENCODED_CURSOR']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['CreatedAtSortKey']>;
};


/** Project and project asset information */
export type ProjectSalesOrdersArgs = {
  cursor: InputMaybe<Scalars['ENCODED_CURSOR']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['CreatedAtSortKey']>;
};

/** An activity event taken by a user in a quote */
export type ProjectActivity = {
  __typename: 'ProjectActivity';
  activityType: Scalars['String'];
  actor: Maybe<BasicUser>;
  createdAt: Scalars['Date'];
  id: Scalars['UUID'];
  meta: Maybe<Scalars['JSON']>;
  objectId: Scalars['UUID'];
  objectType: Scalars['String'];
  quote: Quote;
  summary: Scalars['String'];
  targetId: Scalars['UUID'];
  targetType: Scalars['String'];
  updatedAt: Scalars['Date'];
};

/** Input fields for a Project record */
export type ProjectInput = {
  description: Scalars['String'];
  isSecurePlus: Scalars['Boolean'];
  name: Scalars['String'];
  userEmails: Array<Scalars['String']>;
};

/** User and membership information for a project member */
export type ProjectMembership = {
  __typename: 'ProjectMembership';
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  isFictivEmployee: Scalars['Boolean'];
  isQuoteOwner: Scalars['Boolean'];
  updatedAt: Scalars['Date'];
  updatedBy: BasicUser;
  user: BasicUser;
};

/** Input fields for to update a Project record (empty fields will not have their values updated) */
export type ProjectUpdateInput = {
  description: InputMaybe<Scalars['String']>;
  isSecurePlus: InputMaybe<Scalars['Boolean']>;
  name: InputMaybe<Scalars['String']>;
  userEmails: InputMaybe<Array<Scalars['String']>>;
};

/** PunchoutSession */
export type PunchoutSession = {
  __typename: 'PunchoutSession';
  businessAccountId: Scalars['UUID'];
  buyerCookie: Scalars['String'];
  buyerEmail: Scalars['String'];
  createdAt: Scalars['Date'];
  disabledProcesses: Maybe<Scalars['String']>;
  expireAt: Scalars['Date'];
  id: Scalars['Int'];
  orderUrl: Scalars['String'];
  sessionId: Scalars['UUID'];
  userId: Scalars['Int'];
};

/** Fields associated with PurchaseOrder */
export type PurchaseOrder = {
  __typename: 'PurchaseOrder';
  attachment: Maybe<Attachment>;
  authorizedAmount: Maybe<Scalars['Int']>;
  createdAt: Maybe<Scalars['Date']>;
  deletedAt: Maybe<Scalars['Date']>;
  fileName: Maybe<Scalars['String']>;
  id: Scalars['String'];
  legacy: Maybe<Scalars['Boolean']>;
  referenceId: Scalars['String'];
  standing: Maybe<Scalars['Boolean']>;
  updatedAt: Maybe<Scalars['Date']>;
  userId: Maybe<Scalars['Int']>;
};

/** Input to create a new PurchaseOrderAttachment */
export type PurchaseOrderInput = {
  attachment: AttachmentInput;
  poReference: Scalars['String'];
};

/** Response from eChat API containing the URL of the Slack thread that was created. */
export type QlltSlackThreadResult = {
  __typename: 'QlltSlackThreadResult';
  url: Maybe<Scalars['String']>;
};

/** Annotations metadata for a qmr attachment(pdf) */
export type QmrAttachmentAnnotations = {
  __typename: 'QmrAttachmentAnnotations';
  annotationsDataDownloadUrl: Scalars['String'];
  attachmentId: Scalars['UUID'];
  createdAt: Scalars['Date'];
  createdBy: BasicUser;
  id: Scalars['UUID'];
  quoteModelRevisionId: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
  updatedBy: BasicUser;
};

/** Input field for Annotations */
export type QmrAttachmentAnnotationsInput = {
  annotationsDataId: Scalars['UUID'];
  sanitizationInfo: InputMaybe<SanitizationInfoInput>;
  userId: InputMaybe<Scalars['Int']>;
};

/** A group of QMRs by Category (Possible categories are: “Revision required”, "Review and approve", “Pending Fictiv review”, "Ready to go". ) */
export type QmrDfmCategoryGrouping = {
  __typename: 'QmrDfmCategoryGrouping';
  category: Scalars['String'];
  qmrs: Maybe<Array<QuoteModelRevision>>;
};

/** Flags for a quote model revision */
export enum QmrFlag {
  not_reorderable = 'not_reorderable'
}

/**
 * The lead time breakdown for a qmr and priority. At this time, the only field being used by the client
 * is additionalDays, but the JSON version has many more fields and we may include those here in the future.
 */
export type QmrLeadTimeBreakdown = {
  __typename: 'QmrLeadTimeBreakdown';
  additionalDays: QmrLeadTimeContributionsAdditionalDays;
};

/** Collection of pricing breakdowns for the fastest (excluding premium) domestic and overseas lead times */
export type QmrLeadTimeContributions = {
  __typename: 'QmrLeadTimeContributions';
  fastestDomesticLeadTimeBreakdown: Maybe<QmrLeadTimeBreakdown>;
  fastestOverseasLeadTimeBreakdown: Maybe<QmrLeadTimeBreakdown>;
};

/** Separate, independent factors that can add integer days to the lead time of a part */
export type QmrLeadTimeContributionsAdditionalDays = {
  __typename: 'QmrLeadTimeContributionsAdditionalDays';
  lathe: Scalars['Int'];
  longPart: Scalars['Int'];
  machiningTimeBasedMinimumProductionDays: Scalars['Int'];
  materialException: Scalars['Int'];
  pdfAutoQuotability: Scalars['Int'];
  reamer: Scalars['Int'];
  smallHoles: Scalars['Int'];
  smallTaps: Scalars['Int'];
  tightTolerance: Scalars['Int'];
  uncommonMaterials: Scalars['Int'];
  undercuts: Scalars['Int'];
};

/** Limited QMR info only for displaying navigation icons */
export type QmrLimitedInfoForIcons = {
  __typename: 'QmrLimitedInfoForIcons';
  fileName: Scalars['String'];
  id: Scalars['UUID'];
  thumbnailUri: Maybe<Scalars['String']>;
};

/** QMR merged asset */
export type QmrMergedDfmAssets = {
  __typename: 'QmrMergedDfmAssets';
  assetId: Scalars['UUID'];
  assetType: AssetType;
  createdAt: Scalars['Date'];
  createdBy: Scalars['Int'];
  qmrId: Scalars['UUID'];
  updatedAt: Scalars['Date'];
  updatedBy: Scalars['Int'];
};

/** QmrPostProcessWithPriceAndLead */
export type QmrPostProcessWithPriceAndLead = {
  __typename: 'QmrPostProcessWithPriceAndLead';
  postProcess: PostProcess;
  postProcessAdminNotes: Maybe<Scalars['String']>;
  postProcessColor: Maybe<Color>;
  postProcessInspectionCriteria: Maybe<ProcessInspectionCriteria>;
  postProcessLeadTimeInDays: Maybe<Scalars['Int']>;
  postProcessNumParts: Maybe<Scalars['Int']>;
  postProcessOverseasOnly: Maybe<Scalars['Boolean']>;
  postProcessThickness: Maybe<Thickness>;
  unitPriceInCents: Maybe<Scalars['Int']>;
  unitPriceInCentsWithoutBusinessAccountDiscount: Maybe<Scalars['Int']>;
};

/** QmrProcessWithPrice */
export type QmrProcessWithPrice = {
  __typename: 'QmrProcessWithPrice';
  price: Maybe<Price>;
  process: Process;
};

/** QmrProcessesDetails provides a breakdown of pricing and lead time per process for QuoteModelRevisions */
export type QmrProcessesDetails = {
  __typename: 'QmrProcessesDetails';
  isBusinessAccountDiscountApplied: Maybe<Scalars['Boolean']>;
  /** postProcesses are sorted by step number (QmrPostProcess.stepIdx) */
  postProcesses: Array<QmrPostProcessWithPriceAndLead>;
  primaryProcess: Maybe<QmrProcessWithPrice>;
  productionLeadTime: Maybe<ProductionLeadTime>;
  secondaryProcesses: Array<QmrSecondaryProcessDetails>;
  totalPrice: Maybe<Price>;
};

/** Input for shipping calculator's part configuration */
export type QmrQtyMaterialInput = {
  materialId: InputMaybe<Scalars['String']>;
  quantity: InputMaybe<Scalars['Int']>;
  quoteModelRevisionId: InputMaybe<Scalars['String']>;
};

/** Pricing and Lead time break down for secondary processes */
export type QmrSecondaryProcessDetails = {
  __typename: 'QmrSecondaryProcessDetails';
  leadTimeInDays: Maybe<Scalars['Int']>;
  notes: Maybe<Scalars['String']>;
  /** the following fields will only be returned for admins only */
  pricingAndLeadTimeFields: Maybe<PricingAndLeadTimeFields>;
  process: PostProcess;
  unitPriceInCents: Maybe<Scalars['Int']>;
  unitPriceInCentsWithoutBusinessAccountDiscount: Maybe<Scalars['Int']>;
};

/** QualityDocument record */
export type QualityDocument = {
  __typename: 'QualityDocument';
  active: Scalars['Boolean'];
  attachment: Asset;
  attachmentId: Scalars['String'];
  createdAt: Maybe<Scalars['Date']>;
  createdBy: Maybe<BasicUser>;
  fileName: Scalars['String'];
  fileNameHash: Scalars['String'];
  id: Scalars['Int'];
  updatedAt: Maybe<Scalars['Date']>;
};

/** Represents a collection of default QuantityRanges */
export type QuantityRange = {
  __typename: 'QuantityRange';
  createdAt: Scalars['Date'];
  createdBy: Scalars['Int'];
  deletedAt: Maybe<Scalars['Date']>;
  deletedBy: Maybe<Scalars['Int']>;
  id: Scalars['UUID'];
  quantityLowerRange: Scalars['Int'];
  quantityUpperRange: Scalars['Int'];
  updatedAt: Maybe<Scalars['Date']>;
  updatedBy: Maybe<Scalars['Int']>;
};

/** QuantityRange values */
export type QuantityRangeInput = {
  isQuantityRangeAvailable: Scalars['Boolean'];
  quantityLowerRange: Scalars['Int'];
  quantityUpperRange: Scalars['Int'];
};

/** Density information for a set of quotable materials */
export type Query = {
  __typename: 'Query';
  activeCorrectiveActionRequestAssignees: Maybe<Array<BasicUser>>;
  activeSupplierQualityEngineers: Maybe<Array<BasicUser>>;
  /** @deprecated Temporary endpoint for Ruby use only */
  addProductionDaysToDate: Maybe<Scalars['Date']>;
  adminConfigurablePostProcesses: Array<PostProcess>;
  adminJobRequests: JobRequestResults;
  adminOrderSearch: Maybe<AdminOrderSearch>;
  adminSearchSalesforceAccounts: PartialSalesforceAccountSearchResults;
  adminUserLinks: Maybe<AdminUserLinks>;
  adminUserOrderSearch: Maybe<AdminUserOrderSearch>;
  assignedCorrectiveActionRequestAssignees: Maybe<Array<BasicUser>>;
  assignedCorrectiveActionRequestMfgPartners: Maybe<Array<BasicMfgPartner>>;
  assignedStrategicSourcingManagers: Maybe<Array<BasicUser>>;
  assignedSupplierDevelopmentEngineers: Maybe<Array<BasicUser>>;
  assignedSupplierQualityEngineers: Maybe<Array<BasicUser>>;
  autoConfiguration: Maybe<Array<Maybe<AutoConfiguration>>>;
  autoCorrectMultiPostProcessesOrdering: AutoCorrectedOutput;
  /** A base query to extend */
  baseQuery: Maybe<Scalars['Boolean']>;
  builderConfigurablePostProcesses: Array<PostProcess>;
  businessAccount: BusinessAccount;
  businessAccountContacts: PartialBusinessAccountContactsResults;
  businessAccountMembers: PartialBusinessAccountMembersResults;
  businessAccountOrders: PartialBusinessAccountOrdersResult;
  businessAccountPendingMembers: PartialBusinessAccountPendingMembersResults;
  businessAccountPlans: Maybe<PartialBusinessAccountPlanResults>;
  businessAccountPunchoutFeature: Maybe<BusinessAccountPunchoutFeature>;
  businessAccountQuotes: PartialBusinessAccountQuotesResult;
  businessAccountSubscription: Maybe<BusinessAccountSubscription>;
  businessAccounts: BusinessAccountsResult;
  calculateAdvancedInspectionPendingPrices: PendingAdvancedInspectionPrices;
  calculateQuoteModelRevisionHypotheticalVendorPrice: Maybe<Price>;
  calculateQuoteModelRevisionPendingPrices: Maybe<Array<Maybe<PendingPriceInformation>>>;
  calculateQuoteModelRevisionPendingPricesBreakdownPercentages: Maybe<Array<Maybe<GranularPricingBreakdownPercentages>>>;
  canAcceptInvite: Maybe<Scalars['Boolean']>;
  canOdooDownloadProject: Maybe<Scalars['Boolean']>;
  carrierAccounts: Array<TplCarrierAccount>;
  checkAdditionOfPostProcessToCurrentQmrConfig: Array<QmrPostProcessWithPriceAndLead>;
  checkDomesticMaterialCertification: Scalars['Boolean'];
  colors: Array<Color>;
  correctiveActionRequest: Maybe<CorrectiveActionRequest>;
  correctiveActionRequestList: Maybe<CorrectiveActionRequestList>;
  correctiveActionRequestResponseOptions: Maybe<Array<CorrectiveActionRequestQuestionOption>>;
  correctiveActionRequests: Maybe<CorrectiveActionRequests>;
  countries: Array<Country>;
  currentMarkups: MarkupData;
  dfmFeedback: Maybe<DfmFeedback>;
  dfmFeedbackMessages: Maybe<Array<DfmFeedbackMessage>>;
  dfmFeedbackTopics: Maybe<Array<Topic>>;
  dfmReportLoadingStatus: Maybe<DfmReportLoadingOutput>;
  dfmStatuses: Array<Scalars['String']>;
  estimateItem: Maybe<EstimateItem>;
  exception: Exception;
  exceptionActions: Maybe<Array<ExceptionAction>>;
  exceptionFailure: ExceptionFailure;
  exceptionFailureActions: Maybe<Array<ExceptionFailureAction>>;
  exceptionFailureRootCauses: Maybe<Array<ExceptionFailureRootCause>>;
  exceptionFailures: PartialExceptionFailureResults;
  exceptionTypes: Maybe<Array<ExceptionType>>;
  exceptions: PartialExceptionResults;
  featureFlags: Array<FeatureFlag>;
  fetchEligibleMPsForJob: Maybe<Array<MfgPartner>>;
  fetchExceptionFailureHistoryById: ExceptionFailureHistory;
  fetchExceptionHistoryById: ExceptionHistory;
  fictivHolidays: Array<FictivHoliday>;
  generateJobName: Scalars['String'];
  generateModelConfigurationDfmInspection: Maybe<ModelConfigurationDfmInspection>;
  genericPartInfoSearch: Maybe<Array<Maybe<PartSearchInfo>>>;
  genericUserSearch: Maybe<Array<Maybe<UserSearchInfo>>>;
  getActiveJobBoardRegions: Maybe<Array<JobBoardRegion>>;
  getActiveMfgDriUsers: Array<Maybe<BasicUser>>;
  getAllBatchPostProcessIds: Array<Scalars['String']>;
  getAllBusinessAccountFeatures: Array<BusinessAccountFeature>;
  getBusinessAccountDiscounts: Array<Maybe<BusinessAccountDiscount>>;
  getBusinessAccountFeature: Maybe<BusinessAccountFeature>;
  getBusinessAccountMembershipRequestBanner: Maybe<BusinessAccountMembershipRequestBanner>;
  getBusinessUnits: Array<Scalars['String']>;
  getChangeHistory: Maybe<Array<ChangeHistory>>;
  getCurrentJobBoard: Maybe<JobBoard>;
  getCustomDfmInspection: Array<Maybe<DfmInspectionAsString>>;
  getCustomPartPrice: Array<Maybe<PriceInformation>>;
  getCustomPostProcessPrice: Array<Maybe<PriceInformationWithQmrId>>;
  getDownloadableQuotePdf: Scalars['String'];
  getEligibleFollowers: Maybe<Array<EligibleFollowerUser>>;
  getEligibleMpCountForJobBoard: Scalars['Int'];
  getExceptionCreatedByUserList: Maybe<Array<BasicUser>>;
  getExceptionFailureCreatedByUserList: Maybe<Array<BasicUser>>;
  getInspectionPointCount: GetInspectionPointCountOutput;
  getJobBids: Maybe<Array<JobBid>>;
  getJobBoardCalendar: Maybe<Array<JobBoardCalendar>>;
  getJobBoardJobList: Maybe<Array<JobBoardJob>>;
  getJobParts: Maybe<Array<JobPart>>;
  getJobRequestParts: Maybe<Array<JobRequestPart>>;
  getJobRequestReceipts: Maybe<Array<JobRequestReceipt>>;
  getManufacturingPartnerDrawing: Maybe<ManufacturingPartnerDrawing>;
  getMfgDriUsers: Array<Maybe<BasicUser>>;
  getMfgPartnerLevelOverride: Maybe<MfgPartnerLevelOverride>;
  getMfgPartnerMachineDetails: Maybe<MfgPartnerMachineDetails>;
  getMfgPartnerMaterials: Maybe<Array<MfgPartnerMaterialResult>>;
  getMfgPartnerProcessCapabilities: Maybe<MfgPartnerProcessCapabilities>;
  getModelAttachmentOcrData: Maybe<ModelAttachmentOcrData>;
  getMoldToolRevision: Maybe<Array<Maybe<MoldTool>>>;
  getMpViewedJobOnJobBoardList: Maybe<Array<Scalars['Int']>>;
  getNextJobBoard: Maybe<JobBoard>;
  getNonconfigurableOrderPartConfigInfo: Array<NonconfigurableOrderLineConfigInfo>;
  getPartEstimatedPriceForNonImModels: Array<PartEstimatedPrices>;
  getPartnerShopProcessAvailability: Maybe<PartnerShopProcessAvailability>;
  getPendingClassACalculatorDomesticAndOverseasPrice: Maybe<ClassACalculatorOutput>;
  getPendingEdmCalculatorDomesticAndOverseasPrice: Maybe<EdmCalculatorOutput>;
  getPendingHardwareInstallationPriceAndLeadTime: Maybe<SecondaryProcessManualQuoteCalcFields>;
  getQlltSlackThread: Maybe<QlltSlackThreadResult>;
  getQmrAttachmentAnnotations: Maybe<QmrAttachmentAnnotations>;
  getQualityDocumentByFileNameHash: Maybe<QualityDocument>;
  getQuoteActivitiesForSync: Array<QuoteActivityForSyncing>;
  getQuoteModelRevisionImClassificationScore: Maybe<Array<Maybe<ImScore>>>;
  getQuoteModelRevisionRegionalPrices: Maybe<RegionalPrices>;
  getQuoteProperties: Array<QuoteProperty>;
  getQuoteProperty: Maybe<QuoteProperty>;
  getRawAutoschedulingLambdaResponse: Scalars['JSON'];
  getRawPdfOcrJson: Maybe<RawPdfOcrJson>;
  getRecommendedMpsForJob: Maybe<RecommendedMpsForJob>;
  getReorderEligibilityForOrder: Maybe<ReorderEligibility>;
  getSalesOrderDeliveries: Maybe<Array<SalesOrderDeliveryOrder>>;
  getSchedulingTypes: SchedulingTypesWithLiveJobBoard;
  getShopProcessesByPartnerId: Maybe<Array<Maybe<ShopProcessDetail>>>;
  getSupportingCapabilities: Maybe<Array<SupportingCapabilities>>;
  getTaxAmount: Maybe<Tax>;
  getToolAndPartEstimatedPrices: Array<ToolAndPartEstimatedPrices>;
  getToolAndPartPendingPrices: Maybe<ToolAndPartPendingPrices>;
  getTotalSalesOrderPriceForJob: Maybe<TotalSalesOrderPriceForJob>;
  getUserBusinessAccountStatus: UserBusinessAccountAssociationStatus;
  imQuote: Maybe<InjectionMoldingQuote>;
  imQuoteCostAndLeadTimePreferences: Maybe<Array<Maybe<ImQuotePreference>>>;
  imQuotePreferences: Maybe<Array<Maybe<ImQuotePreference>>>;
  is2dDfmSlideReady: Array<DfmSlideReadyStatus>;
  isActiveUserEmail: Scalars['Boolean'];
  isBusinessAccountDiscountValid: BusinessAccountDiscountValidation;
  isDfmLoading: DfmLoadingStatus;
  isEmployeeEmail: Maybe<Scalars['Boolean']>;
  isMergedDfmReportReady: MergedDfmReadyStatus;
  job: Job;
  jobList: JobsListResult;
  jobMilestones: Maybe<JobMilestones>;
  jobRequest: Maybe<JobRequest>;
  jobRequests: Maybe<Array<JobRequest>>;
  jobs: JobsListResult;
  latheMaterialStock: Maybe<MaterialStock>;
  listAllQuoteModelRevisions: PartialQuoteModelRevisionResults;
  listDFMConsultationRequestOptions: ConsultativeDfmOptions;
  listErpMoldsForQuoteOwner: Maybe<Array<ErpMoldTool>>;
  matchCadFileNamesToPdfFileNames: Maybe<Array<Maybe<NameMatchPairInfo>>>;
  materialConfigurationOptions: Array<MaterialConfigurationOption>;
  materialDensities: Maybe<Array<MaterialDensity>>;
  materials: Maybe<Array<Material>>;
  me: Maybe<User>;
  mfgPartner: Maybe<MfgPartner>;
  mfgPartnerLevelDrilldownDetails: Maybe<MfgPartnerLevelDrilldownDetails>;
  mfgPartnerLevelRecords: Maybe<MfgPartnerLevelRecords>;
  mfgPartnerLevelSnapshotDetails: Maybe<MfgPartnerLevelSnapshotDetails>;
  mfgPartnerOverallStatistics: Maybe<MfgPartnerOverallStatistics>;
  mfgPartners: MfgPartnersResults;
  mfgPartnersForFilter: Maybe<Array<MfgPartner>>;
  millMaterialStock: Maybe<MaterialStock>;
  modelConfigurationDfmInspection: Maybe<ModelConfigurationDfmInspection>;
  modelConfigurationDfmInspectionByConfiguration: Maybe<ModelConfigurationDfmInspection>;
  modelViewerSnapshot: ModelViewerSnapshot;
  modelViewerSnapshotByRevision: Array<ModelViewerSnapshot>;
  moldTool: Maybe<MoldTool>;
  mpCountries: Array<MpCountry>;
  mpJob: MpJob;
  mpJobRequest: Maybe<JobRequest>;
  order: Maybe<Order>;
  orderActivity: PartialProjectActivityResults;
  orderSearch: Maybe<OrderSearch>;
  payoutAdjustmentReasons: Maybe<Array<PayoutAdjustmentReasonCategory>>;
  postProcesses: Array<PostProcess>;
  preCheckoutQuotePricePreviewDownloadUrl: Maybe<Scalars['String']>;
  processTypes: Array<ProcessType>;
  processes: Array<Process>;
  productAttachment: Maybe<ProductAttachment>;
  productAttachmentRevision: Maybe<ProductAttachmentRevision>;
  productModel: Maybe<ProductModel>;
  productModelRevision: Maybe<ProductModelRevision>;
  productionLeadTimes: Maybe<Array<ProductionLeadTime>>;
  project: Maybe<Project>;
  punchoutSession: Maybe<PunchoutSession>;
  purchaseOrder: Maybe<PurchaseOrder>;
  qmrLeadTimeContributions: Maybe<QmrLeadTimeContributions>;
  qmrLeadTimeContributionsJSON: Maybe<Scalars['JSON']>;
  qmrsGroupedByDfmCategory: Array<QmrDfmCategoryGrouping>;
  qmrsInfoFilteredByHasDfm: Array<QmrLimitedInfoForIcons>;
  quantityRanges: Array<QuantityRange>;
  quotabilityBlockers: Maybe<Array<Scalars['String']>>;
  quote: Maybe<Quote>;
  quoteActivity: PartialProjectActivityResults;
  quoteAttachmentRevision: Maybe<QuoteAttachmentRevision>;
  quoteItem: QuoteItem;
  quoteItemsForQmr: Array<QuoteItem>;
  quoteModel: Maybe<QuoteModel>;
  quoteModelRevision: Maybe<QuoteModelRevision>;
  quotePricePreview: Maybe<QuotePricePreview>;
  quotePricePreviewDownloadUrl: Maybe<Scalars['String']>;
  recommendedQuantitiesToHitDeliveryDate: Maybe<Array<RecommendedQuantityToReduceLeadTime>>;
  recommendedQuantityToReduceLeadTime: Maybe<RecommendedQuantityToReduceLeadTime>;
  /** @deprecated Query is no longer supported. Please use 'quoteModelRevision', 'productModelRevision', or 'estimateItem' instead. */
  revision: Maybe<Revision>;
  salesOrder: Maybe<SalesOrder>;
  salesOrderLineProductProcesses: Maybe<Array<SalesOrderLineProductProcess>>;
  salesOrderLines: Maybe<PartialSalesOrderLineResults>;
  salesOrderWithUnbundledParts: PartialSalesOrderResults;
  salesOrders: PartialSalesOrderResults;
  schedulingProcesses: Array<SchedulingProcess>;
  schedulingQueue: SchedulingQueue;
  schedulingQueuesByStatus: Maybe<Array<SchedulingQueue>>;
  secondaryProcessPricingCalculator: ExactPrice;
  sendMPCapacityReminderEmails: Scalars['Int'];
  shipment: Maybe<Shipment>;
  shores: Array<Shore>;
  tax: Maybe<Tax>;
  team: Maybe<Team>;
  teamOrders: PartialSalesOrderViewResults;
  teamQuotes: PartialTeamQuotesResult;
  teamSpendByTime: TeamSpendResult;
  teams: PartialTeamsResult;
  textures: Array<Texture>;
  user: Maybe<User>;
  userEnteredMaterials: Maybe<Array<UserEnteredMaterial>>;
  userTeamMembers: PartialUserTeamMembersResult;
  validateZip: ZipValidationOutput;
  verifyShippingAddress: Maybe<ShippingAddress>;
};


/** Density information for a set of quotable materials */
export type QueryAddProductionDaysToDateArgs = {
  date: Scalars['String'];
  priorityId: Scalars['String'];
  productionDays: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QueryAdminConfigurablePostProcessesArgs = {
  materialId: InputMaybe<Scalars['String']>;
};


/** Density information for a set of quotable materials */
export type QueryAdminJobRequestsArgs = {
  filters: InputMaybe<AdminJobRequestFiltersInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<AllowedAdminJobRequestSort>;
};


/** Density information for a set of quotable materials */
export type QueryAdminOrderSearchArgs = {
  from: Scalars['Int'];
  searchString: Scalars['String'];
  size: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QueryAdminSearchSalesforceAccountsArgs = {
  filters: InputMaybe<SalesforceAccountSearchInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SalesforceAccountSortInput>;
};


/** Density information for a set of quotable materials */
export type QueryAdminUserLinksArgs = {
  email: Scalars['String'];
};


/** Density information for a set of quotable materials */
export type QueryAdminUserOrderSearchArgs = {
  from: Scalars['Int'];
  searchString: Scalars['String'];
  size: Scalars['Int'];
  userId: InputMaybe<Scalars['Int']>;
};


/** Density information for a set of quotable materials */
export type QueryAssignedCorrectiveActionRequestMfgPartnersArgs = {
  sort?: InputMaybe<MfgPartnerSortInput>;
};


/** Density information for a set of quotable materials */
export type QueryAssignedSupplierQualityEngineersArgs = {
  assignedTo: InputMaybe<SqeAssignedToType>;
};


/** Density information for a set of quotable materials */
export type QueryAutoConfigurationArgs = {
  quoteId: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryAutoCorrectMultiPostProcessesOrderingArgs = {
  postProcessIds: Array<Scalars['String']>;
};


/** Density information for a set of quotable materials */
export type QueryBuilderConfigurablePostProcessesArgs = {
  materialId: Scalars['String'];
  processId: InputMaybe<Scalars['String']>;
};


/** Density information for a set of quotable materials */
export type QueryBusinessAccountArgs = {
  businessAccountId: Scalars['String'];
};


/** Density information for a set of quotable materials */
export type QueryBusinessAccountContactsArgs = {
  filterInput: BusinessAccountContactsFilterInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<BusinessAccountContactsSortInput>;
};


/** Density information for a set of quotable materials */
export type QueryBusinessAccountMembersArgs = {
  filters: InputMaybe<BusinessAccountMembersFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<BusinessAccountMembersQuerySortInput>;
};


/** Density information for a set of quotable materials */
export type QueryBusinessAccountOrdersArgs = {
  filters: BusinessAccountOrdersFilterInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** Density information for a set of quotable materials */
export type QueryBusinessAccountPendingMembersArgs = {
  filters: InputMaybe<BusinessAccountPendingMembersFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<BusinessAccountPendingMembersQuerySortInput>;
};


/** Density information for a set of quotable materials */
export type QueryBusinessAccountPlansArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** Density information for a set of quotable materials */
export type QueryBusinessAccountPunchoutFeatureArgs = {
  businessAccountId: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryBusinessAccountQuotesArgs = {
  filters: BusinessAccountQuotesFilterInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** Density information for a set of quotable materials */
export type QueryBusinessAccountSubscriptionArgs = {
  subscriptionId: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QueryBusinessAccountsArgs = {
  filters: InputMaybe<BusinessAccountsFilterInput>;
};


/** Density information for a set of quotable materials */
export type QueryCalculateAdvancedInspectionPendingPricesArgs = {
  inspectionParams: AdminInspectionPricingParamsInput;
  numPartsToInspect: Scalars['Int'];
  quoteModelRevisionId: Scalars['UUID'];
  setupParams: PartSetupsInspectionPricingParamsInput;
};


/** Density information for a set of quotable materials */
export type QueryCalculateQuoteModelRevisionHypotheticalVendorPriceArgs = {
  inspectionData: InputMaybe<InspectionDataInput>;
  modelConfigOverride: ConfigInput;
  pricingConstantOverrides: PricingConstantOverridesInput;
  quoteModelRevisionId: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryCalculateQuoteModelRevisionPendingPricesArgs = {
  inspectionData: InputMaybe<InspectionDataInput>;
  modelConfigOverrides: InputMaybe<Array<ConfigInput>>;
  operationRegion: InputMaybe<Scalars['String']>;
  quoteModelRevisionId: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryCalculateQuoteModelRevisionPendingPricesBreakdownPercentagesArgs = {
  inspectionData: InputMaybe<InspectionDataInput>;
  modelConfigOverrides: InputMaybe<Array<ConfigInput>>;
  quoteModelRevisionId: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryCanAcceptInviteArgs = {
  token: Scalars['String'];
};


/** Density information for a set of quotable materials */
export type QueryCanOdooDownloadProjectArgs = {
  projectId: Scalars['UUID'];
  userId: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QueryCarrierAccountsArgs = {
  userId: InputMaybe<Scalars['Int']>;
};


/** Density information for a set of quotable materials */
export type QueryCheckAdditionOfPostProcessToCurrentQmrConfigArgs = {
  id: Scalars['UUID'];
  postProcess: SecondaryProcessConfigInput;
};


/** Density information for a set of quotable materials */
export type QueryCheckDomesticMaterialCertificationArgs = {
  materialId: Scalars['String'];
};


/** Density information for a set of quotable materials */
export type QueryColorsArgs = {
  materialId: Scalars['String'];
};


/** Density information for a set of quotable materials */
export type QueryCorrectiveActionRequestArgs = {
  id: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryCorrectiveActionRequestListArgs = {
  filters: InputMaybe<CorrectiveActionRequestListFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<CorrectiveActionRequestListSortInput>;
};


/** Density information for a set of quotable materials */
export type QueryCorrectiveActionRequestResponseOptionsArgs = {
  correctiveActionRequestQuestion: CorrectiveActionRequestQuestionType;
};


/** Density information for a set of quotable materials */
export type QueryCorrectiveActionRequestsArgs = {
  filters: InputMaybe<CorrectiveActionRequestFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<CorrectiveActionRequestSortInput>;
};


/** Density information for a set of quotable materials */
export type QueryDfmFeedbackArgs = {
  id: Scalars['UUID'];
  quoteId: InputMaybe<Scalars['UUID']>;
};


/** Density information for a set of quotable materials */
export type QueryDfmFeedbackMessagesArgs = {
  disabled: InputMaybe<Scalars['Boolean']>;
  platformProcessId: InputMaybe<Scalars['String']>;
  topicId: InputMaybe<Scalars['UUID']>;
  type: InputMaybe<DfmFeedbackMessageType>;
};


/** Density information for a set of quotable materials */
export type QueryDfmReportLoadingStatusArgs = {
  targetId: Scalars['UUID'];
  targetType: Scalars['String'];
};


/** Density information for a set of quotable materials */
export type QueryDfmStatusesArgs = {
  quoteType: InputMaybe<QuoteType>;
};


/** Density information for a set of quotable materials */
export type QueryEstimateItemArgs = {
  configOverride: InputMaybe<ConfigurationInput>;
  id: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryExceptionArgs = {
  id: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryExceptionFailureArgs = {
  id: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryExceptionFailuresArgs = {
  filters: InputMaybe<ExceptionFailuresFilterInput>;
  getAllExceptions: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ExceptionFailuresSort>;
};


/** Density information for a set of quotable materials */
export type QueryExceptionsArgs = {
  filters: InputMaybe<ExceptionsFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<AllowedExceptionsSort>;
};


/** Density information for a set of quotable materials */
export type QueryFetchEligibleMPsForJobArgs = {
  forDate: InputMaybe<Scalars['Date']>;
  jobId: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QueryFetchExceptionFailureHistoryByIdArgs = {
  id: InputMaybe<Scalars['ID']>;
};


/** Density information for a set of quotable materials */
export type QueryFetchExceptionHistoryByIdArgs = {
  id: InputMaybe<Scalars['ID']>;
};


/** Density information for a set of quotable materials */
export type QueryGenerateModelConfigurationDfmInspectionArgs = {
  modelConfigOverrides: ConfigInput;
  quoteModelRevisionId: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryGenericPartInfoSearchArgs = {
  searchString: Scalars['String'];
};


/** Density information for a set of quotable materials */
export type QueryGenericUserSearchArgs = {
  searchString: Scalars['String'];
};


/** Density information for a set of quotable materials */
export type QueryGetAllBusinessAccountFeaturesArgs = {
  businessAccountId: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryGetBusinessAccountDiscountsArgs = {
  userId: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QueryGetBusinessAccountFeatureArgs = {
  businessAccountId: Scalars['UUID'];
  featureName: BusinessAccountFeatureInput;
};


/** Density information for a set of quotable materials */
export type QueryGetBusinessAccountMembershipRequestBannerArgs = {
  userId: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QueryGetChangeHistoryArgs = {
  objectId: Scalars['String'];
  objectType: ChangeHistoryObjectType;
};


/** Density information for a set of quotable materials */
export type QueryGetCurrentJobBoardArgs = {
  jobBoardRegionId: InputMaybe<Scalars['String']>;
};


/** Density information for a set of quotable materials */
export type QueryGetCustomDfmInspectionArgs = {
  instantInspection: Scalars['JSON'];
  modelConfigOverrides: Array<ConfigInput>;
  supportingDocAnalysis: InputMaybe<Scalars['JSON']>;
};


/** Density information for a set of quotable materials */
export type QueryGetCustomPartPriceArgs = {
  inspectionData: InspectionDataInput;
  instantInspection: Scalars['JSON'];
  modelConfigOverrides: Array<ConfigInput>;
};


/** Density information for a set of quotable materials */
export type QueryGetCustomPostProcessPriceArgs = {
  modelInfoAndConfigArray: Scalars['JSON'];
};


/** Density information for a set of quotable materials */
export type QueryGetDownloadableQuotePdfArgs = {
  quoteId: Scalars['String'];
};


/** Density information for a set of quotable materials */
export type QueryGetEligibleMpCountForJobBoardArgs = {
  erpSaleOrderId: Scalars['Int'];
  jobBoardRegionId: Scalars['String'];
  processIds: Array<Scalars['Int']>;
};


/** Density information for a set of quotable materials */
export type QueryGetInspectionPointCountArgs = {
  attachmentId: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryGetJobBidsArgs = {
  jobId: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QueryGetJobBoardCalendarArgs = {
  endDate: Scalars['String'];
  startDate: Scalars['String'];
};


/** Density information for a set of quotable materials */
export type QueryGetJobBoardJobListArgs = {
  jobBoardId: InputMaybe<Scalars['String']>;
};


/** Density information for a set of quotable materials */
export type QueryGetJobPartsArgs = {
  jobId: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QueryGetJobRequestPartsArgs = {
  jobRequestId: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QueryGetJobRequestReceiptsArgs = {
  jobRequestId: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QueryGetManufacturingPartnerDrawingArgs = {
  estimateItemId: InputMaybe<Scalars['UUID']>;
  quoteModelRevisionId: InputMaybe<Scalars['UUID']>;
};


/** Density information for a set of quotable materials */
export type QueryGetMfgDriUsersArgs = {
  assignedTo: InputMaybe<Scalars['String']>;
};


/** Density information for a set of quotable materials */
export type QueryGetMfgPartnerLevelOverrideArgs = {
  partnerId: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QueryGetMfgPartnerMachineDetailsArgs = {
  partnerId: Scalars['Int'];
  processId: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QueryGetMfgPartnerMaterialsArgs = {
  isActive: InputMaybe<Scalars['Boolean']>;
  materialId: InputMaybe<Scalars['Int']>;
  partnerId: Scalars['Int'];
  processId: InputMaybe<Scalars['Int']>;
};


/** Density information for a set of quotable materials */
export type QueryGetMfgPartnerProcessCapabilitiesArgs = {
  erpProcessId: Scalars['Int'];
  partnerId: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QueryGetModelAttachmentOcrDataArgs = {
  quoteModelRevisionAttachmentId: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryGetMoldToolRevisionArgs = {
  moldToolRevisionId: InputMaybe<Array<Scalars['UUID']>>;
  quoteId: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryGetMpViewedJobOnJobBoardListArgs = {
  jobIdsAndMpsList: InputMaybe<MpActiveOnJobBoardInput>;
};


/** Density information for a set of quotable materials */
export type QueryGetNonconfigurableOrderPartConfigInfoArgs = {
  orderName: Scalars['String'];
};


/** Density information for a set of quotable materials */
export type QueryGetPartEstimatedPriceForNonImModelsArgs = {
  qmrIds: Array<Scalars['String']>;
  quantity: InputMaybe<Scalars['Int']>;
};


/** Density information for a set of quotable materials */
export type QueryGetPartnerShopProcessAvailabilityArgs = {
  availabilityInput: PartnerShopAvailabilityInput;
};


/** Density information for a set of quotable materials */
export type QueryGetPendingClassACalculatorDomesticAndOverseasPriceArgs = {
  partComplexity: Scalars['String'];
  qmrId: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryGetPendingEdmCalculatorDomesticAndOverseasPriceArgs = {
  edmCalculatorInput: EdmCalculatorInput;
  qmrId: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryGetPendingHardwareInstallationPriceAndLeadTimeArgs = {
  hardwareInstallationInput: HardwareInstallationPricingInput;
  qmrId: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryGetQlltSlackThreadArgs = {
  quoteId: Scalars['String'];
};


/** Density information for a set of quotable materials */
export type QueryGetQmrAttachmentAnnotationsArgs = {
  attachmentId: Scalars['UUID'];
  quoteModelRevisionId: InputMaybe<Scalars['UUID']>;
};


/** Density information for a set of quotable materials */
export type QueryGetQualityDocumentByFileNameHashArgs = {
  fileNameHash: Scalars['String'];
};


/** Density information for a set of quotable materials */
export type QueryGetQuoteModelRevisionImClassificationScoreArgs = {
  qmrIds: Array<InputMaybe<Scalars['UUID']>>;
};


/** Density information for a set of quotable materials */
export type QueryGetQuoteModelRevisionRegionalPricesArgs = {
  quoteModelRevisionId: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryGetQuotePropertiesArgs = {
  quoteId: Scalars['String'];
};


/** Density information for a set of quotable materials */
export type QueryGetQuotePropertyArgs = {
  name: Scalars['String'];
  quoteId: Scalars['String'];
};


/** Density information for a set of quotable materials */
export type QueryGetRawAutoschedulingLambdaResponseArgs = {
  input: Scalars['JSON'];
};


/** Density information for a set of quotable materials */
export type QueryGetRawPdfOcrJsonArgs = {
  quoteModelRevisionId: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryGetRecommendedMpsForJobArgs = {
  filters: InputMaybe<RecommendedMpsForJobFiltersInput>;
  jobId: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QueryGetReorderEligibilityForOrderArgs = {
  orderName: Scalars['String'];
};


/** Density information for a set of quotable materials */
export type QueryGetSalesOrderDeliveriesArgs = {
  saleOrderId: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QueryGetSchedulingTypesArgs = {
  productionCountry: ProductionCountry;
};


/** Density information for a set of quotable materials */
export type QueryGetShopProcessesByPartnerIdArgs = {
  partnerId: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QueryGetTaxAmountArgs = {
  quoteId: Scalars['String'];
  zip: Scalars['String'];
};


/** Density information for a set of quotable materials */
export type QueryGetToolAndPartEstimatedPricesArgs = {
  qmrIds: Array<Scalars['String']>;
};


/** Density information for a set of quotable materials */
export type QueryGetToolAndPartPendingPricesArgs = {
  inspectionData: MoldToolInspectionDataInput;
  partsInspectionData: Array<InputMaybe<PartInspectionDataInput>>;
  pendingPartQuantity: InputMaybe<Scalars['Int']>;
};


/** Density information for a set of quotable materials */
export type QueryGetTotalSalesOrderPriceForJobArgs = {
  jobId: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QueryGetUserBusinessAccountStatusArgs = {
  userId: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QueryImQuoteArgs = {
  estimateItemId: Scalars['UUID'];
  materialId: Scalars['String'];
};


/** Density information for a set of quotable materials */
export type QueryIs2dDfmSlideReadyArgs = {
  dfmIds: InputMaybe<Array<Scalars['UUID']>>;
};


/** Density information for a set of quotable materials */
export type QueryIsActiveUserEmailArgs = {
  email: Scalars['String'];
};


/** Density information for a set of quotable materials */
export type QueryIsBusinessAccountDiscountValidArgs = {
  platformUuid: Scalars['UUID'];
  userId: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QueryIsDfmLoadingArgs = {
  qmrId: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryIsEmployeeEmailArgs = {
  email: Scalars['String'];
};


/** Density information for a set of quotable materials */
export type QueryIsMergedDfmReportReadyArgs = {
  format: InputMaybe<Scalars['String']>;
  qmrId: Scalars['UUID'];
  requestedByAdmin: InputMaybe<Scalars['Boolean']>;
};


/** Density information for a set of quotable materials */
export type QueryJobArgs = {
  id: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QueryJobListArgs = {
  filters: InputMaybe<JobListFiltersInput>;
  getAll: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  sort: InputMaybe<Array<JobSortInput>>;
};


/** Density information for a set of quotable materials */
export type QueryJobMilestonesArgs = {
  jobId: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QueryJobRequestArgs = {
  id: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QueryJobRequestsArgs = {
  jobId: InputMaybe<Scalars['Int']>;
  statuses: Array<JobRequestStatus>;
};


/** Density information for a set of quotable materials */
export type QueryJobsArgs = {
  filters: InputMaybe<JobFiltersInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  sort: InputMaybe<Array<JobSortInput>>;
};


/** Density information for a set of quotable materials */
export type QueryLatheMaterialStockArgs = {
  diameter: Scalars['Float'];
  length: Scalars['Float'];
  materialId: Scalars['String'];
  quantity: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QueryListAllQuoteModelRevisionsArgs = {
  cursor: InputMaybe<Scalars['ENCODED_CURSOR']>;
  filters: InputMaybe<QuoteModelRevisionFiltersInput>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['CreatedAtSortKey']>;
};


/** Density information for a set of quotable materials */
export type QueryListErpMoldsForQuoteOwnerArgs = {
  quoteId: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryMatchCadFileNamesToPdfFileNamesArgs = {
  cadFileNames: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pdfFileNames: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Density information for a set of quotable materials */
export type QueryMaterialConfigurationOptionsArgs = {
  materialId: Scalars['String'];
};


/** Density information for a set of quotable materials */
export type QueryMaterialDensitiesArgs = {
  platformMaterialIds: InputMaybe<Array<Scalars['String']>>;
};


/** Density information for a set of quotable materials */
export type QueryMaterialsArgs = {
  processId: Scalars['String'];
};


/** Density information for a set of quotable materials */
export type QueryMfgPartnerArgs = {
  id: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QueryMfgPartnerLevelDrilldownDetailsArgs = {
  recordId: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QueryMfgPartnerLevelRecordsArgs = {
  filters: InputMaybe<MfgPartnerLevelsFiltersInput>;
  limit?: InputMaybe<Scalars['Int']>;
  mfgPartnerId: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort: InputMaybe<AllowedMfgPartnerLevelsSort>;
};


/** Density information for a set of quotable materials */
export type QueryMfgPartnerLevelSnapshotDetailsArgs = {
  snapshotId: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QueryMfgPartnerOverallStatisticsArgs = {
  mfgPartnerId: InputMaybe<Scalars['Int']>;
};


/** Density information for a set of quotable materials */
export type QueryMfgPartnersArgs = {
  filters: InputMaybe<MfgPartnerFiltersInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<AllowedMfgPartnerSort>;
};


/** Density information for a set of quotable materials */
export type QueryMillMaterialStockArgs = {
  exactThickness: InputMaybe<MillMaterialStockExactThicknessType>;
  length: Scalars['Float'];
  materialId: Scalars['String'];
  preferNesting: InputMaybe<Scalars['Boolean']>;
  quantity: Scalars['Int'];
  thickness: Scalars['Float'];
  width: Scalars['Float'];
};


/** Density information for a set of quotable materials */
export type QueryModelConfigurationDfmInspectionArgs = {
  id: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryModelConfigurationDfmInspectionByConfigurationArgs = {
  modelConfigurationId: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryModelViewerSnapshotArgs = {
  id: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryModelViewerSnapshotByRevisionArgs = {
  quoteModelRevisionId: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryMoldToolArgs = {
  id: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryMpJobArgs = {
  id: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QueryMpJobRequestArgs = {
  id: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QueryOrderArgs = {
  orderId: Scalars['String'];
};


/** Density information for a set of quotable materials */
export type QueryOrderActivityArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  saleOrderId: InputMaybe<Scalars['Int']>;
};


/** Density information for a set of quotable materials */
export type QueryOrderSearchArgs = {
  from: Scalars['Int'];
  searchString: Scalars['String'];
  size: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QueryPostProcessesArgs = {
  materialId: InputMaybe<Scalars['String']>;
};


/** Density information for a set of quotable materials */
export type QueryPreCheckoutQuotePricePreviewDownloadUrlArgs = {
  carrierAccountId: InputMaybe<Scalars['UUID']>;
  forResale?: InputMaybe<Scalars['Boolean']>;
  isShippingOptionForCarrier: InputMaybe<Scalars['Boolean']>;
  quoteId: Scalars['UUID'];
  shippingMethods: InputMaybe<Array<ShippingMethodInput>>;
  userId: InputMaybe<Scalars['Int']>;
};


/** Density information for a set of quotable materials */
export type QueryProcessesArgs = {
  quoteType: InputMaybe<QuoteType>;
};


/** Density information for a set of quotable materials */
export type QueryProductAttachmentArgs = {
  productAttachmentId: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryProductAttachmentRevisionArgs = {
  id: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryProductModelArgs = {
  productModelId: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryProductModelRevisionArgs = {
  id: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryProductionLeadTimesArgs = {
  quoteModelRevisionId: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryProjectArgs = {
  id: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryPunchoutSessionArgs = {
  sessionId: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryPurchaseOrderArgs = {
  id: Scalars['String'];
};


/** Density information for a set of quotable materials */
export type QueryQmrLeadTimeContributionsArgs = {
  quoteModelRevisionId: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryQmrLeadTimeContributionsJsonArgs = {
  quoteModelRevisionId: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryQmrsGroupedByDfmCategoryArgs = {
  orderId: InputMaybe<Scalars['String']>;
  quoteId: InputMaybe<Scalars['UUID']>;
};


/** Density information for a set of quotable materials */
export type QueryQmrsInfoFilteredByHasDfmArgs = {
  orderId: InputMaybe<Scalars['String']>;
  quoteId: InputMaybe<Scalars['UUID']>;
};


/** Density information for a set of quotable materials */
export type QueryQuotabilityBlockersArgs = {
  quoteModelRevisionId: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryQuoteArgs = {
  id: Scalars['UUID'];
  showDeleted: InputMaybe<Scalars['Boolean']>;
  userId: InputMaybe<Scalars['Int']>;
};


/** Density information for a set of quotable materials */
export type QueryQuoteActivityArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  quoteId: InputMaybe<Scalars['String']>;
  showDetailedLogs?: InputMaybe<Scalars['Boolean']>;
};


/** Density information for a set of quotable materials */
export type QueryQuoteAttachmentRevisionArgs = {
  id: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryQuoteItemArgs = {
  id: Scalars['UUID'];
  showDeleted: InputMaybe<Scalars['Boolean']>;
};


/** Density information for a set of quotable materials */
export type QueryQuoteItemsForQmrArgs = {
  qmrId: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryQuoteModelArgs = {
  id: InputMaybe<Scalars['UUID']>;
  showDeleted: InputMaybe<Scalars['Boolean']>;
};


/** Density information for a set of quotable materials */
export type QueryQuoteModelRevisionArgs = {
  id: Scalars['UUID'];
  quoteId: InputMaybe<Scalars['UUID']>;
  showDeleted: InputMaybe<Scalars['Boolean']>;
};


/** Density information for a set of quotable materials */
export type QueryQuotePricePreviewArgs = {
  priceInput: PricingInput;
  userId: InputMaybe<Scalars['Int']>;
};


/** Density information for a set of quotable materials */
export type QueryQuotePricePreviewDownloadUrlArgs = {
  priceInput: PricingInput;
  userId: InputMaybe<Scalars['Int']>;
};


/** Density information for a set of quotable materials */
export type QueryRecommendedQuantitiesToHitDeliveryDateArgs = {
  currentEstimatedDeliveryDate: Scalars['Date'];
  desiredDeliveryDate: InputMaybe<Scalars['Date']>;
  quoteId: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryRecommendedQuantityToReduceLeadTimeArgs = {
  numDaysToReduceFromLeadTime: Scalars['Int'];
  quoteModelRevisionId: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QueryRevisionArgs = {
  id: Scalars['UUID'];
};


/** Density information for a set of quotable materials */
export type QuerySalesOrderArgs = {
  includeService?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};


/** Density information for a set of quotable materials */
export type QuerySalesOrderLineProductProcessesArgs = {
  filters: InputMaybe<ProductProcessFiltersInput>;
  salesOrderId: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QuerySalesOrderLinesArgs = {
  cursor: InputMaybe<Scalars['ENCODED_CURSOR']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderId: Scalars['String'];
  sort?: InputMaybe<Scalars['CreatedAtSortKey']>;
  statusNotIn?: InputMaybe<Array<Scalars['String']>>;
};


/** Density information for a set of quotable materials */
export type QuerySalesOrderWithUnbundledPartsArgs = {
  filters: InputMaybe<SchedulingSalesOrdersFiltersInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  sort: InputMaybe<Array<SortTypeInput>>;
};


/** Density information for a set of quotable materials */
export type QuerySalesOrdersArgs = {
  filters: InputMaybe<SalesOrdersFiltersInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<AllowedSalesOrderSort>;
};


/** Density information for a set of quotable materials */
export type QuerySchedulingQueueArgs = {
  jobId: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QuerySchedulingQueuesByStatusArgs = {
  status: SchedulingQueueStatus;
};


/** Density information for a set of quotable materials */
export type QuerySecondaryProcessPricingCalculatorArgs = {
  quantity: Scalars['Int'];
  quoteFields: PricingQuoteFieldsInput;
};


/** Density information for a set of quotable materials */
export type QueryShipmentArgs = {
  id: Scalars['String'];
};


/** Density information for a set of quotable materials */
export type QueryShoresArgs = {
  materialId: Scalars['String'];
};


/** Density information for a set of quotable materials */
export type QueryTaxArgs = {
  zip: Scalars['String'];
};


/** Density information for a set of quotable materials */
export type QueryTeamArgs = {
  teamId: Scalars['Int'];
  userId: InputMaybe<Scalars['Int']>;
};


/** Density information for a set of quotable materials */
export type QueryTeamOrdersArgs = {
  filters: InputMaybe<TeamQuoteAndOrderFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<TeamQuotesAndOrdersSortInput>;
  teamId: Scalars['Int'];
  userId: InputMaybe<Scalars['Int']>;
};


/** Density information for a set of quotable materials */
export type QueryTeamQuotesArgs = {
  filters: InputMaybe<TeamQuoteAndOrderFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<TeamQuotesSortOrder>;
  teamId: Scalars['Int'];
  userId: InputMaybe<Scalars['Int']>;
};


/** Density information for a set of quotable materials */
export type QueryTeamSpendByTimeArgs = {
  dateRange: DateRangeInput;
  teamId: Scalars['Int'];
  timezoneOffset: InputMaybe<Scalars['Int']>;
  userId: InputMaybe<Scalars['Int']>;
};


/** Density information for a set of quotable materials */
export type QueryTeamsArgs = {
  filters: InputMaybe<TeamsFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<TeamsQuerySortInput>;
};


/** Density information for a set of quotable materials */
export type QueryTexturesArgs = {
  processId: Scalars['String'];
};


/** Density information for a set of quotable materials */
export type QueryUserArgs = {
  id: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QueryUserEnteredMaterialsArgs = {
  userId: Scalars['Int'];
};


/** Density information for a set of quotable materials */
export type QueryUserTeamMembersArgs = {
  filters: InputMaybe<UserTeamMembersFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<UserTeamMembersQuerySortInput>;
};


/** Density information for a set of quotable materials */
export type QueryValidateZipArgs = {
  countryCode: Scalars['String'];
  zipCode: Scalars['String'];
};


/** Density information for a set of quotable materials */
export type QueryVerifyShippingAddressArgs = {
  selectedAddressInput: SelectedAddressInput;
};

/** A collection of models that can get priced */
export type Quote = {
  __typename: 'Quote';
  activity: PartialProjectActivityResults;
  approvedAt: Maybe<Scalars['Date']>;
  approvedBy: Maybe<Scalars['Int']>;
  archivedAt: Maybe<Scalars['Date']>;
  archivedBy: Maybe<Scalars['Int']>;
  beganCheckoutAt: Maybe<Scalars['Date']>;
  bomSpecAttachment: Maybe<QuoteAttachment>;
  businessAccountDiscount: Maybe<BusinessAccountDiscount>;
  contactPhoneNumber: Maybe<Scalars['String']>;
  /** @deprecated will not be supported in future */
  cpqQuote: Maybe<CpqQuote>;
  createdAt: Scalars['Date'];
  deletedAt: Maybe<Scalars['Date']>;
  depositInCents: Maybe<Scalars['Int']>;
  description: Maybe<Scalars['String']>;
  dfmAssets: PartialAssetResults;
  /** @deprecated Use dfmAssets field instead. */
  dfmReports: PartialQuoteAttachmentResults;
  earliestValidUntilDate: Maybe<Scalars['Date']>;
  expiration: Maybe<Scalars['Date']>;
  hasITARRestrictions: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  imQuoteRequirements: Maybe<ImQuoteRequirements>;
  internal: Scalars['Boolean'];
  /** Invites to this quote or null if you are not permitted */
  invites: Maybe<PartialInviteResults>;
  isCpqOwned: Maybe<Scalars['Boolean']>;
  isCpqQuote: Maybe<Scalars['Boolean']>;
  isEligibleForFreeShipping: Maybe<Scalars['Boolean']>;
  isExpired: Scalars['Boolean'];
  isFlexiblePriceQuote: Scalars['Boolean'];
  isLocked: Maybe<Scalars['Boolean']>;
  isMoldRepair: Maybe<Scalars['Boolean']>;
  isOverseasShipping: Scalars['Boolean'];
  isQuoteIMReorder: Scalars['Boolean'];
  isQuoteInRfqState: Scalars['Boolean'];
  isQuotePriceMatchedReorder: Scalars['Boolean'];
  isQuotePublishable: Maybe<Scalars['Boolean']>;
  isQuotePurchasable: Scalars['Boolean'];
  isTaxExempt: Maybe<Scalars['Boolean']>;
  /**
   * Represents the time of the most recent action that a user took that
   * effects the quote, including but not limited to: adding or removing parts
   * backed by the project_activities table
   */
  lastModified: Maybe<Scalars['Date']>;
  members: PartialMembershipResults;
  /** Represents the portion of the subtotal attributable to the tools in a quote */
  moldToolSubtotalInCents: Maybe<Scalars['Int']>;
  molds: Maybe<Array<MoldTool>>;
  name: Scalars['String'];
  needByDate: Maybe<Scalars['Date']>;
  notesToCustomer: Maybe<Scalars['String']>;
  numberOfParts: Scalars['Int'];
  openEndedInviteUrl: Maybe<Scalars['String']>;
  openEndedQuoteInviteUrl: Maybe<Scalars['String']>;
  orderName: Maybe<Scalars['String']>;
  overviewResponses: Maybe<Scalars['JSON']>;
  /** Represents the sum of all parts and tools in the quote that are currently priced */
  partialSubTotalInCents: Maybe<Scalars['Int']>;
  partsSummary: Scalars['JSON'];
  /** @deprecated Use combination of orderName and purchaseInfo instead */
  platformOrder: Maybe<PlatformOrder>;
  pricingEstimateAttachment: Maybe<QuoteAttachment>;
  /** Represents the portion of the subtotal attributable to the production parts in a quote */
  productionPartsSubtotalInCents: Maybe<Scalars['Int']>;
  project: Maybe<BasicProject>;
  /** Contains information about purchase user and the date */
  purchaseInfo: Maybe<BasicPurchaseInfo>;
  purchasedAt: Maybe<Scalars['Date']>;
  purchasedBy: Maybe<Scalars['Int']>;
  quoteAttachments: PartialQuoteAttachmentResults;
  quoteItems: PartialQuoteItemResults;
  quoteLevelLeadTimesAndSubTotalInCents: Maybe<QuoteLevelLeadTimesAndPrices>;
  quoteLevelLeadTimesWithShippingOptions: Maybe<QuoteLevelLeadTimesAndPrices>;
  quoteModels: PartialQuoteModelResults;
  quoteProperties: Maybe<Array<QuoteProperty>>;
  releasedAt: Maybe<Scalars['Date']>;
  releasedBy: Maybe<Scalars['Int']>;
  reorderSourceOrderName: Maybe<Scalars['String']>;
  requestedAt: Maybe<Scalars['Date']>;
  requestedBy: Maybe<Scalars['Int']>;
  requirements: PartialRequirementResults;
  rfqNotes: Maybe<Scalars['String']>;
  salesRep: Maybe<User>;
  sentToPunchoutAt: Maybe<Scalars['Date']>;
  sfdcUrl: Maybe<Scalars['String']>;
  /** @deprecated use shippingOptionsNew with proper type */
  shippingOptions: Scalars['JSON'];
  shippingOptionsNew: QuoteShippingOptions;
  /** @deprecated use slowestShipDateEstimate, adding combined slowest delivery and shipping dates isn't needed anymore */
  slowestDatesEstimate: QuoteSlowestDatesEstimate;
  slowestShipDateEstimate: Maybe<Scalars['Date']>;
  sourceQuoteId: Maybe<Scalars['UUID']>;
  sourceQuoteName: Maybe<Scalars['String']>;
  status: Scalars['String'];
  subTotalInCents: Maybe<Scalars['Int']>;
  summaryStatus: Scalars['String'];
  team: Maybe<Team>;
  type: QuoteType;
  updatedAt: Scalars['Date'];
  user: BasicUser;
  weights: Maybe<QuoteWeights>;
  zipCode: Maybe<Scalars['String']>;
};


/** A collection of models that can get priced */
export type QuoteActivityArgs = {
  cursor: InputMaybe<Scalars['ENCODED_CURSOR']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['CreatedAtSortKey']>;
};


/** A collection of models that can get priced */
export type QuoteDfmAssetsArgs = {
  cursor: InputMaybe<Scalars['ENCODED_CURSOR']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['CreatedAtSortKey']>;
};


/** A collection of models that can get priced */
export type QuoteDfmReportsArgs = {
  cursor: InputMaybe<Scalars['ENCODED_CURSOR']>;
  limit?: InputMaybe<Scalars['Int']>;
  showDeleted: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['CreatedAtSortKey']>;
};


/** A collection of models that can get priced */
export type QuoteInvitesArgs = {
  cursor: InputMaybe<Scalars['ENCODED_CURSOR']>;
  limit?: InputMaybe<Scalars['Int']>;
  showOpenEnded: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['CreatedAtSortKey']>;
};


/** A collection of models that can get priced */
export type QuoteMembersArgs = {
  cursor: InputMaybe<Scalars['ENCODED_CURSOR']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['CreatedAtSortKey']>;
};


/** A collection of models that can get priced */
export type QuoteNumberOfPartsArgs = {
  showDeleted: InputMaybe<Scalars['Boolean']>;
};


/** A collection of models that can get priced */
export type QuoteOpenEndedInviteUrlArgs = {
  senderId: InputMaybe<Scalars['Int']>;
};


/** A collection of models that can get priced */
export type QuoteOpenEndedQuoteInviteUrlArgs = {
  senderId: InputMaybe<Scalars['Int']>;
  utmCampaign: InputMaybe<UtmCampaignType>;
};


/** A collection of models that can get priced */
export type QuoteQuoteAttachmentsArgs = {
  cursor: InputMaybe<Scalars['ENCODED_CURSOR']>;
  limit?: InputMaybe<Scalars['Int']>;
  showDeleted: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['CreatedAtSortKey']>;
};


/** A collection of models that can get priced */
export type QuoteQuoteItemsArgs = {
  cursor: InputMaybe<Scalars['ENCODED_CURSOR']>;
  limit?: InputMaybe<Scalars['Int']>;
  showDeleted: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['CreatedAtSortKey']>;
};


/** A collection of models that can get priced */
export type QuoteQuoteLevelLeadTimesWithShippingOptionsArgs = {
  address: InputMaybe<AddressInput>;
};


/** A collection of models that can get priced */
export type QuoteQuoteModelsArgs = {
  cursor: InputMaybe<Scalars['ENCODED_CURSOR']>;
  limit?: InputMaybe<Scalars['Int']>;
  showDeleted: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['CreatedAtSortKey']>;
};


/** A collection of models that can get priced */
export type QuoteRequirementsArgs = {
  cursor: InputMaybe<Scalars['ENCODED_CURSOR']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['CreatedAtSortKey']>;
};


/** A collection of models that can get priced */
export type QuoteShippingOptionsArgs = {
  address: InputMaybe<AddressInput>;
  carrier: InputMaybe<Carrier>;
  sampleOnly: InputMaybe<Scalars['Boolean']>;
  shippingCalculatorOverrides: InputMaybe<ShippingCalculatorOverridesInput>;
  specifiedQuoteModelRevisions: InputMaybe<Array<Scalars['UUID']>>;
};


/** A collection of models that can get priced */
export type QuoteShippingOptionsNewArgs = {
  address: InputMaybe<AddressInput>;
  carrier: InputMaybe<Carrier>;
  sampleOnly: InputMaybe<Scalars['Boolean']>;
  shippingCalculatorOverrides: InputMaybe<ShippingCalculatorOverridesInput>;
  specifiedQuoteModelRevisions: InputMaybe<Array<Scalars['UUID']>>;
};


/** A collection of models that can get priced */
export type QuoteSubTotalInCentsArgs = {
  includeUnpublishedParts?: InputMaybe<Scalars['Boolean']>;
};


/** A collection of models that can get priced */
export type QuoteWeightsArgs = {
  shippingCalculatorOverrides: InputMaybe<ShippingCalculatorOverridesInput>;
};

/** An object representing data about quotes we want to sync */
export type QuoteActivityForSyncing = {
  __typename: 'QuoteActivityForSyncing';
  quoteId: Scalars['UUID'];
  timestamp: Scalars['Date'];
};

/** Associates an attachment to a quote. */
export type QuoteAttachment = {
  __typename: 'QuoteAttachment';
  /** @deprecated Field no longer supported. Use 'latestAttachmentRevision' instead. */
  attachment: Maybe<Attachment>;
  attachmentRevisions: PartialQuoteAttachmentRevisionResults;
  createdAt: Scalars['Date'];
  id: Scalars['UUID'];
  latestAttachmentRevision: QuoteAttachmentRevision;
  quote: Quote;
  type: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
};


/** Associates an attachment to a quote. */
export type QuoteAttachmentAttachmentRevisionsArgs = {
  cursor: InputMaybe<Scalars['ENCODED_CURSOR']>;
  limit?: InputMaybe<Scalars['Int']>;
};

/** The revisions of a quote attachment */
export type QuoteAttachmentRevision = {
  __typename: 'QuoteAttachmentRevision';
  asset: Maybe<Asset>;
  attachment: Maybe<Attachment>;
  createdAt: Scalars['Date'];
  id: Scalars['UUID'];
  quoteAttachment: QuoteAttachment;
  updatedAt: Scalars['Date'];
  version: Scalars['Int'];
};

/** Quote attributes that can be used to filter quote results */
export enum QuoteAttributeFilterType {
  SECURE_PLUS = 'SECURE_PLUS'
}

/** Input fields for a quote record. */
export type QuoteInput = {
  description: InputMaybe<Scalars['String']>;
  isMoldRepair: InputMaybe<Scalars['Boolean']>;
  name: InputMaybe<Scalars['String']>;
  rfqNotes: InputMaybe<Scalars['String']>;
  zipCode: InputMaybe<Scalars['String']>;
};

/** Represents a collection of QuoteItem on Quote */
export type QuoteItem = {
  __typename: 'QuoteItem';
  cost: Maybe<Scalars['Int']>;
  createdAt: Scalars['Date'];
  createdBy: Scalars['Int'];
  deletedAt: Scalars['String'];
  deletedBy: Scalars['Int'];
  expirationDate: Maybe<Scalars['Date']>;
  id: Scalars['UUID'];
  leadTimeDays: Maybe<Scalars['Int']>;
  modelConfigurationDfmInspectionActivityId: Maybe<Scalars['UUID']>;
  moldToolRevisionId: Maybe<Scalars['String']>;
  price: Maybe<Scalars['Int']>;
  priorityId: Maybe<Scalars['String']>;
  qmrState: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
  quote: Quote;
  quoteId: Maybe<Scalars['UUID']>;
  quoteModelRevision: QuoteModelRevision;
  quoteModelRevisions: Array<QuoteModelRevision>;
  type: Scalars['String'];
  updateBy: Scalars['Int'];
  updatedAt: Scalars['Date'];
};

/** Result of quote level lead times and prices option. */
export type QuoteLevelLeadTimeAndPriceOption = {
  __typename: 'QuoteLevelLeadTimeAndPriceOption';
  /** @deprecated no need on client side */
  deliverByDate: Maybe<Scalars['Date']>;
  leadTimes: Maybe<Array<Scalars['Int']>>;
  shipByDate: Maybe<Scalars['Date']>;
  shippingOptions: Maybe<Array<ShippingOptionItemType>>;
  subTotalInCents: Maybe<Scalars['Int']>;
};

/** Result of quote level lead times and prices. */
export type QuoteLevelLeadTimesAndPrices = {
  __typename: 'QuoteLevelLeadTimesAndPrices';
  domesticCostEffective: Maybe<QuoteLevelLeadTimeAndPriceOption>;
  domesticFastest: Maybe<QuoteLevelLeadTimeAndPriceOption>;
  domesticStandard: Maybe<QuoteLevelLeadTimeAndPriceOption>;
  overseasCostEffective: Maybe<QuoteLevelLeadTimeAndPriceOption>;
  overseasFastest: Maybe<QuoteLevelLeadTimeAndPriceOption>;
  overseasStandard: Maybe<QuoteLevelLeadTimeAndPriceOption>;
};

/** Types for quote level lead times region */
export enum QuoteLevelLeadTimesRegion {
  DOMESTIC = 'DOMESTIC',
  OVERSEAS = 'OVERSEAS'
}

/** Represents a collection of QuoteModelRevisions on a Quote */
export type QuoteModel = {
  __typename: 'QuoteModel';
  createdAt: Scalars['Date'];
  deletedAt: Maybe<Scalars['Date']>;
  id: Scalars['UUID'];
  quote: Maybe<Quote>;
  quoteModelRevisions: Array<QuoteModelRevision>;
  selectedQuoteModelRevision: QuoteModelRevision;
  updatedAt: Scalars['Date'];
};

/** QuoteModelRevision */
export type QuoteModelRevision = {
  __typename: 'QuoteModelRevision';
  annotatedDrawing: Maybe<AnnotatedDrawingAttachment>;
  annotations: Array<Annotation>;
  assetBundleAttachments: Maybe<PartialAssetBundleResults>;
  attachmentLink: Maybe<QuoteModelRevisionAttachment>;
  canBeExclusiveToSingleQuote: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['Date'];
  deletedAt: Maybe<Scalars['Date']>;
  dfmFeedback: Array<DfmFeedback>;
  dfmFeedbackCount: Scalars['Int'];
  dfmReports: Array<PartDfmReport>;
  drawingRequirements: Array<Scalars['String']>;
  erpMoldTool: Maybe<ErpMoldTool>;
  fictivSupportingDocTemplateUrl: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  flags: Maybe<Array<Maybe<QmrFlag>>>;
  holes: Array<Hole>;
  id: Scalars['UUID'];
  isExclusiveToSingleQuote: Maybe<Scalars['Boolean']>;
  isITARProhibitedViewing: Maybe<Scalars['Boolean']>;
  manufacturingDrawing: Maybe<ManufacturingDrawing>;
  modelConfiguration: Maybe<ModelConfiguration>;
  mold: Maybe<MoldTool>;
  partRevision: Revision;
  processesDetails: Maybe<QmrProcessesDetails>;
  quantityRangeStatus: Maybe<Scalars['String']>;
  quoteModel: QuoteModel;
  reorderSourceLeadTimeInDays: Maybe<Scalars['Int']>;
  revisionNotes: Maybe<Scalars['String']>;
  similarQuoteModelRevisions: Array<QuoteModelRevision>;
  sourceQuoteModelRevisionId: Maybe<Scalars['UUID']>;
  state: QuoteModelRevisionState;
  supportedPriorityRegions: SupportedPriorityRegions;
  taps: Array<TapAnnotation>;
  updatedAt: Scalars['Date'];
  uploadUrl: Maybe<Scalars['String']>;
  version: Scalars['String'];
};


/** QuoteModelRevision */
export type QuoteModelRevisionDfmFeedbackArgs = {
  includeDraft?: InputMaybe<Scalars['Boolean']>;
};


/** QuoteModelRevision */
export type QuoteModelRevisionDfmFeedbackCountArgs = {
  includeDraft?: InputMaybe<Scalars['Boolean']>;
};

/** Associates an QuoteModelRevision with a QuoteAttachemntRevision. */
export type QuoteModelRevisionAttachment = {
  __typename: 'QuoteModelRevisionAttachment';
  createdAt: Scalars['Date'];
  id: Scalars['UUID'];
  isPdfOcrAutoQuotable: Maybe<Scalars['Boolean']>;
  quoteAttachmentRevision: QuoteAttachmentRevision;
  quoteModelRevision: QuoteModelRevision;
  updatedAt: Scalars['Date'];
};

/** Input for filtering list of QuoteModelRevisions */
export type QuoteModelRevisionFiltersInput = {
  dfmStatus: InputMaybe<DfmStatus>;
  fileName: InputMaybe<Scalars['String']>;
  materialId: InputMaybe<Scalars['String']>;
  processId: InputMaybe<Scalars['String']>;
  quoteName: InputMaybe<Scalars['String']>;
  quoteRequestedBy: InputMaybe<Scalars['String']>;
  quoteStatus: InputMaybe<Scalars['String']>;
  quotedBy: InputMaybe<Scalars['Int']>;
  skipOnHoldQuotes: InputMaybe<Scalars['String']>;
};

/** States for a quote model revision to be in */
export enum QuoteModelRevisionState {
  deleted = 'deleted',
  error = 'error',
  needs_configuration = 'needs_configuration',
  needs_rfq = 'needs_rfq',
  not_manufacturable = 'not_manufacturable',
  processing = 'processing',
  purchasable = 'purchasable',
  registered = 'registered',
  unresolved_dfm = 'unresolved_dfm'
}

/** Input for uploading a new quote model QuoteModelRevision */
export type QuoteModelRevisionUploadInput = {
  contentType: Scalars['String'];
  fileName: Scalars['String'];
  fileSize: Scalars['Int'];
  referenceId: Scalars['UUID'];
  units: InputMaybe<Scalars['String']>;
};

/** Determined the price breakdown for a quote */
export type QuotePricePreview = {
  __typename: 'QuotePricePreview';
  depositAmountInCents: Maybe<Scalars['Int']>;
  discountAmountInCents: Maybe<Scalars['Int']>;
  discountCode: Maybe<Scalars['String']>;
  discountErrorMessage: Maybe<Scalars['String']>;
  discountPercent: Maybe<Scalars['String']>;
  discountSource: Maybe<Scalars['String']>;
  samplesShippingAmountInCents: Maybe<Scalars['Int']>;
  shippingAmountInCents: Maybe<Scalars['Int']>;
  subTotalAmountInCents: Maybe<Scalars['Int']>;
  taxAmountInCents: Maybe<Scalars['Int']>;
  totalAmountInCents: Maybe<Scalars['Int']>;
};

/** type for quote properties */
export type QuoteProperty = {
  __typename: 'QuoteProperty';
  name: Scalars['String'];
  value: Scalars['String'];
};

/** Input fields for customization of emails on Quote release */
export type QuoteReadyEmailInput = {
  emailFrom: Scalars['String'];
  emailNotes: InputMaybe<Scalars['String']>;
  emailSubject: Scalars['String'];
  emailTo: Scalars['String'];
  emailsCC: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Type of quotes shipping options item */
export type QuoteShippingOptionItemType = {
  __typename: 'QuoteShippingOptionItemType';
  cost: Maybe<Scalars['Int']>;
  deliveredByDate: Maybe<Scalars['Date']>;
  deliveryDays: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  name: Scalars['String'];
  productionPartsCost: Maybe<Scalars['Int']>;
  quoteToken: Maybe<Scalars['String']>;
  samplesCost: Maybe<Scalars['Int']>;
};

/** Type of quotes shipping options */
export type QuoteShippingOptions = {
  __typename: 'QuoteShippingOptions';
  items: Maybe<Array<QuoteShippingOptionItemType>>;
};

/** Represents slowest shipDate or calculated based on that deliver date */
export type QuoteSlowestDatesEstimate = {
  __typename: 'QuoteSlowestDatesEstimate';
  deliverDate: Maybe<Scalars['Date']>;
  shipDate: Maybe<Scalars['Date']>;
};

/** Quote Team memberships map individual quote to a team in a business account */
export type QuoteTeamMembership = {
  __typename: 'QuoteTeamMembership';
  createdAt: Scalars['Date'];
  createdBy: BasicUser;
  deletedAt: Maybe<Scalars['Date']>;
  deletedBy: Maybe<BasicUser>;
  id: Scalars['Int'];
  quoteId: Scalars['UUID'];
  teamId: Scalars['Int'];
  updatedAt: Scalars['Date'];
  updatedBy: BasicUser;
};

/** Types for quote */
export enum QuoteType {
  generic = 'generic',
  im = 'im'
}

/** Container for Quote or BasicQuote type */
export type QuoteView = BasicQuote | Quote;

/** type for quote weights */
export type QuoteWeights = {
  __typename: 'QuoteWeights';
  actualWeight: Maybe<Scalars['Float']>;
  dimensionalWeight: Maybe<Scalars['Float']>;
  shippingWeight: Maybe<Scalars['Float']>;
};

/** Input for DfmInspection quoted fixturing method */
export type QuotedFixturingMethodsInput = {
  mill: InputMaybe<Scalars['String']>;
};

/** Input field for Rawbox */
export type RawBoxInput = {
  boundingBox: InputMaybe<SanitizationBoundingBoxInput>;
  isFictiv: InputMaybe<Scalars['Boolean']>;
  trnAnnotNoMove: InputMaybe<Scalars['Boolean']>;
  userName: InputMaybe<Scalars['String']>;
};

/** The the data that pdfocr scrapes out of a document that admins need for quoting */
export type RawPdfOcrJson = {
  __typename: 'RawPdfOcrJson';
  autoQuotableBlockers: Maybe<Array<Scalars['String']>>;
  finishingNotes: Maybe<Array<Scalars['String']>>;
  finishingNotesWithBoundingBoxes: Maybe<Array<Maybe<NoteWithBoundingBox>>>;
  foundThreadNames: Maybe<Array<Scalars['String']>>;
  measurementUnits: Maybe<Scalars['String']>;
  minOneSidedTolerance: Maybe<Scalars['String']>;
  minTwoSidedTolerance: Maybe<Scalars['String']>;
  numTightTolerances: Maybe<Scalars['Int']>;
  numVeryTightTolerances: Maybe<Scalars['Int']>;
  rawAnalysis: Maybe<Scalars['JSON']>;
  requiresCertificateOfConformance: Maybe<Scalars['Boolean']>;
  requiresMaterialCertificate: Maybe<Scalars['Boolean']>;
  toleranceBlocks: Maybe<Array<ToleranceBlockData>>;
};

/** enum for possible values of reason to skip queue item */
export enum ReasonToSkipQueueItem {
  mp_non_job_accepting_hours = 'mp_non_job_accepting_hours',
  mp_not_eligible_to_work = 'mp_not_eligible_to_work',
  mp_unavailable = 'mp_unavailable'
}

/** Recommended MP sequence, probability and payout for job */
export type RecommendedMp = {
  __typename: 'RecommendedMp';
  jobAcceptanceProbability: Maybe<Scalars['Float']>;
  jobLines: Array<RecommendedMpJobLine>;
  jobOTIFProbability: Maybe<Scalars['Float']>;
  mfgPartner: BasicMfgPartner;
  sequence: Scalars['Int'];
  totalPayout: Scalars['Float'];
};

/** Recommended MP probability and payout for job line */
export type RecommendedMpJobLine = {
  __typename: 'RecommendedMpJobLine';
  acceptanceProbability: Maybe<Scalars['Float']>;
  lineId: Scalars['Int'];
  otifProbability: Maybe<Scalars['Float']>;
  unitPayoutAmount: Scalars['Float'];
};

/** Recommended MPs for Job */
export type RecommendedMpsForJob = {
  __typename: 'RecommendedMpsForJob';
  job: Job;
  minimumEligibilityMps: Maybe<Array<MinimumEligibilityMp>>;
  mpSuggestions: Maybe<Array<RecommendedMp>>;
  recommendedRequestId: Scalars['Int'];
  shiftingAttributes: Maybe<Array<RecommendedMpsShiftingAttribute>>;
  version: Scalars['String'];
};

/** Input for filtering list of recommended MPs for job */
export type RecommendedMpsForJobFiltersInput = {
  maxX: InputMaybe<Scalars['Float']>;
  maxY: InputMaybe<Scalars['Float']>;
  maxZ: InputMaybe<Scalars['Float']>;
  minLeadTime: InputMaybe<Scalars['Int']>;
  minPayout: InputMaybe<Scalars['Float']>;
  minQuantity: InputMaybe<Scalars['Int']>;
  minX: InputMaybe<Scalars['Float']>;
  minY: InputMaybe<Scalars['Float']>;
  minZ: InputMaybe<Scalars['Float']>;
  priority: InputMaybe<RecommendedMpspPriorityTypes>;
  region: InputMaybe<RecommendedMpsRegionTypes>;
  setups: InputMaybe<Scalars['Int']>;
  shiftingAttributes: InputMaybe<Array<InputMaybe<RecommendedMpsShiftingAttributesInput>>>;
};

/** Enum for recommended MPs region type */
export enum RecommendedMpsRegionTypes {
  DOMESTIC = 'DOMESTIC',
  OVERSEAS = 'OVERSEAS'
}

/** Recommended MPs shifting attributes type */
export type RecommendedMpsShiftingAttribute = {
  __typename: 'RecommendedMpsShiftingAttribute';
  attributeName: Scalars['String'];
  value: Scalars['Boolean'];
};

/** Input for recommended MPs shifting attributes type */
export type RecommendedMpsShiftingAttributesInput = {
  attributeName: Scalars['String'];
  value: Scalars['Boolean'];
};

/** Enum for recommended MPs priority type */
export enum RecommendedMpspPriorityTypes {
  NORMAL = 'NORMAL',
  URGENT = 'URGENT',
  VERY_URGENT = 'VERY_URGENT'
}

/** A quantity, integer, that would be able to hit a customer's specified need-by date given their configuration */
export type RecommendedQuantityToReduceLeadTime = {
  __typename: 'RecommendedQuantityToReduceLeadTime';
  qty: Scalars['Int'];
  quoteModelRevisionId: Scalars['UUID'];
  success: Scalars['Boolean'];
};

/** Enum for calculation record type */
export enum RecordType {
  active = 'active',
  weekly = 'weekly'
}

/** Admin only model for getting regional price for every qmr */
export type RegionalPrices = {
  __typename: 'RegionalPrices';
  china: Maybe<BuilderAndMpPrice>;
  india: Maybe<BuilderAndMpPrice>;
  usa: Maybe<BuilderAndMpPrice>;
};

/** Response when removing a business account */
export type RemoveBusinessAccountResponse = {
  __typename: 'RemoveBusinessAccountResponse';
  id: Scalars['UUID'];
  successful: Scalars['Boolean'];
};

/** Container representing successful and unsuccessful attempts to remove Member from a Team */
export type RemoveUserTeamMemberResult = {
  __typename: 'RemoveUserTeamMemberResult';
  /** email that was requested to be removed from the team */
  email: Scalars['String'];
  /** Failure reason why it was not possible to remove the user/email from the team */
  failureReason: Maybe<Scalars['String']>;
  /** Boolean representing if the requested email was successfully removed from the team */
  removed: Scalars['Boolean'];
};

/** Reorder Eligibity with reasaon for ineligibity */
export type ReorderEligibility = {
  __typename: 'ReorderEligibility';
  eligible: Scalars['Boolean'];
  ineligibilityReason: Maybe<Scalars['String']>;
};

/** Input data required for reporting delay */
export type ReportDelayInput = {
  exceptionId: InputMaybe<Scalars['UUID']>;
  jobRequestId: Scalars['Int'];
  milestoneType: MilestoneType;
  mpSuggestedDate: Scalars['Date'];
  products: InputMaybe<Array<ExceptionPartDetailInput>>;
};

/** production and inspection status */
export enum ReportState {
  completed = 'completed',
  in_progress = 'in_progress',
  pending = 'pending'
}

/** Input for reprocess parameters */
export type ReprocessParametersInput = {
  imPullDirectionOverride: InputMaybe<Array<Scalars['Float']>>;
  reprocess: InputMaybe<Scalars['Boolean']>;
};

/** Result for requestImEstimateSlackNotification mutation */
export type RequestImEstimateSlackNotification = {
  __typename: 'RequestImEstimateSlackNotification';
  qmrId: Maybe<Scalars['UUID']>;
};

/** Response type of mutation requestBusinessAccountInvites */
export type RequestInviteResult = {
  __typename: 'RequestInviteResult';
  email: Scalars['String'];
  failureReason: Maybe<Scalars['String']>;
  invite: Maybe<BusinessAccountInvite>;
};

/** Container representing the result of requesting access to a team */
export type RequestTeamAccessResult = {
  __typename: 'RequestTeamAccessResult';
  /** BusinessAccountId to which the team belongs */
  businessAccountId: Scalars['String'];
  /** Timestamp when the request was created */
  createdAt: Scalars['Date'];
  /** UserId of who created the request */
  createdBy: Scalars['Int'];
  /** email of the user for whom the team access was requested */
  email: Scalars['String'];
  /** ID of the team for which the user requested access */
  teamId: Scalars['Int'];
  /** name of the team for which the user requested access */
  teamName: Scalars['String'];
  /** Type indicating the kind of request created */
  type: Maybe<Scalars['String']>;
  /** Timestamp when the request was last updated */
  updatedAt: Scalars['Date'];
  /** UserId of who updated the request last */
  updatedBy: Scalars['Int'];
  /** userId of the user for whom the team access was requested */
  userId: Scalars['Int'];
};

/** A Requirement associated with a set of Annotations and Revisions */
export type Requirement = {
  __typename: 'Requirement';
  agreedAt: Maybe<Scalars['Date']>;
  agreedBy: Maybe<BasicUser>;
  archivedAt: Maybe<Scalars['Date']>;
  archivedBy: Maybe<BasicUser>;
  body: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  deletedAt: Maybe<Scalars['Date']>;
  deletedBy: Maybe<BasicUser>;
  displayId: Scalars['String'];
  id: Scalars['UUID'];
  quote: Quote;
  safeBody: Maybe<Scalars['String']>;
  targets: Array<RequirementTarget>;
  threads: Array<Thread>;
  title: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy: Maybe<BasicUser>;
  user: BasicUser;
};

/**
 * An Annotation or a Revision associated with a Requirement
 * Revision and Attachment are deprecated target types
 */
export type RequirementTarget = Annotation | Attachment | QuoteAttachmentRevision | QuoteModelRevision | Revision;

/** Input for creating a Requirement */
export type RequirementTargetInput = {
  targetId: Scalars['UUID'];
  targetType: AllowedRequirementTarget;
};

/** Type of ResponseFromEchatApi to indicate new slack thread started for particular quote */
export type ResponseFromEchatApi = {
  __typename: 'ResponseFromEchatApi';
  url: Maybe<Scalars['String']>;
};

/** A user's model represented by a uploaded revision. */
export type Revision = {
  __typename: 'Revision';
  analysisErrorCode: Maybe<Scalars['String']>;
  /** @deprecated Annotations moved to QuoteModelRevision */
  annotations: Array<Annotation>;
  boundingBox: Maybe<Vector3>;
  cleanDownloadUri: Maybe<Scalars['String']>;
  cleanedModelContentType: Maybe<Scalars['String']>;
  cleanedModelFileName: Maybe<Scalars['String']>;
  cleanedModelFileSize: Maybe<Scalars['Int']>;
  createdAt: Scalars['Date'];
  /** @deprecated Field moved to QuoteModelRevision */
  description: Maybe<Scalars['String']>;
  downloadUri: Maybe<Scalars['String']>;
  drawingImages: Maybe<Array<Maybe<DrawingImage>>>;
  /** @deprecated Use scene instead */
  featureMappingUri: Maybe<Scalars['String']>;
  /** @deprecated Field no longer supported */
  id: Scalars['UUID'];
  images: Maybe<RevisionImages>;
  isMirror: Maybe<Scalars['Boolean']>;
  modelContentType: Maybe<Scalars['String']>;
  modelFileName: Maybe<Scalars['String']>;
  modelFileSize: Maybe<Scalars['Int']>;
  modelFileType: Maybe<Scalars['String']>;
  /** @deprecated Legacy field needed in Odoo. */
  partId: Maybe<Scalars['Int']>;
  patches: Array<RevisionPatch>;
  pipelineRequestData: Maybe<Scalars['JSON']>;
  processing: Maybe<Scalars['Boolean']>;
  rawAnalysis: Maybe<Scalars['JSON']>;
  /** @deprecated Field moved to QuoteModelRevision */
  revisionFolderAttachments: Array<RevisionFolderAttachment>;
  scene: Maybe<ViewerScene>;
  sceneBundle: Maybe<Scalars['JSON']>;
  status: Maybe<Scalars['String']>;
  surfaceArea: Maybe<Scalars['Float']>;
  thumbnailUri: Maybe<Scalars['String']>;
  units: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
  uri: Maybe<Scalars['String']>;
  /** @deprecated Field no longer supported */
  user: Maybe<BasicUser>;
  version: Scalars['String'];
  /** @deprecated Use scene instead */
  viewerUri: Maybe<Scalars['String']>;
  volume: Maybe<Scalars['Float']>;
  /** @deprecated Use scene instead */
  wallThicknessUri: Maybe<Scalars['String']>;
};

/** Associates an attachment with a revision. */
export type RevisionFolderAttachment = {
  __typename: 'RevisionFolderAttachment';
  createdAt: Scalars['Date'];
  id: Scalars['UUID'];
  quoteAttachment: QuoteAttachment;
  revision: Revision;
  updatedAt: Scalars['Date'];
};

/** Images associated with a revision. */
export type RevisionImages = {
  __typename: 'RevisionImages';
  angled: Maybe<Scalars['String']>;
  front: Maybe<Scalars['String']>;
  side: Maybe<Scalars['String']>;
  top: Maybe<Scalars['String']>;
};

/** Represents a geometric surface of a revision */
export type RevisionPatch = {
  __typename: 'RevisionPatch';
  id: Scalars['String'];
  parameters: Scalars['JSON'];
  type: Scalars['String'];
};

/** Possible Risk statuses for a job request */
export enum RiskStatus {
  at_risk = 'at_risk',
  completed = 'completed',
  not_available = 'not_available',
  not_started = 'not_started',
  on_track = 'on_track'
}

/** A user's role within the Fictiv application */
export type Role = {
  __typename: 'Role';
  createdAt: Scalars['Date'];
  id: Scalars['Int'];
  name: Maybe<Scalars['String']>;
  resourceId: Maybe<Scalars['Int']>;
  resourceType: Maybe<Scalars['String']>;
  source: RoleSourceType;
  updatedAt: Scalars['Date'];
};

/**
 * Possible user roles and capabilities
 *   Roles - Who is this user
 *   Capabilities - What can this user do
 *
 *   The assign_* roles should not be in this list
 *       assign_* roles are granted through SQL updates
 *
 *   To see descriptions of each role visit
 *       https://fictiv.atlassian.net/wiki/spaces/EN/pages/2521628824/Application+Roles
 *   Please update the above doc if you are adding a new role/capability
 *
 *   To see instructions on how to add new roles/capabilities visit
 *       https://fictiv.atlassian.net/wiki/spaces/EN/pages/2482962877/How+to+add+update+common+Users+to+environments
 *
 *   Keep these enum fields alphabetized
 */
export enum RoleAndCapabilities {
  /** Capabilities */
  activity_sync = 'activity_sync',
  business_admin = 'business_admin',
  costing_and_dfm = 'costing_and_dfm',
  cpq_api_user = 'cpq_api_user',
  /** Roles */
  customer = 'customer',
  dfm_feedback_editor = 'dfm_feedback_editor',
  employee = 'employee',
  enterprise = 'enterprise',
  exception_management_user = 'exception_management_user',
  featureflag_api_access = 'featureflag_api_access',
  instant_quoter_api_user = 'instant_quoter_api_user',
  itar_verified = 'itar_verified',
  mp = 'mp',
  mp_level_api_user = 'mp_level_api_user',
  operations_dri = 'operations_dri',
  pdf_generator_for_3d_dfm_api_user = 'pdf_generator_for_3d_dfm_api_user',
  project_admin = 'project_admin',
  quality_manager = 'quality_manager',
  reseller = 'reseller',
  scheduler_api_user = 'scheduler_api_user',
  scheduling_admin = 'scheduling_admin',
  supplier_quality_engineer = 'supplier_quality_engineer'
}

/** Enum for the allowed dfm annotation types */
export enum RoleSourceType {
  BUSINESS_ACCOUNT = 'BUSINESS_ACCOUNT',
  INDIVIDUAL = 'INDIVIDUAL'
}

/** SaleOrder Production country */
export type SaleOrderExtendedData = {
  __typename: 'SaleOrderExtendedData';
  erpSaleOrderId: Scalars['Int'];
  erpSaleOrderLineId: Scalars['Int'];
  productionCountry: Maybe<ProductionCountry>;
  schedulingDri: Maybe<BasicUser>;
};

/** Enum for user.salesForceAccountIdState */
export enum SalesForceAccountIdStateEnum {
  COMPANY_ACCOUNT = 'COMPANY_ACCOUNT',
  MASTER_GENERIC = 'MASTER_GENERIC',
  PENDING_SYNC = 'PENDING_SYNC'
}

/** Represents a list of orders placed by customer. */
export type SalesOrder = {
  __typename: 'SalesOrder';
  /** Order actual transaction margin */
  actualTransactionMargin: Maybe<Scalars['Float']>;
  /** Admin view of the Sales Order Lines */
  adminSalesOrderLines: Maybe<Array<SalesOrderLine>>;
  /** Applied businessAccountDiscount if there is any */
  appliedBusinessAccountDiscountPercent: Maybe<Scalars['Float']>;
  /** Business Unit */
  businessUnit: Maybe<Scalars['String']>;
  /** CAR count */
  carCount: Scalars['Int'];
  /** Committed delivery date */
  committedDeliveryDate: Maybe<Scalars['Date']>;
  /** Platform contract name */
  contract: Maybe<SalesOrderContract>;
  /** The date on which the order was placed. */
  createdAt: Scalars['Date'];
  /** Custoemr Company - Added for scheduling */
  customerCompanyName: Maybe<Scalars['String']>;
  /** Customer Name - Added for scheduling */
  customerName: Maybe<Scalars['String']>;
  /** The status would be decided based on the line items, and can have ('pending production','in production','shipped'). */
  deliveryStatus: Scalars['String'];
  /** Deposit Amount */
  depositAmount: Maybe<Scalars['Int']>;
  /** The uri to download the files attached to the order. */
  downloadAllFilesUri: Scalars['String'];
  /**
   * The uri to download the invoice.
   * Removing the constraint as per the request from Tim
   */
  downloadInvoiceUri: Maybe<Scalars['String']>;
  /** salesOrder drawing attachment count to display total number of files on download notification in Parts & attachments zip */
  drawingAttachmentsCount: Scalars['Int'];
  /** Promised ship date (earliest) */
  earliestPromisedShipDate: Maybe<Scalars['Date']>;
  /** Earliest planned schedule date - Added for scheduling */
  earliestScheduledDate: Maybe<Scalars['Date']>;
  /** Promised delivery date (earliest) */
  earliestScheduledDeliveryDate: Maybe<Scalars['Date']>;
  /**
   * Earliest planned ship date - Added for scheduling
   * @deprecated Use earliestPromisedShipDate instead
   */
  earliestShipDate: Maybe<Scalars['Date']>;
  /** Reorder source Sale Order Id */
  erpReorderSourceSaleOrderId: Maybe<Scalars['Int']>;
  /** Exception count */
  exceptionCount: Scalars['Int'];
  /** The estimated delivery date from checkout page */
  fictivEstimatedDeliveryDate: Maybe<Scalars['Date']>;
  /** Order modified Post sale */
  fictivOrderModifiedPostSale: Maybe<Scalars['Boolean']>;
  /** Incoterm change to DDP */
  fictivOrderUpdatedToDdp: Maybe<Scalars['Boolean']>;
  /** The user selected shipping method on checkout page */
  fictivShipmentMethod: Maybe<Scalars['String']>;
  /** A unique identifier */
  id: Scalars['String'];
  /** Is businessAccountDiscount applied on any of the part when user place the order */
  isBusinessAccountDiscountApplied: Maybe<Scalars['Boolean']>;
  /** Is it a IM re-order (placed using existing mold tool)? */
  isImReorder: Maybe<Scalars['Boolean']>;
  /** Is this a reorder from existing sale order? - Added for scheduling */
  isReorder: Maybe<Scalars['Boolean']>;
  /** Admin Odoo reorders are not allowed - False, Platform Orders - True */
  isReorderAllowed: Scalars['Boolean'];
  /** Claim status */
  isSalesOrderClaimed: Maybe<Scalars['Boolean']>;
  /** Jobs count */
  jobCount: Scalars['Int'];
  /** Promised delivery date (latest) */
  latestPromisedShipDate: Maybe<Scalars['Date']>;
  /** Order margin */
  margin: Maybe<Scalars['Float']>;
  /** MFG DRI */
  mfgDri: Maybe<BasicUser>;
  /** Unique, human readable name of this sale order.  Looks like "moose6377". */
  name: Scalars['String'];
  /** Ordered On */
  orderDate: Maybe<Scalars['Date']>;
  /** Sale order type */
  orderType: Maybe<OrderType>;
  /** Total Sale Order amount before discounts */
  originalTotalAmount: Scalars['Float'];
  /** The payment details. */
  paymentDetails: PaymentDetails;
  /** Sales priority */
  priority: Maybe<Scalars['String']>;
  /** Process lines for all the Sales Order Lines and their scheduling details */
  processLines: Maybe<Array<SalesOrderProcessLine>>;
  /** Sale order production countries */
  productionCountries: Maybe<Array<Maybe<ProductionCountry>>>;
  /** Basic meta about parent project, if exists */
  project: Maybe<BasicProject>;
  /** Order Project Tags */
  projectTags: Maybe<Array<Scalars['String']>>;
  quote: Maybe<SalesOrderQuote>;
  /** quote level dfm notes */
  quoteDfmNotes: Maybe<Scalars['String']>;
  /** Quote id if it is a platform quote */
  quoteId: Maybe<Scalars['String']>;
  /** Quote name */
  quoteName: Maybe<Scalars['String']>;
  /** quote level notes */
  quoteNotes: Maybe<Scalars['String']>;
  /** Owner of the quote */
  quoteOwnerUser: Maybe<BasicUser>;
  /** CPQ quote PDF URL needed for downloading Quote */
  quotePdfUrl: Maybe<Scalars['String']>;
  /** Production region */
  region: Maybe<Scalars['String']>;
  /** Reorder source Sale Order Name */
  reorderSourceSaleOrderName: Maybe<Scalars['String']>;
  /** Order revision */
  revision: Maybe<Scalars['Float']>;
  /** The list of line items associated to the sale order */
  salesOrderLines: PartialSalesOrderLineResults;
  /** scheduling DRI */
  schedulingDris: Maybe<Array<Maybe<BasicUser>>>;
  /** The list of shipments attached to the order. */
  shipments: Maybe<PartialShipmentResults>;
  /**
   * The date computed from the max expected delivery date of the delivery order.
   * TODO: This field has not yet been released. We don't have delivery dates in Odoo yet.
   * deliveryBy: Date!
   * The date computed from the max shipped on date of the delivery order.
   */
  shippedBy: Maybe<Scalars['Date']>;
  /** Checks Ordertype */
  sourceQuoteType: Maybe<QuoteType>;
  /** Team details if order is part of a Team */
  team: Maybe<Team>;
  /** Final Sale Order amount after discounts */
  totalAmount: Scalars['Int'];
  /** Total cost for MP */
  totalCost: Maybe<Scalars['Float']>;
  /** Total discount */
  totalDiscount: Maybe<Scalars['Float']>;
  /** Total price including tax */
  totalPrice: Maybe<Scalars['Float']>;
  /** Total tax */
  totalTax: Maybe<Scalars['Float']>;
  /** Unbundled part count - Added for scheduling */
  unbundledPartCount: Maybe<Scalars['Int']>;
  /** Unbundled part payout - Added for scheduling */
  unbundledPartPayout: Maybe<Scalars['Float']>;
  /** Unbundled process names - Added for scheduling */
  unbundledProcessNames: Maybe<Array<Scalars['String']>>;
  /** Work order count */
  workOrderCount: Scalars['Int'];
};


/** Represents a list of orders placed by customer. */
export type SalesOrderSalesOrderLinesArgs = {
  cursor: InputMaybe<Scalars['ENCODED_CURSOR']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['CreatedAtSortKey']>;
  statusNotIn?: InputMaybe<Array<Scalars['String']>>;
};


/** Represents a list of orders placed by customer. */
export type SalesOrderShipmentsArgs = {
  cursor: InputMaybe<Scalars['ENCODED_CURSOR']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['CreatedAtSortKey']>;
};

/** Sale Order contract details */
export type SalesOrderContract = {
  __typename: 'SalesOrderContract';
  expiryDate: Maybe<Scalars['Date']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  salesforceContractLink: Scalars['String'];
  salesforceContractOpportunityId: Scalars['String'];
};

/** Sale Order delivery order */
export type SalesOrderDeliveryOrder = {
  __typename: 'SalesOrderDeliveryOrder';
  actualCompletionDate: Maybe<Scalars['Date']>;
  actualDeliveryDate: Maybe<Scalars['Date']>;
  actualShipDate: Maybe<Scalars['Date']>;
  committedCompletionDate: Maybe<Scalars['Date']>;
  committedDeliveryDate: Maybe<Scalars['Date']>;
  committedShipDate: Maybe<Scalars['Date']>;
  computedCommittedCompletionDate: Maybe<Scalars['Date']>;
  computedCommittedShipDate: Maybe<Scalars['Date']>;
  date: Maybe<Scalars['Date']>;
  id: Scalars['Int'];
  name: Maybe<Scalars['String']>;
  operationPerformedBy: Maybe<Scalars['Date']>;
  state: Maybe<Scalars['String']>;
};

/** Represents a list of line items associated with the sale order. */
export type SalesOrderLine = {
  __typename: 'SalesOrderLine';
  adminMaterial: Maybe<AdminOrderMaterialDetails>;
  associatedErpProductToolId: Maybe<Scalars['Int']>;
  associatedMoldTool: Maybe<BasicMoldTool>;
  associatedParts: Maybe<Array<Maybe<Scalars['String']>>>;
  boundingBox: Maybe<ErpBoundingBox>;
  deliveredQuantity: Maybe<Scalars['Int']>;
  deliveryStatus: Scalars['String'];
  dfmFeedback: Maybe<Array<DfmFeedback>>;
  discountAmount: Maybe<Scalars['Int']>;
  erpMoldId: Maybe<Scalars['String']>;
  erpProductToolId: Maybe<Scalars['Int']>;
  holes: Maybe<Array<Hole>>;
  htsApplication: Maybe<Scalars['String']>;
  /** HTS code */
  htsCode: Maybe<Scalars['String']>;
  htsCodeSubmitted: Maybe<Scalars['Boolean']>;
  htsDescription: Maybe<Scalars['String']>;
  htsUsageType: Maybe<HtsUsageType>;
  id: Scalars['String'];
  inspectionStatus: ReportState;
  invoicedQuantity: Maybe<Scalars['Int']>;
  markup: Maybe<Scalars['Float']>;
  material: Maybe<OrderMaterialDetails>;
  moldName: Maybe<MoldName>;
  moldStatus: Maybe<Scalars['String']>;
  moldTool: Maybe<BasicMoldTool>;
  moldToolId: Maybe<Scalars['String']>;
  moldToolRevisionId: Maybe<Scalars['String']>;
  mpAdjustedPayout: Maybe<Scalars['Float']>;
  mpAssignedQuantity: Maybe<Scalars['Int']>;
  orderedQuantity: Scalars['Int'];
  originalPrice: Maybe<Scalars['Int']>;
  originalUnitPrice: Maybe<Scalars['Int']>;
  partName: Maybe<Scalars['String']>;
  partType: Maybe<Scalars['String']>;
  processName: Maybe<Scalars['String']>;
  processNames: Maybe<Array<Maybe<Scalars['String']>>>;
  processes: Array<OrderProcessDetails>;
  /**
   * Vendor due date
   * Removing the constraint as platform order would be null
   */
  producedBy: Maybe<Scalars['Date']>;
  productionCountry: Maybe<ProductionCountry>;
  productionRegion: Maybe<Scalars['String']>;
  productionStatus: ReportState;
  quantity: Scalars['Int'];
  quoteModelRevision: Maybe<QuoteModelRevision>;
  quoteModelRevisionAttachment: Maybe<Attachment>;
  quoteModelRevisionUUID: Maybe<Scalars['String']>;
  revision: Maybe<Revision>;
  scheduledDeliveryDate: Maybe<Scalars['Date']>;
  scheduledShipDate: Maybe<Scalars['Date']>;
  schedulingDri: Maybe<BasicUser>;
  shipmentAndInspection: Array<Maybe<SalesOrderLineShipment>>;
  subTotalAmount: Maybe<Scalars['Float']>;
  tax: Maybe<Scalars['Float']>;
  thumbnailUri: Maybe<Scalars['String']>;
  totalCost: Maybe<Scalars['Float']>;
  totalPrice: Maybe<Scalars['Float']>;
  unitCost: Maybe<Scalars['Float']>;
  unitDiscountAmount: Maybe<Scalars['Int']>;
  unitPrice: Scalars['Int'];
};

/** Represents Sales order line product process, this is a data synced from ERP system */
export type SalesOrderLineProductProcess = {
  __typename: 'SalesOrderLineProductProcess';
  /** Associated Mold Tool details */
  associatedMoldTool: Maybe<BasicMoldTool>;
  /** Associated ERP product id */
  erpProductId: Maybe<Scalars['Int']>;
  /** Execution sequence of processes under sale order line */
  executionSequence: Scalars['Int'];
  /** Vendor due date */
  expectedDueDate: Maybe<Scalars['Date']>;
  /** Unique identifier - ERP Product Process Id */
  id: Scalars['Int'];
  /** inspection data */
  inspectionData: Maybe<InspectionData>;
  /** Is this a last product process? */
  isLastProductProcess: Scalars['Boolean'];
  /** Lead time required */
  leadTime: Maybe<Scalars['Int']>;
  /** Part Material configuration */
  materialConfiguration: Maybe<PartMaterialConfiguration>;
  /** Mold Tool details */
  moldTool: Maybe<BasicMoldTool>;
  /** Next JobBoard */
  nextJobBoard: Maybe<JobBoard>;
  /** Part details */
  part: Maybe<Part>;
  /** Payout */
  payout: Maybe<Scalars['Float']>;
  /** Previous job board Jobs */
  previousJobBoardJobs: Maybe<Array<PreviousJobsType>>;
  /** Previous Jobs */
  previousJobs: Maybe<Array<PreviousJobsType>>;
  /** Part Process details */
  processAttributes: Maybe<PartProcessAttributes>;
  /** Associate process id */
  processId: Maybe<Scalars['Int']>;
  /** Process notes */
  processNotes: Maybe<Scalars['String']>;
  /** Associated ERP process type id */
  processTypeId: Scalars['String'];
  /** Associated process type name */
  processTypeName: Scalars['String'];
  /** Sale order line production country */
  productionCountry: Maybe<ProductionCountry>;
  /** Production region */
  productionRegion: Maybe<Scalars['String']>;
  /** Remaining quantity (Unbundled Quantity - Scheduled Quantity) */
  remainingQuantity: Maybe<Scalars['Int']>;
  /** Associated sales order Id */
  salesOrderId: Scalars['Int'];
  /** Associated sales order line Id */
  salesOrderLineId: Scalars['Int'];
  /** Quantity scheduled to produce */
  scheduledQuantity: Maybe<Scalars['Int']>;
  /** Target purchase price */
  targetPurchasePrice: Maybe<Scalars['Float']>;
  /** Part thumbnail image url */
  thumbnailUri: Maybe<Scalars['String']>;
  /** Total quantity ordered */
  unbundledQuantity: Maybe<Scalars['Int']>;
};

/** shipment and inspection documents */
export type SalesOrderLineShipment = {
  __typename: 'SalesOrderLineShipment';
  inspectionDocuments: Maybe<Array<Maybe<InspectionDocument>>>;
  inspectionTypes: Maybe<Array<Maybe<AllowedInspectionType>>>;
  shipmentId: Maybe<Scalars['String']>;
  woAvailableToShow: Maybe<Scalars['Boolean']>;
};

/** Sales order priority */
export enum SalesOrderPriority {
  normal = 'normal',
  not_urgent = 'not_urgent',
  urgent = 'urgent',
  very_urgent = 'very_urgent'
}

/** All process lines for a Sales Order and their jobs information */
export type SalesOrderProcessLine = {
  __typename: 'SalesOrderProcessLine';
  actualScheduledDate: Maybe<Scalars['Date']>;
  actualVendorDueDate: Maybe<Scalars['Date']>;
  associatedMoldTool: Maybe<BasicMoldTool>;
  executionSequence: Scalars['Int'];
  jobId: Maybe<Scalars['Int']>;
  jobName: Maybe<Scalars['String']>;
  jobStatus: Maybe<Scalars['String']>;
  leadTime: Maybe<Scalars['Int']>;
  manufacturingPartnerName: Maybe<Scalars['String']>;
  materialConfiguration: Maybe<PartMaterialConfiguration>;
  moldTool: Maybe<BasicMoldTool>;
  orderLineProcesses: Array<OrderProcessDetails>;
  orderedQuantity: Scalars['Int'];
  part: Maybe<Part>;
  plannedScheduledDate: Maybe<Scalars['Date']>;
  plannedVendorDueDate: Maybe<Scalars['Date']>;
  processAttributes: Maybe<Scalars['String']>;
  processName: Scalars['String'];
  productQuantity: Scalars['Int'];
  remainingUnbundledQuantity: Maybe<Scalars['Int']>;
  rfqNumber: Maybe<Scalars['String']>;
  salesOrderLineId: Scalars['Int'];
  scheduledDeliveryDate: Maybe<Scalars['Date']>;
  scheduledShipDate: Maybe<Scalars['Date']>;
  schedulingQueueProcessedItemsCount: Maybe<Scalars['Int']>;
  schedulingQueueStatus: Maybe<Scalars['String']>;
  schedulingQueueTotalItemsCount: Maybe<Scalars['Int']>;
};

/** Sales order quote details */
export type SalesOrderQuote = {
  __typename: 'SalesOrderQuote';
  id: Scalars['String'];
  name: Scalars['String'];
};

/** Container for SalesOrder or BasicSalesOrder type */
export type SalesOrderView = BasicSalesOrder | SalesOrder;

/** Input for quoteTeamMemberships and orderTeamMemberships query */
export type SalesOrdersFilterInput = {
  searchText: InputMaybe<Scalars['String']>;
};

/** Input for filtering list of SalesOrders */
export type SalesOrdersFiltersInput = {
  businessUnits: InputMaybe<Array<Scalars['String']>>;
  committedDeliveryDateEnd: InputMaybe<Scalars['String']>;
  committedDeliveryDateStart: InputMaybe<Scalars['String']>;
  earliestPromisedShipDateEnd: InputMaybe<Scalars['String']>;
  earliestPromisedShipDateStart: InputMaybe<Scalars['String']>;
  earliestScheduledDeliveryDateEnd: InputMaybe<Scalars['String']>;
  earliestScheduledDeliveryDateStart: InputMaybe<Scalars['String']>;
  mfgDriUserId: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  priority: InputMaybe<Array<InputMaybe<SalesOrderPriority>>>;
  productionCountry: InputMaybe<Array<ProductionCountryFilter>>;
  projectNameLike: InputMaybe<Scalars['String']>;
  region: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  salesOrderNameLike: InputMaybe<Scalars['String']>;
  schedulingDriUserIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  workOrderNameLike: InputMaybe<Scalars['String']>;
  workOrderStatus: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Type of CRM account */
export type SalesforceAccount = {
  __typename: 'SalesforceAccount';
  businessAccount: Maybe<BusinessAccount>;
  hasBusinessAccount: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  totalContacts: Scalars['Int'];
  url: Scalars['String'];
};

/** Input for adminSearchSalesforceAccounts query */
export type SalesforceAccountSearchInput = {
  name: InputMaybe<Scalars['String']>;
};

/** Enum for allowed sort in adminSearchSalesforceAccounts query */
export enum SalesforceAccountSortInput {
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC'
}

/** Input field for Sanitizationboundingbox */
export type SanitizationBoundingBoxInput = {
  xmax: InputMaybe<Scalars['Float']>;
  xmin: InputMaybe<Scalars['Float']>;
  ymax: InputMaybe<Scalars['Float']>;
  ymin: InputMaybe<Scalars['Float']>;
};

/** Input field for Sanitizationinfo */
export type SanitizationInfoInput = {
  numAdminRedBoxes: InputMaybe<Scalars['Int']>;
  numAutoRedBoxes: InputMaybe<Scalars['Int']>;
  rawBoxInfo: InputMaybe<Array<InputMaybe<RawBoxInput>>>;
};

/** A sanitized version of an attachment */
export type SanitizedAttachment = {
  __typename: 'SanitizedAttachment';
  createdAt: Scalars['Date'];
  deletedAt: Maybe<Scalars['Date']>;
  downloadUrl: Maybe<Scalars['String']>;
  extension: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  id: Scalars['UUID'];
  mimeType: Maybe<Scalars['String']>;
  quoteModelRevisionId: Maybe<Scalars['UUID']>;
  sizeInKb: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Date'];
  uploadUrl: Maybe<Scalars['String']>;
};

/** Scene file pointint to a url */
export type SceneFile = {
  __typename: 'SceneFile';
  url: Scalars['String'];
};

/** enumeration of possible values for SchedulingMethod */
export enum SchedulingMethod {
  auto = 'auto',
  rfq = 'rfq',
  select = 'select'
}

/** A manufacturing process - used for scheduling */
export type SchedulingProcess = {
  __typename: 'SchedulingProcess';
  id: Scalars['String'];
  name: Scalars['String'];
};

/** Represents the Scheduling Queue for a job */
export type SchedulingQueue = {
  __typename: 'SchedulingQueue';
  /** Actual transaction margin */
  actualTransactionMargin: Maybe<Scalars['Float']>;
  /** Queue Id */
  id: Scalars['Int'];
  /** Associated Job Id */
  jobId: Scalars['Int'];
  /** Original transaction margin */
  originalTransactionMargin: Maybe<Scalars['Float']>;
  /** Completed Queue Items */
  processedQueueItemCount: Scalars['Int'];
  /** Total count of Queue Items */
  queueItemCount: Scalars['Int'];
  /** Scheduling Queue Items */
  queueItems: Maybe<Array<SchedulingQueueItem>>;
  /** Queue Status */
  status: SchedulingQueueStatus;
};

/** Represents the Scheduling Queue for a job */
export type SchedulingQueueItem = {
  __typename: 'SchedulingQueueItem';
  /** Created At */
  createdAt: Scalars['Date'];
  /** Deleted At */
  deletedAt: Maybe<Scalars['Date']>;
  /** Email Sent At */
  emailSentAt: Maybe<Scalars['Date']>;
  /** Non-voided exceptions associated with job request created on queue item */
  exceptionCount: Maybe<Scalars['Int']>;
  /** History related to scheduling queue item */
  history: Maybe<Array<ChangeHistory>>;
  /** Queue Item Id */
  id: Scalars['Int'];
  /** Job Expiry Time in minutes */
  jobExpiryTime: Scalars['Int'];
  /** Job Extra Viewing Time in minutes */
  jobExtraViewingTime: Scalars['Int'];
  /** Job Request Id */
  jobRequestId: Maybe<Scalars['Int']>;
  /** Manufacturing partner */
  mfgPartner: MfgPartner;
  /** Flag of override mp accpeting hours */
  overrideMpAcceptingHours: Maybe<Scalars['Boolean']>;
  /** Flag of override mp unavailability */
  overrideMpUnavailability: Maybe<Scalars['Boolean']>;
  /** Partner Id */
  partnerId: Scalars['Int'];
  /** Associated Queue Id */
  queueId: Scalars['Int'];
  /** Reason to skip queue item */
  reasonToSkip: Maybe<Scalars['String']>;
  /** Rejection reason */
  rejectionReason: Maybe<Scalars['String']>;
  /** Rejection reason additional info */
  rejectionReasonAdditionalInfo: Maybe<Scalars['String']>;
  /** Schedule No earlier Than */
  scheduleNoEarlierThan: Maybe<Scalars['Date']>;
  /** Scheduling method */
  schedulingMethod: SchedulingMethod;
  /** Sequence No */
  sequenceNo: Scalars['Int'];
  /** Was queue Item skipped */
  skipped: Scalars['Boolean'];
  /** status of the queue item */
  status: Scalars['String'];
  /** Updated At */
  updatedAt: Scalars['Date'];
  /** Wait Time in minutes */
  waitTime: Scalars['Int'];
};

/** Scheduling Queue statuses */
export enum SchedulingQueueStatus {
  accepted = 'accepted',
  canceled = 'canceled',
  empty = 'empty',
  ended = 'ended',
  in_progress = 'in_progress',
  paused = 'paused'
}

/** Input for filtering list of scheduling salesOrders */
export type SchedulingSalesOrdersFiltersInput = {
  businessUnits: InputMaybe<Array<Scalars['String']>>;
  earliestPromisedShipDateEnd: InputMaybe<Scalars['String']>;
  earliestPromisedShipDateStart: InputMaybe<Scalars['String']>;
  earliestScheduledDateEnd: InputMaybe<Scalars['String']>;
  earliestScheduledDateStart: InputMaybe<Scalars['String']>;
  latestPromisedShipDateEnd: InputMaybe<Scalars['String']>;
  latestPromisedShipDateStart: InputMaybe<Scalars['String']>;
  manufacturingRegion: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderType: InputMaybe<Array<InputMaybe<OrderType>>>;
  priority: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  processIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  processTypeIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productionCountry: InputMaybe<Array<ProductionCountryFilter>>;
  projectNameLike: InputMaybe<Scalars['String']>;
  salesOrderDriIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  salesOrderNameLike: InputMaybe<Scalars['String']>;
  unbundledPartPayoutMax: InputMaybe<Scalars['Int']>;
  unbundledPartPayoutMin: InputMaybe<Scalars['Int']>;
};

/** Enum for job schedule type */
export enum SchedulingTypes {
  AUTO_SCHEDULE = 'AUTO_SCHEDULE',
  JOB_BOARD = 'JOB_BOARD',
  MANUAL = 'MANUAL'
}

/** Return type for SchedulingTypes with flag for live job board */
export type SchedulingTypesWithLiveJobBoard = {
  __typename: 'SchedulingTypesWithLiveJobBoard';
  isJobBoardLive: Maybe<Scalars['Boolean']>;
  schedulingTypes: Array<SchedulingTypes>;
};

/** Input for scrap rate in the admin quoting page */
export type ScrapRateDataInput = {
  numParts: Scalars['Int'];
  numPartsBase: Scalars['Int'];
};

/** Input for secondary mfg production process (anodizing, media-blasting, i.e. processes that change the quality of the manufactured model) */
export type SecondaryProcessConfigInput = {
  processColorId: InputMaybe<Scalars['String']>;
  processId: Scalars['String'];
  processInspectionCriteria: InputMaybe<ProcessInspectionCriteria>;
  processNumParts: InputMaybe<Scalars['Int']>;
  processThicknessInInches: InputMaybe<Scalars['Float']>;
};

/** Fields for secondary processes' manual calculation */
export type SecondaryProcessManualQuoteCalcFields = {
  __typename: 'SecondaryProcessManualQuoteCalcFields';
  domestic: Maybe<ManualQuoteFieldsForSecondaryProcesses>;
  international: Maybe<ManualQuoteFieldsForSecondaryProcesses>;
};

/** Attributes needed to verify address */
export type SelectedAddressInput = {
  aptNumber: InputMaybe<Scalars['String']>;
  city: InputMaybe<Scalars['String']>;
  company: InputMaybe<Scalars['String']>;
  country: InputMaybe<Scalars['String']>;
  name: InputMaybe<Scalars['String']>;
  phone: InputMaybe<Scalars['String']>;
  state: InputMaybe<Scalars['String']>;
  street: InputMaybe<Scalars['String']>;
  zip: InputMaybe<Scalars['String']>;
};

/** Either a platform material or something a user entered */
export type SelectedMaterial = Material | UserEnteredMaterial;

/** Container representing an unsuccessful attempt to send a business account invite */
export type SendBusinessAccountInviteError = {
  __typename: 'SendBusinessAccountInviteError';
  /**
   * The name of the business account the user currently belongs to
   * Only present when status is email_exists_different_business_account
   */
  businessAccountName: Maybe<Scalars['String']>;
  /**
   * The URL to the Pending Member tab the user currently belongs to, pre-filtered by the invitee's email
   * Only present when status is email_exists_different_business_account
   */
  businessAccountUrl: Maybe<Scalars['String']>;
  /**
   * The name of the salesforce account the user currently belongs to
   * Only present when status is different_salesforce_account
   */
  currentSalesforceAccountName: Maybe<Scalars['String']>;
  /**
   * The URL to the salesforce account the user currently belongs to
   * Only present when status is different_salesforce_account
   */
  currentSalesforceAccountUrl: Maybe<Scalars['String']>;
  /** Email attempted to be invited */
  email: Scalars['String'];
  /** The type of error that occurred on the server */
  errorCode: Maybe<SendBusinessAccountInviteErrorCode>;
  /**
   * The name of the salesforce account the user needs to belong to in order to be invited to the requested business account
   * Only present when status is different_salesforce_account
   */
  targetSalesforceAccountName: Maybe<Scalars['String']>;
  /**
   * The URL of the salesforce account the user needs to belong to in order to be invited to the requested business account
   * Only present when status is different_salesforce_account
   */
  targetSalesforceAccountUrl: Maybe<Scalars['String']>;
};

/** Possible error types that can occur when sending a business account invite */
export enum SendBusinessAccountInviteErrorCode {
  already_activated = 'already_activated',
  different_salesforce_account = 'different_salesforce_account',
  email_exists_different_business_account = 'email_exists_different_business_account',
  email_exists_same_business_account = 'email_exists_same_business_account',
  failed_to_activate = 'failed_to_activate',
  failed_to_create = 'failed_to_create',
  invite_already_exists = 'invite_already_exists',
  needs_activation = 'needs_activation'
}

/** Container representing successful and unsucessful attempts to send one or more invitations */
export type SendBusinessAccountInviteResult = {
  __typename: 'SendBusinessAccountInviteResult';
  /** List of emails where invitations were not sent (with reason) */
  errors: Maybe<Array<SendBusinessAccountInviteError>>;
  /** Invitations that were successfully sent */
  invites: Array<BusinessAccountInvite>;
};

/** Response type for sendEmailVerificationResponse */
export type SendEmailVerificationResponse = {
  __typename: 'SendEmailVerificationResponse';
  user: User;
  verificationUrl: Maybe<Scalars['String']>;
};

/** An estimate for when an object will be shipped after production. */
export type ShipDateEstimate = {
  __typename: 'ShipDateEstimate';
  id: Scalars['String'];
  shippedByDate: Scalars['Date'];
  validUntilDate: Scalars['Date'];
};

/** Represents Ship to address per shipment */
export type ShipToAddress = {
  __typename: 'ShipToAddress';
  city: Maybe<Scalars['String']>;
  companyName: Maybe<Scalars['String']>;
  countryCode: Maybe<Scalars['String']>;
  countryName: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
  stateCode: Maybe<Scalars['String']>;
  stateName: Maybe<Scalars['String']>;
  street: Maybe<Scalars['String']>;
  street2: Maybe<Scalars['String']>;
  zip: Maybe<Scalars['String']>;
};

/** Represents a Shipment of the sale order of customer. */
export type Shipment = {
  __typename: 'Shipment';
  /** fedex or ups or dhl */
  carrier: Maybe<Scalars['String']>;
  /** next_day_air or next_day_air_early_am or next_day_air_saver or ground or priority_overnight or first_overnight or standard_overnight or ground_home_delivery or other */
  carrierMethod: Maybe<Scalars['String']>;
  /** estimated delivery date per shipment */
  committedDeliveryDate: Maybe<Scalars['Date']>;
  /** The shipment status ('pending_production','in_production','shipped', 'canceled'). */
  deliveryStatus: Scalars['String'];
  /** A unique identifier. */
  id: Scalars['String'];
  /** Ship to information */
  shipToAddress: ShipToAddress;
  /** The list of line items in this shipment */
  shipmentLines: PartialShipmentLineResults;
  /** The shipped on date of the shipment. */
  shippedBy: Scalars['Date'];
  /** The shipment method. */
  shippingMethod: Scalars['String'];
  /** Shipping status of each shipment */
  state: Maybe<Scalars['String']>;
  trackingCode: Maybe<Scalars['String']>;
  trackingData: Maybe<TrackingData>;
};


/** Represents a Shipment of the sale order of customer. */
export type ShipmentShipmentLinesArgs = {
  cursor: InputMaybe<Scalars['ENCODED_CURSOR']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['CreatedAtSortKey']>;
};

/** Represents a ShipmentLine of the sale order of customer. */
export type ShipmentLine = {
  __typename: 'ShipmentLine';
  boundingBox: Maybe<BoundingBox>;
  dfmFeedback: Maybe<Array<DfmFeedback>>;
  erpMoldId: Maybe<Scalars['String']>;
  holes: Maybe<Array<Hole>>;
  id: Scalars['String'];
  inspectionDocuments: Maybe<Array<Maybe<InspectionDocument>>>;
  inspectionTypes: Maybe<Array<Maybe<AllowedInspectionType>>>;
  /** @deprecated Use ShipmentLine.materialDetails */
  material: Scalars['String'];
  materialDetails: Maybe<OrderMaterialDetails>;
  processName: Maybe<Scalars['String']>;
  /** @deprecated Use ShipmentLine.processes */
  processNames: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Processes assosiated with a shipment line */
  processes: Array<OrderProcessDetails>;
  quantity: Scalars['Int'];
  quoteModelRevisionAttachment: Maybe<Attachment>;
  revision: Maybe<Revision>;
  totalQuantity: Scalars['Int'];
  woAvailableToShow: Scalars['Boolean'];
};

/** verifiable address response after api call */
export type ShippingAddress = {
  __typename: 'ShippingAddress';
  city: Maybe<Scalars['String']>;
  company: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  delivery: Maybe<Scalars['JSON']>;
  id: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  street1: Maybe<Scalars['String']>;
  street2: Maybe<Scalars['String']>;
  zip: Maybe<Scalars['String']>;
};

/** input fields for shippingAddress */
export type ShippingAddressInput = {
  aptNumber: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  company: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  id: InputMaybe<Scalars['Int']>;
  isDefault: InputMaybe<Scalars['Boolean']>;
  isVerified: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  phone: Scalars['String'];
  state: Scalars['String'];
  street: Scalars['String'];
  zip: Scalars['String'];
};

/** Input fields for shipping calulator */
export type ShippingCalculatorOverridesInput = {
  isOverseas: InputMaybe<Scalars['Boolean']>;
  qmrQtyMaterialInput: InputMaybe<Array<QmrQtyMaterialInput>>;
};

/** Indication of how an order should be shipped */
export type ShippingMethodInput = {
  addressId: Scalars['Int'];
  token: Scalars['String'];
};

/** Represents the shipping type and deliery date for a quote level lead time option. */
export type ShippingOptionItemType = {
  __typename: 'ShippingOptionItemType';
  cost: Maybe<Scalars['Int']>;
  deliveredByDate: Maybe<Scalars['Date']>;
  deliveryDays: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  productionPartsCost: Maybe<Scalars['Int']>;
  quoteToken: Maybe<Scalars['String']>;
  samplesCost: Maybe<Scalars['Int']>;
  shippingOptionId: Scalars['String'];
};

/** Represents a process done by Manufacturing Partner */
export type ShopProcess = {
  __typename: 'ShopProcess';
  availability: Array<ShopProcessAvailability>;
  id: Scalars['String'];
  name: Scalars['String'];
};


/** Represents a process done by Manufacturing Partner */
export type ShopProcessAvailabilityArgs = {
  date: Scalars['Date'];
};

/** Shop availability information */
export type ShopProcessAvailability = {
  __typename: 'ShopProcessAvailability';
  accepting: Scalars['Boolean'];
  acceptingDisabled: Scalars['Boolean'];
  available: Scalars['Boolean'];
  date: Scalars['Date'];
};

/** Represents only shop process details */
export type ShopProcessDetail = {
  __typename: 'ShopProcessDetail';
  platformProcessId: Scalars['String'];
  platformProcessTypeId: Scalars['String'];
  processId: Scalars['Int'];
  processName: Scalars['String'];
  showMpAvailability: Scalars['Boolean'];
};

/** A manufacturing shore value for maleable materials. */
export type Shore = {
  __typename: 'Shore';
  id: Scalars['String'];
  name: Scalars['String'];
};

/** Nominal coordinate for one or two side tolerance */
export type SidedToleranceNominalCoordinate = {
  __typename: 'SidedToleranceNominalCoordinate';
  page: Maybe<Scalars['Float']>;
  x: Maybe<Scalars['Float']>;
  y: Maybe<Scalars['Float']>;
};

/** Represents slider dimensions */
export type Slider = {
  __typename: 'Slider';
  depth: Maybe<Scalars['Float']>;
  length: Maybe<Scalars['Float']>;
  width: Maybe<Scalars['Float']>;
};

/** Input for sliders */
export type SliderInput = {
  depth: InputMaybe<Scalars['Float']>;
  length: InputMaybe<Scalars['Float']>;
  width: InputMaybe<Scalars['Float']>;
};

/** Enum to dictate whether a sort operation should be 'ascending' or 'descending' */
export enum SortOrderInput {
  asc = 'asc',
  desc = 'desc'
}

/** Input type for scheduling  sales order sort */
export type SortTypeInput = {
  name: AllowedSchedulingSalesOrderSort;
  order: AllowedSchedulingSalesOrderSortOrder;
};

/** Input for DfmInspection special fixturing parameters */
export type SpecialFixturingParametersInput = {
  canBeNested: InputMaybe<Scalars['Boolean']>;
  canBeTabbed: InputMaybe<Scalars['Boolean']>;
  nestingParameters: InputMaybe<NestingParametersInput>;
  quotedFixturingMethods: InputMaybe<DomesticAndOverseasQuotedFixturingMethodsInput>;
  tabbingParameters: InputMaybe<TabbingParametersInput>;
};

/** Enum for supplier quality engineer assigned to */
export enum SqeAssignedToType {
  CAR = 'CAR',
  MP = 'MP'
}

/** Types for stages */
export enum StageType {
  bridge_production = 'bridge_production',
  design_validation = 'design_validation',
  production = 'production'
}

/** Input used for  edm calculator pricing options */
export type StepItemInput = {
  sinkerKnownRemoval: InputMaybe<EdmSinkerKnownRemovalVolumeItemInput>;
  sinkerNoKnownRemoval: InputMaybe<EdmSinkerNoKnownRemovalVolumeItemInput>;
  wire: InputMaybe<EdmWireItemInput>;
};

/** Fields for edm calculator output */
export type StepItemOutput = {
  __typename: 'StepItemOutput';
  priceInCents: Maybe<EdmPriceOutput>;
  sinkerKnownRemoval: Maybe<EdmSinkerKnownRemovalVolumeItemOutput>;
  sinkerNoKnownRemoval: Maybe<EdmSinkerNoKnownRemovalVolumeItemOutput>;
  wire: Maybe<EdmWireItemOutput>;
};

/** Available pre-defined subject types */
export enum SubjectCategory {
  QC_INVENTORY = 'QC_INVENTORY',
  WORKBENCH = 'WORKBENCH'
}

/** Represents Subjects on Work Order */
export type SubjectType = {
  __typename: 'SubjectType';
  id: Maybe<AllowedSubjectTypes>;
  value: Maybe<Scalars['String']>;
};

/** Describes which regions are supported by the part's dfm inspection */
export type SupportedPriorityRegions = {
  __typename: 'SupportedPriorityRegions';
  partSupportsDomestic: Scalars['Boolean'];
  partSupportsInternational: Scalars['Boolean'];
};

/** Process Supporting Capabilities Type */
export type SupportingCapabilities = {
  __typename: 'SupportingCapabilities';
  id: Scalars['String'];
  name: Scalars['String'];
};

/** Supporting doc pdf information parsed by comp geo */
export type SupportingDocAnalysis = {
  __typename: 'SupportingDocAnalysis';
  autoQuotable: Maybe<Scalars['Boolean']>;
  autoQuotableBlockers: Maybe<Array<Maybe<Scalars['String']>>>;
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  finishingNotes: Maybe<Array<Maybe<Scalars['String']>>>;
  foundThreadNames: Maybe<Array<Maybe<Scalars['String']>>>;
  foundThreadsInfo: Maybe<Array<Maybe<SupportingDocAnalysisTapInfo>>>;
  hasHtmlText: Maybe<Scalars['Boolean']>;
  hasText: Maybe<Scalars['Boolean']>;
  htmlFilename: Maybe<Scalars['String']>;
  htmlFilenames: Maybe<Array<Maybe<Scalars['String']>>>;
  measurementUnits: Maybe<Scalars['String']>;
  minOneSidedTolerance: Maybe<Scalars['String']>;
  minTwoSidedTolerance: Maybe<Scalars['String']>;
  oneSidedTolerances: Maybe<Array<Maybe<Scalars['JSON']>>>;
  pdfFilename: Maybe<Scalars['String']>;
  twoSidedTolerances: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

/** Helper type def: contains count and identifying strings for parsed taps */
export type SupportingDocAnalysisTapInfo = {
  __typename: 'SupportingDocAnalysisTapInfo';
  commonName: Maybe<Scalars['String']>;
  count: Scalars['Int'];
  id: Scalars['String'];
};

/** Type of System event to record as Project Activity */
export enum SystemEventName {
  CHECKOUT_BEGAN = 'CHECKOUT_BEGAN'
}

/** Input for DfmInspection tabbing parameters */
export type TabbingParametersInput = {
  domesticTabbingMaterialStock: InputMaybe<Scalars['JSON']>;
  maximumNumberOfTabbedParts: InputMaybe<Scalars['Int']>;
  overseasTabbingMaterialStock: InputMaybe<Scalars['JSON']>;
  tabbingCamSeconds: InputMaybe<Scalars['Int']>;
  tabbingMachiningSeconds: InputMaybe<Scalars['Int']>;
  tabbingMaterialStocks: InputMaybe<DomesticAndOverseasMaterialStockDataInput>;
  tabbingSpecialFixtures: InputMaybe<Scalars['Float']>;
};

/** Annotation for specifying tapped holes */
export type TapAnnotation = {
  __typename: 'TapAnnotation';
  createdAt: Scalars['Date'];
  deletedAt: Maybe<Scalars['Date']>;
  depth: Maybe<Scalars['Float']>;
  /** Contains information from annotation.target */
  hole: Hole;
  /** annotation ID */
  id: Scalars['UUID'];
  tapOption: Maybe<TapOption>;
  updatedAt: Scalars['Date'];
};

/** Inpute for batch inserting tap annotations */
export type TapAnnotationInput = {
  holeId: Scalars['String'];
  tapOptionId: Scalars['String'];
};

/** info from CSV/spreadsheet, hard coded in yaml files */
export type TapOption = {
  __typename: 'TapOption';
  commonName: Scalars['String'];
  /** yaml file ID */
  id: Scalars['String'];
  maxDepth: Scalars['Float'];
};

/** Represents a Tax to be applied on a sale order line. */
export type Tax = {
  __typename: 'Tax';
  /** Error */
  error: Maybe<Scalars['String']>;
  /** Region name */
  regionName: Maybe<Scalars['String']>;
  /** Tax State. */
  state: Maybe<Scalars['String']>;
  /** Tax Amount */
  taxAmount: Scalars['Int'];
  /** Tax Rate. */
  taxRate: Scalars['Float'];
  /** Tax Zip. */
  zip: Scalars['String'];
};

/** Connects related team-members, quotes, and orders to a grouping named Team */
export type Team = {
  __typename: 'Team';
  businessAccount: Maybe<BusinessAccount>;
  businessAccountId: Scalars['UUID'];
  createdAt: Scalars['Date'];
  createdBy: BasicUser;
  deletedAt: Maybe<Scalars['Date']>;
  deletedBy: Maybe<BasicUser>;
  id: Scalars['Int'];
  members: PartialUserTeamMembersResult;
  name: Scalars['String'];
  /** Get list of Orders (Sale Orders) in a given team */
  salesOrders: PartialSalesOrderViewResults;
  totalMembers: Maybe<Scalars['Int']>;
  totalQuotes: Maybe<Scalars['Int']>;
  totalSalesOrders: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Date'];
  updatedBy: BasicUser;
};


/** Connects related team-members, quotes, and orders to a grouping named Team */
export type TeamMembersArgs = {
  filters: InputMaybe<TeamsMembersFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort: InputMaybe<UserTeamsQuerySortInput>;
};


/** Connects related team-members, quotes, and orders to a grouping named Team */
export type TeamSalesOrdersArgs = {
  filters: InputMaybe<SalesOrdersFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<TeamQuotesAndOrdersSortInput>;
};

/** Input for quoteTeamMemberships and orderTeamMemberships query */
export type TeamQuoteAndOrderFilterInput = {
  searchText: InputMaybe<Scalars['String']>;
};

/** Enum for sorting quotes and orders in Teams query */
export enum TeamQuotesAndOrdersSortInput {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC'
}

/** Enum for sorting quotes in teamQuotes query */
export enum TeamQuotesSortOrder {
  UPDATED_ASC = 'UPDATED_ASC',
  UPDATED_DESC = 'UPDATED_DESC'
}

/** Total spend and saving grouped by time */
export type TeamSpendByTimeResult = {
  __typename: 'TeamSpendByTimeResult';
  actualSaving: Scalars['Float'];
  count: Scalars['Int'];
  potentialSavings: Scalars['Float'];
  spend: Scalars['Float'];
  timePeriod: Scalars['String'];
};

/** Team spend query results */
export type TeamSpendResult = {
  __typename: 'TeamSpendResult';
  teamSpendByTime: Array<TeamSpendByTimeResult>;
  teamTotals: TeamTotalsResult;
};

/** Result including totals spend, total number of orders and total savings */
export type TeamTotalsResult = {
  __typename: 'TeamTotalsResult';
  actualSavings: Scalars['Float'];
  orders: Scalars['Int'];
  potentialSavings: Maybe<Scalars['Float']>;
  spend: Scalars['Float'];
};

/** Input for Teams query */
export type TeamsFilterInput = {
  businessAccountId: InputMaybe<Scalars['UUID']>;
  userId: InputMaybe<Scalars['Int']>;
};

/** Input for Teams.members query */
export type TeamsMembersFilterInput = {
  memberType: InputMaybe<UserTeamMembershipFilterMemberType>;
  searchText: InputMaybe<Scalars['String']>;
};

/** Enum for sorting Teams query */
export enum TeamsQuerySortInput {
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC'
}

/** A manufacturing finish for RTV. */
export type Texture = {
  __typename: 'Texture';
  category: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

/** A manufacturing thickness. */
export type Thickness = {
  __typename: 'Thickness';
  id: Scalars['String'];
  name: Scalars['String'];
  value: Scalars['Float'];
};

/** Thread */
export type Thread = {
  __typename: 'Thread';
  comments: PartialCommentsResults;
  createdAt: Scalars['Date'];
  deletedAt: Maybe<Scalars['Date']>;
  id: Scalars['UUID'];
  isResolved: Scalars['Boolean'];
  updatedAt: Scalars['Date'];
  user: BasicUser;
};


/** Thread */
export type ThreadCommentsArgs = {
  limit: InputMaybe<Scalars['Int']>;
};

/** Type for detection boxes of thread info */
export type ThreadInfoDetection = {
  __typename: 'ThreadInfoDetection';
  boundingBox: Maybe<Scalars['Int']>;
  text: Maybe<Scalars['String']>;
};

/** A tolerance spec for injection molding. */
export type Tolerance = {
  __typename: 'Tolerance';
  id: Scalars['String'];
  name: Scalars['String'];
};

/** Tolerance Block Data */
export type ToleranceBlockData = {
  __typename: 'ToleranceBlockData';
  boundingBox: Maybe<Scalars['Int']>;
  nominalCoordinate: Maybe<SidedToleranceNominalCoordinate>;
  rangeMm: Maybe<Scalars['Float']>;
  symbol: Maybe<Scalars['String']>;
  textRaw: Maybe<Scalars['String']>;
  unit: Maybe<Scalars['String']>;
  valueMm: Maybe<Scalars['Float']>;
  valueText: Maybe<Scalars['String']>;
};

/** Low/High Tolerance Bounds */
export type ToleranceBounds = {
  __typename: 'ToleranceBounds';
  sign: Maybe<Scalars['String']>;
  signedValue: Maybe<Scalars['Float']>;
  valueMm: Maybe<Scalars['Float']>;
  valueRaw: Maybe<Scalars['String']>;
};

/** A type of tool used for machining */
export type Tool = {
  __typename: 'Tool';
  diameter: Scalars['Float'];
  flutes: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  length: Maybe<Scalars['Float']>;
  price: Maybe<Scalars['Int']>;
  ratio: Scalars['Int'];
  toolNum: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

/** Estimated part and mold price */
export type ToolAndPartEstimatedPrices = {
  __typename: 'ToolAndPartEstimatedPrices';
  partPrice: Maybe<EstimatedPrice>;
  qmrId: Scalars['String'];
  toolingPrice: Maybe<EstimatedPrice>;
};

/** Granular pricing output for parts in a tool */
export type ToolAndPartPendingPrices = {
  __typename: 'ToolAndPartPendingPrices';
  partPrice: Maybe<ImPartPriceType>;
  toolingPrice: Maybe<ImToolingPriceType>;
};

/** A summary of the cost and tools required for machining a part. */
export type ToolCosts = {
  __typename: 'ToolCosts';
  tools: Maybe<Array<Maybe<Tool>>>;
  totalCost: Maybe<Scalars['Float']>;
};

/** A configuration for the number of parts you can make from an injection mold. */
export type ToolLife = {
  __typename: 'ToolLife';
  id: Scalars['String'];
  name: Scalars['String'];
};

/** Types that define tool life */
export enum ToolLifeType {
  shots_1M = 'shots_1M',
  shots_10k = 'shots_10k',
  shots_50k = 'shots_50k',
  shots_100k = 'shots_100k',
  shots_250k = 'shots_250k',
  shots_500k = 'shots_500k'
}

/** IM DfmFeedback Topic */
export type Topic = {
  __typename: 'Topic';
  id: Scalars['UUID'];
  label: Scalars['String'];
};

/** Total sales order price for Job */
export type TotalSalesOrderPriceForJob = {
  __typename: 'TotalSalesOrderPriceForJob';
  id: Scalars['Int'];
  totalPrice: Scalars['Float'];
};

/** A shipment carrier account */
export type TplCarrierAccount = {
  __typename: 'TplCarrierAccount';
  accountNumber: Scalars['String'];
  country: Scalars['String'];
  createdAt: Scalars['Date'];
  id: Scalars['UUID'];
  name: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  provider: Carrier;
  updatedAt: Scalars['Date'];
};

/** Input fields for a carrier account record. */
export type TplCarrierAccountInput = {
  accountNumber: Scalars['String'];
  country: Scalars['String'];
  name: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
  provider: Carrier;
};

/** Input fields for updating carrier account record. */
export type TplCarrierAccountUpdateInput = {
  accountNumber: InputMaybe<Scalars['String']>;
  country: InputMaybe<Scalars['String']>;
  name: InputMaybe<Scalars['String']>;
  postalCode: InputMaybe<Scalars['String']>;
  provider: InputMaybe<Carrier>;
};

/** Represents all of the tracking information for a package. */
export type TrackingData = {
  __typename: 'TrackingData';
  /** The estimated delivery date provided by the carrier. */
  estDeliveryDate: Maybe<Scalars['Date']>;
  /** The name of the person who signed for the package (if available) */
  signedBy: Maybe<Scalars['String']>;
  /** The current status of the package. */
  status: Scalars['String'];
  /** The list of all previous updates of tracking in the shipment. */
  trackingDetails: Array<TrackingDetail>;
};

/** Represents a tracking details of shipment tracking data. */
export type TrackingDetail = {
  __typename: 'TrackingDetail';
  /** The timestamp when the tracking scan occurred. */
  datetime: Maybe<Scalars['Date']>;
  /** Description of the scan event. */
  message: Scalars['String'];
  /** Status of the package at the time of the scan event. */
  status: Scalars['String'];
  /** The location associated with the scan event. */
  trackingLocation: Maybe<TrackingLocation>;
};

/** Represents the location associated with the scan event */
export type TrackingLocation = {
  __typename: 'TrackingLocation';
  /** The city where the scan event occurred. */
  city: Maybe<Scalars['String']>;
  /** The country the scan event occurred */
  countryCode: Maybe<Scalars['String']>;
  /** The postal code where the scan event occurred */
  postalCode: Maybe<Scalars['String']>;
  /** The state where the scan event occurred */
  state: Maybe<Scalars['String']>;
};

/** Two Sided Tolerance Data */
export type TwoSidedToleranceData = {
  __typename: 'TwoSidedToleranceData';
  boundingBox: Maybe<Scalars['Int']>;
  nominalCoordinate: Maybe<SidedToleranceNominalCoordinate>;
  nominalHoleInfo: Maybe<Scalars['String']>;
  nominalMm: Maybe<Scalars['Float']>;
  nominalRaw: Maybe<Scalars['String']>;
  rangeMm: Maybe<Scalars['Float']>;
  unit: Maybe<Scalars['String']>;
  valueMm: Maybe<Scalars['Float']>;
  valueNumberRaw: Maybe<Scalars['Float']>;
  valueRaw: Maybe<Scalars['String']>;
};

/** Input data required for updating job Auto OT Exception completion dates */
export type UpdateAutoOtDatesInput = {
  autoOtExceptionCreationAt: InputMaybe<Scalars['Date']>;
  deliveryExceptionConsolidationAt: InputMaybe<Scalars['Date']>;
  exceptionConsolidationAt: InputMaybe<Scalars['Date']>;
};

/** Update Job Board Calendar record */
export type UpdateJobBoardCalendarInput = {
  /** Accept now multiplier value */
  acceptNowMultiplier: InputMaybe<Scalars['Float']>;
  /** Job board active or not */
  active: InputMaybe<Scalars['Boolean']>;
  /** End time of job board */
  endTime: InputMaybe<Scalars['String']>;
  /** Job board job duration */
  jobDuration: InputMaybe<Scalars['Int']>;
  /** Max threshold payout value */
  maxThresholdOfPayout: InputMaybe<Scalars['Float']>;
  /** Start time of job board */
  startTime: InputMaybe<Scalars['String']>;
};

/** Input to Update Job Board Region Configuration */
export type UpdateJobBoardRegionConfigurationInput = {
  acceptNowMultiplier: Scalars['Float'];
  endTime: Scalars['String'];
  jobDuration: InputMaybe<Scalars['Int']>;
  maxThresholdOfPayout: Scalars['Float'];
  startTime: Scalars['String'];
};

/** Input data required for updating job */
export type UpdateJobInput = {
  dri: InputMaybe<Scalars['Int']>;
  schedulingDri: InputMaybe<Scalars['Int']>;
  vendorNotes: InputMaybe<Scalars['String']>;
};

/** Input for updating job lines */
export type UpdateJobLineInput = {
  id: Scalars['Int'];
  payoutAdjDescription: InputMaybe<Scalars['String']>;
  payoutAdjReasonCategoryId: InputMaybe<Scalars['Int']>;
  payoutAdjReasonSubCategoryId: InputMaybe<Scalars['Int']>;
  priceUnit: InputMaybe<Scalars['Float']>;
  vendorDueDate: InputMaybe<Scalars['Date']>;
};

/** input for Update Job Request Follower */
export type UpdateJobRequestFollowersInput = {
  addFollowers: InputMaybe<Array<FollowerUserDetailsInput>>;
  removeFollowers: InputMaybe<Array<FollowerUserDetailsInput>>;
};

/** input for augmenting an existing JobRequest */
export type UpdateJobRequestInput = {
  vendorNotes: InputMaybe<Scalars['String']>;
};

/** Input for updating job request lines */
export type UpdateJobRequestLineInput = {
  id: Scalars['Int'];
  payoutAdjDescription: InputMaybe<Scalars['String']>;
  payoutAdjReasonCategoryId: InputMaybe<Scalars['Int']>;
  payoutAdjReasonSubCategoryId: InputMaybe<Scalars['Int']>;
  unitPrice: InputMaybe<Scalars['Float']>;
};

/** Input to update purchaseOrder */
export type UpdatePurchaseOrderInput = {
  referenceId: Scalars['String'];
};

/** Input for MTR to QMR association update */
export type UpdateQmrAssociationInput = {
  cavityPerPart: Scalars['Int'];
  quoteModelRevisionId: Scalars['UUID'];
};

/** The response type when a user updates their email address */
export type UpdatedEmailUser = {
  __typename: 'UpdatedEmailUser';
  accessToken: Scalars['String'];
  email: Scalars['Email'];
  id: Scalars['Int'];
  idToken: Scalars['String'];
};

/** Represents response of upsertTap or Delete Tap Mutation */
export type UpsertOrDeleteTapResponse = {
  __typename: 'UpsertOrDeleteTapResponse';
  /** tap info */
  hole: Hole;
  /** returns valid quoteModelRevisionId */
  quoteModelRevisionId: Maybe<Scalars['String']>;
};

/** Represents response of upsertTaps or DeleteTaps Mutation */
export type UpsertOrDeleteTapsResponse = {
  __typename: 'UpsertOrDeleteTapsResponse';
  /** tap info */
  hole: Array<Hole>;
  /** returns valid quoteModelRevisionId */
  quoteModelRevisionId: Maybe<Scalars['String']>;
};

/** A Fictiv user */
export type User = {
  __typename: 'User';
  achAccounts: Array<AchAccount>;
  businessAccountMembership: Maybe<BusinessAccountMembership>;
  businessAccountSignupStatus: BusinessAccountSignupStatus;
  correctiveActionRequests: Maybe<CorrectiveActionRequests>;
  countryCode: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  creditCards: Array<CreditCard>;
  displayName: Scalars['String'];
  email: Scalars['Email'];
  emailVerificationSentDate: Maybe<Scalars['Date']>;
  emailVerificationStatus: EmailVerificationStatus;
  /** @deprecated Use emailVerificationStatus instead */
  emailVerified: Scalars['Boolean'];
  emailVerifiedDate: Maybe<Scalars['Date']>;
  enabled: Scalars['Boolean'];
  firstName: Maybe<Scalars['String']>;
  flags: Array<UserFeatureFlag>;
  hasSecurePlusMemberships: Scalars['Boolean'];
  id: Scalars['Int'];
  is2faEnabled: Scalars['Boolean'];
  isDfmAnnotationsEnabled: Scalars['Boolean'];
  isIMAndDCQuoteAllowed: Scalars['Boolean'];
  isNUA: Scalars['Boolean'];
  isUserLockedOut: Scalars['Boolean'];
  itarAcceptedDatetime: Maybe<Scalars['Date']>;
  jobRequests: JobRequestResults;
  lastName: Maybe<Scalars['String']>;
  location: Maybe<Scalars['String']>;
  lockoutLoginUntil: Maybe<Scalars['Date']>;
  loginFailedAttempts: Maybe<Scalars['Int']>;
  /** list all mold tools of the user */
  molds: Maybe<Array<Maybe<MoldTool>>>;
  participatesInJobBoard: Maybe<Scalars['Boolean']>;
  /** @deprecated Use type specific paymentOptions: creditCard or achAccounts */
  paymentOptions: Maybe<Array<Maybe<CreditCard>>>;
  phoneNumber: Maybe<Scalars['String']>;
  projects: PartialProjectResults;
  quotePartLimit: Scalars['Int'];
  quotes: Maybe<PartialQuoteViewResults>;
  roles: Array<Role>;
  salesForceAccountIdState: Maybe<SalesForceAccountIdStateEnum>;
  salesOrders: PartialSalesOrderViewResults;
  shippingAddresses: Maybe<Array<UserShippingAddress>>;
  shopProcesses: Array<ShopProcess>;
  teams: PartialTeamsResults;
  updatedAt: Scalars['Date'];
  userEnteredMaterials: Array<UserEnteredMaterial>;
  userPreferences: UserPreferences;
  workspaces: PartialWorkspaceResults;
  zipcode: Maybe<Scalars['String']>;
};


/** A Fictiv user */
export type UserCorrectiveActionRequestsArgs = {
  filters: InputMaybe<MpCorrectiveActionRequestFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort: InputMaybe<MpCorrectiveActionRequestSortInput>;
};


/** A Fictiv user */
export type UserJobRequestsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PageOrder>;
  sort?: InputMaybe<Scalars['String']>;
  states?: InputMaybe<Array<Scalars['String']>>;
};


/** A Fictiv user */
export type UserProjectsArgs = {
  cursor: InputMaybe<Scalars['ENCODED_CURSOR']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['CreatedAtSortKey']>;
};


/** A Fictiv user */
export type UserQuotesArgs = {
  cursor: InputMaybe<Scalars['ENCODED_CURSOR']>;
  filter: InputMaybe<QuoteAttributeFilterType>;
  limit?: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['CreatedAtSortKey']>;
};


/** A Fictiv user */
export type UserSalesOrdersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['CreatedAtSortKey']>;
};


/** A Fictiv user */
export type UserTeamsArgs = {
  filters: InputMaybe<UserTeamsQueryFilterInput>;
  includeTeamsFeatureDisabled?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<UserTeamsQuerySortInput>;
};


/** A Fictiv user */
export type UserWorkspacesArgs = {
  cursor: InputMaybe<Scalars['ENCODED_CURSOR']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['CreatedAtSortKey']>;
};

/** UserBusinessAccountAssociationStatus describes the user's association to a business account */
export type UserBusinessAccountAssociationStatus = {
  __typename: 'UserBusinessAccountAssociationStatus';
  businessAccountId: Maybe<Scalars['String']>;
  businessAccountInviteStatus: Maybe<BusinessAccountInviteStatus>;
  businessAccountName: Maybe<Scalars['String']>;
  isBusinessAccountMember: Maybe<Scalars['Boolean']>;
  isConsultativeDfmFeatureEnabled: Maybe<Scalars['Boolean']>;
  isEmailVerified: Maybe<Scalars['Boolean']>;
  isLTOFeatureEnabled: Maybe<Scalars['Boolean']>;
  isPOFeatureEnabled: Maybe<Scalars['Boolean']>;
  isSalesforceContact: Maybe<Scalars['Boolean']>;
  isTeamsFeatureEnabled: Maybe<Scalars['Boolean']>;
  userId: Scalars['Int'];
};

/** User entered material */
export type UserEnteredMaterial = {
  __typename: 'UserEnteredMaterial';
  createdAt: Scalars['Date'];
  /**
   * This field is really a UUID but needs to be typed as a string
   * because of the SelectedMaterial union
   */
  id: Scalars['String'];
  name: Scalars['String'];
  process: Process;
  user: BasicUser;
};

/** UserFeatureFlag */
export type UserFeatureFlag = {
  __typename: 'UserFeatureFlag';
  key: Scalars['String'];
  variant: Scalars['String'];
};

/** Available mutations on user */
export type UserMutation = {
  __typename: 'UserMutation';
  /** Add ach account for test(e2e cypress) purposes only */
  addAchAccountForTest: Maybe<User>;
  /** Add credit card for test(e2e cypress) purposes only */
  addCreditCardForTest: Maybe<User>;
  /** verify an email address using the token provided in an email */
  claimEmailVerification: ClaimEmailVerificationResponse;
  /** Create stripe client secret */
  createStripeClientSecret: Maybe<Scalars['String']>;
  /** Delete user */
  deleteAccount: Maybe<User>;
  /** Disable 2fa */
  disable2FA: Maybe<User>;
  /** Edit ach account billing information */
  editAchAccount: AchAccount;
  /** Edit credit card billing information */
  editCreditCard: Maybe<CreditCard>;
  /** Edit email */
  editEmail: Maybe<UpdatedEmailUser>;
  /** Edit basic user info */
  editGeneralInfo: Maybe<User>;
  /** Edit password */
  editPassword: Maybe<User>;
  /** Enable 2FA, 1st step of 2 */
  enable2FA: Scalars['String'];
  /** Add/Edit shipping address for user */
  modifyShippingAddress: UserShippingAddress;
  /** Remove ach account for user */
  removeAchAccount: Maybe<Array<AchAccount>>;
  /** Remove credit card for user */
  removeCreditCard: Maybe<Array<Maybe<CreditCard>>>;
  /** Remove shipping address for user */
  removeShippingAddress: Array<UserShippingAddress>;
  /** send an "email verification" email */
  sendEmailVerification: Maybe<SendEmailVerificationResponse>;
  /** update ItarAcceptedDatetime */
  updateItarAcceptedDatetime: Maybe<User>;
  /** Step 2 for enabling 2FA */
  verify2FA: Maybe<User>;
};


/** Available mutations on user */
export type UserMutationAddAchAccountForTestArgs = {
  testPaymentMethod: InputMaybe<Scalars['String']>;
};


/** Available mutations on user */
export type UserMutationAddCreditCardForTestArgs = {
  testPaymentMethod: InputMaybe<Scalars['String']>;
};


/** Available mutations on user */
export type UserMutationClaimEmailVerificationArgs = {
  token: Scalars['String'];
};


/** Available mutations on user */
export type UserMutationCreateStripeClientSecretArgs = {
  paymentTypes: InputMaybe<Array<Scalars['String']>>;
};


/** Available mutations on user */
export type UserMutationDisable2FaArgs = {
  password: InputMaybe<Scalars['String']>;
};


/** Available mutations on user */
export type UserMutationEditAchAccountArgs = {
  achAccountId: Scalars['String'];
  billingInfoInput: BillingInfoInput;
};


/** Available mutations on user */
export type UserMutationEditCreditCardArgs = {
  billingInfoInput: BillingInfoInput;
  cardId: Scalars['String'];
};


/** Available mutations on user */
export type UserMutationEditEmailArgs = {
  email: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
};


/** Available mutations on user */
export type UserMutationEditGeneralInfoArgs = {
  profileInput: UserProfileInput;
};


/** Available mutations on user */
export type UserMutationEditPasswordArgs = {
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
};


/** Available mutations on user */
export type UserMutationModifyShippingAddressArgs = {
  shippingAddressInput: ShippingAddressInput;
};


/** Available mutations on user */
export type UserMutationRemoveAchAccountArgs = {
  achAccountId: Scalars['String'];
};


/** Available mutations on user */
export type UserMutationRemoveCreditCardArgs = {
  cardId: Scalars['String'];
};


/** Available mutations on user */
export type UserMutationRemoveShippingAddressArgs = {
  id: Scalars['Int'];
};


/** Available mutations on user */
export type UserMutationUpdateItarAcceptedDatetimeArgs = {
  id: InputMaybe<Scalars['String']>;
};


/** Available mutations on user */
export type UserMutationVerify2FaArgs = {
  code: Scalars['String'];
};

/** User Preferences */
export type UserPreferences = {
  __typename: 'UserPreferences';
  createdAt: Scalars['Date'];
  deletedAt: Maybe<Scalars['Date']>;
  id: Scalars['Int'];
  preferences: Scalars['JSON'];
  updatedAt: Scalars['Date'];
  user: BasicUser;
};

/** input fields for user profile */
export type UserProfileInput = {
  firstName: InputMaybe<Scalars['String']>;
  lastName: InputMaybe<Scalars['String']>;
  phoneNumber: InputMaybe<Scalars['String']>;
};

/** The user search for admins to find a user */
export type UserSearchInfo = {
  __typename: 'UserSearchInfo';
  createdAt: Scalars['Date'];
  emailAddress: Maybe<Scalars['String']>;
  fullName: Maybe<Scalars['String']>;
  roles: Maybe<Array<Scalars['String']>>;
  userId: Maybe<Scalars['Int']>;
};

/** user output shipping address */
export type UserShippingAddress = {
  __typename: 'UserShippingAddress';
  aptNumber: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  company: Maybe<Scalars['String']>;
  country: Scalars['String'];
  createdAt: Scalars['Date'];
  id: Scalars['Int'];
  isDefault: Maybe<Scalars['Boolean']>;
  isVerified: Maybe<Scalars['Boolean']>;
  name: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  street: Scalars['String'];
  timezone: Maybe<Scalars['String']>;
  zip: Scalars['String'];
};

/** common user type to which includes potential non members */
export type UserTeamMember = {
  __typename: 'UserTeamMember';
  createdAt: Scalars['Date'];
  displayName: Scalars['String'];
  email: Scalars['Email'];
  enabled: Scalars['Boolean'];
  firstName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['Int']>;
  isRequest: Scalars['Boolean'];
  isSelfRequest: Scalars['Boolean'];
  isTeamMember: Scalars['Boolean'];
  joinedDate: Maybe<Scalars['Date']>;
  lastName: Maybe<Scalars['String']>;
  memberType: UserTeamMemberMemberType;
  requestId: Maybe<Scalars['Int']>;
  teamId: Scalars['Int'];
  updatedAt: Scalars['Date'];
};

/** Enum for UserTeamMember memberType */
export enum UserTeamMemberMemberType {
  ACCESS_REQUESTED = 'ACCESS_REQUESTED',
  DEACTIVATED = 'DEACTIVATED',
  PENDING = 'PENDING',
  TEAM_MEMBER = 'TEAM_MEMBER'
}

/** Input for userTeamMemberships query */
export type UserTeamMembersFilterInput = {
  memberType: InputMaybe<UserTeamMembershipFilterMemberType>;
  searchText: InputMaybe<Scalars['String']>;
  teamId: Scalars['Int'];
};

/** Enum for allowed sort in userTeamMembers query */
export enum UserTeamMembersQuerySortInput {
  EMAIL_ASC = 'EMAIL_ASC',
  EMAIL_DESC = 'EMAIL_DESC',
  FIRST_NAME_ASC = 'FIRST_NAME_ASC',
  FIRST_NAME_DESC = 'FIRST_NAME_DESC',
  LAST_NAME_ASC = 'LAST_NAME_ASC',
  LAST_NAME_DESC = 'LAST_NAME_DESC'
}

/** Team memberships enable Business Account members to more easily collaborate */
export type UserTeamMembership = {
  __typename: 'UserTeamMembership';
  createdAt: Scalars['Date'];
  createdBy: BasicUser;
  deletedAt: Maybe<Scalars['Date']>;
  deletedBy: Maybe<BasicUser>;
  id: Scalars['Int'];
  teamId: Scalars['Int'];
  updatedAt: Scalars['Date'];
  updatedBy: BasicUser;
  userId: Scalars['Int'];
};

/** Enum for determining member type */
export enum UserTeamMembershipFilterMemberType {
  ALL = 'ALL',
  EXISTING = 'EXISTING',
  STAGED = 'STAGED'
}

/** Filter Input for UserTeams query */
export type UserTeamsQueryFilterInput = {
  searchText: InputMaybe<Scalars['String']>;
};

/** Enum for allowed sort in User.teams */
export enum UserTeamsQuerySortInput {
  TEAM_NAME_ASC = 'TEAM_NAME_ASC',
  TEAM_NAME_DESC = 'TEAM_NAME_DESC'
}

/** Enum for utm utm campaign */
export enum UtmCampaignType {
  Business_account_invite = 'Business_account_invite',
  Forward_to_purchaser = 'Forward_to_purchaser',
  Share_quote = 'Share_quote'
}

/** Primitive types for conveying geometric data */
export type Vector3 = {
  __typename: 'Vector3';
  x: Scalars['Float'];
  y: Scalars['Float'];
  z: Scalars['Float'];
};

/** 3D Scene data needed for rendering a revision */
export type ViewerScene = {
  __typename: 'ViewerScene';
  featureMapping: Maybe<SceneFile>;
  geometry: Maybe<SceneFile>;
  imPartingLine: Maybe<SceneFile>;
  imSharpEdges: Maybe<SceneFile>;
  imSideActions: Maybe<SceneFile>;
  imThickWallAbs: Maybe<SceneFile>;
  minSetups: Maybe<SceneFile>;
  sharpInternalCorners: Maybe<SceneFile>;
  thinWall: Maybe<SceneFile>;
  unreachableSurfaces: Maybe<SceneFile>;
};

/** model viewer snapshot input for createDfmFeedbackWithSnapshot */
export type ViewerSnapshotInput = {
  assetId: Scalars['UUID'];
  feature: InputMaybe<Scalars['String']>;
  position: Scalars['JSON'];
  snapshot: ModelViewerConfigInput;
  target: Scalars['JSON'];
  type: Scalars['String'];
};

/** Associates an attachment to an work order */
export type WorkOrderAttachment = {
  __typename: 'WorkOrderAttachment';
  attachment: Maybe<Asset>;
  createdAt: Scalars['Date'];
  createdBy: Maybe<BasicUser>;
  deletedAt: Scalars['Date'];
  erpProductId: Maybe<Scalars['Int']>;
  id: Scalars['UUID'];
  source: AllowedAttachmentSources;
  type: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
  visibleToCustomer: Maybe<Scalars['Boolean']>;
  workOrderItemName: Maybe<Scalars['String']>;
};

/** Represents a work order for a vendor to manufacture a set of parts. */
export type WorkOrderComment = {
  __typename: 'WorkOrderComment';
  attachments: Array<ErpAttachment>;
  /** The user object representing the user who authored this comment. */
  author: Maybe<BasicUser>;
  /** Body text of the comment.  Do not allow SQL injection attacks in here. */
  body: Scalars['String'];
  /** Timestamp for when this work order comment was created. */
  createdAt: Scalars['Date'];
  /** Unique identifier for this work order comment.  Machine readable, does not need to be human readable. */
  id: Scalars['Int'];
  /** Subject of the comment */
  subject: Maybe<Scalars['String']>;
  /** Timestamp for when this work order comment was updated. */
  updatedAt: Scalars['Date'];
};

/** WorkspaceInvites is represented by a list of users in a workspace. */
export type WorkspaceInvite = {
  __typename: 'WorkspaceInvite';
  email: Maybe<Scalars['Email']>;
  id: Scalars['UUID'];
  recipient: Maybe<BasicUser>;
  sender: BasicUser;
  status: Scalars['String'];
  token: Scalars['String'];
};

/** A zip download job reference */
export type ZipDownloadJob = {
  __typename: 'ZipDownloadJob';
  error: Maybe<Scalars['String']>;
  /** Hash ID that the Zip File Service returns to GraphQL */
  id: Scalars['String'];
  jobCompleteDate: Maybe<Scalars['Date']>;
  jobStartDate: Scalars['Date'];
  name: Scalars['String'];
  url: Maybe<Scalars['String']>;
};

/** Describes whether a zip code was valid and what the issue was, if not */
export type ZipValidationOutput = {
  __typename: 'ZipValidationOutput';
  errorMsg: Maybe<Scalars['String']>;
  isValid: Scalars['Boolean'];
};

export type ApplyAutoconfigurationMutationVariables = Exact<{
  id: Scalars['UUID'];
  quoteModelRevisionId: Scalars['UUID'];
}>;


export type ApplyAutoconfigurationMutation = { __typename: 'Mutation', autoConfigurePart: boolean };

export type AutoconfigSecondaryProcessConfigFragment = { __typename: 'AutoconfigurationSecondaryProcessDetectionsConfiguration', processColorId: string | null, processId: string | null, processInspectionCriteria: ProcessInspectionCriteria | null, processNumParts: number | null, processThicknessInInches: number | null };

export type AutoconfigSecondaryProcessDetectionsFragment = { __typename: 'AutoconfigurationSecondaryProcessDetections', displayString: string, hashString: string, valid: boolean, tooltipNote: string | null, configuration: { __typename: 'AutoconfigurationSecondaryProcessDetectionsConfiguration', processColorId: string | null, processId: string | null, processInspectionCriteria: ProcessInspectionCriteria | null, processNumParts: number | null, processThicknessInInches: number | null } | null };

export type AutoconfigurationItemFragment = { __typename: 'AutoConfiguration', filename: string, quoteModelRevisionId: string, extractedConfiguration: { __typename: 'AutoconfigurationExtractedConfiguration', canAutoConfigure: boolean, quoteModelRevisionId: string, usableTextFoundInDrawing: boolean, tooltipNote: string | null, materialDetections: Array<{ __typename: 'AutoconfigurationExtractedConfigurationMaterialDetections', displayString: string, platformId: string | null, valid: boolean, tooltipNote: string | null }>, primaryProcessConfig: { __typename: 'AutoconfigurationPrimaryProcessConfig', colorCode: string | null, materialGrade: string | null, materialId: string, priorityId: string | null, processId: string, quantity: number, textureCode: string | null } | null, secondaryProcessConfigs: Array<{ __typename: 'AutoconfigurationSecondaryProcessDetectionsConfiguration', processColorId: string | null, processId: string | null, processInspectionCriteria: ProcessInspectionCriteria | null, processNumParts: number | null, processThicknessInInches: number | null }>, secondaryProcessDetections: Array<{ __typename: 'AutoconfigurationSecondaryProcessDetections', displayString: string, hashString: string, valid: boolean, tooltipNote: string | null, configuration: { __typename: 'AutoconfigurationSecondaryProcessDetectionsConfiguration', processColorId: string | null, processId: string | null, processInspectionCriteria: ProcessInspectionCriteria | null, processNumParts: number | null, processThicknessInInches: number | null } | null }> } | null };

export type AutoconfigurationQueryVariables = Exact<{
  quoteId: Scalars['UUID'];
}>;


export type AutoconfigurationQuery = { __typename: 'Query', autoConfiguration: Array<{ __typename: 'AutoConfiguration', filename: string, quoteModelRevisionId: string, extractedConfiguration: { __typename: 'AutoconfigurationExtractedConfiguration', canAutoConfigure: boolean, quoteModelRevisionId: string, usableTextFoundInDrawing: boolean, tooltipNote: string | null, materialDetections: Array<{ __typename: 'AutoconfigurationExtractedConfigurationMaterialDetections', displayString: string, platformId: string | null, valid: boolean, tooltipNote: string | null }>, primaryProcessConfig: { __typename: 'AutoconfigurationPrimaryProcessConfig', colorCode: string | null, materialGrade: string | null, materialId: string, priorityId: string | null, processId: string, quantity: number, textureCode: string | null } | null, secondaryProcessConfigs: Array<{ __typename: 'AutoconfigurationSecondaryProcessDetectionsConfiguration', processColorId: string | null, processId: string | null, processInspectionCriteria: ProcessInspectionCriteria | null, processNumParts: number | null, processThicknessInInches: number | null }>, secondaryProcessDetections: Array<{ __typename: 'AutoconfigurationSecondaryProcessDetections', displayString: string, hashString: string, valid: boolean, tooltipNote: string | null, configuration: { __typename: 'AutoconfigurationSecondaryProcessDetectionsConfiguration', processColorId: string | null, processId: string | null, processInspectionCriteria: ProcessInspectionCriteria | null, processNumParts: number | null, processThicknessInInches: number | null } | null }> } | null } | null> | null };

export type RequestBusinessAccountInvitesMutationVariables = Exact<{
  businessAccountId: Scalars['UUID'];
  emails: Array<Scalars['String']> | Scalars['String'];
}>;


export type RequestBusinessAccountInvitesMutation = { __typename: 'Mutation', requestBusinessAccountInvites: Array<{ __typename: 'RequestInviteResult', email: string, failureReason: string | null, invite: { __typename: 'BusinessAccountInvite', id: any, email: string, inviteUrl: string | null, sentDate: any | null, status: BusinessAccountInviteStatus } | null }> };

export type FictivHolidayItemFragment = { __typename: 'FictivHoliday', id: string, holiday: string, date: string, country: { __typename: 'Country', code: string } };

export type FictivHolidaysQueryVariables = Exact<{ [key: string]: never; }>;


export type FictivHolidaysQuery = { __typename: 'Query', fictivHolidays: Array<{ __typename: 'FictivHoliday', id: string, holiday: string, date: string, country: { __typename: 'Country', code: string } }> };

export type UpdateItarAcceptedDatetimeMutationVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type UpdateItarAcceptedDatetimeMutation = { __typename: 'Mutation', user: { __typename: 'UserMutation', updateItarAcceptedDatetime: { __typename: 'User', id: number, itarAcceptedDatetime: any | null } | null } | null };

export type ItarAcceptedDatetimeQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type ItarAcceptedDatetimeQuery = { __typename: 'Query', user: { __typename: 'User', id: number, itarAcceptedDatetime: any | null, email: any } | null };

export type MoveQuoteTeamMutationVariables = Exact<{
  teamId: Scalars['Int'];
  userId: Scalars['Int'];
  quoteId: Scalars['UUID'];
}>;


export type MoveQuoteTeamMutation = { __typename: 'Mutation', moveQuoteTeam: { __typename: 'QuoteTeamMembership', id: number } | null };

export type EnableBusinessAccountTrialMutationVariables = Exact<{ [key: string]: never; }>;


export type EnableBusinessAccountTrialMutation = { __typename: 'Mutation', enableBusinessAccountTrial: string };

export type MpExceptionFailuresQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: InputMaybe<Scalars['Int']>;
  sort: InputMaybe<ExceptionFailuresSort>;
  filters: InputMaybe<ExceptionFailuresFilterInput>;
}>;


export type MpExceptionFailuresQuery = { __typename: 'Query', exceptionFailures: { __typename: 'PartialExceptionFailureResults', totalCount: number, items: Array<{ __typename: 'ExceptionFailure', id: any, name: string, exceptionFailureState: string, jobId: number, jobName: string, salesOrderName: string, assignee: string | null, type: string, isFailure: boolean, assignedEntity: string | null, createdAt: any | null, updatedAt: any | null, jobRequest: { __typename: 'JobRequest', id: number, name: string } | null, correctiveActionRequest: { __typename: 'CorrectiveActionRequest', id: any, name: string, type: CorrectiveActionRequestType, status: CorrectiveActionRequestStatus, turnaroundDays: number | null } | null, exceptionFailureParts: Array<{ __typename: 'ExceptionPart', lines: string | null }> | null }> | null } };

export type GetFailuresListQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: InputMaybe<Scalars['Int']>;
  sort: InputMaybe<AllowedExceptionsSort>;
  filters: InputMaybe<ExceptionsFilterInput>;
}>;


export type GetFailuresListQuery = { __typename: 'Query', exceptions: { __typename: 'PartialExceptionResults', totalCount: number, items: Array<{ __typename: 'Exception', id: any, name: string, rfqNumber: string | null, exceptionState: string, workOrderName: string | null, salesOrderName: string | null, erpSaleOrderId: number, jobId: number, mpName: string | null, assignee: string | null, type: string | null, action: string | null, otifIsActive: boolean, otFailureFictiv: boolean, otFailureMP: boolean, otFailureCustomer: boolean, ifFailureMP: boolean, ifFailureFictiv: boolean, ifFailureCustomer: boolean, ignoreFailureForMpCalculation: boolean | null, workOrderRequestDate: any | null, earliestReceiptDate: any | null, earliestPromisedShipDate: any | null, earliestScheduledDeliveryDate: any | null, updatedAt: any | null, otFailureMPDays: number | null, otFailureFictivDays: number | null, otFailureCustomerDays: number | null, workOrderRequestId: number, actionId: number, typeId: number, failureDiscoveredBy: string | null, createdAt: any | null, nonConformanceEmailSentOn: any | null, exceptionParts: Array<{ __typename: 'ExceptionPart', id: number, erpProductId: number, partName: string | null, failedQuantity: number, lines: string | null }> | null, jobRequest: { __typename: 'JobRequest', name: string } | null, correctiveActionRequestForList: Array<{ __typename: 'BasicCarInfo', id: any, name: string, type: string, status: string, turnaroundDays: number | null }> | null, project: { __typename: 'BasicProject', id: any | null, name: string, isSecurePlus: boolean } | null, latestNote: { __typename: 'ExceptionNote', id: number, body: string | null, createdAt: any | null, createdBy: { __typename: 'BasicUser', id: number, displayName: string } | null, exceptionNoteAttachments: Array<{ __typename: 'ExceptionAttachment', id: any, attachment: { __typename: 'Asset', id: any, mimeType: string | null, downloadUrl: string | null } | null }> | null } | null, failureRootCauses: Array<{ __typename: 'ExceptionFailureRootCause', id: number, description: string }> | null, createdBy: { __typename: 'BasicUser', id: number, displayName: string } | null }> } };

export type SetMachineDetailsMutationVariables = Exact<{
  machineDetails: MfgPartnerMachineDetailsInput;
}>;


export type SetMachineDetailsMutation = { __typename: 'Mutation', updateMfgPartnerMachineDetails: { __typename: 'MfgPartnerMachineDetails', id: number } | null };

export type SetMaterialAvailabilityMutationVariables = Exact<{
  partnerId: Scalars['Int'];
  processId: Scalars['Int'];
  materialId: Scalars['Int'];
  isActive: InputMaybe<Scalars['Boolean']>;
}>;


export type SetMaterialAvailabilityMutation = { __typename: 'Mutation', setMfgPartnerMaterial: boolean };

export type SetShopProcessAvailabilityMutationVariables = Exact<{
  availabilityInput: Array<AvailabilityInput> | AvailabilityInput;
  partnerId: InputMaybe<Scalars['Int']>;
}>;


export type SetShopProcessAvailabilityMutation = { __typename: 'Mutation', setShopProcessAvailability: boolean };

export type SetProcessPreferenceMutationVariables = Exact<{
  partnerId: Scalars['Int'];
  capabilities: MfgPartnerProcessCapabilitiesInput;
}>;


export type SetProcessPreferenceMutation = { __typename: 'Mutation', createOrUpdateMfgPartnerProcessCapabilities: { __typename: 'MfgPartnerProcessCapabilities', id: number } | null };

export type MfgPartnerOverallStatisticsQueryVariables = Exact<{
  mfgPartnerId: InputMaybe<Scalars['Int']>;
}>;


export type MfgPartnerOverallStatisticsQuery = { __typename: 'Query', mfgPartnerOverallStatistics: { __typename: 'MfgPartnerOverallStatistics', partnerId: number, mpLevel: MfgPartnerLevelType | null, jobCompletedCount: number, jobCompletedAmount: number, uniquePartsCompletedCount: number, totalCarsCount: number, totalDays: number, mpLevelOverrideRecord: { __typename: 'MfgPartnerLevelOverride', mpLevelOverride: MfgPartnerLevelType, id: number, expiresAt: any } | null } | null };

export type Scorecard_Car_Chart_ItemsFragment = { __typename: 'MfgPartnerLevelCalculationRecord', recordType: RecordType, recordDate: any | null, avgCarTurnaroundDays: number };

export type GetScorecardCarChartDataQueryVariables = Exact<{
  mfgPartnerId: Scalars['Int'];
  filters: InputMaybe<MfgPartnerLevelsFiltersInput>;
}>;


export type GetScorecardCarChartDataQuery = { __typename: 'Query', mfgPartnerLevelRecords: { __typename: 'MfgPartnerLevelRecords', items: Array<{ __typename: 'MfgPartnerLevelCalculationRecord', recordType: RecordType, recordDate: any | null, avgCarTurnaroundDays: number }> | null } | null };

export type Scorecard_Rating_Chart_ItemsFragment = { __typename: 'MfgPartnerLevelCalculationRecord', recordType: RecordType, recordDate: any | null, acceptanceRatio: number, expirationRatio: number, otRatio: number, ifRatio: number };

export type GetScorecardRatingChartDataQueryVariables = Exact<{
  mfgPartnerId: Scalars['Int'];
  filters: InputMaybe<MfgPartnerLevelsFiltersInput>;
}>;


export type GetScorecardRatingChartDataQuery = { __typename: 'Query', mfgPartnerLevelRecords: { __typename: 'MfgPartnerLevelRecords', items: Array<{ __typename: 'MfgPartnerLevelCalculationRecord', recordType: RecordType, recordDate: any | null, acceptanceRatio: number, expirationRatio: number, otRatio: number, ifRatio: number }> | null } | null };

export type GetMachineDetailsByProcessIdQueryVariables = Exact<{
  processId: Scalars['Int'];
  partnerId: Scalars['Int'];
}>;


export type GetMachineDetailsByProcessIdQuery = { __typename: 'Query', getMfgPartnerMachineDetails: { __typename: 'MfgPartnerMachineDetails', id: number, fourAxisCount: number | null, fivePlusAxisCount: number | null, description: string | null, partnerId: number, processId: number, platformProcessId: string | null, platformProcessTypeId: string | null, totalCount: number | null, threeAxisCount: number | null, manualLatheCount: number | null, liveToolingLatheCount: number | null, isFourAxisSupported: boolean | null, isFiveAxisSupported: boolean | null, isLiveToolingSupported: boolean | null, minX: number | null, minY: number | null, minZ: number | null, maxX: number | null, maxY: number | null, maxZ: number | null } | null };

export type GetMaterialsByMpIdMfgPartnerMaterialFragment = { __typename: 'MfgPartnerMaterial', isActive: boolean, materialId: number, materialName: string, erpProcessId: number };

export type GetMaterialsByMpIdMfgPartnerMaterialsFragment = { __typename: 'MfgPartnerMaterialResult', materialCategoryId: string | null, materialCategoryName: string | null, erpPlatformProcessId: string, partnerMaterials: Array<{ __typename: 'MfgPartnerMaterial', isActive: boolean, materialId: number, materialName: string, erpProcessId: number }> };

export type GetMaterialsByMpIdQueryVariables = Exact<{
  partnerId: Scalars['Int'];
}>;


export type GetMaterialsByMpIdQuery = { __typename: 'Query', getMfgPartnerMaterials: Array<{ __typename: 'MfgPartnerMaterialResult', materialCategoryId: string | null, materialCategoryName: string | null, erpPlatformProcessId: string, partnerMaterials: Array<{ __typename: 'MfgPartnerMaterial', isActive: boolean, materialId: number, materialName: string, erpProcessId: number }> }> | null };

export type ProcessAvailabilityFragment = { __typename: 'ShopProcessAvailability', accepting: boolean, date: any };

export type ProcessAvailabilityByProcessIdFragment = { __typename: 'PartnerShopProcessAvailability', availability: Array<{ __typename: 'ShopProcessAvailability', accepting: boolean, date: any }> | null };

export type GetProcessAvailabilityByProcessIdQueryVariables = Exact<{
  availabilityInput: PartnerShopAvailabilityInput;
}>;


export type GetProcessAvailabilityByProcessIdQuery = { __typename: 'Query', getPartnerShopProcessAvailability: { __typename: 'PartnerShopProcessAvailability', availability: Array<{ __typename: 'ShopProcessAvailability', accepting: boolean, date: any }> | null } | null };

export type GetProcessPreferenceByIdFragmentFragment = { __typename: 'MfgPartnerProcessCapabilities', id: number, erpProcessId: number, isVeryUrgentSupported: boolean | null, minSetups: number | null, maxSetups: number | null, minLeadTime: number | null, minQuantity: number | null, minPayout: number | null, maxPayout: number | null, targetSpendOverride: number | null, targetSpendOverrideExpiresAt: any | null, overloadSpend: number | null, overloadSpendJobCount: number | null, isMouSigned: boolean | null, mouSpend: number | null, mouStartsAt: any | null, mouExpiresAt: any | null, payoutMultiplier: number, openJobRequestsCount: number | null, openJobRequestsValue: number | null, currentTargetSpend: number | null, calculatedTargetSpend: number | null, backstopMp: boolean | null, supportingCapabilities: Array<{ __typename: 'SupportingCapabilities', id: string, name: string }> | null };

export type GetProcessPreferenceByIdQueryVariables = Exact<{
  partnerId: Scalars['Int'];
  erpProcessId: Scalars['Int'];
}>;


export type GetProcessPreferenceByIdQuery = { __typename: 'Query', getMfgPartnerProcessCapabilities: { __typename: 'MfgPartnerProcessCapabilities', id: number, erpProcessId: number, isVeryUrgentSupported: boolean | null, minSetups: number | null, maxSetups: number | null, minLeadTime: number | null, minQuantity: number | null, minPayout: number | null, maxPayout: number | null, targetSpendOverride: number | null, targetSpendOverrideExpiresAt: any | null, overloadSpend: number | null, overloadSpendJobCount: number | null, isMouSigned: boolean | null, mouSpend: number | null, mouStartsAt: any | null, mouExpiresAt: any | null, payoutMultiplier: number, openJobRequestsCount: number | null, openJobRequestsValue: number | null, currentTargetSpend: number | null, calculatedTargetSpend: number | null, backstopMp: boolean | null, supportingCapabilities: Array<{ __typename: 'SupportingCapabilities', id: string, name: string }> | null } | null };

export type ProcessesListByMfgIdFragment = { __typename: 'ShopProcessDetail', platformProcessId: string, platformProcessTypeId: string, processId: number, processName: string, showMpAvailability: boolean };

export type GetProcessesByMfgIdQueryVariables = Exact<{
  partnerId: Scalars['Int'];
}>;


export type GetProcessesByMfgIdQuery = { __typename: 'Query', getShopProcessesByPartnerId: Array<{ __typename: 'ShopProcessDetail', platformProcessId: string, platformProcessTypeId: string, processId: number, processName: string, showMpAvailability: boolean } | null> | null };

export type GetSupportingCapabilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSupportingCapabilitiesQuery = { __typename: 'Query', getSupportingCapabilities: Array<{ __typename: 'SupportingCapabilities', id: string, name: string }> | null };

export type AdminJobRequestsQueryQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: InputMaybe<Scalars['Int']>;
  filters: InputMaybe<AdminJobRequestFiltersInput>;
  sort: InputMaybe<AllowedAdminJobRequestSort>;
}>;


export type AdminJobRequestsQueryQuery = { __typename: 'Query', adminJobRequests: { __typename: 'JobRequestResults', totalCount: number, items: Array<{ __typename: 'JobRequest', id: number, name: string, jobId: number, salesOrderName: string, priority: string | null, earliestDeliveryOrderDate: any | null, jobRequestStatus: string | null, earliestReceiptdate: any | null, vendorDueDate: any, originalVendorDueDate: any, project: { __typename: 'BasicProject', id: any | null, name: string, isSecurePlus: boolean } | null, mfgDri: { __typename: 'User', id: number, displayName: string } | null, mfgPartner: { __typename: 'MfgPartner', id: number } }> | null } };

export type MfgPartnerBasicInfoQueryQueryVariables = Exact<{
  id: Scalars['Int'];
  date: Scalars['Date'];
}>;


export type MfgPartnerBasicInfoQueryQuery = { __typename: 'Query', mfgPartner: { __typename: 'MfgPartner', id: number, name: string, displayName: string, preferredCarriers: Array<string> | null, skipOrPauseSchedulingQueue: string, countryName: string, tz: string, mpCutoffTime: string, highTouchOnly: boolean | null, isEligibleForWork: boolean | null, backstopMp: boolean | null, isSecurePlusMp: boolean, fictivHiatus: boolean | null, gmleGroup: string | null, processes: Array<{ __typename: 'MfgPartnerProcess', erpProcessId: number, processName: string }> | null, processesWithAvailability: Array<{ __typename: 'MfgPartnerProcessAvailability', erpProcessId: number, processName: string, availability: Array<{ __typename: 'ShopProcessAvailability', accepting: boolean, acceptingDisabled: boolean, available: boolean, date: any }> | null }> | null, jobAcceptanceHours: Array<{ __typename: 'MfgPartnerJobAcceptanceHours', partnerId: number, name: string | null, day: number, dayName: string, openTime: string, closeTime: string } | null>, strategicSourcingManager: { __typename: 'BasicUser', id: number, displayName: string, firstName: string | null, lastName: string | null } | null, supplierQualityEngineer: { __typename: 'BasicUser', id: number, displayName: string, firstName: string | null, lastName: string | null } | null, supplierDevelopmentEngineer: { __typename: 'BasicUser', id: number, displayName: string, firstName: string | null, lastName: string | null } | null, currentMpLevelDetails: { __typename: 'MfgPartnerLevelCalculationRecord', mpLevel: MfgPartnerLevelType } | null } | null };

export type MpPerformanceListQueryQueryVariables = Exact<{
  mfgPartnerId: Scalars['Int'];
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  sort: InputMaybe<AllowedMfgPartnerLevelsSort>;
  filters: InputMaybe<MfgPartnerLevelsFiltersInput>;
}>;


export type MpPerformanceListQueryQuery = { __typename: 'Query', mfgPartnerLevelRecords: { __typename: 'MfgPartnerLevelRecords', totalCount: number, items: Array<{ __typename: 'MfgPartnerLevelCalculationRecord', id: number, recordType: RecordType, fromDate: any | null, toDate: any | null, recordDate: any | null, scoreCardSharedWithMp: boolean, scorecardSentAt: any | null, mpLevel: MfgPartnerLevelType, acceptanceLevel: MfgPartnerLevelType, acceptanceRatio: number, jobAcceptedCount: number, jobSentCount: number, jobAcceptedAmount: number, expirationLevel: MfgPartnerLevelType, expirationRatio: number, jobExpiredCount: number, jobExpiredAmount: number, otRatio: number, otLevel: MfgPartnerLevelType, jobCompletedCount: number, ifLevel: MfgPartnerLevelType, ifRatio: number, avgCarTurnaroundDays: number, carLevel: MfgPartnerLevelType, thresholdConfiguration: Array<number>, jobRequestsCompletedCountLongTerm: number, jobRequestLineItemsCount: { __typename: 'LineItemsCountType', otCount: number, total: number, ifCount: number } | null }> | null } | null };

export type BasicUserPartFragment = { __typename: 'BasicUser', id: number, displayName: string };

export type AssignedStrategicSourcingManagersQueryVariables = Exact<{ [key: string]: never; }>;


export type AssignedStrategicSourcingManagersQuery = { __typename: 'Query', assignedStrategicSourcingManagers: Array<{ __typename: 'BasicUser', id: number, displayName: string }> | null };

export type AssignedSupplierDevelopmentEngineersQueryVariables = Exact<{ [key: string]: never; }>;


export type AssignedSupplierDevelopmentEngineersQuery = { __typename: 'Query', assignedSupplierDevelopmentEngineers: Array<{ __typename: 'BasicUser', id: number, displayName: string }> | null };

export type MfgPartnerLevelOverridePartFragment = { __typename: 'MfgPartnerLevelOverride', expiresAt: any, id: number, mpLevelOverride: MfgPartnerLevelType, partnerId: number };

export type MfgPartnerLevelCalculationRecordPartFragment = { __typename: 'MfgPartnerLevelCalculationRecord', acceptanceLevel: MfgPartnerLevelType, acceptanceRatio: number, expirationLevel: MfgPartnerLevelType, expirationRatio: number, ifLevel: MfgPartnerLevelType, ifRatio: number, otLevel: MfgPartnerLevelType, otRatio: number, avgCarTurnaroundDays: number, carLevel: MfgPartnerLevelType, mpLevel: MfgPartnerLevelType, mpLevelOverrideRecord: { __typename: 'MfgPartnerLevelOverride', expiresAt: any, id: number, mpLevelOverride: MfgPartnerLevelType, partnerId: number } | null };

export type MfgPartnerPartFragment = { __typename: 'MfgPartner', id: number, name: string, tz: string, openJobsCount: number | null, countryName: string, openFailuresCount: number | null, openCarsCount: number | null, isEligibleForWork: boolean | null, isApprovedVendor: boolean, lastScorecardSent: boolean | null, mpLevelOverrideInEffect: boolean | null, supplierQualityEngineer: { __typename: 'BasicUser', id: number, displayName: string } | null, strategicSourcingManager: { __typename: 'BasicUser', id: number, displayName: string } | null, supplierDevelopmentEngineer: { __typename: 'BasicUser', id: number, displayName: string } | null, currentMpLevelDetails: { __typename: 'MfgPartnerLevelCalculationRecord', acceptanceLevel: MfgPartnerLevelType, acceptanceRatio: number, expirationLevel: MfgPartnerLevelType, expirationRatio: number, ifLevel: MfgPartnerLevelType, ifRatio: number, otLevel: MfgPartnerLevelType, otRatio: number, avgCarTurnaroundDays: number, carLevel: MfgPartnerLevelType, mpLevel: MfgPartnerLevelType, mpLevelOverrideRecord: { __typename: 'MfgPartnerLevelOverride', expiresAt: any, id: number, mpLevelOverride: MfgPartnerLevelType, partnerId: number } | null } | null };

export type MfgPartnersQueryVariables = Exact<{
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  filters: InputMaybe<MfgPartnerFiltersInput>;
  sort: InputMaybe<AllowedMfgPartnerSort>;
}>;


export type MfgPartnersQuery = { __typename: 'Query', mfgPartners: { __typename: 'MfgPartnersResults', offset: number | null, totalCount: number, items: Array<{ __typename: 'MfgPartner', id: number, name: string, tz: string, openJobsCount: number | null, countryName: string, openFailuresCount: number | null, openCarsCount: number | null, isEligibleForWork: boolean | null, isApprovedVendor: boolean, lastScorecardSent: boolean | null, mpLevelOverrideInEffect: boolean | null, supplierQualityEngineer: { __typename: 'BasicUser', id: number, displayName: string } | null, strategicSourcingManager: { __typename: 'BasicUser', id: number, displayName: string } | null, supplierDevelopmentEngineer: { __typename: 'BasicUser', id: number, displayName: string } | null, currentMpLevelDetails: { __typename: 'MfgPartnerLevelCalculationRecord', acceptanceLevel: MfgPartnerLevelType, acceptanceRatio: number, expirationLevel: MfgPartnerLevelType, expirationRatio: number, ifLevel: MfgPartnerLevelType, ifRatio: number, otLevel: MfgPartnerLevelType, otRatio: number, avgCarTurnaroundDays: number, carLevel: MfgPartnerLevelType, mpLevel: MfgPartnerLevelType, mpLevelOverrideRecord: { __typename: 'MfgPartnerLevelOverride', expiresAt: any, id: number, mpLevelOverride: MfgPartnerLevelType, partnerId: number } | null } | null }> | null } };

export type MfgPartnerLevelSnapshotDetails_Cars_ItemsFragment = { __typename: 'MfgPartnerLevelCarsSnapshotDetail', carCanceledAt: any | null, carId: any, carName: string, carSentAt: any | null, carStatus: string, carSubmittedAt: any | null, carTurnaroundDays: number, exceptionId: any, exceptionName: string, jobId: number, jobRequestId: number, jobRequestName: string };

export type GetMpPerformanceCarsQueryVariables = Exact<{
  snapshotId: Scalars['Int'];
  mfgPartnerLevelCarsInput: InputMaybe<MfgPartnerLevelCarsInput>;
}>;


export type GetMpPerformanceCarsQuery = { __typename: 'Query', mfgPartnerLevelSnapshotDetails: { __typename: 'MfgPartnerLevelSnapshotDetails', correctiveActionRequests: { __typename: 'MfgPartnerLevelCarsType', totalCount: number | null, items: Array<{ __typename: 'MfgPartnerLevelCarsSnapshotDetail', carCanceledAt: any | null, carId: any, carName: string, carSentAt: any | null, carStatus: string, carSubmittedAt: any | null, carTurnaroundDays: number, exceptionId: any, exceptionName: string, jobId: number, jobRequestId: number, jobRequestName: string }> | null } | null } | null };

export type MfgPartnerLevelSnapshotDetails_Failures_ItemsFragment = { __typename: 'MfgPartnerLevelFailureSnapshotDetail', exceptionId: any, exceptionName: string, ifFailureMp: boolean | null, otFailureMp: boolean | null, saleOrderId: number, saleOrderName: string, type: ExceptionFailureMpType | null, jobRequestName: string, jobId: number, exceptionCreatedAt: any, exceptionParts: Array<{ __typename: 'MfgPartnerLevelExceptionPart', lines: string | null }> };

export type GetMpPerformanceFailuresQueryVariables = Exact<{
  snapshotId: Scalars['Int'];
  mfgPartnerLevelFailuresInput: InputMaybe<MfgPartnerLevelFailuresInput>;
}>;


export type GetMpPerformanceFailuresQuery = { __typename: 'Query', mfgPartnerLevelSnapshotDetails: { __typename: 'MfgPartnerLevelSnapshotDetails', failures: { __typename: 'MfgPartnerLevelFailureType', totalCount: number | null, items: Array<{ __typename: 'MfgPartnerLevelFailureSnapshotDetail', exceptionId: any, exceptionName: string, ifFailureMp: boolean | null, otFailureMp: boolean | null, saleOrderId: number, saleOrderName: string, type: ExceptionFailureMpType | null, jobRequestName: string, jobId: number, exceptionCreatedAt: any, exceptionParts: Array<{ __typename: 'MfgPartnerLevelExceptionPart', lines: string | null }> }> | null } | null } | null };

export type MfgPartnerLevelSnapshotDetails_JobRequests_ItemsFragment = { __typename: 'MfgPartnerLevelJobRequestSnapshotDetail', jobId: number, jobRequestName: string, jobRequestId: number, saleOrderName: string, projectId: string | null, projectName: string | null, isSecurePlus: boolean | null, priority: string | null, jobRequestStatus: string, acceptedAt: any | null, expiresAt: any, completedAt: any | null, rejectedAt: any | null };

export type GetMpPerformanceJobRequestsQueryVariables = Exact<{
  snapshotId: Scalars['Int'];
  mfgPartnerLevelJobRequestInput: InputMaybe<MfgPartnerLevelJobRequestInput>;
}>;


export type GetMpPerformanceJobRequestsQuery = { __typename: 'Query', mfgPartnerLevelSnapshotDetails: { __typename: 'MfgPartnerLevelSnapshotDetails', jobRequests: { __typename: 'MfgPartnerLevelJobRequestType', totalCount: number | null, items: Array<{ __typename: 'MfgPartnerLevelJobRequestSnapshotDetail', jobId: number, jobRequestName: string, jobRequestId: number, saleOrderName: string, projectId: string | null, projectName: string | null, isSecurePlus: boolean | null, priority: string | null, jobRequestStatus: string, acceptedAt: any | null, expiresAt: any, completedAt: any | null, rejectedAt: any | null }> | null } | null } | null };

export type CarAssociatedExceptionsFragment = { __typename: 'ExceptionFailureDetail', id: any, name: string };

export type MfgPartnerLevelSnapshotDetails_Car_ItemsFragment = { __typename: 'MfgPartnerLevelCarsSnapshotDetail', carCanceledAt: any | null, carId: any, carName: string, carSentAt: any | null, carStatus: string, carSubmittedAt: any | null, carTurnaroundDays: number, jobId: number, jobRequestId: number, jobRequestName: string, exceptions: Array<{ __typename: 'ExceptionFailureDetail', id: any, name: string }> | null };

export type GetMpPerformanceCarsForAutoOtQueryVariables = Exact<{
  snapshotId: Scalars['Int'];
  mfgPartnerLevelCarsInput: InputMaybe<MfgPartnerLevelCarsInput>;
}>;


export type GetMpPerformanceCarsForAutoOtQuery = { __typename: 'Query', mfgPartnerLevelSnapshotDetails: { __typename: 'MfgPartnerLevelSnapshotDetails', correctiveActionRequests: { __typename: 'MfgPartnerLevelCarsType', totalCount: number | null, items: Array<{ __typename: 'MfgPartnerLevelCarsSnapshotDetail', carCanceledAt: any | null, carId: any, carName: string, carSentAt: any | null, carStatus: string, carSubmittedAt: any | null, carTurnaroundDays: number, jobId: number, jobRequestId: number, jobRequestName: string, exceptions: Array<{ __typename: 'ExceptionFailureDetail', id: any, name: string }> | null }> | null } | null } | null };

export type MpPerformanceSummaryQueryVariables = Exact<{
  snapshotId: Scalars['Int'];
}>;


export type MpPerformanceSummaryQuery = { __typename: 'Query', mfgPartnerLevelSnapshotDetails: { __typename: 'MfgPartnerLevelSnapshotDetails', mfgPartner: { __typename: 'BasicMfgPartner', id: number, name: string }, mfgPartnerLevel: { __typename: 'MfgPartnerLevelCalculationRecord', recordType: RecordType, recordDate: any | null, fromDate: any | null, toDate: any | null, mpLevel: MfgPartnerLevelType, acceptanceLevel: MfgPartnerLevelType, acceptanceRatio: number, jobAcceptedCount: number, jobSentCount: number, jobAcceptedAmount: number, expirationLevel: MfgPartnerLevelType, expirationRatio: number, jobExpiredCount: number, jobExpiredAmount: number, otRatio: number, otLevel: MfgPartnerLevelType, jobCompletedCount: number, ifLevel: MfgPartnerLevelType, ifRatio: number, avgCarTurnaroundDays: number, carLevel: MfgPartnerLevelType, jobRequestLineItemsCount: { __typename: 'LineItemsCountType', otCount: number, total: number, ifCount: number } | null } | null } | null };

export type MpPerformanceJobRequestsQueryVariables = Exact<{
  snapshotId: Scalars['Int'];
  mfgPartnerLevelJobRequestInput: InputMaybe<MfgPartnerLevelJobRequestInput>;
}>;


export type MpPerformanceJobRequestsQuery = { __typename: 'Query', mfgPartnerLevelSnapshotDetails: { __typename: 'MfgPartnerLevelSnapshotDetails', jobRequests: { __typename: 'MfgPartnerLevelJobRequestType', totalCount: number | null, items: Array<{ __typename: 'MfgPartnerLevelJobRequestSnapshotDetail', jobId: number, jobRequestName: string, saleOrderName: string, projectId: string | null, projectName: string | null, isSecurePlus: boolean | null, priority: string | null, jobRequestStatus: string, acceptedAt: any | null, expiresAt: any, completedAt: any | null, rejectedAt: any | null }> | null } | null } | null };

export type ResetMpLevelOverrideMutationVariables = Exact<{
  partnerId: Scalars['Int'];
}>;


export type ResetMpLevelOverrideMutation = { __typename: 'Mutation', deactivateMfgPartnerLevelOverride: boolean };

export type SetMpLevelOverrideMutationVariables = Exact<{
  partnerId: Scalars['Int'];
  mpLevelOverride: MfgPartnerLevelType;
  expiresAt: Scalars['Date'];
}>;


export type SetMpLevelOverrideMutation = { __typename: 'Mutation', createMfgPartnerLevelOverride: { __typename: 'MfgPartnerLevelOverride', id: number } };

export type CreateCorrectiveActionRequestAttachmentMutationVariables = Exact<{
  input: CorrectiveActionRequestAttachmentInput;
}>;


export type CreateCorrectiveActionRequestAttachmentMutation = { __typename: 'Mutation', createCorrectiveActionRequestAttachment: { __typename: 'CorrectiveActionRequestAttachment', id: any, correctiveActionRequestId: any, attachment: { __typename: 'Asset', id: any, uploadUrl: string | null, fileName: string, extension: string | null, mimeType: string | null } | null } };

export type CancelCorrectiveActionRequestMutationVariables = Exact<{
  correctiveActionRequestId: Scalars['String'];
  reason: ManualCarCancelationReasons;
  rootCauseReasons: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type CancelCorrectiveActionRequestMutation = { __typename: 'Mutation', cancelCorrectiveActionRequest: string };

export type CorrectiveActionRequestResponseOptionsQueryVariables = Exact<{
  correctiveActionRequestQuestion: CorrectiveActionRequestQuestionType;
}>;


export type CorrectiveActionRequestResponseOptionsQuery = { __typename: 'Query', correctiveActionRequestResponseOptions: Array<{ __typename: 'CorrectiveActionRequestQuestionOption', id: number, description: string }> | null };

export type RemoveCorrectiveActionRequestAttachmentMutationVariables = Exact<{
  removeCorrectiveActionRequestAttachmentId: Scalars['UUID'];
}>;


export type RemoveCorrectiveActionRequestAttachmentMutation = { __typename: 'Mutation', removeCorrectiveActionRequestAttachment: any };

export type MarkCorrectiveActionRequestAttachmentVisibilityMutationVariables = Exact<{
  correctiveActionRequestAttachmentId: Scalars['UUID'];
  correctiveActionRequestId: Scalars['UUID'];
  isVisible: Scalars['Boolean'];
}>;


export type MarkCorrectiveActionRequestAttachmentVisibilityMutation = { __typename: 'Mutation', markCorrectiveActionRequestAttachmentVisibility: any };

export type CorrectiveActionRequestDetailsQueryQueryVariables = Exact<{
  correctiveActionRequestId: Scalars['UUID'];
}>;


export type CorrectiveActionRequestDetailsQueryQuery = { __typename: 'Query', correctiveActionRequest: { __typename: 'CorrectiveActionRequest', id: any, name: string, type: CorrectiveActionRequestType, status: CorrectiveActionRequestStatus, reworkText: string | null, businessUnit: string | null, dueAt: any | null, createdAt: any, viewedAt: any | null, submittedAt: any | null, approvedAt: any | null, closedAt: any | null, canceledAt: any | null, cancelationReason: CancellationReasonType | null, sentForReworkAt: any | null, sentAt: any | null, associatedExceptionFailureTypes: Array<string | null> | null, supplierQualityEngineer: { __typename: 'BasicUser', id: number, displayName: string } | null, assignee: { __typename: 'BasicUser', id: number, displayName: string } | null, mfgPartner: { __typename: 'MfgPartner', id: number, name: string, displayName: string } | null, salesOrder: { __typename: 'SalesOrder', id: string, name: string, customerName: string | null, customerCompanyName: string | null, salesOrderLines: { __typename: 'PartialSalesOrderLineResults', items: Array<{ __typename: 'SalesOrderLine', processName: string | null }> } } | null, questionnaire: Array<{ __typename: 'CorrectiveActionRequestQuestionResponse', id: number, question: CorrectiveActionRequestQuestionType, response: { __typename: 'CorrectiveActionRequestResponse', responseText: string | null, sanitizedResponseText: string | null, selectedOptions: Array<{ __typename: 'CorrectiveActionRequestQuestionSelectedOption', id: number, description: string, active: boolean | null }> | null } | null }> | null, attachments: Array<{ __typename: 'CorrectiveActionRequestAttachment', id: any, visibleToCustomer: boolean | null, source: CorrectiveActionRequestAttachmentSourceType, correctiveActionRequestId: any, attachment: { __typename: 'Asset', id: any, downloadUrl: string | null, uploadUrl: string | null, fileName: string, mimeType: string | null } | null }> | null, exceptionDetails: { __typename: 'Exception', id: any, name: string, otifIsActive: boolean, otFailureFictiv: boolean, otFailureFictivDays: number | null, otFailureMP: boolean, otFailureMPDays: number | null, otFailureCustomer: boolean, otFailureCustomerDays: number | null, ifFailureFictiv: boolean, ifFailureMP: boolean, ifFailureCustomer: boolean, failureDiscoveredBy: string | null, additionalContext: string | null, exceptionParts: Array<{ __typename: 'ExceptionPart', id: number, lines: string | null }> | null, jobRequest: { __typename: 'JobRequest', id: number, name: string, jobId: number } | null, nonConformanceAttachments: Array<{ __typename: 'ExceptionAttachment', id: any, attachment: { __typename: 'Asset', id: any, mimeType: string | null, downloadUrl: string | null } | null }> | null } | null, history: Array<{ __typename: 'ChangeHistory', id: number, objectType: string, objectId: string, contextKey: string | null, oldValue: string | null, newValue: string | null, message: string | null, createdAt: any | null, createdBy: { __typename: 'BasicUser', id: number, displayName: string } | null }> | null, associatedExceptionFailures: Array<{ __typename: 'BasicExceptionFailure', id: string, name: string, exceptionFailureState: string, milestoneType: string | null, type: string, assignedEntity: string | null, additionalContext: string | null, isCustomerImpacted: boolean | null, exceptionFailureAttachments: Array<{ __typename: 'ExceptionFailureAttachment', id: any, attachment: { __typename: 'Asset', id: any, mimeType: string | null, downloadUrl: string | null } | null }> | null, exceptionFailureParts: Array<{ __typename: 'ExceptionPart', id: number, lines: string | null, failedQuantity: number, partName: string | null }> | null }> | null, job: { __typename: 'Job', id: number, status: string, name: string, payout: number | null } | null } | null };

export type PotentialCorrectiveActionRequestAssigneesQueryVariables = Exact<{ [key: string]: never; }>;


export type PotentialCorrectiveActionRequestAssigneesQuery = { __typename: 'Query', activeCorrectiveActionRequestAssignees: Array<{ __typename: 'BasicUser', id: number, displayName: string }> | null };

export type PotentialSupplierQualityEngineersQueryVariables = Exact<{ [key: string]: never; }>;


export type PotentialSupplierQualityEngineersQuery = { __typename: 'Query', activeSupplierQualityEngineers: Array<{ __typename: 'BasicUser', id: number, displayName: string }> | null };

export type UpdateCorrectiveActionRequestAssigneeMutationVariables = Exact<{
  correctiveActionRequestId: Scalars['UUID'];
  assigneeId: Scalars['Int'];
}>;


export type UpdateCorrectiveActionRequestAssigneeMutation = { __typename: 'Mutation', updateCorrectiveActionRequestAssignee: { __typename: 'CorrectiveActionRequest', id: any, name: string } };

export type UpdateCarSupplierQualityEngineerMutationVariables = Exact<{
  correctiveActionRequestId: Scalars['String'];
  supplierQualityEngineerId: Scalars['Int'];
}>;


export type UpdateCarSupplierQualityEngineerMutation = { __typename: 'Mutation', updateCarSupplierQualityEngineer: { __typename: 'CorrectiveActionRequest', id: any, name: string } };

export type UpdateCorrectiveActionRequestStatusMutationVariables = Exact<{
  correctiveActionRequestId: Scalars['UUID'];
  status: CorrectiveActionRequestStatus;
  reworkReason: InputMaybe<Scalars['String']>;
}>;


export type UpdateCorrectiveActionRequestStatusMutation = { __typename: 'Mutation', updateCorrectiveActionRequestStatus: { __typename: 'CorrectiveActionRequest', id: any, name: string, status: CorrectiveActionRequestStatus } };

export type SaveCorrectiveActionRequestQuestionResponseMutationVariables = Exact<{
  correctiveActionRequestId: Scalars['UUID'];
  question: CorrectiveActionRequestQuestionType;
  selectedOptions: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  responseText: InputMaybe<Scalars['String']>;
}>;


export type SaveCorrectiveActionRequestQuestionResponseMutation = { __typename: 'Mutation', saveCorrectiveActionRequestResponse: number };

export type SanitizeCorrectiveActionRequestResponseMutationVariables = Exact<{
  sanitizeCorrectiveActionRequestResponseId: Scalars['Int'];
  correctiveActionRequestId: Scalars['UUID'];
  sanitizedResponseText: Scalars['String'];
}>;


export type SanitizeCorrectiveActionRequestResponseMutation = { __typename: 'Mutation', sanitizeCorrectiveActionRequestResponse: { __typename: 'CorrectiveActionRequestResponse', responseText: string | null, sanitizedResponseText: string | null } };

export type RemoveSanitizedCorrectiveActionResponseMutationVariables = Exact<{
  correctiveActionRequestId: Scalars['UUID'];
  removeSanitizedCorrectiveActionResponseId: Scalars['Int'];
}>;


export type RemoveSanitizedCorrectiveActionResponseMutation = { __typename: 'Mutation', removeSanitizedCorrectiveActionResponse: { __typename: 'CorrectiveActionRequestResponse', responseText: string | null, sanitizedResponseText: string | null } };

export type CorrectiveActionRequestListQueryVariables = Exact<{
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  filters: InputMaybe<CorrectiveActionRequestFilterInput>;
  sort: InputMaybe<CorrectiveActionRequestSortInput>;
}>;


export type CorrectiveActionRequestListQuery = { __typename: 'Query', correctiveActionRequests: { __typename: 'CorrectiveActionRequests', totalCount: number | null, items: Array<{ __typename: 'CorrectiveActionRequest', id: any, name: string, type: CorrectiveActionRequestType, status: CorrectiveActionRequestStatus, erpSaleOrderId: number | null, salesOrderName: string | null, jobRequestName: string | null, jobRequestId: number | null, createdAt: any, updatedAt: any, viewedAt: any | null, submittedAt: any | null, approvedAt: any | null, closedAt: any | null, canceledAt: any | null, sentForReworkAt: any | null, dueAt: any | null, sentAt: any | null, exception: { __typename: 'BasicException', id: string, name: string, exceptionState: string | null, otFailureFictiv: boolean | null, ifFailureFictiv: boolean | null, otFailureMp: boolean | null, ifFailureMp: boolean | null } | null, mfgPartner: { __typename: 'MfgPartner', id: number, name: string } | null, supplierQualityEngineer: { __typename: 'BasicUser', id: number, displayName: string } | null, assignee: { __typename: 'BasicUser', id: number, displayName: string } | null }> | null } | null };

export type AssignedCorrectiveActionRequestMfgPartnersQueryVariables = Exact<{
  sort: InputMaybe<MfgPartnerSortInput>;
}>;


export type AssignedCorrectiveActionRequestMfgPartnersQuery = { __typename: 'Query', assignedCorrectiveActionRequestMfgPartners: Array<{ __typename: 'BasicMfgPartner', id: number, name: string }> | null };

export type AssignedCorrectiveActionRequestAssigneesQueryVariables = Exact<{ [key: string]: never; }>;


export type AssignedCorrectiveActionRequestAssigneesQuery = { __typename: 'Query', assignedCorrectiveActionRequestAssignees: Array<{ __typename: 'BasicUser', id: number, displayName: string }> | null };

export type LinkUnlinkExceptionsMutationVariables = Exact<{
  exceptionFailureIdsGroup: InputMaybe<Array<ExceptionFailureIdsGroupInput> | ExceptionFailureIdsGroupInput>;
}>;


export type LinkUnlinkExceptionsMutation = { __typename: 'Mutation', linkUnlinkExceptions: boolean };

export type AssignedFictivAssigneesQueryVariables = Exact<{ [key: string]: never; }>;


export type AssignedFictivAssigneesQuery = { __typename: 'Query', assignedCorrectiveActionRequestAssignees: Array<{ __typename: 'BasicUser', id: number, displayName: string }> | null };

export type AssignedCarMpQueryVariables = Exact<{
  sort: InputMaybe<MfgPartnerSortInput>;
}>;


export type AssignedCarMpQuery = { __typename: 'Query', assignedCorrectiveActionRequestMfgPartners: Array<{ __typename: 'BasicMfgPartner', id: number, name: string }> | null };

export type CorrectiveActionRequestsQueryVariables = Exact<{
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  filters: InputMaybe<CorrectiveActionRequestListFilterInput>;
  sort: InputMaybe<CorrectiveActionRequestListSortInput>;
}>;


export type CorrectiveActionRequestsQuery = { __typename: 'Query', correctiveActionRequestList: { __typename: 'CorrectiveActionRequestList', totalCount: number | null, items: Array<{ __typename: 'CorrectiveActionRequest', id: any, name: string, jobName: string | null, jobId: number | null, type: CorrectiveActionRequestType, status: CorrectiveActionRequestStatus, erpSaleOrderId: number | null, salesOrderName: string | null, jobRequestId: number | null, businessUnit: string | null, associatedExceptionNames: Array<string | null> | null, associatedExceptionFailureTypes: Array<string | null> | null, createdAt: any, updatedAt: any, viewedAt: any | null, submittedAt: any | null, approvedAt: any | null, closedAt: any | null, canceledAt: any | null, sentForReworkAt: any | null, dueAt: any | null, sentAt: any | null, mfgPartner: { __typename: 'MfgPartner', id: number, name: string } | null, supplierQualityEngineer: { __typename: 'BasicUser', id: number, displayName: string } | null, assignee: { __typename: 'BasicUser', id: number, displayName: string } | null, associatedExceptionFailures: Array<{ __typename: 'BasicExceptionFailure', id: string, name: string, exceptionFailureState: string, milestoneType: string | null, type: string, assignedEntity: string | null }> | null }> | null } | null };

export type CreateExceptionFailureAttachmentMutationVariables = Exact<{
  exceptionFailureAttachmentInput: ExceptionFailureAttachmentInput;
}>;


export type CreateExceptionFailureAttachmentMutation = { __typename: 'Mutation', createExceptionFailureAttachment: { __typename: 'ExceptionFailureAttachment', id: any, exceptionId: string, exceptionNoteId: number | null, createdAt: any, updatedAt: any, attachment: { __typename: 'Asset', id: any, uploadUrl: string | null, fileName: string, extension: string | null, mimeType: string | null } | null } };

export type RemoveExceptionFailureAttachmentMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type RemoveExceptionFailureAttachmentMutation = { __typename: 'Mutation', removeExceptionFailureAttachment: any };

export type SetExceptionFailureStatusMutationVariables = Exact<{
  id: Scalars['UUID'];
  status: ExceptionFailureStatus;
}>;


export type SetExceptionFailureStatusMutation = { __typename: 'Mutation', setExceptionFailureStatus: { __typename: 'ExceptionFailure', id: any } | null };

export type BasicCarDetailsFragment = { __typename: 'CorrectiveActionRequest', id: any, type: CorrectiveActionRequestType, status: CorrectiveActionRequestStatus, associatedExceptionNames: Array<string | null> | null, name: string, assignee: { __typename: 'BasicUser', id: number, displayName: string } | null, mfgPartner: { __typename: 'MfgPartner', id: number, displayName: string } | null, associatedExceptionFailures: Array<{ __typename: 'BasicExceptionFailure', id: string, name: string, type: string, exceptionFailureState: string }> | null };

export type FailureNoteFragment = { __typename: 'ExceptionFailureNote', id: number, createdAt: any | null, body: string | null, createdBy: { __typename: 'BasicUser', id: number, displayName: string } | null, exceptionFailureNoteAttachments: Array<{ __typename: 'ExceptionAttachment', id: any, createdAt: any, attachment: { __typename: 'Asset', createdAt: any, downloadUrl: string | null, uploadUrl: string | null, fileName: string, extension: string | null, id: any, mimeType: string | null } | null }> | null };

export type FailurePartFragment = { __typename: 'ExceptionPart', id: number, lines: string | null, failedQuantity: number, partName: string | null };

export type FailureHistoryFragment = { __typename: 'ExceptionFailureHistory', id: number | null, contextKey: string | null, createdAt: any | null, message: string | null, newValue: string | null, objectId: any | null, updatedAt: any | null, oldValue: string | null, createdBy: { __typename: 'BasicUser', id: number, displayName: string } | null };

export type ExceptionFailureDetailsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ExceptionFailureDetailsQuery = { __typename: 'Query', exceptionFailure: { __typename: 'ExceptionFailure', id: any, name: string, erpSaleOrderId: number, customerName: string | null, salesOrderName: string, status: string, type: string, jobId: number, jobName: string, jobRequestId: number | null, milestoneType: string | null, isFailure: boolean, daysLate: number | null, isCustomerImpacted: boolean, assignedEntity: string | null, assigneeId: number | null, assignee: string | null, manufacturingPartnerId: number | null, manufacturingPartnerName: string | null, mpSuggestedDate: any | null, creator: string, correctiveActionRequestId: string | null, failureDiscoveredBy: string | null, additionalContext: string | null, ignoreFailureForMpCalculation: boolean | null, createdAt: any | null, updatedAt: any | null, action: string | null, exceptionFailureState: string, customerDriUserId: number | null, jobComputedStatus: string, rfqNumber: string | null, businessUnit: string | null, correctiveActionRequest: { __typename: 'CorrectiveActionRequest', id: any, type: CorrectiveActionRequestType, status: CorrectiveActionRequestStatus, associatedExceptionNames: Array<string | null> | null, name: string, assignee: { __typename: 'BasicUser', id: number, displayName: string } | null, mfgPartner: { __typename: 'MfgPartner', id: number, displayName: string } | null, associatedExceptionFailures: Array<{ __typename: 'BasicExceptionFailure', id: string, name: string, type: string, exceptionFailureState: string }> | null } | null, updatedBy: { __typename: 'BasicUser', id: number } | null, mpNotes: Array<{ __typename: 'ExceptionFailureNote', id: number, createdAt: any | null, body: string | null, createdBy: { __typename: 'BasicUser', id: number, displayName: string } | null, exceptionFailureNoteAttachments: Array<{ __typename: 'ExceptionAttachment', id: any, createdAt: any, attachment: { __typename: 'Asset', createdAt: any, downloadUrl: string | null, uploadUrl: string | null, fileName: string, extension: string | null, id: any, mimeType: string | null } | null }> | null }> | null, internalNotes: Array<{ __typename: 'ExceptionFailureNote', id: number, createdAt: any | null, body: string | null, createdBy: { __typename: 'BasicUser', id: number, displayName: string } | null, exceptionFailureNoteAttachments: Array<{ __typename: 'ExceptionAttachment', id: any, createdAt: any, attachment: { __typename: 'Asset', createdAt: any, downloadUrl: string | null, uploadUrl: string | null, fileName: string, extension: string | null, id: any, mimeType: string | null } | null }> | null }> | null, mpMfgDri: { __typename: 'User', id: number, displayName: string } | null, history: Array<{ __typename: 'ExceptionFailureHistory', id: number | null, contextKey: string | null, createdAt: any | null, message: string | null, newValue: string | null, objectId: any | null, updatedAt: any | null, oldValue: string | null, createdBy: { __typename: 'BasicUser', id: number, displayName: string } | null }> | null, exceptionFailureAttachments: Array<{ __typename: 'ExceptionFailureAttachment', id: any, createdAt: any, attachment: { __typename: 'Asset', createdAt: any, downloadUrl: string | null, uploadUrl: string | null, fileName: string, extension: string | null, id: any, mimeType: string | null } | null }> | null, exceptionFailureParts: Array<{ __typename: 'ExceptionPart', id: number, lines: string | null, failedQuantity: number, partName: string | null }> | null, project: { __typename: 'BasicProject', id: any | null, isSecurePlus: boolean, name: string } | null } };

export type ExceptionListsQueryVariables = Exact<{
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  sort: InputMaybe<ExceptionFailuresSort>;
  filters: InputMaybe<ExceptionFailuresFilterInput>;
}>;


export type ExceptionListsQuery = { __typename: 'Query', exceptionFailures: { __typename: 'PartialExceptionFailureResults', totalCount: number, items: Array<{ __typename: 'ExceptionFailure', id: any, name: string, erpSaleOrderId: number, salesOrderName: string, status: string, type: string, jobId: number, jobName: string, jobComputedStatus: string, jobRequestId: number | null, shipmentId: number | null, receiptId: number | null, qcId: number | null, isFailure: boolean, daysLate: number | null, isCustomerImpacted: boolean, assignedEntity: string | null, assigneeId: number | null, assignee: string | null, manufacturingPartnerId: number | null, manufacturingPartnerName: string | null, milestoneType: string | null, creator: string, mpSuggestedDate: any | null, correctiveActionRequestId: string | null, action: string | null, exceptionFailureState: string, rfqNumber: string | null, failureDiscoveredBy: string | null, additionalContext: string | null, createdAt: any | null, updatedAt: any | null, businessUnit: string | null, correctiveActionRequest: { __typename: 'CorrectiveActionRequest', id: any, jobRequestId: number | null, jobRequestName: string | null, name: string, status: CorrectiveActionRequestStatus, type: CorrectiveActionRequestType } | null, updatedBy: { __typename: 'BasicUser', id: number, displayName: string } | null, latestNote: { __typename: 'ExceptionFailureNote', id: number, body: string | null, createdAt: any | null, exceptionFailureNoteAttachments: Array<{ __typename: 'ExceptionAttachment', createdAt: any, attachment: { __typename: 'Asset', createdAt: any, downloadUrl: string | null, uploadUrl: string | null, fileName: string, extension: string | null, id: any, mimeType: string | null } | null }> | null } | null, history: Array<{ __typename: 'ExceptionFailureHistory', id: number | null }> | null, mpMfgDri: { __typename: 'User', id: number, displayName: string } | null, customerMfgDri: { __typename: 'User', id: number, displayName: string } | null, exceptionFailureAttachments: Array<{ __typename: 'ExceptionFailureAttachment', id: any }> | null, exceptionFailureParts: Array<{ __typename: 'ExceptionPart', id: number, failedQuantity: number }> | null, jobRequest: { __typename: 'JobRequest', id: number, name: string } | null, project: { __typename: 'BasicProject', id: any | null, isSecurePlus: boolean } | null }> | null } };

export type JobBidsQueryVariables = Exact<{
  jobId: Scalars['Int'];
}>;


export type JobBidsQuery = { __typename: 'Query', getJobBids: Array<{ __typename: 'JobBid', id: string, mpName: string | null, mpCountry: string | null, bidAmount: number | null, exceptionCount: number | null, updatedAt: any | null, buyItNow: number | null, wonBid: boolean | null, jobRequestId: number | null, additionalComments: string | null }> | null };

export type CancelJobMutationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CancelJobMutationMutation = { __typename: 'Mutation', cancelJob: { __typename: 'Job', id: number, payout: number | null } };

export type UpdateJobRequestVendorDueDateMutationVariables = Exact<{
  id: Scalars['Int'];
  vendorDueDate: Scalars['Date'];
  vendorDueDateUpdateReason: InputMaybe<Scalars['String']>;
}>;


export type UpdateJobRequestVendorDueDateMutation = { __typename: 'Mutation', updateJobRequestVendorDueDate: { __typename: 'JobRequest', id: number, name: string, vendorDueDate: any } };

export type UpdateJobVendorDueDateMutationVariables = Exact<{
  id: Scalars['Int'];
  date: Scalars['Date'];
}>;


export type UpdateJobVendorDueDateMutation = { __typename: 'Mutation', updateJobVendorDueDate: { __typename: 'Job', id: number, name: string, vendorDueDate: any | null, payout: number | null } };

export type GetTotalSalesOrderPriceByJobQueryVariables = Exact<{
  jobId: Scalars['Int'];
}>;


export type GetTotalSalesOrderPriceByJobQuery = { __typename: 'Query', getTotalSalesOrderPriceForJob: { __typename: 'TotalSalesOrderPriceForJob', id: number, totalPrice: number } | null };

export type PayoutAdjustmentReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type PayoutAdjustmentReasonsQuery = { __typename: 'Query', payoutAdjustmentReasons: Array<{ __typename: 'PayoutAdjustmentReasonCategory', id: number, name: string, active: boolean, subCategories: Array<{ __typename: 'PayoutAdjustmentReasonSubCategory', id: number, name: string, active: boolean }> | null }> | null };

export type CreateSchedulingQueueItemsMutationVariables = Exact<{
  queueId: Scalars['Int'];
  input: CreateQueueItemInput;
}>;


export type CreateSchedulingQueueItemsMutation = { __typename: 'Mutation', createSchedulingQueueItems: boolean };

export type ReSequenceSchedulingQueueItemMutationVariables = Exact<{
  id: Scalars['Int'];
  newSequenceNo: Scalars['Int'];
}>;


export type ReSequenceSchedulingQueueItemMutation = { __typename: 'Mutation', reSequenceSchedulingQueueItem: boolean };

export type RemoveSchedulingQueueItemMutationVariables = Exact<{
  removeSchedulingQueueItemId: Scalars['Int'];
}>;


export type RemoveSchedulingQueueItemMutation = { __typename: 'Mutation', removeSchedulingQueueItem: boolean };

export type UpdateQueueStatusMutationVariables = Exact<{
  id: Scalars['Int'];
  queueStatus: SchedulingQueueStatus;
}>;


export type UpdateQueueStatusMutation = { __typename: 'Mutation', updateQueueStatus: { __typename: 'SchedulingQueue', id: number } };

export type GetMpViewedJobOnJobBoardListQueryVariables = Exact<{
  jobIdsAndMpsList: InputMaybe<MpActiveOnJobBoardInput>;
}>;


export type GetMpViewedJobOnJobBoardListQuery = { __typename: 'Query', getMpViewedJobOnJobBoardList: Array<number> | null };

export type Mp_SuggestionFragment = { __typename: 'RecommendedMp', jobOTIFProbability: number | null, sequence: number, totalPayout: number, jobAcceptanceProbability: number | null, mfgPartner: { __typename: 'BasicMfgPartner', id: number, name: string } };

export type Minimum_Eligibility_MpsFragment = { __typename: 'MinimumEligibilityMp', mfgPartner: { __typename: 'BasicMfgPartner', id: number, name: string } };

export type Recommended_Mps_For_JobFragment = { __typename: 'RecommendedMpsForJob', recommendedRequestId: number, shiftingAttributes: Array<{ __typename: 'RecommendedMpsShiftingAttribute', attributeName: string, value: boolean }> | null, minimumEligibilityMps: Array<{ __typename: 'MinimumEligibilityMp', mfgPartner: { __typename: 'BasicMfgPartner', id: number, name: string } }> | null, mpSuggestions: Array<{ __typename: 'RecommendedMp', jobOTIFProbability: number | null, sequence: number, totalPayout: number, jobAcceptanceProbability: number | null, mfgPartner: { __typename: 'BasicMfgPartner', id: number, name: string } }> | null };

export type GetRecommendedMpsQueryVariables = Exact<{
  jobId: Scalars['Int'];
  filters: InputMaybe<RecommendedMpsForJobFiltersInput>;
}>;


export type GetRecommendedMpsQuery = { __typename: 'Query', getRecommendedMpsForJob: { __typename: 'RecommendedMpsForJob', recommendedRequestId: number, shiftingAttributes: Array<{ __typename: 'RecommendedMpsShiftingAttribute', attributeName: string, value: boolean }> | null, minimumEligibilityMps: Array<{ __typename: 'MinimumEligibilityMp', mfgPartner: { __typename: 'BasicMfgPartner', id: number, name: string } }> | null, mpSuggestions: Array<{ __typename: 'RecommendedMp', jobOTIFProbability: number | null, sequence: number, totalPayout: number, jobAcceptanceProbability: number | null, mfgPartner: { __typename: 'BasicMfgPartner', id: number, name: string } }> | null } | null };

export type MfgPartnerFragment = { __typename: 'MfgPartner', id: number, name: string, countryName: string };

export type QueueItemFragment = { __typename: 'SchedulingQueueItem', id: number, queueId: number, waitTime: number, jobExpiryTime: number, jobExtraViewingTime: number, jobRequestId: number | null, scheduleNoEarlierThan: any | null, sequenceNo: number, skipped: boolean, reasonToSkip: string | null, createdAt: any, updatedAt: any, deletedAt: any | null, status: string, exceptionCount: number | null, rejectionReason: string | null, rejectionReasonAdditionalInfo: string | null, overrideMpUnavailability: boolean | null, overrideMpAcceptingHours: boolean | null, mfgPartner: { __typename: 'MfgPartner', id: number, name: string, countryName: string }, history: Array<{ __typename: 'ChangeHistory', id: number, objectType: string, objectId: string, contextKey: string | null, oldValue: string | null, newValue: string | null, message: string | null, createdAt: any | null, createdBy: { __typename: 'BasicUser', id: number, displayName: string, firstName: string | null, lastName: string | null, email: any, createdAt: any, updatedAt: any, enabled: boolean } | null }> | null };

export type SchedulingQueueQueryVariables = Exact<{
  jobId: Scalars['Int'];
}>;


export type SchedulingQueueQuery = { __typename: 'Query', schedulingQueue: { __typename: 'SchedulingQueue', id: number, jobId: number, processedQueueItemCount: number, queueItemCount: number, status: SchedulingQueueStatus, queueItems: Array<{ __typename: 'SchedulingQueueItem', id: number, queueId: number, waitTime: number, jobExpiryTime: number, jobExtraViewingTime: number, jobRequestId: number | null, scheduleNoEarlierThan: any | null, sequenceNo: number, skipped: boolean, reasonToSkip: string | null, createdAt: any, updatedAt: any, deletedAt: any | null, status: string, exceptionCount: number | null, rejectionReason: string | null, rejectionReasonAdditionalInfo: string | null, overrideMpUnavailability: boolean | null, overrideMpAcceptingHours: boolean | null, mfgPartner: { __typename: 'MfgPartner', id: number, name: string, countryName: string }, history: Array<{ __typename: 'ChangeHistory', id: number, objectType: string, objectId: string, contextKey: string | null, oldValue: string | null, newValue: string | null, message: string | null, createdAt: any | null, createdBy: { __typename: 'BasicUser', id: number, displayName: string, firstName: string | null, lastName: string | null, email: any, createdAt: any, updatedAt: any, enabled: boolean } | null }> | null }> | null } };

export type AddJobToActiveJobBoardMutationVariables = Exact<{
  jobId: Scalars['Int'];
}>;


export type AddJobToActiveJobBoardMutation = { __typename: 'Mutation', addJobToActiveJobBoard: { __typename: 'Job', id: number, status: string, payout: number | null } };

export type CreateJobBundleMutationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CreateJobBundleMutationMutation = { __typename: 'Mutation', createJobBundle: { __typename: 'ZipDownloadJob', id: string, url: string | null } };

export type DownloadQualityDocumentsMutationVariables = Exact<{
  jobRequestId: Scalars['Int'];
}>;


export type DownloadQualityDocumentsMutation = { __typename: 'Mutation', createJobRequestZipDownloadJob: { __typename: 'ZipDownloadJob', id: string, url: string | null } | null };

export type UpdateJobMutationVariables = Exact<{
  id: Scalars['Int'];
  input: UpdateJobInput;
}>;


export type UpdateJobMutation = { __typename: 'Mutation', updateJob: { __typename: 'Job', id: number, payout: number | null } };

export type UpdateJobLinesMutationVariables = Exact<{
  jobId: Scalars['Int'];
  jobLineInput: Array<UpdateJobLineInput> | UpdateJobLineInput;
}>;


export type UpdateJobLinesMutation = { __typename: 'Mutation', updateJobLines: boolean };

export type UpdateJobPauseExceptionMutationVariables = Exact<{
  jobId: Scalars['Int'];
  pauseException: Scalars['Boolean'];
}>;


export type UpdateJobPauseExceptionMutation = { __typename: 'Mutation', updateJobPauseException: { __typename: 'Job', id: number, name: string, pauseException: boolean, payout: number | null } };

export type UpdateJobProductionCountryMutationVariables = Exact<{
  jobId: Scalars['Int'];
  productionCountry: JobProductionCountry;
}>;


export type UpdateJobProductionCountryMutation = { __typename: 'Mutation', updateJobProductionCountry: { __typename: 'Job', id: number, name: string, countryCode: string | null, payout: number | null } };

export type UpdateJobRequestMutationVariables = Exact<{
  id: Scalars['Int'];
  input: UpdateJobRequestInput;
}>;


export type UpdateJobRequestMutation = { __typename: 'Mutation', updateJobRequest: { __typename: 'JobRequest', id: number } };

export type UpdateJobRequestLinesMutationVariables = Exact<{
  id: Scalars['Int'];
  input: Array<UpdateJobRequestLineInput> | UpdateJobRequestLineInput;
}>;


export type UpdateJobRequestLinesMutation = { __typename: 'Mutation', updateJobRequestLines: boolean };

export type UpdateJobRequestQcTypeMutationVariables = Exact<{
  id: Scalars['Int'];
  qcType: JobRequestQcType;
}>;


export type UpdateJobRequestQcTypeMutation = { __typename: 'Mutation', updateJobRequestQcType: { __typename: 'JobRequest', id: number, name: string, qcType: JobRequestQcType | null } };

export type UpdateJobRequestStatusMutationVariables = Exact<{
  id: Scalars['Int'];
  status: JobRequestStatus;
  rejectionInfo: InputMaybe<JobRequestRejectionInput>;
}>;


export type UpdateJobRequestStatusMutation = { __typename: 'Mutation', updateJobRequestStatus: { __typename: 'JobRequest', id: number } };

export type JobMpTypeFragment = { __typename: 'MfgPartner', id: number, displayName: string, isMpAvailable: boolean };

export type EligibleMPsForJobQueryVariables = Exact<{
  jobId: Scalars['Int'];
  forDate: InputMaybe<Scalars['Date']>;
}>;


export type EligibleMPsForJobQuery = { __typename: 'Query', fetchEligibleMPsForJob: Array<{ __typename: 'MfgPartner', id: number, displayName: string, isMpAvailable: boolean }> | null };

export type GetCurrentJobBoardWithJobBoardRegionQueryVariables = Exact<{
  jobBoardRegionId: InputMaybe<Scalars['String']>;
}>;


export type GetCurrentJobBoardWithJobBoardRegionQuery = { __typename: 'Query', getCurrentJobBoard: { __typename: 'JobBoard', id: string, startDate: any, endDate: any, status: string } | null };

export type DriFragment = { __typename: 'BasicUser', id: number, displayName: string };

export type JobDetailsQueryVariables = Exact<{
  id: Scalars['Int'];
  mfgPartnerId: InputMaybe<Scalars['Int']>;
  schedulingQueueItemId: InputMaybe<Scalars['Int']>;
}>;


export type JobDetailsQuery = { __typename: 'Query', job: { __typename: 'Job', id: number, name: string, rfqNumber: string | null, erpSaleOrderId: number, salesOrderName: string | null, salesOrderCreatedAt: any, exceptionCount: number | null, jobExceptionCount: number | null, priority: string | null, leadTime: number | null, region: string | null, plannedScheduleDate: any | null, status: string, hasCnc: boolean, queueStatus: string | null, vendorDueDate: any | null, originalVendorDueDate: any | null, pauseException: boolean, payout: number | null, originalPayout: number | null, originalTransactionMargin: number | null, actualTransactionMargin: number | null, vendorNotes: string | null, customerName: string, customerCompanyName: string | null, isForJobBoard: boolean, jobBoardId: any | null, jobBoardStartDate: any | null, jobBoardEndDate: any | null, jobBoardStatus: string | null, jobBoardRegion: string | null, jobBoardEligibleMpsCount: number | null, jobBoardRegionId: string | null, jobBoardJobEndTime: any | null, buyNowPrice: number | null, bidCount: number | null, schedulingType: string | null, businessUnit: string | null, projectTags: Array<string> | null, quoteNotes: string | null, quoteDfmNotes: string | null, countryCode: string | null, mfgDri: { __typename: 'BasicUser', id: number, displayName: string } | null, salesDri: { __typename: 'BasicUser', id: number, displayName: string } | null, schedulingDri: { __typename: 'BasicUser', id: number, displayName: string } | null, project: { __typename: 'BasicProject', id: any | null, name: string, isSecurePlus: boolean } | null, lines: Array<{ __typename: 'JobLine', id: number, name: string, productQty: number, unitPrice: number, totalPayout: number, originalUnitPrice: number, vendorDueDate: any, payoutMultiplier: number, payoutAdjDescription: string | null, productProcess: { __typename: 'SalesOrderLineProductProcess', erpProductId: number | null, id: number, thumbnailUri: string | null, leadTime: number | null, scheduledQuantity: number | null, targetPurchasePrice: number | null, payout: number | null, processNotes: string | null, part: { __typename: 'Part', id: number | null, name: string, depthX: number | null, depthY: number | null, depthZ: number | null, quoteModelRevisionUuid: string | null } | null, associatedMoldTool: { __typename: 'BasicMoldTool', id: string, name: string, moldToolRevisionId: string, version: number | null } | null, moldTool: { __typename: 'BasicMoldTool', id: string, name: string, moldToolRevisionId: string, version: number | null } | null, inspectionData: { __typename: 'InspectionData', numOfSetups: number | null } | null, materialConfiguration: { __typename: 'PartMaterialConfiguration', id: number, name: string, color: string | null, colorCode: string | null, grade: string | null, shoreValue: string | null, dfmNotes: { __typename: 'MaterialDfmNotes', color: string | null, shoreValue: string | null, material: string | null } | null, additionalSpecifications: { __typename: 'MaterialAdditionalSpecifications', color: string | null, shoreValue: string | null, material: string | null } | null } | null, processAttributes: { __typename: 'PartProcessAttributes', id: number, name: string, texture: string | null, color: string | null, thickness: string | null } | null }, orderLineProcesses: Array<{ __typename: 'OrderProcessDetails', id: string, platformProcessId: string | null, platformProcessTypeId: string | null, processName: string, processNotes: string | null, color: string | null, thickness: string | null, texture: string | null, finish: string | null, surfaceFinishCode: string | null, toolLife: string | null, dfmNotes: { __typename: 'ProcessDfmNotes', color: string | null, thickness: string | null, texture: string | null, process: string | null } | null, additionalSpecifications: { __typename: 'ProcessAdditionalSpecifications', color: string | null, thickness: string | null, texture: string | null } | null }> | null, payoutAdjReasonCategory: { __typename: 'PayoutAdjustmentReasonCategory', id: number, name: string, active: boolean, subCategories: Array<{ __typename: 'PayoutAdjustmentReasonSubCategory', id: number, name: string, active: boolean }> | null } | null, payoutAdjReasonSubCategory: { __typename: 'PayoutAdjustmentReasonSubCategory', id: number, name: string, active: boolean } | null }> | null, history: Array<{ __typename: 'ChangeHistory', id: number, objectType: string, objectId: string, contextKey: string | null, oldValue: string | null, newValue: string | null, message: string | null, createdAt: any | null, createdBy: { __typename: 'BasicUser', id: number, displayName: string } | null }> | null, milestones: { __typename: 'JobMilestones', scheduling: { __typename: 'MilestoneDetails', committedDate: any | null, scheduledDate: any | null, actualDate: any | null }, production: { __typename: 'MilestoneDetails', committedDate: any | null, scheduledDate: any | null, actualDate: any | null }, inspection: { __typename: 'MilestoneDetails', committedDate: any | null, scheduledDate: any | null, actualDate: any | null }, deliveryOrder: { __typename: 'MilestoneDetails', committedDate: any | null, scheduledDate: any | null, actualDate: any | null }, shipping: { __typename: 'MilestoneDetails', committedDate: any | null, scheduledDate: any | null, actualDate: any | null }, customerDelivery: { __typename: 'MilestoneDetails', committedDate: any | null, scheduledDate: any | null, actualDate: any | null } } | null } };

export type JobMilestonesQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type JobMilestonesQuery = { __typename: 'Query', jobMilestones: { __typename: 'JobMilestones', scheduling: { __typename: 'MilestoneDetails', committedDate: any | null, scheduledDate: any | null, actualDate: any | null }, production: { __typename: 'MilestoneDetails', committedDate: any | null, scheduledDate: any | null, actualDate: any | null }, inspection: { __typename: 'MilestoneDetails', committedDate: any | null, scheduledDate: any | null, actualDate: any | null }, deliveryOrder: { __typename: 'MilestoneDetails', committedDate: any | null, scheduledDate: any | null, actualDate: any | null }, shipping: { __typename: 'MilestoneDetails', committedDate: any | null, scheduledDate: any | null, actualDate: any | null }, customerDelivery: { __typename: 'MilestoneDetails', committedDate: any | null, scheduledDate: any | null, actualDate: any | null } } | null };

export type JobRequestDetailsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type JobRequestDetailsQuery = { __typename: 'Query', jobRequest: { __typename: 'JobRequest', id: number, jobId: number, erpWorkOrderRequestId: number | null, name: string, payout: number, originalPayout: number, originalTransactionMargin: number | null, actualTransactionMargin: number | null, vendorDueDate: any, originalVendorDueDate: any, status: string, expiresAt: any, viewedAt: any | null, acceptedAt: any | null, completedAt: any | null, rejectedAt: any | null, canceledAt: any | null, rejectionReason: JobRejectionReason | null, rejectionReasonAdditionalInfo: string | null, rejectionComment: string | null, secondaryProcessStartDate: any | null, erpPurchaseOrderId: number | null, vendorNotes: string | null, productionStage: string | null, qcType: JobRequestQcType | null, photosUploadedByMp: boolean | null, createdAt: any, updatedAt: any | null, viewedBy: { __typename: 'BasicUser', id: number, displayName: string } | null, acceptedBy: { __typename: 'BasicUser', id: number, displayName: string } | null, completedBy: { __typename: 'BasicUser', id: number, displayName: string } | null, rejectedBy: { __typename: 'BasicUser', id: number, displayName: string } | null, canceledBy: { __typename: 'BasicUser', id: number, displayName: string } | null, createdBy: { __typename: 'BasicUser', id: number, displayName: string }, mfgPartner: { __typename: 'MfgPartner', id: number, name: string }, updatedBy: { __typename: 'BasicUser', id: number, displayName: string } | null, project: { __typename: 'BasicProject', id: any | null, name: string, isSecurePlus: boolean } | null, followers: Array<{ __typename: 'FollowerUser', id: number, name: string, fictivUserId: number | null, isChannel: boolean, isFictivUser: boolean }> | null, jobRequestComments: Array<{ __typename: 'WorkOrderComment', id: number, body: string, createdAt: any, updatedAt: any, subject: string | null, author: { __typename: 'BasicUser', id: number, displayName: string } | null, attachments: Array<{ __typename: 'ErpAttachment', id: any, fileName: string, url: string }> }>, lines: Array<{ __typename: 'JobRequestLine', id: number, name: string, erpWorkOrderRequestLineId: number | null, vendorDueDate: any, originalVendorDueDate: any, productQty: number, unitPrice: number, originalUnitPrice: number, payoutMultiplier: number, totalPayout: number, inspectionType: string, receiptComplete: boolean | null, qcComplete: boolean | null, payoutAdjDescription: string | null, payoutAdjReasonCategory: { __typename: 'PayoutAdjustmentReasonCategory', id: number, name: string } | null, payoutAdjReasonSubCategory: { __typename: 'PayoutAdjustmentReasonSubCategory', id: number, name: string } | null, productProcess: { __typename: 'SalesOrderLineProductProcess', erpProductId: number | null, id: number, leadTime: number | null, thumbnailUri: string | null, processNotes: string | null, part: { __typename: 'Part', id: number | null, name: string, depthX: number | null, depthY: number | null, depthZ: number | null, quoteModelRevisionUuid: string | null } | null, moldTool: { __typename: 'BasicMoldTool', id: string, name: string, moldToolRevisionId: string } | null, inspectionData: { __typename: 'InspectionData', numOfSetups: number | null } | null, processAttributes: { __typename: 'PartProcessAttributes', id: number, color: string | null, name: string, texture: string | null, thickness: string | null } | null, materialConfiguration: { __typename: 'PartMaterialConfiguration', id: number, name: string, color: string | null, grade: string | null, colorCode: string | null, shoreValue: string | null, dfmNotes: { __typename: 'MaterialDfmNotes', color: string | null, shoreValue: string | null, material: string | null } | null, additionalSpecifications: { __typename: 'MaterialAdditionalSpecifications', color: string | null, shoreValue: string | null, material: string | null } | null } | null }, orderLineProcesses: Array<{ __typename: 'OrderProcessDetails', id: string, platformProcessId: string | null, platformProcessTypeId: string | null, processName: string, processNotes: string | null, color: string | null, thickness: string | null, texture: string | null, finish: string | null, surfaceFinishCode: string | null, toolLife: string | null, dfmNotes: { __typename: 'ProcessDfmNotes', color: string | null, thickness: string | null, texture: string | null, process: string | null } | null, additionalSpecifications: { __typename: 'ProcessAdditionalSpecifications', color: string | null, thickness: string | null, texture: string | null } | null }> | null }> | null, history: Array<{ __typename: 'ChangeHistory', id: number, objectType: string, objectId: string, contextKey: string | null, oldValue: string | null, newValue: string | null, message: string | null, createdAt: any | null, createdBy: { __typename: 'BasicUser', id: number, displayName: string } | null }> | null } | null };

export type CreateJobNoteMutationVariables = Exact<{
  input: CreateNoteInput;
}>;


export type CreateJobNoteMutation = { __typename: 'Mutation', createNote: { __typename: 'Note', id: number, objectId: number, objectType: string, description: string } };

export type CreateJobNoteAttachmentMutationVariables = Exact<{
  input: AttachmentInput;
}>;


export type CreateJobNoteAttachmentMutation = { __typename: 'Mutation', createNoteAttachment: { __typename: 'Asset', id: any, fileName: string, extension: string | null, mimeType: string | null, uploadUrl: string | null } };

export type MarkUploadedJobNoteAttachmentMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type MarkUploadedJobNoteAttachmentMutation = { __typename: 'Mutation', markUploadedAsset: { __typename: 'Asset', id: any, downloadUrl: string | null } };

export type RemoveJobNoteAttachmentMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type RemoveJobNoteAttachmentMutation = { __typename: 'Mutation', removeNoteAttachment: any };

export type JobNoteFragment = { __typename: 'Note', id: number, description: string, createdAt: any, createdBy: { __typename: 'BasicUser', id: number, displayName: string }, attachments: Array<{ __typename: 'NoteAttachment', id: string, createdAt: any, attachment: { __typename: 'Asset', id: any, fileName: string, mimeType: string | null, downloadUrl: string | null } | null, createdBy: { __typename: 'BasicUser', id: number, displayName: string } | null }> | null };

export type JobTypeFragment = { __typename: 'Job', id: number, name: string, countryCode: string | null, salesOrderName: string | null, nextMilestone: MilestoneType | null, trackStatus: JobTrackStatus | null, jobComputedStatus: string | null, status: string, queueStatus: string | null, queueItemCount: number | null, processedQueueItemCount: number | null, leadTime: number | null, payout: number | null, priority: string | null, region: string | null, processNames: Array<string> | null, materialNames: Array<string> | null, exceptionCount: number | null, rfqNumber: string | null, scheduleNoEarlierThan: any | null, erpSaleOrderId: number, pauseException: boolean, jobBoardId: any | null, jobBoardStatus: string | null, jobBoardStartDate: any | null, jobBoardEndDate: any | null, isForJobBoard: boolean, bidCount: number | null, buyNowPrice: number | null, jobBoardRegion: string | null, customerName: string, customerCompanyName: string | null, businessUnit: string | null, notes: Array<{ __typename: 'Note', id: number, description: string, createdAt: any, createdBy: { __typename: 'BasicUser', id: number, displayName: string }, attachments: Array<{ __typename: 'NoteAttachment', id: string, createdAt: any, attachment: { __typename: 'Asset', id: any, fileName: string, mimeType: string | null, downloadUrl: string | null } | null, createdBy: { __typename: 'BasicUser', id: number, displayName: string } | null }> | null }> | null, mpMfgDri: { __typename: 'BasicUser', id: number, displayName: string } | null, customerMfgDri: { __typename: 'BasicUser', id: number, displayName: string } | null, mfgDri: { __typename: 'BasicUser', id: number, displayName: string } | null, mfgPartner: { __typename: 'MfgPartner', id: number, name: string } | null, project: { __typename: 'BasicProject', id: any | null, name: string, isSecurePlus: boolean } | null, milestones: { __typename: 'JobMilestones', scheduling: { __typename: 'MilestoneDetails', committedDate: any | null, scheduledDate: any | null, actualDate: any | null }, production: { __typename: 'MilestoneDetails', committedDate: any | null, scheduledDate: any | null, actualDate: any | null }, inspection: { __typename: 'MilestoneDetails', committedDate: any | null, scheduledDate: any | null, actualDate: any | null }, deliveryOrder: { __typename: 'MilestoneDetails', committedDate: any | null, scheduledDate: any | null, actualDate: any | null }, shipping: { __typename: 'MilestoneDetails', committedDate: any | null, scheduledDate: any | null, actualDate: any | null }, customerDelivery: { __typename: 'MilestoneDetails', committedDate: any | null, scheduledDate: any | null, actualDate: any | null } } | null };

export type JobListQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: InputMaybe<Scalars['Int']>;
  filters: InputMaybe<JobListFiltersInput>;
  sort: InputMaybe<Array<JobSortInput> | JobSortInput>;
}>;


export type JobListQuery = { __typename: 'Query', jobList: { __typename: 'JobsListResult', totalCount: number, items: Array<{ __typename: 'Job', id: number, name: string, countryCode: string | null, salesOrderName: string | null, nextMilestone: MilestoneType | null, trackStatus: JobTrackStatus | null, jobComputedStatus: string | null, status: string, queueStatus: string | null, queueItemCount: number | null, processedQueueItemCount: number | null, leadTime: number | null, payout: number | null, priority: string | null, region: string | null, processNames: Array<string> | null, materialNames: Array<string> | null, exceptionCount: number | null, rfqNumber: string | null, scheduleNoEarlierThan: any | null, erpSaleOrderId: number, pauseException: boolean, jobBoardId: any | null, jobBoardStatus: string | null, jobBoardStartDate: any | null, jobBoardEndDate: any | null, isForJobBoard: boolean, bidCount: number | null, buyNowPrice: number | null, jobBoardRegion: string | null, customerName: string, customerCompanyName: string | null, businessUnit: string | null, notes: Array<{ __typename: 'Note', id: number, description: string, createdAt: any, createdBy: { __typename: 'BasicUser', id: number, displayName: string }, attachments: Array<{ __typename: 'NoteAttachment', id: string, createdAt: any, attachment: { __typename: 'Asset', id: any, fileName: string, mimeType: string | null, downloadUrl: string | null } | null, createdBy: { __typename: 'BasicUser', id: number, displayName: string } | null }> | null }> | null, mpMfgDri: { __typename: 'BasicUser', id: number, displayName: string } | null, customerMfgDri: { __typename: 'BasicUser', id: number, displayName: string } | null, mfgDri: { __typename: 'BasicUser', id: number, displayName: string } | null, mfgPartner: { __typename: 'MfgPartner', id: number, name: string } | null, project: { __typename: 'BasicProject', id: any | null, name: string, isSecurePlus: boolean } | null, milestones: { __typename: 'JobMilestones', scheduling: { __typename: 'MilestoneDetails', committedDate: any | null, scheduledDate: any | null, actualDate: any | null }, production: { __typename: 'MilestoneDetails', committedDate: any | null, scheduledDate: any | null, actualDate: any | null }, inspection: { __typename: 'MilestoneDetails', committedDate: any | null, scheduledDate: any | null, actualDate: any | null }, deliveryOrder: { __typename: 'MilestoneDetails', committedDate: any | null, scheduledDate: any | null, actualDate: any | null }, shipping: { __typename: 'MilestoneDetails', committedDate: any | null, scheduledDate: any | null, actualDate: any | null }, customerDelivery: { __typename: 'MilestoneDetails', committedDate: any | null, scheduledDate: any | null, actualDate: any | null } } | null }> } };

export type MfgPartnerForFilterListFragment = { __typename: 'MfgPartner', id: number, displayName: string };

export type MfgPartnersListForFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type MfgPartnersListForFilterQuery = { __typename: 'Query', mfgPartnersForFilter: Array<{ __typename: 'MfgPartner', id: number, displayName: string }> | null };

export type BusinessUnitsQueryVariables = Exact<{ [key: string]: never; }>;


export type BusinessUnitsQuery = { __typename: 'Query', getBusinessUnits: Array<string> };

export type SalesOrdersExceptionsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: InputMaybe<Scalars['Int']>;
  sort: InputMaybe<AllowedSalesOrderSort>;
  filters: InputMaybe<SalesOrdersFiltersInput>;
}>;


export type SalesOrdersExceptionsQuery = { __typename: 'Query', salesOrders: { __typename: 'PartialSalesOrderResults', totalCount: number, items: Array<{ __typename: 'SalesOrder', id: string, name: string, businessUnit: string | null, productionCountries: Array<ProductionCountry | null> | null, customerName: string | null, customerCompanyName: string | null, committedDeliveryDate: any | null, priority: string | null, earliestPromisedShipDate: any | null, earliestScheduledDeliveryDate: any | null, region: string | null, workOrderCount: number, exceptionCount: number, carCount: number, jobCount: number, schedulingDris: Array<{ __typename: 'BasicUser', id: number, displayName: string } | null> | null, project: { __typename: 'BasicProject', id: any | null, name: string, isSecurePlus: boolean } | null, mfgDri: { __typename: 'BasicUser', id: number, displayName: string } | null }> } };

export type CreateJobsMutationVariables = Exact<{
  createJobsInput: Array<CreateJobInput> | CreateJobInput;
  isForJobBoard: InputMaybe<Scalars['Boolean']>;
  scheduleNoEarlierThan: InputMaybe<Scalars['Date']>;
  jobBoardRegionId: InputMaybe<Scalars['UUID']>;
}>;


export type CreateJobsMutation = { __typename: 'Mutation', createJobs: Array<{ __typename: 'Job', id: number, name: string, payout: number | null }> | null };

export type GetEligibleMpCountForJobBoardQueryVariables = Exact<{
  processIds: Array<Scalars['Int']> | Scalars['Int'];
  jobBoardRegionId: Scalars['String'];
  erpSaleOrderId: Scalars['Int'];
}>;


export type GetEligibleMpCountForJobBoardQuery = { __typename: 'Query', getEligibleMpCountForJobBoard: number };

export type GenerateJobNameQueryVariables = Exact<{ [key: string]: never; }>;


export type GenerateJobNameQuery = { __typename: 'Query', generateJobName: string };

export type SolBasicMoldToolFragment = { __typename: 'BasicMoldTool', id: string, name: string, moldToolRevisionId: string, version: number | null };

export type SolProductProcessAttributesFragment = { __typename: 'PartProcessAttributes', id: number, name: string, color: string | null, thickness: string | null, texture: string | null };

export type SolPartFragment = { __typename: 'Part', id: number | null, revisionUuid: string | null, quoteModelRevisionUuid: string | null, name: string, depthX: number | null, depthY: number | null, depthZ: number | null };

export type SolMaterialFragment = { __typename: 'PartMaterialConfiguration', id: number, name: string, color: string | null, colorCode: string | null, grade: string | null, shoreValue: string | null };

export type SolPreviousJobFragment = { __typename: 'PreviousJobsType', id: number, name: string };

export type SolProductProcessFragment = { __typename: 'SalesOrderLineProductProcess', id: number, erpProductId: number | null, salesOrderId: number, salesOrderLineId: number, processTypeName: string, processNotes: string | null, executionSequence: number, unbundledQuantity: number | null, scheduledQuantity: number | null, remainingQuantity: number | null, targetPurchasePrice: number | null, processTypeId: string, processId: number | null, expectedDueDate: any | null, leadTime: number | null, payout: number | null, thumbnailUri: string | null, isLastProductProcess: boolean, productionRegion: string | null, productionCountry: ProductionCountry | null, part: { __typename: 'Part', id: number | null, revisionUuid: string | null, quoteModelRevisionUuid: string | null, name: string, depthX: number | null, depthY: number | null, depthZ: number | null } | null, moldTool: { __typename: 'BasicMoldTool', id: string, name: string, moldToolRevisionId: string, version: number | null } | null, associatedMoldTool: { __typename: 'BasicMoldTool', id: string, name: string, moldToolRevisionId: string, version: number | null } | null, processAttributes: { __typename: 'PartProcessAttributes', id: number, name: string, color: string | null, thickness: string | null, texture: string | null } | null, materialConfiguration: { __typename: 'PartMaterialConfiguration', id: number, name: string, color: string | null, colorCode: string | null, grade: string | null, shoreValue: string | null } | null, previousJobs: Array<{ __typename: 'PreviousJobsType', id: number, name: string }> | null, previousJobBoardJobs: Array<{ __typename: 'PreviousJobsType', id: number, name: string }> | null, nextJobBoard: { __typename: 'JobBoard', id: string, startDate: any } | null };

export type SalesOrderLineProductProcessesQueryVariables = Exact<{
  salesOrderId: Scalars['Int'];
  filters: InputMaybe<ProductProcessFiltersInput>;
}>;


export type SalesOrderLineProductProcessesQuery = { __typename: 'Query', salesOrderLineProductProcesses: Array<{ __typename: 'SalesOrderLineProductProcess', id: number, erpProductId: number | null, salesOrderId: number, salesOrderLineId: number, processTypeName: string, processNotes: string | null, executionSequence: number, unbundledQuantity: number | null, scheduledQuantity: number | null, remainingQuantity: number | null, targetPurchasePrice: number | null, processTypeId: string, processId: number | null, expectedDueDate: any | null, leadTime: number | null, payout: number | null, thumbnailUri: string | null, isLastProductProcess: boolean, productionRegion: string | null, productionCountry: ProductionCountry | null, part: { __typename: 'Part', id: number | null, revisionUuid: string | null, quoteModelRevisionUuid: string | null, name: string, depthX: number | null, depthY: number | null, depthZ: number | null } | null, moldTool: { __typename: 'BasicMoldTool', id: string, name: string, moldToolRevisionId: string, version: number | null } | null, associatedMoldTool: { __typename: 'BasicMoldTool', id: string, name: string, moldToolRevisionId: string, version: number | null } | null, processAttributes: { __typename: 'PartProcessAttributes', id: number, name: string, color: string | null, thickness: string | null, texture: string | null } | null, materialConfiguration: { __typename: 'PartMaterialConfiguration', id: number, name: string, color: string | null, colorCode: string | null, grade: string | null, shoreValue: string | null } | null, previousJobs: Array<{ __typename: 'PreviousJobsType', id: number, name: string }> | null, previousJobBoardJobs: Array<{ __typename: 'PreviousJobsType', id: number, name: string }> | null, nextJobBoard: { __typename: 'JobBoard', id: string, startDate: any } | null }> | null };

export type GetActiveJobBoardRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveJobBoardRegionsQuery = { __typename: 'Query', getActiveJobBoardRegions: Array<{ __typename: 'JobBoardRegion', id: any, name: string, nextJobBoard: { __typename: 'JobBoard', id: string, startDate: any, endDate: any, status: string } | null }> | null };

export type UnbundledSalesOrdersQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: InputMaybe<Scalars['Int']>;
  sort: InputMaybe<Array<SortTypeInput> | SortTypeInput>;
  filters: InputMaybe<SchedulingSalesOrdersFiltersInput>;
}>;


export type UnbundledSalesOrdersQuery = { __typename: 'Query', salesOrderWithUnbundledParts: { __typename: 'PartialSalesOrderResults', totalCount: number, items: Array<{ __typename: 'SalesOrder', id: string, region: string | null, name: string, reorderSourceSaleOrderName: string | null, earliestScheduledDate: any | null, earliestPromisedShipDate: any | null, latestPromisedShipDate: any | null, unbundledPartCount: number | null, unbundledPartPayout: number | null, priority: string | null, unbundledProcessNames: Array<string> | null, customerName: string | null, customerCompanyName: string | null, orderType: OrderType | null, productionCountries: Array<ProductionCountry | null> | null, businessUnit: string | null, project: { __typename: 'BasicProject', id: any | null, name: string, isSecurePlus: boolean } | null, mfgDri: { __typename: 'BasicUser', id: number, displayName: string } | null }> } };

export type AddExceptionFailureNoteMutationVariables = Exact<{
  input: ExceptionFailureNoteInput;
}>;


export type AddExceptionFailureNoteMutation = { __typename: 'Mutation', addExceptionFailureNote: { __typename: 'ExceptionFailureNote', id: number, body: string | null } | null };

export type CreateAttachmentMutationVariables = Exact<{
  input: AttachmentInput;
}>;


export type CreateAttachmentMutation = { __typename: 'Mutation', createExceptionNoteAttachment: { __typename: 'Asset', id: any, fileName: string, extension: string | null, mimeType: string | null, uploadUrl: string | null } };

export type CreateExceptionFailureMutationVariables = Exact<{
  exceptionFailureInput: ExceptionFailureInput;
}>;


export type CreateExceptionFailureMutation = { __typename: 'Mutation', createExceptionFailure: { __typename: 'ExceptionFailure', id: any, name: string } };

export type CreateExceptionFailureNoteAttachmentMutationVariables = Exact<{
  input: AttachmentInput;
}>;


export type CreateExceptionFailureNoteAttachmentMutation = { __typename: 'Mutation', createExceptionFailureNoteAttachment: { __typename: 'Asset', id: any, fileName: string, extension: string | null, mimeType: string | null, uploadUrl: string | null } };

export type MarkUploadedNoteAttachmentMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type MarkUploadedNoteAttachmentMutation = { __typename: 'Mutation', markUploadedAsset: { __typename: 'Asset', id: any, downloadUrl: string | null } };

export type RemoveExceptionFailureNoteAttachmentMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type RemoveExceptionFailureNoteAttachmentMutation = { __typename: 'Mutation', removeExceptionFailureNoteAttachment: any };

export type SetExceptionFailurePartsMutationVariables = Exact<{
  input: ExceptionFailurePartsInput;
}>;


export type SetExceptionFailurePartsMutation = { __typename: 'Mutation', setExceptionFailureParts: Array<{ __typename: 'ExceptionFailurePart', id: number, exceptionId: any } | null> | null };

export type UpdateExceptionFailureMutationVariables = Exact<{
  id: Scalars['UUID'];
  exceptionFailureInput: ExceptionFailureUpdateInput;
}>;


export type UpdateExceptionFailureMutation = { __typename: 'Mutation', updateExceptionFailure: { __typename: 'ExceptionFailure', id: any } };

export type UpdateExceptionFailurePartsMutationVariables = Exact<{
  input: ExceptionFailurePartsInput;
}>;


export type UpdateExceptionFailurePartsMutation = { __typename: 'Mutation', updateExceptionFailureParts: Array<{ __typename: 'ExceptionFailurePart', id: number, exceptionId: any } | null> | null };

export type ExceptionFailureActionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ExceptionFailureActionsQuery = { __typename: 'Query', exceptionFailureActions: Array<{ __typename: 'ExceptionFailureAction', id: number, name: string }> | null };

export type CarActiveAssigneesQueryVariables = Exact<{ [key: string]: never; }>;


export type CarActiveAssigneesQuery = { __typename: 'Query', activeCorrectiveActionRequestAssignees: Array<{ __typename: 'BasicUser', id: number, displayName: string }> | null };

export type ExceptionFailureQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ExceptionFailureQuery = { __typename: 'Query', exceptionFailure: { __typename: 'ExceptionFailure', id: any, name: string, jobId: number, jobName: string, jobRequestId: number | null, erpSaleOrderId: number, assignee: string | null, type: string, action: string | null, isFailure: boolean, daysLate: number | null, failureDiscoveredBy: string | null, shipmentId: number | null, receiptId: number | null, qcId: number | null, milestoneType: string | null, assignedEntity: string | null, isCustomerImpacted: boolean, assigneeId: number | null, creator: string, actionId: number | null, correctiveActionRequestId: string | null, additionalContext: string | null, correctiveActionRequest: { __typename: 'CorrectiveActionRequest', id: any, status: CorrectiveActionRequestStatus } | null, exceptionFailureAttachments: Array<{ __typename: 'ExceptionFailureAttachment', id: any, createdAt: any, createdBy: { __typename: 'BasicUser', id: number, displayName: string } | null, attachment: { __typename: 'Asset', id: any, fileName: string, downloadUrl: string | null, mimeType: string | null } | null }> | null, exceptionFailureParts: Array<{ __typename: 'ExceptionPart', id: number, erpProductId: number, processes: string | null, lines: string | null, orderedQuantity: number | null, partName: string | null, failedQuantity: number }> | null } };

export type JobPartsQueryVariables = Exact<{
  jobId: Scalars['Int'];
}>;


export type JobPartsQuery = { __typename: 'Query', getJobParts: Array<{ __typename: 'JobPart', productId: string, partName: string, lines: string | null, processes: string | null, orderedQty: number }> | null };

export type JobRequestPartsQueryVariables = Exact<{
  jobRequestId: Scalars['Int'];
}>;


export type JobRequestPartsQuery = { __typename: 'Query', getJobRequestParts: Array<{ __typename: 'JobRequestPart', productId: string, partName: string, lines: string | null, processes: string | null, orderedQty: number }> | null };

export type JobRequestInventoryMoveFragment = { __typename: 'InventoryMove', id: number, name: string, state: string };

export type JobRequestDeliveriesFragment = { __typename: 'SalesOrderDeliveryOrder', id: number, name: string | null, state: string | null, committedCompletionDate: any | null };

export type JobRequestsQueryVariables = Exact<{
  statuses: Array<JobRequestStatus> | JobRequestStatus;
  jobId: InputMaybe<Scalars['Int']>;
}>;


export type JobRequestsQuery = { __typename: 'Query', jobRequests: Array<{ __typename: 'JobRequest', id: number, status: string, mfgPartner: { __typename: 'MfgPartner', id: number, name: string }, receipts: Array<{ __typename: 'InventoryMove', id: number, name: string, state: string }> | null, qualityChecks: Array<{ __typename: 'InventoryMove', id: number, name: string, state: string }> | null, deliveryOrders: Array<{ __typename: 'SalesOrderDeliveryOrder', id: number, name: string | null, state: string | null, committedCompletionDate: any | null }> | null }> | null };

export type ExceptionFailuresQueryVariables = Exact<{
  filters: InputMaybe<ExceptionFailuresFilterInput>;
  limit: InputMaybe<Scalars['Int']>;
}>;


export type ExceptionFailuresQuery = { __typename: 'Query', exceptionFailures: { __typename: 'PartialExceptionFailureResults', totalCount: number, items: Array<{ __typename: 'ExceptionFailure', id: any, name: string, type: string, status: string, jobId: number, jobName: string, exceptionFailureState: string, manufacturingPartnerId: number | null, manufacturingPartnerName: string | null, jobRequestId: number | null, jobComputedStatus: string, milestoneType: string | null, updatedAt: any | null, action: string | null, assignee: string | null, assignedEntity: string | null, isCustomerImpacted: boolean, latestNote: { __typename: 'ExceptionFailureNote', id: number, body: string | null } | null, correctiveActionRequest: { __typename: 'CorrectiveActionRequest', id: any, status: CorrectiveActionRequestStatus, name: string } | null }> | null } };

export type MarkUploadedAttachmentMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type MarkUploadedAttachmentMutation = { __typename: 'Mutation', markUploadedAsset: { __typename: 'Asset', id: any, downloadUrl: string | null } };

export type ActiveMfgDrisQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveMfgDrisQuery = { __typename: 'Query', getActiveMfgDriUsers: Array<{ __typename: 'BasicUser', id: number, displayName: string } | null> };

export type ExceptionMpCountriesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ExceptionMpCountriesQueryQuery = { __typename: 'Query', mpCountries: Array<{ __typename: 'MpCountry', id: string, name: string }> };

export type ActiveJobBoardRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveJobBoardRegionsQuery = { __typename: 'Query', getActiveJobBoardRegions: Array<{ __typename: 'JobBoardRegion', id: any, name: string }> | null };

export type GetBusinessUnitsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBusinessUnitsQuery = { __typename: 'Query', getBusinessUnits: Array<string> };

export type GetExceptionActionsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExceptionActionsQueryQuery = { __typename: 'Query', exceptionActions: Array<{ __typename: 'ExceptionAction', id: number, name: string }> | null };

export type GetExceptionCreatedByUserListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExceptionCreatedByUserListQuery = { __typename: 'Query', getExceptionCreatedByUserList: Array<{ __typename: 'BasicUser', id: number, displayName: string }> | null };

export type GetExceptionTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExceptionTypesQuery = { __typename: 'Query', exceptionTypes: Array<{ __typename: 'ExceptionType', id: number, name: string }> | null };

export type GetMfgDriUsersQueryVariables = Exact<{
  assignedTo: InputMaybe<Scalars['String']>;
}>;


export type GetMfgDriUsersQuery = { __typename: 'Query', getMfgDriUsers: Array<{ __typename: 'BasicUser', id: number, displayName: string } | null> };

export type GetSchedulingTypesQueryVariables = Exact<{
  productionCountry: ProductionCountry;
}>;


export type GetSchedulingTypesQuery = { __typename: 'Query', getSchedulingTypes: { __typename: 'SchedulingTypesWithLiveJobBoard', schedulingTypes: Array<SchedulingTypes>, isJobBoardLive: boolean | null } };

export type GetSchedulingProcessTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSchedulingProcessTypesQuery = { __typename: 'Query', processTypes: Array<{ __typename: 'ProcessType', id: string, name: string, platformProcessTypeId: string | null }> };

export type GetSchedulingProcessesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSchedulingProcessesQuery = { __typename: 'Query', schedulingProcesses: Array<{ __typename: 'SchedulingProcess', id: string, name: string }> };

export type GetSalesDriUsersQueryVariables = Exact<{
  assignedTo: InputMaybe<Scalars['String']>;
}>;


export type GetSalesDriUsersQuery = { __typename: 'Query', getMfgDriUsers: Array<{ __typename: 'BasicUser', id: number, displayName: string } | null> };

export type CreateJobRequestCommentMessagesUiQualityMutationVariables = Exact<{
  jobRequestCommentInput: JobRequestCommentInput;
}>;


export type CreateJobRequestCommentMessagesUiQualityMutation = { __typename: 'Mutation', createJobRequestComment: { __typename: 'JobRequestComment', id: number } };

export type PrintVisualFictiv5QualityMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type PrintVisualFictiv5QualityMutation = { __typename: 'Mutation', generateJobRequestVisualFictiv5: string };

export type AdminJobRequestQueryQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AdminJobRequestQueryQuery = { __typename: 'Query', jobRequest: { __typename: 'JobRequest', id: number, jobId: number, name: string, rfqNumber: string | null, salesOrderName: string, payout: number, vendorDueDate: any, status: string, productionStage: string | null, createdAt: any, inspectionStatus: string | null, mfgPartner: { __typename: 'MfgPartner', id: number, name: string }, project: { __typename: 'BasicProject', id: any | null, name: string, isSecurePlus: boolean } | null, subjectTypes: Array<{ __typename: 'SubjectType', id: AllowedSubjectTypes | null, value: string | null }>, jobRequestComments: Array<{ __typename: 'WorkOrderComment', id: number, subject: string | null, body: string, createdAt: any, author: { __typename: 'BasicUser', id: number, firstName: string | null, lastName: string | null, email: any } | null, attachments: Array<{ __typename: 'ErpAttachment', id: any, fileName: string, url: string }> }>, parts: Array<{ __typename: 'JobRequestPartProduct', id: number, linesWithWorkOrderMapping: Array<{ __typename: 'JobRequestLine', id: number, name: string, drawingUri: string | null, productQty: number, inspectionType: string, processType: string | null, processName: string | null, processTexture: string | null, processThickness: string | null, platformProcessId: string | null, materialName: string | null, processNotes: string | null, processColor: string | null, partProduct: { __typename: 'JobRequestLinePartProduct', id: number | null, colorName: string | null, partFileName: string | null, partProductRevision: { __typename: 'JobRequestPartProductRevision', id: number, basicRevision: { __typename: 'BasicRevision', sceneBundle: any | null, images: { __typename: 'RevisionImages', top: string | null, angled: string | null, side: string | null, front: string | null } | null, boundingBox: { __typename: 'Vector3', x: number, y: number, z: number } | null } | null } | null } | null, moldTool: { __typename: 'BasicMoldTool', id: string, name: string, moldToolRevisionId: string } | null, color: { __typename: 'JobRequestLineColor', id: number | null, name: string | null } | null, jobRequestLineAttachments: Array<{ __typename: 'WorkOrderAttachment', id: any, visibleToCustomer: boolean | null, type: string | null, createdAt: any, workOrderItemName: string | null, source: AllowedAttachmentSources, attachment: { __typename: 'Asset', id: any, downloadUrl: string | null, fileName: string, extension: string | null, mimeType: string | null, uploadUrl: string | null } | null, createdBy: { __typename: 'BasicUser', id: number, displayName: string } | null }> }> | null }> | null, jobRequestAttachments: Array<{ __typename: 'WorkOrderAttachment', id: any, type: string | null, attachment: { __typename: 'Asset', id: any, downloadUrl: string | null, fileName: string, extension: string | null, mimeType: string | null, uploadUrl: string | null } | null }> } | null };

export type RemoveJobRequestAttachmentJobRequestDetailMutationVariables = Exact<{
  ids: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type RemoveJobRequestAttachmentJobRequestDetailMutation = { __typename: 'Mutation', removeJobRequestAttachments: Array<any | null> };

export type UpdateVisibleToCustomerQualityMutationVariables = Exact<{
  id: Scalars['UUID'];
  visibleToCustomer: Scalars['Boolean'];
}>;


export type UpdateVisibleToCustomerQualityMutation = { __typename: 'Mutation', updateVisibleToCustomer: any };

export type CreateJobRequestAttachmentsQualityMutationVariables = Exact<{
  attachmentInput: JobRequestLineAttachmentInput;
}>;


export type CreateJobRequestAttachmentsQualityMutation = { __typename: 'Mutation', createJobRequestAttachments: Array<{ __typename: 'WorkOrderAttachment', id: any, type: string | null, createdAt: any, workOrderItemName: string | null, source: AllowedAttachmentSources, attachment: { __typename: 'Asset', id: any, uploadUrl: string | null, downloadUrl: string | null, mimeType: string | null, fileName: string, extension: string | null } | null, createdBy: { __typename: 'BasicUser', id: number, displayName: string } | null } | null> | null };

export type GetAdminJobRequestsQualityQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: InputMaybe<Scalars['Int']>;
  filters: InputMaybe<AdminJobRequestFiltersInput>;
  sort: InputMaybe<AllowedAdminJobRequestSort>;
}>;


export type GetAdminJobRequestsQualityQuery = { __typename: 'Query', adminJobRequests: { __typename: 'JobRequestResults', totalCount: number, items: Array<{ __typename: 'JobRequest', id: number, name: string, rfqNumber: string | null, inspectionStatus: string | null, businessUnit: string | null, vendorDueDate: any, salesOrderName: string, priority: string | null, hasPostProcess: boolean | null, productionStage: string | null, payout: number, secondaryProcessStartDate: any | null, riskStatus: RiskStatus | null, status: string, project: { __typename: 'BasicProject', id: any | null, isSecurePlus: boolean, name: string } | null, linesWithWorkOrderMapping: Array<{ __typename: 'JobRequestLine', id: number, productQty: number, processName: string | null, processType: string | null, materialName: string | null }> | null, jobRequestAttachments: Array<{ __typename: 'WorkOrderAttachment', type: string | null, source: AllowedAttachmentSources, attachment: { __typename: 'Asset', id: any, mimeType: string | null } | null }>, mfgPartner: { __typename: 'MfgPartner', id: number, displayName: string }, mfgDri: { __typename: 'User', id: number, displayName: string } | null, process: { __typename: 'JobRequestProcessType', id: number | null, name: string | null } | null }> | null } };

export type MpCountriesQualityQueryVariables = Exact<{ [key: string]: never; }>;


export type MpCountriesQualityQuery = { __typename: 'Query', mpCountries: Array<{ __typename: 'MpCountry', id: string, name: string }> };

export type CreateErpAttachmentQualityMutationVariables = Exact<{
  mimeType: Scalars['String'];
  fileName: Scalars['String'];
  sizeInKb: InputMaybe<Scalars['Int']>;
}>;


export type CreateErpAttachmentQualityMutation = { __typename: 'Mutation', createErpAttachment: { __typename: 'ErpAttachment', id: any, erpId: number, url: string, putUrl: string | null, fileName: string } | null };

export type CreateJobRequestCommentMutationVariables = Exact<{
  jobRequestCommentInput: JobRequestCommentInput;
}>;


export type CreateJobRequestCommentMutation = { __typename: 'Mutation', createJobRequestComment: { __typename: 'JobRequestComment', id: number } };

export type GetEligibleFollowersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEligibleFollowersQuery = { __typename: 'Query', getEligibleFollowers: Array<{ __typename: 'EligibleFollowerUser', id: number, firstName: string | null, lastName: string | null, odooUserId: number }> | null };

export type UpdateJobRequestFollowersMutationVariables = Exact<{
  jobRequestId: Scalars['Int'];
  input: UpdateJobRequestFollowersInput;
}>;


export type UpdateJobRequestFollowersMutation = { __typename: 'Mutation', updateJobRequestFollowers: { __typename: 'JobRequest', id: number, name: string } };

export type AdminJobRequestQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AdminJobRequestQuery = { __typename: 'Query', jobRequest: { __typename: 'JobRequest', id: number, jobId: number, name: string, rfqNumber: string | null, salesOrderName: string, payout: number, vendorDueDate: any, status: string, productionStage: string | null, createdAt: any, businessUnit: string | null, mfgPartner: { __typename: 'MfgPartner', id: number, name: string }, project: { __typename: 'BasicProject', id: any | null, name: string, isSecurePlus: boolean } | null, subjectTypes: Array<{ __typename: 'SubjectType', id: AllowedSubjectTypes | null, value: string | null }>, jobRequestComments: Array<{ __typename: 'WorkOrderComment', id: number, subject: string | null, body: string, createdAt: any, author: { __typename: 'BasicUser', id: number, firstName: string | null, lastName: string | null, email: any } | null, attachments: Array<{ __typename: 'ErpAttachment', id: any, fileName: string, url: string }> }>, parts: Array<{ __typename: 'JobRequestPartProduct', id: number, linesWithWorkOrderMapping: Array<{ __typename: 'JobRequestLine', id: number, name: string, drawingUri: string | null, productQty: number, inspectionType: string, processType: string | null, processName: string | null, processTexture: string | null, processThickness: string | null, platformProcessId: string | null, materialName: string | null, partProduct: { __typename: 'JobRequestLinePartProduct', id: number | null, colorName: string | null, partFileName: string | null, partProductRevision: { __typename: 'JobRequestPartProductRevision', id: number, basicRevision: { __typename: 'BasicRevision', sceneBundle: any | null, images: { __typename: 'RevisionImages', top: string | null, angled: string | null, side: string | null, front: string | null } | null, boundingBox: { __typename: 'Vector3', x: number, y: number, z: number } | null } | null } | null } | null, moldTool: { __typename: 'BasicMoldTool', id: string, name: string, moldToolRevisionId: string } | null, color: { __typename: 'JobRequestLineColor', id: number | null, name: string | null } | null, jobRequestLineAttachments: Array<{ __typename: 'WorkOrderAttachment', id: any, visibleToCustomer: boolean | null, type: string | null, createdAt: any, workOrderItemName: string | null, source: AllowedAttachmentSources, attachment: { __typename: 'Asset', id: any, downloadUrl: string | null, fileName: string, extension: string | null, mimeType: string | null, uploadUrl: string | null } | null, createdBy: { __typename: 'BasicUser', id: number, displayName: string } | null }> }> | null }> | null, jobRequestAttachments: Array<{ __typename: 'WorkOrderAttachment', id: any, type: string | null, attachment: { __typename: 'Asset', id: any, downloadUrl: string | null, fileName: string, extension: string | null, mimeType: string | null, uploadUrl: string | null } | null }> } | null };

export type UpdateSaleOrderLineProductionCountryMutationVariables = Exact<{
  salesOrderLineId: Scalars['Int'];
  productionCountry: ProductionCountry;
}>;


export type UpdateSaleOrderLineProductionCountryMutation = { __typename: 'Mutation', updateSaleOrderLineProductionCountry: { __typename: 'SaleOrderExtendedData', erpSaleOrderId: number, erpSaleOrderLineId: number, productionCountry: ProductionCountry | null } };

export type UpdateSchedulingDriMutationVariables = Exact<{
  salesOrderLineId: Scalars['Int'];
  schedulingDriId: Scalars['Int'];
}>;


export type UpdateSchedulingDriMutation = { __typename: 'Mutation', updateSchedulingDri: { __typename: 'SaleOrderExtendedData', erpSaleOrderId: number, schedulingDri: { __typename: 'BasicUser', id: number, displayName: string } | null } };

export type GetJobsForSaleOrderQueryVariables = Exact<{
  filters: InputMaybe<JobFiltersInput>;
}>;


export type GetJobsForSaleOrderQuery = { __typename: 'Query', jobs: { __typename: 'JobsListResult', items: Array<{ __typename: 'Job', id: number, name: string, exceptionCount: number | null, pauseException: boolean, nextMilestone: MilestoneType | null, erpSaleOrderId: number, milestones: { __typename: 'JobMilestones', scheduling: { __typename: 'MilestoneDetails', committedDate: any | null, scheduledDate: any | null, actualDate: any | null }, production: { __typename: 'MilestoneDetails', committedDate: any | null, scheduledDate: any | null, actualDate: any | null }, inspection: { __typename: 'MilestoneDetails', committedDate: any | null, scheduledDate: any | null, actualDate: any | null }, deliveryOrder: { __typename: 'MilestoneDetails', committedDate: any | null, scheduledDate: any | null, actualDate: any | null }, shipping: { __typename: 'MilestoneDetails', committedDate: any | null, scheduledDate: any | null, actualDate: any | null }, customerDelivery: { __typename: 'MilestoneDetails', committedDate: any | null, scheduledDate: any | null, actualDate: any | null } } | null }> } };

export type SalesOrderByNameQueryVariables = Exact<{
  name: Scalars['String'];
  includeService?: InputMaybe<Scalars['Boolean']>;
}>;


export type SalesOrderByNameQuery = { __typename: 'Query', salesOrder: { __typename: 'SalesOrder', id: string, name: string, exceptionCount: number, priority: string | null, customerName: string | null, fictivShipmentMethod: string | null, customerCompanyName: string | null, orderDate: any | null, revision: number | null, reorderSourceSaleOrderName: string | null, fictivOrderModifiedPostSale: boolean | null, quoteId: string | null, margin: number | null, actualTransactionMargin: number | null, projectTags: Array<string> | null, totalDiscount: number | null, totalAmount: number, totalCost: number | null, totalTax: number | null, totalPrice: number | null, originalTotalAmount: number, quoteNotes: string | null, quoteDfmNotes: string | null, orderType: OrderType | null, businessUnit: string | null, schedulingDris: Array<{ __typename: 'BasicUser', id: number, displayName: string } | null> | null, mfgDri: { __typename: 'BasicUser', id: number, displayName: string } | null, project: { __typename: 'BasicProject', id: any | null, name: string, isSecurePlus: boolean } | null, shipments: { __typename: 'PartialShipmentResults', items: Array<{ __typename: 'Shipment', shippedBy: any, shippingMethod: string }> } | null, paymentDetails: { __typename: 'PaymentDetails', paymentType: string | null, purchaseOrderNumber: string | null, billingAddress: { __typename: 'PostalAddress', name: string | null, street: string, street2: string | null, city: string | null, state: string | null, country: string } | null }, contract: { __typename: 'SalesOrderContract', id: any, name: string, expiryDate: any | null, salesforceContractOpportunityId: string, salesforceContractLink: string } | null, adminSalesOrderLines: Array<{ __typename: 'SalesOrderLine', id: string, productionCountry: ProductionCountry | null, quoteModelRevisionUUID: string | null, moldToolRevisionId: string | null, productionRegion: string | null, thumbnailUri: string | null, partName: string | null, partType: string | null, orderedQuantity: number, deliveredQuantity: number | null, invoicedQuantity: number | null, unitPrice: number, subTotalAmount: number | null, unitCost: number | null, markup: number | null, totalCost: number | null, totalPrice: number | null, tax: number | null, scheduledShipDate: any | null, scheduledDeliveryDate: any | null, originalUnitPrice: number | null, originalPrice: number | null, unitDiscountAmount: number | null, discountAmount: number | null, mpAdjustedPayout: number | null, mpAssignedQuantity: number | null, processNames: Array<string | null> | null, schedulingDri: { __typename: 'BasicUser', id: number, displayName: string } | null, adminMaterial: { __typename: 'AdminOrderMaterialDetails', color: string | null, name: string | null, shore: string | null, dfmNotes: { __typename: 'MaterialDfmNotes', color: string | null, material: string | null, shoreValue: string | null } | null, additionalSpecifications: { __typename: 'MaterialAdditionalSpecifications', color: string | null, material: string | null, shoreValue: string | null } | null } | null, boundingBox: { __typename: 'ErpBoundingBox', length: number | null, thickness: number | null, width: number | null } | null, moldTool: { __typename: 'BasicMoldTool', id: string, name: string, moldToolRevisionId: string, version: number | null } | null, associatedMoldTool: { __typename: 'BasicMoldTool', id: string, name: string, moldToolRevisionId: string, version: number | null } | null, processes: Array<{ __typename: 'OrderProcessDetails', id: string, color: string | null, texture: string | null, thickness: string | null, processName: string, processNotes: string | null, additionalSpecifications: { __typename: 'ProcessAdditionalSpecifications', color: string | null, texture: string | null, thickness: string | null } | null, dfmNotes: { __typename: 'ProcessDfmNotes', color: string | null, process: string | null, texture: string | null, thickness: string | null } | null }> }> | null, processLines: Array<{ __typename: 'SalesOrderProcessLine', jobId: number | null, rfqNumber: string | null, actualScheduledDate: any | null, actualVendorDueDate: any | null, executionSequence: number, jobName: string | null, jobStatus: string | null, leadTime: number | null, manufacturingPartnerName: string | null, orderedQuantity: number, remainingUnbundledQuantity: number | null, plannedScheduledDate: any | null, plannedVendorDueDate: any | null, processAttributes: string | null, processName: string, productQuantity: number, salesOrderLineId: number, scheduledDeliveryDate: any | null, scheduledShipDate: any | null, schedulingQueueProcessedItemsCount: number | null, schedulingQueueStatus: string | null, schedulingQueueTotalItemsCount: number | null, part: { __typename: 'Part', id: number | null, name: string, quoteModelRevisionUuid: string | null, thumbnailUri: string | null, revisionUuid: string | null, depthX: number | null, depthY: number | null, depthZ: number | null } | null, orderLineProcesses: Array<{ __typename: 'OrderProcessDetails', id: string, processName: string, processNotes: string | null, color: string | null, thickness: string | null, texture: string | null, dfmNotes: { __typename: 'ProcessDfmNotes', color: string | null, thickness: string | null, texture: string | null, process: string | null } | null, additionalSpecifications: { __typename: 'ProcessAdditionalSpecifications', color: string | null, thickness: string | null, texture: string | null } | null }>, materialConfiguration: { __typename: 'PartMaterialConfiguration', color: string | null, colorCode: string | null, grade: string | null, id: number, name: string, shoreValue: string | null, dfmNotes: { __typename: 'MaterialDfmNotes', color: string | null, shoreValue: string | null, material: string | null } | null, additionalSpecifications: { __typename: 'MaterialAdditionalSpecifications', color: string | null, shoreValue: string | null, material: string | null } | null } | null, moldTool: { __typename: 'BasicMoldTool', id: string, name: string, moldToolRevisionId: string, version: number | null } | null, associatedMoldTool: { __typename: 'BasicMoldTool', id: string, name: string, moldToolRevisionId: string, version: number | null } | null }> | null } | null };

export type OrdersListQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: InputMaybe<Scalars['Int']>;
  isCpqFlagV2Enabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type OrdersListQuery = { __typename: 'Query', me: { __typename: 'User', id: number, salesOrders: { __typename: 'PartialSalesOrderViewResults', totalCount: number, items: Array<{ __typename: 'BasicSalesOrder', id: string, name: string, deliveryStatus: string, shippedBy: any | null, createdAt: any, totalAmount: number, project: { __typename: 'BasicProject', id: any | null, isSecurePlus: boolean, name: string } | null } | { __typename: 'SalesOrder', id: string, isReorderAllowed: boolean, isBusinessAccountDiscountApplied: boolean | null, appliedBusinessAccountDiscountPercent: number | null, name: string, deliveryStatus: string, shippedBy: any | null, createdAt: any, totalAmount: number, downloadAllFilesUri: string, fictivShipmentMethod: string | null, fictivOrderUpdatedToDdp: boolean | null, sourceQuoteType: QuoteType | null, quotePdfUrl?: string | null, team: { __typename: 'Team', id: number, name: string } | null, salesOrderLines: { __typename: 'PartialSalesOrderLineResults', totalCount: number, productCount: number | null, items: Array<{ __typename: 'SalesOrderLine', id: string, htsCodeSubmitted: boolean | null, revision: { __typename: 'Revision', id: any, thumbnailUri: string | null } | null, processes: Array<{ __typename: 'OrderProcessDetails', id: string, platformProcessId: string | null, color: string | null, texture: string | null, thickness: string | null, processNotes: string | null, additionalSpecifications: { __typename: 'ProcessAdditionalSpecifications', color: string | null, texture: string | null, thickness: string | null } | null, dfmNotes: { __typename: 'ProcessDfmNotes', color: string | null, process: string | null, texture: string | null, thickness: string | null } | null }> }>, parts: Array<{ __typename: 'SalesOrderLine', id: string, htsCodeSubmitted: boolean | null, revision: { __typename: 'Revision', id: any, thumbnailUri: string | null } | null, processes: Array<{ __typename: 'OrderProcessDetails', id: string, platformProcessId: string | null, color: string | null, texture: string | null, thickness: string | null, processNotes: string | null, additionalSpecifications: { __typename: 'ProcessAdditionalSpecifications', color: string | null, texture: string | null, thickness: string | null } | null, dfmNotes: { __typename: 'ProcessDfmNotes', color: string | null, process: string | null, texture: string | null, thickness: string | null } | null }> }> | null }, paymentDetails: { __typename: 'PaymentDetails', paymentType: string | null, purchaseOrderNumber: string | null, paidBy: { __typename: 'BasicUser', id: number } | null }, project: { __typename: 'BasicProject', id: any | null, isSecurePlus: boolean, name: string } | null, quote: { __typename: 'SalesOrderQuote', name: string } | null, quoteOwnerUser: { __typename: 'BasicUser', id: number } | null }> } } | null };

export type OrderSearchQueryVariables = Exact<{
  orderSearchSearchString: Scalars['String'];
  from: Scalars['Int'];
  size: Scalars['Int'];
  isCpqFlagV2Enabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type OrderSearchQuery = { __typename: 'Query', orderSearch: { __typename: 'OrderSearch', totalCount: number, page: { __typename: 'Page', total: number | null, totalPages: number | null, pageNumber: number | null, from: number | null, size: number | null } | null, items: Array<{ __typename: 'BasicSalesOrder' } | { __typename: 'SalesOrder', id: string, isReorderAllowed: boolean, name: string, deliveryStatus: string, shippedBy: any | null, createdAt: any, totalAmount: number, downloadAllFilesUri: string, fictivShipmentMethod: string | null, fictivOrderUpdatedToDdp: boolean | null, quotePdfUrl?: string | null, team: { __typename: 'Team', id: number, name: string } | null, salesOrderLines: { __typename: 'PartialSalesOrderLineResults', items: Array<{ __typename: 'SalesOrderLine', id: string, revision: { __typename: 'Revision', thumbnailUri: string | null } | null, processes: Array<{ __typename: 'OrderProcessDetails', id: string, platformProcessId: string | null, color: string | null, texture: string | null, thickness: string | null, processNotes: string | null, additionalSpecifications: { __typename: 'ProcessAdditionalSpecifications', color: string | null, texture: string | null, thickness: string | null } | null, dfmNotes: { __typename: 'ProcessDfmNotes', color: string | null, process: string | null, texture: string | null, thickness: string | null } | null }> }>, parts: Array<{ __typename: 'SalesOrderLine', id: string, htsCodeSubmitted: boolean | null, revision: { __typename: 'Revision', id: any, thumbnailUri: string | null } | null, processes: Array<{ __typename: 'OrderProcessDetails', id: string, platformProcessId: string | null, color: string | null, texture: string | null, thickness: string | null, processNotes: string | null, additionalSpecifications: { __typename: 'ProcessAdditionalSpecifications', color: string | null, texture: string | null, thickness: string | null } | null, dfmNotes: { __typename: 'ProcessDfmNotes', color: string | null, process: string | null, texture: string | null, thickness: string | null } | null }> }> | null }, paymentDetails: { __typename: 'PaymentDetails', paymentType: string | null, purchaseOrderNumber: string | null, paidBy: { __typename: 'BasicUser', id: number } | null }, quoteOwnerUser: { __typename: 'BasicUser', id: number } | null } | null> } | null };

export type AdminUserOrderSearchQueryVariables = Exact<{
  searchString: Scalars['String'];
  from: Scalars['Int'];
  size: Scalars['Int'];
  userId: InputMaybe<Scalars['Int']>;
  isCpqFlagV2Enabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type AdminUserOrderSearchQuery = { __typename: 'Query', adminUserOrderSearch: { __typename: 'AdminUserOrderSearch', totalCount: number, page: { __typename: 'Page', total: number | null, totalPages: number | null, pageNumber: number | null, from: number | null, size: number | null } | null, items: Array<{ __typename: 'BasicSalesOrder' } | { __typename: 'SalesOrder', id: string, isReorderAllowed: boolean, name: string, deliveryStatus: string, fictivEstimatedDeliveryDate: any | null, shippedBy: any | null, createdAt: any, totalAmount: number, downloadAllFilesUri: string, fictivShipmentMethod: string | null, fictivOrderUpdatedToDdp: boolean | null, quotePdfUrl?: string | null, salesOrderLines: { __typename: 'PartialSalesOrderLineResults', items: Array<{ __typename: 'SalesOrderLine', id: string, revision: { __typename: 'Revision', thumbnailUri: string | null } | null }>, parts: Array<{ __typename: 'SalesOrderLine', id: string, htsCodeSubmitted: boolean | null, revision: { __typename: 'Revision', id: any, thumbnailUri: string | null } | null, processes: Array<{ __typename: 'OrderProcessDetails', id: string, platformProcessId: string | null, color: string | null, texture: string | null, thickness: string | null, processNotes: string | null, additionalSpecifications: { __typename: 'ProcessAdditionalSpecifications', color: string | null, texture: string | null, thickness: string | null } | null, dfmNotes: { __typename: 'ProcessDfmNotes', color: string | null, process: string | null, texture: string | null, thickness: string | null } | null }> }> | null }, paymentDetails: { __typename: 'PaymentDetails', paymentType: string | null, purchaseOrderNumber: string | null } } | null> } | null };

export type UpdateHtsMutationVariables = Exact<{
  orderId: Scalars['String'];
  htsInput: Array<HtsUpdateInput> | HtsUpdateInput;
  isDdpQualified: Scalars['Boolean'];
  userId: InputMaybe<Scalars['Int']>;
}>;


export type UpdateHtsMutation = { __typename: 'Mutation', updateHts: boolean };

export type QmrsGroupedByDfmCategoryOdpQueryVariables = Exact<{
  orderId: InputMaybe<Scalars['String']>;
}>;


export type QmrsGroupedByDfmCategoryOdpQuery = { __typename: 'Query', qmrsGroupedByDfmCategory: Array<{ __typename: 'QmrDfmCategoryGrouping', category: string, qmrs: Array<{ __typename: 'QuoteModelRevision', id: any, fileName: string, version: string, attachmentLink: { __typename: 'QuoteModelRevisionAttachment', id: any, quoteAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string } | null } } | null, partRevision: { __typename: 'Revision', id: any, thumbnailUri: string | null }, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, isPublished: boolean }> }> | null }> };

export type DuplicateQuoteFromOrderMutationVariables = Exact<{
  orderName: Scalars['String'];
}>;


export type DuplicateQuoteFromOrderMutation = { __typename: 'Mutation', duplicateQuoteFromOrder: { __typename: 'Quote', id: any, name: string, sourceQuoteId: any | null } };

export type CreateInspectionZipDownloadOrderDetailsMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type CreateInspectionZipDownloadOrderDetailsMutation = { __typename: 'Mutation', createZipDownloadOrderDetails: { __typename: 'ZipDownloadJob', url: string | null } };

export type CreateZipDownloadOrderDetailsMutationVariables = Exact<{
  orderName: Scalars['String'];
}>;


export type CreateZipDownloadOrderDetailsMutation = { __typename: 'Mutation', createZipDownloadOrderDetails: { __typename: 'ZipDownloadJob', id: string, jobStartDate: any, jobCompleteDate: any | null, name: string, error: string | null, url: string | null } };

export type ViewerPageModelViewerSnapshotFragment = { __typename: 'ModelViewerSnapshot', id: any, position: any, target: any, feature: string | null, type: string, createdAt: any, updatedAt: any, deletedAt: any | null, snapshot: { __typename: 'ModelViewerConfig', rotation: Array<number> | null, camera: { __typename: 'ModelViewerCameraConfig', zoom: number, position: Array<number>, up: Array<number> | null, target: Array<number> | null } | null, dfm: Array<{ __typename: 'ModelViewerDfmFeatureConfig', feature: string | null, threshold: number | null, direction: Array<number> | null }>, annotations: Array<{ __typename: 'ModelViewerAnnotationConfig', position: Array<number> }>, part: { __typename: 'ModelViewerPartConfig', transparent: boolean, patches: Array<{ __typename: 'ModelViewerPatchConfig', color: string | null, hashcode: string }> }, crossSection: { __typename: 'ModelViewerCrossSectionConfig', position: any, rotation: any } | null, pointToPoint: { __typename: 'PointToPointConfig', customPoints: Array<any>, selectedPoints: Array<{ __typename: 'P2PPoint', index: number, type: P2PPointType }> } | null } | null };

export type DfmFeedbackOrderDetailsPageFragment = { __typename: 'DfmFeedback', id: any, title: string | null, link: string | null, severity: string, message: string, accepted: boolean, isPublished: boolean, modelViewerSnapshots: Array<{ __typename: 'ModelViewerSnapshot', id: any, position: any, target: any, feature: string | null, type: string, createdAt: any, updatedAt: any, deletedAt: any | null, snapshot: { __typename: 'ModelViewerConfig', rotation: Array<number> | null, camera: { __typename: 'ModelViewerCameraConfig', zoom: number, position: Array<number>, up: Array<number> | null, target: Array<number> | null } | null, dfm: Array<{ __typename: 'ModelViewerDfmFeatureConfig', feature: string | null, threshold: number | null, direction: Array<number> | null }>, annotations: Array<{ __typename: 'ModelViewerAnnotationConfig', position: Array<number> }>, part: { __typename: 'ModelViewerPartConfig', transparent: boolean, patches: Array<{ __typename: 'ModelViewerPatchConfig', color: string | null, hashcode: string }> }, crossSection: { __typename: 'ModelViewerCrossSectionConfig', position: any, rotation: any } | null, pointToPoint: { __typename: 'PointToPointConfig', customPoints: Array<any>, selectedPoints: Array<{ __typename: 'P2PPoint', index: number, type: P2PPointType }> } | null } | null }> };

export type HolesFragment = { __typename: 'Hole', id: string, groupKey: string, type: string, depth: number | null, diameter: number | null, isBlind: boolean | null, tipAngle: number | null, counterboreDepth: number | null, counterboreDiameter: number | null, countersinkAngle: number | null, countersinkDepth: number | null, countersinkDiameter: number | null, direction: any | null, endPoint: Array<number> | null, startPoint: Array<number> | null, patches: Array<{ __typename: 'RevisionPatch', id: string }>, tapOptions: Array<{ __typename: 'TapOption', id: string, maxDepth: number, commonName: string }>, tapAnnotation: { __typename: 'TapAnnotation', id: any, depth: number | null, tapOption: { __typename: 'TapOption', id: string, maxDepth: number, commonName: string } | null } | null };

export type RevisionFragment = { __typename: 'Revision', id: any, version: string, modelFileName: string | null, thumbnailUri: string | null, downloadUri: string | null, sceneBundle: any | null, scene: { __typename: 'ViewerScene', featureMapping: { __typename: 'SceneFile', url: string } | null, geometry: { __typename: 'SceneFile', url: string } | null } | null, boundingBox: { __typename: 'Vector3', x: number, y: number, z: number } | null, revisionFolderAttachments: Array<{ __typename: 'RevisionFolderAttachment', id: any, quoteAttachment: { __typename: 'QuoteAttachment', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string } | null } }> };

export type BoundingBoxFragment = { __typename: 'BoundingBox', width: number, length: number, thickness: number };

export type InspectionDocumentsFragment = { __typename: 'InspectionDocument', fileName: string | null, type: AllowedInspectionDocumentType, mimeType: string | null, downloadUrl: string | null, createdAt: any, updatedAt: any };

export type SalesOrderQueryVariables = Exact<{
  name: Scalars['String'];
  isCpqFlagV2Enabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type SalesOrderQuery = { __typename: 'Query', salesOrder: { __typename: 'SalesOrder', id: string, isReorderAllowed: boolean, isImReorder: boolean | null, name: string, deliveryStatus: string, shippedBy: any | null, createdAt: any, totalAmount: number, customerName: string | null, fictivShipmentMethod: string | null, fictivEstimatedDeliveryDate: any | null, drawingAttachmentsCount: number, sourceQuoteType: QuoteType | null, depositAmount: number | null, isBusinessAccountDiscountApplied: boolean | null, appliedBusinessAccountDiscountPercent: number | null, fictivOrderUpdatedToDdp: boolean | null, fictivOrderModifiedPostSale: boolean | null, quoteId: string | null, quotePdfUrl?: string | null, team: { __typename: 'Team', id: number, name: string } | null, paymentDetails: { __typename: 'PaymentDetails', id: string, paidByDisplayName: string | null, paymentType: string | null, purchaseOrderNumber: string | null, creditCardLast4: string | null, paidBy: { __typename: 'BasicUser', id: number, displayName: string } | null, billingAddress: { __typename: 'PostalAddress', id: string, name: string | null, street: string, street2: string | null, city: string | null, state: string | null, postalCode: string, phone: string | null, country: string } | null }, shipments: { __typename: 'PartialShipmentResults', totalCount: number, items: Array<{ __typename: 'Shipment', id: string, deliveryStatus: string, carrier: string | null, shippedBy: any, shippingMethod: string, trackingCode: string | null, committedDeliveryDate: any | null, shipToAddress: { __typename: 'ShipToAddress', name: string | null, street: string | null, street2: string | null, city: string | null, stateCode: string | null, stateName: string | null, zip: string | null, countryCode: string | null, countryName: string | null, companyName: string | null, phone: string | null }, trackingData: { __typename: 'TrackingData', status: string, estDeliveryDate: any | null, signedBy: string | null, trackingDetails: Array<{ __typename: 'TrackingDetail', message: string, status: string, datetime: any | null, trackingLocation: { __typename: 'TrackingLocation', city: string | null, state: string | null, countryCode: string | null, postalCode: string | null } | null }> } | null, shipmentLines: { __typename: 'PartialShipmentLineResults', totalCount: number, items: Array<{ __typename: 'ShipmentLine', woAvailableToShow: boolean, revision: { __typename: 'Revision', id: any } | null, inspectionDocuments: Array<{ __typename: 'InspectionDocument', fileName: string | null } | null> | null }> | null } }> } | null, salesOrderLines: { __typename: 'PartialSalesOrderLineResults', totalCount: number, items: Array<{ __typename: 'SalesOrderLine', id: string, htsCode: string | null, htsCodeSubmitted: boolean | null, htsDescription: string | null, htsApplication: string | null, htsUsageType: HtsUsageType | null, deliveryStatus: string, quantity: number, unitPrice: number, processName: string | null, productionRegion: string | null, processes: Array<{ __typename: 'OrderProcessDetails', id: string, color: string | null, texture: string | null, thickness: string | null, processNotes: string | null, additionalSpecifications: { __typename: 'ProcessAdditionalSpecifications', color: string | null, texture: string | null, thickness: string | null } | null, dfmNotes: { __typename: 'ProcessDfmNotes', color: string | null, process: string | null, texture: string | null, thickness: string | null } | null }>, revision: { __typename: 'Revision', id: any, modelFileName: string | null, thumbnailUri: string | null } | null, quoteModelRevisionAttachment: { __typename: 'Attachment', id: any, fileName: string } | null, quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, dfmReports: Array<{ __typename: 'PartDfmReport', isPublished: boolean }>, quoteModel: { __typename: 'QuoteModel', id: any, quote: { __typename: 'Quote', id: any, name: string } | null }, modelConfiguration: { __typename: 'ModelConfiguration', fdmInfillPercentageCategoryLabel: string | null, color: { __typename: 'Color', name: string } | null, process: { __typename: 'Process', id: string } | null } | null } | null }>, parts: Array<{ __typename: 'SalesOrderLine', id: string, htsCode: string | null, htsCodeSubmitted: boolean | null, htsDescription: string | null, htsApplication: string | null, htsUsageType: HtsUsageType | null, deliveryStatus: string, quantity: number, unitPrice: number, processName: string | null, productionRegion: string | null, processes: Array<{ __typename: 'OrderProcessDetails', id: string, color: string | null, texture: string | null, thickness: string | null, processNotes: string | null, additionalSpecifications: { __typename: 'ProcessAdditionalSpecifications', color: string | null, texture: string | null, thickness: string | null } | null, dfmNotes: { __typename: 'ProcessDfmNotes', color: string | null, process: string | null, texture: string | null, thickness: string | null } | null }>, revision: { __typename: 'Revision', id: any, modelFileName: string | null, thumbnailUri: string | null } | null, quoteModelRevisionAttachment: { __typename: 'Attachment', id: any, fileName: string } | null, quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, dfmReports: Array<{ __typename: 'PartDfmReport', isPublished: boolean }>, quoteModel: { __typename: 'QuoteModel', id: any, quote: { __typename: 'Quote', id: any, name: string } | null }, modelConfiguration: { __typename: 'ModelConfiguration', fdmInfillPercentageCategoryLabel: string | null, color: { __typename: 'Color', name: string } | null, process: { __typename: 'Process', id: string } | null } | null } | null }> | null }, project: { __typename: 'BasicProject', id: any | null, isSecurePlus: boolean, name: string } | null, quote: { __typename: 'SalesOrderQuote', name: string } | null, quoteOwnerUser: { __typename: 'BasicUser', id: number } | null } | null };

export type SalesOrderLinesQueryVariables = Exact<{
  orderId: Scalars['String'];
  statusNotIn: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  cursor: InputMaybe<Scalars['ENCODED_CURSOR']>;
  isImMaafcoEnabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type SalesOrderLinesQuery = { __typename: 'Query', salesOrderLines: { __typename: 'PartialSalesOrderLineResults', totalCount: number, productCount: number | null, cursor: { __typename: 'Cursor', previous: any | null, next: any | null } | null, items: Array<{ __typename: 'SalesOrderLine', id: string, producedBy: any | null, deliveryStatus: string, moldStatus: string | null, erpMoldId: string | null, quantity: number, orderedQuantity: number, deliveredQuantity: number | null, erpProductToolId: number | null, associatedParts?: Array<string | null> | null, unitPrice: number, productionRegion: string | null, processName: string | null, processNames: Array<string | null> | null, inspectionStatus: ReportState, productionStatus: ReportState, material: { __typename: 'OrderMaterialDetails', id: string, name: string, color: string | null, shore: string | null, materialGrade: string | null, colorCode: string | null, publicName: string | null } | null, revision: { __typename: 'Revision', id: any, version: string, modelFileName: string | null, thumbnailUri: string | null, downloadUri: string | null, sceneBundle: any | null, scene: { __typename: 'ViewerScene', featureMapping: { __typename: 'SceneFile', url: string } | null, geometry: { __typename: 'SceneFile', url: string } | null } | null, boundingBox: { __typename: 'Vector3', x: number, y: number, z: number } | null, revisionFolderAttachments: Array<{ __typename: 'RevisionFolderAttachment', id: any, quoteAttachment: { __typename: 'QuoteAttachment', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string } | null } }> } | null, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, title: string | null, link: string | null, severity: string, message: string, accepted: boolean, isPublished: boolean, modelViewerSnapshots: Array<{ __typename: 'ModelViewerSnapshot', id: any, position: any, target: any, feature: string | null, type: string, createdAt: any, updatedAt: any, deletedAt: any | null, snapshot: { __typename: 'ModelViewerConfig', rotation: Array<number> | null, camera: { __typename: 'ModelViewerCameraConfig', zoom: number, position: Array<number>, up: Array<number> | null, target: Array<number> | null } | null, dfm: Array<{ __typename: 'ModelViewerDfmFeatureConfig', feature: string | null, threshold: number | null, direction: Array<number> | null }>, annotations: Array<{ __typename: 'ModelViewerAnnotationConfig', position: Array<number> }>, part: { __typename: 'ModelViewerPartConfig', transparent: boolean, patches: Array<{ __typename: 'ModelViewerPatchConfig', color: string | null, hashcode: string }> }, crossSection: { __typename: 'ModelViewerCrossSectionConfig', position: any, rotation: any } | null, pointToPoint: { __typename: 'PointToPointConfig', customPoints: Array<any>, selectedPoints: Array<{ __typename: 'P2PPoint', index: number, type: P2PPointType }> } | null } | null }> }> | null, holes: Array<{ __typename: 'Hole', id: string, groupKey: string, type: string, depth: number | null, diameter: number | null, isBlind: boolean | null, tipAngle: number | null, counterboreDepth: number | null, counterboreDiameter: number | null, countersinkAngle: number | null, countersinkDepth: number | null, countersinkDiameter: number | null, direction: any | null, endPoint: Array<number> | null, startPoint: Array<number> | null, patches: Array<{ __typename: 'RevisionPatch', id: string }>, tapOptions: Array<{ __typename: 'TapOption', id: string, maxDepth: number, commonName: string }>, tapAnnotation: { __typename: 'TapAnnotation', id: any, depth: number | null, tapOption: { __typename: 'TapOption', id: string, maxDepth: number, commonName: string } | null } | null }> | null, processes: Array<{ __typename: 'OrderProcessDetails', id: string, platformProcessId: string | null, processName: string, processNotes: string | null, color: string | null, thickness: string | null, texture: string | null, finish: string | null, toolLife: string | null, surfaceFinishCode: string | null, additionalSpecifications: { __typename: 'ProcessAdditionalSpecifications', color: string | null, texture: string | null, thickness: string | null } | null, dfmNotes: { __typename: 'ProcessDfmNotes', color: string | null, process: string | null, texture: string | null, thickness: string | null } | null }>, quoteModelRevisionAttachment: { __typename: 'Attachment', id: any, fileName: string, downloadUrl: string | null, sanitized: { __typename: 'SanitizedAttachment', id: any, fileName: string, downloadUrl: string | null } | null, annotated: { __typename: 'AnnotatedAttachment', id: any, fileName: string, downloadUrl: string | null } | null } | null, shipmentAndInspection: Array<{ __typename: 'SalesOrderLineShipment', shipmentId: string | null, woAvailableToShow: boolean | null, inspectionTypes: Array<AllowedInspectionType | null> | null, inspectionDocuments: Array<{ __typename: 'InspectionDocument', fileName: string | null, type: AllowedInspectionDocumentType, mimeType: string | null, downloadUrl: string | null, createdAt: any, updatedAt: any } | null> | null } | null>, quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, quoteModel: { __typename: 'QuoteModel', quote: { __typename: 'Quote', id: any, type: QuoteType, name: string, isCpqOwned: boolean | null, user: { __typename: 'BasicUser', id: number, firstName: string | null, lastName: string | null, email: any } } | null }, dfmReports: Array<{ __typename: 'PartDfmReport', quoteAttachmentRevisionId: any, source: string | null, uploaderEmail: string | null, isPublished: boolean, asset: { __typename: 'Asset', id: any, createdAt: any, downloadUrl: string | null, fileName: string } | null }>, modelConfiguration: { __typename: 'ModelConfiguration', fdmInfillPercentageCategoryLabel: string | null, colorCode: string | null, color: { __typename: 'Color', name: string } | null, process: { __typename: 'Process', id: string } | null } | null } | null }>, parts: Array<{ __typename: 'SalesOrderLine', id: string, producedBy: any | null, deliveryStatus: string, quantity: number, orderedQuantity: number, associatedErpProductToolId: number | null, unitPrice: number, productionRegion: string | null, processName: string | null, processNames: Array<string | null> | null, inspectionStatus: ReportState, productionStatus: ReportState, material: { __typename: 'OrderMaterialDetails', id: string, name: string, color: string | null, shore: string | null, materialGrade: string | null, colorCode: string | null } | null, revision: { __typename: 'Revision', id: any, version: string, modelFileName: string | null, thumbnailUri: string | null, downloadUri: string | null, sceneBundle: any | null, scene: { __typename: 'ViewerScene', featureMapping: { __typename: 'SceneFile', url: string } | null, geometry: { __typename: 'SceneFile', url: string } | null } | null, boundingBox: { __typename: 'Vector3', x: number, y: number, z: number } | null, revisionFolderAttachments: Array<{ __typename: 'RevisionFolderAttachment', id: any, quoteAttachment: { __typename: 'QuoteAttachment', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string } | null } }> } | null, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, title: string | null, link: string | null, severity: string, message: string, accepted: boolean, isPublished: boolean, modelViewerSnapshots: Array<{ __typename: 'ModelViewerSnapshot', id: any, position: any, target: any, feature: string | null, type: string, createdAt: any, updatedAt: any, deletedAt: any | null, snapshot: { __typename: 'ModelViewerConfig', rotation: Array<number> | null, camera: { __typename: 'ModelViewerCameraConfig', zoom: number, position: Array<number>, up: Array<number> | null, target: Array<number> | null } | null, dfm: Array<{ __typename: 'ModelViewerDfmFeatureConfig', feature: string | null, threshold: number | null, direction: Array<number> | null }>, annotations: Array<{ __typename: 'ModelViewerAnnotationConfig', position: Array<number> }>, part: { __typename: 'ModelViewerPartConfig', transparent: boolean, patches: Array<{ __typename: 'ModelViewerPatchConfig', color: string | null, hashcode: string }> }, crossSection: { __typename: 'ModelViewerCrossSectionConfig', position: any, rotation: any } | null, pointToPoint: { __typename: 'PointToPointConfig', customPoints: Array<any>, selectedPoints: Array<{ __typename: 'P2PPoint', index: number, type: P2PPointType }> } | null } | null }> }> | null, holes: Array<{ __typename: 'Hole', id: string, groupKey: string, type: string, depth: number | null, diameter: number | null, isBlind: boolean | null, tipAngle: number | null, counterboreDepth: number | null, counterboreDiameter: number | null, countersinkAngle: number | null, countersinkDepth: number | null, countersinkDiameter: number | null, direction: any | null, endPoint: Array<number> | null, startPoint: Array<number> | null, patches: Array<{ __typename: 'RevisionPatch', id: string }>, tapOptions: Array<{ __typename: 'TapOption', id: string, maxDepth: number, commonName: string }>, tapAnnotation: { __typename: 'TapAnnotation', id: any, depth: number | null, tapOption: { __typename: 'TapOption', id: string, maxDepth: number, commonName: string } | null } | null }> | null, processes: Array<{ __typename: 'OrderProcessDetails', id: string, platformProcessId: string | null, processName: string, processNotes: string | null, color: string | null, thickness: string | null, texture: string | null, finish: string | null, toolLife: string | null, surfaceFinishCode: string | null, additionalSpecifications: { __typename: 'ProcessAdditionalSpecifications', color: string | null, texture: string | null, thickness: string | null } | null, dfmNotes: { __typename: 'ProcessDfmNotes', color: string | null, process: string | null, texture: string | null, thickness: string | null } | null }>, quoteModelRevisionAttachment: { __typename: 'Attachment', id: any, fileName: string, downloadUrl: string | null, sanitized: { __typename: 'SanitizedAttachment', id: any, fileName: string, downloadUrl: string | null } | null, annotated: { __typename: 'AnnotatedAttachment', id: any, fileName: string, downloadUrl: string | null } | null } | null, quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, quoteModel: { __typename: 'QuoteModel', quote: { __typename: 'Quote', id: any, type: QuoteType, name: string, user: { __typename: 'BasicUser', id: number, firstName: string | null, lastName: string | null, email: any } } | null }, dfmReports: Array<{ __typename: 'PartDfmReport', quoteAttachmentRevisionId: any, source: string | null, uploaderEmail: string | null, isPublished: boolean, asset: { __typename: 'Asset', id: any, createdAt: any, downloadUrl: string | null, fileName: string } | null }>, modelConfiguration: { __typename: 'ModelConfiguration', fdmInfillPercentageCategoryLabel: string | null, colorCode: string | null, color: { __typename: 'Color', name: string } | null, process: { __typename: 'Process', id: string } | null } | null } | null, shipmentAndInspection: Array<{ __typename: 'SalesOrderLineShipment', shipmentId: string | null, woAvailableToShow: boolean | null, inspectionTypes: Array<AllowedInspectionType | null> | null, inspectionDocuments: Array<{ __typename: 'InspectionDocument', fileName: string | null, type: AllowedInspectionDocumentType, mimeType: string | null, downloadUrl: string | null, createdAt: any, updatedAt: any } | null> | null } | null> }> | null } | null };

export type ShipmentLinesQueryVariables = Exact<{
  id: Scalars['String'];
  limit: Scalars['Int'];
  cursor: InputMaybe<Scalars['ENCODED_CURSOR']>;
}>;


export type ShipmentLinesQuery = { __typename: 'Query', shipment: { __typename: 'Shipment', id: string, shipmentLines: { __typename: 'PartialShipmentLineResults', totalCount: number, cursor: { __typename: 'Cursor', previous: any | null, next: any | null } | null, items: Array<{ __typename: 'ShipmentLine', id: string, quantity: number, totalQuantity: number, processName: string | null, processNames: Array<string | null> | null, woAvailableToShow: boolean, inspectionTypes: Array<AllowedInspectionType | null> | null, erpMoldId: string | null, processes: Array<{ __typename: 'OrderProcessDetails', id: string, platformProcessId: string | null, processName: string, processNotes: string | null, color: string | null, thickness: string | null, texture: string | null, finish: string | null, toolLife: string | null, surfaceFinishCode: string | null, additionalSpecifications: { __typename: 'ProcessAdditionalSpecifications', color: string | null, texture: string | null, thickness: string | null } | null, dfmNotes: { __typename: 'ProcessDfmNotes', color: string | null, process: string | null, texture: string | null, thickness: string | null } | null }>, materialDetails: { __typename: 'OrderMaterialDetails', id: string, name: string, color: string | null, shore: string | null, colorCode: string | null, materialGrade: string | null, publicName: string | null } | null, quoteModelRevisionAttachment: { __typename: 'Attachment', id: any, fileName: string, downloadUrl: string | null, sanitized: { __typename: 'SanitizedAttachment', id: any, fileName: string, downloadUrl: string | null } | null, annotated: { __typename: 'AnnotatedAttachment', id: any, fileName: string, downloadUrl: string | null } | null } | null, boundingBox: { __typename: 'BoundingBox', width: number, length: number, thickness: number } | null, inspectionDocuments: Array<{ __typename: 'InspectionDocument', fileName: string | null, type: AllowedInspectionDocumentType, mimeType: string | null, downloadUrl: string | null, createdAt: any, updatedAt: any } | null> | null, revision: { __typename: 'Revision', id: any, version: string, modelFileName: string | null, thumbnailUri: string | null, downloadUri: string | null, sceneBundle: any | null, scene: { __typename: 'ViewerScene', featureMapping: { __typename: 'SceneFile', url: string } | null, geometry: { __typename: 'SceneFile', url: string } | null } | null, boundingBox: { __typename: 'Vector3', x: number, y: number, z: number } | null, revisionFolderAttachments: Array<{ __typename: 'RevisionFolderAttachment', id: any, quoteAttachment: { __typename: 'QuoteAttachment', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string } | null } }> } | null, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, title: string | null, link: string | null, severity: string, message: string, accepted: boolean, isPublished: boolean, modelViewerSnapshots: Array<{ __typename: 'ModelViewerSnapshot', id: any, position: any, target: any, feature: string | null, type: string, createdAt: any, updatedAt: any, deletedAt: any | null, snapshot: { __typename: 'ModelViewerConfig', rotation: Array<number> | null, camera: { __typename: 'ModelViewerCameraConfig', zoom: number, position: Array<number>, up: Array<number> | null, target: Array<number> | null } | null, dfm: Array<{ __typename: 'ModelViewerDfmFeatureConfig', feature: string | null, threshold: number | null, direction: Array<number> | null }>, annotations: Array<{ __typename: 'ModelViewerAnnotationConfig', position: Array<number> }>, part: { __typename: 'ModelViewerPartConfig', transparent: boolean, patches: Array<{ __typename: 'ModelViewerPatchConfig', color: string | null, hashcode: string }> }, crossSection: { __typename: 'ModelViewerCrossSectionConfig', position: any, rotation: any } | null, pointToPoint: { __typename: 'PointToPointConfig', customPoints: Array<any>, selectedPoints: Array<{ __typename: 'P2PPoint', index: number, type: P2PPointType }> } | null } | null }> }> | null, holes: Array<{ __typename: 'Hole', id: string, groupKey: string, type: string, depth: number | null, diameter: number | null, isBlind: boolean | null, tipAngle: number | null, counterboreDepth: number | null, counterboreDiameter: number | null, countersinkAngle: number | null, countersinkDepth: number | null, countersinkDiameter: number | null, direction: any | null, endPoint: Array<number> | null, startPoint: Array<number> | null, patches: Array<{ __typename: 'RevisionPatch', id: string }>, tapOptions: Array<{ __typename: 'TapOption', id: string, maxDepth: number, commonName: string }>, tapAnnotation: { __typename: 'TapAnnotation', id: any, depth: number | null, tapOption: { __typename: 'TapOption', id: string, maxDepth: number, commonName: string } | null } | null }> | null }> | null } } | null };

export type DfmFeedbackQueryQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type DfmFeedbackQueryQuery = { __typename: 'Query', salesOrder: { __typename: 'SalesOrder', salesOrderLines: { __typename: 'PartialSalesOrderLineResults', items: Array<{ __typename: 'SalesOrderLine', id: string, quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, isPublished: boolean }> } | null }>, parts: Array<{ __typename: 'SalesOrderLine', id: string, quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, isPublished: boolean }> } | null }> | null } } | null };

export type SalesOrderDownloadInvoiceUriQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type SalesOrderDownloadInvoiceUriQuery = { __typename: 'Query', salesOrder: { __typename: 'SalesOrder', downloadInvoiceUri: string | null } | null };

export type CreateReorderQuoteFromOrderMutationVariables = Exact<{
  orderName: Scalars['String'];
  userId: InputMaybe<Scalars['Int']>;
}>;


export type CreateReorderQuoteFromOrderMutation = { __typename: 'Mutation', createReorderQuoteFromOrder: { __typename: 'Quote', id: any, name: string } };

export type GetNonconfigurableOrderPartConfigInfoQueryVariables = Exact<{
  orderName: Scalars['String'];
}>;


export type GetNonconfigurableOrderPartConfigInfoQuery = { __typename: 'Query', getNonconfigurableOrderPartConfigInfo: Array<{ __typename: 'NonconfigurableOrderLineConfigInfo', fileName: string, processes: Array<{ __typename: 'Process', id: string, name: string }>, materials: Array<{ __typename: 'Material', id: string, name: string, processTechnologyId: string | null }>, postProcesses: Array<{ __typename: 'InvalidPostProcessConfigInfo', id: string, name: string, color: string | null }>, secondaryProcesses: Array<{ __typename: 'InvalidSecondaryProcessConfigInfo', id: string, name: string | null }> }> };

export type GetReorderEligibilityForOrderQueryVariables = Exact<{
  orderName: Scalars['String'];
}>;


export type GetReorderEligibilityForOrderQuery = { __typename: 'Query', getReorderEligibilityForOrder: { __typename: 'ReorderEligibility', eligible: boolean, ineligibilityReason: string | null } | null };

export type FeatureFlagsDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type FeatureFlagsDashboardQuery = { __typename: 'Query', featureFlags: Array<{ __typename: 'FeatureFlag', key: string, defaultVariant: string, scope: FeatureFlagScope, updatedAt: any | null, rules: Array<{ __typename: 'FeatureFlagRule', attribute: string, operation: string, values: Array<string>, variant: string }> }> };

export type SetFeatureFlagDashboardMutationVariables = Exact<{
  setFeatureFlagInput: FeatureFlagInput;
}>;


export type SetFeatureFlagDashboardMutation = { __typename: 'Mutation', setFeatureFlag: { __typename: 'FeatureFlag', key: string, defaultVariant: string, scope: FeatureFlagScope, updatedAt: any | null, rules: Array<{ __typename: 'FeatureFlagRule', attribute: string, operation: string, values: Array<string>, variant: string }> } };

export type CancelPlatformOrderOrderDetailViewMutationVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type CancelPlatformOrderOrderDetailViewMutation = { __typename: 'Mutation', cancelPlatformOrder: { __typename: 'Order', id: number } | null };

export type OrderQueryVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type OrderQuery = { __typename: 'Query', order: { __typename: 'Order', id: number, status: string | null } | null };

export type OrderInvoiceQueryVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type OrderInvoiceQuery = { __typename: 'Query', order: { __typename: 'Order', id: number, instantQuoteInvoiceUri: string | null } | null };

export type CreateQuoteLevelMoldMutationVariables = Exact<{
  quoteId: Scalars['UUID'];
  isImMaafcoEnabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateQuoteLevelMoldMutation = { __typename: 'Mutation', createQuoteMoldTool: { __typename: 'MoldTool', id: any, name?: string, moldToolRevision?: { __typename: 'MoldToolRevision', id: any, version: number, processId: string | null } } };

export type CreateMoldToolQmrAssociationMutationVariables = Exact<{
  moldToolId: Scalars['UUID'];
  modelConfigurationDfmInspectionId: Scalars['UUID'];
}>;


export type CreateMoldToolQmrAssociationMutation = { __typename: 'Mutation', createMoldToolQmrAssociation: { __typename: 'QuoteModelRevision', id: any, fileName: string } | null };

export type UpdateMoldToolInspectionDataMutationVariables = Exact<{
  updateMoldToolInspectionDataId: Scalars['UUID'];
  inspectionData: MoldToolInspectionDataInput;
}>;


export type UpdateMoldToolInspectionDataMutation = { __typename: 'Mutation', updateMoldToolInspectionData: { __typename: 'MoldTool', id: any, uiIndex: number } };

export type UpdateMoldToolOverrideDataMutationVariables = Exact<{
  moldId: Scalars['UUID'];
  moldToolOverrideData: MoldToolOverrideInput;
}>;


export type UpdateMoldToolOverrideDataMutation = { __typename: 'Mutation', updateMoldToolOverrideData: { __typename: 'MoldTool', manualOverrideMpUnitPayout: number | null, manualOverrideUnitAmount: number | null } };

export type AddMtrToQmrAssociationMutationVariables = Exact<{
  moldToolRevisionId: Scalars['UUID'];
  quoteModelRevisionId: Scalars['UUID'];
}>;


export type AddMtrToQmrAssociationMutation = { __typename: 'Mutation', addMoldToolRevisionToQMRAssociation: { __typename: 'MoldTool', id: any, name: string, moldToolRevisionQmr: Array<{ __typename: 'MoldToolRevisionQmr', cavityPerPart: number | null }> } | null };

export type UpdateMoldToolRevisionMutationVariables = Exact<{
  moldToolRevisionId: Scalars['String'];
  input: MoldToolRevisionInput;
}>;


export type UpdateMoldToolRevisionMutation = { __typename: 'Mutation', updateMoldToolRevision: { __typename: 'MoldTool', id: any, moldToolRevisionId: any, name: string, toolLife: number | null, moldToolRevision: { __typename: 'MoldToolRevision', gateType: string | null, processId: string | null } } | null };

export type DestroyMoldToolRevisionToQmrAssociationMutationVariables = Exact<{
  moldToolRevisionId: Scalars['UUID'];
  quoteModelRevisionId: Scalars['UUID'];
}>;


export type DestroyMoldToolRevisionToQmrAssociationMutation = { __typename: 'Mutation', destroyMoldToolRevisionToQMRAssociation: { __typename: 'MoldTool', id: any, name: string } | null };

export type UpdateMoldToolRevisionToQmrAssociationMutationVariables = Exact<{
  moldToolRevisionId: Scalars['UUID'];
  cavityPerQmr: Array<InputMaybe<UpdateQmrAssociationInput>> | InputMaybe<UpdateQmrAssociationInput>;
}>;


export type UpdateMoldToolRevisionToQmrAssociationMutation = { __typename: 'Mutation', updateMoldToolRevisionToQMRAssociation: { __typename: 'MoldTool', id: any, name: string } | null };

export type UpdateMoldToolInspectionOverrideDataMutationVariables = Exact<{
  moldRevisionId: Scalars['UUID'];
  moldToolOverrideData: InputMaybe<MoldToolOverrideInput>;
}>;


export type UpdateMoldToolInspectionOverrideDataMutation = { __typename: 'Mutation', updateMoldToolInspectionOverrideData: { __typename: 'MoldTool', manualOverrideMpUnitPayout: number | null, manualOverrideUnitAmount: number | null } | null };

export type CreateMoldToolRevisionMutationVariables = Exact<{
  moldToolRevisionId: Scalars['String'];
  quoteId: Scalars['String'];
}>;


export type CreateMoldToolRevisionMutation = { __typename: 'Mutation', createMoldToolRevision: { __typename: 'MoldTool', id: any, name: string, moldToolRevisionId: any, inspectionData: any | null, uiIndex: number, moldToolRevision: { __typename: 'MoldToolRevision', id: any, version: number, processId: string | null }, quoteModelRevisions: Array<{ __typename: 'QuoteModelRevision', id: any, fileName: string, version: string, partRevision: { __typename: 'Revision', thumbnailUri: string | null } }>, moldToolRevisionQmr: Array<{ __typename: 'MoldToolRevisionQmr', id: any, moldToolRevisionId: any, quoteModelRevisionId: string, cavityPerPart: number | null }> } | null };

export type DestroyMoldToolRevisionAssociationMutationVariables = Exact<{
  moldToolRevisionId: Scalars['UUID'];
}>;


export type DestroyMoldToolRevisionAssociationMutation = { __typename: 'Mutation', destroyMoldToolRevisionAssociations: Array<{ __typename: 'MoldToolRevisionQmr', id: any } | null> | null };

export type UpdateMoldRepairQuoteMutationVariables = Exact<{
  updateQuoteId: Scalars['UUID'];
  input: QuoteInput;
}>;


export type UpdateMoldRepairQuoteMutation = { __typename: 'Mutation', updateQuote: { __typename: 'Quote', isMoldRepair: boolean | null } };

export type AdminQuoteDetailsModelConfigurationFragment = { __typename: 'ModelConfiguration', id: any, materialGrade: string | null, colorCode: string | null, textureCode: string | null, quantity: number | null, requiresOvermold: boolean, additionalRequirements: string | null, userNeedsConfigHelp: boolean, fdmInfillPercentageCategory: string | null, fdmInfillPercentageCategoryLabel: string | null, dfmInspection: { __typename: 'ModelConfigurationDfmInspection', id: any | null, manualOverrideMpUnitPayout: number | null, manualOverrideUnitAmount: number | null, manualOverrideUnitProductionDays: number | null, inspectionData: any } | null, process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string } | null, material: { __typename: 'Material', id: string, name: string } | { __typename: 'UserEnteredMaterial', id: string, name: string, process: { __typename: 'Process', id: string, name: string } } | null, color: { __typename: 'Color', id: string, name: string } | null, shore: { __typename: 'Shore', id: string, name: string } | null, texture: { __typename: 'Texture', id: string, name: string } | null, productionLeadTime: { __typename: 'ProductionLeadTime', id: string, priorityId: string, productionDays: number, shipDateEstimate: { __typename: 'ShipDateEstimate', id: string, validUntilDate: any, shippedByDate: any } } | null };

export type ReleaseDfmReportsMutationVariables = Exact<{
  quoteId: Scalars['UUID'];
  orderId: InputMaybe<Scalars['String']>;
  skipDfmEmail: InputMaybe<Scalars['Boolean']>;
  emailInput: InputMaybe<QuoteReadyEmailInput>;
}>;


export type ReleaseDfmReportsMutation = { __typename: 'Mutation', releaseDfmReports: { __typename: 'Quote', id: any } };

export type PublishDfmAndInspectionDataForQuoteMutationVariables = Exact<{
  quoteId: Scalars['UUID'];
  skipEmails: InputMaybe<Scalars['Boolean']>;
  emailInput: InputMaybe<QuoteReadyEmailInput>;
}>;


export type PublishDfmAndInspectionDataForQuoteMutation = { __typename: 'Mutation', publishDfmAndInspectionDataForQuote: { __typename: 'Quote', id: any, name: string, status: string, user: { __typename: 'BasicUser', id: number, email: any, displayName: string }, quoteModels: { __typename: 'PartialQuoteModelResults', totalCount: number, items: Array<{ __typename: 'QuoteModel', id: any, selectedQuoteModelRevision: { __typename: 'QuoteModelRevision', id: any, version: string, state: QuoteModelRevisionState, fileName: string, createdAt: any, updatedAt: any, partRevision: { __typename: 'Revision', id: any, thumbnailUri: string | null, downloadUri: string | null, status: string | null, modelFileName: string | null, analysisErrorCode: string | null, boundingBox: { __typename: 'Vector3', x: number, y: number, z: number } | null }, attachmentLink: { __typename: 'QuoteModelRevisionAttachment', id: any, quoteAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, uploadUrl: string | null, downloadUrl: string | null, fileName: string, extension: string | null, mimeType: string | null, sizeInKb: number | null, createdAt: any, user: { __typename: 'BasicUser', id: number, email: any, firstName: string | null, lastName: string | null }, sanitized: { __typename: 'SanitizedAttachment', id: any, uploadUrl: string | null, downloadUrl: string | null, fileName: string, extension: string | null, mimeType: string | null, sizeInKb: number | null, createdAt: any, updatedAt: any, deletedAt: any | null } | null } | null } } | null, annotations: Array<{ __typename: 'Annotation', id: any }>, modelConfiguration: { __typename: 'ModelConfiguration', id: any, materialGrade: string | null, colorCode: string | null, textureCode: string | null, quantity: number | null, requiresOvermold: boolean, additionalRequirements: string | null, userNeedsConfigHelp: boolean, fdmInfillPercentageCategory: string | null, fdmInfillPercentageCategoryLabel: string | null, dfmInspection: { __typename: 'ModelConfigurationDfmInspection', id: any | null, manualOverrideMpUnitPayout: number | null, manualOverrideUnitAmount: number | null, manualOverrideUnitProductionDays: number | null, inspectionData: any } | null, process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string } | null, material: { __typename: 'Material', id: string, name: string } | { __typename: 'UserEnteredMaterial', id: string, name: string, process: { __typename: 'Process', id: string, name: string } } | null, color: { __typename: 'Color', id: string, name: string } | null, shore: { __typename: 'Shore', id: string, name: string } | null, texture: { __typename: 'Texture', id: string, name: string } | null, productionLeadTime: { __typename: 'ProductionLeadTime', id: string, priorityId: string, productionDays: number, shipDateEstimate: { __typename: 'ShipDateEstimate', id: string, validUntilDate: any, shippedByDate: any } } | null } | null } }> }, quoteAttachments: { __typename: 'PartialQuoteAttachmentResults', totalCount: number, items: Array<{ __typename: 'QuoteAttachment', id: any, latestAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string, downloadUrl: string | null } | null } }> } } };

export type UpdateNotesToCustomerMutationMutationVariables = Exact<{
  quoteId: Scalars['UUID'];
  notes: InputMaybe<Scalars['String']>;
}>;


export type UpdateNotesToCustomerMutationMutation = { __typename: 'Mutation', updateNotesToCustomer: { __typename: 'Quote', id: any, notesToCustomer: string | null } };

export type UpdateSalesRepContactInfoMutationMutationVariables = Exact<{
  quoteId: Scalars['UUID'];
  email: InputMaybe<Scalars['String']>;
}>;


export type UpdateSalesRepContactInfoMutationMutation = { __typename: 'Mutation', upsertQuoteSalesRep: { __typename: 'Quote', id: any, salesRep: { __typename: 'User', id: number, email: any, phoneNumber: string | null, displayName: string } | null } };

export type CreateMoldToolByQmrIdMutationVariables = Exact<{
  qmrId: Scalars['UUID'];
  isImMaafcoEnabled: Scalars['Boolean'];
}>;


export type CreateMoldToolByQmrIdMutation = { __typename: 'Mutation', createMoldTool: { __typename: 'MoldTool', id: any, moldToolRevision?: { __typename: 'MoldToolRevision', id: any, processId: string | null } } | null };

export type CreateQuoteDetailCsvFileMutationVariables = Exact<{
  quoteId: Scalars['UUID'];
  fileName: Scalars['String'];
}>;


export type CreateQuoteDetailCsvFileMutation = { __typename: 'Mutation', createQuoteDetailCSVFile: string };

export type OverrideDfmInspectionPartPricingAndLeadtimeMutationVariables = Exact<{
  modelConfigurationDfmInspectionId: Scalars['UUID'];
  pricingLeadTimeInput: OverridePartPricingLeadtimeInput;
}>;


export type OverrideDfmInspectionPartPricingAndLeadtimeMutation = { __typename: 'Mutation', overrideDfmInspectionPartPricingAndLeadtime: { __typename: 'ModelConfigurationDfmInspection', manualOverrideMpUnitPayout: number | null } };

export type CreateErpMoldToolModelConfigurationDfmAssociationMutationVariables = Exact<{
  erpMoldId: Scalars['String'];
  modelConfigurationDfmInspectionId: Scalars['UUID'];
}>;


export type CreateErpMoldToolModelConfigurationDfmAssociationMutation = { __typename: 'Mutation', createErpMoldToolModelConfigurationDfmAssociation: { __typename: 'QuoteModelRevision', id: any } };

export type DeleteErpMoldToolAssciationIdMutationVariables = Exact<{
  modelConfigurationDfmInspectionId: Scalars['UUID'];
}>;


export type DeleteErpMoldToolAssciationIdMutation = { __typename: 'Mutation', destroyERPMoldToolAssociation: { __typename: 'QuoteModelRevision', deletedAt: any | null } | null };

export type AdminQuoteDetailsQueryQueryVariables = Exact<{
  id: Scalars['UUID'];
  showDeleted: InputMaybe<Scalars['Boolean']>;
  includeUnpublishedParts: InputMaybe<Scalars['Boolean']>;
  isImMaafcoEnabled?: InputMaybe<Scalars['Boolean']>;
  isCpqFlagV2Enabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type AdminQuoteDetailsQueryQuery = { __typename: 'Query', quote: { __typename: 'Quote', hasITARRestrictions: boolean | null, isEligibleForFreeShipping: boolean | null, id: any, name: string, type: QuoteType, status: string, summaryStatus: string, orderName: string | null, slowestShipDateEstimate: any | null, isOverseasShipping: boolean, lastModified: any | null, subTotalInCents: number | null, isQuotePurchasable: boolean, isQuotePublishable: boolean | null, isQuoteIMReorder?: boolean, isMoldRepair: boolean | null, isLocked: boolean | null, isCpqOwned: boolean | null, rfqNotes: string | null, notesToCustomer: string | null, contactPhoneNumber: string | null, isFlexiblePriceQuote: boolean, isCpqQuote?: boolean | null, sfdcUrl?: string | null, sourceQuoteId: any | null, sourceQuoteName: string | null, reorderSourceOrderName: string | null, cpqQuote?: { __typename: 'CpqQuote', sfdcId: any, quotePdfUrl: string, orderTotal: number, partsCount: number, moldCount: number, orderQuantity: number, platformQuote: { __typename: 'Quote', id: any } } | null, businessAccountDiscount: { __typename: 'BusinessAccountDiscount', id: number, percent: number } | null, dfmAssets: { __typename: 'PartialAssetResults', totalCount: number, items: Array<{ __typename: 'Asset', id: any, fileName: string, downloadUrl: string | null }> }, user: { __typename: 'BasicUser', id: number, email: any, displayName: string }, salesRep: { __typename: 'User', id: number, email: any, phoneNumber: string | null, displayName: string } | null, activity: { __typename: 'PartialProjectActivityResults', items: Array<{ __typename: 'ProjectActivity', id: any, activityType: string, updatedAt: any, actor: { __typename: 'BasicUser', email: any } | null }> }, quoteModels: { __typename: 'PartialQuoteModelResults', totalCount: number, items: Array<{ __typename: 'QuoteModel', id: any, deletedAt: any | null, selectedQuoteModelRevision: { __typename: 'QuoteModelRevision', isITARProhibitedViewing: boolean | null, id: any, version: string, flags: Array<QmrFlag | null> | null, fileName: string, createdAt: any, updatedAt: any, state: QuoteModelRevisionState, drawingRequirements: Array<string>, dfmReports: Array<{ __typename: 'PartDfmReport', isPublished: boolean, asset: { __typename: 'Asset', id: any, createdAt: any, downloadUrl: string | null, fileName: string } | null }>, partRevision: { __typename: 'Revision', id: any, thumbnailUri: string | null, downloadUri: string | null, status: string | null, modelFileName: string | null, analysisErrorCode: string | null, boundingBox: { __typename: 'Vector3', x: number, y: number, z: number } | null }, erpMoldTool: { __typename: 'ErpMoldTool', id: any, erpMoldId: string } | null, attachmentLink: { __typename: 'QuoteModelRevisionAttachment', id: any, createdAt: any, isPdfOcrAutoQuotable: boolean | null, quoteAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, uploadUrl: string | null, downloadUrl: string | null, fileName: string, extension: string | null, mimeType: string | null, sizeInKb: number | null, createdAt: any, user: { __typename: 'BasicUser', id: number, email: any, firstName: string | null, lastName: string | null }, sanitized: { __typename: 'SanitizedAttachment', id: any, uploadUrl: string | null, downloadUrl: string | null, fileName: string, extension: string | null, mimeType: string | null, sizeInKb: number | null, createdAt: any, updatedAt: any, deletedAt: any | null } | null } | null } } | null, quoteModel: { __typename: 'QuoteModel', id: any, quote: { __typename: 'Quote', id: any, type: QuoteType } | null }, annotations: Array<{ __typename: 'Annotation', id: any }>, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, severity: string, isPublished: boolean }>, processesDetails: { __typename: 'QmrProcessesDetails', isBusinessAccountDiscountApplied: boolean | null, postProcesses: Array<{ __typename: 'QmrPostProcessWithPriceAndLead', postProcessNumParts: number | null, postProcessInspectionCriteria: ProcessInspectionCriteria | null, postProcess: { __typename: 'PostProcess', id: string, name: string }, postProcessThickness: { __typename: 'Thickness', id: string, name: string } | null, postProcessColor: { __typename: 'Color', id: string, name: string } | null }>, secondaryProcesses: Array<{ __typename: 'QmrSecondaryProcessDetails', process: { __typename: 'PostProcess', id: string, name: string } }>, totalPrice: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', unitPriceInCents: number | null, priceInCents: number | null } | null } | null, modelConfiguration: { __typename: 'ModelConfiguration', id: any, materialGrade: string | null, colorCode: string | null, textureCode: string | null, quantity: number | null, requiresOvermold: boolean, additionalRequirements: string | null, userNeedsConfigHelp: boolean, fdmInfillPercentageCategory: string | null, fdmInfillPercentageCategoryLabel: string | null, dfmInspection: { __typename: 'ModelConfigurationDfmInspection', id: any | null, manualOverrideMpUnitPayout: number | null, manualOverrideUnitAmount: number | null, manualOverrideUnitProductionDays: number | null, inspectionData: any } | null, process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string } | null, material: { __typename: 'Material', id: string, name: string } | { __typename: 'UserEnteredMaterial', id: string, name: string, process: { __typename: 'Process', id: string, name: string } } | null, color: { __typename: 'Color', id: string, name: string } | null, shore: { __typename: 'Shore', id: string, name: string } | null, texture: { __typename: 'Texture', id: string, name: string } | null, productionLeadTime: { __typename: 'ProductionLeadTime', id: string, priorityId: string, productionDays: number, shipDateEstimate: { __typename: 'ShipDateEstimate', id: string, validUntilDate: any, shippedByDate: any } } | null } | null, taps: Array<{ __typename: 'TapAnnotation', id: any }>, holes: Array<{ __typename: 'Hole', id: string, tapAnnotation: { __typename: 'TapAnnotation', id: any } | null, tapOptions: Array<{ __typename: 'TapOption', id: string }> }>, mold: { __typename: 'MoldTool', id: any, name?: string, customerToolName?: string | null, gateType: string | null, leadTimeDays: number | null, inspectionData: any | null, manualOverrideMpUnitPayout: number | null, manualOverrideUnitAmount: number | null, toolLife: number | null, uiIndex: number, moldToolRevision?: { __typename: 'MoldToolRevision', id: any, version: number, processId: string | null }, quoteModelRevisions?: Array<{ __typename: 'QuoteModelRevision', fileName: string, id: any, version: string }>, moldToolRevisionQmr?: Array<{ __typename: 'MoldToolRevisionQmr', id: any, moldToolRevisionId: any, quoteModelRevisionId: string, cavityPerPart: number | null }>, material: { __typename: 'Material', id: string, name: string } | null, price: { __typename: 'ExactPrice', priceInCents: number | null } | null } | null } }> }, quoteAttachments: { __typename: 'PartialQuoteAttachmentResults', totalCount: number, items: Array<{ __typename: 'QuoteAttachment', id: any, latestAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string, downloadUrl: string | null } | null } }> }, quoteProperties: Array<{ __typename: 'QuoteProperty', name: string, value: string }> | null } | null };

export type AdminQuoteDetailsPageOrderQueryQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type AdminQuoteDetailsPageOrderQueryQuery = { __typename: 'Query', salesOrder: { __typename: 'SalesOrder', id: string, deliveryStatus: string, shippedBy: any | null } | null };

export type DeleteQuoteMoldMutationVariables = Exact<{
  moldId: Scalars['UUID'];
}>;


export type DeleteQuoteMoldMutation = { __typename: 'Mutation', deleteQuoteMold: { __typename: 'Quote', id: any, name: string } };

export type ListErpMoldsForQuoteOwnerQueryVariables = Exact<{
  quoteId: Scalars['UUID'];
  isImMaafcoEnabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type ListErpMoldsForQuoteOwnerQuery = { __typename: 'Query', listErpMoldsForQuoteOwner: Array<{ __typename: 'ErpMoldTool', id: any, erpMoldId: string, platformMoldToolRevisionId?: string | null, processId: string | null }> | null };

export type GetToolAndPartEstimatedPricesQueryVariables = Exact<{
  qmrIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetToolAndPartEstimatedPricesQuery = { __typename: 'Query', getToolAndPartEstimatedPrices: Array<{ __typename: 'ToolAndPartEstimatedPrices', qmrId: string, partPrice: { __typename: 'EstimatedPrice', lowUnitPriceInCents: number | null, highUnitPriceInCents: number | null } | null, toolingPrice: { __typename: 'EstimatedPrice', lowUnitPriceInCents: number | null, highUnitPriceInCents: number | null } | null }> };

export type QuoteModelRevisionQueryVariables = Exact<{
  quoteModelRevisionId: Scalars['UUID'];
}>;


export type QuoteModelRevisionQuery = { __typename: 'Query', quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, erpMoldTool: { __typename: 'ErpMoldTool', id: any, erpMoldId: string } | null } | null };

export type GetMoldbyMtrQueryVariables = Exact<{
  moldToolRevisionId: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  quoteId: Scalars['UUID'];
}>;


export type GetMoldbyMtrQuery = { __typename: 'Query', getMoldToolRevision: Array<{ __typename: 'MoldTool', id: any, name: string, leadTimeDays: number | null, toolLife: number | null, gateType: string | null, inspectionData: any | null, manualOverrideMpUnitPayout: number | null, manualOverrideUnitAmount: number | null, ownerId: number | null, uiIndex: number, material: { __typename: 'Material', id: string, materialCategory: string | null, name: string, processTechnologyId: string | null, processTechnologyName: string | null } | null, price: { __typename: 'ExactPrice', priceInCents: number | null } | null, moldToolRevision: { __typename: 'MoldToolRevision', id: any, version: number, processId: string | null }, quoteModelRevisions: Array<{ __typename: 'QuoteModelRevision', id: any, fileName: string, version: string, partRevision: { __typename: 'Revision', thumbnailUri: string | null } }>, moldToolRevisionQmr: Array<{ __typename: 'MoldToolRevisionQmr', id: any, cavityPerPart: number | null, quoteModelRevisionId: string, moldToolRevisionId: any }> } | null> | null };

export type SetQuotePropertyMutationVariables = Exact<{
  quoteId: Scalars['UUID'];
  name: Scalars['String'];
  value: Scalars['String'];
}>;


export type SetQuotePropertyMutation = { __typename: 'Mutation', setQuoteProperty: { __typename: 'QuoteProperty', name: string } };

export type DeleteQuotePropertyMutationVariables = Exact<{
  quoteId: Scalars['UUID'];
  name: Scalars['String'];
}>;


export type DeleteQuotePropertyMutation = { __typename: 'Mutation', deleteQuoteProperty: { __typename: 'QuoteProperty', name: string } | null };

export type UpdateQuoteMutationMutationVariables = Exact<{
  quoteId: Scalars['UUID'];
  input: InputMaybe<Scalars['String']>;
}>;


export type UpdateQuoteMutationMutation = { __typename: 'Mutation', updateQuote: { __typename: 'Quote', rfqNotes: string | null } };

export type UnlockQuoteMutationVariables = Exact<{
  unlockQuoteId: Scalars['UUID'];
}>;


export type UnlockQuoteMutation = { __typename: 'Mutation', unlockQuote: { __typename: 'Quote', id: any, isLocked: boolean | null } };

export type LockQuoteMutationVariables = Exact<{
  lockQuoteId: Scalars['UUID'];
}>;


export type LockQuoteMutation = { __typename: 'Mutation', lockQuote: { __typename: 'Quote', id: any, isCpqOwned: boolean | null, isLocked: boolean | null } };

export type UpdateSlideSortOrderMutationVariables = Exact<{
  dfmFeedbackId: Scalars['UUID'];
  ordinalPos: Scalars['Int'];
}>;


export type UpdateSlideSortOrderMutation = { __typename: 'Mutation', updateDfmFeedbackSortOrder: { __typename: 'DfmFeedback', id: any } };

export type GeneratePdfFor3dDfmMutationVariables = Exact<{
  assetId: Scalars['UUID'];
  feedbackId: Scalars['UUID'];
}>;


export type GeneratePdfFor3dDfmMutation = { __typename: 'Mutation', generatePdfFor3dDfm: { __typename: 'DfmSlideReadyStatus', error: string | null, feedbackId: any, loading: boolean, signedUrl: string | null } };

export type DfmFeedbackAttachmentQueryVariables = Exact<{
  dfmFeedbackId: Scalars['UUID'];
}>;


export type DfmFeedbackAttachmentQuery = { __typename: 'Query', dfmFeedback: { __typename: 'DfmFeedback', id: any, attachment: { __typename: 'Asset', id: any } | null } | null };

export type DfmStatusesQueryVariables = Exact<{
  quoteType: InputMaybe<QuoteType>;
}>;


export type DfmStatusesQuery = { __typename: 'Query', dfmStatuses: Array<string> };

export type DfmFeedbackTopicsQueryVariables = Exact<{ [key: string]: never; }>;


export type DfmFeedbackTopicsQuery = { __typename: 'Query', dfmFeedbackTopics: Array<{ __typename: 'Topic', id: any, label: string }> | null };

export type UpdateImDfmFeedbackInfoMutationVariables = Exact<{
  dfmFeedbackId: Scalars['UUID'];
  topicId: InputMaybe<Scalars['String']>;
  status: InputMaybe<Scalars['String']>;
  title: InputMaybe<Scalars['String']>;
}>;


export type UpdateImDfmFeedbackInfoMutation = { __typename: 'Mutation', updateDfmFeedbackInfo: { __typename: 'DfmFeedback', id: any, status: string | null, title: string | null, updatedAt: any, topic: { __typename: 'Topic', id: any, label: string } | null, updatedBy: { __typename: 'BasicUser', id: number, email: any } } };

export type ImDfmFeedbackUpdateRefetchQueryQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ImDfmFeedbackUpdateRefetchQueryQuery = { __typename: 'Query', quoteModelRevision: { __typename: 'QuoteModelRevision', dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any }> } | null };

export type CreateAssetMutationVariables = Exact<{
  fileName: Scalars['String'];
}>;


export type CreateAssetMutation = { __typename: 'Mutation', createAsset: { __typename: 'Asset', id: any, uploadUrl: string | null } };

export type CreateDfmFeedbackWithSnapshotMutationVariables = Exact<{
  modelConfigurationId: Scalars['UUID'];
  dfmInput: DfmFeedbackWithSnapshotInput;
}>;


export type CreateDfmFeedbackWithSnapshotMutation = { __typename: 'Mutation', createDfmFeedbackWithSnapshot: { __typename: 'DfmSlideReadyStatus', error: string | null, feedbackId: any, loading: boolean, signedUrl: string | null } };

export type ModelConfigurationIdActiveUnsaved3dSlideQueryVariables = Exact<{
  qmrId: Scalars['UUID'];
  showDeleted: InputMaybe<Scalars['Boolean']>;
}>;


export type ModelConfigurationIdActiveUnsaved3dSlideQuery = { __typename: 'Query', quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, modelConfiguration: { __typename: 'ModelConfiguration', id: any } | null } | null };

export type DfmFeedbackMessagesQueryVariables = Exact<{
  platformProcessId: InputMaybe<Scalars['String']>;
  type: InputMaybe<DfmFeedbackMessageType>;
  topicId: InputMaybe<Scalars['UUID']>;
}>;


export type DfmFeedbackMessagesQuery = { __typename: 'Query', dfmFeedbackMessages: Array<{ __typename: 'DfmFeedbackMessage', id: any, message: string, title: string }> | null };

export type DestroyDfmFeedbackImDfmSlideMutationVariables = Exact<{
  dfmFeedbackId: Scalars['UUID'];
}>;


export type DestroyDfmFeedbackImDfmSlideMutation = { __typename: 'Mutation', destroyDfmFeedback: { __typename: 'DfmFeedback', id: any } };

export type GetAttachmentAnnotationIdsImDfmModalQueryVariables = Exact<{
  attachmentId: Scalars['UUID'];
  quoteModelRevisionId: InputMaybe<Scalars['UUID']>;
}>;


export type GetAttachmentAnnotationIdsImDfmModalQuery = { __typename: 'Query', getQmrAttachmentAnnotations: { __typename: 'QmrAttachmentAnnotations', id: any } | null };

export type ImDfmFeedbackQueryVariables = Exact<{
  qmrId: Scalars['UUID'];
}>;


export type ImDfmFeedbackQuery = { __typename: 'Query', quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, createdAt: any, isPublished: boolean, message: string, sourceType: string | null, status: string | null, updatedAt: any, isAutoGeneratedDfm: boolean, title: string | null, updatedBy: { __typename: 'BasicUser', id: number, email: any }, topic: { __typename: 'Topic', id: any, label: string } | null, attachment: { __typename: 'Asset', id: any, fileName: string, downloadUrl: string | null } | null, acceptedBy: { __typename: 'BasicUser', id: number, email: any } | null }> } | null };

export type Is2dDfmSlideReadyQueryVariables = Exact<{
  dfmIds: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
}>;


export type Is2dDfmSlideReadyQuery = { __typename: 'Query', is2dDfmSlideReady: Array<{ __typename: 'DfmSlideReadyStatus', feedbackId: any, loading: boolean, error: string | null, signedUrl: string | null }> };

export type ImDfmFeedbackIdQueryVariables = Exact<{
  qmrId: Scalars['UUID'];
}>;


export type ImDfmFeedbackIdQuery = { __typename: 'Query', quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any }> } | null };

export type DfmReportsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DfmReportsQuery = { __typename: 'Query', quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, dfmReports: Array<{ __typename: 'PartDfmReport', isPublished: boolean }> } | null };

export type ImDfmFeedbackAttachmentQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ImDfmFeedbackAttachmentQuery = { __typename: 'Query', quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, attachment: { __typename: 'Asset', id: any, fileName: string, downloadUrl: string | null } | null }> } | null };

export type IsDfmLoadingQueryVariables = Exact<{
  qmrId: Scalars['UUID'];
}>;


export type IsDfmLoadingQuery = { __typename: 'Query', isDfmLoading: { __typename: 'DfmLoadingStatus', error: string | null, loading: boolean } };

export type UploadQmrDfmReportPdfMutationVariables = Exact<{
  qmrId: Scalars['UUID'];
  attachment: AttachmentInput;
}>;


export type UploadQmrDfmReportPdfMutation = { __typename: 'Mutation', uploadQmrDfmReportPdf: { __typename: 'DfmLoadingStatus', error: string | null, loading: boolean, uploadUrl: string | null } };

export type PullDirectionRawAnalysisQueryVariables = Exact<{
  qmrId: Scalars['UUID'];
}>;


export type PullDirectionRawAnalysisQuery = { __typename: 'Query', quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, partRevision: { __typename: 'Revision', id: any, rawAnalysis: any | null } } | null };

export type QuoteModelRevisionModelViewerPanelQueryVariables = Exact<{
  id: Scalars['UUID'];
  showDeleted: InputMaybe<Scalars['Boolean']>;
}>;


export type QuoteModelRevisionModelViewerPanelQuery = { __typename: 'Query', quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, holes: Array<{ __typename: 'Hole', id: string, groupKey: string, type: string, depth: number | null, diameter: number | null, isBlind: boolean | null, tipAngle: number | null, counterboreDepth: number | null, counterboreDiameter: number | null, countersinkAngle: number | null, countersinkDepth: number | null, countersinkDiameter: number | null, direction: any | null, endPoint: Array<number> | null, startPoint: Array<number> | null, patches: Array<{ __typename: 'RevisionPatch', id: string }>, tapOptions: Array<{ __typename: 'TapOption', id: string, maxDepth: number, commonName: string }>, tapAnnotation: { __typename: 'TapAnnotation', id: any, depth: number | null, tapOption: { __typename: 'TapOption', id: string, maxDepth: number, commonName: string } | null } | null }>, partRevision: { __typename: 'Revision', id: any, sceneBundle: any | null, rawAnalysis: any | null, modelFileName: string | null }, attachmentLink: { __typename: 'QuoteModelRevisionAttachment', id: any, quoteAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string } | null } } | null, processesDetails: { __typename: 'QmrProcessesDetails', primaryProcess: { __typename: 'QmrProcessWithPrice', process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string } } | null } | null } | null };

export type MarkUploadedAssetMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type MarkUploadedAssetMutation = { __typename: 'Mutation', markUploadedAsset: { __typename: 'Asset', id: any, downloadUrl: string | null } };

export type UpsertDfmAttachmentAnnotationsImDfmPdfViewerMutationVariables = Exact<{
  attachmentId: Scalars['UUID'];
  qmrAttachmentAnnotationsInput: DfmAttachmentAnnotationsInput;
}>;


export type UpsertDfmAttachmentAnnotationsImDfmPdfViewerMutation = { __typename: 'Mutation', upsertDfmAttachmentAnnotations: { __typename: 'QmrAttachmentAnnotations', id: any, annotationsDataDownloadUrl: string, attachmentId: any, createdAt: any, updatedAt: any, createdBy: { __typename: 'BasicUser', id: number, displayName: string }, updatedBy: { __typename: 'BasicUser', id: number, displayName: string } } };

export type CreateSanitizedAttachmentUploaderMutationVariables = Exact<{
  attachmentId: Scalars['UUID'];
  fileName: Scalars['String'];
  extension: InputMaybe<Scalars['String']>;
  mimeType: InputMaybe<Scalars['String']>;
  quoteModelRevisionId: InputMaybe<Scalars['UUID']>;
}>;


export type CreateSanitizedAttachmentUploaderMutation = { __typename: 'Mutation', createSanitizedAttachment: { __typename: 'SanitizedAttachment', id: any, uploadUrl: string | null, fileName: string } };

export type MarkUploadedSanitizedAttachmentMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type MarkUploadedSanitizedAttachmentMutation = { __typename: 'Mutation', markUploadedSanitizedAttachment: { __typename: 'SanitizedAttachment', id: any, downloadUrl: string | null, fileName: string } };

export type RemoveSanitizedAttachmentMutationVariables = Exact<{
  attachmentId: Scalars['UUID'];
}>;


export type RemoveSanitizedAttachmentMutation = { __typename: 'Mutation', removeSanitizedAttachment: { __typename: 'SanitizedAttachment', id: any, downloadUrl: string | null, fileName: string } };

export type AdminQuoteModelRevisionDataPartRevisionFragment = { __typename: 'Revision', id: any, modelFileName: string | null, downloadUri: string | null, cleanDownloadUri: string | null, thumbnailUri: string | null, sceneBundle: any | null, units: string | null, rawAnalysis: any | null, partId: number | null, updatedAt: any, boundingBox: { __typename: 'Vector3', x: number, y: number, z: number } | null };

export type AdminQuoteModelRevisionHoleFragment = { __typename: 'Hole', id: string, groupKey: string, type: string, depth: number | null, diameter: number | null, isBlind: boolean | null, tipAngle: number | null, counterboreDepth: number | null, counterboreDiameter: number | null, countersinkAngle: number | null, countersinkDepth: number | null, countersinkDiameter: number | null, direction: any | null, endPoint: Array<number> | null, startPoint: Array<number> | null, tapOptions: Array<{ __typename: 'TapOption', id: string, maxDepth: number, commonName: string }>, tapAnnotation: { __typename: 'TapAnnotation', id: any, depth: number | null, tapOption: { __typename: 'TapOption', id: string, maxDepth: number, commonName: string } | null } | null };

export type AdminQuoteModelRevisionSanitizedAttachmentFragment = { __typename: 'SanitizedAttachment', id: any, downloadUrl: string | null };

export type AdminQuoteModelRevisionGeneratedDrawingFragment = { __typename: 'GeneratedDrawing', id: any, attachment: { __typename: 'Attachment', id: any, downloadUrl: string | null } | null };

export type AdminQuoteModelRevisionQuoteModelQuoteUserFragment = { __typename: 'BasicUser', id: number, firstName: string | null, lastName: string | null, email: any };

export type AdminQuoteModelRevisionQuoteModelQuoteFragment = { __typename: 'Quote', id: any, name: string, status: string, isFlexiblePriceQuote: boolean, openEndedQuoteInviteUrl: string | null, isCpqOwned?: boolean | null, type: QuoteType, user: { __typename: 'BasicUser', id: number, firstName: string | null, lastName: string | null, email: any }, quoteModels: { __typename: 'PartialQuoteModelResults', items: Array<{ __typename: 'QuoteModel', id: any, selectedQuoteModelRevision: { __typename: 'QuoteModelRevision', processesDetails: { __typename: 'QmrProcessesDetails', totalPrice: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', unitPriceInCents: number | null, priceInCents: number | null } | null } | null }, quoteModelRevisions: Array<{ __typename: 'QuoteModelRevision', id: any, dfmFeedback: Array<{ __typename: 'DfmFeedback', isPublished: boolean }>, dfmReports: Array<{ __typename: 'PartDfmReport', isPublished: boolean, source: string | null, uploaderEmail: string | null, asset: { __typename: 'Asset', id: any, fileName: string, createdAt: any, downloadUrl: string | null } | null }>, partRevision: { __typename: 'Revision', modelFileName: string | null, thumbnailUri: string | null }, quoteModel: { __typename: 'QuoteModel', quote: { __typename: 'Quote', isQuotePurchasable: boolean } | null } }> }> }, quoteAttachments: { __typename: 'PartialQuoteAttachmentResults', items: Array<{ __typename: 'QuoteAttachment', id: any, latestAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, uploadUrl: string | null, downloadUrl: string | null, fileName: string, extension: string | null, mimeType: string | null, sizeInKb: number | null, createdAt: any, user: { __typename: 'BasicUser', id: number, email: any, firstName: string | null, lastName: string | null }, sanitized: { __typename: 'SanitizedAttachment', id: any, uploadUrl: string | null, downloadUrl: string | null, fileName: string, extension: string | null, mimeType: string | null, sizeInKb: number | null, createdAt: any, updatedAt: any, deletedAt: any | null } | null } | null } }> } };

export type AdminQuoteModelRevisionDfmReportFragment = { __typename: 'PartDfmReport', quoteAttachmentRevisionId: any, uploaderEmail: string | null, source: string | null, isPublished: boolean, asset: { __typename: 'Asset', id: any, createdAt: any, downloadUrl: string | null, fileName: string } | null };

export type AdminQuoteModelRevisionDataFragment = { __typename: 'QuoteModelRevision', id: any, isITARProhibitedViewing: boolean | null, isExclusiveToSingleQuote: boolean | null, canBeExclusiveToSingleQuote: boolean | null, fileName: string, version: string, updatedAt: any, flags: Array<QmrFlag | null> | null, state: QuoteModelRevisionState, sourceQuoteModelRevisionId: any | null, quantityRangeStatus: string | null, supportedPriorityRegions: { __typename: 'SupportedPriorityRegions', partSupportsDomestic: boolean, partSupportsInternational: boolean }, dfmReports: Array<{ __typename: 'PartDfmReport', quoteAttachmentRevisionId: any, uploaderEmail: string | null, source: string | null, isPublished: boolean, asset: { __typename: 'Asset', id: any, createdAt: any, downloadUrl: string | null, fileName: string } | null }>, quoteModel: { __typename: 'QuoteModel', id: any, quote: { __typename: 'Quote', id: any, name: string, status: string, isFlexiblePriceQuote: boolean, openEndedQuoteInviteUrl: string | null, isCpqOwned?: boolean | null, type: QuoteType, user: { __typename: 'BasicUser', id: number, firstName: string | null, lastName: string | null, email: any }, quoteModels: { __typename: 'PartialQuoteModelResults', items: Array<{ __typename: 'QuoteModel', id: any, selectedQuoteModelRevision: { __typename: 'QuoteModelRevision', processesDetails: { __typename: 'QmrProcessesDetails', totalPrice: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', unitPriceInCents: number | null, priceInCents: number | null } | null } | null }, quoteModelRevisions: Array<{ __typename: 'QuoteModelRevision', id: any, dfmFeedback: Array<{ __typename: 'DfmFeedback', isPublished: boolean }>, dfmReports: Array<{ __typename: 'PartDfmReport', isPublished: boolean, source: string | null, uploaderEmail: string | null, asset: { __typename: 'Asset', id: any, fileName: string, createdAt: any, downloadUrl: string | null } | null }>, partRevision: { __typename: 'Revision', modelFileName: string | null, thumbnailUri: string | null }, quoteModel: { __typename: 'QuoteModel', quote: { __typename: 'Quote', isQuotePurchasable: boolean } | null } }> }> }, quoteAttachments: { __typename: 'PartialQuoteAttachmentResults', items: Array<{ __typename: 'QuoteAttachment', id: any, latestAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, uploadUrl: string | null, downloadUrl: string | null, fileName: string, extension: string | null, mimeType: string | null, sizeInKb: number | null, createdAt: any, user: { __typename: 'BasicUser', id: number, email: any, firstName: string | null, lastName: string | null }, sanitized: { __typename: 'SanitizedAttachment', id: any, uploadUrl: string | null, downloadUrl: string | null, fileName: string, extension: string | null, mimeType: string | null, sizeInKb: number | null, createdAt: any, updatedAt: any, deletedAt: any | null } | null } | null } }> } } | null }, annotations: Array<{ __typename: 'Annotation', id: any }>, manufacturingDrawing: { __typename: 'GeneratedDrawing', id: any, attachment: { __typename: 'Attachment', id: any, downloadUrl: string | null } | null } | { __typename: 'SanitizedAttachment', id: any, downloadUrl: string | null } | null, attachmentLink: { __typename: 'QuoteModelRevisionAttachment', id: any, createdAt: any, isPdfOcrAutoQuotable: boolean | null, quoteAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, quoteAttachment: { __typename: 'QuoteAttachment', id: any }, attachment: { __typename: 'Attachment', id: any, fileName: string, downloadUrl: string | null, sanitized: { __typename: 'SanitizedAttachment', id: any, downloadUrl: string | null, fileName: string } | null, annotated: { __typename: 'AnnotatedAttachment', id: any, downloadUrl: string | null, fileName: string } | null } | null } } | null, holes: Array<{ __typename: 'Hole', id: string, groupKey: string, type: string, depth: number | null, diameter: number | null, isBlind: boolean | null, tipAngle: number | null, counterboreDepth: number | null, counterboreDiameter: number | null, countersinkAngle: number | null, countersinkDepth: number | null, countersinkDiameter: number | null, direction: any | null, endPoint: Array<number> | null, startPoint: Array<number> | null, tapOptions: Array<{ __typename: 'TapOption', id: string, maxDepth: number, commonName: string }>, tapAnnotation: { __typename: 'TapAnnotation', id: any, depth: number | null, tapOption: { __typename: 'TapOption', id: string, maxDepth: number, commonName: string } | null } | null }>, taps: Array<{ __typename: 'TapAnnotation', id: any }>, partRevision: { __typename: 'Revision', id: any, modelFileName: string | null, downloadUri: string | null, cleanDownloadUri: string | null, thumbnailUri: string | null, sceneBundle: any | null, units: string | null, rawAnalysis: any | null, partId: number | null, updatedAt: any, boundingBox: { __typename: 'Vector3', x: number, y: number, z: number } | null }, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, isValid: boolean, message: string, title: string | null, link: string | null, code: string | null, isPublished: boolean, severity: string, sourceType: string | null, isAutoGeneratedDfm: boolean, createdAt: any, deletedAt: any | null, createdBy: { __typename: 'BasicUser', displayName: string, email: any }, modelViewerSnapshots: Array<{ __typename: 'ModelViewerSnapshot', id: any, snapshot: { __typename: 'ModelViewerConfig', rotation: Array<number> | null, camera: { __typename: 'ModelViewerCameraConfig', position: Array<number>, zoom: number, up: Array<number> | null, target: Array<number> | null } | null, part: { __typename: 'ModelViewerPartConfig', transparent: boolean, patches: Array<{ __typename: 'ModelViewerPatchConfig', color: string | null, hashcode: string }> }, dfm: Array<{ __typename: 'ModelViewerDfmFeatureConfig', color: string | null, threshold: number | null, feature: string | null, direction: Array<number> | null }>, annotations: Array<{ __typename: 'ModelViewerAnnotationConfig', position: Array<number> }>, crossSection: { __typename: 'ModelViewerCrossSectionConfig', position: any, rotation: any } | null, pointToPoint: { __typename: 'PointToPointConfig', customPoints: Array<any>, selectedPoints: Array<{ __typename: 'P2PPoint', index: number, type: P2PPointType }> } | null } | null }> }>, processesDetails: { __typename: 'QmrProcessesDetails', isBusinessAccountDiscountApplied: boolean | null, totalPrice: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null, primaryProcess: { __typename: 'QmrProcessWithPrice', process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string }, price: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null } | null, postProcesses: Array<{ __typename: 'QmrPostProcessWithPriceAndLead', unitPriceInCents: number | null, postProcessLeadTimeInDays: number | null, postProcessNumParts: number | null, postProcessInspectionCriteria: ProcessInspectionCriteria | null, postProcess: { __typename: 'PostProcess', id: string, name: string, typeName: string | null, colors: Array<{ __typename: 'Color', id: string, name: string } | null> | null, thicknesses: Array<{ __typename: 'Thickness', id: string, name: string, value: number } | null> | null }, postProcessThickness: { __typename: 'Thickness', id: string, name: string } | null, postProcessColor: { __typename: 'Color', id: string, name: string } | null }>, secondaryProcesses: Array<{ __typename: 'QmrSecondaryProcessDetails', unitPriceInCents: number | null, leadTimeInDays: number | null, notes: string | null, process: { __typename: 'PostProcess', id: string, name: string, typeName: string | null }, pricingAndLeadTimeFields: { __typename: 'HardwareInstallationManualQuoteCalcFields', international: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', markupPercentage: number, mpPayoutInCents: number | null, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, domestic: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', mpPayoutInCents: number | null, markupPercentage: number, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, lineItems: Array<{ __typename: 'HardwareLineItem', supplier: string | null, partNumber: string | null, qtyPerPart: number, pricePerPack: number, qtyPerPack: number }> | null } | { __typename: 'SecondaryProcessManualQuoteCalcFields', international: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', markupPercentage: number, mpPayoutInCents: number | null, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, domestic: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', mpPayoutInCents: number | null, markupPercentage: number, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null } | null }> } | null, modelConfiguration: { __typename: 'ModelConfiguration', id: any, requiresOvermold: boolean, additionalRequirements: string | null, materialGrade: string | null, colorCode: string | null, textureCode: string | null, quantity: number | null, errorCode: string | null, updatedAt: any, dfmInspections: Array<{ __typename: 'ModelConfigurationDfmInspection', id: any | null, inspectionData: any, quantityLowerRange: number | null, quantityUpperRange: number | null, isQuantityRangeAvailable: boolean | null, isPublished: boolean, manualOverrideMpUnitPayout: number | null, manualOverrideUnitAmount: number | null, quotedAt: any | null, quoteUpdatedAt: any | null, updatedAt: any, quotedBy: { __typename: 'BasicUser', id: number, displayName: string } | null, quoteUpdatedBy: { __typename: 'BasicUser', id: number, displayName: string } | null } | null> | null, dfmInspection: { __typename: 'ModelConfigurationDfmInspection', id: any | null, inspectionData: any, isPublished: boolean, quotedAt: any | null, quoteUpdatedAt: any | null, updatedAt: any, manualOverrideMpUnitPayout: number | null, manualOverrideUnitAmount: number | null, quotedBy: { __typename: 'BasicUser', id: number, displayName: string } | null, quoteUpdatedBy: { __typename: 'BasicUser', id: number, displayName: string } | null } | null, productionLeadTime: { __typename: 'ProductionLeadTime', id: string, priorityId: string, productionDays: number, primaryProductionDays: number, shipDateEstimate: { __typename: 'ShipDateEstimate', id: string, validUntilDate: any, shippedByDate: any } } | null, process: { __typename: 'Process', id: string, name: string } | null, material: { __typename: 'Material', id: string, name: string } | { __typename: 'UserEnteredMaterial', id: string, name: string } | null, color: { __typename: 'Color', id: string, name: string } | null, texture: { __typename: 'Texture', id: string, name: string } | null, updatedBy: { __typename: 'BasicUser', id: number, email: any, updatedAt: any }, toolDetails: { __typename: 'ToolCosts', totalCost: number | null, tools: Array<{ __typename: 'Tool', id: string, type: string, diameter: number, length: number | null, ratio: number, price: number | null } | null> | null } | null } | null, mold: { __typename: 'MoldTool', id: any, inspectionData: any | null, manualOverrideMpUnitPayout: number | null, manualOverrideUnitAmount: number | null, price: { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null } | null };

export type AdminQuoteModelRevisionQueryVariables = Exact<{
  id: Scalars['UUID'];
  showDeleted: InputMaybe<Scalars['Boolean']>;
  isCpqFlagV2Enabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type AdminQuoteModelRevisionQuery = { __typename: 'Query', quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, isITARProhibitedViewing: boolean | null, isExclusiveToSingleQuote: boolean | null, canBeExclusiveToSingleQuote: boolean | null, fileName: string, version: string, updatedAt: any, flags: Array<QmrFlag | null> | null, state: QuoteModelRevisionState, sourceQuoteModelRevisionId: any | null, quantityRangeStatus: string | null, supportedPriorityRegions: { __typename: 'SupportedPriorityRegions', partSupportsDomestic: boolean, partSupportsInternational: boolean }, dfmReports: Array<{ __typename: 'PartDfmReport', quoteAttachmentRevisionId: any, uploaderEmail: string | null, source: string | null, isPublished: boolean, asset: { __typename: 'Asset', id: any, createdAt: any, downloadUrl: string | null, fileName: string } | null }>, quoteModel: { __typename: 'QuoteModel', id: any, quote: { __typename: 'Quote', id: any, name: string, status: string, isFlexiblePriceQuote: boolean, openEndedQuoteInviteUrl: string | null, isCpqOwned?: boolean | null, type: QuoteType, user: { __typename: 'BasicUser', id: number, firstName: string | null, lastName: string | null, email: any }, quoteModels: { __typename: 'PartialQuoteModelResults', items: Array<{ __typename: 'QuoteModel', id: any, selectedQuoteModelRevision: { __typename: 'QuoteModelRevision', processesDetails: { __typename: 'QmrProcessesDetails', totalPrice: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', unitPriceInCents: number | null, priceInCents: number | null } | null } | null }, quoteModelRevisions: Array<{ __typename: 'QuoteModelRevision', id: any, dfmFeedback: Array<{ __typename: 'DfmFeedback', isPublished: boolean }>, dfmReports: Array<{ __typename: 'PartDfmReport', isPublished: boolean, source: string | null, uploaderEmail: string | null, asset: { __typename: 'Asset', id: any, fileName: string, createdAt: any, downloadUrl: string | null } | null }>, partRevision: { __typename: 'Revision', modelFileName: string | null, thumbnailUri: string | null }, quoteModel: { __typename: 'QuoteModel', quote: { __typename: 'Quote', isQuotePurchasable: boolean } | null } }> }> }, quoteAttachments: { __typename: 'PartialQuoteAttachmentResults', items: Array<{ __typename: 'QuoteAttachment', id: any, latestAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, uploadUrl: string | null, downloadUrl: string | null, fileName: string, extension: string | null, mimeType: string | null, sizeInKb: number | null, createdAt: any, user: { __typename: 'BasicUser', id: number, email: any, firstName: string | null, lastName: string | null }, sanitized: { __typename: 'SanitizedAttachment', id: any, uploadUrl: string | null, downloadUrl: string | null, fileName: string, extension: string | null, mimeType: string | null, sizeInKb: number | null, createdAt: any, updatedAt: any, deletedAt: any | null } | null } | null } }> } } | null }, annotations: Array<{ __typename: 'Annotation', id: any }>, manufacturingDrawing: { __typename: 'GeneratedDrawing', id: any, attachment: { __typename: 'Attachment', id: any, downloadUrl: string | null } | null } | { __typename: 'SanitizedAttachment', id: any, downloadUrl: string | null } | null, attachmentLink: { __typename: 'QuoteModelRevisionAttachment', id: any, createdAt: any, isPdfOcrAutoQuotable: boolean | null, quoteAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, quoteAttachment: { __typename: 'QuoteAttachment', id: any }, attachment: { __typename: 'Attachment', id: any, fileName: string, downloadUrl: string | null, sanitized: { __typename: 'SanitizedAttachment', id: any, downloadUrl: string | null, fileName: string } | null, annotated: { __typename: 'AnnotatedAttachment', id: any, downloadUrl: string | null, fileName: string } | null } | null } } | null, holes: Array<{ __typename: 'Hole', id: string, groupKey: string, type: string, depth: number | null, diameter: number | null, isBlind: boolean | null, tipAngle: number | null, counterboreDepth: number | null, counterboreDiameter: number | null, countersinkAngle: number | null, countersinkDepth: number | null, countersinkDiameter: number | null, direction: any | null, endPoint: Array<number> | null, startPoint: Array<number> | null, tapOptions: Array<{ __typename: 'TapOption', id: string, maxDepth: number, commonName: string }>, tapAnnotation: { __typename: 'TapAnnotation', id: any, depth: number | null, tapOption: { __typename: 'TapOption', id: string, maxDepth: number, commonName: string } | null } | null }>, taps: Array<{ __typename: 'TapAnnotation', id: any }>, partRevision: { __typename: 'Revision', id: any, modelFileName: string | null, downloadUri: string | null, cleanDownloadUri: string | null, thumbnailUri: string | null, sceneBundle: any | null, units: string | null, rawAnalysis: any | null, partId: number | null, updatedAt: any, boundingBox: { __typename: 'Vector3', x: number, y: number, z: number } | null }, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, isValid: boolean, message: string, title: string | null, link: string | null, code: string | null, isPublished: boolean, severity: string, sourceType: string | null, isAutoGeneratedDfm: boolean, createdAt: any, deletedAt: any | null, createdBy: { __typename: 'BasicUser', displayName: string, email: any }, modelViewerSnapshots: Array<{ __typename: 'ModelViewerSnapshot', id: any, snapshot: { __typename: 'ModelViewerConfig', rotation: Array<number> | null, camera: { __typename: 'ModelViewerCameraConfig', position: Array<number>, zoom: number, up: Array<number> | null, target: Array<number> | null } | null, part: { __typename: 'ModelViewerPartConfig', transparent: boolean, patches: Array<{ __typename: 'ModelViewerPatchConfig', color: string | null, hashcode: string }> }, dfm: Array<{ __typename: 'ModelViewerDfmFeatureConfig', color: string | null, threshold: number | null, feature: string | null, direction: Array<number> | null }>, annotations: Array<{ __typename: 'ModelViewerAnnotationConfig', position: Array<number> }>, crossSection: { __typename: 'ModelViewerCrossSectionConfig', position: any, rotation: any } | null, pointToPoint: { __typename: 'PointToPointConfig', customPoints: Array<any>, selectedPoints: Array<{ __typename: 'P2PPoint', index: number, type: P2PPointType }> } | null } | null }> }>, processesDetails: { __typename: 'QmrProcessesDetails', isBusinessAccountDiscountApplied: boolean | null, totalPrice: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null, primaryProcess: { __typename: 'QmrProcessWithPrice', process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string }, price: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null } | null, postProcesses: Array<{ __typename: 'QmrPostProcessWithPriceAndLead', unitPriceInCents: number | null, postProcessLeadTimeInDays: number | null, postProcessNumParts: number | null, postProcessInspectionCriteria: ProcessInspectionCriteria | null, postProcess: { __typename: 'PostProcess', id: string, name: string, typeName: string | null, colors: Array<{ __typename: 'Color', id: string, name: string } | null> | null, thicknesses: Array<{ __typename: 'Thickness', id: string, name: string, value: number } | null> | null }, postProcessThickness: { __typename: 'Thickness', id: string, name: string } | null, postProcessColor: { __typename: 'Color', id: string, name: string } | null }>, secondaryProcesses: Array<{ __typename: 'QmrSecondaryProcessDetails', unitPriceInCents: number | null, leadTimeInDays: number | null, notes: string | null, process: { __typename: 'PostProcess', id: string, name: string, typeName: string | null }, pricingAndLeadTimeFields: { __typename: 'HardwareInstallationManualQuoteCalcFields', international: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', markupPercentage: number, mpPayoutInCents: number | null, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, domestic: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', mpPayoutInCents: number | null, markupPercentage: number, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, lineItems: Array<{ __typename: 'HardwareLineItem', supplier: string | null, partNumber: string | null, qtyPerPart: number, pricePerPack: number, qtyPerPack: number }> | null } | { __typename: 'SecondaryProcessManualQuoteCalcFields', international: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', markupPercentage: number, mpPayoutInCents: number | null, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, domestic: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', mpPayoutInCents: number | null, markupPercentage: number, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null } | null }> } | null, modelConfiguration: { __typename: 'ModelConfiguration', id: any, requiresOvermold: boolean, additionalRequirements: string | null, materialGrade: string | null, colorCode: string | null, textureCode: string | null, quantity: number | null, errorCode: string | null, updatedAt: any, dfmInspections: Array<{ __typename: 'ModelConfigurationDfmInspection', id: any | null, inspectionData: any, quantityLowerRange: number | null, quantityUpperRange: number | null, isQuantityRangeAvailable: boolean | null, isPublished: boolean, manualOverrideMpUnitPayout: number | null, manualOverrideUnitAmount: number | null, quotedAt: any | null, quoteUpdatedAt: any | null, updatedAt: any, quotedBy: { __typename: 'BasicUser', id: number, displayName: string } | null, quoteUpdatedBy: { __typename: 'BasicUser', id: number, displayName: string } | null } | null> | null, dfmInspection: { __typename: 'ModelConfigurationDfmInspection', id: any | null, inspectionData: any, isPublished: boolean, quotedAt: any | null, quoteUpdatedAt: any | null, updatedAt: any, manualOverrideMpUnitPayout: number | null, manualOverrideUnitAmount: number | null, quotedBy: { __typename: 'BasicUser', id: number, displayName: string } | null, quoteUpdatedBy: { __typename: 'BasicUser', id: number, displayName: string } | null } | null, productionLeadTime: { __typename: 'ProductionLeadTime', id: string, priorityId: string, productionDays: number, primaryProductionDays: number, shipDateEstimate: { __typename: 'ShipDateEstimate', id: string, validUntilDate: any, shippedByDate: any } } | null, process: { __typename: 'Process', id: string, name: string } | null, material: { __typename: 'Material', id: string, name: string } | { __typename: 'UserEnteredMaterial', id: string, name: string } | null, color: { __typename: 'Color', id: string, name: string } | null, texture: { __typename: 'Texture', id: string, name: string } | null, updatedBy: { __typename: 'BasicUser', id: number, email: any, updatedAt: any }, toolDetails: { __typename: 'ToolCosts', totalCost: number | null, tools: Array<{ __typename: 'Tool', id: string, type: string, diameter: number, length: number | null, ratio: number, price: number | null } | null> | null } | null } | null, mold: { __typename: 'MoldTool', id: any, inspectionData: any | null, manualOverrideMpUnitPayout: number | null, manualOverrideUnitAmount: number | null, price: { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null } | null } | null };

export type AdminCalculateAdvancedInspectionPendingPricesQueryVariables = Exact<{
  quoteModelRevisionId: Scalars['UUID'];
  numPartsToInspect: Scalars['Int'];
  inspectionParams: AdminInspectionPricingParamsInput;
  setupParams: PartSetupsInspectionPricingParamsInput;
}>;


export type AdminCalculateAdvancedInspectionPendingPricesQuery = { __typename: 'Query', calculateAdvancedInspectionPendingPrices: { __typename: 'PendingAdvancedInspectionPrices', domestic: { __typename: 'PendingAdvancedInspectionPrice', mpPayoutInCents: number | null, builderPayoutInCents: number | null, leadTimeInDays: number | null }, overseas: { __typename: 'PendingAdvancedInspectionPrice', mpPayoutInCents: number | null, builderPayoutInCents: number | null, leadTimeInDays: number | null } } };

export type CalculateQuoteModelRevisionHypotheticalVendorPriceQueryVariables = Exact<{
  quoteModelRevisionId: Scalars['UUID'];
  inspectionData: InputMaybe<InspectionDataInput>;
  modelConfigOverride: ConfigInput;
  pricingConstantOverrides: PricingConstantOverridesInput;
}>;


export type CalculateQuoteModelRevisionHypotheticalVendorPriceQuery = { __typename: 'Query', calculateQuoteModelRevisionHypotheticalVendorPrice: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null };

export type EdmCalculatorPendingPriceQueryQueryVariables = Exact<{
  qmrId: Scalars['UUID'];
  edmCalculatorInput: EdmCalculatorInput;
}>;


export type EdmCalculatorPendingPriceQueryQuery = { __typename: 'Query', getPendingEdmCalculatorDomesticAndOverseasPrice: { __typename: 'EdmCalculatorOutput', stepItems: Array<{ __typename: 'StepItemOutput', wire: { __typename: 'EdmWireItemOutput', gear: string, roughness: string, cutPath: number, plateThickness: number } | null, sinkerKnownRemoval: { __typename: 'EdmSinkerKnownRemovalVolumeItemOutput', roughness: string, setups: number, volumeRemoved: number } | null, sinkerNoKnownRemoval: { __typename: 'EdmSinkerNoKnownRemovalVolumeItemOutput', roughness: string, setups: number, desiredFilletRadius: number, standardFilletRadius: number, lengthOfFillet: number } | null, priceInCents: { __typename: 'EdmPriceOutput', usa: number | null, china: number | null, india: number | null } | null }> } | null };

export type UpdateStepItemsMutationAdminQuotingpAgeMutationVariables = Exact<{
  modelConfigurationDfmInspectionId: Scalars['UUID'];
  inspectionData: InspectionDataInput;
}>;


export type UpdateStepItemsMutationAdminQuotingpAgeMutation = { __typename: 'Mutation', updateModelConfigurationDfmInspection: { __typename: 'ModelConfigurationDfmInspection', id: any | null, inspectionData: any } };

export type HardwareInstallationPendingPriceQueryQueryVariables = Exact<{
  qmrId: Scalars['UUID'];
  hardwareInstallationInput: HardwareInstallationPricingInput;
}>;


export type HardwareInstallationPendingPriceQueryQuery = { __typename: 'Query', getPendingHardwareInstallationPriceAndLeadTime: { __typename: 'SecondaryProcessManualQuoteCalcFields', international: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', leadTimeInDays: number | null, leadTimePartsLimit: number } | null, domestic: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', mpPayoutInCents: number | null, leadTimeInDays: number | null, leadTimePartsLimit: number } | null } | null };

export type UpsertHardwareInstallationSecondaryProcessWithCalculatedPricingMutationVariables = Exact<{
  qmrId: Scalars['UUID'];
  quotedProcessConfig: HardwareInstallationConfigInput;
}>;


export type UpsertHardwareInstallationSecondaryProcessWithCalculatedPricingMutation = { __typename: 'Mutation', upsertHardwareInstallationSecondaryProcessWithCalculatedPricing: { __typename: 'QuoteModelRevision', id: any } };

export type AdminImPanelPendingPriceQueryQueryVariables = Exact<{
  toolInspectionData: MoldToolInspectionDataInput;
  partsInspectionData: Array<InputMaybe<PartInspectionDataInput>> | InputMaybe<PartInspectionDataInput>;
}>;


export type AdminImPanelPendingPriceQueryQuery = { __typename: 'Query', getToolAndPartPendingPrices: { __typename: 'ToolAndPartPendingPrices', toolingPrice: { __typename: 'ImToolingPriceType', mpPayoutCents: number | null, customerPrice: number | null } | null, partPrice: { __typename: 'ImPartPriceType', unitMpPayoutInCentsPerQmr: any | null, unitCustomerPriceInCentsPerQmr: any | null } | null } | null };

export type AdminQmrLeadTimeContributionsJsonQueryVariables = Exact<{
  quoteModelRevisionId: Scalars['UUID'];
}>;


export type AdminQmrLeadTimeContributionsJsonQuery = { __typename: 'Query', qmrLeadTimeContributionsJSON: any | null };

export type CreateQuoteModelRevisionAttachmentPartDfmReportMutationVariables = Exact<{
  quoteModelRevisionId: Scalars['UUID'];
  quoteAttachmentRevisionId: Scalars['UUID'];
  userId: InputMaybe<Scalars['Int']>;
}>;


export type CreateQuoteModelRevisionAttachmentPartDfmReportMutation = { __typename: 'Mutation', createQuoteModelRevisionAttachment: { __typename: 'QuoteModelRevisionAttachment', id: any } };

export type ClassACalculatorPendingPriceQueryQueryVariables = Exact<{
  qmrId: Scalars['UUID'];
  partComplexity: Scalars['String'];
}>;


export type ClassACalculatorPendingPriceQueryQuery = { __typename: 'Query', getPendingClassACalculatorDomesticAndOverseasPrice: { __typename: 'ClassACalculatorOutput', classANonRecurringCostsInCents: { __typename: 'ClassAPriceOutput', usa: number | null }, classAProductionCostsInCents: { __typename: 'ClassAPriceOutput', usa: number | null } } | null };

export type MaterialsAdminQuotingPageQueryVariables = Exact<{
  processId: Scalars['String'];
}>;


export type MaterialsAdminQuotingPageQuery = { __typename: 'Query', materials: Array<{ __typename: 'Material', id: string, name: string }> | null };

export type CalculateQuoteModelRevisionPendingPricesQueryVariables = Exact<{
  quoteModelRevisionId: Scalars['UUID'];
  inspectionData: InputMaybe<InspectionDataInput>;
  modelConfigOverrides: InputMaybe<Array<ConfigInput> | ConfigInput>;
  operationRegion: InputMaybe<Scalars['String']>;
}>;


export type CalculateQuoteModelRevisionPendingPricesQuery = { __typename: 'Query', calculateQuoteModelRevisionPendingPrices: Array<{ __typename: 'PendingPriceInformation', builderPrice: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null, manufacturingPartnerPrice: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null, granularPricingData: { __typename: 'GranularCncPricingData', setupPricingInCents: number, camTimePricingInCents: number, fixturePricingInCents: number, threadsPricingInCents: number, tightTolerancePricingInCents: number, scrapRate: number | null, cncPricingBreakdown: any | null } | null, leadTimeData: { __typename: 'PendingLeadTimeData', rush: number | null, standard: number | null, economy: number | null, flex: number | null, saver: number | null, overseas: number | null } | null, markupData: { __typename: 'PendingMarkupData', rush: number | null, standard: number | null, economy: number | null, flex: number | null, saver: number | null, overseas: number | null } | null } | null> | null };

export type GetBusinessAccountDiscountAdminQuotingPageQueryQueryVariables = Exact<{
  id: Scalars['UUID'];
  showDeleted: InputMaybe<Scalars['Boolean']>;
}>;


export type GetBusinessAccountDiscountAdminQuotingPageQueryQuery = { __typename: 'Query', quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, quoteModel: { __typename: 'QuoteModel', id: any, quote: { __typename: 'Quote', id: any, businessAccountDiscount: { __typename: 'BusinessAccountDiscount', id: number, percent: number } | null } | null } } | null };

export type AdminAttachmentFragment = { __typename: 'Attachment', id: any, uploadUrl: string | null, downloadUrl: string | null, fileName: string, extension: string | null, mimeType: string | null, sizeInKb: number | null, createdAt: any, user: { __typename: 'BasicUser', id: number, email: any, firstName: string | null, lastName: string | null }, sanitized: { __typename: 'SanitizedAttachment', id: any, uploadUrl: string | null, downloadUrl: string | null, fileName: string, extension: string | null, mimeType: string | null, sizeInKb: number | null, createdAt: any, updatedAt: any, deletedAt: any | null } | null };

export type DfmFeedbackDeprecatedSnapshotFragment = { __typename: 'ModelViewerConfig', rotation: Array<number> | null, camera: { __typename: 'ModelViewerCameraConfig', position: Array<number>, zoom: number, up: Array<number> | null, target: Array<number> | null } | null, part: { __typename: 'ModelViewerPartConfig', transparent: boolean, patches: Array<{ __typename: 'ModelViewerPatchConfig', color: string | null, hashcode: string }> }, dfm: Array<{ __typename: 'ModelViewerDfmFeatureConfig', color: string | null, threshold: number | null, feature: string | null, direction: Array<number> | null }>, annotations: Array<{ __typename: 'ModelViewerAnnotationConfig', position: Array<number> }>, crossSection: { __typename: 'ModelViewerCrossSectionConfig', position: any, rotation: any } | null, pointToPoint: { __typename: 'PointToPointConfig', customPoints: Array<any>, selectedPoints: Array<{ __typename: 'P2PPoint', index: number, type: P2PPointType }> } | null };

export type DfmFeedbackDeprecatedFragment = { __typename: 'DfmFeedback', id: any, isValid: boolean, message: string, title: string | null, link: string | null, code: string | null, isPublished: boolean, severity: string, sourceType: string | null, isAutoGeneratedDfm: boolean, createdAt: any, deletedAt: any | null, createdBy: { __typename: 'BasicUser', displayName: string, email: any }, modelViewerSnapshots: Array<{ __typename: 'ModelViewerSnapshot', id: any, snapshot: { __typename: 'ModelViewerConfig', rotation: Array<number> | null, camera: { __typename: 'ModelViewerCameraConfig', position: Array<number>, zoom: number, up: Array<number> | null, target: Array<number> | null } | null, part: { __typename: 'ModelViewerPartConfig', transparent: boolean, patches: Array<{ __typename: 'ModelViewerPatchConfig', color: string | null, hashcode: string }> }, dfm: Array<{ __typename: 'ModelViewerDfmFeatureConfig', color: string | null, threshold: number | null, feature: string | null, direction: Array<number> | null }>, annotations: Array<{ __typename: 'ModelViewerAnnotationConfig', position: Array<number> }>, crossSection: { __typename: 'ModelViewerCrossSectionConfig', position: any, rotation: any } | null, pointToPoint: { __typename: 'PointToPointConfig', customPoints: Array<any>, selectedPoints: Array<{ __typename: 'P2PPoint', index: number, type: P2PPointType }> } | null } | null }> };

export type AdminImModelConfigurationFragment = { __typename: 'ModelConfiguration', id: any, materialGrade: string | null, colorCode: string | null, textureCode: string | null, hasMultipleFinishes: boolean, userNeedsConfigHelp: boolean, quantity: number | null, errorCode: string | null, updatedAt: any, dfmInspection: { __typename: 'ModelConfigurationDfmInspection', id: any | null, inspectionData: any, isPublished: boolean, quotedAt: any | null, quoteUpdatedAt: any | null, updatedAt: any, quotedBy: { __typename: 'BasicUser', id: number, displayName: string } | null, quoteUpdatedBy: { __typename: 'BasicUser', id: number, displayName: string } | null } | null, productionLeadTime: { __typename: 'ProductionLeadTime', id: string, priorityId: string, productionDays: number, primaryProductionDays: number, shipDateEstimate: { __typename: 'ShipDateEstimate', id: string, validUntilDate: any, shippedByDate: any } } | null, process: { __typename: 'Process', id: string, name: string } | null, material: { __typename: 'Material', id: string, name: string } | { __typename: 'UserEnteredMaterial', id: string, name: string } | null, color: { __typename: 'Color', id: string, name: string } | null, updatedBy: { __typename: 'BasicUser', id: number, email: any, updatedAt: any }, toolDetails: { __typename: 'ToolCosts', totalCost: number | null, tools: Array<{ __typename: 'Tool', id: string, type: string, diameter: number, length: number | null, ratio: number, price: number | null } | null> | null } | null };

export type AdminModelConfigurationDeprecatedDfmInspectionFragment = { __typename: 'ModelConfigurationDfmInspection', id: any | null, inspectionData: any, isPublished: boolean, quotedAt: any | null, quoteUpdatedAt: any | null, updatedAt: any, manualOverrideMpUnitPayout: number | null, manualOverrideUnitAmount: number | null, quotedBy: { __typename: 'BasicUser', id: number, displayName: string } | null, quoteUpdatedBy: { __typename: 'BasicUser', id: number, displayName: string } | null };

export type AdminModelConfigurationDeprecatedDfmInspectionsItemFragment = { __typename: 'ModelConfigurationDfmInspection', id: any | null, inspectionData: any, quantityLowerRange: number | null, quantityUpperRange: number | null, isQuantityRangeAvailable: boolean | null, isPublished: boolean, manualOverrideMpUnitPayout: number | null, manualOverrideUnitAmount: number | null, quotedAt: any | null, quoteUpdatedAt: any | null, updatedAt: any, quotedBy: { __typename: 'BasicUser', id: number, displayName: string } | null, quoteUpdatedBy: { __typename: 'BasicUser', id: number, displayName: string } | null };

export type AdminModelConfigurationDeprecatedFragment = { __typename: 'ModelConfiguration', id: any, requiresOvermold: boolean, additionalRequirements: string | null, materialGrade: string | null, colorCode: string | null, textureCode: string | null, quantity: number | null, errorCode: string | null, updatedAt: any, dfmInspections: Array<{ __typename: 'ModelConfigurationDfmInspection', id: any | null, inspectionData: any, quantityLowerRange: number | null, quantityUpperRange: number | null, isQuantityRangeAvailable: boolean | null, isPublished: boolean, manualOverrideMpUnitPayout: number | null, manualOverrideUnitAmount: number | null, quotedAt: any | null, quoteUpdatedAt: any | null, updatedAt: any, quotedBy: { __typename: 'BasicUser', id: number, displayName: string } | null, quoteUpdatedBy: { __typename: 'BasicUser', id: number, displayName: string } | null } | null> | null, dfmInspection: { __typename: 'ModelConfigurationDfmInspection', id: any | null, inspectionData: any, isPublished: boolean, quotedAt: any | null, quoteUpdatedAt: any | null, updatedAt: any, manualOverrideMpUnitPayout: number | null, manualOverrideUnitAmount: number | null, quotedBy: { __typename: 'BasicUser', id: number, displayName: string } | null, quoteUpdatedBy: { __typename: 'BasicUser', id: number, displayName: string } | null } | null, productionLeadTime: { __typename: 'ProductionLeadTime', id: string, priorityId: string, productionDays: number, primaryProductionDays: number, shipDateEstimate: { __typename: 'ShipDateEstimate', id: string, validUntilDate: any, shippedByDate: any } } | null, process: { __typename: 'Process', id: string, name: string } | null, material: { __typename: 'Material', id: string, name: string } | { __typename: 'UserEnteredMaterial', id: string, name: string } | null, color: { __typename: 'Color', id: string, name: string } | null, texture: { __typename: 'Texture', id: string, name: string } | null, updatedBy: { __typename: 'BasicUser', id: number, email: any, updatedAt: any }, toolDetails: { __typename: 'ToolCosts', totalCost: number | null, tools: Array<{ __typename: 'Tool', id: string, type: string, diameter: number, length: number | null, ratio: number, price: number | null } | null> | null } | null };

export type ProcessesDetailsDeprecatedSecondaryProcessHardwareInstallationManualQuoteCalcFieldsFragment = { __typename: 'HardwareInstallationManualQuoteCalcFields', international: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', markupPercentage: number, mpPayoutInCents: number | null, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, domestic: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', mpPayoutInCents: number | null, markupPercentage: number, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, lineItems: Array<{ __typename: 'HardwareLineItem', supplier: string | null, partNumber: string | null, qtyPerPart: number, pricePerPack: number, qtyPerPack: number }> | null };

export type ProcessesDetailsDeprecatedSecondaryProcessFragment = { __typename: 'QmrSecondaryProcessDetails', unitPriceInCents: number | null, leadTimeInDays: number | null, notes: string | null, process: { __typename: 'PostProcess', id: string, name: string, typeName: string | null }, pricingAndLeadTimeFields: { __typename: 'HardwareInstallationManualQuoteCalcFields', international: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', markupPercentage: number, mpPayoutInCents: number | null, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, domestic: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', mpPayoutInCents: number | null, markupPercentage: number, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, lineItems: Array<{ __typename: 'HardwareLineItem', supplier: string | null, partNumber: string | null, qtyPerPart: number, pricePerPack: number, qtyPerPack: number }> | null } | { __typename: 'SecondaryProcessManualQuoteCalcFields', international: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', markupPercentage: number, mpPayoutInCents: number | null, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, domestic: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', mpPayoutInCents: number | null, markupPercentage: number, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null } | null };

export type ProcessesDetailsDeprecatedFragment = { __typename: 'QmrProcessesDetails', isBusinessAccountDiscountApplied: boolean | null, totalPrice: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null, primaryProcess: { __typename: 'QmrProcessWithPrice', process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string }, price: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null } | null, postProcesses: Array<{ __typename: 'QmrPostProcessWithPriceAndLead', unitPriceInCents: number | null, postProcessLeadTimeInDays: number | null, postProcessNumParts: number | null, postProcessInspectionCriteria: ProcessInspectionCriteria | null, postProcess: { __typename: 'PostProcess', id: string, name: string, typeName: string | null, colors: Array<{ __typename: 'Color', id: string, name: string } | null> | null, thicknesses: Array<{ __typename: 'Thickness', id: string, name: string, value: number } | null> | null }, postProcessThickness: { __typename: 'Thickness', id: string, name: string } | null, postProcessColor: { __typename: 'Color', id: string, name: string } | null }>, secondaryProcesses: Array<{ __typename: 'QmrSecondaryProcessDetails', unitPriceInCents: number | null, leadTimeInDays: number | null, notes: string | null, process: { __typename: 'PostProcess', id: string, name: string, typeName: string | null }, pricingAndLeadTimeFields: { __typename: 'HardwareInstallationManualQuoteCalcFields', international: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', markupPercentage: number, mpPayoutInCents: number | null, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, domestic: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', mpPayoutInCents: number | null, markupPercentage: number, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, lineItems: Array<{ __typename: 'HardwareLineItem', supplier: string | null, partNumber: string | null, qtyPerPart: number, pricePerPack: number, qtyPerPack: number }> | null } | { __typename: 'SecondaryProcessManualQuoteCalcFields', international: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', markupPercentage: number, mpPayoutInCents: number | null, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, domestic: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', mpPayoutInCents: number | null, markupPercentage: number, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null } | null }> };

export type GetProjectIdQueryQueryVariables = Exact<{
  id: Scalars['UUID'];
  showDeleted: InputMaybe<Scalars['Boolean']>;
}>;


export type GetProjectIdQueryQuery = { __typename: 'Query', quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, quoteModel: { __typename: 'QuoteModel', id: any, quote: { __typename: 'Quote', id: any, project: { __typename: 'BasicProject', id: any | null } | null } | null } } | null };

export type AdminQuoteModelRevisionAttachmentQueryVariables = Exact<{
  id: Scalars['UUID'];
  showDeleted: InputMaybe<Scalars['Boolean']>;
}>;


export type AdminQuoteModelRevisionAttachmentQuery = { __typename: 'Query', quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, attachmentLink: { __typename: 'QuoteModelRevisionAttachment', id: any, quoteAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, downloadUrl: string | null } | null } } | null } | null };

export type QuantityRangesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type QuantityRangesQueryQuery = { __typename: 'Query', quantityRanges: Array<{ __typename: 'QuantityRange', id: any, quantityLowerRange: number, quantityUpperRange: number }> };

export type GenerateModelConfigurationDfmInspectionQueryVariables = Exact<{
  quoteModelRevisionId: Scalars['UUID'];
  modelConfigOverrides: ConfigInput;
}>;


export type GenerateModelConfigurationDfmInspectionQuery = { __typename: 'Query', generateModelConfigurationDfmInspection: { __typename: 'ModelConfigurationDfmInspection', id: any | null, quantityLowerRange: number | null, quantityUpperRange: number | null, inspectionData: any, isPublished: boolean } | null };

export type SimilarQuoteModelRevisionsQueryQueryVariables = Exact<{
  quoteModelRevisionId: Scalars['UUID'];
}>;


export type SimilarQuoteModelRevisionsQueryQuery = { __typename: 'Query', quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, similarQuoteModelRevisions: Array<{ __typename: 'QuoteModelRevision', id: any, version: string, fileName: string, state: QuoteModelRevisionState, partRevision: { __typename: 'Revision', id: any, thumbnailUri: string | null, isMirror: boolean | null }, processesDetails: { __typename: 'QmrProcessesDetails', totalPrice: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null } | null }> } | null };

export type AdminQmrLastUpdatedQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type AdminQmrLastUpdatedQuery = { __typename: 'Query', quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, partRevision: { __typename: 'Revision', id: any, updatedAt: any } } | null };

export type DestroyDfmFeedbackMutationVariables = Exact<{
  dfmFeedbackId: Scalars['UUID'];
}>;


export type DestroyDfmFeedbackMutation = { __typename: 'Mutation', destroyDfmFeedback: { __typename: 'DfmFeedback', id: any } };

export type UpdateDfmFeedbackInfoMutationVariables = Exact<{
  dfmFeedbackId: Scalars['UUID'];
  severity: InputMaybe<Scalars['String']>;
  message: InputMaybe<Scalars['String']>;
  isPublished: InputMaybe<Scalars['Boolean']>;
  title: InputMaybe<Scalars['String']>;
  link: InputMaybe<Scalars['String']>;
  code: InputMaybe<Scalars['String']>;
}>;


export type UpdateDfmFeedbackInfoMutation = { __typename: 'Mutation', updateDfmFeedbackInfo: { __typename: 'DfmFeedback', id: any } };

export type CreateModelViewerSnapshotMutationVariables = Exact<{
  quoteModelRevisionId: Scalars['UUID'];
  position: Scalars['JSON'];
  target: Scalars['JSON'];
  feature: Scalars['String'];
  type: Scalars['String'];
  snapshot: ModelViewerConfigInput;
}>;


export type CreateModelViewerSnapshotMutation = { __typename: 'Mutation', createModelViewerSnapshot: { __typename: 'ModelViewerSnapshot', id: any } };

export type UpdateModelViewerSnapshotMutationVariables = Exact<{
  dfmSnapshotId: Scalars['UUID'];
  attrs: ModelViewerSnapshotInput;
}>;


export type UpdateModelViewerSnapshotMutation = { __typename: 'Mutation', updateModelViewerSnapshot: { __typename: 'ModelViewerSnapshot', id: any } };

export type CreateModelConfigurationDfmFeedbackMutationVariables = Exact<{
  modelConfigurationId: Scalars['UUID'];
  modelViewerSnapshotId: Scalars['UUID'];
  severity: Scalars['String'];
  message: Scalars['String'];
  title: InputMaybe<Scalars['String']>;
  link: InputMaybe<Scalars['String']>;
  code: InputMaybe<Scalars['String']>;
}>;


export type CreateModelConfigurationDfmFeedbackMutation = { __typename: 'Mutation', createModelConfigurationDfmFeedback: { __typename: 'DfmFeedback', id: any } };

export type UpdateModelConfigurationDfmInspectionMutationVariables = Exact<{
  modelConfigurationDfmInspectionId: Scalars['UUID'];
  inspectionData: InspectionDataInput;
  lastModifiedAt: InputMaybe<Scalars['Date']>;
  override: InputMaybe<Scalars['Boolean']>;
  isQuantityRangeAvailable: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateModelConfigurationDfmInspectionMutation = { __typename: 'Mutation', updateModelConfigurationDfmInspection: { __typename: 'ModelConfigurationDfmInspection', id: any | null } };

export type AddModelConfigurationDfmInspectionMutationVariables = Exact<{
  modelConfigurationId: Scalars['UUID'];
  inspectionData: InspectionDataInput;
  quantityRangeData: QuantityRangeInput;
}>;


export type AddModelConfigurationDfmInspectionMutation = { __typename: 'Mutation', addModelConfigurationDfmInspection: { __typename: 'ModelConfigurationDfmInspection', id: any | null, quantityLowerRange: number | null, quantityUpperRange: number | null, isQuantityRangeAvailable: boolean | null, isPublished: boolean, inspectionData: any, updatedBy: { __typename: 'BasicUser', id: number } } };

export type PublishQuoteModelRevisionMutationVariables = Exact<{
  quoteModelRevisionId: Scalars['UUID'];
  quantityLowerRange: InputMaybe<Scalars['Int']>;
  quantityUpperRange: InputMaybe<Scalars['Int']>;
}>;


export type PublishQuoteModelRevisionMutation = { __typename: 'Mutation', publishQuoteModelRevision: { __typename: 'QuoteModelRevision', id: any } };

export type GetPdfOcrOutputQueryVariables = Exact<{
  quoteModelRevisionId: Scalars['UUID'];
}>;


export type GetPdfOcrOutputQuery = { __typename: 'Query', getRawPdfOcrJson: { __typename: 'RawPdfOcrJson', finishingNotes: Array<string> | null, foundThreadNames: Array<string> | null, measurementUnits: string | null, minOneSidedTolerance: string | null, minTwoSidedTolerance: string | null, autoQuotableBlockers: Array<string> | null, numTightTolerances: number | null, numVeryTightTolerances: number | null, rawAnalysis: any | null, requiresCertificateOfConformance: boolean | null, requiresMaterialCertificate: boolean | null, toleranceBlocks: Array<{ __typename: 'ToleranceBlockData', textRaw: string | null, symbol: string | null }> | null } | null };

export type QuotabilityBlockersAdminQuotingPageQueryVariables = Exact<{
  quoteModelRevisionId: Scalars['UUID'];
}>;


export type QuotabilityBlockersAdminQuotingPageQuery = { __typename: 'Query', quotabilityBlockers: Array<string> | null };

export type MarkQuoteModelRevisionFlagsAdminQuotingPageMutationVariables = Exact<{
  quoteModelRevisionId: Scalars['UUID'];
  flags: InputMaybe<Array<InputMaybe<QmrFlag>> | InputMaybe<QmrFlag>>;
}>;


export type MarkQuoteModelRevisionFlagsAdminQuotingPageMutation = { __typename: 'Mutation', markQuoteModelRevisionFlags: { __typename: 'QuoteModelRevision', id: any, flags: Array<QmrFlag | null> | null } | null };

export type AdminQuotingPageLockQmrToSingleQuoteMutationVariables = Exact<{
  quoteModelRevisionId: Scalars['UUID'];
  flag: Scalars['Boolean'];
}>;


export type AdminQuotingPageLockQmrToSingleQuoteMutation = { __typename: 'Mutation', lockQMRToSingleQuote: { __typename: 'QuoteModelRevision', id: any, isExclusiveToSingleQuote: boolean | null } };

export type AdminReprocessPartMutationMutationVariables = Exact<{
  partId: Scalars['Int'];
  reprocessParameters: InputMaybe<ReprocessParametersInput>;
}>;


export type AdminReprocessPartMutationMutation = { __typename: 'Mutation', finalizeUploadAndProcessPart: { __typename: 'InstantQuoterResponseType', partId: number, status: InstantQuoterStatus, reason: string | null } };

export type AdminOrderSearchItemPartFragment = { __typename: 'OrderSearchPart', partRevisionId: string | null, partId: string | null, modelFileName: string | null, thumbnailUri: string | null };

export type AdminOrderSearchItemFragment = { __typename: 'AdminOrderResult', id: string, saleOrderId: string | null, isErpOrder: boolean, purchaserId: number | null, userEmail: string | null, purchaserEmail: string | null, orderName: string, quoteName: string | null, quoteId: string | null, businessAccountName: string | null, businessAccountId: string | null, userId: number | null, status: string | null, totalAmount: number | null, paymentType: string | null, poNumber: string | null, createdAt: string | null, isAdminProjectMember: boolean | null, isProjectAdmin: boolean | null, isSecure: boolean | null, parts: Array<{ __typename: 'OrderSearchPart', partRevisionId: string | null, partId: string | null, modelFileName: string | null, thumbnailUri: string | null } | null> | null };

export type AdminOrderSearchQueryVariables = Exact<{
  searchString: Scalars['String'];
  from: Scalars['Int'];
  size: Scalars['Int'];
}>;


export type AdminOrderSearchQuery = { __typename: 'Query', adminOrderSearch: { __typename: 'AdminOrderSearch', totalCount: number, items: Array<{ __typename: 'AdminOrderResult', id: string, saleOrderId: string | null, isErpOrder: boolean, purchaserId: number | null, userEmail: string | null, purchaserEmail: string | null, orderName: string, quoteName: string | null, quoteId: string | null, businessAccountName: string | null, businessAccountId: string | null, userId: number | null, status: string | null, totalAmount: number | null, paymentType: string | null, poNumber: string | null, createdAt: string | null, isAdminProjectMember: boolean | null, isProjectAdmin: boolean | null, isSecure: boolean | null, parts: Array<{ __typename: 'OrderSearchPart', partRevisionId: string | null, partId: string | null, modelFileName: string | null, thumbnailUri: string | null } | null> | null }> } | null };

export type BusinessAccountSearchItemFragment = { __typename: 'BusinessAccount', id: any, enabledAt: any | null, isEnabled: boolean, name: string, totalMembers: number, totalTeams: number, subscription: { __typename: 'BusinessAccountSubscription', id: number, enabledAt: any, expiresAt: any, disabledAt: any | null, durationDays: number, status: BusinessAccountSubscriptionStatus, businessAccountId: any, planId: any, enabledBy: { __typename: 'User', id: number, displayName: string, email: any }, disabledBy: { __typename: 'User', id: number, displayName: string, email: any } | null, plan: { __typename: 'BusinessAccountPlan', id: number, planName: string, planId: any, durationDays: number } } | null };

export type BusinessAccountSearchQueryQueryVariables = Exact<{
  filters: InputMaybe<BusinessAccountsFilterInput>;
}>;


export type BusinessAccountSearchQueryQuery = { __typename: 'Query', businessAccounts: { __typename: 'BusinessAccountsResult', totalCount: number, items: Array<{ __typename: 'BusinessAccount', id: any, enabledAt: any | null, isEnabled: boolean, name: string, totalMembers: number, totalTeams: number, subscription: { __typename: 'BusinessAccountSubscription', id: number, enabledAt: any, expiresAt: any, disabledAt: any | null, durationDays: number, status: BusinessAccountSubscriptionStatus, businessAccountId: any, planId: any, enabledBy: { __typename: 'User', id: number, displayName: string, email: any }, disabledBy: { __typename: 'User', id: number, displayName: string, email: any } | null, plan: { __typename: 'BusinessAccountPlan', id: number, planName: string, planId: any, durationDays: number } } | null }> } };

export type PartSearchAdminFieldsFragment = { __typename: 'PartSearchInfo', qmrId: any | null, partRevisionUuid: any | null, quoteItemId: any | null, eiUuid: any | null, partId: number | null, modelFileName: string | null, userId: number | null, email: string | null, matchedText: string | null, partCreatedAt: string | null, orderName: string | null, quoteName: string | null, quoteId: any | null, quoteItemDeletedAt: string | null, hasAttachedPdf: boolean | null, quoteStatus: string | null, ownerId: number | null };

export type PartSearchAdminSearchQueryVariables = Exact<{
  searchString: Scalars['String'];
}>;


export type PartSearchAdminSearchQuery = { __typename: 'Query', genericPartInfoSearch: Array<{ __typename: 'PartSearchInfo', qmrId: any | null, partRevisionUuid: any | null, quoteItemId: any | null, eiUuid: any | null, partId: number | null, modelFileName: string | null, userId: number | null, email: string | null, matchedText: string | null, partCreatedAt: string | null, orderName: string | null, quoteName: string | null, quoteId: any | null, quoteItemDeletedAt: string | null, hasAttachedPdf: boolean | null, quoteStatus: string | null, ownerId: number | null } | null> | null };

export type UserSearchAdminSearchFieldsFragment = { __typename: 'UserSearchInfo', userId: number | null, emailAddress: string | null, fullName: string | null, createdAt: any, roles: Array<string> | null };

export type UserSearchAdminSearchQueryVariables = Exact<{
  searchString: Scalars['String'];
}>;


export type UserSearchAdminSearchQuery = { __typename: 'Query', genericUserSearch: Array<{ __typename: 'UserSearchInfo', userId: number | null, emailAddress: string | null, fullName: string | null, createdAt: any, roles: Array<string> | null } | null> | null };

export type AdminToolingPageRemoveManuallyQuotedSecondaryProcessMutationVariables = Exact<{
  ids: Array<Scalars['UUID']> | Scalars['UUID'];
  processId: InputMaybe<Scalars['String']>;
}>;


export type AdminToolingPageRemoveManuallyQuotedSecondaryProcessMutation = { __typename: 'Mutation', removeManuallyQuotedSecondaryProcess: Array<string> };

export type AdminQuoteQmrsQueryAdminToolingQuotingPageQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type AdminQuoteQmrsQueryAdminToolingQuotingPageQuery = { __typename: 'Query', quote: { __typename: 'Quote', id: any, status: string } | null };

export type AdminMoldQmrQueryAdminToolingQuotingPageQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type AdminMoldQmrQueryAdminToolingQuotingPageQuery = { __typename: 'Query', moldTool: { __typename: 'MoldTool', id: any, quoteModelRevisions: Array<{ __typename: 'QuoteModelRevision', id: any, fileName: string, state: QuoteModelRevisionState, flags: Array<QmrFlag | null> | null, version: string, partRevision: { __typename: 'Revision', id: any, thumbnailUri: string | null, downloadUri: string | null, status: string | null, modelFileName: string | null, analysisErrorCode: string | null, boundingBox: { __typename: 'Vector3', x: number, y: number, z: number } | null }, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, accepted: boolean, severity: string }>, taps: Array<{ __typename: 'TapAnnotation', id: any }>, attachmentLink: { __typename: 'QuoteModelRevisionAttachment', id: any, quoteAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, downloadUrl: string | null, fileName: string, extension: string | null } | null } } | null, supportedPriorityRegions: { __typename: 'SupportedPriorityRegions', partSupportsDomestic: boolean, partSupportsInternational: boolean }, processesDetails: { __typename: 'QmrProcessesDetails', totalPrice: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', unitPriceInCents: number | null, priceInCents: number | null } | null, postProcesses: Array<{ __typename: 'QmrPostProcessWithPriceAndLead', unitPriceInCents: number | null, postProcessLeadTimeInDays: number | null, postProcessNumParts: number | null, postProcessInspectionCriteria: ProcessInspectionCriteria | null, postProcess: { __typename: 'PostProcess', id: string, name: string }, postProcessThickness: { __typename: 'Thickness', id: string, name: string } | null, postProcessColor: { __typename: 'Color', id: string, name: string } | null }>, secondaryProcesses: Array<{ __typename: 'QmrSecondaryProcessDetails', unitPriceInCents: number | null, leadTimeInDays: number | null, notes: string | null, process: { __typename: 'PostProcess', id: string, name: string, typeName: string | null }, pricingAndLeadTimeFields: { __typename: 'HardwareInstallationManualQuoteCalcFields', international: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', markupPercentage: number, mpPayoutInCents: number | null, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, domestic: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', mpPayoutInCents: number | null, markupPercentage: number, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, lineItems: Array<{ __typename: 'HardwareLineItem', supplier: string | null, partNumber: string | null, qtyPerPart: number, pricePerPack: number, qtyPerPack: number }> | null } | { __typename: 'SecondaryProcessManualQuoteCalcFields', international: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', markupPercentage: number, mpPayoutInCents: number | null, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, domestic: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', mpPayoutInCents: number | null, markupPercentage: number, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null } | null }> } | null, modelConfiguration: { __typename: 'ModelConfiguration', id: any, materialGrade: string | null, colorCode: string | null, quantity: number | null, textureCode: string | null, hasMultipleFinishes: boolean, userNeedsConfigHelp: boolean, requiresOvermold: boolean, additionalRequirements: string | null, dfmInspection: { __typename: 'ModelConfigurationDfmInspection', id: any | null, inspectionData: any } | null, process: { __typename: 'Process', id: string, name: string } | null, material: { __typename: 'Material', id: string, name: string } | { __typename: 'UserEnteredMaterial', id: string, name: string } | null, color: { __typename: 'Color', id: string, name: string } | null, shore: { __typename: 'Shore', id: string, name: string } | null, texture: { __typename: 'Texture', id: string, name: string } | null } | null }> } | null };

export type CalculateCostQueryAdminToolingQuotingPageQueryVariables = Exact<{
  inspectionData: MoldToolInspectionDataInput;
  partsInspectionData: Array<InputMaybe<PartInspectionDataInput>> | InputMaybe<PartInspectionDataInput>;
  pendingPartQuantity: Scalars['Int'];
}>;


export type CalculateCostQueryAdminToolingQuotingPageQuery = { __typename: 'Query', getToolAndPartPendingPrices: { __typename: 'ToolAndPartPendingPrices', toolingPrice: { __typename: 'ImToolingPriceType', insertMaterialCostCents: number | null, insertMachiningCostCents: number | null, moldBaseCostCents: number | null, standardPartsCostCents: number | null, moldTrialCostCents: number | null, structureCostCents: number | null, designCostCents: number | null, moldAssemblyCostCents: number | null, surfaceFinishCostCents: number | null, materialCostCents: number | null, baseCostCents: number | null, mpPayoutCents: number | null, customerPrice: number | null, leadTimeDays: number | null, pressMachineSizeTon: number | null } | null, partPrice: { __typename: 'ImPartPriceType', materialCostCents: number | null, injectionCostCents: number | null, packagingCostCents: number | null, setupCostCents: number | null, basePartCostCents: number | null, unitMpPayoutInCentsPerQmr: any | null, unitCustomerPriceInCentsPerQmr: any | null, cycleTimeSecs: number | null, totalPartsWeightGram: number | null } | null } | null };

export type UpdateMoldToolInspectionDataAdminToolingQuotingPageMutationVariables = Exact<{
  id: Scalars['UUID'];
  inspectionData: MoldToolInspectionDataInput;
}>;


export type UpdateMoldToolInspectionDataAdminToolingQuotingPageMutation = { __typename: 'Mutation', updateMoldToolInspectionData: { __typename: 'MoldTool', id: any, toolLife: number | null, gateType: string | null, inspectionData: any | null, leadTimeDays: number | null, createdAt: any, updatedAt: any, publishedAt: any | null, published: boolean, createdBy: { __typename: 'User', id: number, email: any } } };

export type UpdatePartPricingParametersMutationAdminToolingQuotingPageMutationVariables = Exact<{
  modelConfigurationDfmInspectionId: Scalars['UUID'];
  inspectionData: InspectionDataInput;
}>;


export type UpdatePartPricingParametersMutationAdminToolingQuotingPageMutation = { __typename: 'Mutation', updateModelConfigurationDfmInspection: { __typename: 'ModelConfigurationDfmInspection', id: any | null, inspectionData: any } };

export type PublishMoldToolMutationAdminToolingQuotingPageMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type PublishMoldToolMutationAdminToolingQuotingPageMutation = { __typename: 'Mutation', publishMoldTool: { __typename: 'MoldTool', id: any, published: boolean } };

export type PublishQmrMutationAdminToolingQuotingPageMutationVariables = Exact<{
  quoteModelRevisionId: Scalars['UUID'];
}>;


export type PublishQmrMutationAdminToolingQuotingPageMutation = { __typename: 'Mutation', publishQuoteModelRevision: { __typename: 'QuoteModelRevision', id: any } };

export type AdminQuoteQueryAdminToolingQuotingPageQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type AdminQuoteQueryAdminToolingQuotingPageQuery = { __typename: 'Query', quote: { __typename: 'Quote', id: any, name: string, status: string, user: { __typename: 'BasicUser', id: number, email: any }, imQuoteRequirements: { __typename: 'ImQuoteRequirements', deliveryDate: any, developmentStage: StageType, toolTypeNotes: string | null, additionalRequirementNotes: string | null } | null } | null };

export type AdminMoldQueryAdminToolingQuotingPageQueryVariables = Exact<{
  id: Scalars['UUID'];
  isImMaafcoEnabled: Scalars['Boolean'];
}>;


export type AdminMoldQueryAdminToolingQuotingPageQuery = { __typename: 'Query', moldTool: { __typename: 'MoldTool', id: any, toolLife: number | null, gateType: string | null, inspectionData: any | null, leadTimeDays: number | null, createdAt: any, updatedAt: any, publishedAt: any | null, published: boolean, createdBy: { __typename: 'User', id: number, email: any }, moldToolRevision?: { __typename: 'MoldToolRevision', id: any } } | null };

export type AdminUserSalesOrderAdminUserOrdersPageQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  isCpqFlagV2Enabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type AdminUserSalesOrderAdminUserOrdersPageQuery = { __typename: 'Query', user: { __typename: 'User', id: number, salesOrders: { __typename: 'PartialSalesOrderViewResults', totalCount: number, items: Array<{ __typename: 'BasicSalesOrder', id: string, name: string, deliveryStatus: string, shippedBy: any | null, createdAt: any, totalAmount: number, project: { __typename: 'BasicProject', id: any | null, isSecurePlus: boolean, name: string } | null } | { __typename: 'SalesOrder', id: string, isReorderAllowed: boolean, name: string, deliveryStatus: string, shippedBy: any | null, createdAt: any, totalAmount: number, downloadAllFilesUri: string, fictivShipmentMethod: string | null, isBusinessAccountDiscountApplied: boolean | null, appliedBusinessAccountDiscountPercent: number | null, sourceQuoteType: QuoteType | null, quotePdfUrl?: string | null, salesOrderLines: { __typename: 'PartialSalesOrderLineResults', totalCount: number, productCount: number | null, primaryProductLines: Array<{ __typename: 'SalesOrderLine', id: string, htsCodeSubmitted: boolean | null, revision: { __typename: 'Revision', id: any, thumbnailUri: string | null } | null }> | null, items: Array<{ __typename: 'SalesOrderLine', id: string, htsCodeSubmitted: boolean | null, revision: { __typename: 'Revision', id: any, thumbnailUri: string | null } | null, processes: Array<{ __typename: 'OrderProcessDetails', id: string, platformProcessId: string | null, color: string | null, texture: string | null, thickness: string | null, processNotes: string | null, additionalSpecifications: { __typename: 'ProcessAdditionalSpecifications', color: string | null, texture: string | null, thickness: string | null } | null, dfmNotes: { __typename: 'ProcessDfmNotes', color: string | null, process: string | null, texture: string | null, thickness: string | null } | null }> }>, parts: Array<{ __typename: 'SalesOrderLine', id: string, htsCodeSubmitted: boolean | null, revision: { __typename: 'Revision', id: any, thumbnailUri: string | null } | null, processes: Array<{ __typename: 'OrderProcessDetails', id: string, platformProcessId: string | null, color: string | null, texture: string | null, thickness: string | null, processNotes: string | null, additionalSpecifications: { __typename: 'ProcessAdditionalSpecifications', color: string | null, texture: string | null, thickness: string | null } | null, dfmNotes: { __typename: 'ProcessDfmNotes', color: string | null, process: string | null, texture: string | null, thickness: string | null } | null }> }> | null }, paymentDetails: { __typename: 'PaymentDetails', paymentType: string | null, purchaseOrderNumber: string | null, paidBy: { __typename: 'BasicUser', id: number } | null }, team: { __typename: 'Team', id: number, name: string } | null, project: { __typename: 'BasicProject', id: any | null, isSecurePlus: boolean, name: string } | null, quoteOwnerUser: { __typename: 'BasicUser', id: number } | null }> } } | null };

export type UnlockUserAdminUserProfileMutationVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type UnlockUserAdminUserProfileMutation = { __typename: 'Mutation', adminOnlyMutations: { __typename: 'AdminOnlyMutations', resetLockedOutUser: { __typename: 'User', id: number, email: any } } | null };

export type ModifyRoleOrCapabilitiesAdminUserProfileMutationVariables = Exact<{
  userId: Scalars['Int'];
  roleOrCapabilities: RoleAndCapabilities;
  action: Action;
}>;


export type ModifyRoleOrCapabilitiesAdminUserProfileMutation = { __typename: 'Mutation', adminOnlyMutations: { __typename: 'AdminOnlyMutations', modifyRoleAndCapabilities: { __typename: 'User', id: number, roles: Array<{ __typename: 'Role', id: number, name: string | null }> } } | null };

export type ResendEmailVerificationMutationVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type ResendEmailVerificationMutation = { __typename: 'Mutation', adminOnlyMutations: { __typename: 'AdminOnlyMutations', resendEmailVerification: string | null } | null };

export type ResetPasswordAdminUserProfileMutationVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type ResetPasswordAdminUserProfileMutation = { __typename: 'Mutation', adminOnlyMutations: { __typename: 'AdminOnlyMutations', initiatePwdReset: { __typename: 'User', id: number } } | null };

export type UserProfileAdminUserQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UserProfileAdminUserQuery = { __typename: 'Query', user: { __typename: 'User', id: number, email: any, displayName: string, firstName: string | null, lastName: string | null, phoneNumber: string | null, updatedAt: any, enabled: boolean, createdAt: any, isUserLockedOut: boolean, lockoutLoginUntil: any | null, emailVerificationSentDate: any | null, emailVerificationStatus: EmailVerificationStatus, roles: Array<{ __typename: 'Role', id: number, name: string | null, source: RoleSourceType }>, businessAccountMembership: { __typename: 'BusinessAccountMembership', businessAccount: { __typename: 'BusinessAccount', id: any, name: string, isEnabled: boolean, isTeamsFeatureEnabled: boolean | null }, user: { __typename: 'User', id: number, enabled: boolean } } | null } | null };

export type DeleteUserAccountByAdminMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteUserAccountByAdminMutation = { __typename: 'Mutation', adminUser: { __typename: 'UserMutation', deleteAccount: { __typename: 'User', id: number } | null } | null };

export type Is2FaEnalbedForUserQueryAdminUserProfileQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type Is2FaEnalbedForUserQueryAdminUserProfileQuery = { __typename: 'Query', user: { __typename: 'User', id: number, is2faEnabled: boolean } | null };

export type Disable2FaForUserAdminUserProfileMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type Disable2FaForUserAdminUserProfileMutation = { __typename: 'Mutation', adminUser: { __typename: 'UserMutation', disable2FA: { __typename: 'User', id: number, is2faEnabled: boolean } | null } | null };

export type AdminRolesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminRolesQueryQuery = { __typename: 'Query', me: { __typename: 'User', id: number, roles: Array<{ __typename: 'Role', id: number, name: string | null }> } | null };

export type AdminUserQueryAdminUserQuoteDetailPageQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AdminUserQueryAdminUserQuoteDetailPageQuery = { __typename: 'Query', user: { __typename: 'User', id: number, email: any, salesForceAccountIdState: SalesForceAccountIdStateEnum | null, displayName: string, roles: Array<{ __typename: 'Role', id: number, name: string | null, source: RoleSourceType }>, businessAccountMembership: { __typename: 'BusinessAccountMembership', businessAccount: { __typename: 'BusinessAccount', id: any, name: string, isEnabled: boolean, isTeamsFeatureEnabled: boolean | null } } | null } | null };

export type AdminQuoteQueryAdminUserQuoteDetailPageQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type AdminQuoteQueryAdminUserQuoteDetailPageQuery = { __typename: 'Query', quote: { __typename: 'Quote', id: any, name: string } | null };

export type EnableBusinessAccountAndAddUserMutationVariables = Exact<{
  userId: InputMaybe<Scalars['Int']>;
  isBusinessAccountTrialRequest: InputMaybe<Scalars['Boolean']>;
  isPoVisibility: InputMaybe<Scalars['Boolean']>;
}>;


export type EnableBusinessAccountAndAddUserMutation = { __typename: 'Mutation', enableBusinessAccountTrial: string };

export type QuotesListAdminUserQuotesQueryVariables = Exact<{
  limit: Scalars['Int'];
  sort: InputMaybe<Scalars['CreatedAtSortKey']>;
  offset: InputMaybe<Scalars['Int']>;
  userId: Scalars['Int'];
  filter: InputMaybe<QuoteAttributeFilterType>;
}>;


export type QuotesListAdminUserQuotesQuery = { __typename: 'Query', user: { __typename: 'User', id: number, email: any, displayName: string, hasSecurePlusMemberships: boolean, roles: Array<{ __typename: 'Role', id: number, name: string | null, source: RoleSourceType }>, quotes: { __typename: 'PartialQuoteViewResults', totalCount: number, items: Array<{ __typename: 'BasicQuote', id: any, name: string, project: { __typename: 'BasicProject', isSecurePlus: boolean, name: string, id: any | null } | null } | { __typename: 'Quote', id: any, name: string, type: QuoteType, status: string, lastModified: any | null, subTotalInCents: number | null, depositInCents: number | null, productionPartsSubtotalInCents: number | null, moldToolSubtotalInCents: number | null, earliestValidUntilDate: any | null, slowestShipDateEstimate: any | null, isQuotePurchasable: boolean, zipCode: string | null, isLocked: boolean | null, isCpqOwned: boolean | null, isTaxExempt: boolean | null, partsSummary: any, numberOfParts: number, isEligibleForFreeShipping: boolean | null, cpqQuote: { __typename: 'CpqQuote', platformQuote: { __typename: 'Quote', id: any } } | null, businessAccountDiscount: { __typename: 'BusinessAccountDiscount', id: number, percent: number, isActive: boolean, endAt: any } | null, team: { __typename: 'Team', id: number, name: string } | null, user: { __typename: 'BasicUser', id: number }, quoteAttachments: { __typename: 'PartialQuoteAttachmentResults', totalCount: number, items: Array<{ __typename: 'QuoteAttachment', id: any, latestAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any } }> }, quoteModels: { __typename: 'PartialQuoteModelResults', totalCount: number, items: Array<{ __typename: 'QuoteModel', id: any, selectedQuoteModelRevision: { __typename: 'QuoteModelRevision', id: any, state: QuoteModelRevisionState, fileName: string, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, accepted: boolean, severity: string }>, attachmentLink: { __typename: 'QuoteModelRevisionAttachment', id: any, quoteAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any } } | null, processesDetails: { __typename: 'QmrProcessesDetails', totalPrice: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', unitPriceInCents: number | null, priceInCents: number | null } | null } | null, modelConfiguration: { __typename: 'ModelConfiguration', id: any, quantity: number | null, productionLeadTime: { __typename: 'ProductionLeadTime', productionDays: number } | null, material: { __typename: 'Material', id: string, name: string } | { __typename: 'UserEnteredMaterial', id: string, name: string, process: { __typename: 'Process', id: string, name: string } } | null, process: { __typename: 'Process', id: string, name: string } | null, color: { __typename: 'Color', id: string, name: string } | null } | null } }> }, project: { __typename: 'BasicProject', isSecurePlus: boolean, name: string, id: any | null } | null }> } | null } | null };

export type QuotesTotalAndUserAdminUserQuotesQueryVariables = Exact<{
  limit: Scalars['Int'];
  sort: InputMaybe<Scalars['CreatedAtSortKey']>;
  offset: InputMaybe<Scalars['Int']>;
  userId: Scalars['Int'];
  filter: InputMaybe<QuoteAttributeFilterType>;
}>;


export type QuotesTotalAndUserAdminUserQuotesQuery = { __typename: 'Query', user: { __typename: 'User', id: number, email: any, salesForceAccountIdState: SalesForceAccountIdStateEnum | null, displayName: string, hasSecurePlusMemberships: boolean, roles: Array<{ __typename: 'Role', id: number, name: string | null, source: RoleSourceType }>, businessAccountMembership: { __typename: 'BusinessAccountMembership', businessAccount: { __typename: 'BusinessAccount', id: any, name: string, isEnabled: boolean, isTeamsFeatureEnabled: boolean | null } } | null, quotes: { __typename: 'PartialQuoteViewResults', totalCount: number } | null } | null };

export type AdminOboQuotesListMoveToQuoteModalQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type AdminOboQuotesListMoveToQuoteModalQuery = { __typename: 'Query', user: { __typename: 'User', id: number, quotes: { __typename: 'PartialQuoteViewResults', items: Array<{ __typename: 'BasicQuote' } | { __typename: 'Quote', id: any, name: string, type: QuoteType, status: string, lastModified: any | null, requestedAt: any | null, quoteModels: { __typename: 'PartialQuoteModelResults', totalCount: number }, project: { __typename: 'BasicProject', isSecurePlus: boolean, name: string, id: any | null } | null }> } | null } | null };

export type EstimateItemModelAttachmentMarkupsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type EstimateItemModelAttachmentMarkupsQuery = { __typename: 'Query', estimateItem: { __typename: 'EstimateItem', id: any, supportingDocUrl: string | null, revision: { __typename: 'Revision', modelFileName: string | null }, modelAttachmentSelections: Array<{ __typename: 'ModelAttachmentSelection', id: any, documentPage: number, positionX: number, positionY: number, height: number | null, width: number | null, text: string | null, modelAttachmentAnnotation: { __typename: 'ModelAttachmentAnnotation', id: any, positionX: number, positionY: number, documentPage: number, radius: number, label: number } | null }>, modelAttachmentSanitizations: Array<{ __typename: 'ModelAttachmentSelection', id: any, documentPage: number, positionX: number, positionY: number, height: number | null, width: number | null }> } | null };

export type EstimateItemSupportingDocUploadUrlQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type EstimateItemSupportingDocUploadUrlQuery = { __typename: 'Query', estimateItem: { __typename: 'EstimateItem', id: any, sanitizedSupportingDocUploadUrl: string | null } | null };

export type EstimateItemCalloutLabelsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type EstimateItemCalloutLabelsQuery = { __typename: 'Query', estimateItem: { __typename: 'EstimateItem', id: any, modelAttachmentSelections: Array<{ __typename: 'ModelAttachmentSelection', id: any, modelAttachmentAnnotation: { __typename: 'ModelAttachmentAnnotation', id: any, label: number } | null }> } | null };

export type CreateModelAttachmentCalloutMutationVariables = Exact<{
  modelAttachmentAnnotationInput: ModelAttachmentAnnotationInput;
  modelAttachmentSelectionInput: ModelAttachmentSelectionInput;
}>;


export type CreateModelAttachmentCalloutMutation = { __typename: 'Mutation', createModelAttachmentCallout: { __typename: 'ModelAttachmentSelection', id: any, documentPage: number, positionX: number, positionY: number, width: number | null, height: number | null, text: string | null, modelAttachmentAnnotation: { __typename: 'ModelAttachmentAnnotation', id: any, documentPage: number, positionX: number, positionY: number, radius: number, label: number } | null } };

export type ReplaceAllModelAttachmentCalloutsMutationVariables = Exact<{
  modelAttachmentCalloutInputs: Array<ModelAttachmentCalloutInput> | ModelAttachmentCalloutInput;
  attachmentId: InputMaybe<Scalars['UUID']>;
}>;


export type ReplaceAllModelAttachmentCalloutsMutation = { __typename: 'Mutation', replaceAllModelAttachmentCallouts: Array<{ __typename: 'ModelAttachmentSelection', id: any, documentPage: number, positionX: number, positionY: number, width: number | null, height: number | null, text: string | null, modelAttachmentAnnotation: { __typename: 'ModelAttachmentAnnotation', id: any, documentPage: number, positionX: number, positionY: number, radius: number, label: number } | null }> };

export type CreateModelAttachmentSanitizationMutationVariables = Exact<{
  input: ModelAttachmentSelectionInput;
}>;


export type CreateModelAttachmentSanitizationMutation = { __typename: 'Mutation', createModelAttachmentSanitization: { __typename: 'ModelAttachmentSelection', id: any, documentPage: number, positionX: number, positionY: number, width: number | null, height: number | null } };

export type DestroyModelAttachmentCalloutsMutationVariables = Exact<{
  calloutIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type DestroyModelAttachmentCalloutsMutation = { __typename: 'Mutation', destroyModelAttachmentCallouts: Array<any> };

export type DestroyModelAttachmentSanitizationsMutationVariables = Exact<{
  sanitizationIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type DestroyModelAttachmentSanitizationsMutation = { __typename: 'Mutation', destroyModelAttachmentSanitizations: Array<any> };

export type UpdateModelAttachmentAnnotationMutationVariables = Exact<{
  id: Scalars['UUID'];
  input: ModelAttachmentAnnotationInput;
}>;


export type UpdateModelAttachmentAnnotationMutation = { __typename: 'Mutation', updateModelAttachmentAnnotation: { __typename: 'ModelAttachmentAnnotation', id: any, documentPage: number, positionX: number, positionY: number, radius: number, label: number } };

export type QuoteModelRevisionAttachmentMarkupsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type QuoteModelRevisionAttachmentMarkupsQuery = { __typename: 'Query', quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, attachmentLink: { __typename: 'QuoteModelRevisionAttachment', id: any, quoteAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, downloadUrl: string | null, fileName: string, annotated: { __typename: 'AnnotatedAttachment', id: any, fileName: string, downloadUrl: string | null } | null, modelAttachmentSelections: Array<{ __typename: 'ModelAttachmentSelection', id: any, documentPage: number, positionX: number, positionY: number, height: number | null, width: number | null, text: string | null, modelAttachmentAnnotation: { __typename: 'ModelAttachmentAnnotation', id: any, positionX: number, positionY: number, documentPage: number, radius: number, label: number } | null }>, modelAttachmentSanitizations: Array<{ __typename: 'ModelAttachmentSelection', id: any, documentPage: number, positionX: number, positionY: number, height: number | null, width: number | null }> } | null } } | null } | null };

export type CreateSanitizedAttachmentBubbleDrawingMutationVariables = Exact<{
  attachmentId: Scalars['UUID'];
  uploadMetadata: AttachmentInput;
  quoteModelRevisionId: InputMaybe<Scalars['UUID']>;
}>;


export type CreateSanitizedAttachmentBubbleDrawingMutation = { __typename: 'Mutation', createSanitizedAttachment: { __typename: 'SanitizedAttachment', id: any, uploadUrl: string | null } };

export type MarkUploadedSanitizedAttachmentBubbleDrawingMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type MarkUploadedSanitizedAttachmentBubbleDrawingMutation = { __typename: 'Mutation', markUploadedSanitizedAttachment: { __typename: 'SanitizedAttachment', id: any } };

export type QuoteModelRevisionCalloutLabelsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type QuoteModelRevisionCalloutLabelsQuery = { __typename: 'Query', quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, attachmentLink: { __typename: 'QuoteModelRevisionAttachment', id: any, quoteAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, modelAttachmentSelections: Array<{ __typename: 'ModelAttachmentSelection', id: any, userAnnotationsId: any | null, modelAttachmentAnnotation: { __typename: 'ModelAttachmentAnnotation', id: any, label: number } | null }> } | null } } | null } | null };

export type BusinessAccountInviteTypeFragment = { __typename: 'BusinessAccountInvite', email: string, inviteUrl: string | null };

export type BusinessAccountInviteErrorTypeFragment = { __typename: 'SendBusinessAccountInviteError', email: string, errorCode: SendBusinessAccountInviteErrorCode | null, currentSalesforceAccountUrl: string | null, currentSalesforceAccountName: string | null, targetSalesforceAccountUrl: string | null, targetSalesforceAccountName: string | null, businessAccountName: string | null, businessAccountUrl: string | null };

export type SendBusinessAccountInvitesMutationVariables = Exact<{
  businessAccountId: Scalars['UUID'];
  emails: Array<Scalars['String']> | Scalars['String'];
}>;


export type SendBusinessAccountInvitesMutation = { __typename: 'Mutation', sendBusinessAccountInvites: { __typename: 'SendBusinessAccountInviteResult', invites: Array<{ __typename: 'BusinessAccountInvite', email: string, inviteUrl: string | null }>, errors: Array<{ __typename: 'SendBusinessAccountInviteError', email: string, errorCode: SendBusinessAccountInviteErrorCode | null, currentSalesforceAccountUrl: string | null, currentSalesforceAccountName: string | null, targetSalesforceAccountUrl: string | null, targetSalesforceAccountName: string | null, businessAccountName: string | null, businessAccountUrl: string | null }> | null } };

export type BusinessAccountOrdersQueryQueryVariables = Exact<{
  businessAccountId: Scalars['String'];
  searchText: InputMaybe<Scalars['String']>;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type BusinessAccountOrdersQueryQuery = { __typename: 'Query', businessAccountOrders: { __typename: 'PartialBusinessAccountOrdersResult', totalCount: number, items: Array<{ __typename: 'BusinessAccountOrder', id: string, name: string | null, purchaserEmail: string, purchaserId: number, status: string, createdAt: any, updatedAt: any }> } };

export type BusinessAccountQuotesQueryQueryVariables = Exact<{
  businessAccountId: Scalars['String'];
  searchText: InputMaybe<Scalars['String']>;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type BusinessAccountQuotesQueryQuery = { __typename: 'Query', businessAccountQuotes: { __typename: 'PartialBusinessAccountQuotesResult', totalCount: number, items: Array<{ __typename: 'BusinessAccountQuote', quoteId: string, quoteName: string, ownerEmail: string, ownerEnabled: boolean, ownerId: number, status: string | null, createdAt: any, updatedAt: any }> } };

export type UpsertBusinessAccountPunchoutFeatureMutationVariables = Exact<{
  businessAccountId: Scalars['UUID'];
  disabledProcesses: InputMaybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
}>;


export type UpsertBusinessAccountPunchoutFeatureMutation = { __typename: 'Mutation', upsertBusinessAccountPunchoutFeature: { __typename: 'BusinessAccountPunchoutFeature', id: number } | null };

export type PunchoutFeatureFragment = { __typename: 'BusinessAccountPunchoutFeature', disabledProcesses: string | null, isActive: boolean, sharedSecret: string, updatedAt: any };

export type BusinessAccountPunchoutFeatureQueryVariables = Exact<{
  businessAccountId: Scalars['UUID'];
}>;


export type BusinessAccountPunchoutFeatureQuery = { __typename: 'Query', businessAccountPunchoutFeature: { __typename: 'BusinessAccountPunchoutFeature', disabledProcesses: string | null, isActive: boolean, sharedSecret: string, updatedAt: any } | null };

export type BusinessAccountAdminDiscountQueryVariables = Exact<{
  businessAccountId: Scalars['String'];
}>;


export type BusinessAccountAdminDiscountQuery = { __typename: 'Query', businessAccount: { __typename: 'BusinessAccount', id: any, discount: { __typename: 'BusinessAccountDiscount', id: number, percent: number, salesforceOpportunityId: string, salesforceOpportunityName: string, startAt: any, endAt: any, isActive: boolean, notes: string | null, createdAt: any, createdBy: { __typename: 'BasicUser', id: number, firstName: string | null, lastName: string | null } } | null } };

export type BusinessAccountFragment = { __typename: 'BusinessAccount', id: any, createdAt: any, isEnabled: boolean, enabledAt: any | null, name: string, isTeamsFeatureEnabled: boolean | null, totalMembers: number, totalTeams: number, salesforceAccount: { __typename: 'SalesforceAccount', url: string } | null, subscription: { __typename: 'BusinessAccountSubscription', id: number, enabledAt: any, expiresAt: any, disabledAt: any | null, durationDays: number, status: BusinessAccountSubscriptionStatus, businessAccountId: any, planId: any, enabledBy: { __typename: 'User', id: number, displayName: string, email: any }, disabledBy: { __typename: 'User', id: number, displayName: string, email: any } | null, plan: { __typename: 'BusinessAccountPlan', id: number, planName: string, planId: any, durationDays: number } } | null, excludedCountries: Array<{ __typename: 'BusinessAccountExcludedCountry', name: string | null, value: string | null } | null> | null };

export type BusinessAccountQueryVariables = Exact<{
  businessAccountId: Scalars['String'];
}>;


export type BusinessAccountQuery = { __typename: 'Query', businessAccount: { __typename: 'BusinessAccount', id: any, createdAt: any, isEnabled: boolean, enabledAt: any | null, name: string, isTeamsFeatureEnabled: boolean | null, totalMembers: number, totalTeams: number, salesforceAccount: { __typename: 'SalesforceAccount', url: string } | null, subscription: { __typename: 'BusinessAccountSubscription', id: number, enabledAt: any, expiresAt: any, disabledAt: any | null, durationDays: number, status: BusinessAccountSubscriptionStatus, businessAccountId: any, planId: any, enabledBy: { __typename: 'User', id: number, displayName: string, email: any }, disabledBy: { __typename: 'User', id: number, displayName: string, email: any } | null, plan: { __typename: 'BusinessAccountPlan', id: number, planName: string, planId: any, durationDays: number } } | null, excludedCountries: Array<{ __typename: 'BusinessAccountExcludedCountry', name: string | null, value: string | null } | null> | null } };

export type CreateBusinessAccountDiscountMutationVariables = Exact<{
  businessAccountId: Scalars['String'];
  businessAccountDiscountDataInput: BusinessAccountDiscountDataInput;
}>;


export type CreateBusinessAccountDiscountMutation = { __typename: 'Mutation', createBusinessAccountDiscount: { __typename: 'BusinessAccountDiscount', id: number, percent: number, salesforceOpportunityId: string, startAt: any, endAt: any, isActive: boolean, notes: string | null, createdAt: any, createdBy: { __typename: 'BasicUser', id: number, firstName: string | null, lastName: string | null } } };

export type DeleteBusinessAccountDiscountMutationVariables = Exact<{
  businessAccountId: Scalars['String'];
}>;


export type DeleteBusinessAccountDiscountMutation = { __typename: 'Mutation', deactivateBusinessAccountDiscount: { __typename: 'BusinessAccountDiscount', id: number } | null };

export type BusinessAccountFeatureItemFragment = { __typename: 'BusinessAccountFeature', id: any, businessAccountId: any, featureName: BusinessAccountFeatureInput, isEnabled: boolean, updatedAt: any };

export type GetAllBusinessAccountFeaturesQueryVariables = Exact<{
  businessAccountId: Scalars['UUID'];
}>;


export type GetAllBusinessAccountFeaturesQuery = { __typename: 'Query', getAllBusinessAccountFeatures: Array<{ __typename: 'BusinessAccountFeature', id: any, businessAccountId: any, featureName: BusinessAccountFeatureInput, isEnabled: boolean, updatedAt: any }> };

export type UpdateBusinessAccountDiscountMutationVariables = Exact<{
  businessAccountId: Scalars['String'];
  businessAccountDiscountDataInput: BusinessAccountDiscountDataInput;
}>;


export type UpdateBusinessAccountDiscountMutation = { __typename: 'Mutation', updateBusinessAccountDiscount: { __typename: 'BusinessAccountDiscount', id: number, percent: number, salesforceOpportunityId: string, startAt: any, endAt: any, isActive: boolean, notes: string | null, createdAt: any, createdBy: { __typename: 'BasicUser', id: number, firstName: string | null, lastName: string | null } } };

export type CreateBusinessAccountSubscriptionMutationVariables = Exact<{
  businessAccountId: Scalars['String'];
  planId: Scalars['String'];
  expiration: Scalars['Date'];
  setActive: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateBusinessAccountSubscriptionMutation = { __typename: 'Mutation', createBusinessAccountSubscription: { __typename: 'BusinessAccountSubscription', id: number, enabledAt: any, expiresAt: any, disabledAt: any | null, status: BusinessAccountSubscriptionStatus, durationDays: number, enabledBy: { __typename: 'User', id: number, displayName: string, email: any }, disabledBy: { __typename: 'User', id: number, displayName: string, email: any } | null, plan: { __typename: 'BusinessAccountPlan', id: number, planName: string, planId: any, durationDays: number } } };

export type EnableOrDisableBusinessAccountSubscriptionMutationVariables = Exact<{
  subscriptionId: Scalars['Int'];
  status: BusinessAccountSubscriptionEnablementStatus;
}>;


export type EnableOrDisableBusinessAccountSubscriptionMutation = { __typename: 'Mutation', updateBusinessAccountSubscription: { __typename: 'BusinessAccountSubscription', id: number, enabledAt: any, expiresAt: any, disabledAt: any | null, status: BusinessAccountSubscriptionStatus, durationDays: number, enabledBy: { __typename: 'User', id: number, displayName: string, email: any }, disabledBy: { __typename: 'User', id: number, displayName: string, email: any } | null, plan: { __typename: 'BusinessAccountPlan', id: number, planName: string, planId: any, durationDays: number } } };

export type BusinessAccountPlansQueryVariables = Exact<{
  includeDisabled: InputMaybe<Scalars['Boolean']>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
}>;


export type BusinessAccountPlansQuery = { __typename: 'Query', businessAccountPlans: { __typename: 'PartialBusinessAccountPlanResults', totalCount: number, items: Array<{ __typename: 'BusinessAccountPlan', id: number, planId: any, planName: string, durationDays: number }> | null } | null };

export type BusinessAccountSubscriptionFragment = { __typename: 'BusinessAccountSubscription', id: number, enabledAt: any, expiresAt: any, disabledAt: any | null, durationDays: number, status: BusinessAccountSubscriptionStatus, businessAccountId: any, planId: any, enabledBy: { __typename: 'User', id: number, displayName: string, email: any }, disabledBy: { __typename: 'User', id: number, displayName: string, email: any } | null, plan: { __typename: 'BusinessAccountPlan', id: number, planName: string, planId: any, durationDays: number } };

export type BusinessAccountSubscriptionQueryVariables = Exact<{
  businessAccountId: Scalars['String'];
}>;


export type BusinessAccountSubscriptionQuery = { __typename: 'Query', businessAccount: { __typename: 'BusinessAccount', id: any, subscription: { __typename: 'BusinessAccountSubscription', id: number, enabledAt: any, expiresAt: any, disabledAt: any | null, durationDays: number, status: BusinessAccountSubscriptionStatus, businessAccountId: any, planId: any, enabledBy: { __typename: 'User', id: number, displayName: string, email: any }, disabledBy: { __typename: 'User', id: number, displayName: string, email: any } | null, plan: { __typename: 'BusinessAccountPlan', id: number, planName: string, planId: any, durationDays: number } } | null } };

export type BusinessAccountSubscriptionHistoryQueryVariables = Exact<{
  businessAccountId: Scalars['String'];
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
}>;


export type BusinessAccountSubscriptionHistoryQuery = { __typename: 'Query', businessAccount: { __typename: 'BusinessAccount', id: any, subscriptionHistory: { __typename: 'PartialBusinessAccountSubscriptionHistoryResults', count: number, subscriptions: Array<{ __typename: 'BusinessAccountSubscription', id: number, enabledAt: any, expiresAt: any, disabledAt: any | null, durationDays: number, status: BusinessAccountSubscriptionStatus, businessAccountId: any, planId: any, enabledBy: { __typename: 'User', id: number, displayName: string, email: any }, disabledBy: { __typename: 'User', id: number, displayName: string, email: any } | null, plan: { __typename: 'BusinessAccountPlan', id: number, planName: string, planId: any, durationDays: number } }> } } };

export type BusinessAccountMembersQueryQueryVariables = Exact<{
  filters: InputMaybe<BusinessAccountMembersFilterInput>;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type BusinessAccountMembersQueryQuery = { __typename: 'Query', businessAccountMembers: { __typename: 'PartialBusinessAccountMembersResults', totalCount: number, items: Array<{ __typename: 'BusinessAccountMembership', id: any, salesforceContactUrl: string | null, createdAt: any | null, lastLoginDate: any | null, capabilities: Array<string> | null, user: { __typename: 'User', id: number, displayName: string, email: any, enabled: boolean } } | null> } };

export type BusinessAccountPendingMembersQueryQueryVariables = Exact<{
  filters: InputMaybe<BusinessAccountPendingMembersFilterInput>;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type BusinessAccountPendingMembersQueryQuery = { __typename: 'Query', businessAccountPendingMembers: { __typename: 'PartialBusinessAccountPendingMembersResults', totalCount: number, items: Array<{ __typename: 'BusinessAccountPendingMember', lastLoginDate: any | null, salesforceContactUrl: string | null, capabilities: Array<string>, invite: { __typename: 'BusinessAccountInvite', id: any, email: string, sentDate: any | null, status: BusinessAccountInviteStatus } | null, user: { __typename: 'BasicUser', id: number, displayName: string, email: any } | null }> } };

export type BusinessAccountContactsQueryVariables = Exact<{
  businessAccountId: Scalars['String'];
  searchText: InputMaybe<Scalars['String']>;
  membershipFilters: InputMaybe<Array<BusinessAccountMembershipFilterType> | BusinessAccountMembershipFilterType>;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type BusinessAccountContactsQuery = { __typename: 'Query', businessAccountContacts: { __typename: 'PartialBusinessAccountContactsResults', totalCount: number, items: Array<{ __typename: 'BusinessAccountContact', status: BusinessAccountContactStatus | null, lastLoginDate: any | null, user: { __typename: 'BasicUser', id: number, displayName: string, email: any, createdAt: any, enabled: boolean } | null }> } };

export type TeamsQueryVariables = Exact<{
  filters: InputMaybe<TeamsFilterInput>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
}>;


export type TeamsQuery = { __typename: 'Query', teams: { __typename: 'PartialTeamsResult', totalCount: number, items: Array<{ __typename: 'Team', id: number, name: string, totalMembers: number | null, totalQuotes: number | null, totalSalesOrders: number | null, createdAt: any, createdBy: { __typename: 'BasicUser', email: any, id: number } }> } };

export type UpdateBusinessAccountNameMutationVariables = Exact<{
  businessAccountId: Scalars['UUID'];
  name: Scalars['String'];
}>;


export type UpdateBusinessAccountNameMutation = { __typename: 'Mutation', updateBusinessAccount: { __typename: 'BusinessAccount', id: any, name: string, updatedAt: any, updatedBy: { __typename: 'User', id: number, displayName: string, email: any } } };

export type BusinessAccountDiscountAdminBusinessAccountDicountSectionQueryVariables = Exact<{
  businessAccountId: Scalars['String'];
}>;


export type BusinessAccountDiscountAdminBusinessAccountDicountSectionQuery = { __typename: 'Query', businessAccount: { __typename: 'BusinessAccount', id: any, discount: { __typename: 'BusinessAccountDiscount', id: number, percent: number, salesforceOpportunityId: string, salesforceOpportunityName: string, startAt: any, endAt: any, isActive: boolean, notes: string | null, createdAt: any, createdBy: { __typename: 'BasicUser', id: number, firstName: string | null, lastName: string | null } } | null } };

export type CreateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutationVariables = Exact<{
  businessAccountId: Scalars['String'];
  businessAccountDiscountDataInput: BusinessAccountDiscountDataInput;
}>;


export type CreateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation = { __typename: 'Mutation', createBusinessAccountDiscount: { __typename: 'BusinessAccountDiscount', id: number, percent: number, salesforceOpportunityId: string, startAt: any, endAt: any, isActive: boolean, notes: string | null, createdAt: any, createdBy: { __typename: 'BasicUser', id: number, firstName: string | null, lastName: string | null } } };

export type UpdateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutationVariables = Exact<{
  businessAccountId: Scalars['String'];
  businessAccountDiscountDataInput: BusinessAccountDiscountDataInput;
}>;


export type UpdateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation = { __typename: 'Mutation', updateBusinessAccountDiscount: { __typename: 'BusinessAccountDiscount', id: number, percent: number, salesforceOpportunityId: string, startAt: any, endAt: any, isActive: boolean, notes: string | null, createdAt: any, createdBy: { __typename: 'BasicUser', id: number, firstName: string | null, lastName: string | null } } };

export type DeleteBusinessAccountDiscountAdminBusinessAccountDiscountFormMutationVariables = Exact<{
  businessAccountId: Scalars['String'];
}>;


export type DeleteBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation = { __typename: 'Mutation', deactivateBusinessAccountDiscount: { __typename: 'BusinessAccountDiscount', id: number } | null };

export type GetAllBusinessAccountFeaturesQueryQueryVariables = Exact<{
  businessAccountId: Scalars['UUID'];
}>;


export type GetAllBusinessAccountFeaturesQueryQuery = { __typename: 'Query', getAllBusinessAccountFeatures: Array<{ __typename: 'BusinessAccountFeature', id: any, businessAccountId: any, featureName: BusinessAccountFeatureInput, isEnabled: boolean, updatedAt: any }> };

export type MessageManagemenPageDfmFeedbackMessagesQueryVariables = Exact<{
  platformProcessId: InputMaybe<Scalars['String']>;
  type: InputMaybe<DfmFeedbackMessageType>;
  topicId: InputMaybe<Scalars['UUID']>;
  disabled: InputMaybe<Scalars['Boolean']>;
}>;


export type MessageManagemenPageDfmFeedbackMessagesQuery = { __typename: 'Query', dfmFeedbackMessages: Array<{ __typename: 'DfmFeedbackMessage', id: any, code: string, type: DfmFeedbackMessageType, disabled: boolean, severity: string | null, message: string, platformProcessId: string, link: string | null, title: string, createdAt: any, updatedAt: any, deletedAt: any | null, dfmTopic: { __typename: 'Topic', id: any, label: string } | null, createdBy: { __typename: 'BasicUser', id: number }, updatedBy: { __typename: 'BasicUser', id: number, displayName: string }, deletedBy: { __typename: 'BasicUser', id: number } | null }> | null };

export type CreateDfmFeedbackMessageMutationVariables = Exact<{
  code: Scalars['String'];
  type: DfmFeedbackMessageType;
  severity: DfmFeedbackSeverity;
  platformProcessId: Scalars['String'];
  title: Scalars['String'];
  message: Scalars['String'];
  link: InputMaybe<Scalars['String']>;
  topicId: InputMaybe<Scalars['UUID']>;
  disabled: Scalars['Boolean'];
}>;


export type CreateDfmFeedbackMessageMutation = { __typename: 'Mutation', createDfmFeedbackMessage: { __typename: 'DfmFeedbackMessage', id: any } | null };

export type EditDfmFeedbackMessageMutationVariables = Exact<{
  id: Scalars['UUID'];
  severity: DfmFeedbackSeverity;
  title: Scalars['String'];
  message: Scalars['String'];
  platformProcessId: Scalars['String'];
  link: InputMaybe<Scalars['String']>;
  disabled: Scalars['Boolean'];
}>;


export type EditDfmFeedbackMessageMutation = { __typename: 'Mutation', editDfmFeedbackMessage: { __typename: 'DfmFeedbackMessage', id: any } | null };

export type QmrGenerateDrawingEndpointQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type QmrGenerateDrawingEndpointQuery = { __typename: 'Query', quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, fictivSupportingDocTemplateUrl: string | null, modelConfiguration: { __typename: 'ModelConfiguration', material: { __typename: 'Material', id: string, name: string } | { __typename: 'UserEnteredMaterial', id: string, name: string } | null, color: { __typename: 'Color', id: string, name: string } | null, process: { __typename: 'Process', id: string, name: string } | null, shore: { __typename: 'Shore', id: string, name: string } | null, texture: { __typename: 'Texture', id: string, name: string } | null } | null, processesDetails: { __typename: 'QmrProcessesDetails', postProcesses: Array<{ __typename: 'QmrPostProcessWithPriceAndLead', postProcessNumParts: number | null, postProcessInspectionCriteria: ProcessInspectionCriteria | null, postProcess: { __typename: 'PostProcess', id: string, name: string }, postProcessColor: { __typename: 'Color', id: string, name: string } | null, postProcessThickness: { __typename: 'Thickness', id: string, name: string } | null }>, secondaryProcesses: Array<{ __typename: 'QmrSecondaryProcessDetails', notes: string | null, process: { __typename: 'PostProcess', id: string, name: string } }> } | null, partRevision: { __typename: 'Revision', id: any, downloadUri: string | null, modelFileName: string | null, units: string | null, createdAt: any, updatedAt: any, status: string | null, thumbnailUri: string | null, rawAnalysis: any | null, sceneBundle: any | null, boundingBox: { __typename: 'Vector3', x: number, y: number, z: number } | null, scene: { __typename: 'ViewerScene', featureMapping: { __typename: 'SceneFile', url: string } | null, geometry: { __typename: 'SceneFile', url: string } | null, thinWall: { __typename: 'SceneFile', url: string } | null, sharpInternalCorners: { __typename: 'SceneFile', url: string } | null, unreachableSurfaces: { __typename: 'SceneFile', url: string } | null, imThickWallAbs: { __typename: 'SceneFile', url: string } | null, imSharpEdges: { __typename: 'SceneFile', url: string } | null, imSideActions: { __typename: 'SceneFile', url: string } | null, imPartingLine: { __typename: 'SceneFile', url: string } | null } | null }, holes: Array<{ __typename: 'Hole', id: string, counterboreDiameter: number | null, countersinkDiameter: number | null, counterboreDepth: number | null, depth: number | null, diameter: number | null, direction: any | null, endPoint: Array<number> | null, groupKey: string, isBlind: boolean | null, startPoint: Array<number> | null, tipAngle: number | null, type: string, tapAnnotation: { __typename: 'TapAnnotation', id: any, tapOption: { __typename: 'TapOption', id: string, commonName: string } | null } | null, tapOptions: Array<{ __typename: 'TapOption', id: string, commonName: string, maxDepth: number }> }> } | null };

export type DrawingGeneratorAnnotationFragment = { __typename: 'Annotation', id: any, message: string | null, position: any, target: any, feature: string | null, type: string, accepted: boolean, severity: string, deletedAt: any | null, createdAt: any };

export type DrawingGeneratorSceneFragment = { __typename: 'ViewerScene', featureMapping: { __typename: 'SceneFile', url: string } | null, geometry: { __typename: 'SceneFile', url: string } | null, thinWall: { __typename: 'SceneFile', url: string } | null, sharpInternalCorners: { __typename: 'SceneFile', url: string } | null, unreachableSurfaces: { __typename: 'SceneFile', url: string } | null, imThickWallAbs: { __typename: 'SceneFile', url: string } | null, imSharpEdges: { __typename: 'SceneFile', url: string } | null, imSideActions: { __typename: 'SceneFile', url: string } | null, imPartingLine: { __typename: 'SceneFile', url: string } | null };

export type GenericPartInfoSearchQueryVariables = Exact<{
  searchString: Scalars['String'];
}>;


export type GenericPartInfoSearchQuery = { __typename: 'Query', genericPartInfoSearch: Array<{ __typename: 'PartSearchInfo', qmrId: any | null, partRevisionUuid: any | null, quoteItemId: any | null, eiUuid: any | null, partId: number | null, modelFileName: string | null, userId: number | null, email: string | null, matchedText: string | null, partCreatedAt: string | null, orderName: string | null, quoteName: string | null, quoteId: any | null, quoteItemDeletedAt: string | null, hasAttachedPdf: boolean | null, quoteStatus: string | null } | null> | null };

export type UpdateJobBoardRegionConfigurationMutationVariables = Exact<{
  jobBoardRegionId: Scalars['UUID'];
  configurationInput: UpdateJobBoardRegionConfigurationInput;
}>;


export type UpdateJobBoardRegionConfigurationMutation = { __typename: 'Mutation', updateJobBoardRegionConfiguration: { __typename: 'JobBoardRegion', id: any } };

export type UpdateJobBoardCalendarMutationVariables = Exact<{
  jobBoardId: Scalars['String'];
  updateJobBoardCalendar: UpdateJobBoardCalendarInput;
  isApplicableNextSevenDays: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateJobBoardCalendarMutation = { __typename: 'Mutation', updateJobBoardCalendar: Array<{ __typename: 'JobBoardCalendar', jobBoardId: string | null } | null> | null };

export type JobBoardRegion_ItemsFragment = { __typename: 'JobBoardRegion', acceptNowMultiplier: number, endTime: string, id: any, maxThresholdOfPayout: number, name: string, startTime: string, timezone: string, active: boolean, jobDuration: number | null };

export type JobBoardForRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type JobBoardForRegionsQuery = { __typename: 'Query', getActiveJobBoardRegions: Array<{ __typename: 'JobBoardRegion', acceptNowMultiplier: number, endTime: string, id: any, maxThresholdOfPayout: number, name: string, startTime: string, timezone: string, active: boolean, jobDuration: number | null }> | null };

export type GetJobBoardCalendarQueryVariables = Exact<{
  startDate: Scalars['String'];
  endDate: Scalars['String'];
}>;


export type GetJobBoardCalendarQuery = { __typename: 'Query', getJobBoardCalendar: Array<{ __typename: 'JobBoardCalendar', jobBoardId: string | null, status: string | null, active: boolean | null, jobBoardDate: any, startTime: string | null, endTime: string | null, maxThresholdOfPayout: number | null, acceptNowMultiplier: number | null, jobBoardRegionId: any, isEditable: boolean, jobBoardRegionName: string, jobDuration: number | null }> | null };

export type CurrentMarkupsAdjustmentPageQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentMarkupsAdjustmentPageQuery = { __typename: 'Query', currentMarkups: { __typename: 'MarkupData', quantityRanges: Array<number>, markups: { __typename: 'MarkupsByPriority', premium: Array<number>, rush: Array<number>, standard: Array<number>, economy: Array<number>, flex: Array<number>, saver: Array<number>, overseas: Array<number> } } };

export type AdjustCurrentMarkupsAdjustmentPageMutationVariables = Exact<{
  newMarkupData: MarkupDataInput;
}>;


export type AdjustCurrentMarkupsAdjustmentPageMutation = { __typename: 'Mutation', adjustCurrentMarkups: { __typename: 'MarkupData', quantityRanges: Array<number>, markups: { __typename: 'MarkupsByPriority', premium: Array<number>, rush: Array<number>, standard: Array<number>, economy: Array<number>, flex: Array<number>, saver: Array<number>, overseas: Array<number> } } };

export type ProcessesAdminQmrsQueueQueryVariables = Exact<{ [key: string]: never; }>;


export type ProcessesAdminQmrsQueueQuery = { __typename: 'Query', processes: Array<{ __typename: 'Process', id: string, name: string }> };

export type MaterialsAdminQmrsQueueQueryVariables = Exact<{
  processId: Scalars['String'];
}>;


export type MaterialsAdminQmrsQueueQuery = { __typename: 'Query', materials: Array<{ __typename: 'Material', id: string, name: string }> | null };

export type AdminQueueModelConfigurationFragment = { __typename: 'ModelConfiguration', id: any, quantity: number | null, process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string } | null, material: { __typename: 'Material', id: string, name: string } | { __typename: 'UserEnteredMaterial', id: string, name: string, process: { __typename: 'Process', id: string, name: string } } | null, color: { __typename: 'Color', id: string, name: string } | null, shore: { __typename: 'Shore', id: string, name: string } | null, texture: { __typename: 'Texture', id: string, name: string } | null, productionLeadTime: { __typename: 'ProductionLeadTime', id: string, priorityId: string, productionDays: number, shipDateEstimate: { __typename: 'ShipDateEstimate', id: string, validUntilDate: any, shippedByDate: any } } | null };

export type ReleaseRfqQuotesWithNoUnpublishedQmRsMutationVariables = Exact<{ [key: string]: never; }>;


export type ReleaseRfqQuotesWithNoUnpublishedQmRsMutation = { __typename: 'Mutation', releaseRFQQuotesWithNoUnpublishedQMRs: boolean | null };

export type AdminQuoteModelRevisionQueueItemFragment = { __typename: 'QuoteModelRevision', id: any, fileName: string, modelConfiguration: { __typename: 'ModelConfiguration', id: any, quantity: number | null, process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string } | null, material: { __typename: 'Material', id: string, name: string } | { __typename: 'UserEnteredMaterial', id: string, name: string, process: { __typename: 'Process', id: string, name: string } } | null, color: { __typename: 'Color', id: string, name: string } | null, shore: { __typename: 'Shore', id: string, name: string } | null, texture: { __typename: 'Texture', id: string, name: string } | null, productionLeadTime: { __typename: 'ProductionLeadTime', id: string, priorityId: string, productionDays: number, shipDateEstimate: { __typename: 'ShipDateEstimate', id: string, validUntilDate: any, shippedByDate: any } } | null } | null, quoteModel: { __typename: 'QuoteModel', id: any, quote: { __typename: 'Quote', id: any, name: string, status: string, lastModified: any | null, requestedAt: any | null, requestedBy: number | null, partialSubTotalInCents: number | null, numberOfParts: number, quoteProperties: Array<{ __typename: 'QuoteProperty', name: string, value: string }> | null, user: { __typename: 'BasicUser', id: number } } | null } };

export type AdminQuoteModelRevisionsQueueQueryVariables = Exact<{
  filters: InputMaybe<QuoteModelRevisionFiltersInput>;
  limit: Scalars['Int'];
  cursor: InputMaybe<Scalars['ENCODED_CURSOR']>;
}>;


export type AdminQuoteModelRevisionsQueueQuery = { __typename: 'Query', listAllQuoteModelRevisions: { __typename: 'PartialQuoteModelRevisionResults', totalCount: number, cursor: { __typename: 'Cursor', previous: any | null, next: any | null } | null, items: Array<{ __typename: 'QuoteModelRevision', id: any, fileName: string, modelConfiguration: { __typename: 'ModelConfiguration', id: any, quantity: number | null, process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string } | null, material: { __typename: 'Material', id: string, name: string } | { __typename: 'UserEnteredMaterial', id: string, name: string, process: { __typename: 'Process', id: string, name: string } } | null, color: { __typename: 'Color', id: string, name: string } | null, shore: { __typename: 'Shore', id: string, name: string } | null, texture: { __typename: 'Texture', id: string, name: string } | null, productionLeadTime: { __typename: 'ProductionLeadTime', id: string, priorityId: string, productionDays: number, shipDateEstimate: { __typename: 'ShipDateEstimate', id: string, validUntilDate: any, shippedByDate: any } } | null } | null, quoteModel: { __typename: 'QuoteModel', id: any, quote: { __typename: 'Quote', id: any, name: string, status: string, lastModified: any | null, requestedAt: any | null, requestedBy: number | null, partialSubTotalInCents: number | null, numberOfParts: number, quoteProperties: Array<{ __typename: 'QuoteProperty', name: string, value: string }> | null, user: { __typename: 'BasicUser', id: number } } | null } }> } };

export type UserEmailAndOrderCountQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UserEmailAndOrderCountQuery = { __typename: 'Query', user: { __typename: 'User', id: number, email: any, salesOrders: { __typename: 'PartialSalesOrderViewResults', totalCount: number } } | null };

export type DestroyProjectQuoteMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DestroyProjectQuoteMutation = { __typename: 'Mutation', destroyQuote: { __typename: 'Quote', id: any } | null };

export type UpdateProjectSettingsMutationMutationVariables = Exact<{
  id: Scalars['UUID'];
  projectInput: ProjectUpdateInput;
}>;


export type UpdateProjectSettingsMutationMutation = { __typename: 'Mutation', updateProject: { __typename: 'Project', id: any, name: string, description: string | null } | null };

export type GetProjectNameQueryProjectPageQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetProjectNameQueryProjectPageQuery = { __typename: 'Query', project: { __typename: 'Project', id: any, name: string } | null };

export type GetProjectQuotesQueryProjectQuoteTabQueryVariables = Exact<{
  id: Scalars['UUID'];
  limit: Scalars['Int'];
  offset: InputMaybe<Scalars['Int']>;
  sort: InputMaybe<Scalars['CreatedAtSortKey']>;
  cursor: InputMaybe<Scalars['ENCODED_CURSOR']>;
}>;


export type GetProjectQuotesQueryProjectQuoteTabQuery = { __typename: 'Query', project: { __typename: 'Project', id: any, name: string, quotes: { __typename: 'PartialQuoteResults', totalCount: number, items: Array<{ __typename: 'Quote', name: string, id: any, lastModified: any | null, user: { __typename: 'BasicUser', email: any, id: number }, activity: { __typename: 'PartialProjectActivityResults', items: Array<{ __typename: 'ProjectActivity', actor: { __typename: 'BasicUser', email: any } | null }> } }> } | null } | null };

export type GetProjectSalesOrderOrdersTabQueryVariables = Exact<{
  id: Scalars['UUID'];
  limit: Scalars['Int'];
  offset: InputMaybe<Scalars['Int']>;
  sort: InputMaybe<Scalars['CreatedAtSortKey']>;
  cursor: InputMaybe<Scalars['ENCODED_CURSOR']>;
}>;


export type GetProjectSalesOrderOrdersTabQuery = { __typename: 'Query', project: { __typename: 'Project', id: any, name: string, salesOrders: { __typename: 'PartialSalesOrderResults', totalCount: number, items: Array<{ __typename: 'SalesOrder', name: string, id: string, createdAt: any, paymentDetails: { __typename: 'PaymentDetails', id: string, paidBy: { __typename: 'BasicUser', id: number, email: any, displayName: string } | null }, quoteOwnerUser: { __typename: 'BasicUser', id: number } | null }> } } | null };

export type GetProjectMembersQueryVariables = Exact<{
  id: Scalars['UUID'];
  limit: Scalars['Int'];
  offset: InputMaybe<Scalars['Int']>;
  sort: InputMaybe<Scalars['CreatedAtSortKey']>;
  cursor: InputMaybe<Scalars['ENCODED_CURSOR']>;
}>;


export type GetProjectMembersQuery = { __typename: 'Query', project: { __typename: 'Project', id: any, memberships: { __typename: 'PartialProjectMembershipResults', totalCount: number, items: Array<{ __typename: 'ProjectMembership', id: any, isFictivEmployee: boolean, isQuoteOwner: boolean, isActive: boolean, updatedAt: any, user: { __typename: 'BasicUser', id: number, displayName: string, firstName: string | null, lastName: string | null, email: any }, updatedBy: { __typename: 'BasicUser', email: any } }> } } | null };

export type GetProjectMembersEmailListQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetProjectMembersEmailListQuery = { __typename: 'Query', project: { __typename: 'Project', id: any, memberships: { __typename: 'PartialProjectMembershipResults', items: Array<{ __typename: 'ProjectMembership', id: any, isActive: boolean, isFictivEmployee: boolean, user: { __typename: 'BasicUser', id: number, displayName: string, email: any } }> } } | null };

export type CreateSecureQuoteMutationMutationVariables = Exact<{
  name: InputMaybe<Scalars['String']>;
  description: InputMaybe<Scalars['String']>;
  userId: InputMaybe<Scalars['Int']>;
  projectId: InputMaybe<Scalars['UUID']>;
}>;


export type CreateSecureQuoteMutationMutation = { __typename: 'Mutation', createQuote: { __typename: 'Quote', id: any, name: string } };

export type CheckIfCurrentUserIsProjectMemberQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type CheckIfCurrentUserIsProjectMemberQuery = { __typename: 'Query', project: { __typename: 'Project', id: any, currentUserIsMember: boolean } | null };

export type GetProjectSettingsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetProjectSettingsQuery = { __typename: 'Query', project: { __typename: 'Project', id: any, name: string, description: string | null } | null };

export type RevokeProjectMembershipMutationVariables = Exact<{
  projectId: Scalars['UUID'];
  membershipId: Scalars['String'];
}>;


export type RevokeProjectMembershipMutation = { __typename: 'Mutation', revokeProjectMembership: { __typename: 'ProjectMembership', id: any } };

export type RestoreProjectMembershipMutationVariables = Exact<{
  projectId: Scalars['UUID'];
  membershipId: Scalars['String'];
}>;


export type RestoreProjectMembershipMutation = { __typename: 'Mutation', restoreProjectMembership: { __typename: 'ProjectMembership', id: any } };

export type AddProjectMemberMutationVariables = Exact<{
  projectId: Scalars['UUID'];
  userEmails: Array<Scalars['String']> | Scalars['String'];
}>;


export type AddProjectMemberMutation = { __typename: 'Mutation', addProjectMembers: Array<{ __typename: 'ProjectMembership', id: any }> };

export type GetUserProjectsQueryQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: InputMaybe<Scalars['Int']>;
  sort: InputMaybe<Scalars['CreatedAtSortKey']>;
  cursor: InputMaybe<Scalars['ENCODED_CURSOR']>;
}>;


export type GetUserProjectsQueryQuery = { __typename: 'Query', me: { __typename: 'User', id: number, projects: { __typename: 'PartialProjectResults', totalCount: number, items: Array<{ __typename: 'Project', id: any, name: string, description: string | null, createdAt: any, createdBy: { __typename: 'BasicUser', displayName: string }, updatedBy: { __typename: 'BasicUser', email: any } }> } } | null };

export type CreateProjectMutationMutationVariables = Exact<{
  projectInput: ProjectInput;
}>;


export type CreateProjectMutationMutation = { __typename: 'Mutation', createProject: { __typename: 'Project', id: any, name: string, description: string | null, createdAt: any, updatedAt: any } | null };

export type IsActiveUserEmailQueryQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type IsActiveUserEmailQueryQuery = { __typename: 'Query', isActiveUserEmail: boolean };

export type IsEmployeeEmailQueryQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type IsEmployeeEmailQueryQuery = { __typename: 'Query', isEmployeeEmail: boolean | null };

export type UpdateBusinessAccountFeatureMutationVariables = Exact<{
  businessAccountId: Scalars['UUID'];
  featureName: BusinessAccountFeatureInput;
  isEnabled: Scalars['Boolean'];
}>;


export type UpdateBusinessAccountFeatureMutation = { __typename: 'Mutation', setBusinessAccountFeature: { __typename: 'BusinessAccountFeature', id: any } | null };

export type DownloadDfmFeedbackForQmrMutationVariables = Exact<{
  qmrId: Scalars['UUID'];
  requestedByAdmin: InputMaybe<Scalars['Boolean']>;
  format: InputMaybe<Scalars['String']>;
}>;


export type DownloadDfmFeedbackForQmrMutation = { __typename: 'Mutation', downloadDfmFeedbackForQmr: { __typename: 'DfmLoadingStatus', uploadUrl: string | null, error: string | null, loading: boolean } | null };

export type IsMergedDfmReportReadyQueryVariables = Exact<{
  qmrId: Scalars['UUID'];
  requestedByAdmin: InputMaybe<Scalars['Boolean']>;
  format: InputMaybe<Scalars['String']>;
}>;


export type IsMergedDfmReportReadyQuery = { __typename: 'Query', isMergedDfmReportReady: { __typename: 'MergedDfmReadyStatus', loading: boolean, signedUrl: string | null, error: string | null } };

export type QmrFileNameDownloadImDfmReportPageQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type QmrFileNameDownloadImDfmReportPageQuery = { __typename: 'Query', quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, fileName: string } | null };

export type UpdateQuoteStatusToSentToPunchoutMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type UpdateQuoteStatusToSentToPunchoutMutation = { __typename: 'Mutation', updateQuoteStatusToSentToPunchout: { __typename: 'Quote', id: any } };

export type QmrItemFragment = { __typename: 'QuoteItem', quoteModelRevision: { __typename: 'QuoteModelRevision', isITARProhibitedViewing: boolean | null, fileName: string, id: any, processesDetails: { __typename: 'QmrProcessesDetails', primaryProcess: { __typename: 'QmrProcessWithPrice', process: { __typename: 'Process', platformProcessTypeId: string } } | null, postProcesses: Array<{ __typename: 'QmrPostProcessWithPriceAndLead', postProcess: { __typename: 'PostProcess', name: string } }>, secondaryProcesses: Array<{ __typename: 'QmrSecondaryProcessDetails', process: { __typename: 'PostProcess', name: string } }>, totalPrice: { __typename: 'EstimatedPrice' } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null } | null, modelConfiguration: { __typename: 'ModelConfiguration', quantity: number | null, productionLeadTime: { __typename: 'ProductionLeadTime', productionDays: number } | null } | null } };

export type QuoteQmrDataQueryVariables = Exact<{
  quoteId: Scalars['UUID'];
}>;


export type QuoteQmrDataQuery = { __typename: 'Query', quote: { __typename: 'Quote', isCpqQuote: boolean | null, quoteItems: { __typename: 'PartialQuoteItemResults', items: Array<{ __typename: 'QuoteItem', quoteModelRevision: { __typename: 'QuoteModelRevision', isITARProhibitedViewing: boolean | null, fileName: string, id: any, processesDetails: { __typename: 'QmrProcessesDetails', primaryProcess: { __typename: 'QmrProcessWithPrice', process: { __typename: 'Process', platformProcessTypeId: string } } | null, postProcesses: Array<{ __typename: 'QmrPostProcessWithPriceAndLead', postProcess: { __typename: 'PostProcess', name: string } }>, secondaryProcesses: Array<{ __typename: 'QmrSecondaryProcessDetails', process: { __typename: 'PostProcess', name: string } }>, totalPrice: { __typename: 'EstimatedPrice' } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null } | null, modelConfiguration: { __typename: 'ModelConfiguration', quantity: number | null, productionLeadTime: { __typename: 'ProductionLeadTime', productionDays: number } | null } | null } }> } } | null };

export type CreatePurchaseOrderMutationVariables = Exact<{
  input: PurchaseOrderInput;
  userId: InputMaybe<Scalars['Int']>;
}>;


export type CreatePurchaseOrderMutation = { __typename: 'Mutation', createPurchaseOrder: { __typename: 'PurchaseOrder', id: string, referenceId: string, fileName: string | null, createdAt: any | null, updatedAt: any | null, attachment: { __typename: 'Attachment', id: any, uploadUrl: string | null, downloadUrl: string | null, fileName: string, extension: string | null, mimeType: string | null, sizeInKb: number | null, createdAt: any, updatedAt: any } | null } };

export type MarkUploadedAttachmentPurchaseOrderPdfUploaderMutationVariables = Exact<{
  attachmentId: Scalars['UUID'];
}>;


export type MarkUploadedAttachmentPurchaseOrderPdfUploaderMutation = { __typename: 'Mutation', markUploadedAttachment: { __typename: 'Attachment', id: any, fileName: string, downloadUrl: string | null } };

export type ConsultativeDfmConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type ConsultativeDfmConfigurationQuery = { __typename: 'Query', listDFMConsultationRequestOptions: { __typename: 'ConsultativeDfmOptions', commentsMaxLength: number, sections: Array<{ __typename: 'ConsultativeDfmConfigSection', sectionKey: string, title: string, subtitle: string | null, separatorAfter: boolean, minChecked: number, options: Array<{ __typename: 'ConsultativeDfmConfigOption', key: string, label: string }> }> } };

export type CreateDfmConsultationRequestMutationVariables = Exact<{
  qmrId: InputMaybe<Scalars['UUID']>;
  quoteId: InputMaybe<Scalars['UUID']>;
  sections: InputMaybe<Array<InputMaybe<DfmConsultationRequestSectionInput>> | InputMaybe<DfmConsultationRequestSectionInput>>;
  notes: InputMaybe<Scalars['String']>;
}>;


export type CreateDfmConsultationRequestMutation = { __typename: 'Mutation', createDFMConsultationRequest: string | null };

export type UpsertQmrAttachmentAnnotationsMutationVariables = Exact<{
  quoteId: Scalars['UUID'];
  attachmentId: Scalars['UUID'];
  qmrId: Scalars['UUID'];
  qmrAttachmentAnnotationsInput: QmrAttachmentAnnotationsInput;
}>;


export type UpsertQmrAttachmentAnnotationsMutation = { __typename: 'Mutation', upsertQmrAttachmentAnnotations: { __typename: 'QmrAttachmentAnnotations', id: any, annotationsDataDownloadUrl: string, quoteModelRevisionId: string | null } | null };

export type ImColorsQueryVariables = Exact<{
  materialId: Scalars['String'];
}>;


export type ImColorsQuery = { __typename: 'Query', colors: Array<{ __typename: 'Color', id: string, name: string }> };

export type ImFinishDropdownQueryVariables = Exact<{
  processId: Scalars['String'];
}>;


export type ImFinishDropdownQuery = { __typename: 'Query', textures: Array<{ __typename: 'Texture', id: string, name: string, category: string | null }> };

export type ImMaterialsDropdownQueryVariables = Exact<{
  processId: Scalars['String'];
}>;


export type ImMaterialsDropdownQuery = { __typename: 'Query', materials: Array<{ __typename: 'Material', id: string, name: string, materialCategory: string | null }> | null };

export type ImUserEnteredMaterialsDropdownQueryVariables = Exact<{ [key: string]: never; }>;


export type ImUserEnteredMaterialsDropdownQuery = { __typename: 'Query', me: { __typename: 'User', id: number, userEnteredMaterials: Array<{ __typename: 'UserEnteredMaterial', id: string, name: string, process: { __typename: 'Process', id: string, name: string } }> } | null };

export type ImMaterialConfigurationOptionsQueryVariables = Exact<{
  materialId: Scalars['String'];
}>;


export type ImMaterialConfigurationOptionsQuery = { __typename: 'Query', materialConfigurationOptions: Array<{ __typename: 'MaterialConfigurationOption', id: string, colorId: string | null, colorName: string | null, shoreId: string | null, shoreName: string | null }> };

export type AddManuallyQuotedSecondaryProcessForBuilderMutationVariables = Exact<{
  ids: Array<Scalars['UUID']> | Scalars['UUID'];
  processId: Scalars['String'];
}>;


export type AddManuallyQuotedSecondaryProcessForBuilderMutation = { __typename: 'Mutation', addManuallyQuotedSecondaryProcessForBuilder: Array<any> };

export type BuilderImModelConfigurationFragment = { __typename: 'ModelConfiguration', id: any, materialGrade: string | null, colorCode: string | null, textureCode: string | null, hasMultipleFinishes: boolean, userNeedsConfigHelp: boolean, quantity: number | null, material: { __typename: 'Material', id: string, name: string } | { __typename: 'UserEnteredMaterial', id: string, name: string, process: { __typename: 'Process', id: string, name: string } } | null, color: { __typename: 'Color', id: string, name: string } | null, shore: { __typename: 'Shore', id: string, name: string } | null, texture: { __typename: 'Texture', id: string, name: string } | null, productionLeadTime: { __typename: 'ProductionLeadTime', id: string, priorityId: string, productionDays: number, shipDateEstimate: { __typename: 'ShipDateEstimate', id: string, validUntilDate: any, shippedByDate: any } } | null };

export type AdminUpdateImProcessConfigsOnQmrsMutationVariables = Exact<{
  ids: Array<Scalars['UUID']> | Scalars['UUID'];
  primaryProcessConfig: PrimaryProcessConfigInput;
  secondaryProcessConfigs: Array<SecondaryProcessConfigInput> | SecondaryProcessConfigInput;
  removeManuallyQuotedSecondaryProcesses: InputMaybe<Scalars['Boolean']>;
  additionalConfig: InputMaybe<AdditionalConfigInput>;
}>;


export type AdminUpdateImProcessConfigsOnQmrsMutation = { __typename: 'Mutation', updateProcessConfigsOnQuoteModelRevisions: Array<{ __typename: 'QuoteModelRevision', id: any, fileName: string, version: string, updatedAt: any, state: QuoteModelRevisionState, processesDetails: { __typename: 'QmrProcessesDetails', isBusinessAccountDiscountApplied: boolean | null, totalPrice: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null, primaryProcess: { __typename: 'QmrProcessWithPrice', process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string }, price: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null } | null, postProcesses: Array<{ __typename: 'QmrPostProcessWithPriceAndLead', unitPriceInCents: number | null, postProcessLeadTimeInDays: number | null, postProcessNumParts: number | null, postProcessInspectionCriteria: ProcessInspectionCriteria | null, postProcess: { __typename: 'PostProcess', id: string, name: string, typeName: string | null, colors: Array<{ __typename: 'Color', id: string, name: string } | null> | null, thicknesses: Array<{ __typename: 'Thickness', id: string, name: string, value: number } | null> | null }, postProcessThickness: { __typename: 'Thickness', id: string, name: string } | null, postProcessColor: { __typename: 'Color', id: string, name: string } | null }>, secondaryProcesses: Array<{ __typename: 'QmrSecondaryProcessDetails', unitPriceInCents: number | null, leadTimeInDays: number | null, notes: string | null, process: { __typename: 'PostProcess', id: string, name: string, typeName: string | null }, pricingAndLeadTimeFields: { __typename: 'HardwareInstallationManualQuoteCalcFields', international: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', markupPercentage: number, mpPayoutInCents: number | null, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, domestic: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', mpPayoutInCents: number | null, markupPercentage: number, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, lineItems: Array<{ __typename: 'HardwareLineItem', supplier: string | null, partNumber: string | null, qtyPerPart: number, pricePerPack: number, qtyPerPack: number }> | null } | { __typename: 'SecondaryProcessManualQuoteCalcFields', international: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', markupPercentage: number, mpPayoutInCents: number | null, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, domestic: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', mpPayoutInCents: number | null, markupPercentage: number, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null } | null }> } | null, modelConfiguration: { __typename: 'ModelConfiguration', id: any, materialGrade: string | null, colorCode: string | null, textureCode: string | null, hasMultipleFinishes: boolean, userNeedsConfigHelp: boolean, quantity: number | null, errorCode: string | null, updatedAt: any, dfmInspection: { __typename: 'ModelConfigurationDfmInspection', id: any | null, inspectionData: any, isPublished: boolean, quotedAt: any | null, quoteUpdatedAt: any | null, updatedAt: any, quotedBy: { __typename: 'BasicUser', id: number, displayName: string } | null, quoteUpdatedBy: { __typename: 'BasicUser', id: number, displayName: string } | null } | null, productionLeadTime: { __typename: 'ProductionLeadTime', id: string, priorityId: string, productionDays: number, primaryProductionDays: number, shipDateEstimate: { __typename: 'ShipDateEstimate', id: string, validUntilDate: any, shippedByDate: any } } | null, process: { __typename: 'Process', id: string, name: string } | null, material: { __typename: 'Material', id: string, name: string } | { __typename: 'UserEnteredMaterial', id: string, name: string } | null, color: { __typename: 'Color', id: string, name: string } | null, updatedBy: { __typename: 'BasicUser', id: number, email: any, updatedAt: any }, toolDetails: { __typename: 'ToolCosts', totalCost: number | null, tools: Array<{ __typename: 'Tool', id: string, type: string, diameter: number, length: number | null, ratio: number, price: number | null } | null> | null } | null } | null, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, isValid: boolean, message: string, title: string | null, link: string | null, code: string | null, isPublished: boolean, severity: string, sourceType: string | null, isAutoGeneratedDfm: boolean, createdAt: any, deletedAt: any | null, createdBy: { __typename: 'BasicUser', displayName: string, email: any }, modelViewerSnapshots: Array<{ __typename: 'ModelViewerSnapshot', id: any, snapshot: { __typename: 'ModelViewerConfig', rotation: Array<number> | null, camera: { __typename: 'ModelViewerCameraConfig', position: Array<number>, zoom: number, up: Array<number> | null, target: Array<number> | null } | null, part: { __typename: 'ModelViewerPartConfig', transparent: boolean, patches: Array<{ __typename: 'ModelViewerPatchConfig', color: string | null, hashcode: string }> }, dfm: Array<{ __typename: 'ModelViewerDfmFeatureConfig', color: string | null, threshold: number | null, feature: string | null, direction: Array<number> | null }>, annotations: Array<{ __typename: 'ModelViewerAnnotationConfig', position: Array<number> }>, crossSection: { __typename: 'ModelViewerCrossSectionConfig', position: any, rotation: any } | null, pointToPoint: { __typename: 'PointToPointConfig', customPoints: Array<any>, selectedPoints: Array<{ __typename: 'P2PPoint', index: number, type: P2PPointType }> } | null } | null }> }> }> };

export type UpdateOvermoldRequirementMutationVariables = Exact<{
  id: Scalars['UUID'];
  requiresOvermold: Scalars['Boolean'];
}>;


export type UpdateOvermoldRequirementMutation = { __typename: 'Mutation', updateOvermoldRequirement: { __typename: 'QuoteModelRevision', id: any, modelConfiguration: { __typename: 'ModelConfiguration', id: any, requiresOvermold: boolean } | null } };

export type UpdateImProcessConfigsOnQmrsMutationVariables = Exact<{
  ids: Array<Scalars['UUID']> | Scalars['UUID'];
  primaryProcessConfig: PrimaryProcessConfigInput;
  secondaryProcessConfigs: Array<SecondaryProcessConfigInput> | SecondaryProcessConfigInput;
  removeManuallyQuotedSecondaryProcesses: InputMaybe<Scalars['Boolean']>;
  additionalConfig: InputMaybe<AdditionalConfigInput>;
}>;


export type UpdateImProcessConfigsOnQmrsMutation = { __typename: 'Mutation', updateProcessConfigsOnQuoteModelRevisions: Array<{ __typename: 'QuoteModelRevision', id: any, modelConfiguration: { __typename: 'ModelConfiguration', id: any, materialGrade: string | null, colorCode: string | null, textureCode: string | null, hasMultipleFinishes: boolean, userNeedsConfigHelp: boolean, quantity: number | null, material: { __typename: 'Material', id: string, name: string } | { __typename: 'UserEnteredMaterial', id: string, name: string, process: { __typename: 'Process', id: string, name: string } } | null, color: { __typename: 'Color', id: string, name: string } | null, shore: { __typename: 'Shore', id: string, name: string } | null, texture: { __typename: 'Texture', id: string, name: string } | null, productionLeadTime: { __typename: 'ProductionLeadTime', id: string, priorityId: string, productionDays: number, shipDateEstimate: { __typename: 'ShipDateEstimate', id: string, validUntilDate: any, shippedByDate: any } } | null } | null, processesDetails: { __typename: 'QmrProcessesDetails', primaryProcess: { __typename: 'QmrProcessWithPrice', process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string }, price: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null } | null, postProcesses: Array<{ __typename: 'QmrPostProcessWithPriceAndLead', unitPriceInCents: number | null, postProcessLeadTimeInDays: number | null, postProcessNumParts: number | null, postProcessInspectionCriteria: ProcessInspectionCriteria | null, postProcess: { __typename: 'PostProcess', id: string, name: string }, postProcessThickness: { __typename: 'Thickness', id: string } | null, postProcessColor: { __typename: 'Color', id: string } | null }>, secondaryProcesses: Array<{ __typename: 'QmrSecondaryProcessDetails', unitPriceInCents: number | null, leadTimeInDays: number | null, notes: string | null, process: { __typename: 'PostProcess', id: string, name: string } }>, totalPrice: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null } | null }> };

export type RemoveImManuallyQuotedSecondaryProcessMutationVariables = Exact<{
  ids: Array<Scalars['UUID']> | Scalars['UUID'];
  processId: InputMaybe<Scalars['String']>;
}>;


export type RemoveImManuallyQuotedSecondaryProcessMutation = { __typename: 'Mutation', removeManuallyQuotedSecondaryProcess: Array<string> };

export type RequestImEstimateSlackNotificationMutationVariables = Exact<{
  qmrId: Scalars['UUID'];
}>;


export type RequestImEstimateSlackNotificationMutation = { __typename: 'Mutation', requestImEstimateSlackNotification: { __typename: 'RequestImEstimateSlackNotification', qmrId: any | null } | null };

export type GetPartEstimatedPriceForNonImModelsQueryVariables = Exact<{
  qmrIds: Array<Scalars['String']> | Scalars['String'];
  quantity: InputMaybe<Scalars['Int']>;
}>;


export type GetPartEstimatedPriceForNonImModelsQuery = { __typename: 'Query', getPartEstimatedPriceForNonImModels: Array<{ __typename: 'PartEstimatedPrices', partPrice: { __typename: 'EstimatedPrice', highUnitPriceInCents: number | null, lowUnitPriceInCents: number | null } | null }> };

export type GetQuoteModelRevisionImClassificationScoreQueryVariables = Exact<{
  qmrIds: Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>;
}>;


export type GetQuoteModelRevisionImClassificationScoreQuery = { __typename: 'Query', getQuoteModelRevisionImClassificationScore: Array<{ __typename: 'ImScore', score: number, qmrId: any } | null> | null };

export type QuoteModelRevisionWithHolesQueryVariables = Exact<{
  id: Scalars['UUID'];
  showDeleted: InputMaybe<Scalars['Boolean']>;
}>;


export type QuoteModelRevisionWithHolesQuery = { __typename: 'Query', quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, quoteModel: { __typename: 'QuoteModel', id: any, quote: { __typename: 'Quote', id: any } | null }, dfmReports: Array<{ __typename: 'PartDfmReport', quoteAttachmentRevisionId: any, isPublished: boolean, uploaderEmail: string | null, source: string | null, asset: { __typename: 'Asset', id: any, createdAt: any, downloadUrl: string | null, fileName: string } | null }>, holes: Array<{ __typename: 'Hole', id: string, groupKey: string, type: string, depth: number | null, diameter: number | null, isBlind: boolean | null, tipAngle: number | null, counterboreDepth: number | null, counterboreDiameter: number | null, countersinkAngle: number | null, countersinkDepth: number | null, countersinkDiameter: number | null, direction: any | null, endPoint: Array<number> | null, startPoint: Array<number> | null, patches: Array<{ __typename: 'RevisionPatch', id: string }>, tapOptions: Array<{ __typename: 'TapOption', id: string, maxDepth: number, commonName: string }>, tapAnnotation: { __typename: 'TapAnnotation', id: any, depth: number | null, tapOption: { __typename: 'TapOption', id: string, maxDepth: number, commonName: string } | null } | null }> } | null };

export type GetQmrAttachmentAnnotationsQueryVariables = Exact<{
  attachmentId: Scalars['UUID'];
  quoteModelRevisionId: InputMaybe<Scalars['UUID']>;
}>;


export type GetQmrAttachmentAnnotationsQuery = { __typename: 'Query', getQmrAttachmentAnnotations: { __typename: 'QmrAttachmentAnnotations', id: any, annotationsDataDownloadUrl: string, attachmentId: any, createdAt: any, updatedAt: any, createdBy: { __typename: 'BasicUser', id: number, displayName: string }, updatedBy: { __typename: 'BasicUser', id: number, displayName: string } } | null };

export type GetInspectionPointCountQueryVariables = Exact<{
  attachmentId: Scalars['UUID'];
}>;


export type GetInspectionPointCountQuery = { __typename: 'Query', getInspectionPointCount: { __typename: 'GetInspectionPointCountOutput', db: number, s3: number, autoInspectionPoint: number } };

export type CreateAutoGenerateUser2DDrawingMutationVariables = Exact<{
  qmrId: Scalars['UUID'];
  quoteId: Scalars['UUID'];
}>;


export type CreateAutoGenerateUser2DDrawingMutation = { __typename: 'Mutation', createAutoGenerateUserDrawing: { __typename: 'QuoteModelRevision', id: any } };

export type RemoveQmrAttachmentMutationVariables = Exact<{
  quoteModelRevisionId: Scalars['UUID'];
  quoteAttachmentRevisionId: Scalars['UUID'];
  quoteId: InputMaybe<Scalars['UUID']>;
}>;


export type RemoveQmrAttachmentMutation = { __typename: 'Mutation', removeQuoteModelRevisionAttachment: { __typename: 'QuoteModelRevisionAttachment', id: any, quoteModelRevision: { __typename: 'QuoteModelRevision', id: any } } | null };

export type QueryIsDfmAnnoQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type QueryIsDfmAnnoQuery = { __typename: 'Query', user: { __typename: 'User', id: number, isDfmAnnotationsEnabled: boolean } | null };

export type RecommendedQuantitiesToHitDeliveryDateQueryVariables = Exact<{
  quoteId: Scalars['UUID'];
  currentEstimatedDeliveryDate: Scalars['Date'];
  desiredDeliveryDate: InputMaybe<Scalars['Date']>;
}>;


export type RecommendedQuantitiesToHitDeliveryDateQuery = { __typename: 'Query', recommendedQuantitiesToHitDeliveryDate: Array<{ __typename: 'RecommendedQuantityToReduceLeadTime', quoteModelRevisionId: any, qty: number, success: boolean }> | null };

export type DfmTopicsTableQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DfmTopicsTableQuery = { __typename: 'Query', quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, status: string | null, title: string | null, acceptedAt: any | null, topic: { __typename: 'Topic', id: any, label: string } | null }> } | null };

export type QuoteStatusQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type QuoteStatusQuery = { __typename: 'Query', quote: { __typename: 'Quote', id: any, status: string, isLocked: boolean | null } | null };

export type ImDfmModalHeaderQueryQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ImDfmModalHeaderQueryQuery = { __typename: 'Query', quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, fileName: string, version: string, partRevision: { __typename: 'Revision', id: any }, quoteModel: { __typename: 'QuoteModel', selectedQuoteModelRevision: { __typename: 'QuoteModelRevision', version: string, id: any }, quote: { __typename: 'Quote', id: any, user: { __typename: 'BasicUser', id: number } } | null }, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any }> } | null };

export type GetSlideAttachmentAnnotationsQueryVariables = Exact<{
  attachmentId: Scalars['UUID'];
  quoteModelRevisionId: InputMaybe<Scalars['UUID']>;
}>;


export type GetSlideAttachmentAnnotationsQuery = { __typename: 'Query', getQmrAttachmentAnnotations: { __typename: 'QmrAttachmentAnnotations', id: any, annotationsDataDownloadUrl: string } | null };

export type ImDfmSlidesPanelQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ImDfmSlidesPanelQuery = { __typename: 'Query', quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, version: string, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, acceptedAt: any | null, status: string | null, message: string, title: string | null, sourceType: string | null, acceptedBy: { __typename: 'BasicUser', id: number, email: any } | null, attachment: { __typename: 'Asset', id: any } | null, modelViewerSnapshots: Array<{ __typename: 'ModelViewerSnapshot', id: any, snapshot: { __typename: 'ModelViewerConfig', rotation: Array<number> | null, camera: { __typename: 'ModelViewerCameraConfig', position: Array<number>, zoom: number, up: Array<number> | null, target: Array<number> | null } | null, part: { __typename: 'ModelViewerPartConfig', transparent: boolean, patches: Array<{ __typename: 'ModelViewerPatchConfig', color: string | null, hashcode: string }> }, dfm: Array<{ __typename: 'ModelViewerDfmFeatureConfig', color: string | null, threshold: number | null, feature: string | null, direction: Array<number> | null }>, annotations: Array<{ __typename: 'ModelViewerAnnotationConfig', position: Array<number> }>, crossSection: { __typename: 'ModelViewerCrossSectionConfig', position: any, rotation: any } | null, pointToPoint: { __typename: 'PointToPointConfig', customPoints: Array<any>, selectedPoints: Array<{ __typename: 'P2PPoint', index: number, type: P2PPointType }> } | null } | null }>, topic: { __typename: 'Topic', id: any, label: string } | null }>, quoteModel: { __typename: 'QuoteModel', selectedQuoteModelRevision: { __typename: 'QuoteModelRevision', id: any, version: string }, quote: { __typename: 'Quote', isCpqOwned: boolean | null, type: QuoteType } | null } } | null };

export type QmrImDfmModal3dViewerQueryVariables = Exact<{
  qmrId: Scalars['UUID'];
  showDeleted: InputMaybe<Scalars['Boolean']>;
}>;


export type QmrImDfmModal3dViewerQuery = { __typename: 'Query', quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, sourceType: string | null, modelViewerSnapshots: Array<{ __typename: 'ModelViewerSnapshot', id: any, snapshot: { __typename: 'ModelViewerConfig', rotation: Array<number> | null, camera: { __typename: 'ModelViewerCameraConfig', position: Array<number>, zoom: number, up: Array<number> | null, target: Array<number> | null } | null, part: { __typename: 'ModelViewerPartConfig', transparent: boolean, patches: Array<{ __typename: 'ModelViewerPatchConfig', color: string | null, hashcode: string }> }, dfm: Array<{ __typename: 'ModelViewerDfmFeatureConfig', color: string | null, threshold: number | null, feature: string | null, direction: Array<number> | null }>, annotations: Array<{ __typename: 'ModelViewerAnnotationConfig', position: Array<number> }>, crossSection: { __typename: 'ModelViewerCrossSectionConfig', position: any, rotation: any } | null, pointToPoint: { __typename: 'PointToPointConfig', customPoints: Array<any>, selectedPoints: Array<{ __typename: 'P2PPoint', index: number, type: P2PPointType }> } | null } | null }> }>, holes: Array<{ __typename: 'Hole', id: string, groupKey: string, type: string, depth: number | null, diameter: number | null, isBlind: boolean | null, tipAngle: number | null, counterboreDepth: number | null, counterboreDiameter: number | null, countersinkAngle: number | null, countersinkDepth: number | null, countersinkDiameter: number | null, direction: any | null, endPoint: Array<number> | null, startPoint: Array<number> | null, patches: Array<{ __typename: 'RevisionPatch', id: string }>, tapOptions: Array<{ __typename: 'TapOption', id: string, maxDepth: number, commonName: string }>, tapAnnotation: { __typename: 'TapAnnotation', id: any, depth: number | null, tapOption: { __typename: 'TapOption', id: string, maxDepth: number, commonName: string } | null } | null }>, partRevision: { __typename: 'Revision', id: any, sceneBundle: any | null } } | null };

export type ImDfmPdfViewerModalQueryQueryVariables = Exact<{
  dfmFeedbackId: Scalars['UUID'];
}>;


export type ImDfmPdfViewerModalQueryQuery = { __typename: 'Query', dfmFeedback: { __typename: 'DfmFeedback', id: any, attachment: { __typename: 'Asset', id: any, fileName: string, downloadUrl: string | null } | null } | null };

export type QmrsInfoFilteredByHasDfmQueryVariables = Exact<{
  quoteId: InputMaybe<Scalars['UUID']>;
  orderId: InputMaybe<Scalars['String']>;
}>;


export type QmrsInfoFilteredByHasDfmQuery = { __typename: 'Query', qmrsInfoFilteredByHasDfm: Array<{ __typename: 'QmrLimitedInfoForIcons', id: any, fileName: string, thumbnailUri: string | null }> };

export type SalesOrderIdQmrNavigationQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type SalesOrderIdQmrNavigationQuery = { __typename: 'Query', salesOrder: { __typename: 'SalesOrder', id: string } | null };

export type AcceptDfmFeedbackSlideActionPanelMutationVariables = Exact<{
  dfmFeedbackId: Scalars['UUID'];
}>;


export type AcceptDfmFeedbackSlideActionPanelMutation = { __typename: 'Mutation', acceptDfmFeedback: { __typename: 'DfmFeedback', id: any, acceptedAt: any | null, status: string | null, acceptedBy: { __typename: 'BasicUser', id: number, email: any } | null } };

export type QmrRevisionRefetchQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type QmrRevisionRefetchQuery = { __typename: 'Query', quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, status: string | null }>, partRevision: { __typename: 'Revision', id: any, thumbnailUri: string | null }, quoteModel: { __typename: 'QuoteModel', id: any, quote: { __typename: 'Quote', id: any, status: string } | null, quoteModelRevisions: Array<{ __typename: 'QuoteModelRevision', id: any, modelConfiguration: { __typename: 'ModelConfiguration', id: any, process: { __typename: 'Process', id: string } | null } | null }> } } | null };

export type DfmFeedbackImDfmModalQueryVariables = Exact<{
  dfmFeedbackId: Scalars['UUID'];
}>;


export type DfmFeedbackImDfmModalQuery = { __typename: 'Query', dfmFeedback: { __typename: 'DfmFeedback', id: any, attachment: { __typename: 'Asset', id: any } | null } | null };

export type GetQmrAttachmentAnnotationsImDfmModalQueryVariables = Exact<{
  attachmentId: Scalars['UUID'];
  quoteModelRevisionId: InputMaybe<Scalars['UUID']>;
}>;


export type GetQmrAttachmentAnnotationsImDfmModalQuery = { __typename: 'Query', getQmrAttachmentAnnotations: { __typename: 'QmrAttachmentAnnotations', id: any, annotationsDataDownloadUrl: string } | null };

export type UpsertDfmAttachmentAnnotationsImDfmModalMutationVariables = Exact<{
  attachmentId: Scalars['UUID'];
  qmrAttachmentAnnotationsInput: DfmAttachmentAnnotationsInput;
  newAnnotationsAdded: InputMaybe<Scalars['Boolean']>;
}>;


export type UpsertDfmAttachmentAnnotationsImDfmModalMutation = { __typename: 'Mutation', upsertDfmAttachmentAnnotations: { __typename: 'QmrAttachmentAnnotations', id: any, annotationsDataDownloadUrl: string, attachmentId: any, createdAt: any, updatedAt: any, createdBy: { __typename: 'BasicUser', id: number, displayName: string }, updatedBy: { __typename: 'BasicUser', id: number, displayName: string } } };

export type NotifyAdminMutationVariables = Exact<{
  quoteId: Scalars['UUID'];
  userId: Scalars['Int'];
}>;


export type NotifyAdminMutation = { __typename: 'Mutation', notifyAdmin: { __typename: 'Quote', id: any } | null };

export type NotifyAdminOnOdpMutationVariables = Exact<{
  userId: Scalars['Int'];
  orderId: InputMaybe<Scalars['String']>;
}>;


export type NotifyAdminOnOdpMutation = { __typename: 'Mutation', notifyAdmin: { __typename: 'Quote', id: any } | null };

export type QmrsGroupedByDfmCategoryQueryVariables = Exact<{
  quoteId: InputMaybe<Scalars['UUID']>;
  orderId: InputMaybe<Scalars['String']>;
}>;


export type QmrsGroupedByDfmCategoryQuery = { __typename: 'Query', qmrsGroupedByDfmCategory: Array<{ __typename: 'QmrDfmCategoryGrouping', category: string, qmrs: Array<{ __typename: 'QuoteModelRevision', id: any, fileName: string, version: string, attachmentLink: { __typename: 'QuoteModelRevisionAttachment', id: any, quoteAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string } | null } } | null, partRevision: { __typename: 'Revision', id: any, thumbnailUri: string | null }, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, isPublished: boolean }> }> | null }> };

export type MoveToNewQuoteMutationVariables = Exact<{
  quoteModelRevisionIds: Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>;
  newQuoteName: InputMaybe<Scalars['String']>;
  userId: InputMaybe<Scalars['Int']>;
}>;


export type MoveToNewQuoteMutation = { __typename: 'Mutation', moveToNewQuote: { __typename: 'Quote', id: any, name: string } };

export type MoveToExistingQuoteMutationVariables = Exact<{
  quoteModelRevisionIds: Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>;
  destinationQuoteId: Scalars['UUID'];
  userId: InputMaybe<Scalars['Int']>;
}>;


export type MoveToExistingQuoteMutation = { __typename: 'Mutation', moveToExistingQuote: { __typename: 'Quote', id: any, name: string } };

export type QuotesListMoveToQuoteModalQueryVariables = Exact<{ [key: string]: never; }>;


export type QuotesListMoveToQuoteModalQuery = { __typename: 'Query', me: { __typename: 'User', id: number, quotes: { __typename: 'PartialQuoteViewResults', items: Array<{ __typename: 'BasicQuote' } | { __typename: 'Quote', id: any, name: string, type: QuoteType, status: string, lastModified: any | null, requestedAt: any | null, quoteModels: { __typename: 'PartialQuoteModelResults', totalCount: number }, project: { __typename: 'BasicProject', isSecurePlus: boolean, name: string, id: any | null } | null }> } | null } | null };

export type UpdateQuoteLevelLeadTimesQuoteDetailPageMutationVariables = Exact<{
  quoteId: Scalars['UUID'];
  productionDays: Scalars['Int'];
  region: QuoteLevelLeadTimesRegion;
}>;


export type UpdateQuoteLevelLeadTimesQuoteDetailPageMutation = { __typename: 'Mutation', updateQuoteLeadTimes: { __typename: 'Quote', id: any } };

export type QlltOptionFragment = { __typename: 'QuoteLevelLeadTimeAndPriceOption', leadTimes: Array<number> | null, shipByDate: any | null, subTotalInCents: number | null, shippingOptions: Array<{ __typename: 'ShippingOptionItemType', shippingOptionId: string, name: string, deliveredByDate: any | null }> | null };

export type QuoteLevelLeadTimesWithShippingOptionsQueryVariables = Exact<{
  quoteId: Scalars['UUID'];
  address: InputMaybe<AddressInput>;
}>;


export type QuoteLevelLeadTimesWithShippingOptionsQuery = { __typename: 'Query', quote: { __typename: 'Quote', id: any, quoteLevelLeadTimesWithShippingOptions: { __typename: 'QuoteLevelLeadTimesAndPrices', domesticFastest: { __typename: 'QuoteLevelLeadTimeAndPriceOption', leadTimes: Array<number> | null, shipByDate: any | null, subTotalInCents: number | null, shippingOptions: Array<{ __typename: 'ShippingOptionItemType', shippingOptionId: string, name: string, deliveredByDate: any | null }> | null } | null, domesticStandard: { __typename: 'QuoteLevelLeadTimeAndPriceOption', leadTimes: Array<number> | null, shipByDate: any | null, subTotalInCents: number | null, shippingOptions: Array<{ __typename: 'ShippingOptionItemType', shippingOptionId: string, name: string, deliveredByDate: any | null }> | null } | null, domesticCostEffective: { __typename: 'QuoteLevelLeadTimeAndPriceOption', leadTimes: Array<number> | null, shipByDate: any | null, subTotalInCents: number | null, shippingOptions: Array<{ __typename: 'ShippingOptionItemType', shippingOptionId: string, name: string, deliveredByDate: any | null }> | null } | null, overseasFastest: { __typename: 'QuoteLevelLeadTimeAndPriceOption', leadTimes: Array<number> | null, shipByDate: any | null, subTotalInCents: number | null, shippingOptions: Array<{ __typename: 'ShippingOptionItemType', shippingOptionId: string, name: string, deliveredByDate: any | null }> | null } | null, overseasStandard: { __typename: 'QuoteLevelLeadTimeAndPriceOption', leadTimes: Array<number> | null, shipByDate: any | null, subTotalInCents: number | null, shippingOptions: Array<{ __typename: 'ShippingOptionItemType', shippingOptionId: string, name: string, deliveredByDate: any | null }> | null } | null, overseasCostEffective: { __typename: 'QuoteLevelLeadTimeAndPriceOption', leadTimes: Array<number> | null, shipByDate: any | null, subTotalInCents: number | null, shippingOptions: Array<{ __typename: 'ShippingOptionItemType', shippingOptionId: string, name: string, deliveredByDate: any | null }> | null } | null } | null } | null };

export type DestroyTapsThreadsTagMutationVariables = Exact<{
  quoteModelRevisionId: Scalars['UUID'];
  holesList: Array<Scalars['String']> | Scalars['String'];
}>;


export type DestroyTapsThreadsTagMutation = { __typename: 'Mutation', destroyQuoteModelRevisionTapOnHoles: { __typename: 'UpsertOrDeleteTapsResponse', quoteModelRevisionId: string | null, hole: Array<{ __typename: 'Hole', id: string, tapAnnotation: { __typename: 'TapAnnotation', id: any, tapOption: { __typename: 'TapOption', id: string, commonName: string } | null } | null }> } };

export type RemoveQmrAttachmentDrawingTagMutationVariables = Exact<{
  quoteModelRevisionId: Scalars['UUID'];
  quoteAttachmentRevisionId: Scalars['UUID'];
  quoteId: InputMaybe<Scalars['UUID']>;
}>;


export type RemoveQmrAttachmentDrawingTagMutation = { __typename: 'Mutation', removeQuoteModelRevisionAttachment: { __typename: 'QuoteModelRevisionAttachment', id: any, quoteModelRevision: { __typename: 'QuoteModelRevision', id: any } } | null };

export type UpdateCustomerToolNameMutationVariables = Exact<{
  moldToolId: Scalars['UUID'];
  customerToolName: InputMaybe<Scalars['String']>;
}>;


export type UpdateCustomerToolNameMutation = { __typename: 'Mutation', updateCustomerToolName: { __typename: 'MoldTool', id: any, name: string, customerToolName: string | null } };

export type ProductionLeadTimesDropdownQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ProductionLeadTimesDropdownQuery = { __typename: 'Query', productionLeadTimes: Array<{ __typename: 'ProductionLeadTime', id: string, priorityId: string, productionDays: number, primaryProductionDays: number }> | null };

export type CreateQuoteAttachmentRevisionFilesTabMutationVariables = Exact<{
  uploadMetadata: AttachmentInput;
  quoteId: Scalars['UUID'];
  quoteAttachmentId: InputMaybe<Scalars['UUID']>;
  attachmentType: InputMaybe<Scalars['String']>;
  productAttachmentId: InputMaybe<Scalars['String']>;
}>;


export type CreateQuoteAttachmentRevisionFilesTabMutation = { __typename: 'Mutation', createQuoteAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string, uploadUrl: string | null } | null, asset: { __typename: 'Asset', id: any, fileName: string, uploadUrl: string | null } | null } };

export type CreateQuoteModelRevisionMutationVariables = Exact<{
  uploadMetadata: QuoteModelRevisionUploadInput;
  quoteId: Scalars['UUID'];
  quoteModelId: InputMaybe<Scalars['UUID']>;
  setAsSelectedForQuoteModel: Scalars['Boolean'];
  userId: InputMaybe<Scalars['Int']>;
}>;


export type CreateQuoteModelRevisionMutation = { __typename: 'Mutation', createQuoteModelRevision: { __typename: 'QuoteModelRevision', id: any, uploadUrl: string | null, partRevision: { __typename: 'Revision', id: any, partId: number | null, thumbnailUri: string | null } } };

export type DestroyQuoteModelMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DestroyQuoteModelMutation = { __typename: 'Mutation', destroyQuoteModel: { __typename: 'QuoteModel', id: any } };

export type DestroyQuoteModelsMutationVariables = Exact<{
  ids: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type DestroyQuoteModelsMutation = { __typename: 'Mutation', destroyQuoteModels: Array<{ __typename: 'QuoteModel', id: any }> };

export type FilesTabFinalizeUploadAndProcessPartMutationVariables = Exact<{
  partId: Scalars['Int'];
}>;


export type FilesTabFinalizeUploadAndProcessPartMutation = { __typename: 'Mutation', finalizeUploadAndProcessPart: { __typename: 'InstantQuoterResponseType', partId: number, status: InstantQuoterStatus, reason: string | null } };

export type MarkQuoteAttachmentRevisionUploadedFilesTabMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type MarkQuoteAttachmentRevisionUploadedFilesTabMutation = { __typename: 'Mutation', markQuoteAttachmentRevisionUploaded: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string, downloadUrl: string | null } | null } };

export type RemoveQuoteAttachmentFilesTabMutationVariables = Exact<{
  quoteId: Scalars['UUID'];
  attachmentId: Scalars['UUID'];
}>;


export type RemoveQuoteAttachmentFilesTabMutation = { __typename: 'Mutation', removeQuoteAttachment: { __typename: 'QuoteAttachment', id: any } };

export type UserEnteredMaterialsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserEnteredMaterialsQuery = { __typename: 'Query', me: { __typename: 'User', id: number, userEnteredMaterials: Array<{ __typename: 'UserEnteredMaterial', id: string, name: string, process: { __typename: 'Process', id: string, name: string } }> } | null };

export type ProductionLocationOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductionLocationOptionsQuery = { __typename: 'Query', imQuotePreferences: Array<{ __typename: 'ImQuotePreference', label: string, name: string, value: string } | null> | null };

export type UpdateImQuoteRequirementsMutationVariables = Exact<{
  quoteId: Scalars['UUID'];
  input: ImQuoteRequirementsInput;
}>;


export type UpdateImQuoteRequirementsMutation = { __typename: 'Mutation', updateIMQuoteRequirements: { __typename: 'Quote', id: any, imQuoteRequirements: { __typename: 'ImQuoteRequirements', deliveryDate: any, developmentStage: StageType, toolLife: ToolLifeType | null, toolTypeNotes: string | null, additionalRequirementNotes: string | null, productionRateForecast: { __typename: 'ProductionRateForecast', quantity: number | null, timeScale: ProductionRateTimeScaleInput | null } | null } | null } };

export type Im_Quote_Cost_And_Lead_Time_PreferencesFragment = { __typename: 'ImQuotePreference', label: string, name: string, value: string };

export type CostAndLeadTimeOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CostAndLeadTimeOptionsQuery = { __typename: 'Query', imQuoteCostAndLeadTimePreferences: Array<{ __typename: 'ImQuotePreference', label: string, name: string, value: string } | null> | null };

export type QuoteImProjectRequirements_Quote_ImQuoteRequirements_PreferencesFragment = { __typename: 'ImQuotePreference', label: string, name: string, value: string };

export type QuoteImProjectRequirements_Quote_ImQuoteRequirements_ProductionRateForecastFragment = { __typename: 'ProductionRateForecast', quantity: number | null, timeScale: ProductionRateTimeScaleInput | null };

export type QuoteImProjectRequirementsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type QuoteImProjectRequirementsQuery = { __typename: 'Query', quote: { __typename: 'Quote', id: any, imQuoteRequirements: { __typename: 'ImQuoteRequirements', deliveryDate: any, developmentStage: StageType, toolLife: ToolLifeType | null, toolTypeNotes: string | null, additionalRequirementNotes: string | null, preferences: { __typename: 'ImQuotePreference', label: string, name: string, value: string } | null, productionRateForecast: { __typename: 'ProductionRateForecast', quantity: number | null, timeScale: ProductionRateTimeScaleInput | null } | null, costAndLeadTimePreferences: { __typename: 'ImQuotePreference', label: string, name: string, value: string } | null } | null } | null };

export type QuoteModelRevisionReorderViewerQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type QuoteModelRevisionReorderViewerQuery = { __typename: 'Query', quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, quoteModel: { __typename: 'QuoteModel', id: any, quote: { __typename: 'Quote', id: any } | null }, holes: Array<{ __typename: 'Hole', id: string, groupKey: string, type: string, depth: number | null, diameter: number | null, isBlind: boolean | null, tipAngle: number | null, counterboreDepth: number | null, counterboreDiameter: number | null, countersinkAngle: number | null, countersinkDepth: number | null, countersinkDiameter: number | null, direction: any | null, endPoint: Array<number> | null, startPoint: Array<number> | null, patches: Array<{ __typename: 'RevisionPatch', id: string }>, tapOptions: Array<{ __typename: 'TapOption', id: string, maxDepth: number, commonName: string }>, tapAnnotation: { __typename: 'TapAnnotation', id: any, depth: number | null, tapOption: { __typename: 'TapOption', id: string, maxDepth: number, commonName: string } | null } | null }>, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, severity: string, message: string, title: string | null, link: string | null, accepted: boolean, modelViewerSnapshots: Array<{ __typename: 'ModelViewerSnapshot', id: any, position: any, target: any, feature: string | null, type: string, createdAt: any, updatedAt: any, deletedAt: any | null, snapshot: { __typename: 'ModelViewerConfig', rotation: Array<number> | null, camera: { __typename: 'ModelViewerCameraConfig', zoom: number, position: Array<number>, up: Array<number> | null, target: Array<number> | null } | null, dfm: Array<{ __typename: 'ModelViewerDfmFeatureConfig', feature: string | null, threshold: number | null, direction: Array<number> | null }>, annotations: Array<{ __typename: 'ModelViewerAnnotationConfig', position: Array<number> }>, part: { __typename: 'ModelViewerPartConfig', transparent: boolean, patches: Array<{ __typename: 'ModelViewerPatchConfig', color: string | null, hashcode: string }> }, crossSection: { __typename: 'ModelViewerCrossSectionConfig', position: any, rotation: any } | null, pointToPoint: { __typename: 'PointToPointConfig', customPoints: Array<any>, selectedPoints: Array<{ __typename: 'P2PPoint', index: number, type: P2PPointType }> } | null } | null }> }>, partRevision: { __typename: 'Revision', id: any, analysisErrorCode: string | null, downloadUri: string | null, version: string, modelFileName: string | null, status: string | null, thumbnailUri: string | null, sceneBundle: any | null, updatedAt: any, scene: { __typename: 'ViewerScene', featureMapping: { __typename: 'SceneFile', url: string } | null, geometry: { __typename: 'SceneFile', url: string } | null } | null, boundingBox: { __typename: 'Vector3', x: number, y: number, z: number } | null } } | null };

export type CreateOdooQuoteMutationVariables = Exact<{
  quoteId: Scalars['UUID'];
  moldToolRevisionIds: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type CreateOdooQuoteMutation = { __typename: 'Mutation', createOdooQuote: { __typename: 'Quote', id: any, status: string } };

export type UpdateQuoteMutationVariables = Exact<{
  id: Scalars['UUID'];
  name: Scalars['String'];
}>;


export type UpdateQuoteMutation = { __typename: 'Mutation', updateQuote: { __typename: 'Quote', id: any, name: string } };

export type UpdateFpqDesignationMutationVariables = Exact<{
  quoteId: Scalars['UUID'];
  isFpq: Scalars['Boolean'];
}>;


export type UpdateFpqDesignationMutation = { __typename: 'Mutation', updateFPQDesignation: { __typename: 'Quote', isFlexiblePriceQuote: boolean } };

export type GetQuoteIdFromQmrIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetQuoteIdFromQmrIdQuery = { __typename: 'Query', quoteModelRevision: { __typename: 'QuoteModelRevision', quoteModel: { __typename: 'QuoteModel', id: any, quote: { __typename: 'Quote', id: any, project: { __typename: 'BasicProject', id: any | null } | null } | null } } | null };

export type QmrDfmFeedback_QuoteModelRevisionFragment = { __typename: 'QuoteModelRevision', id: any, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, severity: string, accepted: boolean, message: string, title: string | null, link: string | null, modelViewerSnapshots: Array<{ __typename: 'ModelViewerSnapshot', id: any, position: any, target: any, feature: string | null, type: string, createdAt: any, updatedAt: any, deletedAt: any | null, snapshot: { __typename: 'ModelViewerConfig', rotation: Array<number> | null, camera: { __typename: 'ModelViewerCameraConfig', zoom: number, position: Array<number>, up: Array<number> | null, target: Array<number> | null } | null, dfm: Array<{ __typename: 'ModelViewerDfmFeatureConfig', feature: string | null, threshold: number | null, direction: Array<number> | null }>, annotations: Array<{ __typename: 'ModelViewerAnnotationConfig', position: Array<number> }>, part: { __typename: 'ModelViewerPartConfig', transparent: boolean, patches: Array<{ __typename: 'ModelViewerPatchConfig', color: string | null, hashcode: string }> }, crossSection: { __typename: 'ModelViewerCrossSectionConfig', position: any, rotation: any } | null, pointToPoint: { __typename: 'PointToPointConfig', customPoints: Array<any>, selectedPoints: Array<{ __typename: 'P2PPoint', index: number, type: P2PPointType }> } | null } | null }> }>, processesDetails: { __typename: 'QmrProcessesDetails', totalPrice: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null } | null };

export type QmrDfmFeedbackQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type QmrDfmFeedbackQuery = { __typename: 'Query', quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, severity: string, accepted: boolean, message: string, title: string | null, link: string | null, modelViewerSnapshots: Array<{ __typename: 'ModelViewerSnapshot', id: any, position: any, target: any, feature: string | null, type: string, createdAt: any, updatedAt: any, deletedAt: any | null, snapshot: { __typename: 'ModelViewerConfig', rotation: Array<number> | null, camera: { __typename: 'ModelViewerCameraConfig', zoom: number, position: Array<number>, up: Array<number> | null, target: Array<number> | null } | null, dfm: Array<{ __typename: 'ModelViewerDfmFeatureConfig', feature: string | null, threshold: number | null, direction: Array<number> | null }>, annotations: Array<{ __typename: 'ModelViewerAnnotationConfig', position: Array<number> }>, part: { __typename: 'ModelViewerPartConfig', transparent: boolean, patches: Array<{ __typename: 'ModelViewerPatchConfig', color: string | null, hashcode: string }> }, crossSection: { __typename: 'ModelViewerCrossSectionConfig', position: any, rotation: any } | null, pointToPoint: { __typename: 'PointToPointConfig', customPoints: Array<any>, selectedPoints: Array<{ __typename: 'P2PPoint', index: number, type: P2PPointType }> } | null } | null }> }>, processesDetails: { __typename: 'QmrProcessesDetails', totalPrice: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null } | null } | null };

export type QuoteDetails_Quote_QuoteModels_Item_QuoteModelRevisionFragment = { __typename: 'QuoteModelRevision', id: any, dfmReports: Array<{ __typename: 'PartDfmReport', isPublished: boolean, source: string | null, uploaderEmail: string | null, asset: { __typename: 'Asset', id: any, fileName: string, downloadUrl: string | null, createdAt: any } | null }> };

export type QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_AttachmentLinkFragment = { __typename: 'QuoteModelRevisionAttachment', id: any, createdAt: any, isPdfOcrAutoQuotable: boolean | null, quoteAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string, downloadUrl: string | null, annotated: { __typename: 'AnnotatedAttachment', id: any, fileName: string, downloadUrl: string | null } | null, sanitized: { __typename: 'SanitizedAttachment', id: any, fileName: string, downloadUrl: string | null } | null } | null } };

export type QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ModelConfiguration_ProcessFragment = { __typename: 'Process', id: string, name: string, platformProcessTypeId: string };

export type QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ModelConfiguration_Material_MaterialFragment = { __typename: 'Material', id: string, name: string, materialCategory: string | null };

export type QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ModelConfigurationFragment = { __typename: 'ModelConfiguration', id: any, materialGrade: string | null, colorCode: string | null, textureCode: string | null, hasMultipleFinishes: boolean, userNeedsConfigHelp: boolean, quantity: number | null, requiresOvermold: boolean, additionalRequirements: string | null, fdmInfillPercentageCategory: string | null, fdmInfillPercentageCategoryLabel: string | null, process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string } | null, material: { __typename: 'Material', id: string, name: string, materialCategory: string | null } | { __typename: 'UserEnteredMaterial', id: string, name: string, process: { __typename: 'Process', id: string, name: string } } | null, color: { __typename: 'Color', id: string, name: string } | null, shore: { __typename: 'Shore', id: string, name: string } | null, texture: { __typename: 'Texture', id: string, name: string } | null, productionLeadTime: { __typename: 'ProductionLeadTime', id: string, priorityId: string, productionDays: number, primaryProductionDays: number, shipDateEstimate: { __typename: 'ShipDateEstimate', id: string, validUntilDate: any, shippedByDate: any } } | null };

export type QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_QuoteModel_QuoteFragment = { __typename: 'Quote', id: any, type: QuoteType };

export type QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_QuoteModelFragment = { __typename: 'QuoteModel', id: any, quote: { __typename: 'Quote', id: any, type: QuoteType } | null };

export type QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_DfmFeedbackFragment = { __typename: 'DfmFeedback', id: any, accepted: boolean, severity: string, message: string, title: string | null, isPublished: boolean };

export type QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetails_PostProcessFragment = { __typename: 'QmrPostProcessWithPriceAndLead', unitPriceInCents: number | null, postProcessLeadTimeInDays: number | null, postProcessNumParts: number | null, postProcessInspectionCriteria: ProcessInspectionCriteria | null, postProcess: { __typename: 'PostProcess', id: string, name: string, typeName: string | null }, postProcessThickness: { __typename: 'Thickness', id: string, name: string } | null, postProcessColor: { __typename: 'Color', id: string, name: string } | null };

export type QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetails_SecondaryProcessFragment = { __typename: 'QmrSecondaryProcessDetails', unitPriceInCents: number | null, leadTimeInDays: number | null, notes: string | null, process: { __typename: 'PostProcess', id: string, name: string, typeName: string | null }, pricingAndLeadTimeFields: { __typename: 'HardwareInstallationManualQuoteCalcFields', international: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', markupPercentage: number, mpPayoutInCents: number | null, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, domestic: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', mpPayoutInCents: number | null, markupPercentage: number, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, lineItems: Array<{ __typename: 'HardwareLineItem', supplier: string | null, partNumber: string | null, qtyPerPart: number, pricePerPack: number, qtyPerPack: number }> | null } | { __typename: 'SecondaryProcessManualQuoteCalcFields', international: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', markupPercentage: number, mpPayoutInCents: number | null, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, domestic: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', mpPayoutInCents: number | null, markupPercentage: number, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null } | null };

export type QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetails_TotalPrice_ExactPriceFragment = { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null };

export type QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetails_TotalPrice_EstimatedPriceFragment = { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null };

type QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetails_TotalPrice_EstimatedPrice_Fragment = { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null };

type QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetails_TotalPrice_ExactPrice_Fragment = { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null };

export type QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetails_TotalPriceFragment = QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetails_TotalPrice_EstimatedPrice_Fragment | QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetails_TotalPrice_ExactPrice_Fragment;

export type QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetailsFragment = { __typename: 'QmrProcessesDetails', isBusinessAccountDiscountApplied: boolean | null, primaryProcess: { __typename: 'QmrProcessWithPrice', process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string }, price: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null } | null, postProcesses: Array<{ __typename: 'QmrPostProcessWithPriceAndLead', unitPriceInCents: number | null, postProcessLeadTimeInDays: number | null, postProcessNumParts: number | null, postProcessInspectionCriteria: ProcessInspectionCriteria | null, postProcess: { __typename: 'PostProcess', id: string, name: string, typeName: string | null }, postProcessThickness: { __typename: 'Thickness', id: string, name: string } | null, postProcessColor: { __typename: 'Color', id: string, name: string } | null }>, secondaryProcesses: Array<{ __typename: 'QmrSecondaryProcessDetails', unitPriceInCents: number | null, leadTimeInDays: number | null, notes: string | null, process: { __typename: 'PostProcess', id: string, name: string, typeName: string | null }, pricingAndLeadTimeFields: { __typename: 'HardwareInstallationManualQuoteCalcFields', international: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', markupPercentage: number, mpPayoutInCents: number | null, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, domestic: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', mpPayoutInCents: number | null, markupPercentage: number, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, lineItems: Array<{ __typename: 'HardwareLineItem', supplier: string | null, partNumber: string | null, qtyPerPart: number, pricePerPack: number, qtyPerPack: number }> | null } | { __typename: 'SecondaryProcessManualQuoteCalcFields', international: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', markupPercentage: number, mpPayoutInCents: number | null, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, domestic: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', mpPayoutInCents: number | null, markupPercentage: number, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null } | null }>, totalPrice: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null };

export type QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_PartRevision_BoundingBoxFragment = { __typename: 'Vector3', x: number, y: number, z: number };

export type QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_PartRevisionFragment = { __typename: 'Revision', id: any, analysisErrorCode: string | null, downloadUri: string | null, modelFileName: string | null, status: string | null, sceneBundle: any | null, thumbnailUri: string | null, updatedAt: any, boundingBox: { __typename: 'Vector3', x: number, y: number, z: number } | null };

export type QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_TapFragment = { __typename: 'TapAnnotation', id: any };

export type QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevisionFragment = { __typename: 'QuoteModelRevision', isITARProhibitedViewing: boolean | null, id: any, quantityRangeStatus: string | null, createdAt: any, fileName: string, state: QuoteModelRevisionState, updatedAt: any, version: string, drawingRequirements: Array<string>, supportedPriorityRegions: { __typename: 'SupportedPriorityRegions', partSupportsDomestic: boolean, partSupportsInternational: boolean }, dfmReports: Array<{ __typename: 'PartDfmReport', quoteAttachmentRevisionId: any, isPublished: boolean, uploaderEmail: string | null, source: string | null, asset: { __typename: 'Asset', id: any, createdAt: any, downloadUrl: string | null, fileName: string } | null }>, modelConfiguration: { __typename: 'ModelConfiguration', fdmInfillPercentageCategory: string | null, fdmInfillPercentageCategoryLabel: string | null, id: any, materialGrade: string | null, colorCode: string | null, textureCode: string | null, hasMultipleFinishes: boolean, userNeedsConfigHelp: boolean, quantity: number | null, requiresOvermold: boolean, additionalRequirements: string | null, dfmInspection: { __typename: 'ModelConfigurationDfmInspection', id: any | null, isPublished: boolean, manualOverrideMpUnitPayout: number | null, manualOverrideUnitAmount: number | null, manualOverrideUnitProductionDays: number | null, inspectionData: any, updatedBy: { __typename: 'BasicUser', id: number }, quotedBy: { __typename: 'BasicUser', id: number } | null, quoteUpdatedBy: { __typename: 'BasicUser', id: number } | null } | null, process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string } | null, material: { __typename: 'Material', id: string, name: string, materialCategory: string | null } | { __typename: 'UserEnteredMaterial', id: string, name: string, process: { __typename: 'Process', id: string, name: string } } | null, color: { __typename: 'Color', id: string, name: string } | null, shore: { __typename: 'Shore', id: string, name: string } | null, texture: { __typename: 'Texture', id: string, name: string } | null, productionLeadTime: { __typename: 'ProductionLeadTime', id: string, priorityId: string, productionDays: number, primaryProductionDays: number, shipDateEstimate: { __typename: 'ShipDateEstimate', id: string, validUntilDate: any, shippedByDate: any } } | null } | null, quoteModel: { __typename: 'QuoteModel', id: any, quote: { __typename: 'Quote', id: any, type: QuoteType } | null }, annotations: Array<{ __typename: 'Annotation', id: any }>, taps: Array<{ __typename: 'TapAnnotation', id: any }>, holes: Array<{ __typename: 'Hole', id: string, groupKey: string, patches: Array<{ __typename: 'RevisionPatch', id: string }>, tapOptions: Array<{ __typename: 'TapOption', id: string }>, tapAnnotation: { __typename: 'TapAnnotation', id: any, depth: number | null, tapOption: { __typename: 'TapOption', id: string } | null } | null }>, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, accepted: boolean, severity: string, message: string, title: string | null, isPublished: boolean }>, processesDetails: { __typename: 'QmrProcessesDetails', isBusinessAccountDiscountApplied: boolean | null, primaryProcess: { __typename: 'QmrProcessWithPrice', process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string }, price: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null } | null, postProcesses: Array<{ __typename: 'QmrPostProcessWithPriceAndLead', unitPriceInCents: number | null, postProcessLeadTimeInDays: number | null, postProcessNumParts: number | null, postProcessInspectionCriteria: ProcessInspectionCriteria | null, postProcess: { __typename: 'PostProcess', id: string, name: string, typeName: string | null }, postProcessThickness: { __typename: 'Thickness', id: string, name: string } | null, postProcessColor: { __typename: 'Color', id: string, name: string } | null }>, secondaryProcesses: Array<{ __typename: 'QmrSecondaryProcessDetails', unitPriceInCents: number | null, leadTimeInDays: number | null, notes: string | null, process: { __typename: 'PostProcess', id: string, name: string, typeName: string | null }, pricingAndLeadTimeFields: { __typename: 'HardwareInstallationManualQuoteCalcFields', international: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', markupPercentage: number, mpPayoutInCents: number | null, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, domestic: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', mpPayoutInCents: number | null, markupPercentage: number, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, lineItems: Array<{ __typename: 'HardwareLineItem', supplier: string | null, partNumber: string | null, qtyPerPart: number, pricePerPack: number, qtyPerPack: number }> | null } | { __typename: 'SecondaryProcessManualQuoteCalcFields', international: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', markupPercentage: number, mpPayoutInCents: number | null, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, domestic: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', mpPayoutInCents: number | null, markupPercentage: number, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null } | null }>, totalPrice: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null } | null, partRevision: { __typename: 'Revision', id: any, analysisErrorCode: string | null, downloadUri: string | null, modelFileName: string | null, status: string | null, sceneBundle: any | null, thumbnailUri: string | null, updatedAt: any, boundingBox: { __typename: 'Vector3', x: number, y: number, z: number } | null }, attachmentLink: { __typename: 'QuoteModelRevisionAttachment', id: any, createdAt: any, isPdfOcrAutoQuotable: boolean | null, quoteAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string, downloadUrl: string | null, annotated: { __typename: 'AnnotatedAttachment', id: any, fileName: string, downloadUrl: string | null } | null, sanitized: { __typename: 'SanitizedAttachment', id: any, fileName: string, downloadUrl: string | null } | null } | null } } | null, mold: { __typename: 'MoldTool', id: any, name?: string, leadTimeDays: number | null, customerToolName?: string | null, toolLife: number | null, uiIndex: number, material: { __typename: 'Material', id: string, name: string } | null, price: { __typename: 'ExactPrice', priceInCents: number | null } | null, moldToolRevisionQmr?: Array<{ __typename: 'MoldToolRevisionQmr', moldToolRevisionId: any, quoteModelRevisionId: string, cavityPerPart: number | null }> } | null };

export type QuoteDetails_Quote_BusinessAccountDiscountFragment = { __typename: 'BusinessAccountDiscount', id: number, percent: number, isActive: boolean, endAt: any };

export type QuoteDetails_Quote_QuoteModelsFragment = { __typename: 'PartialQuoteModelResults', totalCount: number, items: Array<{ __typename: 'QuoteModel', id: any, quoteModelRevisions: Array<{ __typename: 'QuoteModelRevision', id: any, dfmReports: Array<{ __typename: 'PartDfmReport', isPublished: boolean, source: string | null, uploaderEmail: string | null, asset: { __typename: 'Asset', id: any, fileName: string, downloadUrl: string | null, createdAt: any } | null }> }>, selectedQuoteModelRevision: { __typename: 'QuoteModelRevision', isITARProhibitedViewing: boolean | null, id: any, quantityRangeStatus: string | null, createdAt: any, fileName: string, state: QuoteModelRevisionState, updatedAt: any, version: string, drawingRequirements: Array<string>, supportedPriorityRegions: { __typename: 'SupportedPriorityRegions', partSupportsDomestic: boolean, partSupportsInternational: boolean }, dfmReports: Array<{ __typename: 'PartDfmReport', quoteAttachmentRevisionId: any, isPublished: boolean, uploaderEmail: string | null, source: string | null, asset: { __typename: 'Asset', id: any, createdAt: any, downloadUrl: string | null, fileName: string } | null }>, modelConfiguration: { __typename: 'ModelConfiguration', fdmInfillPercentageCategory: string | null, fdmInfillPercentageCategoryLabel: string | null, id: any, materialGrade: string | null, colorCode: string | null, textureCode: string | null, hasMultipleFinishes: boolean, userNeedsConfigHelp: boolean, quantity: number | null, requiresOvermold: boolean, additionalRequirements: string | null, dfmInspection: { __typename: 'ModelConfigurationDfmInspection', id: any | null, isPublished: boolean, manualOverrideMpUnitPayout: number | null, manualOverrideUnitAmount: number | null, manualOverrideUnitProductionDays: number | null, inspectionData: any, updatedBy: { __typename: 'BasicUser', id: number }, quotedBy: { __typename: 'BasicUser', id: number } | null, quoteUpdatedBy: { __typename: 'BasicUser', id: number } | null } | null, process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string } | null, material: { __typename: 'Material', id: string, name: string, materialCategory: string | null } | { __typename: 'UserEnteredMaterial', id: string, name: string, process: { __typename: 'Process', id: string, name: string } } | null, color: { __typename: 'Color', id: string, name: string } | null, shore: { __typename: 'Shore', id: string, name: string } | null, texture: { __typename: 'Texture', id: string, name: string } | null, productionLeadTime: { __typename: 'ProductionLeadTime', id: string, priorityId: string, productionDays: number, primaryProductionDays: number, shipDateEstimate: { __typename: 'ShipDateEstimate', id: string, validUntilDate: any, shippedByDate: any } } | null } | null, quoteModel: { __typename: 'QuoteModel', id: any, quote: { __typename: 'Quote', id: any, type: QuoteType } | null }, annotations: Array<{ __typename: 'Annotation', id: any }>, taps: Array<{ __typename: 'TapAnnotation', id: any }>, holes: Array<{ __typename: 'Hole', id: string, groupKey: string, patches: Array<{ __typename: 'RevisionPatch', id: string }>, tapOptions: Array<{ __typename: 'TapOption', id: string }>, tapAnnotation: { __typename: 'TapAnnotation', id: any, depth: number | null, tapOption: { __typename: 'TapOption', id: string } | null } | null }>, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, accepted: boolean, severity: string, message: string, title: string | null, isPublished: boolean }>, processesDetails: { __typename: 'QmrProcessesDetails', isBusinessAccountDiscountApplied: boolean | null, primaryProcess: { __typename: 'QmrProcessWithPrice', process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string }, price: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null } | null, postProcesses: Array<{ __typename: 'QmrPostProcessWithPriceAndLead', unitPriceInCents: number | null, postProcessLeadTimeInDays: number | null, postProcessNumParts: number | null, postProcessInspectionCriteria: ProcessInspectionCriteria | null, postProcess: { __typename: 'PostProcess', id: string, name: string, typeName: string | null }, postProcessThickness: { __typename: 'Thickness', id: string, name: string } | null, postProcessColor: { __typename: 'Color', id: string, name: string } | null }>, secondaryProcesses: Array<{ __typename: 'QmrSecondaryProcessDetails', unitPriceInCents: number | null, leadTimeInDays: number | null, notes: string | null, process: { __typename: 'PostProcess', id: string, name: string, typeName: string | null }, pricingAndLeadTimeFields: { __typename: 'HardwareInstallationManualQuoteCalcFields', international: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', markupPercentage: number, mpPayoutInCents: number | null, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, domestic: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', mpPayoutInCents: number | null, markupPercentage: number, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, lineItems: Array<{ __typename: 'HardwareLineItem', supplier: string | null, partNumber: string | null, qtyPerPart: number, pricePerPack: number, qtyPerPack: number }> | null } | { __typename: 'SecondaryProcessManualQuoteCalcFields', international: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', markupPercentage: number, mpPayoutInCents: number | null, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, domestic: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', mpPayoutInCents: number | null, markupPercentage: number, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null } | null }>, totalPrice: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null } | null, partRevision: { __typename: 'Revision', id: any, analysisErrorCode: string | null, downloadUri: string | null, modelFileName: string | null, status: string | null, sceneBundle: any | null, thumbnailUri: string | null, updatedAt: any, boundingBox: { __typename: 'Vector3', x: number, y: number, z: number } | null }, attachmentLink: { __typename: 'QuoteModelRevisionAttachment', id: any, createdAt: any, isPdfOcrAutoQuotable: boolean | null, quoteAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string, downloadUrl: string | null, annotated: { __typename: 'AnnotatedAttachment', id: any, fileName: string, downloadUrl: string | null } | null, sanitized: { __typename: 'SanitizedAttachment', id: any, fileName: string, downloadUrl: string | null } | null } | null } } | null, mold: { __typename: 'MoldTool', id: any, name?: string, leadTimeDays: number | null, customerToolName?: string | null, toolLife: number | null, uiIndex: number, material: { __typename: 'Material', id: string, name: string } | null, price: { __typename: 'ExactPrice', priceInCents: number | null } | null, moldToolRevisionQmr?: Array<{ __typename: 'MoldToolRevisionQmr', moldToolRevisionId: any, quoteModelRevisionId: string, cavityPerPart: number | null }> } | null } }> };

export type QuoteDetails_Quote_QuoteModels_ItemFragment = { __typename: 'QuoteModel', id: any, quoteModelRevisions: Array<{ __typename: 'QuoteModelRevision', id: any, dfmReports: Array<{ __typename: 'PartDfmReport', isPublished: boolean, source: string | null, uploaderEmail: string | null, asset: { __typename: 'Asset', id: any, fileName: string, downloadUrl: string | null, createdAt: any } | null }> }>, selectedQuoteModelRevision: { __typename: 'QuoteModelRevision', isITARProhibitedViewing: boolean | null, id: any, quantityRangeStatus: string | null, createdAt: any, fileName: string, state: QuoteModelRevisionState, updatedAt: any, version: string, drawingRequirements: Array<string>, supportedPriorityRegions: { __typename: 'SupportedPriorityRegions', partSupportsDomestic: boolean, partSupportsInternational: boolean }, dfmReports: Array<{ __typename: 'PartDfmReport', quoteAttachmentRevisionId: any, isPublished: boolean, uploaderEmail: string | null, source: string | null, asset: { __typename: 'Asset', id: any, createdAt: any, downloadUrl: string | null, fileName: string } | null }>, modelConfiguration: { __typename: 'ModelConfiguration', fdmInfillPercentageCategory: string | null, fdmInfillPercentageCategoryLabel: string | null, id: any, materialGrade: string | null, colorCode: string | null, textureCode: string | null, hasMultipleFinishes: boolean, userNeedsConfigHelp: boolean, quantity: number | null, requiresOvermold: boolean, additionalRequirements: string | null, dfmInspection: { __typename: 'ModelConfigurationDfmInspection', id: any | null, isPublished: boolean, manualOverrideMpUnitPayout: number | null, manualOverrideUnitAmount: number | null, manualOverrideUnitProductionDays: number | null, inspectionData: any, updatedBy: { __typename: 'BasicUser', id: number }, quotedBy: { __typename: 'BasicUser', id: number } | null, quoteUpdatedBy: { __typename: 'BasicUser', id: number } | null } | null, process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string } | null, material: { __typename: 'Material', id: string, name: string, materialCategory: string | null } | { __typename: 'UserEnteredMaterial', id: string, name: string, process: { __typename: 'Process', id: string, name: string } } | null, color: { __typename: 'Color', id: string, name: string } | null, shore: { __typename: 'Shore', id: string, name: string } | null, texture: { __typename: 'Texture', id: string, name: string } | null, productionLeadTime: { __typename: 'ProductionLeadTime', id: string, priorityId: string, productionDays: number, primaryProductionDays: number, shipDateEstimate: { __typename: 'ShipDateEstimate', id: string, validUntilDate: any, shippedByDate: any } } | null } | null, quoteModel: { __typename: 'QuoteModel', id: any, quote: { __typename: 'Quote', id: any, type: QuoteType } | null }, annotations: Array<{ __typename: 'Annotation', id: any }>, taps: Array<{ __typename: 'TapAnnotation', id: any }>, holes: Array<{ __typename: 'Hole', id: string, groupKey: string, patches: Array<{ __typename: 'RevisionPatch', id: string }>, tapOptions: Array<{ __typename: 'TapOption', id: string }>, tapAnnotation: { __typename: 'TapAnnotation', id: any, depth: number | null, tapOption: { __typename: 'TapOption', id: string } | null } | null }>, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, accepted: boolean, severity: string, message: string, title: string | null, isPublished: boolean }>, processesDetails: { __typename: 'QmrProcessesDetails', isBusinessAccountDiscountApplied: boolean | null, primaryProcess: { __typename: 'QmrProcessWithPrice', process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string }, price: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null } | null, postProcesses: Array<{ __typename: 'QmrPostProcessWithPriceAndLead', unitPriceInCents: number | null, postProcessLeadTimeInDays: number | null, postProcessNumParts: number | null, postProcessInspectionCriteria: ProcessInspectionCriteria | null, postProcess: { __typename: 'PostProcess', id: string, name: string, typeName: string | null }, postProcessThickness: { __typename: 'Thickness', id: string, name: string } | null, postProcessColor: { __typename: 'Color', id: string, name: string } | null }>, secondaryProcesses: Array<{ __typename: 'QmrSecondaryProcessDetails', unitPriceInCents: number | null, leadTimeInDays: number | null, notes: string | null, process: { __typename: 'PostProcess', id: string, name: string, typeName: string | null }, pricingAndLeadTimeFields: { __typename: 'HardwareInstallationManualQuoteCalcFields', international: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', markupPercentage: number, mpPayoutInCents: number | null, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, domestic: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', mpPayoutInCents: number | null, markupPercentage: number, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, lineItems: Array<{ __typename: 'HardwareLineItem', supplier: string | null, partNumber: string | null, qtyPerPart: number, pricePerPack: number, qtyPerPack: number }> | null } | { __typename: 'SecondaryProcessManualQuoteCalcFields', international: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', markupPercentage: number, mpPayoutInCents: number | null, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, domestic: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', mpPayoutInCents: number | null, markupPercentage: number, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null } | null }>, totalPrice: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null } | null, partRevision: { __typename: 'Revision', id: any, analysisErrorCode: string | null, downloadUri: string | null, modelFileName: string | null, status: string | null, sceneBundle: any | null, thumbnailUri: string | null, updatedAt: any, boundingBox: { __typename: 'Vector3', x: number, y: number, z: number } | null }, attachmentLink: { __typename: 'QuoteModelRevisionAttachment', id: any, createdAt: any, isPdfOcrAutoQuotable: boolean | null, quoteAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string, downloadUrl: string | null, annotated: { __typename: 'AnnotatedAttachment', id: any, fileName: string, downloadUrl: string | null } | null, sanitized: { __typename: 'SanitizedAttachment', id: any, fileName: string, downloadUrl: string | null } | null } | null } } | null, mold: { __typename: 'MoldTool', id: any, name?: string, leadTimeDays: number | null, customerToolName?: string | null, toolLife: number | null, uiIndex: number, material: { __typename: 'Material', id: string, name: string } | null, price: { __typename: 'ExactPrice', priceInCents: number | null } | null, moldToolRevisionQmr?: Array<{ __typename: 'MoldToolRevisionQmr', moldToolRevisionId: any, quoteModelRevisionId: string, cavityPerPart: number | null }> } | null } };

export type QuoteDetails_Quote_Attachments_Item_LatestAttachmentRevision_AttachmentFragment = { __typename: 'Attachment', id: any, fileName: string, downloadUrl: string | null, annotated: { __typename: 'AnnotatedAttachment', id: any, fileName: string, downloadUrl: string | null } | null, sanitized: { __typename: 'SanitizedAttachment', id: any, fileName: string, downloadUrl: string | null } | null };

export type QuoteDetails_Quote_Attachments_Item_LatestAttachmentRevisionFragment = { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string, downloadUrl: string | null, annotated: { __typename: 'AnnotatedAttachment', id: any, fileName: string, downloadUrl: string | null } | null, sanitized: { __typename: 'SanitizedAttachment', id: any, fileName: string, downloadUrl: string | null } | null } | null };

export type QuoteDetails_Quote_Attachments_ItemFragment = { __typename: 'QuoteAttachment', id: any, latestAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string, downloadUrl: string | null, annotated: { __typename: 'AnnotatedAttachment', id: any, fileName: string, downloadUrl: string | null } | null, sanitized: { __typename: 'SanitizedAttachment', id: any, fileName: string, downloadUrl: string | null } | null } | null } };

export type QuoteDetails_Quote_PlatformOrderFragment = { __typename: 'PlatformOrder', id: number | null, name: string | null, purchaserEmail: string | null, purchasedDate: any | null, purchaserUserId: number | null };

export type QuoteDetails_Quote_UserFragment = { __typename: 'BasicUser', id: number, email: any };

export type QuoteDetails_Quote_AttachmentsFragment = { __typename: 'PartialQuoteAttachmentResults', totalCount: number, items: Array<{ __typename: 'QuoteAttachment', id: any, latestAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string, downloadUrl: string | null, annotated: { __typename: 'AnnotatedAttachment', id: any, fileName: string, downloadUrl: string | null } | null, sanitized: { __typename: 'SanitizedAttachment', id: any, fileName: string, downloadUrl: string | null } | null } | null } }> };

export type QuoteDetails_Quote_DfmAssets_ItemFragment = { __typename: 'Asset', id: any, fileName: string, downloadUrl: string | null };

export type QuoteDetails_Quote_DfmAssetsFragment = { __typename: 'PartialAssetResults', totalCount: number, items: Array<{ __typename: 'Asset', id: any, fileName: string, downloadUrl: string | null }> };

export type QuoteDetails_QuoteFragment = { __typename: 'Quote', id: any, type: QuoteType, isLocked: boolean | null, isQuoteInRfqState: boolean, isQuotePurchasable: boolean, isQuoteIMReorder: boolean, lastModified: any | null, name: string, orderName: string | null, needByDate: any | null, notesToCustomer: string | null, slowestShipDateEstimate: any | null, isOverseasShipping: boolean, earliestValidUntilDate: any | null, status: string, subTotalInCents: number | null, reorderSourceOrderName: string | null, deletedAt: any | null, beganCheckoutAt: any | null, zipCode: string | null, isTaxExempt: boolean | null, numberOfParts: number, partsSummary: any, expiration: any | null, isExpired: boolean, depositInCents: number | null, productionPartsSubtotalInCents: number | null, moldToolSubtotalInCents: number | null, isEligibleForFreeShipping: boolean | null, isMoldRepair: boolean | null, platformOrder: { __typename: 'PlatformOrder', id: number | null, name: string | null, purchaserEmail: string | null, purchasedDate: any | null, purchaserUserId: number | null } | null, purchaseInfo: { __typename: 'BasicPurchaseInfo', purchaserEmail: string | null, purchasedDate: any | null, purchaserUserId: number | null } | null, user: { __typename: 'BasicUser', id: number, email: any }, team: { __typename: 'Team', id: number, name: string } | null, businessAccountDiscount: { __typename: 'BusinessAccountDiscount', id: number, percent: number, isActive: boolean, endAt: any } | null, quoteAttachments: { __typename: 'PartialQuoteAttachmentResults', totalCount: number, items: Array<{ __typename: 'QuoteAttachment', id: any, latestAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string, downloadUrl: string | null, annotated: { __typename: 'AnnotatedAttachment', id: any, fileName: string, downloadUrl: string | null } | null, sanitized: { __typename: 'SanitizedAttachment', id: any, fileName: string, downloadUrl: string | null } | null } | null } }> }, quoteModels: { __typename: 'PartialQuoteModelResults', totalCount: number, items: Array<{ __typename: 'QuoteModel', id: any, quoteModelRevisions: Array<{ __typename: 'QuoteModelRevision', id: any, dfmReports: Array<{ __typename: 'PartDfmReport', isPublished: boolean, source: string | null, uploaderEmail: string | null, asset: { __typename: 'Asset', id: any, fileName: string, downloadUrl: string | null, createdAt: any } | null }> }>, selectedQuoteModelRevision: { __typename: 'QuoteModelRevision', isITARProhibitedViewing: boolean | null, id: any, quantityRangeStatus: string | null, createdAt: any, fileName: string, state: QuoteModelRevisionState, updatedAt: any, version: string, drawingRequirements: Array<string>, supportedPriorityRegions: { __typename: 'SupportedPriorityRegions', partSupportsDomestic: boolean, partSupportsInternational: boolean }, dfmReports: Array<{ __typename: 'PartDfmReport', quoteAttachmentRevisionId: any, isPublished: boolean, uploaderEmail: string | null, source: string | null, asset: { __typename: 'Asset', id: any, createdAt: any, downloadUrl: string | null, fileName: string } | null }>, modelConfiguration: { __typename: 'ModelConfiguration', fdmInfillPercentageCategory: string | null, fdmInfillPercentageCategoryLabel: string | null, id: any, materialGrade: string | null, colorCode: string | null, textureCode: string | null, hasMultipleFinishes: boolean, userNeedsConfigHelp: boolean, quantity: number | null, requiresOvermold: boolean, additionalRequirements: string | null, dfmInspection: { __typename: 'ModelConfigurationDfmInspection', id: any | null, isPublished: boolean, manualOverrideMpUnitPayout: number | null, manualOverrideUnitAmount: number | null, manualOverrideUnitProductionDays: number | null, inspectionData: any, updatedBy: { __typename: 'BasicUser', id: number }, quotedBy: { __typename: 'BasicUser', id: number } | null, quoteUpdatedBy: { __typename: 'BasicUser', id: number } | null } | null, process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string } | null, material: { __typename: 'Material', id: string, name: string, materialCategory: string | null } | { __typename: 'UserEnteredMaterial', id: string, name: string, process: { __typename: 'Process', id: string, name: string } } | null, color: { __typename: 'Color', id: string, name: string } | null, shore: { __typename: 'Shore', id: string, name: string } | null, texture: { __typename: 'Texture', id: string, name: string } | null, productionLeadTime: { __typename: 'ProductionLeadTime', id: string, priorityId: string, productionDays: number, primaryProductionDays: number, shipDateEstimate: { __typename: 'ShipDateEstimate', id: string, validUntilDate: any, shippedByDate: any } } | null } | null, quoteModel: { __typename: 'QuoteModel', id: any, quote: { __typename: 'Quote', id: any, type: QuoteType } | null }, annotations: Array<{ __typename: 'Annotation', id: any }>, taps: Array<{ __typename: 'TapAnnotation', id: any }>, holes: Array<{ __typename: 'Hole', id: string, groupKey: string, patches: Array<{ __typename: 'RevisionPatch', id: string }>, tapOptions: Array<{ __typename: 'TapOption', id: string }>, tapAnnotation: { __typename: 'TapAnnotation', id: any, depth: number | null, tapOption: { __typename: 'TapOption', id: string } | null } | null }>, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, accepted: boolean, severity: string, message: string, title: string | null, isPublished: boolean }>, processesDetails: { __typename: 'QmrProcessesDetails', isBusinessAccountDiscountApplied: boolean | null, primaryProcess: { __typename: 'QmrProcessWithPrice', process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string }, price: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null } | null, postProcesses: Array<{ __typename: 'QmrPostProcessWithPriceAndLead', unitPriceInCents: number | null, postProcessLeadTimeInDays: number | null, postProcessNumParts: number | null, postProcessInspectionCriteria: ProcessInspectionCriteria | null, postProcess: { __typename: 'PostProcess', id: string, name: string, typeName: string | null }, postProcessThickness: { __typename: 'Thickness', id: string, name: string } | null, postProcessColor: { __typename: 'Color', id: string, name: string } | null }>, secondaryProcesses: Array<{ __typename: 'QmrSecondaryProcessDetails', unitPriceInCents: number | null, leadTimeInDays: number | null, notes: string | null, process: { __typename: 'PostProcess', id: string, name: string, typeName: string | null }, pricingAndLeadTimeFields: { __typename: 'HardwareInstallationManualQuoteCalcFields', international: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', markupPercentage: number, mpPayoutInCents: number | null, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, domestic: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', mpPayoutInCents: number | null, markupPercentage: number, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, lineItems: Array<{ __typename: 'HardwareLineItem', supplier: string | null, partNumber: string | null, qtyPerPart: number, pricePerPack: number, qtyPerPack: number }> | null } | { __typename: 'SecondaryProcessManualQuoteCalcFields', international: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', markupPercentage: number, mpPayoutInCents: number | null, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, domestic: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', mpPayoutInCents: number | null, markupPercentage: number, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null } | null }>, totalPrice: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null } | null, partRevision: { __typename: 'Revision', id: any, analysisErrorCode: string | null, downloadUri: string | null, modelFileName: string | null, status: string | null, sceneBundle: any | null, thumbnailUri: string | null, updatedAt: any, boundingBox: { __typename: 'Vector3', x: number, y: number, z: number } | null }, attachmentLink: { __typename: 'QuoteModelRevisionAttachment', id: any, createdAt: any, isPdfOcrAutoQuotable: boolean | null, quoteAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string, downloadUrl: string | null, annotated: { __typename: 'AnnotatedAttachment', id: any, fileName: string, downloadUrl: string | null } | null, sanitized: { __typename: 'SanitizedAttachment', id: any, fileName: string, downloadUrl: string | null } | null } | null } } | null, mold: { __typename: 'MoldTool', id: any, name?: string, leadTimeDays: number | null, customerToolName?: string | null, toolLife: number | null, uiIndex: number, material: { __typename: 'Material', id: string, name: string } | null, price: { __typename: 'ExactPrice', priceInCents: number | null } | null, moldToolRevisionQmr?: Array<{ __typename: 'MoldToolRevisionQmr', moldToolRevisionId: any, quoteModelRevisionId: string, cavityPerPart: number | null }> } | null } }> }, project: { __typename: 'BasicProject', id: any | null, isSecurePlus: boolean, name: string } | null, dfmAssets: { __typename: 'PartialAssetResults', totalCount: number, items: Array<{ __typename: 'Asset', id: any, fileName: string, downloadUrl: string | null }> } };

export type QuoteDetailsQueryVariables = Exact<{
  id: Scalars['UUID'];
  isImMaafcoEnabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type QuoteDetailsQuery = { __typename: 'Query', quote: { __typename: 'Quote', id: any, type: QuoteType, isLocked: boolean | null, isQuoteInRfqState: boolean, isQuotePurchasable: boolean, isQuoteIMReorder: boolean, lastModified: any | null, name: string, orderName: string | null, needByDate: any | null, notesToCustomer: string | null, slowestShipDateEstimate: any | null, isOverseasShipping: boolean, earliestValidUntilDate: any | null, status: string, subTotalInCents: number | null, reorderSourceOrderName: string | null, deletedAt: any | null, beganCheckoutAt: any | null, zipCode: string | null, isTaxExempt: boolean | null, numberOfParts: number, partsSummary: any, expiration: any | null, isExpired: boolean, depositInCents: number | null, productionPartsSubtotalInCents: number | null, moldToolSubtotalInCents: number | null, isEligibleForFreeShipping: boolean | null, isMoldRepair: boolean | null, platformOrder: { __typename: 'PlatformOrder', id: number | null, name: string | null, purchaserEmail: string | null, purchasedDate: any | null, purchaserUserId: number | null } | null, purchaseInfo: { __typename: 'BasicPurchaseInfo', purchaserEmail: string | null, purchasedDate: any | null, purchaserUserId: number | null } | null, user: { __typename: 'BasicUser', id: number, email: any }, team: { __typename: 'Team', id: number, name: string } | null, businessAccountDiscount: { __typename: 'BusinessAccountDiscount', id: number, percent: number, isActive: boolean, endAt: any } | null, quoteAttachments: { __typename: 'PartialQuoteAttachmentResults', totalCount: number, items: Array<{ __typename: 'QuoteAttachment', id: any, latestAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string, downloadUrl: string | null, annotated: { __typename: 'AnnotatedAttachment', id: any, fileName: string, downloadUrl: string | null } | null, sanitized: { __typename: 'SanitizedAttachment', id: any, fileName: string, downloadUrl: string | null } | null } | null } }> }, quoteModels: { __typename: 'PartialQuoteModelResults', totalCount: number, items: Array<{ __typename: 'QuoteModel', id: any, quoteModelRevisions: Array<{ __typename: 'QuoteModelRevision', id: any, dfmReports: Array<{ __typename: 'PartDfmReport', isPublished: boolean, source: string | null, uploaderEmail: string | null, asset: { __typename: 'Asset', id: any, fileName: string, downloadUrl: string | null, createdAt: any } | null }> }>, selectedQuoteModelRevision: { __typename: 'QuoteModelRevision', isITARProhibitedViewing: boolean | null, id: any, quantityRangeStatus: string | null, createdAt: any, fileName: string, state: QuoteModelRevisionState, updatedAt: any, version: string, drawingRequirements: Array<string>, supportedPriorityRegions: { __typename: 'SupportedPriorityRegions', partSupportsDomestic: boolean, partSupportsInternational: boolean }, dfmReports: Array<{ __typename: 'PartDfmReport', quoteAttachmentRevisionId: any, isPublished: boolean, uploaderEmail: string | null, source: string | null, asset: { __typename: 'Asset', id: any, createdAt: any, downloadUrl: string | null, fileName: string } | null }>, modelConfiguration: { __typename: 'ModelConfiguration', fdmInfillPercentageCategory: string | null, fdmInfillPercentageCategoryLabel: string | null, id: any, materialGrade: string | null, colorCode: string | null, textureCode: string | null, hasMultipleFinishes: boolean, userNeedsConfigHelp: boolean, quantity: number | null, requiresOvermold: boolean, additionalRequirements: string | null, dfmInspection: { __typename: 'ModelConfigurationDfmInspection', id: any | null, isPublished: boolean, manualOverrideMpUnitPayout: number | null, manualOverrideUnitAmount: number | null, manualOverrideUnitProductionDays: number | null, inspectionData: any, updatedBy: { __typename: 'BasicUser', id: number }, quotedBy: { __typename: 'BasicUser', id: number } | null, quoteUpdatedBy: { __typename: 'BasicUser', id: number } | null } | null, process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string } | null, material: { __typename: 'Material', id: string, name: string, materialCategory: string | null } | { __typename: 'UserEnteredMaterial', id: string, name: string, process: { __typename: 'Process', id: string, name: string } } | null, color: { __typename: 'Color', id: string, name: string } | null, shore: { __typename: 'Shore', id: string, name: string } | null, texture: { __typename: 'Texture', id: string, name: string } | null, productionLeadTime: { __typename: 'ProductionLeadTime', id: string, priorityId: string, productionDays: number, primaryProductionDays: number, shipDateEstimate: { __typename: 'ShipDateEstimate', id: string, validUntilDate: any, shippedByDate: any } } | null } | null, quoteModel: { __typename: 'QuoteModel', id: any, quote: { __typename: 'Quote', id: any, type: QuoteType } | null }, annotations: Array<{ __typename: 'Annotation', id: any }>, taps: Array<{ __typename: 'TapAnnotation', id: any }>, holes: Array<{ __typename: 'Hole', id: string, groupKey: string, patches: Array<{ __typename: 'RevisionPatch', id: string }>, tapOptions: Array<{ __typename: 'TapOption', id: string }>, tapAnnotation: { __typename: 'TapAnnotation', id: any, depth: number | null, tapOption: { __typename: 'TapOption', id: string } | null } | null }>, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, accepted: boolean, severity: string, message: string, title: string | null, isPublished: boolean }>, processesDetails: { __typename: 'QmrProcessesDetails', isBusinessAccountDiscountApplied: boolean | null, primaryProcess: { __typename: 'QmrProcessWithPrice', process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string }, price: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null } | null, postProcesses: Array<{ __typename: 'QmrPostProcessWithPriceAndLead', unitPriceInCents: number | null, postProcessLeadTimeInDays: number | null, postProcessNumParts: number | null, postProcessInspectionCriteria: ProcessInspectionCriteria | null, postProcess: { __typename: 'PostProcess', id: string, name: string, typeName: string | null }, postProcessThickness: { __typename: 'Thickness', id: string, name: string } | null, postProcessColor: { __typename: 'Color', id: string, name: string } | null }>, secondaryProcesses: Array<{ __typename: 'QmrSecondaryProcessDetails', unitPriceInCents: number | null, leadTimeInDays: number | null, notes: string | null, process: { __typename: 'PostProcess', id: string, name: string, typeName: string | null }, pricingAndLeadTimeFields: { __typename: 'HardwareInstallationManualQuoteCalcFields', international: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', markupPercentage: number, mpPayoutInCents: number | null, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, domestic: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', mpPayoutInCents: number | null, markupPercentage: number, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, lineItems: Array<{ __typename: 'HardwareLineItem', supplier: string | null, partNumber: string | null, qtyPerPart: number, pricePerPack: number, qtyPerPack: number }> | null } | { __typename: 'SecondaryProcessManualQuoteCalcFields', international: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', markupPercentage: number, mpPayoutInCents: number | null, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, domestic: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', mpPayoutInCents: number | null, markupPercentage: number, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null } | null }>, totalPrice: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null } | null, partRevision: { __typename: 'Revision', id: any, analysisErrorCode: string | null, downloadUri: string | null, modelFileName: string | null, status: string | null, sceneBundle: any | null, thumbnailUri: string | null, updatedAt: any, boundingBox: { __typename: 'Vector3', x: number, y: number, z: number } | null }, attachmentLink: { __typename: 'QuoteModelRevisionAttachment', id: any, createdAt: any, isPdfOcrAutoQuotable: boolean | null, quoteAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string, downloadUrl: string | null, annotated: { __typename: 'AnnotatedAttachment', id: any, fileName: string, downloadUrl: string | null } | null, sanitized: { __typename: 'SanitizedAttachment', id: any, fileName: string, downloadUrl: string | null } | null } | null } } | null, mold: { __typename: 'MoldTool', id: any, name?: string, leadTimeDays: number | null, customerToolName?: string | null, toolLife: number | null, uiIndex: number, material: { __typename: 'Material', id: string, name: string } | null, price: { __typename: 'ExactPrice', priceInCents: number | null } | null, moldToolRevisionQmr?: Array<{ __typename: 'MoldToolRevisionQmr', moldToolRevisionId: any, quoteModelRevisionId: string, cavityPerPart: number | null }> } | null } }> }, project: { __typename: 'BasicProject', id: any | null, isSecurePlus: boolean, name: string } | null, dfmAssets: { __typename: 'PartialAssetResults', totalCount: number, items: Array<{ __typename: 'Asset', id: any, fileName: string, downloadUrl: string | null }> } } | null };

export type QuoteShipStatusQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type QuoteShipStatusQuery = { __typename: 'Query', quote: { __typename: 'Quote', id: any, isQuotePurchasable: boolean, earliestValidUntilDate: any | null, slowestShipDateEstimate: any | null } | null };

export type CreateOpenInviteOnQuoteMutationVariables = Exact<{
  id: Scalars['UUID'];
  senderId: InputMaybe<Scalars['Int']>;
}>;


export type CreateOpenInviteOnQuoteMutation = { __typename: 'Mutation', createOpenInviteOnQuote: { __typename: 'Quote', id: any, openEndedInviteUrl: string | null } };

export type SubmitQuoteChangeRequestMutationVariables = Exact<{
  submitQuoteChangeRequestId: Scalars['UUID'];
  changeRequestInput: ChangeRequestInput;
}>;


export type SubmitQuoteChangeRequestMutation = { __typename: 'Mutation', submitQuoteChangeRequest: { __typename: 'Quote', id: any, isLocked: boolean | null } };

export type QuoteModelHistoryQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type QuoteModelHistoryQuery = { __typename: 'Query', quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, fileName: string, modelConfiguration: { __typename: 'ModelConfiguration', process: { __typename: 'Process', platformProcessTypeId: string, name: string, id: string } | null } | null, partRevision: { __typename: 'Revision', id: any, analysisErrorCode: string | null, downloadUri: string | null, modelFileName: string | null, status: string | null, sceneBundle: any | null, thumbnailUri: string | null, updatedAt: any, boundingBox: { __typename: 'Vector3', x: number, y: number, z: number } | null }, quoteModel: { __typename: 'QuoteModel', id: any, quote: { __typename: 'Quote', id: any, status: string, type: QuoteType, isQuoteIMReorder: boolean, isLocked: boolean | null, user: { __typename: 'BasicUser', id: number } } | null, selectedQuoteModelRevision: { __typename: 'QuoteModelRevision', id: any, fileName: string, version: string }, quoteModelRevisions: Array<{ __typename: 'QuoteModelRevision', id: any, fileName: string, version: string, createdAt: any, updatedAt: any, revisionNotes: string | null, dfmReports: Array<{ __typename: 'PartDfmReport', isPublished: boolean, source: string | null, uploaderEmail: string | null, asset: { __typename: 'Asset', id: any, fileName: string, downloadUrl: string | null, createdAt: any } | null }>, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any }> }> } } | null };

export type PunchoutSessionDataFragment = { __typename: 'PunchoutSession', businessAccountId: any, buyerCookie: string, disabledProcesses: string | null, orderUrl: string, buyerEmail: string, expireAt: any, sessionId: any };

export type PunchoutSessionQueryVariables = Exact<{
  punchoutSessionId: Scalars['UUID'];
}>;


export type PunchoutSessionQuery = { __typename: 'Query', punchoutSession: { __typename: 'PunchoutSession', businessAccountId: any, buyerCookie: string, disabledProcesses: string | null, orderUrl: string, buyerEmail: string, expireAt: any, sessionId: any } | null };

export type QuotesTotalCountQuoteDropzonePageQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type QuotesTotalCountQuoteDropzonePageQueryQuery = { __typename: 'Query', me: { __typename: 'User', id: number, quotes: { __typename: 'PartialQuoteViewResults', totalCount: number } | null } | null };

export type ObouserQuotesTotalCountQuoteDropzonePageQueryQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type ObouserQuotesTotalCountQuoteDropzonePageQueryQuery = { __typename: 'Query', user: { __typename: 'User', id: number, quotes: { __typename: 'PartialQuoteViewResults', totalCount: number } | null } | null };

export type IsUserPotentialNuaQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IsUserPotentialNuaQuery = { __typename: 'Query', user: { __typename: 'User', id: number, email: any, isNUA: boolean } | null };

export type RequestOdooQuoteMutationVariables = Exact<{
  quoteId: Scalars['UUID'];
  userId: InputMaybe<Scalars['Int']>;
  isOdooRequest: InputMaybe<Scalars['Boolean']>;
}>;


export type RequestOdooQuoteMutation = { __typename: 'Mutation', requestOdooQuote: { __typename: 'Quote', id: any, status: string } };

export type CreateQuoteDropzoneMutationVariables = Exact<{
  name: InputMaybe<Scalars['String']>;
  description: InputMaybe<Scalars['String']>;
  userId: InputMaybe<Scalars['Int']>;
  quoteType: InputMaybe<QuoteType>;
  teamId: InputMaybe<Scalars['Int']>;
  processId: InputMaybe<Scalars['String']>;
}>;


export type CreateQuoteDropzoneMutation = { __typename: 'Mutation', createQuote: { __typename: 'Quote', id: any, name: string } };

export type CreateQmrDropzoneMutationVariables = Exact<{
  uploadMetadata: QuoteModelRevisionUploadInput;
  quoteId: Scalars['UUID'];
  quoteModelId: InputMaybe<Scalars['UUID']>;
  setAsSelectedForQuoteModel: Scalars['Boolean'];
  userId: InputMaybe<Scalars['Int']>;
}>;


export type CreateQmrDropzoneMutation = { __typename: 'Mutation', createQuoteModelRevision: { __typename: 'QuoteModelRevision', id: any, uploadUrl: string | null, partRevision: { __typename: 'Revision', id: any, partId: number | null, thumbnailUri: string | null } } };

export type CreateQuoteAttachmentRevisionDropzoneMutationVariables = Exact<{
  uploadMetadata: AttachmentInput;
  quoteId: Scalars['UUID'];
  quoteAttachmentId: InputMaybe<Scalars['UUID']>;
  attachmentType: InputMaybe<Scalars['String']>;
  productAttachmentId: InputMaybe<Scalars['String']>;
}>;


export type CreateQuoteAttachmentRevisionDropzoneMutation = { __typename: 'Mutation', createQuoteAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string, uploadUrl: string | null } | null, asset: { __typename: 'Asset', id: any, fileName: string, uploadUrl: string | null } | null } };

export type DropZoneFinalizeUploadAndProcessPartMutationVariables = Exact<{
  partId: Scalars['Int'];
}>;


export type DropZoneFinalizeUploadAndProcessPartMutation = { __typename: 'Mutation', finalizeUploadAndProcessPart: { __typename: 'InstantQuoterResponseType', partId: number, status: InstantQuoterStatus, reason: string | null } };

export type MarkQuoteAttachmentRevisionUploadedDropzoneMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type MarkQuoteAttachmentRevisionUploadedDropzoneMutation = { __typename: 'Mutation', markQuoteAttachmentRevisionUploaded: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string, downloadUrl: string | null } | null } };

export type QuotesListQueryVariables = Exact<{
  limit: Scalars['Int'];
  sort: InputMaybe<Scalars['CreatedAtSortKey']>;
  offset: InputMaybe<Scalars['Int']>;
  filter: InputMaybe<QuoteAttributeFilterType>;
  isCpqFlagV2Enabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type QuotesListQuery = { __typename: 'Query', me: { __typename: 'User', id: number, hasSecurePlusMemberships: boolean, quotes: { __typename: 'PartialQuoteViewResults', totalCount: number, items: Array<{ __typename: 'BasicQuote', id: any, name: string, project: { __typename: 'BasicProject', isSecurePlus: boolean, name: string, id: any | null } | null } | { __typename: 'Quote', id: any, name: string, type: QuoteType, status: string, lastModified: any | null, isEligibleForFreeShipping: boolean | null, subTotalInCents: number | null, earliestValidUntilDate: any | null, slowestShipDateEstimate: any | null, isOverseasShipping: boolean, isQuotePurchasable: boolean, isLocked: boolean | null, isCpqOwned: boolean | null, isCpqQuote?: boolean | null, beganCheckoutAt: any | null, isExpired: boolean, expiration: any | null, depositInCents: number | null, productionPartsSubtotalInCents: number | null, moldToolSubtotalInCents: number | null, isQuoteInRfqState: boolean, zipCode: string | null, isTaxExempt: boolean | null, partsSummary: any, numberOfParts: number, platformOrder: { __typename: 'PlatformOrder', id: number | null, name: string | null, purchaserEmail: string | null, purchasedDate: any | null, purchaserUserId: number | null } | null, cpqQuote?: { __typename: 'CpqQuote', sfdcId: any, quotePdfUrl: string, orderTotal: number, partsCount: number, moldCount: number, orderQuantity: number, platformQuote: { __typename: 'Quote', id: any } } | null, user: { __typename: 'BasicUser', id: number, email: any }, team: { __typename: 'Team', id: number, name: string } | null, businessAccountDiscount: { __typename: 'BusinessAccountDiscount', id: number, percent: number, isActive: boolean, endAt: any } | null, quoteAttachments: { __typename: 'PartialQuoteAttachmentResults', totalCount: number, items: Array<{ __typename: 'QuoteAttachment', id: any, latestAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any } }> }, quoteModels: { __typename: 'PartialQuoteModelResults', totalCount: number, items: Array<{ __typename: 'QuoteModel', id: any, selectedQuoteModelRevision: { __typename: 'QuoteModelRevision', id: any, state: QuoteModelRevisionState, fileName: string, quantityRangeStatus: string | null, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, accepted: boolean, severity: string }>, attachmentLink: { __typename: 'QuoteModelRevisionAttachment', id: any, quoteAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any } } | null, processesDetails: { __typename: 'QmrProcessesDetails', totalPrice: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', unitPriceInCents: number | null, priceInCents: number | null } | null } | null, modelConfiguration: { __typename: 'ModelConfiguration', id: any, colorCode: string | null, quantity: number | null, productionLeadTime: { __typename: 'ProductionLeadTime', productionDays: number } | null, material: { __typename: 'Material', id: string, name: string } | { __typename: 'UserEnteredMaterial', id: string, name: string, process: { __typename: 'Process', id: string, name: string } } | null, process: { __typename: 'Process', id: string, name: string } | null, color: { __typename: 'Color', id: string, name: string } | null } | null } }> }, project: { __typename: 'BasicProject', id: any | null, name: string, isSecurePlus: boolean } | null }> } | null } | null };

export type DestroyQuoteMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DestroyQuoteMutation = { __typename: 'Mutation', destroyQuote: { __typename: 'Quote', id: any } | null };

export type OrderActivityQuoteItemQmrFragment = { __typename: 'QuoteItem', quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, fileName: string } };

export type OrderActivityItemFragment = { __typename: 'ProjectActivity', id: any, createdAt: any, meta: any | null, summary: string, targetId: any, actor: { __typename: 'BasicUser', id: number, email: any } | null, quote: { __typename: 'Quote', quoteItems: { __typename: 'PartialQuoteItemResults', items: Array<{ __typename: 'QuoteItem', quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, fileName: string } }> } } };

export type OrderActivityQueryQueryVariables = Exact<{
  saleOrderId: InputMaybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type OrderActivityQueryQuery = { __typename: 'Query', orderActivity: { __typename: 'PartialProjectActivityResults', totalCount: number, items: Array<{ __typename: 'ProjectActivity', id: any, createdAt: any, meta: any | null, summary: string, targetId: any, actor: { __typename: 'BasicUser', id: number, email: any } | null, quote: { __typename: 'Quote', quoteItems: { __typename: 'PartialQuoteItemResults', items: Array<{ __typename: 'QuoteItem', quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, fileName: string } }> } } }> } };

export type QuoteActivityQuoteItemQmrFragment = { __typename: 'QuoteItem', quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, fileName: string } };

export type QuoteActivityItemFragment = { __typename: 'ProjectActivity', id: any, createdAt: any, meta: any | null, summary: string, targetId: any, actor: { __typename: 'BasicUser', id: number, email: any } | null, quote: { __typename: 'Quote', quoteItems: { __typename: 'PartialQuoteItemResults', items: Array<{ __typename: 'QuoteItem', quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, fileName: string } }> } } };

export type QuoteActivityQueryQueryVariables = Exact<{
  quoteId: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  showDetailedLogs: InputMaybe<Scalars['Boolean']>;
}>;


export type QuoteActivityQueryQuery = { __typename: 'Query', quoteActivity: { __typename: 'PartialProjectActivityResults', totalCount: number, items: Array<{ __typename: 'ProjectActivity', id: any, createdAt: any, meta: any | null, summary: string, targetId: any, actor: { __typename: 'BasicUser', id: number, email: any } | null, quote: { __typename: 'Quote', quoteItems: { __typename: 'PartialQuoteItemResults', items: Array<{ __typename: 'QuoteItem', quoteModelRevision: { __typename: 'QuoteModelRevision', id: any, fileName: string } }> } } }> } };

export type QuoteDetailsForInviteAndMemberQueryVariables = Exact<{
  id: Scalars['UUID'];
  senderId: InputMaybe<Scalars['Int']>;
}>;


export type QuoteDetailsForInviteAndMemberQuery = { __typename: 'Query', quote: { __typename: 'Quote', id: any, openEndedQuoteInviteUrl: string | null, isQuotePurchasable: boolean, user: { __typename: 'BasicUser', id: number, email: any, firstName: string | null, lastName: string | null, enabled: boolean }, members: { __typename: 'PartialMembershipResults', items: Array<{ __typename: 'Membership', id: any, role: string, user: { __typename: 'BasicUser', id: number, displayName: string, firstName: string | null, lastName: string | null, email: any, enabled: boolean } }> }, team: { __typename: 'Team', id: number, name: string } | null, invites: { __typename: 'PartialInviteResults', totalCount: number, items: Array<{ __typename: 'Invite', id: any, status: string, email: any | null, isOpenEnded: boolean, createdAt: any, deletedAt: any | null }> } | null } | null };

export type RemoveQuoteTeamMembershipMutationVariables = Exact<{
  quoteId: Scalars['UUID'];
  teamId: Scalars['Int'];
  userId: InputMaybe<Scalars['Int']>;
}>;


export type RemoveQuoteTeamMembershipMutation = { __typename: 'Mutation', removeQuoteTeamMembership: { __typename: 'QuoteTeamMembership', id: number } | null };

export type AddTeamMembersMutationVariables = Exact<{
  members: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  teamId: Scalars['Int'];
  userId: Scalars['Int'];
}>;


export type AddTeamMembersMutation = { __typename: 'Mutation', addTeamMembers: { __typename: 'AddUserTeamMembershipResult', errors: Array<{ __typename: 'AddUserTeamMembershipError', email: string, error: string } | null> | null, userTeamMemberships: Array<{ __typename: 'UserTeamMembership', id: number } | null> | null } };

export type RemoveTeamMemberMutationVariables = Exact<{
  email: Scalars['String'];
  teamId: Scalars['Int'];
  userId: Scalars['Int'];
}>;


export type RemoveTeamMemberMutation = { __typename: 'Mutation', removeTeamMember: { __typename: 'RemoveUserTeamMemberResult', email: string, removed: boolean, failureReason: string | null } };

export type UserBusinessAccountMembershipDateQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UserBusinessAccountMembershipDateQuery = { __typename: 'Query', user: { __typename: 'User', id: number, businessAccountMembership: { __typename: 'BusinessAccountMembership', businessAccount: { __typename: 'BusinessAccount', id: any, name: string, isEnabled: boolean, isTeamsFeatureEnabled: boolean | null, discount: { __typename: 'BusinessAccountDiscount', isActive: boolean } | null }, user: { __typename: 'User', id: number, enabled: boolean } } | null } | null };

export type TeamSpendByTimeItemFragment = { __typename: 'TeamSpendByTimeResult', spend: number, actualSaving: number, potentialSavings: number, count: number, timePeriod: string };

export type TeamSpendByTimeQueryVariables = Exact<{
  teamId: Scalars['Int'];
  userId: Scalars['Int'];
  dateRange: DateRangeInput;
  timezoneOffset: InputMaybe<Scalars['Int']>;
}>;


export type TeamSpendByTimeQuery = { __typename: 'Query', teamSpendByTime: { __typename: 'TeamSpendResult', teamTotals: { __typename: 'TeamTotalsResult', orders: number, spend: number, actualSavings: number, potentialSavings: number | null }, teamSpendByTime: Array<{ __typename: 'TeamSpendByTimeResult', spend: number, actualSaving: number, potentialSavings: number, count: number, timePeriod: string }> } };

export type TeamOrdersQueryVariables = Exact<{
  teamId: Scalars['Int'];
  userId: InputMaybe<Scalars['Int']>;
  filters: InputMaybe<TeamQuoteAndOrderFilterInput>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  sort: InputMaybe<TeamQuotesAndOrdersSortInput>;
}>;


export type TeamOrdersQuery = { __typename: 'Query', teamOrders: { __typename: 'PartialSalesOrderViewResults', totalCount: number, items: Array<{ __typename: 'BasicSalesOrder' } | { __typename: 'SalesOrder', id: string, name: string, deliveryStatus: string, orderDate: any | null, createdAt: any, fictivEstimatedDeliveryDate: any | null, totalAmount: number, paymentDetails: { __typename: 'PaymentDetails', paymentType: string | null, purchaseOrderNumber: string | null, paidBy: { __typename: 'BasicUser', id: number, email: any } | null }, salesOrderLines: { __typename: 'PartialSalesOrderLineResults', totalCount: number, items: Array<{ __typename: 'SalesOrderLine', id: string, revision: { __typename: 'Revision', thumbnailUri: string | null } | null }> }, shipments: { __typename: 'PartialShipmentResults', items: Array<{ __typename: 'Shipment', trackingData: { __typename: 'TrackingData', estDeliveryDate: any | null, trackingDetails: Array<{ __typename: 'TrackingDetail', status: string, datetime: any | null }> } | null }> } | null }> } };

export type TeamQuotesQueryVariables = Exact<{
  teamId: Scalars['Int'];
  filters: InputMaybe<TeamQuoteAndOrderFilterInput>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  userId: InputMaybe<Scalars['Int']>;
}>;


export type TeamQuotesQuery = { __typename: 'Query', teamQuotes: { __typename: 'PartialTeamQuotesResult', totalCount: number, items: Array<{ __typename: 'Quote', id: any, lastModified: any | null, name: string, createdAt: any, subTotalInCents: number | null, user: { __typename: 'BasicUser', email: any, id: number }, quoteModels: { __typename: 'PartialQuoteModelResults', totalCount: number, items: Array<{ __typename: 'QuoteModel', id: any, quoteModelRevisions: Array<{ __typename: 'QuoteModelRevision', partRevision: { __typename: 'Revision', thumbnailUri: string | null } }> }> } } | null> } };

export type TeamQueryVariables = Exact<{
  teamId: Scalars['Int'];
  userId: InputMaybe<Scalars['Int']>;
}>;


export type TeamQuery = { __typename: 'Query', team: { __typename: 'Team', id: number, name: string, businessAccountId: any, totalMembers: number | null, totalQuotes: number | null, totalSalesOrders: number | null, createdAt: any, updatedAt: any, createdBy: { __typename: 'BasicUser', id: number, displayName: string, email: any, createdAt: any, updatedAt: any, enabled: boolean }, updatedBy: { __typename: 'BasicUser', id: number, displayName: string, email: any, createdAt: any, updatedAt: any, enabled: boolean }, salesOrders: { __typename: 'PartialSalesOrderViewResults', totalCount: number } } | null };

export type RequestTeamAccessMutationVariables = Exact<{
  teamId: Scalars['Int'];
  userId: InputMaybe<Scalars['Int']>;
}>;


export type RequestTeamAccessMutation = { __typename: 'Mutation', requestTeamAccess: { __typename: 'RequestTeamAccessResult', email: string, userId: number, teamId: number, teamName: string, businessAccountId: string } | null };

export type WorkspaceMemberFragment = { __typename: 'UserTeamMember', displayName: string, id: number | null, email: any, memberType: UserTeamMemberMemberType, teamId: number };

export type WorkspacesQueryVariables = Exact<{
  filters: InputMaybe<TeamsFilterInput>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  memberFilters: InputMaybe<TeamsMembersFilterInput>;
}>;


export type WorkspacesQuery = { __typename: 'Query', teams: { __typename: 'PartialTeamsResult', totalCount: number, items: Array<{ __typename: 'Team', id: number, name: string, totalQuotes: number | null, totalSalesOrders: number | null, members: { __typename: 'PartialUserTeamMembersResult', items: Array<{ __typename: 'UserTeamMember', displayName: string, id: number | null, email: any, memberType: UserTeamMemberMemberType, teamId: number }> }, createdBy: { __typename: 'BasicUser', displayName: string, id: number } }> } };

export type ApproveTeamAccessRequestMutationVariables = Exact<{
  requestId: Scalars['Int'];
}>;


export type ApproveTeamAccessRequestMutation = { __typename: 'Mutation', approveTeamAccessRequest: string | null };

export type DenyTeamAccessRequestMutationVariables = Exact<{
  requestId: Scalars['Int'];
}>;


export type DenyTeamAccessRequestMutation = { __typename: 'Mutation', denyTeamAccessRequest: string | null };

export type TeamMemberFragment = { __typename: 'UserTeamMember', id: number | null, email: any, displayName: string, firstName: string | null, lastName: string | null, enabled: boolean, isTeamMember: boolean, isRequest: boolean, createdAt: any, joinedDate: any | null, isSelfRequest: boolean, memberType: UserTeamMemberMemberType, requestId: number | null, teamId: number };

export type UserTeamMembersQueryVariables = Exact<{
  filters: InputMaybe<UserTeamMembersFilterInput>;
}>;


export type UserTeamMembersQuery = { __typename: 'Query', userTeamMembers: { __typename: 'PartialUserTeamMembersResult', totalCount: number, items: Array<{ __typename: 'UserTeamMember', id: number | null, email: any, displayName: string, firstName: string | null, lastName: string | null, enabled: boolean, isTeamMember: boolean, isRequest: boolean, createdAt: any, joinedDate: any | null, isSelfRequest: boolean, memberType: UserTeamMemberMemberType, requestId: number | null, teamId: number }> } };

export type SendEmailVerificationMutationVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type SendEmailVerificationMutation = { __typename: 'Mutation', user: { __typename: 'UserMutation', sendEmailVerification: { __typename: 'SendEmailVerificationResponse', verificationUrl: string | null, user: { __typename: 'User', id: number } } | null } | null };

export type DeleteAccountUserProfileMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteAccountUserProfileMutation = { __typename: 'Mutation', user: { __typename: 'UserMutation', deleteAccount: { __typename: 'User', id: number, email: any, updatedAt: any } | null } | null };

export type UpdateUserProfileMutationVariables = Exact<{
  id: Scalars['Int'];
  profileInput: UserProfileInput;
}>;


export type UpdateUserProfileMutation = { __typename: 'Mutation', user: { __typename: 'UserMutation', editGeneralInfo: { __typename: 'User', id: number, firstName: string | null, lastName: string | null, phoneNumber: string | null } | null } | null };

export type UserPhoneNumberUserProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type UserPhoneNumberUserProfileQuery = { __typename: 'Query', me: { __typename: 'User', id: number, phoneNumber: string | null } | null };

export type FileUploaderFinalizeUploadAndProcessPartMutationVariables = Exact<{
  partId: Scalars['Int'];
}>;


export type FileUploaderFinalizeUploadAndProcessPartMutation = { __typename: 'Mutation', finalizeUploadAndProcessPart: { __typename: 'InstantQuoterResponseType', partId: number, status: InstantQuoterStatus, reason: string | null } };

export type CreateQuoteFileUploaderMutationVariables = Exact<{
  name: InputMaybe<Scalars['String']>;
  description: InputMaybe<Scalars['String']>;
}>;


export type CreateQuoteFileUploaderMutation = { __typename: 'Mutation', createQuote: { __typename: 'Quote', id: any, name: string } };

export type CreateQmrFileUploaderMutationVariables = Exact<{
  uploadMetadata: QuoteModelRevisionUploadInput;
  quoteId: Scalars['UUID'];
  quoteModelId: InputMaybe<Scalars['UUID']>;
  setAsSelectedForQuoteModel: Scalars['Boolean'];
}>;


export type CreateQmrFileUploaderMutation = { __typename: 'Mutation', createQuoteModelRevision: { __typename: 'QuoteModelRevision', id: any, uploadUrl: string | null, partRevision: { __typename: 'Revision', id: any, partId: number | null, thumbnailUri: string | null } } };

export type CreateQuoteAttachmentRevisionFileUploaderMutationVariables = Exact<{
  uploadMetadata: AttachmentInput;
  quoteId: Scalars['UUID'];
  quoteAttachmentId: InputMaybe<Scalars['UUID']>;
  attachmentType: InputMaybe<Scalars['String']>;
  productAttachmentId: InputMaybe<Scalars['String']>;
  adminReplaced: InputMaybe<Scalars['Boolean']>;
  userId: InputMaybe<Scalars['Int']>;
}>;


export type CreateQuoteAttachmentRevisionFileUploaderMutation = { __typename: 'Mutation', createQuoteAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string, uploadUrl: string | null } | null, asset: { __typename: 'Asset', id: any, fileName: string, uploadUrl: string | null } | null } };

export type MarkQuoteAttachmentRevisionUploadedFileUploaderMutationVariables = Exact<{
  id: Scalars['UUID'];
  userId: InputMaybe<Scalars['Int']>;
}>;


export type MarkQuoteAttachmentRevisionUploadedFileUploaderMutation = { __typename: 'Mutation', markQuoteAttachmentRevisionUploaded: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string, downloadUrl: string | null } | null } };

export type CreateQmrAttachmentMutationMutationVariables = Exact<{
  quoteModelRevisionId: Scalars['UUID'];
  quoteAttachmentRevisionId: Scalars['UUID'];
  userId: InputMaybe<Scalars['Int']>;
}>;


export type CreateQmrAttachmentMutationMutation = { __typename: 'Mutation', createQuoteModelRevisionAttachment: { __typename: 'QuoteModelRevisionAttachment', id: any, quoteModelRevision: { __typename: 'QuoteModelRevision', id: any } } };

export type UpdateGeneratedDrawingMutationMutationVariables = Exact<{
  id: Scalars['UUID'];
  attachment: AttachmentInput;
}>;


export type UpdateGeneratedDrawingMutationMutation = { __typename: 'Mutation', updateGeneratedDrawing: { __typename: 'GeneratedDrawing', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string, uploadUrl: string | null } | null } };

export type MarkUploadedAttachmentMutationMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type MarkUploadedAttachmentMutationMutation = { __typename: 'Mutation', markUploadedAttachment: { __typename: 'Attachment', id: any, fileName: string, downloadUrl: string | null } };

export type GetUserBusinessAccountStatusQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetUserBusinessAccountStatusQuery = { __typename: 'Query', getUserBusinessAccountStatus: { __typename: 'UserBusinessAccountAssociationStatus', businessAccountId: string | null, businessAccountName: string | null, businessAccountInviteStatus: BusinessAccountInviteStatus | null, isBusinessAccountMember: boolean | null, isEmailVerified: boolean | null, isLTOFeatureEnabled: boolean | null, isPOFeatureEnabled: boolean | null, isSalesforceContact: boolean | null, isTeamsFeatureEnabled: boolean | null, isConsultativeDfmFeatureEnabled: boolean | null, userId: number } };

export type CreateStripeClientSecretMutationVariables = Exact<{
  id: Scalars['Int'];
  supportedPaymentTypes: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type CreateStripeClientSecretMutation = { __typename: 'Mutation', user: { __typename: 'UserMutation', createStripeClientSecret: string | null } | null };

export type CreateZipDownloadMutationVariables = Exact<{
  name: Scalars['String'];
  folderId: InputMaybe<Scalars['UUID']>;
  revisionIds: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  attachmentIds: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  quoteModelRevisionIds: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  quoteAttachmentRevisionIds: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  estimateItemIds: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
}>;


export type CreateZipDownloadMutation = { __typename: 'Mutation', createZipDownload: { __typename: 'ZipDownloadJob', id: string, jobStartDate: any, jobCompleteDate: any | null, name: string, error: string | null, url: string | null } };

export type CreateEstimateItemZipDownloadMutationVariables = Exact<{
  name: Scalars['String'];
  estimateItemIds: Array<Scalars['UUID']> | Scalars['UUID'];
  mode: EstimateItemZipMode;
}>;


export type CreateEstimateItemZipDownloadMutation = { __typename: 'Mutation', createEstimateItemZipDownload: { __typename: 'ZipDownloadJob', id: string, error: string | null, url: string | null, name: string, jobStartDate: any, jobCompleteDate: any | null } };

export type QuoteAttachmentRevisionQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type QuoteAttachmentRevisionQuery = { __typename: 'Query', quoteAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, downloadUrl: string | null, uploadUrl: string | null, fileName: string, annotated: { __typename: 'AnnotatedAttachment', id: any, downloadUrl: string | null, fileName: string } | null } | null } | null };

export type Disable2FaMyAccountMutationVariables = Exact<{
  id: Scalars['Int'];
  password: InputMaybe<Scalars['String']>;
}>;


export type Disable2FaMyAccountMutation = { __typename: 'Mutation', user: { __typename: 'UserMutation', disable2FA: { __typename: 'User', id: number, email: any, is2faEnabled: boolean } | null } | null };

export type GetIs2faEnabledMyAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIs2faEnabledMyAccountQuery = { __typename: 'Query', me: { __typename: 'User', id: number, is2faEnabled: boolean } | null };

export type GetQrCodeMyAccountPageMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetQrCodeMyAccountPageMutation = { __typename: 'Mutation', user: { __typename: 'UserMutation', enable2FA: string } | null };

export type Verify2FaMyAccountPageMutationVariables = Exact<{
  id: Scalars['Int'];
  code: Scalars['String'];
}>;


export type Verify2FaMyAccountPageMutation = { __typename: 'Mutation', user: { __typename: 'UserMutation', verify2FA: { __typename: 'User', id: number, email: any, is2faEnabled: boolean } | null } | null };

export type SetBusinessAccountExcludedCountriesMutationVariables = Exact<{
  businessAccountId: Scalars['UUID'];
  excludedCountryIDs: InputMaybe<Array<InputMaybe<BusinessAccountExcludedCountriesInput>> | InputMaybe<BusinessAccountExcludedCountriesInput>>;
}>;


export type SetBusinessAccountExcludedCountriesMutation = { __typename: 'Mutation', setBusinessAccountExcludedCountries: { __typename: 'BusinessAccount', id: any, excludedCountries: Array<{ __typename: 'BusinessAccountExcludedCountry', name: string | null, value: string | null } | null> | null } | null };

export type AcceptDfmFeedbackMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type AcceptDfmFeedbackMutation = { __typename: 'Mutation', acceptDfmFeedback: { __typename: 'DfmFeedback', id: any } };

export type AcceptOpenInviteMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type AcceptOpenInviteMutation = { __typename: 'Mutation', acceptOpenInvite: { __typename: 'Invite', id: any } };

export type AcceptQuoteInviteMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type AcceptQuoteInviteMutation = { __typename: 'Mutation', acceptInvite: { __typename: 'Invite', id: any } };

export type AddCustomerShippingAccountMutationVariables = Exact<{
  name: InputMaybe<Scalars['String']>;
  provider: Carrier;
  accountNumber: Scalars['String'];
  country: Scalars['String'];
  postalCode: Scalars['String'];
  userId: InputMaybe<Scalars['Int']>;
}>;


export type AddCustomerShippingAccountMutation = { __typename: 'Mutation', createCarrierAccount: { __typename: 'TplCarrierAccount', id: any, provider: Carrier } };

export type AdminAddOrModifyShippingAddressForUserAdminUserQuoteCheckoutPageMutationVariables = Exact<{
  userId: Scalars['Int'];
  shippingAddressInput: ShippingAddressInput;
}>;


export type AdminAddOrModifyShippingAddressForUserAdminUserQuoteCheckoutPageMutation = { __typename: 'Mutation', adminUser: { __typename: 'UserMutation', modifyShippingAddress: { __typename: 'UserShippingAddress', id: number, name: string | null, company: string | null, street: string, aptNumber: string | null, city: string | null, state: string | null, zip: string, phone: string | null, country: string, createdAt: any, isVerified: boolean | null, isDefault: boolean | null, timezone: string | null } } | null };

export type AdminDeactivateBusinessAccountMemberMutationVariables = Exact<{
  businessAccountId: Scalars['String'];
  userId: Scalars['Int'];
}>;


export type AdminDeactivateBusinessAccountMemberMutation = { __typename: 'Mutation', deactivateBusinessAccountMember: boolean };

export type AdminRemoveShippingAddressForUserAdminUserQuoteCheckoutPageMutationVariables = Exact<{
  userId: Scalars['Int'];
  id: Scalars['Int'];
}>;


export type AdminRemoveShippingAddressForUserAdminUserQuoteCheckoutPageMutation = { __typename: 'Mutation', adminUser: { __typename: 'UserMutation', removeShippingAddress: Array<{ __typename: 'UserShippingAddress', id: number, name: string | null, company: string | null, street: string, aptNumber: string | null, city: string | null, state: string | null, zip: string, phone: string | null, country: string, createdAt: any, isVerified: boolean | null, isDefault: boolean | null, timezone: string | null }> } | null };

export type AdminUpdateProcessConfigsOnQmrsMutationVariables = Exact<{
  ids: Array<Scalars['UUID']> | Scalars['UUID'];
  primaryProcessConfig: PrimaryProcessConfigInput;
  secondaryProcessConfigs: Array<SecondaryProcessConfigInput> | SecondaryProcessConfigInput;
  removeManuallyQuotedSecondaryProcesses: InputMaybe<Scalars['Boolean']>;
}>;


export type AdminUpdateProcessConfigsOnQmrsMutation = { __typename: 'Mutation', updateProcessConfigsOnQuoteModelRevisions: Array<{ __typename: 'QuoteModelRevision', id: any, fileName: string, version: string, updatedAt: any, state: QuoteModelRevisionState, quantityRangeStatus: string | null, processesDetails: { __typename: 'QmrProcessesDetails', isBusinessAccountDiscountApplied: boolean | null, totalPrice: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null, primaryProcess: { __typename: 'QmrProcessWithPrice', process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string }, price: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null } | null, postProcesses: Array<{ __typename: 'QmrPostProcessWithPriceAndLead', unitPriceInCents: number | null, postProcessLeadTimeInDays: number | null, postProcessNumParts: number | null, postProcessInspectionCriteria: ProcessInspectionCriteria | null, postProcess: { __typename: 'PostProcess', id: string, name: string, typeName: string | null, colors: Array<{ __typename: 'Color', id: string, name: string } | null> | null, thicknesses: Array<{ __typename: 'Thickness', id: string, name: string, value: number } | null> | null }, postProcessThickness: { __typename: 'Thickness', id: string, name: string } | null, postProcessColor: { __typename: 'Color', id: string, name: string } | null }>, secondaryProcesses: Array<{ __typename: 'QmrSecondaryProcessDetails', unitPriceInCents: number | null, leadTimeInDays: number | null, notes: string | null, process: { __typename: 'PostProcess', id: string, name: string, typeName: string | null }, pricingAndLeadTimeFields: { __typename: 'HardwareInstallationManualQuoteCalcFields', international: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', markupPercentage: number, mpPayoutInCents: number | null, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, domestic: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', mpPayoutInCents: number | null, markupPercentage: number, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, lineItems: Array<{ __typename: 'HardwareLineItem', supplier: string | null, partNumber: string | null, qtyPerPart: number, pricePerPack: number, qtyPerPack: number }> | null } | { __typename: 'SecondaryProcessManualQuoteCalcFields', international: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', markupPercentage: number, mpPayoutInCents: number | null, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, domestic: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', mpPayoutInCents: number | null, markupPercentage: number, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null } | null }> } | null, modelConfiguration: { __typename: 'ModelConfiguration', id: any, requiresOvermold: boolean, additionalRequirements: string | null, materialGrade: string | null, colorCode: string | null, textureCode: string | null, quantity: number | null, errorCode: string | null, updatedAt: any, dfmInspections: Array<{ __typename: 'ModelConfigurationDfmInspection', id: any | null, inspectionData: any, quantityLowerRange: number | null, quantityUpperRange: number | null, isQuantityRangeAvailable: boolean | null, isPublished: boolean, manualOverrideMpUnitPayout: number | null, manualOverrideUnitAmount: number | null, quotedAt: any | null, quoteUpdatedAt: any | null, updatedAt: any, quotedBy: { __typename: 'BasicUser', id: number, displayName: string } | null, quoteUpdatedBy: { __typename: 'BasicUser', id: number, displayName: string } | null } | null> | null, dfmInspection: { __typename: 'ModelConfigurationDfmInspection', id: any | null, inspectionData: any, isPublished: boolean, quotedAt: any | null, quoteUpdatedAt: any | null, updatedAt: any, manualOverrideMpUnitPayout: number | null, manualOverrideUnitAmount: number | null, quotedBy: { __typename: 'BasicUser', id: number, displayName: string } | null, quoteUpdatedBy: { __typename: 'BasicUser', id: number, displayName: string } | null } | null, productionLeadTime: { __typename: 'ProductionLeadTime', id: string, priorityId: string, productionDays: number, primaryProductionDays: number, shipDateEstimate: { __typename: 'ShipDateEstimate', id: string, validUntilDate: any, shippedByDate: any } } | null, process: { __typename: 'Process', id: string, name: string } | null, material: { __typename: 'Material', id: string, name: string, materialCategory: string | null } | { __typename: 'UserEnteredMaterial', id: string, name: string } | null, color: { __typename: 'Color', id: string, name: string } | null, texture: { __typename: 'Texture', id: string, name: string } | null, updatedBy: { __typename: 'BasicUser', id: number, email: any, updatedAt: any }, toolDetails: { __typename: 'ToolCosts', totalCost: number | null, tools: Array<{ __typename: 'Tool', id: string, type: string, diameter: number, length: number | null, ratio: number, price: number | null } | null> | null } | null } | null, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, isValid: boolean, message: string, title: string | null, link: string | null, code: string | null, isPublished: boolean, severity: string, sourceType: string | null, isAutoGeneratedDfm: boolean, createdAt: any, deletedAt: any | null, createdBy: { __typename: 'BasicUser', displayName: string, email: any }, modelViewerSnapshots: Array<{ __typename: 'ModelViewerSnapshot', id: any, snapshot: { __typename: 'ModelViewerConfig', rotation: Array<number> | null, camera: { __typename: 'ModelViewerCameraConfig', position: Array<number>, zoom: number, up: Array<number> | null, target: Array<number> | null } | null, part: { __typename: 'ModelViewerPartConfig', transparent: boolean, patches: Array<{ __typename: 'ModelViewerPatchConfig', color: string | null, hashcode: string }> }, dfm: Array<{ __typename: 'ModelViewerDfmFeatureConfig', color: string | null, threshold: number | null, feature: string | null, direction: Array<number> | null }>, annotations: Array<{ __typename: 'ModelViewerAnnotationConfig', position: Array<number> }>, crossSection: { __typename: 'ModelViewerCrossSectionConfig', position: any, rotation: any } | null, pointToPoint: { __typename: 'PointToPointConfig', customPoints: Array<any>, selectedPoints: Array<{ __typename: 'P2PPoint', index: number, type: P2PPointType }> } | null } | null }> }> }> };

export type AdminUpsertManuallyQuotedSecondaryProcessesConfigMutationVariables = Exact<{
  id: Scalars['UUID'];
  manuallyQuotedSecondaryProcessConfig: ManuallyQuotedSecondaryProcessConfigInput;
}>;


export type AdminUpsertManuallyQuotedSecondaryProcessesConfigMutation = { __typename: 'Mutation', upsertManuallyQuotedSecondaryProcessesConfig: { __typename: 'QuoteModelRevision', id: any } };

export type ClaimEmailVerificationMutationVariables = Exact<{
  token: Scalars['String'];
  userId: Scalars['Int'];
}>;


export type ClaimEmailVerificationMutation = { __typename: 'Mutation', user: { __typename: 'UserMutation', claimEmailVerification: { __typename: 'ClaimEmailVerificationResponse', addedToBusinessAccount: boolean, isPremiumTrialActivated: boolean | null, user: { __typename: 'User', id: number } } } | null };

export type CreateBusinessAccountMutationVariables = Exact<{
  salesforceAccountId: Scalars['String'];
  enabled: Scalars['Boolean'];
}>;


export type CreateBusinessAccountMutation = { __typename: 'Mutation', createBusinessAccount: { __typename: 'BusinessAccount', id: any, name: string, isEnabled: boolean } | null };

export type CreateOrUpdateShippingAddressQuoteCheckoutPageMutationVariables = Exact<{
  userId: Scalars['Int'];
  shippingAddressInput: ShippingAddressInput;
}>;


export type CreateOrUpdateShippingAddressQuoteCheckoutPageMutation = { __typename: 'Mutation', user: { __typename: 'UserMutation', modifyShippingAddress: { __typename: 'UserShippingAddress', id: number, name: string | null, company: string | null, street: string, aptNumber: string | null, city: string | null, state: string | null, zip: string, phone: string | null, country: string, createdAt: any, isVerified: boolean | null, isDefault: boolean | null, timezone: string | null } } | null };

export type CreateQmrAttachmentMutationVariables = Exact<{
  quoteModelRevisionId: Scalars['UUID'];
  quoteAttachmentRevisionId: Scalars['UUID'];
}>;


export type CreateQmrAttachmentMutation = { __typename: 'Mutation', createQuoteModelRevisionAttachment: { __typename: 'QuoteModelRevisionAttachment', id: any, quoteModelRevision: { __typename: 'QuoteModelRevision', id: any } } };

export type CreateQmrAttachmentAdditionalRequirementsMutationVariables = Exact<{
  quoteModelRevisionId: Scalars['UUID'];
  quoteAttachmentRevisionId: Scalars['UUID'];
}>;


export type CreateQmrAttachmentAdditionalRequirementsMutation = { __typename: 'Mutation', createQuoteModelRevisionAttachment: { __typename: 'QuoteModelRevisionAttachment', id: any, quoteModelRevision: { __typename: 'QuoteModelRevision', id: any }, quoteAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string, downloadUrl: string | null } | null } } };

export type CreateQmrAttachmentAutoAttachMutationVariables = Exact<{
  quoteModelRevisionId: Scalars['UUID'];
  quoteAttachmentRevisionId: Scalars['UUID'];
}>;


export type CreateQmrAttachmentAutoAttachMutation = { __typename: 'Mutation', createQuoteModelRevisionAttachment: { __typename: 'QuoteModelRevisionAttachment', id: any } };

export type CreateQmrRevisionMutationVariables = Exact<{
  uploadMetadata: QuoteModelRevisionUploadInput;
  quoteId: Scalars['UUID'];
  quoteModelId: InputMaybe<Scalars['UUID']>;
  setAsSelectedForQuoteModel: Scalars['Boolean'];
  revisionNotes: InputMaybe<Scalars['String']>;
}>;


export type CreateQmrRevisionMutation = { __typename: 'Mutation', createQuoteModelRevision: { __typename: 'QuoteModelRevision', id: any, uploadUrl: string | null, partRevision: { __typename: 'Revision', id: any, partId: number | null, downloadUri: string | null } } };

export type CreateQuoteAttachmentRevisionMutationVariables = Exact<{
  uploadMetadata: AttachmentInput;
  quoteId: Scalars['UUID'];
  quoteAttachmentId: InputMaybe<Scalars['UUID']>;
  attachmentType: InputMaybe<Scalars['String']>;
  productAttachmentId: InputMaybe<Scalars['String']>;
}>;


export type CreateQuoteAttachmentRevisionMutation = { __typename: 'Mutation', createQuoteAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string, uploadUrl: string | null } | null, asset: { __typename: 'Asset', id: any, fileName: string, uploadUrl: string | null } | null } };

export type CreateQuoteModelRevisionAttachmentMutationVariables = Exact<{
  quoteModelRevisionId: Scalars['UUID'];
  quoteAttachmentRevisionId: Scalars['UUID'];
}>;


export type CreateQuoteModelRevisionAttachmentMutation = { __typename: 'Mutation', createQuoteModelRevisionAttachment: { __typename: 'QuoteModelRevisionAttachment', id: any } };

export type CreateTeamMutationVariables = Exact<{
  businessAccountId: Scalars['UUID'];
  name: Scalars['String'];
  userId: Scalars['Int'];
}>;


export type CreateTeamMutation = { __typename: 'Mutation', createTeam: { __typename: 'CreateTeamOutput', team: { __typename: 'Team', id: number } } | null };

export type DeleteCustomerShippingAccountMutationVariables = Exact<{
  id: Scalars['UUID'];
  userId: InputMaybe<Scalars['Int']>;
}>;


export type DeleteCustomerShippingAccountMutation = { __typename: 'Mutation', destroyCarrierAccount: { __typename: 'TplCarrierAccount', id: any } };

export type DeletePaymentOptionMutationVariables = Exact<{
  id: Scalars['Int'];
  cardId: Scalars['String'];
}>;


export type DeletePaymentOptionMutation = { __typename: 'Mutation', user: { __typename: 'UserMutation', removeCreditCard: Array<{ __typename: 'CreditCard', id: string | null, referenceId: string | null, card: { __typename: 'Card', id: string | null, brand: string | null, expMonth: number | null, expYear: number | null, last4: string | null } | null } | null> | null } | null };

export type DeleteTeamMutationVariables = Exact<{
  teamId: Scalars['Int'];
  userId: Scalars['Int'];
}>;


export type DeleteTeamMutation = { __typename: 'Mutation', deleteTeam: { __typename: 'Team', id: number } | null };

export type DestroyInviteMutationVariables = Exact<{
  id: Scalars['UUID'];
  actorOverrideId: InputMaybe<Scalars['Int']>;
}>;


export type DestroyInviteMutation = { __typename: 'Mutation', destroyInvite: { __typename: 'Invite', id: any } };

export type DestroyQuoteModelRevisionTapOnHoleMutationVariables = Exact<{
  quoteModelRevisionId: Scalars['UUID'];
  holeId: Scalars['String'];
}>;


export type DestroyQuoteModelRevisionTapOnHoleMutation = { __typename: 'Mutation', destroyQuoteModelRevisionTapOnHole: { __typename: 'UpsertOrDeleteTapResponse', quoteModelRevisionId: string | null, hole: { __typename: 'Hole', id: string, tapAnnotation: { __typename: 'TapAnnotation', id: any, tapOption: { __typename: 'TapOption', id: string, commonName: string } | null } | null } } };

export type DestroyQuoteModelRevisionTapOnHolesMutationVariables = Exact<{
  quoteModelRevisionId: Scalars['UUID'];
  holesList: Array<Scalars['String']> | Scalars['String'];
}>;


export type DestroyQuoteModelRevisionTapOnHolesMutation = { __typename: 'Mutation', destroyQuoteModelRevisionTapOnHoles: { __typename: 'UpsertOrDeleteTapsResponse', quoteModelRevisionId: string | null, hole: Array<{ __typename: 'Hole', id: string, tapAnnotation: { __typename: 'TapAnnotation', id: any, tapOption: { __typename: 'TapOption', id: string, commonName: string } | null } | null }> } };

export type DisableTeamsMutationConfirmationModalMutationVariables = Exact<{
  businessAccountId: Scalars['String'];
}>;


export type DisableTeamsMutationConfirmationModalMutation = { __typename: 'Mutation', disableTeams: { __typename: 'BusinessAccountFeature', isEnabled: boolean } };

export type EnableBusinessAccountMutationConfirmationModalMutationVariables = Exact<{
  businessAccountId: Scalars['String'];
}>;


export type EnableBusinessAccountMutationConfirmationModalMutation = { __typename: 'Mutation', enableBusinessAccount: { __typename: 'BusinessAccount', id: any } | null };

export type EnableTeamsMutationConfirmationModalMutationVariables = Exact<{
  businessAccountId: Scalars['String'];
}>;


export type EnableTeamsMutationConfirmationModalMutation = { __typename: 'Mutation', enableTeams: { __typename: 'BusinessAccountFeature', isEnabled: boolean } };

export type FinalizeUploadAndProcessPartMutationVariables = Exact<{
  partId: Scalars['Int'];
}>;


export type FinalizeUploadAndProcessPartMutation = { __typename: 'Mutation', finalizeUploadAndProcessPart: { __typename: 'InstantQuoterResponseType', partId: number, status: InstantQuoterStatus, reason: string | null } };

export type MarkQuoteAttachmentRevisionUploadedMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type MarkQuoteAttachmentRevisionUploadedMutation = { __typename: 'Mutation', markQuoteAttachmentRevisionUploaded: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string, downloadUrl: string | null } | null } };

export type MoveOrderTeamMutationVariables = Exact<{
  teamId: Scalars['Int'];
  erpSaleOrderId: InputMaybe<Scalars['Int']>;
  platformOrderId: InputMaybe<Scalars['Int']>;
  userId: InputMaybe<Scalars['Int']>;
}>;


export type MoveOrderTeamMutation = { __typename: 'Mutation', moveOrderTeam: { __typename: 'OrderTeamMembership', id: number } | null };

export type PlaceOrderMutationVariables = Exact<{
  orderInput: OrderInput;
  userId: InputMaybe<Scalars['Int']>;
}>;


export type PlaceOrderMutation = { __typename: 'Mutation', placeOrder: { __typename: 'Order', id: number, name: string | null } | null };

export type ReactivateBusinessAccountMemberMutationVariables = Exact<{
  businessAccountId: Scalars['String'];
  userId: Scalars['Int'];
}>;


export type ReactivateBusinessAccountMemberMutation = { __typename: 'Mutation', reactivateBusinessAccountMember: boolean };

export type RecordBeganCheckoutEventMutationMutationVariables = Exact<{
  quoteId: Scalars['UUID'];
}>;


export type RecordBeganCheckoutEventMutationMutation = { __typename: 'Mutation', recordSystemEvent: boolean };

export type RemoveBusinessAccountMembershipMutationVariables = Exact<{
  removeBusinessAccountMembershipId: Scalars['UUID'];
}>;


export type RemoveBusinessAccountMembershipMutation = { __typename: 'Mutation', removeBusinessAccountMembership: { __typename: 'BusinessAccountMembership', id: any } };

export type RemoveManuallyQuotedSecondaryProcessMutationVariables = Exact<{
  ids: Array<Scalars['UUID']> | Scalars['UUID'];
  processId: InputMaybe<Scalars['String']>;
}>;


export type RemoveManuallyQuotedSecondaryProcessMutation = { __typename: 'Mutation', removeManuallyQuotedSecondaryProcess: Array<string> };

export type RemoveMembershipMutationVariables = Exact<{
  id: Scalars['UUID'];
  actorOverrideId: InputMaybe<Scalars['Int']>;
}>;


export type RemoveMembershipMutation = { __typename: 'Mutation', removeMembership: { __typename: 'Membership', id: any } };

export type RemoveOrderTeamMembershipMutationVariables = Exact<{
  teamId: Scalars['Int'];
  platformOrderId: InputMaybe<Scalars['Int']>;
  erpSaleOrderId: InputMaybe<Scalars['Int']>;
  userId: InputMaybe<Scalars['Int']>;
}>;


export type RemoveOrderTeamMembershipMutation = { __typename: 'Mutation', removeOrderTeamMembership: { __typename: 'OrderTeamMembership', id: number } | null };

export type RemoveQmrAttachmentAdditionalRequirementsMutationVariables = Exact<{
  quoteModelRevisionId: Scalars['UUID'];
  quoteAttachmentRevisionId: Scalars['UUID'];
  userId: InputMaybe<Scalars['Int']>;
  quoteId: InputMaybe<Scalars['UUID']>;
}>;


export type RemoveQmrAttachmentAdditionalRequirementsMutation = { __typename: 'Mutation', removeQuoteModelRevisionAttachment: { __typename: 'QuoteModelRevisionAttachment', id: any, quoteModelRevision: { __typename: 'QuoteModelRevision', id: any } } | null };

export type RemoveShippingAddressQuoteCheckoutPageMutationVariables = Exact<{
  userId: Scalars['Int'];
  id: Scalars['Int'];
}>;


export type RemoveShippingAddressQuoteCheckoutPageMutation = { __typename: 'Mutation', user: { __typename: 'UserMutation', removeShippingAddress: Array<{ __typename: 'UserShippingAddress', id: number, name: string | null, company: string | null, street: string, aptNumber: string | null, city: string | null, state: string | null, zip: string, phone: string | null, country: string, createdAt: any, isVerified: boolean | null, isDefault: boolean | null, timezone: string | null }> } | null };

export type RenameTeamMutationVariables = Exact<{
  teamId: Scalars['Int'];
  name: Scalars['String'];
  userId: Scalars['Int'];
}>;


export type RenameTeamMutation = { __typename: 'Mutation', renameTeam: { __typename: 'Team', id: number } | null };

export type ResendBusinessAccountInviteMutationVariables = Exact<{
  businessAccountInviteId: Scalars['UUID'];
}>;


export type ResendBusinessAccountInviteMutation = { __typename: 'Mutation', resendBusinessAccountInvite: { __typename: 'BusinessAccountInvite', id: any, email: string, sentDate: any | null, status: BusinessAccountInviteStatus, inviteUrl: string | null } | null };

export type RevokeBusinessAccountInvitesMutationVariables = Exact<{
  inviteIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type RevokeBusinessAccountInvitesMutation = { __typename: 'Mutation', revokeBusinessAccountInvites: Array<{ __typename: 'BusinessAccountInvite', id: any, email: string } | null> };

export type SaveUserPreferencesMutationVariables = Exact<{
  userId: Scalars['Int'];
  preferenceType: PreferenceType;
  name: Scalars['String'];
  value: InputMaybe<Scalars['JSON']>;
}>;


export type SaveUserPreferencesMutation = { __typename: 'Mutation', updateOrAddUserPreference: { __typename: 'UserPreferences', id: number, preferences: any } };

export type ShareQuoteMutationVariables = Exact<{
  quoteId: Scalars['UUID'];
  emailAttributes: InputMaybe<EmailAttributesInput>;
  emailSpecificInput: EmailSpecificInput;
  includePdfInput: InputMaybe<IncludePdfInput>;
}>;


export type ShareQuoteMutation = { __typename: 'Mutation', shareQuote: { __typename: 'Invite', id: any, email: any | null, quoteUrl: string | null } | null };

export type UpdateAdditionalRequirementOnQmrMutationVariables = Exact<{
  id: Scalars['UUID'];
  notes: Scalars['String'];
}>;


export type UpdateAdditionalRequirementOnQmrMutation = { __typename: 'Mutation', updateAdditionalRequirementOnQmr: { __typename: 'QuoteModelRevision', id: any, modelConfiguration: { __typename: 'ModelConfiguration', id: any, quantity: number | null, additionalRequirements: string | null, fdmInfillPercentageCategory: string | null, fdmInfillPercentageCategoryLabel: string | null, process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string } | null, material: { __typename: 'Material', id: string, name: string } | { __typename: 'UserEnteredMaterial', id: string, name: string, process: { __typename: 'Process', id: string, name: string } } | null, color: { __typename: 'Color', id: string, name: string } | null, shore: { __typename: 'Shore', id: string, name: string } | null, texture: { __typename: 'Texture', id: string, name: string } | null, productionLeadTime: { __typename: 'ProductionLeadTime', id: string, priorityId: string, productionDays: number, shipDateEstimate: { __typename: 'ShipDateEstimate', id: string, validUntilDate: any, shippedByDate: any } } | null } | null } };

export type UpdateCustomerShippingAccountMutationVariables = Exact<{
  id: Scalars['UUID'];
  account: TplCarrierAccountUpdateInput;
  userId: InputMaybe<Scalars['Int']>;
}>;


export type UpdateCustomerShippingAccountMutation = { __typename: 'Mutation', updateCarrierAccount: { __typename: 'TplCarrierAccount', id: any, provider: Carrier } };

export type UpdatePasswordUserProfileMutationVariables = Exact<{
  id: Scalars['Int'];
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
}>;


export type UpdatePasswordUserProfileMutation = { __typename: 'Mutation', user: { __typename: 'UserMutation', editPassword: { __typename: 'User', id: number } | null } | null };

export type UpdateProcessConfigsOnQmrsMutationVariables = Exact<{
  ids: Array<Scalars['UUID']> | Scalars['UUID'];
  primaryProcessConfig: PrimaryProcessConfigInput;
  secondaryProcessConfigs: Array<SecondaryProcessConfigInput> | SecondaryProcessConfigInput;
  removeManuallyQuotedSecondaryProcesses: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateProcessConfigsOnQmrsMutation = { __typename: 'Mutation', updateProcessConfigsOnQuoteModelRevisions: Array<{ __typename: 'QuoteModelRevision', id: any, quantityRangeStatus: string | null, modelConfiguration: { __typename: 'ModelConfiguration', id: any, quantity: number | null, additionalRequirements: string | null, fdmInfillPercentageCategory: string | null, fdmInfillPercentageCategoryLabel: string | null, process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string } | null, material: { __typename: 'Material', id: string, name: string } | { __typename: 'UserEnteredMaterial', id: string, name: string, process: { __typename: 'Process', id: string, name: string } } | null, color: { __typename: 'Color', id: string, name: string } | null, shore: { __typename: 'Shore', id: string, name: string } | null, texture: { __typename: 'Texture', id: string, name: string } | null, productionLeadTime: { __typename: 'ProductionLeadTime', id: string, priorityId: string, productionDays: number, shipDateEstimate: { __typename: 'ShipDateEstimate', id: string, validUntilDate: any, shippedByDate: any } } | null } | null, processesDetails: { __typename: 'QmrProcessesDetails', primaryProcess: { __typename: 'QmrProcessWithPrice', process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string }, price: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null } | null, postProcesses: Array<{ __typename: 'QmrPostProcessWithPriceAndLead', unitPriceInCents: number | null, postProcessLeadTimeInDays: number | null, postProcessNumParts: number | null, postProcessInspectionCriteria: ProcessInspectionCriteria | null, postProcess: { __typename: 'PostProcess', id: string, name: string }, postProcessThickness: { __typename: 'Thickness', id: string } | null, postProcessColor: { __typename: 'Color', id: string } | null }>, secondaryProcesses: Array<{ __typename: 'QmrSecondaryProcessDetails', unitPriceInCents: number | null, leadTimeInDays: number | null, notes: string | null, process: { __typename: 'PostProcess', id: string, name: string } }>, totalPrice: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null } | null }> };

export type UpdateQuoteStatusToDraftCheckoutSummaryMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type UpdateQuoteStatusToDraftCheckoutSummaryMutation = { __typename: 'Mutation', updateQuoteStatusToDraft: { __typename: 'Quote', id: any, status: string, isQuoteInRfqState: boolean } };

export type UpdateQuoteZipTaxModalMutationVariables = Exact<{
  id: Scalars['UUID'];
  zipCode: Scalars['String'];
}>;


export type UpdateQuoteZipTaxModalMutation = { __typename: 'Mutation', updateQuote: { __typename: 'Quote', id: any, zipCode: string | null } };

export type UpdateTaxExemptFieldTaxModalMutationVariables = Exact<{
  id: Scalars['UUID'];
  isTaxExempt: Scalars['Boolean'];
  userId: InputMaybe<Scalars['Int']>;
}>;


export type UpdateTaxExemptFieldTaxModalMutation = { __typename: 'Mutation', updateTaxExemptField: { __typename: 'Quote', id: any, isTaxExempt: boolean | null } };

export type UpsertQuoteModelRevisionTapOnHoleMutationVariables = Exact<{
  quoteModelRevisionId: Scalars['UUID'];
  holeId: Scalars['String'];
  tapOptionId: Scalars['String'];
}>;


export type UpsertQuoteModelRevisionTapOnHoleMutation = { __typename: 'Mutation', upsertQuoteModelRevisionTapOnHole: { __typename: 'UpsertOrDeleteTapResponse', quoteModelRevisionId: string | null, hole: { __typename: 'Hole', id: string, tapAnnotation: { __typename: 'TapAnnotation', id: any, depth: number | null, tapOption: { __typename: 'TapOption', id: string, commonName: string } | null } | null } } };

export type UpsertQuoteModelRevisionTapOnHolesMutationVariables = Exact<{
  quoteModelRevisionId: Scalars['UUID'];
  holesList: Array<Scalars['String']> | Scalars['String'];
  tapOptionId: Scalars['String'];
}>;


export type UpsertQuoteModelRevisionTapOnHolesMutation = { __typename: 'Mutation', upsertQuoteModelRevisionTapOnHoles: { __typename: 'UpsertOrDeleteTapsResponse', quoteModelRevisionId: string | null, hole: Array<{ __typename: 'Hole', id: string, tapAnnotation: { __typename: 'TapAnnotation', id: any, depth: number | null, tapOption: { __typename: 'TapOption', id: string, commonName: string } | null } | null }> } };

export type UserAchAccountsItemFragment = { __typename: 'AchAccount', id: string | null, referenceId: string | null, achAccount: { __typename: 'Ach', last4: string | null, bankName: string | null } | null };

export type AdminModelConfigurationFragment = { __typename: 'ModelConfiguration', id: any, requiresOvermold: boolean, additionalRequirements: string | null, materialGrade: string | null, colorCode: string | null, textureCode: string | null, quantity: number | null, errorCode: string | null, updatedAt: any, dfmInspections: Array<{ __typename: 'ModelConfigurationDfmInspection', id: any | null, inspectionData: any, quantityLowerRange: number | null, quantityUpperRange: number | null, isQuantityRangeAvailable: boolean | null, isPublished: boolean, manualOverrideMpUnitPayout: number | null, manualOverrideUnitAmount: number | null, quotedAt: any | null, quoteUpdatedAt: any | null, updatedAt: any, quotedBy: { __typename: 'BasicUser', id: number, displayName: string } | null, quoteUpdatedBy: { __typename: 'BasicUser', id: number, displayName: string } | null } | null> | null, dfmInspection: { __typename: 'ModelConfigurationDfmInspection', id: any | null, inspectionData: any, isPublished: boolean, quotedAt: any | null, quoteUpdatedAt: any | null, updatedAt: any, manualOverrideMpUnitPayout: number | null, manualOverrideUnitAmount: number | null, quotedBy: { __typename: 'BasicUser', id: number, displayName: string } | null, quoteUpdatedBy: { __typename: 'BasicUser', id: number, displayName: string } | null } | null, productionLeadTime: { __typename: 'ProductionLeadTime', id: string, priorityId: string, productionDays: number, primaryProductionDays: number, shipDateEstimate: { __typename: 'ShipDateEstimate', id: string, validUntilDate: any, shippedByDate: any } } | null, process: { __typename: 'Process', id: string, name: string } | null, material: { __typename: 'Material', id: string, name: string, materialCategory: string | null } | { __typename: 'UserEnteredMaterial', id: string, name: string } | null, color: { __typename: 'Color', id: string, name: string } | null, texture: { __typename: 'Texture', id: string, name: string } | null, updatedBy: { __typename: 'BasicUser', id: number, email: any, updatedAt: any }, toolDetails: { __typename: 'ToolCosts', totalCost: number | null, tools: Array<{ __typename: 'Tool', id: string, type: string, diameter: number, length: number | null, ratio: number, price: number | null } | null> | null } | null };

export type AdminSearchSalesforceAccountItemFragment = { __typename: 'SalesforceAccount', id: string, name: string, totalContacts: number, hasBusinessAccount: boolean };

export type BuilderModelConfigurationFragment = { __typename: 'ModelConfiguration', id: any, quantity: number | null, additionalRequirements: string | null, fdmInfillPercentageCategory: string | null, fdmInfillPercentageCategoryLabel: string | null, process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string } | null, material: { __typename: 'Material', id: string, name: string } | { __typename: 'UserEnteredMaterial', id: string, name: string, process: { __typename: 'Process', id: string, name: string } } | null, color: { __typename: 'Color', id: string, name: string } | null, shore: { __typename: 'Shore', id: string, name: string } | null, texture: { __typename: 'Texture', id: string, name: string } | null, productionLeadTime: { __typename: 'ProductionLeadTime', id: string, priorityId: string, productionDays: number, shipDateEstimate: { __typename: 'ShipDateEstimate', id: string, validUntilDate: any, shippedByDate: any } } | null };

export type CarrierAccountFragment = { __typename: 'TplCarrierAccount', id: any, name: string | null, provider: Carrier, accountNumber: string, country: string, postalCode: string, createdAt: any, updatedAt: any };

export type UserCreditCardsItemFragment = { __typename: 'CreditCard', id: string | null, referenceId: string | null, card: { __typename: 'Card', last4: string | null, brand: string | null } | null };

export type DfmFeedbackFragment = { __typename: 'DfmFeedback', id: any, isValid: boolean, message: string, title: string | null, link: string | null, code: string | null, isPublished: boolean, severity: string, sourceType: string | null, isAutoGeneratedDfm: boolean, createdAt: any, deletedAt: any | null, createdBy: { __typename: 'BasicUser', displayName: string, email: any }, modelViewerSnapshots: Array<{ __typename: 'ModelViewerSnapshot', id: any, snapshot: { __typename: 'ModelViewerConfig', rotation: Array<number> | null, camera: { __typename: 'ModelViewerCameraConfig', position: Array<number>, zoom: number, up: Array<number> | null, target: Array<number> | null } | null, part: { __typename: 'ModelViewerPartConfig', transparent: boolean, patches: Array<{ __typename: 'ModelViewerPatchConfig', color: string | null, hashcode: string }> }, dfm: Array<{ __typename: 'ModelViewerDfmFeatureConfig', color: string | null, threshold: number | null, feature: string | null, direction: Array<number> | null }>, annotations: Array<{ __typename: 'ModelViewerAnnotationConfig', position: Array<number> }>, crossSection: { __typename: 'ModelViewerCrossSectionConfig', position: any, rotation: any } | null, pointToPoint: { __typename: 'PointToPointConfig', customPoints: Array<any>, selectedPoints: Array<{ __typename: 'P2PPoint', index: number, type: P2PPointType }> } | null } | null }> };

export type MaterialsDropdownFdmInfillOptionFragment = { __typename: 'FdmInfillOption', optionName: string, optionLabelCustomer: string, isDefault: boolean };

export type IsoCountryFragment = { __typename: 'Country', id: string, name: string };

export type MaterialsDropdownMaterialFragment = { __typename: 'Material', id: string, name: string, materialCategory: string | null, fdmInfillOptions: Array<{ __typename: 'FdmInfillOption', optionName: string, optionLabelCustomer: string, isDefault: boolean }> | null };

export type PaymentOptionFragment = { __typename: 'CreditCard', id: string | null, referenceId: string | null, card: { __typename: 'Card', id: string | null, brand: string | null, expMonth: number | null, expYear: number | null, last4: string | null } | null };

export type ProcessesDetailsFragment = { __typename: 'QmrProcessesDetails', isBusinessAccountDiscountApplied: boolean | null, totalPrice: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null, primaryProcess: { __typename: 'QmrProcessWithPrice', process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string }, price: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null } | null, postProcesses: Array<{ __typename: 'QmrPostProcessWithPriceAndLead', unitPriceInCents: number | null, postProcessLeadTimeInDays: number | null, postProcessNumParts: number | null, postProcessInspectionCriteria: ProcessInspectionCriteria | null, postProcess: { __typename: 'PostProcess', id: string, name: string, typeName: string | null, colors: Array<{ __typename: 'Color', id: string, name: string } | null> | null, thicknesses: Array<{ __typename: 'Thickness', id: string, name: string, value: number } | null> | null }, postProcessThickness: { __typename: 'Thickness', id: string, name: string } | null, postProcessColor: { __typename: 'Color', id: string, name: string } | null }>, secondaryProcesses: Array<{ __typename: 'QmrSecondaryProcessDetails', unitPriceInCents: number | null, leadTimeInDays: number | null, notes: string | null, process: { __typename: 'PostProcess', id: string, name: string, typeName: string | null }, pricingAndLeadTimeFields: { __typename: 'HardwareInstallationManualQuoteCalcFields', international: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', markupPercentage: number, mpPayoutInCents: number | null, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, domestic: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', mpPayoutInCents: number | null, markupPercentage: number, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, lineItems: Array<{ __typename: 'HardwareLineItem', supplier: string | null, partNumber: string | null, qtyPerPart: number, pricePerPack: number, qtyPerPack: number }> | null } | { __typename: 'SecondaryProcessManualQuoteCalcFields', international: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', markupPercentage: number, mpPayoutInCents: number | null, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null, domestic: { __typename: 'ManualQuoteFieldsForSecondaryProcesses', mpPayoutInCents: number | null, markupPercentage: number, mpPayoutPartsLimit: number, leadTimeInDays: number | null, leadTimePartsLimit: number } | null } | null }> };

export type QlltWithShippingOptionsOptionFragment = { __typename: 'QuoteLevelLeadTimeAndPriceOption', leadTimes: Array<number> | null, shipByDate: any | null, subTotalInCents: number | null, shippingOptions: Array<{ __typename: 'ShippingOptionItemType', shippingOptionId: string, name: string, deliveredByDate: any | null }> | null };

export type QlltWithShippingOptionsResultFragment = { __typename: 'QuoteLevelLeadTimesAndPrices', domesticFastest: { __typename: 'QuoteLevelLeadTimeAndPriceOption', leadTimes: Array<number> | null, shipByDate: any | null, subTotalInCents: number | null, shippingOptions: Array<{ __typename: 'ShippingOptionItemType', shippingOptionId: string, name: string, deliveredByDate: any | null }> | null } | null, domesticStandard: { __typename: 'QuoteLevelLeadTimeAndPriceOption', leadTimes: Array<number> | null, shipByDate: any | null, subTotalInCents: number | null, shippingOptions: Array<{ __typename: 'ShippingOptionItemType', shippingOptionId: string, name: string, deliveredByDate: any | null }> | null } | null, domesticCostEffective: { __typename: 'QuoteLevelLeadTimeAndPriceOption', leadTimes: Array<number> | null, shipByDate: any | null, subTotalInCents: number | null, shippingOptions: Array<{ __typename: 'ShippingOptionItemType', shippingOptionId: string, name: string, deliveredByDate: any | null }> | null } | null, overseasFastest: { __typename: 'QuoteLevelLeadTimeAndPriceOption', leadTimes: Array<number> | null, shipByDate: any | null, subTotalInCents: number | null, shippingOptions: Array<{ __typename: 'ShippingOptionItemType', shippingOptionId: string, name: string, deliveredByDate: any | null }> | null } | null, overseasStandard: { __typename: 'QuoteLevelLeadTimeAndPriceOption', leadTimes: Array<number> | null, shipByDate: any | null, subTotalInCents: number | null, shippingOptions: Array<{ __typename: 'ShippingOptionItemType', shippingOptionId: string, name: string, deliveredByDate: any | null }> | null } | null, overseasCostEffective: { __typename: 'QuoteLevelLeadTimeAndPriceOption', leadTimes: Array<number> | null, shipByDate: any | null, subTotalInCents: number | null, shippingOptions: Array<{ __typename: 'ShippingOptionItemType', shippingOptionId: string, name: string, deliveredByDate: any | null }> | null } | null };

export type ShippingAddressesItemFragment = { __typename: 'UserShippingAddress', id: number, name: string | null, company: string | null, street: string, aptNumber: string | null, city: string | null, state: string | null, zip: string, phone: string | null, country: string, createdAt: any, isVerified: boolean | null, isDefault: boolean | null, timezone: string | null };

export type UserTeamFragment = { __typename: 'Team', name: string, id: number };

export type UnlockReorderQuoteMutationVariables = Exact<{
  quoteId: Scalars['UUID'];
}>;


export type UnlockReorderQuoteMutation = { __typename: 'Mutation', unlockReorderQuote: { __typename: 'Quote', id: any, status: string } };

export type SalesforceAccountSearchQueryQueryVariables = Exact<{
  filters: InputMaybe<SalesforceAccountSearchInput>;
}>;


export type SalesforceAccountSearchQueryQuery = { __typename: 'Query', adminSearchSalesforceAccounts: { __typename: 'PartialSalesforceAccountSearchResults', totalCount: number, items: Array<{ __typename: 'SalesforceAccount', id: string, name: string, totalContacts: number, hasBusinessAccount: boolean }> } };

export type BusinessAccountMembersQueryVariables = Exact<{
  filters: InputMaybe<BusinessAccountMembersFilterInput>;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type BusinessAccountMembersQuery = { __typename: 'Query', businessAccountMembers: { __typename: 'PartialBusinessAccountMembersResults', totalCount: number, items: Array<{ __typename: 'BusinessAccountMembership', id: any, salesforceContactUrl: string | null, createdAt: any | null, lastLoginDate: any | null, capabilities: Array<string> | null, user: { __typename: 'User', id: number, displayName: string, email: any, enabled: boolean } } | null> } };

export type BusinessAccountPendingMembersQueryVariables = Exact<{
  filters: InputMaybe<BusinessAccountPendingMembersFilterInput>;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type BusinessAccountPendingMembersQuery = { __typename: 'Query', businessAccountPendingMembers: { __typename: 'PartialBusinessAccountPendingMembersResults', totalCount: number, items: Array<{ __typename: 'BusinessAccountPendingMember', lastLoginDate: any | null, salesforceContactUrl: string | null, capabilities: Array<string>, invite: { __typename: 'BusinessAccountInvite', id: any, email: string, sentDate: any | null, status: BusinessAccountInviteStatus } | null, user: { __typename: 'BasicUser', id: number, displayName: string, email: any } | null }> } };

export type MaterialColorsQueryVariables = Exact<{
  materialId: Scalars['String'];
}>;


export type MaterialColorsQuery = { __typename: 'Query', colors: Array<{ __typename: 'Color', id: string, name: string }> };

export type MaterialDensitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type MaterialDensitiesQuery = { __typename: 'Query', materialDensities: Array<{ __typename: 'MaterialDensity', standardDensityMaterial: string, platformMaterialId: string }> | null };

export type BusinessAccountAlertQueryVariables = Exact<{ [key: string]: never; }>;


export type BusinessAccountAlertQuery = { __typename: 'Query', me: { __typename: 'User', id: number, businessAccountSignupStatus: BusinessAccountSignupStatus } | null };

export type EmailVerificationStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type EmailVerificationStatusQuery = { __typename: 'Query', me: { __typename: 'User', id: number, email: any, businessAccountSignupStatus: BusinessAccountSignupStatus, emailVerificationStatus: EmailVerificationStatus, emailVerifiedDate: any | null } | null };

export type QlltWithShippingOptionsQueryVariables = Exact<{
  quoteId: Scalars['UUID'];
  address: InputMaybe<AddressInput>;
}>;


export type QlltWithShippingOptionsQuery = { __typename: 'Query', quote: { __typename: 'Quote', id: any, quoteLevelLeadTimesWithShippingOptions: { __typename: 'QuoteLevelLeadTimesAndPrices', domesticFastest: { __typename: 'QuoteLevelLeadTimeAndPriceOption', leadTimes: Array<number> | null, shipByDate: any | null, subTotalInCents: number | null, shippingOptions: Array<{ __typename: 'ShippingOptionItemType', shippingOptionId: string, name: string, deliveredByDate: any | null }> | null } | null, domesticStandard: { __typename: 'QuoteLevelLeadTimeAndPriceOption', leadTimes: Array<number> | null, shipByDate: any | null, subTotalInCents: number | null, shippingOptions: Array<{ __typename: 'ShippingOptionItemType', shippingOptionId: string, name: string, deliveredByDate: any | null }> | null } | null, domesticCostEffective: { __typename: 'QuoteLevelLeadTimeAndPriceOption', leadTimes: Array<number> | null, shipByDate: any | null, subTotalInCents: number | null, shippingOptions: Array<{ __typename: 'ShippingOptionItemType', shippingOptionId: string, name: string, deliveredByDate: any | null }> | null } | null, overseasFastest: { __typename: 'QuoteLevelLeadTimeAndPriceOption', leadTimes: Array<number> | null, shipByDate: any | null, subTotalInCents: number | null, shippingOptions: Array<{ __typename: 'ShippingOptionItemType', shippingOptionId: string, name: string, deliveredByDate: any | null }> | null } | null, overseasStandard: { __typename: 'QuoteLevelLeadTimeAndPriceOption', leadTimes: Array<number> | null, shipByDate: any | null, subTotalInCents: number | null, shippingOptions: Array<{ __typename: 'ShippingOptionItemType', shippingOptionId: string, name: string, deliveredByDate: any | null }> | null } | null, overseasCostEffective: { __typename: 'QuoteLevelLeadTimeAndPriceOption', leadTimes: Array<number> | null, shipByDate: any | null, subTotalInCents: number | null, shippingOptions: Array<{ __typename: 'ShippingOptionItemType', shippingOptionId: string, name: string, deliveredByDate: any | null }> | null } | null } | null } | null };

export type GetShippingOptionsQueryVariables = Exact<{
  id: Scalars['UUID'];
  address: AddressInput;
  shippingCalculatorOverrides: InputMaybe<ShippingCalculatorOverridesInput>;
}>;


export type GetShippingOptionsQuery = { __typename: 'Query', quote: { __typename: 'Quote', id: any, shippingOptionsNew: { __typename: 'QuoteShippingOptions', items: Array<{ __typename: 'QuoteShippingOptionItemType', cost: number | null, deliveredByDate: any | null, deliveryDays: number | null, id: string, name: string, productionPartsCost: number | null, quoteToken: string | null, samplesCost: number | null }> | null } } | null };

export type GetShippingWeightsQueryVariables = Exact<{
  id: Scalars['UUID'];
  shippingCalculatorOverrides: InputMaybe<ShippingCalculatorOverridesInput>;
}>;


export type GetShippingWeightsQuery = { __typename: 'Query', quote: { __typename: 'Quote', id: any, weights: { __typename: 'QuoteWeights', actualWeight: number | null, shippingWeight: number | null, dimensionalWeight: number | null } | null } | null };

export type QuoteDetailsQueryForShippingCalculatorQuoteModelItemFragment = { __typename: 'QuoteModel', id: any, selectedQuoteModelRevision: { __typename: 'QuoteModelRevision', id: any, fileName: string, partRevision: { __typename: 'Revision', id: any, downloadUri: string | null, modelFileName: string | null, thumbnailUri: string | null }, modelConfiguration: { __typename: 'ModelConfiguration', id: any, quantity: number | null, material: { __typename: 'Material', id: string, name: string } | { __typename: 'UserEnteredMaterial' } | null } | null } };

export type QuoteDetailsQueryForShippingCalculatorQuoteFragment = { __typename: 'Quote', id: any, name: string, weights: { __typename: 'QuoteWeights', actualWeight: number | null, shippingWeight: number | null, dimensionalWeight: number | null } | null, quoteModels: { __typename: 'PartialQuoteModelResults', totalCount: number, items: Array<{ __typename: 'QuoteModel', id: any, selectedQuoteModelRevision: { __typename: 'QuoteModelRevision', id: any, fileName: string, partRevision: { __typename: 'Revision', id: any, downloadUri: string | null, modelFileName: string | null, thumbnailUri: string | null }, modelConfiguration: { __typename: 'ModelConfiguration', id: any, quantity: number | null, material: { __typename: 'Material', id: string, name: string } | { __typename: 'UserEnteredMaterial' } | null } | null } }> } };

export type QuoteDetailsQueryForShippingCalculatorQueryVariables = Exact<{
  id: Scalars['UUID'];
  shippingCalculatorOverrides: InputMaybe<ShippingCalculatorOverridesInput>;
}>;


export type QuoteDetailsQueryForShippingCalculatorQuery = { __typename: 'Query', quote: { __typename: 'Quote', id: any, name: string, weights: { __typename: 'QuoteWeights', actualWeight: number | null, shippingWeight: number | null, dimensionalWeight: number | null } | null, quoteModels: { __typename: 'PartialQuoteModelResults', totalCount: number, items: Array<{ __typename: 'QuoteModel', id: any, selectedQuoteModelRevision: { __typename: 'QuoteModelRevision', id: any, fileName: string, partRevision: { __typename: 'Revision', id: any, downloadUri: string | null, modelFileName: string | null, thumbnailUri: string | null }, modelConfiguration: { __typename: 'ModelConfiguration', id: any, quantity: number | null, material: { __typename: 'Material', id: string, name: string } | { __typename: 'UserEnteredMaterial' } | null } | null } }> } } | null };

export type QuoteDetailsStatusUpdateQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type QuoteDetailsStatusUpdateQuery = { __typename: 'Query', quote: { __typename: 'Quote', id: any, status: string } | null };

export type QuoteShippingOptionsQuoteCheckoutSummaryCardQueryVariables = Exact<{
  id: Scalars['UUID'];
  address: InputMaybe<AddressInput>;
  carrier: InputMaybe<Carrier>;
}>;


export type QuoteShippingOptionsQuoteCheckoutSummaryCardQuery = { __typename: 'Query', quote: { __typename: 'Quote', id: any, isOverseasShipping: boolean, weights: { __typename: 'QuoteWeights', shippingWeight: number | null } | null, shippingOptionsNew: { __typename: 'QuoteShippingOptions', items: Array<{ __typename: 'QuoteShippingOptionItemType', cost: number | null, deliveredByDate: any | null, deliveryDays: number | null, id: string, name: string, productionPartsCost: number | null, quoteToken: string | null, samplesCost: number | null }> | null } } | null };

export type GetProjectIdFromQuoteItemQueryVariables = Exact<{
  id: Scalars['UUID'];
  showDeleted: InputMaybe<Scalars['Boolean']>;
}>;


export type GetProjectIdFromQuoteItemQuery = { __typename: 'Query', quoteItem: { __typename: 'QuoteItem', id: any, quote: { __typename: 'Quote', id: any, project: { __typename: 'BasicProject', id: any | null } | null }, quoteModelRevision: { __typename: 'QuoteModelRevision', id: any } } };

export type GetSalesTaxQuoteCheckoutSummaryQueryVariables = Exact<{
  quoteId: Scalars['String'];
  zip: Scalars['String'];
}>;


export type GetSalesTaxQuoteCheckoutSummaryQuery = { __typename: 'Query', getTaxAmount: { __typename: 'Tax', taxAmount: number, taxRate: number, error: string | null } | null };

export type AdditionalRequirementsRawPdfOcrDataFragment = { __typename: 'RawPdfOcrJson', numTightTolerances: number | null, numVeryTightTolerances: number | null, requiresCertificateOfConformance: boolean | null, requiresMaterialCertificate: boolean | null, autoQuotableBlockers: Array<string> | null, finishingNotes: Array<string> | null, finishingNotesWithBoundingBoxes: Array<{ __typename: 'NoteWithBoundingBox', boundingBox: number | null, text: string | null } | null> | null };

export type AdditionalRequirementsRawPdfOcrQueryVariables = Exact<{
  quoteModelRevisionId: Scalars['UUID'];
}>;


export type AdditionalRequirementsRawPdfOcrQuery = { __typename: 'Query', getRawPdfOcrJson: { __typename: 'RawPdfOcrJson', numTightTolerances: number | null, numVeryTightTolerances: number | null, requiresCertificateOfConformance: boolean | null, requiresMaterialCertificate: boolean | null, autoQuotableBlockers: Array<string> | null, finishingNotes: Array<string> | null, finishingNotesWithBoundingBoxes: Array<{ __typename: 'NoteWithBoundingBox', boundingBox: number | null, text: string | null } | null> | null } | null };

export type AdminAchAccountsForUserQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type AdminAchAccountsForUserQuery = { __typename: 'Query', user: { __typename: 'User', id: number, achAccounts: Array<{ __typename: 'AchAccount', id: string | null, referenceId: string | null, achAccount: { __typename: 'Ach', last4: string | null, bankName: string | null } | null }> } | null };

export type AdminConfigurablePostProcessesQueryVariables = Exact<{
  materialId: Scalars['String'];
}>;


export type AdminConfigurablePostProcessesQuery = { __typename: 'Query', adminConfigurablePostProcesses: Array<{ __typename: 'PostProcess', id: string, name: string, typeName: string | null }> };

export type AdminCreditCardsForUserQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type AdminCreditCardsForUserQuery = { __typename: 'Query', user: { __typename: 'User', id: number, creditCards: Array<{ __typename: 'CreditCard', id: string | null, referenceId: string | null, card: { __typename: 'Card', last4: string | null, brand: string | null } | null }> } | null };

export type AdminPaymentOptionsForUserAdminUserQuoteCheckoutPageQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AdminPaymentOptionsForUserAdminUserQuoteCheckoutPageQuery = { __typename: 'Query', user: { __typename: 'User', id: number, paymentOptions: Array<{ __typename: 'CreditCard', id: string | null, referenceId: string | null, card: { __typename: 'Card', id: string | null, brand: string | null, expMonth: number | null, expYear: number | null, last4: string | null } | null } | null> | null } | null };

export type AdminUserRolesFragment = { __typename: 'User', id: number, roles: Array<{ __typename: 'Role', id: number, name: string | null }> };

export type AdminUserRolesQuoteDetailSummaryCardQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AdminUserRolesQuoteDetailSummaryCardQuery = { __typename: 'Query', user: { __typename: 'User', id: number, roles: Array<{ __typename: 'Role', id: number, name: string | null }> } | null };

export type AdminUserShippingAddressAdminUserQuoteCheckoutPageQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AdminUserShippingAddressAdminUserQuoteCheckoutPageQuery = { __typename: 'Query', user: { __typename: 'User', id: number, shippingAddresses: Array<{ __typename: 'UserShippingAddress', id: number, name: string | null, company: string | null, street: string, aptNumber: string | null, city: string | null, state: string | null, zip: string, phone: string | null, country: string, createdAt: any, isVerified: boolean | null, isDefault: boolean | null, timezone: string | null }> | null } | null };

export type AssignedSupplierQualityEngineersQueryVariables = Exact<{
  assignedTo: InputMaybe<SqeAssignedToType>;
}>;


export type AssignedSupplierQualityEngineersQuery = { __typename: 'Query', assignedSupplierQualityEngineers: Array<{ __typename: 'BasicUser', id: number, displayName: string, firstName: string | null, lastName: string | null, email: any, createdAt: any, updatedAt: any, enabled: boolean }> | null };

export type AutoCorrectMultiPostProcessesAlertQueryVariables = Exact<{
  postProcessIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type AutoCorrectMultiPostProcessesAlertQuery = { __typename: 'Query', autoCorrectMultiPostProcessesOrdering: { __typename: 'AutoCorrectedOutput', conflictingPostProcesses: Array<{ __typename: 'PostProcess', id: string, name: string }> } };

export type BuilderConfigurablePostProcessesDataFragment = { __typename: 'PostProcess', id: string, name: string, typeName: string | null, colors: Array<{ __typename: 'Color', id: string, name: string } | null> | null, thicknesses: Array<{ __typename: 'Thickness', id: string, name: string, value: number } | null> | null };

export type BuilderConfigurablePostProcessesQueryVariables = Exact<{
  materialId: Scalars['String'];
  processId: InputMaybe<Scalars['String']>;
}>;


export type BuilderConfigurablePostProcessesQuery = { __typename: 'Query', builderConfigurablePostProcesses: Array<{ __typename: 'PostProcess', id: string, name: string, typeName: string | null, colors: Array<{ __typename: 'Color', id: string, name: string } | null> | null, thicknesses: Array<{ __typename: 'Thickness', id: string, name: string, value: number } | null> | null }> };

export type CheckAdditionOfPostProcessToCurrentQmrConfigQueryVariables = Exact<{
  id: Scalars['UUID'];
  postProcess: SecondaryProcessConfigInput;
}>;


export type CheckAdditionOfPostProcessToCurrentQmrConfigQuery = { __typename: 'Query', checkAdditionOfPostProcessToCurrentQmrConfig: Array<{ __typename: 'QmrPostProcessWithPriceAndLead', postProcessNumParts: number | null, postProcessInspectionCriteria: ProcessInspectionCriteria | null, postProcessLeadTimeInDays: number | null, unitPriceInCents: number | null, postProcessOverseasOnly: boolean | null, postProcess: { __typename: 'PostProcess', id: string }, postProcessColor: { __typename: 'Color', id: string } | null, postProcessThickness: { __typename: 'Thickness', id: string } | null }> };

export type CheckDomesticMaterialCertificationQueryVariables = Exact<{
  materialId: Scalars['String'];
}>;


export type CheckDomesticMaterialCertificationQuery = { __typename: 'Query', checkDomesticMaterialCertification: boolean };

export type CheckSupportedPriorityRegionsQueryInSpSectionQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type CheckSupportedPriorityRegionsQueryInSpSectionQuery = { __typename: 'Query', quoteModelRevision: { __typename: 'QuoteModelRevision', supportedPriorityRegions: { __typename: 'SupportedPriorityRegions', partSupportsDomestic: boolean, partSupportsInternational: boolean } } | null };

export type FetchIsoCountryDataQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchIsoCountryDataQuery = { __typename: 'Query', countries: Array<{ __typename: 'Country', id: string, name: string }> };

export type GetDownloadableQuotePdfQueryVariables = Exact<{
  quoteId: Scalars['String'];
}>;


export type GetDownloadableQuotePdfQuery = { __typename: 'Query', getDownloadableQuotePdf: string };

export type ImQuotePartsAndMoldsCountSummaryCardQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ImQuotePartsAndMoldsCountSummaryCardQuery = { __typename: 'Query', quote: { __typename: 'Quote', id: any, quoteItems: { __typename: 'PartialQuoteItemResults', totalCount: number }, molds: Array<{ __typename: 'MoldTool', id: any }> | null } | null };

export type ListCustomerShippingAccountQueryVariables = Exact<{
  userId: InputMaybe<Scalars['Int']>;
}>;


export type ListCustomerShippingAccountQuery = { __typename: 'Query', carrierAccounts: Array<{ __typename: 'TplCarrierAccount', id: any, name: string | null, provider: Carrier, accountNumber: string, country: string, postalCode: string, createdAt: any, updatedAt: any }> };

export type MatchCadFileNamesToPdfFileNamesQueryVariables = Exact<{
  cadNames: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  pdfNames: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type MatchCadFileNamesToPdfFileNamesQuery = { __typename: 'Query', matchCadFileNamesToPdfFileNames: Array<{ __typename: 'NameMatchPairInfo', cadFileName: string | null, pdfFileName: string | null } | null> | null };

export type MaterialConfigurationOptionsQueryVariables = Exact<{
  materialId: Scalars['String'];
}>;


export type MaterialConfigurationOptionsQuery = { __typename: 'Query', materialConfigurationOptions: Array<{ __typename: 'MaterialConfigurationOption', id: string, colorId: string | null, colorName: string | null, shoreId: string | null, shoreName: string | null }> };

export type MaterialShoresQueryVariables = Exact<{
  materialId: Scalars['String'];
}>;


export type MaterialShoresQuery = { __typename: 'Query', shores: Array<{ __typename: 'Shore', id: string, name: string }> };

export type MaterialsDropdownQueryVariables = Exact<{
  processId: Scalars['String'];
}>;


export type MaterialsDropdownQuery = { __typename: 'Query', materials: Array<{ __typename: 'Material', id: string, name: string, materialCategory: string | null, fdmInfillOptions: Array<{ __typename: 'FdmInfillOption', optionName: string, optionLabelCustomer: string, isDefault: boolean }> | null }> | null };

export type PreCheckoutQuotePricePreviewDownloadUrlQueryVariables = Exact<{
  quoteId: Scalars['UUID'];
  userId: InputMaybe<Scalars['Int']>;
  shippingMethods: InputMaybe<Array<ShippingMethodInput> | ShippingMethodInput>;
  forResale: InputMaybe<Scalars['Boolean']>;
  carrierAccountId: InputMaybe<Scalars['UUID']>;
  isShippingOptionForCarrier: InputMaybe<Scalars['Boolean']>;
}>;


export type PreCheckoutQuotePricePreviewDownloadUrlQuery = { __typename: 'Query', preCheckoutQuotePricePreviewDownloadUrl: string | null };

export type ProcessTextureFragment = { __typename: 'Texture', id: string, name: string, category: string | null };

export type ProcessTexturesQueryVariables = Exact<{
  processId: Scalars['String'];
}>;


export type ProcessTexturesQuery = { __typename: 'Query', textures: Array<{ __typename: 'Texture', id: string, name: string, category: string | null }> };

export type ProcessesConfigFormProcessDropdownQueryVariables = Exact<{
  quoteType: InputMaybe<QuoteType>;
}>;


export type ProcessesConfigFormProcessDropdownQuery = { __typename: 'Query', processes: Array<{ __typename: 'Process', id: string, name: string }> };

export type ProjectMemberCheckQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ProjectMemberCheckQuery = { __typename: 'Query', project: { __typename: 'Project', id: any, currentUserIsMember: boolean } | null };

export type QuoteDetailsCheckoutShippingOptionsItemFragment = { __typename: 'QuoteShippingOptionItemType', cost: number | null, deliveredByDate: any | null, deliveryDays: number | null, id: string, name: string, productionPartsCost: number | null, quoteToken: string | null, samplesCost: number | null };

export type QuoteDetailsCheckoutFragment = { __typename: 'Quote', id: any, name: string, isEligibleForFreeShipping: boolean | null, earliestValidUntilDate: any | null, type: QuoteType, numberOfParts: number, partsSummary: any, expiration: any | null, isQuotePurchasable: boolean, isOverseasShipping: boolean, isQuoteIMReorder: boolean, isTaxExempt: boolean | null, isCpqOwned: boolean | null, isCpqQuote?: boolean | null, subTotalInCents: number | null, slowestShipDateEstimate: any | null, moldToolSubtotalInCents: number | null, productionPartsSubtotalInCents: number | null, cpqQuote?: { __typename: 'CpqQuote', sfdcId: any, quotePdfUrl: string, orderTotal: number, partsCount: number, moldCount: number, orderQuantity: number, platformQuote: { __typename: 'Quote', id: any } } | null, businessAccountDiscount: { __typename: 'BusinessAccountDiscount', id: number, percent: number, isActive: boolean, endAt: any } | null, weights: { __typename: 'QuoteWeights', shippingWeight: number | null } | null, team: { __typename: 'Team', id: number, name: string } | null, shippingOptionsNew: { __typename: 'QuoteShippingOptions', items: Array<{ __typename: 'QuoteShippingOptionItemType', cost: number | null, deliveredByDate: any | null, deliveryDays: number | null, id: string, name: string, productionPartsCost: number | null, quoteToken: string | null, samplesCost: number | null }> | null }, molds: Array<{ __typename: 'MoldTool', id: any }> | null, quoteModels: { __typename: 'PartialQuoteModelResults', totalCount: number, items: Array<{ __typename: 'QuoteModel', selectedQuoteModelRevision: { __typename: 'QuoteModelRevision', isITARProhibitedViewing: boolean | null, id: any } }> }, user: { __typename: 'BasicUser', id: number } };

export type QuoteDetailsCheckoutQueryVariables = Exact<{
  id: Scalars['UUID'];
  address: InputMaybe<AddressInput>;
  carrier: InputMaybe<Carrier>;
  isCpqFlagV2Enabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type QuoteDetailsCheckoutQuery = { __typename: 'Query', quote: { __typename: 'Quote', id: any, name: string, isEligibleForFreeShipping: boolean | null, earliestValidUntilDate: any | null, type: QuoteType, numberOfParts: number, partsSummary: any, expiration: any | null, isQuotePurchasable: boolean, isOverseasShipping: boolean, isQuoteIMReorder: boolean, isTaxExempt: boolean | null, isCpqOwned: boolean | null, isCpqQuote?: boolean | null, subTotalInCents: number | null, slowestShipDateEstimate: any | null, moldToolSubtotalInCents: number | null, productionPartsSubtotalInCents: number | null, cpqQuote?: { __typename: 'CpqQuote', sfdcId: any, quotePdfUrl: string, orderTotal: number, partsCount: number, moldCount: number, orderQuantity: number, platformQuote: { __typename: 'Quote', id: any } } | null, businessAccountDiscount: { __typename: 'BusinessAccountDiscount', id: number, percent: number, isActive: boolean, endAt: any } | null, weights: { __typename: 'QuoteWeights', shippingWeight: number | null } | null, team: { __typename: 'Team', id: number, name: string } | null, shippingOptionsNew: { __typename: 'QuoteShippingOptions', items: Array<{ __typename: 'QuoteShippingOptionItemType', cost: number | null, deliveredByDate: any | null, deliveryDays: number | null, id: string, name: string, productionPartsCost: number | null, quoteToken: string | null, samplesCost: number | null }> | null }, molds: Array<{ __typename: 'MoldTool', id: any }> | null, quoteModels: { __typename: 'PartialQuoteModelResults', totalCount: number, items: Array<{ __typename: 'QuoteModel', selectedQuoteModelRevision: { __typename: 'QuoteModelRevision', isITARProhibitedViewing: boolean | null, id: any } }> }, user: { __typename: 'BasicUser', id: number } } | null };

export type QuotePricePreviewDataFragment = { __typename: 'QuotePricePreview', subTotalAmountInCents: number | null, taxAmountInCents: number | null, shippingAmountInCents: number | null, totalAmountInCents: number | null, discountPercent: string | null, discountAmountInCents: number | null, discountErrorMessage: string | null, samplesShippingAmountInCents: number | null, depositAmountInCents: number | null };

export type QuotePricePreviewQueryVariables = Exact<{
  priceInput: PricingInput;
  userId: InputMaybe<Scalars['Int']>;
}>;


export type QuotePricePreviewQuery = { __typename: 'Query', quotePricePreview: { __typename: 'QuotePricePreview', subTotalAmountInCents: number | null, taxAmountInCents: number | null, shippingAmountInCents: number | null, totalAmountInCents: number | null, discountPercent: string | null, discountAmountInCents: number | null, discountErrorMessage: string | null, samplesShippingAmountInCents: number | null, depositAmountInCents: number | null } | null };

export type QuotePricePreviewDownloadUrlQueryVariables = Exact<{
  priceInput: PricingInput;
  userId: InputMaybe<Scalars['Int']>;
}>;


export type QuotePricePreviewDownloadUrlQuery = { __typename: 'Query', quotePricePreviewDownloadUrl: string | null };

export type SecondaryProcessPricingCalculatorQueryVariables = Exact<{
  quoteFields: PricingQuoteFieldsInput;
  quantity: Scalars['Int'];
}>;


export type SecondaryProcessPricingCalculatorQuery = { __typename: 'Query', secondaryProcessPricingCalculator: { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } };

export type ShippingAddresssesQuoteCheckoutPageQueryVariables = Exact<{ [key: string]: never; }>;


export type ShippingAddresssesQuoteCheckoutPageQuery = { __typename: 'Query', me: { __typename: 'User', id: number, shippingAddresses: Array<{ __typename: 'UserShippingAddress', id: number, name: string | null, company: string | null, street: string, aptNumber: string | null, city: string | null, state: string | null, zip: string, phone: string | null, country: string, createdAt: any, isVerified: boolean | null, isDefault: boolean | null, timezone: string | null }> | null } | null };

export type UserAchAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserAchAccountsQuery = { __typename: 'Query', me: { __typename: 'User', id: number, achAccounts: Array<{ __typename: 'AchAccount', id: string | null, referenceId: string | null, achAccount: { __typename: 'Ach', last4: string | null, bankName: string | null } | null }> } | null };

export type UserCreditCardsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserCreditCardsQuery = { __typename: 'Query', me: { __typename: 'User', id: number, creditCards: Array<{ __typename: 'CreditCard', id: string | null, referenceId: string | null, card: { __typename: 'Card', last4: string | null, brand: string | null } | null }> } | null };

export type UserEnteredMaterialsDropdownQueryVariables = Exact<{ [key: string]: never; }>;


export type UserEnteredMaterialsDropdownQuery = { __typename: 'Query', me: { __typename: 'User', id: number, userEnteredMaterials: Array<{ __typename: 'UserEnteredMaterial', id: string, name: string, process: { __typename: 'Process', id: string, name: string } }> } | null };

export type UserPaymentOptionsUserProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type UserPaymentOptionsUserProfileQuery = { __typename: 'Query', me: { __typename: 'User', id: number, paymentOptions: Array<{ __typename: 'CreditCard', id: string | null, referenceId: string | null, card: { __typename: 'Card', id: string | null, brand: string | null, expMonth: number | null, expYear: number | null, last4: string | null } | null } | null> | null } | null };

export type UserTeamsQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type UserTeamsQuery = { __typename: 'Query', user: { __typename: 'User', id: number, email: any, teams: { __typename: 'PartialTeamsResults', items: Array<{ __typename: 'Team', name: string, id: number }> } } | null };

export type ValidatePostalCodeQueryVariables = Exact<{
  countryCode: Scalars['String'];
  zipCode: Scalars['String'];
}>;


export type ValidatePostalCodeQuery = { __typename: 'Query', validateZip: { __typename: 'ZipValidationOutput', isValid: boolean, errorMsg: string | null } };

export type VerifiedAddressFragment = { __typename: 'ShippingAddress', id: string | null, street1: string | null, street2: string | null, city: string | null, state: string | null, zip: string | null, phone: string | null, name: string | null, company: string | null, country: string | null, delivery: any | null };

export type VerifyShippingAddressQueryVariables = Exact<{
  selectedAddressInput: SelectedAddressInput;
}>;


export type VerifyShippingAddressQuery = { __typename: 'Query', verifyShippingAddress: { __typename: 'ShippingAddress', id: string | null, street1: string | null, street2: string | null, city: string | null, state: string | null, zip: string | null, phone: string | null, name: string | null, company: string | null, country: string | null, delivery: any | null } | null };

export type CurrentUserIdentityQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserIdentityQuery = { __typename: 'Query', me: { __typename: 'User', id: number, createdAt: any, email: any, emailVerified: boolean, emailVerifiedDate: any | null, emailVerificationStatus: EmailVerificationStatus, displayName: string, firstName: string | null, lastName: string | null, zipcode: string | null, quotePartLimit: number, businessAccountSignupStatus: BusinessAccountSignupStatus, flags: Array<{ __typename: 'UserFeatureFlag', key: string, variant: string }>, roles: Array<{ __typename: 'Role', id: number, name: string | null }>, userPreferences: { __typename: 'UserPreferences', id: number, preferences: any }, businessAccountMembership: { __typename: 'BusinessAccountMembership', id: any, createdAt: any | null, businessAccount: { __typename: 'BusinessAccount', id: any, name: string, isEnabled: boolean, isTeamsFeatureEnabled: boolean | null, totalTeams: number, discount: { __typename: 'BusinessAccountDiscount', percent: number } | null }, user: { __typename: 'User', id: number, enabled: boolean } } | null, teams: { __typename: 'PartialTeamsResults', items: Array<{ __typename: 'Team', id: number }> } } | null };

export type GetByQuoteModelRevisionAttachmentIdQueryVariables = Exact<{
  quoteModelRevisionAttachmentId: Scalars['UUID'];
}>;


export type GetByQuoteModelRevisionAttachmentIdQuery = { __typename: 'Query', getModelAttachmentOcrData: { __typename: 'ModelAttachmentOcrData', id: any | null, callsForOffPlatformFinish: boolean | null, oneSidedTolerances: Array<{ __typename: 'OneSidedToleranceData', boundingBox: number | null, nominalCoordinate: { __typename: 'SidedToleranceNominalCoordinate', page: number | null, x: number | null, y: number | null } | null } | null> | null, twoSidedTolerances: Array<{ __typename: 'TwoSidedToleranceData', boundingBox: number | null, nominalCoordinate: { __typename: 'SidedToleranceNominalCoordinate', page: number | null, x: number | null, y: number | null } | null } | null> | null, standardDimensions: Array<{ __typename: 'NoteWithBoundingBox', boundingBox: number | null, text: string | null } | null> | null, certificateOfConformanceNotes: Array<{ __typename: 'NoteWithBoundingBox', boundingBox: number | null, text: string | null } | null> | null, materialCertificateNotes: Array<{ __typename: 'NoteWithBoundingBox', boundingBox: number | null, text: string | null } | null> | null, detectionBoundingBoxes: Array<{ __typename: 'PdfDetectionBoundingBox', pageNumber: number | null, xmin: number | null, xmax: number | null, ymax: number | null, ymin: number | null } | null> | null, foundThreadsInfo: Array<{ __typename: 'ModelAttachmentOcrThreadInfo', id: string | null, commonName: string | null, count: number | null, diameter: number | null, type: string | null, detections: Array<{ __typename: 'ThreadInfoDetection', boundingBox: number | null, text: string | null } | null> | null } | null> | null, sanitizedBoundingBoxes: Array<{ __typename: 'PdfDetectionBoundingBox', pageNumber: number | null, xmax: number | null, xmin: number | null, ymax: number | null, ymin: number | null } | null> | null, toleranceBlocks: Array<{ __typename: 'ToleranceBlockData', boundingBox: number | null, textRaw: string | null, symbol: string | null, nominalCoordinate: { __typename: 'SidedToleranceNominalCoordinate', page: number | null, x: number | null, y: number | null } | null } | null> | null, allReamableOneSidedTolerances: Array<{ __typename: 'OneSidedToleranceData', boundingBox: number | null, nominalCoordinate: { __typename: 'SidedToleranceNominalCoordinate', page: number | null, x: number | null, y: number | null } | null } | null> | null, allReamableTwoSidedTolerances: Array<{ __typename: 'TwoSidedToleranceData', boundingBox: number | null, nominalCoordinate: { __typename: 'SidedToleranceNominalCoordinate', page: number | null, x: number | null, y: number | null } | null } | null> | null } | null };

export type SendPrivateMessageToDriftMutationVariables = Exact<{
  message: Scalars['String'];
  conversationId: Scalars['String'];
  userId: Scalars['String'];
}>;


export type SendPrivateMessageToDriftMutation = { __typename: 'Mutation', sendPrivateMessageToDrift: boolean };

export type ConfigurationTabQueryQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ConfigurationTabQueryQuery = { __typename: 'Query', quote: { __typename: 'Quote', hasITARRestrictions: boolean | null, id: any, type: QuoteType, status: string, name: string, user: { __typename: 'BasicUser', id: number, email: any }, project: { __typename: 'BasicProject', id: any | null, isSecurePlus: boolean, name: string } | null, team: { __typename: 'Team', id: number, name: string } | null, quoteModels: { __typename: 'PartialQuoteModelResults', totalCount: number, items: Array<{ __typename: 'QuoteModel', id: any, quoteModelRevisions: Array<{ __typename: 'QuoteModelRevision', id: any, dfmReports: Array<{ __typename: 'PartDfmReport', isPublished: boolean }> }>, selectedQuoteModelRevision: { __typename: 'QuoteModelRevision', isITARProhibitedViewing: boolean | null, id: any, quantityRangeStatus: string | null, version: string, state: QuoteModelRevisionState, drawingRequirements: Array<string>, partRevision: { __typename: 'Revision', id: any, modelFileName: string | null, downloadUri: string | null }, processesDetails: { __typename: 'QmrProcessesDetails', isBusinessAccountDiscountApplied: boolean | null, postProcesses: Array<{ __typename: 'QmrPostProcessWithPriceAndLead', postProcess: { __typename: 'PostProcess', id: string, name: string, typeName: string | null }, postProcessThickness: { __typename: 'Thickness', id: string, name: string } | null, postProcessColor: { __typename: 'Color', id: string, name: string } | null }>, totalPrice: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null, secondaryProcesses: Array<{ __typename: 'QmrSecondaryProcessDetails', process: { __typename: 'PostProcess', name: string } }> } | null, modelConfiguration: { __typename: 'ModelConfiguration', id: any, materialGrade: string | null, colorCode: string | null, quantity: number | null, textureCode: string | null, process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string } | null, color: { __typename: 'Color', id: string, name: string } | null, shore: { __typename: 'Shore', id: string, name: string } | null, texture: { __typename: 'Texture', id: string, name: string } | null, material: { __typename: 'Material', id: string, name: string } | { __typename: 'UserEnteredMaterial' } | null, productionLeadTime: { __typename: 'ProductionLeadTime', priorityId: string, productionDays: number, shipDateEstimate: { __typename: 'ShipDateEstimate', shippedByDate: any } } | null } | null, attachmentLink: { __typename: 'QuoteModelRevisionAttachment', id: any, createdAt: any, quoteAttachmentRevision: { __typename: 'QuoteAttachmentRevision', attachment: { __typename: 'Attachment', id: any, fileName: string, downloadUrl: string | null } | null } } | null, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, accepted: boolean, severity: string, message: string, isPublished: boolean }>, dfmReports: Array<{ __typename: 'PartDfmReport', quoteAttachmentRevisionId: any, isPublished: boolean, asset: { __typename: 'Asset', id: any, createdAt: any, downloadUrl: string | null, fileName: string } | null }>, taps: Array<{ __typename: 'TapAnnotation', id: any }>, holes: Array<{ __typename: 'Hole', id: string, tapOptions: Array<{ __typename: 'TapOption', id: string }> }> } }> }, quoteAttachments: { __typename: 'PartialQuoteAttachmentResults', totalCount: number, items: Array<{ __typename: 'QuoteAttachment', id: any, latestAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string, downloadUrl: string | null, annotated: { __typename: 'AnnotatedAttachment', id: any, fileName: string, downloadUrl: string | null } | null } | null } }> } } | null };

export type CoreQuoteDetailsShippingQueryVariables = Exact<{
  id: Scalars['UUID'];
  address: InputMaybe<AddressInput>;
}>;


export type CoreQuoteDetailsShippingQuery = { __typename: 'Query', quote: { __typename: 'Quote', id: any, name: string, isOverseasShipping: boolean, zipCode: string | null, hasITARRestrictions: boolean | null, isEligibleForFreeShipping: boolean | null, quoteItems: { __typename: 'PartialQuoteItemResults', totalCount: number, items: Array<{ __typename: 'QuoteItem', id: any, quoteModelRevision: { __typename: 'QuoteModelRevision', isITARProhibitedViewing: boolean | null, id: any, fileName: string, mold: { __typename: 'MoldTool', id: any, leadTimeDays: number | null, estimatedSampleDeliveryDate: any | null } | null } }> } } | null };

export type CoreQuoteDetailsQueryVariables = Exact<{
  id: Scalars['UUID'];
  isImMaafcoEnabled?: InputMaybe<Scalars['Boolean']>;
  isCpqFlagV2Enabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type CoreQuoteDetailsQuery = { __typename: 'Query', quote: { __typename: 'Quote', id: any, name: string, status: string, zipCode: string | null, isTaxExempt: boolean | null, numberOfParts: number, partsSummary: any, needByDate: any | null, lastModified: any | null, isLocked: boolean | null, isCpqOwned: boolean | null, isQuoteInRfqState: boolean, isQuoteIMReorder: boolean, type: QuoteType, beganCheckoutAt: any | null, productionPartsSubtotalInCents: number | null, moldToolSubtotalInCents: number | null, depositInCents: number | null, subTotalInCents: number | null, slowestShipDateEstimate: any | null, isOverseasShipping: boolean, expiration: any | null, isExpired: boolean, isQuotePurchasable: boolean, earliestValidUntilDate: any | null, reorderSourceOrderName: string | null, isFlexiblePriceQuote: boolean, notesToCustomer: string | null, deletedAt: any | null, isMoldRepair: boolean | null, isCpqQuote?: boolean | null, hasITARRestrictions: boolean | null, isEligibleForFreeShipping: boolean | null, orderName: string | null, cpqQuote?: { __typename: 'CpqQuote', sfdcId: any, quotePdfUrl: string, orderTotal: number, partsCount: number, moldCount: number, orderQuantity: number, platformQuote: { __typename: 'Quote', id: any } } | null, project: { __typename: 'BasicProject', id: any | null, isSecurePlus: boolean, name: string } | null, team: { __typename: 'Team', id: number, name: string } | null, platformOrder: { __typename: 'PlatformOrder', name: string | null, purchaserEmail: string | null, purchasedDate: any | null, purchaserUserId: number | null } | null, purchaseInfo: { __typename: 'BasicPurchaseInfo', purchaserEmail: string | null, purchasedDate: any | null, purchaserUserId: number | null } | null, businessAccountDiscount: { __typename: 'BusinessAccountDiscount', id: number, isActive: boolean, endAt: any, percent: number } | null, user: { __typename: 'BasicUser', id: number }, quoteAttachments: { __typename: 'PartialQuoteAttachmentResults', totalCount: number, items: Array<{ __typename: 'QuoteAttachment', id: any, latestAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string, downloadUrl: string | null, annotated: { __typename: 'AnnotatedAttachment', id: any, fileName: string, downloadUrl: string | null } | null, sanitized: { __typename: 'SanitizedAttachment', id: any, fileName: string, downloadUrl: string | null } | null } | null } }> }, quoteModels: { __typename: 'PartialQuoteModelResults', totalCount: number, items: Array<{ __typename: 'QuoteModel', id: any, quoteModelRevisions: Array<{ __typename: 'QuoteModelRevision', id: any, attachmentLink: { __typename: 'QuoteModelRevisionAttachment', id: any } | null }>, selectedQuoteModelRevision: { __typename: 'QuoteModelRevision', isITARProhibitedViewing: boolean | null, id: any, fileName: string, createdAt: any, quantityRangeStatus: string | null, state: QuoteModelRevisionState, version: string, drawingRequirements: Array<string>, taps: Array<{ __typename: 'TapAnnotation', id: any }>, holes: Array<{ __typename: 'Hole', id: string, groupKey: string, patches: Array<{ __typename: 'RevisionPatch', id: string }>, tapOptions: Array<{ __typename: 'TapOption', id: string }>, tapAnnotation: { __typename: 'TapAnnotation', id: any, depth: number | null, tapOption: { __typename: 'TapOption', id: string } | null } | null }>, mold: { __typename: 'MoldTool', id: any, name?: string, leadTimeDays: number | null, customerToolName?: string | null, toolLife: number | null, uiIndex: number, material: { __typename: 'Material', id: string, name: string } | null, price: { __typename: 'ExactPrice', priceInCents: number | null } | null, moldToolRevisionQmr?: Array<{ __typename: 'MoldToolRevisionQmr', moldToolRevisionId: any, quoteModelRevisionId: string, cavityPerPart: number | null }> } | null, partRevision: { __typename: 'Revision', id: any, analysisErrorCode: string | null, updatedAt: any, modelFileName: string | null, downloadUri: string | null, thumbnailUri: string | null, status: string | null, sceneBundle: any | null, boundingBox: { __typename: 'Vector3', x: number, y: number, z: number } | null }, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, accepted: boolean, severity: string, message: string, isPublished: boolean }>, dfmReports: Array<{ __typename: 'PartDfmReport', quoteAttachmentRevisionId: any, isPublished: boolean, asset: { __typename: 'Asset', id: any, createdAt: any, downloadUrl: string | null, fileName: string } | null }>, modelConfiguration: { __typename: 'ModelConfiguration', id: any, colorCode: string | null, textureCode: string | null, quantity: number | null, requiresOvermold: boolean, materialGrade: string | null, fdmInfillPercentageCategory: string | null, fdmInfillPercentageCategoryLabel: string | null, dfmInspection: { __typename: 'ModelConfigurationDfmInspection', id: any | null, inspectionData: any, isPublished: boolean } | null, productionLeadTime: { __typename: 'ProductionLeadTime', id: string, priorityId: string, productionDays: number } | null, material: { __typename: 'Material', id: string, name: string } | { __typename: 'UserEnteredMaterial', id: string, name: string, process: { __typename: 'Process', id: string, name: string } } | null, color: { __typename: 'Color', id: string, name: string } | null, shore: { __typename: 'Shore', id: string, name: string } | null, texture: { __typename: 'Texture', id: string, name: string } | null, process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string } | null } | null, quoteModel: { __typename: 'QuoteModel', id: any, quote: { __typename: 'Quote', id: any, type: QuoteType } | null }, annotations: Array<{ __typename: 'Annotation', id: any }>, processesDetails: { __typename: 'QmrProcessesDetails', isBusinessAccountDiscountApplied: boolean | null, primaryProcess: { __typename: 'QmrProcessWithPrice', process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string } } | null, postProcesses: Array<{ __typename: 'QmrPostProcessWithPriceAndLead', unitPriceInCents: number | null, postProcessLeadTimeInDays: number | null, postProcessNumParts: number | null, postProcessInspectionCriteria: ProcessInspectionCriteria | null, postProcess: { __typename: 'PostProcess', id: string, name: string, typeName: string | null }, postProcessThickness: { __typename: 'Thickness', id: string, name: string } | null, postProcessColor: { __typename: 'Color', id: string, name: string } | null }>, totalPrice: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null, secondaryProcesses: Array<{ __typename: 'QmrSecondaryProcessDetails', process: { __typename: 'PostProcess', id: string, name: string, typeName: string | null } }> } | null, supportedPriorityRegions: { __typename: 'SupportedPriorityRegions', partSupportsDomestic: boolean, partSupportsInternational: boolean }, attachmentLink: { __typename: 'QuoteModelRevisionAttachment', id: any, createdAt: any, isPdfOcrAutoQuotable: boolean | null, quoteAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string, downloadUrl: string | null, annotated: { __typename: 'AnnotatedAttachment', id: any, fileName: string, downloadUrl: string | null } | null, sanitized: { __typename: 'SanitizedAttachment', id: any, fileName: string, downloadUrl: string | null } | null } | null } } | null } }> }, dfmAssets: { __typename: 'PartialAssetResults', totalCount: number, items: Array<{ __typename: 'Asset', id: any, fileName: string, downloadUrl: string | null }> } } | null };

export type DrawingAnalysisTabQueryQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DrawingAnalysisTabQueryQuery = { __typename: 'Query', quote: { __typename: 'Quote', hasITARRestrictions: boolean | null, id: any, name: string, status: string, type: QuoteType, user: { __typename: 'BasicUser', id: number }, quoteModels: { __typename: 'PartialQuoteModelResults', items: Array<{ __typename: 'QuoteModel', id: any, quoteModelRevisions: Array<{ __typename: 'QuoteModelRevision', id: any, attachmentLink: { __typename: 'QuoteModelRevisionAttachment', id: any } | null }>, selectedQuoteModelRevision: { __typename: 'QuoteModelRevision', isITARProhibitedViewing: boolean | null, id: any, fileName: string, state: QuoteModelRevisionState, version: string, drawingRequirements: Array<string>, taps: Array<{ __typename: 'TapAnnotation', id: any }>, partRevision: { __typename: 'Revision', id: any, analysisErrorCode: string | null, updatedAt: any, modelFileName: string | null, downloadUri: string | null, thumbnailUri: string | null, status: string | null, sceneBundle: any | null, boundingBox: { __typename: 'Vector3', x: number, y: number, z: number } | null }, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, severity: string }>, modelConfiguration: { __typename: 'ModelConfiguration', id: any, colorCode: string | null, textureCode: string | null, quantity: number | null, requiresOvermold: boolean, materialGrade: string | null, additionalRequirements: string | null, hasMultipleFinishes: boolean, userNeedsConfigHelp: boolean, dfmInspection: { __typename: 'ModelConfigurationDfmInspection', id: any | null, inspectionData: any } | null, productionLeadTime: { __typename: 'ProductionLeadTime', id: string, priorityId: string, productionDays: number } | null, material: { __typename: 'Material', id: string, name: string } | { __typename: 'UserEnteredMaterial' } | null, color: { __typename: 'Color', id: string, name: string } | null, shore: { __typename: 'Shore', id: string, name: string } | null, texture: { __typename: 'Texture', id: string, name: string } | null, process: { __typename: 'Process', id: string, name: string } | null } | null, annotations: Array<{ __typename: 'Annotation', id: any }>, processesDetails: { __typename: 'QmrProcessesDetails', primaryProcess: { __typename: 'QmrProcessWithPrice', process: { __typename: 'Process', id: string, name: string, platformProcessTypeId: string } } | null, postProcesses: Array<{ __typename: 'QmrPostProcessWithPriceAndLead', unitPriceInCents: number | null, postProcessLeadTimeInDays: number | null, postProcessNumParts: number | null, postProcessInspectionCriteria: ProcessInspectionCriteria | null, postProcess: { __typename: 'PostProcess', id: string, name: string, typeName: string | null }, postProcessThickness: { __typename: 'Thickness', id: string, name: string } | null, postProcessColor: { __typename: 'Color', id: string, name: string } | null }>, totalPrice: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null, secondaryProcesses: Array<{ __typename: 'QmrSecondaryProcessDetails', process: { __typename: 'PostProcess', id: string, name: string, typeName: string | null } }> } | null, attachmentLink: { __typename: 'QuoteModelRevisionAttachment', id: any, createdAt: any, isPdfOcrAutoQuotable: boolean | null, quoteAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string, downloadUrl: string | null, annotated: { __typename: 'AnnotatedAttachment', id: any, fileName: string, downloadUrl: string | null } | null } | null } } | null } }> } } | null };

export type DetailsForFeedbackThreadsAddReqModalConfigTabQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DetailsForFeedbackThreadsAddReqModalConfigTabQuery = { __typename: 'Query', quote: { __typename: 'Quote', hasITARRestrictions: boolean | null, id: any, type: QuoteType, status: string, user: { __typename: 'BasicUser', id: number }, project: { __typename: 'BasicProject', isSecurePlus: boolean } | null, quoteModels: { __typename: 'PartialQuoteModelResults', items: Array<{ __typename: 'QuoteModel', id: any, quoteModelRevisions: Array<{ __typename: 'QuoteModelRevision', id: any }>, selectedQuoteModelRevision: { __typename: 'QuoteModelRevision', isITARProhibitedViewing: boolean | null, id: any, state: QuoteModelRevisionState, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, accepted: boolean, severity: string }>, partRevision: { __typename: 'Revision', modelFileName: string | null }, processesDetails: { __typename: 'QmrProcessesDetails', postProcesses: Array<{ __typename: 'QmrPostProcessWithPriceAndLead', postProcess: { __typename: 'PostProcess', id: string, name: string } }>, secondaryProcesses: Array<{ __typename: 'QmrSecondaryProcessDetails', process: { __typename: 'PostProcess', typeName: string | null } }>, totalPrice: { __typename: 'EstimatedPrice', lowPriceInCents: number | null, lowUnitPriceInCents: number | null, highPriceInCents: number | null, highUnitPriceInCents: number | null } | { __typename: 'ExactPrice', priceInCents: number | null, unitPriceInCents: number | null } | null } | null, attachmentLink: { __typename: 'QuoteModelRevisionAttachment', id: any, quoteAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any } | null } } | null, modelConfiguration: { __typename: 'ModelConfiguration', id: any, additionalRequirements: string | null, dfmInspection: { __typename: 'ModelConfigurationDfmInspection', id: any | null, inspectionData: any } | null, process: { __typename: 'Process', id: string } | null, material: { __typename: 'Material', id: string } | { __typename: 'UserEnteredMaterial' } | null, productionLeadTime: { __typename: 'ProductionLeadTime', id: string, productionDays: number, shipDateEstimate: { __typename: 'ShipDateEstimate', shippedByDate: any } } | null } | null } }> } } | null };

export type DetailsForImFeedbackAddReqUnconfiguredConfigModalTabsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DetailsForImFeedbackAddReqUnconfiguredConfigModalTabsQuery = { __typename: 'Query', quote: { __typename: 'Quote', hasITARRestrictions: boolean | null, id: any, type: QuoteType, status: string, user: { __typename: 'BasicUser', id: number }, quoteModels: { __typename: 'PartialQuoteModelResults', items: Array<{ __typename: 'QuoteModel', selectedQuoteModelRevision: { __typename: 'QuoteModelRevision', isITARProhibitedViewing: boolean | null, id: any, state: QuoteModelRevisionState, version: string, dfmReports: Array<{ __typename: 'PartDfmReport', isPublished: boolean }>, partRevision: { __typename: 'Revision', id: any, units: string | null }, modelConfiguration: { __typename: 'ModelConfiguration', quantity: number | null, colorCode: string | null, materialGrade: string | null, textureCode: string | null, additionalRequirements: string | null, process: { __typename: 'Process', id: string } | null, texture: { __typename: 'Texture', id: string } | null, material: { __typename: 'Material', id: string, name: string } | { __typename: 'UserEnteredMaterial', id: string, name: string, process: { __typename: 'Process', id: string, name: string } } | null, color: { __typename: 'Color', id: string } | null, productionLeadTime: { __typename: 'ProductionLeadTime', productionDays: number } | null, dfmInspection: { __typename: 'ModelConfigurationDfmInspection', inspectionData: any } | null } | null, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, severity: string }>, processesDetails: { __typename: 'QmrProcessesDetails', postProcesses: Array<{ __typename: 'QmrPostProcessWithPriceAndLead', postProcess: { __typename: 'PostProcess', id: string, typeName: string | null } }>, secondaryProcesses: Array<{ __typename: 'QmrSecondaryProcessDetails', process: { __typename: 'PostProcess', id: string } }> } | null, attachmentLink: { __typename: 'QuoteModelRevisionAttachment', quoteAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any } } | null, quoteModel: { __typename: 'QuoteModel', id: any } } }> } } | null };

export type SetNeedByDateMutationVariables = Exact<{
  quoteId: Scalars['UUID'];
  needByDate: InputMaybe<Scalars['Date']>;
}>;


export type SetNeedByDateMutation = { __typename: 'Mutation', setNeedByDate: any | null };

export type SendQlltOptimisationNotificationMutationVariables = Exact<{
  quoteId: Scalars['UUID'];
  userId: Scalars['Int'];
}>;


export type SendQlltOptimisationNotificationMutation = { __typename: 'Mutation', sendQlltOptimisationNotification: { __typename: 'ResponseFromEchatApi', url: string | null } | null };

export type SetBusinessAccountFeatureMutationVariables = Exact<{
  businessAccountId: Scalars['UUID'];
  featureName: BusinessAccountFeatureInput;
  isEnabled: Scalars['Boolean'];
}>;


export type SetBusinessAccountFeatureMutation = { __typename: 'Mutation', setBusinessAccountFeature: { __typename: 'BusinessAccountFeature', id: any, businessAccountId: any, featureName: BusinessAccountFeatureInput, isEnabled: boolean } | null };

export type RecordCltOptimizerViewMutationVariables = Exact<{
  quoteId: Scalars['UUID'];
}>;


export type RecordCltOptimizerViewMutation = { __typename: 'Mutation', recordCltOptimizerView: { __typename: 'CltOptimizerView', id: any, quoteId: any, viewCount: number, lastViewed: any, createdAt: any } };

export type RecordCltOptimizationMutationVariables = Exact<{
  quoteModelRevisionId: Scalars['UUID'];
  operation: Scalars['String'];
  description: Scalars['String'];
  initialCostCents: Scalars['Int'];
  finalCostCents: Scalars['Int'];
  initialTimeDays: Scalars['Int'];
  finalTimeDays: Scalars['Int'];
  initialQuantity: Scalars['Int'];
  finalQuantity: Scalars['Int'];
}>;


export type RecordCltOptimizationMutation = { __typename: 'Mutation', recordCltOptimization: { __typename: 'CltOptimization', id: any, quoteId: any, quoteModelRevisionId: any, userId: number, businessAccountMembershipId: any | null, operation: string, description: string, initialCostCents: number, finalCostCents: number, initialTimeDays: number, finalTimeDays: number, initialQuantity: number, finalQuantity: number, createdAt: any } };

export type LogRequestAssistanceMutationVariables = Exact<{
  quoteId: Scalars['UUID'];
}>;


export type LogRequestAssistanceMutation = { __typename: 'Mutation', logRequestAssistance: boolean };

export type GenerateCltOptimizerReportMutationVariables = Exact<{
  quoteId: Scalars['UUID'];
}>;


export type GenerateCltOptimizerReportMutation = { __typename: 'Mutation', generateCltOptimizerReport: { __typename: 'CltOptimizerReport', id: any, quoteId: any, userId: number, businessAccountId: any | null, costCentsDelta: number, timeDaysDelta: number, viewCount: number, lastViewed: any } | null };

export type QmrLeadTimeContributionsQueryVariables = Exact<{
  quoteModelRevisionId: Scalars['UUID'];
}>;


export type QmrLeadTimeContributionsQuery = { __typename: 'Query', qmrLeadTimeContributions: { __typename: 'QmrLeadTimeContributions', fastestDomesticLeadTimeBreakdown: { __typename: 'QmrLeadTimeBreakdown', additionalDays: { __typename: 'QmrLeadTimeContributionsAdditionalDays', longPart: number, tightTolerance: number, lathe: number, uncommonMaterials: number, reamer: number, pdfAutoQuotability: number, smallHoles: number, undercuts: number, smallTaps: number, machiningTimeBasedMinimumProductionDays: number } } | null } | null };

export type CalculateQuoteModelRevisionPendingPricesBreakdownPercentagesQueryVariables = Exact<{
  quoteModelRevisionId: Scalars['UUID'];
}>;


export type CalculateQuoteModelRevisionPendingPricesBreakdownPercentagesQuery = { __typename: 'Query', calculateQuoteModelRevisionPendingPricesBreakdownPercentages: Array<{ __typename: 'GranularPricingBreakdownPercentages', machineCost: number, materialCost: number, threadCost: number, setupCost: number, camCost: number, fixtureCost: number, miscNonRecurringEngineeringCost: number, toleranceCost: number, toolCost: number, otherCost: number } | null> | null };

export type CostAndLeadTimeQueryVariables = Exact<{
  quoteId: Scalars['UUID'];
}>;


export type CostAndLeadTimeQuery = { __typename: 'Query', quote: { __typename: 'Quote', id: any, name: string, status: string, type: QuoteType, isQuotePurchasable: boolean, reorderSourceOrderName: string | null, user: { __typename: 'BasicUser', id: number }, quoteModels: { __typename: 'PartialQuoteModelResults', totalCount: number, items: Array<{ __typename: 'QuoteModel', selectedQuoteModelRevision: { __typename: 'QuoteModelRevision', id: any, state: QuoteModelRevisionState, fileName: string, version: string, quantityRangeStatus: string | null, holes: Array<{ __typename: 'Hole', id: string, tapOptions: Array<{ __typename: 'TapOption', id: string }> }>, taps: Array<{ __typename: 'TapAnnotation', id: any }>, attachmentLink: { __typename: 'QuoteModelRevisionAttachment', id: any, quoteAttachmentRevision: { __typename: 'QuoteAttachmentRevision', id: any, attachment: { __typename: 'Attachment', id: any, fileName: string, downloadUrl: string | null, annotated: { __typename: 'AnnotatedAttachment', id: any, fileName: string, downloadUrl: string | null } | null, sanitized: { __typename: 'SanitizedAttachment', id: any, fileName: string, downloadUrl: string | null } | null } | null } } | null, dfmFeedback: Array<{ __typename: 'DfmFeedback', id: any, accepted: boolean, severity: string, message: string, isPublished: boolean }>, modelConfiguration: { __typename: 'ModelConfiguration', id: any, materialGrade: string | null, textureCode: string | null, colorCode: string | null, quantity: number | null, productionLeadTime: { __typename: 'ProductionLeadTime', id: string, priorityId: string, productionDays: number } | null, process: { __typename: 'Process', id: string } | null, material: { __typename: 'Material', id: string } | { __typename: 'UserEnteredMaterial', id: string, process: { __typename: 'Process', id: string } } | null } | null, processesDetails: { __typename: 'QmrProcessesDetails', primaryProcess: { __typename: 'QmrProcessWithPrice', price: { __typename: 'EstimatedPrice' } | { __typename: 'ExactPrice', priceInCents: number | null } | null, process: { __typename: 'Process', name: string, id: string } } | null, productionLeadTime: { __typename: 'ProductionLeadTime', shipDateEstimate: { __typename: 'ShipDateEstimate', shippedByDate: any } } | null, postProcesses: Array<{ __typename: 'QmrPostProcessWithPriceAndLead', unitPriceInCents: number | null, postProcessLeadTimeInDays: number | null, postProcessInspectionCriteria: ProcessInspectionCriteria | null, postProcessNumParts: number | null, postProcess: { __typename: 'PostProcess', name: string, id: string }, postProcessColor: { __typename: 'Color', id: string, name: string } | null, postProcessThickness: { __typename: 'Thickness', value: number } | null }>, totalPrice: { __typename: 'EstimatedPrice' } | { __typename: 'ExactPrice', priceInCents: number | null } | null } | null, partRevision: { __typename: 'Revision', thumbnailUri: string | null } } }> } } | null };

export type QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type QueryQuery = { __typename: 'Query', getAllBatchPostProcessIds: Array<string> };

export type GetQlltSlackThreadQueryVariables = Exact<{
  quoteId: Scalars['String'];
}>;


export type GetQlltSlackThreadQuery = { __typename: 'Query', getQlltSlackThread: { __typename: 'QlltSlackThreadResult', url: string | null } | null };

export type GetBusinessAccountFeatureQueryVariables = Exact<{
  businessAccountId: Scalars['UUID'];
  featureName: BusinessAccountFeatureInput;
}>;


export type GetBusinessAccountFeatureQuery = { __typename: 'Query', getBusinessAccountFeature: { __typename: 'BusinessAccountFeature', id: any, businessAccountId: any, featureName: BusinessAccountFeatureInput, isEnabled: boolean, updatedAt: any } | null };

export const AutoconfigSecondaryProcessConfigFragmentDoc = gql`
    fragment AutoconfigSecondaryProcessConfig on AutoconfigurationSecondaryProcessDetectionsConfiguration {
  processColorId
  processId
  processInspectionCriteria
  processNumParts
  processThicknessInInches
}
    `;
export const AutoconfigSecondaryProcessDetectionsFragmentDoc = gql`
    fragment AutoconfigSecondaryProcessDetections on AutoconfigurationSecondaryProcessDetections {
  configuration {
    ...AutoconfigSecondaryProcessConfig
  }
  displayString
  hashString
  valid
  tooltipNote
}
    ${AutoconfigSecondaryProcessConfigFragmentDoc}`;
export const AutoconfigurationItemFragmentDoc = gql`
    fragment AutoconfigurationItem on AutoConfiguration {
  filename
  extractedConfiguration {
    canAutoConfigure
    materialDetections {
      displayString
      platformId
      valid
      tooltipNote
    }
    primaryProcessConfig {
      colorCode
      materialGrade
      materialId
      priorityId
      processId
      quantity
      textureCode
    }
    quoteModelRevisionId
    secondaryProcessConfigs {
      ...AutoconfigSecondaryProcessConfig
    }
    secondaryProcessDetections {
      ...AutoconfigSecondaryProcessDetections
    }
    usableTextFoundInDrawing
    tooltipNote
  }
  quoteModelRevisionId
}
    ${AutoconfigSecondaryProcessConfigFragmentDoc}
${AutoconfigSecondaryProcessDetectionsFragmentDoc}`;
export const FictivHolidayItemFragmentDoc = gql`
    fragment FictivHolidayItem on FictivHoliday {
  id
  holiday
  date
  country {
    code
  }
}
    `;
export const Scorecard_Car_Chart_ItemsFragmentDoc = gql`
    fragment Scorecard_Car_Chart_Items on MfgPartnerLevelCalculationRecord {
  recordType
  recordDate
  avgCarTurnaroundDays
}
    `;
export const Scorecard_Rating_Chart_ItemsFragmentDoc = gql`
    fragment Scorecard_Rating_Chart_Items on MfgPartnerLevelCalculationRecord {
  recordType
  recordDate
  acceptanceRatio
  expirationRatio
  otRatio
  ifRatio
}
    `;
export const GetMaterialsByMpIdMfgPartnerMaterialFragmentDoc = gql`
    fragment GetMaterialsByMpIdMfgPartnerMaterial on MfgPartnerMaterial {
  isActive
  materialId
  materialName
  erpProcessId
}
    `;
export const GetMaterialsByMpIdMfgPartnerMaterialsFragmentDoc = gql`
    fragment GetMaterialsByMpIdMfgPartnerMaterials on MfgPartnerMaterialResult {
  materialCategoryId
  materialCategoryName
  erpPlatformProcessId
  partnerMaterials {
    ...GetMaterialsByMpIdMfgPartnerMaterial
  }
}
    ${GetMaterialsByMpIdMfgPartnerMaterialFragmentDoc}`;
export const ProcessAvailabilityFragmentDoc = gql`
    fragment ProcessAvailability on ShopProcessAvailability {
  accepting
  date
}
    `;
export const ProcessAvailabilityByProcessIdFragmentDoc = gql`
    fragment ProcessAvailabilityByProcessId on PartnerShopProcessAvailability {
  availability {
    ...ProcessAvailability
  }
}
    ${ProcessAvailabilityFragmentDoc}`;
export const GetProcessPreferenceByIdFragmentFragmentDoc = gql`
    fragment getProcessPreferenceByIdFragment on MfgPartnerProcessCapabilities {
  id
  erpProcessId
  isVeryUrgentSupported
  minSetups
  maxSetups
  minLeadTime
  minQuantity
  minPayout
  maxPayout
  targetSpendOverride
  targetSpendOverrideExpiresAt
  overloadSpend
  overloadSpendJobCount
  isMouSigned
  mouSpend
  mouStartsAt
  mouExpiresAt
  payoutMultiplier
  openJobRequestsCount
  openJobRequestsValue
  currentTargetSpend
  calculatedTargetSpend
  backstopMp
  supportingCapabilities {
    id
    name
  }
}
    `;
export const ProcessesListByMfgIdFragmentDoc = gql`
    fragment ProcessesListByMfgId on ShopProcessDetail {
  platformProcessId
  platformProcessTypeId
  processId
  processName
  showMpAvailability
}
    `;
export const BasicUserPartFragmentDoc = gql`
    fragment BasicUserPart on BasicUser {
  id
  displayName
}
    `;
export const MfgPartnerLevelOverridePartFragmentDoc = gql`
    fragment MfgPartnerLevelOverridePart on MfgPartnerLevelOverride {
  expiresAt
  id
  mpLevelOverride
  partnerId
}
    `;
export const MfgPartnerLevelCalculationRecordPartFragmentDoc = gql`
    fragment MfgPartnerLevelCalculationRecordPart on MfgPartnerLevelCalculationRecord {
  acceptanceLevel
  acceptanceRatio
  expirationLevel
  expirationRatio
  ifLevel
  ifRatio
  otLevel
  otRatio
  avgCarTurnaroundDays
  carLevel
  mpLevel
  mpLevelOverrideRecord {
    ...MfgPartnerLevelOverridePart
  }
}
    ${MfgPartnerLevelOverridePartFragmentDoc}`;
export const MfgPartnerPartFragmentDoc = gql`
    fragment MfgPartnerPart on MfgPartner {
  id
  name
  tz
  supplierQualityEngineer {
    id
    displayName
  }
  strategicSourcingManager {
    id
    displayName
  }
  supplierDevelopmentEngineer {
    id
    displayName
  }
  openJobsCount
  countryName
  openFailuresCount
  openCarsCount
  currentMpLevelDetails {
    ...MfgPartnerLevelCalculationRecordPart
  }
  isEligibleForWork
  isApprovedVendor
  lastScorecardSent
  mpLevelOverrideInEffect
}
    ${MfgPartnerLevelCalculationRecordPartFragmentDoc}`;
export const MfgPartnerLevelSnapshotDetails_Cars_ItemsFragmentDoc = gql`
    fragment MfgPartnerLevelSnapshotDetails_CARS_Items on MfgPartnerLevelCarsSnapshotDetail {
  carCanceledAt
  carId
  carName
  carSentAt
  carStatus
  carSubmittedAt
  carTurnaroundDays
  exceptionId
  exceptionName
  jobId
  jobRequestId
  jobRequestName
}
    `;
export const MfgPartnerLevelSnapshotDetails_Failures_ItemsFragmentDoc = gql`
    fragment MfgPartnerLevelSnapshotDetails_Failures_Items on MfgPartnerLevelFailureSnapshotDetail {
  exceptionId
  exceptionName
  ifFailureMp
  otFailureMp
  saleOrderId
  saleOrderName
  type
  jobRequestName
  jobId
  exceptionCreatedAt
  exceptionParts {
    lines
  }
}
    `;
export const MfgPartnerLevelSnapshotDetails_JobRequests_ItemsFragmentDoc = gql`
    fragment MfgPartnerLevelSnapshotDetails_JobRequests_Items on MfgPartnerLevelJobRequestSnapshotDetail {
  jobId
  jobRequestName
  jobRequestId
  saleOrderName
  projectId
  projectName
  isSecurePlus
  priority
  jobRequestStatus
  acceptedAt
  expiresAt
  completedAt
  rejectedAt
}
    `;
export const CarAssociatedExceptionsFragmentDoc = gql`
    fragment CarAssociatedExceptions on ExceptionFailureDetail {
  id
  name
}
    `;
export const MfgPartnerLevelSnapshotDetails_Car_ItemsFragmentDoc = gql`
    fragment MfgPartnerLevelSnapshotDetails_CAR_Items on MfgPartnerLevelCarsSnapshotDetail {
  carCanceledAt
  carId
  carName
  carSentAt
  carStatus
  carSubmittedAt
  carTurnaroundDays
  exceptions {
    ...CarAssociatedExceptions
  }
  jobId
  jobRequestId
  jobRequestName
}
    ${CarAssociatedExceptionsFragmentDoc}`;
export const BasicCarDetailsFragmentDoc = gql`
    fragment BasicCarDetails on CorrectiveActionRequest {
  id
  type
  status
  assignee {
    id
    displayName
  }
  mfgPartner {
    id
    displayName
  }
  associatedExceptionFailures {
    id
    name
    type
    exceptionFailureState
  }
  associatedExceptionNames
  name
}
    `;
export const FailureNoteFragmentDoc = gql`
    fragment FailureNote on ExceptionFailureNote {
  id
  createdAt
  body
  createdBy {
    id
    displayName
  }
  exceptionFailureNoteAttachments {
    id
    attachment {
      createdAt
      downloadUrl
      uploadUrl
      fileName
      extension
      id
      mimeType
    }
    createdAt
  }
}
    `;
export const FailurePartFragmentDoc = gql`
    fragment FailurePart on ExceptionPart {
  id
  lines
  failedQuantity
  partName
}
    `;
export const FailureHistoryFragmentDoc = gql`
    fragment FailureHistory on ExceptionFailureHistory {
  id
  contextKey
  createdAt
  createdBy {
    id
    displayName
  }
  message
  newValue
  objectId
  updatedAt
  oldValue
}
    `;
export const Minimum_Eligibility_MpsFragmentDoc = gql`
    fragment Minimum_Eligibility_Mps on MinimumEligibilityMp {
  mfgPartner {
    id
    name
  }
}
    `;
export const Mp_SuggestionFragmentDoc = gql`
    fragment Mp_Suggestion on RecommendedMp {
  mfgPartner {
    id
    name
  }
  jobOTIFProbability
  sequence
  totalPayout
  jobAcceptanceProbability
}
    `;
export const Recommended_Mps_For_JobFragmentDoc = gql`
    fragment Recommended_Mps_For_Job on RecommendedMpsForJob {
  shiftingAttributes {
    attributeName
    value
  }
  minimumEligibilityMps {
    ...Minimum_Eligibility_Mps
  }
  recommendedRequestId
  mpSuggestions {
    ...Mp_Suggestion
  }
}
    ${Minimum_Eligibility_MpsFragmentDoc}
${Mp_SuggestionFragmentDoc}`;
export const MfgPartnerFragmentDoc = gql`
    fragment MfgPartner on MfgPartner {
  id
  name
  countryName
}
    `;
export const QueueItemFragmentDoc = gql`
    fragment QueueItem on SchedulingQueueItem {
  id
  queueId
  waitTime
  jobExpiryTime
  jobExtraViewingTime
  jobRequestId
  scheduleNoEarlierThan
  sequenceNo
  skipped
  reasonToSkip
  createdAt
  updatedAt
  deletedAt
  status
  exceptionCount
  mfgPartner {
    ...MfgPartner
  }
  rejectionReason
  rejectionReasonAdditionalInfo
  overrideMpUnavailability
  overrideMpAcceptingHours
  history {
    id
    objectType
    objectId
    contextKey
    oldValue
    newValue
    message
    createdBy {
      id
      displayName
      firstName
      lastName
      email
      createdAt
      updatedAt
      enabled
    }
    createdAt
  }
}
    ${MfgPartnerFragmentDoc}`;
export const JobMpTypeFragmentDoc = gql`
    fragment JobMpType on MfgPartner {
  id
  displayName
  isMpAvailable(jobId: $jobId, forDate: $forDate)
}
    `;
export const DriFragmentDoc = gql`
    fragment Dri on BasicUser {
  id
  displayName
}
    `;
export const JobNoteFragmentDoc = gql`
    fragment JobNote on Note {
  id
  description
  createdBy {
    id
    displayName
  }
  createdAt
  attachments {
    id
    attachment {
      id
      fileName
      mimeType
      downloadUrl
    }
    createdAt
    createdBy {
      id
      displayName
    }
  }
}
    `;
export const JobTypeFragmentDoc = gql`
    fragment JobType on Job {
  id
  name
  countryCode
  salesOrderName
  nextMilestone
  trackStatus
  jobComputedStatus
  status
  queueStatus
  queueItemCount
  processedQueueItemCount
  leadTime
  payout
  priority
  notes {
    ...JobNote
  }
  region
  processNames
  materialNames
  exceptionCount
  rfqNumber
  scheduleNoEarlierThan
  erpSaleOrderId
  pauseException
  jobBoardId
  jobBoardStatus
  jobBoardStartDate
  jobBoardEndDate
  isForJobBoard
  bidCount
  buyNowPrice
  jobBoardRegion
  customerName
  customerCompanyName
  businessUnit
  mpMfgDri {
    id
    displayName
  }
  customerMfgDri {
    id
    displayName
  }
  mfgDri {
    id
    displayName
  }
  mfgPartner {
    id
    name
  }
  project {
    id
    name
    isSecurePlus
  }
  milestones {
    scheduling {
      committedDate
      scheduledDate
      actualDate
    }
    production {
      committedDate
      scheduledDate
      actualDate
    }
    inspection {
      committedDate
      scheduledDate
      actualDate
    }
    deliveryOrder {
      committedDate
      scheduledDate
      actualDate
    }
    shipping {
      committedDate
      scheduledDate
      actualDate
    }
    customerDelivery {
      committedDate
      scheduledDate
      actualDate
    }
  }
}
    ${JobNoteFragmentDoc}`;
export const MfgPartnerForFilterListFragmentDoc = gql`
    fragment mfgPartnerForFilterList on MfgPartner {
  id
  displayName
}
    `;
export const SolPartFragmentDoc = gql`
    fragment SolPart on Part {
  id
  revisionUuid
  quoteModelRevisionUuid
  name
  depthX
  depthY
  depthZ
}
    `;
export const SolBasicMoldToolFragmentDoc = gql`
    fragment SolBasicMoldTool on BasicMoldTool {
  id
  name
  moldToolRevisionId
  version
}
    `;
export const SolProductProcessAttributesFragmentDoc = gql`
    fragment SolProductProcessAttributes on PartProcessAttributes {
  id
  name
  color
  thickness
  texture
}
    `;
export const SolMaterialFragmentDoc = gql`
    fragment SolMaterial on PartMaterialConfiguration {
  id
  name
  color
  colorCode
  grade
  shoreValue
}
    `;
export const SolPreviousJobFragmentDoc = gql`
    fragment SolPreviousJob on PreviousJobsType {
  id
  name
}
    `;
export const SolProductProcessFragmentDoc = gql`
    fragment SolProductProcess on SalesOrderLineProductProcess {
  id
  erpProductId
  salesOrderId
  salesOrderLineId
  processTypeName
  processNotes
  executionSequence
  unbundledQuantity
  scheduledQuantity
  remainingQuantity
  targetPurchasePrice
  processTypeId
  processId
  expectedDueDate
  leadTime
  payout
  thumbnailUri
  isLastProductProcess
  part {
    ...SolPart
  }
  moldTool {
    ...SolBasicMoldTool
  }
  associatedMoldTool {
    id
    name
    moldToolRevisionId
    version
  }
  processAttributes {
    ...SolProductProcessAttributes
  }
  materialConfiguration {
    ...SolMaterial
  }
  previousJobs {
    ...SolPreviousJob
  }
  previousJobBoardJobs {
    id
    name
  }
  isLastProductProcess
  productionRegion
  nextJobBoard {
    id
    startDate
  }
  productionCountry
}
    ${SolPartFragmentDoc}
${SolBasicMoldToolFragmentDoc}
${SolProductProcessAttributesFragmentDoc}
${SolMaterialFragmentDoc}
${SolPreviousJobFragmentDoc}`;
export const JobRequestInventoryMoveFragmentDoc = gql`
    fragment JobRequestInventoryMove on InventoryMove {
  id
  name
  state
}
    `;
export const JobRequestDeliveriesFragmentDoc = gql`
    fragment JobRequestDeliveries on SalesOrderDeliveryOrder {
  id
  name
  state
  committedCompletionDate
}
    `;
export const ViewerPageModelViewerSnapshotFragmentDoc = gql`
    fragment ViewerPageModelViewerSnapshot on ModelViewerSnapshot {
  id
  position
  target
  feature
  type
  snapshot {
    camera {
      zoom
      position
      up
      target
    }
    dfm {
      feature
      threshold
      direction
    }
    annotations {
      position
    }
    rotation
    part {
      transparent
      patches {
        color
        hashcode
      }
    }
    crossSection {
      position
      rotation
    }
    pointToPoint {
      customPoints
      selectedPoints {
        index
        type
      }
    }
  }
  createdAt
  updatedAt
  deletedAt
}
    `;
export const DfmFeedbackOrderDetailsPageFragmentDoc = gql`
    fragment dfmFeedbackOrderDetailsPage on DfmFeedback {
  id
  title
  link
  severity
  message
  accepted
  modelViewerSnapshots {
    ...ViewerPageModelViewerSnapshot
  }
  isPublished
}
    ${ViewerPageModelViewerSnapshotFragmentDoc}`;
export const HolesFragmentDoc = gql`
    fragment holes on Hole {
  id
  groupKey
  patches {
    id
  }
  type
  depth
  diameter
  isBlind
  tipAngle
  counterboreDepth
  counterboreDiameter
  countersinkAngle
  countersinkDepth
  countersinkDiameter
  direction
  endPoint
  startPoint
  tapOptions {
    id
    maxDepth
    commonName
  }
  tapAnnotation {
    id
    depth
    tapOption {
      id
      maxDepth
      commonName
    }
  }
}
    `;
export const RevisionFragmentDoc = gql`
    fragment revision on Revision {
  id
  version
  modelFileName
  thumbnailUri
  downloadUri
  sceneBundle
  scene {
    featureMapping {
      url
    }
    geometry {
      url
    }
  }
  boundingBox {
    x
    y
    z
  }
  revisionFolderAttachments {
    id
    quoteAttachment {
      id
      attachment {
        id
        fileName
      }
    }
  }
}
    `;
export const BoundingBoxFragmentDoc = gql`
    fragment boundingBox on BoundingBox {
  width
  length
  thickness
}
    `;
export const InspectionDocumentsFragmentDoc = gql`
    fragment inspectionDocuments on InspectionDocument {
  fileName
  type
  mimeType
  downloadUrl
  createdAt
  updatedAt
}
    `;
export const AdminQuoteDetailsModelConfigurationFragmentDoc = gql`
    fragment adminQuoteDetailsModelConfiguration on ModelConfiguration {
  id
  dfmInspection {
    id
  }
  process {
    id
    name
    platformProcessTypeId
  }
  material {
    ... on Material {
      id
      name
    }
    ... on UserEnteredMaterial {
      id
      name
      process {
        id
        name
      }
    }
  }
  materialGrade
  color {
    id
    name
  }
  colorCode
  shore {
    id
    name
  }
  texture {
    id
    name
  }
  textureCode
  dfmInspection {
    id
    manualOverrideMpUnitPayout
    manualOverrideUnitAmount
    manualOverrideUnitProductionDays
    inspectionData
  }
  productionLeadTime {
    id
    priorityId
    productionDays
    shipDateEstimate {
      id
      validUntilDate
      shippedByDate
    }
  }
  quantity
  requiresOvermold
  additionalRequirements
  userNeedsConfigHelp
  fdmInfillPercentageCategory
  fdmInfillPercentageCategoryLabel
}
    `;
export const AdminQuoteModelRevisionDfmReportFragmentDoc = gql`
    fragment AdminQuoteModelRevisionDfmReport on PartDfmReport {
  quoteAttachmentRevisionId
  asset {
    id
    createdAt
    downloadUrl
    fileName
  }
  uploaderEmail
  source
  isPublished
}
    `;
export const AdminQuoteModelRevisionQuoteModelQuoteUserFragmentDoc = gql`
    fragment AdminQuoteModelRevisionQuoteModelQuoteUser on BasicUser {
  id
  firstName
  lastName
  email
}
    `;
export const AdminAttachmentFragmentDoc = gql`
    fragment adminAttachment on Attachment {
  id
  user {
    id
    email
    firstName
    lastName
  }
  sanitized {
    id
    uploadUrl
    downloadUrl
    fileName
    extension
    mimeType
    sizeInKb
    createdAt
    updatedAt
    deletedAt
  }
  uploadUrl
  downloadUrl
  fileName
  extension
  mimeType
  sizeInKb
  createdAt
}
    `;
export const AdminQuoteModelRevisionQuoteModelQuoteFragmentDoc = gql`
    fragment AdminQuoteModelRevisionQuoteModelQuote on Quote {
  id
  name
  status
  isFlexiblePriceQuote
  openEndedQuoteInviteUrl
  isCpqOwned @include(if: $isCpqFlagV2Enabled)
  type
  user {
    ...AdminQuoteModelRevisionQuoteModelQuoteUser
  }
  quoteModels(limit: 1000) {
    items {
      id
      selectedQuoteModelRevision {
        processesDetails {
          totalPrice {
            ... on ExactPrice {
              unitPriceInCents
              priceInCents
            }
            ... on EstimatedPrice {
              lowPriceInCents
              lowUnitPriceInCents
              highPriceInCents
              highUnitPriceInCents
            }
          }
        }
      }
      quoteModelRevisions {
        id
        dfmFeedback(includeDraft: true) {
          isPublished
        }
        dfmReports {
          isPublished
          source
          uploaderEmail
          asset {
            id
            fileName
            createdAt
            downloadUrl
          }
        }
        partRevision {
          modelFileName
          thumbnailUri
        }
        quoteModel {
          quote {
            isQuotePurchasable
          }
        }
      }
    }
  }
  quoteAttachments {
    items {
      id
      latestAttachmentRevision {
        id
        attachment {
          ...adminAttachment
        }
      }
    }
  }
}
    ${AdminQuoteModelRevisionQuoteModelQuoteUserFragmentDoc}
${AdminAttachmentFragmentDoc}`;
export const AdminQuoteModelRevisionSanitizedAttachmentFragmentDoc = gql`
    fragment AdminQuoteModelRevisionSanitizedAttachment on SanitizedAttachment {
  id
  downloadUrl
}
    `;
export const AdminQuoteModelRevisionGeneratedDrawingFragmentDoc = gql`
    fragment AdminQuoteModelRevisionGeneratedDrawing on GeneratedDrawing {
  id
  attachment {
    id
    downloadUrl
  }
}
    `;
export const AdminQuoteModelRevisionHoleFragmentDoc = gql`
    fragment AdminQuoteModelRevisionHole on Hole {
  id
  groupKey
  type
  depth
  diameter
  isBlind
  tipAngle
  counterboreDepth
  counterboreDiameter
  countersinkAngle
  countersinkDepth
  countersinkDiameter
  direction
  endPoint
  startPoint
  tapOptions {
    id
    maxDepth
    commonName
  }
  tapAnnotation {
    id
    depth
    tapOption {
      id
      maxDepth
      commonName
    }
  }
}
    `;
export const AdminQuoteModelRevisionDataPartRevisionFragmentDoc = gql`
    fragment AdminQuoteModelRevisionDataPartRevision on Revision {
  id
  modelFileName
  downloadUri
  cleanDownloadUri
  thumbnailUri
  sceneBundle
  units
  boundingBox {
    x
    y
    z
  }
  rawAnalysis
  partId
  updatedAt
}
    `;
export const DfmFeedbackDeprecatedSnapshotFragmentDoc = gql`
    fragment DfmFeedbackDeprecatedSnapshot on ModelViewerConfig {
  camera {
    position
    zoom
    up
    target
  }
  part {
    transparent
    patches {
      color
      hashcode
    }
  }
  rotation
  dfm {
    color
    threshold
    feature
    direction
  }
  annotations {
    position
  }
  crossSection {
    position
    rotation
  }
  pointToPoint {
    customPoints
    selectedPoints {
      index
      type
    }
  }
}
    `;
export const DfmFeedbackDeprecatedFragmentDoc = gql`
    fragment dfmFeedbackDeprecated on DfmFeedback {
  id
  isValid
  message
  title
  link
  code
  isPublished
  severity
  sourceType
  isAutoGeneratedDfm
  createdBy {
    displayName
    email
  }
  modelViewerSnapshots {
    id
    snapshot {
      ...DfmFeedbackDeprecatedSnapshot
    }
  }
  createdAt
  deletedAt
}
    ${DfmFeedbackDeprecatedSnapshotFragmentDoc}`;
export const ProcessesDetailsDeprecatedSecondaryProcessHardwareInstallationManualQuoteCalcFieldsFragmentDoc = gql`
    fragment ProcessesDetailsDeprecatedSecondaryProcessHardwareInstallationManualQuoteCalcFields on HardwareInstallationManualQuoteCalcFields {
  international {
    markupPercentage
    mpPayoutInCents
    mpPayoutPartsLimit
    leadTimeInDays
    leadTimePartsLimit
  }
  domestic {
    mpPayoutInCents
    markupPercentage
    mpPayoutPartsLimit
    leadTimeInDays
    leadTimePartsLimit
  }
  lineItems {
    supplier
    partNumber
    qtyPerPart
    pricePerPack
    qtyPerPack
  }
}
    `;
export const ProcessesDetailsDeprecatedSecondaryProcessFragmentDoc = gql`
    fragment ProcessesDetailsDeprecatedSecondaryProcess on QmrSecondaryProcessDetails {
  process {
    id
    name
    typeName
  }
  unitPriceInCents
  leadTimeInDays
  notes
  pricingAndLeadTimeFields {
    ... on SecondaryProcessManualQuoteCalcFields {
      international {
        markupPercentage
        mpPayoutInCents
        mpPayoutPartsLimit
        leadTimeInDays
        leadTimePartsLimit
      }
      domestic {
        mpPayoutInCents
        markupPercentage
        mpPayoutPartsLimit
        leadTimeInDays
        leadTimePartsLimit
      }
    }
    ... on HardwareInstallationManualQuoteCalcFields {
      ...ProcessesDetailsDeprecatedSecondaryProcessHardwareInstallationManualQuoteCalcFields
    }
  }
}
    ${ProcessesDetailsDeprecatedSecondaryProcessHardwareInstallationManualQuoteCalcFieldsFragmentDoc}`;
export const ProcessesDetailsDeprecatedFragmentDoc = gql`
    fragment processesDetailsDeprecated on QmrProcessesDetails {
  totalPrice {
    ... on EstimatedPrice {
      lowPriceInCents
      lowUnitPriceInCents
      highPriceInCents
      highUnitPriceInCents
    }
    ... on ExactPrice {
      priceInCents
      unitPriceInCents
    }
  }
  primaryProcess {
    process {
      id
      name
      platformProcessTypeId
    }
    price {
      ... on EstimatedPrice {
        lowPriceInCents
        lowUnitPriceInCents
        highPriceInCents
        highUnitPriceInCents
      }
      ... on ExactPrice {
        priceInCents
        unitPriceInCents
      }
    }
  }
  postProcesses {
    unitPriceInCents
    postProcessLeadTimeInDays
    postProcessNumParts
    postProcessInspectionCriteria
    postProcess {
      id
      name
      typeName
      colors {
        id
        name
      }
      thicknesses {
        id
        name
        value
      }
    }
    postProcessThickness {
      id
      name
    }
    postProcessColor {
      id
      name
    }
  }
  secondaryProcesses {
    ...ProcessesDetailsDeprecatedSecondaryProcess
  }
  isBusinessAccountDiscountApplied
}
    ${ProcessesDetailsDeprecatedSecondaryProcessFragmentDoc}`;
export const AdminModelConfigurationDeprecatedDfmInspectionsItemFragmentDoc = gql`
    fragment AdminModelConfigurationDeprecatedDfmInspectionsItem on ModelConfigurationDfmInspection {
  id
  inspectionData
  quantityLowerRange
  quantityUpperRange
  isQuantityRangeAvailable
  isPublished
  manualOverrideMpUnitPayout
  manualOverrideUnitAmount
  quotedBy {
    id
    displayName
  }
  quotedAt
  quoteUpdatedBy {
    id
    displayName
  }
  quoteUpdatedAt
  updatedAt
}
    `;
export const AdminModelConfigurationDeprecatedDfmInspectionFragmentDoc = gql`
    fragment AdminModelConfigurationDeprecatedDfmInspection on ModelConfigurationDfmInspection {
  id
  inspectionData
  isPublished
  quotedBy {
    id
    displayName
  }
  quotedAt
  quoteUpdatedBy {
    id
    displayName
  }
  quoteUpdatedAt
  updatedAt
  manualOverrideMpUnitPayout
  manualOverrideUnitAmount
}
    `;
export const AdminModelConfigurationDeprecatedFragmentDoc = gql`
    fragment adminModelConfigurationDeprecated on ModelConfiguration {
  id
  requiresOvermold
  additionalRequirements
  dfmInspections {
    ...AdminModelConfigurationDeprecatedDfmInspectionsItem
  }
  dfmInspection {
    ...AdminModelConfigurationDeprecatedDfmInspection
  }
  productionLeadTime {
    id
    priorityId
    productionDays
    primaryProductionDays
    shipDateEstimate {
      id
      validUntilDate
      shippedByDate
    }
  }
  process {
    id
    name
  }
  material {
    __typename
    ... on Material {
      id
      name
    }
    ... on UserEnteredMaterial {
      id
      name
    }
  }
  materialGrade
  color {
    id
    name
  }
  colorCode
  texture {
    id
    name
  }
  textureCode
  quantity
  errorCode
  updatedAt
  updatedBy {
    id
    email
    updatedAt
  }
  toolDetails {
    totalCost
    tools {
      id
      type
      diameter
      length
      ratio
      price
    }
  }
}
    ${AdminModelConfigurationDeprecatedDfmInspectionsItemFragmentDoc}
${AdminModelConfigurationDeprecatedDfmInspectionFragmentDoc}`;
export const AdminQuoteModelRevisionDataFragmentDoc = gql`
    fragment AdminQuoteModelRevisionData on QuoteModelRevision {
  id
  isITARProhibitedViewing
  isExclusiveToSingleQuote
  canBeExclusiveToSingleQuote
  fileName
  version
  updatedAt
  flags
  state
  supportedPriorityRegions {
    partSupportsDomestic
    partSupportsInternational
  }
  dfmReports {
    ...AdminQuoteModelRevisionDfmReport
  }
  quoteModel {
    id
    quote {
      ...AdminQuoteModelRevisionQuoteModelQuote
    }
  }
  sourceQuoteModelRevisionId
  annotations {
    id
  }
  manufacturingDrawing {
    ... on SanitizedAttachment {
      ...AdminQuoteModelRevisionSanitizedAttachment
    }
    ... on GeneratedDrawing {
      ...AdminQuoteModelRevisionGeneratedDrawing
    }
  }
  attachmentLink {
    id
    quoteAttachmentRevision {
      id
      quoteAttachment {
        id
      }
      attachment {
        ... on Attachment {
          id
          fileName
          downloadUrl
          sanitized {
            id
            downloadUrl
            fileName
          }
          annotated {
            id
            downloadUrl
            fileName
          }
        }
      }
    }
    createdAt
    isPdfOcrAutoQuotable
  }
  holes {
    ...AdminQuoteModelRevisionHole
  }
  taps {
    id
  }
  partRevision {
    ...AdminQuoteModelRevisionDataPartRevision
  }
  dfmFeedback(includeDraft: true) {
    ...dfmFeedbackDeprecated
  }
  quantityRangeStatus
  processesDetails {
    ...processesDetailsDeprecated
  }
  modelConfiguration {
    ...adminModelConfigurationDeprecated
  }
  mold {
    id
    inspectionData
    price {
      priceInCents
      unitPriceInCents
    }
    manualOverrideMpUnitPayout
    manualOverrideUnitAmount
  }
}
    ${AdminQuoteModelRevisionDfmReportFragmentDoc}
${AdminQuoteModelRevisionQuoteModelQuoteFragmentDoc}
${AdminQuoteModelRevisionSanitizedAttachmentFragmentDoc}
${AdminQuoteModelRevisionGeneratedDrawingFragmentDoc}
${AdminQuoteModelRevisionHoleFragmentDoc}
${AdminQuoteModelRevisionDataPartRevisionFragmentDoc}
${DfmFeedbackDeprecatedFragmentDoc}
${ProcessesDetailsDeprecatedFragmentDoc}
${AdminModelConfigurationDeprecatedFragmentDoc}`;
export const AdminImModelConfigurationFragmentDoc = gql`
    fragment adminImModelConfiguration on ModelConfiguration {
  id
  dfmInspection {
    id
    inspectionData
    isPublished
    quotedBy {
      id
      displayName
    }
    quotedAt
    quoteUpdatedBy {
      id
      displayName
    }
    quoteUpdatedAt
    updatedAt
  }
  productionLeadTime {
    id
    priorityId
    productionDays
    primaryProductionDays
    shipDateEstimate {
      id
      validUntilDate
      shippedByDate
    }
  }
  process {
    id
    name
  }
  material {
    __typename
    ... on Material {
      id
      name
    }
    ... on UserEnteredMaterial {
      id
      name
    }
  }
  materialGrade
  color {
    id
    name
  }
  colorCode
  textureCode
  hasMultipleFinishes
  userNeedsConfigHelp
  quantity
  errorCode
  updatedAt
  updatedBy {
    id
    email
    updatedAt
  }
  toolDetails {
    totalCost
    tools {
      id
      type
      diameter
      length
      ratio
      price
    }
  }
}
    `;
export const AdminOrderSearchItemPartFragmentDoc = gql`
    fragment AdminOrderSearchItemPart on OrderSearchPart {
  partRevisionId
  partId
  modelFileName
  thumbnailUri
}
    `;
export const AdminOrderSearchItemFragmentDoc = gql`
    fragment AdminOrderSearchItem on AdminOrderResult {
  parts {
    ...AdminOrderSearchItemPart
  }
  id
  saleOrderId
  isErpOrder
  purchaserId
  userEmail
  purchaserEmail
  orderName
  quoteName
  quoteId
  businessAccountName
  businessAccountId
  userId
  status
  totalAmount
  paymentType
  poNumber
  createdAt
  isAdminProjectMember
  isProjectAdmin
  isSecure
}
    ${AdminOrderSearchItemPartFragmentDoc}`;
export const BusinessAccountSubscriptionFragmentDoc = gql`
    fragment BusinessAccountSubscription on BusinessAccountSubscription {
  id
  enabledBy {
    id
    displayName
    email
  }
  enabledAt
  expiresAt
  disabledBy {
    id
    displayName
    email
  }
  disabledAt
  plan {
    id
    planName
    planId
    durationDays
  }
  durationDays
  status
  businessAccountId
  planId
}
    `;
export const BusinessAccountSearchItemFragmentDoc = gql`
    fragment BusinessAccountSearchItem on BusinessAccount {
  id
  enabledAt
  isEnabled
  name
  totalMembers
  totalTeams
  subscription {
    ...BusinessAccountSubscription
  }
}
    ${BusinessAccountSubscriptionFragmentDoc}`;
export const PartSearchAdminFieldsFragmentDoc = gql`
    fragment PartSearchAdminFields on PartSearchInfo {
  qmrId
  partRevisionUuid
  quoteItemId
  eiUuid
  partId
  modelFileName
  userId
  email
  matchedText
  partCreatedAt
  orderName
  quoteName
  quoteId
  quoteItemDeletedAt
  hasAttachedPdf
  quoteStatus
  ownerId
}
    `;
export const UserSearchAdminSearchFieldsFragmentDoc = gql`
    fragment UserSearchAdminSearchFields on UserSearchInfo {
  userId
  emailAddress
  fullName
  createdAt
  roles
}
    `;
export const BusinessAccountInviteTypeFragmentDoc = gql`
    fragment BusinessAccountInviteType on BusinessAccountInvite {
  email
  inviteUrl
}
    `;
export const BusinessAccountInviteErrorTypeFragmentDoc = gql`
    fragment BusinessAccountInviteErrorType on SendBusinessAccountInviteError {
  email
  errorCode
  currentSalesforceAccountUrl
  currentSalesforceAccountName
  targetSalesforceAccountUrl
  targetSalesforceAccountName
  businessAccountName
  businessAccountUrl
}
    `;
export const PunchoutFeatureFragmentDoc = gql`
    fragment PunchoutFeature on BusinessAccountPunchoutFeature {
  disabledProcesses
  isActive
  sharedSecret
  updatedAt
}
    `;
export const BusinessAccountFragmentDoc = gql`
    fragment BusinessAccount on BusinessAccount {
  id
  createdAt
  isEnabled
  enabledAt
  name
  isTeamsFeatureEnabled
  salesforceAccount {
    url
  }
  totalMembers
  totalTeams
  subscription {
    ...BusinessAccountSubscription
  }
  excludedCountries {
    name
    value
  }
}
    ${BusinessAccountSubscriptionFragmentDoc}`;
export const BusinessAccountFeatureItemFragmentDoc = gql`
    fragment BusinessAccountFeatureItem on BusinessAccountFeature {
  id
  businessAccountId
  featureName
  isEnabled
  updatedAt
}
    `;
export const DrawingGeneratorAnnotationFragmentDoc = gql`
    fragment drawingGeneratorAnnotation on Annotation {
  id
  message
  position
  target
  feature
  type
  accepted
  severity
  deletedAt
  createdAt
}
    `;
export const DrawingGeneratorSceneFragmentDoc = gql`
    fragment drawingGeneratorScene on ViewerScene {
  featureMapping {
    url
  }
  geometry {
    url
  }
  thinWall {
    url
  }
  sharpInternalCorners {
    url
  }
  unreachableSurfaces {
    url
  }
  imThickWallAbs {
    url
  }
  imSharpEdges {
    url
  }
  imSideActions {
    url
  }
  imPartingLine {
    url
  }
}
    `;
export const JobBoardRegion_ItemsFragmentDoc = gql`
    fragment JobBoardRegion_Items on JobBoardRegion {
  acceptNowMultiplier
  endTime
  id
  maxThresholdOfPayout
  name
  startTime
  timezone
  active
  jobDuration
}
    `;
export const AdminQueueModelConfigurationFragmentDoc = gql`
    fragment adminQueueModelConfiguration on ModelConfiguration {
  id
  process {
    id
    name
    platformProcessTypeId
  }
  material {
    ... on Material {
      id
      name
    }
    ... on UserEnteredMaterial {
      id
      name
      process {
        id
        name
      }
    }
  }
  color {
    id
    name
  }
  shore {
    id
    name
  }
  texture {
    id
    name
  }
  productionLeadTime {
    id
    priorityId
    productionDays
    shipDateEstimate {
      id
      validUntilDate
      shippedByDate
    }
  }
  quantity
}
    `;
export const AdminQuoteModelRevisionQueueItemFragmentDoc = gql`
    fragment adminQuoteModelRevisionQueueItem on QuoteModelRevision {
  id
  fileName
  modelConfiguration {
    ...adminQueueModelConfiguration
  }
  quoteModel {
    id
    quote {
      id
      name
      status
      lastModified
      requestedAt
      requestedBy
      partialSubTotalInCents
      numberOfParts(showDeleted: false)
      quoteProperties {
        name
        value
      }
      user {
        id
      }
    }
  }
}
    ${AdminQueueModelConfigurationFragmentDoc}`;
export const QmrItemFragmentDoc = gql`
    fragment QMRItem on QuoteItem {
  quoteModelRevision {
    isITARProhibitedViewing
    fileName
    id
    processesDetails {
      primaryProcess {
        process {
          platformProcessTypeId
        }
      }
      postProcesses {
        postProcess {
          name
        }
      }
      secondaryProcesses {
        process {
          name
        }
      }
      totalPrice {
        ... on ExactPrice {
          priceInCents
          unitPriceInCents
        }
      }
    }
    modelConfiguration {
      productionLeadTime {
        productionDays
      }
      quantity
    }
  }
}
    `;
export const BuilderImModelConfigurationFragmentDoc = gql`
    fragment builderImModelConfiguration on ModelConfiguration {
  id
  material {
    ... on Material {
      id
      name
    }
    ... on UserEnteredMaterial {
      id
      name
      process {
        id
        name
      }
    }
  }
  materialGrade
  color {
    id
    name
  }
  shore {
    id
    name
  }
  colorCode
  texture {
    id
    name
  }
  textureCode
  hasMultipleFinishes
  userNeedsConfigHelp
  productionLeadTime {
    id
    priorityId
    productionDays
    shipDateEstimate {
      id
      validUntilDate
      shippedByDate
    }
  }
  quantity
}
    `;
export const QlltOptionFragmentDoc = gql`
    fragment QlltOption on QuoteLevelLeadTimeAndPriceOption {
  leadTimes
  shipByDate
  shippingOptions {
    shippingOptionId
    name
    deliveredByDate
  }
  subTotalInCents
}
    `;
export const Im_Quote_Cost_And_Lead_Time_PreferencesFragmentDoc = gql`
    fragment im_quote_cost_and_lead_time_preferences on ImQuotePreference {
  label
  name
  value
}
    `;
export const QuoteImProjectRequirements_Quote_ImQuoteRequirements_PreferencesFragmentDoc = gql`
    fragment QuoteImProjectRequirements_Quote_ImQuoteRequirements_Preferences on ImQuotePreference {
  label
  name
  value
}
    `;
export const QuoteImProjectRequirements_Quote_ImQuoteRequirements_ProductionRateForecastFragmentDoc = gql`
    fragment QuoteImProjectRequirements_Quote_ImQuoteRequirements_ProductionRateForecast on ProductionRateForecast {
  quantity
  timeScale
}
    `;
export const QmrDfmFeedback_QuoteModelRevisionFragmentDoc = gql`
    fragment QmrDfmFeedback_QuoteModelRevision on QuoteModelRevision {
  id
  dfmFeedback {
    id
    severity
    accepted
    message
    title
    link
    modelViewerSnapshots {
      id
      position
      target
      feature
      type
      snapshot {
        camera {
          zoom
          position
          up
          target
        }
        dfm {
          feature
          threshold
          direction
        }
        annotations {
          position
        }
        rotation
        part {
          transparent
          patches {
            color
            hashcode
          }
        }
        crossSection {
          position
          rotation
        }
        pointToPoint {
          customPoints
          selectedPoints {
            index
            type
          }
        }
      }
      createdAt
      updatedAt
      deletedAt
    }
  }
  processesDetails {
    totalPrice {
      ... on ExactPrice {
        priceInCents
        unitPriceInCents
      }
      ... on EstimatedPrice {
        lowPriceInCents
        lowUnitPriceInCents
        highPriceInCents
        highUnitPriceInCents
      }
    }
  }
}
    `;
export const QuoteDetails_Quote_PlatformOrderFragmentDoc = gql`
    fragment QuoteDetails_Quote_PlatformOrder on PlatformOrder {
  id
  name
  purchaserEmail
  purchasedDate
  purchaserUserId
}
    `;
export const QuoteDetails_Quote_UserFragmentDoc = gql`
    fragment QuoteDetails_Quote_User on BasicUser {
  id
  email
}
    `;
export const QuoteDetails_Quote_BusinessAccountDiscountFragmentDoc = gql`
    fragment QuoteDetails_Quote_BusinessAccountDiscount on BusinessAccountDiscount {
  id
  percent
  isActive
  endAt
}
    `;
export const QuoteDetails_Quote_Attachments_Item_LatestAttachmentRevision_AttachmentFragmentDoc = gql`
    fragment QuoteDetails_Quote_Attachments_Item_LatestAttachmentRevision_Attachment on Attachment {
  id
  fileName
  downloadUrl
  annotated {
    id
    fileName
    downloadUrl
  }
  sanitized {
    id
    fileName
    downloadUrl
  }
}
    `;
export const QuoteDetails_Quote_Attachments_Item_LatestAttachmentRevisionFragmentDoc = gql`
    fragment QuoteDetails_Quote_Attachments_Item_LatestAttachmentRevision on QuoteAttachmentRevision {
  id
  attachment {
    ...QuoteDetails_Quote_Attachments_Item_LatestAttachmentRevision_Attachment
  }
}
    ${QuoteDetails_Quote_Attachments_Item_LatestAttachmentRevision_AttachmentFragmentDoc}`;
export const QuoteDetails_Quote_Attachments_ItemFragmentDoc = gql`
    fragment QuoteDetails_Quote_Attachments_Item on QuoteAttachment {
  id
  latestAttachmentRevision {
    ...QuoteDetails_Quote_Attachments_Item_LatestAttachmentRevision
  }
}
    ${QuoteDetails_Quote_Attachments_Item_LatestAttachmentRevisionFragmentDoc}`;
export const QuoteDetails_Quote_AttachmentsFragmentDoc = gql`
    fragment QuoteDetails_Quote_Attachments on PartialQuoteAttachmentResults {
  totalCount
  items {
    ...QuoteDetails_Quote_Attachments_Item
  }
}
    ${QuoteDetails_Quote_Attachments_ItemFragmentDoc}`;
export const QuoteDetails_Quote_QuoteModels_Item_QuoteModelRevisionFragmentDoc = gql`
    fragment QuoteDetails_Quote_QuoteModels_Item_QuoteModelRevision on QuoteModelRevision {
  id
  dfmReports {
    asset {
      id
      fileName
      downloadUrl
      createdAt
    }
    isPublished
    source
    uploaderEmail
  }
}
    `;
export const QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_QuoteModel_QuoteFragmentDoc = gql`
    fragment QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_QuoteModel_Quote on Quote {
  id
  type
}
    `;
export const QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_QuoteModelFragmentDoc = gql`
    fragment QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_QuoteModel on QuoteModel {
  id
  quote {
    ...QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_QuoteModel_Quote
  }
}
    ${QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_QuoteModel_QuoteFragmentDoc}`;
export const QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_TapFragmentDoc = gql`
    fragment QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_Tap on TapAnnotation {
  id
}
    `;
export const QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_DfmFeedbackFragmentDoc = gql`
    fragment QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_DfmFeedback on DfmFeedback {
  id
  accepted
  severity
  message
  title
  isPublished
}
    `;
export const QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetails_PostProcessFragmentDoc = gql`
    fragment QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetails_PostProcess on QmrPostProcessWithPriceAndLead {
  postProcess {
    id
    name
    typeName
  }
  unitPriceInCents
  postProcessLeadTimeInDays
  postProcessThickness {
    id
    name
  }
  postProcessColor {
    id
    name
  }
  postProcessNumParts
  postProcessInspectionCriteria
}
    `;
export const QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetails_SecondaryProcessFragmentDoc = gql`
    fragment QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetails_SecondaryProcess on QmrSecondaryProcessDetails {
  process {
    id
    name
    typeName
  }
  unitPriceInCents
  leadTimeInDays
  notes
  pricingAndLeadTimeFields {
    ... on SecondaryProcessManualQuoteCalcFields {
      international {
        markupPercentage
        mpPayoutInCents
        mpPayoutPartsLimit
        leadTimeInDays
        leadTimePartsLimit
      }
      domestic {
        mpPayoutInCents
        markupPercentage
        mpPayoutPartsLimit
        leadTimeInDays
        leadTimePartsLimit
      }
    }
    ... on HardwareInstallationManualQuoteCalcFields {
      international {
        markupPercentage
        mpPayoutInCents
        mpPayoutPartsLimit
        leadTimeInDays
        leadTimePartsLimit
      }
      domestic {
        mpPayoutInCents
        markupPercentage
        mpPayoutPartsLimit
        leadTimeInDays
        leadTimePartsLimit
      }
      lineItems {
        supplier
        partNumber
        qtyPerPart
        pricePerPack
        qtyPerPack
      }
    }
  }
}
    `;
export const QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetails_TotalPrice_ExactPriceFragmentDoc = gql`
    fragment QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetails_TotalPrice_ExactPrice on ExactPrice {
  priceInCents
  unitPriceInCents
}
    `;
export const QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetails_TotalPrice_EstimatedPriceFragmentDoc = gql`
    fragment QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetails_TotalPrice_EstimatedPrice on EstimatedPrice {
  lowPriceInCents
  lowUnitPriceInCents
  highPriceInCents
  highUnitPriceInCents
}
    `;
export const QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetails_TotalPriceFragmentDoc = gql`
    fragment QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetails_TotalPrice on Price {
  ... on ExactPrice {
    ...QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetails_TotalPrice_ExactPrice
  }
  ... on EstimatedPrice {
    ...QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetails_TotalPrice_EstimatedPrice
  }
}
    ${QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetails_TotalPrice_ExactPriceFragmentDoc}
${QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetails_TotalPrice_EstimatedPriceFragmentDoc}`;
export const QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetailsFragmentDoc = gql`
    fragment QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetails on QmrProcessesDetails {
  isBusinessAccountDiscountApplied
  primaryProcess {
    process {
      id
      name
      platformProcessTypeId
    }
    price {
      ... on ExactPrice {
        priceInCents
        unitPriceInCents
      }
      ... on EstimatedPrice {
        lowPriceInCents
        lowUnitPriceInCents
        highPriceInCents
        highUnitPriceInCents
      }
    }
  }
  postProcesses {
    ...QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetails_PostProcess
  }
  secondaryProcesses {
    ...QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetails_SecondaryProcess
  }
  totalPrice {
    ...QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetails_TotalPrice
  }
}
    ${QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetails_PostProcessFragmentDoc}
${QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetails_SecondaryProcessFragmentDoc}
${QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetails_TotalPriceFragmentDoc}`;
export const QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_PartRevision_BoundingBoxFragmentDoc = gql`
    fragment QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_PartRevision_BoundingBox on Vector3 {
  x
  y
  z
}
    `;
export const QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_PartRevisionFragmentDoc = gql`
    fragment QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_PartRevision on Revision {
  id
  analysisErrorCode
  downloadUri
  modelFileName
  status
  sceneBundle
  thumbnailUri
  updatedAt
  boundingBox {
    ...QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_PartRevision_BoundingBox
  }
}
    ${QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_PartRevision_BoundingBoxFragmentDoc}`;
export const QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_AttachmentLinkFragmentDoc = gql`
    fragment QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_AttachmentLink on QuoteModelRevisionAttachment {
  id
  createdAt
  isPdfOcrAutoQuotable
  quoteAttachmentRevision {
    id
    attachment {
      ... on Attachment {
        id
        fileName
        downloadUrl
        annotated {
          id
          fileName
          downloadUrl
        }
        sanitized {
          id
          fileName
          downloadUrl
        }
      }
    }
  }
}
    `;
export const QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ModelConfiguration_ProcessFragmentDoc = gql`
    fragment QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ModelConfiguration_Process on Process {
  id
  name
  platformProcessTypeId
}
    `;
export const QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ModelConfiguration_Material_MaterialFragmentDoc = gql`
    fragment QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ModelConfiguration_Material_Material on Material {
  id
  name
  materialCategory
}
    `;
export const QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ModelConfigurationFragmentDoc = gql`
    fragment QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ModelConfiguration on ModelConfiguration {
  id
  process {
    ...QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ModelConfiguration_Process
  }
  material {
    ... on Material {
      ...QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ModelConfiguration_Material_Material
    }
    ... on UserEnteredMaterial {
      id
      name
      process {
        id
        name
      }
    }
  }
  materialGrade
  color {
    id
    name
  }
  colorCode
  shore {
    id
    name
  }
  texture {
    id
    name
  }
  textureCode
  hasMultipleFinishes
  userNeedsConfigHelp
  productionLeadTime {
    id
    priorityId
    productionDays
    primaryProductionDays
    shipDateEstimate {
      id
      validUntilDate
      shippedByDate
    }
  }
  quantity
  requiresOvermold
  additionalRequirements
  fdmInfillPercentageCategory
  fdmInfillPercentageCategoryLabel
}
    ${QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ModelConfiguration_ProcessFragmentDoc}
${QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ModelConfiguration_Material_MaterialFragmentDoc}`;
export const QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevisionFragmentDoc = gql`
    fragment QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision on QuoteModelRevision {
  isITARProhibitedViewing
  id
  quantityRangeStatus
  createdAt
  fileName
  state
  updatedAt
  version
  supportedPriorityRegions {
    partSupportsDomestic
    partSupportsInternational
  }
  dfmReports {
    quoteAttachmentRevisionId
    asset {
      id
      createdAt
      downloadUrl
      fileName
    }
    isPublished
    uploaderEmail
    source
  }
  modelConfiguration {
    fdmInfillPercentageCategory
    fdmInfillPercentageCategoryLabel
    dfmInspection {
      id
      isPublished
      manualOverrideMpUnitPayout
      manualOverrideUnitAmount
      manualOverrideUnitProductionDays
      inspectionData
      updatedBy {
        id
      }
      quotedBy {
        id
      }
      quoteUpdatedBy {
        id
      }
    }
  }
  quoteModel {
    ...QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_QuoteModel
  }
  annotations {
    id
  }
  taps {
    ...QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_Tap
  }
  holes {
    id
    groupKey
    patches {
      id
    }
    tapOptions {
      id
    }
    tapAnnotation {
      id
      depth
      tapOption {
        id
      }
    }
  }
  dfmFeedback {
    ...QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_DfmFeedback
  }
  processesDetails {
    ...QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetails
  }
  partRevision {
    ...QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_PartRevision
  }
  attachmentLink {
    ...QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_AttachmentLink
  }
  modelConfiguration {
    ...QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ModelConfiguration
  }
  mold {
    id
    name @include(if: $isImMaafcoEnabled)
    leadTimeDays
    customerToolName @include(if: $isImMaafcoEnabled)
    material {
      id
      name
    }
    price {
      priceInCents
    }
    toolLife
    uiIndex
    moldToolRevisionQmr @include(if: $isImMaafcoEnabled) {
      moldToolRevisionId
      quoteModelRevisionId
      cavityPerPart
    }
  }
  drawingRequirements
}
    ${QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_QuoteModelFragmentDoc}
${QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_TapFragmentDoc}
${QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_DfmFeedbackFragmentDoc}
${QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ProcessesDetailsFragmentDoc}
${QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_PartRevisionFragmentDoc}
${QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_AttachmentLinkFragmentDoc}
${QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_ModelConfigurationFragmentDoc}`;
export const QuoteDetails_Quote_QuoteModels_ItemFragmentDoc = gql`
    fragment QuoteDetails_Quote_QuoteModels_Item on QuoteModel {
  id
  quoteModelRevisions {
    ...QuoteDetails_Quote_QuoteModels_Item_QuoteModelRevision
  }
  selectedQuoteModelRevision {
    ...QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision
  }
}
    ${QuoteDetails_Quote_QuoteModels_Item_QuoteModelRevisionFragmentDoc}
${QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevisionFragmentDoc}`;
export const QuoteDetails_Quote_QuoteModelsFragmentDoc = gql`
    fragment QuoteDetails_Quote_QuoteModels on PartialQuoteModelResults {
  totalCount
  items {
    ...QuoteDetails_Quote_QuoteModels_Item
  }
}
    ${QuoteDetails_Quote_QuoteModels_ItemFragmentDoc}`;
export const QuoteDetails_Quote_DfmAssets_ItemFragmentDoc = gql`
    fragment QuoteDetails_Quote_DfmAssets_Item on Asset {
  id
  fileName
  downloadUrl
}
    `;
export const QuoteDetails_Quote_DfmAssetsFragmentDoc = gql`
    fragment QuoteDetails_Quote_DfmAssets on PartialAssetResults {
  totalCount
  items {
    ...QuoteDetails_Quote_DfmAssets_Item
  }
}
    ${QuoteDetails_Quote_DfmAssets_ItemFragmentDoc}`;
export const QuoteDetails_QuoteFragmentDoc = gql`
    fragment QuoteDetails_Quote on Quote {
  id
  type
  isLocked
  isQuoteInRfqState
  isQuotePurchasable
  isQuoteIMReorder
  lastModified
  name
  platformOrder {
    ...QuoteDetails_Quote_PlatformOrder
  }
  purchaseInfo {
    purchaserEmail
    purchasedDate
    purchaserUserId
  }
  orderName
  needByDate
  notesToCustomer
  slowestShipDateEstimate
  isOverseasShipping
  earliestValidUntilDate
  status
  subTotalInCents
  reorderSourceOrderName
  deletedAt
  beganCheckoutAt
  zipCode
  isTaxExempt
  numberOfParts
  partsSummary
  expiration
  isExpired
  depositInCents
  productionPartsSubtotalInCents
  moldToolSubtotalInCents
  isEligibleForFreeShipping
  isMoldRepair
  user {
    ...QuoteDetails_Quote_User
  }
  team {
    id
    name
  }
  businessAccountDiscount {
    ...QuoteDetails_Quote_BusinessAccountDiscount
  }
  quoteAttachments(limit: 1000) {
    ...QuoteDetails_Quote_Attachments
  }
  quoteModels(limit: 1000) {
    ...QuoteDetails_Quote_QuoteModels
  }
  project {
    id
    isSecurePlus
    name
  }
  dfmAssets(limit: 1000) {
    ...QuoteDetails_Quote_DfmAssets
  }
}
    ${QuoteDetails_Quote_PlatformOrderFragmentDoc}
${QuoteDetails_Quote_UserFragmentDoc}
${QuoteDetails_Quote_BusinessAccountDiscountFragmentDoc}
${QuoteDetails_Quote_AttachmentsFragmentDoc}
${QuoteDetails_Quote_QuoteModelsFragmentDoc}
${QuoteDetails_Quote_DfmAssetsFragmentDoc}`;
export const PunchoutSessionDataFragmentDoc = gql`
    fragment PunchoutSessionData on PunchoutSession {
  businessAccountId
  buyerCookie
  disabledProcesses
  orderUrl
  buyerEmail
  expireAt
  sessionId
}
    `;
export const OrderActivityQuoteItemQmrFragmentDoc = gql`
    fragment OrderActivityQuoteItemQmr on QuoteItem {
  quoteModelRevision {
    id
    fileName
  }
}
    `;
export const OrderActivityItemFragmentDoc = gql`
    fragment OrderActivityItem on ProjectActivity {
  id
  createdAt
  meta
  summary
  targetId
  actor {
    id
    email
  }
  quote {
    quoteItems {
      items {
        ...OrderActivityQuoteItemQmr
      }
    }
  }
}
    ${OrderActivityQuoteItemQmrFragmentDoc}`;
export const QuoteActivityQuoteItemQmrFragmentDoc = gql`
    fragment QuoteActivityQuoteItemQmr on QuoteItem {
  quoteModelRevision {
    id
    fileName
  }
}
    `;
export const QuoteActivityItemFragmentDoc = gql`
    fragment QuoteActivityItem on ProjectActivity {
  id
  createdAt
  meta
  summary
  targetId
  actor {
    id
    email
  }
  quote {
    quoteItems {
      items {
        ...QuoteActivityQuoteItemQmr
      }
    }
  }
}
    ${QuoteActivityQuoteItemQmrFragmentDoc}`;
export const TeamSpendByTimeItemFragmentDoc = gql`
    fragment TeamSpendByTimeItem on TeamSpendByTimeResult {
  spend
  actualSaving
  potentialSavings
  count
  timePeriod
}
    `;
export const WorkspaceMemberFragmentDoc = gql`
    fragment WorkspaceMember on UserTeamMember {
  displayName
  id
  email
  memberType
  teamId
}
    `;
export const TeamMemberFragmentDoc = gql`
    fragment TeamMember on UserTeamMember {
  id
  email
  displayName
  firstName
  lastName
  enabled
  isTeamMember
  isRequest
  createdAt
  joinedDate
  isSelfRequest
  memberType
  requestId
  teamId
}
    `;
export const UserAchAccountsItemFragmentDoc = gql`
    fragment UserAchAccountsItem on AchAccount {
  id
  referenceId
  achAccount {
    last4
    bankName
  }
}
    `;
export const AdminModelConfigurationFragmentDoc = gql`
    fragment AdminModelConfiguration on ModelConfiguration {
  id
  requiresOvermold
  additionalRequirements
  dfmInspections {
    id
    inspectionData
    quantityLowerRange
    quantityUpperRange
    isQuantityRangeAvailable
    isPublished
    manualOverrideMpUnitPayout
    manualOverrideUnitAmount
    quotedBy {
      id
      displayName
    }
    quotedAt
    quoteUpdatedBy {
      id
      displayName
    }
    quoteUpdatedAt
    updatedAt
  }
  dfmInspection {
    id
    inspectionData
    isPublished
    quotedBy {
      id
      displayName
    }
    quotedAt
    quoteUpdatedBy {
      id
      displayName
    }
    quoteUpdatedAt
    updatedAt
    manualOverrideMpUnitPayout
    manualOverrideUnitAmount
  }
  productionLeadTime {
    id
    priorityId
    productionDays
    primaryProductionDays
    shipDateEstimate {
      id
      validUntilDate
      shippedByDate
    }
  }
  process {
    id
    name
  }
  material {
    __typename
    ... on Material {
      id
      name
      materialCategory
    }
    ... on UserEnteredMaterial {
      id
      name
    }
  }
  materialGrade
  color {
    id
    name
  }
  colorCode
  texture {
    id
    name
  }
  textureCode
  quantity
  errorCode
  updatedAt
  updatedBy {
    id
    email
    updatedAt
  }
  toolDetails {
    totalCost
    tools {
      id
      type
      diameter
      length
      ratio
      price
    }
  }
}
    `;
export const AdminSearchSalesforceAccountItemFragmentDoc = gql`
    fragment AdminSearchSalesforceAccountItem on SalesforceAccount {
  id
  name
  totalContacts
  hasBusinessAccount
}
    `;
export const BuilderModelConfigurationFragmentDoc = gql`
    fragment BuilderModelConfiguration on ModelConfiguration {
  id
  process {
    id
    name
    platformProcessTypeId
  }
  material {
    ... on Material {
      id
      name
    }
    ... on UserEnteredMaterial {
      id
      name
      process {
        id
        name
      }
    }
  }
  color {
    id
    name
  }
  shore {
    id
    name
  }
  texture {
    id
    name
  }
  productionLeadTime {
    id
    priorityId
    productionDays
    shipDateEstimate {
      id
      validUntilDate
      shippedByDate
    }
  }
  quantity
  additionalRequirements
  fdmInfillPercentageCategory
  fdmInfillPercentageCategoryLabel
}
    `;
export const CarrierAccountFragmentDoc = gql`
    fragment CarrierAccount on TplCarrierAccount {
  id
  name
  provider
  accountNumber
  country
  postalCode
  createdAt
  updatedAt
}
    `;
export const UserCreditCardsItemFragmentDoc = gql`
    fragment UserCreditCardsItem on CreditCard {
  id
  referenceId
  card {
    last4
    brand
  }
}
    `;
export const DfmFeedbackFragmentDoc = gql`
    fragment DfmFeedback on DfmFeedback {
  id
  isValid
  message
  title
  link
  code
  isPublished
  severity
  sourceType
  isAutoGeneratedDfm
  createdBy {
    displayName
    email
  }
  modelViewerSnapshots {
    id
    snapshot {
      camera {
        position
        zoom
        up
        target
      }
      part {
        transparent
        patches {
          color
          hashcode
        }
      }
      rotation
      dfm {
        color
        threshold
        feature
        direction
      }
      annotations {
        position
      }
      crossSection {
        position
        rotation
      }
      pointToPoint {
        customPoints
        selectedPoints {
          index
          type
        }
      }
    }
  }
  createdAt
  deletedAt
}
    `;
export const IsoCountryFragmentDoc = gql`
    fragment ISOCountry on Country {
  id
  name
}
    `;
export const MaterialsDropdownFdmInfillOptionFragmentDoc = gql`
    fragment MaterialsDropdownFdmInfillOption on FdmInfillOption {
  optionName
  optionLabelCustomer
  isDefault
}
    `;
export const MaterialsDropdownMaterialFragmentDoc = gql`
    fragment MaterialsDropdownMaterial on Material {
  id
  name
  materialCategory
  fdmInfillOptions {
    ...MaterialsDropdownFdmInfillOption
  }
}
    ${MaterialsDropdownFdmInfillOptionFragmentDoc}`;
export const PaymentOptionFragmentDoc = gql`
    fragment PaymentOption on CreditCard {
  id
  referenceId
  card {
    id
    brand
    expMonth
    expYear
    last4
  }
}
    `;
export const ProcessesDetailsFragmentDoc = gql`
    fragment ProcessesDetails on QmrProcessesDetails {
  totalPrice {
    ... on EstimatedPrice {
      lowPriceInCents
      lowUnitPriceInCents
      highPriceInCents
      highUnitPriceInCents
    }
    ... on ExactPrice {
      priceInCents
      unitPriceInCents
    }
  }
  primaryProcess {
    process {
      id
      name
      platformProcessTypeId
    }
    price {
      ... on EstimatedPrice {
        lowPriceInCents
        lowUnitPriceInCents
        highPriceInCents
        highUnitPriceInCents
      }
      ... on ExactPrice {
        priceInCents
        unitPriceInCents
      }
    }
  }
  postProcesses {
    unitPriceInCents
    postProcessLeadTimeInDays
    postProcessNumParts
    postProcessInspectionCriteria
    postProcess {
      id
      name
      typeName
      colors {
        id
        name
      }
      thicknesses {
        id
        name
        value
      }
    }
    postProcessThickness {
      id
      name
    }
    postProcessColor {
      id
      name
    }
  }
  secondaryProcesses {
    process {
      id
      name
      typeName
    }
    unitPriceInCents
    leadTimeInDays
    notes
    pricingAndLeadTimeFields {
      ... on SecondaryProcessManualQuoteCalcFields {
        international {
          markupPercentage
          mpPayoutInCents
          mpPayoutPartsLimit
          leadTimeInDays
          leadTimePartsLimit
        }
        domestic {
          mpPayoutInCents
          markupPercentage
          mpPayoutPartsLimit
          leadTimeInDays
          leadTimePartsLimit
        }
      }
      ... on HardwareInstallationManualQuoteCalcFields {
        international {
          markupPercentage
          mpPayoutInCents
          mpPayoutPartsLimit
          leadTimeInDays
          leadTimePartsLimit
        }
        domestic {
          mpPayoutInCents
          markupPercentage
          mpPayoutPartsLimit
          leadTimeInDays
          leadTimePartsLimit
        }
        lineItems {
          supplier
          partNumber
          qtyPerPart
          pricePerPack
          qtyPerPack
        }
      }
    }
  }
  isBusinessAccountDiscountApplied
}
    `;
export const QlltWithShippingOptionsOptionFragmentDoc = gql`
    fragment QlltWithShippingOptionsOption on QuoteLevelLeadTimeAndPriceOption {
  leadTimes
  shipByDate
  shippingOptions {
    shippingOptionId
    name
    deliveredByDate
  }
  subTotalInCents
}
    `;
export const QlltWithShippingOptionsResultFragmentDoc = gql`
    fragment QlltWithShippingOptionsResult on QuoteLevelLeadTimesAndPrices {
  domesticFastest {
    ...QlltWithShippingOptionsOption
  }
  domesticStandard {
    ...QlltWithShippingOptionsOption
  }
  domesticCostEffective {
    ...QlltWithShippingOptionsOption
  }
  overseasFastest {
    ...QlltWithShippingOptionsOption
  }
  overseasStandard {
    ...QlltWithShippingOptionsOption
  }
  overseasCostEffective {
    ...QlltWithShippingOptionsOption
  }
}
    ${QlltWithShippingOptionsOptionFragmentDoc}`;
export const ShippingAddressesItemFragmentDoc = gql`
    fragment ShippingAddressesItem on UserShippingAddress {
  id
  name
  company
  street
  aptNumber
  city
  state
  zip
  phone
  country
  createdAt
  isVerified
  isDefault
  timezone
}
    `;
export const UserTeamFragmentDoc = gql`
    fragment UserTeam on Team {
  name
  id
}
    `;
export const QuoteDetailsQueryForShippingCalculatorQuoteModelItemFragmentDoc = gql`
    fragment QuoteDetailsQueryForShippingCalculatorQuoteModelItem on QuoteModel {
  id
  selectedQuoteModelRevision {
    id
    fileName
    partRevision {
      id
      downloadUri
      modelFileName
      thumbnailUri
    }
    modelConfiguration {
      id
      material {
        ... on Material {
          id
          name
        }
      }
      quantity
    }
  }
}
    `;
export const QuoteDetailsQueryForShippingCalculatorQuoteFragmentDoc = gql`
    fragment QuoteDetailsQueryForShippingCalculatorQuote on Quote {
  id
  name
  weights(shippingCalculatorOverrides: $shippingCalculatorOverrides) {
    actualWeight
    shippingWeight
    dimensionalWeight
  }
  quoteModels(limit: 1000) {
    totalCount
    items {
      ...QuoteDetailsQueryForShippingCalculatorQuoteModelItem
    }
  }
}
    ${QuoteDetailsQueryForShippingCalculatorQuoteModelItemFragmentDoc}`;
export const AdditionalRequirementsRawPdfOcrDataFragmentDoc = gql`
    fragment AdditionalRequirementsRawPdfOcrData on RawPdfOcrJson {
  numTightTolerances
  numVeryTightTolerances
  requiresCertificateOfConformance
  requiresMaterialCertificate
  autoQuotableBlockers
  finishingNotesWithBoundingBoxes {
    boundingBox
    text
  }
  finishingNotes
}
    `;
export const AdminUserRolesFragmentDoc = gql`
    fragment AdminUserRoles on User {
  id
  roles {
    id
    name
  }
}
    `;
export const BuilderConfigurablePostProcessesDataFragmentDoc = gql`
    fragment BuilderConfigurablePostProcessesData on PostProcess {
  id
  name
  typeName
  colors {
    id
    name
  }
  thicknesses {
    id
    name
    value
  }
}
    `;
export const ProcessTextureFragmentDoc = gql`
    fragment ProcessTexture on Texture {
  id
  name
  category
}
    `;
export const QuoteDetailsCheckoutShippingOptionsItemFragmentDoc = gql`
    fragment QuoteDetailsCheckoutShippingOptionsItem on QuoteShippingOptionItemType {
  cost
  deliveredByDate
  deliveryDays
  id
  name
  productionPartsCost
  quoteToken
  samplesCost
}
    `;
export const QuoteDetailsCheckoutFragmentDoc = gql`
    fragment QuoteDetailsCheckout on Quote {
  id
  name
  isEligibleForFreeShipping
  earliestValidUntilDate
  type
  numberOfParts
  partsSummary
  expiration
  isQuotePurchasable
  isOverseasShipping
  isQuoteIMReorder
  isTaxExempt
  isCpqOwned
  isCpqQuote @include(if: $isCpqFlagV2Enabled)
  cpqQuote @include(if: $isCpqFlagV2Enabled) {
    sfdcId
    platformQuote {
      id
    }
    quotePdfUrl
    orderTotal
    partsCount
    moldCount
    orderQuantity
  }
  businessAccountDiscount {
    id
    percent
    isActive
    endAt
  }
  weights {
    shippingWeight
  }
  team {
    id
    name
  }
  subTotalInCents
  slowestShipDateEstimate
  shippingOptionsNew(address: $address, carrier: $carrier) {
    items {
      ...QuoteDetailsCheckoutShippingOptionsItem
    }
  }
  moldToolSubtotalInCents
  productionPartsSubtotalInCents
  molds {
    id
  }
  quoteModels(limit: 1000) {
    totalCount
    items {
      selectedQuoteModelRevision {
        isITARProhibitedViewing
        id
      }
    }
  }
  user {
    id
  }
}
    ${QuoteDetailsCheckoutShippingOptionsItemFragmentDoc}`;
export const QuotePricePreviewDataFragmentDoc = gql`
    fragment QuotePricePreviewData on QuotePricePreview {
  subTotalAmountInCents
  taxAmountInCents
  shippingAmountInCents
  totalAmountInCents
  discountPercent
  discountAmountInCents
  discountErrorMessage
  samplesShippingAmountInCents
  depositAmountInCents
}
    `;
export const VerifiedAddressFragmentDoc = gql`
    fragment VerifiedAddress on ShippingAddress {
  id
  street1
  street2
  city
  state
  zip
  phone
  name
  company
  country
  delivery
}
    `;
export const ApplyAutoconfigurationDocument = gql`
    mutation applyAutoconfiguration($id: UUID!, $quoteModelRevisionId: UUID!) {
  autoConfigurePart(quoteId: $id, quoteModelRevisionId: $quoteModelRevisionId)
}
    `;
export type ApplyAutoconfigurationMutationFn = Apollo.MutationFunction<ApplyAutoconfigurationMutation, ApplyAutoconfigurationMutationVariables>;

/**
 * __useApplyAutoconfigurationMutation__
 *
 * To run a mutation, you first call `useApplyAutoconfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyAutoconfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyAutoconfigurationMutation, { data, loading, error }] = useApplyAutoconfigurationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *   },
 * });
 */
export function useApplyAutoconfigurationMutation(baseOptions?: Apollo.MutationHookOptions<ApplyAutoconfigurationMutation, ApplyAutoconfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyAutoconfigurationMutation, ApplyAutoconfigurationMutationVariables>(ApplyAutoconfigurationDocument, options);
      }
export type ApplyAutoconfigurationMutationHookResult = ReturnType<typeof useApplyAutoconfigurationMutation>;
export type ApplyAutoconfigurationMutationResult = Apollo.MutationResult<ApplyAutoconfigurationMutation>;
export type ApplyAutoconfigurationMutationOptions = Apollo.BaseMutationOptions<ApplyAutoconfigurationMutation, ApplyAutoconfigurationMutationVariables>;
export const AutoconfigurationDocument = gql`
    query Autoconfiguration($quoteId: UUID!) {
  autoConfiguration(quoteId: $quoteId) {
    ...AutoconfigurationItem
  }
}
    ${AutoconfigurationItemFragmentDoc}`;

/**
 * __useAutoconfigurationQuery__
 *
 * To run a query within a React component, call `useAutoconfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutoconfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutoconfigurationQuery({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useAutoconfigurationQuery(baseOptions: Apollo.QueryHookOptions<AutoconfigurationQuery, AutoconfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutoconfigurationQuery, AutoconfigurationQueryVariables>(AutoconfigurationDocument, options);
      }
export function useAutoconfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutoconfigurationQuery, AutoconfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutoconfigurationQuery, AutoconfigurationQueryVariables>(AutoconfigurationDocument, options);
        }
export type AutoconfigurationQueryHookResult = ReturnType<typeof useAutoconfigurationQuery>;
export type AutoconfigurationLazyQueryHookResult = ReturnType<typeof useAutoconfigurationLazyQuery>;
export type AutoconfigurationQueryResult = Apollo.QueryResult<AutoconfigurationQuery, AutoconfigurationQueryVariables>;
export function refetchAutoconfigurationQuery(variables: AutoconfigurationQueryVariables) {
      return { query: AutoconfigurationDocument, variables: variables }
    }
export const RequestBusinessAccountInvitesDocument = gql`
    mutation requestBusinessAccountInvites($businessAccountId: UUID!, $emails: [String!]!) {
  requestBusinessAccountInvites(
    businessAccountId: $businessAccountId
    emails: $emails
  ) {
    email
    invite {
      id
      email
      inviteUrl
      sentDate
      status
    }
    failureReason
  }
}
    `;
export type RequestBusinessAccountInvitesMutationFn = Apollo.MutationFunction<RequestBusinessAccountInvitesMutation, RequestBusinessAccountInvitesMutationVariables>;

/**
 * __useRequestBusinessAccountInvitesMutation__
 *
 * To run a mutation, you first call `useRequestBusinessAccountInvitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestBusinessAccountInvitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestBusinessAccountInvitesMutation, { data, loading, error }] = useRequestBusinessAccountInvitesMutation({
 *   variables: {
 *      businessAccountId: // value for 'businessAccountId'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useRequestBusinessAccountInvitesMutation(baseOptions?: Apollo.MutationHookOptions<RequestBusinessAccountInvitesMutation, RequestBusinessAccountInvitesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestBusinessAccountInvitesMutation, RequestBusinessAccountInvitesMutationVariables>(RequestBusinessAccountInvitesDocument, options);
      }
export type RequestBusinessAccountInvitesMutationHookResult = ReturnType<typeof useRequestBusinessAccountInvitesMutation>;
export type RequestBusinessAccountInvitesMutationResult = Apollo.MutationResult<RequestBusinessAccountInvitesMutation>;
export type RequestBusinessAccountInvitesMutationOptions = Apollo.BaseMutationOptions<RequestBusinessAccountInvitesMutation, RequestBusinessAccountInvitesMutationVariables>;
export const FictivHolidaysDocument = gql`
    query fictivHolidays {
  fictivHolidays {
    ...FictivHolidayItem
  }
}
    ${FictivHolidayItemFragmentDoc}`;

/**
 * __useFictivHolidaysQuery__
 *
 * To run a query within a React component, call `useFictivHolidaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useFictivHolidaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFictivHolidaysQuery({
 *   variables: {
 *   },
 * });
 */
export function useFictivHolidaysQuery(baseOptions?: Apollo.QueryHookOptions<FictivHolidaysQuery, FictivHolidaysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FictivHolidaysQuery, FictivHolidaysQueryVariables>(FictivHolidaysDocument, options);
      }
export function useFictivHolidaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FictivHolidaysQuery, FictivHolidaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FictivHolidaysQuery, FictivHolidaysQueryVariables>(FictivHolidaysDocument, options);
        }
export type FictivHolidaysQueryHookResult = ReturnType<typeof useFictivHolidaysQuery>;
export type FictivHolidaysLazyQueryHookResult = ReturnType<typeof useFictivHolidaysLazyQuery>;
export type FictivHolidaysQueryResult = Apollo.QueryResult<FictivHolidaysQuery, FictivHolidaysQueryVariables>;
export function refetchFictivHolidaysQuery(variables?: FictivHolidaysQueryVariables) {
      return { query: FictivHolidaysDocument, variables: variables }
    }
export const UpdateItarAcceptedDatetimeDocument = gql`
    mutation updateItarAcceptedDatetime($userId: Int!) {
  user(id: $userId) {
    updateItarAcceptedDatetime {
      id
      itarAcceptedDatetime
    }
  }
}
    `;
export type UpdateItarAcceptedDatetimeMutationFn = Apollo.MutationFunction<UpdateItarAcceptedDatetimeMutation, UpdateItarAcceptedDatetimeMutationVariables>;

/**
 * __useUpdateItarAcceptedDatetimeMutation__
 *
 * To run a mutation, you first call `useUpdateItarAcceptedDatetimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateItarAcceptedDatetimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateItarAcceptedDatetimeMutation, { data, loading, error }] = useUpdateItarAcceptedDatetimeMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateItarAcceptedDatetimeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateItarAcceptedDatetimeMutation, UpdateItarAcceptedDatetimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateItarAcceptedDatetimeMutation, UpdateItarAcceptedDatetimeMutationVariables>(UpdateItarAcceptedDatetimeDocument, options);
      }
export type UpdateItarAcceptedDatetimeMutationHookResult = ReturnType<typeof useUpdateItarAcceptedDatetimeMutation>;
export type UpdateItarAcceptedDatetimeMutationResult = Apollo.MutationResult<UpdateItarAcceptedDatetimeMutation>;
export type UpdateItarAcceptedDatetimeMutationOptions = Apollo.BaseMutationOptions<UpdateItarAcceptedDatetimeMutation, UpdateItarAcceptedDatetimeMutationVariables>;
export const ItarAcceptedDatetimeDocument = gql`
    query itarAcceptedDatetime($userId: Int!) {
  user(id: $userId) {
    id
    itarAcceptedDatetime
    email
  }
}
    `;

/**
 * __useItarAcceptedDatetimeQuery__
 *
 * To run a query within a React component, call `useItarAcceptedDatetimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useItarAcceptedDatetimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItarAcceptedDatetimeQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useItarAcceptedDatetimeQuery(baseOptions: Apollo.QueryHookOptions<ItarAcceptedDatetimeQuery, ItarAcceptedDatetimeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItarAcceptedDatetimeQuery, ItarAcceptedDatetimeQueryVariables>(ItarAcceptedDatetimeDocument, options);
      }
export function useItarAcceptedDatetimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItarAcceptedDatetimeQuery, ItarAcceptedDatetimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItarAcceptedDatetimeQuery, ItarAcceptedDatetimeQueryVariables>(ItarAcceptedDatetimeDocument, options);
        }
export type ItarAcceptedDatetimeQueryHookResult = ReturnType<typeof useItarAcceptedDatetimeQuery>;
export type ItarAcceptedDatetimeLazyQueryHookResult = ReturnType<typeof useItarAcceptedDatetimeLazyQuery>;
export type ItarAcceptedDatetimeQueryResult = Apollo.QueryResult<ItarAcceptedDatetimeQuery, ItarAcceptedDatetimeQueryVariables>;
export function refetchItarAcceptedDatetimeQuery(variables: ItarAcceptedDatetimeQueryVariables) {
      return { query: ItarAcceptedDatetimeDocument, variables: variables }
    }
export const MoveQuoteTeamDocument = gql`
    mutation MoveQuoteTeam($teamId: Int!, $userId: Int!, $quoteId: UUID!) {
  moveQuoteTeam(teamId: $teamId, userId: $userId, quoteId: $quoteId) {
    id
  }
}
    `;
export type MoveQuoteTeamMutationFn = Apollo.MutationFunction<MoveQuoteTeamMutation, MoveQuoteTeamMutationVariables>;

/**
 * __useMoveQuoteTeamMutation__
 *
 * To run a mutation, you first call `useMoveQuoteTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveQuoteTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveQuoteTeamMutation, { data, loading, error }] = useMoveQuoteTeamMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      userId: // value for 'userId'
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useMoveQuoteTeamMutation(baseOptions?: Apollo.MutationHookOptions<MoveQuoteTeamMutation, MoveQuoteTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveQuoteTeamMutation, MoveQuoteTeamMutationVariables>(MoveQuoteTeamDocument, options);
      }
export type MoveQuoteTeamMutationHookResult = ReturnType<typeof useMoveQuoteTeamMutation>;
export type MoveQuoteTeamMutationResult = Apollo.MutationResult<MoveQuoteTeamMutation>;
export type MoveQuoteTeamMutationOptions = Apollo.BaseMutationOptions<MoveQuoteTeamMutation, MoveQuoteTeamMutationVariables>;
export const EnableBusinessAccountTrialDocument = gql`
    mutation enableBusinessAccountTrial {
  enableBusinessAccountTrial
}
    `;
export type EnableBusinessAccountTrialMutationFn = Apollo.MutationFunction<EnableBusinessAccountTrialMutation, EnableBusinessAccountTrialMutationVariables>;

/**
 * __useEnableBusinessAccountTrialMutation__
 *
 * To run a mutation, you first call `useEnableBusinessAccountTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableBusinessAccountTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableBusinessAccountTrialMutation, { data, loading, error }] = useEnableBusinessAccountTrialMutation({
 *   variables: {
 *   },
 * });
 */
export function useEnableBusinessAccountTrialMutation(baseOptions?: Apollo.MutationHookOptions<EnableBusinessAccountTrialMutation, EnableBusinessAccountTrialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableBusinessAccountTrialMutation, EnableBusinessAccountTrialMutationVariables>(EnableBusinessAccountTrialDocument, options);
      }
export type EnableBusinessAccountTrialMutationHookResult = ReturnType<typeof useEnableBusinessAccountTrialMutation>;
export type EnableBusinessAccountTrialMutationResult = Apollo.MutationResult<EnableBusinessAccountTrialMutation>;
export type EnableBusinessAccountTrialMutationOptions = Apollo.BaseMutationOptions<EnableBusinessAccountTrialMutation, EnableBusinessAccountTrialMutationVariables>;
export const MpExceptionFailuresDocument = gql`
    query mpExceptionFailures($limit: Int!, $offset: Int, $sort: ExceptionFailuresSort, $filters: ExceptionFailuresFilterInput) {
  exceptionFailures(
    limit: $limit
    offset: $offset
    sort: $sort
    filters: $filters
  ) {
    totalCount
    items {
      id
      name
      exceptionFailureState
      jobId
      jobName
      salesOrderName
      assignee
      type
      isFailure
      assignedEntity
      createdAt
      updatedAt
      type
      jobRequest {
        id
        name
      }
      correctiveActionRequest {
        id
        name
        type
        status
        turnaroundDays
      }
      exceptionFailureParts {
        lines
      }
    }
  }
}
    `;

/**
 * __useMpExceptionFailuresQuery__
 *
 * To run a query within a React component, call `useMpExceptionFailuresQuery` and pass it any options that fit your needs.
 * When your component renders, `useMpExceptionFailuresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMpExceptionFailuresQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useMpExceptionFailuresQuery(baseOptions: Apollo.QueryHookOptions<MpExceptionFailuresQuery, MpExceptionFailuresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MpExceptionFailuresQuery, MpExceptionFailuresQueryVariables>(MpExceptionFailuresDocument, options);
      }
export function useMpExceptionFailuresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MpExceptionFailuresQuery, MpExceptionFailuresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MpExceptionFailuresQuery, MpExceptionFailuresQueryVariables>(MpExceptionFailuresDocument, options);
        }
export type MpExceptionFailuresQueryHookResult = ReturnType<typeof useMpExceptionFailuresQuery>;
export type MpExceptionFailuresLazyQueryHookResult = ReturnType<typeof useMpExceptionFailuresLazyQuery>;
export type MpExceptionFailuresQueryResult = Apollo.QueryResult<MpExceptionFailuresQuery, MpExceptionFailuresQueryVariables>;
export function refetchMpExceptionFailuresQuery(variables: MpExceptionFailuresQueryVariables) {
      return { query: MpExceptionFailuresDocument, variables: variables }
    }
export const GetFailuresListDocument = gql`
    query getFailuresList($limit: Int!, $offset: Int, $sort: AllowedExceptionsSort, $filters: ExceptionsFilterInput) {
  exceptions(limit: $limit, offset: $offset, sort: $sort, filters: $filters) {
    totalCount
    items {
      id
      name
      rfqNumber
      exceptionState
      workOrderName
      salesOrderName
      erpSaleOrderId
      jobId
      mpName
      assignee
      type
      action
      otifIsActive
      otFailureFictiv
      otFailureMP
      otFailureCustomer
      ifFailureMP
      ifFailureFictiv
      ifFailureCustomer
      ignoreFailureForMpCalculation
      workOrderRequestDate
      earliestReceiptDate
      earliestPromisedShipDate
      earliestScheduledDeliveryDate
      updatedAt
      otFailureMPDays
      otFailureFictivDays
      otFailureCustomerDays
      workOrderRequestId
      actionId
      typeId
      exceptionParts {
        id
        erpProductId
        partName
        failedQuantity
        lines
      }
      jobRequest {
        name
      }
      correctiveActionRequestForList {
        id
        name
        type
        status
        turnaroundDays
      }
      project {
        id
        name
        isSecurePlus
      }
      latestNote {
        id
        body
        createdBy {
          id
          displayName
        }
        createdAt
        exceptionNoteAttachments {
          id
          attachment {
            id
            mimeType
            downloadUrl
          }
        }
      }
      failureDiscoveredBy
      failureRootCauses {
        id
        description
      }
      createdBy {
        id
        displayName
      }
      createdAt
      nonConformanceEmailSentOn
    }
  }
}
    `;

/**
 * __useGetFailuresListQuery__
 *
 * To run a query within a React component, call `useGetFailuresListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFailuresListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFailuresListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetFailuresListQuery(baseOptions: Apollo.QueryHookOptions<GetFailuresListQuery, GetFailuresListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFailuresListQuery, GetFailuresListQueryVariables>(GetFailuresListDocument, options);
      }
export function useGetFailuresListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFailuresListQuery, GetFailuresListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFailuresListQuery, GetFailuresListQueryVariables>(GetFailuresListDocument, options);
        }
export type GetFailuresListQueryHookResult = ReturnType<typeof useGetFailuresListQuery>;
export type GetFailuresListLazyQueryHookResult = ReturnType<typeof useGetFailuresListLazyQuery>;
export type GetFailuresListQueryResult = Apollo.QueryResult<GetFailuresListQuery, GetFailuresListQueryVariables>;
export function refetchGetFailuresListQuery(variables: GetFailuresListQueryVariables) {
      return { query: GetFailuresListDocument, variables: variables }
    }
export const SetMachineDetailsDocument = gql`
    mutation setMachineDetails($machineDetails: MfgPartnerMachineDetailsInput!) {
  updateMfgPartnerMachineDetails(machineDetails: $machineDetails) {
    id
  }
}
    `;
export type SetMachineDetailsMutationFn = Apollo.MutationFunction<SetMachineDetailsMutation, SetMachineDetailsMutationVariables>;

/**
 * __useSetMachineDetailsMutation__
 *
 * To run a mutation, you first call `useSetMachineDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMachineDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMachineDetailsMutation, { data, loading, error }] = useSetMachineDetailsMutation({
 *   variables: {
 *      machineDetails: // value for 'machineDetails'
 *   },
 * });
 */
export function useSetMachineDetailsMutation(baseOptions?: Apollo.MutationHookOptions<SetMachineDetailsMutation, SetMachineDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMachineDetailsMutation, SetMachineDetailsMutationVariables>(SetMachineDetailsDocument, options);
      }
export type SetMachineDetailsMutationHookResult = ReturnType<typeof useSetMachineDetailsMutation>;
export type SetMachineDetailsMutationResult = Apollo.MutationResult<SetMachineDetailsMutation>;
export type SetMachineDetailsMutationOptions = Apollo.BaseMutationOptions<SetMachineDetailsMutation, SetMachineDetailsMutationVariables>;
export const SetMaterialAvailabilityDocument = gql`
    mutation setMaterialAvailability($partnerId: Int!, $processId: Int!, $materialId: Int!, $isActive: Boolean) {
  setMfgPartnerMaterial(
    partnerId: $partnerId
    processId: $processId
    materialId: $materialId
    isActive: $isActive
  )
}
    `;
export type SetMaterialAvailabilityMutationFn = Apollo.MutationFunction<SetMaterialAvailabilityMutation, SetMaterialAvailabilityMutationVariables>;

/**
 * __useSetMaterialAvailabilityMutation__
 *
 * To run a mutation, you first call `useSetMaterialAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMaterialAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMaterialAvailabilityMutation, { data, loading, error }] = useSetMaterialAvailabilityMutation({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      processId: // value for 'processId'
 *      materialId: // value for 'materialId'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useSetMaterialAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<SetMaterialAvailabilityMutation, SetMaterialAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMaterialAvailabilityMutation, SetMaterialAvailabilityMutationVariables>(SetMaterialAvailabilityDocument, options);
      }
export type SetMaterialAvailabilityMutationHookResult = ReturnType<typeof useSetMaterialAvailabilityMutation>;
export type SetMaterialAvailabilityMutationResult = Apollo.MutationResult<SetMaterialAvailabilityMutation>;
export type SetMaterialAvailabilityMutationOptions = Apollo.BaseMutationOptions<SetMaterialAvailabilityMutation, SetMaterialAvailabilityMutationVariables>;
export const SetShopProcessAvailabilityDocument = gql`
    mutation SetShopProcessAvailability($availabilityInput: [AvailabilityInput!]!, $partnerId: Int) {
  setShopProcessAvailability(
    availabilityInput: $availabilityInput
    partnerId: $partnerId
  )
}
    `;
export type SetShopProcessAvailabilityMutationFn = Apollo.MutationFunction<SetShopProcessAvailabilityMutation, SetShopProcessAvailabilityMutationVariables>;

/**
 * __useSetShopProcessAvailabilityMutation__
 *
 * To run a mutation, you first call `useSetShopProcessAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetShopProcessAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setShopProcessAvailabilityMutation, { data, loading, error }] = useSetShopProcessAvailabilityMutation({
 *   variables: {
 *      availabilityInput: // value for 'availabilityInput'
 *      partnerId: // value for 'partnerId'
 *   },
 * });
 */
export function useSetShopProcessAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<SetShopProcessAvailabilityMutation, SetShopProcessAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetShopProcessAvailabilityMutation, SetShopProcessAvailabilityMutationVariables>(SetShopProcessAvailabilityDocument, options);
      }
export type SetShopProcessAvailabilityMutationHookResult = ReturnType<typeof useSetShopProcessAvailabilityMutation>;
export type SetShopProcessAvailabilityMutationResult = Apollo.MutationResult<SetShopProcessAvailabilityMutation>;
export type SetShopProcessAvailabilityMutationOptions = Apollo.BaseMutationOptions<SetShopProcessAvailabilityMutation, SetShopProcessAvailabilityMutationVariables>;
export const SetProcessPreferenceDocument = gql`
    mutation setProcessPreference($partnerId: Int!, $capabilities: MfgPartnerProcessCapabilitiesInput!) {
  createOrUpdateMfgPartnerProcessCapabilities(
    partnerId: $partnerId
    capabilities: $capabilities
  ) {
    id
  }
}
    `;
export type SetProcessPreferenceMutationFn = Apollo.MutationFunction<SetProcessPreferenceMutation, SetProcessPreferenceMutationVariables>;

/**
 * __useSetProcessPreferenceMutation__
 *
 * To run a mutation, you first call `useSetProcessPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProcessPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProcessPreferenceMutation, { data, loading, error }] = useSetProcessPreferenceMutation({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      capabilities: // value for 'capabilities'
 *   },
 * });
 */
export function useSetProcessPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<SetProcessPreferenceMutation, SetProcessPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetProcessPreferenceMutation, SetProcessPreferenceMutationVariables>(SetProcessPreferenceDocument, options);
      }
export type SetProcessPreferenceMutationHookResult = ReturnType<typeof useSetProcessPreferenceMutation>;
export type SetProcessPreferenceMutationResult = Apollo.MutationResult<SetProcessPreferenceMutation>;
export type SetProcessPreferenceMutationOptions = Apollo.BaseMutationOptions<SetProcessPreferenceMutation, SetProcessPreferenceMutationVariables>;
export const MfgPartnerOverallStatisticsDocument = gql`
    query MfgPartnerOverallStatistics($mfgPartnerId: Int) {
  mfgPartnerOverallStatistics(mfgPartnerId: $mfgPartnerId) {
    partnerId
    mpLevel
    jobCompletedCount
    jobCompletedAmount
    uniquePartsCompletedCount
    totalCarsCount
    totalDays
    mpLevelOverrideRecord {
      mpLevelOverride
      id
      expiresAt
    }
  }
}
    `;

/**
 * __useMfgPartnerOverallStatisticsQuery__
 *
 * To run a query within a React component, call `useMfgPartnerOverallStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMfgPartnerOverallStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMfgPartnerOverallStatisticsQuery({
 *   variables: {
 *      mfgPartnerId: // value for 'mfgPartnerId'
 *   },
 * });
 */
export function useMfgPartnerOverallStatisticsQuery(baseOptions?: Apollo.QueryHookOptions<MfgPartnerOverallStatisticsQuery, MfgPartnerOverallStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MfgPartnerOverallStatisticsQuery, MfgPartnerOverallStatisticsQueryVariables>(MfgPartnerOverallStatisticsDocument, options);
      }
export function useMfgPartnerOverallStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MfgPartnerOverallStatisticsQuery, MfgPartnerOverallStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MfgPartnerOverallStatisticsQuery, MfgPartnerOverallStatisticsQueryVariables>(MfgPartnerOverallStatisticsDocument, options);
        }
export type MfgPartnerOverallStatisticsQueryHookResult = ReturnType<typeof useMfgPartnerOverallStatisticsQuery>;
export type MfgPartnerOverallStatisticsLazyQueryHookResult = ReturnType<typeof useMfgPartnerOverallStatisticsLazyQuery>;
export type MfgPartnerOverallStatisticsQueryResult = Apollo.QueryResult<MfgPartnerOverallStatisticsQuery, MfgPartnerOverallStatisticsQueryVariables>;
export function refetchMfgPartnerOverallStatisticsQuery(variables?: MfgPartnerOverallStatisticsQueryVariables) {
      return { query: MfgPartnerOverallStatisticsDocument, variables: variables }
    }
export const GetScorecardCarChartDataDocument = gql`
    query getScorecardCarChartData($mfgPartnerId: Int!, $filters: MfgPartnerLevelsFiltersInput) {
  mfgPartnerLevelRecords(mfgPartnerId: $mfgPartnerId, filters: $filters) {
    items {
      ...Scorecard_Car_Chart_Items
    }
  }
}
    ${Scorecard_Car_Chart_ItemsFragmentDoc}`;

/**
 * __useGetScorecardCarChartDataQuery__
 *
 * To run a query within a React component, call `useGetScorecardCarChartDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScorecardCarChartDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScorecardCarChartDataQuery({
 *   variables: {
 *      mfgPartnerId: // value for 'mfgPartnerId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetScorecardCarChartDataQuery(baseOptions: Apollo.QueryHookOptions<GetScorecardCarChartDataQuery, GetScorecardCarChartDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScorecardCarChartDataQuery, GetScorecardCarChartDataQueryVariables>(GetScorecardCarChartDataDocument, options);
      }
export function useGetScorecardCarChartDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScorecardCarChartDataQuery, GetScorecardCarChartDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScorecardCarChartDataQuery, GetScorecardCarChartDataQueryVariables>(GetScorecardCarChartDataDocument, options);
        }
export type GetScorecardCarChartDataQueryHookResult = ReturnType<typeof useGetScorecardCarChartDataQuery>;
export type GetScorecardCarChartDataLazyQueryHookResult = ReturnType<typeof useGetScorecardCarChartDataLazyQuery>;
export type GetScorecardCarChartDataQueryResult = Apollo.QueryResult<GetScorecardCarChartDataQuery, GetScorecardCarChartDataQueryVariables>;
export function refetchGetScorecardCarChartDataQuery(variables: GetScorecardCarChartDataQueryVariables) {
      return { query: GetScorecardCarChartDataDocument, variables: variables }
    }
export const GetScorecardRatingChartDataDocument = gql`
    query getScorecardRatingChartData($mfgPartnerId: Int!, $filters: MfgPartnerLevelsFiltersInput) {
  mfgPartnerLevelRecords(mfgPartnerId: $mfgPartnerId, filters: $filters) {
    items {
      ...Scorecard_Rating_Chart_Items
    }
  }
}
    ${Scorecard_Rating_Chart_ItemsFragmentDoc}`;

/**
 * __useGetScorecardRatingChartDataQuery__
 *
 * To run a query within a React component, call `useGetScorecardRatingChartDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScorecardRatingChartDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScorecardRatingChartDataQuery({
 *   variables: {
 *      mfgPartnerId: // value for 'mfgPartnerId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetScorecardRatingChartDataQuery(baseOptions: Apollo.QueryHookOptions<GetScorecardRatingChartDataQuery, GetScorecardRatingChartDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScorecardRatingChartDataQuery, GetScorecardRatingChartDataQueryVariables>(GetScorecardRatingChartDataDocument, options);
      }
export function useGetScorecardRatingChartDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScorecardRatingChartDataQuery, GetScorecardRatingChartDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScorecardRatingChartDataQuery, GetScorecardRatingChartDataQueryVariables>(GetScorecardRatingChartDataDocument, options);
        }
export type GetScorecardRatingChartDataQueryHookResult = ReturnType<typeof useGetScorecardRatingChartDataQuery>;
export type GetScorecardRatingChartDataLazyQueryHookResult = ReturnType<typeof useGetScorecardRatingChartDataLazyQuery>;
export type GetScorecardRatingChartDataQueryResult = Apollo.QueryResult<GetScorecardRatingChartDataQuery, GetScorecardRatingChartDataQueryVariables>;
export function refetchGetScorecardRatingChartDataQuery(variables: GetScorecardRatingChartDataQueryVariables) {
      return { query: GetScorecardRatingChartDataDocument, variables: variables }
    }
export const GetMachineDetailsByProcessIdDocument = gql`
    query getMachineDetailsByProcessId($processId: Int!, $partnerId: Int!) {
  getMfgPartnerMachineDetails(processId: $processId, partnerId: $partnerId) {
    id
    fourAxisCount
    fivePlusAxisCount
    description
    partnerId
    processId
    platformProcessId
    platformProcessTypeId
    totalCount
    threeAxisCount
    manualLatheCount
    liveToolingLatheCount
    isFourAxisSupported
    isFiveAxisSupported
    isLiveToolingSupported
    minX
    minY
    minZ
    maxX
    maxY
    maxZ
  }
}
    `;

/**
 * __useGetMachineDetailsByProcessIdQuery__
 *
 * To run a query within a React component, call `useGetMachineDetailsByProcessIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachineDetailsByProcessIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachineDetailsByProcessIdQuery({
 *   variables: {
 *      processId: // value for 'processId'
 *      partnerId: // value for 'partnerId'
 *   },
 * });
 */
export function useGetMachineDetailsByProcessIdQuery(baseOptions: Apollo.QueryHookOptions<GetMachineDetailsByProcessIdQuery, GetMachineDetailsByProcessIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMachineDetailsByProcessIdQuery, GetMachineDetailsByProcessIdQueryVariables>(GetMachineDetailsByProcessIdDocument, options);
      }
export function useGetMachineDetailsByProcessIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMachineDetailsByProcessIdQuery, GetMachineDetailsByProcessIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMachineDetailsByProcessIdQuery, GetMachineDetailsByProcessIdQueryVariables>(GetMachineDetailsByProcessIdDocument, options);
        }
export type GetMachineDetailsByProcessIdQueryHookResult = ReturnType<typeof useGetMachineDetailsByProcessIdQuery>;
export type GetMachineDetailsByProcessIdLazyQueryHookResult = ReturnType<typeof useGetMachineDetailsByProcessIdLazyQuery>;
export type GetMachineDetailsByProcessIdQueryResult = Apollo.QueryResult<GetMachineDetailsByProcessIdQuery, GetMachineDetailsByProcessIdQueryVariables>;
export function refetchGetMachineDetailsByProcessIdQuery(variables: GetMachineDetailsByProcessIdQueryVariables) {
      return { query: GetMachineDetailsByProcessIdDocument, variables: variables }
    }
export const GetMaterialsByMpIdDocument = gql`
    query getMaterialsByMpId($partnerId: Int!) {
  getMfgPartnerMaterials(partnerId: $partnerId) {
    ...GetMaterialsByMpIdMfgPartnerMaterials
  }
}
    ${GetMaterialsByMpIdMfgPartnerMaterialsFragmentDoc}`;

/**
 * __useGetMaterialsByMpIdQuery__
 *
 * To run a query within a React component, call `useGetMaterialsByMpIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialsByMpIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterialsByMpIdQuery({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *   },
 * });
 */
export function useGetMaterialsByMpIdQuery(baseOptions: Apollo.QueryHookOptions<GetMaterialsByMpIdQuery, GetMaterialsByMpIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaterialsByMpIdQuery, GetMaterialsByMpIdQueryVariables>(GetMaterialsByMpIdDocument, options);
      }
export function useGetMaterialsByMpIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMaterialsByMpIdQuery, GetMaterialsByMpIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaterialsByMpIdQuery, GetMaterialsByMpIdQueryVariables>(GetMaterialsByMpIdDocument, options);
        }
export type GetMaterialsByMpIdQueryHookResult = ReturnType<typeof useGetMaterialsByMpIdQuery>;
export type GetMaterialsByMpIdLazyQueryHookResult = ReturnType<typeof useGetMaterialsByMpIdLazyQuery>;
export type GetMaterialsByMpIdQueryResult = Apollo.QueryResult<GetMaterialsByMpIdQuery, GetMaterialsByMpIdQueryVariables>;
export function refetchGetMaterialsByMpIdQuery(variables: GetMaterialsByMpIdQueryVariables) {
      return { query: GetMaterialsByMpIdDocument, variables: variables }
    }
export const GetProcessAvailabilityByProcessIdDocument = gql`
    query getProcessAvailabilityByProcessId($availabilityInput: PartnerShopAvailabilityInput!) {
  getPartnerShopProcessAvailability(availabilityInput: $availabilityInput) {
    ...ProcessAvailabilityByProcessId
  }
}
    ${ProcessAvailabilityByProcessIdFragmentDoc}`;

/**
 * __useGetProcessAvailabilityByProcessIdQuery__
 *
 * To run a query within a React component, call `useGetProcessAvailabilityByProcessIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcessAvailabilityByProcessIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProcessAvailabilityByProcessIdQuery({
 *   variables: {
 *      availabilityInput: // value for 'availabilityInput'
 *   },
 * });
 */
export function useGetProcessAvailabilityByProcessIdQuery(baseOptions: Apollo.QueryHookOptions<GetProcessAvailabilityByProcessIdQuery, GetProcessAvailabilityByProcessIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProcessAvailabilityByProcessIdQuery, GetProcessAvailabilityByProcessIdQueryVariables>(GetProcessAvailabilityByProcessIdDocument, options);
      }
export function useGetProcessAvailabilityByProcessIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProcessAvailabilityByProcessIdQuery, GetProcessAvailabilityByProcessIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProcessAvailabilityByProcessIdQuery, GetProcessAvailabilityByProcessIdQueryVariables>(GetProcessAvailabilityByProcessIdDocument, options);
        }
export type GetProcessAvailabilityByProcessIdQueryHookResult = ReturnType<typeof useGetProcessAvailabilityByProcessIdQuery>;
export type GetProcessAvailabilityByProcessIdLazyQueryHookResult = ReturnType<typeof useGetProcessAvailabilityByProcessIdLazyQuery>;
export type GetProcessAvailabilityByProcessIdQueryResult = Apollo.QueryResult<GetProcessAvailabilityByProcessIdQuery, GetProcessAvailabilityByProcessIdQueryVariables>;
export function refetchGetProcessAvailabilityByProcessIdQuery(variables: GetProcessAvailabilityByProcessIdQueryVariables) {
      return { query: GetProcessAvailabilityByProcessIdDocument, variables: variables }
    }
export const GetProcessPreferenceByIdDocument = gql`
    query getProcessPreferenceById($partnerId: Int!, $erpProcessId: Int!) {
  getMfgPartnerProcessCapabilities(
    partnerId: $partnerId
    erpProcessId: $erpProcessId
  ) {
    ...getProcessPreferenceByIdFragment
  }
}
    ${GetProcessPreferenceByIdFragmentFragmentDoc}`;

/**
 * __useGetProcessPreferenceByIdQuery__
 *
 * To run a query within a React component, call `useGetProcessPreferenceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcessPreferenceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProcessPreferenceByIdQuery({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      erpProcessId: // value for 'erpProcessId'
 *   },
 * });
 */
export function useGetProcessPreferenceByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProcessPreferenceByIdQuery, GetProcessPreferenceByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProcessPreferenceByIdQuery, GetProcessPreferenceByIdQueryVariables>(GetProcessPreferenceByIdDocument, options);
      }
export function useGetProcessPreferenceByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProcessPreferenceByIdQuery, GetProcessPreferenceByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProcessPreferenceByIdQuery, GetProcessPreferenceByIdQueryVariables>(GetProcessPreferenceByIdDocument, options);
        }
export type GetProcessPreferenceByIdQueryHookResult = ReturnType<typeof useGetProcessPreferenceByIdQuery>;
export type GetProcessPreferenceByIdLazyQueryHookResult = ReturnType<typeof useGetProcessPreferenceByIdLazyQuery>;
export type GetProcessPreferenceByIdQueryResult = Apollo.QueryResult<GetProcessPreferenceByIdQuery, GetProcessPreferenceByIdQueryVariables>;
export function refetchGetProcessPreferenceByIdQuery(variables: GetProcessPreferenceByIdQueryVariables) {
      return { query: GetProcessPreferenceByIdDocument, variables: variables }
    }
export const GetProcessesByMfgIdDocument = gql`
    query getProcessesByMfgId($partnerId: Int!) {
  getShopProcessesByPartnerId(partnerId: $partnerId) {
    ...ProcessesListByMfgId
  }
}
    ${ProcessesListByMfgIdFragmentDoc}`;

/**
 * __useGetProcessesByMfgIdQuery__
 *
 * To run a query within a React component, call `useGetProcessesByMfgIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcessesByMfgIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProcessesByMfgIdQuery({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *   },
 * });
 */
export function useGetProcessesByMfgIdQuery(baseOptions: Apollo.QueryHookOptions<GetProcessesByMfgIdQuery, GetProcessesByMfgIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProcessesByMfgIdQuery, GetProcessesByMfgIdQueryVariables>(GetProcessesByMfgIdDocument, options);
      }
export function useGetProcessesByMfgIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProcessesByMfgIdQuery, GetProcessesByMfgIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProcessesByMfgIdQuery, GetProcessesByMfgIdQueryVariables>(GetProcessesByMfgIdDocument, options);
        }
export type GetProcessesByMfgIdQueryHookResult = ReturnType<typeof useGetProcessesByMfgIdQuery>;
export type GetProcessesByMfgIdLazyQueryHookResult = ReturnType<typeof useGetProcessesByMfgIdLazyQuery>;
export type GetProcessesByMfgIdQueryResult = Apollo.QueryResult<GetProcessesByMfgIdQuery, GetProcessesByMfgIdQueryVariables>;
export function refetchGetProcessesByMfgIdQuery(variables: GetProcessesByMfgIdQueryVariables) {
      return { query: GetProcessesByMfgIdDocument, variables: variables }
    }
export const GetSupportingCapabilitiesDocument = gql`
    query getSupportingCapabilities {
  getSupportingCapabilities {
    id
    name
  }
}
    `;

/**
 * __useGetSupportingCapabilitiesQuery__
 *
 * To run a query within a React component, call `useGetSupportingCapabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportingCapabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportingCapabilitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSupportingCapabilitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetSupportingCapabilitiesQuery, GetSupportingCapabilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupportingCapabilitiesQuery, GetSupportingCapabilitiesQueryVariables>(GetSupportingCapabilitiesDocument, options);
      }
export function useGetSupportingCapabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupportingCapabilitiesQuery, GetSupportingCapabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupportingCapabilitiesQuery, GetSupportingCapabilitiesQueryVariables>(GetSupportingCapabilitiesDocument, options);
        }
export type GetSupportingCapabilitiesQueryHookResult = ReturnType<typeof useGetSupportingCapabilitiesQuery>;
export type GetSupportingCapabilitiesLazyQueryHookResult = ReturnType<typeof useGetSupportingCapabilitiesLazyQuery>;
export type GetSupportingCapabilitiesQueryResult = Apollo.QueryResult<GetSupportingCapabilitiesQuery, GetSupportingCapabilitiesQueryVariables>;
export function refetchGetSupportingCapabilitiesQuery(variables?: GetSupportingCapabilitiesQueryVariables) {
      return { query: GetSupportingCapabilitiesDocument, variables: variables }
    }
export const AdminJobRequestsQueryDocument = gql`
    query adminJobRequestsQuery($limit: Int!, $offset: Int, $filters: AdminJobRequestFiltersInput, $sort: AllowedAdminJobRequestSort) {
  adminJobRequests(limit: $limit, offset: $offset, filters: $filters, sort: $sort) {
    totalCount
    items {
      id
      name
      jobId
      salesOrderName
      project {
        id
        name
        isSecurePlus
      }
      priority
      mfgDri {
        id
        displayName
      }
      mfgPartner {
        id
      }
      earliestDeliveryOrderDate
      jobRequestStatus
      earliestReceiptdate
      vendorDueDate
      originalVendorDueDate
    }
  }
}
    `;

/**
 * __useAdminJobRequestsQueryQuery__
 *
 * To run a query within a React component, call `useAdminJobRequestsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminJobRequestsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminJobRequestsQueryQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAdminJobRequestsQueryQuery(baseOptions: Apollo.QueryHookOptions<AdminJobRequestsQueryQuery, AdminJobRequestsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminJobRequestsQueryQuery, AdminJobRequestsQueryQueryVariables>(AdminJobRequestsQueryDocument, options);
      }
export function useAdminJobRequestsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminJobRequestsQueryQuery, AdminJobRequestsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminJobRequestsQueryQuery, AdminJobRequestsQueryQueryVariables>(AdminJobRequestsQueryDocument, options);
        }
export type AdminJobRequestsQueryQueryHookResult = ReturnType<typeof useAdminJobRequestsQueryQuery>;
export type AdminJobRequestsQueryLazyQueryHookResult = ReturnType<typeof useAdminJobRequestsQueryLazyQuery>;
export type AdminJobRequestsQueryQueryResult = Apollo.QueryResult<AdminJobRequestsQueryQuery, AdminJobRequestsQueryQueryVariables>;
export function refetchAdminJobRequestsQueryQuery(variables: AdminJobRequestsQueryQueryVariables) {
      return { query: AdminJobRequestsQueryDocument, variables: variables }
    }
export const MfgPartnerBasicInfoQueryDocument = gql`
    query mfgPartnerBasicInfoQuery($id: Int!, $date: Date!) {
  mfgPartner(id: $id) {
    id
    name
    displayName
    preferredCarriers
    skipOrPauseSchedulingQueue
    countryName
    tz
    mpCutoffTime
    processes {
      erpProcessId
      processName
    }
    processesWithAvailability(date: $date) {
      erpProcessId
      processName
      availability(date: $date) {
        accepting
        acceptingDisabled
        available
        date
      }
    }
    jobAcceptanceHours {
      partnerId
      name
      day
      dayName
      openTime
      closeTime
    }
    highTouchOnly
    isEligibleForWork
    backstopMp
    isSecurePlusMp
    fictivHiatus
    strategicSourcingManager {
      id
      displayName
      firstName
      lastName
    }
    supplierQualityEngineer {
      id
      displayName
      firstName
      lastName
    }
    supplierDevelopmentEngineer {
      id
      displayName
      firstName
      lastName
    }
    gmleGroup
    currentMpLevelDetails {
      mpLevel
    }
  }
}
    `;

/**
 * __useMfgPartnerBasicInfoQueryQuery__
 *
 * To run a query within a React component, call `useMfgPartnerBasicInfoQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMfgPartnerBasicInfoQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMfgPartnerBasicInfoQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useMfgPartnerBasicInfoQueryQuery(baseOptions: Apollo.QueryHookOptions<MfgPartnerBasicInfoQueryQuery, MfgPartnerBasicInfoQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MfgPartnerBasicInfoQueryQuery, MfgPartnerBasicInfoQueryQueryVariables>(MfgPartnerBasicInfoQueryDocument, options);
      }
export function useMfgPartnerBasicInfoQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MfgPartnerBasicInfoQueryQuery, MfgPartnerBasicInfoQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MfgPartnerBasicInfoQueryQuery, MfgPartnerBasicInfoQueryQueryVariables>(MfgPartnerBasicInfoQueryDocument, options);
        }
export type MfgPartnerBasicInfoQueryQueryHookResult = ReturnType<typeof useMfgPartnerBasicInfoQueryQuery>;
export type MfgPartnerBasicInfoQueryLazyQueryHookResult = ReturnType<typeof useMfgPartnerBasicInfoQueryLazyQuery>;
export type MfgPartnerBasicInfoQueryQueryResult = Apollo.QueryResult<MfgPartnerBasicInfoQueryQuery, MfgPartnerBasicInfoQueryQueryVariables>;
export function refetchMfgPartnerBasicInfoQueryQuery(variables: MfgPartnerBasicInfoQueryQueryVariables) {
      return { query: MfgPartnerBasicInfoQueryDocument, variables: variables }
    }
export const MpPerformanceListQueryDocument = gql`
    query mpPerformanceListQuery($mfgPartnerId: Int!, $limit: Int, $offset: Int, $sort: AllowedMfgPartnerLevelsSort, $filters: MfgPartnerLevelsFiltersInput) {
  mfgPartnerLevelRecords(
    mfgPartnerId: $mfgPartnerId
    limit: $limit
    offset: $offset
    sort: $sort
    filters: $filters
  ) {
    totalCount
    items {
      id
      recordType
      fromDate
      toDate
      recordDate
      scoreCardSharedWithMp
      scorecardSentAt
      mpLevel
      acceptanceLevel
      acceptanceRatio
      jobAcceptedCount
      jobSentCount
      jobAcceptedAmount
      expirationLevel
      expirationRatio
      jobExpiredCount
      jobExpiredAmount
      otRatio
      otLevel
      jobRequestLineItemsCount {
        otCount
        total
        ifCount
      }
      jobCompletedCount
      ifLevel
      ifRatio
      avgCarTurnaroundDays
      carLevel
      thresholdConfiguration
      jobRequestsCompletedCountLongTerm
    }
  }
}
    `;

/**
 * __useMpPerformanceListQueryQuery__
 *
 * To run a query within a React component, call `useMpPerformanceListQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMpPerformanceListQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMpPerformanceListQueryQuery({
 *   variables: {
 *      mfgPartnerId: // value for 'mfgPartnerId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useMpPerformanceListQueryQuery(baseOptions: Apollo.QueryHookOptions<MpPerformanceListQueryQuery, MpPerformanceListQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MpPerformanceListQueryQuery, MpPerformanceListQueryQueryVariables>(MpPerformanceListQueryDocument, options);
      }
export function useMpPerformanceListQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MpPerformanceListQueryQuery, MpPerformanceListQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MpPerformanceListQueryQuery, MpPerformanceListQueryQueryVariables>(MpPerformanceListQueryDocument, options);
        }
export type MpPerformanceListQueryQueryHookResult = ReturnType<typeof useMpPerformanceListQueryQuery>;
export type MpPerformanceListQueryLazyQueryHookResult = ReturnType<typeof useMpPerformanceListQueryLazyQuery>;
export type MpPerformanceListQueryQueryResult = Apollo.QueryResult<MpPerformanceListQueryQuery, MpPerformanceListQueryQueryVariables>;
export function refetchMpPerformanceListQueryQuery(variables: MpPerformanceListQueryQueryVariables) {
      return { query: MpPerformanceListQueryDocument, variables: variables }
    }
export const AssignedStrategicSourcingManagersDocument = gql`
    query AssignedStrategicSourcingManagers {
  assignedStrategicSourcingManagers {
    ...BasicUserPart
  }
}
    ${BasicUserPartFragmentDoc}`;

/**
 * __useAssignedStrategicSourcingManagersQuery__
 *
 * To run a query within a React component, call `useAssignedStrategicSourcingManagersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignedStrategicSourcingManagersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignedStrategicSourcingManagersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAssignedStrategicSourcingManagersQuery(baseOptions?: Apollo.QueryHookOptions<AssignedStrategicSourcingManagersQuery, AssignedStrategicSourcingManagersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssignedStrategicSourcingManagersQuery, AssignedStrategicSourcingManagersQueryVariables>(AssignedStrategicSourcingManagersDocument, options);
      }
export function useAssignedStrategicSourcingManagersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssignedStrategicSourcingManagersQuery, AssignedStrategicSourcingManagersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssignedStrategicSourcingManagersQuery, AssignedStrategicSourcingManagersQueryVariables>(AssignedStrategicSourcingManagersDocument, options);
        }
export type AssignedStrategicSourcingManagersQueryHookResult = ReturnType<typeof useAssignedStrategicSourcingManagersQuery>;
export type AssignedStrategicSourcingManagersLazyQueryHookResult = ReturnType<typeof useAssignedStrategicSourcingManagersLazyQuery>;
export type AssignedStrategicSourcingManagersQueryResult = Apollo.QueryResult<AssignedStrategicSourcingManagersQuery, AssignedStrategicSourcingManagersQueryVariables>;
export function refetchAssignedStrategicSourcingManagersQuery(variables?: AssignedStrategicSourcingManagersQueryVariables) {
      return { query: AssignedStrategicSourcingManagersDocument, variables: variables }
    }
export const AssignedSupplierDevelopmentEngineersDocument = gql`
    query AssignedSupplierDevelopmentEngineers {
  assignedSupplierDevelopmentEngineers {
    ...BasicUserPart
  }
}
    ${BasicUserPartFragmentDoc}`;

/**
 * __useAssignedSupplierDevelopmentEngineersQuery__
 *
 * To run a query within a React component, call `useAssignedSupplierDevelopmentEngineersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignedSupplierDevelopmentEngineersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignedSupplierDevelopmentEngineersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAssignedSupplierDevelopmentEngineersQuery(baseOptions?: Apollo.QueryHookOptions<AssignedSupplierDevelopmentEngineersQuery, AssignedSupplierDevelopmentEngineersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssignedSupplierDevelopmentEngineersQuery, AssignedSupplierDevelopmentEngineersQueryVariables>(AssignedSupplierDevelopmentEngineersDocument, options);
      }
export function useAssignedSupplierDevelopmentEngineersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssignedSupplierDevelopmentEngineersQuery, AssignedSupplierDevelopmentEngineersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssignedSupplierDevelopmentEngineersQuery, AssignedSupplierDevelopmentEngineersQueryVariables>(AssignedSupplierDevelopmentEngineersDocument, options);
        }
export type AssignedSupplierDevelopmentEngineersQueryHookResult = ReturnType<typeof useAssignedSupplierDevelopmentEngineersQuery>;
export type AssignedSupplierDevelopmentEngineersLazyQueryHookResult = ReturnType<typeof useAssignedSupplierDevelopmentEngineersLazyQuery>;
export type AssignedSupplierDevelopmentEngineersQueryResult = Apollo.QueryResult<AssignedSupplierDevelopmentEngineersQuery, AssignedSupplierDevelopmentEngineersQueryVariables>;
export function refetchAssignedSupplierDevelopmentEngineersQuery(variables?: AssignedSupplierDevelopmentEngineersQueryVariables) {
      return { query: AssignedSupplierDevelopmentEngineersDocument, variables: variables }
    }
export const MfgPartnersDocument = gql`
    query MfgPartners($limit: Int, $offset: Int, $filters: MfgPartnerFiltersInput, $sort: AllowedMfgPartnerSort) {
  mfgPartners(limit: $limit, offset: $offset, filters: $filters, sort: $sort) {
    items {
      ...MfgPartnerPart
    }
    offset
    totalCount
  }
}
    ${MfgPartnerPartFragmentDoc}`;

/**
 * __useMfgPartnersQuery__
 *
 * To run a query within a React component, call `useMfgPartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMfgPartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMfgPartnersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useMfgPartnersQuery(baseOptions?: Apollo.QueryHookOptions<MfgPartnersQuery, MfgPartnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MfgPartnersQuery, MfgPartnersQueryVariables>(MfgPartnersDocument, options);
      }
export function useMfgPartnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MfgPartnersQuery, MfgPartnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MfgPartnersQuery, MfgPartnersQueryVariables>(MfgPartnersDocument, options);
        }
export type MfgPartnersQueryHookResult = ReturnType<typeof useMfgPartnersQuery>;
export type MfgPartnersLazyQueryHookResult = ReturnType<typeof useMfgPartnersLazyQuery>;
export type MfgPartnersQueryResult = Apollo.QueryResult<MfgPartnersQuery, MfgPartnersQueryVariables>;
export function refetchMfgPartnersQuery(variables?: MfgPartnersQueryVariables) {
      return { query: MfgPartnersDocument, variables: variables }
    }
export const GetMpPerformanceCarsDocument = gql`
    query GetMpPerformanceCars($snapshotId: Int!, $mfgPartnerLevelCarsInput: MfgPartnerLevelCarsInput) {
  mfgPartnerLevelSnapshotDetails(snapshotId: $snapshotId) {
    correctiveActionRequests(mfgPartnerLevelCarsInput: $mfgPartnerLevelCarsInput) {
      items {
        ...MfgPartnerLevelSnapshotDetails_CARS_Items
      }
      totalCount
    }
  }
}
    ${MfgPartnerLevelSnapshotDetails_Cars_ItemsFragmentDoc}`;

/**
 * __useGetMpPerformanceCarsQuery__
 *
 * To run a query within a React component, call `useGetMpPerformanceCarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMpPerformanceCarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMpPerformanceCarsQuery({
 *   variables: {
 *      snapshotId: // value for 'snapshotId'
 *      mfgPartnerLevelCarsInput: // value for 'mfgPartnerLevelCarsInput'
 *   },
 * });
 */
export function useGetMpPerformanceCarsQuery(baseOptions: Apollo.QueryHookOptions<GetMpPerformanceCarsQuery, GetMpPerformanceCarsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMpPerformanceCarsQuery, GetMpPerformanceCarsQueryVariables>(GetMpPerformanceCarsDocument, options);
      }
export function useGetMpPerformanceCarsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMpPerformanceCarsQuery, GetMpPerformanceCarsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMpPerformanceCarsQuery, GetMpPerformanceCarsQueryVariables>(GetMpPerformanceCarsDocument, options);
        }
export type GetMpPerformanceCarsQueryHookResult = ReturnType<typeof useGetMpPerformanceCarsQuery>;
export type GetMpPerformanceCarsLazyQueryHookResult = ReturnType<typeof useGetMpPerformanceCarsLazyQuery>;
export type GetMpPerformanceCarsQueryResult = Apollo.QueryResult<GetMpPerformanceCarsQuery, GetMpPerformanceCarsQueryVariables>;
export function refetchGetMpPerformanceCarsQuery(variables: GetMpPerformanceCarsQueryVariables) {
      return { query: GetMpPerformanceCarsDocument, variables: variables }
    }
export const GetMpPerformanceFailuresDocument = gql`
    query GetMpPerformanceFailures($snapshotId: Int!, $mfgPartnerLevelFailuresInput: MfgPartnerLevelFailuresInput) {
  mfgPartnerLevelSnapshotDetails(snapshotId: $snapshotId) {
    failures(mfgPartnerLevelFailuresInput: $mfgPartnerLevelFailuresInput) {
      items {
        ...MfgPartnerLevelSnapshotDetails_Failures_Items
      }
      totalCount
    }
  }
}
    ${MfgPartnerLevelSnapshotDetails_Failures_ItemsFragmentDoc}`;

/**
 * __useGetMpPerformanceFailuresQuery__
 *
 * To run a query within a React component, call `useGetMpPerformanceFailuresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMpPerformanceFailuresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMpPerformanceFailuresQuery({
 *   variables: {
 *      snapshotId: // value for 'snapshotId'
 *      mfgPartnerLevelFailuresInput: // value for 'mfgPartnerLevelFailuresInput'
 *   },
 * });
 */
export function useGetMpPerformanceFailuresQuery(baseOptions: Apollo.QueryHookOptions<GetMpPerformanceFailuresQuery, GetMpPerformanceFailuresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMpPerformanceFailuresQuery, GetMpPerformanceFailuresQueryVariables>(GetMpPerformanceFailuresDocument, options);
      }
export function useGetMpPerformanceFailuresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMpPerformanceFailuresQuery, GetMpPerformanceFailuresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMpPerformanceFailuresQuery, GetMpPerformanceFailuresQueryVariables>(GetMpPerformanceFailuresDocument, options);
        }
export type GetMpPerformanceFailuresQueryHookResult = ReturnType<typeof useGetMpPerformanceFailuresQuery>;
export type GetMpPerformanceFailuresLazyQueryHookResult = ReturnType<typeof useGetMpPerformanceFailuresLazyQuery>;
export type GetMpPerformanceFailuresQueryResult = Apollo.QueryResult<GetMpPerformanceFailuresQuery, GetMpPerformanceFailuresQueryVariables>;
export function refetchGetMpPerformanceFailuresQuery(variables: GetMpPerformanceFailuresQueryVariables) {
      return { query: GetMpPerformanceFailuresDocument, variables: variables }
    }
export const GetMpPerformanceJobRequestsDocument = gql`
    query GetMpPerformanceJobRequests($snapshotId: Int!, $mfgPartnerLevelJobRequestInput: MfgPartnerLevelJobRequestInput) {
  mfgPartnerLevelSnapshotDetails(snapshotId: $snapshotId) {
    jobRequests(mfgPartnerLevelJobRequestInput: $mfgPartnerLevelJobRequestInput) {
      items {
        ...MfgPartnerLevelSnapshotDetails_JobRequests_Items
      }
      totalCount
    }
  }
}
    ${MfgPartnerLevelSnapshotDetails_JobRequests_ItemsFragmentDoc}`;

/**
 * __useGetMpPerformanceJobRequestsQuery__
 *
 * To run a query within a React component, call `useGetMpPerformanceJobRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMpPerformanceJobRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMpPerformanceJobRequestsQuery({
 *   variables: {
 *      snapshotId: // value for 'snapshotId'
 *      mfgPartnerLevelJobRequestInput: // value for 'mfgPartnerLevelJobRequestInput'
 *   },
 * });
 */
export function useGetMpPerformanceJobRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetMpPerformanceJobRequestsQuery, GetMpPerformanceJobRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMpPerformanceJobRequestsQuery, GetMpPerformanceJobRequestsQueryVariables>(GetMpPerformanceJobRequestsDocument, options);
      }
export function useGetMpPerformanceJobRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMpPerformanceJobRequestsQuery, GetMpPerformanceJobRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMpPerformanceJobRequestsQuery, GetMpPerformanceJobRequestsQueryVariables>(GetMpPerformanceJobRequestsDocument, options);
        }
export type GetMpPerformanceJobRequestsQueryHookResult = ReturnType<typeof useGetMpPerformanceJobRequestsQuery>;
export type GetMpPerformanceJobRequestsLazyQueryHookResult = ReturnType<typeof useGetMpPerformanceJobRequestsLazyQuery>;
export type GetMpPerformanceJobRequestsQueryResult = Apollo.QueryResult<GetMpPerformanceJobRequestsQuery, GetMpPerformanceJobRequestsQueryVariables>;
export function refetchGetMpPerformanceJobRequestsQuery(variables: GetMpPerformanceJobRequestsQueryVariables) {
      return { query: GetMpPerformanceJobRequestsDocument, variables: variables }
    }
export const GetMpPerformanceCarsForAutoOtDocument = gql`
    query GetMpPerformanceCarsForAutoOT($snapshotId: Int!, $mfgPartnerLevelCarsInput: MfgPartnerLevelCarsInput) {
  mfgPartnerLevelSnapshotDetails(snapshotId: $snapshotId) {
    correctiveActionRequests(mfgPartnerLevelCarsInput: $mfgPartnerLevelCarsInput) {
      items {
        ...MfgPartnerLevelSnapshotDetails_CAR_Items
      }
      totalCount
    }
  }
}
    ${MfgPartnerLevelSnapshotDetails_Car_ItemsFragmentDoc}`;

/**
 * __useGetMpPerformanceCarsForAutoOtQuery__
 *
 * To run a query within a React component, call `useGetMpPerformanceCarsForAutoOtQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMpPerformanceCarsForAutoOtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMpPerformanceCarsForAutoOtQuery({
 *   variables: {
 *      snapshotId: // value for 'snapshotId'
 *      mfgPartnerLevelCarsInput: // value for 'mfgPartnerLevelCarsInput'
 *   },
 * });
 */
export function useGetMpPerformanceCarsForAutoOtQuery(baseOptions: Apollo.QueryHookOptions<GetMpPerformanceCarsForAutoOtQuery, GetMpPerformanceCarsForAutoOtQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMpPerformanceCarsForAutoOtQuery, GetMpPerformanceCarsForAutoOtQueryVariables>(GetMpPerformanceCarsForAutoOtDocument, options);
      }
export function useGetMpPerformanceCarsForAutoOtLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMpPerformanceCarsForAutoOtQuery, GetMpPerformanceCarsForAutoOtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMpPerformanceCarsForAutoOtQuery, GetMpPerformanceCarsForAutoOtQueryVariables>(GetMpPerformanceCarsForAutoOtDocument, options);
        }
export type GetMpPerformanceCarsForAutoOtQueryHookResult = ReturnType<typeof useGetMpPerformanceCarsForAutoOtQuery>;
export type GetMpPerformanceCarsForAutoOtLazyQueryHookResult = ReturnType<typeof useGetMpPerformanceCarsForAutoOtLazyQuery>;
export type GetMpPerformanceCarsForAutoOtQueryResult = Apollo.QueryResult<GetMpPerformanceCarsForAutoOtQuery, GetMpPerformanceCarsForAutoOtQueryVariables>;
export function refetchGetMpPerformanceCarsForAutoOtQuery(variables: GetMpPerformanceCarsForAutoOtQueryVariables) {
      return { query: GetMpPerformanceCarsForAutoOtDocument, variables: variables }
    }
export const MpPerformanceSummaryDocument = gql`
    query MpPerformanceSummary($snapshotId: Int!) {
  mfgPartnerLevelSnapshotDetails(snapshotId: $snapshotId) {
    mfgPartner {
      id
      name
    }
    mfgPartnerLevel {
      recordType
      recordDate
      fromDate
      toDate
      mpLevel
      acceptanceLevel
      acceptanceRatio
      jobAcceptedCount
      jobSentCount
      jobAcceptedAmount
      expirationLevel
      expirationRatio
      jobExpiredCount
      jobExpiredAmount
      otRatio
      otLevel
      jobRequestLineItemsCount {
        otCount
        total
        ifCount
      }
      jobCompletedCount
      ifLevel
      ifRatio
      avgCarTurnaroundDays
      carLevel
    }
  }
}
    `;

/**
 * __useMpPerformanceSummaryQuery__
 *
 * To run a query within a React component, call `useMpPerformanceSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMpPerformanceSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMpPerformanceSummaryQuery({
 *   variables: {
 *      snapshotId: // value for 'snapshotId'
 *   },
 * });
 */
export function useMpPerformanceSummaryQuery(baseOptions: Apollo.QueryHookOptions<MpPerformanceSummaryQuery, MpPerformanceSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MpPerformanceSummaryQuery, MpPerformanceSummaryQueryVariables>(MpPerformanceSummaryDocument, options);
      }
export function useMpPerformanceSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MpPerformanceSummaryQuery, MpPerformanceSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MpPerformanceSummaryQuery, MpPerformanceSummaryQueryVariables>(MpPerformanceSummaryDocument, options);
        }
export type MpPerformanceSummaryQueryHookResult = ReturnType<typeof useMpPerformanceSummaryQuery>;
export type MpPerformanceSummaryLazyQueryHookResult = ReturnType<typeof useMpPerformanceSummaryLazyQuery>;
export type MpPerformanceSummaryQueryResult = Apollo.QueryResult<MpPerformanceSummaryQuery, MpPerformanceSummaryQueryVariables>;
export function refetchMpPerformanceSummaryQuery(variables: MpPerformanceSummaryQueryVariables) {
      return { query: MpPerformanceSummaryDocument, variables: variables }
    }
export const MpPerformanceJobRequestsDocument = gql`
    query MpPerformanceJobRequests($snapshotId: Int!, $mfgPartnerLevelJobRequestInput: MfgPartnerLevelJobRequestInput) {
  mfgPartnerLevelSnapshotDetails(snapshotId: $snapshotId) {
    jobRequests(mfgPartnerLevelJobRequestInput: $mfgPartnerLevelJobRequestInput) {
      items {
        jobId
        jobRequestName
        saleOrderName
        projectId
        projectName
        isSecurePlus
        priority
        jobRequestStatus
        acceptedAt
        expiresAt
        completedAt
        rejectedAt
      }
      totalCount
    }
  }
}
    `;

/**
 * __useMpPerformanceJobRequestsQuery__
 *
 * To run a query within a React component, call `useMpPerformanceJobRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMpPerformanceJobRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMpPerformanceJobRequestsQuery({
 *   variables: {
 *      snapshotId: // value for 'snapshotId'
 *      mfgPartnerLevelJobRequestInput: // value for 'mfgPartnerLevelJobRequestInput'
 *   },
 * });
 */
export function useMpPerformanceJobRequestsQuery(baseOptions: Apollo.QueryHookOptions<MpPerformanceJobRequestsQuery, MpPerformanceJobRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MpPerformanceJobRequestsQuery, MpPerformanceJobRequestsQueryVariables>(MpPerformanceJobRequestsDocument, options);
      }
export function useMpPerformanceJobRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MpPerformanceJobRequestsQuery, MpPerformanceJobRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MpPerformanceJobRequestsQuery, MpPerformanceJobRequestsQueryVariables>(MpPerformanceJobRequestsDocument, options);
        }
export type MpPerformanceJobRequestsQueryHookResult = ReturnType<typeof useMpPerformanceJobRequestsQuery>;
export type MpPerformanceJobRequestsLazyQueryHookResult = ReturnType<typeof useMpPerformanceJobRequestsLazyQuery>;
export type MpPerformanceJobRequestsQueryResult = Apollo.QueryResult<MpPerformanceJobRequestsQuery, MpPerformanceJobRequestsQueryVariables>;
export function refetchMpPerformanceJobRequestsQuery(variables: MpPerformanceJobRequestsQueryVariables) {
      return { query: MpPerformanceJobRequestsDocument, variables: variables }
    }
export const ResetMpLevelOverrideDocument = gql`
    mutation resetMpLevelOverride($partnerId: Int!) {
  deactivateMfgPartnerLevelOverride(partnerId: $partnerId)
}
    `;
export type ResetMpLevelOverrideMutationFn = Apollo.MutationFunction<ResetMpLevelOverrideMutation, ResetMpLevelOverrideMutationVariables>;

/**
 * __useResetMpLevelOverrideMutation__
 *
 * To run a mutation, you first call `useResetMpLevelOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetMpLevelOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetMpLevelOverrideMutation, { data, loading, error }] = useResetMpLevelOverrideMutation({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *   },
 * });
 */
export function useResetMpLevelOverrideMutation(baseOptions?: Apollo.MutationHookOptions<ResetMpLevelOverrideMutation, ResetMpLevelOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetMpLevelOverrideMutation, ResetMpLevelOverrideMutationVariables>(ResetMpLevelOverrideDocument, options);
      }
export type ResetMpLevelOverrideMutationHookResult = ReturnType<typeof useResetMpLevelOverrideMutation>;
export type ResetMpLevelOverrideMutationResult = Apollo.MutationResult<ResetMpLevelOverrideMutation>;
export type ResetMpLevelOverrideMutationOptions = Apollo.BaseMutationOptions<ResetMpLevelOverrideMutation, ResetMpLevelOverrideMutationVariables>;
export const SetMpLevelOverrideDocument = gql`
    mutation setMpLevelOverride($partnerId: Int!, $mpLevelOverride: MfgPartnerLevelType!, $expiresAt: Date!) {
  createMfgPartnerLevelOverride(
    partnerId: $partnerId
    mpLevelOverride: $mpLevelOverride
    expiresAt: $expiresAt
  ) {
    id
  }
}
    `;
export type SetMpLevelOverrideMutationFn = Apollo.MutationFunction<SetMpLevelOverrideMutation, SetMpLevelOverrideMutationVariables>;

/**
 * __useSetMpLevelOverrideMutation__
 *
 * To run a mutation, you first call `useSetMpLevelOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMpLevelOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMpLevelOverrideMutation, { data, loading, error }] = useSetMpLevelOverrideMutation({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      mpLevelOverride: // value for 'mpLevelOverride'
 *      expiresAt: // value for 'expiresAt'
 *   },
 * });
 */
export function useSetMpLevelOverrideMutation(baseOptions?: Apollo.MutationHookOptions<SetMpLevelOverrideMutation, SetMpLevelOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMpLevelOverrideMutation, SetMpLevelOverrideMutationVariables>(SetMpLevelOverrideDocument, options);
      }
export type SetMpLevelOverrideMutationHookResult = ReturnType<typeof useSetMpLevelOverrideMutation>;
export type SetMpLevelOverrideMutationResult = Apollo.MutationResult<SetMpLevelOverrideMutation>;
export type SetMpLevelOverrideMutationOptions = Apollo.BaseMutationOptions<SetMpLevelOverrideMutation, SetMpLevelOverrideMutationVariables>;
export const CreateCorrectiveActionRequestAttachmentDocument = gql`
    mutation createCorrectiveActionRequestAttachment($input: CorrectiveActionRequestAttachmentInput!) {
  createCorrectiveActionRequestAttachment(input: $input) {
    id
    correctiveActionRequestId
    attachment {
      id
      uploadUrl
      fileName
      extension
      mimeType
    }
  }
}
    `;
export type CreateCorrectiveActionRequestAttachmentMutationFn = Apollo.MutationFunction<CreateCorrectiveActionRequestAttachmentMutation, CreateCorrectiveActionRequestAttachmentMutationVariables>;

/**
 * __useCreateCorrectiveActionRequestAttachmentMutation__
 *
 * To run a mutation, you first call `useCreateCorrectiveActionRequestAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCorrectiveActionRequestAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCorrectiveActionRequestAttachmentMutation, { data, loading, error }] = useCreateCorrectiveActionRequestAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCorrectiveActionRequestAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCorrectiveActionRequestAttachmentMutation, CreateCorrectiveActionRequestAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCorrectiveActionRequestAttachmentMutation, CreateCorrectiveActionRequestAttachmentMutationVariables>(CreateCorrectiveActionRequestAttachmentDocument, options);
      }
export type CreateCorrectiveActionRequestAttachmentMutationHookResult = ReturnType<typeof useCreateCorrectiveActionRequestAttachmentMutation>;
export type CreateCorrectiveActionRequestAttachmentMutationResult = Apollo.MutationResult<CreateCorrectiveActionRequestAttachmentMutation>;
export type CreateCorrectiveActionRequestAttachmentMutationOptions = Apollo.BaseMutationOptions<CreateCorrectiveActionRequestAttachmentMutation, CreateCorrectiveActionRequestAttachmentMutationVariables>;
export const CancelCorrectiveActionRequestDocument = gql`
    mutation CancelCorrectiveActionRequest($correctiveActionRequestId: String!, $reason: ManualCarCancelationReasons!, $rootCauseReasons: [Int!]) {
  cancelCorrectiveActionRequest(
    id: $correctiveActionRequestId
    reason: $reason
    rootCauseReasons: $rootCauseReasons
  )
}
    `;
export type CancelCorrectiveActionRequestMutationFn = Apollo.MutationFunction<CancelCorrectiveActionRequestMutation, CancelCorrectiveActionRequestMutationVariables>;

/**
 * __useCancelCorrectiveActionRequestMutation__
 *
 * To run a mutation, you first call `useCancelCorrectiveActionRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelCorrectiveActionRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelCorrectiveActionRequestMutation, { data, loading, error }] = useCancelCorrectiveActionRequestMutation({
 *   variables: {
 *      correctiveActionRequestId: // value for 'correctiveActionRequestId'
 *      reason: // value for 'reason'
 *      rootCauseReasons: // value for 'rootCauseReasons'
 *   },
 * });
 */
export function useCancelCorrectiveActionRequestMutation(baseOptions?: Apollo.MutationHookOptions<CancelCorrectiveActionRequestMutation, CancelCorrectiveActionRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelCorrectiveActionRequestMutation, CancelCorrectiveActionRequestMutationVariables>(CancelCorrectiveActionRequestDocument, options);
      }
export type CancelCorrectiveActionRequestMutationHookResult = ReturnType<typeof useCancelCorrectiveActionRequestMutation>;
export type CancelCorrectiveActionRequestMutationResult = Apollo.MutationResult<CancelCorrectiveActionRequestMutation>;
export type CancelCorrectiveActionRequestMutationOptions = Apollo.BaseMutationOptions<CancelCorrectiveActionRequestMutation, CancelCorrectiveActionRequestMutationVariables>;
export const CorrectiveActionRequestResponseOptionsDocument = gql`
    query CorrectiveActionRequestResponseOptions($correctiveActionRequestQuestion: CorrectiveActionRequestQuestionType!) {
  correctiveActionRequestResponseOptions(
    correctiveActionRequestQuestion: $correctiveActionRequestQuestion
  ) {
    id
    description
  }
}
    `;

/**
 * __useCorrectiveActionRequestResponseOptionsQuery__
 *
 * To run a query within a React component, call `useCorrectiveActionRequestResponseOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorrectiveActionRequestResponseOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorrectiveActionRequestResponseOptionsQuery({
 *   variables: {
 *      correctiveActionRequestQuestion: // value for 'correctiveActionRequestQuestion'
 *   },
 * });
 */
export function useCorrectiveActionRequestResponseOptionsQuery(baseOptions: Apollo.QueryHookOptions<CorrectiveActionRequestResponseOptionsQuery, CorrectiveActionRequestResponseOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CorrectiveActionRequestResponseOptionsQuery, CorrectiveActionRequestResponseOptionsQueryVariables>(CorrectiveActionRequestResponseOptionsDocument, options);
      }
export function useCorrectiveActionRequestResponseOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CorrectiveActionRequestResponseOptionsQuery, CorrectiveActionRequestResponseOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CorrectiveActionRequestResponseOptionsQuery, CorrectiveActionRequestResponseOptionsQueryVariables>(CorrectiveActionRequestResponseOptionsDocument, options);
        }
export type CorrectiveActionRequestResponseOptionsQueryHookResult = ReturnType<typeof useCorrectiveActionRequestResponseOptionsQuery>;
export type CorrectiveActionRequestResponseOptionsLazyQueryHookResult = ReturnType<typeof useCorrectiveActionRequestResponseOptionsLazyQuery>;
export type CorrectiveActionRequestResponseOptionsQueryResult = Apollo.QueryResult<CorrectiveActionRequestResponseOptionsQuery, CorrectiveActionRequestResponseOptionsQueryVariables>;
export function refetchCorrectiveActionRequestResponseOptionsQuery(variables: CorrectiveActionRequestResponseOptionsQueryVariables) {
      return { query: CorrectiveActionRequestResponseOptionsDocument, variables: variables }
    }
export const RemoveCorrectiveActionRequestAttachmentDocument = gql`
    mutation removeCorrectiveActionRequestAttachment($removeCorrectiveActionRequestAttachmentId: UUID!) {
  removeCorrectiveActionRequestAttachment(
    id: $removeCorrectiveActionRequestAttachmentId
  )
}
    `;
export type RemoveCorrectiveActionRequestAttachmentMutationFn = Apollo.MutationFunction<RemoveCorrectiveActionRequestAttachmentMutation, RemoveCorrectiveActionRequestAttachmentMutationVariables>;

/**
 * __useRemoveCorrectiveActionRequestAttachmentMutation__
 *
 * To run a mutation, you first call `useRemoveCorrectiveActionRequestAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCorrectiveActionRequestAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCorrectiveActionRequestAttachmentMutation, { data, loading, error }] = useRemoveCorrectiveActionRequestAttachmentMutation({
 *   variables: {
 *      removeCorrectiveActionRequestAttachmentId: // value for 'removeCorrectiveActionRequestAttachmentId'
 *   },
 * });
 */
export function useRemoveCorrectiveActionRequestAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCorrectiveActionRequestAttachmentMutation, RemoveCorrectiveActionRequestAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCorrectiveActionRequestAttachmentMutation, RemoveCorrectiveActionRequestAttachmentMutationVariables>(RemoveCorrectiveActionRequestAttachmentDocument, options);
      }
export type RemoveCorrectiveActionRequestAttachmentMutationHookResult = ReturnType<typeof useRemoveCorrectiveActionRequestAttachmentMutation>;
export type RemoveCorrectiveActionRequestAttachmentMutationResult = Apollo.MutationResult<RemoveCorrectiveActionRequestAttachmentMutation>;
export type RemoveCorrectiveActionRequestAttachmentMutationOptions = Apollo.BaseMutationOptions<RemoveCorrectiveActionRequestAttachmentMutation, RemoveCorrectiveActionRequestAttachmentMutationVariables>;
export const MarkCorrectiveActionRequestAttachmentVisibilityDocument = gql`
    mutation MarkCorrectiveActionRequestAttachmentVisibility($correctiveActionRequestAttachmentId: UUID!, $correctiveActionRequestId: UUID!, $isVisible: Boolean!) {
  markCorrectiveActionRequestAttachmentVisibility(
    correctiveActionRequestAttachmentId: $correctiveActionRequestAttachmentId
    correctiveActionRequestId: $correctiveActionRequestId
    isVisible: $isVisible
  )
}
    `;
export type MarkCorrectiveActionRequestAttachmentVisibilityMutationFn = Apollo.MutationFunction<MarkCorrectiveActionRequestAttachmentVisibilityMutation, MarkCorrectiveActionRequestAttachmentVisibilityMutationVariables>;

/**
 * __useMarkCorrectiveActionRequestAttachmentVisibilityMutation__
 *
 * To run a mutation, you first call `useMarkCorrectiveActionRequestAttachmentVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkCorrectiveActionRequestAttachmentVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markCorrectiveActionRequestAttachmentVisibilityMutation, { data, loading, error }] = useMarkCorrectiveActionRequestAttachmentVisibilityMutation({
 *   variables: {
 *      correctiveActionRequestAttachmentId: // value for 'correctiveActionRequestAttachmentId'
 *      correctiveActionRequestId: // value for 'correctiveActionRequestId'
 *      isVisible: // value for 'isVisible'
 *   },
 * });
 */
export function useMarkCorrectiveActionRequestAttachmentVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<MarkCorrectiveActionRequestAttachmentVisibilityMutation, MarkCorrectiveActionRequestAttachmentVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkCorrectiveActionRequestAttachmentVisibilityMutation, MarkCorrectiveActionRequestAttachmentVisibilityMutationVariables>(MarkCorrectiveActionRequestAttachmentVisibilityDocument, options);
      }
export type MarkCorrectiveActionRequestAttachmentVisibilityMutationHookResult = ReturnType<typeof useMarkCorrectiveActionRequestAttachmentVisibilityMutation>;
export type MarkCorrectiveActionRequestAttachmentVisibilityMutationResult = Apollo.MutationResult<MarkCorrectiveActionRequestAttachmentVisibilityMutation>;
export type MarkCorrectiveActionRequestAttachmentVisibilityMutationOptions = Apollo.BaseMutationOptions<MarkCorrectiveActionRequestAttachmentVisibilityMutation, MarkCorrectiveActionRequestAttachmentVisibilityMutationVariables>;
export const CorrectiveActionRequestDetailsQueryDocument = gql`
    query CorrectiveActionRequestDetailsQuery($correctiveActionRequestId: UUID!) {
  correctiveActionRequest(id: $correctiveActionRequestId) {
    id
    name
    type
    status
    reworkText
    supplierQualityEngineer {
      id
      displayName
    }
    assignee {
      id
      displayName
    }
    mfgPartner {
      id
      name
      displayName
    }
    businessUnit
    salesOrder {
      id
      name
      customerName
      customerCompanyName
      salesOrderLines {
        items {
          processName
        }
      }
    }
    questionnaire {
      id
      question
      response {
        responseText
        sanitizedResponseText
        selectedOptions {
          id
          description
          active
        }
      }
    }
    dueAt
    createdAt
    viewedAt
    submittedAt
    approvedAt
    closedAt
    canceledAt
    cancelationReason
    sentForReworkAt
    sentAt
    attachments {
      id
      visibleToCustomer
      attachment {
        id
        downloadUrl
        uploadUrl
        fileName
        mimeType
      }
      source
      correctiveActionRequestId
    }
    exceptionDetails {
      id
      name
      otifIsActive
      otFailureFictiv
      otFailureFictivDays
      otFailureMP
      otFailureMPDays
      otFailureCustomer
      otFailureCustomerDays
      ifFailureFictiv
      ifFailureMP
      ifFailureCustomer
      failureDiscoveredBy
      additionalContext
      exceptionParts {
        id
        lines
      }
      jobRequest {
        id
        name
        jobId
      }
      nonConformanceAttachments {
        id
        attachment {
          id
          mimeType
          downloadUrl
        }
      }
    }
    history {
      id
      objectType
      objectId
      contextKey
      oldValue
      newValue
      message
      createdBy {
        id
        displayName
      }
      createdAt
    }
    associatedExceptionFailureTypes
    associatedExceptionFailures {
      id
      name
      exceptionFailureState
      milestoneType
      type
      assignedEntity
      additionalContext
      exceptionFailureAttachments {
        id
        attachment {
          id
          mimeType
          downloadUrl
        }
      }
      exceptionFailureParts {
        id
        lines
        failedQuantity
        partName
      }
      isCustomerImpacted
    }
    job {
      id
      status
      name
      payout
    }
  }
}
    `;

/**
 * __useCorrectiveActionRequestDetailsQueryQuery__
 *
 * To run a query within a React component, call `useCorrectiveActionRequestDetailsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorrectiveActionRequestDetailsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorrectiveActionRequestDetailsQueryQuery({
 *   variables: {
 *      correctiveActionRequestId: // value for 'correctiveActionRequestId'
 *   },
 * });
 */
export function useCorrectiveActionRequestDetailsQueryQuery(baseOptions: Apollo.QueryHookOptions<CorrectiveActionRequestDetailsQueryQuery, CorrectiveActionRequestDetailsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CorrectiveActionRequestDetailsQueryQuery, CorrectiveActionRequestDetailsQueryQueryVariables>(CorrectiveActionRequestDetailsQueryDocument, options);
      }
export function useCorrectiveActionRequestDetailsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CorrectiveActionRequestDetailsQueryQuery, CorrectiveActionRequestDetailsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CorrectiveActionRequestDetailsQueryQuery, CorrectiveActionRequestDetailsQueryQueryVariables>(CorrectiveActionRequestDetailsQueryDocument, options);
        }
export type CorrectiveActionRequestDetailsQueryQueryHookResult = ReturnType<typeof useCorrectiveActionRequestDetailsQueryQuery>;
export type CorrectiveActionRequestDetailsQueryLazyQueryHookResult = ReturnType<typeof useCorrectiveActionRequestDetailsQueryLazyQuery>;
export type CorrectiveActionRequestDetailsQueryQueryResult = Apollo.QueryResult<CorrectiveActionRequestDetailsQueryQuery, CorrectiveActionRequestDetailsQueryQueryVariables>;
export function refetchCorrectiveActionRequestDetailsQueryQuery(variables: CorrectiveActionRequestDetailsQueryQueryVariables) {
      return { query: CorrectiveActionRequestDetailsQueryDocument, variables: variables }
    }
export const PotentialCorrectiveActionRequestAssigneesDocument = gql`
    query PotentialCorrectiveActionRequestAssignees {
  activeCorrectiveActionRequestAssignees {
    id
    displayName
  }
}
    `;

/**
 * __usePotentialCorrectiveActionRequestAssigneesQuery__
 *
 * To run a query within a React component, call `usePotentialCorrectiveActionRequestAssigneesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePotentialCorrectiveActionRequestAssigneesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePotentialCorrectiveActionRequestAssigneesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePotentialCorrectiveActionRequestAssigneesQuery(baseOptions?: Apollo.QueryHookOptions<PotentialCorrectiveActionRequestAssigneesQuery, PotentialCorrectiveActionRequestAssigneesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PotentialCorrectiveActionRequestAssigneesQuery, PotentialCorrectiveActionRequestAssigneesQueryVariables>(PotentialCorrectiveActionRequestAssigneesDocument, options);
      }
export function usePotentialCorrectiveActionRequestAssigneesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PotentialCorrectiveActionRequestAssigneesQuery, PotentialCorrectiveActionRequestAssigneesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PotentialCorrectiveActionRequestAssigneesQuery, PotentialCorrectiveActionRequestAssigneesQueryVariables>(PotentialCorrectiveActionRequestAssigneesDocument, options);
        }
export type PotentialCorrectiveActionRequestAssigneesQueryHookResult = ReturnType<typeof usePotentialCorrectiveActionRequestAssigneesQuery>;
export type PotentialCorrectiveActionRequestAssigneesLazyQueryHookResult = ReturnType<typeof usePotentialCorrectiveActionRequestAssigneesLazyQuery>;
export type PotentialCorrectiveActionRequestAssigneesQueryResult = Apollo.QueryResult<PotentialCorrectiveActionRequestAssigneesQuery, PotentialCorrectiveActionRequestAssigneesQueryVariables>;
export function refetchPotentialCorrectiveActionRequestAssigneesQuery(variables?: PotentialCorrectiveActionRequestAssigneesQueryVariables) {
      return { query: PotentialCorrectiveActionRequestAssigneesDocument, variables: variables }
    }
export const PotentialSupplierQualityEngineersDocument = gql`
    query PotentialSupplierQualityEngineers {
  activeSupplierQualityEngineers {
    id
    displayName
  }
}
    `;

/**
 * __usePotentialSupplierQualityEngineersQuery__
 *
 * To run a query within a React component, call `usePotentialSupplierQualityEngineersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePotentialSupplierQualityEngineersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePotentialSupplierQualityEngineersQuery({
 *   variables: {
 *   },
 * });
 */
export function usePotentialSupplierQualityEngineersQuery(baseOptions?: Apollo.QueryHookOptions<PotentialSupplierQualityEngineersQuery, PotentialSupplierQualityEngineersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PotentialSupplierQualityEngineersQuery, PotentialSupplierQualityEngineersQueryVariables>(PotentialSupplierQualityEngineersDocument, options);
      }
export function usePotentialSupplierQualityEngineersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PotentialSupplierQualityEngineersQuery, PotentialSupplierQualityEngineersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PotentialSupplierQualityEngineersQuery, PotentialSupplierQualityEngineersQueryVariables>(PotentialSupplierQualityEngineersDocument, options);
        }
export type PotentialSupplierQualityEngineersQueryHookResult = ReturnType<typeof usePotentialSupplierQualityEngineersQuery>;
export type PotentialSupplierQualityEngineersLazyQueryHookResult = ReturnType<typeof usePotentialSupplierQualityEngineersLazyQuery>;
export type PotentialSupplierQualityEngineersQueryResult = Apollo.QueryResult<PotentialSupplierQualityEngineersQuery, PotentialSupplierQualityEngineersQueryVariables>;
export function refetchPotentialSupplierQualityEngineersQuery(variables?: PotentialSupplierQualityEngineersQueryVariables) {
      return { query: PotentialSupplierQualityEngineersDocument, variables: variables }
    }
export const UpdateCorrectiveActionRequestAssigneeDocument = gql`
    mutation UpdateCorrectiveActionRequestAssignee($correctiveActionRequestId: UUID!, $assigneeId: Int!) {
  updateCorrectiveActionRequestAssignee(
    id: $correctiveActionRequestId
    assigneeId: $assigneeId
  ) {
    id
    name
  }
}
    `;
export type UpdateCorrectiveActionRequestAssigneeMutationFn = Apollo.MutationFunction<UpdateCorrectiveActionRequestAssigneeMutation, UpdateCorrectiveActionRequestAssigneeMutationVariables>;

/**
 * __useUpdateCorrectiveActionRequestAssigneeMutation__
 *
 * To run a mutation, you first call `useUpdateCorrectiveActionRequestAssigneeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCorrectiveActionRequestAssigneeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCorrectiveActionRequestAssigneeMutation, { data, loading, error }] = useUpdateCorrectiveActionRequestAssigneeMutation({
 *   variables: {
 *      correctiveActionRequestId: // value for 'correctiveActionRequestId'
 *      assigneeId: // value for 'assigneeId'
 *   },
 * });
 */
export function useUpdateCorrectiveActionRequestAssigneeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCorrectiveActionRequestAssigneeMutation, UpdateCorrectiveActionRequestAssigneeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCorrectiveActionRequestAssigneeMutation, UpdateCorrectiveActionRequestAssigneeMutationVariables>(UpdateCorrectiveActionRequestAssigneeDocument, options);
      }
export type UpdateCorrectiveActionRequestAssigneeMutationHookResult = ReturnType<typeof useUpdateCorrectiveActionRequestAssigneeMutation>;
export type UpdateCorrectiveActionRequestAssigneeMutationResult = Apollo.MutationResult<UpdateCorrectiveActionRequestAssigneeMutation>;
export type UpdateCorrectiveActionRequestAssigneeMutationOptions = Apollo.BaseMutationOptions<UpdateCorrectiveActionRequestAssigneeMutation, UpdateCorrectiveActionRequestAssigneeMutationVariables>;
export const UpdateCarSupplierQualityEngineerDocument = gql`
    mutation UpdateCarSupplierQualityEngineer($correctiveActionRequestId: String!, $supplierQualityEngineerId: Int!) {
  updateCarSupplierQualityEngineer(
    id: $correctiveActionRequestId
    supplierQualityEngineerId: $supplierQualityEngineerId
  ) {
    id
    name
  }
}
    `;
export type UpdateCarSupplierQualityEngineerMutationFn = Apollo.MutationFunction<UpdateCarSupplierQualityEngineerMutation, UpdateCarSupplierQualityEngineerMutationVariables>;

/**
 * __useUpdateCarSupplierQualityEngineerMutation__
 *
 * To run a mutation, you first call `useUpdateCarSupplierQualityEngineerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarSupplierQualityEngineerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCarSupplierQualityEngineerMutation, { data, loading, error }] = useUpdateCarSupplierQualityEngineerMutation({
 *   variables: {
 *      correctiveActionRequestId: // value for 'correctiveActionRequestId'
 *      supplierQualityEngineerId: // value for 'supplierQualityEngineerId'
 *   },
 * });
 */
export function useUpdateCarSupplierQualityEngineerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCarSupplierQualityEngineerMutation, UpdateCarSupplierQualityEngineerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCarSupplierQualityEngineerMutation, UpdateCarSupplierQualityEngineerMutationVariables>(UpdateCarSupplierQualityEngineerDocument, options);
      }
export type UpdateCarSupplierQualityEngineerMutationHookResult = ReturnType<typeof useUpdateCarSupplierQualityEngineerMutation>;
export type UpdateCarSupplierQualityEngineerMutationResult = Apollo.MutationResult<UpdateCarSupplierQualityEngineerMutation>;
export type UpdateCarSupplierQualityEngineerMutationOptions = Apollo.BaseMutationOptions<UpdateCarSupplierQualityEngineerMutation, UpdateCarSupplierQualityEngineerMutationVariables>;
export const UpdateCorrectiveActionRequestStatusDocument = gql`
    mutation UpdateCorrectiveActionRequestStatus($correctiveActionRequestId: UUID!, $status: CorrectiveActionRequestStatus!, $reworkReason: String) {
  updateCorrectiveActionRequestStatus(
    id: $correctiveActionRequestId
    status: $status
    reworkReason: $reworkReason
  ) {
    id
    name
    status
  }
}
    `;
export type UpdateCorrectiveActionRequestStatusMutationFn = Apollo.MutationFunction<UpdateCorrectiveActionRequestStatusMutation, UpdateCorrectiveActionRequestStatusMutationVariables>;

/**
 * __useUpdateCorrectiveActionRequestStatusMutation__
 *
 * To run a mutation, you first call `useUpdateCorrectiveActionRequestStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCorrectiveActionRequestStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCorrectiveActionRequestStatusMutation, { data, loading, error }] = useUpdateCorrectiveActionRequestStatusMutation({
 *   variables: {
 *      correctiveActionRequestId: // value for 'correctiveActionRequestId'
 *      status: // value for 'status'
 *      reworkReason: // value for 'reworkReason'
 *   },
 * });
 */
export function useUpdateCorrectiveActionRequestStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCorrectiveActionRequestStatusMutation, UpdateCorrectiveActionRequestStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCorrectiveActionRequestStatusMutation, UpdateCorrectiveActionRequestStatusMutationVariables>(UpdateCorrectiveActionRequestStatusDocument, options);
      }
export type UpdateCorrectiveActionRequestStatusMutationHookResult = ReturnType<typeof useUpdateCorrectiveActionRequestStatusMutation>;
export type UpdateCorrectiveActionRequestStatusMutationResult = Apollo.MutationResult<UpdateCorrectiveActionRequestStatusMutation>;
export type UpdateCorrectiveActionRequestStatusMutationOptions = Apollo.BaseMutationOptions<UpdateCorrectiveActionRequestStatusMutation, UpdateCorrectiveActionRequestStatusMutationVariables>;
export const SaveCorrectiveActionRequestQuestionResponseDocument = gql`
    mutation saveCorrectiveActionRequestQuestionResponse($correctiveActionRequestId: UUID!, $question: CorrectiveActionRequestQuestionType!, $selectedOptions: [Int!], $responseText: String) {
  saveCorrectiveActionRequestResponse(
    correctiveActionRequestId: $correctiveActionRequestId
    question: $question
    selectedOptions: $selectedOptions
    responseText: $responseText
  )
}
    `;
export type SaveCorrectiveActionRequestQuestionResponseMutationFn = Apollo.MutationFunction<SaveCorrectiveActionRequestQuestionResponseMutation, SaveCorrectiveActionRequestQuestionResponseMutationVariables>;

/**
 * __useSaveCorrectiveActionRequestQuestionResponseMutation__
 *
 * To run a mutation, you first call `useSaveCorrectiveActionRequestQuestionResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCorrectiveActionRequestQuestionResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCorrectiveActionRequestQuestionResponseMutation, { data, loading, error }] = useSaveCorrectiveActionRequestQuestionResponseMutation({
 *   variables: {
 *      correctiveActionRequestId: // value for 'correctiveActionRequestId'
 *      question: // value for 'question'
 *      selectedOptions: // value for 'selectedOptions'
 *      responseText: // value for 'responseText'
 *   },
 * });
 */
export function useSaveCorrectiveActionRequestQuestionResponseMutation(baseOptions?: Apollo.MutationHookOptions<SaveCorrectiveActionRequestQuestionResponseMutation, SaveCorrectiveActionRequestQuestionResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCorrectiveActionRequestQuestionResponseMutation, SaveCorrectiveActionRequestQuestionResponseMutationVariables>(SaveCorrectiveActionRequestQuestionResponseDocument, options);
      }
export type SaveCorrectiveActionRequestQuestionResponseMutationHookResult = ReturnType<typeof useSaveCorrectiveActionRequestQuestionResponseMutation>;
export type SaveCorrectiveActionRequestQuestionResponseMutationResult = Apollo.MutationResult<SaveCorrectiveActionRequestQuestionResponseMutation>;
export type SaveCorrectiveActionRequestQuestionResponseMutationOptions = Apollo.BaseMutationOptions<SaveCorrectiveActionRequestQuestionResponseMutation, SaveCorrectiveActionRequestQuestionResponseMutationVariables>;
export const SanitizeCorrectiveActionRequestResponseDocument = gql`
    mutation SanitizeCorrectiveActionRequestResponse($sanitizeCorrectiveActionRequestResponseId: Int!, $correctiveActionRequestId: UUID!, $sanitizedResponseText: String!) {
  sanitizeCorrectiveActionRequestResponse(
    id: $sanitizeCorrectiveActionRequestResponseId
    correctiveActionRequestId: $correctiveActionRequestId
    sanitizedResponseText: $sanitizedResponseText
  ) {
    responseText
    sanitizedResponseText
  }
}
    `;
export type SanitizeCorrectiveActionRequestResponseMutationFn = Apollo.MutationFunction<SanitizeCorrectiveActionRequestResponseMutation, SanitizeCorrectiveActionRequestResponseMutationVariables>;

/**
 * __useSanitizeCorrectiveActionRequestResponseMutation__
 *
 * To run a mutation, you first call `useSanitizeCorrectiveActionRequestResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSanitizeCorrectiveActionRequestResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sanitizeCorrectiveActionRequestResponseMutation, { data, loading, error }] = useSanitizeCorrectiveActionRequestResponseMutation({
 *   variables: {
 *      sanitizeCorrectiveActionRequestResponseId: // value for 'sanitizeCorrectiveActionRequestResponseId'
 *      correctiveActionRequestId: // value for 'correctiveActionRequestId'
 *      sanitizedResponseText: // value for 'sanitizedResponseText'
 *   },
 * });
 */
export function useSanitizeCorrectiveActionRequestResponseMutation(baseOptions?: Apollo.MutationHookOptions<SanitizeCorrectiveActionRequestResponseMutation, SanitizeCorrectiveActionRequestResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SanitizeCorrectiveActionRequestResponseMutation, SanitizeCorrectiveActionRequestResponseMutationVariables>(SanitizeCorrectiveActionRequestResponseDocument, options);
      }
export type SanitizeCorrectiveActionRequestResponseMutationHookResult = ReturnType<typeof useSanitizeCorrectiveActionRequestResponseMutation>;
export type SanitizeCorrectiveActionRequestResponseMutationResult = Apollo.MutationResult<SanitizeCorrectiveActionRequestResponseMutation>;
export type SanitizeCorrectiveActionRequestResponseMutationOptions = Apollo.BaseMutationOptions<SanitizeCorrectiveActionRequestResponseMutation, SanitizeCorrectiveActionRequestResponseMutationVariables>;
export const RemoveSanitizedCorrectiveActionResponseDocument = gql`
    mutation RemoveSanitizedCorrectiveActionResponse($correctiveActionRequestId: UUID!, $removeSanitizedCorrectiveActionResponseId: Int!) {
  removeSanitizedCorrectiveActionResponse(
    correctiveActionRequestId: $correctiveActionRequestId
    id: $removeSanitizedCorrectiveActionResponseId
  ) {
    responseText
    sanitizedResponseText
  }
}
    `;
export type RemoveSanitizedCorrectiveActionResponseMutationFn = Apollo.MutationFunction<RemoveSanitizedCorrectiveActionResponseMutation, RemoveSanitizedCorrectiveActionResponseMutationVariables>;

/**
 * __useRemoveSanitizedCorrectiveActionResponseMutation__
 *
 * To run a mutation, you first call `useRemoveSanitizedCorrectiveActionResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSanitizedCorrectiveActionResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSanitizedCorrectiveActionResponseMutation, { data, loading, error }] = useRemoveSanitizedCorrectiveActionResponseMutation({
 *   variables: {
 *      correctiveActionRequestId: // value for 'correctiveActionRequestId'
 *      removeSanitizedCorrectiveActionResponseId: // value for 'removeSanitizedCorrectiveActionResponseId'
 *   },
 * });
 */
export function useRemoveSanitizedCorrectiveActionResponseMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSanitizedCorrectiveActionResponseMutation, RemoveSanitizedCorrectiveActionResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSanitizedCorrectiveActionResponseMutation, RemoveSanitizedCorrectiveActionResponseMutationVariables>(RemoveSanitizedCorrectiveActionResponseDocument, options);
      }
export type RemoveSanitizedCorrectiveActionResponseMutationHookResult = ReturnType<typeof useRemoveSanitizedCorrectiveActionResponseMutation>;
export type RemoveSanitizedCorrectiveActionResponseMutationResult = Apollo.MutationResult<RemoveSanitizedCorrectiveActionResponseMutation>;
export type RemoveSanitizedCorrectiveActionResponseMutationOptions = Apollo.BaseMutationOptions<RemoveSanitizedCorrectiveActionResponseMutation, RemoveSanitizedCorrectiveActionResponseMutationVariables>;
export const CorrectiveActionRequestListDocument = gql`
    query CorrectiveActionRequestList($limit: Int, $offset: Int, $filters: CorrectiveActionRequestFilterInput, $sort: CorrectiveActionRequestSortInput) {
  correctiveActionRequests(
    limit: $limit
    offset: $offset
    filters: $filters
    sort: $sort
  ) {
    items {
      id
      name
      type
      status
      exception {
        id
        name
        exceptionState
        otFailureFictiv
        ifFailureFictiv
        otFailureMp
        ifFailureMp
      }
      erpSaleOrderId
      salesOrderName
      jobRequestName
      jobRequestId
      createdAt
      updatedAt
      viewedAt
      submittedAt
      approvedAt
      closedAt
      canceledAt
      sentForReworkAt
      dueAt
      sentAt
      mfgPartner {
        id
        name
      }
      supplierQualityEngineer {
        id
        displayName
      }
      assignee {
        id
        displayName
      }
    }
    totalCount
  }
}
    `;

/**
 * __useCorrectiveActionRequestListQuery__
 *
 * To run a query within a React component, call `useCorrectiveActionRequestListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorrectiveActionRequestListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorrectiveActionRequestListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCorrectiveActionRequestListQuery(baseOptions?: Apollo.QueryHookOptions<CorrectiveActionRequestListQuery, CorrectiveActionRequestListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CorrectiveActionRequestListQuery, CorrectiveActionRequestListQueryVariables>(CorrectiveActionRequestListDocument, options);
      }
export function useCorrectiveActionRequestListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CorrectiveActionRequestListQuery, CorrectiveActionRequestListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CorrectiveActionRequestListQuery, CorrectiveActionRequestListQueryVariables>(CorrectiveActionRequestListDocument, options);
        }
export type CorrectiveActionRequestListQueryHookResult = ReturnType<typeof useCorrectiveActionRequestListQuery>;
export type CorrectiveActionRequestListLazyQueryHookResult = ReturnType<typeof useCorrectiveActionRequestListLazyQuery>;
export type CorrectiveActionRequestListQueryResult = Apollo.QueryResult<CorrectiveActionRequestListQuery, CorrectiveActionRequestListQueryVariables>;
export function refetchCorrectiveActionRequestListQuery(variables?: CorrectiveActionRequestListQueryVariables) {
      return { query: CorrectiveActionRequestListDocument, variables: variables }
    }
export const AssignedCorrectiveActionRequestMfgPartnersDocument = gql`
    query AssignedCorrectiveActionRequestMfgPartners($sort: MfgPartnerSortInput) {
  assignedCorrectiveActionRequestMfgPartners(sort: $sort) {
    id
    name
  }
}
    `;

/**
 * __useAssignedCorrectiveActionRequestMfgPartnersQuery__
 *
 * To run a query within a React component, call `useAssignedCorrectiveActionRequestMfgPartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignedCorrectiveActionRequestMfgPartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignedCorrectiveActionRequestMfgPartnersQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAssignedCorrectiveActionRequestMfgPartnersQuery(baseOptions?: Apollo.QueryHookOptions<AssignedCorrectiveActionRequestMfgPartnersQuery, AssignedCorrectiveActionRequestMfgPartnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssignedCorrectiveActionRequestMfgPartnersQuery, AssignedCorrectiveActionRequestMfgPartnersQueryVariables>(AssignedCorrectiveActionRequestMfgPartnersDocument, options);
      }
export function useAssignedCorrectiveActionRequestMfgPartnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssignedCorrectiveActionRequestMfgPartnersQuery, AssignedCorrectiveActionRequestMfgPartnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssignedCorrectiveActionRequestMfgPartnersQuery, AssignedCorrectiveActionRequestMfgPartnersQueryVariables>(AssignedCorrectiveActionRequestMfgPartnersDocument, options);
        }
export type AssignedCorrectiveActionRequestMfgPartnersQueryHookResult = ReturnType<typeof useAssignedCorrectiveActionRequestMfgPartnersQuery>;
export type AssignedCorrectiveActionRequestMfgPartnersLazyQueryHookResult = ReturnType<typeof useAssignedCorrectiveActionRequestMfgPartnersLazyQuery>;
export type AssignedCorrectiveActionRequestMfgPartnersQueryResult = Apollo.QueryResult<AssignedCorrectiveActionRequestMfgPartnersQuery, AssignedCorrectiveActionRequestMfgPartnersQueryVariables>;
export function refetchAssignedCorrectiveActionRequestMfgPartnersQuery(variables?: AssignedCorrectiveActionRequestMfgPartnersQueryVariables) {
      return { query: AssignedCorrectiveActionRequestMfgPartnersDocument, variables: variables }
    }
export const AssignedCorrectiveActionRequestAssigneesDocument = gql`
    query AssignedCorrectiveActionRequestAssignees {
  assignedCorrectiveActionRequestAssignees {
    id
    displayName
  }
}
    `;

/**
 * __useAssignedCorrectiveActionRequestAssigneesQuery__
 *
 * To run a query within a React component, call `useAssignedCorrectiveActionRequestAssigneesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignedCorrectiveActionRequestAssigneesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignedCorrectiveActionRequestAssigneesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAssignedCorrectiveActionRequestAssigneesQuery(baseOptions?: Apollo.QueryHookOptions<AssignedCorrectiveActionRequestAssigneesQuery, AssignedCorrectiveActionRequestAssigneesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssignedCorrectiveActionRequestAssigneesQuery, AssignedCorrectiveActionRequestAssigneesQueryVariables>(AssignedCorrectiveActionRequestAssigneesDocument, options);
      }
export function useAssignedCorrectiveActionRequestAssigneesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssignedCorrectiveActionRequestAssigneesQuery, AssignedCorrectiveActionRequestAssigneesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssignedCorrectiveActionRequestAssigneesQuery, AssignedCorrectiveActionRequestAssigneesQueryVariables>(AssignedCorrectiveActionRequestAssigneesDocument, options);
        }
export type AssignedCorrectiveActionRequestAssigneesQueryHookResult = ReturnType<typeof useAssignedCorrectiveActionRequestAssigneesQuery>;
export type AssignedCorrectiveActionRequestAssigneesLazyQueryHookResult = ReturnType<typeof useAssignedCorrectiveActionRequestAssigneesLazyQuery>;
export type AssignedCorrectiveActionRequestAssigneesQueryResult = Apollo.QueryResult<AssignedCorrectiveActionRequestAssigneesQuery, AssignedCorrectiveActionRequestAssigneesQueryVariables>;
export function refetchAssignedCorrectiveActionRequestAssigneesQuery(variables?: AssignedCorrectiveActionRequestAssigneesQueryVariables) {
      return { query: AssignedCorrectiveActionRequestAssigneesDocument, variables: variables }
    }
export const LinkUnlinkExceptionsDocument = gql`
    mutation linkUnlinkExceptions($exceptionFailureIdsGroup: [ExceptionFailureIdsGroupInput!]) {
  linkUnlinkExceptions(exceptionFailureIdsGroup: $exceptionFailureIdsGroup)
}
    `;
export type LinkUnlinkExceptionsMutationFn = Apollo.MutationFunction<LinkUnlinkExceptionsMutation, LinkUnlinkExceptionsMutationVariables>;

/**
 * __useLinkUnlinkExceptionsMutation__
 *
 * To run a mutation, you first call `useLinkUnlinkExceptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkUnlinkExceptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkUnlinkExceptionsMutation, { data, loading, error }] = useLinkUnlinkExceptionsMutation({
 *   variables: {
 *      exceptionFailureIdsGroup: // value for 'exceptionFailureIdsGroup'
 *   },
 * });
 */
export function useLinkUnlinkExceptionsMutation(baseOptions?: Apollo.MutationHookOptions<LinkUnlinkExceptionsMutation, LinkUnlinkExceptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkUnlinkExceptionsMutation, LinkUnlinkExceptionsMutationVariables>(LinkUnlinkExceptionsDocument, options);
      }
export type LinkUnlinkExceptionsMutationHookResult = ReturnType<typeof useLinkUnlinkExceptionsMutation>;
export type LinkUnlinkExceptionsMutationResult = Apollo.MutationResult<LinkUnlinkExceptionsMutation>;
export type LinkUnlinkExceptionsMutationOptions = Apollo.BaseMutationOptions<LinkUnlinkExceptionsMutation, LinkUnlinkExceptionsMutationVariables>;
export const AssignedFictivAssigneesDocument = gql`
    query assignedFictivAssignees {
  assignedCorrectiveActionRequestAssignees {
    id
    displayName
  }
}
    `;

/**
 * __useAssignedFictivAssigneesQuery__
 *
 * To run a query within a React component, call `useAssignedFictivAssigneesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignedFictivAssigneesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignedFictivAssigneesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAssignedFictivAssigneesQuery(baseOptions?: Apollo.QueryHookOptions<AssignedFictivAssigneesQuery, AssignedFictivAssigneesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssignedFictivAssigneesQuery, AssignedFictivAssigneesQueryVariables>(AssignedFictivAssigneesDocument, options);
      }
export function useAssignedFictivAssigneesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssignedFictivAssigneesQuery, AssignedFictivAssigneesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssignedFictivAssigneesQuery, AssignedFictivAssigneesQueryVariables>(AssignedFictivAssigneesDocument, options);
        }
export type AssignedFictivAssigneesQueryHookResult = ReturnType<typeof useAssignedFictivAssigneesQuery>;
export type AssignedFictivAssigneesLazyQueryHookResult = ReturnType<typeof useAssignedFictivAssigneesLazyQuery>;
export type AssignedFictivAssigneesQueryResult = Apollo.QueryResult<AssignedFictivAssigneesQuery, AssignedFictivAssigneesQueryVariables>;
export function refetchAssignedFictivAssigneesQuery(variables?: AssignedFictivAssigneesQueryVariables) {
      return { query: AssignedFictivAssigneesDocument, variables: variables }
    }
export const AssignedCarMpDocument = gql`
    query assignedCarMP($sort: MfgPartnerSortInput) {
  assignedCorrectiveActionRequestMfgPartners(sort: $sort) {
    id
    name
  }
}
    `;

/**
 * __useAssignedCarMpQuery__
 *
 * To run a query within a React component, call `useAssignedCarMpQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignedCarMpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignedCarMpQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAssignedCarMpQuery(baseOptions?: Apollo.QueryHookOptions<AssignedCarMpQuery, AssignedCarMpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssignedCarMpQuery, AssignedCarMpQueryVariables>(AssignedCarMpDocument, options);
      }
export function useAssignedCarMpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssignedCarMpQuery, AssignedCarMpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssignedCarMpQuery, AssignedCarMpQueryVariables>(AssignedCarMpDocument, options);
        }
export type AssignedCarMpQueryHookResult = ReturnType<typeof useAssignedCarMpQuery>;
export type AssignedCarMpLazyQueryHookResult = ReturnType<typeof useAssignedCarMpLazyQuery>;
export type AssignedCarMpQueryResult = Apollo.QueryResult<AssignedCarMpQuery, AssignedCarMpQueryVariables>;
export function refetchAssignedCarMpQuery(variables?: AssignedCarMpQueryVariables) {
      return { query: AssignedCarMpDocument, variables: variables }
    }
export const CorrectiveActionRequestsDocument = gql`
    query CorrectiveActionRequests($limit: Int, $offset: Int, $filters: CorrectiveActionRequestListFilterInput, $sort: CorrectiveActionRequestListSortInput) {
  correctiveActionRequestList(
    limit: $limit
    offset: $offset
    filters: $filters
    sort: $sort
  ) {
    totalCount
    items {
      id
      name
      jobName
      jobId
      type
      status
      erpSaleOrderId
      salesOrderName
      jobRequestId
      businessUnit
      mfgPartner {
        id
        name
      }
      supplierQualityEngineer {
        id
        displayName
      }
      assignee {
        id
        displayName
      }
      associatedExceptionNames
      associatedExceptionFailureTypes
      associatedExceptionFailures {
        id
        name
        exceptionFailureState
        milestoneType
        type
        assignedEntity
      }
      createdAt
      updatedAt
      viewedAt
      submittedAt
      approvedAt
      closedAt
      canceledAt
      sentForReworkAt
      dueAt
      sentAt
    }
  }
}
    `;

/**
 * __useCorrectiveActionRequestsQuery__
 *
 * To run a query within a React component, call `useCorrectiveActionRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorrectiveActionRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorrectiveActionRequestsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCorrectiveActionRequestsQuery(baseOptions?: Apollo.QueryHookOptions<CorrectiveActionRequestsQuery, CorrectiveActionRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CorrectiveActionRequestsQuery, CorrectiveActionRequestsQueryVariables>(CorrectiveActionRequestsDocument, options);
      }
export function useCorrectiveActionRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CorrectiveActionRequestsQuery, CorrectiveActionRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CorrectiveActionRequestsQuery, CorrectiveActionRequestsQueryVariables>(CorrectiveActionRequestsDocument, options);
        }
export type CorrectiveActionRequestsQueryHookResult = ReturnType<typeof useCorrectiveActionRequestsQuery>;
export type CorrectiveActionRequestsLazyQueryHookResult = ReturnType<typeof useCorrectiveActionRequestsLazyQuery>;
export type CorrectiveActionRequestsQueryResult = Apollo.QueryResult<CorrectiveActionRequestsQuery, CorrectiveActionRequestsQueryVariables>;
export function refetchCorrectiveActionRequestsQuery(variables?: CorrectiveActionRequestsQueryVariables) {
      return { query: CorrectiveActionRequestsDocument, variables: variables }
    }
export const CreateExceptionFailureAttachmentDocument = gql`
    mutation createExceptionFailureAttachment($exceptionFailureAttachmentInput: ExceptionFailureAttachmentInput!) {
  createExceptionFailureAttachment(
    exceptionFailureAttachmentInput: $exceptionFailureAttachmentInput
  ) {
    id
    exceptionId
    exceptionNoteId
    createdAt
    updatedAt
    attachment {
      id
      uploadUrl
      fileName
      extension
      mimeType
    }
  }
}
    `;
export type CreateExceptionFailureAttachmentMutationFn = Apollo.MutationFunction<CreateExceptionFailureAttachmentMutation, CreateExceptionFailureAttachmentMutationVariables>;

/**
 * __useCreateExceptionFailureAttachmentMutation__
 *
 * To run a mutation, you first call `useCreateExceptionFailureAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExceptionFailureAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExceptionFailureAttachmentMutation, { data, loading, error }] = useCreateExceptionFailureAttachmentMutation({
 *   variables: {
 *      exceptionFailureAttachmentInput: // value for 'exceptionFailureAttachmentInput'
 *   },
 * });
 */
export function useCreateExceptionFailureAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateExceptionFailureAttachmentMutation, CreateExceptionFailureAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExceptionFailureAttachmentMutation, CreateExceptionFailureAttachmentMutationVariables>(CreateExceptionFailureAttachmentDocument, options);
      }
export type CreateExceptionFailureAttachmentMutationHookResult = ReturnType<typeof useCreateExceptionFailureAttachmentMutation>;
export type CreateExceptionFailureAttachmentMutationResult = Apollo.MutationResult<CreateExceptionFailureAttachmentMutation>;
export type CreateExceptionFailureAttachmentMutationOptions = Apollo.BaseMutationOptions<CreateExceptionFailureAttachmentMutation, CreateExceptionFailureAttachmentMutationVariables>;
export const RemoveExceptionFailureAttachmentDocument = gql`
    mutation removeExceptionFailureAttachment($id: UUID!) {
  removeExceptionFailureAttachment(id: $id)
}
    `;
export type RemoveExceptionFailureAttachmentMutationFn = Apollo.MutationFunction<RemoveExceptionFailureAttachmentMutation, RemoveExceptionFailureAttachmentMutationVariables>;

/**
 * __useRemoveExceptionFailureAttachmentMutation__
 *
 * To run a mutation, you first call `useRemoveExceptionFailureAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveExceptionFailureAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeExceptionFailureAttachmentMutation, { data, loading, error }] = useRemoveExceptionFailureAttachmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveExceptionFailureAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveExceptionFailureAttachmentMutation, RemoveExceptionFailureAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveExceptionFailureAttachmentMutation, RemoveExceptionFailureAttachmentMutationVariables>(RemoveExceptionFailureAttachmentDocument, options);
      }
export type RemoveExceptionFailureAttachmentMutationHookResult = ReturnType<typeof useRemoveExceptionFailureAttachmentMutation>;
export type RemoveExceptionFailureAttachmentMutationResult = Apollo.MutationResult<RemoveExceptionFailureAttachmentMutation>;
export type RemoveExceptionFailureAttachmentMutationOptions = Apollo.BaseMutationOptions<RemoveExceptionFailureAttachmentMutation, RemoveExceptionFailureAttachmentMutationVariables>;
export const SetExceptionFailureStatusDocument = gql`
    mutation setExceptionFailureStatus($id: UUID!, $status: ExceptionFailureStatus!) {
  setExceptionFailureStatus(id: $id, status: $status) {
    id
  }
}
    `;
export type SetExceptionFailureStatusMutationFn = Apollo.MutationFunction<SetExceptionFailureStatusMutation, SetExceptionFailureStatusMutationVariables>;

/**
 * __useSetExceptionFailureStatusMutation__
 *
 * To run a mutation, you first call `useSetExceptionFailureStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetExceptionFailureStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setExceptionFailureStatusMutation, { data, loading, error }] = useSetExceptionFailureStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSetExceptionFailureStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetExceptionFailureStatusMutation, SetExceptionFailureStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetExceptionFailureStatusMutation, SetExceptionFailureStatusMutationVariables>(SetExceptionFailureStatusDocument, options);
      }
export type SetExceptionFailureStatusMutationHookResult = ReturnType<typeof useSetExceptionFailureStatusMutation>;
export type SetExceptionFailureStatusMutationResult = Apollo.MutationResult<SetExceptionFailureStatusMutation>;
export type SetExceptionFailureStatusMutationOptions = Apollo.BaseMutationOptions<SetExceptionFailureStatusMutation, SetExceptionFailureStatusMutationVariables>;
export const ExceptionFailureDetailsDocument = gql`
    query ExceptionFailureDetails($id: UUID!) {
  exceptionFailure(id: $id) {
    id
    name
    erpSaleOrderId
    customerName
    salesOrderName
    status
    type
    jobId
    jobName
    jobRequestId
    milestoneType
    isFailure
    daysLate
    isCustomerImpacted
    assignedEntity
    assigneeId
    assignee
    manufacturingPartnerId
    manufacturingPartnerName
    mpSuggestedDate
    creator
    correctiveActionRequestId
    correctiveActionRequest {
      ...BasicCarDetails
    }
    failureDiscoveredBy
    additionalContext
    ignoreFailureForMpCalculation
    updatedBy {
      id
    }
    createdAt
    updatedAt
    mpNotes {
      ...FailureNote
    }
    internalNotes {
      ...FailureNote
    }
    action
    exceptionFailureState
    mpMfgDri {
      id
      displayName
    }
    customerDriUserId
    jobComputedStatus
    rfqNumber
    businessUnit
    history {
      ...FailureHistory
    }
    exceptionFailureAttachments {
      id
      attachment {
        createdAt
        downloadUrl
        uploadUrl
        fileName
        extension
        id
        mimeType
      }
      createdAt
    }
    exceptionFailureParts {
      ...FailurePart
    }
    project {
      id
      isSecurePlus
      name
    }
  }
}
    ${BasicCarDetailsFragmentDoc}
${FailureNoteFragmentDoc}
${FailureHistoryFragmentDoc}
${FailurePartFragmentDoc}`;

/**
 * __useExceptionFailureDetailsQuery__
 *
 * To run a query within a React component, call `useExceptionFailureDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExceptionFailureDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExceptionFailureDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExceptionFailureDetailsQuery(baseOptions: Apollo.QueryHookOptions<ExceptionFailureDetailsQuery, ExceptionFailureDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExceptionFailureDetailsQuery, ExceptionFailureDetailsQueryVariables>(ExceptionFailureDetailsDocument, options);
      }
export function useExceptionFailureDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExceptionFailureDetailsQuery, ExceptionFailureDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExceptionFailureDetailsQuery, ExceptionFailureDetailsQueryVariables>(ExceptionFailureDetailsDocument, options);
        }
export type ExceptionFailureDetailsQueryHookResult = ReturnType<typeof useExceptionFailureDetailsQuery>;
export type ExceptionFailureDetailsLazyQueryHookResult = ReturnType<typeof useExceptionFailureDetailsLazyQuery>;
export type ExceptionFailureDetailsQueryResult = Apollo.QueryResult<ExceptionFailureDetailsQuery, ExceptionFailureDetailsQueryVariables>;
export function refetchExceptionFailureDetailsQuery(variables: ExceptionFailureDetailsQueryVariables) {
      return { query: ExceptionFailureDetailsDocument, variables: variables }
    }
export const ExceptionListsDocument = gql`
    query exceptionLists($limit: Int, $offset: Int, $sort: ExceptionFailuresSort, $filters: ExceptionFailuresFilterInput) {
  exceptionFailures(
    limit: $limit
    offset: $offset
    sort: $sort
    filters: $filters
  ) {
    totalCount
    items {
      id
      name
      erpSaleOrderId
      salesOrderName
      status
      type
      jobId
      jobName
      jobComputedStatus
      jobRequestId
      shipmentId
      receiptId
      qcId
      isFailure
      daysLate
      isCustomerImpacted
      assignedEntity
      assigneeId
      assignee
      manufacturingPartnerId
      manufacturingPartnerName
      milestoneType
      creator
      mpSuggestedDate
      correctiveActionRequestId
      action
      exceptionFailureState
      rfqNumber
      correctiveActionRequest {
        id
        jobRequestId
        jobRequestName
        name
        status
        type
      }
      failureDiscoveredBy
      additionalContext
      creator
      updatedBy {
        id
        displayName
      }
      createdAt
      updatedAt
      latestNote {
        id
        body
        createdAt
        exceptionFailureNoteAttachments {
          attachment {
            createdAt
            downloadUrl
            uploadUrl
            fileName
            extension
            id
            mimeType
          }
          createdAt
        }
      }
      history {
        id
      }
      mpMfgDri {
        id
        displayName
      }
      customerMfgDri {
        id
        displayName
      }
      exceptionFailureAttachments {
        id
      }
      exceptionFailureParts {
        id
        failedQuantity
      }
      jobRequest {
        id
        name
      }
      project {
        id
        isSecurePlus
      }
      updatedAt
      businessUnit
    }
  }
}
    `;

/**
 * __useExceptionListsQuery__
 *
 * To run a query within a React component, call `useExceptionListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExceptionListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExceptionListsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useExceptionListsQuery(baseOptions?: Apollo.QueryHookOptions<ExceptionListsQuery, ExceptionListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExceptionListsQuery, ExceptionListsQueryVariables>(ExceptionListsDocument, options);
      }
export function useExceptionListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExceptionListsQuery, ExceptionListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExceptionListsQuery, ExceptionListsQueryVariables>(ExceptionListsDocument, options);
        }
export type ExceptionListsQueryHookResult = ReturnType<typeof useExceptionListsQuery>;
export type ExceptionListsLazyQueryHookResult = ReturnType<typeof useExceptionListsLazyQuery>;
export type ExceptionListsQueryResult = Apollo.QueryResult<ExceptionListsQuery, ExceptionListsQueryVariables>;
export function refetchExceptionListsQuery(variables?: ExceptionListsQueryVariables) {
      return { query: ExceptionListsDocument, variables: variables }
    }
export const JobBidsDocument = gql`
    query jobBids($jobId: Int!) {
  getJobBids(jobId: $jobId) {
    id
    mpName
    mpCountry
    bidAmount
    exceptionCount
    updatedAt
    buyItNow
    wonBid
    jobRequestId
    additionalComments
  }
}
    `;

/**
 * __useJobBidsQuery__
 *
 * To run a query within a React component, call `useJobBidsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobBidsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobBidsQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useJobBidsQuery(baseOptions: Apollo.QueryHookOptions<JobBidsQuery, JobBidsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobBidsQuery, JobBidsQueryVariables>(JobBidsDocument, options);
      }
export function useJobBidsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobBidsQuery, JobBidsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobBidsQuery, JobBidsQueryVariables>(JobBidsDocument, options);
        }
export type JobBidsQueryHookResult = ReturnType<typeof useJobBidsQuery>;
export type JobBidsLazyQueryHookResult = ReturnType<typeof useJobBidsLazyQuery>;
export type JobBidsQueryResult = Apollo.QueryResult<JobBidsQuery, JobBidsQueryVariables>;
export function refetchJobBidsQuery(variables: JobBidsQueryVariables) {
      return { query: JobBidsDocument, variables: variables }
    }
export const CancelJobMutationDocument = gql`
    mutation cancelJobMutation($id: Int!) {
  cancelJob(id: $id) {
    id
    payout
  }
}
    `;
export type CancelJobMutationMutationFn = Apollo.MutationFunction<CancelJobMutationMutation, CancelJobMutationMutationVariables>;

/**
 * __useCancelJobMutationMutation__
 *
 * To run a mutation, you first call `useCancelJobMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelJobMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelJobMutationMutation, { data, loading, error }] = useCancelJobMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelJobMutationMutation(baseOptions?: Apollo.MutationHookOptions<CancelJobMutationMutation, CancelJobMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelJobMutationMutation, CancelJobMutationMutationVariables>(CancelJobMutationDocument, options);
      }
export type CancelJobMutationMutationHookResult = ReturnType<typeof useCancelJobMutationMutation>;
export type CancelJobMutationMutationResult = Apollo.MutationResult<CancelJobMutationMutation>;
export type CancelJobMutationMutationOptions = Apollo.BaseMutationOptions<CancelJobMutationMutation, CancelJobMutationMutationVariables>;
export const UpdateJobRequestVendorDueDateDocument = gql`
    mutation updateJobRequestVendorDueDate($id: Int!, $vendorDueDate: Date!, $vendorDueDateUpdateReason: String) {
  updateJobRequestVendorDueDate(
    id: $id
    vendorDueDate: $vendorDueDate
    vendorDueDateUpdateReason: $vendorDueDateUpdateReason
  ) {
    id
    name
    vendorDueDate
  }
}
    `;
export type UpdateJobRequestVendorDueDateMutationFn = Apollo.MutationFunction<UpdateJobRequestVendorDueDateMutation, UpdateJobRequestVendorDueDateMutationVariables>;

/**
 * __useUpdateJobRequestVendorDueDateMutation__
 *
 * To run a mutation, you first call `useUpdateJobRequestVendorDueDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobRequestVendorDueDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobRequestVendorDueDateMutation, { data, loading, error }] = useUpdateJobRequestVendorDueDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      vendorDueDate: // value for 'vendorDueDate'
 *      vendorDueDateUpdateReason: // value for 'vendorDueDateUpdateReason'
 *   },
 * });
 */
export function useUpdateJobRequestVendorDueDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobRequestVendorDueDateMutation, UpdateJobRequestVendorDueDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobRequestVendorDueDateMutation, UpdateJobRequestVendorDueDateMutationVariables>(UpdateJobRequestVendorDueDateDocument, options);
      }
export type UpdateJobRequestVendorDueDateMutationHookResult = ReturnType<typeof useUpdateJobRequestVendorDueDateMutation>;
export type UpdateJobRequestVendorDueDateMutationResult = Apollo.MutationResult<UpdateJobRequestVendorDueDateMutation>;
export type UpdateJobRequestVendorDueDateMutationOptions = Apollo.BaseMutationOptions<UpdateJobRequestVendorDueDateMutation, UpdateJobRequestVendorDueDateMutationVariables>;
export const UpdateJobVendorDueDateDocument = gql`
    mutation updateJobVendorDueDate($id: Int!, $date: Date!) {
  updateJobVendorDueDate(id: $id, vendorDueDate: $date) {
    id
    name
    vendorDueDate
    payout
  }
}
    `;
export type UpdateJobVendorDueDateMutationFn = Apollo.MutationFunction<UpdateJobVendorDueDateMutation, UpdateJobVendorDueDateMutationVariables>;

/**
 * __useUpdateJobVendorDueDateMutation__
 *
 * To run a mutation, you first call `useUpdateJobVendorDueDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobVendorDueDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobVendorDueDateMutation, { data, loading, error }] = useUpdateJobVendorDueDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useUpdateJobVendorDueDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobVendorDueDateMutation, UpdateJobVendorDueDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobVendorDueDateMutation, UpdateJobVendorDueDateMutationVariables>(UpdateJobVendorDueDateDocument, options);
      }
export type UpdateJobVendorDueDateMutationHookResult = ReturnType<typeof useUpdateJobVendorDueDateMutation>;
export type UpdateJobVendorDueDateMutationResult = Apollo.MutationResult<UpdateJobVendorDueDateMutation>;
export type UpdateJobVendorDueDateMutationOptions = Apollo.BaseMutationOptions<UpdateJobVendorDueDateMutation, UpdateJobVendorDueDateMutationVariables>;
export const GetTotalSalesOrderPriceByJobDocument = gql`
    query getTotalSalesOrderPriceByJob($jobId: Int!) {
  getTotalSalesOrderPriceForJob(jobId: $jobId) {
    id
    totalPrice
  }
}
    `;

/**
 * __useGetTotalSalesOrderPriceByJobQuery__
 *
 * To run a query within a React component, call `useGetTotalSalesOrderPriceByJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotalSalesOrderPriceByJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotalSalesOrderPriceByJobQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetTotalSalesOrderPriceByJobQuery(baseOptions: Apollo.QueryHookOptions<GetTotalSalesOrderPriceByJobQuery, GetTotalSalesOrderPriceByJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTotalSalesOrderPriceByJobQuery, GetTotalSalesOrderPriceByJobQueryVariables>(GetTotalSalesOrderPriceByJobDocument, options);
      }
export function useGetTotalSalesOrderPriceByJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTotalSalesOrderPriceByJobQuery, GetTotalSalesOrderPriceByJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTotalSalesOrderPriceByJobQuery, GetTotalSalesOrderPriceByJobQueryVariables>(GetTotalSalesOrderPriceByJobDocument, options);
        }
export type GetTotalSalesOrderPriceByJobQueryHookResult = ReturnType<typeof useGetTotalSalesOrderPriceByJobQuery>;
export type GetTotalSalesOrderPriceByJobLazyQueryHookResult = ReturnType<typeof useGetTotalSalesOrderPriceByJobLazyQuery>;
export type GetTotalSalesOrderPriceByJobQueryResult = Apollo.QueryResult<GetTotalSalesOrderPriceByJobQuery, GetTotalSalesOrderPriceByJobQueryVariables>;
export function refetchGetTotalSalesOrderPriceByJobQuery(variables: GetTotalSalesOrderPriceByJobQueryVariables) {
      return { query: GetTotalSalesOrderPriceByJobDocument, variables: variables }
    }
export const PayoutAdjustmentReasonsDocument = gql`
    query payoutAdjustmentReasons {
  payoutAdjustmentReasons {
    id
    name
    active
    subCategories {
      id
      name
      active
    }
  }
}
    `;

/**
 * __usePayoutAdjustmentReasonsQuery__
 *
 * To run a query within a React component, call `usePayoutAdjustmentReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayoutAdjustmentReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayoutAdjustmentReasonsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePayoutAdjustmentReasonsQuery(baseOptions?: Apollo.QueryHookOptions<PayoutAdjustmentReasonsQuery, PayoutAdjustmentReasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayoutAdjustmentReasonsQuery, PayoutAdjustmentReasonsQueryVariables>(PayoutAdjustmentReasonsDocument, options);
      }
export function usePayoutAdjustmentReasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayoutAdjustmentReasonsQuery, PayoutAdjustmentReasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayoutAdjustmentReasonsQuery, PayoutAdjustmentReasonsQueryVariables>(PayoutAdjustmentReasonsDocument, options);
        }
export type PayoutAdjustmentReasonsQueryHookResult = ReturnType<typeof usePayoutAdjustmentReasonsQuery>;
export type PayoutAdjustmentReasonsLazyQueryHookResult = ReturnType<typeof usePayoutAdjustmentReasonsLazyQuery>;
export type PayoutAdjustmentReasonsQueryResult = Apollo.QueryResult<PayoutAdjustmentReasonsQuery, PayoutAdjustmentReasonsQueryVariables>;
export function refetchPayoutAdjustmentReasonsQuery(variables?: PayoutAdjustmentReasonsQueryVariables) {
      return { query: PayoutAdjustmentReasonsDocument, variables: variables }
    }
export const CreateSchedulingQueueItemsDocument = gql`
    mutation createSchedulingQueueItems($queueId: Int!, $input: CreateQueueItemInput!) {
  createSchedulingQueueItems(queueId: $queueId, input: $input)
}
    `;
export type CreateSchedulingQueueItemsMutationFn = Apollo.MutationFunction<CreateSchedulingQueueItemsMutation, CreateSchedulingQueueItemsMutationVariables>;

/**
 * __useCreateSchedulingQueueItemsMutation__
 *
 * To run a mutation, you first call `useCreateSchedulingQueueItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSchedulingQueueItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSchedulingQueueItemsMutation, { data, loading, error }] = useCreateSchedulingQueueItemsMutation({
 *   variables: {
 *      queueId: // value for 'queueId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSchedulingQueueItemsMutation(baseOptions?: Apollo.MutationHookOptions<CreateSchedulingQueueItemsMutation, CreateSchedulingQueueItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSchedulingQueueItemsMutation, CreateSchedulingQueueItemsMutationVariables>(CreateSchedulingQueueItemsDocument, options);
      }
export type CreateSchedulingQueueItemsMutationHookResult = ReturnType<typeof useCreateSchedulingQueueItemsMutation>;
export type CreateSchedulingQueueItemsMutationResult = Apollo.MutationResult<CreateSchedulingQueueItemsMutation>;
export type CreateSchedulingQueueItemsMutationOptions = Apollo.BaseMutationOptions<CreateSchedulingQueueItemsMutation, CreateSchedulingQueueItemsMutationVariables>;
export const ReSequenceSchedulingQueueItemDocument = gql`
    mutation reSequenceSchedulingQueueItem($id: Int!, $newSequenceNo: Int!) {
  reSequenceSchedulingQueueItem(id: $id, newSequenceNo: $newSequenceNo)
}
    `;
export type ReSequenceSchedulingQueueItemMutationFn = Apollo.MutationFunction<ReSequenceSchedulingQueueItemMutation, ReSequenceSchedulingQueueItemMutationVariables>;

/**
 * __useReSequenceSchedulingQueueItemMutation__
 *
 * To run a mutation, you first call `useReSequenceSchedulingQueueItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReSequenceSchedulingQueueItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reSequenceSchedulingQueueItemMutation, { data, loading, error }] = useReSequenceSchedulingQueueItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      newSequenceNo: // value for 'newSequenceNo'
 *   },
 * });
 */
export function useReSequenceSchedulingQueueItemMutation(baseOptions?: Apollo.MutationHookOptions<ReSequenceSchedulingQueueItemMutation, ReSequenceSchedulingQueueItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReSequenceSchedulingQueueItemMutation, ReSequenceSchedulingQueueItemMutationVariables>(ReSequenceSchedulingQueueItemDocument, options);
      }
export type ReSequenceSchedulingQueueItemMutationHookResult = ReturnType<typeof useReSequenceSchedulingQueueItemMutation>;
export type ReSequenceSchedulingQueueItemMutationResult = Apollo.MutationResult<ReSequenceSchedulingQueueItemMutation>;
export type ReSequenceSchedulingQueueItemMutationOptions = Apollo.BaseMutationOptions<ReSequenceSchedulingQueueItemMutation, ReSequenceSchedulingQueueItemMutationVariables>;
export const RemoveSchedulingQueueItemDocument = gql`
    mutation removeSchedulingQueueItem($removeSchedulingQueueItemId: Int!) {
  removeSchedulingQueueItem(id: $removeSchedulingQueueItemId)
}
    `;
export type RemoveSchedulingQueueItemMutationFn = Apollo.MutationFunction<RemoveSchedulingQueueItemMutation, RemoveSchedulingQueueItemMutationVariables>;

/**
 * __useRemoveSchedulingQueueItemMutation__
 *
 * To run a mutation, you first call `useRemoveSchedulingQueueItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSchedulingQueueItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSchedulingQueueItemMutation, { data, loading, error }] = useRemoveSchedulingQueueItemMutation({
 *   variables: {
 *      removeSchedulingQueueItemId: // value for 'removeSchedulingQueueItemId'
 *   },
 * });
 */
export function useRemoveSchedulingQueueItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSchedulingQueueItemMutation, RemoveSchedulingQueueItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSchedulingQueueItemMutation, RemoveSchedulingQueueItemMutationVariables>(RemoveSchedulingQueueItemDocument, options);
      }
export type RemoveSchedulingQueueItemMutationHookResult = ReturnType<typeof useRemoveSchedulingQueueItemMutation>;
export type RemoveSchedulingQueueItemMutationResult = Apollo.MutationResult<RemoveSchedulingQueueItemMutation>;
export type RemoveSchedulingQueueItemMutationOptions = Apollo.BaseMutationOptions<RemoveSchedulingQueueItemMutation, RemoveSchedulingQueueItemMutationVariables>;
export const UpdateQueueStatusDocument = gql`
    mutation updateQueueStatus($id: Int!, $queueStatus: SchedulingQueueStatus!) {
  updateQueueStatus(id: $id, queueStatus: $queueStatus) {
    id
  }
}
    `;
export type UpdateQueueStatusMutationFn = Apollo.MutationFunction<UpdateQueueStatusMutation, UpdateQueueStatusMutationVariables>;

/**
 * __useUpdateQueueStatusMutation__
 *
 * To run a mutation, you first call `useUpdateQueueStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQueueStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQueueStatusMutation, { data, loading, error }] = useUpdateQueueStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      queueStatus: // value for 'queueStatus'
 *   },
 * });
 */
export function useUpdateQueueStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQueueStatusMutation, UpdateQueueStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQueueStatusMutation, UpdateQueueStatusMutationVariables>(UpdateQueueStatusDocument, options);
      }
export type UpdateQueueStatusMutationHookResult = ReturnType<typeof useUpdateQueueStatusMutation>;
export type UpdateQueueStatusMutationResult = Apollo.MutationResult<UpdateQueueStatusMutation>;
export type UpdateQueueStatusMutationOptions = Apollo.BaseMutationOptions<UpdateQueueStatusMutation, UpdateQueueStatusMutationVariables>;
export const GetMpViewedJobOnJobBoardListDocument = gql`
    query getMpViewedJobOnJobBoardList($jobIdsAndMpsList: MpActiveOnJobBoardInput) {
  getMpViewedJobOnJobBoardList(jobIdsAndMpsList: $jobIdsAndMpsList)
}
    `;

/**
 * __useGetMpViewedJobOnJobBoardListQuery__
 *
 * To run a query within a React component, call `useGetMpViewedJobOnJobBoardListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMpViewedJobOnJobBoardListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMpViewedJobOnJobBoardListQuery({
 *   variables: {
 *      jobIdsAndMpsList: // value for 'jobIdsAndMpsList'
 *   },
 * });
 */
export function useGetMpViewedJobOnJobBoardListQuery(baseOptions?: Apollo.QueryHookOptions<GetMpViewedJobOnJobBoardListQuery, GetMpViewedJobOnJobBoardListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMpViewedJobOnJobBoardListQuery, GetMpViewedJobOnJobBoardListQueryVariables>(GetMpViewedJobOnJobBoardListDocument, options);
      }
export function useGetMpViewedJobOnJobBoardListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMpViewedJobOnJobBoardListQuery, GetMpViewedJobOnJobBoardListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMpViewedJobOnJobBoardListQuery, GetMpViewedJobOnJobBoardListQueryVariables>(GetMpViewedJobOnJobBoardListDocument, options);
        }
export type GetMpViewedJobOnJobBoardListQueryHookResult = ReturnType<typeof useGetMpViewedJobOnJobBoardListQuery>;
export type GetMpViewedJobOnJobBoardListLazyQueryHookResult = ReturnType<typeof useGetMpViewedJobOnJobBoardListLazyQuery>;
export type GetMpViewedJobOnJobBoardListQueryResult = Apollo.QueryResult<GetMpViewedJobOnJobBoardListQuery, GetMpViewedJobOnJobBoardListQueryVariables>;
export function refetchGetMpViewedJobOnJobBoardListQuery(variables?: GetMpViewedJobOnJobBoardListQueryVariables) {
      return { query: GetMpViewedJobOnJobBoardListDocument, variables: variables }
    }
export const GetRecommendedMpsDocument = gql`
    query getRecommendedMps($jobId: Int!, $filters: RecommendedMpsForJobFiltersInput) {
  getRecommendedMpsForJob(jobId: $jobId, filters: $filters) {
    ...Recommended_Mps_For_Job
  }
}
    ${Recommended_Mps_For_JobFragmentDoc}`;

/**
 * __useGetRecommendedMpsQuery__
 *
 * To run a query within a React component, call `useGetRecommendedMpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendedMpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendedMpsQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetRecommendedMpsQuery(baseOptions: Apollo.QueryHookOptions<GetRecommendedMpsQuery, GetRecommendedMpsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecommendedMpsQuery, GetRecommendedMpsQueryVariables>(GetRecommendedMpsDocument, options);
      }
export function useGetRecommendedMpsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecommendedMpsQuery, GetRecommendedMpsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecommendedMpsQuery, GetRecommendedMpsQueryVariables>(GetRecommendedMpsDocument, options);
        }
export type GetRecommendedMpsQueryHookResult = ReturnType<typeof useGetRecommendedMpsQuery>;
export type GetRecommendedMpsLazyQueryHookResult = ReturnType<typeof useGetRecommendedMpsLazyQuery>;
export type GetRecommendedMpsQueryResult = Apollo.QueryResult<GetRecommendedMpsQuery, GetRecommendedMpsQueryVariables>;
export function refetchGetRecommendedMpsQuery(variables: GetRecommendedMpsQueryVariables) {
      return { query: GetRecommendedMpsDocument, variables: variables }
    }
export const SchedulingQueueDocument = gql`
    query schedulingQueue($jobId: Int!) {
  schedulingQueue(jobId: $jobId) {
    id
    jobId
    processedQueueItemCount
    queueItemCount
    status
    queueItems {
      ...QueueItem
    }
  }
}
    ${QueueItemFragmentDoc}`;

/**
 * __useSchedulingQueueQuery__
 *
 * To run a query within a React component, call `useSchedulingQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchedulingQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchedulingQueueQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useSchedulingQueueQuery(baseOptions: Apollo.QueryHookOptions<SchedulingQueueQuery, SchedulingQueueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchedulingQueueQuery, SchedulingQueueQueryVariables>(SchedulingQueueDocument, options);
      }
export function useSchedulingQueueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchedulingQueueQuery, SchedulingQueueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchedulingQueueQuery, SchedulingQueueQueryVariables>(SchedulingQueueDocument, options);
        }
export type SchedulingQueueQueryHookResult = ReturnType<typeof useSchedulingQueueQuery>;
export type SchedulingQueueLazyQueryHookResult = ReturnType<typeof useSchedulingQueueLazyQuery>;
export type SchedulingQueueQueryResult = Apollo.QueryResult<SchedulingQueueQuery, SchedulingQueueQueryVariables>;
export function refetchSchedulingQueueQuery(variables: SchedulingQueueQueryVariables) {
      return { query: SchedulingQueueDocument, variables: variables }
    }
export const AddJobToActiveJobBoardDocument = gql`
    mutation addJobToActiveJobBoard($jobId: Int!) {
  addJobToActiveJobBoard(jobId: $jobId) {
    id
    status
    payout
  }
}
    `;
export type AddJobToActiveJobBoardMutationFn = Apollo.MutationFunction<AddJobToActiveJobBoardMutation, AddJobToActiveJobBoardMutationVariables>;

/**
 * __useAddJobToActiveJobBoardMutation__
 *
 * To run a mutation, you first call `useAddJobToActiveJobBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddJobToActiveJobBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addJobToActiveJobBoardMutation, { data, loading, error }] = useAddJobToActiveJobBoardMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useAddJobToActiveJobBoardMutation(baseOptions?: Apollo.MutationHookOptions<AddJobToActiveJobBoardMutation, AddJobToActiveJobBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddJobToActiveJobBoardMutation, AddJobToActiveJobBoardMutationVariables>(AddJobToActiveJobBoardDocument, options);
      }
export type AddJobToActiveJobBoardMutationHookResult = ReturnType<typeof useAddJobToActiveJobBoardMutation>;
export type AddJobToActiveJobBoardMutationResult = Apollo.MutationResult<AddJobToActiveJobBoardMutation>;
export type AddJobToActiveJobBoardMutationOptions = Apollo.BaseMutationOptions<AddJobToActiveJobBoardMutation, AddJobToActiveJobBoardMutationVariables>;
export const CreateJobBundleMutationDocument = gql`
    mutation createJobBundleMutation($id: Int!) {
  createJobBundle(id: $id) {
    id
    url
  }
}
    `;
export type CreateJobBundleMutationMutationFn = Apollo.MutationFunction<CreateJobBundleMutationMutation, CreateJobBundleMutationMutationVariables>;

/**
 * __useCreateJobBundleMutationMutation__
 *
 * To run a mutation, you first call `useCreateJobBundleMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobBundleMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobBundleMutationMutation, { data, loading, error }] = useCreateJobBundleMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateJobBundleMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobBundleMutationMutation, CreateJobBundleMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobBundleMutationMutation, CreateJobBundleMutationMutationVariables>(CreateJobBundleMutationDocument, options);
      }
export type CreateJobBundleMutationMutationHookResult = ReturnType<typeof useCreateJobBundleMutationMutation>;
export type CreateJobBundleMutationMutationResult = Apollo.MutationResult<CreateJobBundleMutationMutation>;
export type CreateJobBundleMutationMutationOptions = Apollo.BaseMutationOptions<CreateJobBundleMutationMutation, CreateJobBundleMutationMutationVariables>;
export const DownloadQualityDocumentsDocument = gql`
    mutation downloadQualityDocuments($jobRequestId: Int!) {
  createJobRequestZipDownloadJob(jobRequestId: $jobRequestId) {
    id
    url
  }
}
    `;
export type DownloadQualityDocumentsMutationFn = Apollo.MutationFunction<DownloadQualityDocumentsMutation, DownloadQualityDocumentsMutationVariables>;

/**
 * __useDownloadQualityDocumentsMutation__
 *
 * To run a mutation, you first call `useDownloadQualityDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadQualityDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadQualityDocumentsMutation, { data, loading, error }] = useDownloadQualityDocumentsMutation({
 *   variables: {
 *      jobRequestId: // value for 'jobRequestId'
 *   },
 * });
 */
export function useDownloadQualityDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<DownloadQualityDocumentsMutation, DownloadQualityDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadQualityDocumentsMutation, DownloadQualityDocumentsMutationVariables>(DownloadQualityDocumentsDocument, options);
      }
export type DownloadQualityDocumentsMutationHookResult = ReturnType<typeof useDownloadQualityDocumentsMutation>;
export type DownloadQualityDocumentsMutationResult = Apollo.MutationResult<DownloadQualityDocumentsMutation>;
export type DownloadQualityDocumentsMutationOptions = Apollo.BaseMutationOptions<DownloadQualityDocumentsMutation, DownloadQualityDocumentsMutationVariables>;
export const UpdateJobDocument = gql`
    mutation updateJob($id: Int!, $input: UpdateJobInput!) {
  updateJob(id: $id, input: $input) {
    id
    payout
  }
}
    `;
export type UpdateJobMutationFn = Apollo.MutationFunction<UpdateJobMutation, UpdateJobMutationVariables>;

/**
 * __useUpdateJobMutation__
 *
 * To run a mutation, you first call `useUpdateJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobMutation, { data, loading, error }] = useUpdateJobMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateJobMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobMutation, UpdateJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobMutation, UpdateJobMutationVariables>(UpdateJobDocument, options);
      }
export type UpdateJobMutationHookResult = ReturnType<typeof useUpdateJobMutation>;
export type UpdateJobMutationResult = Apollo.MutationResult<UpdateJobMutation>;
export type UpdateJobMutationOptions = Apollo.BaseMutationOptions<UpdateJobMutation, UpdateJobMutationVariables>;
export const UpdateJobLinesDocument = gql`
    mutation updateJobLines($jobId: Int!, $jobLineInput: [UpdateJobLineInput!]!) {
  updateJobLines(jobId: $jobId, jobLineInput: $jobLineInput)
}
    `;
export type UpdateJobLinesMutationFn = Apollo.MutationFunction<UpdateJobLinesMutation, UpdateJobLinesMutationVariables>;

/**
 * __useUpdateJobLinesMutation__
 *
 * To run a mutation, you first call `useUpdateJobLinesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobLinesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobLinesMutation, { data, loading, error }] = useUpdateJobLinesMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      jobLineInput: // value for 'jobLineInput'
 *   },
 * });
 */
export function useUpdateJobLinesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobLinesMutation, UpdateJobLinesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobLinesMutation, UpdateJobLinesMutationVariables>(UpdateJobLinesDocument, options);
      }
export type UpdateJobLinesMutationHookResult = ReturnType<typeof useUpdateJobLinesMutation>;
export type UpdateJobLinesMutationResult = Apollo.MutationResult<UpdateJobLinesMutation>;
export type UpdateJobLinesMutationOptions = Apollo.BaseMutationOptions<UpdateJobLinesMutation, UpdateJobLinesMutationVariables>;
export const UpdateJobPauseExceptionDocument = gql`
    mutation updateJobPauseException($jobId: Int!, $pauseException: Boolean!) {
  updateJobPauseException(jobId: $jobId, pauseException: $pauseException) {
    id
    name
    pauseException
    payout
  }
}
    `;
export type UpdateJobPauseExceptionMutationFn = Apollo.MutationFunction<UpdateJobPauseExceptionMutation, UpdateJobPauseExceptionMutationVariables>;

/**
 * __useUpdateJobPauseExceptionMutation__
 *
 * To run a mutation, you first call `useUpdateJobPauseExceptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobPauseExceptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobPauseExceptionMutation, { data, loading, error }] = useUpdateJobPauseExceptionMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      pauseException: // value for 'pauseException'
 *   },
 * });
 */
export function useUpdateJobPauseExceptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobPauseExceptionMutation, UpdateJobPauseExceptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobPauseExceptionMutation, UpdateJobPauseExceptionMutationVariables>(UpdateJobPauseExceptionDocument, options);
      }
export type UpdateJobPauseExceptionMutationHookResult = ReturnType<typeof useUpdateJobPauseExceptionMutation>;
export type UpdateJobPauseExceptionMutationResult = Apollo.MutationResult<UpdateJobPauseExceptionMutation>;
export type UpdateJobPauseExceptionMutationOptions = Apollo.BaseMutationOptions<UpdateJobPauseExceptionMutation, UpdateJobPauseExceptionMutationVariables>;
export const UpdateJobProductionCountryDocument = gql`
    mutation updateJobProductionCountry($jobId: Int!, $productionCountry: JobProductionCountry!) {
  updateJobProductionCountry(jobId: $jobId, productionCountry: $productionCountry) {
    id
    name
    countryCode
    payout
  }
}
    `;
export type UpdateJobProductionCountryMutationFn = Apollo.MutationFunction<UpdateJobProductionCountryMutation, UpdateJobProductionCountryMutationVariables>;

/**
 * __useUpdateJobProductionCountryMutation__
 *
 * To run a mutation, you first call `useUpdateJobProductionCountryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobProductionCountryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobProductionCountryMutation, { data, loading, error }] = useUpdateJobProductionCountryMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      productionCountry: // value for 'productionCountry'
 *   },
 * });
 */
export function useUpdateJobProductionCountryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobProductionCountryMutation, UpdateJobProductionCountryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobProductionCountryMutation, UpdateJobProductionCountryMutationVariables>(UpdateJobProductionCountryDocument, options);
      }
export type UpdateJobProductionCountryMutationHookResult = ReturnType<typeof useUpdateJobProductionCountryMutation>;
export type UpdateJobProductionCountryMutationResult = Apollo.MutationResult<UpdateJobProductionCountryMutation>;
export type UpdateJobProductionCountryMutationOptions = Apollo.BaseMutationOptions<UpdateJobProductionCountryMutation, UpdateJobProductionCountryMutationVariables>;
export const UpdateJobRequestDocument = gql`
    mutation updateJobRequest($id: Int!, $input: UpdateJobRequestInput!) {
  updateJobRequest(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateJobRequestMutationFn = Apollo.MutationFunction<UpdateJobRequestMutation, UpdateJobRequestMutationVariables>;

/**
 * __useUpdateJobRequestMutation__
 *
 * To run a mutation, you first call `useUpdateJobRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobRequestMutation, { data, loading, error }] = useUpdateJobRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateJobRequestMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobRequestMutation, UpdateJobRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobRequestMutation, UpdateJobRequestMutationVariables>(UpdateJobRequestDocument, options);
      }
export type UpdateJobRequestMutationHookResult = ReturnType<typeof useUpdateJobRequestMutation>;
export type UpdateJobRequestMutationResult = Apollo.MutationResult<UpdateJobRequestMutation>;
export type UpdateJobRequestMutationOptions = Apollo.BaseMutationOptions<UpdateJobRequestMutation, UpdateJobRequestMutationVariables>;
export const UpdateJobRequestLinesDocument = gql`
    mutation updateJobRequestLines($id: Int!, $input: [UpdateJobRequestLineInput!]!) {
  updateJobRequestLines(jobRequestId: $id, jobRequestLineInput: $input)
}
    `;
export type UpdateJobRequestLinesMutationFn = Apollo.MutationFunction<UpdateJobRequestLinesMutation, UpdateJobRequestLinesMutationVariables>;

/**
 * __useUpdateJobRequestLinesMutation__
 *
 * To run a mutation, you first call `useUpdateJobRequestLinesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobRequestLinesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobRequestLinesMutation, { data, loading, error }] = useUpdateJobRequestLinesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateJobRequestLinesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobRequestLinesMutation, UpdateJobRequestLinesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobRequestLinesMutation, UpdateJobRequestLinesMutationVariables>(UpdateJobRequestLinesDocument, options);
      }
export type UpdateJobRequestLinesMutationHookResult = ReturnType<typeof useUpdateJobRequestLinesMutation>;
export type UpdateJobRequestLinesMutationResult = Apollo.MutationResult<UpdateJobRequestLinesMutation>;
export type UpdateJobRequestLinesMutationOptions = Apollo.BaseMutationOptions<UpdateJobRequestLinesMutation, UpdateJobRequestLinesMutationVariables>;
export const UpdateJobRequestQcTypeDocument = gql`
    mutation updateJobRequestQcType($id: Int!, $qcType: JobRequestQcType!) {
  updateJobRequestQcType(id: $id, qcType: $qcType) {
    id
    name
    qcType
  }
}
    `;
export type UpdateJobRequestQcTypeMutationFn = Apollo.MutationFunction<UpdateJobRequestQcTypeMutation, UpdateJobRequestQcTypeMutationVariables>;

/**
 * __useUpdateJobRequestQcTypeMutation__
 *
 * To run a mutation, you first call `useUpdateJobRequestQcTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobRequestQcTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobRequestQcTypeMutation, { data, loading, error }] = useUpdateJobRequestQcTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      qcType: // value for 'qcType'
 *   },
 * });
 */
export function useUpdateJobRequestQcTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobRequestQcTypeMutation, UpdateJobRequestQcTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobRequestQcTypeMutation, UpdateJobRequestQcTypeMutationVariables>(UpdateJobRequestQcTypeDocument, options);
      }
export type UpdateJobRequestQcTypeMutationHookResult = ReturnType<typeof useUpdateJobRequestQcTypeMutation>;
export type UpdateJobRequestQcTypeMutationResult = Apollo.MutationResult<UpdateJobRequestQcTypeMutation>;
export type UpdateJobRequestQcTypeMutationOptions = Apollo.BaseMutationOptions<UpdateJobRequestQcTypeMutation, UpdateJobRequestQcTypeMutationVariables>;
export const UpdateJobRequestStatusDocument = gql`
    mutation updateJobRequestStatus($id: Int!, $status: JobRequestStatus!, $rejectionInfo: JobRequestRejectionInput) {
  updateJobRequestStatus(id: $id, status: $status, rejectionInfo: $rejectionInfo) {
    id
  }
}
    `;
export type UpdateJobRequestStatusMutationFn = Apollo.MutationFunction<UpdateJobRequestStatusMutation, UpdateJobRequestStatusMutationVariables>;

/**
 * __useUpdateJobRequestStatusMutation__
 *
 * To run a mutation, you first call `useUpdateJobRequestStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobRequestStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobRequestStatusMutation, { data, loading, error }] = useUpdateJobRequestStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      rejectionInfo: // value for 'rejectionInfo'
 *   },
 * });
 */
export function useUpdateJobRequestStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobRequestStatusMutation, UpdateJobRequestStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobRequestStatusMutation, UpdateJobRequestStatusMutationVariables>(UpdateJobRequestStatusDocument, options);
      }
export type UpdateJobRequestStatusMutationHookResult = ReturnType<typeof useUpdateJobRequestStatusMutation>;
export type UpdateJobRequestStatusMutationResult = Apollo.MutationResult<UpdateJobRequestStatusMutation>;
export type UpdateJobRequestStatusMutationOptions = Apollo.BaseMutationOptions<UpdateJobRequestStatusMutation, UpdateJobRequestStatusMutationVariables>;
export const EligibleMPsForJobDocument = gql`
    query eligibleMPsForJob($jobId: Int!, $forDate: Date) {
  fetchEligibleMPsForJob(jobId: $jobId) {
    ...JobMpType
  }
}
    ${JobMpTypeFragmentDoc}`;

/**
 * __useEligibleMPsForJobQuery__
 *
 * To run a query within a React component, call `useEligibleMPsForJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useEligibleMPsForJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEligibleMPsForJobQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      forDate: // value for 'forDate'
 *   },
 * });
 */
export function useEligibleMPsForJobQuery(baseOptions: Apollo.QueryHookOptions<EligibleMPsForJobQuery, EligibleMPsForJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EligibleMPsForJobQuery, EligibleMPsForJobQueryVariables>(EligibleMPsForJobDocument, options);
      }
export function useEligibleMPsForJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EligibleMPsForJobQuery, EligibleMPsForJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EligibleMPsForJobQuery, EligibleMPsForJobQueryVariables>(EligibleMPsForJobDocument, options);
        }
export type EligibleMPsForJobQueryHookResult = ReturnType<typeof useEligibleMPsForJobQuery>;
export type EligibleMPsForJobLazyQueryHookResult = ReturnType<typeof useEligibleMPsForJobLazyQuery>;
export type EligibleMPsForJobQueryResult = Apollo.QueryResult<EligibleMPsForJobQuery, EligibleMPsForJobQueryVariables>;
export function refetchEligibleMPsForJobQuery(variables: EligibleMPsForJobQueryVariables) {
      return { query: EligibleMPsForJobDocument, variables: variables }
    }
export const GetCurrentJobBoardWithJobBoardRegionDocument = gql`
    query GetCurrentJobBoardWithJobBoardRegion($jobBoardRegionId: String) {
  getCurrentJobBoard(jobBoardRegionId: $jobBoardRegionId) {
    id
    startDate
    endDate
    status
  }
}
    `;

/**
 * __useGetCurrentJobBoardWithJobBoardRegionQuery__
 *
 * To run a query within a React component, call `useGetCurrentJobBoardWithJobBoardRegionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentJobBoardWithJobBoardRegionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentJobBoardWithJobBoardRegionQuery({
 *   variables: {
 *      jobBoardRegionId: // value for 'jobBoardRegionId'
 *   },
 * });
 */
export function useGetCurrentJobBoardWithJobBoardRegionQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentJobBoardWithJobBoardRegionQuery, GetCurrentJobBoardWithJobBoardRegionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentJobBoardWithJobBoardRegionQuery, GetCurrentJobBoardWithJobBoardRegionQueryVariables>(GetCurrentJobBoardWithJobBoardRegionDocument, options);
      }
export function useGetCurrentJobBoardWithJobBoardRegionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentJobBoardWithJobBoardRegionQuery, GetCurrentJobBoardWithJobBoardRegionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentJobBoardWithJobBoardRegionQuery, GetCurrentJobBoardWithJobBoardRegionQueryVariables>(GetCurrentJobBoardWithJobBoardRegionDocument, options);
        }
export type GetCurrentJobBoardWithJobBoardRegionQueryHookResult = ReturnType<typeof useGetCurrentJobBoardWithJobBoardRegionQuery>;
export type GetCurrentJobBoardWithJobBoardRegionLazyQueryHookResult = ReturnType<typeof useGetCurrentJobBoardWithJobBoardRegionLazyQuery>;
export type GetCurrentJobBoardWithJobBoardRegionQueryResult = Apollo.QueryResult<GetCurrentJobBoardWithJobBoardRegionQuery, GetCurrentJobBoardWithJobBoardRegionQueryVariables>;
export function refetchGetCurrentJobBoardWithJobBoardRegionQuery(variables?: GetCurrentJobBoardWithJobBoardRegionQueryVariables) {
      return { query: GetCurrentJobBoardWithJobBoardRegionDocument, variables: variables }
    }
export const JobDetailsDocument = gql`
    query jobDetails($id: Int!, $mfgPartnerId: Int, $schedulingQueueItemId: Int) {
  job(id: $id) {
    id
    name
    rfqNumber
    erpSaleOrderId
    salesOrderName
    salesOrderCreatedAt
    exceptionCount
    jobExceptionCount
    priority
    leadTime
    region
    plannedScheduleDate
    status
    hasCnc
    queueStatus
    vendorDueDate
    originalVendorDueDate
    pauseException
    payout(
      mfgPartnerId: $mfgPartnerId
      schedulingQueueItemId: $schedulingQueueItemId
    )
    originalPayout
    originalTransactionMargin
    actualTransactionMargin(
      mfgPartnerId: $mfgPartnerId
      schedulingQueueItemId: $schedulingQueueItemId
    )
    vendorNotes
    customerName
    customerCompanyName
    isForJobBoard
    jobBoardId
    jobBoardStartDate
    jobBoardEndDate
    jobBoardStatus
    jobBoardRegion
    jobBoardEligibleMpsCount
    jobBoardRegionId
    jobBoardJobEndTime
    buyNowPrice
    bidCount
    schedulingType
    businessUnit
    mfgDri {
      ...Dri
    }
    salesDri {
      ...Dri
    }
    schedulingDri {
      ...Dri
    }
    project {
      id
      name
      isSecurePlus
    }
    projectTags
    lines(
      mfgPartnerId: $mfgPartnerId
      schedulingQueueItemId: $schedulingQueueItemId
    ) {
      id
      name
      productQty
      unitPrice
      totalPayout
      originalUnitPrice
      productQty
      vendorDueDate
      payoutMultiplier
      productProcess {
        erpProductId
        id
        thumbnailUri
        leadTime
        scheduledQuantity
        targetPurchasePrice
        payout
        processNotes
        part {
          id
          name
          depthX
          depthY
          depthZ
          quoteModelRevisionUuid
        }
        associatedMoldTool {
          id
          name
          moldToolRevisionId
          version
        }
        moldTool {
          id
          name
          moldToolRevisionId
          version
        }
        inspectionData {
          numOfSetups
        }
        materialConfiguration {
          id
          name
          color
          colorCode
          grade
          shoreValue
          dfmNotes {
            color
            shoreValue
            material
          }
          additionalSpecifications {
            color
            shoreValue
            material
          }
        }
        processAttributes {
          id
          name
          texture
          color
          thickness
        }
      }
      orderLineProcesses {
        id
        platformProcessId
        platformProcessTypeId
        processName
        processNotes
        color
        thickness
        texture
        finish
        surfaceFinishCode
        toolLife
        dfmNotes {
          color
          thickness
          texture
          process
        }
        additionalSpecifications {
          color
          thickness
          texture
        }
      }
      payoutAdjReasonCategory {
        id
        name
        active
        subCategories {
          id
          name
          active
        }
      }
      payoutAdjReasonSubCategory {
        id
        name
        active
      }
      payoutAdjDescription
    }
    history {
      id
      objectType
      objectId
      contextKey
      oldValue
      newValue
      message
      createdBy {
        id
        displayName
      }
      createdAt
    }
    milestones {
      scheduling {
        committedDate
        scheduledDate
        actualDate
      }
      production {
        committedDate
        scheduledDate
        actualDate
      }
      inspection {
        committedDate
        scheduledDate
        actualDate
      }
      deliveryOrder {
        committedDate
        scheduledDate
        actualDate
      }
      shipping {
        committedDate
        scheduledDate
        actualDate
      }
      customerDelivery {
        committedDate
        scheduledDate
        actualDate
      }
    }
    quoteNotes
    quoteDfmNotes
    countryCode
  }
}
    ${DriFragmentDoc}`;

/**
 * __useJobDetailsQuery__
 *
 * To run a query within a React component, call `useJobDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      mfgPartnerId: // value for 'mfgPartnerId'
 *      schedulingQueueItemId: // value for 'schedulingQueueItemId'
 *   },
 * });
 */
export function useJobDetailsQuery(baseOptions: Apollo.QueryHookOptions<JobDetailsQuery, JobDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobDetailsQuery, JobDetailsQueryVariables>(JobDetailsDocument, options);
      }
export function useJobDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobDetailsQuery, JobDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobDetailsQuery, JobDetailsQueryVariables>(JobDetailsDocument, options);
        }
export type JobDetailsQueryHookResult = ReturnType<typeof useJobDetailsQuery>;
export type JobDetailsLazyQueryHookResult = ReturnType<typeof useJobDetailsLazyQuery>;
export type JobDetailsQueryResult = Apollo.QueryResult<JobDetailsQuery, JobDetailsQueryVariables>;
export function refetchJobDetailsQuery(variables: JobDetailsQueryVariables) {
      return { query: JobDetailsDocument, variables: variables }
    }
export const JobMilestonesDocument = gql`
    query jobMilestones($id: Int!) {
  jobMilestones(jobId: $id) {
    scheduling {
      committedDate
      scheduledDate
      actualDate
    }
    production {
      committedDate
      scheduledDate
      actualDate
    }
    inspection {
      committedDate
      scheduledDate
      actualDate
    }
    deliveryOrder {
      committedDate
      scheduledDate
      actualDate
    }
    shipping {
      committedDate
      scheduledDate
      actualDate
    }
    customerDelivery {
      committedDate
      scheduledDate
      actualDate
    }
  }
}
    `;

/**
 * __useJobMilestonesQuery__
 *
 * To run a query within a React component, call `useJobMilestonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobMilestonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobMilestonesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJobMilestonesQuery(baseOptions: Apollo.QueryHookOptions<JobMilestonesQuery, JobMilestonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobMilestonesQuery, JobMilestonesQueryVariables>(JobMilestonesDocument, options);
      }
export function useJobMilestonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobMilestonesQuery, JobMilestonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobMilestonesQuery, JobMilestonesQueryVariables>(JobMilestonesDocument, options);
        }
export type JobMilestonesQueryHookResult = ReturnType<typeof useJobMilestonesQuery>;
export type JobMilestonesLazyQueryHookResult = ReturnType<typeof useJobMilestonesLazyQuery>;
export type JobMilestonesQueryResult = Apollo.QueryResult<JobMilestonesQuery, JobMilestonesQueryVariables>;
export function refetchJobMilestonesQuery(variables: JobMilestonesQueryVariables) {
      return { query: JobMilestonesDocument, variables: variables }
    }
export const JobRequestDetailsDocument = gql`
    query JobRequestDetails($id: Int!) {
  jobRequest(id: $id) {
    id
    jobId
    erpWorkOrderRequestId
    name
    payout
    originalPayout
    originalTransactionMargin
    actualTransactionMargin
    vendorDueDate
    originalVendorDueDate
    status
    expiresAt
    viewedAt
    viewedBy {
      id
      displayName
    }
    acceptedAt
    acceptedBy {
      id
      displayName
    }
    completedAt
    completedBy {
      id
      displayName
    }
    rejectedAt
    rejectedBy {
      id
      displayName
    }
    canceledAt
    canceledBy {
      id
      displayName
    }
    rejectionReason
    rejectionReasonAdditionalInfo
    rejectionComment
    secondaryProcessStartDate
    erpPurchaseOrderId
    vendorNotes
    productionStage
    qcType
    photosUploadedByMp
    createdAt
    createdBy {
      id
      displayName
    }
    mfgPartner {
      id
      name
    }
    updatedAt
    updatedBy {
      id
      displayName
    }
    project {
      id
      name
      isSecurePlus
    }
    followers {
      id
      name
      fictivUserId
      isChannel
      isFictivUser
    }
    jobRequestComments {
      id
      body
      author {
        id
        displayName
      }
      createdAt
      updatedAt
      subject
      attachments {
        id
        fileName
        url
      }
    }
    lines {
      id
      name
      erpWorkOrderRequestLineId
      vendorDueDate
      originalVendorDueDate
      productQty
      unitPrice
      originalUnitPrice
      payoutMultiplier
      totalPayout
      inspectionType
      receiptComplete
      qcComplete
      payoutAdjReasonCategory {
        id
        name
      }
      payoutAdjReasonSubCategory {
        id
        name
      }
      payoutAdjDescription
      productProcess {
        erpProductId
        id
        leadTime
        thumbnailUri
        processNotes
        part {
          id
          name
          depthX
          depthY
          depthZ
          quoteModelRevisionUuid
        }
        moldTool {
          id
          name
          moldToolRevisionId
        }
        inspectionData {
          numOfSetups
        }
        processAttributes {
          id
          color
          name
          texture
          thickness
        }
        materialConfiguration {
          id
          name
          color
          grade
          colorCode
          shoreValue
          dfmNotes {
            color
            shoreValue
            material
          }
          additionalSpecifications {
            color
            shoreValue
            material
          }
        }
      }
      orderLineProcesses {
        id
        platformProcessId
        platformProcessTypeId
        processName
        processNotes
        color
        thickness
        texture
        finish
        surfaceFinishCode
        toolLife
        dfmNotes {
          color
          thickness
          texture
          process
        }
        additionalSpecifications {
          color
          thickness
          texture
        }
      }
    }
    history {
      id
      objectType
      objectId
      contextKey
      oldValue
      newValue
      message
      createdBy {
        id
        displayName
      }
      createdAt
    }
  }
}
    `;

/**
 * __useJobRequestDetailsQuery__
 *
 * To run a query within a React component, call `useJobRequestDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobRequestDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobRequestDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJobRequestDetailsQuery(baseOptions: Apollo.QueryHookOptions<JobRequestDetailsQuery, JobRequestDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobRequestDetailsQuery, JobRequestDetailsQueryVariables>(JobRequestDetailsDocument, options);
      }
export function useJobRequestDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobRequestDetailsQuery, JobRequestDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobRequestDetailsQuery, JobRequestDetailsQueryVariables>(JobRequestDetailsDocument, options);
        }
export type JobRequestDetailsQueryHookResult = ReturnType<typeof useJobRequestDetailsQuery>;
export type JobRequestDetailsLazyQueryHookResult = ReturnType<typeof useJobRequestDetailsLazyQuery>;
export type JobRequestDetailsQueryResult = Apollo.QueryResult<JobRequestDetailsQuery, JobRequestDetailsQueryVariables>;
export function refetchJobRequestDetailsQuery(variables: JobRequestDetailsQueryVariables) {
      return { query: JobRequestDetailsDocument, variables: variables }
    }
export const CreateJobNoteDocument = gql`
    mutation createJobNote($input: CreateNoteInput!) {
  createNote(input: $input) {
    id
    objectId
    objectType
    description
  }
}
    `;
export type CreateJobNoteMutationFn = Apollo.MutationFunction<CreateJobNoteMutation, CreateJobNoteMutationVariables>;

/**
 * __useCreateJobNoteMutation__
 *
 * To run a mutation, you first call `useCreateJobNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobNoteMutation, { data, loading, error }] = useCreateJobNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateJobNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobNoteMutation, CreateJobNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobNoteMutation, CreateJobNoteMutationVariables>(CreateJobNoteDocument, options);
      }
export type CreateJobNoteMutationHookResult = ReturnType<typeof useCreateJobNoteMutation>;
export type CreateJobNoteMutationResult = Apollo.MutationResult<CreateJobNoteMutation>;
export type CreateJobNoteMutationOptions = Apollo.BaseMutationOptions<CreateJobNoteMutation, CreateJobNoteMutationVariables>;
export const CreateJobNoteAttachmentDocument = gql`
    mutation createJobNoteAttachment($input: AttachmentInput!) {
  createNoteAttachment(input: $input) {
    id
    fileName
    extension
    mimeType
    uploadUrl
  }
}
    `;
export type CreateJobNoteAttachmentMutationFn = Apollo.MutationFunction<CreateJobNoteAttachmentMutation, CreateJobNoteAttachmentMutationVariables>;

/**
 * __useCreateJobNoteAttachmentMutation__
 *
 * To run a mutation, you first call `useCreateJobNoteAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobNoteAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobNoteAttachmentMutation, { data, loading, error }] = useCreateJobNoteAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateJobNoteAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobNoteAttachmentMutation, CreateJobNoteAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobNoteAttachmentMutation, CreateJobNoteAttachmentMutationVariables>(CreateJobNoteAttachmentDocument, options);
      }
export type CreateJobNoteAttachmentMutationHookResult = ReturnType<typeof useCreateJobNoteAttachmentMutation>;
export type CreateJobNoteAttachmentMutationResult = Apollo.MutationResult<CreateJobNoteAttachmentMutation>;
export type CreateJobNoteAttachmentMutationOptions = Apollo.BaseMutationOptions<CreateJobNoteAttachmentMutation, CreateJobNoteAttachmentMutationVariables>;
export const MarkUploadedJobNoteAttachmentDocument = gql`
    mutation markUploadedJobNoteAttachment($id: UUID!) {
  markUploadedAsset(id: $id) {
    id
    downloadUrl
  }
}
    `;
export type MarkUploadedJobNoteAttachmentMutationFn = Apollo.MutationFunction<MarkUploadedJobNoteAttachmentMutation, MarkUploadedJobNoteAttachmentMutationVariables>;

/**
 * __useMarkUploadedJobNoteAttachmentMutation__
 *
 * To run a mutation, you first call `useMarkUploadedJobNoteAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkUploadedJobNoteAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markUploadedJobNoteAttachmentMutation, { data, loading, error }] = useMarkUploadedJobNoteAttachmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkUploadedJobNoteAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<MarkUploadedJobNoteAttachmentMutation, MarkUploadedJobNoteAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkUploadedJobNoteAttachmentMutation, MarkUploadedJobNoteAttachmentMutationVariables>(MarkUploadedJobNoteAttachmentDocument, options);
      }
export type MarkUploadedJobNoteAttachmentMutationHookResult = ReturnType<typeof useMarkUploadedJobNoteAttachmentMutation>;
export type MarkUploadedJobNoteAttachmentMutationResult = Apollo.MutationResult<MarkUploadedJobNoteAttachmentMutation>;
export type MarkUploadedJobNoteAttachmentMutationOptions = Apollo.BaseMutationOptions<MarkUploadedJobNoteAttachmentMutation, MarkUploadedJobNoteAttachmentMutationVariables>;
export const RemoveJobNoteAttachmentDocument = gql`
    mutation removeJobNoteAttachment($id: UUID!) {
  removeNoteAttachment(id: $id)
}
    `;
export type RemoveJobNoteAttachmentMutationFn = Apollo.MutationFunction<RemoveJobNoteAttachmentMutation, RemoveJobNoteAttachmentMutationVariables>;

/**
 * __useRemoveJobNoteAttachmentMutation__
 *
 * To run a mutation, you first call `useRemoveJobNoteAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveJobNoteAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeJobNoteAttachmentMutation, { data, loading, error }] = useRemoveJobNoteAttachmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveJobNoteAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveJobNoteAttachmentMutation, RemoveJobNoteAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveJobNoteAttachmentMutation, RemoveJobNoteAttachmentMutationVariables>(RemoveJobNoteAttachmentDocument, options);
      }
export type RemoveJobNoteAttachmentMutationHookResult = ReturnType<typeof useRemoveJobNoteAttachmentMutation>;
export type RemoveJobNoteAttachmentMutationResult = Apollo.MutationResult<RemoveJobNoteAttachmentMutation>;
export type RemoveJobNoteAttachmentMutationOptions = Apollo.BaseMutationOptions<RemoveJobNoteAttachmentMutation, RemoveJobNoteAttachmentMutationVariables>;
export const JobListDocument = gql`
    query jobList($limit: Int!, $offset: Int, $filters: JobListFiltersInput, $sort: [JobSortInput!]) {
  jobList(limit: $limit, offset: $offset, filters: $filters, sort: $sort) {
    totalCount
    items {
      ...JobType
    }
  }
}
    ${JobTypeFragmentDoc}`;

/**
 * __useJobListQuery__
 *
 * To run a query within a React component, call `useJobListQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useJobListQuery(baseOptions: Apollo.QueryHookOptions<JobListQuery, JobListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobListQuery, JobListQueryVariables>(JobListDocument, options);
      }
export function useJobListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobListQuery, JobListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobListQuery, JobListQueryVariables>(JobListDocument, options);
        }
export type JobListQueryHookResult = ReturnType<typeof useJobListQuery>;
export type JobListLazyQueryHookResult = ReturnType<typeof useJobListLazyQuery>;
export type JobListQueryResult = Apollo.QueryResult<JobListQuery, JobListQueryVariables>;
export function refetchJobListQuery(variables: JobListQueryVariables) {
      return { query: JobListDocument, variables: variables }
    }
export const MfgPartnersListForFilterDocument = gql`
    query mfgPartnersListForFilter {
  mfgPartnersForFilter {
    ...mfgPartnerForFilterList
  }
}
    ${MfgPartnerForFilterListFragmentDoc}`;

/**
 * __useMfgPartnersListForFilterQuery__
 *
 * To run a query within a React component, call `useMfgPartnersListForFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useMfgPartnersListForFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMfgPartnersListForFilterQuery({
 *   variables: {
 *   },
 * });
 */
export function useMfgPartnersListForFilterQuery(baseOptions?: Apollo.QueryHookOptions<MfgPartnersListForFilterQuery, MfgPartnersListForFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MfgPartnersListForFilterQuery, MfgPartnersListForFilterQueryVariables>(MfgPartnersListForFilterDocument, options);
      }
export function useMfgPartnersListForFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MfgPartnersListForFilterQuery, MfgPartnersListForFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MfgPartnersListForFilterQuery, MfgPartnersListForFilterQueryVariables>(MfgPartnersListForFilterDocument, options);
        }
export type MfgPartnersListForFilterQueryHookResult = ReturnType<typeof useMfgPartnersListForFilterQuery>;
export type MfgPartnersListForFilterLazyQueryHookResult = ReturnType<typeof useMfgPartnersListForFilterLazyQuery>;
export type MfgPartnersListForFilterQueryResult = Apollo.QueryResult<MfgPartnersListForFilterQuery, MfgPartnersListForFilterQueryVariables>;
export function refetchMfgPartnersListForFilterQuery(variables?: MfgPartnersListForFilterQueryVariables) {
      return { query: MfgPartnersListForFilterDocument, variables: variables }
    }
export const BusinessUnitsDocument = gql`
    query businessUnits {
  getBusinessUnits
}
    `;

/**
 * __useBusinessUnitsQuery__
 *
 * To run a query within a React component, call `useBusinessUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessUnitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBusinessUnitsQuery(baseOptions?: Apollo.QueryHookOptions<BusinessUnitsQuery, BusinessUnitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessUnitsQuery, BusinessUnitsQueryVariables>(BusinessUnitsDocument, options);
      }
export function useBusinessUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessUnitsQuery, BusinessUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessUnitsQuery, BusinessUnitsQueryVariables>(BusinessUnitsDocument, options);
        }
export type BusinessUnitsQueryHookResult = ReturnType<typeof useBusinessUnitsQuery>;
export type BusinessUnitsLazyQueryHookResult = ReturnType<typeof useBusinessUnitsLazyQuery>;
export type BusinessUnitsQueryResult = Apollo.QueryResult<BusinessUnitsQuery, BusinessUnitsQueryVariables>;
export function refetchBusinessUnitsQuery(variables?: BusinessUnitsQueryVariables) {
      return { query: BusinessUnitsDocument, variables: variables }
    }
export const SalesOrdersExceptionsDocument = gql`
    query salesOrdersExceptions($limit: Int!, $offset: Int, $sort: AllowedSalesOrderSort, $filters: SalesOrdersFiltersInput) {
  salesOrders(limit: $limit, offset: $offset, filters: $filters, sort: $sort) {
    totalCount
    items {
      id
      name
      businessUnit
      schedulingDris {
        id
        displayName
      }
      productionCountries
      customerName
      customerCompanyName
      committedDeliveryDate
      project {
        id
        name
        isSecurePlus
      }
      priority
      earliestPromisedShipDate
      earliestScheduledDeliveryDate
      region
      mfgDri {
        id
        displayName
      }
      workOrderCount
      exceptionCount
      carCount
      jobCount
      businessUnit
    }
  }
}
    `;

/**
 * __useSalesOrdersExceptionsQuery__
 *
 * To run a query within a React component, call `useSalesOrdersExceptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesOrdersExceptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesOrdersExceptionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSalesOrdersExceptionsQuery(baseOptions: Apollo.QueryHookOptions<SalesOrdersExceptionsQuery, SalesOrdersExceptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesOrdersExceptionsQuery, SalesOrdersExceptionsQueryVariables>(SalesOrdersExceptionsDocument, options);
      }
export function useSalesOrdersExceptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesOrdersExceptionsQuery, SalesOrdersExceptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesOrdersExceptionsQuery, SalesOrdersExceptionsQueryVariables>(SalesOrdersExceptionsDocument, options);
        }
export type SalesOrdersExceptionsQueryHookResult = ReturnType<typeof useSalesOrdersExceptionsQuery>;
export type SalesOrdersExceptionsLazyQueryHookResult = ReturnType<typeof useSalesOrdersExceptionsLazyQuery>;
export type SalesOrdersExceptionsQueryResult = Apollo.QueryResult<SalesOrdersExceptionsQuery, SalesOrdersExceptionsQueryVariables>;
export function refetchSalesOrdersExceptionsQuery(variables: SalesOrdersExceptionsQueryVariables) {
      return { query: SalesOrdersExceptionsDocument, variables: variables }
    }
export const CreateJobsDocument = gql`
    mutation createJobs($createJobsInput: [CreateJobInput!]!, $isForJobBoard: Boolean, $scheduleNoEarlierThan: Date, $jobBoardRegionId: UUID) {
  createJobs(
    input: $createJobsInput
    isForJobBoard: $isForJobBoard
    scheduleNoEarlierThan: $scheduleNoEarlierThan
    jobBoardRegionId: $jobBoardRegionId
  ) {
    id
    name
    payout
  }
}
    `;
export type CreateJobsMutationFn = Apollo.MutationFunction<CreateJobsMutation, CreateJobsMutationVariables>;

/**
 * __useCreateJobsMutation__
 *
 * To run a mutation, you first call `useCreateJobsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobsMutation, { data, loading, error }] = useCreateJobsMutation({
 *   variables: {
 *      createJobsInput: // value for 'createJobsInput'
 *      isForJobBoard: // value for 'isForJobBoard'
 *      scheduleNoEarlierThan: // value for 'scheduleNoEarlierThan'
 *      jobBoardRegionId: // value for 'jobBoardRegionId'
 *   },
 * });
 */
export function useCreateJobsMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobsMutation, CreateJobsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobsMutation, CreateJobsMutationVariables>(CreateJobsDocument, options);
      }
export type CreateJobsMutationHookResult = ReturnType<typeof useCreateJobsMutation>;
export type CreateJobsMutationResult = Apollo.MutationResult<CreateJobsMutation>;
export type CreateJobsMutationOptions = Apollo.BaseMutationOptions<CreateJobsMutation, CreateJobsMutationVariables>;
export const GetEligibleMpCountForJobBoardDocument = gql`
    query getEligibleMpCountForJobBoard($processIds: [Int!]!, $jobBoardRegionId: String!, $erpSaleOrderId: Int!) {
  getEligibleMpCountForJobBoard(
    processIds: $processIds
    jobBoardRegionId: $jobBoardRegionId
    erpSaleOrderId: $erpSaleOrderId
  )
}
    `;

/**
 * __useGetEligibleMpCountForJobBoardQuery__
 *
 * To run a query within a React component, call `useGetEligibleMpCountForJobBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEligibleMpCountForJobBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEligibleMpCountForJobBoardQuery({
 *   variables: {
 *      processIds: // value for 'processIds'
 *      jobBoardRegionId: // value for 'jobBoardRegionId'
 *      erpSaleOrderId: // value for 'erpSaleOrderId'
 *   },
 * });
 */
export function useGetEligibleMpCountForJobBoardQuery(baseOptions: Apollo.QueryHookOptions<GetEligibleMpCountForJobBoardQuery, GetEligibleMpCountForJobBoardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEligibleMpCountForJobBoardQuery, GetEligibleMpCountForJobBoardQueryVariables>(GetEligibleMpCountForJobBoardDocument, options);
      }
export function useGetEligibleMpCountForJobBoardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEligibleMpCountForJobBoardQuery, GetEligibleMpCountForJobBoardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEligibleMpCountForJobBoardQuery, GetEligibleMpCountForJobBoardQueryVariables>(GetEligibleMpCountForJobBoardDocument, options);
        }
export type GetEligibleMpCountForJobBoardQueryHookResult = ReturnType<typeof useGetEligibleMpCountForJobBoardQuery>;
export type GetEligibleMpCountForJobBoardLazyQueryHookResult = ReturnType<typeof useGetEligibleMpCountForJobBoardLazyQuery>;
export type GetEligibleMpCountForJobBoardQueryResult = Apollo.QueryResult<GetEligibleMpCountForJobBoardQuery, GetEligibleMpCountForJobBoardQueryVariables>;
export function refetchGetEligibleMpCountForJobBoardQuery(variables: GetEligibleMpCountForJobBoardQueryVariables) {
      return { query: GetEligibleMpCountForJobBoardDocument, variables: variables }
    }
export const GenerateJobNameDocument = gql`
    query generateJobName {
  generateJobName
}
    `;

/**
 * __useGenerateJobNameQuery__
 *
 * To run a query within a React component, call `useGenerateJobNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateJobNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateJobNameQuery({
 *   variables: {
 *   },
 * });
 */
export function useGenerateJobNameQuery(baseOptions?: Apollo.QueryHookOptions<GenerateJobNameQuery, GenerateJobNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateJobNameQuery, GenerateJobNameQueryVariables>(GenerateJobNameDocument, options);
      }
export function useGenerateJobNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateJobNameQuery, GenerateJobNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateJobNameQuery, GenerateJobNameQueryVariables>(GenerateJobNameDocument, options);
        }
export type GenerateJobNameQueryHookResult = ReturnType<typeof useGenerateJobNameQuery>;
export type GenerateJobNameLazyQueryHookResult = ReturnType<typeof useGenerateJobNameLazyQuery>;
export type GenerateJobNameQueryResult = Apollo.QueryResult<GenerateJobNameQuery, GenerateJobNameQueryVariables>;
export function refetchGenerateJobNameQuery(variables?: GenerateJobNameQueryVariables) {
      return { query: GenerateJobNameDocument, variables: variables }
    }
export const SalesOrderLineProductProcessesDocument = gql`
    query salesOrderLineProductProcesses($salesOrderId: Int!, $filters: ProductProcessFiltersInput) {
  salesOrderLineProductProcesses(salesOrderId: $salesOrderId, filters: $filters) {
    ...SolProductProcess
  }
}
    ${SolProductProcessFragmentDoc}`;

/**
 * __useSalesOrderLineProductProcessesQuery__
 *
 * To run a query within a React component, call `useSalesOrderLineProductProcessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesOrderLineProductProcessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesOrderLineProductProcessesQuery({
 *   variables: {
 *      salesOrderId: // value for 'salesOrderId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSalesOrderLineProductProcessesQuery(baseOptions: Apollo.QueryHookOptions<SalesOrderLineProductProcessesQuery, SalesOrderLineProductProcessesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesOrderLineProductProcessesQuery, SalesOrderLineProductProcessesQueryVariables>(SalesOrderLineProductProcessesDocument, options);
      }
export function useSalesOrderLineProductProcessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesOrderLineProductProcessesQuery, SalesOrderLineProductProcessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesOrderLineProductProcessesQuery, SalesOrderLineProductProcessesQueryVariables>(SalesOrderLineProductProcessesDocument, options);
        }
export type SalesOrderLineProductProcessesQueryHookResult = ReturnType<typeof useSalesOrderLineProductProcessesQuery>;
export type SalesOrderLineProductProcessesLazyQueryHookResult = ReturnType<typeof useSalesOrderLineProductProcessesLazyQuery>;
export type SalesOrderLineProductProcessesQueryResult = Apollo.QueryResult<SalesOrderLineProductProcessesQuery, SalesOrderLineProductProcessesQueryVariables>;
export function refetchSalesOrderLineProductProcessesQuery(variables: SalesOrderLineProductProcessesQueryVariables) {
      return { query: SalesOrderLineProductProcessesDocument, variables: variables }
    }
export const GetActiveJobBoardRegionsDocument = gql`
    query GetActiveJobBoardRegions {
  getActiveJobBoardRegions {
    id
    name
    nextJobBoard {
      id
      startDate
      endDate
      status
    }
  }
}
    `;

/**
 * __useGetActiveJobBoardRegionsQuery__
 *
 * To run a query within a React component, call `useGetActiveJobBoardRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveJobBoardRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveJobBoardRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveJobBoardRegionsQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveJobBoardRegionsQuery, GetActiveJobBoardRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveJobBoardRegionsQuery, GetActiveJobBoardRegionsQueryVariables>(GetActiveJobBoardRegionsDocument, options);
      }
export function useGetActiveJobBoardRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveJobBoardRegionsQuery, GetActiveJobBoardRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveJobBoardRegionsQuery, GetActiveJobBoardRegionsQueryVariables>(GetActiveJobBoardRegionsDocument, options);
        }
export type GetActiveJobBoardRegionsQueryHookResult = ReturnType<typeof useGetActiveJobBoardRegionsQuery>;
export type GetActiveJobBoardRegionsLazyQueryHookResult = ReturnType<typeof useGetActiveJobBoardRegionsLazyQuery>;
export type GetActiveJobBoardRegionsQueryResult = Apollo.QueryResult<GetActiveJobBoardRegionsQuery, GetActiveJobBoardRegionsQueryVariables>;
export function refetchGetActiveJobBoardRegionsQuery(variables?: GetActiveJobBoardRegionsQueryVariables) {
      return { query: GetActiveJobBoardRegionsDocument, variables: variables }
    }
export const UnbundledSalesOrdersDocument = gql`
    query unbundledSalesOrders($limit: Int!, $offset: Int, $sort: [SortTypeInput!], $filters: SchedulingSalesOrdersFiltersInput) {
  salesOrderWithUnbundledParts(
    limit: $limit
    offset: $offset
    filters: $filters
    sort: $sort
  ) {
    totalCount
    items {
      id
      region
      name
      reorderSourceSaleOrderName
      project {
        id
        name
        isSecurePlus
      }
      earliestScheduledDate
      earliestPromisedShipDate
      latestPromisedShipDate
      unbundledPartCount
      unbundledPartPayout
      priority
      mfgDri {
        id
        displayName
      }
      unbundledProcessNames
      customerName
      customerCompanyName
      orderType
      productionCountries
      businessUnit
    }
  }
}
    `;

/**
 * __useUnbundledSalesOrdersQuery__
 *
 * To run a query within a React component, call `useUnbundledSalesOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnbundledSalesOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnbundledSalesOrdersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useUnbundledSalesOrdersQuery(baseOptions: Apollo.QueryHookOptions<UnbundledSalesOrdersQuery, UnbundledSalesOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnbundledSalesOrdersQuery, UnbundledSalesOrdersQueryVariables>(UnbundledSalesOrdersDocument, options);
      }
export function useUnbundledSalesOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnbundledSalesOrdersQuery, UnbundledSalesOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnbundledSalesOrdersQuery, UnbundledSalesOrdersQueryVariables>(UnbundledSalesOrdersDocument, options);
        }
export type UnbundledSalesOrdersQueryHookResult = ReturnType<typeof useUnbundledSalesOrdersQuery>;
export type UnbundledSalesOrdersLazyQueryHookResult = ReturnType<typeof useUnbundledSalesOrdersLazyQuery>;
export type UnbundledSalesOrdersQueryResult = Apollo.QueryResult<UnbundledSalesOrdersQuery, UnbundledSalesOrdersQueryVariables>;
export function refetchUnbundledSalesOrdersQuery(variables: UnbundledSalesOrdersQueryVariables) {
      return { query: UnbundledSalesOrdersDocument, variables: variables }
    }
export const AddExceptionFailureNoteDocument = gql`
    mutation addExceptionFailureNote($input: ExceptionFailureNoteInput!) {
  addExceptionFailureNote(exceptionFailureNoteInput: $input) {
    id
    body
  }
}
    `;
export type AddExceptionFailureNoteMutationFn = Apollo.MutationFunction<AddExceptionFailureNoteMutation, AddExceptionFailureNoteMutationVariables>;

/**
 * __useAddExceptionFailureNoteMutation__
 *
 * To run a mutation, you first call `useAddExceptionFailureNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddExceptionFailureNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addExceptionFailureNoteMutation, { data, loading, error }] = useAddExceptionFailureNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddExceptionFailureNoteMutation(baseOptions?: Apollo.MutationHookOptions<AddExceptionFailureNoteMutation, AddExceptionFailureNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddExceptionFailureNoteMutation, AddExceptionFailureNoteMutationVariables>(AddExceptionFailureNoteDocument, options);
      }
export type AddExceptionFailureNoteMutationHookResult = ReturnType<typeof useAddExceptionFailureNoteMutation>;
export type AddExceptionFailureNoteMutationResult = Apollo.MutationResult<AddExceptionFailureNoteMutation>;
export type AddExceptionFailureNoteMutationOptions = Apollo.BaseMutationOptions<AddExceptionFailureNoteMutation, AddExceptionFailureNoteMutationVariables>;
export const CreateAttachmentDocument = gql`
    mutation createAttachment($input: AttachmentInput!) {
  createExceptionNoteAttachment(input: $input) {
    id
    fileName
    extension
    mimeType
    uploadUrl
  }
}
    `;
export type CreateAttachmentMutationFn = Apollo.MutationFunction<CreateAttachmentMutation, CreateAttachmentMutationVariables>;

/**
 * __useCreateAttachmentMutation__
 *
 * To run a mutation, you first call `useCreateAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAttachmentMutation, { data, loading, error }] = useCreateAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAttachmentMutation, CreateAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAttachmentMutation, CreateAttachmentMutationVariables>(CreateAttachmentDocument, options);
      }
export type CreateAttachmentMutationHookResult = ReturnType<typeof useCreateAttachmentMutation>;
export type CreateAttachmentMutationResult = Apollo.MutationResult<CreateAttachmentMutation>;
export type CreateAttachmentMutationOptions = Apollo.BaseMutationOptions<CreateAttachmentMutation, CreateAttachmentMutationVariables>;
export const CreateExceptionFailureDocument = gql`
    mutation createExceptionFailure($exceptionFailureInput: ExceptionFailureInput!) {
  createExceptionFailure(exceptionFailureInput: $exceptionFailureInput) {
    id
    name
  }
}
    `;
export type CreateExceptionFailureMutationFn = Apollo.MutationFunction<CreateExceptionFailureMutation, CreateExceptionFailureMutationVariables>;

/**
 * __useCreateExceptionFailureMutation__
 *
 * To run a mutation, you first call `useCreateExceptionFailureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExceptionFailureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExceptionFailureMutation, { data, loading, error }] = useCreateExceptionFailureMutation({
 *   variables: {
 *      exceptionFailureInput: // value for 'exceptionFailureInput'
 *   },
 * });
 */
export function useCreateExceptionFailureMutation(baseOptions?: Apollo.MutationHookOptions<CreateExceptionFailureMutation, CreateExceptionFailureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExceptionFailureMutation, CreateExceptionFailureMutationVariables>(CreateExceptionFailureDocument, options);
      }
export type CreateExceptionFailureMutationHookResult = ReturnType<typeof useCreateExceptionFailureMutation>;
export type CreateExceptionFailureMutationResult = Apollo.MutationResult<CreateExceptionFailureMutation>;
export type CreateExceptionFailureMutationOptions = Apollo.BaseMutationOptions<CreateExceptionFailureMutation, CreateExceptionFailureMutationVariables>;
export const CreateExceptionFailureNoteAttachmentDocument = gql`
    mutation createExceptionFailureNoteAttachment($input: AttachmentInput!) {
  createExceptionFailureNoteAttachment(attachmentInput: $input) {
    id
    fileName
    extension
    mimeType
    uploadUrl
  }
}
    `;
export type CreateExceptionFailureNoteAttachmentMutationFn = Apollo.MutationFunction<CreateExceptionFailureNoteAttachmentMutation, CreateExceptionFailureNoteAttachmentMutationVariables>;

/**
 * __useCreateExceptionFailureNoteAttachmentMutation__
 *
 * To run a mutation, you first call `useCreateExceptionFailureNoteAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExceptionFailureNoteAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExceptionFailureNoteAttachmentMutation, { data, loading, error }] = useCreateExceptionFailureNoteAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExceptionFailureNoteAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateExceptionFailureNoteAttachmentMutation, CreateExceptionFailureNoteAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExceptionFailureNoteAttachmentMutation, CreateExceptionFailureNoteAttachmentMutationVariables>(CreateExceptionFailureNoteAttachmentDocument, options);
      }
export type CreateExceptionFailureNoteAttachmentMutationHookResult = ReturnType<typeof useCreateExceptionFailureNoteAttachmentMutation>;
export type CreateExceptionFailureNoteAttachmentMutationResult = Apollo.MutationResult<CreateExceptionFailureNoteAttachmentMutation>;
export type CreateExceptionFailureNoteAttachmentMutationOptions = Apollo.BaseMutationOptions<CreateExceptionFailureNoteAttachmentMutation, CreateExceptionFailureNoteAttachmentMutationVariables>;
export const MarkUploadedNoteAttachmentDocument = gql`
    mutation markUploadedNoteAttachment($id: UUID!) {
  markUploadedAsset(id: $id) {
    id
    downloadUrl
  }
}
    `;
export type MarkUploadedNoteAttachmentMutationFn = Apollo.MutationFunction<MarkUploadedNoteAttachmentMutation, MarkUploadedNoteAttachmentMutationVariables>;

/**
 * __useMarkUploadedNoteAttachmentMutation__
 *
 * To run a mutation, you first call `useMarkUploadedNoteAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkUploadedNoteAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markUploadedNoteAttachmentMutation, { data, loading, error }] = useMarkUploadedNoteAttachmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkUploadedNoteAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<MarkUploadedNoteAttachmentMutation, MarkUploadedNoteAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkUploadedNoteAttachmentMutation, MarkUploadedNoteAttachmentMutationVariables>(MarkUploadedNoteAttachmentDocument, options);
      }
export type MarkUploadedNoteAttachmentMutationHookResult = ReturnType<typeof useMarkUploadedNoteAttachmentMutation>;
export type MarkUploadedNoteAttachmentMutationResult = Apollo.MutationResult<MarkUploadedNoteAttachmentMutation>;
export type MarkUploadedNoteAttachmentMutationOptions = Apollo.BaseMutationOptions<MarkUploadedNoteAttachmentMutation, MarkUploadedNoteAttachmentMutationVariables>;
export const RemoveExceptionFailureNoteAttachmentDocument = gql`
    mutation removeExceptionFailureNoteAttachment($id: UUID!) {
  removeExceptionFailureNoteAttachment(id: $id)
}
    `;
export type RemoveExceptionFailureNoteAttachmentMutationFn = Apollo.MutationFunction<RemoveExceptionFailureNoteAttachmentMutation, RemoveExceptionFailureNoteAttachmentMutationVariables>;

/**
 * __useRemoveExceptionFailureNoteAttachmentMutation__
 *
 * To run a mutation, you first call `useRemoveExceptionFailureNoteAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveExceptionFailureNoteAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeExceptionFailureNoteAttachmentMutation, { data, loading, error }] = useRemoveExceptionFailureNoteAttachmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveExceptionFailureNoteAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveExceptionFailureNoteAttachmentMutation, RemoveExceptionFailureNoteAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveExceptionFailureNoteAttachmentMutation, RemoveExceptionFailureNoteAttachmentMutationVariables>(RemoveExceptionFailureNoteAttachmentDocument, options);
      }
export type RemoveExceptionFailureNoteAttachmentMutationHookResult = ReturnType<typeof useRemoveExceptionFailureNoteAttachmentMutation>;
export type RemoveExceptionFailureNoteAttachmentMutationResult = Apollo.MutationResult<RemoveExceptionFailureNoteAttachmentMutation>;
export type RemoveExceptionFailureNoteAttachmentMutationOptions = Apollo.BaseMutationOptions<RemoveExceptionFailureNoteAttachmentMutation, RemoveExceptionFailureNoteAttachmentMutationVariables>;
export const SetExceptionFailurePartsDocument = gql`
    mutation setExceptionFailureParts($input: ExceptionFailurePartsInput!) {
  setExceptionFailureParts(inputExceptionFailureParts: $input) {
    id
    exceptionId
  }
}
    `;
export type SetExceptionFailurePartsMutationFn = Apollo.MutationFunction<SetExceptionFailurePartsMutation, SetExceptionFailurePartsMutationVariables>;

/**
 * __useSetExceptionFailurePartsMutation__
 *
 * To run a mutation, you first call `useSetExceptionFailurePartsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetExceptionFailurePartsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setExceptionFailurePartsMutation, { data, loading, error }] = useSetExceptionFailurePartsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetExceptionFailurePartsMutation(baseOptions?: Apollo.MutationHookOptions<SetExceptionFailurePartsMutation, SetExceptionFailurePartsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetExceptionFailurePartsMutation, SetExceptionFailurePartsMutationVariables>(SetExceptionFailurePartsDocument, options);
      }
export type SetExceptionFailurePartsMutationHookResult = ReturnType<typeof useSetExceptionFailurePartsMutation>;
export type SetExceptionFailurePartsMutationResult = Apollo.MutationResult<SetExceptionFailurePartsMutation>;
export type SetExceptionFailurePartsMutationOptions = Apollo.BaseMutationOptions<SetExceptionFailurePartsMutation, SetExceptionFailurePartsMutationVariables>;
export const UpdateExceptionFailureDocument = gql`
    mutation updateExceptionFailure($id: UUID!, $exceptionFailureInput: ExceptionFailureUpdateInput!) {
  updateExceptionFailure(exceptionFailureInput: $exceptionFailureInput, id: $id) {
    id
  }
}
    `;
export type UpdateExceptionFailureMutationFn = Apollo.MutationFunction<UpdateExceptionFailureMutation, UpdateExceptionFailureMutationVariables>;

/**
 * __useUpdateExceptionFailureMutation__
 *
 * To run a mutation, you first call `useUpdateExceptionFailureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExceptionFailureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExceptionFailureMutation, { data, loading, error }] = useUpdateExceptionFailureMutation({
 *   variables: {
 *      id: // value for 'id'
 *      exceptionFailureInput: // value for 'exceptionFailureInput'
 *   },
 * });
 */
export function useUpdateExceptionFailureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExceptionFailureMutation, UpdateExceptionFailureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExceptionFailureMutation, UpdateExceptionFailureMutationVariables>(UpdateExceptionFailureDocument, options);
      }
export type UpdateExceptionFailureMutationHookResult = ReturnType<typeof useUpdateExceptionFailureMutation>;
export type UpdateExceptionFailureMutationResult = Apollo.MutationResult<UpdateExceptionFailureMutation>;
export type UpdateExceptionFailureMutationOptions = Apollo.BaseMutationOptions<UpdateExceptionFailureMutation, UpdateExceptionFailureMutationVariables>;
export const UpdateExceptionFailurePartsDocument = gql`
    mutation updateExceptionFailureParts($input: ExceptionFailurePartsInput!) {
  updateExceptionFailureParts(inputExceptionFailureParts: $input) {
    id
    exceptionId
  }
}
    `;
export type UpdateExceptionFailurePartsMutationFn = Apollo.MutationFunction<UpdateExceptionFailurePartsMutation, UpdateExceptionFailurePartsMutationVariables>;

/**
 * __useUpdateExceptionFailurePartsMutation__
 *
 * To run a mutation, you first call `useUpdateExceptionFailurePartsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExceptionFailurePartsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExceptionFailurePartsMutation, { data, loading, error }] = useUpdateExceptionFailurePartsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExceptionFailurePartsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExceptionFailurePartsMutation, UpdateExceptionFailurePartsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExceptionFailurePartsMutation, UpdateExceptionFailurePartsMutationVariables>(UpdateExceptionFailurePartsDocument, options);
      }
export type UpdateExceptionFailurePartsMutationHookResult = ReturnType<typeof useUpdateExceptionFailurePartsMutation>;
export type UpdateExceptionFailurePartsMutationResult = Apollo.MutationResult<UpdateExceptionFailurePartsMutation>;
export type UpdateExceptionFailurePartsMutationOptions = Apollo.BaseMutationOptions<UpdateExceptionFailurePartsMutation, UpdateExceptionFailurePartsMutationVariables>;
export const ExceptionFailureActionsDocument = gql`
    query exceptionFailureActions {
  exceptionFailureActions {
    id
    name
  }
}
    `;

/**
 * __useExceptionFailureActionsQuery__
 *
 * To run a query within a React component, call `useExceptionFailureActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExceptionFailureActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExceptionFailureActionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useExceptionFailureActionsQuery(baseOptions?: Apollo.QueryHookOptions<ExceptionFailureActionsQuery, ExceptionFailureActionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExceptionFailureActionsQuery, ExceptionFailureActionsQueryVariables>(ExceptionFailureActionsDocument, options);
      }
export function useExceptionFailureActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExceptionFailureActionsQuery, ExceptionFailureActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExceptionFailureActionsQuery, ExceptionFailureActionsQueryVariables>(ExceptionFailureActionsDocument, options);
        }
export type ExceptionFailureActionsQueryHookResult = ReturnType<typeof useExceptionFailureActionsQuery>;
export type ExceptionFailureActionsLazyQueryHookResult = ReturnType<typeof useExceptionFailureActionsLazyQuery>;
export type ExceptionFailureActionsQueryResult = Apollo.QueryResult<ExceptionFailureActionsQuery, ExceptionFailureActionsQueryVariables>;
export function refetchExceptionFailureActionsQuery(variables?: ExceptionFailureActionsQueryVariables) {
      return { query: ExceptionFailureActionsDocument, variables: variables }
    }
export const CarActiveAssigneesDocument = gql`
    query carActiveAssignees {
  activeCorrectiveActionRequestAssignees {
    id
    displayName
  }
}
    `;

/**
 * __useCarActiveAssigneesQuery__
 *
 * To run a query within a React component, call `useCarActiveAssigneesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarActiveAssigneesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarActiveAssigneesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCarActiveAssigneesQuery(baseOptions?: Apollo.QueryHookOptions<CarActiveAssigneesQuery, CarActiveAssigneesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarActiveAssigneesQuery, CarActiveAssigneesQueryVariables>(CarActiveAssigneesDocument, options);
      }
export function useCarActiveAssigneesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarActiveAssigneesQuery, CarActiveAssigneesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarActiveAssigneesQuery, CarActiveAssigneesQueryVariables>(CarActiveAssigneesDocument, options);
        }
export type CarActiveAssigneesQueryHookResult = ReturnType<typeof useCarActiveAssigneesQuery>;
export type CarActiveAssigneesLazyQueryHookResult = ReturnType<typeof useCarActiveAssigneesLazyQuery>;
export type CarActiveAssigneesQueryResult = Apollo.QueryResult<CarActiveAssigneesQuery, CarActiveAssigneesQueryVariables>;
export function refetchCarActiveAssigneesQuery(variables?: CarActiveAssigneesQueryVariables) {
      return { query: CarActiveAssigneesDocument, variables: variables }
    }
export const ExceptionFailureDocument = gql`
    query exceptionFailure($id: UUID!) {
  exceptionFailure(id: $id) {
    id
    name
    jobId
    jobName
    jobRequestId
    erpSaleOrderId
    assignee
    type
    action
    isFailure
    daysLate
    failureDiscoveredBy
    shipmentId
    receiptId
    qcId
    milestoneType
    assignedEntity
    isCustomerImpacted
    assigneeId
    creator
    actionId
    correctiveActionRequestId
    correctiveActionRequest {
      id
      status
    }
    exceptionFailureAttachments {
      id
      createdBy {
        id
        displayName
      }
      attachment {
        id
        fileName
        downloadUrl
        mimeType
      }
      createdAt
    }
    exceptionFailureParts {
      id
      erpProductId
      processes
      lines
      orderedQuantity
      partName
      failedQuantity
    }
    additionalContext
  }
}
    `;

/**
 * __useExceptionFailureQuery__
 *
 * To run a query within a React component, call `useExceptionFailureQuery` and pass it any options that fit your needs.
 * When your component renders, `useExceptionFailureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExceptionFailureQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExceptionFailureQuery(baseOptions: Apollo.QueryHookOptions<ExceptionFailureQuery, ExceptionFailureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExceptionFailureQuery, ExceptionFailureQueryVariables>(ExceptionFailureDocument, options);
      }
export function useExceptionFailureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExceptionFailureQuery, ExceptionFailureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExceptionFailureQuery, ExceptionFailureQueryVariables>(ExceptionFailureDocument, options);
        }
export type ExceptionFailureQueryHookResult = ReturnType<typeof useExceptionFailureQuery>;
export type ExceptionFailureLazyQueryHookResult = ReturnType<typeof useExceptionFailureLazyQuery>;
export type ExceptionFailureQueryResult = Apollo.QueryResult<ExceptionFailureQuery, ExceptionFailureQueryVariables>;
export function refetchExceptionFailureQuery(variables: ExceptionFailureQueryVariables) {
      return { query: ExceptionFailureDocument, variables: variables }
    }
export const JobPartsDocument = gql`
    query jobParts($jobId: Int!) {
  getJobParts(jobId: $jobId) {
    productId
    partName
    lines
    processes
    orderedQty
  }
}
    `;

/**
 * __useJobPartsQuery__
 *
 * To run a query within a React component, call `useJobPartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobPartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobPartsQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useJobPartsQuery(baseOptions: Apollo.QueryHookOptions<JobPartsQuery, JobPartsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobPartsQuery, JobPartsQueryVariables>(JobPartsDocument, options);
      }
export function useJobPartsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobPartsQuery, JobPartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobPartsQuery, JobPartsQueryVariables>(JobPartsDocument, options);
        }
export type JobPartsQueryHookResult = ReturnType<typeof useJobPartsQuery>;
export type JobPartsLazyQueryHookResult = ReturnType<typeof useJobPartsLazyQuery>;
export type JobPartsQueryResult = Apollo.QueryResult<JobPartsQuery, JobPartsQueryVariables>;
export function refetchJobPartsQuery(variables: JobPartsQueryVariables) {
      return { query: JobPartsDocument, variables: variables }
    }
export const JobRequestPartsDocument = gql`
    query jobRequestParts($jobRequestId: Int!) {
  getJobRequestParts(jobRequestId: $jobRequestId) {
    productId
    partName
    lines
    processes
    orderedQty
  }
}
    `;

/**
 * __useJobRequestPartsQuery__
 *
 * To run a query within a React component, call `useJobRequestPartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobRequestPartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobRequestPartsQuery({
 *   variables: {
 *      jobRequestId: // value for 'jobRequestId'
 *   },
 * });
 */
export function useJobRequestPartsQuery(baseOptions: Apollo.QueryHookOptions<JobRequestPartsQuery, JobRequestPartsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobRequestPartsQuery, JobRequestPartsQueryVariables>(JobRequestPartsDocument, options);
      }
export function useJobRequestPartsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobRequestPartsQuery, JobRequestPartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobRequestPartsQuery, JobRequestPartsQueryVariables>(JobRequestPartsDocument, options);
        }
export type JobRequestPartsQueryHookResult = ReturnType<typeof useJobRequestPartsQuery>;
export type JobRequestPartsLazyQueryHookResult = ReturnType<typeof useJobRequestPartsLazyQuery>;
export type JobRequestPartsQueryResult = Apollo.QueryResult<JobRequestPartsQuery, JobRequestPartsQueryVariables>;
export function refetchJobRequestPartsQuery(variables: JobRequestPartsQueryVariables) {
      return { query: JobRequestPartsDocument, variables: variables }
    }
export const JobRequestsDocument = gql`
    query jobRequests($statuses: [JobRequestStatus!]!, $jobId: Int) {
  jobRequests(statuses: $statuses, jobId: $jobId) {
    id
    status
    mfgPartner {
      id
      name
    }
    receipts {
      ...JobRequestInventoryMove
    }
    qualityChecks {
      ...JobRequestInventoryMove
    }
    deliveryOrders {
      ...JobRequestDeliveries
    }
  }
}
    ${JobRequestInventoryMoveFragmentDoc}
${JobRequestDeliveriesFragmentDoc}`;

/**
 * __useJobRequestsQuery__
 *
 * To run a query within a React component, call `useJobRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobRequestsQuery({
 *   variables: {
 *      statuses: // value for 'statuses'
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useJobRequestsQuery(baseOptions: Apollo.QueryHookOptions<JobRequestsQuery, JobRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobRequestsQuery, JobRequestsQueryVariables>(JobRequestsDocument, options);
      }
export function useJobRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobRequestsQuery, JobRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobRequestsQuery, JobRequestsQueryVariables>(JobRequestsDocument, options);
        }
export type JobRequestsQueryHookResult = ReturnType<typeof useJobRequestsQuery>;
export type JobRequestsLazyQueryHookResult = ReturnType<typeof useJobRequestsLazyQuery>;
export type JobRequestsQueryResult = Apollo.QueryResult<JobRequestsQuery, JobRequestsQueryVariables>;
export function refetchJobRequestsQuery(variables: JobRequestsQueryVariables) {
      return { query: JobRequestsDocument, variables: variables }
    }
export const ExceptionFailuresDocument = gql`
    query exceptionFailures($filters: ExceptionFailuresFilterInput, $limit: Int) {
  exceptionFailures(filters: $filters, limit: $limit) {
    totalCount
    items {
      id
      name
      type
      status
      jobId
      jobName
      exceptionFailureState
      manufacturingPartnerId
      manufacturingPartnerName
      jobRequestId
      jobComputedStatus
      milestoneType
      updatedAt
      action
      assignee
      assignedEntity
      isCustomerImpacted
      latestNote {
        id
        body
      }
      correctiveActionRequest {
        id
        status
        name
      }
    }
  }
}
    `;

/**
 * __useExceptionFailuresQuery__
 *
 * To run a query within a React component, call `useExceptionFailuresQuery` and pass it any options that fit your needs.
 * When your component renders, `useExceptionFailuresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExceptionFailuresQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useExceptionFailuresQuery(baseOptions?: Apollo.QueryHookOptions<ExceptionFailuresQuery, ExceptionFailuresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExceptionFailuresQuery, ExceptionFailuresQueryVariables>(ExceptionFailuresDocument, options);
      }
export function useExceptionFailuresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExceptionFailuresQuery, ExceptionFailuresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExceptionFailuresQuery, ExceptionFailuresQueryVariables>(ExceptionFailuresDocument, options);
        }
export type ExceptionFailuresQueryHookResult = ReturnType<typeof useExceptionFailuresQuery>;
export type ExceptionFailuresLazyQueryHookResult = ReturnType<typeof useExceptionFailuresLazyQuery>;
export type ExceptionFailuresQueryResult = Apollo.QueryResult<ExceptionFailuresQuery, ExceptionFailuresQueryVariables>;
export function refetchExceptionFailuresQuery(variables?: ExceptionFailuresQueryVariables) {
      return { query: ExceptionFailuresDocument, variables: variables }
    }
export const MarkUploadedAttachmentDocument = gql`
    mutation markUploadedAttachment($id: UUID!) {
  markUploadedAsset(id: $id) {
    id
    downloadUrl
  }
}
    `;
export type MarkUploadedAttachmentMutationFn = Apollo.MutationFunction<MarkUploadedAttachmentMutation, MarkUploadedAttachmentMutationVariables>;

/**
 * __useMarkUploadedAttachmentMutation__
 *
 * To run a mutation, you first call `useMarkUploadedAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkUploadedAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markUploadedAttachmentMutation, { data, loading, error }] = useMarkUploadedAttachmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkUploadedAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<MarkUploadedAttachmentMutation, MarkUploadedAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkUploadedAttachmentMutation, MarkUploadedAttachmentMutationVariables>(MarkUploadedAttachmentDocument, options);
      }
export type MarkUploadedAttachmentMutationHookResult = ReturnType<typeof useMarkUploadedAttachmentMutation>;
export type MarkUploadedAttachmentMutationResult = Apollo.MutationResult<MarkUploadedAttachmentMutation>;
export type MarkUploadedAttachmentMutationOptions = Apollo.BaseMutationOptions<MarkUploadedAttachmentMutation, MarkUploadedAttachmentMutationVariables>;
export const ActiveMfgDrisDocument = gql`
    query activeMfgDris {
  getActiveMfgDriUsers {
    id
    displayName
  }
}
    `;

/**
 * __useActiveMfgDrisQuery__
 *
 * To run a query within a React component, call `useActiveMfgDrisQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveMfgDrisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveMfgDrisQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveMfgDrisQuery(baseOptions?: Apollo.QueryHookOptions<ActiveMfgDrisQuery, ActiveMfgDrisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveMfgDrisQuery, ActiveMfgDrisQueryVariables>(ActiveMfgDrisDocument, options);
      }
export function useActiveMfgDrisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveMfgDrisQuery, ActiveMfgDrisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveMfgDrisQuery, ActiveMfgDrisQueryVariables>(ActiveMfgDrisDocument, options);
        }
export type ActiveMfgDrisQueryHookResult = ReturnType<typeof useActiveMfgDrisQuery>;
export type ActiveMfgDrisLazyQueryHookResult = ReturnType<typeof useActiveMfgDrisLazyQuery>;
export type ActiveMfgDrisQueryResult = Apollo.QueryResult<ActiveMfgDrisQuery, ActiveMfgDrisQueryVariables>;
export function refetchActiveMfgDrisQuery(variables?: ActiveMfgDrisQueryVariables) {
      return { query: ActiveMfgDrisDocument, variables: variables }
    }
export const ExceptionMpCountriesQueryDocument = gql`
    query exceptionMpCountriesQuery {
  mpCountries {
    id
    name
  }
}
    `;

/**
 * __useExceptionMpCountriesQueryQuery__
 *
 * To run a query within a React component, call `useExceptionMpCountriesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useExceptionMpCountriesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExceptionMpCountriesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useExceptionMpCountriesQueryQuery(baseOptions?: Apollo.QueryHookOptions<ExceptionMpCountriesQueryQuery, ExceptionMpCountriesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExceptionMpCountriesQueryQuery, ExceptionMpCountriesQueryQueryVariables>(ExceptionMpCountriesQueryDocument, options);
      }
export function useExceptionMpCountriesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExceptionMpCountriesQueryQuery, ExceptionMpCountriesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExceptionMpCountriesQueryQuery, ExceptionMpCountriesQueryQueryVariables>(ExceptionMpCountriesQueryDocument, options);
        }
export type ExceptionMpCountriesQueryQueryHookResult = ReturnType<typeof useExceptionMpCountriesQueryQuery>;
export type ExceptionMpCountriesQueryLazyQueryHookResult = ReturnType<typeof useExceptionMpCountriesQueryLazyQuery>;
export type ExceptionMpCountriesQueryQueryResult = Apollo.QueryResult<ExceptionMpCountriesQueryQuery, ExceptionMpCountriesQueryQueryVariables>;
export function refetchExceptionMpCountriesQueryQuery(variables?: ExceptionMpCountriesQueryQueryVariables) {
      return { query: ExceptionMpCountriesQueryDocument, variables: variables }
    }
export const ActiveJobBoardRegionsDocument = gql`
    query activeJobBoardRegions {
  getActiveJobBoardRegions {
    id
    name
  }
}
    `;

/**
 * __useActiveJobBoardRegionsQuery__
 *
 * To run a query within a React component, call `useActiveJobBoardRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveJobBoardRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveJobBoardRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveJobBoardRegionsQuery(baseOptions?: Apollo.QueryHookOptions<ActiveJobBoardRegionsQuery, ActiveJobBoardRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveJobBoardRegionsQuery, ActiveJobBoardRegionsQueryVariables>(ActiveJobBoardRegionsDocument, options);
      }
export function useActiveJobBoardRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveJobBoardRegionsQuery, ActiveJobBoardRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveJobBoardRegionsQuery, ActiveJobBoardRegionsQueryVariables>(ActiveJobBoardRegionsDocument, options);
        }
export type ActiveJobBoardRegionsQueryHookResult = ReturnType<typeof useActiveJobBoardRegionsQuery>;
export type ActiveJobBoardRegionsLazyQueryHookResult = ReturnType<typeof useActiveJobBoardRegionsLazyQuery>;
export type ActiveJobBoardRegionsQueryResult = Apollo.QueryResult<ActiveJobBoardRegionsQuery, ActiveJobBoardRegionsQueryVariables>;
export function refetchActiveJobBoardRegionsQuery(variables?: ActiveJobBoardRegionsQueryVariables) {
      return { query: ActiveJobBoardRegionsDocument, variables: variables }
    }
export const GetBusinessUnitsDocument = gql`
    query getBusinessUnits {
  getBusinessUnits
}
    `;

/**
 * __useGetBusinessUnitsQuery__
 *
 * To run a query within a React component, call `useGetBusinessUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessUnitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBusinessUnitsQuery(baseOptions?: Apollo.QueryHookOptions<GetBusinessUnitsQuery, GetBusinessUnitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessUnitsQuery, GetBusinessUnitsQueryVariables>(GetBusinessUnitsDocument, options);
      }
export function useGetBusinessUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessUnitsQuery, GetBusinessUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessUnitsQuery, GetBusinessUnitsQueryVariables>(GetBusinessUnitsDocument, options);
        }
export type GetBusinessUnitsQueryHookResult = ReturnType<typeof useGetBusinessUnitsQuery>;
export type GetBusinessUnitsLazyQueryHookResult = ReturnType<typeof useGetBusinessUnitsLazyQuery>;
export type GetBusinessUnitsQueryResult = Apollo.QueryResult<GetBusinessUnitsQuery, GetBusinessUnitsQueryVariables>;
export function refetchGetBusinessUnitsQuery(variables?: GetBusinessUnitsQueryVariables) {
      return { query: GetBusinessUnitsDocument, variables: variables }
    }
export const GetExceptionActionsQueryDocument = gql`
    query getExceptionActionsQuery {
  exceptionActions {
    id
    name
  }
}
    `;

/**
 * __useGetExceptionActionsQueryQuery__
 *
 * To run a query within a React component, call `useGetExceptionActionsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExceptionActionsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExceptionActionsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExceptionActionsQueryQuery(baseOptions?: Apollo.QueryHookOptions<GetExceptionActionsQueryQuery, GetExceptionActionsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExceptionActionsQueryQuery, GetExceptionActionsQueryQueryVariables>(GetExceptionActionsQueryDocument, options);
      }
export function useGetExceptionActionsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExceptionActionsQueryQuery, GetExceptionActionsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExceptionActionsQueryQuery, GetExceptionActionsQueryQueryVariables>(GetExceptionActionsQueryDocument, options);
        }
export type GetExceptionActionsQueryQueryHookResult = ReturnType<typeof useGetExceptionActionsQueryQuery>;
export type GetExceptionActionsQueryLazyQueryHookResult = ReturnType<typeof useGetExceptionActionsQueryLazyQuery>;
export type GetExceptionActionsQueryQueryResult = Apollo.QueryResult<GetExceptionActionsQueryQuery, GetExceptionActionsQueryQueryVariables>;
export function refetchGetExceptionActionsQueryQuery(variables?: GetExceptionActionsQueryQueryVariables) {
      return { query: GetExceptionActionsQueryDocument, variables: variables }
    }
export const GetExceptionCreatedByUserListDocument = gql`
    query getExceptionCreatedByUserList {
  getExceptionCreatedByUserList {
    id
    displayName
  }
}
    `;

/**
 * __useGetExceptionCreatedByUserListQuery__
 *
 * To run a query within a React component, call `useGetExceptionCreatedByUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExceptionCreatedByUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExceptionCreatedByUserListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExceptionCreatedByUserListQuery(baseOptions?: Apollo.QueryHookOptions<GetExceptionCreatedByUserListQuery, GetExceptionCreatedByUserListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExceptionCreatedByUserListQuery, GetExceptionCreatedByUserListQueryVariables>(GetExceptionCreatedByUserListDocument, options);
      }
export function useGetExceptionCreatedByUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExceptionCreatedByUserListQuery, GetExceptionCreatedByUserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExceptionCreatedByUserListQuery, GetExceptionCreatedByUserListQueryVariables>(GetExceptionCreatedByUserListDocument, options);
        }
export type GetExceptionCreatedByUserListQueryHookResult = ReturnType<typeof useGetExceptionCreatedByUserListQuery>;
export type GetExceptionCreatedByUserListLazyQueryHookResult = ReturnType<typeof useGetExceptionCreatedByUserListLazyQuery>;
export type GetExceptionCreatedByUserListQueryResult = Apollo.QueryResult<GetExceptionCreatedByUserListQuery, GetExceptionCreatedByUserListQueryVariables>;
export function refetchGetExceptionCreatedByUserListQuery(variables?: GetExceptionCreatedByUserListQueryVariables) {
      return { query: GetExceptionCreatedByUserListDocument, variables: variables }
    }
export const GetExceptionTypesDocument = gql`
    query getExceptionTypes {
  exceptionTypes {
    id
    name
  }
}
    `;

/**
 * __useGetExceptionTypesQuery__
 *
 * To run a query within a React component, call `useGetExceptionTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExceptionTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExceptionTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExceptionTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetExceptionTypesQuery, GetExceptionTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExceptionTypesQuery, GetExceptionTypesQueryVariables>(GetExceptionTypesDocument, options);
      }
export function useGetExceptionTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExceptionTypesQuery, GetExceptionTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExceptionTypesQuery, GetExceptionTypesQueryVariables>(GetExceptionTypesDocument, options);
        }
export type GetExceptionTypesQueryHookResult = ReturnType<typeof useGetExceptionTypesQuery>;
export type GetExceptionTypesLazyQueryHookResult = ReturnType<typeof useGetExceptionTypesLazyQuery>;
export type GetExceptionTypesQueryResult = Apollo.QueryResult<GetExceptionTypesQuery, GetExceptionTypesQueryVariables>;
export function refetchGetExceptionTypesQuery(variables?: GetExceptionTypesQueryVariables) {
      return { query: GetExceptionTypesDocument, variables: variables }
    }
export const GetMfgDriUsersDocument = gql`
    query getMfgDriUsers($assignedTo: String) {
  getMfgDriUsers(assignedTo: $assignedTo) {
    id
    displayName
  }
}
    `;

/**
 * __useGetMfgDriUsersQuery__
 *
 * To run a query within a React component, call `useGetMfgDriUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMfgDriUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMfgDriUsersQuery({
 *   variables: {
 *      assignedTo: // value for 'assignedTo'
 *   },
 * });
 */
export function useGetMfgDriUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetMfgDriUsersQuery, GetMfgDriUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMfgDriUsersQuery, GetMfgDriUsersQueryVariables>(GetMfgDriUsersDocument, options);
      }
export function useGetMfgDriUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMfgDriUsersQuery, GetMfgDriUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMfgDriUsersQuery, GetMfgDriUsersQueryVariables>(GetMfgDriUsersDocument, options);
        }
export type GetMfgDriUsersQueryHookResult = ReturnType<typeof useGetMfgDriUsersQuery>;
export type GetMfgDriUsersLazyQueryHookResult = ReturnType<typeof useGetMfgDriUsersLazyQuery>;
export type GetMfgDriUsersQueryResult = Apollo.QueryResult<GetMfgDriUsersQuery, GetMfgDriUsersQueryVariables>;
export function refetchGetMfgDriUsersQuery(variables?: GetMfgDriUsersQueryVariables) {
      return { query: GetMfgDriUsersDocument, variables: variables }
    }
export const GetSchedulingTypesDocument = gql`
    query getSchedulingTypes($productionCountry: ProductionCountry!) {
  getSchedulingTypes(productionCountry: $productionCountry) {
    schedulingTypes
    isJobBoardLive
  }
}
    `;

/**
 * __useGetSchedulingTypesQuery__
 *
 * To run a query within a React component, call `useGetSchedulingTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchedulingTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchedulingTypesQuery({
 *   variables: {
 *      productionCountry: // value for 'productionCountry'
 *   },
 * });
 */
export function useGetSchedulingTypesQuery(baseOptions: Apollo.QueryHookOptions<GetSchedulingTypesQuery, GetSchedulingTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchedulingTypesQuery, GetSchedulingTypesQueryVariables>(GetSchedulingTypesDocument, options);
      }
export function useGetSchedulingTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchedulingTypesQuery, GetSchedulingTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchedulingTypesQuery, GetSchedulingTypesQueryVariables>(GetSchedulingTypesDocument, options);
        }
export type GetSchedulingTypesQueryHookResult = ReturnType<typeof useGetSchedulingTypesQuery>;
export type GetSchedulingTypesLazyQueryHookResult = ReturnType<typeof useGetSchedulingTypesLazyQuery>;
export type GetSchedulingTypesQueryResult = Apollo.QueryResult<GetSchedulingTypesQuery, GetSchedulingTypesQueryVariables>;
export function refetchGetSchedulingTypesQuery(variables: GetSchedulingTypesQueryVariables) {
      return { query: GetSchedulingTypesDocument, variables: variables }
    }
export const GetSchedulingProcessTypesDocument = gql`
    query getSchedulingProcessTypes {
  processTypes {
    id
    name
    platformProcessTypeId
  }
}
    `;

/**
 * __useGetSchedulingProcessTypesQuery__
 *
 * To run a query within a React component, call `useGetSchedulingProcessTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchedulingProcessTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchedulingProcessTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSchedulingProcessTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetSchedulingProcessTypesQuery, GetSchedulingProcessTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchedulingProcessTypesQuery, GetSchedulingProcessTypesQueryVariables>(GetSchedulingProcessTypesDocument, options);
      }
export function useGetSchedulingProcessTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchedulingProcessTypesQuery, GetSchedulingProcessTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchedulingProcessTypesQuery, GetSchedulingProcessTypesQueryVariables>(GetSchedulingProcessTypesDocument, options);
        }
export type GetSchedulingProcessTypesQueryHookResult = ReturnType<typeof useGetSchedulingProcessTypesQuery>;
export type GetSchedulingProcessTypesLazyQueryHookResult = ReturnType<typeof useGetSchedulingProcessTypesLazyQuery>;
export type GetSchedulingProcessTypesQueryResult = Apollo.QueryResult<GetSchedulingProcessTypesQuery, GetSchedulingProcessTypesQueryVariables>;
export function refetchGetSchedulingProcessTypesQuery(variables?: GetSchedulingProcessTypesQueryVariables) {
      return { query: GetSchedulingProcessTypesDocument, variables: variables }
    }
export const GetSchedulingProcessesDocument = gql`
    query getSchedulingProcesses {
  schedulingProcesses {
    id
    name
  }
}
    `;

/**
 * __useGetSchedulingProcessesQuery__
 *
 * To run a query within a React component, call `useGetSchedulingProcessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchedulingProcessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchedulingProcessesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSchedulingProcessesQuery(baseOptions?: Apollo.QueryHookOptions<GetSchedulingProcessesQuery, GetSchedulingProcessesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchedulingProcessesQuery, GetSchedulingProcessesQueryVariables>(GetSchedulingProcessesDocument, options);
      }
export function useGetSchedulingProcessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchedulingProcessesQuery, GetSchedulingProcessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchedulingProcessesQuery, GetSchedulingProcessesQueryVariables>(GetSchedulingProcessesDocument, options);
        }
export type GetSchedulingProcessesQueryHookResult = ReturnType<typeof useGetSchedulingProcessesQuery>;
export type GetSchedulingProcessesLazyQueryHookResult = ReturnType<typeof useGetSchedulingProcessesLazyQuery>;
export type GetSchedulingProcessesQueryResult = Apollo.QueryResult<GetSchedulingProcessesQuery, GetSchedulingProcessesQueryVariables>;
export function refetchGetSchedulingProcessesQuery(variables?: GetSchedulingProcessesQueryVariables) {
      return { query: GetSchedulingProcessesDocument, variables: variables }
    }
export const GetSalesDriUsersDocument = gql`
    query getSalesDriUsers($assignedTo: String) {
  getMfgDriUsers(assignedTo: $assignedTo) {
    id
    displayName
  }
}
    `;

/**
 * __useGetSalesDriUsersQuery__
 *
 * To run a query within a React component, call `useGetSalesDriUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesDriUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesDriUsersQuery({
 *   variables: {
 *      assignedTo: // value for 'assignedTo'
 *   },
 * });
 */
export function useGetSalesDriUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetSalesDriUsersQuery, GetSalesDriUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesDriUsersQuery, GetSalesDriUsersQueryVariables>(GetSalesDriUsersDocument, options);
      }
export function useGetSalesDriUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesDriUsersQuery, GetSalesDriUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesDriUsersQuery, GetSalesDriUsersQueryVariables>(GetSalesDriUsersDocument, options);
        }
export type GetSalesDriUsersQueryHookResult = ReturnType<typeof useGetSalesDriUsersQuery>;
export type GetSalesDriUsersLazyQueryHookResult = ReturnType<typeof useGetSalesDriUsersLazyQuery>;
export type GetSalesDriUsersQueryResult = Apollo.QueryResult<GetSalesDriUsersQuery, GetSalesDriUsersQueryVariables>;
export function refetchGetSalesDriUsersQuery(variables?: GetSalesDriUsersQueryVariables) {
      return { query: GetSalesDriUsersDocument, variables: variables }
    }
export const CreateJobRequestCommentMessagesUiQualityDocument = gql`
    mutation createJobRequestCommentMessagesUIQuality($jobRequestCommentInput: JobRequestCommentInput!) {
  createJobRequestComment(jobRequestCommentInput: $jobRequestCommentInput) {
    id
    __typename
  }
}
    `;
export type CreateJobRequestCommentMessagesUiQualityMutationFn = Apollo.MutationFunction<CreateJobRequestCommentMessagesUiQualityMutation, CreateJobRequestCommentMessagesUiQualityMutationVariables>;

/**
 * __useCreateJobRequestCommentMessagesUiQualityMutation__
 *
 * To run a mutation, you first call `useCreateJobRequestCommentMessagesUiQualityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobRequestCommentMessagesUiQualityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobRequestCommentMessagesUiQualityMutation, { data, loading, error }] = useCreateJobRequestCommentMessagesUiQualityMutation({
 *   variables: {
 *      jobRequestCommentInput: // value for 'jobRequestCommentInput'
 *   },
 * });
 */
export function useCreateJobRequestCommentMessagesUiQualityMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobRequestCommentMessagesUiQualityMutation, CreateJobRequestCommentMessagesUiQualityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobRequestCommentMessagesUiQualityMutation, CreateJobRequestCommentMessagesUiQualityMutationVariables>(CreateJobRequestCommentMessagesUiQualityDocument, options);
      }
export type CreateJobRequestCommentMessagesUiQualityMutationHookResult = ReturnType<typeof useCreateJobRequestCommentMessagesUiQualityMutation>;
export type CreateJobRequestCommentMessagesUiQualityMutationResult = Apollo.MutationResult<CreateJobRequestCommentMessagesUiQualityMutation>;
export type CreateJobRequestCommentMessagesUiQualityMutationOptions = Apollo.BaseMutationOptions<CreateJobRequestCommentMessagesUiQualityMutation, CreateJobRequestCommentMessagesUiQualityMutationVariables>;
export const PrintVisualFictiv5QualityDocument = gql`
    mutation printVisualFictiv5Quality($id: Int!) {
  generateJobRequestVisualFictiv5(jobRequestId: $id)
}
    `;
export type PrintVisualFictiv5QualityMutationFn = Apollo.MutationFunction<PrintVisualFictiv5QualityMutation, PrintVisualFictiv5QualityMutationVariables>;

/**
 * __usePrintVisualFictiv5QualityMutation__
 *
 * To run a mutation, you first call `usePrintVisualFictiv5QualityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintVisualFictiv5QualityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printVisualFictiv5QualityMutation, { data, loading, error }] = usePrintVisualFictiv5QualityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePrintVisualFictiv5QualityMutation(baseOptions?: Apollo.MutationHookOptions<PrintVisualFictiv5QualityMutation, PrintVisualFictiv5QualityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrintVisualFictiv5QualityMutation, PrintVisualFictiv5QualityMutationVariables>(PrintVisualFictiv5QualityDocument, options);
      }
export type PrintVisualFictiv5QualityMutationHookResult = ReturnType<typeof usePrintVisualFictiv5QualityMutation>;
export type PrintVisualFictiv5QualityMutationResult = Apollo.MutationResult<PrintVisualFictiv5QualityMutation>;
export type PrintVisualFictiv5QualityMutationOptions = Apollo.BaseMutationOptions<PrintVisualFictiv5QualityMutation, PrintVisualFictiv5QualityMutationVariables>;
export const AdminJobRequestQueryDocument = gql`
    query adminJobRequestQuery($id: Int!) {
  jobRequest(id: $id) {
    id
    jobId
    name
    rfqNumber
    salesOrderName
    payout
    vendorDueDate
    status
    productionStage
    createdAt
    mfgPartner {
      id
      name
    }
    project {
      id
      name
      isSecurePlus
    }
    inspectionStatus
    subjectTypes(category: QC_INVENTORY) {
      id
      value
    }
    jobRequestComments {
      id
      author {
        id
        firstName
        lastName
        email
      }
      subject
      body
      createdAt
      attachments {
        id
        fileName
        url
      }
    }
    parts {
      id
      linesWithWorkOrderMapping {
        id
        name
        partProduct {
          id
          colorName
          partFileName
          partProductRevision {
            id
            basicRevision {
              sceneBundle
              images {
                top
                angled
                side
                front
              }
              boundingBox {
                x
                y
                z
              }
            }
          }
        }
        moldTool {
          id
          name
          moldToolRevisionId
        }
        color {
          id
          name
        }
        drawingUri
        productQty
        inspectionType
        processType
        processName
        processTexture
        processThickness
        platformProcessId
        materialName
        processNotes
        processColor
        jobRequestLineAttachments {
          id
          visibleToCustomer
          attachment {
            id
            downloadUrl
            fileName
            extension
            mimeType
            uploadUrl
          }
          type
          createdAt
          workOrderItemName
          createdBy {
            id
            displayName
          }
          source
        }
      }
    }
    jobRequestAttachments {
      id
      attachment {
        id
        downloadUrl
        fileName
        extension
        mimeType
        uploadUrl
      }
      type
    }
  }
}
    `;

/**
 * __useAdminJobRequestQueryQuery__
 *
 * To run a query within a React component, call `useAdminJobRequestQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminJobRequestQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminJobRequestQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminJobRequestQueryQuery(baseOptions: Apollo.QueryHookOptions<AdminJobRequestQueryQuery, AdminJobRequestQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminJobRequestQueryQuery, AdminJobRequestQueryQueryVariables>(AdminJobRequestQueryDocument, options);
      }
export function useAdminJobRequestQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminJobRequestQueryQuery, AdminJobRequestQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminJobRequestQueryQuery, AdminJobRequestQueryQueryVariables>(AdminJobRequestQueryDocument, options);
        }
export type AdminJobRequestQueryQueryHookResult = ReturnType<typeof useAdminJobRequestQueryQuery>;
export type AdminJobRequestQueryLazyQueryHookResult = ReturnType<typeof useAdminJobRequestQueryLazyQuery>;
export type AdminJobRequestQueryQueryResult = Apollo.QueryResult<AdminJobRequestQueryQuery, AdminJobRequestQueryQueryVariables>;
export function refetchAdminJobRequestQueryQuery(variables: AdminJobRequestQueryQueryVariables) {
      return { query: AdminJobRequestQueryDocument, variables: variables }
    }
export const RemoveJobRequestAttachmentJobRequestDetailDocument = gql`
    mutation removeJobRequestAttachmentJobRequestDetail($ids: [UUID!]!) {
  removeJobRequestAttachments(ids: $ids)
}
    `;
export type RemoveJobRequestAttachmentJobRequestDetailMutationFn = Apollo.MutationFunction<RemoveJobRequestAttachmentJobRequestDetailMutation, RemoveJobRequestAttachmentJobRequestDetailMutationVariables>;

/**
 * __useRemoveJobRequestAttachmentJobRequestDetailMutation__
 *
 * To run a mutation, you first call `useRemoveJobRequestAttachmentJobRequestDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveJobRequestAttachmentJobRequestDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeJobRequestAttachmentJobRequestDetailMutation, { data, loading, error }] = useRemoveJobRequestAttachmentJobRequestDetailMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRemoveJobRequestAttachmentJobRequestDetailMutation(baseOptions?: Apollo.MutationHookOptions<RemoveJobRequestAttachmentJobRequestDetailMutation, RemoveJobRequestAttachmentJobRequestDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveJobRequestAttachmentJobRequestDetailMutation, RemoveJobRequestAttachmentJobRequestDetailMutationVariables>(RemoveJobRequestAttachmentJobRequestDetailDocument, options);
      }
export type RemoveJobRequestAttachmentJobRequestDetailMutationHookResult = ReturnType<typeof useRemoveJobRequestAttachmentJobRequestDetailMutation>;
export type RemoveJobRequestAttachmentJobRequestDetailMutationResult = Apollo.MutationResult<RemoveJobRequestAttachmentJobRequestDetailMutation>;
export type RemoveJobRequestAttachmentJobRequestDetailMutationOptions = Apollo.BaseMutationOptions<RemoveJobRequestAttachmentJobRequestDetailMutation, RemoveJobRequestAttachmentJobRequestDetailMutationVariables>;
export const UpdateVisibleToCustomerQualityDocument = gql`
    mutation updateVisibleToCustomerQuality($id: UUID!, $visibleToCustomer: Boolean!) {
  updateVisibleToCustomer(id: $id, visibleToCustomer: $visibleToCustomer)
}
    `;
export type UpdateVisibleToCustomerQualityMutationFn = Apollo.MutationFunction<UpdateVisibleToCustomerQualityMutation, UpdateVisibleToCustomerQualityMutationVariables>;

/**
 * __useUpdateVisibleToCustomerQualityMutation__
 *
 * To run a mutation, you first call `useUpdateVisibleToCustomerQualityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVisibleToCustomerQualityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVisibleToCustomerQualityMutation, { data, loading, error }] = useUpdateVisibleToCustomerQualityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      visibleToCustomer: // value for 'visibleToCustomer'
 *   },
 * });
 */
export function useUpdateVisibleToCustomerQualityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVisibleToCustomerQualityMutation, UpdateVisibleToCustomerQualityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVisibleToCustomerQualityMutation, UpdateVisibleToCustomerQualityMutationVariables>(UpdateVisibleToCustomerQualityDocument, options);
      }
export type UpdateVisibleToCustomerQualityMutationHookResult = ReturnType<typeof useUpdateVisibleToCustomerQualityMutation>;
export type UpdateVisibleToCustomerQualityMutationResult = Apollo.MutationResult<UpdateVisibleToCustomerQualityMutation>;
export type UpdateVisibleToCustomerQualityMutationOptions = Apollo.BaseMutationOptions<UpdateVisibleToCustomerQualityMutation, UpdateVisibleToCustomerQualityMutationVariables>;
export const CreateJobRequestAttachmentsQualityDocument = gql`
    mutation createJobRequestAttachmentsQuality($attachmentInput: JobRequestLineAttachmentInput!) {
  createJobRequestAttachments(input: $attachmentInput) {
    id
    attachment {
      id
      uploadUrl
      downloadUrl
      mimeType
      fileName
      extension
    }
    type
    createdAt
    workOrderItemName
    createdBy {
      id
      displayName
    }
    source
  }
}
    `;
export type CreateJobRequestAttachmentsQualityMutationFn = Apollo.MutationFunction<CreateJobRequestAttachmentsQualityMutation, CreateJobRequestAttachmentsQualityMutationVariables>;

/**
 * __useCreateJobRequestAttachmentsQualityMutation__
 *
 * To run a mutation, you first call `useCreateJobRequestAttachmentsQualityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobRequestAttachmentsQualityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobRequestAttachmentsQualityMutation, { data, loading, error }] = useCreateJobRequestAttachmentsQualityMutation({
 *   variables: {
 *      attachmentInput: // value for 'attachmentInput'
 *   },
 * });
 */
export function useCreateJobRequestAttachmentsQualityMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobRequestAttachmentsQualityMutation, CreateJobRequestAttachmentsQualityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobRequestAttachmentsQualityMutation, CreateJobRequestAttachmentsQualityMutationVariables>(CreateJobRequestAttachmentsQualityDocument, options);
      }
export type CreateJobRequestAttachmentsQualityMutationHookResult = ReturnType<typeof useCreateJobRequestAttachmentsQualityMutation>;
export type CreateJobRequestAttachmentsQualityMutationResult = Apollo.MutationResult<CreateJobRequestAttachmentsQualityMutation>;
export type CreateJobRequestAttachmentsQualityMutationOptions = Apollo.BaseMutationOptions<CreateJobRequestAttachmentsQualityMutation, CreateJobRequestAttachmentsQualityMutationVariables>;
export const GetAdminJobRequestsQualityDocument = gql`
    query getAdminJobRequestsQuality($limit: Int!, $offset: Int, $filters: AdminJobRequestFiltersInput, $sort: AllowedAdminJobRequestSort) {
  adminJobRequests(limit: $limit, offset: $offset, filters: $filters, sort: $sort) {
    totalCount
    items {
      id
      name
      rfqNumber
      inspectionStatus
      businessUnit
      project {
        id
        isSecurePlus
        name
      }
      vendorDueDate
      salesOrderName
      priority
      linesWithWorkOrderMapping {
        id
        productQty
        processName
        processType
        materialName
      }
      jobRequestAttachments {
        type
        source
        attachment {
          id
          mimeType
        }
      }
      mfgPartner {
        id
        displayName
      }
      mfgDri {
        id
        displayName
      }
      hasPostProcess
      productionStage
      payout
      secondaryProcessStartDate
      riskStatus
      process {
        id
        name
      }
      status
    }
  }
}
    `;

/**
 * __useGetAdminJobRequestsQualityQuery__
 *
 * To run a query within a React component, call `useGetAdminJobRequestsQualityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminJobRequestsQualityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminJobRequestsQualityQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetAdminJobRequestsQualityQuery(baseOptions: Apollo.QueryHookOptions<GetAdminJobRequestsQualityQuery, GetAdminJobRequestsQualityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminJobRequestsQualityQuery, GetAdminJobRequestsQualityQueryVariables>(GetAdminJobRequestsQualityDocument, options);
      }
export function useGetAdminJobRequestsQualityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminJobRequestsQualityQuery, GetAdminJobRequestsQualityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminJobRequestsQualityQuery, GetAdminJobRequestsQualityQueryVariables>(GetAdminJobRequestsQualityDocument, options);
        }
export type GetAdminJobRequestsQualityQueryHookResult = ReturnType<typeof useGetAdminJobRequestsQualityQuery>;
export type GetAdminJobRequestsQualityLazyQueryHookResult = ReturnType<typeof useGetAdminJobRequestsQualityLazyQuery>;
export type GetAdminJobRequestsQualityQueryResult = Apollo.QueryResult<GetAdminJobRequestsQualityQuery, GetAdminJobRequestsQualityQueryVariables>;
export function refetchGetAdminJobRequestsQualityQuery(variables: GetAdminJobRequestsQualityQueryVariables) {
      return { query: GetAdminJobRequestsQualityDocument, variables: variables }
    }
export const MpCountriesQualityDocument = gql`
    query mpCountriesQuality {
  mpCountries {
    id
    name
  }
}
    `;

/**
 * __useMpCountriesQualityQuery__
 *
 * To run a query within a React component, call `useMpCountriesQualityQuery` and pass it any options that fit your needs.
 * When your component renders, `useMpCountriesQualityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMpCountriesQualityQuery({
 *   variables: {
 *   },
 * });
 */
export function useMpCountriesQualityQuery(baseOptions?: Apollo.QueryHookOptions<MpCountriesQualityQuery, MpCountriesQualityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MpCountriesQualityQuery, MpCountriesQualityQueryVariables>(MpCountriesQualityDocument, options);
      }
export function useMpCountriesQualityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MpCountriesQualityQuery, MpCountriesQualityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MpCountriesQualityQuery, MpCountriesQualityQueryVariables>(MpCountriesQualityDocument, options);
        }
export type MpCountriesQualityQueryHookResult = ReturnType<typeof useMpCountriesQualityQuery>;
export type MpCountriesQualityLazyQueryHookResult = ReturnType<typeof useMpCountriesQualityLazyQuery>;
export type MpCountriesQualityQueryResult = Apollo.QueryResult<MpCountriesQualityQuery, MpCountriesQualityQueryVariables>;
export function refetchMpCountriesQualityQuery(variables?: MpCountriesQualityQueryVariables) {
      return { query: MpCountriesQualityDocument, variables: variables }
    }
export const CreateErpAttachmentQualityDocument = gql`
    mutation createErpAttachmentQuality($mimeType: String!, $fileName: String!, $sizeInKb: Int) {
  createErpAttachment(
    mimeType: $mimeType
    fileName: $fileName
    sizeInKb: $sizeInKb
  ) {
    id
    erpId
    url
    putUrl
    fileName
  }
}
    `;
export type CreateErpAttachmentQualityMutationFn = Apollo.MutationFunction<CreateErpAttachmentQualityMutation, CreateErpAttachmentQualityMutationVariables>;

/**
 * __useCreateErpAttachmentQualityMutation__
 *
 * To run a mutation, you first call `useCreateErpAttachmentQualityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateErpAttachmentQualityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createErpAttachmentQualityMutation, { data, loading, error }] = useCreateErpAttachmentQualityMutation({
 *   variables: {
 *      mimeType: // value for 'mimeType'
 *      fileName: // value for 'fileName'
 *      sizeInKb: // value for 'sizeInKb'
 *   },
 * });
 */
export function useCreateErpAttachmentQualityMutation(baseOptions?: Apollo.MutationHookOptions<CreateErpAttachmentQualityMutation, CreateErpAttachmentQualityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateErpAttachmentQualityMutation, CreateErpAttachmentQualityMutationVariables>(CreateErpAttachmentQualityDocument, options);
      }
export type CreateErpAttachmentQualityMutationHookResult = ReturnType<typeof useCreateErpAttachmentQualityMutation>;
export type CreateErpAttachmentQualityMutationResult = Apollo.MutationResult<CreateErpAttachmentQualityMutation>;
export type CreateErpAttachmentQualityMutationOptions = Apollo.BaseMutationOptions<CreateErpAttachmentQualityMutation, CreateErpAttachmentQualityMutationVariables>;
export const CreateJobRequestCommentDocument = gql`
    mutation createJobRequestComment($jobRequestCommentInput: JobRequestCommentInput!) {
  createJobRequestComment(jobRequestCommentInput: $jobRequestCommentInput) {
    id
    __typename
  }
}
    `;
export type CreateJobRequestCommentMutationFn = Apollo.MutationFunction<CreateJobRequestCommentMutation, CreateJobRequestCommentMutationVariables>;

/**
 * __useCreateJobRequestCommentMutation__
 *
 * To run a mutation, you first call `useCreateJobRequestCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobRequestCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobRequestCommentMutation, { data, loading, error }] = useCreateJobRequestCommentMutation({
 *   variables: {
 *      jobRequestCommentInput: // value for 'jobRequestCommentInput'
 *   },
 * });
 */
export function useCreateJobRequestCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobRequestCommentMutation, CreateJobRequestCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobRequestCommentMutation, CreateJobRequestCommentMutationVariables>(CreateJobRequestCommentDocument, options);
      }
export type CreateJobRequestCommentMutationHookResult = ReturnType<typeof useCreateJobRequestCommentMutation>;
export type CreateJobRequestCommentMutationResult = Apollo.MutationResult<CreateJobRequestCommentMutation>;
export type CreateJobRequestCommentMutationOptions = Apollo.BaseMutationOptions<CreateJobRequestCommentMutation, CreateJobRequestCommentMutationVariables>;
export const GetEligibleFollowersDocument = gql`
    query getEligibleFollowers {
  getEligibleFollowers {
    id
    firstName
    lastName
    odooUserId
  }
}
    `;

/**
 * __useGetEligibleFollowersQuery__
 *
 * To run a query within a React component, call `useGetEligibleFollowersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEligibleFollowersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEligibleFollowersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEligibleFollowersQuery(baseOptions?: Apollo.QueryHookOptions<GetEligibleFollowersQuery, GetEligibleFollowersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEligibleFollowersQuery, GetEligibleFollowersQueryVariables>(GetEligibleFollowersDocument, options);
      }
export function useGetEligibleFollowersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEligibleFollowersQuery, GetEligibleFollowersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEligibleFollowersQuery, GetEligibleFollowersQueryVariables>(GetEligibleFollowersDocument, options);
        }
export type GetEligibleFollowersQueryHookResult = ReturnType<typeof useGetEligibleFollowersQuery>;
export type GetEligibleFollowersLazyQueryHookResult = ReturnType<typeof useGetEligibleFollowersLazyQuery>;
export type GetEligibleFollowersQueryResult = Apollo.QueryResult<GetEligibleFollowersQuery, GetEligibleFollowersQueryVariables>;
export function refetchGetEligibleFollowersQuery(variables?: GetEligibleFollowersQueryVariables) {
      return { query: GetEligibleFollowersDocument, variables: variables }
    }
export const UpdateJobRequestFollowersDocument = gql`
    mutation UpdateJobRequestFollowers($jobRequestId: Int!, $input: UpdateJobRequestFollowersInput!) {
  updateJobRequestFollowers(jobRequestId: $jobRequestId, input: $input) {
    id
    name
  }
}
    `;
export type UpdateJobRequestFollowersMutationFn = Apollo.MutationFunction<UpdateJobRequestFollowersMutation, UpdateJobRequestFollowersMutationVariables>;

/**
 * __useUpdateJobRequestFollowersMutation__
 *
 * To run a mutation, you first call `useUpdateJobRequestFollowersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobRequestFollowersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobRequestFollowersMutation, { data, loading, error }] = useUpdateJobRequestFollowersMutation({
 *   variables: {
 *      jobRequestId: // value for 'jobRequestId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateJobRequestFollowersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobRequestFollowersMutation, UpdateJobRequestFollowersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobRequestFollowersMutation, UpdateJobRequestFollowersMutationVariables>(UpdateJobRequestFollowersDocument, options);
      }
export type UpdateJobRequestFollowersMutationHookResult = ReturnType<typeof useUpdateJobRequestFollowersMutation>;
export type UpdateJobRequestFollowersMutationResult = Apollo.MutationResult<UpdateJobRequestFollowersMutation>;
export type UpdateJobRequestFollowersMutationOptions = Apollo.BaseMutationOptions<UpdateJobRequestFollowersMutation, UpdateJobRequestFollowersMutationVariables>;
export const AdminJobRequestDocument = gql`
    query adminJobRequest($id: Int!) {
  jobRequest(id: $id) {
    id
    jobId
    name
    rfqNumber
    salesOrderName
    payout
    vendorDueDate
    status
    productionStage
    createdAt
    businessUnit
    mfgPartner {
      id
      name
    }
    project {
      id
      name
      isSecurePlus
    }
    subjectTypes(category: QC_INVENTORY) {
      id
      value
    }
    jobRequestComments {
      id
      author {
        id
        firstName
        lastName
        email
      }
      subject
      body
      createdAt
      attachments {
        id
        fileName
        url
      }
    }
    parts {
      id
      linesWithWorkOrderMapping {
        id
        name
        partProduct {
          id
          colorName
          partFileName
          partProductRevision {
            id
            basicRevision {
              sceneBundle
              images {
                top
                angled
                side
                front
              }
              boundingBox {
                x
                y
                z
              }
            }
          }
        }
        moldTool {
          id
          name
          moldToolRevisionId
        }
        color {
          id
          name
        }
        drawingUri
        productQty
        inspectionType
        processType
        processName
        processTexture
        processThickness
        platformProcessId
        materialName
        jobRequestLineAttachments {
          id
          visibleToCustomer
          attachment {
            id
            downloadUrl
            fileName
            extension
            mimeType
            uploadUrl
          }
          type
          createdAt
          workOrderItemName
          createdBy {
            id
            displayName
          }
          source
        }
      }
    }
    jobRequestAttachments {
      id
      attachment {
        id
        downloadUrl
        fileName
        extension
        mimeType
        uploadUrl
      }
      type
    }
  }
}
    `;

/**
 * __useAdminJobRequestQuery__
 *
 * To run a query within a React component, call `useAdminJobRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminJobRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminJobRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminJobRequestQuery(baseOptions: Apollo.QueryHookOptions<AdminJobRequestQuery, AdminJobRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminJobRequestQuery, AdminJobRequestQueryVariables>(AdminJobRequestDocument, options);
      }
export function useAdminJobRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminJobRequestQuery, AdminJobRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminJobRequestQuery, AdminJobRequestQueryVariables>(AdminJobRequestDocument, options);
        }
export type AdminJobRequestQueryHookResult = ReturnType<typeof useAdminJobRequestQuery>;
export type AdminJobRequestLazyQueryHookResult = ReturnType<typeof useAdminJobRequestLazyQuery>;
export type AdminJobRequestQueryResult = Apollo.QueryResult<AdminJobRequestQuery, AdminJobRequestQueryVariables>;
export function refetchAdminJobRequestQuery(variables: AdminJobRequestQueryVariables) {
      return { query: AdminJobRequestDocument, variables: variables }
    }
export const UpdateSaleOrderLineProductionCountryDocument = gql`
    mutation UpdateSaleOrderLineProductionCountry($salesOrderLineId: Int!, $productionCountry: ProductionCountry!) {
  updateSaleOrderLineProductionCountry(
    salesOrderLineId: $salesOrderLineId
    productionCountry: $productionCountry
  ) {
    erpSaleOrderId
    erpSaleOrderLineId
    productionCountry
  }
}
    `;
export type UpdateSaleOrderLineProductionCountryMutationFn = Apollo.MutationFunction<UpdateSaleOrderLineProductionCountryMutation, UpdateSaleOrderLineProductionCountryMutationVariables>;

/**
 * __useUpdateSaleOrderLineProductionCountryMutation__
 *
 * To run a mutation, you first call `useUpdateSaleOrderLineProductionCountryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSaleOrderLineProductionCountryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSaleOrderLineProductionCountryMutation, { data, loading, error }] = useUpdateSaleOrderLineProductionCountryMutation({
 *   variables: {
 *      salesOrderLineId: // value for 'salesOrderLineId'
 *      productionCountry: // value for 'productionCountry'
 *   },
 * });
 */
export function useUpdateSaleOrderLineProductionCountryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSaleOrderLineProductionCountryMutation, UpdateSaleOrderLineProductionCountryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSaleOrderLineProductionCountryMutation, UpdateSaleOrderLineProductionCountryMutationVariables>(UpdateSaleOrderLineProductionCountryDocument, options);
      }
export type UpdateSaleOrderLineProductionCountryMutationHookResult = ReturnType<typeof useUpdateSaleOrderLineProductionCountryMutation>;
export type UpdateSaleOrderLineProductionCountryMutationResult = Apollo.MutationResult<UpdateSaleOrderLineProductionCountryMutation>;
export type UpdateSaleOrderLineProductionCountryMutationOptions = Apollo.BaseMutationOptions<UpdateSaleOrderLineProductionCountryMutation, UpdateSaleOrderLineProductionCountryMutationVariables>;
export const UpdateSchedulingDriDocument = gql`
    mutation updateSchedulingDri($salesOrderLineId: Int!, $schedulingDriId: Int!) {
  updateSchedulingDri(
    salesOrderLineId: $salesOrderLineId
    schedulingDriId: $schedulingDriId
  ) {
    erpSaleOrderId
    schedulingDri {
      id
      displayName
    }
  }
}
    `;
export type UpdateSchedulingDriMutationFn = Apollo.MutationFunction<UpdateSchedulingDriMutation, UpdateSchedulingDriMutationVariables>;

/**
 * __useUpdateSchedulingDriMutation__
 *
 * To run a mutation, you first call `useUpdateSchedulingDriMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchedulingDriMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSchedulingDriMutation, { data, loading, error }] = useUpdateSchedulingDriMutation({
 *   variables: {
 *      salesOrderLineId: // value for 'salesOrderLineId'
 *      schedulingDriId: // value for 'schedulingDriId'
 *   },
 * });
 */
export function useUpdateSchedulingDriMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSchedulingDriMutation, UpdateSchedulingDriMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSchedulingDriMutation, UpdateSchedulingDriMutationVariables>(UpdateSchedulingDriDocument, options);
      }
export type UpdateSchedulingDriMutationHookResult = ReturnType<typeof useUpdateSchedulingDriMutation>;
export type UpdateSchedulingDriMutationResult = Apollo.MutationResult<UpdateSchedulingDriMutation>;
export type UpdateSchedulingDriMutationOptions = Apollo.BaseMutationOptions<UpdateSchedulingDriMutation, UpdateSchedulingDriMutationVariables>;
export const GetJobsForSaleOrderDocument = gql`
    query getJobsForSaleOrder($filters: JobFiltersInput) {
  jobs(filters: $filters) {
    items {
      id
      name
      exceptionCount
      pauseException
      nextMilestone
      erpSaleOrderId
      milestones {
        scheduling {
          committedDate
          scheduledDate
          actualDate
        }
        production {
          committedDate
          scheduledDate
          actualDate
        }
        inspection {
          committedDate
          scheduledDate
          actualDate
        }
        deliveryOrder {
          committedDate
          scheduledDate
          actualDate
        }
        shipping {
          committedDate
          scheduledDate
          actualDate
        }
        customerDelivery {
          committedDate
          scheduledDate
          actualDate
        }
      }
    }
  }
}
    `;

/**
 * __useGetJobsForSaleOrderQuery__
 *
 * To run a query within a React component, call `useGetJobsForSaleOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsForSaleOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsForSaleOrderQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetJobsForSaleOrderQuery(baseOptions?: Apollo.QueryHookOptions<GetJobsForSaleOrderQuery, GetJobsForSaleOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobsForSaleOrderQuery, GetJobsForSaleOrderQueryVariables>(GetJobsForSaleOrderDocument, options);
      }
export function useGetJobsForSaleOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobsForSaleOrderQuery, GetJobsForSaleOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobsForSaleOrderQuery, GetJobsForSaleOrderQueryVariables>(GetJobsForSaleOrderDocument, options);
        }
export type GetJobsForSaleOrderQueryHookResult = ReturnType<typeof useGetJobsForSaleOrderQuery>;
export type GetJobsForSaleOrderLazyQueryHookResult = ReturnType<typeof useGetJobsForSaleOrderLazyQuery>;
export type GetJobsForSaleOrderQueryResult = Apollo.QueryResult<GetJobsForSaleOrderQuery, GetJobsForSaleOrderQueryVariables>;
export function refetchGetJobsForSaleOrderQuery(variables?: GetJobsForSaleOrderQueryVariables) {
      return { query: GetJobsForSaleOrderDocument, variables: variables }
    }
export const SalesOrderByNameDocument = gql`
    query salesOrderByName($name: String!, $includeService: Boolean = false) {
  salesOrder(name: $name, includeService: $includeService) {
    id
    name
    exceptionCount
    priority
    schedulingDris {
      id
      displayName
    }
    mfgDri {
      id
      displayName
    }
    project {
      id
      name
      isSecurePlus
    }
    shipments {
      items {
        shippedBy
        shippingMethod
      }
    }
    paymentDetails {
      billingAddress {
        name
        street
        street2
        city
        state
        country
      }
      paymentType
      purchaseOrderNumber
    }
    customerName
    fictivShipmentMethod
    customerCompanyName
    orderDate
    revision
    reorderSourceSaleOrderName
    fictivOrderModifiedPostSale
    quoteId
    margin
    actualTransactionMargin
    projectTags
    contract {
      id
      name
      expiryDate
      salesforceContractOpportunityId
      salesforceContractLink
    }
    totalDiscount
    totalAmount
    totalCost
    totalTax
    totalPrice
    originalTotalAmount
    adminSalesOrderLines {
      id
      productionCountry
      schedulingDri {
        id
        displayName
      }
      quoteModelRevisionUUID
      moldToolRevisionId
      productionRegion
      thumbnailUri
      partName
      partType
      orderedQuantity
      deliveredQuantity
      invoicedQuantity
      unitPrice
      subTotalAmount
      unitCost
      markup
      totalCost
      totalPrice
      tax
      scheduledShipDate
      scheduledDeliveryDate
      originalUnitPrice
      originalPrice
      unitDiscountAmount
      discountAmount
      mpAdjustedPayout
      mpAssignedQuantity
      adminMaterial {
        color
        name
      }
      processNames
      boundingBox {
        length
        thickness
        width
      }
      moldTool {
        id
        name
        moldToolRevisionId
        version
      }
      associatedMoldTool {
        id
        name
        moldToolRevisionId
        version
      }
      processes {
        id
        color
        texture
        thickness
        processName
        processNotes
        additionalSpecifications {
          color
          texture
          thickness
        }
        dfmNotes {
          color
          process
          texture
          thickness
        }
      }
      adminMaterial {
        name
        shore
        color
        dfmNotes {
          color
          material
          shoreValue
        }
        additionalSpecifications {
          color
          material
          shoreValue
        }
      }
    }
    processLines {
      jobId
      rfqNumber
      actualScheduledDate
      actualVendorDueDate
      executionSequence
      jobName
      jobStatus
      leadTime
      manufacturingPartnerName
      orderedQuantity
      remainingUnbundledQuantity
      part {
        id
        name
        quoteModelRevisionUuid
        thumbnailUri
        revisionUuid
        depthX
        depthY
        depthZ
      }
      orderLineProcesses {
        id
        processName
        processNotes
        color
        thickness
        texture
        dfmNotes {
          color
          thickness
          texture
          process
        }
        additionalSpecifications {
          color
          thickness
          texture
        }
      }
      materialConfiguration {
        color
        colorCode
        grade
        id
        name
        shoreValue
        dfmNotes {
          color
          shoreValue
          material
        }
        additionalSpecifications {
          color
          shoreValue
          material
        }
      }
      plannedScheduledDate
      plannedVendorDueDate
      processAttributes
      processName
      productQuantity
      salesOrderLineId
      scheduledDeliveryDate
      scheduledShipDate
      schedulingQueueProcessedItemsCount
      schedulingQueueStatus
      schedulingQueueTotalItemsCount
      moldTool {
        id
        name
        moldToolRevisionId
        version
      }
      associatedMoldTool {
        id
        name
        moldToolRevisionId
        version
      }
    }
    quoteNotes
    quoteDfmNotes
    orderType
    businessUnit
  }
}
    `;

/**
 * __useSalesOrderByNameQuery__
 *
 * To run a query within a React component, call `useSalesOrderByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesOrderByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesOrderByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *      includeService: // value for 'includeService'
 *   },
 * });
 */
export function useSalesOrderByNameQuery(baseOptions: Apollo.QueryHookOptions<SalesOrderByNameQuery, SalesOrderByNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesOrderByNameQuery, SalesOrderByNameQueryVariables>(SalesOrderByNameDocument, options);
      }
export function useSalesOrderByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesOrderByNameQuery, SalesOrderByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesOrderByNameQuery, SalesOrderByNameQueryVariables>(SalesOrderByNameDocument, options);
        }
export type SalesOrderByNameQueryHookResult = ReturnType<typeof useSalesOrderByNameQuery>;
export type SalesOrderByNameLazyQueryHookResult = ReturnType<typeof useSalesOrderByNameLazyQuery>;
export type SalesOrderByNameQueryResult = Apollo.QueryResult<SalesOrderByNameQuery, SalesOrderByNameQueryVariables>;
export function refetchSalesOrderByNameQuery(variables: SalesOrderByNameQueryVariables) {
      return { query: SalesOrderByNameDocument, variables: variables }
    }
export const OrdersListDocument = gql`
    query ordersList($limit: Int!, $offset: Int, $isCpqFlagV2Enabled: Boolean = false) {
  me {
    id
    salesOrders(limit: $limit, offset: $offset) {
      totalCount
      items {
        ... on SalesOrder {
          id
          isReorderAllowed
          isBusinessAccountDiscountApplied
          appliedBusinessAccountDiscountPercent
          name
          deliveryStatus
          shippedBy
          createdAt
          totalAmount
          downloadAllFilesUri
          fictivShipmentMethod
          fictivOrderUpdatedToDdp
          team {
            id
            name
          }
          salesOrderLines(limit: 4) {
            totalCount
            productCount
            items {
              id
              revision {
                id
                thumbnailUri
              }
              processes {
                id
                platformProcessId
                color
                texture
                thickness
                processNotes
                additionalSpecifications {
                  color
                  texture
                  thickness
                }
                dfmNotes {
                  color
                  process
                  texture
                  thickness
                }
              }
              htsCodeSubmitted
            }
            parts {
              id
              revision {
                id
                thumbnailUri
              }
              processes {
                id
                platformProcessId
                color
                texture
                thickness
                processNotes
                additionalSpecifications {
                  color
                  texture
                  thickness
                }
                dfmNotes {
                  color
                  process
                  texture
                  thickness
                }
              }
              htsCodeSubmitted
            }
          }
          paymentDetails {
            paymentType
            purchaseOrderNumber
            paidBy {
              id
            }
          }
          project {
            id
            isSecurePlus
            name
          }
          sourceQuoteType
          quote {
            name
          }
          quotePdfUrl @include(if: $isCpqFlagV2Enabled)
          quoteOwnerUser {
            id
          }
        }
        ... on BasicSalesOrder {
          id
          name
          deliveryStatus
          shippedBy
          createdAt
          totalAmount
          project {
            id
            isSecurePlus
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useOrdersListQuery__
 *
 * To run a query within a React component, call `useOrdersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      isCpqFlagV2Enabled: // value for 'isCpqFlagV2Enabled'
 *   },
 * });
 */
export function useOrdersListQuery(baseOptions: Apollo.QueryHookOptions<OrdersListQuery, OrdersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrdersListQuery, OrdersListQueryVariables>(OrdersListDocument, options);
      }
export function useOrdersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdersListQuery, OrdersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrdersListQuery, OrdersListQueryVariables>(OrdersListDocument, options);
        }
export type OrdersListQueryHookResult = ReturnType<typeof useOrdersListQuery>;
export type OrdersListLazyQueryHookResult = ReturnType<typeof useOrdersListLazyQuery>;
export type OrdersListQueryResult = Apollo.QueryResult<OrdersListQuery, OrdersListQueryVariables>;
export function refetchOrdersListQuery(variables: OrdersListQueryVariables) {
      return { query: OrdersListDocument, variables: variables }
    }
export const OrderSearchDocument = gql`
    query orderSearch($orderSearchSearchString: String!, $from: Int!, $size: Int!, $isCpqFlagV2Enabled: Boolean = false) {
  orderSearch(searchString: $orderSearchSearchString, from: $from, size: $size) {
    totalCount
    page {
      total
      totalPages
      pageNumber
      from
      size
    }
    items {
      ... on SalesOrder {
        id
        isReorderAllowed
        name
        deliveryStatus
        shippedBy
        createdAt
        totalAmount
        downloadAllFilesUri
        fictivShipmentMethod
        fictivOrderUpdatedToDdp
        team {
          id
          name
        }
        quotePdfUrl @include(if: $isCpqFlagV2Enabled)
        salesOrderLines {
          items {
            id
            revision {
              thumbnailUri
              __typename
            }
            processes {
              id
              platformProcessId
              color
              texture
              thickness
              processNotes
              additionalSpecifications {
                color
                texture
                thickness
              }
              dfmNotes {
                color
                process
                texture
                thickness
              }
              __typename
            }
            __typename
          }
          parts {
            id
            revision {
              id
              thumbnailUri
              __typename
            }
            processes {
              id
              platformProcessId
              color
              texture
              thickness
              processNotes
              additionalSpecifications {
                color
                texture
                thickness
              }
              dfmNotes {
                color
                process
                texture
                thickness
              }
              __typename
            }
            htsCodeSubmitted
            __typename
          }
        }
        paymentDetails {
          paymentType
          purchaseOrderNumber
          paidBy {
            id
          }
        }
        quoteOwnerUser {
          id
        }
      }
      __typename
    }
  }
}
    `;

/**
 * __useOrderSearchQuery__
 *
 * To run a query within a React component, call `useOrderSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderSearchQuery({
 *   variables: {
 *      orderSearchSearchString: // value for 'orderSearchSearchString'
 *      from: // value for 'from'
 *      size: // value for 'size'
 *      isCpqFlagV2Enabled: // value for 'isCpqFlagV2Enabled'
 *   },
 * });
 */
export function useOrderSearchQuery(baseOptions: Apollo.QueryHookOptions<OrderSearchQuery, OrderSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderSearchQuery, OrderSearchQueryVariables>(OrderSearchDocument, options);
      }
export function useOrderSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderSearchQuery, OrderSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderSearchQuery, OrderSearchQueryVariables>(OrderSearchDocument, options);
        }
export type OrderSearchQueryHookResult = ReturnType<typeof useOrderSearchQuery>;
export type OrderSearchLazyQueryHookResult = ReturnType<typeof useOrderSearchLazyQuery>;
export type OrderSearchQueryResult = Apollo.QueryResult<OrderSearchQuery, OrderSearchQueryVariables>;
export function refetchOrderSearchQuery(variables: OrderSearchQueryVariables) {
      return { query: OrderSearchDocument, variables: variables }
    }
export const AdminUserOrderSearchDocument = gql`
    query AdminUserOrderSearch($searchString: String!, $from: Int!, $size: Int!, $userId: Int, $isCpqFlagV2Enabled: Boolean = false) {
  adminUserOrderSearch(
    searchString: $searchString
    from: $from
    size: $size
    userId: $userId
  ) {
    totalCount
    page {
      total
      totalPages
      pageNumber
      from
      size
    }
    items {
      ... on SalesOrder {
        id
        isReorderAllowed
        name
        deliveryStatus
        fictivEstimatedDeliveryDate
        shippedBy
        createdAt
        totalAmount
        downloadAllFilesUri
        fictivShipmentMethod
        fictivOrderUpdatedToDdp
        quotePdfUrl @include(if: $isCpqFlagV2Enabled)
        salesOrderLines {
          items {
            id
            revision {
              thumbnailUri
              __typename
            }
            __typename
          }
          parts {
            id
            revision {
              id
              thumbnailUri
              __typename
            }
            processes {
              id
              platformProcessId
              color
              texture
              thickness
              processNotes
              additionalSpecifications {
                color
                texture
                thickness
              }
              dfmNotes {
                color
                process
                texture
                thickness
              }
              __typename
            }
            htsCodeSubmitted
            __typename
          }
        }
        paymentDetails {
          paymentType
          purchaseOrderNumber
        }
      }
      __typename
    }
  }
}
    `;

/**
 * __useAdminUserOrderSearchQuery__
 *
 * To run a query within a React component, call `useAdminUserOrderSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserOrderSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserOrderSearchQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      from: // value for 'from'
 *      size: // value for 'size'
 *      userId: // value for 'userId'
 *      isCpqFlagV2Enabled: // value for 'isCpqFlagV2Enabled'
 *   },
 * });
 */
export function useAdminUserOrderSearchQuery(baseOptions: Apollo.QueryHookOptions<AdminUserOrderSearchQuery, AdminUserOrderSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminUserOrderSearchQuery, AdminUserOrderSearchQueryVariables>(AdminUserOrderSearchDocument, options);
      }
export function useAdminUserOrderSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminUserOrderSearchQuery, AdminUserOrderSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminUserOrderSearchQuery, AdminUserOrderSearchQueryVariables>(AdminUserOrderSearchDocument, options);
        }
export type AdminUserOrderSearchQueryHookResult = ReturnType<typeof useAdminUserOrderSearchQuery>;
export type AdminUserOrderSearchLazyQueryHookResult = ReturnType<typeof useAdminUserOrderSearchLazyQuery>;
export type AdminUserOrderSearchQueryResult = Apollo.QueryResult<AdminUserOrderSearchQuery, AdminUserOrderSearchQueryVariables>;
export function refetchAdminUserOrderSearchQuery(variables: AdminUserOrderSearchQueryVariables) {
      return { query: AdminUserOrderSearchDocument, variables: variables }
    }
export const UpdateHtsDocument = gql`
    mutation updateHts($orderId: String!, $htsInput: [HtsUpdateInput!]!, $isDdpQualified: Boolean!, $userId: Int) {
  updateHts(
    orderId: $orderId
    orderLinesInput: $htsInput
    isDdpQualified: $isDdpQualified
    userId: $userId
  )
}
    `;
export type UpdateHtsMutationFn = Apollo.MutationFunction<UpdateHtsMutation, UpdateHtsMutationVariables>;

/**
 * __useUpdateHtsMutation__
 *
 * To run a mutation, you first call `useUpdateHtsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHtsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHtsMutation, { data, loading, error }] = useUpdateHtsMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      htsInput: // value for 'htsInput'
 *      isDdpQualified: // value for 'isDdpQualified'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateHtsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHtsMutation, UpdateHtsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHtsMutation, UpdateHtsMutationVariables>(UpdateHtsDocument, options);
      }
export type UpdateHtsMutationHookResult = ReturnType<typeof useUpdateHtsMutation>;
export type UpdateHtsMutationResult = Apollo.MutationResult<UpdateHtsMutation>;
export type UpdateHtsMutationOptions = Apollo.BaseMutationOptions<UpdateHtsMutation, UpdateHtsMutationVariables>;
export const QmrsGroupedByDfmCategoryOdpDocument = gql`
    query qmrsGroupedByDfmCategoryOdp($orderId: String) {
  qmrsGroupedByDfmCategory(orderId: $orderId) {
    category
    qmrs {
      id
      fileName
      version
      attachmentLink {
        id
        quoteAttachmentRevision {
          id
          attachment {
            id
            fileName
          }
        }
      }
      partRevision {
        id
        thumbnailUri
      }
      dfmFeedback {
        id
        isPublished
      }
    }
  }
}
    `;

/**
 * __useQmrsGroupedByDfmCategoryOdpQuery__
 *
 * To run a query within a React component, call `useQmrsGroupedByDfmCategoryOdpQuery` and pass it any options that fit your needs.
 * When your component renders, `useQmrsGroupedByDfmCategoryOdpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQmrsGroupedByDfmCategoryOdpQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useQmrsGroupedByDfmCategoryOdpQuery(baseOptions?: Apollo.QueryHookOptions<QmrsGroupedByDfmCategoryOdpQuery, QmrsGroupedByDfmCategoryOdpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QmrsGroupedByDfmCategoryOdpQuery, QmrsGroupedByDfmCategoryOdpQueryVariables>(QmrsGroupedByDfmCategoryOdpDocument, options);
      }
export function useQmrsGroupedByDfmCategoryOdpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QmrsGroupedByDfmCategoryOdpQuery, QmrsGroupedByDfmCategoryOdpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QmrsGroupedByDfmCategoryOdpQuery, QmrsGroupedByDfmCategoryOdpQueryVariables>(QmrsGroupedByDfmCategoryOdpDocument, options);
        }
export type QmrsGroupedByDfmCategoryOdpQueryHookResult = ReturnType<typeof useQmrsGroupedByDfmCategoryOdpQuery>;
export type QmrsGroupedByDfmCategoryOdpLazyQueryHookResult = ReturnType<typeof useQmrsGroupedByDfmCategoryOdpLazyQuery>;
export type QmrsGroupedByDfmCategoryOdpQueryResult = Apollo.QueryResult<QmrsGroupedByDfmCategoryOdpQuery, QmrsGroupedByDfmCategoryOdpQueryVariables>;
export function refetchQmrsGroupedByDfmCategoryOdpQuery(variables?: QmrsGroupedByDfmCategoryOdpQueryVariables) {
      return { query: QmrsGroupedByDfmCategoryOdpDocument, variables: variables }
    }
export const DuplicateQuoteFromOrderDocument = gql`
    mutation duplicateQuoteFromOrder($orderName: String!) {
  duplicateQuoteFromOrder(orderName: $orderName) {
    id
    name
    sourceQuoteId
  }
}
    `;
export type DuplicateQuoteFromOrderMutationFn = Apollo.MutationFunction<DuplicateQuoteFromOrderMutation, DuplicateQuoteFromOrderMutationVariables>;

/**
 * __useDuplicateQuoteFromOrderMutation__
 *
 * To run a mutation, you first call `useDuplicateQuoteFromOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateQuoteFromOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateQuoteFromOrderMutation, { data, loading, error }] = useDuplicateQuoteFromOrderMutation({
 *   variables: {
 *      orderName: // value for 'orderName'
 *   },
 * });
 */
export function useDuplicateQuoteFromOrderMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateQuoteFromOrderMutation, DuplicateQuoteFromOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateQuoteFromOrderMutation, DuplicateQuoteFromOrderMutationVariables>(DuplicateQuoteFromOrderDocument, options);
      }
export type DuplicateQuoteFromOrderMutationHookResult = ReturnType<typeof useDuplicateQuoteFromOrderMutation>;
export type DuplicateQuoteFromOrderMutationResult = Apollo.MutationResult<DuplicateQuoteFromOrderMutation>;
export type DuplicateQuoteFromOrderMutationOptions = Apollo.BaseMutationOptions<DuplicateQuoteFromOrderMutation, DuplicateQuoteFromOrderMutationVariables>;
export const CreateInspectionZipDownloadOrderDetailsDocument = gql`
    mutation createInspectionZipDownloadOrderDetails($id: String!) {
  createZipDownloadOrderDetails: createSaleOrderInspectionDownload(id: $id) {
    url
  }
}
    `;
export type CreateInspectionZipDownloadOrderDetailsMutationFn = Apollo.MutationFunction<CreateInspectionZipDownloadOrderDetailsMutation, CreateInspectionZipDownloadOrderDetailsMutationVariables>;

/**
 * __useCreateInspectionZipDownloadOrderDetailsMutation__
 *
 * To run a mutation, you first call `useCreateInspectionZipDownloadOrderDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInspectionZipDownloadOrderDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInspectionZipDownloadOrderDetailsMutation, { data, loading, error }] = useCreateInspectionZipDownloadOrderDetailsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateInspectionZipDownloadOrderDetailsMutation(baseOptions?: Apollo.MutationHookOptions<CreateInspectionZipDownloadOrderDetailsMutation, CreateInspectionZipDownloadOrderDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInspectionZipDownloadOrderDetailsMutation, CreateInspectionZipDownloadOrderDetailsMutationVariables>(CreateInspectionZipDownloadOrderDetailsDocument, options);
      }
export type CreateInspectionZipDownloadOrderDetailsMutationHookResult = ReturnType<typeof useCreateInspectionZipDownloadOrderDetailsMutation>;
export type CreateInspectionZipDownloadOrderDetailsMutationResult = Apollo.MutationResult<CreateInspectionZipDownloadOrderDetailsMutation>;
export type CreateInspectionZipDownloadOrderDetailsMutationOptions = Apollo.BaseMutationOptions<CreateInspectionZipDownloadOrderDetailsMutation, CreateInspectionZipDownloadOrderDetailsMutationVariables>;
export const CreateZipDownloadOrderDetailsDocument = gql`
    mutation createZipDownloadOrderDetails($orderName: String!) {
  createZipDownloadOrderDetails(orderName: $orderName) {
    id
    jobStartDate
    jobCompleteDate
    name
    error
    url
  }
}
    `;
export type CreateZipDownloadOrderDetailsMutationFn = Apollo.MutationFunction<CreateZipDownloadOrderDetailsMutation, CreateZipDownloadOrderDetailsMutationVariables>;

/**
 * __useCreateZipDownloadOrderDetailsMutation__
 *
 * To run a mutation, you first call `useCreateZipDownloadOrderDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateZipDownloadOrderDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createZipDownloadOrderDetailsMutation, { data, loading, error }] = useCreateZipDownloadOrderDetailsMutation({
 *   variables: {
 *      orderName: // value for 'orderName'
 *   },
 * });
 */
export function useCreateZipDownloadOrderDetailsMutation(baseOptions?: Apollo.MutationHookOptions<CreateZipDownloadOrderDetailsMutation, CreateZipDownloadOrderDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateZipDownloadOrderDetailsMutation, CreateZipDownloadOrderDetailsMutationVariables>(CreateZipDownloadOrderDetailsDocument, options);
      }
export type CreateZipDownloadOrderDetailsMutationHookResult = ReturnType<typeof useCreateZipDownloadOrderDetailsMutation>;
export type CreateZipDownloadOrderDetailsMutationResult = Apollo.MutationResult<CreateZipDownloadOrderDetailsMutation>;
export type CreateZipDownloadOrderDetailsMutationOptions = Apollo.BaseMutationOptions<CreateZipDownloadOrderDetailsMutation, CreateZipDownloadOrderDetailsMutationVariables>;
export const SalesOrderDocument = gql`
    query salesOrder($name: String!, $isCpqFlagV2Enabled: Boolean = false) {
  salesOrder(name: $name) {
    id
    isReorderAllowed
    isImReorder
    name
    deliveryStatus
    shippedBy
    createdAt
    totalAmount
    customerName
    fictivShipmentMethod
    fictivEstimatedDeliveryDate
    drawingAttachmentsCount
    sourceQuoteType
    depositAmount
    isBusinessAccountDiscountApplied
    appliedBusinessAccountDiscountPercent
    fictivOrderUpdatedToDdp
    fictivOrderModifiedPostSale
    team {
      id
      name
    }
    paymentDetails {
      id
      paidBy {
        id
        displayName
      }
      paidByDisplayName
      billingAddress {
        id
        name
        street
        street2
        city
        state
        postalCode
        phone
        country
      }
      paymentType
      purchaseOrderNumber
      creditCardLast4
    }
    shipments {
      totalCount
      items {
        id
        deliveryStatus
        carrier
        shippedBy
        shippingMethod
        trackingCode
        shipToAddress {
          name
          street
          street2
          city
          stateCode
          stateName
          zip
          countryCode
          countryName
          companyName
          phone
        }
        committedDeliveryDate
        trackingData {
          status
          estDeliveryDate
          signedBy
          trackingDetails {
            message
            status
            datetime
            trackingLocation {
              city
              state
              countryCode
              postalCode
            }
          }
        }
        shipmentLines {
          totalCount
          items {
            revision {
              id
            }
            woAvailableToShow
            inspectionDocuments {
              fileName
            }
          }
        }
      }
    }
    salesOrderLines(limit: 100) {
      totalCount
      items {
        id
        htsCode
        htsCodeSubmitted
        htsDescription
        htsApplication
        htsUsageType
        deliveryStatus
        quantity
        unitPrice
        processName
        productionRegion
        processes {
          id
          color
          texture
          thickness
          processNotes
          additionalSpecifications {
            color
            texture
            thickness
          }
          dfmNotes {
            color
            process
            texture
            thickness
          }
        }
        revision {
          id
          modelFileName
          thumbnailUri
        }
        quoteModelRevisionAttachment {
          id
          fileName
        }
        quoteModelRevision {
          id
          dfmReports {
            isPublished
          }
          quoteModel {
            id
            quote {
              id
              name
            }
          }
          modelConfiguration {
            fdmInfillPercentageCategoryLabel
            color {
              name
            }
            process {
              id
            }
          }
        }
      }
      parts {
        id
        htsCode
        htsCodeSubmitted
        htsDescription
        htsApplication
        htsUsageType
        deliveryStatus
        quantity
        unitPrice
        processName
        productionRegion
        processes {
          id
          color
          texture
          thickness
          processNotes
          additionalSpecifications {
            color
            texture
            thickness
          }
          dfmNotes {
            color
            process
            texture
            thickness
          }
        }
        revision {
          id
          modelFileName
          thumbnailUri
        }
        quoteModelRevisionAttachment {
          id
          fileName
        }
        quoteModelRevision {
          id
          dfmReports {
            isPublished
          }
          quoteModel {
            id
            quote {
              id
              name
            }
          }
          modelConfiguration {
            fdmInfillPercentageCategoryLabel
            color {
              name
            }
            process {
              id
            }
          }
        }
      }
    }
    project {
      id
      isSecurePlus
      name
    }
    quoteId
    quote {
      name
    }
    quoteOwnerUser {
      id
    }
    quotePdfUrl @include(if: $isCpqFlagV2Enabled)
  }
}
    `;

/**
 * __useSalesOrderQuery__
 *
 * To run a query within a React component, call `useSalesOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesOrderQuery({
 *   variables: {
 *      name: // value for 'name'
 *      isCpqFlagV2Enabled: // value for 'isCpqFlagV2Enabled'
 *   },
 * });
 */
export function useSalesOrderQuery(baseOptions: Apollo.QueryHookOptions<SalesOrderQuery, SalesOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesOrderQuery, SalesOrderQueryVariables>(SalesOrderDocument, options);
      }
export function useSalesOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesOrderQuery, SalesOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesOrderQuery, SalesOrderQueryVariables>(SalesOrderDocument, options);
        }
export type SalesOrderQueryHookResult = ReturnType<typeof useSalesOrderQuery>;
export type SalesOrderLazyQueryHookResult = ReturnType<typeof useSalesOrderLazyQuery>;
export type SalesOrderQueryResult = Apollo.QueryResult<SalesOrderQuery, SalesOrderQueryVariables>;
export function refetchSalesOrderQuery(variables: SalesOrderQueryVariables) {
      return { query: SalesOrderDocument, variables: variables }
    }
export const SalesOrderLinesDocument = gql`
    query salesOrderLines($orderId: String!, $statusNotIn: [String!], $limit: Int!, $offset: Int!, $cursor: ENCODED_CURSOR, $isImMaafcoEnabled: Boolean = false) {
  salesOrderLines(
    orderId: $orderId
    statusNotIn: $statusNotIn
    limit: $limit
    offset: $offset
    cursor: $cursor
  ) {
    cursor {
      previous
      next
    }
    totalCount
    productCount
    items {
      id
      producedBy
      deliveryStatus
      moldStatus
      erpMoldId
      quantity
      orderedQuantity
      deliveredQuantity
      erpProductToolId
      associatedParts @include(if: $isImMaafcoEnabled)
      material {
        id
        name
        color
        shore
        materialGrade
        colorCode
        publicName
      }
      unitPrice
      productionRegion
      revision {
        ...revision
      }
      dfmFeedback {
        ...dfmFeedbackOrderDetailsPage
      }
      holes {
        ...holes
      }
      processName
      processNames
      processes {
        id
        platformProcessId
        processName
        processNotes
        color
        thickness
        texture
        finish
        toolLife
        surfaceFinishCode
        additionalSpecifications {
          color
          texture
          thickness
        }
        dfmNotes {
          color
          process
          texture
          thickness
        }
      }
      inspectionStatus
      productionStatus
      quoteModelRevisionAttachment {
        id
        fileName
        downloadUrl
        sanitized {
          id
          fileName
          downloadUrl
        }
        annotated {
          id
          fileName
          downloadUrl
        }
      }
      shipmentAndInspection {
        shipmentId
        inspectionDocuments {
          ...inspectionDocuments
        }
        woAvailableToShow
        inspectionTypes
      }
      quoteModelRevision {
        id
        quoteModel {
          quote {
            id
            type
            name
            isCpqOwned
            user {
              id
              firstName
              lastName
              email
            }
          }
        }
        dfmReports {
          quoteAttachmentRevisionId
          asset {
            id
            createdAt
            downloadUrl
            fileName
          }
          source
          uploaderEmail
          source
          isPublished
        }
        modelConfiguration {
          fdmInfillPercentageCategoryLabel
          color {
            name
          }
          colorCode
          process {
            id
          }
        }
      }
    }
    parts {
      id
      producedBy
      deliveryStatus
      quantity
      orderedQuantity
      associatedErpProductToolId
      material {
        id
        name
        color
        shore
        materialGrade
        colorCode
      }
      unitPrice
      productionRegion
      revision {
        ...revision
      }
      dfmFeedback {
        ...dfmFeedbackOrderDetailsPage
      }
      holes {
        ...holes
      }
      processName
      processNames
      processes {
        id
        platformProcessId
        processName
        processNotes
        color
        thickness
        texture
        finish
        toolLife
        surfaceFinishCode
        additionalSpecifications {
          color
          texture
          thickness
        }
        dfmNotes {
          color
          process
          texture
          thickness
        }
      }
      inspectionStatus
      productionStatus
      quoteModelRevisionAttachment {
        id
        fileName
        downloadUrl
        sanitized {
          id
          fileName
          downloadUrl
        }
        annotated {
          id
          fileName
          downloadUrl
        }
      }
      quoteModelRevision {
        id
        quoteModel {
          quote {
            id
            type
            name
            user {
              id
              firstName
              lastName
              email
            }
          }
        }
        dfmReports {
          quoteAttachmentRevisionId
          asset {
            id
            createdAt
            downloadUrl
            fileName
          }
          source
          uploaderEmail
          source
          isPublished
        }
        modelConfiguration {
          fdmInfillPercentageCategoryLabel
          color {
            name
          }
          colorCode
          process {
            id
          }
        }
      }
      shipmentAndInspection {
        shipmentId
        inspectionDocuments {
          ...inspectionDocuments
        }
        woAvailableToShow
        inspectionTypes
      }
    }
  }
}
    ${RevisionFragmentDoc}
${DfmFeedbackOrderDetailsPageFragmentDoc}
${HolesFragmentDoc}
${InspectionDocumentsFragmentDoc}`;

/**
 * __useSalesOrderLinesQuery__
 *
 * To run a query within a React component, call `useSalesOrderLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesOrderLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesOrderLinesQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      statusNotIn: // value for 'statusNotIn'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      cursor: // value for 'cursor'
 *      isImMaafcoEnabled: // value for 'isImMaafcoEnabled'
 *   },
 * });
 */
export function useSalesOrderLinesQuery(baseOptions: Apollo.QueryHookOptions<SalesOrderLinesQuery, SalesOrderLinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesOrderLinesQuery, SalesOrderLinesQueryVariables>(SalesOrderLinesDocument, options);
      }
export function useSalesOrderLinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesOrderLinesQuery, SalesOrderLinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesOrderLinesQuery, SalesOrderLinesQueryVariables>(SalesOrderLinesDocument, options);
        }
export type SalesOrderLinesQueryHookResult = ReturnType<typeof useSalesOrderLinesQuery>;
export type SalesOrderLinesLazyQueryHookResult = ReturnType<typeof useSalesOrderLinesLazyQuery>;
export type SalesOrderLinesQueryResult = Apollo.QueryResult<SalesOrderLinesQuery, SalesOrderLinesQueryVariables>;
export function refetchSalesOrderLinesQuery(variables: SalesOrderLinesQueryVariables) {
      return { query: SalesOrderLinesDocument, variables: variables }
    }
export const ShipmentLinesDocument = gql`
    query shipmentLines($id: String!, $limit: Int!, $cursor: ENCODED_CURSOR) {
  shipment(id: $id) {
    id
    shipmentLines(limit: $limit, cursor: $cursor) {
      totalCount
      cursor {
        previous
        next
      }
      items {
        id
        quantity
        totalQuantity
        processName
        processNames
        processes {
          id
          platformProcessId
          processName
          processNotes
          color
          thickness
          texture
          finish
          toolLife
          surfaceFinishCode
          additionalSpecifications {
            color
            texture
            thickness
          }
          dfmNotes {
            color
            process
            texture
            thickness
          }
        }
        materialDetails {
          id
          name
          color
          shore
          colorCode
          materialGrade
          publicName
        }
        woAvailableToShow
        quoteModelRevisionAttachment {
          id
          fileName
          downloadUrl
          sanitized {
            id
            fileName
            downloadUrl
          }
          annotated {
            id
            fileName
            downloadUrl
          }
        }
        boundingBox {
          ...boundingBox
        }
        inspectionDocuments {
          ...inspectionDocuments
        }
        revision {
          ...revision
        }
        dfmFeedback {
          ...dfmFeedbackOrderDetailsPage
        }
        holes {
          ...holes
        }
        inspectionTypes
        erpMoldId
      }
    }
  }
}
    ${BoundingBoxFragmentDoc}
${InspectionDocumentsFragmentDoc}
${RevisionFragmentDoc}
${DfmFeedbackOrderDetailsPageFragmentDoc}
${HolesFragmentDoc}`;

/**
 * __useShipmentLinesQuery__
 *
 * To run a query within a React component, call `useShipmentLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipmentLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipmentLinesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useShipmentLinesQuery(baseOptions: Apollo.QueryHookOptions<ShipmentLinesQuery, ShipmentLinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShipmentLinesQuery, ShipmentLinesQueryVariables>(ShipmentLinesDocument, options);
      }
export function useShipmentLinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShipmentLinesQuery, ShipmentLinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShipmentLinesQuery, ShipmentLinesQueryVariables>(ShipmentLinesDocument, options);
        }
export type ShipmentLinesQueryHookResult = ReturnType<typeof useShipmentLinesQuery>;
export type ShipmentLinesLazyQueryHookResult = ReturnType<typeof useShipmentLinesLazyQuery>;
export type ShipmentLinesQueryResult = Apollo.QueryResult<ShipmentLinesQuery, ShipmentLinesQueryVariables>;
export function refetchShipmentLinesQuery(variables: ShipmentLinesQueryVariables) {
      return { query: ShipmentLinesDocument, variables: variables }
    }
export const DfmFeedbackQueryDocument = gql`
    query dfmFeedbackQuery($name: String!) {
  salesOrder(name: $name) {
    salesOrderLines(limit: 100) {
      items {
        id
        quoteModelRevision {
          id
          dfmFeedback(includeDraft: true) {
            id
            isPublished
          }
        }
      }
      parts {
        id
        quoteModelRevision {
          id
          dfmFeedback(includeDraft: true) {
            id
            isPublished
          }
        }
      }
    }
  }
}
    `;

/**
 * __useDfmFeedbackQueryQuery__
 *
 * To run a query within a React component, call `useDfmFeedbackQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDfmFeedbackQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDfmFeedbackQueryQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDfmFeedbackQueryQuery(baseOptions: Apollo.QueryHookOptions<DfmFeedbackQueryQuery, DfmFeedbackQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DfmFeedbackQueryQuery, DfmFeedbackQueryQueryVariables>(DfmFeedbackQueryDocument, options);
      }
export function useDfmFeedbackQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DfmFeedbackQueryQuery, DfmFeedbackQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DfmFeedbackQueryQuery, DfmFeedbackQueryQueryVariables>(DfmFeedbackQueryDocument, options);
        }
export type DfmFeedbackQueryQueryHookResult = ReturnType<typeof useDfmFeedbackQueryQuery>;
export type DfmFeedbackQueryLazyQueryHookResult = ReturnType<typeof useDfmFeedbackQueryLazyQuery>;
export type DfmFeedbackQueryQueryResult = Apollo.QueryResult<DfmFeedbackQueryQuery, DfmFeedbackQueryQueryVariables>;
export function refetchDfmFeedbackQueryQuery(variables: DfmFeedbackQueryQueryVariables) {
      return { query: DfmFeedbackQueryDocument, variables: variables }
    }
export const SalesOrderDownloadInvoiceUriDocument = gql`
    query salesOrderDownloadInvoiceUri($name: String!) {
  salesOrder(name: $name) {
    downloadInvoiceUri
  }
}
    `;

/**
 * __useSalesOrderDownloadInvoiceUriQuery__
 *
 * To run a query within a React component, call `useSalesOrderDownloadInvoiceUriQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesOrderDownloadInvoiceUriQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesOrderDownloadInvoiceUriQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSalesOrderDownloadInvoiceUriQuery(baseOptions: Apollo.QueryHookOptions<SalesOrderDownloadInvoiceUriQuery, SalesOrderDownloadInvoiceUriQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesOrderDownloadInvoiceUriQuery, SalesOrderDownloadInvoiceUriQueryVariables>(SalesOrderDownloadInvoiceUriDocument, options);
      }
export function useSalesOrderDownloadInvoiceUriLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesOrderDownloadInvoiceUriQuery, SalesOrderDownloadInvoiceUriQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesOrderDownloadInvoiceUriQuery, SalesOrderDownloadInvoiceUriQueryVariables>(SalesOrderDownloadInvoiceUriDocument, options);
        }
export type SalesOrderDownloadInvoiceUriQueryHookResult = ReturnType<typeof useSalesOrderDownloadInvoiceUriQuery>;
export type SalesOrderDownloadInvoiceUriLazyQueryHookResult = ReturnType<typeof useSalesOrderDownloadInvoiceUriLazyQuery>;
export type SalesOrderDownloadInvoiceUriQueryResult = Apollo.QueryResult<SalesOrderDownloadInvoiceUriQuery, SalesOrderDownloadInvoiceUriQueryVariables>;
export function refetchSalesOrderDownloadInvoiceUriQuery(variables: SalesOrderDownloadInvoiceUriQueryVariables) {
      return { query: SalesOrderDownloadInvoiceUriDocument, variables: variables }
    }
export const CreateReorderQuoteFromOrderDocument = gql`
    mutation createReorderQuoteFromOrder($orderName: String!, $userId: Int) {
  createReorderQuoteFromOrder(orderName: $orderName, userId: $userId) {
    id
    name
  }
}
    `;
export type CreateReorderQuoteFromOrderMutationFn = Apollo.MutationFunction<CreateReorderQuoteFromOrderMutation, CreateReorderQuoteFromOrderMutationVariables>;

/**
 * __useCreateReorderQuoteFromOrderMutation__
 *
 * To run a mutation, you first call `useCreateReorderQuoteFromOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReorderQuoteFromOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReorderQuoteFromOrderMutation, { data, loading, error }] = useCreateReorderQuoteFromOrderMutation({
 *   variables: {
 *      orderName: // value for 'orderName'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCreateReorderQuoteFromOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateReorderQuoteFromOrderMutation, CreateReorderQuoteFromOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReorderQuoteFromOrderMutation, CreateReorderQuoteFromOrderMutationVariables>(CreateReorderQuoteFromOrderDocument, options);
      }
export type CreateReorderQuoteFromOrderMutationHookResult = ReturnType<typeof useCreateReorderQuoteFromOrderMutation>;
export type CreateReorderQuoteFromOrderMutationResult = Apollo.MutationResult<CreateReorderQuoteFromOrderMutation>;
export type CreateReorderQuoteFromOrderMutationOptions = Apollo.BaseMutationOptions<CreateReorderQuoteFromOrderMutation, CreateReorderQuoteFromOrderMutationVariables>;
export const GetNonconfigurableOrderPartConfigInfoDocument = gql`
    query getNonconfigurableOrderPartConfigInfo($orderName: String!) {
  getNonconfigurableOrderPartConfigInfo(orderName: $orderName) {
    fileName
    processes {
      id
      name
    }
    materials {
      id
      name
      processTechnologyId
    }
    postProcesses {
      id
      name
      color
    }
    secondaryProcesses {
      id
      name
    }
  }
}
    `;

/**
 * __useGetNonconfigurableOrderPartConfigInfoQuery__
 *
 * To run a query within a React component, call `useGetNonconfigurableOrderPartConfigInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNonconfigurableOrderPartConfigInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNonconfigurableOrderPartConfigInfoQuery({
 *   variables: {
 *      orderName: // value for 'orderName'
 *   },
 * });
 */
export function useGetNonconfigurableOrderPartConfigInfoQuery(baseOptions: Apollo.QueryHookOptions<GetNonconfigurableOrderPartConfigInfoQuery, GetNonconfigurableOrderPartConfigInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNonconfigurableOrderPartConfigInfoQuery, GetNonconfigurableOrderPartConfigInfoQueryVariables>(GetNonconfigurableOrderPartConfigInfoDocument, options);
      }
export function useGetNonconfigurableOrderPartConfigInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNonconfigurableOrderPartConfigInfoQuery, GetNonconfigurableOrderPartConfigInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNonconfigurableOrderPartConfigInfoQuery, GetNonconfigurableOrderPartConfigInfoQueryVariables>(GetNonconfigurableOrderPartConfigInfoDocument, options);
        }
export type GetNonconfigurableOrderPartConfigInfoQueryHookResult = ReturnType<typeof useGetNonconfigurableOrderPartConfigInfoQuery>;
export type GetNonconfigurableOrderPartConfigInfoLazyQueryHookResult = ReturnType<typeof useGetNonconfigurableOrderPartConfigInfoLazyQuery>;
export type GetNonconfigurableOrderPartConfigInfoQueryResult = Apollo.QueryResult<GetNonconfigurableOrderPartConfigInfoQuery, GetNonconfigurableOrderPartConfigInfoQueryVariables>;
export function refetchGetNonconfigurableOrderPartConfigInfoQuery(variables: GetNonconfigurableOrderPartConfigInfoQueryVariables) {
      return { query: GetNonconfigurableOrderPartConfigInfoDocument, variables: variables }
    }
export const GetReorderEligibilityForOrderDocument = gql`
    query getReorderEligibilityForOrder($orderName: String!) {
  getReorderEligibilityForOrder(orderName: $orderName) {
    eligible
    ineligibilityReason
  }
}
    `;

/**
 * __useGetReorderEligibilityForOrderQuery__
 *
 * To run a query within a React component, call `useGetReorderEligibilityForOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReorderEligibilityForOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReorderEligibilityForOrderQuery({
 *   variables: {
 *      orderName: // value for 'orderName'
 *   },
 * });
 */
export function useGetReorderEligibilityForOrderQuery(baseOptions: Apollo.QueryHookOptions<GetReorderEligibilityForOrderQuery, GetReorderEligibilityForOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReorderEligibilityForOrderQuery, GetReorderEligibilityForOrderQueryVariables>(GetReorderEligibilityForOrderDocument, options);
      }
export function useGetReorderEligibilityForOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReorderEligibilityForOrderQuery, GetReorderEligibilityForOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReorderEligibilityForOrderQuery, GetReorderEligibilityForOrderQueryVariables>(GetReorderEligibilityForOrderDocument, options);
        }
export type GetReorderEligibilityForOrderQueryHookResult = ReturnType<typeof useGetReorderEligibilityForOrderQuery>;
export type GetReorderEligibilityForOrderLazyQueryHookResult = ReturnType<typeof useGetReorderEligibilityForOrderLazyQuery>;
export type GetReorderEligibilityForOrderQueryResult = Apollo.QueryResult<GetReorderEligibilityForOrderQuery, GetReorderEligibilityForOrderQueryVariables>;
export function refetchGetReorderEligibilityForOrderQuery(variables: GetReorderEligibilityForOrderQueryVariables) {
      return { query: GetReorderEligibilityForOrderDocument, variables: variables }
    }
export const FeatureFlagsDashboardDocument = gql`
    query featureFlagsDashboard {
  featureFlags {
    key
    defaultVariant
    scope
    updatedAt
    rules {
      attribute
      operation
      values
      variant
    }
  }
}
    `;

/**
 * __useFeatureFlagsDashboardQuery__
 *
 * To run a query within a React component, call `useFeatureFlagsDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureFlagsDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureFlagsDashboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeatureFlagsDashboardQuery(baseOptions?: Apollo.QueryHookOptions<FeatureFlagsDashboardQuery, FeatureFlagsDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeatureFlagsDashboardQuery, FeatureFlagsDashboardQueryVariables>(FeatureFlagsDashboardDocument, options);
      }
export function useFeatureFlagsDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeatureFlagsDashboardQuery, FeatureFlagsDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeatureFlagsDashboardQuery, FeatureFlagsDashboardQueryVariables>(FeatureFlagsDashboardDocument, options);
        }
export type FeatureFlagsDashboardQueryHookResult = ReturnType<typeof useFeatureFlagsDashboardQuery>;
export type FeatureFlagsDashboardLazyQueryHookResult = ReturnType<typeof useFeatureFlagsDashboardLazyQuery>;
export type FeatureFlagsDashboardQueryResult = Apollo.QueryResult<FeatureFlagsDashboardQuery, FeatureFlagsDashboardQueryVariables>;
export function refetchFeatureFlagsDashboardQuery(variables?: FeatureFlagsDashboardQueryVariables) {
      return { query: FeatureFlagsDashboardDocument, variables: variables }
    }
export const SetFeatureFlagDashboardDocument = gql`
    mutation setFeatureFlagDashboard($setFeatureFlagInput: FeatureFlagInput!) {
  setFeatureFlag(input: $setFeatureFlagInput) {
    key
    defaultVariant
    scope
    updatedAt
    rules {
      attribute
      operation
      values
      variant
    }
  }
}
    `;
export type SetFeatureFlagDashboardMutationFn = Apollo.MutationFunction<SetFeatureFlagDashboardMutation, SetFeatureFlagDashboardMutationVariables>;

/**
 * __useSetFeatureFlagDashboardMutation__
 *
 * To run a mutation, you first call `useSetFeatureFlagDashboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFeatureFlagDashboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFeatureFlagDashboardMutation, { data, loading, error }] = useSetFeatureFlagDashboardMutation({
 *   variables: {
 *      setFeatureFlagInput: // value for 'setFeatureFlagInput'
 *   },
 * });
 */
export function useSetFeatureFlagDashboardMutation(baseOptions?: Apollo.MutationHookOptions<SetFeatureFlagDashboardMutation, SetFeatureFlagDashboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetFeatureFlagDashboardMutation, SetFeatureFlagDashboardMutationVariables>(SetFeatureFlagDashboardDocument, options);
      }
export type SetFeatureFlagDashboardMutationHookResult = ReturnType<typeof useSetFeatureFlagDashboardMutation>;
export type SetFeatureFlagDashboardMutationResult = Apollo.MutationResult<SetFeatureFlagDashboardMutation>;
export type SetFeatureFlagDashboardMutationOptions = Apollo.BaseMutationOptions<SetFeatureFlagDashboardMutation, SetFeatureFlagDashboardMutationVariables>;
export const CancelPlatformOrderOrderDetailViewDocument = gql`
    mutation cancelPlatformOrderOrderDetailView($orderId: String!) {
  cancelPlatformOrder(orderId: $orderId) {
    id
  }
}
    `;
export type CancelPlatformOrderOrderDetailViewMutationFn = Apollo.MutationFunction<CancelPlatformOrderOrderDetailViewMutation, CancelPlatformOrderOrderDetailViewMutationVariables>;

/**
 * __useCancelPlatformOrderOrderDetailViewMutation__
 *
 * To run a mutation, you first call `useCancelPlatformOrderOrderDetailViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPlatformOrderOrderDetailViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPlatformOrderOrderDetailViewMutation, { data, loading, error }] = useCancelPlatformOrderOrderDetailViewMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useCancelPlatformOrderOrderDetailViewMutation(baseOptions?: Apollo.MutationHookOptions<CancelPlatformOrderOrderDetailViewMutation, CancelPlatformOrderOrderDetailViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelPlatformOrderOrderDetailViewMutation, CancelPlatformOrderOrderDetailViewMutationVariables>(CancelPlatformOrderOrderDetailViewDocument, options);
      }
export type CancelPlatformOrderOrderDetailViewMutationHookResult = ReturnType<typeof useCancelPlatformOrderOrderDetailViewMutation>;
export type CancelPlatformOrderOrderDetailViewMutationResult = Apollo.MutationResult<CancelPlatformOrderOrderDetailViewMutation>;
export type CancelPlatformOrderOrderDetailViewMutationOptions = Apollo.BaseMutationOptions<CancelPlatformOrderOrderDetailViewMutation, CancelPlatformOrderOrderDetailViewMutationVariables>;
export const OrderDocument = gql`
    query order($orderId: String!) {
  order(orderId: $orderId) {
    id
    status
  }
}
    `;

/**
 * __useOrderQuery__
 *
 * To run a query within a React component, call `useOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useOrderQuery(baseOptions: Apollo.QueryHookOptions<OrderQuery, OrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
      }
export function useOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderQuery, OrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
        }
export type OrderQueryHookResult = ReturnType<typeof useOrderQuery>;
export type OrderLazyQueryHookResult = ReturnType<typeof useOrderLazyQuery>;
export type OrderQueryResult = Apollo.QueryResult<OrderQuery, OrderQueryVariables>;
export function refetchOrderQuery(variables: OrderQueryVariables) {
      return { query: OrderDocument, variables: variables }
    }
export const OrderInvoiceDocument = gql`
    query orderInvoice($orderId: String!) {
  order(orderId: $orderId) {
    id
    instantQuoteInvoiceUri
  }
}
    `;

/**
 * __useOrderInvoiceQuery__
 *
 * To run a query within a React component, call `useOrderInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderInvoiceQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useOrderInvoiceQuery(baseOptions: Apollo.QueryHookOptions<OrderInvoiceQuery, OrderInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderInvoiceQuery, OrderInvoiceQueryVariables>(OrderInvoiceDocument, options);
      }
export function useOrderInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderInvoiceQuery, OrderInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderInvoiceQuery, OrderInvoiceQueryVariables>(OrderInvoiceDocument, options);
        }
export type OrderInvoiceQueryHookResult = ReturnType<typeof useOrderInvoiceQuery>;
export type OrderInvoiceLazyQueryHookResult = ReturnType<typeof useOrderInvoiceLazyQuery>;
export type OrderInvoiceQueryResult = Apollo.QueryResult<OrderInvoiceQuery, OrderInvoiceQueryVariables>;
export function refetchOrderInvoiceQuery(variables: OrderInvoiceQueryVariables) {
      return { query: OrderInvoiceDocument, variables: variables }
    }
export const CreateQuoteLevelMoldDocument = gql`
    mutation CreateQuoteLevelMold($quoteId: UUID!, $isImMaafcoEnabled: Boolean = false) {
  createQuoteMoldTool(quoteId: $quoteId) {
    id
    name @include(if: $isImMaafcoEnabled)
    moldToolRevision @include(if: $isImMaafcoEnabled) {
      id
      version
      processId
    }
  }
}
    `;
export type CreateQuoteLevelMoldMutationFn = Apollo.MutationFunction<CreateQuoteLevelMoldMutation, CreateQuoteLevelMoldMutationVariables>;

/**
 * __useCreateQuoteLevelMoldMutation__
 *
 * To run a mutation, you first call `useCreateQuoteLevelMoldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuoteLevelMoldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuoteLevelMoldMutation, { data, loading, error }] = useCreateQuoteLevelMoldMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      isImMaafcoEnabled: // value for 'isImMaafcoEnabled'
 *   },
 * });
 */
export function useCreateQuoteLevelMoldMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuoteLevelMoldMutation, CreateQuoteLevelMoldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuoteLevelMoldMutation, CreateQuoteLevelMoldMutationVariables>(CreateQuoteLevelMoldDocument, options);
      }
export type CreateQuoteLevelMoldMutationHookResult = ReturnType<typeof useCreateQuoteLevelMoldMutation>;
export type CreateQuoteLevelMoldMutationResult = Apollo.MutationResult<CreateQuoteLevelMoldMutation>;
export type CreateQuoteLevelMoldMutationOptions = Apollo.BaseMutationOptions<CreateQuoteLevelMoldMutation, CreateQuoteLevelMoldMutationVariables>;
export const CreateMoldToolQmrAssociationDocument = gql`
    mutation createMoldToolQmrAssociation($moldToolId: UUID!, $modelConfigurationDfmInspectionId: UUID!) {
  createMoldToolQmrAssociation(
    moldToolId: $moldToolId
    modelConfigurationDfmInspectionId: $modelConfigurationDfmInspectionId
  ) {
    id
    fileName
  }
}
    `;
export type CreateMoldToolQmrAssociationMutationFn = Apollo.MutationFunction<CreateMoldToolQmrAssociationMutation, CreateMoldToolQmrAssociationMutationVariables>;

/**
 * __useCreateMoldToolQmrAssociationMutation__
 *
 * To run a mutation, you first call `useCreateMoldToolQmrAssociationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMoldToolQmrAssociationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMoldToolQmrAssociationMutation, { data, loading, error }] = useCreateMoldToolQmrAssociationMutation({
 *   variables: {
 *      moldToolId: // value for 'moldToolId'
 *      modelConfigurationDfmInspectionId: // value for 'modelConfigurationDfmInspectionId'
 *   },
 * });
 */
export function useCreateMoldToolQmrAssociationMutation(baseOptions?: Apollo.MutationHookOptions<CreateMoldToolQmrAssociationMutation, CreateMoldToolQmrAssociationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMoldToolQmrAssociationMutation, CreateMoldToolQmrAssociationMutationVariables>(CreateMoldToolQmrAssociationDocument, options);
      }
export type CreateMoldToolQmrAssociationMutationHookResult = ReturnType<typeof useCreateMoldToolQmrAssociationMutation>;
export type CreateMoldToolQmrAssociationMutationResult = Apollo.MutationResult<CreateMoldToolQmrAssociationMutation>;
export type CreateMoldToolQmrAssociationMutationOptions = Apollo.BaseMutationOptions<CreateMoldToolQmrAssociationMutation, CreateMoldToolQmrAssociationMutationVariables>;
export const UpdateMoldToolInspectionDataDocument = gql`
    mutation UpdateMoldToolInspectionData($updateMoldToolInspectionDataId: UUID!, $inspectionData: MoldToolInspectionDataInput!) {
  updateMoldToolInspectionData(
    id: $updateMoldToolInspectionDataId
    inspectionData: $inspectionData
  ) {
    id
    uiIndex
  }
}
    `;
export type UpdateMoldToolInspectionDataMutationFn = Apollo.MutationFunction<UpdateMoldToolInspectionDataMutation, UpdateMoldToolInspectionDataMutationVariables>;

/**
 * __useUpdateMoldToolInspectionDataMutation__
 *
 * To run a mutation, you first call `useUpdateMoldToolInspectionDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMoldToolInspectionDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMoldToolInspectionDataMutation, { data, loading, error }] = useUpdateMoldToolInspectionDataMutation({
 *   variables: {
 *      updateMoldToolInspectionDataId: // value for 'updateMoldToolInspectionDataId'
 *      inspectionData: // value for 'inspectionData'
 *   },
 * });
 */
export function useUpdateMoldToolInspectionDataMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMoldToolInspectionDataMutation, UpdateMoldToolInspectionDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMoldToolInspectionDataMutation, UpdateMoldToolInspectionDataMutationVariables>(UpdateMoldToolInspectionDataDocument, options);
      }
export type UpdateMoldToolInspectionDataMutationHookResult = ReturnType<typeof useUpdateMoldToolInspectionDataMutation>;
export type UpdateMoldToolInspectionDataMutationResult = Apollo.MutationResult<UpdateMoldToolInspectionDataMutation>;
export type UpdateMoldToolInspectionDataMutationOptions = Apollo.BaseMutationOptions<UpdateMoldToolInspectionDataMutation, UpdateMoldToolInspectionDataMutationVariables>;
export const UpdateMoldToolOverrideDataDocument = gql`
    mutation updateMoldToolOverrideData($moldId: UUID!, $moldToolOverrideData: MoldToolOverrideInput!) {
  updateMoldToolOverrideData(
    moldId: $moldId
    moldToolOverrideData: $moldToolOverrideData
  ) {
    manualOverrideMpUnitPayout
    manualOverrideUnitAmount
  }
}
    `;
export type UpdateMoldToolOverrideDataMutationFn = Apollo.MutationFunction<UpdateMoldToolOverrideDataMutation, UpdateMoldToolOverrideDataMutationVariables>;

/**
 * __useUpdateMoldToolOverrideDataMutation__
 *
 * To run a mutation, you first call `useUpdateMoldToolOverrideDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMoldToolOverrideDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMoldToolOverrideDataMutation, { data, loading, error }] = useUpdateMoldToolOverrideDataMutation({
 *   variables: {
 *      moldId: // value for 'moldId'
 *      moldToolOverrideData: // value for 'moldToolOverrideData'
 *   },
 * });
 */
export function useUpdateMoldToolOverrideDataMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMoldToolOverrideDataMutation, UpdateMoldToolOverrideDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMoldToolOverrideDataMutation, UpdateMoldToolOverrideDataMutationVariables>(UpdateMoldToolOverrideDataDocument, options);
      }
export type UpdateMoldToolOverrideDataMutationHookResult = ReturnType<typeof useUpdateMoldToolOverrideDataMutation>;
export type UpdateMoldToolOverrideDataMutationResult = Apollo.MutationResult<UpdateMoldToolOverrideDataMutation>;
export type UpdateMoldToolOverrideDataMutationOptions = Apollo.BaseMutationOptions<UpdateMoldToolOverrideDataMutation, UpdateMoldToolOverrideDataMutationVariables>;
export const AddMtrToQmrAssociationDocument = gql`
    mutation addMtrToQmrAssociation($moldToolRevisionId: UUID!, $quoteModelRevisionId: UUID!) {
  addMoldToolRevisionToQMRAssociation(
    moldToolRevisionId: $moldToolRevisionId
    quoteModelRevisionId: $quoteModelRevisionId
  ) {
    id
    name
    moldToolRevisionQmr {
      cavityPerPart
    }
  }
}
    `;
export type AddMtrToQmrAssociationMutationFn = Apollo.MutationFunction<AddMtrToQmrAssociationMutation, AddMtrToQmrAssociationMutationVariables>;

/**
 * __useAddMtrToQmrAssociationMutation__
 *
 * To run a mutation, you first call `useAddMtrToQmrAssociationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMtrToQmrAssociationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMtrToQmrAssociationMutation, { data, loading, error }] = useAddMtrToQmrAssociationMutation({
 *   variables: {
 *      moldToolRevisionId: // value for 'moldToolRevisionId'
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *   },
 * });
 */
export function useAddMtrToQmrAssociationMutation(baseOptions?: Apollo.MutationHookOptions<AddMtrToQmrAssociationMutation, AddMtrToQmrAssociationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMtrToQmrAssociationMutation, AddMtrToQmrAssociationMutationVariables>(AddMtrToQmrAssociationDocument, options);
      }
export type AddMtrToQmrAssociationMutationHookResult = ReturnType<typeof useAddMtrToQmrAssociationMutation>;
export type AddMtrToQmrAssociationMutationResult = Apollo.MutationResult<AddMtrToQmrAssociationMutation>;
export type AddMtrToQmrAssociationMutationOptions = Apollo.BaseMutationOptions<AddMtrToQmrAssociationMutation, AddMtrToQmrAssociationMutationVariables>;
export const UpdateMoldToolRevisionDocument = gql`
    mutation updateMoldToolRevision($moldToolRevisionId: String!, $input: MoldToolRevisionInput!) {
  updateMoldToolRevision(
    moldToolRevisionId: $moldToolRevisionId
    inspectionData: $input
  ) {
    id
    moldToolRevisionId
    name
    toolLife
    moldToolRevision {
      gateType
      processId
    }
  }
}
    `;
export type UpdateMoldToolRevisionMutationFn = Apollo.MutationFunction<UpdateMoldToolRevisionMutation, UpdateMoldToolRevisionMutationVariables>;

/**
 * __useUpdateMoldToolRevisionMutation__
 *
 * To run a mutation, you first call `useUpdateMoldToolRevisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMoldToolRevisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMoldToolRevisionMutation, { data, loading, error }] = useUpdateMoldToolRevisionMutation({
 *   variables: {
 *      moldToolRevisionId: // value for 'moldToolRevisionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMoldToolRevisionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMoldToolRevisionMutation, UpdateMoldToolRevisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMoldToolRevisionMutation, UpdateMoldToolRevisionMutationVariables>(UpdateMoldToolRevisionDocument, options);
      }
export type UpdateMoldToolRevisionMutationHookResult = ReturnType<typeof useUpdateMoldToolRevisionMutation>;
export type UpdateMoldToolRevisionMutationResult = Apollo.MutationResult<UpdateMoldToolRevisionMutation>;
export type UpdateMoldToolRevisionMutationOptions = Apollo.BaseMutationOptions<UpdateMoldToolRevisionMutation, UpdateMoldToolRevisionMutationVariables>;
export const DestroyMoldToolRevisionToQmrAssociationDocument = gql`
    mutation destroyMoldToolRevisionToQMRAssociation($moldToolRevisionId: UUID!, $quoteModelRevisionId: UUID!) {
  destroyMoldToolRevisionToQMRAssociation(
    moldToolRevisionId: $moldToolRevisionId
    quoteModelRevisionId: $quoteModelRevisionId
  ) {
    id
    name
  }
}
    `;
export type DestroyMoldToolRevisionToQmrAssociationMutationFn = Apollo.MutationFunction<DestroyMoldToolRevisionToQmrAssociationMutation, DestroyMoldToolRevisionToQmrAssociationMutationVariables>;

/**
 * __useDestroyMoldToolRevisionToQmrAssociationMutation__
 *
 * To run a mutation, you first call `useDestroyMoldToolRevisionToQmrAssociationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyMoldToolRevisionToQmrAssociationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyMoldToolRevisionToQmrAssociationMutation, { data, loading, error }] = useDestroyMoldToolRevisionToQmrAssociationMutation({
 *   variables: {
 *      moldToolRevisionId: // value for 'moldToolRevisionId'
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *   },
 * });
 */
export function useDestroyMoldToolRevisionToQmrAssociationMutation(baseOptions?: Apollo.MutationHookOptions<DestroyMoldToolRevisionToQmrAssociationMutation, DestroyMoldToolRevisionToQmrAssociationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroyMoldToolRevisionToQmrAssociationMutation, DestroyMoldToolRevisionToQmrAssociationMutationVariables>(DestroyMoldToolRevisionToQmrAssociationDocument, options);
      }
export type DestroyMoldToolRevisionToQmrAssociationMutationHookResult = ReturnType<typeof useDestroyMoldToolRevisionToQmrAssociationMutation>;
export type DestroyMoldToolRevisionToQmrAssociationMutationResult = Apollo.MutationResult<DestroyMoldToolRevisionToQmrAssociationMutation>;
export type DestroyMoldToolRevisionToQmrAssociationMutationOptions = Apollo.BaseMutationOptions<DestroyMoldToolRevisionToQmrAssociationMutation, DestroyMoldToolRevisionToQmrAssociationMutationVariables>;
export const UpdateMoldToolRevisionToQmrAssociationDocument = gql`
    mutation updateMoldToolRevisionToQMRAssociation($moldToolRevisionId: UUID!, $cavityPerQmr: [UpdateQmrAssociationInput]!) {
  updateMoldToolRevisionToQMRAssociation(
    moldToolRevisionId: $moldToolRevisionId
    cavityPerQmr: $cavityPerQmr
  ) {
    id
    name
  }
}
    `;
export type UpdateMoldToolRevisionToQmrAssociationMutationFn = Apollo.MutationFunction<UpdateMoldToolRevisionToQmrAssociationMutation, UpdateMoldToolRevisionToQmrAssociationMutationVariables>;

/**
 * __useUpdateMoldToolRevisionToQmrAssociationMutation__
 *
 * To run a mutation, you first call `useUpdateMoldToolRevisionToQmrAssociationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMoldToolRevisionToQmrAssociationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMoldToolRevisionToQmrAssociationMutation, { data, loading, error }] = useUpdateMoldToolRevisionToQmrAssociationMutation({
 *   variables: {
 *      moldToolRevisionId: // value for 'moldToolRevisionId'
 *      cavityPerQmr: // value for 'cavityPerQmr'
 *   },
 * });
 */
export function useUpdateMoldToolRevisionToQmrAssociationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMoldToolRevisionToQmrAssociationMutation, UpdateMoldToolRevisionToQmrAssociationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMoldToolRevisionToQmrAssociationMutation, UpdateMoldToolRevisionToQmrAssociationMutationVariables>(UpdateMoldToolRevisionToQmrAssociationDocument, options);
      }
export type UpdateMoldToolRevisionToQmrAssociationMutationHookResult = ReturnType<typeof useUpdateMoldToolRevisionToQmrAssociationMutation>;
export type UpdateMoldToolRevisionToQmrAssociationMutationResult = Apollo.MutationResult<UpdateMoldToolRevisionToQmrAssociationMutation>;
export type UpdateMoldToolRevisionToQmrAssociationMutationOptions = Apollo.BaseMutationOptions<UpdateMoldToolRevisionToQmrAssociationMutation, UpdateMoldToolRevisionToQmrAssociationMutationVariables>;
export const UpdateMoldToolInspectionOverrideDataDocument = gql`
    mutation updateMoldToolInspectionOverrideData($moldRevisionId: UUID!, $moldToolOverrideData: MoldToolOverrideInput) {
  updateMoldToolInspectionOverrideData(
    moldToolRevisionId: $moldRevisionId
    moldToolOverrideData: $moldToolOverrideData
  ) {
    manualOverrideMpUnitPayout
    manualOverrideUnitAmount
    __typename
  }
}
    `;
export type UpdateMoldToolInspectionOverrideDataMutationFn = Apollo.MutationFunction<UpdateMoldToolInspectionOverrideDataMutation, UpdateMoldToolInspectionOverrideDataMutationVariables>;

/**
 * __useUpdateMoldToolInspectionOverrideDataMutation__
 *
 * To run a mutation, you first call `useUpdateMoldToolInspectionOverrideDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMoldToolInspectionOverrideDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMoldToolInspectionOverrideDataMutation, { data, loading, error }] = useUpdateMoldToolInspectionOverrideDataMutation({
 *   variables: {
 *      moldRevisionId: // value for 'moldRevisionId'
 *      moldToolOverrideData: // value for 'moldToolOverrideData'
 *   },
 * });
 */
export function useUpdateMoldToolInspectionOverrideDataMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMoldToolInspectionOverrideDataMutation, UpdateMoldToolInspectionOverrideDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMoldToolInspectionOverrideDataMutation, UpdateMoldToolInspectionOverrideDataMutationVariables>(UpdateMoldToolInspectionOverrideDataDocument, options);
      }
export type UpdateMoldToolInspectionOverrideDataMutationHookResult = ReturnType<typeof useUpdateMoldToolInspectionOverrideDataMutation>;
export type UpdateMoldToolInspectionOverrideDataMutationResult = Apollo.MutationResult<UpdateMoldToolInspectionOverrideDataMutation>;
export type UpdateMoldToolInspectionOverrideDataMutationOptions = Apollo.BaseMutationOptions<UpdateMoldToolInspectionOverrideDataMutation, UpdateMoldToolInspectionOverrideDataMutationVariables>;
export const CreateMoldToolRevisionDocument = gql`
    mutation createMoldToolRevision($moldToolRevisionId: String!, $quoteId: String!) {
  createMoldToolRevision(
    moldToolRevisionId: $moldToolRevisionId
    quoteId: $quoteId
  ) {
    id
    name
    moldToolRevisionId
    moldToolRevision {
      id
      version
      processId
    }
    inspectionData
    quoteModelRevisions {
      id
      fileName
      version
      partRevision {
        thumbnailUri
      }
    }
    moldToolRevisionQmr {
      id
      moldToolRevisionId
      quoteModelRevisionId
      cavityPerPart
    }
    uiIndex
  }
}
    `;
export type CreateMoldToolRevisionMutationFn = Apollo.MutationFunction<CreateMoldToolRevisionMutation, CreateMoldToolRevisionMutationVariables>;

/**
 * __useCreateMoldToolRevisionMutation__
 *
 * To run a mutation, you first call `useCreateMoldToolRevisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMoldToolRevisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMoldToolRevisionMutation, { data, loading, error }] = useCreateMoldToolRevisionMutation({
 *   variables: {
 *      moldToolRevisionId: // value for 'moldToolRevisionId'
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useCreateMoldToolRevisionMutation(baseOptions?: Apollo.MutationHookOptions<CreateMoldToolRevisionMutation, CreateMoldToolRevisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMoldToolRevisionMutation, CreateMoldToolRevisionMutationVariables>(CreateMoldToolRevisionDocument, options);
      }
export type CreateMoldToolRevisionMutationHookResult = ReturnType<typeof useCreateMoldToolRevisionMutation>;
export type CreateMoldToolRevisionMutationResult = Apollo.MutationResult<CreateMoldToolRevisionMutation>;
export type CreateMoldToolRevisionMutationOptions = Apollo.BaseMutationOptions<CreateMoldToolRevisionMutation, CreateMoldToolRevisionMutationVariables>;
export const DestroyMoldToolRevisionAssociationDocument = gql`
    mutation destroyMoldToolRevisionAssociation($moldToolRevisionId: UUID!) {
  destroyMoldToolRevisionAssociations(moldToolRevisionId: $moldToolRevisionId) {
    id
  }
}
    `;
export type DestroyMoldToolRevisionAssociationMutationFn = Apollo.MutationFunction<DestroyMoldToolRevisionAssociationMutation, DestroyMoldToolRevisionAssociationMutationVariables>;

/**
 * __useDestroyMoldToolRevisionAssociationMutation__
 *
 * To run a mutation, you first call `useDestroyMoldToolRevisionAssociationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyMoldToolRevisionAssociationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyMoldToolRevisionAssociationMutation, { data, loading, error }] = useDestroyMoldToolRevisionAssociationMutation({
 *   variables: {
 *      moldToolRevisionId: // value for 'moldToolRevisionId'
 *   },
 * });
 */
export function useDestroyMoldToolRevisionAssociationMutation(baseOptions?: Apollo.MutationHookOptions<DestroyMoldToolRevisionAssociationMutation, DestroyMoldToolRevisionAssociationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroyMoldToolRevisionAssociationMutation, DestroyMoldToolRevisionAssociationMutationVariables>(DestroyMoldToolRevisionAssociationDocument, options);
      }
export type DestroyMoldToolRevisionAssociationMutationHookResult = ReturnType<typeof useDestroyMoldToolRevisionAssociationMutation>;
export type DestroyMoldToolRevisionAssociationMutationResult = Apollo.MutationResult<DestroyMoldToolRevisionAssociationMutation>;
export type DestroyMoldToolRevisionAssociationMutationOptions = Apollo.BaseMutationOptions<DestroyMoldToolRevisionAssociationMutation, DestroyMoldToolRevisionAssociationMutationVariables>;
export const UpdateMoldRepairQuoteDocument = gql`
    mutation UpdateMoldRepairQuote($updateQuoteId: UUID!, $input: QuoteInput!) {
  updateQuote(id: $updateQuoteId, input: $input) {
    isMoldRepair
  }
}
    `;
export type UpdateMoldRepairQuoteMutationFn = Apollo.MutationFunction<UpdateMoldRepairQuoteMutation, UpdateMoldRepairQuoteMutationVariables>;

/**
 * __useUpdateMoldRepairQuoteMutation__
 *
 * To run a mutation, you first call `useUpdateMoldRepairQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMoldRepairQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMoldRepairQuoteMutation, { data, loading, error }] = useUpdateMoldRepairQuoteMutation({
 *   variables: {
 *      updateQuoteId: // value for 'updateQuoteId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMoldRepairQuoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMoldRepairQuoteMutation, UpdateMoldRepairQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMoldRepairQuoteMutation, UpdateMoldRepairQuoteMutationVariables>(UpdateMoldRepairQuoteDocument, options);
      }
export type UpdateMoldRepairQuoteMutationHookResult = ReturnType<typeof useUpdateMoldRepairQuoteMutation>;
export type UpdateMoldRepairQuoteMutationResult = Apollo.MutationResult<UpdateMoldRepairQuoteMutation>;
export type UpdateMoldRepairQuoteMutationOptions = Apollo.BaseMutationOptions<UpdateMoldRepairQuoteMutation, UpdateMoldRepairQuoteMutationVariables>;
export const ReleaseDfmReportsDocument = gql`
    mutation releaseDfmReports($quoteId: UUID!, $orderId: String, $skipDfmEmail: Boolean, $emailInput: QuoteReadyEmailInput) {
  releaseDfmReports(
    quoteId: $quoteId
    orderId: $orderId
    skipDfmEmail: $skipDfmEmail
    emailInput: $emailInput
  ) {
    id
  }
}
    `;
export type ReleaseDfmReportsMutationFn = Apollo.MutationFunction<ReleaseDfmReportsMutation, ReleaseDfmReportsMutationVariables>;

/**
 * __useReleaseDfmReportsMutation__
 *
 * To run a mutation, you first call `useReleaseDfmReportsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleaseDfmReportsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releaseDfmReportsMutation, { data, loading, error }] = useReleaseDfmReportsMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      orderId: // value for 'orderId'
 *      skipDfmEmail: // value for 'skipDfmEmail'
 *      emailInput: // value for 'emailInput'
 *   },
 * });
 */
export function useReleaseDfmReportsMutation(baseOptions?: Apollo.MutationHookOptions<ReleaseDfmReportsMutation, ReleaseDfmReportsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReleaseDfmReportsMutation, ReleaseDfmReportsMutationVariables>(ReleaseDfmReportsDocument, options);
      }
export type ReleaseDfmReportsMutationHookResult = ReturnType<typeof useReleaseDfmReportsMutation>;
export type ReleaseDfmReportsMutationResult = Apollo.MutationResult<ReleaseDfmReportsMutation>;
export type ReleaseDfmReportsMutationOptions = Apollo.BaseMutationOptions<ReleaseDfmReportsMutation, ReleaseDfmReportsMutationVariables>;
export const PublishDfmAndInspectionDataForQuoteDocument = gql`
    mutation publishDfmAndInspectionDataForQuote($quoteId: UUID!, $skipEmails: Boolean, $emailInput: QuoteReadyEmailInput) {
  publishDfmAndInspectionDataForQuote(
    quoteId: $quoteId
    skipEmails: $skipEmails
    emailInput: $emailInput
  ) {
    id
    name
    status
    user {
      id
      email
      displayName
    }
    quoteModels {
      totalCount
      items {
        id
        selectedQuoteModelRevision {
          id
          version
          state
          partRevision {
            id
            thumbnailUri
            downloadUri
            status
            modelFileName
            boundingBox {
              x
              y
              z
            }
            analysisErrorCode
          }
          attachmentLink {
            id
            quoteAttachmentRevision {
              id
              attachment {
                ...adminAttachment
              }
            }
          }
          fileName
          createdAt
          updatedAt
          annotations {
            id
          }
          modelConfiguration {
            ...adminQuoteDetailsModelConfiguration
          }
        }
      }
    }
    quoteAttachments {
      totalCount
      items {
        id
        latestAttachmentRevision {
          id
          attachment {
            ... on Attachment {
              id
              fileName
              downloadUrl
            }
          }
        }
      }
    }
  }
}
    ${AdminAttachmentFragmentDoc}
${AdminQuoteDetailsModelConfigurationFragmentDoc}`;
export type PublishDfmAndInspectionDataForQuoteMutationFn = Apollo.MutationFunction<PublishDfmAndInspectionDataForQuoteMutation, PublishDfmAndInspectionDataForQuoteMutationVariables>;

/**
 * __usePublishDfmAndInspectionDataForQuoteMutation__
 *
 * To run a mutation, you first call `usePublishDfmAndInspectionDataForQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishDfmAndInspectionDataForQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishDfmAndInspectionDataForQuoteMutation, { data, loading, error }] = usePublishDfmAndInspectionDataForQuoteMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      skipEmails: // value for 'skipEmails'
 *      emailInput: // value for 'emailInput'
 *   },
 * });
 */
export function usePublishDfmAndInspectionDataForQuoteMutation(baseOptions?: Apollo.MutationHookOptions<PublishDfmAndInspectionDataForQuoteMutation, PublishDfmAndInspectionDataForQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishDfmAndInspectionDataForQuoteMutation, PublishDfmAndInspectionDataForQuoteMutationVariables>(PublishDfmAndInspectionDataForQuoteDocument, options);
      }
export type PublishDfmAndInspectionDataForQuoteMutationHookResult = ReturnType<typeof usePublishDfmAndInspectionDataForQuoteMutation>;
export type PublishDfmAndInspectionDataForQuoteMutationResult = Apollo.MutationResult<PublishDfmAndInspectionDataForQuoteMutation>;
export type PublishDfmAndInspectionDataForQuoteMutationOptions = Apollo.BaseMutationOptions<PublishDfmAndInspectionDataForQuoteMutation, PublishDfmAndInspectionDataForQuoteMutationVariables>;
export const UpdateNotesToCustomerMutationDocument = gql`
    mutation updateNotesToCustomerMutation($quoteId: UUID!, $notes: String) {
  updateNotesToCustomer(quoteId: $quoteId, notes: $notes) {
    id
    notesToCustomer
  }
}
    `;
export type UpdateNotesToCustomerMutationMutationFn = Apollo.MutationFunction<UpdateNotesToCustomerMutationMutation, UpdateNotesToCustomerMutationMutationVariables>;

/**
 * __useUpdateNotesToCustomerMutationMutation__
 *
 * To run a mutation, you first call `useUpdateNotesToCustomerMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotesToCustomerMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotesToCustomerMutationMutation, { data, loading, error }] = useUpdateNotesToCustomerMutationMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUpdateNotesToCustomerMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotesToCustomerMutationMutation, UpdateNotesToCustomerMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotesToCustomerMutationMutation, UpdateNotesToCustomerMutationMutationVariables>(UpdateNotesToCustomerMutationDocument, options);
      }
export type UpdateNotesToCustomerMutationMutationHookResult = ReturnType<typeof useUpdateNotesToCustomerMutationMutation>;
export type UpdateNotesToCustomerMutationMutationResult = Apollo.MutationResult<UpdateNotesToCustomerMutationMutation>;
export type UpdateNotesToCustomerMutationMutationOptions = Apollo.BaseMutationOptions<UpdateNotesToCustomerMutationMutation, UpdateNotesToCustomerMutationMutationVariables>;
export const UpdateSalesRepContactInfoMutationDocument = gql`
    mutation updateSalesRepContactInfoMutation($quoteId: UUID!, $email: String) {
  upsertQuoteSalesRep(quoteId: $quoteId, salesRepEmail: $email) {
    id
    salesRep {
      id
      email
      phoneNumber
      displayName
    }
  }
}
    `;
export type UpdateSalesRepContactInfoMutationMutationFn = Apollo.MutationFunction<UpdateSalesRepContactInfoMutationMutation, UpdateSalesRepContactInfoMutationMutationVariables>;

/**
 * __useUpdateSalesRepContactInfoMutationMutation__
 *
 * To run a mutation, you first call `useUpdateSalesRepContactInfoMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSalesRepContactInfoMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSalesRepContactInfoMutationMutation, { data, loading, error }] = useUpdateSalesRepContactInfoMutationMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUpdateSalesRepContactInfoMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSalesRepContactInfoMutationMutation, UpdateSalesRepContactInfoMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSalesRepContactInfoMutationMutation, UpdateSalesRepContactInfoMutationMutationVariables>(UpdateSalesRepContactInfoMutationDocument, options);
      }
export type UpdateSalesRepContactInfoMutationMutationHookResult = ReturnType<typeof useUpdateSalesRepContactInfoMutationMutation>;
export type UpdateSalesRepContactInfoMutationMutationResult = Apollo.MutationResult<UpdateSalesRepContactInfoMutationMutation>;
export type UpdateSalesRepContactInfoMutationMutationOptions = Apollo.BaseMutationOptions<UpdateSalesRepContactInfoMutationMutation, UpdateSalesRepContactInfoMutationMutationVariables>;
export const CreateMoldToolByQmrIdDocument = gql`
    mutation createMoldToolByQmrId($qmrId: UUID!, $isImMaafcoEnabled: Boolean!) {
  createMoldTool(qmrId: $qmrId) {
    id
    moldToolRevision @include(if: $isImMaafcoEnabled) {
      id
      processId
    }
  }
}
    `;
export type CreateMoldToolByQmrIdMutationFn = Apollo.MutationFunction<CreateMoldToolByQmrIdMutation, CreateMoldToolByQmrIdMutationVariables>;

/**
 * __useCreateMoldToolByQmrIdMutation__
 *
 * To run a mutation, you first call `useCreateMoldToolByQmrIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMoldToolByQmrIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMoldToolByQmrIdMutation, { data, loading, error }] = useCreateMoldToolByQmrIdMutation({
 *   variables: {
 *      qmrId: // value for 'qmrId'
 *      isImMaafcoEnabled: // value for 'isImMaafcoEnabled'
 *   },
 * });
 */
export function useCreateMoldToolByQmrIdMutation(baseOptions?: Apollo.MutationHookOptions<CreateMoldToolByQmrIdMutation, CreateMoldToolByQmrIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMoldToolByQmrIdMutation, CreateMoldToolByQmrIdMutationVariables>(CreateMoldToolByQmrIdDocument, options);
      }
export type CreateMoldToolByQmrIdMutationHookResult = ReturnType<typeof useCreateMoldToolByQmrIdMutation>;
export type CreateMoldToolByQmrIdMutationResult = Apollo.MutationResult<CreateMoldToolByQmrIdMutation>;
export type CreateMoldToolByQmrIdMutationOptions = Apollo.BaseMutationOptions<CreateMoldToolByQmrIdMutation, CreateMoldToolByQmrIdMutationVariables>;
export const CreateQuoteDetailCsvFileDocument = gql`
    mutation createQuoteDetailCSVFile($quoteId: UUID!, $fileName: String!) {
  createQuoteDetailCSVFile(quoteId: $quoteId, fileName: $fileName)
}
    `;
export type CreateQuoteDetailCsvFileMutationFn = Apollo.MutationFunction<CreateQuoteDetailCsvFileMutation, CreateQuoteDetailCsvFileMutationVariables>;

/**
 * __useCreateQuoteDetailCsvFileMutation__
 *
 * To run a mutation, you first call `useCreateQuoteDetailCsvFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuoteDetailCsvFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuoteDetailCsvFileMutation, { data, loading, error }] = useCreateQuoteDetailCsvFileMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useCreateQuoteDetailCsvFileMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuoteDetailCsvFileMutation, CreateQuoteDetailCsvFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuoteDetailCsvFileMutation, CreateQuoteDetailCsvFileMutationVariables>(CreateQuoteDetailCsvFileDocument, options);
      }
export type CreateQuoteDetailCsvFileMutationHookResult = ReturnType<typeof useCreateQuoteDetailCsvFileMutation>;
export type CreateQuoteDetailCsvFileMutationResult = Apollo.MutationResult<CreateQuoteDetailCsvFileMutation>;
export type CreateQuoteDetailCsvFileMutationOptions = Apollo.BaseMutationOptions<CreateQuoteDetailCsvFileMutation, CreateQuoteDetailCsvFileMutationVariables>;
export const OverrideDfmInspectionPartPricingAndLeadtimeDocument = gql`
    mutation overrideDfmInspectionPartPricingAndLeadtime($modelConfigurationDfmInspectionId: UUID!, $pricingLeadTimeInput: OverridePartPricingLeadtimeInput!) {
  overrideDfmInspectionPartPricingAndLeadtime(
    modelConfigurationDfmInspectionId: $modelConfigurationDfmInspectionId
    pricingLeadTimeInput: $pricingLeadTimeInput
  ) {
    manualOverrideMpUnitPayout
  }
}
    `;
export type OverrideDfmInspectionPartPricingAndLeadtimeMutationFn = Apollo.MutationFunction<OverrideDfmInspectionPartPricingAndLeadtimeMutation, OverrideDfmInspectionPartPricingAndLeadtimeMutationVariables>;

/**
 * __useOverrideDfmInspectionPartPricingAndLeadtimeMutation__
 *
 * To run a mutation, you first call `useOverrideDfmInspectionPartPricingAndLeadtimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverrideDfmInspectionPartPricingAndLeadtimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overrideDfmInspectionPartPricingAndLeadtimeMutation, { data, loading, error }] = useOverrideDfmInspectionPartPricingAndLeadtimeMutation({
 *   variables: {
 *      modelConfigurationDfmInspectionId: // value for 'modelConfigurationDfmInspectionId'
 *      pricingLeadTimeInput: // value for 'pricingLeadTimeInput'
 *   },
 * });
 */
export function useOverrideDfmInspectionPartPricingAndLeadtimeMutation(baseOptions?: Apollo.MutationHookOptions<OverrideDfmInspectionPartPricingAndLeadtimeMutation, OverrideDfmInspectionPartPricingAndLeadtimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OverrideDfmInspectionPartPricingAndLeadtimeMutation, OverrideDfmInspectionPartPricingAndLeadtimeMutationVariables>(OverrideDfmInspectionPartPricingAndLeadtimeDocument, options);
      }
export type OverrideDfmInspectionPartPricingAndLeadtimeMutationHookResult = ReturnType<typeof useOverrideDfmInspectionPartPricingAndLeadtimeMutation>;
export type OverrideDfmInspectionPartPricingAndLeadtimeMutationResult = Apollo.MutationResult<OverrideDfmInspectionPartPricingAndLeadtimeMutation>;
export type OverrideDfmInspectionPartPricingAndLeadtimeMutationOptions = Apollo.BaseMutationOptions<OverrideDfmInspectionPartPricingAndLeadtimeMutation, OverrideDfmInspectionPartPricingAndLeadtimeMutationVariables>;
export const CreateErpMoldToolModelConfigurationDfmAssociationDocument = gql`
    mutation CreateErpMoldToolModelConfigurationDfmAssociation($erpMoldId: String!, $modelConfigurationDfmInspectionId: UUID!) {
  createErpMoldToolModelConfigurationDfmAssociation(
    erpMoldId: $erpMoldId
    modelConfigurationDfmInspectionId: $modelConfigurationDfmInspectionId
  ) {
    id
  }
}
    `;
export type CreateErpMoldToolModelConfigurationDfmAssociationMutationFn = Apollo.MutationFunction<CreateErpMoldToolModelConfigurationDfmAssociationMutation, CreateErpMoldToolModelConfigurationDfmAssociationMutationVariables>;

/**
 * __useCreateErpMoldToolModelConfigurationDfmAssociationMutation__
 *
 * To run a mutation, you first call `useCreateErpMoldToolModelConfigurationDfmAssociationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateErpMoldToolModelConfigurationDfmAssociationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createErpMoldToolModelConfigurationDfmAssociationMutation, { data, loading, error }] = useCreateErpMoldToolModelConfigurationDfmAssociationMutation({
 *   variables: {
 *      erpMoldId: // value for 'erpMoldId'
 *      modelConfigurationDfmInspectionId: // value for 'modelConfigurationDfmInspectionId'
 *   },
 * });
 */
export function useCreateErpMoldToolModelConfigurationDfmAssociationMutation(baseOptions?: Apollo.MutationHookOptions<CreateErpMoldToolModelConfigurationDfmAssociationMutation, CreateErpMoldToolModelConfigurationDfmAssociationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateErpMoldToolModelConfigurationDfmAssociationMutation, CreateErpMoldToolModelConfigurationDfmAssociationMutationVariables>(CreateErpMoldToolModelConfigurationDfmAssociationDocument, options);
      }
export type CreateErpMoldToolModelConfigurationDfmAssociationMutationHookResult = ReturnType<typeof useCreateErpMoldToolModelConfigurationDfmAssociationMutation>;
export type CreateErpMoldToolModelConfigurationDfmAssociationMutationResult = Apollo.MutationResult<CreateErpMoldToolModelConfigurationDfmAssociationMutation>;
export type CreateErpMoldToolModelConfigurationDfmAssociationMutationOptions = Apollo.BaseMutationOptions<CreateErpMoldToolModelConfigurationDfmAssociationMutation, CreateErpMoldToolModelConfigurationDfmAssociationMutationVariables>;
export const DeleteErpMoldToolAssciationIdDocument = gql`
    mutation deleteErpMoldToolAssciationId($modelConfigurationDfmInspectionId: UUID!) {
  destroyERPMoldToolAssociation(
    modelConfigurationDfmInspectionId: $modelConfigurationDfmInspectionId
  ) {
    deletedAt
  }
}
    `;
export type DeleteErpMoldToolAssciationIdMutationFn = Apollo.MutationFunction<DeleteErpMoldToolAssciationIdMutation, DeleteErpMoldToolAssciationIdMutationVariables>;

/**
 * __useDeleteErpMoldToolAssciationIdMutation__
 *
 * To run a mutation, you first call `useDeleteErpMoldToolAssciationIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteErpMoldToolAssciationIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteErpMoldToolAssciationIdMutation, { data, loading, error }] = useDeleteErpMoldToolAssciationIdMutation({
 *   variables: {
 *      modelConfigurationDfmInspectionId: // value for 'modelConfigurationDfmInspectionId'
 *   },
 * });
 */
export function useDeleteErpMoldToolAssciationIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteErpMoldToolAssciationIdMutation, DeleteErpMoldToolAssciationIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteErpMoldToolAssciationIdMutation, DeleteErpMoldToolAssciationIdMutationVariables>(DeleteErpMoldToolAssciationIdDocument, options);
      }
export type DeleteErpMoldToolAssciationIdMutationHookResult = ReturnType<typeof useDeleteErpMoldToolAssciationIdMutation>;
export type DeleteErpMoldToolAssciationIdMutationResult = Apollo.MutationResult<DeleteErpMoldToolAssciationIdMutation>;
export type DeleteErpMoldToolAssciationIdMutationOptions = Apollo.BaseMutationOptions<DeleteErpMoldToolAssciationIdMutation, DeleteErpMoldToolAssciationIdMutationVariables>;
export const AdminQuoteDetailsQueryDocument = gql`
    query adminQuoteDetailsQuery($id: UUID!, $showDeleted: Boolean, $includeUnpublishedParts: Boolean, $isImMaafcoEnabled: Boolean = false, $isCpqFlagV2Enabled: Boolean = false) {
  quote(id: $id, showDeleted: $showDeleted) {
    hasITARRestrictions
    isEligibleForFreeShipping
    id
    name
    type
    status
    summaryStatus
    orderName
    slowestShipDateEstimate
    isOverseasShipping
    lastModified
    subTotalInCents(includeUnpublishedParts: $includeUnpublishedParts)
    isQuotePurchasable
    isQuotePublishable
    isQuoteIMReorder @include(if: $isImMaafcoEnabled)
    isMoldRepair
    isLocked
    isCpqOwned
    rfqNotes
    notesToCustomer
    contactPhoneNumber
    isFlexiblePriceQuote
    isCpqQuote @include(if: $isCpqFlagV2Enabled)
    sfdcUrl @include(if: $isCpqFlagV2Enabled)
    cpqQuote @include(if: $isCpqFlagV2Enabled) {
      sfdcId
      platformQuote {
        id
      }
      quotePdfUrl
      orderTotal
      partsCount
      moldCount
      orderQuantity
    }
    businessAccountDiscount {
      id
      percent
    }
    dfmAssets {
      totalCount
      items {
        id
        fileName
        downloadUrl
      }
    }
    user {
      id
      email
      displayName
    }
    salesRep {
      id
      email
      phoneNumber
      displayName
    }
    activity {
      items {
        id
        activityType
        updatedAt
        actor {
          email
        }
      }
    }
    sourceQuoteId
    sourceQuoteName
    reorderSourceOrderName
    quoteModels(limit: 1000, showDeleted: $showDeleted) {
      totalCount
      items {
        id
        deletedAt
        selectedQuoteModelRevision {
          isITARProhibitedViewing
          id
          version
          flags
          dfmReports {
            asset {
              id
              createdAt
              downloadUrl
              fileName
            }
            isPublished
          }
          partRevision {
            id
            thumbnailUri
            downloadUri
            status
            modelFileName
            boundingBox {
              x
              y
              z
            }
            analysisErrorCode
          }
          erpMoldTool {
            id
            erpMoldId
          }
          attachmentLink {
            id
            createdAt
            isPdfOcrAutoQuotable
            quoteAttachmentRevision {
              id
              attachment {
                ...adminAttachment
              }
            }
          }
          fileName
          createdAt
          updatedAt
          quoteModel {
            id
            quote {
              id
              type
            }
          }
          annotations {
            id
          }
          dfmFeedback(includeDraft: true) {
            id
            severity
            isPublished
          }
          processesDetails {
            isBusinessAccountDiscountApplied
            postProcesses {
              postProcess {
                id
                name
              }
              postProcessThickness {
                id
                name
              }
              postProcessColor {
                id
                name
              }
              postProcessNumParts
              postProcessInspectionCriteria
            }
            secondaryProcesses {
              process {
                id
                name
              }
            }
            totalPrice {
              ... on ExactPrice {
                unitPriceInCents
                priceInCents
              }
              ... on EstimatedPrice {
                lowPriceInCents
                lowUnitPriceInCents
                highPriceInCents
                highUnitPriceInCents
              }
            }
          }
          modelConfiguration {
            ...adminQuoteDetailsModelConfiguration
          }
          taps {
            id
          }
          holes {
            id
            tapAnnotation {
              id
            }
            tapOptions {
              id
            }
          }
          state
          drawingRequirements
          mold {
            id
            name @include(if: $isImMaafcoEnabled)
            customerToolName @include(if: $isImMaafcoEnabled)
            gateType
            leadTimeDays
            inspectionData
            manualOverrideMpUnitPayout
            manualOverrideUnitAmount
            moldToolRevision @include(if: $isImMaafcoEnabled) {
              id
              version
              processId
            }
            quoteModelRevisions @include(if: $isImMaafcoEnabled) {
              fileName
              id
              version
            }
            moldToolRevisionQmr @include(if: $isImMaafcoEnabled) {
              id
              moldToolRevisionId
              quoteModelRevisionId
              cavityPerPart
            }
            material {
              id
              name
            }
            price {
              priceInCents
            }
            toolLife
            uiIndex
          }
        }
      }
    }
    quoteAttachments(limit: 1000, showDeleted: $showDeleted) {
      totalCount
      items {
        id
        latestAttachmentRevision {
          id
          attachment {
            ... on Attachment {
              id
              fileName
              downloadUrl
            }
          }
        }
      }
    }
    quoteProperties {
      name
      value
    }
  }
}
    ${AdminAttachmentFragmentDoc}
${AdminQuoteDetailsModelConfigurationFragmentDoc}`;

/**
 * __useAdminQuoteDetailsQueryQuery__
 *
 * To run a query within a React component, call `useAdminQuoteDetailsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminQuoteDetailsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminQuoteDetailsQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      showDeleted: // value for 'showDeleted'
 *      includeUnpublishedParts: // value for 'includeUnpublishedParts'
 *      isImMaafcoEnabled: // value for 'isImMaafcoEnabled'
 *      isCpqFlagV2Enabled: // value for 'isCpqFlagV2Enabled'
 *   },
 * });
 */
export function useAdminQuoteDetailsQueryQuery(baseOptions: Apollo.QueryHookOptions<AdminQuoteDetailsQueryQuery, AdminQuoteDetailsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminQuoteDetailsQueryQuery, AdminQuoteDetailsQueryQueryVariables>(AdminQuoteDetailsQueryDocument, options);
      }
export function useAdminQuoteDetailsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminQuoteDetailsQueryQuery, AdminQuoteDetailsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminQuoteDetailsQueryQuery, AdminQuoteDetailsQueryQueryVariables>(AdminQuoteDetailsQueryDocument, options);
        }
export type AdminQuoteDetailsQueryQueryHookResult = ReturnType<typeof useAdminQuoteDetailsQueryQuery>;
export type AdminQuoteDetailsQueryLazyQueryHookResult = ReturnType<typeof useAdminQuoteDetailsQueryLazyQuery>;
export type AdminQuoteDetailsQueryQueryResult = Apollo.QueryResult<AdminQuoteDetailsQueryQuery, AdminQuoteDetailsQueryQueryVariables>;
export function refetchAdminQuoteDetailsQueryQuery(variables: AdminQuoteDetailsQueryQueryVariables) {
      return { query: AdminQuoteDetailsQueryDocument, variables: variables }
    }
export const AdminQuoteDetailsPageOrderQueryDocument = gql`
    query adminQuoteDetailsPageOrderQuery($name: String!) {
  salesOrder(name: $name) {
    id
    deliveryStatus
    shippedBy
  }
}
    `;

/**
 * __useAdminQuoteDetailsPageOrderQueryQuery__
 *
 * To run a query within a React component, call `useAdminQuoteDetailsPageOrderQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminQuoteDetailsPageOrderQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminQuoteDetailsPageOrderQueryQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAdminQuoteDetailsPageOrderQueryQuery(baseOptions: Apollo.QueryHookOptions<AdminQuoteDetailsPageOrderQueryQuery, AdminQuoteDetailsPageOrderQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminQuoteDetailsPageOrderQueryQuery, AdminQuoteDetailsPageOrderQueryQueryVariables>(AdminQuoteDetailsPageOrderQueryDocument, options);
      }
export function useAdminQuoteDetailsPageOrderQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminQuoteDetailsPageOrderQueryQuery, AdminQuoteDetailsPageOrderQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminQuoteDetailsPageOrderQueryQuery, AdminQuoteDetailsPageOrderQueryQueryVariables>(AdminQuoteDetailsPageOrderQueryDocument, options);
        }
export type AdminQuoteDetailsPageOrderQueryQueryHookResult = ReturnType<typeof useAdminQuoteDetailsPageOrderQueryQuery>;
export type AdminQuoteDetailsPageOrderQueryLazyQueryHookResult = ReturnType<typeof useAdminQuoteDetailsPageOrderQueryLazyQuery>;
export type AdminQuoteDetailsPageOrderQueryQueryResult = Apollo.QueryResult<AdminQuoteDetailsPageOrderQueryQuery, AdminQuoteDetailsPageOrderQueryQueryVariables>;
export function refetchAdminQuoteDetailsPageOrderQueryQuery(variables: AdminQuoteDetailsPageOrderQueryQueryVariables) {
      return { query: AdminQuoteDetailsPageOrderQueryDocument, variables: variables }
    }
export const DeleteQuoteMoldDocument = gql`
    mutation deleteQuoteMold($moldId: UUID!) {
  deleteQuoteMold(moldId: $moldId) {
    id
    name
  }
}
    `;
export type DeleteQuoteMoldMutationFn = Apollo.MutationFunction<DeleteQuoteMoldMutation, DeleteQuoteMoldMutationVariables>;

/**
 * __useDeleteQuoteMoldMutation__
 *
 * To run a mutation, you first call `useDeleteQuoteMoldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuoteMoldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuoteMoldMutation, { data, loading, error }] = useDeleteQuoteMoldMutation({
 *   variables: {
 *      moldId: // value for 'moldId'
 *   },
 * });
 */
export function useDeleteQuoteMoldMutation(baseOptions?: Apollo.MutationHookOptions<DeleteQuoteMoldMutation, DeleteQuoteMoldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteQuoteMoldMutation, DeleteQuoteMoldMutationVariables>(DeleteQuoteMoldDocument, options);
      }
export type DeleteQuoteMoldMutationHookResult = ReturnType<typeof useDeleteQuoteMoldMutation>;
export type DeleteQuoteMoldMutationResult = Apollo.MutationResult<DeleteQuoteMoldMutation>;
export type DeleteQuoteMoldMutationOptions = Apollo.BaseMutationOptions<DeleteQuoteMoldMutation, DeleteQuoteMoldMutationVariables>;
export const ListErpMoldsForQuoteOwnerDocument = gql`
    query listErpMoldsForQuoteOwner($quoteId: UUID!, $isImMaafcoEnabled: Boolean = false) {
  listErpMoldsForQuoteOwner(quoteId: $quoteId) {
    id
    erpMoldId
    platformMoldToolRevisionId @include(if: $isImMaafcoEnabled)
    processId
  }
}
    `;

/**
 * __useListErpMoldsForQuoteOwnerQuery__
 *
 * To run a query within a React component, call `useListErpMoldsForQuoteOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useListErpMoldsForQuoteOwnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListErpMoldsForQuoteOwnerQuery({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      isImMaafcoEnabled: // value for 'isImMaafcoEnabled'
 *   },
 * });
 */
export function useListErpMoldsForQuoteOwnerQuery(baseOptions: Apollo.QueryHookOptions<ListErpMoldsForQuoteOwnerQuery, ListErpMoldsForQuoteOwnerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListErpMoldsForQuoteOwnerQuery, ListErpMoldsForQuoteOwnerQueryVariables>(ListErpMoldsForQuoteOwnerDocument, options);
      }
export function useListErpMoldsForQuoteOwnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListErpMoldsForQuoteOwnerQuery, ListErpMoldsForQuoteOwnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListErpMoldsForQuoteOwnerQuery, ListErpMoldsForQuoteOwnerQueryVariables>(ListErpMoldsForQuoteOwnerDocument, options);
        }
export type ListErpMoldsForQuoteOwnerQueryHookResult = ReturnType<typeof useListErpMoldsForQuoteOwnerQuery>;
export type ListErpMoldsForQuoteOwnerLazyQueryHookResult = ReturnType<typeof useListErpMoldsForQuoteOwnerLazyQuery>;
export type ListErpMoldsForQuoteOwnerQueryResult = Apollo.QueryResult<ListErpMoldsForQuoteOwnerQuery, ListErpMoldsForQuoteOwnerQueryVariables>;
export function refetchListErpMoldsForQuoteOwnerQuery(variables: ListErpMoldsForQuoteOwnerQueryVariables) {
      return { query: ListErpMoldsForQuoteOwnerDocument, variables: variables }
    }
export const GetToolAndPartEstimatedPricesDocument = gql`
    query getToolAndPartEstimatedPrices($qmrIds: [String!]!) {
  getToolAndPartEstimatedPrices(qmrIds: $qmrIds) {
    qmrId
    partPrice {
      lowUnitPriceInCents
      highUnitPriceInCents
    }
    toolingPrice {
      lowUnitPriceInCents
      highUnitPriceInCents
    }
  }
}
    `;

/**
 * __useGetToolAndPartEstimatedPricesQuery__
 *
 * To run a query within a React component, call `useGetToolAndPartEstimatedPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetToolAndPartEstimatedPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetToolAndPartEstimatedPricesQuery({
 *   variables: {
 *      qmrIds: // value for 'qmrIds'
 *   },
 * });
 */
export function useGetToolAndPartEstimatedPricesQuery(baseOptions: Apollo.QueryHookOptions<GetToolAndPartEstimatedPricesQuery, GetToolAndPartEstimatedPricesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetToolAndPartEstimatedPricesQuery, GetToolAndPartEstimatedPricesQueryVariables>(GetToolAndPartEstimatedPricesDocument, options);
      }
export function useGetToolAndPartEstimatedPricesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetToolAndPartEstimatedPricesQuery, GetToolAndPartEstimatedPricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetToolAndPartEstimatedPricesQuery, GetToolAndPartEstimatedPricesQueryVariables>(GetToolAndPartEstimatedPricesDocument, options);
        }
export type GetToolAndPartEstimatedPricesQueryHookResult = ReturnType<typeof useGetToolAndPartEstimatedPricesQuery>;
export type GetToolAndPartEstimatedPricesLazyQueryHookResult = ReturnType<typeof useGetToolAndPartEstimatedPricesLazyQuery>;
export type GetToolAndPartEstimatedPricesQueryResult = Apollo.QueryResult<GetToolAndPartEstimatedPricesQuery, GetToolAndPartEstimatedPricesQueryVariables>;
export function refetchGetToolAndPartEstimatedPricesQuery(variables: GetToolAndPartEstimatedPricesQueryVariables) {
      return { query: GetToolAndPartEstimatedPricesDocument, variables: variables }
    }
export const QuoteModelRevisionDocument = gql`
    query QuoteModelRevision($quoteModelRevisionId: UUID!) {
  quoteModelRevision(id: $quoteModelRevisionId) {
    id
    erpMoldTool {
      id
      erpMoldId
    }
  }
}
    `;

/**
 * __useQuoteModelRevisionQuery__
 *
 * To run a query within a React component, call `useQuoteModelRevisionQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteModelRevisionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteModelRevisionQuery({
 *   variables: {
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *   },
 * });
 */
export function useQuoteModelRevisionQuery(baseOptions: Apollo.QueryHookOptions<QuoteModelRevisionQuery, QuoteModelRevisionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteModelRevisionQuery, QuoteModelRevisionQueryVariables>(QuoteModelRevisionDocument, options);
      }
export function useQuoteModelRevisionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteModelRevisionQuery, QuoteModelRevisionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteModelRevisionQuery, QuoteModelRevisionQueryVariables>(QuoteModelRevisionDocument, options);
        }
export type QuoteModelRevisionQueryHookResult = ReturnType<typeof useQuoteModelRevisionQuery>;
export type QuoteModelRevisionLazyQueryHookResult = ReturnType<typeof useQuoteModelRevisionLazyQuery>;
export type QuoteModelRevisionQueryResult = Apollo.QueryResult<QuoteModelRevisionQuery, QuoteModelRevisionQueryVariables>;
export function refetchQuoteModelRevisionQuery(variables: QuoteModelRevisionQueryVariables) {
      return { query: QuoteModelRevisionDocument, variables: variables }
    }
export const GetMoldbyMtrDocument = gql`
    query getMoldbyMtr($moldToolRevisionId: [UUID!], $quoteId: UUID!) {
  getMoldToolRevision(moldToolRevisionId: $moldToolRevisionId, quoteId: $quoteId) {
    id
    name
    leadTimeDays
    toolLife
    gateType
    inspectionData
    manualOverrideMpUnitPayout
    manualOverrideUnitAmount
    material {
      id
      materialCategory
      name
      processTechnologyId
      processTechnologyName
    }
    ownerId
    price {
      priceInCents
    }
    moldToolRevision {
      id
      version
      processId
    }
    quoteModelRevisions {
      id
      fileName
      version
      partRevision {
        thumbnailUri
      }
    }
    moldToolRevisionQmr {
      id
      cavityPerPart
      quoteModelRevisionId
      moldToolRevisionId
    }
    uiIndex
  }
}
    `;

/**
 * __useGetMoldbyMtrQuery__
 *
 * To run a query within a React component, call `useGetMoldbyMtrQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMoldbyMtrQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMoldbyMtrQuery({
 *   variables: {
 *      moldToolRevisionId: // value for 'moldToolRevisionId'
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useGetMoldbyMtrQuery(baseOptions: Apollo.QueryHookOptions<GetMoldbyMtrQuery, GetMoldbyMtrQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMoldbyMtrQuery, GetMoldbyMtrQueryVariables>(GetMoldbyMtrDocument, options);
      }
export function useGetMoldbyMtrLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMoldbyMtrQuery, GetMoldbyMtrQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMoldbyMtrQuery, GetMoldbyMtrQueryVariables>(GetMoldbyMtrDocument, options);
        }
export type GetMoldbyMtrQueryHookResult = ReturnType<typeof useGetMoldbyMtrQuery>;
export type GetMoldbyMtrLazyQueryHookResult = ReturnType<typeof useGetMoldbyMtrLazyQuery>;
export type GetMoldbyMtrQueryResult = Apollo.QueryResult<GetMoldbyMtrQuery, GetMoldbyMtrQueryVariables>;
export function refetchGetMoldbyMtrQuery(variables: GetMoldbyMtrQueryVariables) {
      return { query: GetMoldbyMtrDocument, variables: variables }
    }
export const SetQuotePropertyDocument = gql`
    mutation setQuoteProperty($quoteId: UUID!, $name: String!, $value: String!) {
  setQuoteProperty(quoteId: $quoteId, name: $name, value: $value) {
    name
  }
}
    `;
export type SetQuotePropertyMutationFn = Apollo.MutationFunction<SetQuotePropertyMutation, SetQuotePropertyMutationVariables>;

/**
 * __useSetQuotePropertyMutation__
 *
 * To run a mutation, you first call `useSetQuotePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetQuotePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setQuotePropertyMutation, { data, loading, error }] = useSetQuotePropertyMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      name: // value for 'name'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useSetQuotePropertyMutation(baseOptions?: Apollo.MutationHookOptions<SetQuotePropertyMutation, SetQuotePropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetQuotePropertyMutation, SetQuotePropertyMutationVariables>(SetQuotePropertyDocument, options);
      }
export type SetQuotePropertyMutationHookResult = ReturnType<typeof useSetQuotePropertyMutation>;
export type SetQuotePropertyMutationResult = Apollo.MutationResult<SetQuotePropertyMutation>;
export type SetQuotePropertyMutationOptions = Apollo.BaseMutationOptions<SetQuotePropertyMutation, SetQuotePropertyMutationVariables>;
export const DeleteQuotePropertyDocument = gql`
    mutation deleteQuoteProperty($quoteId: UUID!, $name: String!) {
  deleteQuoteProperty(quoteId: $quoteId, name: $name) {
    name
  }
}
    `;
export type DeleteQuotePropertyMutationFn = Apollo.MutationFunction<DeleteQuotePropertyMutation, DeleteQuotePropertyMutationVariables>;

/**
 * __useDeleteQuotePropertyMutation__
 *
 * To run a mutation, you first call `useDeleteQuotePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuotePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuotePropertyMutation, { data, loading, error }] = useDeleteQuotePropertyMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteQuotePropertyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteQuotePropertyMutation, DeleteQuotePropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteQuotePropertyMutation, DeleteQuotePropertyMutationVariables>(DeleteQuotePropertyDocument, options);
      }
export type DeleteQuotePropertyMutationHookResult = ReturnType<typeof useDeleteQuotePropertyMutation>;
export type DeleteQuotePropertyMutationResult = Apollo.MutationResult<DeleteQuotePropertyMutation>;
export type DeleteQuotePropertyMutationOptions = Apollo.BaseMutationOptions<DeleteQuotePropertyMutation, DeleteQuotePropertyMutationVariables>;
export const UpdateQuoteMutationDocument = gql`
    mutation updateQuoteMutation($quoteId: UUID!, $input: String) {
  updateQuote(id: $quoteId, input: {rfqNotes: $input}) {
    rfqNotes
  }
}
    `;
export type UpdateQuoteMutationMutationFn = Apollo.MutationFunction<UpdateQuoteMutationMutation, UpdateQuoteMutationMutationVariables>;

/**
 * __useUpdateQuoteMutationMutation__
 *
 * To run a mutation, you first call `useUpdateQuoteMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuoteMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuoteMutationMutation, { data, loading, error }] = useUpdateQuoteMutationMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuoteMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuoteMutationMutation, UpdateQuoteMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuoteMutationMutation, UpdateQuoteMutationMutationVariables>(UpdateQuoteMutationDocument, options);
      }
export type UpdateQuoteMutationMutationHookResult = ReturnType<typeof useUpdateQuoteMutationMutation>;
export type UpdateQuoteMutationMutationResult = Apollo.MutationResult<UpdateQuoteMutationMutation>;
export type UpdateQuoteMutationMutationOptions = Apollo.BaseMutationOptions<UpdateQuoteMutationMutation, UpdateQuoteMutationMutationVariables>;
export const UnlockQuoteDocument = gql`
    mutation UnlockQuote($unlockQuoteId: UUID!) {
  unlockQuote(id: $unlockQuoteId) {
    id
    isLocked
  }
}
    `;
export type UnlockQuoteMutationFn = Apollo.MutationFunction<UnlockQuoteMutation, UnlockQuoteMutationVariables>;

/**
 * __useUnlockQuoteMutation__
 *
 * To run a mutation, you first call `useUnlockQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockQuoteMutation, { data, loading, error }] = useUnlockQuoteMutation({
 *   variables: {
 *      unlockQuoteId: // value for 'unlockQuoteId'
 *   },
 * });
 */
export function useUnlockQuoteMutation(baseOptions?: Apollo.MutationHookOptions<UnlockQuoteMutation, UnlockQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlockQuoteMutation, UnlockQuoteMutationVariables>(UnlockQuoteDocument, options);
      }
export type UnlockQuoteMutationHookResult = ReturnType<typeof useUnlockQuoteMutation>;
export type UnlockQuoteMutationResult = Apollo.MutationResult<UnlockQuoteMutation>;
export type UnlockQuoteMutationOptions = Apollo.BaseMutationOptions<UnlockQuoteMutation, UnlockQuoteMutationVariables>;
export const LockQuoteDocument = gql`
    mutation LockQuote($lockQuoteId: UUID!) {
  lockQuote(id: $lockQuoteId) {
    id
    isCpqOwned
    isLocked
  }
}
    `;
export type LockQuoteMutationFn = Apollo.MutationFunction<LockQuoteMutation, LockQuoteMutationVariables>;

/**
 * __useLockQuoteMutation__
 *
 * To run a mutation, you first call `useLockQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLockQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lockQuoteMutation, { data, loading, error }] = useLockQuoteMutation({
 *   variables: {
 *      lockQuoteId: // value for 'lockQuoteId'
 *   },
 * });
 */
export function useLockQuoteMutation(baseOptions?: Apollo.MutationHookOptions<LockQuoteMutation, LockQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LockQuoteMutation, LockQuoteMutationVariables>(LockQuoteDocument, options);
      }
export type LockQuoteMutationHookResult = ReturnType<typeof useLockQuoteMutation>;
export type LockQuoteMutationResult = Apollo.MutationResult<LockQuoteMutation>;
export type LockQuoteMutationOptions = Apollo.BaseMutationOptions<LockQuoteMutation, LockQuoteMutationVariables>;
export const UpdateSlideSortOrderDocument = gql`
    mutation updateSlideSortOrder($dfmFeedbackId: UUID!, $ordinalPos: Int!) {
  updateDfmFeedbackSortOrder(
    dfmFeedbackId: $dfmFeedbackId
    ordinalPos: $ordinalPos
  ) {
    id
  }
}
    `;
export type UpdateSlideSortOrderMutationFn = Apollo.MutationFunction<UpdateSlideSortOrderMutation, UpdateSlideSortOrderMutationVariables>;

/**
 * __useUpdateSlideSortOrderMutation__
 *
 * To run a mutation, you first call `useUpdateSlideSortOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSlideSortOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSlideSortOrderMutation, { data, loading, error }] = useUpdateSlideSortOrderMutation({
 *   variables: {
 *      dfmFeedbackId: // value for 'dfmFeedbackId'
 *      ordinalPos: // value for 'ordinalPos'
 *   },
 * });
 */
export function useUpdateSlideSortOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSlideSortOrderMutation, UpdateSlideSortOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSlideSortOrderMutation, UpdateSlideSortOrderMutationVariables>(UpdateSlideSortOrderDocument, options);
      }
export type UpdateSlideSortOrderMutationHookResult = ReturnType<typeof useUpdateSlideSortOrderMutation>;
export type UpdateSlideSortOrderMutationResult = Apollo.MutationResult<UpdateSlideSortOrderMutation>;
export type UpdateSlideSortOrderMutationOptions = Apollo.BaseMutationOptions<UpdateSlideSortOrderMutation, UpdateSlideSortOrderMutationVariables>;
export const GeneratePdfFor3dDfmDocument = gql`
    mutation generatePdfFor3dDfm($assetId: UUID!, $feedbackId: UUID!) {
  generatePdfFor3dDfm(assetId: $assetId, feedbackId: $feedbackId) {
    error
    feedbackId
    loading
    signedUrl
  }
}
    `;
export type GeneratePdfFor3dDfmMutationFn = Apollo.MutationFunction<GeneratePdfFor3dDfmMutation, GeneratePdfFor3dDfmMutationVariables>;

/**
 * __useGeneratePdfFor3dDfmMutation__
 *
 * To run a mutation, you first call `useGeneratePdfFor3dDfmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePdfFor3dDfmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePdfFor3dDfmMutation, { data, loading, error }] = useGeneratePdfFor3dDfmMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      feedbackId: // value for 'feedbackId'
 *   },
 * });
 */
export function useGeneratePdfFor3dDfmMutation(baseOptions?: Apollo.MutationHookOptions<GeneratePdfFor3dDfmMutation, GeneratePdfFor3dDfmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GeneratePdfFor3dDfmMutation, GeneratePdfFor3dDfmMutationVariables>(GeneratePdfFor3dDfmDocument, options);
      }
export type GeneratePdfFor3dDfmMutationHookResult = ReturnType<typeof useGeneratePdfFor3dDfmMutation>;
export type GeneratePdfFor3dDfmMutationResult = Apollo.MutationResult<GeneratePdfFor3dDfmMutation>;
export type GeneratePdfFor3dDfmMutationOptions = Apollo.BaseMutationOptions<GeneratePdfFor3dDfmMutation, GeneratePdfFor3dDfmMutationVariables>;
export const DfmFeedbackAttachmentDocument = gql`
    query dfmFeedbackAttachment($dfmFeedbackId: UUID!) {
  dfmFeedback(id: $dfmFeedbackId) {
    id
    attachment {
      id
    }
  }
}
    `;

/**
 * __useDfmFeedbackAttachmentQuery__
 *
 * To run a query within a React component, call `useDfmFeedbackAttachmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDfmFeedbackAttachmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDfmFeedbackAttachmentQuery({
 *   variables: {
 *      dfmFeedbackId: // value for 'dfmFeedbackId'
 *   },
 * });
 */
export function useDfmFeedbackAttachmentQuery(baseOptions: Apollo.QueryHookOptions<DfmFeedbackAttachmentQuery, DfmFeedbackAttachmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DfmFeedbackAttachmentQuery, DfmFeedbackAttachmentQueryVariables>(DfmFeedbackAttachmentDocument, options);
      }
export function useDfmFeedbackAttachmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DfmFeedbackAttachmentQuery, DfmFeedbackAttachmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DfmFeedbackAttachmentQuery, DfmFeedbackAttachmentQueryVariables>(DfmFeedbackAttachmentDocument, options);
        }
export type DfmFeedbackAttachmentQueryHookResult = ReturnType<typeof useDfmFeedbackAttachmentQuery>;
export type DfmFeedbackAttachmentLazyQueryHookResult = ReturnType<typeof useDfmFeedbackAttachmentLazyQuery>;
export type DfmFeedbackAttachmentQueryResult = Apollo.QueryResult<DfmFeedbackAttachmentQuery, DfmFeedbackAttachmentQueryVariables>;
export function refetchDfmFeedbackAttachmentQuery(variables: DfmFeedbackAttachmentQueryVariables) {
      return { query: DfmFeedbackAttachmentDocument, variables: variables }
    }
export const DfmStatusesDocument = gql`
    query dfmStatuses($quoteType: QuoteType) {
  dfmStatuses(quoteType: $quoteType)
}
    `;

/**
 * __useDfmStatusesQuery__
 *
 * To run a query within a React component, call `useDfmStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDfmStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDfmStatusesQuery({
 *   variables: {
 *      quoteType: // value for 'quoteType'
 *   },
 * });
 */
export function useDfmStatusesQuery(baseOptions?: Apollo.QueryHookOptions<DfmStatusesQuery, DfmStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DfmStatusesQuery, DfmStatusesQueryVariables>(DfmStatusesDocument, options);
      }
export function useDfmStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DfmStatusesQuery, DfmStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DfmStatusesQuery, DfmStatusesQueryVariables>(DfmStatusesDocument, options);
        }
export type DfmStatusesQueryHookResult = ReturnType<typeof useDfmStatusesQuery>;
export type DfmStatusesLazyQueryHookResult = ReturnType<typeof useDfmStatusesLazyQuery>;
export type DfmStatusesQueryResult = Apollo.QueryResult<DfmStatusesQuery, DfmStatusesQueryVariables>;
export function refetchDfmStatusesQuery(variables?: DfmStatusesQueryVariables) {
      return { query: DfmStatusesDocument, variables: variables }
    }
export const DfmFeedbackTopicsDocument = gql`
    query dfmFeedbackTopics {
  dfmFeedbackTopics {
    id
    label
  }
}
    `;

/**
 * __useDfmFeedbackTopicsQuery__
 *
 * To run a query within a React component, call `useDfmFeedbackTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDfmFeedbackTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDfmFeedbackTopicsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDfmFeedbackTopicsQuery(baseOptions?: Apollo.QueryHookOptions<DfmFeedbackTopicsQuery, DfmFeedbackTopicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DfmFeedbackTopicsQuery, DfmFeedbackTopicsQueryVariables>(DfmFeedbackTopicsDocument, options);
      }
export function useDfmFeedbackTopicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DfmFeedbackTopicsQuery, DfmFeedbackTopicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DfmFeedbackTopicsQuery, DfmFeedbackTopicsQueryVariables>(DfmFeedbackTopicsDocument, options);
        }
export type DfmFeedbackTopicsQueryHookResult = ReturnType<typeof useDfmFeedbackTopicsQuery>;
export type DfmFeedbackTopicsLazyQueryHookResult = ReturnType<typeof useDfmFeedbackTopicsLazyQuery>;
export type DfmFeedbackTopicsQueryResult = Apollo.QueryResult<DfmFeedbackTopicsQuery, DfmFeedbackTopicsQueryVariables>;
export function refetchDfmFeedbackTopicsQuery(variables?: DfmFeedbackTopicsQueryVariables) {
      return { query: DfmFeedbackTopicsDocument, variables: variables }
    }
export const UpdateImDfmFeedbackInfoDocument = gql`
    mutation updateImDfmFeedbackInfo($dfmFeedbackId: UUID!, $topicId: String, $status: String, $title: String) {
  updateDfmFeedbackInfo(
    dfmFeedbackId: $dfmFeedbackId
    topicId: $topicId
    status: $status
    title: $title
  ) {
    id
    status
    topic {
      id
      label
    }
    title
    updatedAt
    updatedBy {
      id
      email
    }
  }
}
    `;
export type UpdateImDfmFeedbackInfoMutationFn = Apollo.MutationFunction<UpdateImDfmFeedbackInfoMutation, UpdateImDfmFeedbackInfoMutationVariables>;

/**
 * __useUpdateImDfmFeedbackInfoMutation__
 *
 * To run a mutation, you first call `useUpdateImDfmFeedbackInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImDfmFeedbackInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImDfmFeedbackInfoMutation, { data, loading, error }] = useUpdateImDfmFeedbackInfoMutation({
 *   variables: {
 *      dfmFeedbackId: // value for 'dfmFeedbackId'
 *      topicId: // value for 'topicId'
 *      status: // value for 'status'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateImDfmFeedbackInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateImDfmFeedbackInfoMutation, UpdateImDfmFeedbackInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateImDfmFeedbackInfoMutation, UpdateImDfmFeedbackInfoMutationVariables>(UpdateImDfmFeedbackInfoDocument, options);
      }
export type UpdateImDfmFeedbackInfoMutationHookResult = ReturnType<typeof useUpdateImDfmFeedbackInfoMutation>;
export type UpdateImDfmFeedbackInfoMutationResult = Apollo.MutationResult<UpdateImDfmFeedbackInfoMutation>;
export type UpdateImDfmFeedbackInfoMutationOptions = Apollo.BaseMutationOptions<UpdateImDfmFeedbackInfoMutation, UpdateImDfmFeedbackInfoMutationVariables>;
export const ImDfmFeedbackUpdateRefetchQueryDocument = gql`
    query imDfmFeedbackUpdateRefetchQuery($id: UUID!) {
  quoteModelRevision(id: $id) {
    dfmFeedback(includeDraft: true) {
      id
    }
  }
}
    `;

/**
 * __useImDfmFeedbackUpdateRefetchQueryQuery__
 *
 * To run a query within a React component, call `useImDfmFeedbackUpdateRefetchQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useImDfmFeedbackUpdateRefetchQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImDfmFeedbackUpdateRefetchQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useImDfmFeedbackUpdateRefetchQueryQuery(baseOptions: Apollo.QueryHookOptions<ImDfmFeedbackUpdateRefetchQueryQuery, ImDfmFeedbackUpdateRefetchQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImDfmFeedbackUpdateRefetchQueryQuery, ImDfmFeedbackUpdateRefetchQueryQueryVariables>(ImDfmFeedbackUpdateRefetchQueryDocument, options);
      }
export function useImDfmFeedbackUpdateRefetchQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImDfmFeedbackUpdateRefetchQueryQuery, ImDfmFeedbackUpdateRefetchQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImDfmFeedbackUpdateRefetchQueryQuery, ImDfmFeedbackUpdateRefetchQueryQueryVariables>(ImDfmFeedbackUpdateRefetchQueryDocument, options);
        }
export type ImDfmFeedbackUpdateRefetchQueryQueryHookResult = ReturnType<typeof useImDfmFeedbackUpdateRefetchQueryQuery>;
export type ImDfmFeedbackUpdateRefetchQueryLazyQueryHookResult = ReturnType<typeof useImDfmFeedbackUpdateRefetchQueryLazyQuery>;
export type ImDfmFeedbackUpdateRefetchQueryQueryResult = Apollo.QueryResult<ImDfmFeedbackUpdateRefetchQueryQuery, ImDfmFeedbackUpdateRefetchQueryQueryVariables>;
export function refetchImDfmFeedbackUpdateRefetchQueryQuery(variables: ImDfmFeedbackUpdateRefetchQueryQueryVariables) {
      return { query: ImDfmFeedbackUpdateRefetchQueryDocument, variables: variables }
    }
export const CreateAssetDocument = gql`
    mutation createAsset($fileName: String!) {
  createAsset(fileName: $fileName) {
    id
    uploadUrl
  }
}
    `;
export type CreateAssetMutationFn = Apollo.MutationFunction<CreateAssetMutation, CreateAssetMutationVariables>;

/**
 * __useCreateAssetMutation__
 *
 * To run a mutation, you first call `useCreateAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssetMutation, { data, loading, error }] = useCreateAssetMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useCreateAssetMutation(baseOptions?: Apollo.MutationHookOptions<CreateAssetMutation, CreateAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAssetMutation, CreateAssetMutationVariables>(CreateAssetDocument, options);
      }
export type CreateAssetMutationHookResult = ReturnType<typeof useCreateAssetMutation>;
export type CreateAssetMutationResult = Apollo.MutationResult<CreateAssetMutation>;
export type CreateAssetMutationOptions = Apollo.BaseMutationOptions<CreateAssetMutation, CreateAssetMutationVariables>;
export const CreateDfmFeedbackWithSnapshotDocument = gql`
    mutation createDfmFeedbackWithSnapshot($modelConfigurationId: UUID!, $dfmInput: DfmFeedbackWithSnapshotInput!) {
  createDfmFeedbackWithSnapshot(
    modelConfigurationId: $modelConfigurationId
    dfmInput: $dfmInput
  ) {
    error
    feedbackId
    loading
    signedUrl
  }
}
    `;
export type CreateDfmFeedbackWithSnapshotMutationFn = Apollo.MutationFunction<CreateDfmFeedbackWithSnapshotMutation, CreateDfmFeedbackWithSnapshotMutationVariables>;

/**
 * __useCreateDfmFeedbackWithSnapshotMutation__
 *
 * To run a mutation, you first call `useCreateDfmFeedbackWithSnapshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDfmFeedbackWithSnapshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDfmFeedbackWithSnapshotMutation, { data, loading, error }] = useCreateDfmFeedbackWithSnapshotMutation({
 *   variables: {
 *      modelConfigurationId: // value for 'modelConfigurationId'
 *      dfmInput: // value for 'dfmInput'
 *   },
 * });
 */
export function useCreateDfmFeedbackWithSnapshotMutation(baseOptions?: Apollo.MutationHookOptions<CreateDfmFeedbackWithSnapshotMutation, CreateDfmFeedbackWithSnapshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDfmFeedbackWithSnapshotMutation, CreateDfmFeedbackWithSnapshotMutationVariables>(CreateDfmFeedbackWithSnapshotDocument, options);
      }
export type CreateDfmFeedbackWithSnapshotMutationHookResult = ReturnType<typeof useCreateDfmFeedbackWithSnapshotMutation>;
export type CreateDfmFeedbackWithSnapshotMutationResult = Apollo.MutationResult<CreateDfmFeedbackWithSnapshotMutation>;
export type CreateDfmFeedbackWithSnapshotMutationOptions = Apollo.BaseMutationOptions<CreateDfmFeedbackWithSnapshotMutation, CreateDfmFeedbackWithSnapshotMutationVariables>;
export const ModelConfigurationIdActiveUnsaved3dSlideDocument = gql`
    query modelConfigurationIdActiveUnsaved3dSlide($qmrId: UUID!, $showDeleted: Boolean) {
  quoteModelRevision(id: $qmrId, showDeleted: $showDeleted) {
    id
    modelConfiguration {
      id
    }
  }
}
    `;

/**
 * __useModelConfigurationIdActiveUnsaved3dSlideQuery__
 *
 * To run a query within a React component, call `useModelConfigurationIdActiveUnsaved3dSlideQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelConfigurationIdActiveUnsaved3dSlideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelConfigurationIdActiveUnsaved3dSlideQuery({
 *   variables: {
 *      qmrId: // value for 'qmrId'
 *      showDeleted: // value for 'showDeleted'
 *   },
 * });
 */
export function useModelConfigurationIdActiveUnsaved3dSlideQuery(baseOptions: Apollo.QueryHookOptions<ModelConfigurationIdActiveUnsaved3dSlideQuery, ModelConfigurationIdActiveUnsaved3dSlideQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelConfigurationIdActiveUnsaved3dSlideQuery, ModelConfigurationIdActiveUnsaved3dSlideQueryVariables>(ModelConfigurationIdActiveUnsaved3dSlideDocument, options);
      }
export function useModelConfigurationIdActiveUnsaved3dSlideLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelConfigurationIdActiveUnsaved3dSlideQuery, ModelConfigurationIdActiveUnsaved3dSlideQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelConfigurationIdActiveUnsaved3dSlideQuery, ModelConfigurationIdActiveUnsaved3dSlideQueryVariables>(ModelConfigurationIdActiveUnsaved3dSlideDocument, options);
        }
export type ModelConfigurationIdActiveUnsaved3dSlideQueryHookResult = ReturnType<typeof useModelConfigurationIdActiveUnsaved3dSlideQuery>;
export type ModelConfigurationIdActiveUnsaved3dSlideLazyQueryHookResult = ReturnType<typeof useModelConfigurationIdActiveUnsaved3dSlideLazyQuery>;
export type ModelConfigurationIdActiveUnsaved3dSlideQueryResult = Apollo.QueryResult<ModelConfigurationIdActiveUnsaved3dSlideQuery, ModelConfigurationIdActiveUnsaved3dSlideQueryVariables>;
export function refetchModelConfigurationIdActiveUnsaved3dSlideQuery(variables: ModelConfigurationIdActiveUnsaved3dSlideQueryVariables) {
      return { query: ModelConfigurationIdActiveUnsaved3dSlideDocument, variables: variables }
    }
export const DfmFeedbackMessagesDocument = gql`
    query dfmFeedbackMessages($platformProcessId: String, $type: DfmFeedbackMessageType, $topicId: UUID) {
  dfmFeedbackMessages(
    platformProcessId: $platformProcessId
    type: $type
    topicId: $topicId
  ) {
    id
    message
    title
  }
}
    `;

/**
 * __useDfmFeedbackMessagesQuery__
 *
 * To run a query within a React component, call `useDfmFeedbackMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDfmFeedbackMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDfmFeedbackMessagesQuery({
 *   variables: {
 *      platformProcessId: // value for 'platformProcessId'
 *      type: // value for 'type'
 *      topicId: // value for 'topicId'
 *   },
 * });
 */
export function useDfmFeedbackMessagesQuery(baseOptions?: Apollo.QueryHookOptions<DfmFeedbackMessagesQuery, DfmFeedbackMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DfmFeedbackMessagesQuery, DfmFeedbackMessagesQueryVariables>(DfmFeedbackMessagesDocument, options);
      }
export function useDfmFeedbackMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DfmFeedbackMessagesQuery, DfmFeedbackMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DfmFeedbackMessagesQuery, DfmFeedbackMessagesQueryVariables>(DfmFeedbackMessagesDocument, options);
        }
export type DfmFeedbackMessagesQueryHookResult = ReturnType<typeof useDfmFeedbackMessagesQuery>;
export type DfmFeedbackMessagesLazyQueryHookResult = ReturnType<typeof useDfmFeedbackMessagesLazyQuery>;
export type DfmFeedbackMessagesQueryResult = Apollo.QueryResult<DfmFeedbackMessagesQuery, DfmFeedbackMessagesQueryVariables>;
export function refetchDfmFeedbackMessagesQuery(variables?: DfmFeedbackMessagesQueryVariables) {
      return { query: DfmFeedbackMessagesDocument, variables: variables }
    }
export const DestroyDfmFeedbackImDfmSlideDocument = gql`
    mutation destroyDfmFeedbackImDfmSlide($dfmFeedbackId: UUID!) {
  destroyDfmFeedback(dfmFeedbackId: $dfmFeedbackId) {
    id
  }
}
    `;
export type DestroyDfmFeedbackImDfmSlideMutationFn = Apollo.MutationFunction<DestroyDfmFeedbackImDfmSlideMutation, DestroyDfmFeedbackImDfmSlideMutationVariables>;

/**
 * __useDestroyDfmFeedbackImDfmSlideMutation__
 *
 * To run a mutation, you first call `useDestroyDfmFeedbackImDfmSlideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyDfmFeedbackImDfmSlideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyDfmFeedbackImDfmSlideMutation, { data, loading, error }] = useDestroyDfmFeedbackImDfmSlideMutation({
 *   variables: {
 *      dfmFeedbackId: // value for 'dfmFeedbackId'
 *   },
 * });
 */
export function useDestroyDfmFeedbackImDfmSlideMutation(baseOptions?: Apollo.MutationHookOptions<DestroyDfmFeedbackImDfmSlideMutation, DestroyDfmFeedbackImDfmSlideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroyDfmFeedbackImDfmSlideMutation, DestroyDfmFeedbackImDfmSlideMutationVariables>(DestroyDfmFeedbackImDfmSlideDocument, options);
      }
export type DestroyDfmFeedbackImDfmSlideMutationHookResult = ReturnType<typeof useDestroyDfmFeedbackImDfmSlideMutation>;
export type DestroyDfmFeedbackImDfmSlideMutationResult = Apollo.MutationResult<DestroyDfmFeedbackImDfmSlideMutation>;
export type DestroyDfmFeedbackImDfmSlideMutationOptions = Apollo.BaseMutationOptions<DestroyDfmFeedbackImDfmSlideMutation, DestroyDfmFeedbackImDfmSlideMutationVariables>;
export const GetAttachmentAnnotationIdsImDfmModalDocument = gql`
    query getAttachmentAnnotationIdsImDfmModal($attachmentId: UUID!, $quoteModelRevisionId: UUID) {
  getQmrAttachmentAnnotations(
    attachmentId: $attachmentId
    quoteModelRevisionId: $quoteModelRevisionId
  ) {
    id
  }
}
    `;

/**
 * __useGetAttachmentAnnotationIdsImDfmModalQuery__
 *
 * To run a query within a React component, call `useGetAttachmentAnnotationIdsImDfmModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttachmentAnnotationIdsImDfmModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttachmentAnnotationIdsImDfmModalQuery({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *   },
 * });
 */
export function useGetAttachmentAnnotationIdsImDfmModalQuery(baseOptions: Apollo.QueryHookOptions<GetAttachmentAnnotationIdsImDfmModalQuery, GetAttachmentAnnotationIdsImDfmModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttachmentAnnotationIdsImDfmModalQuery, GetAttachmentAnnotationIdsImDfmModalQueryVariables>(GetAttachmentAnnotationIdsImDfmModalDocument, options);
      }
export function useGetAttachmentAnnotationIdsImDfmModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttachmentAnnotationIdsImDfmModalQuery, GetAttachmentAnnotationIdsImDfmModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttachmentAnnotationIdsImDfmModalQuery, GetAttachmentAnnotationIdsImDfmModalQueryVariables>(GetAttachmentAnnotationIdsImDfmModalDocument, options);
        }
export type GetAttachmentAnnotationIdsImDfmModalQueryHookResult = ReturnType<typeof useGetAttachmentAnnotationIdsImDfmModalQuery>;
export type GetAttachmentAnnotationIdsImDfmModalLazyQueryHookResult = ReturnType<typeof useGetAttachmentAnnotationIdsImDfmModalLazyQuery>;
export type GetAttachmentAnnotationIdsImDfmModalQueryResult = Apollo.QueryResult<GetAttachmentAnnotationIdsImDfmModalQuery, GetAttachmentAnnotationIdsImDfmModalQueryVariables>;
export function refetchGetAttachmentAnnotationIdsImDfmModalQuery(variables: GetAttachmentAnnotationIdsImDfmModalQueryVariables) {
      return { query: GetAttachmentAnnotationIdsImDfmModalDocument, variables: variables }
    }
export const ImDfmFeedbackDocument = gql`
    query imDfmFeedback($qmrId: UUID!) {
  quoteModelRevision(id: $qmrId) {
    id
    dfmFeedback(includeDraft: true) {
      id
      createdAt
      isPublished
      message
      sourceType
      status
      updatedAt
      isAutoGeneratedDfm
      updatedBy {
        id
        email
      }
      topic {
        id
        label
      }
      title
      attachment {
        id
        fileName
        downloadUrl
      }
      acceptedBy {
        id
        email
      }
    }
  }
}
    `;

/**
 * __useImDfmFeedbackQuery__
 *
 * To run a query within a React component, call `useImDfmFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useImDfmFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImDfmFeedbackQuery({
 *   variables: {
 *      qmrId: // value for 'qmrId'
 *   },
 * });
 */
export function useImDfmFeedbackQuery(baseOptions: Apollo.QueryHookOptions<ImDfmFeedbackQuery, ImDfmFeedbackQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImDfmFeedbackQuery, ImDfmFeedbackQueryVariables>(ImDfmFeedbackDocument, options);
      }
export function useImDfmFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImDfmFeedbackQuery, ImDfmFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImDfmFeedbackQuery, ImDfmFeedbackQueryVariables>(ImDfmFeedbackDocument, options);
        }
export type ImDfmFeedbackQueryHookResult = ReturnType<typeof useImDfmFeedbackQuery>;
export type ImDfmFeedbackLazyQueryHookResult = ReturnType<typeof useImDfmFeedbackLazyQuery>;
export type ImDfmFeedbackQueryResult = Apollo.QueryResult<ImDfmFeedbackQuery, ImDfmFeedbackQueryVariables>;
export function refetchImDfmFeedbackQuery(variables: ImDfmFeedbackQueryVariables) {
      return { query: ImDfmFeedbackDocument, variables: variables }
    }
export const Is2dDfmSlideReadyDocument = gql`
    query Is2dDfmSlideReady($dfmIds: [UUID!]) {
  is2dDfmSlideReady(dfmIds: $dfmIds) {
    feedbackId
    loading
    error
    signedUrl
  }
}
    `;

/**
 * __useIs2dDfmSlideReadyQuery__
 *
 * To run a query within a React component, call `useIs2dDfmSlideReadyQuery` and pass it any options that fit your needs.
 * When your component renders, `useIs2dDfmSlideReadyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIs2dDfmSlideReadyQuery({
 *   variables: {
 *      dfmIds: // value for 'dfmIds'
 *   },
 * });
 */
export function useIs2dDfmSlideReadyQuery(baseOptions?: Apollo.QueryHookOptions<Is2dDfmSlideReadyQuery, Is2dDfmSlideReadyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Is2dDfmSlideReadyQuery, Is2dDfmSlideReadyQueryVariables>(Is2dDfmSlideReadyDocument, options);
      }
export function useIs2dDfmSlideReadyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Is2dDfmSlideReadyQuery, Is2dDfmSlideReadyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Is2dDfmSlideReadyQuery, Is2dDfmSlideReadyQueryVariables>(Is2dDfmSlideReadyDocument, options);
        }
export type Is2dDfmSlideReadyQueryHookResult = ReturnType<typeof useIs2dDfmSlideReadyQuery>;
export type Is2dDfmSlideReadyLazyQueryHookResult = ReturnType<typeof useIs2dDfmSlideReadyLazyQuery>;
export type Is2dDfmSlideReadyQueryResult = Apollo.QueryResult<Is2dDfmSlideReadyQuery, Is2dDfmSlideReadyQueryVariables>;
export function refetchIs2dDfmSlideReadyQuery(variables?: Is2dDfmSlideReadyQueryVariables) {
      return { query: Is2dDfmSlideReadyDocument, variables: variables }
    }
export const ImDfmFeedbackIdDocument = gql`
    query imDfmFeedbackId($qmrId: UUID!) {
  quoteModelRevision(id: $qmrId) {
    id
    dfmFeedback(includeDraft: true) {
      id
    }
  }
}
    `;

/**
 * __useImDfmFeedbackIdQuery__
 *
 * To run a query within a React component, call `useImDfmFeedbackIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useImDfmFeedbackIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImDfmFeedbackIdQuery({
 *   variables: {
 *      qmrId: // value for 'qmrId'
 *   },
 * });
 */
export function useImDfmFeedbackIdQuery(baseOptions: Apollo.QueryHookOptions<ImDfmFeedbackIdQuery, ImDfmFeedbackIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImDfmFeedbackIdQuery, ImDfmFeedbackIdQueryVariables>(ImDfmFeedbackIdDocument, options);
      }
export function useImDfmFeedbackIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImDfmFeedbackIdQuery, ImDfmFeedbackIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImDfmFeedbackIdQuery, ImDfmFeedbackIdQueryVariables>(ImDfmFeedbackIdDocument, options);
        }
export type ImDfmFeedbackIdQueryHookResult = ReturnType<typeof useImDfmFeedbackIdQuery>;
export type ImDfmFeedbackIdLazyQueryHookResult = ReturnType<typeof useImDfmFeedbackIdLazyQuery>;
export type ImDfmFeedbackIdQueryResult = Apollo.QueryResult<ImDfmFeedbackIdQuery, ImDfmFeedbackIdQueryVariables>;
export function refetchImDfmFeedbackIdQuery(variables: ImDfmFeedbackIdQueryVariables) {
      return { query: ImDfmFeedbackIdDocument, variables: variables }
    }
export const DfmReportsDocument = gql`
    query dfmReports($id: UUID!) {
  quoteModelRevision(id: $id) {
    id
    dfmReports {
      isPublished
    }
  }
}
    `;

/**
 * __useDfmReportsQuery__
 *
 * To run a query within a React component, call `useDfmReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDfmReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDfmReportsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDfmReportsQuery(baseOptions: Apollo.QueryHookOptions<DfmReportsQuery, DfmReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DfmReportsQuery, DfmReportsQueryVariables>(DfmReportsDocument, options);
      }
export function useDfmReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DfmReportsQuery, DfmReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DfmReportsQuery, DfmReportsQueryVariables>(DfmReportsDocument, options);
        }
export type DfmReportsQueryHookResult = ReturnType<typeof useDfmReportsQuery>;
export type DfmReportsLazyQueryHookResult = ReturnType<typeof useDfmReportsLazyQuery>;
export type DfmReportsQueryResult = Apollo.QueryResult<DfmReportsQuery, DfmReportsQueryVariables>;
export function refetchDfmReportsQuery(variables: DfmReportsQueryVariables) {
      return { query: DfmReportsDocument, variables: variables }
    }
export const ImDfmFeedbackAttachmentDocument = gql`
    query imDfmFeedbackAttachment($id: UUID!) {
  quoteModelRevision(id: $id) {
    id
    dfmFeedback(includeDraft: true) {
      id
      attachment {
        id
        fileName
        downloadUrl
      }
    }
  }
}
    `;

/**
 * __useImDfmFeedbackAttachmentQuery__
 *
 * To run a query within a React component, call `useImDfmFeedbackAttachmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useImDfmFeedbackAttachmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImDfmFeedbackAttachmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useImDfmFeedbackAttachmentQuery(baseOptions: Apollo.QueryHookOptions<ImDfmFeedbackAttachmentQuery, ImDfmFeedbackAttachmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImDfmFeedbackAttachmentQuery, ImDfmFeedbackAttachmentQueryVariables>(ImDfmFeedbackAttachmentDocument, options);
      }
export function useImDfmFeedbackAttachmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImDfmFeedbackAttachmentQuery, ImDfmFeedbackAttachmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImDfmFeedbackAttachmentQuery, ImDfmFeedbackAttachmentQueryVariables>(ImDfmFeedbackAttachmentDocument, options);
        }
export type ImDfmFeedbackAttachmentQueryHookResult = ReturnType<typeof useImDfmFeedbackAttachmentQuery>;
export type ImDfmFeedbackAttachmentLazyQueryHookResult = ReturnType<typeof useImDfmFeedbackAttachmentLazyQuery>;
export type ImDfmFeedbackAttachmentQueryResult = Apollo.QueryResult<ImDfmFeedbackAttachmentQuery, ImDfmFeedbackAttachmentQueryVariables>;
export function refetchImDfmFeedbackAttachmentQuery(variables: ImDfmFeedbackAttachmentQueryVariables) {
      return { query: ImDfmFeedbackAttachmentDocument, variables: variables }
    }
export const IsDfmLoadingDocument = gql`
    query isDfmLoading($qmrId: UUID!) {
  isDfmLoading(qmrId: $qmrId) {
    error
    loading
  }
}
    `;

/**
 * __useIsDfmLoadingQuery__
 *
 * To run a query within a React component, call `useIsDfmLoadingQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsDfmLoadingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsDfmLoadingQuery({
 *   variables: {
 *      qmrId: // value for 'qmrId'
 *   },
 * });
 */
export function useIsDfmLoadingQuery(baseOptions: Apollo.QueryHookOptions<IsDfmLoadingQuery, IsDfmLoadingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsDfmLoadingQuery, IsDfmLoadingQueryVariables>(IsDfmLoadingDocument, options);
      }
export function useIsDfmLoadingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsDfmLoadingQuery, IsDfmLoadingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsDfmLoadingQuery, IsDfmLoadingQueryVariables>(IsDfmLoadingDocument, options);
        }
export type IsDfmLoadingQueryHookResult = ReturnType<typeof useIsDfmLoadingQuery>;
export type IsDfmLoadingLazyQueryHookResult = ReturnType<typeof useIsDfmLoadingLazyQuery>;
export type IsDfmLoadingQueryResult = Apollo.QueryResult<IsDfmLoadingQuery, IsDfmLoadingQueryVariables>;
export function refetchIsDfmLoadingQuery(variables: IsDfmLoadingQueryVariables) {
      return { query: IsDfmLoadingDocument, variables: variables }
    }
export const UploadQmrDfmReportPdfDocument = gql`
    mutation uploadQmrDfmReportPdf($qmrId: UUID!, $attachment: AttachmentInput!) {
  uploadQmrDfmReportPdf(qmrId: $qmrId, attachment: $attachment) {
    error
    loading
    uploadUrl
  }
}
    `;
export type UploadQmrDfmReportPdfMutationFn = Apollo.MutationFunction<UploadQmrDfmReportPdfMutation, UploadQmrDfmReportPdfMutationVariables>;

/**
 * __useUploadQmrDfmReportPdfMutation__
 *
 * To run a mutation, you first call `useUploadQmrDfmReportPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadQmrDfmReportPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadQmrDfmReportPdfMutation, { data, loading, error }] = useUploadQmrDfmReportPdfMutation({
 *   variables: {
 *      qmrId: // value for 'qmrId'
 *      attachment: // value for 'attachment'
 *   },
 * });
 */
export function useUploadQmrDfmReportPdfMutation(baseOptions?: Apollo.MutationHookOptions<UploadQmrDfmReportPdfMutation, UploadQmrDfmReportPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadQmrDfmReportPdfMutation, UploadQmrDfmReportPdfMutationVariables>(UploadQmrDfmReportPdfDocument, options);
      }
export type UploadQmrDfmReportPdfMutationHookResult = ReturnType<typeof useUploadQmrDfmReportPdfMutation>;
export type UploadQmrDfmReportPdfMutationResult = Apollo.MutationResult<UploadQmrDfmReportPdfMutation>;
export type UploadQmrDfmReportPdfMutationOptions = Apollo.BaseMutationOptions<UploadQmrDfmReportPdfMutation, UploadQmrDfmReportPdfMutationVariables>;
export const PullDirectionRawAnalysisDocument = gql`
    query pullDirectionRawAnalysis($qmrId: UUID!) {
  quoteModelRevision(id: $qmrId) {
    id
    partRevision {
      id
      rawAnalysis
    }
  }
}
    `;

/**
 * __usePullDirectionRawAnalysisQuery__
 *
 * To run a query within a React component, call `usePullDirectionRawAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `usePullDirectionRawAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePullDirectionRawAnalysisQuery({
 *   variables: {
 *      qmrId: // value for 'qmrId'
 *   },
 * });
 */
export function usePullDirectionRawAnalysisQuery(baseOptions: Apollo.QueryHookOptions<PullDirectionRawAnalysisQuery, PullDirectionRawAnalysisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PullDirectionRawAnalysisQuery, PullDirectionRawAnalysisQueryVariables>(PullDirectionRawAnalysisDocument, options);
      }
export function usePullDirectionRawAnalysisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PullDirectionRawAnalysisQuery, PullDirectionRawAnalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PullDirectionRawAnalysisQuery, PullDirectionRawAnalysisQueryVariables>(PullDirectionRawAnalysisDocument, options);
        }
export type PullDirectionRawAnalysisQueryHookResult = ReturnType<typeof usePullDirectionRawAnalysisQuery>;
export type PullDirectionRawAnalysisLazyQueryHookResult = ReturnType<typeof usePullDirectionRawAnalysisLazyQuery>;
export type PullDirectionRawAnalysisQueryResult = Apollo.QueryResult<PullDirectionRawAnalysisQuery, PullDirectionRawAnalysisQueryVariables>;
export function refetchPullDirectionRawAnalysisQuery(variables: PullDirectionRawAnalysisQueryVariables) {
      return { query: PullDirectionRawAnalysisDocument, variables: variables }
    }
export const QuoteModelRevisionModelViewerPanelDocument = gql`
    query quoteModelRevisionModelViewerPanel($id: UUID!, $showDeleted: Boolean) {
  quoteModelRevision(id: $id, showDeleted: $showDeleted) {
    id
    holes {
      id
      groupKey
      type
      depth
      diameter
      isBlind
      tipAngle
      counterboreDepth
      counterboreDiameter
      countersinkAngle
      countersinkDepth
      countersinkDiameter
      direction
      endPoint
      startPoint
      patches {
        id
      }
      tapOptions {
        id
        maxDepth
        commonName
      }
      tapAnnotation {
        id
        depth
        tapOption {
          id
          maxDepth
          commonName
        }
      }
    }
    partRevision {
      id
      sceneBundle
      rawAnalysis
      modelFileName
    }
    attachmentLink {
      id
      quoteAttachmentRevision {
        id
        attachment {
          ... on Attachment {
            id
            fileName
          }
        }
      }
    }
    processesDetails {
      primaryProcess {
        process {
          id
          name
          platformProcessTypeId
        }
      }
    }
  }
}
    `;

/**
 * __useQuoteModelRevisionModelViewerPanelQuery__
 *
 * To run a query within a React component, call `useQuoteModelRevisionModelViewerPanelQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteModelRevisionModelViewerPanelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteModelRevisionModelViewerPanelQuery({
 *   variables: {
 *      id: // value for 'id'
 *      showDeleted: // value for 'showDeleted'
 *   },
 * });
 */
export function useQuoteModelRevisionModelViewerPanelQuery(baseOptions: Apollo.QueryHookOptions<QuoteModelRevisionModelViewerPanelQuery, QuoteModelRevisionModelViewerPanelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteModelRevisionModelViewerPanelQuery, QuoteModelRevisionModelViewerPanelQueryVariables>(QuoteModelRevisionModelViewerPanelDocument, options);
      }
export function useQuoteModelRevisionModelViewerPanelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteModelRevisionModelViewerPanelQuery, QuoteModelRevisionModelViewerPanelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteModelRevisionModelViewerPanelQuery, QuoteModelRevisionModelViewerPanelQueryVariables>(QuoteModelRevisionModelViewerPanelDocument, options);
        }
export type QuoteModelRevisionModelViewerPanelQueryHookResult = ReturnType<typeof useQuoteModelRevisionModelViewerPanelQuery>;
export type QuoteModelRevisionModelViewerPanelLazyQueryHookResult = ReturnType<typeof useQuoteModelRevisionModelViewerPanelLazyQuery>;
export type QuoteModelRevisionModelViewerPanelQueryResult = Apollo.QueryResult<QuoteModelRevisionModelViewerPanelQuery, QuoteModelRevisionModelViewerPanelQueryVariables>;
export function refetchQuoteModelRevisionModelViewerPanelQuery(variables: QuoteModelRevisionModelViewerPanelQueryVariables) {
      return { query: QuoteModelRevisionModelViewerPanelDocument, variables: variables }
    }
export const MarkUploadedAssetDocument = gql`
    mutation markUploadedAsset($id: UUID!) {
  markUploadedAsset(id: $id) {
    id
    downloadUrl
  }
}
    `;
export type MarkUploadedAssetMutationFn = Apollo.MutationFunction<MarkUploadedAssetMutation, MarkUploadedAssetMutationVariables>;

/**
 * __useMarkUploadedAssetMutation__
 *
 * To run a mutation, you first call `useMarkUploadedAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkUploadedAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markUploadedAssetMutation, { data, loading, error }] = useMarkUploadedAssetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkUploadedAssetMutation(baseOptions?: Apollo.MutationHookOptions<MarkUploadedAssetMutation, MarkUploadedAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkUploadedAssetMutation, MarkUploadedAssetMutationVariables>(MarkUploadedAssetDocument, options);
      }
export type MarkUploadedAssetMutationHookResult = ReturnType<typeof useMarkUploadedAssetMutation>;
export type MarkUploadedAssetMutationResult = Apollo.MutationResult<MarkUploadedAssetMutation>;
export type MarkUploadedAssetMutationOptions = Apollo.BaseMutationOptions<MarkUploadedAssetMutation, MarkUploadedAssetMutationVariables>;
export const UpsertDfmAttachmentAnnotationsImDfmPdfViewerDocument = gql`
    mutation upsertDfmAttachmentAnnotationsImDfmPdfViewer($attachmentId: UUID!, $qmrAttachmentAnnotationsInput: DfmAttachmentAnnotationsInput!) {
  upsertDfmAttachmentAnnotations(
    attachmentId: $attachmentId
    qmrAttachmentAnnotationsInput: $qmrAttachmentAnnotationsInput
  ) {
    id
    annotationsDataDownloadUrl
    attachmentId
    createdAt
    createdBy {
      id
      displayName
    }
    updatedAt
    updatedBy {
      id
      displayName
    }
  }
}
    `;
export type UpsertDfmAttachmentAnnotationsImDfmPdfViewerMutationFn = Apollo.MutationFunction<UpsertDfmAttachmentAnnotationsImDfmPdfViewerMutation, UpsertDfmAttachmentAnnotationsImDfmPdfViewerMutationVariables>;

/**
 * __useUpsertDfmAttachmentAnnotationsImDfmPdfViewerMutation__
 *
 * To run a mutation, you first call `useUpsertDfmAttachmentAnnotationsImDfmPdfViewerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDfmAttachmentAnnotationsImDfmPdfViewerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDfmAttachmentAnnotationsImDfmPdfViewerMutation, { data, loading, error }] = useUpsertDfmAttachmentAnnotationsImDfmPdfViewerMutation({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *      qmrAttachmentAnnotationsInput: // value for 'qmrAttachmentAnnotationsInput'
 *   },
 * });
 */
export function useUpsertDfmAttachmentAnnotationsImDfmPdfViewerMutation(baseOptions?: Apollo.MutationHookOptions<UpsertDfmAttachmentAnnotationsImDfmPdfViewerMutation, UpsertDfmAttachmentAnnotationsImDfmPdfViewerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertDfmAttachmentAnnotationsImDfmPdfViewerMutation, UpsertDfmAttachmentAnnotationsImDfmPdfViewerMutationVariables>(UpsertDfmAttachmentAnnotationsImDfmPdfViewerDocument, options);
      }
export type UpsertDfmAttachmentAnnotationsImDfmPdfViewerMutationHookResult = ReturnType<typeof useUpsertDfmAttachmentAnnotationsImDfmPdfViewerMutation>;
export type UpsertDfmAttachmentAnnotationsImDfmPdfViewerMutationResult = Apollo.MutationResult<UpsertDfmAttachmentAnnotationsImDfmPdfViewerMutation>;
export type UpsertDfmAttachmentAnnotationsImDfmPdfViewerMutationOptions = Apollo.BaseMutationOptions<UpsertDfmAttachmentAnnotationsImDfmPdfViewerMutation, UpsertDfmAttachmentAnnotationsImDfmPdfViewerMutationVariables>;
export const CreateSanitizedAttachmentUploaderDocument = gql`
    mutation createSanitizedAttachmentUploader($attachmentId: UUID!, $fileName: String!, $extension: String, $mimeType: String, $quoteModelRevisionId: UUID) {
  createSanitizedAttachment(
    attachmentId: $attachmentId
    uploadMetadata: {fileName: $fileName, extension: $extension, mimeType: $mimeType}
    quoteModelRevisionId: $quoteModelRevisionId
  ) {
    id
    uploadUrl
    fileName
  }
}
    `;
export type CreateSanitizedAttachmentUploaderMutationFn = Apollo.MutationFunction<CreateSanitizedAttachmentUploaderMutation, CreateSanitizedAttachmentUploaderMutationVariables>;

/**
 * __useCreateSanitizedAttachmentUploaderMutation__
 *
 * To run a mutation, you first call `useCreateSanitizedAttachmentUploaderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSanitizedAttachmentUploaderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSanitizedAttachmentUploaderMutation, { data, loading, error }] = useCreateSanitizedAttachmentUploaderMutation({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *      fileName: // value for 'fileName'
 *      extension: // value for 'extension'
 *      mimeType: // value for 'mimeType'
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *   },
 * });
 */
export function useCreateSanitizedAttachmentUploaderMutation(baseOptions?: Apollo.MutationHookOptions<CreateSanitizedAttachmentUploaderMutation, CreateSanitizedAttachmentUploaderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSanitizedAttachmentUploaderMutation, CreateSanitizedAttachmentUploaderMutationVariables>(CreateSanitizedAttachmentUploaderDocument, options);
      }
export type CreateSanitizedAttachmentUploaderMutationHookResult = ReturnType<typeof useCreateSanitizedAttachmentUploaderMutation>;
export type CreateSanitizedAttachmentUploaderMutationResult = Apollo.MutationResult<CreateSanitizedAttachmentUploaderMutation>;
export type CreateSanitizedAttachmentUploaderMutationOptions = Apollo.BaseMutationOptions<CreateSanitizedAttachmentUploaderMutation, CreateSanitizedAttachmentUploaderMutationVariables>;
export const MarkUploadedSanitizedAttachmentDocument = gql`
    mutation markUploadedSanitizedAttachment($id: UUID!) {
  markUploadedSanitizedAttachment(id: $id) {
    id
    downloadUrl
    fileName
  }
}
    `;
export type MarkUploadedSanitizedAttachmentMutationFn = Apollo.MutationFunction<MarkUploadedSanitizedAttachmentMutation, MarkUploadedSanitizedAttachmentMutationVariables>;

/**
 * __useMarkUploadedSanitizedAttachmentMutation__
 *
 * To run a mutation, you first call `useMarkUploadedSanitizedAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkUploadedSanitizedAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markUploadedSanitizedAttachmentMutation, { data, loading, error }] = useMarkUploadedSanitizedAttachmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkUploadedSanitizedAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<MarkUploadedSanitizedAttachmentMutation, MarkUploadedSanitizedAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkUploadedSanitizedAttachmentMutation, MarkUploadedSanitizedAttachmentMutationVariables>(MarkUploadedSanitizedAttachmentDocument, options);
      }
export type MarkUploadedSanitizedAttachmentMutationHookResult = ReturnType<typeof useMarkUploadedSanitizedAttachmentMutation>;
export type MarkUploadedSanitizedAttachmentMutationResult = Apollo.MutationResult<MarkUploadedSanitizedAttachmentMutation>;
export type MarkUploadedSanitizedAttachmentMutationOptions = Apollo.BaseMutationOptions<MarkUploadedSanitizedAttachmentMutation, MarkUploadedSanitizedAttachmentMutationVariables>;
export const RemoveSanitizedAttachmentDocument = gql`
    mutation removeSanitizedAttachment($attachmentId: UUID!) {
  removeSanitizedAttachment(id: $attachmentId) {
    id
    downloadUrl
    fileName
  }
}
    `;
export type RemoveSanitizedAttachmentMutationFn = Apollo.MutationFunction<RemoveSanitizedAttachmentMutation, RemoveSanitizedAttachmentMutationVariables>;

/**
 * __useRemoveSanitizedAttachmentMutation__
 *
 * To run a mutation, you first call `useRemoveSanitizedAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSanitizedAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSanitizedAttachmentMutation, { data, loading, error }] = useRemoveSanitizedAttachmentMutation({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useRemoveSanitizedAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSanitizedAttachmentMutation, RemoveSanitizedAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSanitizedAttachmentMutation, RemoveSanitizedAttachmentMutationVariables>(RemoveSanitizedAttachmentDocument, options);
      }
export type RemoveSanitizedAttachmentMutationHookResult = ReturnType<typeof useRemoveSanitizedAttachmentMutation>;
export type RemoveSanitizedAttachmentMutationResult = Apollo.MutationResult<RemoveSanitizedAttachmentMutation>;
export type RemoveSanitizedAttachmentMutationOptions = Apollo.BaseMutationOptions<RemoveSanitizedAttachmentMutation, RemoveSanitizedAttachmentMutationVariables>;
export const AdminQuoteModelRevisionDocument = gql`
    query adminQuoteModelRevision($id: UUID!, $showDeleted: Boolean, $isCpqFlagV2Enabled: Boolean = false) {
  quoteModelRevision(id: $id, showDeleted: $showDeleted) {
    ...AdminQuoteModelRevisionData
  }
}
    ${AdminQuoteModelRevisionDataFragmentDoc}`;

/**
 * __useAdminQuoteModelRevisionQuery__
 *
 * To run a query within a React component, call `useAdminQuoteModelRevisionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminQuoteModelRevisionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminQuoteModelRevisionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      showDeleted: // value for 'showDeleted'
 *      isCpqFlagV2Enabled: // value for 'isCpqFlagV2Enabled'
 *   },
 * });
 */
export function useAdminQuoteModelRevisionQuery(baseOptions: Apollo.QueryHookOptions<AdminQuoteModelRevisionQuery, AdminQuoteModelRevisionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminQuoteModelRevisionQuery, AdminQuoteModelRevisionQueryVariables>(AdminQuoteModelRevisionDocument, options);
      }
export function useAdminQuoteModelRevisionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminQuoteModelRevisionQuery, AdminQuoteModelRevisionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminQuoteModelRevisionQuery, AdminQuoteModelRevisionQueryVariables>(AdminQuoteModelRevisionDocument, options);
        }
export type AdminQuoteModelRevisionQueryHookResult = ReturnType<typeof useAdminQuoteModelRevisionQuery>;
export type AdminQuoteModelRevisionLazyQueryHookResult = ReturnType<typeof useAdminQuoteModelRevisionLazyQuery>;
export type AdminQuoteModelRevisionQueryResult = Apollo.QueryResult<AdminQuoteModelRevisionQuery, AdminQuoteModelRevisionQueryVariables>;
export function refetchAdminQuoteModelRevisionQuery(variables: AdminQuoteModelRevisionQueryVariables) {
      return { query: AdminQuoteModelRevisionDocument, variables: variables }
    }
export const AdminCalculateAdvancedInspectionPendingPricesDocument = gql`
    query adminCalculateAdvancedInspectionPendingPrices($quoteModelRevisionId: UUID!, $numPartsToInspect: Int!, $inspectionParams: AdminInspectionPricingParamsInput!, $setupParams: PartSetupsInspectionPricingParamsInput!) {
  calculateAdvancedInspectionPendingPrices(
    quoteModelRevisionId: $quoteModelRevisionId
    numPartsToInspect: $numPartsToInspect
    inspectionParams: $inspectionParams
    setupParams: $setupParams
  ) {
    domestic {
      mpPayoutInCents
      builderPayoutInCents
      leadTimeInDays
    }
    overseas {
      mpPayoutInCents
      builderPayoutInCents
      leadTimeInDays
    }
  }
}
    `;

/**
 * __useAdminCalculateAdvancedInspectionPendingPricesQuery__
 *
 * To run a query within a React component, call `useAdminCalculateAdvancedInspectionPendingPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCalculateAdvancedInspectionPendingPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCalculateAdvancedInspectionPendingPricesQuery({
 *   variables: {
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *      numPartsToInspect: // value for 'numPartsToInspect'
 *      inspectionParams: // value for 'inspectionParams'
 *      setupParams: // value for 'setupParams'
 *   },
 * });
 */
export function useAdminCalculateAdvancedInspectionPendingPricesQuery(baseOptions: Apollo.QueryHookOptions<AdminCalculateAdvancedInspectionPendingPricesQuery, AdminCalculateAdvancedInspectionPendingPricesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminCalculateAdvancedInspectionPendingPricesQuery, AdminCalculateAdvancedInspectionPendingPricesQueryVariables>(AdminCalculateAdvancedInspectionPendingPricesDocument, options);
      }
export function useAdminCalculateAdvancedInspectionPendingPricesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminCalculateAdvancedInspectionPendingPricesQuery, AdminCalculateAdvancedInspectionPendingPricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminCalculateAdvancedInspectionPendingPricesQuery, AdminCalculateAdvancedInspectionPendingPricesQueryVariables>(AdminCalculateAdvancedInspectionPendingPricesDocument, options);
        }
export type AdminCalculateAdvancedInspectionPendingPricesQueryHookResult = ReturnType<typeof useAdminCalculateAdvancedInspectionPendingPricesQuery>;
export type AdminCalculateAdvancedInspectionPendingPricesLazyQueryHookResult = ReturnType<typeof useAdminCalculateAdvancedInspectionPendingPricesLazyQuery>;
export type AdminCalculateAdvancedInspectionPendingPricesQueryResult = Apollo.QueryResult<AdminCalculateAdvancedInspectionPendingPricesQuery, AdminCalculateAdvancedInspectionPendingPricesQueryVariables>;
export function refetchAdminCalculateAdvancedInspectionPendingPricesQuery(variables: AdminCalculateAdvancedInspectionPendingPricesQueryVariables) {
      return { query: AdminCalculateAdvancedInspectionPendingPricesDocument, variables: variables }
    }
export const CalculateQuoteModelRevisionHypotheticalVendorPriceDocument = gql`
    query calculateQuoteModelRevisionHypotheticalVendorPrice($quoteModelRevisionId: UUID!, $inspectionData: InspectionDataInput, $modelConfigOverride: ConfigInput!, $pricingConstantOverrides: PricingConstantOverridesInput!) {
  calculateQuoteModelRevisionHypotheticalVendorPrice(
    quoteModelRevisionId: $quoteModelRevisionId
    inspectionData: $inspectionData
    modelConfigOverride: $modelConfigOverride
    pricingConstantOverrides: $pricingConstantOverrides
  ) {
    ... on ExactPrice {
      priceInCents
      unitPriceInCents
    }
    ... on EstimatedPrice {
      lowPriceInCents
      lowUnitPriceInCents
      highPriceInCents
      highUnitPriceInCents
    }
  }
}
    `;

/**
 * __useCalculateQuoteModelRevisionHypotheticalVendorPriceQuery__
 *
 * To run a query within a React component, call `useCalculateQuoteModelRevisionHypotheticalVendorPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateQuoteModelRevisionHypotheticalVendorPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateQuoteModelRevisionHypotheticalVendorPriceQuery({
 *   variables: {
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *      inspectionData: // value for 'inspectionData'
 *      modelConfigOverride: // value for 'modelConfigOverride'
 *      pricingConstantOverrides: // value for 'pricingConstantOverrides'
 *   },
 * });
 */
export function useCalculateQuoteModelRevisionHypotheticalVendorPriceQuery(baseOptions: Apollo.QueryHookOptions<CalculateQuoteModelRevisionHypotheticalVendorPriceQuery, CalculateQuoteModelRevisionHypotheticalVendorPriceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateQuoteModelRevisionHypotheticalVendorPriceQuery, CalculateQuoteModelRevisionHypotheticalVendorPriceQueryVariables>(CalculateQuoteModelRevisionHypotheticalVendorPriceDocument, options);
      }
export function useCalculateQuoteModelRevisionHypotheticalVendorPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateQuoteModelRevisionHypotheticalVendorPriceQuery, CalculateQuoteModelRevisionHypotheticalVendorPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateQuoteModelRevisionHypotheticalVendorPriceQuery, CalculateQuoteModelRevisionHypotheticalVendorPriceQueryVariables>(CalculateQuoteModelRevisionHypotheticalVendorPriceDocument, options);
        }
export type CalculateQuoteModelRevisionHypotheticalVendorPriceQueryHookResult = ReturnType<typeof useCalculateQuoteModelRevisionHypotheticalVendorPriceQuery>;
export type CalculateQuoteModelRevisionHypotheticalVendorPriceLazyQueryHookResult = ReturnType<typeof useCalculateQuoteModelRevisionHypotheticalVendorPriceLazyQuery>;
export type CalculateQuoteModelRevisionHypotheticalVendorPriceQueryResult = Apollo.QueryResult<CalculateQuoteModelRevisionHypotheticalVendorPriceQuery, CalculateQuoteModelRevisionHypotheticalVendorPriceQueryVariables>;
export function refetchCalculateQuoteModelRevisionHypotheticalVendorPriceQuery(variables: CalculateQuoteModelRevisionHypotheticalVendorPriceQueryVariables) {
      return { query: CalculateQuoteModelRevisionHypotheticalVendorPriceDocument, variables: variables }
    }
export const EdmCalculatorPendingPriceQueryDocument = gql`
    query edmCalculatorPendingPriceQuery($qmrId: UUID!, $edmCalculatorInput: EdmCalculatorInput!) {
  getPendingEdmCalculatorDomesticAndOverseasPrice(
    qmrId: $qmrId
    edmCalculatorInput: $edmCalculatorInput
  ) {
    stepItems {
      wire {
        gear
        roughness
        cutPath
        plateThickness
      }
      sinkerKnownRemoval {
        roughness
        setups
        volumeRemoved
      }
      sinkerNoKnownRemoval {
        roughness
        setups
        desiredFilletRadius
        standardFilletRadius
        lengthOfFillet
      }
      priceInCents {
        usa
        china
        india
      }
    }
  }
}
    `;

/**
 * __useEdmCalculatorPendingPriceQueryQuery__
 *
 * To run a query within a React component, call `useEdmCalculatorPendingPriceQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmCalculatorPendingPriceQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmCalculatorPendingPriceQueryQuery({
 *   variables: {
 *      qmrId: // value for 'qmrId'
 *      edmCalculatorInput: // value for 'edmCalculatorInput'
 *   },
 * });
 */
export function useEdmCalculatorPendingPriceQueryQuery(baseOptions: Apollo.QueryHookOptions<EdmCalculatorPendingPriceQueryQuery, EdmCalculatorPendingPriceQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EdmCalculatorPendingPriceQueryQuery, EdmCalculatorPendingPriceQueryQueryVariables>(EdmCalculatorPendingPriceQueryDocument, options);
      }
export function useEdmCalculatorPendingPriceQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EdmCalculatorPendingPriceQueryQuery, EdmCalculatorPendingPriceQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EdmCalculatorPendingPriceQueryQuery, EdmCalculatorPendingPriceQueryQueryVariables>(EdmCalculatorPendingPriceQueryDocument, options);
        }
export type EdmCalculatorPendingPriceQueryQueryHookResult = ReturnType<typeof useEdmCalculatorPendingPriceQueryQuery>;
export type EdmCalculatorPendingPriceQueryLazyQueryHookResult = ReturnType<typeof useEdmCalculatorPendingPriceQueryLazyQuery>;
export type EdmCalculatorPendingPriceQueryQueryResult = Apollo.QueryResult<EdmCalculatorPendingPriceQueryQuery, EdmCalculatorPendingPriceQueryQueryVariables>;
export function refetchEdmCalculatorPendingPriceQueryQuery(variables: EdmCalculatorPendingPriceQueryQueryVariables) {
      return { query: EdmCalculatorPendingPriceQueryDocument, variables: variables }
    }
export const UpdateStepItemsMutationAdminQuotingpAgeDocument = gql`
    mutation updateStepItemsMutationAdminQuotingpAGE($modelConfigurationDfmInspectionId: UUID!, $inspectionData: InspectionDataInput!) {
  updateModelConfigurationDfmInspection(
    modelConfigurationDfmInspectionId: $modelConfigurationDfmInspectionId
    inspectionData: $inspectionData
  ) {
    id
    inspectionData
  }
}
    `;
export type UpdateStepItemsMutationAdminQuotingpAgeMutationFn = Apollo.MutationFunction<UpdateStepItemsMutationAdminQuotingpAgeMutation, UpdateStepItemsMutationAdminQuotingpAgeMutationVariables>;

/**
 * __useUpdateStepItemsMutationAdminQuotingpAgeMutation__
 *
 * To run a mutation, you first call `useUpdateStepItemsMutationAdminQuotingpAgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStepItemsMutationAdminQuotingpAgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStepItemsMutationAdminQuotingpAgeMutation, { data, loading, error }] = useUpdateStepItemsMutationAdminQuotingpAgeMutation({
 *   variables: {
 *      modelConfigurationDfmInspectionId: // value for 'modelConfigurationDfmInspectionId'
 *      inspectionData: // value for 'inspectionData'
 *   },
 * });
 */
export function useUpdateStepItemsMutationAdminQuotingpAgeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStepItemsMutationAdminQuotingpAgeMutation, UpdateStepItemsMutationAdminQuotingpAgeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStepItemsMutationAdminQuotingpAgeMutation, UpdateStepItemsMutationAdminQuotingpAgeMutationVariables>(UpdateStepItemsMutationAdminQuotingpAgeDocument, options);
      }
export type UpdateStepItemsMutationAdminQuotingpAgeMutationHookResult = ReturnType<typeof useUpdateStepItemsMutationAdminQuotingpAgeMutation>;
export type UpdateStepItemsMutationAdminQuotingpAgeMutationResult = Apollo.MutationResult<UpdateStepItemsMutationAdminQuotingpAgeMutation>;
export type UpdateStepItemsMutationAdminQuotingpAgeMutationOptions = Apollo.BaseMutationOptions<UpdateStepItemsMutationAdminQuotingpAgeMutation, UpdateStepItemsMutationAdminQuotingpAgeMutationVariables>;
export const HardwareInstallationPendingPriceQueryDocument = gql`
    query hardwareInstallationPendingPriceQuery($qmrId: UUID!, $hardwareInstallationInput: HardwareInstallationPricingInput!) {
  getPendingHardwareInstallationPriceAndLeadTime(
    qmrId: $qmrId
    hardwareInstallationInput: $hardwareInstallationInput
  ) {
    international {
      leadTimeInDays
      leadTimePartsLimit
    }
    domestic {
      mpPayoutInCents
      leadTimeInDays
      leadTimePartsLimit
    }
  }
}
    `;

/**
 * __useHardwareInstallationPendingPriceQueryQuery__
 *
 * To run a query within a React component, call `useHardwareInstallationPendingPriceQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useHardwareInstallationPendingPriceQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHardwareInstallationPendingPriceQueryQuery({
 *   variables: {
 *      qmrId: // value for 'qmrId'
 *      hardwareInstallationInput: // value for 'hardwareInstallationInput'
 *   },
 * });
 */
export function useHardwareInstallationPendingPriceQueryQuery(baseOptions: Apollo.QueryHookOptions<HardwareInstallationPendingPriceQueryQuery, HardwareInstallationPendingPriceQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HardwareInstallationPendingPriceQueryQuery, HardwareInstallationPendingPriceQueryQueryVariables>(HardwareInstallationPendingPriceQueryDocument, options);
      }
export function useHardwareInstallationPendingPriceQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HardwareInstallationPendingPriceQueryQuery, HardwareInstallationPendingPriceQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HardwareInstallationPendingPriceQueryQuery, HardwareInstallationPendingPriceQueryQueryVariables>(HardwareInstallationPendingPriceQueryDocument, options);
        }
export type HardwareInstallationPendingPriceQueryQueryHookResult = ReturnType<typeof useHardwareInstallationPendingPriceQueryQuery>;
export type HardwareInstallationPendingPriceQueryLazyQueryHookResult = ReturnType<typeof useHardwareInstallationPendingPriceQueryLazyQuery>;
export type HardwareInstallationPendingPriceQueryQueryResult = Apollo.QueryResult<HardwareInstallationPendingPriceQueryQuery, HardwareInstallationPendingPriceQueryQueryVariables>;
export function refetchHardwareInstallationPendingPriceQueryQuery(variables: HardwareInstallationPendingPriceQueryQueryVariables) {
      return { query: HardwareInstallationPendingPriceQueryDocument, variables: variables }
    }
export const UpsertHardwareInstallationSecondaryProcessWithCalculatedPricingDocument = gql`
    mutation upsertHardwareInstallationSecondaryProcessWithCalculatedPricing($qmrId: UUID!, $quotedProcessConfig: HardwareInstallationConfigInput!) {
  upsertHardwareInstallationSecondaryProcessWithCalculatedPricing(
    id: $qmrId
    quotedProcessConfig: $quotedProcessConfig
  ) {
    id
  }
}
    `;
export type UpsertHardwareInstallationSecondaryProcessWithCalculatedPricingMutationFn = Apollo.MutationFunction<UpsertHardwareInstallationSecondaryProcessWithCalculatedPricingMutation, UpsertHardwareInstallationSecondaryProcessWithCalculatedPricingMutationVariables>;

/**
 * __useUpsertHardwareInstallationSecondaryProcessWithCalculatedPricingMutation__
 *
 * To run a mutation, you first call `useUpsertHardwareInstallationSecondaryProcessWithCalculatedPricingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertHardwareInstallationSecondaryProcessWithCalculatedPricingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertHardwareInstallationSecondaryProcessWithCalculatedPricingMutation, { data, loading, error }] = useUpsertHardwareInstallationSecondaryProcessWithCalculatedPricingMutation({
 *   variables: {
 *      qmrId: // value for 'qmrId'
 *      quotedProcessConfig: // value for 'quotedProcessConfig'
 *   },
 * });
 */
export function useUpsertHardwareInstallationSecondaryProcessWithCalculatedPricingMutation(baseOptions?: Apollo.MutationHookOptions<UpsertHardwareInstallationSecondaryProcessWithCalculatedPricingMutation, UpsertHardwareInstallationSecondaryProcessWithCalculatedPricingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertHardwareInstallationSecondaryProcessWithCalculatedPricingMutation, UpsertHardwareInstallationSecondaryProcessWithCalculatedPricingMutationVariables>(UpsertHardwareInstallationSecondaryProcessWithCalculatedPricingDocument, options);
      }
export type UpsertHardwareInstallationSecondaryProcessWithCalculatedPricingMutationHookResult = ReturnType<typeof useUpsertHardwareInstallationSecondaryProcessWithCalculatedPricingMutation>;
export type UpsertHardwareInstallationSecondaryProcessWithCalculatedPricingMutationResult = Apollo.MutationResult<UpsertHardwareInstallationSecondaryProcessWithCalculatedPricingMutation>;
export type UpsertHardwareInstallationSecondaryProcessWithCalculatedPricingMutationOptions = Apollo.BaseMutationOptions<UpsertHardwareInstallationSecondaryProcessWithCalculatedPricingMutation, UpsertHardwareInstallationSecondaryProcessWithCalculatedPricingMutationVariables>;
export const AdminImPanelPendingPriceQueryDocument = gql`
    query adminImPanelPendingPriceQuery($toolInspectionData: MoldToolInspectionDataInput!, $partsInspectionData: [PartInspectionDataInput]!) {
  getToolAndPartPendingPrices(
    inspectionData: $toolInspectionData
    partsInspectionData: $partsInspectionData
  ) {
    toolingPrice {
      mpPayoutCents
      customerPrice
    }
    partPrice {
      unitMpPayoutInCentsPerQmr
      unitCustomerPriceInCentsPerQmr
    }
  }
}
    `;

/**
 * __useAdminImPanelPendingPriceQueryQuery__
 *
 * To run a query within a React component, call `useAdminImPanelPendingPriceQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminImPanelPendingPriceQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminImPanelPendingPriceQueryQuery({
 *   variables: {
 *      toolInspectionData: // value for 'toolInspectionData'
 *      partsInspectionData: // value for 'partsInspectionData'
 *   },
 * });
 */
export function useAdminImPanelPendingPriceQueryQuery(baseOptions: Apollo.QueryHookOptions<AdminImPanelPendingPriceQueryQuery, AdminImPanelPendingPriceQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminImPanelPendingPriceQueryQuery, AdminImPanelPendingPriceQueryQueryVariables>(AdminImPanelPendingPriceQueryDocument, options);
      }
export function useAdminImPanelPendingPriceQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminImPanelPendingPriceQueryQuery, AdminImPanelPendingPriceQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminImPanelPendingPriceQueryQuery, AdminImPanelPendingPriceQueryQueryVariables>(AdminImPanelPendingPriceQueryDocument, options);
        }
export type AdminImPanelPendingPriceQueryQueryHookResult = ReturnType<typeof useAdminImPanelPendingPriceQueryQuery>;
export type AdminImPanelPendingPriceQueryLazyQueryHookResult = ReturnType<typeof useAdminImPanelPendingPriceQueryLazyQuery>;
export type AdminImPanelPendingPriceQueryQueryResult = Apollo.QueryResult<AdminImPanelPendingPriceQueryQuery, AdminImPanelPendingPriceQueryQueryVariables>;
export function refetchAdminImPanelPendingPriceQueryQuery(variables: AdminImPanelPendingPriceQueryQueryVariables) {
      return { query: AdminImPanelPendingPriceQueryDocument, variables: variables }
    }
export const AdminQmrLeadTimeContributionsJsonDocument = gql`
    query adminQmrLeadTimeContributionsJSON($quoteModelRevisionId: UUID!) {
  qmrLeadTimeContributionsJSON(quoteModelRevisionId: $quoteModelRevisionId)
}
    `;

/**
 * __useAdminQmrLeadTimeContributionsJsonQuery__
 *
 * To run a query within a React component, call `useAdminQmrLeadTimeContributionsJsonQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminQmrLeadTimeContributionsJsonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminQmrLeadTimeContributionsJsonQuery({
 *   variables: {
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *   },
 * });
 */
export function useAdminQmrLeadTimeContributionsJsonQuery(baseOptions: Apollo.QueryHookOptions<AdminQmrLeadTimeContributionsJsonQuery, AdminQmrLeadTimeContributionsJsonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminQmrLeadTimeContributionsJsonQuery, AdminQmrLeadTimeContributionsJsonQueryVariables>(AdminQmrLeadTimeContributionsJsonDocument, options);
      }
export function useAdminQmrLeadTimeContributionsJsonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminQmrLeadTimeContributionsJsonQuery, AdminQmrLeadTimeContributionsJsonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminQmrLeadTimeContributionsJsonQuery, AdminQmrLeadTimeContributionsJsonQueryVariables>(AdminQmrLeadTimeContributionsJsonDocument, options);
        }
export type AdminQmrLeadTimeContributionsJsonQueryHookResult = ReturnType<typeof useAdminQmrLeadTimeContributionsJsonQuery>;
export type AdminQmrLeadTimeContributionsJsonLazyQueryHookResult = ReturnType<typeof useAdminQmrLeadTimeContributionsJsonLazyQuery>;
export type AdminQmrLeadTimeContributionsJsonQueryResult = Apollo.QueryResult<AdminQmrLeadTimeContributionsJsonQuery, AdminQmrLeadTimeContributionsJsonQueryVariables>;
export function refetchAdminQmrLeadTimeContributionsJsonQuery(variables: AdminQmrLeadTimeContributionsJsonQueryVariables) {
      return { query: AdminQmrLeadTimeContributionsJsonDocument, variables: variables }
    }
export const CreateQuoteModelRevisionAttachmentPartDfmReportDocument = gql`
    mutation createQuoteModelRevisionAttachmentPartDFMReport($quoteModelRevisionId: UUID!, $quoteAttachmentRevisionId: UUID!, $userId: Int) {
  createQuoteModelRevisionAttachment(
    quoteModelRevisionId: $quoteModelRevisionId
    quoteAttachmentRevisionId: $quoteAttachmentRevisionId
    userId: $userId
  ) {
    id
  }
}
    `;
export type CreateQuoteModelRevisionAttachmentPartDfmReportMutationFn = Apollo.MutationFunction<CreateQuoteModelRevisionAttachmentPartDfmReportMutation, CreateQuoteModelRevisionAttachmentPartDfmReportMutationVariables>;

/**
 * __useCreateQuoteModelRevisionAttachmentPartDfmReportMutation__
 *
 * To run a mutation, you first call `useCreateQuoteModelRevisionAttachmentPartDfmReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuoteModelRevisionAttachmentPartDfmReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuoteModelRevisionAttachmentPartDfmReportMutation, { data, loading, error }] = useCreateQuoteModelRevisionAttachmentPartDfmReportMutation({
 *   variables: {
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *      quoteAttachmentRevisionId: // value for 'quoteAttachmentRevisionId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCreateQuoteModelRevisionAttachmentPartDfmReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuoteModelRevisionAttachmentPartDfmReportMutation, CreateQuoteModelRevisionAttachmentPartDfmReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuoteModelRevisionAttachmentPartDfmReportMutation, CreateQuoteModelRevisionAttachmentPartDfmReportMutationVariables>(CreateQuoteModelRevisionAttachmentPartDfmReportDocument, options);
      }
export type CreateQuoteModelRevisionAttachmentPartDfmReportMutationHookResult = ReturnType<typeof useCreateQuoteModelRevisionAttachmentPartDfmReportMutation>;
export type CreateQuoteModelRevisionAttachmentPartDfmReportMutationResult = Apollo.MutationResult<CreateQuoteModelRevisionAttachmentPartDfmReportMutation>;
export type CreateQuoteModelRevisionAttachmentPartDfmReportMutationOptions = Apollo.BaseMutationOptions<CreateQuoteModelRevisionAttachmentPartDfmReportMutation, CreateQuoteModelRevisionAttachmentPartDfmReportMutationVariables>;
export const ClassACalculatorPendingPriceQueryDocument = gql`
    query classACalculatorPendingPriceQuery($qmrId: UUID!, $partComplexity: String!) {
  getPendingClassACalculatorDomesticAndOverseasPrice(
    qmrId: $qmrId
    partComplexity: $partComplexity
  ) {
    classANonRecurringCostsInCents {
      usa
    }
    classAProductionCostsInCents {
      usa
    }
  }
}
    `;

/**
 * __useClassACalculatorPendingPriceQueryQuery__
 *
 * To run a query within a React component, call `useClassACalculatorPendingPriceQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassACalculatorPendingPriceQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassACalculatorPendingPriceQueryQuery({
 *   variables: {
 *      qmrId: // value for 'qmrId'
 *      partComplexity: // value for 'partComplexity'
 *   },
 * });
 */
export function useClassACalculatorPendingPriceQueryQuery(baseOptions: Apollo.QueryHookOptions<ClassACalculatorPendingPriceQueryQuery, ClassACalculatorPendingPriceQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassACalculatorPendingPriceQueryQuery, ClassACalculatorPendingPriceQueryQueryVariables>(ClassACalculatorPendingPriceQueryDocument, options);
      }
export function useClassACalculatorPendingPriceQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassACalculatorPendingPriceQueryQuery, ClassACalculatorPendingPriceQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassACalculatorPendingPriceQueryQuery, ClassACalculatorPendingPriceQueryQueryVariables>(ClassACalculatorPendingPriceQueryDocument, options);
        }
export type ClassACalculatorPendingPriceQueryQueryHookResult = ReturnType<typeof useClassACalculatorPendingPriceQueryQuery>;
export type ClassACalculatorPendingPriceQueryLazyQueryHookResult = ReturnType<typeof useClassACalculatorPendingPriceQueryLazyQuery>;
export type ClassACalculatorPendingPriceQueryQueryResult = Apollo.QueryResult<ClassACalculatorPendingPriceQueryQuery, ClassACalculatorPendingPriceQueryQueryVariables>;
export function refetchClassACalculatorPendingPriceQueryQuery(variables: ClassACalculatorPendingPriceQueryQueryVariables) {
      return { query: ClassACalculatorPendingPriceQueryDocument, variables: variables }
    }
export const MaterialsAdminQuotingPageDocument = gql`
    query materialsAdminQuotingPage($processId: String!) {
  materials(processId: $processId) {
    id
    name
  }
}
    `;

/**
 * __useMaterialsAdminQuotingPageQuery__
 *
 * To run a query within a React component, call `useMaterialsAdminQuotingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialsAdminQuotingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialsAdminQuotingPageQuery({
 *   variables: {
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useMaterialsAdminQuotingPageQuery(baseOptions: Apollo.QueryHookOptions<MaterialsAdminQuotingPageQuery, MaterialsAdminQuotingPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaterialsAdminQuotingPageQuery, MaterialsAdminQuotingPageQueryVariables>(MaterialsAdminQuotingPageDocument, options);
      }
export function useMaterialsAdminQuotingPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaterialsAdminQuotingPageQuery, MaterialsAdminQuotingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaterialsAdminQuotingPageQuery, MaterialsAdminQuotingPageQueryVariables>(MaterialsAdminQuotingPageDocument, options);
        }
export type MaterialsAdminQuotingPageQueryHookResult = ReturnType<typeof useMaterialsAdminQuotingPageQuery>;
export type MaterialsAdminQuotingPageLazyQueryHookResult = ReturnType<typeof useMaterialsAdminQuotingPageLazyQuery>;
export type MaterialsAdminQuotingPageQueryResult = Apollo.QueryResult<MaterialsAdminQuotingPageQuery, MaterialsAdminQuotingPageQueryVariables>;
export function refetchMaterialsAdminQuotingPageQuery(variables: MaterialsAdminQuotingPageQueryVariables) {
      return { query: MaterialsAdminQuotingPageDocument, variables: variables }
    }
export const CalculateQuoteModelRevisionPendingPricesDocument = gql`
    query calculateQuoteModelRevisionPendingPrices($quoteModelRevisionId: UUID!, $inspectionData: InspectionDataInput, $modelConfigOverrides: [ConfigInput!], $operationRegion: String) {
  calculateQuoteModelRevisionPendingPrices(
    quoteModelRevisionId: $quoteModelRevisionId
    inspectionData: $inspectionData
    modelConfigOverrides: $modelConfigOverrides
    operationRegion: $operationRegion
  ) {
    builderPrice {
      ... on ExactPrice {
        priceInCents
        unitPriceInCents
      }
      ... on EstimatedPrice {
        lowPriceInCents
        lowUnitPriceInCents
        highPriceInCents
        highUnitPriceInCents
      }
    }
    manufacturingPartnerPrice {
      ... on ExactPrice {
        priceInCents
        unitPriceInCents
      }
      ... on EstimatedPrice {
        lowPriceInCents
        lowUnitPriceInCents
        highPriceInCents
        highUnitPriceInCents
      }
    }
    granularPricingData {
      ... on GranularCncPricingData {
        setupPricingInCents
        camTimePricingInCents
        fixturePricingInCents
        threadsPricingInCents
        tightTolerancePricingInCents
        scrapRate
        cncPricingBreakdown
      }
    }
    leadTimeData {
      rush
      standard
      economy
      flex
      saver
      overseas
    }
    markupData {
      rush
      standard
      economy
      flex
      saver
      overseas
    }
  }
}
    `;

/**
 * __useCalculateQuoteModelRevisionPendingPricesQuery__
 *
 * To run a query within a React component, call `useCalculateQuoteModelRevisionPendingPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateQuoteModelRevisionPendingPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateQuoteModelRevisionPendingPricesQuery({
 *   variables: {
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *      inspectionData: // value for 'inspectionData'
 *      modelConfigOverrides: // value for 'modelConfigOverrides'
 *      operationRegion: // value for 'operationRegion'
 *   },
 * });
 */
export function useCalculateQuoteModelRevisionPendingPricesQuery(baseOptions: Apollo.QueryHookOptions<CalculateQuoteModelRevisionPendingPricesQuery, CalculateQuoteModelRevisionPendingPricesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateQuoteModelRevisionPendingPricesQuery, CalculateQuoteModelRevisionPendingPricesQueryVariables>(CalculateQuoteModelRevisionPendingPricesDocument, options);
      }
export function useCalculateQuoteModelRevisionPendingPricesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateQuoteModelRevisionPendingPricesQuery, CalculateQuoteModelRevisionPendingPricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateQuoteModelRevisionPendingPricesQuery, CalculateQuoteModelRevisionPendingPricesQueryVariables>(CalculateQuoteModelRevisionPendingPricesDocument, options);
        }
export type CalculateQuoteModelRevisionPendingPricesQueryHookResult = ReturnType<typeof useCalculateQuoteModelRevisionPendingPricesQuery>;
export type CalculateQuoteModelRevisionPendingPricesLazyQueryHookResult = ReturnType<typeof useCalculateQuoteModelRevisionPendingPricesLazyQuery>;
export type CalculateQuoteModelRevisionPendingPricesQueryResult = Apollo.QueryResult<CalculateQuoteModelRevisionPendingPricesQuery, CalculateQuoteModelRevisionPendingPricesQueryVariables>;
export function refetchCalculateQuoteModelRevisionPendingPricesQuery(variables: CalculateQuoteModelRevisionPendingPricesQueryVariables) {
      return { query: CalculateQuoteModelRevisionPendingPricesDocument, variables: variables }
    }
export const GetBusinessAccountDiscountAdminQuotingPageQueryDocument = gql`
    query getBusinessAccountDiscountAdminQuotingPageQuery($id: UUID!, $showDeleted: Boolean) {
  quoteModelRevision(id: $id, showDeleted: $showDeleted) {
    id
    quoteModel {
      id
      quote {
        id
        businessAccountDiscount {
          id
          percent
        }
      }
    }
  }
}
    `;

/**
 * __useGetBusinessAccountDiscountAdminQuotingPageQueryQuery__
 *
 * To run a query within a React component, call `useGetBusinessAccountDiscountAdminQuotingPageQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessAccountDiscountAdminQuotingPageQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessAccountDiscountAdminQuotingPageQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      showDeleted: // value for 'showDeleted'
 *   },
 * });
 */
export function useGetBusinessAccountDiscountAdminQuotingPageQueryQuery(baseOptions: Apollo.QueryHookOptions<GetBusinessAccountDiscountAdminQuotingPageQueryQuery, GetBusinessAccountDiscountAdminQuotingPageQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessAccountDiscountAdminQuotingPageQueryQuery, GetBusinessAccountDiscountAdminQuotingPageQueryQueryVariables>(GetBusinessAccountDiscountAdminQuotingPageQueryDocument, options);
      }
export function useGetBusinessAccountDiscountAdminQuotingPageQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessAccountDiscountAdminQuotingPageQueryQuery, GetBusinessAccountDiscountAdminQuotingPageQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessAccountDiscountAdminQuotingPageQueryQuery, GetBusinessAccountDiscountAdminQuotingPageQueryQueryVariables>(GetBusinessAccountDiscountAdminQuotingPageQueryDocument, options);
        }
export type GetBusinessAccountDiscountAdminQuotingPageQueryQueryHookResult = ReturnType<typeof useGetBusinessAccountDiscountAdminQuotingPageQueryQuery>;
export type GetBusinessAccountDiscountAdminQuotingPageQueryLazyQueryHookResult = ReturnType<typeof useGetBusinessAccountDiscountAdminQuotingPageQueryLazyQuery>;
export type GetBusinessAccountDiscountAdminQuotingPageQueryQueryResult = Apollo.QueryResult<GetBusinessAccountDiscountAdminQuotingPageQueryQuery, GetBusinessAccountDiscountAdminQuotingPageQueryQueryVariables>;
export function refetchGetBusinessAccountDiscountAdminQuotingPageQueryQuery(variables: GetBusinessAccountDiscountAdminQuotingPageQueryQueryVariables) {
      return { query: GetBusinessAccountDiscountAdminQuotingPageQueryDocument, variables: variables }
    }
export const GetProjectIdQueryDocument = gql`
    query getProjectIdQuery($id: UUID!, $showDeleted: Boolean) {
  quoteModelRevision(id: $id, showDeleted: $showDeleted) {
    id
    quoteModel {
      id
      quote {
        id
        project {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetProjectIdQueryQuery__
 *
 * To run a query within a React component, call `useGetProjectIdQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectIdQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectIdQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      showDeleted: // value for 'showDeleted'
 *   },
 * });
 */
export function useGetProjectIdQueryQuery(baseOptions: Apollo.QueryHookOptions<GetProjectIdQueryQuery, GetProjectIdQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectIdQueryQuery, GetProjectIdQueryQueryVariables>(GetProjectIdQueryDocument, options);
      }
export function useGetProjectIdQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectIdQueryQuery, GetProjectIdQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectIdQueryQuery, GetProjectIdQueryQueryVariables>(GetProjectIdQueryDocument, options);
        }
export type GetProjectIdQueryQueryHookResult = ReturnType<typeof useGetProjectIdQueryQuery>;
export type GetProjectIdQueryLazyQueryHookResult = ReturnType<typeof useGetProjectIdQueryLazyQuery>;
export type GetProjectIdQueryQueryResult = Apollo.QueryResult<GetProjectIdQueryQuery, GetProjectIdQueryQueryVariables>;
export function refetchGetProjectIdQueryQuery(variables: GetProjectIdQueryQueryVariables) {
      return { query: GetProjectIdQueryDocument, variables: variables }
    }
export const AdminQuoteModelRevisionAttachmentDocument = gql`
    query adminQuoteModelRevisionAttachment($id: UUID!, $showDeleted: Boolean) {
  quoteModelRevision(id: $id, showDeleted: $showDeleted) {
    id
    attachmentLink {
      id
      quoteAttachmentRevision {
        id
        attachment {
          ... on Attachment {
            id
            downloadUrl
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAdminQuoteModelRevisionAttachmentQuery__
 *
 * To run a query within a React component, call `useAdminQuoteModelRevisionAttachmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminQuoteModelRevisionAttachmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminQuoteModelRevisionAttachmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      showDeleted: // value for 'showDeleted'
 *   },
 * });
 */
export function useAdminQuoteModelRevisionAttachmentQuery(baseOptions: Apollo.QueryHookOptions<AdminQuoteModelRevisionAttachmentQuery, AdminQuoteModelRevisionAttachmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminQuoteModelRevisionAttachmentQuery, AdminQuoteModelRevisionAttachmentQueryVariables>(AdminQuoteModelRevisionAttachmentDocument, options);
      }
export function useAdminQuoteModelRevisionAttachmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminQuoteModelRevisionAttachmentQuery, AdminQuoteModelRevisionAttachmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminQuoteModelRevisionAttachmentQuery, AdminQuoteModelRevisionAttachmentQueryVariables>(AdminQuoteModelRevisionAttachmentDocument, options);
        }
export type AdminQuoteModelRevisionAttachmentQueryHookResult = ReturnType<typeof useAdminQuoteModelRevisionAttachmentQuery>;
export type AdminQuoteModelRevisionAttachmentLazyQueryHookResult = ReturnType<typeof useAdminQuoteModelRevisionAttachmentLazyQuery>;
export type AdminQuoteModelRevisionAttachmentQueryResult = Apollo.QueryResult<AdminQuoteModelRevisionAttachmentQuery, AdminQuoteModelRevisionAttachmentQueryVariables>;
export function refetchAdminQuoteModelRevisionAttachmentQuery(variables: AdminQuoteModelRevisionAttachmentQueryVariables) {
      return { query: AdminQuoteModelRevisionAttachmentDocument, variables: variables }
    }
export const QuantityRangesQueryDocument = gql`
    query quantityRangesQuery {
  quantityRanges {
    id
    quantityLowerRange
    quantityUpperRange
  }
}
    `;

/**
 * __useQuantityRangesQueryQuery__
 *
 * To run a query within a React component, call `useQuantityRangesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuantityRangesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuantityRangesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useQuantityRangesQueryQuery(baseOptions?: Apollo.QueryHookOptions<QuantityRangesQueryQuery, QuantityRangesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuantityRangesQueryQuery, QuantityRangesQueryQueryVariables>(QuantityRangesQueryDocument, options);
      }
export function useQuantityRangesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuantityRangesQueryQuery, QuantityRangesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuantityRangesQueryQuery, QuantityRangesQueryQueryVariables>(QuantityRangesQueryDocument, options);
        }
export type QuantityRangesQueryQueryHookResult = ReturnType<typeof useQuantityRangesQueryQuery>;
export type QuantityRangesQueryLazyQueryHookResult = ReturnType<typeof useQuantityRangesQueryLazyQuery>;
export type QuantityRangesQueryQueryResult = Apollo.QueryResult<QuantityRangesQueryQuery, QuantityRangesQueryQueryVariables>;
export function refetchQuantityRangesQueryQuery(variables?: QuantityRangesQueryQueryVariables) {
      return { query: QuantityRangesQueryDocument, variables: variables }
    }
export const GenerateModelConfigurationDfmInspectionDocument = gql`
    query generateModelConfigurationDfmInspection($quoteModelRevisionId: UUID!, $modelConfigOverrides: ConfigInput!) {
  generateModelConfigurationDfmInspection(
    quoteModelRevisionId: $quoteModelRevisionId
    modelConfigOverrides: $modelConfigOverrides
  ) {
    id
    quantityLowerRange
    quantityUpperRange
    inspectionData
    isPublished
  }
}
    `;

/**
 * __useGenerateModelConfigurationDfmInspectionQuery__
 *
 * To run a query within a React component, call `useGenerateModelConfigurationDfmInspectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateModelConfigurationDfmInspectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateModelConfigurationDfmInspectionQuery({
 *   variables: {
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *      modelConfigOverrides: // value for 'modelConfigOverrides'
 *   },
 * });
 */
export function useGenerateModelConfigurationDfmInspectionQuery(baseOptions: Apollo.QueryHookOptions<GenerateModelConfigurationDfmInspectionQuery, GenerateModelConfigurationDfmInspectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateModelConfigurationDfmInspectionQuery, GenerateModelConfigurationDfmInspectionQueryVariables>(GenerateModelConfigurationDfmInspectionDocument, options);
      }
export function useGenerateModelConfigurationDfmInspectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateModelConfigurationDfmInspectionQuery, GenerateModelConfigurationDfmInspectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateModelConfigurationDfmInspectionQuery, GenerateModelConfigurationDfmInspectionQueryVariables>(GenerateModelConfigurationDfmInspectionDocument, options);
        }
export type GenerateModelConfigurationDfmInspectionQueryHookResult = ReturnType<typeof useGenerateModelConfigurationDfmInspectionQuery>;
export type GenerateModelConfigurationDfmInspectionLazyQueryHookResult = ReturnType<typeof useGenerateModelConfigurationDfmInspectionLazyQuery>;
export type GenerateModelConfigurationDfmInspectionQueryResult = Apollo.QueryResult<GenerateModelConfigurationDfmInspectionQuery, GenerateModelConfigurationDfmInspectionQueryVariables>;
export function refetchGenerateModelConfigurationDfmInspectionQuery(variables: GenerateModelConfigurationDfmInspectionQueryVariables) {
      return { query: GenerateModelConfigurationDfmInspectionDocument, variables: variables }
    }
export const SimilarQuoteModelRevisionsQueryDocument = gql`
    query similarQuoteModelRevisionsQuery($quoteModelRevisionId: UUID!) {
  quoteModelRevision(id: $quoteModelRevisionId) {
    id
    similarQuoteModelRevisions {
      id
      version
      fileName
      state
      partRevision {
        id
        thumbnailUri
        isMirror
      }
      processesDetails {
        totalPrice {
          ... on ExactPrice {
            priceInCents
            unitPriceInCents
          }
          ... on EstimatedPrice {
            lowPriceInCents
            lowUnitPriceInCents
            highPriceInCents
            highUnitPriceInCents
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSimilarQuoteModelRevisionsQueryQuery__
 *
 * To run a query within a React component, call `useSimilarQuoteModelRevisionsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimilarQuoteModelRevisionsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimilarQuoteModelRevisionsQueryQuery({
 *   variables: {
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *   },
 * });
 */
export function useSimilarQuoteModelRevisionsQueryQuery(baseOptions: Apollo.QueryHookOptions<SimilarQuoteModelRevisionsQueryQuery, SimilarQuoteModelRevisionsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SimilarQuoteModelRevisionsQueryQuery, SimilarQuoteModelRevisionsQueryQueryVariables>(SimilarQuoteModelRevisionsQueryDocument, options);
      }
export function useSimilarQuoteModelRevisionsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SimilarQuoteModelRevisionsQueryQuery, SimilarQuoteModelRevisionsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SimilarQuoteModelRevisionsQueryQuery, SimilarQuoteModelRevisionsQueryQueryVariables>(SimilarQuoteModelRevisionsQueryDocument, options);
        }
export type SimilarQuoteModelRevisionsQueryQueryHookResult = ReturnType<typeof useSimilarQuoteModelRevisionsQueryQuery>;
export type SimilarQuoteModelRevisionsQueryLazyQueryHookResult = ReturnType<typeof useSimilarQuoteModelRevisionsQueryLazyQuery>;
export type SimilarQuoteModelRevisionsQueryQueryResult = Apollo.QueryResult<SimilarQuoteModelRevisionsQueryQuery, SimilarQuoteModelRevisionsQueryQueryVariables>;
export function refetchSimilarQuoteModelRevisionsQueryQuery(variables: SimilarQuoteModelRevisionsQueryQueryVariables) {
      return { query: SimilarQuoteModelRevisionsQueryDocument, variables: variables }
    }
export const AdminQmrLastUpdatedDocument = gql`
    query adminQmrLastUpdated($id: UUID!) {
  quoteModelRevision(id: $id) {
    id
    partRevision {
      id
      updatedAt
    }
  }
}
    `;

/**
 * __useAdminQmrLastUpdatedQuery__
 *
 * To run a query within a React component, call `useAdminQmrLastUpdatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminQmrLastUpdatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminQmrLastUpdatedQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminQmrLastUpdatedQuery(baseOptions: Apollo.QueryHookOptions<AdminQmrLastUpdatedQuery, AdminQmrLastUpdatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminQmrLastUpdatedQuery, AdminQmrLastUpdatedQueryVariables>(AdminQmrLastUpdatedDocument, options);
      }
export function useAdminQmrLastUpdatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminQmrLastUpdatedQuery, AdminQmrLastUpdatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminQmrLastUpdatedQuery, AdminQmrLastUpdatedQueryVariables>(AdminQmrLastUpdatedDocument, options);
        }
export type AdminQmrLastUpdatedQueryHookResult = ReturnType<typeof useAdminQmrLastUpdatedQuery>;
export type AdminQmrLastUpdatedLazyQueryHookResult = ReturnType<typeof useAdminQmrLastUpdatedLazyQuery>;
export type AdminQmrLastUpdatedQueryResult = Apollo.QueryResult<AdminQmrLastUpdatedQuery, AdminQmrLastUpdatedQueryVariables>;
export function refetchAdminQmrLastUpdatedQuery(variables: AdminQmrLastUpdatedQueryVariables) {
      return { query: AdminQmrLastUpdatedDocument, variables: variables }
    }
export const DestroyDfmFeedbackDocument = gql`
    mutation destroyDfmFeedback($dfmFeedbackId: UUID!) {
  destroyDfmFeedback(dfmFeedbackId: $dfmFeedbackId) {
    id
  }
}
    `;
export type DestroyDfmFeedbackMutationFn = Apollo.MutationFunction<DestroyDfmFeedbackMutation, DestroyDfmFeedbackMutationVariables>;

/**
 * __useDestroyDfmFeedbackMutation__
 *
 * To run a mutation, you first call `useDestroyDfmFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyDfmFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyDfmFeedbackMutation, { data, loading, error }] = useDestroyDfmFeedbackMutation({
 *   variables: {
 *      dfmFeedbackId: // value for 'dfmFeedbackId'
 *   },
 * });
 */
export function useDestroyDfmFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<DestroyDfmFeedbackMutation, DestroyDfmFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroyDfmFeedbackMutation, DestroyDfmFeedbackMutationVariables>(DestroyDfmFeedbackDocument, options);
      }
export type DestroyDfmFeedbackMutationHookResult = ReturnType<typeof useDestroyDfmFeedbackMutation>;
export type DestroyDfmFeedbackMutationResult = Apollo.MutationResult<DestroyDfmFeedbackMutation>;
export type DestroyDfmFeedbackMutationOptions = Apollo.BaseMutationOptions<DestroyDfmFeedbackMutation, DestroyDfmFeedbackMutationVariables>;
export const UpdateDfmFeedbackInfoDocument = gql`
    mutation updateDfmFeedbackInfo($dfmFeedbackId: UUID!, $severity: String, $message: String, $isPublished: Boolean, $title: String, $link: String, $code: String) {
  updateDfmFeedbackInfo(
    dfmFeedbackId: $dfmFeedbackId
    severity: $severity
    message: $message
    isPublished: $isPublished
    title: $title
    link: $link
    code: $code
  ) {
    id
  }
}
    `;
export type UpdateDfmFeedbackInfoMutationFn = Apollo.MutationFunction<UpdateDfmFeedbackInfoMutation, UpdateDfmFeedbackInfoMutationVariables>;

/**
 * __useUpdateDfmFeedbackInfoMutation__
 *
 * To run a mutation, you first call `useUpdateDfmFeedbackInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDfmFeedbackInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDfmFeedbackInfoMutation, { data, loading, error }] = useUpdateDfmFeedbackInfoMutation({
 *   variables: {
 *      dfmFeedbackId: // value for 'dfmFeedbackId'
 *      severity: // value for 'severity'
 *      message: // value for 'message'
 *      isPublished: // value for 'isPublished'
 *      title: // value for 'title'
 *      link: // value for 'link'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useUpdateDfmFeedbackInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDfmFeedbackInfoMutation, UpdateDfmFeedbackInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDfmFeedbackInfoMutation, UpdateDfmFeedbackInfoMutationVariables>(UpdateDfmFeedbackInfoDocument, options);
      }
export type UpdateDfmFeedbackInfoMutationHookResult = ReturnType<typeof useUpdateDfmFeedbackInfoMutation>;
export type UpdateDfmFeedbackInfoMutationResult = Apollo.MutationResult<UpdateDfmFeedbackInfoMutation>;
export type UpdateDfmFeedbackInfoMutationOptions = Apollo.BaseMutationOptions<UpdateDfmFeedbackInfoMutation, UpdateDfmFeedbackInfoMutationVariables>;
export const CreateModelViewerSnapshotDocument = gql`
    mutation createModelViewerSnapshot($quoteModelRevisionId: UUID!, $position: JSON!, $target: JSON!, $feature: String!, $type: String!, $snapshot: ModelViewerConfigInput!) {
  createModelViewerSnapshot(
    attrs: {quoteModelRevisionId: $quoteModelRevisionId, position: $position, target: $target, feature: $feature, type: $type, snapshot: $snapshot}
  ) {
    id
  }
}
    `;
export type CreateModelViewerSnapshotMutationFn = Apollo.MutationFunction<CreateModelViewerSnapshotMutation, CreateModelViewerSnapshotMutationVariables>;

/**
 * __useCreateModelViewerSnapshotMutation__
 *
 * To run a mutation, you first call `useCreateModelViewerSnapshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateModelViewerSnapshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createModelViewerSnapshotMutation, { data, loading, error }] = useCreateModelViewerSnapshotMutation({
 *   variables: {
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *      position: // value for 'position'
 *      target: // value for 'target'
 *      feature: // value for 'feature'
 *      type: // value for 'type'
 *      snapshot: // value for 'snapshot'
 *   },
 * });
 */
export function useCreateModelViewerSnapshotMutation(baseOptions?: Apollo.MutationHookOptions<CreateModelViewerSnapshotMutation, CreateModelViewerSnapshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateModelViewerSnapshotMutation, CreateModelViewerSnapshotMutationVariables>(CreateModelViewerSnapshotDocument, options);
      }
export type CreateModelViewerSnapshotMutationHookResult = ReturnType<typeof useCreateModelViewerSnapshotMutation>;
export type CreateModelViewerSnapshotMutationResult = Apollo.MutationResult<CreateModelViewerSnapshotMutation>;
export type CreateModelViewerSnapshotMutationOptions = Apollo.BaseMutationOptions<CreateModelViewerSnapshotMutation, CreateModelViewerSnapshotMutationVariables>;
export const UpdateModelViewerSnapshotDocument = gql`
    mutation updateModelViewerSnapshot($dfmSnapshotId: UUID!, $attrs: ModelViewerSnapshotInput!) {
  updateModelViewerSnapshot(dfmSnapshotId: $dfmSnapshotId, attrs: $attrs) {
    id
  }
}
    `;
export type UpdateModelViewerSnapshotMutationFn = Apollo.MutationFunction<UpdateModelViewerSnapshotMutation, UpdateModelViewerSnapshotMutationVariables>;

/**
 * __useUpdateModelViewerSnapshotMutation__
 *
 * To run a mutation, you first call `useUpdateModelViewerSnapshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModelViewerSnapshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModelViewerSnapshotMutation, { data, loading, error }] = useUpdateModelViewerSnapshotMutation({
 *   variables: {
 *      dfmSnapshotId: // value for 'dfmSnapshotId'
 *      attrs: // value for 'attrs'
 *   },
 * });
 */
export function useUpdateModelViewerSnapshotMutation(baseOptions?: Apollo.MutationHookOptions<UpdateModelViewerSnapshotMutation, UpdateModelViewerSnapshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateModelViewerSnapshotMutation, UpdateModelViewerSnapshotMutationVariables>(UpdateModelViewerSnapshotDocument, options);
      }
export type UpdateModelViewerSnapshotMutationHookResult = ReturnType<typeof useUpdateModelViewerSnapshotMutation>;
export type UpdateModelViewerSnapshotMutationResult = Apollo.MutationResult<UpdateModelViewerSnapshotMutation>;
export type UpdateModelViewerSnapshotMutationOptions = Apollo.BaseMutationOptions<UpdateModelViewerSnapshotMutation, UpdateModelViewerSnapshotMutationVariables>;
export const CreateModelConfigurationDfmFeedbackDocument = gql`
    mutation createModelConfigurationDfmFeedback($modelConfigurationId: UUID!, $modelViewerSnapshotId: UUID!, $severity: String!, $message: String!, $title: String, $link: String, $code: String) {
  createModelConfigurationDfmFeedback(
    attrs: {modelConfigurationId: $modelConfigurationId, modelViewerSnapshotId: $modelViewerSnapshotId, severity: $severity, message: $message, title: $title, link: $link, code: $code}
  ) {
    id
  }
}
    `;
export type CreateModelConfigurationDfmFeedbackMutationFn = Apollo.MutationFunction<CreateModelConfigurationDfmFeedbackMutation, CreateModelConfigurationDfmFeedbackMutationVariables>;

/**
 * __useCreateModelConfigurationDfmFeedbackMutation__
 *
 * To run a mutation, you first call `useCreateModelConfigurationDfmFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateModelConfigurationDfmFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createModelConfigurationDfmFeedbackMutation, { data, loading, error }] = useCreateModelConfigurationDfmFeedbackMutation({
 *   variables: {
 *      modelConfigurationId: // value for 'modelConfigurationId'
 *      modelViewerSnapshotId: // value for 'modelViewerSnapshotId'
 *      severity: // value for 'severity'
 *      message: // value for 'message'
 *      title: // value for 'title'
 *      link: // value for 'link'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useCreateModelConfigurationDfmFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<CreateModelConfigurationDfmFeedbackMutation, CreateModelConfigurationDfmFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateModelConfigurationDfmFeedbackMutation, CreateModelConfigurationDfmFeedbackMutationVariables>(CreateModelConfigurationDfmFeedbackDocument, options);
      }
export type CreateModelConfigurationDfmFeedbackMutationHookResult = ReturnType<typeof useCreateModelConfigurationDfmFeedbackMutation>;
export type CreateModelConfigurationDfmFeedbackMutationResult = Apollo.MutationResult<CreateModelConfigurationDfmFeedbackMutation>;
export type CreateModelConfigurationDfmFeedbackMutationOptions = Apollo.BaseMutationOptions<CreateModelConfigurationDfmFeedbackMutation, CreateModelConfigurationDfmFeedbackMutationVariables>;
export const UpdateModelConfigurationDfmInspectionDocument = gql`
    mutation updateModelConfigurationDfmInspection($modelConfigurationDfmInspectionId: UUID!, $inspectionData: InspectionDataInput!, $lastModifiedAt: Date, $override: Boolean, $isQuantityRangeAvailable: Boolean) {
  updateModelConfigurationDfmInspection(
    modelConfigurationDfmInspectionId: $modelConfigurationDfmInspectionId
    inspectionData: $inspectionData
    lastModifiedAt: $lastModifiedAt
    override: $override
    isQuantityRangeAvailable: $isQuantityRangeAvailable
  ) {
    id
  }
}
    `;
export type UpdateModelConfigurationDfmInspectionMutationFn = Apollo.MutationFunction<UpdateModelConfigurationDfmInspectionMutation, UpdateModelConfigurationDfmInspectionMutationVariables>;

/**
 * __useUpdateModelConfigurationDfmInspectionMutation__
 *
 * To run a mutation, you first call `useUpdateModelConfigurationDfmInspectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModelConfigurationDfmInspectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModelConfigurationDfmInspectionMutation, { data, loading, error }] = useUpdateModelConfigurationDfmInspectionMutation({
 *   variables: {
 *      modelConfigurationDfmInspectionId: // value for 'modelConfigurationDfmInspectionId'
 *      inspectionData: // value for 'inspectionData'
 *      lastModifiedAt: // value for 'lastModifiedAt'
 *      override: // value for 'override'
 *      isQuantityRangeAvailable: // value for 'isQuantityRangeAvailable'
 *   },
 * });
 */
export function useUpdateModelConfigurationDfmInspectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateModelConfigurationDfmInspectionMutation, UpdateModelConfigurationDfmInspectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateModelConfigurationDfmInspectionMutation, UpdateModelConfigurationDfmInspectionMutationVariables>(UpdateModelConfigurationDfmInspectionDocument, options);
      }
export type UpdateModelConfigurationDfmInspectionMutationHookResult = ReturnType<typeof useUpdateModelConfigurationDfmInspectionMutation>;
export type UpdateModelConfigurationDfmInspectionMutationResult = Apollo.MutationResult<UpdateModelConfigurationDfmInspectionMutation>;
export type UpdateModelConfigurationDfmInspectionMutationOptions = Apollo.BaseMutationOptions<UpdateModelConfigurationDfmInspectionMutation, UpdateModelConfigurationDfmInspectionMutationVariables>;
export const AddModelConfigurationDfmInspectionDocument = gql`
    mutation addModelConfigurationDfmInspection($modelConfigurationId: UUID!, $inspectionData: InspectionDataInput!, $quantityRangeData: QuantityRangeInput!) {
  addModelConfigurationDfmInspection(
    modelConfigurationId: $modelConfigurationId
    inspectionData: $inspectionData
    quantityRangeData: $quantityRangeData
  ) {
    id
    quantityLowerRange
    quantityUpperRange
    isQuantityRangeAvailable
    isPublished
    updatedBy {
      id
    }
    inspectionData
  }
}
    `;
export type AddModelConfigurationDfmInspectionMutationFn = Apollo.MutationFunction<AddModelConfigurationDfmInspectionMutation, AddModelConfigurationDfmInspectionMutationVariables>;

/**
 * __useAddModelConfigurationDfmInspectionMutation__
 *
 * To run a mutation, you first call `useAddModelConfigurationDfmInspectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddModelConfigurationDfmInspectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addModelConfigurationDfmInspectionMutation, { data, loading, error }] = useAddModelConfigurationDfmInspectionMutation({
 *   variables: {
 *      modelConfigurationId: // value for 'modelConfigurationId'
 *      inspectionData: // value for 'inspectionData'
 *      quantityRangeData: // value for 'quantityRangeData'
 *   },
 * });
 */
export function useAddModelConfigurationDfmInspectionMutation(baseOptions?: Apollo.MutationHookOptions<AddModelConfigurationDfmInspectionMutation, AddModelConfigurationDfmInspectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddModelConfigurationDfmInspectionMutation, AddModelConfigurationDfmInspectionMutationVariables>(AddModelConfigurationDfmInspectionDocument, options);
      }
export type AddModelConfigurationDfmInspectionMutationHookResult = ReturnType<typeof useAddModelConfigurationDfmInspectionMutation>;
export type AddModelConfigurationDfmInspectionMutationResult = Apollo.MutationResult<AddModelConfigurationDfmInspectionMutation>;
export type AddModelConfigurationDfmInspectionMutationOptions = Apollo.BaseMutationOptions<AddModelConfigurationDfmInspectionMutation, AddModelConfigurationDfmInspectionMutationVariables>;
export const PublishQuoteModelRevisionDocument = gql`
    mutation publishQuoteModelRevision($quoteModelRevisionId: UUID!, $quantityLowerRange: Int, $quantityUpperRange: Int) {
  publishQuoteModelRevision(
    quoteModelRevisionId: $quoteModelRevisionId
    quantityLowerRange: $quantityLowerRange
    quantityUpperRange: $quantityUpperRange
  ) {
    id
  }
}
    `;
export type PublishQuoteModelRevisionMutationFn = Apollo.MutationFunction<PublishQuoteModelRevisionMutation, PublishQuoteModelRevisionMutationVariables>;

/**
 * __usePublishQuoteModelRevisionMutation__
 *
 * To run a mutation, you first call `usePublishQuoteModelRevisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishQuoteModelRevisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishQuoteModelRevisionMutation, { data, loading, error }] = usePublishQuoteModelRevisionMutation({
 *   variables: {
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *      quantityLowerRange: // value for 'quantityLowerRange'
 *      quantityUpperRange: // value for 'quantityUpperRange'
 *   },
 * });
 */
export function usePublishQuoteModelRevisionMutation(baseOptions?: Apollo.MutationHookOptions<PublishQuoteModelRevisionMutation, PublishQuoteModelRevisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishQuoteModelRevisionMutation, PublishQuoteModelRevisionMutationVariables>(PublishQuoteModelRevisionDocument, options);
      }
export type PublishQuoteModelRevisionMutationHookResult = ReturnType<typeof usePublishQuoteModelRevisionMutation>;
export type PublishQuoteModelRevisionMutationResult = Apollo.MutationResult<PublishQuoteModelRevisionMutation>;
export type PublishQuoteModelRevisionMutationOptions = Apollo.BaseMutationOptions<PublishQuoteModelRevisionMutation, PublishQuoteModelRevisionMutationVariables>;
export const GetPdfOcrOutputDocument = gql`
    query getPdfOcrOutput($quoteModelRevisionId: UUID!) {
  getRawPdfOcrJson(quoteModelRevisionId: $quoteModelRevisionId) {
    finishingNotes
    foundThreadNames
    measurementUnits
    minOneSidedTolerance
    minTwoSidedTolerance
    autoQuotableBlockers
    numTightTolerances
    numVeryTightTolerances
    rawAnalysis
    requiresCertificateOfConformance
    requiresMaterialCertificate
    toleranceBlocks {
      textRaw
      symbol
    }
  }
}
    `;

/**
 * __useGetPdfOcrOutputQuery__
 *
 * To run a query within a React component, call `useGetPdfOcrOutputQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPdfOcrOutputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPdfOcrOutputQuery({
 *   variables: {
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *   },
 * });
 */
export function useGetPdfOcrOutputQuery(baseOptions: Apollo.QueryHookOptions<GetPdfOcrOutputQuery, GetPdfOcrOutputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPdfOcrOutputQuery, GetPdfOcrOutputQueryVariables>(GetPdfOcrOutputDocument, options);
      }
export function useGetPdfOcrOutputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPdfOcrOutputQuery, GetPdfOcrOutputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPdfOcrOutputQuery, GetPdfOcrOutputQueryVariables>(GetPdfOcrOutputDocument, options);
        }
export type GetPdfOcrOutputQueryHookResult = ReturnType<typeof useGetPdfOcrOutputQuery>;
export type GetPdfOcrOutputLazyQueryHookResult = ReturnType<typeof useGetPdfOcrOutputLazyQuery>;
export type GetPdfOcrOutputQueryResult = Apollo.QueryResult<GetPdfOcrOutputQuery, GetPdfOcrOutputQueryVariables>;
export function refetchGetPdfOcrOutputQuery(variables: GetPdfOcrOutputQueryVariables) {
      return { query: GetPdfOcrOutputDocument, variables: variables }
    }
export const QuotabilityBlockersAdminQuotingPageDocument = gql`
    query quotabilityBlockersAdminQuotingPage($quoteModelRevisionId: UUID!) {
  quotabilityBlockers(quoteModelRevisionId: $quoteModelRevisionId)
}
    `;

/**
 * __useQuotabilityBlockersAdminQuotingPageQuery__
 *
 * To run a query within a React component, call `useQuotabilityBlockersAdminQuotingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuotabilityBlockersAdminQuotingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuotabilityBlockersAdminQuotingPageQuery({
 *   variables: {
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *   },
 * });
 */
export function useQuotabilityBlockersAdminQuotingPageQuery(baseOptions: Apollo.QueryHookOptions<QuotabilityBlockersAdminQuotingPageQuery, QuotabilityBlockersAdminQuotingPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuotabilityBlockersAdminQuotingPageQuery, QuotabilityBlockersAdminQuotingPageQueryVariables>(QuotabilityBlockersAdminQuotingPageDocument, options);
      }
export function useQuotabilityBlockersAdminQuotingPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuotabilityBlockersAdminQuotingPageQuery, QuotabilityBlockersAdminQuotingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuotabilityBlockersAdminQuotingPageQuery, QuotabilityBlockersAdminQuotingPageQueryVariables>(QuotabilityBlockersAdminQuotingPageDocument, options);
        }
export type QuotabilityBlockersAdminQuotingPageQueryHookResult = ReturnType<typeof useQuotabilityBlockersAdminQuotingPageQuery>;
export type QuotabilityBlockersAdminQuotingPageLazyQueryHookResult = ReturnType<typeof useQuotabilityBlockersAdminQuotingPageLazyQuery>;
export type QuotabilityBlockersAdminQuotingPageQueryResult = Apollo.QueryResult<QuotabilityBlockersAdminQuotingPageQuery, QuotabilityBlockersAdminQuotingPageQueryVariables>;
export function refetchQuotabilityBlockersAdminQuotingPageQuery(variables: QuotabilityBlockersAdminQuotingPageQueryVariables) {
      return { query: QuotabilityBlockersAdminQuotingPageDocument, variables: variables }
    }
export const MarkQuoteModelRevisionFlagsAdminQuotingPageDocument = gql`
    mutation markQuoteModelRevisionFlagsAdminQuotingPage($quoteModelRevisionId: UUID!, $flags: [QmrFlag]) {
  markQuoteModelRevisionFlags(
    quoteModelRevisionId: $quoteModelRevisionId
    flags: $flags
  ) {
    id
    flags
  }
}
    `;
export type MarkQuoteModelRevisionFlagsAdminQuotingPageMutationFn = Apollo.MutationFunction<MarkQuoteModelRevisionFlagsAdminQuotingPageMutation, MarkQuoteModelRevisionFlagsAdminQuotingPageMutationVariables>;

/**
 * __useMarkQuoteModelRevisionFlagsAdminQuotingPageMutation__
 *
 * To run a mutation, you first call `useMarkQuoteModelRevisionFlagsAdminQuotingPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkQuoteModelRevisionFlagsAdminQuotingPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markQuoteModelRevisionFlagsAdminQuotingPageMutation, { data, loading, error }] = useMarkQuoteModelRevisionFlagsAdminQuotingPageMutation({
 *   variables: {
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *      flags: // value for 'flags'
 *   },
 * });
 */
export function useMarkQuoteModelRevisionFlagsAdminQuotingPageMutation(baseOptions?: Apollo.MutationHookOptions<MarkQuoteModelRevisionFlagsAdminQuotingPageMutation, MarkQuoteModelRevisionFlagsAdminQuotingPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkQuoteModelRevisionFlagsAdminQuotingPageMutation, MarkQuoteModelRevisionFlagsAdminQuotingPageMutationVariables>(MarkQuoteModelRevisionFlagsAdminQuotingPageDocument, options);
      }
export type MarkQuoteModelRevisionFlagsAdminQuotingPageMutationHookResult = ReturnType<typeof useMarkQuoteModelRevisionFlagsAdminQuotingPageMutation>;
export type MarkQuoteModelRevisionFlagsAdminQuotingPageMutationResult = Apollo.MutationResult<MarkQuoteModelRevisionFlagsAdminQuotingPageMutation>;
export type MarkQuoteModelRevisionFlagsAdminQuotingPageMutationOptions = Apollo.BaseMutationOptions<MarkQuoteModelRevisionFlagsAdminQuotingPageMutation, MarkQuoteModelRevisionFlagsAdminQuotingPageMutationVariables>;
export const AdminQuotingPageLockQmrToSingleQuoteDocument = gql`
    mutation adminQuotingPageLockQMRToSingleQuote($quoteModelRevisionId: UUID!, $flag: Boolean!) {
  lockQMRToSingleQuote(quoteModelRevisionId: $quoteModelRevisionId, flag: $flag) {
    id
    isExclusiveToSingleQuote
  }
}
    `;
export type AdminQuotingPageLockQmrToSingleQuoteMutationFn = Apollo.MutationFunction<AdminQuotingPageLockQmrToSingleQuoteMutation, AdminQuotingPageLockQmrToSingleQuoteMutationVariables>;

/**
 * __useAdminQuotingPageLockQmrToSingleQuoteMutation__
 *
 * To run a mutation, you first call `useAdminQuotingPageLockQmrToSingleQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminQuotingPageLockQmrToSingleQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminQuotingPageLockQmrToSingleQuoteMutation, { data, loading, error }] = useAdminQuotingPageLockQmrToSingleQuoteMutation({
 *   variables: {
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *      flag: // value for 'flag'
 *   },
 * });
 */
export function useAdminQuotingPageLockQmrToSingleQuoteMutation(baseOptions?: Apollo.MutationHookOptions<AdminQuotingPageLockQmrToSingleQuoteMutation, AdminQuotingPageLockQmrToSingleQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminQuotingPageLockQmrToSingleQuoteMutation, AdminQuotingPageLockQmrToSingleQuoteMutationVariables>(AdminQuotingPageLockQmrToSingleQuoteDocument, options);
      }
export type AdminQuotingPageLockQmrToSingleQuoteMutationHookResult = ReturnType<typeof useAdminQuotingPageLockQmrToSingleQuoteMutation>;
export type AdminQuotingPageLockQmrToSingleQuoteMutationResult = Apollo.MutationResult<AdminQuotingPageLockQmrToSingleQuoteMutation>;
export type AdminQuotingPageLockQmrToSingleQuoteMutationOptions = Apollo.BaseMutationOptions<AdminQuotingPageLockQmrToSingleQuoteMutation, AdminQuotingPageLockQmrToSingleQuoteMutationVariables>;
export const AdminReprocessPartMutationDocument = gql`
    mutation adminReprocessPartMutation($partId: Int!, $reprocessParameters: ReprocessParametersInput) {
  finalizeUploadAndProcessPart(
    partId: $partId
    reprocessParameters: $reprocessParameters
  ) {
    partId
    status
    reason
  }
}
    `;
export type AdminReprocessPartMutationMutationFn = Apollo.MutationFunction<AdminReprocessPartMutationMutation, AdminReprocessPartMutationMutationVariables>;

/**
 * __useAdminReprocessPartMutationMutation__
 *
 * To run a mutation, you first call `useAdminReprocessPartMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminReprocessPartMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminReprocessPartMutationMutation, { data, loading, error }] = useAdminReprocessPartMutationMutation({
 *   variables: {
 *      partId: // value for 'partId'
 *      reprocessParameters: // value for 'reprocessParameters'
 *   },
 * });
 */
export function useAdminReprocessPartMutationMutation(baseOptions?: Apollo.MutationHookOptions<AdminReprocessPartMutationMutation, AdminReprocessPartMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminReprocessPartMutationMutation, AdminReprocessPartMutationMutationVariables>(AdminReprocessPartMutationDocument, options);
      }
export type AdminReprocessPartMutationMutationHookResult = ReturnType<typeof useAdminReprocessPartMutationMutation>;
export type AdminReprocessPartMutationMutationResult = Apollo.MutationResult<AdminReprocessPartMutationMutation>;
export type AdminReprocessPartMutationMutationOptions = Apollo.BaseMutationOptions<AdminReprocessPartMutationMutation, AdminReprocessPartMutationMutationVariables>;
export const AdminOrderSearchDocument = gql`
    query adminOrderSearch($searchString: String!, $from: Int!, $size: Int!) {
  adminOrderSearch(searchString: $searchString, from: $from, size: $size) {
    totalCount
    items {
      ...AdminOrderSearchItem
    }
  }
}
    ${AdminOrderSearchItemFragmentDoc}`;

/**
 * __useAdminOrderSearchQuery__
 *
 * To run a query within a React component, call `useAdminOrderSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminOrderSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOrderSearchQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      from: // value for 'from'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useAdminOrderSearchQuery(baseOptions: Apollo.QueryHookOptions<AdminOrderSearchQuery, AdminOrderSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOrderSearchQuery, AdminOrderSearchQueryVariables>(AdminOrderSearchDocument, options);
      }
export function useAdminOrderSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOrderSearchQuery, AdminOrderSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOrderSearchQuery, AdminOrderSearchQueryVariables>(AdminOrderSearchDocument, options);
        }
export type AdminOrderSearchQueryHookResult = ReturnType<typeof useAdminOrderSearchQuery>;
export type AdminOrderSearchLazyQueryHookResult = ReturnType<typeof useAdminOrderSearchLazyQuery>;
export type AdminOrderSearchQueryResult = Apollo.QueryResult<AdminOrderSearchQuery, AdminOrderSearchQueryVariables>;
export function refetchAdminOrderSearchQuery(variables: AdminOrderSearchQueryVariables) {
      return { query: AdminOrderSearchDocument, variables: variables }
    }
export const BusinessAccountSearchQueryDocument = gql`
    query businessAccountSearchQuery($filters: BusinessAccountsFilterInput) {
  businessAccounts(filters: $filters) {
    items {
      ...BusinessAccountSearchItem
    }
    totalCount
  }
}
    ${BusinessAccountSearchItemFragmentDoc}`;

/**
 * __useBusinessAccountSearchQueryQuery__
 *
 * To run a query within a React component, call `useBusinessAccountSearchQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessAccountSearchQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessAccountSearchQueryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useBusinessAccountSearchQueryQuery(baseOptions?: Apollo.QueryHookOptions<BusinessAccountSearchQueryQuery, BusinessAccountSearchQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessAccountSearchQueryQuery, BusinessAccountSearchQueryQueryVariables>(BusinessAccountSearchQueryDocument, options);
      }
export function useBusinessAccountSearchQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessAccountSearchQueryQuery, BusinessAccountSearchQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessAccountSearchQueryQuery, BusinessAccountSearchQueryQueryVariables>(BusinessAccountSearchQueryDocument, options);
        }
export type BusinessAccountSearchQueryQueryHookResult = ReturnType<typeof useBusinessAccountSearchQueryQuery>;
export type BusinessAccountSearchQueryLazyQueryHookResult = ReturnType<typeof useBusinessAccountSearchQueryLazyQuery>;
export type BusinessAccountSearchQueryQueryResult = Apollo.QueryResult<BusinessAccountSearchQueryQuery, BusinessAccountSearchQueryQueryVariables>;
export function refetchBusinessAccountSearchQueryQuery(variables?: BusinessAccountSearchQueryQueryVariables) {
      return { query: BusinessAccountSearchQueryDocument, variables: variables }
    }
export const PartSearchAdminSearchDocument = gql`
    query partSearchAdminSearch($searchString: String!) {
  genericPartInfoSearch(searchString: $searchString) {
    ...PartSearchAdminFields
  }
}
    ${PartSearchAdminFieldsFragmentDoc}`;

/**
 * __usePartSearchAdminSearchQuery__
 *
 * To run a query within a React component, call `usePartSearchAdminSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartSearchAdminSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartSearchAdminSearchQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *   },
 * });
 */
export function usePartSearchAdminSearchQuery(baseOptions: Apollo.QueryHookOptions<PartSearchAdminSearchQuery, PartSearchAdminSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartSearchAdminSearchQuery, PartSearchAdminSearchQueryVariables>(PartSearchAdminSearchDocument, options);
      }
export function usePartSearchAdminSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartSearchAdminSearchQuery, PartSearchAdminSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartSearchAdminSearchQuery, PartSearchAdminSearchQueryVariables>(PartSearchAdminSearchDocument, options);
        }
export type PartSearchAdminSearchQueryHookResult = ReturnType<typeof usePartSearchAdminSearchQuery>;
export type PartSearchAdminSearchLazyQueryHookResult = ReturnType<typeof usePartSearchAdminSearchLazyQuery>;
export type PartSearchAdminSearchQueryResult = Apollo.QueryResult<PartSearchAdminSearchQuery, PartSearchAdminSearchQueryVariables>;
export function refetchPartSearchAdminSearchQuery(variables: PartSearchAdminSearchQueryVariables) {
      return { query: PartSearchAdminSearchDocument, variables: variables }
    }
export const UserSearchAdminSearchDocument = gql`
    query userSearchAdminSearch($searchString: String!) {
  genericUserSearch(searchString: $searchString) {
    ...UserSearchAdminSearchFields
  }
}
    ${UserSearchAdminSearchFieldsFragmentDoc}`;

/**
 * __useUserSearchAdminSearchQuery__
 *
 * To run a query within a React component, call `useUserSearchAdminSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSearchAdminSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSearchAdminSearchQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *   },
 * });
 */
export function useUserSearchAdminSearchQuery(baseOptions: Apollo.QueryHookOptions<UserSearchAdminSearchQuery, UserSearchAdminSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSearchAdminSearchQuery, UserSearchAdminSearchQueryVariables>(UserSearchAdminSearchDocument, options);
      }
export function useUserSearchAdminSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSearchAdminSearchQuery, UserSearchAdminSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSearchAdminSearchQuery, UserSearchAdminSearchQueryVariables>(UserSearchAdminSearchDocument, options);
        }
export type UserSearchAdminSearchQueryHookResult = ReturnType<typeof useUserSearchAdminSearchQuery>;
export type UserSearchAdminSearchLazyQueryHookResult = ReturnType<typeof useUserSearchAdminSearchLazyQuery>;
export type UserSearchAdminSearchQueryResult = Apollo.QueryResult<UserSearchAdminSearchQuery, UserSearchAdminSearchQueryVariables>;
export function refetchUserSearchAdminSearchQuery(variables: UserSearchAdminSearchQueryVariables) {
      return { query: UserSearchAdminSearchDocument, variables: variables }
    }
export const AdminToolingPageRemoveManuallyQuotedSecondaryProcessDocument = gql`
    mutation adminToolingPageRemoveManuallyQuotedSecondaryProcess($ids: [UUID!]!, $processId: String) {
  removeManuallyQuotedSecondaryProcess(ids: $ids, processId: $processId)
}
    `;
export type AdminToolingPageRemoveManuallyQuotedSecondaryProcessMutationFn = Apollo.MutationFunction<AdminToolingPageRemoveManuallyQuotedSecondaryProcessMutation, AdminToolingPageRemoveManuallyQuotedSecondaryProcessMutationVariables>;

/**
 * __useAdminToolingPageRemoveManuallyQuotedSecondaryProcessMutation__
 *
 * To run a mutation, you first call `useAdminToolingPageRemoveManuallyQuotedSecondaryProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminToolingPageRemoveManuallyQuotedSecondaryProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminToolingPageRemoveManuallyQuotedSecondaryProcessMutation, { data, loading, error }] = useAdminToolingPageRemoveManuallyQuotedSecondaryProcessMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useAdminToolingPageRemoveManuallyQuotedSecondaryProcessMutation(baseOptions?: Apollo.MutationHookOptions<AdminToolingPageRemoveManuallyQuotedSecondaryProcessMutation, AdminToolingPageRemoveManuallyQuotedSecondaryProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminToolingPageRemoveManuallyQuotedSecondaryProcessMutation, AdminToolingPageRemoveManuallyQuotedSecondaryProcessMutationVariables>(AdminToolingPageRemoveManuallyQuotedSecondaryProcessDocument, options);
      }
export type AdminToolingPageRemoveManuallyQuotedSecondaryProcessMutationHookResult = ReturnType<typeof useAdminToolingPageRemoveManuallyQuotedSecondaryProcessMutation>;
export type AdminToolingPageRemoveManuallyQuotedSecondaryProcessMutationResult = Apollo.MutationResult<AdminToolingPageRemoveManuallyQuotedSecondaryProcessMutation>;
export type AdminToolingPageRemoveManuallyQuotedSecondaryProcessMutationOptions = Apollo.BaseMutationOptions<AdminToolingPageRemoveManuallyQuotedSecondaryProcessMutation, AdminToolingPageRemoveManuallyQuotedSecondaryProcessMutationVariables>;
export const AdminQuoteQmrsQueryAdminToolingQuotingPageDocument = gql`
    query adminQuoteQmrsQueryAdminToolingQuotingPage($id: UUID!) {
  quote(id: $id) {
    id
    status
  }
}
    `;

/**
 * __useAdminQuoteQmrsQueryAdminToolingQuotingPageQuery__
 *
 * To run a query within a React component, call `useAdminQuoteQmrsQueryAdminToolingQuotingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminQuoteQmrsQueryAdminToolingQuotingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminQuoteQmrsQueryAdminToolingQuotingPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminQuoteQmrsQueryAdminToolingQuotingPageQuery(baseOptions: Apollo.QueryHookOptions<AdminQuoteQmrsQueryAdminToolingQuotingPageQuery, AdminQuoteQmrsQueryAdminToolingQuotingPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminQuoteQmrsQueryAdminToolingQuotingPageQuery, AdminQuoteQmrsQueryAdminToolingQuotingPageQueryVariables>(AdminQuoteQmrsQueryAdminToolingQuotingPageDocument, options);
      }
export function useAdminQuoteQmrsQueryAdminToolingQuotingPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminQuoteQmrsQueryAdminToolingQuotingPageQuery, AdminQuoteQmrsQueryAdminToolingQuotingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminQuoteQmrsQueryAdminToolingQuotingPageQuery, AdminQuoteQmrsQueryAdminToolingQuotingPageQueryVariables>(AdminQuoteQmrsQueryAdminToolingQuotingPageDocument, options);
        }
export type AdminQuoteQmrsQueryAdminToolingQuotingPageQueryHookResult = ReturnType<typeof useAdminQuoteQmrsQueryAdminToolingQuotingPageQuery>;
export type AdminQuoteQmrsQueryAdminToolingQuotingPageLazyQueryHookResult = ReturnType<typeof useAdminQuoteQmrsQueryAdminToolingQuotingPageLazyQuery>;
export type AdminQuoteQmrsQueryAdminToolingQuotingPageQueryResult = Apollo.QueryResult<AdminQuoteQmrsQueryAdminToolingQuotingPageQuery, AdminQuoteQmrsQueryAdminToolingQuotingPageQueryVariables>;
export function refetchAdminQuoteQmrsQueryAdminToolingQuotingPageQuery(variables: AdminQuoteQmrsQueryAdminToolingQuotingPageQueryVariables) {
      return { query: AdminQuoteQmrsQueryAdminToolingQuotingPageDocument, variables: variables }
    }
export const AdminMoldQmrQueryAdminToolingQuotingPageDocument = gql`
    query adminMoldQmrQueryAdminToolingQuotingPage($id: UUID!) {
  moldTool(id: $id) {
    id
    quoteModelRevisions {
      id
      fileName
      state
      flags
      version
      partRevision {
        id
        thumbnailUri
        downloadUri
        status
        modelFileName
        boundingBox {
          x
          y
          z
        }
        analysisErrorCode
      }
      dfmFeedback {
        id
        accepted
        severity
      }
      taps {
        id
      }
      attachmentLink {
        id
        quoteAttachmentRevision {
          id
          attachment {
            ... on Attachment {
              id
              downloadUrl
              fileName
              extension
            }
          }
        }
      }
      supportedPriorityRegions {
        partSupportsDomestic
        partSupportsInternational
      }
      processesDetails {
        totalPrice {
          ... on ExactPrice {
            unitPriceInCents
            priceInCents
          }
          ... on EstimatedPrice {
            lowPriceInCents
            lowUnitPriceInCents
            highPriceInCents
            highUnitPriceInCents
          }
        }
        postProcesses {
          postProcess {
            id
            name
          }
          postProcessThickness {
            id
            name
          }
          postProcessColor {
            id
            name
          }
          unitPriceInCents
          postProcessLeadTimeInDays
          postProcessNumParts
          postProcessInspectionCriteria
        }
        secondaryProcesses {
          process {
            id
            name
            typeName
          }
          unitPriceInCents
          leadTimeInDays
          notes
          pricingAndLeadTimeFields {
            ... on SecondaryProcessManualQuoteCalcFields {
              international {
                markupPercentage
                mpPayoutInCents
                mpPayoutPartsLimit
                leadTimeInDays
                leadTimePartsLimit
              }
              domestic {
                mpPayoutInCents
                markupPercentage
                mpPayoutPartsLimit
                leadTimeInDays
                leadTimePartsLimit
              }
            }
            ... on HardwareInstallationManualQuoteCalcFields {
              international {
                markupPercentage
                mpPayoutInCents
                mpPayoutPartsLimit
                leadTimeInDays
                leadTimePartsLimit
              }
              domestic {
                mpPayoutInCents
                markupPercentage
                mpPayoutPartsLimit
                leadTimeInDays
                leadTimePartsLimit
              }
              lineItems {
                supplier
                partNumber
                qtyPerPart
                pricePerPack
                qtyPerPack
              }
            }
          }
        }
      }
      modelConfiguration {
        id
        dfmInspection {
          id
          inspectionData
        }
        process {
          id
          name
        }
        material {
          ... on Material {
            id
            name
          }
          ... on UserEnteredMaterial {
            id
            name
          }
        }
        materialGrade
        color {
          id
          name
        }
        colorCode
        shore {
          id
          name
        }
        texture {
          id
          name
        }
        quantity
        textureCode
        hasMultipleFinishes
        userNeedsConfigHelp
        requiresOvermold
        additionalRequirements
      }
    }
  }
}
    `;

/**
 * __useAdminMoldQmrQueryAdminToolingQuotingPageQuery__
 *
 * To run a query within a React component, call `useAdminMoldQmrQueryAdminToolingQuotingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMoldQmrQueryAdminToolingQuotingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMoldQmrQueryAdminToolingQuotingPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminMoldQmrQueryAdminToolingQuotingPageQuery(baseOptions: Apollo.QueryHookOptions<AdminMoldQmrQueryAdminToolingQuotingPageQuery, AdminMoldQmrQueryAdminToolingQuotingPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMoldQmrQueryAdminToolingQuotingPageQuery, AdminMoldQmrQueryAdminToolingQuotingPageQueryVariables>(AdminMoldQmrQueryAdminToolingQuotingPageDocument, options);
      }
export function useAdminMoldQmrQueryAdminToolingQuotingPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMoldQmrQueryAdminToolingQuotingPageQuery, AdminMoldQmrQueryAdminToolingQuotingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMoldQmrQueryAdminToolingQuotingPageQuery, AdminMoldQmrQueryAdminToolingQuotingPageQueryVariables>(AdminMoldQmrQueryAdminToolingQuotingPageDocument, options);
        }
export type AdminMoldQmrQueryAdminToolingQuotingPageQueryHookResult = ReturnType<typeof useAdminMoldQmrQueryAdminToolingQuotingPageQuery>;
export type AdminMoldQmrQueryAdminToolingQuotingPageLazyQueryHookResult = ReturnType<typeof useAdminMoldQmrQueryAdminToolingQuotingPageLazyQuery>;
export type AdminMoldQmrQueryAdminToolingQuotingPageQueryResult = Apollo.QueryResult<AdminMoldQmrQueryAdminToolingQuotingPageQuery, AdminMoldQmrQueryAdminToolingQuotingPageQueryVariables>;
export function refetchAdminMoldQmrQueryAdminToolingQuotingPageQuery(variables: AdminMoldQmrQueryAdminToolingQuotingPageQueryVariables) {
      return { query: AdminMoldQmrQueryAdminToolingQuotingPageDocument, variables: variables }
    }
export const CalculateCostQueryAdminToolingQuotingPageDocument = gql`
    query calculateCostQueryAdminToolingQuotingPage($inspectionData: MoldToolInspectionDataInput!, $partsInspectionData: [PartInspectionDataInput]!, $pendingPartQuantity: Int!) {
  getToolAndPartPendingPrices(
    inspectionData: $inspectionData
    partsInspectionData: $partsInspectionData
    pendingPartQuantity: $pendingPartQuantity
  ) {
    toolingPrice {
      insertMaterialCostCents
      insertMachiningCostCents
      moldBaseCostCents
      standardPartsCostCents
      moldTrialCostCents
      structureCostCents
      designCostCents
      moldAssemblyCostCents
      surfaceFinishCostCents
      materialCostCents
      baseCostCents
      mpPayoutCents
      customerPrice
      leadTimeDays
      pressMachineSizeTon
    }
    partPrice {
      materialCostCents
      injectionCostCents
      packagingCostCents
      setupCostCents
      basePartCostCents
      unitMpPayoutInCentsPerQmr
      unitCustomerPriceInCentsPerQmr
      cycleTimeSecs
      totalPartsWeightGram
    }
  }
}
    `;

/**
 * __useCalculateCostQueryAdminToolingQuotingPageQuery__
 *
 * To run a query within a React component, call `useCalculateCostQueryAdminToolingQuotingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateCostQueryAdminToolingQuotingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateCostQueryAdminToolingQuotingPageQuery({
 *   variables: {
 *      inspectionData: // value for 'inspectionData'
 *      partsInspectionData: // value for 'partsInspectionData'
 *      pendingPartQuantity: // value for 'pendingPartQuantity'
 *   },
 * });
 */
export function useCalculateCostQueryAdminToolingQuotingPageQuery(baseOptions: Apollo.QueryHookOptions<CalculateCostQueryAdminToolingQuotingPageQuery, CalculateCostQueryAdminToolingQuotingPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateCostQueryAdminToolingQuotingPageQuery, CalculateCostQueryAdminToolingQuotingPageQueryVariables>(CalculateCostQueryAdminToolingQuotingPageDocument, options);
      }
export function useCalculateCostQueryAdminToolingQuotingPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateCostQueryAdminToolingQuotingPageQuery, CalculateCostQueryAdminToolingQuotingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateCostQueryAdminToolingQuotingPageQuery, CalculateCostQueryAdminToolingQuotingPageQueryVariables>(CalculateCostQueryAdminToolingQuotingPageDocument, options);
        }
export type CalculateCostQueryAdminToolingQuotingPageQueryHookResult = ReturnType<typeof useCalculateCostQueryAdminToolingQuotingPageQuery>;
export type CalculateCostQueryAdminToolingQuotingPageLazyQueryHookResult = ReturnType<typeof useCalculateCostQueryAdminToolingQuotingPageLazyQuery>;
export type CalculateCostQueryAdminToolingQuotingPageQueryResult = Apollo.QueryResult<CalculateCostQueryAdminToolingQuotingPageQuery, CalculateCostQueryAdminToolingQuotingPageQueryVariables>;
export function refetchCalculateCostQueryAdminToolingQuotingPageQuery(variables: CalculateCostQueryAdminToolingQuotingPageQueryVariables) {
      return { query: CalculateCostQueryAdminToolingQuotingPageDocument, variables: variables }
    }
export const UpdateMoldToolInspectionDataAdminToolingQuotingPageDocument = gql`
    mutation updateMoldToolInspectionDataAdminToolingQuotingPage($id: UUID!, $inspectionData: MoldToolInspectionDataInput!) {
  updateMoldToolInspectionData(id: $id, inspectionData: $inspectionData) {
    id
    toolLife
    gateType
    inspectionData
    leadTimeDays
    createdAt
    createdBy {
      id
      email
    }
    updatedAt
    publishedAt
    published
  }
}
    `;
export type UpdateMoldToolInspectionDataAdminToolingQuotingPageMutationFn = Apollo.MutationFunction<UpdateMoldToolInspectionDataAdminToolingQuotingPageMutation, UpdateMoldToolInspectionDataAdminToolingQuotingPageMutationVariables>;

/**
 * __useUpdateMoldToolInspectionDataAdminToolingQuotingPageMutation__
 *
 * To run a mutation, you first call `useUpdateMoldToolInspectionDataAdminToolingQuotingPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMoldToolInspectionDataAdminToolingQuotingPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMoldToolInspectionDataAdminToolingQuotingPageMutation, { data, loading, error }] = useUpdateMoldToolInspectionDataAdminToolingQuotingPageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      inspectionData: // value for 'inspectionData'
 *   },
 * });
 */
export function useUpdateMoldToolInspectionDataAdminToolingQuotingPageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMoldToolInspectionDataAdminToolingQuotingPageMutation, UpdateMoldToolInspectionDataAdminToolingQuotingPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMoldToolInspectionDataAdminToolingQuotingPageMutation, UpdateMoldToolInspectionDataAdminToolingQuotingPageMutationVariables>(UpdateMoldToolInspectionDataAdminToolingQuotingPageDocument, options);
      }
export type UpdateMoldToolInspectionDataAdminToolingQuotingPageMutationHookResult = ReturnType<typeof useUpdateMoldToolInspectionDataAdminToolingQuotingPageMutation>;
export type UpdateMoldToolInspectionDataAdminToolingQuotingPageMutationResult = Apollo.MutationResult<UpdateMoldToolInspectionDataAdminToolingQuotingPageMutation>;
export type UpdateMoldToolInspectionDataAdminToolingQuotingPageMutationOptions = Apollo.BaseMutationOptions<UpdateMoldToolInspectionDataAdminToolingQuotingPageMutation, UpdateMoldToolInspectionDataAdminToolingQuotingPageMutationVariables>;
export const UpdatePartPricingParametersMutationAdminToolingQuotingPageDocument = gql`
    mutation updatePartPricingParametersMutationAdminToolingQuotingPage($modelConfigurationDfmInspectionId: UUID!, $inspectionData: InspectionDataInput!) {
  updateModelConfigurationDfmInspection(
    modelConfigurationDfmInspectionId: $modelConfigurationDfmInspectionId
    inspectionData: $inspectionData
  ) {
    id
    inspectionData
  }
}
    `;
export type UpdatePartPricingParametersMutationAdminToolingQuotingPageMutationFn = Apollo.MutationFunction<UpdatePartPricingParametersMutationAdminToolingQuotingPageMutation, UpdatePartPricingParametersMutationAdminToolingQuotingPageMutationVariables>;

/**
 * __useUpdatePartPricingParametersMutationAdminToolingQuotingPageMutation__
 *
 * To run a mutation, you first call `useUpdatePartPricingParametersMutationAdminToolingQuotingPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartPricingParametersMutationAdminToolingQuotingPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartPricingParametersMutationAdminToolingQuotingPageMutation, { data, loading, error }] = useUpdatePartPricingParametersMutationAdminToolingQuotingPageMutation({
 *   variables: {
 *      modelConfigurationDfmInspectionId: // value for 'modelConfigurationDfmInspectionId'
 *      inspectionData: // value for 'inspectionData'
 *   },
 * });
 */
export function useUpdatePartPricingParametersMutationAdminToolingQuotingPageMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePartPricingParametersMutationAdminToolingQuotingPageMutation, UpdatePartPricingParametersMutationAdminToolingQuotingPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePartPricingParametersMutationAdminToolingQuotingPageMutation, UpdatePartPricingParametersMutationAdminToolingQuotingPageMutationVariables>(UpdatePartPricingParametersMutationAdminToolingQuotingPageDocument, options);
      }
export type UpdatePartPricingParametersMutationAdminToolingQuotingPageMutationHookResult = ReturnType<typeof useUpdatePartPricingParametersMutationAdminToolingQuotingPageMutation>;
export type UpdatePartPricingParametersMutationAdminToolingQuotingPageMutationResult = Apollo.MutationResult<UpdatePartPricingParametersMutationAdminToolingQuotingPageMutation>;
export type UpdatePartPricingParametersMutationAdminToolingQuotingPageMutationOptions = Apollo.BaseMutationOptions<UpdatePartPricingParametersMutationAdminToolingQuotingPageMutation, UpdatePartPricingParametersMutationAdminToolingQuotingPageMutationVariables>;
export const PublishMoldToolMutationAdminToolingQuotingPageDocument = gql`
    mutation publishMoldToolMutationAdminToolingQuotingPage($id: UUID!) {
  publishMoldTool(id: $id) {
    id
    published
  }
}
    `;
export type PublishMoldToolMutationAdminToolingQuotingPageMutationFn = Apollo.MutationFunction<PublishMoldToolMutationAdminToolingQuotingPageMutation, PublishMoldToolMutationAdminToolingQuotingPageMutationVariables>;

/**
 * __usePublishMoldToolMutationAdminToolingQuotingPageMutation__
 *
 * To run a mutation, you first call `usePublishMoldToolMutationAdminToolingQuotingPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishMoldToolMutationAdminToolingQuotingPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishMoldToolMutationAdminToolingQuotingPageMutation, { data, loading, error }] = usePublishMoldToolMutationAdminToolingQuotingPageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublishMoldToolMutationAdminToolingQuotingPageMutation(baseOptions?: Apollo.MutationHookOptions<PublishMoldToolMutationAdminToolingQuotingPageMutation, PublishMoldToolMutationAdminToolingQuotingPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishMoldToolMutationAdminToolingQuotingPageMutation, PublishMoldToolMutationAdminToolingQuotingPageMutationVariables>(PublishMoldToolMutationAdminToolingQuotingPageDocument, options);
      }
export type PublishMoldToolMutationAdminToolingQuotingPageMutationHookResult = ReturnType<typeof usePublishMoldToolMutationAdminToolingQuotingPageMutation>;
export type PublishMoldToolMutationAdminToolingQuotingPageMutationResult = Apollo.MutationResult<PublishMoldToolMutationAdminToolingQuotingPageMutation>;
export type PublishMoldToolMutationAdminToolingQuotingPageMutationOptions = Apollo.BaseMutationOptions<PublishMoldToolMutationAdminToolingQuotingPageMutation, PublishMoldToolMutationAdminToolingQuotingPageMutationVariables>;
export const PublishQmrMutationAdminToolingQuotingPageDocument = gql`
    mutation publishQmrMutationAdminToolingQuotingPage($quoteModelRevisionId: UUID!) {
  publishQuoteModelRevision(quoteModelRevisionId: $quoteModelRevisionId) {
    id
  }
}
    `;
export type PublishQmrMutationAdminToolingQuotingPageMutationFn = Apollo.MutationFunction<PublishQmrMutationAdminToolingQuotingPageMutation, PublishQmrMutationAdminToolingQuotingPageMutationVariables>;

/**
 * __usePublishQmrMutationAdminToolingQuotingPageMutation__
 *
 * To run a mutation, you first call `usePublishQmrMutationAdminToolingQuotingPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishQmrMutationAdminToolingQuotingPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishQmrMutationAdminToolingQuotingPageMutation, { data, loading, error }] = usePublishQmrMutationAdminToolingQuotingPageMutation({
 *   variables: {
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *   },
 * });
 */
export function usePublishQmrMutationAdminToolingQuotingPageMutation(baseOptions?: Apollo.MutationHookOptions<PublishQmrMutationAdminToolingQuotingPageMutation, PublishQmrMutationAdminToolingQuotingPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishQmrMutationAdminToolingQuotingPageMutation, PublishQmrMutationAdminToolingQuotingPageMutationVariables>(PublishQmrMutationAdminToolingQuotingPageDocument, options);
      }
export type PublishQmrMutationAdminToolingQuotingPageMutationHookResult = ReturnType<typeof usePublishQmrMutationAdminToolingQuotingPageMutation>;
export type PublishQmrMutationAdminToolingQuotingPageMutationResult = Apollo.MutationResult<PublishQmrMutationAdminToolingQuotingPageMutation>;
export type PublishQmrMutationAdminToolingQuotingPageMutationOptions = Apollo.BaseMutationOptions<PublishQmrMutationAdminToolingQuotingPageMutation, PublishQmrMutationAdminToolingQuotingPageMutationVariables>;
export const AdminQuoteQueryAdminToolingQuotingPageDocument = gql`
    query adminQuoteQueryAdminToolingQuotingPage($id: UUID!) {
  quote(id: $id) {
    id
    name
    user {
      id
      email
    }
    status
    imQuoteRequirements {
      deliveryDate
      developmentStage
      toolTypeNotes
      additionalRequirementNotes
    }
  }
}
    `;

/**
 * __useAdminQuoteQueryAdminToolingQuotingPageQuery__
 *
 * To run a query within a React component, call `useAdminQuoteQueryAdminToolingQuotingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminQuoteQueryAdminToolingQuotingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminQuoteQueryAdminToolingQuotingPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminQuoteQueryAdminToolingQuotingPageQuery(baseOptions: Apollo.QueryHookOptions<AdminQuoteQueryAdminToolingQuotingPageQuery, AdminQuoteQueryAdminToolingQuotingPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminQuoteQueryAdminToolingQuotingPageQuery, AdminQuoteQueryAdminToolingQuotingPageQueryVariables>(AdminQuoteQueryAdminToolingQuotingPageDocument, options);
      }
export function useAdminQuoteQueryAdminToolingQuotingPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminQuoteQueryAdminToolingQuotingPageQuery, AdminQuoteQueryAdminToolingQuotingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminQuoteQueryAdminToolingQuotingPageQuery, AdminQuoteQueryAdminToolingQuotingPageQueryVariables>(AdminQuoteQueryAdminToolingQuotingPageDocument, options);
        }
export type AdminQuoteQueryAdminToolingQuotingPageQueryHookResult = ReturnType<typeof useAdminQuoteQueryAdminToolingQuotingPageQuery>;
export type AdminQuoteQueryAdminToolingQuotingPageLazyQueryHookResult = ReturnType<typeof useAdminQuoteQueryAdminToolingQuotingPageLazyQuery>;
export type AdminQuoteQueryAdminToolingQuotingPageQueryResult = Apollo.QueryResult<AdminQuoteQueryAdminToolingQuotingPageQuery, AdminQuoteQueryAdminToolingQuotingPageQueryVariables>;
export function refetchAdminQuoteQueryAdminToolingQuotingPageQuery(variables: AdminQuoteQueryAdminToolingQuotingPageQueryVariables) {
      return { query: AdminQuoteQueryAdminToolingQuotingPageDocument, variables: variables }
    }
export const AdminMoldQueryAdminToolingQuotingPageDocument = gql`
    query adminMoldQueryAdminToolingQuotingPage($id: UUID!, $isImMaafcoEnabled: Boolean!) {
  moldTool(id: $id) {
    id
    toolLife
    gateType
    inspectionData
    leadTimeDays
    createdAt
    createdBy {
      id
      email
    }
    updatedAt
    publishedAt
    published
    moldToolRevision @include(if: $isImMaafcoEnabled) {
      id
    }
  }
}
    `;

/**
 * __useAdminMoldQueryAdminToolingQuotingPageQuery__
 *
 * To run a query within a React component, call `useAdminMoldQueryAdminToolingQuotingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMoldQueryAdminToolingQuotingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMoldQueryAdminToolingQuotingPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      isImMaafcoEnabled: // value for 'isImMaafcoEnabled'
 *   },
 * });
 */
export function useAdminMoldQueryAdminToolingQuotingPageQuery(baseOptions: Apollo.QueryHookOptions<AdminMoldQueryAdminToolingQuotingPageQuery, AdminMoldQueryAdminToolingQuotingPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMoldQueryAdminToolingQuotingPageQuery, AdminMoldQueryAdminToolingQuotingPageQueryVariables>(AdminMoldQueryAdminToolingQuotingPageDocument, options);
      }
export function useAdminMoldQueryAdminToolingQuotingPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMoldQueryAdminToolingQuotingPageQuery, AdminMoldQueryAdminToolingQuotingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMoldQueryAdminToolingQuotingPageQuery, AdminMoldQueryAdminToolingQuotingPageQueryVariables>(AdminMoldQueryAdminToolingQuotingPageDocument, options);
        }
export type AdminMoldQueryAdminToolingQuotingPageQueryHookResult = ReturnType<typeof useAdminMoldQueryAdminToolingQuotingPageQuery>;
export type AdminMoldQueryAdminToolingQuotingPageLazyQueryHookResult = ReturnType<typeof useAdminMoldQueryAdminToolingQuotingPageLazyQuery>;
export type AdminMoldQueryAdminToolingQuotingPageQueryResult = Apollo.QueryResult<AdminMoldQueryAdminToolingQuotingPageQuery, AdminMoldQueryAdminToolingQuotingPageQueryVariables>;
export function refetchAdminMoldQueryAdminToolingQuotingPageQuery(variables: AdminMoldQueryAdminToolingQuotingPageQueryVariables) {
      return { query: AdminMoldQueryAdminToolingQuotingPageDocument, variables: variables }
    }
export const AdminUserSalesOrderAdminUserOrdersPageDocument = gql`
    query adminUserSalesOrderAdminUserOrdersPage($limit: Int!, $offset: Int, $id: Int!, $isCpqFlagV2Enabled: Boolean = false) {
  user(id: $id) {
    id
    salesOrders(limit: $limit, offset: $offset) {
      totalCount
      items {
        ... on SalesOrder {
          id
          isReorderAllowed
          name
          deliveryStatus
          shippedBy
          createdAt
          totalAmount
          downloadAllFilesUri
          fictivShipmentMethod
          isBusinessAccountDiscountApplied
          appliedBusinessAccountDiscountPercent
          salesOrderLines(limit: 4) {
            totalCount
            productCount
            primaryProductLines {
              id
              revision {
                id
                thumbnailUri
              }
              htsCodeSubmitted
            }
            items {
              id
              revision {
                id
                thumbnailUri
              }
              htsCodeSubmitted
              processes {
                id
                platformProcessId
                color
                texture
                thickness
                processNotes
                additionalSpecifications {
                  color
                  texture
                  thickness
                }
                dfmNotes {
                  color
                  process
                  texture
                  thickness
                }
              }
            }
            parts {
              id
              revision {
                id
                thumbnailUri
              }
              htsCodeSubmitted
              processes {
                id
                platformProcessId
                color
                texture
                thickness
                processNotes
                additionalSpecifications {
                  color
                  texture
                  thickness
                }
                dfmNotes {
                  color
                  process
                  texture
                  thickness
                }
              }
            }
          }
          paymentDetails {
            paymentType
            purchaseOrderNumber
            paidBy {
              id
            }
          }
          team {
            id
            name
          }
          project {
            id
            isSecurePlus
            name
          }
          sourceQuoteType
          quoteOwnerUser {
            id
          }
          quotePdfUrl @include(if: $isCpqFlagV2Enabled)
        }
        ... on BasicSalesOrder {
          id
          name
          deliveryStatus
          shippedBy
          createdAt
          totalAmount
          project {
            id
            isSecurePlus
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAdminUserSalesOrderAdminUserOrdersPageQuery__
 *
 * To run a query within a React component, call `useAdminUserSalesOrderAdminUserOrdersPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserSalesOrderAdminUserOrdersPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserSalesOrderAdminUserOrdersPageQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      id: // value for 'id'
 *      isCpqFlagV2Enabled: // value for 'isCpqFlagV2Enabled'
 *   },
 * });
 */
export function useAdminUserSalesOrderAdminUserOrdersPageQuery(baseOptions: Apollo.QueryHookOptions<AdminUserSalesOrderAdminUserOrdersPageQuery, AdminUserSalesOrderAdminUserOrdersPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminUserSalesOrderAdminUserOrdersPageQuery, AdminUserSalesOrderAdminUserOrdersPageQueryVariables>(AdminUserSalesOrderAdminUserOrdersPageDocument, options);
      }
export function useAdminUserSalesOrderAdminUserOrdersPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminUserSalesOrderAdminUserOrdersPageQuery, AdminUserSalesOrderAdminUserOrdersPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminUserSalesOrderAdminUserOrdersPageQuery, AdminUserSalesOrderAdminUserOrdersPageQueryVariables>(AdminUserSalesOrderAdminUserOrdersPageDocument, options);
        }
export type AdminUserSalesOrderAdminUserOrdersPageQueryHookResult = ReturnType<typeof useAdminUserSalesOrderAdminUserOrdersPageQuery>;
export type AdminUserSalesOrderAdminUserOrdersPageLazyQueryHookResult = ReturnType<typeof useAdminUserSalesOrderAdminUserOrdersPageLazyQuery>;
export type AdminUserSalesOrderAdminUserOrdersPageQueryResult = Apollo.QueryResult<AdminUserSalesOrderAdminUserOrdersPageQuery, AdminUserSalesOrderAdminUserOrdersPageQueryVariables>;
export function refetchAdminUserSalesOrderAdminUserOrdersPageQuery(variables: AdminUserSalesOrderAdminUserOrdersPageQueryVariables) {
      return { query: AdminUserSalesOrderAdminUserOrdersPageDocument, variables: variables }
    }
export const UnlockUserAdminUserProfileDocument = gql`
    mutation unlockUserAdminUserProfile($userId: Int!) {
  adminOnlyMutations(userId: $userId) {
    resetLockedOutUser(notifyUser: true) {
      id
      email
    }
  }
}
    `;
export type UnlockUserAdminUserProfileMutationFn = Apollo.MutationFunction<UnlockUserAdminUserProfileMutation, UnlockUserAdminUserProfileMutationVariables>;

/**
 * __useUnlockUserAdminUserProfileMutation__
 *
 * To run a mutation, you first call `useUnlockUserAdminUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockUserAdminUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockUserAdminUserProfileMutation, { data, loading, error }] = useUnlockUserAdminUserProfileMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUnlockUserAdminUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<UnlockUserAdminUserProfileMutation, UnlockUserAdminUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlockUserAdminUserProfileMutation, UnlockUserAdminUserProfileMutationVariables>(UnlockUserAdminUserProfileDocument, options);
      }
export type UnlockUserAdminUserProfileMutationHookResult = ReturnType<typeof useUnlockUserAdminUserProfileMutation>;
export type UnlockUserAdminUserProfileMutationResult = Apollo.MutationResult<UnlockUserAdminUserProfileMutation>;
export type UnlockUserAdminUserProfileMutationOptions = Apollo.BaseMutationOptions<UnlockUserAdminUserProfileMutation, UnlockUserAdminUserProfileMutationVariables>;
export const ModifyRoleOrCapabilitiesAdminUserProfileDocument = gql`
    mutation modifyRoleOrCapabilitiesAdminUserProfile($userId: Int!, $roleOrCapabilities: RoleAndCapabilities!, $action: Action!) {
  adminOnlyMutations(userId: $userId) {
    modifyRoleAndCapabilities(
      roleOrCapabilities: $roleOrCapabilities
      action: $action
    ) {
      id
      roles {
        id
        name
      }
    }
  }
}
    `;
export type ModifyRoleOrCapabilitiesAdminUserProfileMutationFn = Apollo.MutationFunction<ModifyRoleOrCapabilitiesAdminUserProfileMutation, ModifyRoleOrCapabilitiesAdminUserProfileMutationVariables>;

/**
 * __useModifyRoleOrCapabilitiesAdminUserProfileMutation__
 *
 * To run a mutation, you first call `useModifyRoleOrCapabilitiesAdminUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyRoleOrCapabilitiesAdminUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyRoleOrCapabilitiesAdminUserProfileMutation, { data, loading, error }] = useModifyRoleOrCapabilitiesAdminUserProfileMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      roleOrCapabilities: // value for 'roleOrCapabilities'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useModifyRoleOrCapabilitiesAdminUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<ModifyRoleOrCapabilitiesAdminUserProfileMutation, ModifyRoleOrCapabilitiesAdminUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModifyRoleOrCapabilitiesAdminUserProfileMutation, ModifyRoleOrCapabilitiesAdminUserProfileMutationVariables>(ModifyRoleOrCapabilitiesAdminUserProfileDocument, options);
      }
export type ModifyRoleOrCapabilitiesAdminUserProfileMutationHookResult = ReturnType<typeof useModifyRoleOrCapabilitiesAdminUserProfileMutation>;
export type ModifyRoleOrCapabilitiesAdminUserProfileMutationResult = Apollo.MutationResult<ModifyRoleOrCapabilitiesAdminUserProfileMutation>;
export type ModifyRoleOrCapabilitiesAdminUserProfileMutationOptions = Apollo.BaseMutationOptions<ModifyRoleOrCapabilitiesAdminUserProfileMutation, ModifyRoleOrCapabilitiesAdminUserProfileMutationVariables>;
export const ResendEmailVerificationDocument = gql`
    mutation resendEmailVerification($userId: Int!) {
  adminOnlyMutations(userId: $userId) {
    resendEmailVerification
  }
}
    `;
export type ResendEmailVerificationMutationFn = Apollo.MutationFunction<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>;

/**
 * __useResendEmailVerificationMutation__
 *
 * To run a mutation, you first call `useResendEmailVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendEmailVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendEmailVerificationMutation, { data, loading, error }] = useResendEmailVerificationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useResendEmailVerificationMutation(baseOptions?: Apollo.MutationHookOptions<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>(ResendEmailVerificationDocument, options);
      }
export type ResendEmailVerificationMutationHookResult = ReturnType<typeof useResendEmailVerificationMutation>;
export type ResendEmailVerificationMutationResult = Apollo.MutationResult<ResendEmailVerificationMutation>;
export type ResendEmailVerificationMutationOptions = Apollo.BaseMutationOptions<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>;
export const ResetPasswordAdminUserProfileDocument = gql`
    mutation resetPasswordAdminUserProfile($userId: Int!) {
  adminOnlyMutations(userId: $userId) {
    initiatePwdReset {
      id
    }
  }
}
    `;
export type ResetPasswordAdminUserProfileMutationFn = Apollo.MutationFunction<ResetPasswordAdminUserProfileMutation, ResetPasswordAdminUserProfileMutationVariables>;

/**
 * __useResetPasswordAdminUserProfileMutation__
 *
 * To run a mutation, you first call `useResetPasswordAdminUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordAdminUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordAdminUserProfileMutation, { data, loading, error }] = useResetPasswordAdminUserProfileMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useResetPasswordAdminUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordAdminUserProfileMutation, ResetPasswordAdminUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordAdminUserProfileMutation, ResetPasswordAdminUserProfileMutationVariables>(ResetPasswordAdminUserProfileDocument, options);
      }
export type ResetPasswordAdminUserProfileMutationHookResult = ReturnType<typeof useResetPasswordAdminUserProfileMutation>;
export type ResetPasswordAdminUserProfileMutationResult = Apollo.MutationResult<ResetPasswordAdminUserProfileMutation>;
export type ResetPasswordAdminUserProfileMutationOptions = Apollo.BaseMutationOptions<ResetPasswordAdminUserProfileMutation, ResetPasswordAdminUserProfileMutationVariables>;
export const UserProfileAdminUserDocument = gql`
    query userProfileAdminUser($id: Int!) {
  user(id: $id) {
    id
    email
    displayName
    firstName
    lastName
    phoneNumber
    updatedAt
    enabled
    createdAt
    isUserLockedOut
    lockoutLoginUntil
    emailVerificationSentDate
    emailVerificationStatus
    roles {
      id
      name
      source
    }
    businessAccountMembership {
      businessAccount {
        id
        name
        isEnabled
        isTeamsFeatureEnabled
      }
      user {
        id
        enabled
      }
    }
  }
}
    `;

/**
 * __useUserProfileAdminUserQuery__
 *
 * To run a query within a React component, call `useUserProfileAdminUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileAdminUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileAdminUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserProfileAdminUserQuery(baseOptions: Apollo.QueryHookOptions<UserProfileAdminUserQuery, UserProfileAdminUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProfileAdminUserQuery, UserProfileAdminUserQueryVariables>(UserProfileAdminUserDocument, options);
      }
export function useUserProfileAdminUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserProfileAdminUserQuery, UserProfileAdminUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProfileAdminUserQuery, UserProfileAdminUserQueryVariables>(UserProfileAdminUserDocument, options);
        }
export type UserProfileAdminUserQueryHookResult = ReturnType<typeof useUserProfileAdminUserQuery>;
export type UserProfileAdminUserLazyQueryHookResult = ReturnType<typeof useUserProfileAdminUserLazyQuery>;
export type UserProfileAdminUserQueryResult = Apollo.QueryResult<UserProfileAdminUserQuery, UserProfileAdminUserQueryVariables>;
export function refetchUserProfileAdminUserQuery(variables: UserProfileAdminUserQueryVariables) {
      return { query: UserProfileAdminUserDocument, variables: variables }
    }
export const DeleteUserAccountByAdminDocument = gql`
    mutation deleteUserAccountByAdmin($id: Int!) {
  adminUser(userId: $id) {
    deleteAccount {
      id
    }
  }
}
    `;
export type DeleteUserAccountByAdminMutationFn = Apollo.MutationFunction<DeleteUserAccountByAdminMutation, DeleteUserAccountByAdminMutationVariables>;

/**
 * __useDeleteUserAccountByAdminMutation__
 *
 * To run a mutation, you first call `useDeleteUserAccountByAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserAccountByAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserAccountByAdminMutation, { data, loading, error }] = useDeleteUserAccountByAdminMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserAccountByAdminMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserAccountByAdminMutation, DeleteUserAccountByAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserAccountByAdminMutation, DeleteUserAccountByAdminMutationVariables>(DeleteUserAccountByAdminDocument, options);
      }
export type DeleteUserAccountByAdminMutationHookResult = ReturnType<typeof useDeleteUserAccountByAdminMutation>;
export type DeleteUserAccountByAdminMutationResult = Apollo.MutationResult<DeleteUserAccountByAdminMutation>;
export type DeleteUserAccountByAdminMutationOptions = Apollo.BaseMutationOptions<DeleteUserAccountByAdminMutation, DeleteUserAccountByAdminMutationVariables>;
export const Is2FaEnalbedForUserQueryAdminUserProfileDocument = gql`
    query is2FAEnalbedForUserQueryAdminUserProfile($id: Int!) {
  user(id: $id) {
    id
    is2faEnabled
  }
}
    `;

/**
 * __useIs2FaEnalbedForUserQueryAdminUserProfileQuery__
 *
 * To run a query within a React component, call `useIs2FaEnalbedForUserQueryAdminUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useIs2FaEnalbedForUserQueryAdminUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIs2FaEnalbedForUserQueryAdminUserProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIs2FaEnalbedForUserQueryAdminUserProfileQuery(baseOptions: Apollo.QueryHookOptions<Is2FaEnalbedForUserQueryAdminUserProfileQuery, Is2FaEnalbedForUserQueryAdminUserProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Is2FaEnalbedForUserQueryAdminUserProfileQuery, Is2FaEnalbedForUserQueryAdminUserProfileQueryVariables>(Is2FaEnalbedForUserQueryAdminUserProfileDocument, options);
      }
export function useIs2FaEnalbedForUserQueryAdminUserProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Is2FaEnalbedForUserQueryAdminUserProfileQuery, Is2FaEnalbedForUserQueryAdminUserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Is2FaEnalbedForUserQueryAdminUserProfileQuery, Is2FaEnalbedForUserQueryAdminUserProfileQueryVariables>(Is2FaEnalbedForUserQueryAdminUserProfileDocument, options);
        }
export type Is2FaEnalbedForUserQueryAdminUserProfileQueryHookResult = ReturnType<typeof useIs2FaEnalbedForUserQueryAdminUserProfileQuery>;
export type Is2FaEnalbedForUserQueryAdminUserProfileLazyQueryHookResult = ReturnType<typeof useIs2FaEnalbedForUserQueryAdminUserProfileLazyQuery>;
export type Is2FaEnalbedForUserQueryAdminUserProfileQueryResult = Apollo.QueryResult<Is2FaEnalbedForUserQueryAdminUserProfileQuery, Is2FaEnalbedForUserQueryAdminUserProfileQueryVariables>;
export function refetchIs2FaEnalbedForUserQueryAdminUserProfileQuery(variables: Is2FaEnalbedForUserQueryAdminUserProfileQueryVariables) {
      return { query: Is2FaEnalbedForUserQueryAdminUserProfileDocument, variables: variables }
    }
export const Disable2FaForUserAdminUserProfileDocument = gql`
    mutation disable2FAForUserAdminUserProfile($id: Int!) {
  adminUser(userId: $id) {
    disable2FA {
      id
      is2faEnabled
    }
  }
}
    `;
export type Disable2FaForUserAdminUserProfileMutationFn = Apollo.MutationFunction<Disable2FaForUserAdminUserProfileMutation, Disable2FaForUserAdminUserProfileMutationVariables>;

/**
 * __useDisable2FaForUserAdminUserProfileMutation__
 *
 * To run a mutation, you first call `useDisable2FaForUserAdminUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisable2FaForUserAdminUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disable2FaForUserAdminUserProfileMutation, { data, loading, error }] = useDisable2FaForUserAdminUserProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisable2FaForUserAdminUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<Disable2FaForUserAdminUserProfileMutation, Disable2FaForUserAdminUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Disable2FaForUserAdminUserProfileMutation, Disable2FaForUserAdminUserProfileMutationVariables>(Disable2FaForUserAdminUserProfileDocument, options);
      }
export type Disable2FaForUserAdminUserProfileMutationHookResult = ReturnType<typeof useDisable2FaForUserAdminUserProfileMutation>;
export type Disable2FaForUserAdminUserProfileMutationResult = Apollo.MutationResult<Disable2FaForUserAdminUserProfileMutation>;
export type Disable2FaForUserAdminUserProfileMutationOptions = Apollo.BaseMutationOptions<Disable2FaForUserAdminUserProfileMutation, Disable2FaForUserAdminUserProfileMutationVariables>;
export const AdminRolesQueryDocument = gql`
    query adminRolesQuery {
  me {
    id
    roles {
      id
      name
    }
  }
}
    `;

/**
 * __useAdminRolesQueryQuery__
 *
 * To run a query within a React component, call `useAdminRolesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminRolesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminRolesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminRolesQueryQuery(baseOptions?: Apollo.QueryHookOptions<AdminRolesQueryQuery, AdminRolesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminRolesQueryQuery, AdminRolesQueryQueryVariables>(AdminRolesQueryDocument, options);
      }
export function useAdminRolesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminRolesQueryQuery, AdminRolesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminRolesQueryQuery, AdminRolesQueryQueryVariables>(AdminRolesQueryDocument, options);
        }
export type AdminRolesQueryQueryHookResult = ReturnType<typeof useAdminRolesQueryQuery>;
export type AdminRolesQueryLazyQueryHookResult = ReturnType<typeof useAdminRolesQueryLazyQuery>;
export type AdminRolesQueryQueryResult = Apollo.QueryResult<AdminRolesQueryQuery, AdminRolesQueryQueryVariables>;
export function refetchAdminRolesQueryQuery(variables?: AdminRolesQueryQueryVariables) {
      return { query: AdminRolesQueryDocument, variables: variables }
    }
export const AdminUserQueryAdminUserQuoteDetailPageDocument = gql`
    query adminUserQueryAdminUserQuoteDetailPage($id: Int!) {
  user(id: $id) {
    id
    email
    salesForceAccountIdState
    roles {
      id
      name
      source
    }
    businessAccountMembership {
      businessAccount {
        id
        name
        isEnabled
        isTeamsFeatureEnabled
      }
    }
    displayName
  }
}
    `;

/**
 * __useAdminUserQueryAdminUserQuoteDetailPageQuery__
 *
 * To run a query within a React component, call `useAdminUserQueryAdminUserQuoteDetailPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserQueryAdminUserQuoteDetailPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserQueryAdminUserQuoteDetailPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminUserQueryAdminUserQuoteDetailPageQuery(baseOptions: Apollo.QueryHookOptions<AdminUserQueryAdminUserQuoteDetailPageQuery, AdminUserQueryAdminUserQuoteDetailPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminUserQueryAdminUserQuoteDetailPageQuery, AdminUserQueryAdminUserQuoteDetailPageQueryVariables>(AdminUserQueryAdminUserQuoteDetailPageDocument, options);
      }
export function useAdminUserQueryAdminUserQuoteDetailPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminUserQueryAdminUserQuoteDetailPageQuery, AdminUserQueryAdminUserQuoteDetailPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminUserQueryAdminUserQuoteDetailPageQuery, AdminUserQueryAdminUserQuoteDetailPageQueryVariables>(AdminUserQueryAdminUserQuoteDetailPageDocument, options);
        }
export type AdminUserQueryAdminUserQuoteDetailPageQueryHookResult = ReturnType<typeof useAdminUserQueryAdminUserQuoteDetailPageQuery>;
export type AdminUserQueryAdminUserQuoteDetailPageLazyQueryHookResult = ReturnType<typeof useAdminUserQueryAdminUserQuoteDetailPageLazyQuery>;
export type AdminUserQueryAdminUserQuoteDetailPageQueryResult = Apollo.QueryResult<AdminUserQueryAdminUserQuoteDetailPageQuery, AdminUserQueryAdminUserQuoteDetailPageQueryVariables>;
export function refetchAdminUserQueryAdminUserQuoteDetailPageQuery(variables: AdminUserQueryAdminUserQuoteDetailPageQueryVariables) {
      return { query: AdminUserQueryAdminUserQuoteDetailPageDocument, variables: variables }
    }
export const AdminQuoteQueryAdminUserQuoteDetailPageDocument = gql`
    query adminQuoteQueryAdminUserQuoteDetailPage($id: UUID!) {
  quote(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useAdminQuoteQueryAdminUserQuoteDetailPageQuery__
 *
 * To run a query within a React component, call `useAdminQuoteQueryAdminUserQuoteDetailPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminQuoteQueryAdminUserQuoteDetailPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminQuoteQueryAdminUserQuoteDetailPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminQuoteQueryAdminUserQuoteDetailPageQuery(baseOptions: Apollo.QueryHookOptions<AdminQuoteQueryAdminUserQuoteDetailPageQuery, AdminQuoteQueryAdminUserQuoteDetailPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminQuoteQueryAdminUserQuoteDetailPageQuery, AdminQuoteQueryAdminUserQuoteDetailPageQueryVariables>(AdminQuoteQueryAdminUserQuoteDetailPageDocument, options);
      }
export function useAdminQuoteQueryAdminUserQuoteDetailPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminQuoteQueryAdminUserQuoteDetailPageQuery, AdminQuoteQueryAdminUserQuoteDetailPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminQuoteQueryAdminUserQuoteDetailPageQuery, AdminQuoteQueryAdminUserQuoteDetailPageQueryVariables>(AdminQuoteQueryAdminUserQuoteDetailPageDocument, options);
        }
export type AdminQuoteQueryAdminUserQuoteDetailPageQueryHookResult = ReturnType<typeof useAdminQuoteQueryAdminUserQuoteDetailPageQuery>;
export type AdminQuoteQueryAdminUserQuoteDetailPageLazyQueryHookResult = ReturnType<typeof useAdminQuoteQueryAdminUserQuoteDetailPageLazyQuery>;
export type AdminQuoteQueryAdminUserQuoteDetailPageQueryResult = Apollo.QueryResult<AdminQuoteQueryAdminUserQuoteDetailPageQuery, AdminQuoteQueryAdminUserQuoteDetailPageQueryVariables>;
export function refetchAdminQuoteQueryAdminUserQuoteDetailPageQuery(variables: AdminQuoteQueryAdminUserQuoteDetailPageQueryVariables) {
      return { query: AdminQuoteQueryAdminUserQuoteDetailPageDocument, variables: variables }
    }
export const EnableBusinessAccountAndAddUserDocument = gql`
    mutation EnableBusinessAccountAndAddUser($userId: Int, $isBusinessAccountTrialRequest: Boolean, $isPoVisibility: Boolean) {
  enableBusinessAccountTrial(
    userId: $userId
    isBusinessAccountTrialRequest: $isBusinessAccountTrialRequest
    isPoVisibility: $isPoVisibility
  )
}
    `;
export type EnableBusinessAccountAndAddUserMutationFn = Apollo.MutationFunction<EnableBusinessAccountAndAddUserMutation, EnableBusinessAccountAndAddUserMutationVariables>;

/**
 * __useEnableBusinessAccountAndAddUserMutation__
 *
 * To run a mutation, you first call `useEnableBusinessAccountAndAddUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableBusinessAccountAndAddUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableBusinessAccountAndAddUserMutation, { data, loading, error }] = useEnableBusinessAccountAndAddUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      isBusinessAccountTrialRequest: // value for 'isBusinessAccountTrialRequest'
 *      isPoVisibility: // value for 'isPoVisibility'
 *   },
 * });
 */
export function useEnableBusinessAccountAndAddUserMutation(baseOptions?: Apollo.MutationHookOptions<EnableBusinessAccountAndAddUserMutation, EnableBusinessAccountAndAddUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableBusinessAccountAndAddUserMutation, EnableBusinessAccountAndAddUserMutationVariables>(EnableBusinessAccountAndAddUserDocument, options);
      }
export type EnableBusinessAccountAndAddUserMutationHookResult = ReturnType<typeof useEnableBusinessAccountAndAddUserMutation>;
export type EnableBusinessAccountAndAddUserMutationResult = Apollo.MutationResult<EnableBusinessAccountAndAddUserMutation>;
export type EnableBusinessAccountAndAddUserMutationOptions = Apollo.BaseMutationOptions<EnableBusinessAccountAndAddUserMutation, EnableBusinessAccountAndAddUserMutationVariables>;
export const QuotesListAdminUserQuotesDocument = gql`
    query quotesListAdminUserQuotes($limit: Int!, $sort: CreatedAtSortKey, $offset: Int, $userId: Int!, $filter: QuoteAttributeFilterType) {
  user(id: $userId) {
    id
    email
    displayName
    roles {
      id
      name
      source
    }
    quotes(limit: $limit, sort: $sort, offset: $offset, filter: $filter) {
      totalCount
      items {
        ... on Quote {
          id
          name
          type
          status
          lastModified
          subTotalInCents
          depositInCents
          productionPartsSubtotalInCents
          moldToolSubtotalInCents
          earliestValidUntilDate
          slowestShipDateEstimate
          isQuotePurchasable
          zipCode
          isLocked
          isCpqOwned
          isTaxExempt
          partsSummary
          numberOfParts
          isEligibleForFreeShipping
          cpqQuote {
            platformQuote {
              id
            }
          }
          businessAccountDiscount {
            id
            percent
            isActive
            endAt
          }
          team {
            id
            name
          }
          user {
            id
          }
          quoteAttachments {
            totalCount
            items {
              id
              latestAttachmentRevision {
                id
              }
            }
          }
          quoteModels(limit: 5) {
            totalCount
            items {
              id
              selectedQuoteModelRevision {
                id
                state
                fileName
                dfmFeedback {
                  id
                  accepted
                  severity
                }
                attachmentLink {
                  id
                  quoteAttachmentRevision {
                    id
                  }
                }
                processesDetails {
                  totalPrice {
                    ... on ExactPrice {
                      unitPriceInCents
                      priceInCents
                    }
                    ... on EstimatedPrice {
                      lowPriceInCents
                      lowUnitPriceInCents
                      highPriceInCents
                      highUnitPriceInCents
                    }
                  }
                }
                modelConfiguration {
                  id
                  productionLeadTime {
                    productionDays
                  }
                  material {
                    ... on Material {
                      id
                      name
                    }
                    ... on UserEnteredMaterial {
                      id
                      name
                      process {
                        id
                        name
                      }
                    }
                  }
                  process {
                    id
                    name
                  }
                  color {
                    id
                    name
                  }
                  quantity
                }
              }
            }
          }
          project {
            isSecurePlus
            name
            id
          }
        }
        ... on BasicQuote {
          id
          name
          project {
            isSecurePlus
            name
            id
          }
        }
      }
    }
    hasSecurePlusMemberships
  }
}
    `;

/**
 * __useQuotesListAdminUserQuotesQuery__
 *
 * To run a query within a React component, call `useQuotesListAdminUserQuotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuotesListAdminUserQuotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuotesListAdminUserQuotesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      userId: // value for 'userId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useQuotesListAdminUserQuotesQuery(baseOptions: Apollo.QueryHookOptions<QuotesListAdminUserQuotesQuery, QuotesListAdminUserQuotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuotesListAdminUserQuotesQuery, QuotesListAdminUserQuotesQueryVariables>(QuotesListAdminUserQuotesDocument, options);
      }
export function useQuotesListAdminUserQuotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuotesListAdminUserQuotesQuery, QuotesListAdminUserQuotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuotesListAdminUserQuotesQuery, QuotesListAdminUserQuotesQueryVariables>(QuotesListAdminUserQuotesDocument, options);
        }
export type QuotesListAdminUserQuotesQueryHookResult = ReturnType<typeof useQuotesListAdminUserQuotesQuery>;
export type QuotesListAdminUserQuotesLazyQueryHookResult = ReturnType<typeof useQuotesListAdminUserQuotesLazyQuery>;
export type QuotesListAdminUserQuotesQueryResult = Apollo.QueryResult<QuotesListAdminUserQuotesQuery, QuotesListAdminUserQuotesQueryVariables>;
export function refetchQuotesListAdminUserQuotesQuery(variables: QuotesListAdminUserQuotesQueryVariables) {
      return { query: QuotesListAdminUserQuotesDocument, variables: variables }
    }
export const QuotesTotalAndUserAdminUserQuotesDocument = gql`
    query quotesTotalAndUserAdminUserQuotes($limit: Int!, $sort: CreatedAtSortKey, $offset: Int, $userId: Int!, $filter: QuoteAttributeFilterType) {
  user(id: $userId) {
    id
    email
    salesForceAccountIdState
    displayName
    hasSecurePlusMemberships
    roles {
      id
      name
      source
    }
    businessAccountMembership {
      businessAccount {
        id
        name
        isEnabled
        isTeamsFeatureEnabled
      }
    }
    quotes(limit: $limit, sort: $sort, offset: $offset, filter: $filter) {
      totalCount
    }
  }
}
    `;

/**
 * __useQuotesTotalAndUserAdminUserQuotesQuery__
 *
 * To run a query within a React component, call `useQuotesTotalAndUserAdminUserQuotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuotesTotalAndUserAdminUserQuotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuotesTotalAndUserAdminUserQuotesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      userId: // value for 'userId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useQuotesTotalAndUserAdminUserQuotesQuery(baseOptions: Apollo.QueryHookOptions<QuotesTotalAndUserAdminUserQuotesQuery, QuotesTotalAndUserAdminUserQuotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuotesTotalAndUserAdminUserQuotesQuery, QuotesTotalAndUserAdminUserQuotesQueryVariables>(QuotesTotalAndUserAdminUserQuotesDocument, options);
      }
export function useQuotesTotalAndUserAdminUserQuotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuotesTotalAndUserAdminUserQuotesQuery, QuotesTotalAndUserAdminUserQuotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuotesTotalAndUserAdminUserQuotesQuery, QuotesTotalAndUserAdminUserQuotesQueryVariables>(QuotesTotalAndUserAdminUserQuotesDocument, options);
        }
export type QuotesTotalAndUserAdminUserQuotesQueryHookResult = ReturnType<typeof useQuotesTotalAndUserAdminUserQuotesQuery>;
export type QuotesTotalAndUserAdminUserQuotesLazyQueryHookResult = ReturnType<typeof useQuotesTotalAndUserAdminUserQuotesLazyQuery>;
export type QuotesTotalAndUserAdminUserQuotesQueryResult = Apollo.QueryResult<QuotesTotalAndUserAdminUserQuotesQuery, QuotesTotalAndUserAdminUserQuotesQueryVariables>;
export function refetchQuotesTotalAndUserAdminUserQuotesQuery(variables: QuotesTotalAndUserAdminUserQuotesQueryVariables) {
      return { query: QuotesTotalAndUserAdminUserQuotesDocument, variables: variables }
    }
export const AdminOboQuotesListMoveToQuoteModalDocument = gql`
    query adminOBOQuotesListMoveToQuoteModal($userId: Int!) {
  user(id: $userId) {
    id
    quotes(limit: 1000, sort: "LAST_MODIFIED_DESC") {
      items {
        ... on Quote {
          id
          name
          type
          status
          lastModified
          requestedAt
          quoteModels {
            totalCount
          }
          project {
            isSecurePlus
            name
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAdminOboQuotesListMoveToQuoteModalQuery__
 *
 * To run a query within a React component, call `useAdminOboQuotesListMoveToQuoteModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminOboQuotesListMoveToQuoteModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOboQuotesListMoveToQuoteModalQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminOboQuotesListMoveToQuoteModalQuery(baseOptions: Apollo.QueryHookOptions<AdminOboQuotesListMoveToQuoteModalQuery, AdminOboQuotesListMoveToQuoteModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOboQuotesListMoveToQuoteModalQuery, AdminOboQuotesListMoveToQuoteModalQueryVariables>(AdminOboQuotesListMoveToQuoteModalDocument, options);
      }
export function useAdminOboQuotesListMoveToQuoteModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOboQuotesListMoveToQuoteModalQuery, AdminOboQuotesListMoveToQuoteModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOboQuotesListMoveToQuoteModalQuery, AdminOboQuotesListMoveToQuoteModalQueryVariables>(AdminOboQuotesListMoveToQuoteModalDocument, options);
        }
export type AdminOboQuotesListMoveToQuoteModalQueryHookResult = ReturnType<typeof useAdminOboQuotesListMoveToQuoteModalQuery>;
export type AdminOboQuotesListMoveToQuoteModalLazyQueryHookResult = ReturnType<typeof useAdminOboQuotesListMoveToQuoteModalLazyQuery>;
export type AdminOboQuotesListMoveToQuoteModalQueryResult = Apollo.QueryResult<AdminOboQuotesListMoveToQuoteModalQuery, AdminOboQuotesListMoveToQuoteModalQueryVariables>;
export function refetchAdminOboQuotesListMoveToQuoteModalQuery(variables: AdminOboQuotesListMoveToQuoteModalQueryVariables) {
      return { query: AdminOboQuotesListMoveToQuoteModalDocument, variables: variables }
    }
export const EstimateItemModelAttachmentMarkupsDocument = gql`
    query estimateItemModelAttachmentMarkups($id: UUID!) {
  estimateItem(id: $id) {
    id
    supportingDocUrl
    revision {
      modelFileName
    }
    modelAttachmentSelections {
      id
      documentPage
      positionX
      positionY
      height
      width
      text
      modelAttachmentAnnotation {
        id
        positionX
        positionY
        documentPage
        radius
        label
      }
    }
    modelAttachmentSanitizations {
      id
      documentPage
      positionX
      positionY
      height
      width
    }
  }
}
    `;

/**
 * __useEstimateItemModelAttachmentMarkupsQuery__
 *
 * To run a query within a React component, call `useEstimateItemModelAttachmentMarkupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEstimateItemModelAttachmentMarkupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEstimateItemModelAttachmentMarkupsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEstimateItemModelAttachmentMarkupsQuery(baseOptions: Apollo.QueryHookOptions<EstimateItemModelAttachmentMarkupsQuery, EstimateItemModelAttachmentMarkupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EstimateItemModelAttachmentMarkupsQuery, EstimateItemModelAttachmentMarkupsQueryVariables>(EstimateItemModelAttachmentMarkupsDocument, options);
      }
export function useEstimateItemModelAttachmentMarkupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EstimateItemModelAttachmentMarkupsQuery, EstimateItemModelAttachmentMarkupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EstimateItemModelAttachmentMarkupsQuery, EstimateItemModelAttachmentMarkupsQueryVariables>(EstimateItemModelAttachmentMarkupsDocument, options);
        }
export type EstimateItemModelAttachmentMarkupsQueryHookResult = ReturnType<typeof useEstimateItemModelAttachmentMarkupsQuery>;
export type EstimateItemModelAttachmentMarkupsLazyQueryHookResult = ReturnType<typeof useEstimateItemModelAttachmentMarkupsLazyQuery>;
export type EstimateItemModelAttachmentMarkupsQueryResult = Apollo.QueryResult<EstimateItemModelAttachmentMarkupsQuery, EstimateItemModelAttachmentMarkupsQueryVariables>;
export function refetchEstimateItemModelAttachmentMarkupsQuery(variables: EstimateItemModelAttachmentMarkupsQueryVariables) {
      return { query: EstimateItemModelAttachmentMarkupsDocument, variables: variables }
    }
export const EstimateItemSupportingDocUploadUrlDocument = gql`
    query estimateItemSupportingDocUploadUrl($id: UUID!) {
  estimateItem(id: $id) {
    id
    sanitizedSupportingDocUploadUrl
  }
}
    `;

/**
 * __useEstimateItemSupportingDocUploadUrlQuery__
 *
 * To run a query within a React component, call `useEstimateItemSupportingDocUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useEstimateItemSupportingDocUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEstimateItemSupportingDocUploadUrlQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEstimateItemSupportingDocUploadUrlQuery(baseOptions: Apollo.QueryHookOptions<EstimateItemSupportingDocUploadUrlQuery, EstimateItemSupportingDocUploadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EstimateItemSupportingDocUploadUrlQuery, EstimateItemSupportingDocUploadUrlQueryVariables>(EstimateItemSupportingDocUploadUrlDocument, options);
      }
export function useEstimateItemSupportingDocUploadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EstimateItemSupportingDocUploadUrlQuery, EstimateItemSupportingDocUploadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EstimateItemSupportingDocUploadUrlQuery, EstimateItemSupportingDocUploadUrlQueryVariables>(EstimateItemSupportingDocUploadUrlDocument, options);
        }
export type EstimateItemSupportingDocUploadUrlQueryHookResult = ReturnType<typeof useEstimateItemSupportingDocUploadUrlQuery>;
export type EstimateItemSupportingDocUploadUrlLazyQueryHookResult = ReturnType<typeof useEstimateItemSupportingDocUploadUrlLazyQuery>;
export type EstimateItemSupportingDocUploadUrlQueryResult = Apollo.QueryResult<EstimateItemSupportingDocUploadUrlQuery, EstimateItemSupportingDocUploadUrlQueryVariables>;
export function refetchEstimateItemSupportingDocUploadUrlQuery(variables: EstimateItemSupportingDocUploadUrlQueryVariables) {
      return { query: EstimateItemSupportingDocUploadUrlDocument, variables: variables }
    }
export const EstimateItemCalloutLabelsDocument = gql`
    query estimateItemCalloutLabels($id: UUID!) {
  estimateItem(id: $id) {
    id
    modelAttachmentSelections {
      id
      modelAttachmentAnnotation {
        id
        label
      }
    }
  }
}
    `;

/**
 * __useEstimateItemCalloutLabelsQuery__
 *
 * To run a query within a React component, call `useEstimateItemCalloutLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEstimateItemCalloutLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEstimateItemCalloutLabelsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEstimateItemCalloutLabelsQuery(baseOptions: Apollo.QueryHookOptions<EstimateItemCalloutLabelsQuery, EstimateItemCalloutLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EstimateItemCalloutLabelsQuery, EstimateItemCalloutLabelsQueryVariables>(EstimateItemCalloutLabelsDocument, options);
      }
export function useEstimateItemCalloutLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EstimateItemCalloutLabelsQuery, EstimateItemCalloutLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EstimateItemCalloutLabelsQuery, EstimateItemCalloutLabelsQueryVariables>(EstimateItemCalloutLabelsDocument, options);
        }
export type EstimateItemCalloutLabelsQueryHookResult = ReturnType<typeof useEstimateItemCalloutLabelsQuery>;
export type EstimateItemCalloutLabelsLazyQueryHookResult = ReturnType<typeof useEstimateItemCalloutLabelsLazyQuery>;
export type EstimateItemCalloutLabelsQueryResult = Apollo.QueryResult<EstimateItemCalloutLabelsQuery, EstimateItemCalloutLabelsQueryVariables>;
export function refetchEstimateItemCalloutLabelsQuery(variables: EstimateItemCalloutLabelsQueryVariables) {
      return { query: EstimateItemCalloutLabelsDocument, variables: variables }
    }
export const CreateModelAttachmentCalloutDocument = gql`
    mutation createModelAttachmentCallout($modelAttachmentAnnotationInput: ModelAttachmentAnnotationInput!, $modelAttachmentSelectionInput: ModelAttachmentSelectionInput!) {
  createModelAttachmentCallout(
    modelAttachmentAnnotationInput: $modelAttachmentAnnotationInput
    modelAttachmentSelectionInput: $modelAttachmentSelectionInput
  ) {
    id
    documentPage
    positionX
    positionY
    width
    height
    text
    modelAttachmentAnnotation {
      id
      documentPage
      positionX
      positionY
      radius
      label
    }
  }
}
    `;
export type CreateModelAttachmentCalloutMutationFn = Apollo.MutationFunction<CreateModelAttachmentCalloutMutation, CreateModelAttachmentCalloutMutationVariables>;

/**
 * __useCreateModelAttachmentCalloutMutation__
 *
 * To run a mutation, you first call `useCreateModelAttachmentCalloutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateModelAttachmentCalloutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createModelAttachmentCalloutMutation, { data, loading, error }] = useCreateModelAttachmentCalloutMutation({
 *   variables: {
 *      modelAttachmentAnnotationInput: // value for 'modelAttachmentAnnotationInput'
 *      modelAttachmentSelectionInput: // value for 'modelAttachmentSelectionInput'
 *   },
 * });
 */
export function useCreateModelAttachmentCalloutMutation(baseOptions?: Apollo.MutationHookOptions<CreateModelAttachmentCalloutMutation, CreateModelAttachmentCalloutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateModelAttachmentCalloutMutation, CreateModelAttachmentCalloutMutationVariables>(CreateModelAttachmentCalloutDocument, options);
      }
export type CreateModelAttachmentCalloutMutationHookResult = ReturnType<typeof useCreateModelAttachmentCalloutMutation>;
export type CreateModelAttachmentCalloutMutationResult = Apollo.MutationResult<CreateModelAttachmentCalloutMutation>;
export type CreateModelAttachmentCalloutMutationOptions = Apollo.BaseMutationOptions<CreateModelAttachmentCalloutMutation, CreateModelAttachmentCalloutMutationVariables>;
export const ReplaceAllModelAttachmentCalloutsDocument = gql`
    mutation replaceAllModelAttachmentCallouts($modelAttachmentCalloutInputs: [ModelAttachmentCalloutInput!]!, $attachmentId: UUID) {
  replaceAllModelAttachmentCallouts(
    modelAttachmentCalloutInputs: $modelAttachmentCalloutInputs
    attachmentId: $attachmentId
  ) {
    id
    documentPage
    positionX
    positionY
    width
    height
    text
    modelAttachmentAnnotation {
      id
      documentPage
      positionX
      positionY
      radius
      label
    }
  }
}
    `;
export type ReplaceAllModelAttachmentCalloutsMutationFn = Apollo.MutationFunction<ReplaceAllModelAttachmentCalloutsMutation, ReplaceAllModelAttachmentCalloutsMutationVariables>;

/**
 * __useReplaceAllModelAttachmentCalloutsMutation__
 *
 * To run a mutation, you first call `useReplaceAllModelAttachmentCalloutsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceAllModelAttachmentCalloutsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceAllModelAttachmentCalloutsMutation, { data, loading, error }] = useReplaceAllModelAttachmentCalloutsMutation({
 *   variables: {
 *      modelAttachmentCalloutInputs: // value for 'modelAttachmentCalloutInputs'
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useReplaceAllModelAttachmentCalloutsMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceAllModelAttachmentCalloutsMutation, ReplaceAllModelAttachmentCalloutsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceAllModelAttachmentCalloutsMutation, ReplaceAllModelAttachmentCalloutsMutationVariables>(ReplaceAllModelAttachmentCalloutsDocument, options);
      }
export type ReplaceAllModelAttachmentCalloutsMutationHookResult = ReturnType<typeof useReplaceAllModelAttachmentCalloutsMutation>;
export type ReplaceAllModelAttachmentCalloutsMutationResult = Apollo.MutationResult<ReplaceAllModelAttachmentCalloutsMutation>;
export type ReplaceAllModelAttachmentCalloutsMutationOptions = Apollo.BaseMutationOptions<ReplaceAllModelAttachmentCalloutsMutation, ReplaceAllModelAttachmentCalloutsMutationVariables>;
export const CreateModelAttachmentSanitizationDocument = gql`
    mutation createModelAttachmentSanitization($input: ModelAttachmentSelectionInput!) {
  createModelAttachmentSanitization(input: $input) {
    id
    documentPage
    positionX
    positionY
    width
    height
  }
}
    `;
export type CreateModelAttachmentSanitizationMutationFn = Apollo.MutationFunction<CreateModelAttachmentSanitizationMutation, CreateModelAttachmentSanitizationMutationVariables>;

/**
 * __useCreateModelAttachmentSanitizationMutation__
 *
 * To run a mutation, you first call `useCreateModelAttachmentSanitizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateModelAttachmentSanitizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createModelAttachmentSanitizationMutation, { data, loading, error }] = useCreateModelAttachmentSanitizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateModelAttachmentSanitizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateModelAttachmentSanitizationMutation, CreateModelAttachmentSanitizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateModelAttachmentSanitizationMutation, CreateModelAttachmentSanitizationMutationVariables>(CreateModelAttachmentSanitizationDocument, options);
      }
export type CreateModelAttachmentSanitizationMutationHookResult = ReturnType<typeof useCreateModelAttachmentSanitizationMutation>;
export type CreateModelAttachmentSanitizationMutationResult = Apollo.MutationResult<CreateModelAttachmentSanitizationMutation>;
export type CreateModelAttachmentSanitizationMutationOptions = Apollo.BaseMutationOptions<CreateModelAttachmentSanitizationMutation, CreateModelAttachmentSanitizationMutationVariables>;
export const DestroyModelAttachmentCalloutsDocument = gql`
    mutation destroyModelAttachmentCallouts($calloutIds: [UUID!]!) {
  destroyModelAttachmentCallouts(calloutIds: $calloutIds)
}
    `;
export type DestroyModelAttachmentCalloutsMutationFn = Apollo.MutationFunction<DestroyModelAttachmentCalloutsMutation, DestroyModelAttachmentCalloutsMutationVariables>;

/**
 * __useDestroyModelAttachmentCalloutsMutation__
 *
 * To run a mutation, you first call `useDestroyModelAttachmentCalloutsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyModelAttachmentCalloutsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyModelAttachmentCalloutsMutation, { data, loading, error }] = useDestroyModelAttachmentCalloutsMutation({
 *   variables: {
 *      calloutIds: // value for 'calloutIds'
 *   },
 * });
 */
export function useDestroyModelAttachmentCalloutsMutation(baseOptions?: Apollo.MutationHookOptions<DestroyModelAttachmentCalloutsMutation, DestroyModelAttachmentCalloutsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroyModelAttachmentCalloutsMutation, DestroyModelAttachmentCalloutsMutationVariables>(DestroyModelAttachmentCalloutsDocument, options);
      }
export type DestroyModelAttachmentCalloutsMutationHookResult = ReturnType<typeof useDestroyModelAttachmentCalloutsMutation>;
export type DestroyModelAttachmentCalloutsMutationResult = Apollo.MutationResult<DestroyModelAttachmentCalloutsMutation>;
export type DestroyModelAttachmentCalloutsMutationOptions = Apollo.BaseMutationOptions<DestroyModelAttachmentCalloutsMutation, DestroyModelAttachmentCalloutsMutationVariables>;
export const DestroyModelAttachmentSanitizationsDocument = gql`
    mutation destroyModelAttachmentSanitizations($sanitizationIds: [UUID!]!) {
  destroyModelAttachmentSanitizations(sanitizationIds: $sanitizationIds)
}
    `;
export type DestroyModelAttachmentSanitizationsMutationFn = Apollo.MutationFunction<DestroyModelAttachmentSanitizationsMutation, DestroyModelAttachmentSanitizationsMutationVariables>;

/**
 * __useDestroyModelAttachmentSanitizationsMutation__
 *
 * To run a mutation, you first call `useDestroyModelAttachmentSanitizationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyModelAttachmentSanitizationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyModelAttachmentSanitizationsMutation, { data, loading, error }] = useDestroyModelAttachmentSanitizationsMutation({
 *   variables: {
 *      sanitizationIds: // value for 'sanitizationIds'
 *   },
 * });
 */
export function useDestroyModelAttachmentSanitizationsMutation(baseOptions?: Apollo.MutationHookOptions<DestroyModelAttachmentSanitizationsMutation, DestroyModelAttachmentSanitizationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroyModelAttachmentSanitizationsMutation, DestroyModelAttachmentSanitizationsMutationVariables>(DestroyModelAttachmentSanitizationsDocument, options);
      }
export type DestroyModelAttachmentSanitizationsMutationHookResult = ReturnType<typeof useDestroyModelAttachmentSanitizationsMutation>;
export type DestroyModelAttachmentSanitizationsMutationResult = Apollo.MutationResult<DestroyModelAttachmentSanitizationsMutation>;
export type DestroyModelAttachmentSanitizationsMutationOptions = Apollo.BaseMutationOptions<DestroyModelAttachmentSanitizationsMutation, DestroyModelAttachmentSanitizationsMutationVariables>;
export const UpdateModelAttachmentAnnotationDocument = gql`
    mutation updateModelAttachmentAnnotation($id: UUID!, $input: ModelAttachmentAnnotationInput!) {
  updateModelAttachmentAnnotation(id: $id, input: $input) {
    id
    documentPage
    positionX
    positionY
    radius
    label
  }
}
    `;
export type UpdateModelAttachmentAnnotationMutationFn = Apollo.MutationFunction<UpdateModelAttachmentAnnotationMutation, UpdateModelAttachmentAnnotationMutationVariables>;

/**
 * __useUpdateModelAttachmentAnnotationMutation__
 *
 * To run a mutation, you first call `useUpdateModelAttachmentAnnotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModelAttachmentAnnotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModelAttachmentAnnotationMutation, { data, loading, error }] = useUpdateModelAttachmentAnnotationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateModelAttachmentAnnotationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateModelAttachmentAnnotationMutation, UpdateModelAttachmentAnnotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateModelAttachmentAnnotationMutation, UpdateModelAttachmentAnnotationMutationVariables>(UpdateModelAttachmentAnnotationDocument, options);
      }
export type UpdateModelAttachmentAnnotationMutationHookResult = ReturnType<typeof useUpdateModelAttachmentAnnotationMutation>;
export type UpdateModelAttachmentAnnotationMutationResult = Apollo.MutationResult<UpdateModelAttachmentAnnotationMutation>;
export type UpdateModelAttachmentAnnotationMutationOptions = Apollo.BaseMutationOptions<UpdateModelAttachmentAnnotationMutation, UpdateModelAttachmentAnnotationMutationVariables>;
export const QuoteModelRevisionAttachmentMarkupsDocument = gql`
    query quoteModelRevisionAttachmentMarkups($id: UUID!) {
  quoteModelRevision(id: $id) {
    id
    attachmentLink {
      id
      quoteAttachmentRevision {
        id
        attachment {
          ... on Attachment {
            id
            downloadUrl
            fileName
            annotated {
              id
              fileName
              downloadUrl
            }
            modelAttachmentSelections {
              id
              documentPage
              positionX
              positionY
              height
              width
              text
              modelAttachmentAnnotation {
                id
                positionX
                positionY
                documentPage
                radius
                label
              }
            }
            modelAttachmentSanitizations {
              id
              documentPage
              positionX
              positionY
              height
              width
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useQuoteModelRevisionAttachmentMarkupsQuery__
 *
 * To run a query within a React component, call `useQuoteModelRevisionAttachmentMarkupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteModelRevisionAttachmentMarkupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteModelRevisionAttachmentMarkupsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuoteModelRevisionAttachmentMarkupsQuery(baseOptions: Apollo.QueryHookOptions<QuoteModelRevisionAttachmentMarkupsQuery, QuoteModelRevisionAttachmentMarkupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteModelRevisionAttachmentMarkupsQuery, QuoteModelRevisionAttachmentMarkupsQueryVariables>(QuoteModelRevisionAttachmentMarkupsDocument, options);
      }
export function useQuoteModelRevisionAttachmentMarkupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteModelRevisionAttachmentMarkupsQuery, QuoteModelRevisionAttachmentMarkupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteModelRevisionAttachmentMarkupsQuery, QuoteModelRevisionAttachmentMarkupsQueryVariables>(QuoteModelRevisionAttachmentMarkupsDocument, options);
        }
export type QuoteModelRevisionAttachmentMarkupsQueryHookResult = ReturnType<typeof useQuoteModelRevisionAttachmentMarkupsQuery>;
export type QuoteModelRevisionAttachmentMarkupsLazyQueryHookResult = ReturnType<typeof useQuoteModelRevisionAttachmentMarkupsLazyQuery>;
export type QuoteModelRevisionAttachmentMarkupsQueryResult = Apollo.QueryResult<QuoteModelRevisionAttachmentMarkupsQuery, QuoteModelRevisionAttachmentMarkupsQueryVariables>;
export function refetchQuoteModelRevisionAttachmentMarkupsQuery(variables: QuoteModelRevisionAttachmentMarkupsQueryVariables) {
      return { query: QuoteModelRevisionAttachmentMarkupsDocument, variables: variables }
    }
export const CreateSanitizedAttachmentBubbleDrawingDocument = gql`
    mutation createSanitizedAttachmentBubbleDrawing($attachmentId: UUID!, $uploadMetadata: AttachmentInput!, $quoteModelRevisionId: UUID) {
  createSanitizedAttachment(
    attachmentId: $attachmentId
    uploadMetadata: $uploadMetadata
    quoteModelRevisionId: $quoteModelRevisionId
  ) {
    id
    uploadUrl
  }
}
    `;
export type CreateSanitizedAttachmentBubbleDrawingMutationFn = Apollo.MutationFunction<CreateSanitizedAttachmentBubbleDrawingMutation, CreateSanitizedAttachmentBubbleDrawingMutationVariables>;

/**
 * __useCreateSanitizedAttachmentBubbleDrawingMutation__
 *
 * To run a mutation, you first call `useCreateSanitizedAttachmentBubbleDrawingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSanitizedAttachmentBubbleDrawingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSanitizedAttachmentBubbleDrawingMutation, { data, loading, error }] = useCreateSanitizedAttachmentBubbleDrawingMutation({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *      uploadMetadata: // value for 'uploadMetadata'
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *   },
 * });
 */
export function useCreateSanitizedAttachmentBubbleDrawingMutation(baseOptions?: Apollo.MutationHookOptions<CreateSanitizedAttachmentBubbleDrawingMutation, CreateSanitizedAttachmentBubbleDrawingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSanitizedAttachmentBubbleDrawingMutation, CreateSanitizedAttachmentBubbleDrawingMutationVariables>(CreateSanitizedAttachmentBubbleDrawingDocument, options);
      }
export type CreateSanitizedAttachmentBubbleDrawingMutationHookResult = ReturnType<typeof useCreateSanitizedAttachmentBubbleDrawingMutation>;
export type CreateSanitizedAttachmentBubbleDrawingMutationResult = Apollo.MutationResult<CreateSanitizedAttachmentBubbleDrawingMutation>;
export type CreateSanitizedAttachmentBubbleDrawingMutationOptions = Apollo.BaseMutationOptions<CreateSanitizedAttachmentBubbleDrawingMutation, CreateSanitizedAttachmentBubbleDrawingMutationVariables>;
export const MarkUploadedSanitizedAttachmentBubbleDrawingDocument = gql`
    mutation markUploadedSanitizedAttachmentBubbleDrawing($id: UUID!) {
  markUploadedSanitizedAttachment(id: $id) {
    id
  }
}
    `;
export type MarkUploadedSanitizedAttachmentBubbleDrawingMutationFn = Apollo.MutationFunction<MarkUploadedSanitizedAttachmentBubbleDrawingMutation, MarkUploadedSanitizedAttachmentBubbleDrawingMutationVariables>;

/**
 * __useMarkUploadedSanitizedAttachmentBubbleDrawingMutation__
 *
 * To run a mutation, you first call `useMarkUploadedSanitizedAttachmentBubbleDrawingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkUploadedSanitizedAttachmentBubbleDrawingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markUploadedSanitizedAttachmentBubbleDrawingMutation, { data, loading, error }] = useMarkUploadedSanitizedAttachmentBubbleDrawingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkUploadedSanitizedAttachmentBubbleDrawingMutation(baseOptions?: Apollo.MutationHookOptions<MarkUploadedSanitizedAttachmentBubbleDrawingMutation, MarkUploadedSanitizedAttachmentBubbleDrawingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkUploadedSanitizedAttachmentBubbleDrawingMutation, MarkUploadedSanitizedAttachmentBubbleDrawingMutationVariables>(MarkUploadedSanitizedAttachmentBubbleDrawingDocument, options);
      }
export type MarkUploadedSanitizedAttachmentBubbleDrawingMutationHookResult = ReturnType<typeof useMarkUploadedSanitizedAttachmentBubbleDrawingMutation>;
export type MarkUploadedSanitizedAttachmentBubbleDrawingMutationResult = Apollo.MutationResult<MarkUploadedSanitizedAttachmentBubbleDrawingMutation>;
export type MarkUploadedSanitizedAttachmentBubbleDrawingMutationOptions = Apollo.BaseMutationOptions<MarkUploadedSanitizedAttachmentBubbleDrawingMutation, MarkUploadedSanitizedAttachmentBubbleDrawingMutationVariables>;
export const QuoteModelRevisionCalloutLabelsDocument = gql`
    query quoteModelRevisionCalloutLabels($id: UUID!) {
  quoteModelRevision(id: $id) {
    id
    attachmentLink {
      id
      quoteAttachmentRevision {
        id
        attachment {
          ... on Attachment {
            id
            modelAttachmentSelections {
              id
              userAnnotationsId
              modelAttachmentAnnotation {
                id
                label
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useQuoteModelRevisionCalloutLabelsQuery__
 *
 * To run a query within a React component, call `useQuoteModelRevisionCalloutLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteModelRevisionCalloutLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteModelRevisionCalloutLabelsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuoteModelRevisionCalloutLabelsQuery(baseOptions: Apollo.QueryHookOptions<QuoteModelRevisionCalloutLabelsQuery, QuoteModelRevisionCalloutLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteModelRevisionCalloutLabelsQuery, QuoteModelRevisionCalloutLabelsQueryVariables>(QuoteModelRevisionCalloutLabelsDocument, options);
      }
export function useQuoteModelRevisionCalloutLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteModelRevisionCalloutLabelsQuery, QuoteModelRevisionCalloutLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteModelRevisionCalloutLabelsQuery, QuoteModelRevisionCalloutLabelsQueryVariables>(QuoteModelRevisionCalloutLabelsDocument, options);
        }
export type QuoteModelRevisionCalloutLabelsQueryHookResult = ReturnType<typeof useQuoteModelRevisionCalloutLabelsQuery>;
export type QuoteModelRevisionCalloutLabelsLazyQueryHookResult = ReturnType<typeof useQuoteModelRevisionCalloutLabelsLazyQuery>;
export type QuoteModelRevisionCalloutLabelsQueryResult = Apollo.QueryResult<QuoteModelRevisionCalloutLabelsQuery, QuoteModelRevisionCalloutLabelsQueryVariables>;
export function refetchQuoteModelRevisionCalloutLabelsQuery(variables: QuoteModelRevisionCalloutLabelsQueryVariables) {
      return { query: QuoteModelRevisionCalloutLabelsDocument, variables: variables }
    }
export const SendBusinessAccountInvitesDocument = gql`
    mutation sendBusinessAccountInvites($businessAccountId: UUID!, $emails: [String!]!) {
  sendBusinessAccountInvites(
    businessAccountId: $businessAccountId
    emails: $emails
  ) {
    invites {
      ...BusinessAccountInviteType
    }
    errors {
      ...BusinessAccountInviteErrorType
    }
  }
}
    ${BusinessAccountInviteTypeFragmentDoc}
${BusinessAccountInviteErrorTypeFragmentDoc}`;
export type SendBusinessAccountInvitesMutationFn = Apollo.MutationFunction<SendBusinessAccountInvitesMutation, SendBusinessAccountInvitesMutationVariables>;

/**
 * __useSendBusinessAccountInvitesMutation__
 *
 * To run a mutation, you first call `useSendBusinessAccountInvitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendBusinessAccountInvitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendBusinessAccountInvitesMutation, { data, loading, error }] = useSendBusinessAccountInvitesMutation({
 *   variables: {
 *      businessAccountId: // value for 'businessAccountId'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useSendBusinessAccountInvitesMutation(baseOptions?: Apollo.MutationHookOptions<SendBusinessAccountInvitesMutation, SendBusinessAccountInvitesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendBusinessAccountInvitesMutation, SendBusinessAccountInvitesMutationVariables>(SendBusinessAccountInvitesDocument, options);
      }
export type SendBusinessAccountInvitesMutationHookResult = ReturnType<typeof useSendBusinessAccountInvitesMutation>;
export type SendBusinessAccountInvitesMutationResult = Apollo.MutationResult<SendBusinessAccountInvitesMutation>;
export type SendBusinessAccountInvitesMutationOptions = Apollo.BaseMutationOptions<SendBusinessAccountInvitesMutation, SendBusinessAccountInvitesMutationVariables>;
export const BusinessAccountOrdersQueryDocument = gql`
    query businessAccountOrdersQuery($businessAccountId: String!, $searchText: String, $offset: Int!, $limit: Int!) {
  businessAccountOrders(
    filters: {businessAccountId: $businessAccountId, searchText: $searchText}
    offset: $offset
    limit: $limit
  ) {
    totalCount
    items {
      id
      name
      purchaserEmail
      purchaserId
      status
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useBusinessAccountOrdersQueryQuery__
 *
 * To run a query within a React component, call `useBusinessAccountOrdersQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessAccountOrdersQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessAccountOrdersQueryQuery({
 *   variables: {
 *      businessAccountId: // value for 'businessAccountId'
 *      searchText: // value for 'searchText'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBusinessAccountOrdersQueryQuery(baseOptions: Apollo.QueryHookOptions<BusinessAccountOrdersQueryQuery, BusinessAccountOrdersQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessAccountOrdersQueryQuery, BusinessAccountOrdersQueryQueryVariables>(BusinessAccountOrdersQueryDocument, options);
      }
export function useBusinessAccountOrdersQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessAccountOrdersQueryQuery, BusinessAccountOrdersQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessAccountOrdersQueryQuery, BusinessAccountOrdersQueryQueryVariables>(BusinessAccountOrdersQueryDocument, options);
        }
export type BusinessAccountOrdersQueryQueryHookResult = ReturnType<typeof useBusinessAccountOrdersQueryQuery>;
export type BusinessAccountOrdersQueryLazyQueryHookResult = ReturnType<typeof useBusinessAccountOrdersQueryLazyQuery>;
export type BusinessAccountOrdersQueryQueryResult = Apollo.QueryResult<BusinessAccountOrdersQueryQuery, BusinessAccountOrdersQueryQueryVariables>;
export function refetchBusinessAccountOrdersQueryQuery(variables: BusinessAccountOrdersQueryQueryVariables) {
      return { query: BusinessAccountOrdersQueryDocument, variables: variables }
    }
export const BusinessAccountQuotesQueryDocument = gql`
    query businessAccountQuotesQuery($businessAccountId: String!, $searchText: String, $offset: Int!, $limit: Int!) {
  businessAccountQuotes(
    filters: {businessAccountId: $businessAccountId, searchText: $searchText}
    offset: $offset
    limit: $limit
  ) {
    totalCount
    items {
      quoteId
      quoteName
      ownerEmail
      ownerEnabled
      ownerId
      status
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useBusinessAccountQuotesQueryQuery__
 *
 * To run a query within a React component, call `useBusinessAccountQuotesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessAccountQuotesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessAccountQuotesQueryQuery({
 *   variables: {
 *      businessAccountId: // value for 'businessAccountId'
 *      searchText: // value for 'searchText'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBusinessAccountQuotesQueryQuery(baseOptions: Apollo.QueryHookOptions<BusinessAccountQuotesQueryQuery, BusinessAccountQuotesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessAccountQuotesQueryQuery, BusinessAccountQuotesQueryQueryVariables>(BusinessAccountQuotesQueryDocument, options);
      }
export function useBusinessAccountQuotesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessAccountQuotesQueryQuery, BusinessAccountQuotesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessAccountQuotesQueryQuery, BusinessAccountQuotesQueryQueryVariables>(BusinessAccountQuotesQueryDocument, options);
        }
export type BusinessAccountQuotesQueryQueryHookResult = ReturnType<typeof useBusinessAccountQuotesQueryQuery>;
export type BusinessAccountQuotesQueryLazyQueryHookResult = ReturnType<typeof useBusinessAccountQuotesQueryLazyQuery>;
export type BusinessAccountQuotesQueryQueryResult = Apollo.QueryResult<BusinessAccountQuotesQueryQuery, BusinessAccountQuotesQueryQueryVariables>;
export function refetchBusinessAccountQuotesQueryQuery(variables: BusinessAccountQuotesQueryQueryVariables) {
      return { query: BusinessAccountQuotesQueryDocument, variables: variables }
    }
export const UpsertBusinessAccountPunchoutFeatureDocument = gql`
    mutation UpsertBusinessAccountPunchoutFeature($businessAccountId: UUID!, $disabledProcesses: String, $isActive: Boolean!) {
  upsertBusinessAccountPunchoutFeature(
    businessAccountId: $businessAccountId
    disabledProcesses: $disabledProcesses
    isActive: $isActive
  ) {
    id
  }
}
    `;
export type UpsertBusinessAccountPunchoutFeatureMutationFn = Apollo.MutationFunction<UpsertBusinessAccountPunchoutFeatureMutation, UpsertBusinessAccountPunchoutFeatureMutationVariables>;

/**
 * __useUpsertBusinessAccountPunchoutFeatureMutation__
 *
 * To run a mutation, you first call `useUpsertBusinessAccountPunchoutFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertBusinessAccountPunchoutFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertBusinessAccountPunchoutFeatureMutation, { data, loading, error }] = useUpsertBusinessAccountPunchoutFeatureMutation({
 *   variables: {
 *      businessAccountId: // value for 'businessAccountId'
 *      disabledProcesses: // value for 'disabledProcesses'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useUpsertBusinessAccountPunchoutFeatureMutation(baseOptions?: Apollo.MutationHookOptions<UpsertBusinessAccountPunchoutFeatureMutation, UpsertBusinessAccountPunchoutFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertBusinessAccountPunchoutFeatureMutation, UpsertBusinessAccountPunchoutFeatureMutationVariables>(UpsertBusinessAccountPunchoutFeatureDocument, options);
      }
export type UpsertBusinessAccountPunchoutFeatureMutationHookResult = ReturnType<typeof useUpsertBusinessAccountPunchoutFeatureMutation>;
export type UpsertBusinessAccountPunchoutFeatureMutationResult = Apollo.MutationResult<UpsertBusinessAccountPunchoutFeatureMutation>;
export type UpsertBusinessAccountPunchoutFeatureMutationOptions = Apollo.BaseMutationOptions<UpsertBusinessAccountPunchoutFeatureMutation, UpsertBusinessAccountPunchoutFeatureMutationVariables>;
export const BusinessAccountPunchoutFeatureDocument = gql`
    query BusinessAccountPunchoutFeature($businessAccountId: UUID!) {
  businessAccountPunchoutFeature(businessAccountId: $businessAccountId) {
    ...PunchoutFeature
  }
}
    ${PunchoutFeatureFragmentDoc}`;

/**
 * __useBusinessAccountPunchoutFeatureQuery__
 *
 * To run a query within a React component, call `useBusinessAccountPunchoutFeatureQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessAccountPunchoutFeatureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessAccountPunchoutFeatureQuery({
 *   variables: {
 *      businessAccountId: // value for 'businessAccountId'
 *   },
 * });
 */
export function useBusinessAccountPunchoutFeatureQuery(baseOptions: Apollo.QueryHookOptions<BusinessAccountPunchoutFeatureQuery, BusinessAccountPunchoutFeatureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessAccountPunchoutFeatureQuery, BusinessAccountPunchoutFeatureQueryVariables>(BusinessAccountPunchoutFeatureDocument, options);
      }
export function useBusinessAccountPunchoutFeatureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessAccountPunchoutFeatureQuery, BusinessAccountPunchoutFeatureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessAccountPunchoutFeatureQuery, BusinessAccountPunchoutFeatureQueryVariables>(BusinessAccountPunchoutFeatureDocument, options);
        }
export type BusinessAccountPunchoutFeatureQueryHookResult = ReturnType<typeof useBusinessAccountPunchoutFeatureQuery>;
export type BusinessAccountPunchoutFeatureLazyQueryHookResult = ReturnType<typeof useBusinessAccountPunchoutFeatureLazyQuery>;
export type BusinessAccountPunchoutFeatureQueryResult = Apollo.QueryResult<BusinessAccountPunchoutFeatureQuery, BusinessAccountPunchoutFeatureQueryVariables>;
export function refetchBusinessAccountPunchoutFeatureQuery(variables: BusinessAccountPunchoutFeatureQueryVariables) {
      return { query: BusinessAccountPunchoutFeatureDocument, variables: variables }
    }
export const BusinessAccountAdminDiscountDocument = gql`
    query businessAccountAdminDiscount($businessAccountId: String!) {
  businessAccount(businessAccountId: $businessAccountId) {
    id
    discount {
      id
      percent
      salesforceOpportunityId
      salesforceOpportunityName
      startAt
      endAt
      isActive
      notes
      createdAt
      createdBy {
        id
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useBusinessAccountAdminDiscountQuery__
 *
 * To run a query within a React component, call `useBusinessAccountAdminDiscountQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessAccountAdminDiscountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessAccountAdminDiscountQuery({
 *   variables: {
 *      businessAccountId: // value for 'businessAccountId'
 *   },
 * });
 */
export function useBusinessAccountAdminDiscountQuery(baseOptions: Apollo.QueryHookOptions<BusinessAccountAdminDiscountQuery, BusinessAccountAdminDiscountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessAccountAdminDiscountQuery, BusinessAccountAdminDiscountQueryVariables>(BusinessAccountAdminDiscountDocument, options);
      }
export function useBusinessAccountAdminDiscountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessAccountAdminDiscountQuery, BusinessAccountAdminDiscountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessAccountAdminDiscountQuery, BusinessAccountAdminDiscountQueryVariables>(BusinessAccountAdminDiscountDocument, options);
        }
export type BusinessAccountAdminDiscountQueryHookResult = ReturnType<typeof useBusinessAccountAdminDiscountQuery>;
export type BusinessAccountAdminDiscountLazyQueryHookResult = ReturnType<typeof useBusinessAccountAdminDiscountLazyQuery>;
export type BusinessAccountAdminDiscountQueryResult = Apollo.QueryResult<BusinessAccountAdminDiscountQuery, BusinessAccountAdminDiscountQueryVariables>;
export function refetchBusinessAccountAdminDiscountQuery(variables: BusinessAccountAdminDiscountQueryVariables) {
      return { query: BusinessAccountAdminDiscountDocument, variables: variables }
    }
export const BusinessAccountDocument = gql`
    query businessAccount($businessAccountId: String!) {
  businessAccount(businessAccountId: $businessAccountId) {
    ...BusinessAccount
  }
}
    ${BusinessAccountFragmentDoc}`;

/**
 * __useBusinessAccountQuery__
 *
 * To run a query within a React component, call `useBusinessAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessAccountQuery({
 *   variables: {
 *      businessAccountId: // value for 'businessAccountId'
 *   },
 * });
 */
export function useBusinessAccountQuery(baseOptions: Apollo.QueryHookOptions<BusinessAccountQuery, BusinessAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessAccountQuery, BusinessAccountQueryVariables>(BusinessAccountDocument, options);
      }
export function useBusinessAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessAccountQuery, BusinessAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessAccountQuery, BusinessAccountQueryVariables>(BusinessAccountDocument, options);
        }
export type BusinessAccountQueryHookResult = ReturnType<typeof useBusinessAccountQuery>;
export type BusinessAccountLazyQueryHookResult = ReturnType<typeof useBusinessAccountLazyQuery>;
export type BusinessAccountQueryResult = Apollo.QueryResult<BusinessAccountQuery, BusinessAccountQueryVariables>;
export function refetchBusinessAccountQuery(variables: BusinessAccountQueryVariables) {
      return { query: BusinessAccountDocument, variables: variables }
    }
export const CreateBusinessAccountDiscountDocument = gql`
    mutation createBusinessAccountDiscount($businessAccountId: String!, $businessAccountDiscountDataInput: BusinessAccountDiscountDataInput!) {
  createBusinessAccountDiscount(
    businessAccountId: $businessAccountId
    businessAccountDiscountDataInput: $businessAccountDiscountDataInput
  ) {
    id
    percent
    salesforceOpportunityId
    startAt
    endAt
    isActive
    notes
    createdAt
    createdBy {
      id
      firstName
      lastName
    }
  }
}
    `;
export type CreateBusinessAccountDiscountMutationFn = Apollo.MutationFunction<CreateBusinessAccountDiscountMutation, CreateBusinessAccountDiscountMutationVariables>;

/**
 * __useCreateBusinessAccountDiscountMutation__
 *
 * To run a mutation, you first call `useCreateBusinessAccountDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBusinessAccountDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBusinessAccountDiscountMutation, { data, loading, error }] = useCreateBusinessAccountDiscountMutation({
 *   variables: {
 *      businessAccountId: // value for 'businessAccountId'
 *      businessAccountDiscountDataInput: // value for 'businessAccountDiscountDataInput'
 *   },
 * });
 */
export function useCreateBusinessAccountDiscountMutation(baseOptions?: Apollo.MutationHookOptions<CreateBusinessAccountDiscountMutation, CreateBusinessAccountDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBusinessAccountDiscountMutation, CreateBusinessAccountDiscountMutationVariables>(CreateBusinessAccountDiscountDocument, options);
      }
export type CreateBusinessAccountDiscountMutationHookResult = ReturnType<typeof useCreateBusinessAccountDiscountMutation>;
export type CreateBusinessAccountDiscountMutationResult = Apollo.MutationResult<CreateBusinessAccountDiscountMutation>;
export type CreateBusinessAccountDiscountMutationOptions = Apollo.BaseMutationOptions<CreateBusinessAccountDiscountMutation, CreateBusinessAccountDiscountMutationVariables>;
export const DeleteBusinessAccountDiscountDocument = gql`
    mutation deleteBusinessAccountDiscount($businessAccountId: String!) {
  deactivateBusinessAccountDiscount(businessAccountId: $businessAccountId) {
    id
  }
}
    `;
export type DeleteBusinessAccountDiscountMutationFn = Apollo.MutationFunction<DeleteBusinessAccountDiscountMutation, DeleteBusinessAccountDiscountMutationVariables>;

/**
 * __useDeleteBusinessAccountDiscountMutation__
 *
 * To run a mutation, you first call `useDeleteBusinessAccountDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBusinessAccountDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBusinessAccountDiscountMutation, { data, loading, error }] = useDeleteBusinessAccountDiscountMutation({
 *   variables: {
 *      businessAccountId: // value for 'businessAccountId'
 *   },
 * });
 */
export function useDeleteBusinessAccountDiscountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBusinessAccountDiscountMutation, DeleteBusinessAccountDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBusinessAccountDiscountMutation, DeleteBusinessAccountDiscountMutationVariables>(DeleteBusinessAccountDiscountDocument, options);
      }
export type DeleteBusinessAccountDiscountMutationHookResult = ReturnType<typeof useDeleteBusinessAccountDiscountMutation>;
export type DeleteBusinessAccountDiscountMutationResult = Apollo.MutationResult<DeleteBusinessAccountDiscountMutation>;
export type DeleteBusinessAccountDiscountMutationOptions = Apollo.BaseMutationOptions<DeleteBusinessAccountDiscountMutation, DeleteBusinessAccountDiscountMutationVariables>;
export const GetAllBusinessAccountFeaturesDocument = gql`
    query getAllBusinessAccountFeatures($businessAccountId: UUID!) {
  getAllBusinessAccountFeatures(businessAccountId: $businessAccountId) {
    ...BusinessAccountFeatureItem
  }
}
    ${BusinessAccountFeatureItemFragmentDoc}`;

/**
 * __useGetAllBusinessAccountFeaturesQuery__
 *
 * To run a query within a React component, call `useGetAllBusinessAccountFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllBusinessAccountFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllBusinessAccountFeaturesQuery({
 *   variables: {
 *      businessAccountId: // value for 'businessAccountId'
 *   },
 * });
 */
export function useGetAllBusinessAccountFeaturesQuery(baseOptions: Apollo.QueryHookOptions<GetAllBusinessAccountFeaturesQuery, GetAllBusinessAccountFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllBusinessAccountFeaturesQuery, GetAllBusinessAccountFeaturesQueryVariables>(GetAllBusinessAccountFeaturesDocument, options);
      }
export function useGetAllBusinessAccountFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllBusinessAccountFeaturesQuery, GetAllBusinessAccountFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllBusinessAccountFeaturesQuery, GetAllBusinessAccountFeaturesQueryVariables>(GetAllBusinessAccountFeaturesDocument, options);
        }
export type GetAllBusinessAccountFeaturesQueryHookResult = ReturnType<typeof useGetAllBusinessAccountFeaturesQuery>;
export type GetAllBusinessAccountFeaturesLazyQueryHookResult = ReturnType<typeof useGetAllBusinessAccountFeaturesLazyQuery>;
export type GetAllBusinessAccountFeaturesQueryResult = Apollo.QueryResult<GetAllBusinessAccountFeaturesQuery, GetAllBusinessAccountFeaturesQueryVariables>;
export function refetchGetAllBusinessAccountFeaturesQuery(variables: GetAllBusinessAccountFeaturesQueryVariables) {
      return { query: GetAllBusinessAccountFeaturesDocument, variables: variables }
    }
export const UpdateBusinessAccountDiscountDocument = gql`
    mutation updateBusinessAccountDiscount($businessAccountId: String!, $businessAccountDiscountDataInput: BusinessAccountDiscountDataInput!) {
  updateBusinessAccountDiscount(
    businessAccountId: $businessAccountId
    businessAccountDiscountDataInput: $businessAccountDiscountDataInput
  ) {
    id
    percent
    salesforceOpportunityId
    startAt
    endAt
    isActive
    notes
    createdAt
    createdBy {
      id
      firstName
      lastName
    }
  }
}
    `;
export type UpdateBusinessAccountDiscountMutationFn = Apollo.MutationFunction<UpdateBusinessAccountDiscountMutation, UpdateBusinessAccountDiscountMutationVariables>;

/**
 * __useUpdateBusinessAccountDiscountMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessAccountDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessAccountDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessAccountDiscountMutation, { data, loading, error }] = useUpdateBusinessAccountDiscountMutation({
 *   variables: {
 *      businessAccountId: // value for 'businessAccountId'
 *      businessAccountDiscountDataInput: // value for 'businessAccountDiscountDataInput'
 *   },
 * });
 */
export function useUpdateBusinessAccountDiscountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessAccountDiscountMutation, UpdateBusinessAccountDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBusinessAccountDiscountMutation, UpdateBusinessAccountDiscountMutationVariables>(UpdateBusinessAccountDiscountDocument, options);
      }
export type UpdateBusinessAccountDiscountMutationHookResult = ReturnType<typeof useUpdateBusinessAccountDiscountMutation>;
export type UpdateBusinessAccountDiscountMutationResult = Apollo.MutationResult<UpdateBusinessAccountDiscountMutation>;
export type UpdateBusinessAccountDiscountMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessAccountDiscountMutation, UpdateBusinessAccountDiscountMutationVariables>;
export const CreateBusinessAccountSubscriptionDocument = gql`
    mutation createBusinessAccountSubscription($businessAccountId: String!, $planId: String!, $expiration: Date!, $setActive: Boolean) {
  createBusinessAccountSubscription(
    businessAccountId: $businessAccountId
    planId: $planId
    expiration: $expiration
    setActive: $setActive
  ) {
    id
    enabledBy {
      id
      displayName
      email
    }
    enabledAt
    expiresAt
    disabledBy {
      id
      displayName
      email
    }
    disabledAt
    plan {
      id
      planName
      planId
      durationDays
    }
    status
    durationDays
  }
}
    `;
export type CreateBusinessAccountSubscriptionMutationFn = Apollo.MutationFunction<CreateBusinessAccountSubscriptionMutation, CreateBusinessAccountSubscriptionMutationVariables>;

/**
 * __useCreateBusinessAccountSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateBusinessAccountSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBusinessAccountSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBusinessAccountSubscriptionMutation, { data, loading, error }] = useCreateBusinessAccountSubscriptionMutation({
 *   variables: {
 *      businessAccountId: // value for 'businessAccountId'
 *      planId: // value for 'planId'
 *      expiration: // value for 'expiration'
 *      setActive: // value for 'setActive'
 *   },
 * });
 */
export function useCreateBusinessAccountSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateBusinessAccountSubscriptionMutation, CreateBusinessAccountSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBusinessAccountSubscriptionMutation, CreateBusinessAccountSubscriptionMutationVariables>(CreateBusinessAccountSubscriptionDocument, options);
      }
export type CreateBusinessAccountSubscriptionMutationHookResult = ReturnType<typeof useCreateBusinessAccountSubscriptionMutation>;
export type CreateBusinessAccountSubscriptionMutationResult = Apollo.MutationResult<CreateBusinessAccountSubscriptionMutation>;
export type CreateBusinessAccountSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateBusinessAccountSubscriptionMutation, CreateBusinessAccountSubscriptionMutationVariables>;
export const EnableOrDisableBusinessAccountSubscriptionDocument = gql`
    mutation enableOrDisableBusinessAccountSubscription($subscriptionId: Int!, $status: BusinessAccountSubscriptionEnablementStatus!) {
  updateBusinessAccountSubscription(
    subscriptionId: $subscriptionId
    status: $status
  ) {
    id
    enabledBy {
      id
      displayName
      email
    }
    enabledAt
    expiresAt
    disabledBy {
      id
      displayName
      email
    }
    disabledAt
    plan {
      id
      planName
      planId
      durationDays
    }
    status
    durationDays
  }
}
    `;
export type EnableOrDisableBusinessAccountSubscriptionMutationFn = Apollo.MutationFunction<EnableOrDisableBusinessAccountSubscriptionMutation, EnableOrDisableBusinessAccountSubscriptionMutationVariables>;

/**
 * __useEnableOrDisableBusinessAccountSubscriptionMutation__
 *
 * To run a mutation, you first call `useEnableOrDisableBusinessAccountSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableOrDisableBusinessAccountSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableOrDisableBusinessAccountSubscriptionMutation, { data, loading, error }] = useEnableOrDisableBusinessAccountSubscriptionMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useEnableOrDisableBusinessAccountSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<EnableOrDisableBusinessAccountSubscriptionMutation, EnableOrDisableBusinessAccountSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableOrDisableBusinessAccountSubscriptionMutation, EnableOrDisableBusinessAccountSubscriptionMutationVariables>(EnableOrDisableBusinessAccountSubscriptionDocument, options);
      }
export type EnableOrDisableBusinessAccountSubscriptionMutationHookResult = ReturnType<typeof useEnableOrDisableBusinessAccountSubscriptionMutation>;
export type EnableOrDisableBusinessAccountSubscriptionMutationResult = Apollo.MutationResult<EnableOrDisableBusinessAccountSubscriptionMutation>;
export type EnableOrDisableBusinessAccountSubscriptionMutationOptions = Apollo.BaseMutationOptions<EnableOrDisableBusinessAccountSubscriptionMutation, EnableOrDisableBusinessAccountSubscriptionMutationVariables>;
export const BusinessAccountPlansDocument = gql`
    query businessAccountPlans($includeDisabled: Boolean, $limit: Int, $offset: Int) {
  businessAccountPlans(
    includeDisabled: $includeDisabled
    limit: $limit
    offset: $offset
  ) {
    totalCount
    items {
      id
      planId
      planName
      durationDays
    }
  }
}
    `;

/**
 * __useBusinessAccountPlansQuery__
 *
 * To run a query within a React component, call `useBusinessAccountPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessAccountPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessAccountPlansQuery({
 *   variables: {
 *      includeDisabled: // value for 'includeDisabled'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useBusinessAccountPlansQuery(baseOptions?: Apollo.QueryHookOptions<BusinessAccountPlansQuery, BusinessAccountPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessAccountPlansQuery, BusinessAccountPlansQueryVariables>(BusinessAccountPlansDocument, options);
      }
export function useBusinessAccountPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessAccountPlansQuery, BusinessAccountPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessAccountPlansQuery, BusinessAccountPlansQueryVariables>(BusinessAccountPlansDocument, options);
        }
export type BusinessAccountPlansQueryHookResult = ReturnType<typeof useBusinessAccountPlansQuery>;
export type BusinessAccountPlansLazyQueryHookResult = ReturnType<typeof useBusinessAccountPlansLazyQuery>;
export type BusinessAccountPlansQueryResult = Apollo.QueryResult<BusinessAccountPlansQuery, BusinessAccountPlansQueryVariables>;
export function refetchBusinessAccountPlansQuery(variables?: BusinessAccountPlansQueryVariables) {
      return { query: BusinessAccountPlansDocument, variables: variables }
    }
export const BusinessAccountSubscriptionDocument = gql`
    query businessAccountSubscription($businessAccountId: String!) {
  businessAccount(businessAccountId: $businessAccountId) {
    id
    subscription {
      ...BusinessAccountSubscription
    }
  }
}
    ${BusinessAccountSubscriptionFragmentDoc}`;

/**
 * __useBusinessAccountSubscriptionQuery__
 *
 * To run a query within a React component, call `useBusinessAccountSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessAccountSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessAccountSubscriptionQuery({
 *   variables: {
 *      businessAccountId: // value for 'businessAccountId'
 *   },
 * });
 */
export function useBusinessAccountSubscriptionQuery(baseOptions: Apollo.QueryHookOptions<BusinessAccountSubscriptionQuery, BusinessAccountSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessAccountSubscriptionQuery, BusinessAccountSubscriptionQueryVariables>(BusinessAccountSubscriptionDocument, options);
      }
export function useBusinessAccountSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessAccountSubscriptionQuery, BusinessAccountSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessAccountSubscriptionQuery, BusinessAccountSubscriptionQueryVariables>(BusinessAccountSubscriptionDocument, options);
        }
export type BusinessAccountSubscriptionQueryHookResult = ReturnType<typeof useBusinessAccountSubscriptionQuery>;
export type BusinessAccountSubscriptionLazyQueryHookResult = ReturnType<typeof useBusinessAccountSubscriptionLazyQuery>;
export type BusinessAccountSubscriptionQueryResult = Apollo.QueryResult<BusinessAccountSubscriptionQuery, BusinessAccountSubscriptionQueryVariables>;
export function refetchBusinessAccountSubscriptionQuery(variables: BusinessAccountSubscriptionQueryVariables) {
      return { query: BusinessAccountSubscriptionDocument, variables: variables }
    }
export const BusinessAccountSubscriptionHistoryDocument = gql`
    query businessAccountSubscriptionHistory($businessAccountId: String!, $limit: Int, $offset: Int) {
  businessAccount(businessAccountId: $businessAccountId) {
    id
    subscriptionHistory(limit: $limit, offset: $offset) {
      subscriptions {
        ...BusinessAccountSubscription
      }
      count
    }
  }
}
    ${BusinessAccountSubscriptionFragmentDoc}`;

/**
 * __useBusinessAccountSubscriptionHistoryQuery__
 *
 * To run a query within a React component, call `useBusinessAccountSubscriptionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessAccountSubscriptionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessAccountSubscriptionHistoryQuery({
 *   variables: {
 *      businessAccountId: // value for 'businessAccountId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useBusinessAccountSubscriptionHistoryQuery(baseOptions: Apollo.QueryHookOptions<BusinessAccountSubscriptionHistoryQuery, BusinessAccountSubscriptionHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessAccountSubscriptionHistoryQuery, BusinessAccountSubscriptionHistoryQueryVariables>(BusinessAccountSubscriptionHistoryDocument, options);
      }
export function useBusinessAccountSubscriptionHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessAccountSubscriptionHistoryQuery, BusinessAccountSubscriptionHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessAccountSubscriptionHistoryQuery, BusinessAccountSubscriptionHistoryQueryVariables>(BusinessAccountSubscriptionHistoryDocument, options);
        }
export type BusinessAccountSubscriptionHistoryQueryHookResult = ReturnType<typeof useBusinessAccountSubscriptionHistoryQuery>;
export type BusinessAccountSubscriptionHistoryLazyQueryHookResult = ReturnType<typeof useBusinessAccountSubscriptionHistoryLazyQuery>;
export type BusinessAccountSubscriptionHistoryQueryResult = Apollo.QueryResult<BusinessAccountSubscriptionHistoryQuery, BusinessAccountSubscriptionHistoryQueryVariables>;
export function refetchBusinessAccountSubscriptionHistoryQuery(variables: BusinessAccountSubscriptionHistoryQueryVariables) {
      return { query: BusinessAccountSubscriptionHistoryDocument, variables: variables }
    }
export const BusinessAccountMembersQueryDocument = gql`
    query businessAccountMembersQuery($filters: BusinessAccountMembersFilterInput, $offset: Int!, $limit: Int!) {
  businessAccountMembers(filters: $filters, offset: $offset, limit: $limit) {
    totalCount
    items {
      id
      user {
        id
        displayName
        email
        enabled
      }
      salesforceContactUrl
      createdAt
      lastLoginDate
      capabilities
    }
  }
}
    `;

/**
 * __useBusinessAccountMembersQueryQuery__
 *
 * To run a query within a React component, call `useBusinessAccountMembersQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessAccountMembersQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessAccountMembersQueryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBusinessAccountMembersQueryQuery(baseOptions: Apollo.QueryHookOptions<BusinessAccountMembersQueryQuery, BusinessAccountMembersQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessAccountMembersQueryQuery, BusinessAccountMembersQueryQueryVariables>(BusinessAccountMembersQueryDocument, options);
      }
export function useBusinessAccountMembersQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessAccountMembersQueryQuery, BusinessAccountMembersQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessAccountMembersQueryQuery, BusinessAccountMembersQueryQueryVariables>(BusinessAccountMembersQueryDocument, options);
        }
export type BusinessAccountMembersQueryQueryHookResult = ReturnType<typeof useBusinessAccountMembersQueryQuery>;
export type BusinessAccountMembersQueryLazyQueryHookResult = ReturnType<typeof useBusinessAccountMembersQueryLazyQuery>;
export type BusinessAccountMembersQueryQueryResult = Apollo.QueryResult<BusinessAccountMembersQueryQuery, BusinessAccountMembersQueryQueryVariables>;
export function refetchBusinessAccountMembersQueryQuery(variables: BusinessAccountMembersQueryQueryVariables) {
      return { query: BusinessAccountMembersQueryDocument, variables: variables }
    }
export const BusinessAccountPendingMembersQueryDocument = gql`
    query businessAccountPendingMembersQuery($filters: BusinessAccountPendingMembersFilterInput, $offset: Int!, $limit: Int!) {
  businessAccountPendingMembers(filters: $filters, offset: $offset, limit: $limit) {
    totalCount
    items {
      lastLoginDate
      salesforceContactUrl
      capabilities
      invite {
        id
        email
        sentDate
        status
      }
      user {
        id
        displayName
        email
      }
    }
  }
}
    `;

/**
 * __useBusinessAccountPendingMembersQueryQuery__
 *
 * To run a query within a React component, call `useBusinessAccountPendingMembersQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessAccountPendingMembersQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessAccountPendingMembersQueryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBusinessAccountPendingMembersQueryQuery(baseOptions: Apollo.QueryHookOptions<BusinessAccountPendingMembersQueryQuery, BusinessAccountPendingMembersQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessAccountPendingMembersQueryQuery, BusinessAccountPendingMembersQueryQueryVariables>(BusinessAccountPendingMembersQueryDocument, options);
      }
export function useBusinessAccountPendingMembersQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessAccountPendingMembersQueryQuery, BusinessAccountPendingMembersQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessAccountPendingMembersQueryQuery, BusinessAccountPendingMembersQueryQueryVariables>(BusinessAccountPendingMembersQueryDocument, options);
        }
export type BusinessAccountPendingMembersQueryQueryHookResult = ReturnType<typeof useBusinessAccountPendingMembersQueryQuery>;
export type BusinessAccountPendingMembersQueryLazyQueryHookResult = ReturnType<typeof useBusinessAccountPendingMembersQueryLazyQuery>;
export type BusinessAccountPendingMembersQueryQueryResult = Apollo.QueryResult<BusinessAccountPendingMembersQueryQuery, BusinessAccountPendingMembersQueryQueryVariables>;
export function refetchBusinessAccountPendingMembersQueryQuery(variables: BusinessAccountPendingMembersQueryQueryVariables) {
      return { query: BusinessAccountPendingMembersQueryDocument, variables: variables }
    }
export const BusinessAccountContactsDocument = gql`
    query BusinessAccountContacts($businessAccountId: String!, $searchText: String, $membershipFilters: [BusinessAccountMembershipFilterType!], $offset: Int!, $limit: Int!) {
  businessAccountContacts(
    filterInput: {businessAccountId: $businessAccountId, searchText: $searchText, membershipFilters: $membershipFilters}
    limit: $limit
    offset: $offset
  ) {
    items {
      user {
        id
        displayName
        email
        createdAt
        enabled
      }
      status
      lastLoginDate
    }
    totalCount
  }
}
    `;

/**
 * __useBusinessAccountContactsQuery__
 *
 * To run a query within a React component, call `useBusinessAccountContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessAccountContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessAccountContactsQuery({
 *   variables: {
 *      businessAccountId: // value for 'businessAccountId'
 *      searchText: // value for 'searchText'
 *      membershipFilters: // value for 'membershipFilters'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBusinessAccountContactsQuery(baseOptions: Apollo.QueryHookOptions<BusinessAccountContactsQuery, BusinessAccountContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessAccountContactsQuery, BusinessAccountContactsQueryVariables>(BusinessAccountContactsDocument, options);
      }
export function useBusinessAccountContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessAccountContactsQuery, BusinessAccountContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessAccountContactsQuery, BusinessAccountContactsQueryVariables>(BusinessAccountContactsDocument, options);
        }
export type BusinessAccountContactsQueryHookResult = ReturnType<typeof useBusinessAccountContactsQuery>;
export type BusinessAccountContactsLazyQueryHookResult = ReturnType<typeof useBusinessAccountContactsLazyQuery>;
export type BusinessAccountContactsQueryResult = Apollo.QueryResult<BusinessAccountContactsQuery, BusinessAccountContactsQueryVariables>;
export function refetchBusinessAccountContactsQuery(variables: BusinessAccountContactsQueryVariables) {
      return { query: BusinessAccountContactsDocument, variables: variables }
    }
export const TeamsDocument = gql`
    query Teams($filters: TeamsFilterInput, $limit: Int, $offset: Int) {
  teams(filters: $filters, limit: $limit, offset: $offset) {
    totalCount
    items {
      id
      name
      totalMembers
      totalQuotes
      totalSalesOrders
      createdAt
      createdBy {
        email
        id
      }
    }
  }
}
    `;

/**
 * __useTeamsQuery__
 *
 * To run a query within a React component, call `useTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useTeamsQuery(baseOptions?: Apollo.QueryHookOptions<TeamsQuery, TeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamsQuery, TeamsQueryVariables>(TeamsDocument, options);
      }
export function useTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamsQuery, TeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamsQuery, TeamsQueryVariables>(TeamsDocument, options);
        }
export type TeamsQueryHookResult = ReturnType<typeof useTeamsQuery>;
export type TeamsLazyQueryHookResult = ReturnType<typeof useTeamsLazyQuery>;
export type TeamsQueryResult = Apollo.QueryResult<TeamsQuery, TeamsQueryVariables>;
export function refetchTeamsQuery(variables?: TeamsQueryVariables) {
      return { query: TeamsDocument, variables: variables }
    }
export const UpdateBusinessAccountNameDocument = gql`
    mutation updateBusinessAccountName($businessAccountId: UUID!, $name: String!) {
  updateBusinessAccount(businessAccountId: $businessAccountId, name: $name) {
    id
    name
    updatedBy {
      id
      displayName
      email
    }
    updatedAt
  }
}
    `;
export type UpdateBusinessAccountNameMutationFn = Apollo.MutationFunction<UpdateBusinessAccountNameMutation, UpdateBusinessAccountNameMutationVariables>;

/**
 * __useUpdateBusinessAccountNameMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessAccountNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessAccountNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessAccountNameMutation, { data, loading, error }] = useUpdateBusinessAccountNameMutation({
 *   variables: {
 *      businessAccountId: // value for 'businessAccountId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateBusinessAccountNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessAccountNameMutation, UpdateBusinessAccountNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBusinessAccountNameMutation, UpdateBusinessAccountNameMutationVariables>(UpdateBusinessAccountNameDocument, options);
      }
export type UpdateBusinessAccountNameMutationHookResult = ReturnType<typeof useUpdateBusinessAccountNameMutation>;
export type UpdateBusinessAccountNameMutationResult = Apollo.MutationResult<UpdateBusinessAccountNameMutation>;
export type UpdateBusinessAccountNameMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessAccountNameMutation, UpdateBusinessAccountNameMutationVariables>;
export const BusinessAccountDiscountAdminBusinessAccountDicountSectionDocument = gql`
    query businessAccountDiscountAdminBusinessAccountDicountSection($businessAccountId: String!) {
  businessAccount(businessAccountId: $businessAccountId) {
    id
    discount {
      id
      percent
      salesforceOpportunityId
      salesforceOpportunityName
      startAt
      endAt
      isActive
      notes
      createdAt
      createdBy {
        id
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useBusinessAccountDiscountAdminBusinessAccountDicountSectionQuery__
 *
 * To run a query within a React component, call `useBusinessAccountDiscountAdminBusinessAccountDicountSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessAccountDiscountAdminBusinessAccountDicountSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessAccountDiscountAdminBusinessAccountDicountSectionQuery({
 *   variables: {
 *      businessAccountId: // value for 'businessAccountId'
 *   },
 * });
 */
export function useBusinessAccountDiscountAdminBusinessAccountDicountSectionQuery(baseOptions: Apollo.QueryHookOptions<BusinessAccountDiscountAdminBusinessAccountDicountSectionQuery, BusinessAccountDiscountAdminBusinessAccountDicountSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessAccountDiscountAdminBusinessAccountDicountSectionQuery, BusinessAccountDiscountAdminBusinessAccountDicountSectionQueryVariables>(BusinessAccountDiscountAdminBusinessAccountDicountSectionDocument, options);
      }
export function useBusinessAccountDiscountAdminBusinessAccountDicountSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessAccountDiscountAdminBusinessAccountDicountSectionQuery, BusinessAccountDiscountAdminBusinessAccountDicountSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessAccountDiscountAdminBusinessAccountDicountSectionQuery, BusinessAccountDiscountAdminBusinessAccountDicountSectionQueryVariables>(BusinessAccountDiscountAdminBusinessAccountDicountSectionDocument, options);
        }
export type BusinessAccountDiscountAdminBusinessAccountDicountSectionQueryHookResult = ReturnType<typeof useBusinessAccountDiscountAdminBusinessAccountDicountSectionQuery>;
export type BusinessAccountDiscountAdminBusinessAccountDicountSectionLazyQueryHookResult = ReturnType<typeof useBusinessAccountDiscountAdminBusinessAccountDicountSectionLazyQuery>;
export type BusinessAccountDiscountAdminBusinessAccountDicountSectionQueryResult = Apollo.QueryResult<BusinessAccountDiscountAdminBusinessAccountDicountSectionQuery, BusinessAccountDiscountAdminBusinessAccountDicountSectionQueryVariables>;
export function refetchBusinessAccountDiscountAdminBusinessAccountDicountSectionQuery(variables: BusinessAccountDiscountAdminBusinessAccountDicountSectionQueryVariables) {
      return { query: BusinessAccountDiscountAdminBusinessAccountDicountSectionDocument, variables: variables }
    }
export const CreateBusinessAccountDiscountAdminBusinessAccountDiscountFormDocument = gql`
    mutation createBusinessAccountDiscountAdminBusinessAccountDiscountForm($businessAccountId: String!, $businessAccountDiscountDataInput: BusinessAccountDiscountDataInput!) {
  createBusinessAccountDiscount(
    businessAccountId: $businessAccountId
    businessAccountDiscountDataInput: $businessAccountDiscountDataInput
  ) {
    id
    percent
    salesforceOpportunityId
    startAt
    endAt
    isActive
    notes
    createdAt
    createdBy {
      id
      firstName
      lastName
    }
  }
}
    `;
export type CreateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutationFn = Apollo.MutationFunction<CreateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation, CreateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutationVariables>;

/**
 * __useCreateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation__
 *
 * To run a mutation, you first call `useCreateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation, { data, loading, error }] = useCreateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation({
 *   variables: {
 *      businessAccountId: // value for 'businessAccountId'
 *      businessAccountDiscountDataInput: // value for 'businessAccountDiscountDataInput'
 *   },
 * });
 */
export function useCreateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation(baseOptions?: Apollo.MutationHookOptions<CreateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation, CreateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation, CreateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutationVariables>(CreateBusinessAccountDiscountAdminBusinessAccountDiscountFormDocument, options);
      }
export type CreateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutationHookResult = ReturnType<typeof useCreateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation>;
export type CreateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutationResult = Apollo.MutationResult<CreateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation>;
export type CreateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutationOptions = Apollo.BaseMutationOptions<CreateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation, CreateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutationVariables>;
export const UpdateBusinessAccountDiscountAdminBusinessAccountDiscountFormDocument = gql`
    mutation updateBusinessAccountDiscountAdminBusinessAccountDiscountForm($businessAccountId: String!, $businessAccountDiscountDataInput: BusinessAccountDiscountDataInput!) {
  updateBusinessAccountDiscount(
    businessAccountId: $businessAccountId
    businessAccountDiscountDataInput: $businessAccountDiscountDataInput
  ) {
    id
    percent
    salesforceOpportunityId
    startAt
    endAt
    isActive
    notes
    createdAt
    createdBy {
      id
      firstName
      lastName
    }
  }
}
    `;
export type UpdateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutationFn = Apollo.MutationFunction<UpdateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation, UpdateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutationVariables>;

/**
 * __useUpdateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation, { data, loading, error }] = useUpdateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation({
 *   variables: {
 *      businessAccountId: // value for 'businessAccountId'
 *      businessAccountDiscountDataInput: // value for 'businessAccountDiscountDataInput'
 *   },
 * });
 */
export function useUpdateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation, UpdateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation, UpdateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutationVariables>(UpdateBusinessAccountDiscountAdminBusinessAccountDiscountFormDocument, options);
      }
export type UpdateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutationHookResult = ReturnType<typeof useUpdateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation>;
export type UpdateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutationResult = Apollo.MutationResult<UpdateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation>;
export type UpdateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation, UpdateBusinessAccountDiscountAdminBusinessAccountDiscountFormMutationVariables>;
export const DeleteBusinessAccountDiscountAdminBusinessAccountDiscountFormDocument = gql`
    mutation deleteBusinessAccountDiscountAdminBusinessAccountDiscountForm($businessAccountId: String!) {
  deactivateBusinessAccountDiscount(businessAccountId: $businessAccountId) {
    id
  }
}
    `;
export type DeleteBusinessAccountDiscountAdminBusinessAccountDiscountFormMutationFn = Apollo.MutationFunction<DeleteBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation, DeleteBusinessAccountDiscountAdminBusinessAccountDiscountFormMutationVariables>;

/**
 * __useDeleteBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation__
 *
 * To run a mutation, you first call `useDeleteBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation, { data, loading, error }] = useDeleteBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation({
 *   variables: {
 *      businessAccountId: // value for 'businessAccountId'
 *   },
 * });
 */
export function useDeleteBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation, DeleteBusinessAccountDiscountAdminBusinessAccountDiscountFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation, DeleteBusinessAccountDiscountAdminBusinessAccountDiscountFormMutationVariables>(DeleteBusinessAccountDiscountAdminBusinessAccountDiscountFormDocument, options);
      }
export type DeleteBusinessAccountDiscountAdminBusinessAccountDiscountFormMutationHookResult = ReturnType<typeof useDeleteBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation>;
export type DeleteBusinessAccountDiscountAdminBusinessAccountDiscountFormMutationResult = Apollo.MutationResult<DeleteBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation>;
export type DeleteBusinessAccountDiscountAdminBusinessAccountDiscountFormMutationOptions = Apollo.BaseMutationOptions<DeleteBusinessAccountDiscountAdminBusinessAccountDiscountFormMutation, DeleteBusinessAccountDiscountAdminBusinessAccountDiscountFormMutationVariables>;
export const GetAllBusinessAccountFeaturesQueryDocument = gql`
    query getAllBusinessAccountFeaturesQuery($businessAccountId: UUID!) {
  getAllBusinessAccountFeatures(businessAccountId: $businessAccountId) {
    id
    businessAccountId
    featureName
    isEnabled
    updatedAt
  }
}
    `;

/**
 * __useGetAllBusinessAccountFeaturesQueryQuery__
 *
 * To run a query within a React component, call `useGetAllBusinessAccountFeaturesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllBusinessAccountFeaturesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllBusinessAccountFeaturesQueryQuery({
 *   variables: {
 *      businessAccountId: // value for 'businessAccountId'
 *   },
 * });
 */
export function useGetAllBusinessAccountFeaturesQueryQuery(baseOptions: Apollo.QueryHookOptions<GetAllBusinessAccountFeaturesQueryQuery, GetAllBusinessAccountFeaturesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllBusinessAccountFeaturesQueryQuery, GetAllBusinessAccountFeaturesQueryQueryVariables>(GetAllBusinessAccountFeaturesQueryDocument, options);
      }
export function useGetAllBusinessAccountFeaturesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllBusinessAccountFeaturesQueryQuery, GetAllBusinessAccountFeaturesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllBusinessAccountFeaturesQueryQuery, GetAllBusinessAccountFeaturesQueryQueryVariables>(GetAllBusinessAccountFeaturesQueryDocument, options);
        }
export type GetAllBusinessAccountFeaturesQueryQueryHookResult = ReturnType<typeof useGetAllBusinessAccountFeaturesQueryQuery>;
export type GetAllBusinessAccountFeaturesQueryLazyQueryHookResult = ReturnType<typeof useGetAllBusinessAccountFeaturesQueryLazyQuery>;
export type GetAllBusinessAccountFeaturesQueryQueryResult = Apollo.QueryResult<GetAllBusinessAccountFeaturesQueryQuery, GetAllBusinessAccountFeaturesQueryQueryVariables>;
export function refetchGetAllBusinessAccountFeaturesQueryQuery(variables: GetAllBusinessAccountFeaturesQueryQueryVariables) {
      return { query: GetAllBusinessAccountFeaturesQueryDocument, variables: variables }
    }
export const MessageManagemenPageDfmFeedbackMessagesDocument = gql`
    query messageManagemenPageDfmFeedbackMessages($platformProcessId: String, $type: DfmFeedbackMessageType, $topicId: UUID, $disabled: Boolean) {
  dfmFeedbackMessages(
    platformProcessId: $platformProcessId
    type: $type
    topicId: $topicId
    disabled: $disabled
  ) {
    id
    code
    type
    disabled
    severity
    message
    platformProcessId
    link
    title
    dfmTopic {
      id
      label
    }
    createdAt
    createdBy {
      id
    }
    updatedAt
    updatedBy {
      id
      displayName
    }
    deletedAt
    deletedBy {
      id
    }
  }
}
    `;

/**
 * __useMessageManagemenPageDfmFeedbackMessagesQuery__
 *
 * To run a query within a React component, call `useMessageManagemenPageDfmFeedbackMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageManagemenPageDfmFeedbackMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageManagemenPageDfmFeedbackMessagesQuery({
 *   variables: {
 *      platformProcessId: // value for 'platformProcessId'
 *      type: // value for 'type'
 *      topicId: // value for 'topicId'
 *      disabled: // value for 'disabled'
 *   },
 * });
 */
export function useMessageManagemenPageDfmFeedbackMessagesQuery(baseOptions?: Apollo.QueryHookOptions<MessageManagemenPageDfmFeedbackMessagesQuery, MessageManagemenPageDfmFeedbackMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessageManagemenPageDfmFeedbackMessagesQuery, MessageManagemenPageDfmFeedbackMessagesQueryVariables>(MessageManagemenPageDfmFeedbackMessagesDocument, options);
      }
export function useMessageManagemenPageDfmFeedbackMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessageManagemenPageDfmFeedbackMessagesQuery, MessageManagemenPageDfmFeedbackMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessageManagemenPageDfmFeedbackMessagesQuery, MessageManagemenPageDfmFeedbackMessagesQueryVariables>(MessageManagemenPageDfmFeedbackMessagesDocument, options);
        }
export type MessageManagemenPageDfmFeedbackMessagesQueryHookResult = ReturnType<typeof useMessageManagemenPageDfmFeedbackMessagesQuery>;
export type MessageManagemenPageDfmFeedbackMessagesLazyQueryHookResult = ReturnType<typeof useMessageManagemenPageDfmFeedbackMessagesLazyQuery>;
export type MessageManagemenPageDfmFeedbackMessagesQueryResult = Apollo.QueryResult<MessageManagemenPageDfmFeedbackMessagesQuery, MessageManagemenPageDfmFeedbackMessagesQueryVariables>;
export function refetchMessageManagemenPageDfmFeedbackMessagesQuery(variables?: MessageManagemenPageDfmFeedbackMessagesQueryVariables) {
      return { query: MessageManagemenPageDfmFeedbackMessagesDocument, variables: variables }
    }
export const CreateDfmFeedbackMessageDocument = gql`
    mutation createDfmFeedbackMessage($code: String!, $type: DfmFeedbackMessageType!, $severity: DfmFeedbackSeverity!, $platformProcessId: String!, $title: String!, $message: String!, $link: String, $topicId: UUID, $disabled: Boolean!) {
  createDfmFeedbackMessage(
    messageAttrs: {code: $code, type: $type, severity: $severity, title: $title, message: $message, link: $link, platformProcessId: $platformProcessId, topicId: $topicId, disabled: $disabled}
  ) {
    id
  }
}
    `;
export type CreateDfmFeedbackMessageMutationFn = Apollo.MutationFunction<CreateDfmFeedbackMessageMutation, CreateDfmFeedbackMessageMutationVariables>;

/**
 * __useCreateDfmFeedbackMessageMutation__
 *
 * To run a mutation, you first call `useCreateDfmFeedbackMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDfmFeedbackMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDfmFeedbackMessageMutation, { data, loading, error }] = useCreateDfmFeedbackMessageMutation({
 *   variables: {
 *      code: // value for 'code'
 *      type: // value for 'type'
 *      severity: // value for 'severity'
 *      platformProcessId: // value for 'platformProcessId'
 *      title: // value for 'title'
 *      message: // value for 'message'
 *      link: // value for 'link'
 *      topicId: // value for 'topicId'
 *      disabled: // value for 'disabled'
 *   },
 * });
 */
export function useCreateDfmFeedbackMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateDfmFeedbackMessageMutation, CreateDfmFeedbackMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDfmFeedbackMessageMutation, CreateDfmFeedbackMessageMutationVariables>(CreateDfmFeedbackMessageDocument, options);
      }
export type CreateDfmFeedbackMessageMutationHookResult = ReturnType<typeof useCreateDfmFeedbackMessageMutation>;
export type CreateDfmFeedbackMessageMutationResult = Apollo.MutationResult<CreateDfmFeedbackMessageMutation>;
export type CreateDfmFeedbackMessageMutationOptions = Apollo.BaseMutationOptions<CreateDfmFeedbackMessageMutation, CreateDfmFeedbackMessageMutationVariables>;
export const EditDfmFeedbackMessageDocument = gql`
    mutation editDfmFeedbackMessage($id: UUID!, $severity: DfmFeedbackSeverity!, $title: String!, $message: String!, $platformProcessId: String!, $link: String, $disabled: Boolean!) {
  editDfmFeedbackMessage(
    messageAttrs: {id: $id, severity: $severity, title: $title, message: $message, platformProcessId: $platformProcessId, link: $link, disabled: $disabled}
  ) {
    id
  }
}
    `;
export type EditDfmFeedbackMessageMutationFn = Apollo.MutationFunction<EditDfmFeedbackMessageMutation, EditDfmFeedbackMessageMutationVariables>;

/**
 * __useEditDfmFeedbackMessageMutation__
 *
 * To run a mutation, you first call `useEditDfmFeedbackMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDfmFeedbackMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDfmFeedbackMessageMutation, { data, loading, error }] = useEditDfmFeedbackMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      severity: // value for 'severity'
 *      title: // value for 'title'
 *      message: // value for 'message'
 *      platformProcessId: // value for 'platformProcessId'
 *      link: // value for 'link'
 *      disabled: // value for 'disabled'
 *   },
 * });
 */
export function useEditDfmFeedbackMessageMutation(baseOptions?: Apollo.MutationHookOptions<EditDfmFeedbackMessageMutation, EditDfmFeedbackMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditDfmFeedbackMessageMutation, EditDfmFeedbackMessageMutationVariables>(EditDfmFeedbackMessageDocument, options);
      }
export type EditDfmFeedbackMessageMutationHookResult = ReturnType<typeof useEditDfmFeedbackMessageMutation>;
export type EditDfmFeedbackMessageMutationResult = Apollo.MutationResult<EditDfmFeedbackMessageMutation>;
export type EditDfmFeedbackMessageMutationOptions = Apollo.BaseMutationOptions<EditDfmFeedbackMessageMutation, EditDfmFeedbackMessageMutationVariables>;
export const QmrGenerateDrawingEndpointDocument = gql`
    query qmrGenerateDrawingEndpoint($id: UUID!) {
  quoteModelRevision(id: $id) {
    id
    fictivSupportingDocTemplateUrl
    modelConfiguration {
      material {
        ... on Material {
          id
          name
        }
        ... on UserEnteredMaterial {
          id
          name
        }
      }
      color {
        id
        name
      }
      process {
        id
        name
      }
      shore {
        id
        name
      }
      texture {
        id
        name
      }
    }
    processesDetails {
      postProcesses {
        postProcess {
          id
          name
        }
        postProcessColor {
          id
          name
        }
        postProcessThickness {
          id
          name
        }
        postProcessNumParts
        postProcessInspectionCriteria
      }
      secondaryProcesses {
        process {
          id
          name
        }
        notes
      }
    }
    partRevision {
      id
      downloadUri
      modelFileName
      units
      createdAt
      updatedAt
      status
      thumbnailUri
      rawAnalysis
      boundingBox {
        x
        y
        z
      }
      scene {
        ...drawingGeneratorScene
      }
      sceneBundle
    }
    holes {
      id
      counterboreDiameter
      countersinkDiameter
      counterboreDepth
      counterboreDiameter
      depth
      diameter
      direction
      endPoint
      groupKey
      isBlind
      startPoint
      tapAnnotation {
        id
        tapOption {
          id
          commonName
        }
      }
      tapOptions {
        id
        commonName
        maxDepth
      }
      tipAngle
      type
    }
  }
}
    ${DrawingGeneratorSceneFragmentDoc}`;

/**
 * __useQmrGenerateDrawingEndpointQuery__
 *
 * To run a query within a React component, call `useQmrGenerateDrawingEndpointQuery` and pass it any options that fit your needs.
 * When your component renders, `useQmrGenerateDrawingEndpointQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQmrGenerateDrawingEndpointQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQmrGenerateDrawingEndpointQuery(baseOptions: Apollo.QueryHookOptions<QmrGenerateDrawingEndpointQuery, QmrGenerateDrawingEndpointQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QmrGenerateDrawingEndpointQuery, QmrGenerateDrawingEndpointQueryVariables>(QmrGenerateDrawingEndpointDocument, options);
      }
export function useQmrGenerateDrawingEndpointLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QmrGenerateDrawingEndpointQuery, QmrGenerateDrawingEndpointQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QmrGenerateDrawingEndpointQuery, QmrGenerateDrawingEndpointQueryVariables>(QmrGenerateDrawingEndpointDocument, options);
        }
export type QmrGenerateDrawingEndpointQueryHookResult = ReturnType<typeof useQmrGenerateDrawingEndpointQuery>;
export type QmrGenerateDrawingEndpointLazyQueryHookResult = ReturnType<typeof useQmrGenerateDrawingEndpointLazyQuery>;
export type QmrGenerateDrawingEndpointQueryResult = Apollo.QueryResult<QmrGenerateDrawingEndpointQuery, QmrGenerateDrawingEndpointQueryVariables>;
export function refetchQmrGenerateDrawingEndpointQuery(variables: QmrGenerateDrawingEndpointQueryVariables) {
      return { query: QmrGenerateDrawingEndpointDocument, variables: variables }
    }
export const GenericPartInfoSearchDocument = gql`
    query genericPartInfoSearch($searchString: String!) {
  genericPartInfoSearch(searchString: $searchString) {
    qmrId
    partRevisionUuid
    quoteItemId
    eiUuid
    partId
    modelFileName
    userId
    email
    matchedText
    partCreatedAt
    orderName
    quoteName
    quoteId
    quoteItemDeletedAt
    hasAttachedPdf
    quoteStatus
  }
}
    `;

/**
 * __useGenericPartInfoSearchQuery__
 *
 * To run a query within a React component, call `useGenericPartInfoSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericPartInfoSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenericPartInfoSearchQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *   },
 * });
 */
export function useGenericPartInfoSearchQuery(baseOptions: Apollo.QueryHookOptions<GenericPartInfoSearchQuery, GenericPartInfoSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenericPartInfoSearchQuery, GenericPartInfoSearchQueryVariables>(GenericPartInfoSearchDocument, options);
      }
export function useGenericPartInfoSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenericPartInfoSearchQuery, GenericPartInfoSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenericPartInfoSearchQuery, GenericPartInfoSearchQueryVariables>(GenericPartInfoSearchDocument, options);
        }
export type GenericPartInfoSearchQueryHookResult = ReturnType<typeof useGenericPartInfoSearchQuery>;
export type GenericPartInfoSearchLazyQueryHookResult = ReturnType<typeof useGenericPartInfoSearchLazyQuery>;
export type GenericPartInfoSearchQueryResult = Apollo.QueryResult<GenericPartInfoSearchQuery, GenericPartInfoSearchQueryVariables>;
export function refetchGenericPartInfoSearchQuery(variables: GenericPartInfoSearchQueryVariables) {
      return { query: GenericPartInfoSearchDocument, variables: variables }
    }
export const UpdateJobBoardRegionConfigurationDocument = gql`
    mutation UpdateJobBoardRegionConfiguration($jobBoardRegionId: UUID!, $configurationInput: UpdateJobBoardRegionConfigurationInput!) {
  updateJobBoardRegionConfiguration(
    jobBoardRegionId: $jobBoardRegionId
    configurationInput: $configurationInput
  ) {
    id
  }
}
    `;
export type UpdateJobBoardRegionConfigurationMutationFn = Apollo.MutationFunction<UpdateJobBoardRegionConfigurationMutation, UpdateJobBoardRegionConfigurationMutationVariables>;

/**
 * __useUpdateJobBoardRegionConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateJobBoardRegionConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobBoardRegionConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobBoardRegionConfigurationMutation, { data, loading, error }] = useUpdateJobBoardRegionConfigurationMutation({
 *   variables: {
 *      jobBoardRegionId: // value for 'jobBoardRegionId'
 *      configurationInput: // value for 'configurationInput'
 *   },
 * });
 */
export function useUpdateJobBoardRegionConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobBoardRegionConfigurationMutation, UpdateJobBoardRegionConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobBoardRegionConfigurationMutation, UpdateJobBoardRegionConfigurationMutationVariables>(UpdateJobBoardRegionConfigurationDocument, options);
      }
export type UpdateJobBoardRegionConfigurationMutationHookResult = ReturnType<typeof useUpdateJobBoardRegionConfigurationMutation>;
export type UpdateJobBoardRegionConfigurationMutationResult = Apollo.MutationResult<UpdateJobBoardRegionConfigurationMutation>;
export type UpdateJobBoardRegionConfigurationMutationOptions = Apollo.BaseMutationOptions<UpdateJobBoardRegionConfigurationMutation, UpdateJobBoardRegionConfigurationMutationVariables>;
export const UpdateJobBoardCalendarDocument = gql`
    mutation UpdateJobBoardCalendar($jobBoardId: String!, $updateJobBoardCalendar: UpdateJobBoardCalendarInput!, $isApplicableNextSevenDays: Boolean) {
  updateJobBoardCalendar(
    jobBoardId: $jobBoardId
    updateJobBoardCalendar: $updateJobBoardCalendar
    isApplicableNextSevenDays: $isApplicableNextSevenDays
  ) {
    jobBoardId
  }
}
    `;
export type UpdateJobBoardCalendarMutationFn = Apollo.MutationFunction<UpdateJobBoardCalendarMutation, UpdateJobBoardCalendarMutationVariables>;

/**
 * __useUpdateJobBoardCalendarMutation__
 *
 * To run a mutation, you first call `useUpdateJobBoardCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobBoardCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobBoardCalendarMutation, { data, loading, error }] = useUpdateJobBoardCalendarMutation({
 *   variables: {
 *      jobBoardId: // value for 'jobBoardId'
 *      updateJobBoardCalendar: // value for 'updateJobBoardCalendar'
 *      isApplicableNextSevenDays: // value for 'isApplicableNextSevenDays'
 *   },
 * });
 */
export function useUpdateJobBoardCalendarMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobBoardCalendarMutation, UpdateJobBoardCalendarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobBoardCalendarMutation, UpdateJobBoardCalendarMutationVariables>(UpdateJobBoardCalendarDocument, options);
      }
export type UpdateJobBoardCalendarMutationHookResult = ReturnType<typeof useUpdateJobBoardCalendarMutation>;
export type UpdateJobBoardCalendarMutationResult = Apollo.MutationResult<UpdateJobBoardCalendarMutation>;
export type UpdateJobBoardCalendarMutationOptions = Apollo.BaseMutationOptions<UpdateJobBoardCalendarMutation, UpdateJobBoardCalendarMutationVariables>;
export const JobBoardForRegionsDocument = gql`
    query JobBoardForRegions {
  getActiveJobBoardRegions {
    ...JobBoardRegion_Items
  }
}
    ${JobBoardRegion_ItemsFragmentDoc}`;

/**
 * __useJobBoardForRegionsQuery__
 *
 * To run a query within a React component, call `useJobBoardForRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobBoardForRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobBoardForRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useJobBoardForRegionsQuery(baseOptions?: Apollo.QueryHookOptions<JobBoardForRegionsQuery, JobBoardForRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobBoardForRegionsQuery, JobBoardForRegionsQueryVariables>(JobBoardForRegionsDocument, options);
      }
export function useJobBoardForRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobBoardForRegionsQuery, JobBoardForRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobBoardForRegionsQuery, JobBoardForRegionsQueryVariables>(JobBoardForRegionsDocument, options);
        }
export type JobBoardForRegionsQueryHookResult = ReturnType<typeof useJobBoardForRegionsQuery>;
export type JobBoardForRegionsLazyQueryHookResult = ReturnType<typeof useJobBoardForRegionsLazyQuery>;
export type JobBoardForRegionsQueryResult = Apollo.QueryResult<JobBoardForRegionsQuery, JobBoardForRegionsQueryVariables>;
export function refetchJobBoardForRegionsQuery(variables?: JobBoardForRegionsQueryVariables) {
      return { query: JobBoardForRegionsDocument, variables: variables }
    }
export const GetJobBoardCalendarDocument = gql`
    query GetJobBoardCalendar($startDate: String!, $endDate: String!) {
  getJobBoardCalendar(startDate: $startDate, endDate: $endDate) {
    jobBoardId
    status
    active
    jobBoardDate
    startTime
    endTime
    maxThresholdOfPayout
    acceptNowMultiplier
    jobBoardRegionId
    isEditable
    jobBoardRegionName
    jobDuration
  }
}
    `;

/**
 * __useGetJobBoardCalendarQuery__
 *
 * To run a query within a React component, call `useGetJobBoardCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobBoardCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobBoardCalendarQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetJobBoardCalendarQuery(baseOptions: Apollo.QueryHookOptions<GetJobBoardCalendarQuery, GetJobBoardCalendarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobBoardCalendarQuery, GetJobBoardCalendarQueryVariables>(GetJobBoardCalendarDocument, options);
      }
export function useGetJobBoardCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobBoardCalendarQuery, GetJobBoardCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobBoardCalendarQuery, GetJobBoardCalendarQueryVariables>(GetJobBoardCalendarDocument, options);
        }
export type GetJobBoardCalendarQueryHookResult = ReturnType<typeof useGetJobBoardCalendarQuery>;
export type GetJobBoardCalendarLazyQueryHookResult = ReturnType<typeof useGetJobBoardCalendarLazyQuery>;
export type GetJobBoardCalendarQueryResult = Apollo.QueryResult<GetJobBoardCalendarQuery, GetJobBoardCalendarQueryVariables>;
export function refetchGetJobBoardCalendarQuery(variables: GetJobBoardCalendarQueryVariables) {
      return { query: GetJobBoardCalendarDocument, variables: variables }
    }
export const CurrentMarkupsAdjustmentPageDocument = gql`
    query currentMarkupsAdjustmentPage {
  currentMarkups {
    markups {
      premium
      rush
      standard
      economy
      flex
      saver
      overseas
    }
    quantityRanges
  }
}
    `;

/**
 * __useCurrentMarkupsAdjustmentPageQuery__
 *
 * To run a query within a React component, call `useCurrentMarkupsAdjustmentPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentMarkupsAdjustmentPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentMarkupsAdjustmentPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentMarkupsAdjustmentPageQuery(baseOptions?: Apollo.QueryHookOptions<CurrentMarkupsAdjustmentPageQuery, CurrentMarkupsAdjustmentPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentMarkupsAdjustmentPageQuery, CurrentMarkupsAdjustmentPageQueryVariables>(CurrentMarkupsAdjustmentPageDocument, options);
      }
export function useCurrentMarkupsAdjustmentPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentMarkupsAdjustmentPageQuery, CurrentMarkupsAdjustmentPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentMarkupsAdjustmentPageQuery, CurrentMarkupsAdjustmentPageQueryVariables>(CurrentMarkupsAdjustmentPageDocument, options);
        }
export type CurrentMarkupsAdjustmentPageQueryHookResult = ReturnType<typeof useCurrentMarkupsAdjustmentPageQuery>;
export type CurrentMarkupsAdjustmentPageLazyQueryHookResult = ReturnType<typeof useCurrentMarkupsAdjustmentPageLazyQuery>;
export type CurrentMarkupsAdjustmentPageQueryResult = Apollo.QueryResult<CurrentMarkupsAdjustmentPageQuery, CurrentMarkupsAdjustmentPageQueryVariables>;
export function refetchCurrentMarkupsAdjustmentPageQuery(variables?: CurrentMarkupsAdjustmentPageQueryVariables) {
      return { query: CurrentMarkupsAdjustmentPageDocument, variables: variables }
    }
export const AdjustCurrentMarkupsAdjustmentPageDocument = gql`
    mutation adjustCurrentMarkupsAdjustmentPage($newMarkupData: MarkupDataInput!) {
  adjustCurrentMarkups(newMarkupData: $newMarkupData) {
    markups {
      premium
      rush
      standard
      economy
      flex
      saver
      overseas
    }
    quantityRanges
  }
}
    `;
export type AdjustCurrentMarkupsAdjustmentPageMutationFn = Apollo.MutationFunction<AdjustCurrentMarkupsAdjustmentPageMutation, AdjustCurrentMarkupsAdjustmentPageMutationVariables>;

/**
 * __useAdjustCurrentMarkupsAdjustmentPageMutation__
 *
 * To run a mutation, you first call `useAdjustCurrentMarkupsAdjustmentPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdjustCurrentMarkupsAdjustmentPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adjustCurrentMarkupsAdjustmentPageMutation, { data, loading, error }] = useAdjustCurrentMarkupsAdjustmentPageMutation({
 *   variables: {
 *      newMarkupData: // value for 'newMarkupData'
 *   },
 * });
 */
export function useAdjustCurrentMarkupsAdjustmentPageMutation(baseOptions?: Apollo.MutationHookOptions<AdjustCurrentMarkupsAdjustmentPageMutation, AdjustCurrentMarkupsAdjustmentPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdjustCurrentMarkupsAdjustmentPageMutation, AdjustCurrentMarkupsAdjustmentPageMutationVariables>(AdjustCurrentMarkupsAdjustmentPageDocument, options);
      }
export type AdjustCurrentMarkupsAdjustmentPageMutationHookResult = ReturnType<typeof useAdjustCurrentMarkupsAdjustmentPageMutation>;
export type AdjustCurrentMarkupsAdjustmentPageMutationResult = Apollo.MutationResult<AdjustCurrentMarkupsAdjustmentPageMutation>;
export type AdjustCurrentMarkupsAdjustmentPageMutationOptions = Apollo.BaseMutationOptions<AdjustCurrentMarkupsAdjustmentPageMutation, AdjustCurrentMarkupsAdjustmentPageMutationVariables>;
export const ProcessesAdminQmrsQueueDocument = gql`
    query processesAdminQmrsQueue {
  processes {
    id
    name
  }
}
    `;

/**
 * __useProcessesAdminQmrsQueueQuery__
 *
 * To run a query within a React component, call `useProcessesAdminQmrsQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessesAdminQmrsQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessesAdminQmrsQueueQuery({
 *   variables: {
 *   },
 * });
 */
export function useProcessesAdminQmrsQueueQuery(baseOptions?: Apollo.QueryHookOptions<ProcessesAdminQmrsQueueQuery, ProcessesAdminQmrsQueueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessesAdminQmrsQueueQuery, ProcessesAdminQmrsQueueQueryVariables>(ProcessesAdminQmrsQueueDocument, options);
      }
export function useProcessesAdminQmrsQueueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessesAdminQmrsQueueQuery, ProcessesAdminQmrsQueueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessesAdminQmrsQueueQuery, ProcessesAdminQmrsQueueQueryVariables>(ProcessesAdminQmrsQueueDocument, options);
        }
export type ProcessesAdminQmrsQueueQueryHookResult = ReturnType<typeof useProcessesAdminQmrsQueueQuery>;
export type ProcessesAdminQmrsQueueLazyQueryHookResult = ReturnType<typeof useProcessesAdminQmrsQueueLazyQuery>;
export type ProcessesAdminQmrsQueueQueryResult = Apollo.QueryResult<ProcessesAdminQmrsQueueQuery, ProcessesAdminQmrsQueueQueryVariables>;
export function refetchProcessesAdminQmrsQueueQuery(variables?: ProcessesAdminQmrsQueueQueryVariables) {
      return { query: ProcessesAdminQmrsQueueDocument, variables: variables }
    }
export const MaterialsAdminQmrsQueueDocument = gql`
    query materialsAdminQmrsQueue($processId: String!) {
  materials(processId: $processId) {
    id
    name
  }
}
    `;

/**
 * __useMaterialsAdminQmrsQueueQuery__
 *
 * To run a query within a React component, call `useMaterialsAdminQmrsQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialsAdminQmrsQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialsAdminQmrsQueueQuery({
 *   variables: {
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useMaterialsAdminQmrsQueueQuery(baseOptions: Apollo.QueryHookOptions<MaterialsAdminQmrsQueueQuery, MaterialsAdminQmrsQueueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaterialsAdminQmrsQueueQuery, MaterialsAdminQmrsQueueQueryVariables>(MaterialsAdminQmrsQueueDocument, options);
      }
export function useMaterialsAdminQmrsQueueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaterialsAdminQmrsQueueQuery, MaterialsAdminQmrsQueueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaterialsAdminQmrsQueueQuery, MaterialsAdminQmrsQueueQueryVariables>(MaterialsAdminQmrsQueueDocument, options);
        }
export type MaterialsAdminQmrsQueueQueryHookResult = ReturnType<typeof useMaterialsAdminQmrsQueueQuery>;
export type MaterialsAdminQmrsQueueLazyQueryHookResult = ReturnType<typeof useMaterialsAdminQmrsQueueLazyQuery>;
export type MaterialsAdminQmrsQueueQueryResult = Apollo.QueryResult<MaterialsAdminQmrsQueueQuery, MaterialsAdminQmrsQueueQueryVariables>;
export function refetchMaterialsAdminQmrsQueueQuery(variables: MaterialsAdminQmrsQueueQueryVariables) {
      return { query: MaterialsAdminQmrsQueueDocument, variables: variables }
    }
export const ReleaseRfqQuotesWithNoUnpublishedQmRsDocument = gql`
    mutation releaseRFQQuotesWithNoUnpublishedQMRs {
  releaseRFQQuotesWithNoUnpublishedQMRs
}
    `;
export type ReleaseRfqQuotesWithNoUnpublishedQmRsMutationFn = Apollo.MutationFunction<ReleaseRfqQuotesWithNoUnpublishedQmRsMutation, ReleaseRfqQuotesWithNoUnpublishedQmRsMutationVariables>;

/**
 * __useReleaseRfqQuotesWithNoUnpublishedQmRsMutation__
 *
 * To run a mutation, you first call `useReleaseRfqQuotesWithNoUnpublishedQmRsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleaseRfqQuotesWithNoUnpublishedQmRsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releaseRfqQuotesWithNoUnpublishedQmRsMutation, { data, loading, error }] = useReleaseRfqQuotesWithNoUnpublishedQmRsMutation({
 *   variables: {
 *   },
 * });
 */
export function useReleaseRfqQuotesWithNoUnpublishedQmRsMutation(baseOptions?: Apollo.MutationHookOptions<ReleaseRfqQuotesWithNoUnpublishedQmRsMutation, ReleaseRfqQuotesWithNoUnpublishedQmRsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReleaseRfqQuotesWithNoUnpublishedQmRsMutation, ReleaseRfqQuotesWithNoUnpublishedQmRsMutationVariables>(ReleaseRfqQuotesWithNoUnpublishedQmRsDocument, options);
      }
export type ReleaseRfqQuotesWithNoUnpublishedQmRsMutationHookResult = ReturnType<typeof useReleaseRfqQuotesWithNoUnpublishedQmRsMutation>;
export type ReleaseRfqQuotesWithNoUnpublishedQmRsMutationResult = Apollo.MutationResult<ReleaseRfqQuotesWithNoUnpublishedQmRsMutation>;
export type ReleaseRfqQuotesWithNoUnpublishedQmRsMutationOptions = Apollo.BaseMutationOptions<ReleaseRfqQuotesWithNoUnpublishedQmRsMutation, ReleaseRfqQuotesWithNoUnpublishedQmRsMutationVariables>;
export const AdminQuoteModelRevisionsQueueDocument = gql`
    query adminQuoteModelRevisionsQueue($filters: QuoteModelRevisionFiltersInput, $limit: Int!, $cursor: ENCODED_CURSOR) {
  listAllQuoteModelRevisions(filters: $filters, limit: $limit, cursor: $cursor) {
    totalCount
    cursor {
      previous
      next
    }
    items {
      ...adminQuoteModelRevisionQueueItem
    }
  }
}
    ${AdminQuoteModelRevisionQueueItemFragmentDoc}`;

/**
 * __useAdminQuoteModelRevisionsQueueQuery__
 *
 * To run a query within a React component, call `useAdminQuoteModelRevisionsQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminQuoteModelRevisionsQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminQuoteModelRevisionsQueueQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useAdminQuoteModelRevisionsQueueQuery(baseOptions: Apollo.QueryHookOptions<AdminQuoteModelRevisionsQueueQuery, AdminQuoteModelRevisionsQueueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminQuoteModelRevisionsQueueQuery, AdminQuoteModelRevisionsQueueQueryVariables>(AdminQuoteModelRevisionsQueueDocument, options);
      }
export function useAdminQuoteModelRevisionsQueueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminQuoteModelRevisionsQueueQuery, AdminQuoteModelRevisionsQueueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminQuoteModelRevisionsQueueQuery, AdminQuoteModelRevisionsQueueQueryVariables>(AdminQuoteModelRevisionsQueueDocument, options);
        }
export type AdminQuoteModelRevisionsQueueQueryHookResult = ReturnType<typeof useAdminQuoteModelRevisionsQueueQuery>;
export type AdminQuoteModelRevisionsQueueLazyQueryHookResult = ReturnType<typeof useAdminQuoteModelRevisionsQueueLazyQuery>;
export type AdminQuoteModelRevisionsQueueQueryResult = Apollo.QueryResult<AdminQuoteModelRevisionsQueueQuery, AdminQuoteModelRevisionsQueueQueryVariables>;
export function refetchAdminQuoteModelRevisionsQueueQuery(variables: AdminQuoteModelRevisionsQueueQueryVariables) {
      return { query: AdminQuoteModelRevisionsQueueDocument, variables: variables }
    }
export const UserEmailAndOrderCountDocument = gql`
    query userEmailAndOrderCount($id: Int!) {
  user(id: $id) {
    id
    email
    salesOrders {
      totalCount
    }
  }
}
    `;

/**
 * __useUserEmailAndOrderCountQuery__
 *
 * To run a query within a React component, call `useUserEmailAndOrderCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserEmailAndOrderCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserEmailAndOrderCountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserEmailAndOrderCountQuery(baseOptions: Apollo.QueryHookOptions<UserEmailAndOrderCountQuery, UserEmailAndOrderCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserEmailAndOrderCountQuery, UserEmailAndOrderCountQueryVariables>(UserEmailAndOrderCountDocument, options);
      }
export function useUserEmailAndOrderCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserEmailAndOrderCountQuery, UserEmailAndOrderCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserEmailAndOrderCountQuery, UserEmailAndOrderCountQueryVariables>(UserEmailAndOrderCountDocument, options);
        }
export type UserEmailAndOrderCountQueryHookResult = ReturnType<typeof useUserEmailAndOrderCountQuery>;
export type UserEmailAndOrderCountLazyQueryHookResult = ReturnType<typeof useUserEmailAndOrderCountLazyQuery>;
export type UserEmailAndOrderCountQueryResult = Apollo.QueryResult<UserEmailAndOrderCountQuery, UserEmailAndOrderCountQueryVariables>;
export function refetchUserEmailAndOrderCountQuery(variables: UserEmailAndOrderCountQueryVariables) {
      return { query: UserEmailAndOrderCountDocument, variables: variables }
    }
export const DestroyProjectQuoteDocument = gql`
    mutation destroyProjectQuote($id: UUID!) {
  destroyQuote(id: $id) {
    id
  }
}
    `;
export type DestroyProjectQuoteMutationFn = Apollo.MutationFunction<DestroyProjectQuoteMutation, DestroyProjectQuoteMutationVariables>;

/**
 * __useDestroyProjectQuoteMutation__
 *
 * To run a mutation, you first call `useDestroyProjectQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyProjectQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyProjectQuoteMutation, { data, loading, error }] = useDestroyProjectQuoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDestroyProjectQuoteMutation(baseOptions?: Apollo.MutationHookOptions<DestroyProjectQuoteMutation, DestroyProjectQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroyProjectQuoteMutation, DestroyProjectQuoteMutationVariables>(DestroyProjectQuoteDocument, options);
      }
export type DestroyProjectQuoteMutationHookResult = ReturnType<typeof useDestroyProjectQuoteMutation>;
export type DestroyProjectQuoteMutationResult = Apollo.MutationResult<DestroyProjectQuoteMutation>;
export type DestroyProjectQuoteMutationOptions = Apollo.BaseMutationOptions<DestroyProjectQuoteMutation, DestroyProjectQuoteMutationVariables>;
export const UpdateProjectSettingsMutationDocument = gql`
    mutation updateProjectSettingsMutation($id: UUID!, $projectInput: ProjectUpdateInput!) {
  updateProject(id: $id, projectInput: $projectInput) {
    id
    name
    description
  }
}
    `;
export type UpdateProjectSettingsMutationMutationFn = Apollo.MutationFunction<UpdateProjectSettingsMutationMutation, UpdateProjectSettingsMutationMutationVariables>;

/**
 * __useUpdateProjectSettingsMutationMutation__
 *
 * To run a mutation, you first call `useUpdateProjectSettingsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectSettingsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectSettingsMutationMutation, { data, loading, error }] = useUpdateProjectSettingsMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      projectInput: // value for 'projectInput'
 *   },
 * });
 */
export function useUpdateProjectSettingsMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectSettingsMutationMutation, UpdateProjectSettingsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectSettingsMutationMutation, UpdateProjectSettingsMutationMutationVariables>(UpdateProjectSettingsMutationDocument, options);
      }
export type UpdateProjectSettingsMutationMutationHookResult = ReturnType<typeof useUpdateProjectSettingsMutationMutation>;
export type UpdateProjectSettingsMutationMutationResult = Apollo.MutationResult<UpdateProjectSettingsMutationMutation>;
export type UpdateProjectSettingsMutationMutationOptions = Apollo.BaseMutationOptions<UpdateProjectSettingsMutationMutation, UpdateProjectSettingsMutationMutationVariables>;
export const GetProjectNameQueryProjectPageDocument = gql`
    query getProjectNameQueryProjectPage($id: UUID!) {
  project(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useGetProjectNameQueryProjectPageQuery__
 *
 * To run a query within a React component, call `useGetProjectNameQueryProjectPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectNameQueryProjectPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectNameQueryProjectPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectNameQueryProjectPageQuery(baseOptions: Apollo.QueryHookOptions<GetProjectNameQueryProjectPageQuery, GetProjectNameQueryProjectPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectNameQueryProjectPageQuery, GetProjectNameQueryProjectPageQueryVariables>(GetProjectNameQueryProjectPageDocument, options);
      }
export function useGetProjectNameQueryProjectPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectNameQueryProjectPageQuery, GetProjectNameQueryProjectPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectNameQueryProjectPageQuery, GetProjectNameQueryProjectPageQueryVariables>(GetProjectNameQueryProjectPageDocument, options);
        }
export type GetProjectNameQueryProjectPageQueryHookResult = ReturnType<typeof useGetProjectNameQueryProjectPageQuery>;
export type GetProjectNameQueryProjectPageLazyQueryHookResult = ReturnType<typeof useGetProjectNameQueryProjectPageLazyQuery>;
export type GetProjectNameQueryProjectPageQueryResult = Apollo.QueryResult<GetProjectNameQueryProjectPageQuery, GetProjectNameQueryProjectPageQueryVariables>;
export function refetchGetProjectNameQueryProjectPageQuery(variables: GetProjectNameQueryProjectPageQueryVariables) {
      return { query: GetProjectNameQueryProjectPageDocument, variables: variables }
    }
export const GetProjectQuotesQueryProjectQuoteTabDocument = gql`
    query getProjectQuotesQueryProjectQuoteTab($id: UUID!, $limit: Int!, $offset: Int, $sort: CreatedAtSortKey, $cursor: ENCODED_CURSOR) {
  project(id: $id) {
    id
    name
    quotes(limit: $limit, cursor: $cursor, sort: $sort, offset: $offset) {
      items {
        name
        id
        lastModified
        user {
          email
          id
        }
        activity {
          items {
            actor {
              email
            }
          }
        }
      }
      totalCount
    }
  }
}
    `;

/**
 * __useGetProjectQuotesQueryProjectQuoteTabQuery__
 *
 * To run a query within a React component, call `useGetProjectQuotesQueryProjectQuoteTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectQuotesQueryProjectQuoteTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectQuotesQueryProjectQuoteTabQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sort: // value for 'sort'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetProjectQuotesQueryProjectQuoteTabQuery(baseOptions: Apollo.QueryHookOptions<GetProjectQuotesQueryProjectQuoteTabQuery, GetProjectQuotesQueryProjectQuoteTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectQuotesQueryProjectQuoteTabQuery, GetProjectQuotesQueryProjectQuoteTabQueryVariables>(GetProjectQuotesQueryProjectQuoteTabDocument, options);
      }
export function useGetProjectQuotesQueryProjectQuoteTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectQuotesQueryProjectQuoteTabQuery, GetProjectQuotesQueryProjectQuoteTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectQuotesQueryProjectQuoteTabQuery, GetProjectQuotesQueryProjectQuoteTabQueryVariables>(GetProjectQuotesQueryProjectQuoteTabDocument, options);
        }
export type GetProjectQuotesQueryProjectQuoteTabQueryHookResult = ReturnType<typeof useGetProjectQuotesQueryProjectQuoteTabQuery>;
export type GetProjectQuotesQueryProjectQuoteTabLazyQueryHookResult = ReturnType<typeof useGetProjectQuotesQueryProjectQuoteTabLazyQuery>;
export type GetProjectQuotesQueryProjectQuoteTabQueryResult = Apollo.QueryResult<GetProjectQuotesQueryProjectQuoteTabQuery, GetProjectQuotesQueryProjectQuoteTabQueryVariables>;
export function refetchGetProjectQuotesQueryProjectQuoteTabQuery(variables: GetProjectQuotesQueryProjectQuoteTabQueryVariables) {
      return { query: GetProjectQuotesQueryProjectQuoteTabDocument, variables: variables }
    }
export const GetProjectSalesOrderOrdersTabDocument = gql`
    query getProjectSalesOrderOrdersTab($id: UUID!, $limit: Int!, $offset: Int, $sort: CreatedAtSortKey, $cursor: ENCODED_CURSOR) {
  project(id: $id) {
    id
    name
    salesOrders(limit: $limit, cursor: $cursor, sort: $sort, offset: $offset) {
      totalCount
      items {
        name
        id
        createdAt
        paymentDetails {
          id
          paidBy {
            id
            email
            displayName
          }
        }
        quoteOwnerUser {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetProjectSalesOrderOrdersTabQuery__
 *
 * To run a query within a React component, call `useGetProjectSalesOrderOrdersTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectSalesOrderOrdersTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectSalesOrderOrdersTabQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sort: // value for 'sort'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetProjectSalesOrderOrdersTabQuery(baseOptions: Apollo.QueryHookOptions<GetProjectSalesOrderOrdersTabQuery, GetProjectSalesOrderOrdersTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectSalesOrderOrdersTabQuery, GetProjectSalesOrderOrdersTabQueryVariables>(GetProjectSalesOrderOrdersTabDocument, options);
      }
export function useGetProjectSalesOrderOrdersTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectSalesOrderOrdersTabQuery, GetProjectSalesOrderOrdersTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectSalesOrderOrdersTabQuery, GetProjectSalesOrderOrdersTabQueryVariables>(GetProjectSalesOrderOrdersTabDocument, options);
        }
export type GetProjectSalesOrderOrdersTabQueryHookResult = ReturnType<typeof useGetProjectSalesOrderOrdersTabQuery>;
export type GetProjectSalesOrderOrdersTabLazyQueryHookResult = ReturnType<typeof useGetProjectSalesOrderOrdersTabLazyQuery>;
export type GetProjectSalesOrderOrdersTabQueryResult = Apollo.QueryResult<GetProjectSalesOrderOrdersTabQuery, GetProjectSalesOrderOrdersTabQueryVariables>;
export function refetchGetProjectSalesOrderOrdersTabQuery(variables: GetProjectSalesOrderOrdersTabQueryVariables) {
      return { query: GetProjectSalesOrderOrdersTabDocument, variables: variables }
    }
export const GetProjectMembersDocument = gql`
    query getProjectMembers($id: UUID!, $limit: Int!, $offset: Int, $sort: CreatedAtSortKey, $cursor: ENCODED_CURSOR) {
  project(id: $id) {
    id
    memberships(limit: $limit, cursor: $cursor, sort: $sort, offset: $offset) {
      totalCount
      items {
        id
        user {
          id
          displayName
          firstName
          lastName
          email
        }
        updatedBy {
          email
        }
        isFictivEmployee
        isQuoteOwner
        isActive
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useGetProjectMembersQuery__
 *
 * To run a query within a React component, call `useGetProjectMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectMembersQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sort: // value for 'sort'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetProjectMembersQuery(baseOptions: Apollo.QueryHookOptions<GetProjectMembersQuery, GetProjectMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectMembersQuery, GetProjectMembersQueryVariables>(GetProjectMembersDocument, options);
      }
export function useGetProjectMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectMembersQuery, GetProjectMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectMembersQuery, GetProjectMembersQueryVariables>(GetProjectMembersDocument, options);
        }
export type GetProjectMembersQueryHookResult = ReturnType<typeof useGetProjectMembersQuery>;
export type GetProjectMembersLazyQueryHookResult = ReturnType<typeof useGetProjectMembersLazyQuery>;
export type GetProjectMembersQueryResult = Apollo.QueryResult<GetProjectMembersQuery, GetProjectMembersQueryVariables>;
export function refetchGetProjectMembersQuery(variables: GetProjectMembersQueryVariables) {
      return { query: GetProjectMembersDocument, variables: variables }
    }
export const GetProjectMembersEmailListDocument = gql`
    query getProjectMembersEmailList($id: UUID!) {
  project(id: $id) {
    id
    memberships {
      items {
        id
        isActive
        isFictivEmployee
        user {
          id
          displayName
          email
        }
      }
    }
  }
}
    `;

/**
 * __useGetProjectMembersEmailListQuery__
 *
 * To run a query within a React component, call `useGetProjectMembersEmailListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectMembersEmailListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectMembersEmailListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectMembersEmailListQuery(baseOptions: Apollo.QueryHookOptions<GetProjectMembersEmailListQuery, GetProjectMembersEmailListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectMembersEmailListQuery, GetProjectMembersEmailListQueryVariables>(GetProjectMembersEmailListDocument, options);
      }
export function useGetProjectMembersEmailListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectMembersEmailListQuery, GetProjectMembersEmailListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectMembersEmailListQuery, GetProjectMembersEmailListQueryVariables>(GetProjectMembersEmailListDocument, options);
        }
export type GetProjectMembersEmailListQueryHookResult = ReturnType<typeof useGetProjectMembersEmailListQuery>;
export type GetProjectMembersEmailListLazyQueryHookResult = ReturnType<typeof useGetProjectMembersEmailListLazyQuery>;
export type GetProjectMembersEmailListQueryResult = Apollo.QueryResult<GetProjectMembersEmailListQuery, GetProjectMembersEmailListQueryVariables>;
export function refetchGetProjectMembersEmailListQuery(variables: GetProjectMembersEmailListQueryVariables) {
      return { query: GetProjectMembersEmailListDocument, variables: variables }
    }
export const CreateSecureQuoteMutationDocument = gql`
    mutation createSecureQuoteMutation($name: String, $description: String, $userId: Int, $projectId: UUID) {
  createQuote(
    input: {name: $name, description: $description}
    userId: $userId
    projectId: $projectId
  ) {
    id
    name
  }
}
    `;
export type CreateSecureQuoteMutationMutationFn = Apollo.MutationFunction<CreateSecureQuoteMutationMutation, CreateSecureQuoteMutationMutationVariables>;

/**
 * __useCreateSecureQuoteMutationMutation__
 *
 * To run a mutation, you first call `useCreateSecureQuoteMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSecureQuoteMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSecureQuoteMutationMutation, { data, loading, error }] = useCreateSecureQuoteMutationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      userId: // value for 'userId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCreateSecureQuoteMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateSecureQuoteMutationMutation, CreateSecureQuoteMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSecureQuoteMutationMutation, CreateSecureQuoteMutationMutationVariables>(CreateSecureQuoteMutationDocument, options);
      }
export type CreateSecureQuoteMutationMutationHookResult = ReturnType<typeof useCreateSecureQuoteMutationMutation>;
export type CreateSecureQuoteMutationMutationResult = Apollo.MutationResult<CreateSecureQuoteMutationMutation>;
export type CreateSecureQuoteMutationMutationOptions = Apollo.BaseMutationOptions<CreateSecureQuoteMutationMutation, CreateSecureQuoteMutationMutationVariables>;
export const CheckIfCurrentUserIsProjectMemberDocument = gql`
    query checkIfCurrentUserIsProjectMember($id: UUID!) {
  project(id: $id) {
    id
    currentUserIsMember
  }
}
    `;

/**
 * __useCheckIfCurrentUserIsProjectMemberQuery__
 *
 * To run a query within a React component, call `useCheckIfCurrentUserIsProjectMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckIfCurrentUserIsProjectMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckIfCurrentUserIsProjectMemberQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCheckIfCurrentUserIsProjectMemberQuery(baseOptions: Apollo.QueryHookOptions<CheckIfCurrentUserIsProjectMemberQuery, CheckIfCurrentUserIsProjectMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckIfCurrentUserIsProjectMemberQuery, CheckIfCurrentUserIsProjectMemberQueryVariables>(CheckIfCurrentUserIsProjectMemberDocument, options);
      }
export function useCheckIfCurrentUserIsProjectMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckIfCurrentUserIsProjectMemberQuery, CheckIfCurrentUserIsProjectMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckIfCurrentUserIsProjectMemberQuery, CheckIfCurrentUserIsProjectMemberQueryVariables>(CheckIfCurrentUserIsProjectMemberDocument, options);
        }
export type CheckIfCurrentUserIsProjectMemberQueryHookResult = ReturnType<typeof useCheckIfCurrentUserIsProjectMemberQuery>;
export type CheckIfCurrentUserIsProjectMemberLazyQueryHookResult = ReturnType<typeof useCheckIfCurrentUserIsProjectMemberLazyQuery>;
export type CheckIfCurrentUserIsProjectMemberQueryResult = Apollo.QueryResult<CheckIfCurrentUserIsProjectMemberQuery, CheckIfCurrentUserIsProjectMemberQueryVariables>;
export function refetchCheckIfCurrentUserIsProjectMemberQuery(variables: CheckIfCurrentUserIsProjectMemberQueryVariables) {
      return { query: CheckIfCurrentUserIsProjectMemberDocument, variables: variables }
    }
export const GetProjectSettingsDocument = gql`
    query getProjectSettings($id: UUID!) {
  project(id: $id) {
    id
    name
    description
  }
}
    `;

/**
 * __useGetProjectSettingsQuery__
 *
 * To run a query within a React component, call `useGetProjectSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectSettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>(GetProjectSettingsDocument, options);
      }
export function useGetProjectSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>(GetProjectSettingsDocument, options);
        }
export type GetProjectSettingsQueryHookResult = ReturnType<typeof useGetProjectSettingsQuery>;
export type GetProjectSettingsLazyQueryHookResult = ReturnType<typeof useGetProjectSettingsLazyQuery>;
export type GetProjectSettingsQueryResult = Apollo.QueryResult<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>;
export function refetchGetProjectSettingsQuery(variables: GetProjectSettingsQueryVariables) {
      return { query: GetProjectSettingsDocument, variables: variables }
    }
export const RevokeProjectMembershipDocument = gql`
    mutation revokeProjectMembership($projectId: UUID!, $membershipId: String!) {
  revokeProjectMembership(projectId: $projectId, membershipId: $membershipId) {
    id
  }
}
    `;
export type RevokeProjectMembershipMutationFn = Apollo.MutationFunction<RevokeProjectMembershipMutation, RevokeProjectMembershipMutationVariables>;

/**
 * __useRevokeProjectMembershipMutation__
 *
 * To run a mutation, you first call `useRevokeProjectMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeProjectMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeProjectMembershipMutation, { data, loading, error }] = useRevokeProjectMembershipMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      membershipId: // value for 'membershipId'
 *   },
 * });
 */
export function useRevokeProjectMembershipMutation(baseOptions?: Apollo.MutationHookOptions<RevokeProjectMembershipMutation, RevokeProjectMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeProjectMembershipMutation, RevokeProjectMembershipMutationVariables>(RevokeProjectMembershipDocument, options);
      }
export type RevokeProjectMembershipMutationHookResult = ReturnType<typeof useRevokeProjectMembershipMutation>;
export type RevokeProjectMembershipMutationResult = Apollo.MutationResult<RevokeProjectMembershipMutation>;
export type RevokeProjectMembershipMutationOptions = Apollo.BaseMutationOptions<RevokeProjectMembershipMutation, RevokeProjectMembershipMutationVariables>;
export const RestoreProjectMembershipDocument = gql`
    mutation restoreProjectMembership($projectId: UUID!, $membershipId: String!) {
  restoreProjectMembership(projectId: $projectId, membershipId: $membershipId) {
    id
  }
}
    `;
export type RestoreProjectMembershipMutationFn = Apollo.MutationFunction<RestoreProjectMembershipMutation, RestoreProjectMembershipMutationVariables>;

/**
 * __useRestoreProjectMembershipMutation__
 *
 * To run a mutation, you first call `useRestoreProjectMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreProjectMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreProjectMembershipMutation, { data, loading, error }] = useRestoreProjectMembershipMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      membershipId: // value for 'membershipId'
 *   },
 * });
 */
export function useRestoreProjectMembershipMutation(baseOptions?: Apollo.MutationHookOptions<RestoreProjectMembershipMutation, RestoreProjectMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreProjectMembershipMutation, RestoreProjectMembershipMutationVariables>(RestoreProjectMembershipDocument, options);
      }
export type RestoreProjectMembershipMutationHookResult = ReturnType<typeof useRestoreProjectMembershipMutation>;
export type RestoreProjectMembershipMutationResult = Apollo.MutationResult<RestoreProjectMembershipMutation>;
export type RestoreProjectMembershipMutationOptions = Apollo.BaseMutationOptions<RestoreProjectMembershipMutation, RestoreProjectMembershipMutationVariables>;
export const AddProjectMemberDocument = gql`
    mutation addProjectMember($projectId: UUID!, $userEmails: [String!]!) {
  addProjectMembers(projectId: $projectId, userEmails: $userEmails) {
    id
  }
}
    `;
export type AddProjectMemberMutationFn = Apollo.MutationFunction<AddProjectMemberMutation, AddProjectMemberMutationVariables>;

/**
 * __useAddProjectMemberMutation__
 *
 * To run a mutation, you first call `useAddProjectMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectMemberMutation, { data, loading, error }] = useAddProjectMemberMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      userEmails: // value for 'userEmails'
 *   },
 * });
 */
export function useAddProjectMemberMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectMemberMutation, AddProjectMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectMemberMutation, AddProjectMemberMutationVariables>(AddProjectMemberDocument, options);
      }
export type AddProjectMemberMutationHookResult = ReturnType<typeof useAddProjectMemberMutation>;
export type AddProjectMemberMutationResult = Apollo.MutationResult<AddProjectMemberMutation>;
export type AddProjectMemberMutationOptions = Apollo.BaseMutationOptions<AddProjectMemberMutation, AddProjectMemberMutationVariables>;
export const GetUserProjectsQueryDocument = gql`
    query getUserProjectsQuery($limit: Int!, $offset: Int, $sort: CreatedAtSortKey, $cursor: ENCODED_CURSOR) {
  me {
    id
    projects(limit: $limit, cursor: $cursor, sort: $sort, offset: $offset) {
      totalCount
      items {
        id
        name
        description
        createdAt
        createdBy {
          displayName
        }
        updatedBy {
          email
        }
      }
    }
  }
}
    `;

/**
 * __useGetUserProjectsQueryQuery__
 *
 * To run a query within a React component, call `useGetUserProjectsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProjectsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProjectsQueryQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sort: // value for 'sort'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetUserProjectsQueryQuery(baseOptions: Apollo.QueryHookOptions<GetUserProjectsQueryQuery, GetUserProjectsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserProjectsQueryQuery, GetUserProjectsQueryQueryVariables>(GetUserProjectsQueryDocument, options);
      }
export function useGetUserProjectsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserProjectsQueryQuery, GetUserProjectsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserProjectsQueryQuery, GetUserProjectsQueryQueryVariables>(GetUserProjectsQueryDocument, options);
        }
export type GetUserProjectsQueryQueryHookResult = ReturnType<typeof useGetUserProjectsQueryQuery>;
export type GetUserProjectsQueryLazyQueryHookResult = ReturnType<typeof useGetUserProjectsQueryLazyQuery>;
export type GetUserProjectsQueryQueryResult = Apollo.QueryResult<GetUserProjectsQueryQuery, GetUserProjectsQueryQueryVariables>;
export function refetchGetUserProjectsQueryQuery(variables: GetUserProjectsQueryQueryVariables) {
      return { query: GetUserProjectsQueryDocument, variables: variables }
    }
export const CreateProjectMutationDocument = gql`
    mutation createProjectMutation($projectInput: ProjectInput!) {
  createProject(projectInput: $projectInput) {
    id
    name
    description
    createdAt
    updatedAt
  }
}
    `;
export type CreateProjectMutationMutationFn = Apollo.MutationFunction<CreateProjectMutationMutation, CreateProjectMutationMutationVariables>;

/**
 * __useCreateProjectMutationMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutationMutation, { data, loading, error }] = useCreateProjectMutationMutation({
 *   variables: {
 *      projectInput: // value for 'projectInput'
 *   },
 * });
 */
export function useCreateProjectMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectMutationMutation, CreateProjectMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectMutationMutation, CreateProjectMutationMutationVariables>(CreateProjectMutationDocument, options);
      }
export type CreateProjectMutationMutationHookResult = ReturnType<typeof useCreateProjectMutationMutation>;
export type CreateProjectMutationMutationResult = Apollo.MutationResult<CreateProjectMutationMutation>;
export type CreateProjectMutationMutationOptions = Apollo.BaseMutationOptions<CreateProjectMutationMutation, CreateProjectMutationMutationVariables>;
export const IsActiveUserEmailQueryDocument = gql`
    query isActiveUserEmailQuery($email: String!) {
  isActiveUserEmail(email: $email)
}
    `;

/**
 * __useIsActiveUserEmailQueryQuery__
 *
 * To run a query within a React component, call `useIsActiveUserEmailQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsActiveUserEmailQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsActiveUserEmailQueryQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useIsActiveUserEmailQueryQuery(baseOptions: Apollo.QueryHookOptions<IsActiveUserEmailQueryQuery, IsActiveUserEmailQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsActiveUserEmailQueryQuery, IsActiveUserEmailQueryQueryVariables>(IsActiveUserEmailQueryDocument, options);
      }
export function useIsActiveUserEmailQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsActiveUserEmailQueryQuery, IsActiveUserEmailQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsActiveUserEmailQueryQuery, IsActiveUserEmailQueryQueryVariables>(IsActiveUserEmailQueryDocument, options);
        }
export type IsActiveUserEmailQueryQueryHookResult = ReturnType<typeof useIsActiveUserEmailQueryQuery>;
export type IsActiveUserEmailQueryLazyQueryHookResult = ReturnType<typeof useIsActiveUserEmailQueryLazyQuery>;
export type IsActiveUserEmailQueryQueryResult = Apollo.QueryResult<IsActiveUserEmailQueryQuery, IsActiveUserEmailQueryQueryVariables>;
export function refetchIsActiveUserEmailQueryQuery(variables: IsActiveUserEmailQueryQueryVariables) {
      return { query: IsActiveUserEmailQueryDocument, variables: variables }
    }
export const IsEmployeeEmailQueryDocument = gql`
    query isEmployeeEmailQuery($email: String!) {
  isEmployeeEmail(email: $email)
}
    `;

/**
 * __useIsEmployeeEmailQueryQuery__
 *
 * To run a query within a React component, call `useIsEmployeeEmailQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsEmployeeEmailQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsEmployeeEmailQueryQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useIsEmployeeEmailQueryQuery(baseOptions: Apollo.QueryHookOptions<IsEmployeeEmailQueryQuery, IsEmployeeEmailQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsEmployeeEmailQueryQuery, IsEmployeeEmailQueryQueryVariables>(IsEmployeeEmailQueryDocument, options);
      }
export function useIsEmployeeEmailQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsEmployeeEmailQueryQuery, IsEmployeeEmailQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsEmployeeEmailQueryQuery, IsEmployeeEmailQueryQueryVariables>(IsEmployeeEmailQueryDocument, options);
        }
export type IsEmployeeEmailQueryQueryHookResult = ReturnType<typeof useIsEmployeeEmailQueryQuery>;
export type IsEmployeeEmailQueryLazyQueryHookResult = ReturnType<typeof useIsEmployeeEmailQueryLazyQuery>;
export type IsEmployeeEmailQueryQueryResult = Apollo.QueryResult<IsEmployeeEmailQueryQuery, IsEmployeeEmailQueryQueryVariables>;
export function refetchIsEmployeeEmailQueryQuery(variables: IsEmployeeEmailQueryQueryVariables) {
      return { query: IsEmployeeEmailQueryDocument, variables: variables }
    }
export const UpdateBusinessAccountFeatureDocument = gql`
    mutation updateBusinessAccountFeature($businessAccountId: UUID!, $featureName: BusinessAccountFeatureInput!, $isEnabled: Boolean!) {
  setBusinessAccountFeature(
    businessAccountId: $businessAccountId
    featureName: $featureName
    isEnabled: $isEnabled
  ) {
    id
  }
}
    `;
export type UpdateBusinessAccountFeatureMutationFn = Apollo.MutationFunction<UpdateBusinessAccountFeatureMutation, UpdateBusinessAccountFeatureMutationVariables>;

/**
 * __useUpdateBusinessAccountFeatureMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessAccountFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessAccountFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessAccountFeatureMutation, { data, loading, error }] = useUpdateBusinessAccountFeatureMutation({
 *   variables: {
 *      businessAccountId: // value for 'businessAccountId'
 *      featureName: // value for 'featureName'
 *      isEnabled: // value for 'isEnabled'
 *   },
 * });
 */
export function useUpdateBusinessAccountFeatureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessAccountFeatureMutation, UpdateBusinessAccountFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBusinessAccountFeatureMutation, UpdateBusinessAccountFeatureMutationVariables>(UpdateBusinessAccountFeatureDocument, options);
      }
export type UpdateBusinessAccountFeatureMutationHookResult = ReturnType<typeof useUpdateBusinessAccountFeatureMutation>;
export type UpdateBusinessAccountFeatureMutationResult = Apollo.MutationResult<UpdateBusinessAccountFeatureMutation>;
export type UpdateBusinessAccountFeatureMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessAccountFeatureMutation, UpdateBusinessAccountFeatureMutationVariables>;
export const DownloadDfmFeedbackForQmrDocument = gql`
    mutation downloadDfmFeedbackForQmr($qmrId: UUID!, $requestedByAdmin: Boolean, $format: String) {
  downloadDfmFeedbackForQmr(
    qmrId: $qmrId
    requestedByAdmin: $requestedByAdmin
    format: $format
  ) {
    uploadUrl
    error
    loading
  }
}
    `;
export type DownloadDfmFeedbackForQmrMutationFn = Apollo.MutationFunction<DownloadDfmFeedbackForQmrMutation, DownloadDfmFeedbackForQmrMutationVariables>;

/**
 * __useDownloadDfmFeedbackForQmrMutation__
 *
 * To run a mutation, you first call `useDownloadDfmFeedbackForQmrMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadDfmFeedbackForQmrMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadDfmFeedbackForQmrMutation, { data, loading, error }] = useDownloadDfmFeedbackForQmrMutation({
 *   variables: {
 *      qmrId: // value for 'qmrId'
 *      requestedByAdmin: // value for 'requestedByAdmin'
 *      format: // value for 'format'
 *   },
 * });
 */
export function useDownloadDfmFeedbackForQmrMutation(baseOptions?: Apollo.MutationHookOptions<DownloadDfmFeedbackForQmrMutation, DownloadDfmFeedbackForQmrMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadDfmFeedbackForQmrMutation, DownloadDfmFeedbackForQmrMutationVariables>(DownloadDfmFeedbackForQmrDocument, options);
      }
export type DownloadDfmFeedbackForQmrMutationHookResult = ReturnType<typeof useDownloadDfmFeedbackForQmrMutation>;
export type DownloadDfmFeedbackForQmrMutationResult = Apollo.MutationResult<DownloadDfmFeedbackForQmrMutation>;
export type DownloadDfmFeedbackForQmrMutationOptions = Apollo.BaseMutationOptions<DownloadDfmFeedbackForQmrMutation, DownloadDfmFeedbackForQmrMutationVariables>;
export const IsMergedDfmReportReadyDocument = gql`
    query isMergedDfmReportReady($qmrId: UUID!, $requestedByAdmin: Boolean, $format: String) {
  isMergedDfmReportReady(
    qmrId: $qmrId
    requestedByAdmin: $requestedByAdmin
    format: $format
  ) {
    loading
    signedUrl
    error
  }
}
    `;

/**
 * __useIsMergedDfmReportReadyQuery__
 *
 * To run a query within a React component, call `useIsMergedDfmReportReadyQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsMergedDfmReportReadyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsMergedDfmReportReadyQuery({
 *   variables: {
 *      qmrId: // value for 'qmrId'
 *      requestedByAdmin: // value for 'requestedByAdmin'
 *      format: // value for 'format'
 *   },
 * });
 */
export function useIsMergedDfmReportReadyQuery(baseOptions: Apollo.QueryHookOptions<IsMergedDfmReportReadyQuery, IsMergedDfmReportReadyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsMergedDfmReportReadyQuery, IsMergedDfmReportReadyQueryVariables>(IsMergedDfmReportReadyDocument, options);
      }
export function useIsMergedDfmReportReadyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsMergedDfmReportReadyQuery, IsMergedDfmReportReadyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsMergedDfmReportReadyQuery, IsMergedDfmReportReadyQueryVariables>(IsMergedDfmReportReadyDocument, options);
        }
export type IsMergedDfmReportReadyQueryHookResult = ReturnType<typeof useIsMergedDfmReportReadyQuery>;
export type IsMergedDfmReportReadyLazyQueryHookResult = ReturnType<typeof useIsMergedDfmReportReadyLazyQuery>;
export type IsMergedDfmReportReadyQueryResult = Apollo.QueryResult<IsMergedDfmReportReadyQuery, IsMergedDfmReportReadyQueryVariables>;
export function refetchIsMergedDfmReportReadyQuery(variables: IsMergedDfmReportReadyQueryVariables) {
      return { query: IsMergedDfmReportReadyDocument, variables: variables }
    }
export const QmrFileNameDownloadImDfmReportPageDocument = gql`
    query qmrFileNameDownloadImDfmReportPage($id: UUID!) {
  quoteModelRevision(id: $id) {
    id
    fileName
  }
}
    `;

/**
 * __useQmrFileNameDownloadImDfmReportPageQuery__
 *
 * To run a query within a React component, call `useQmrFileNameDownloadImDfmReportPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useQmrFileNameDownloadImDfmReportPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQmrFileNameDownloadImDfmReportPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQmrFileNameDownloadImDfmReportPageQuery(baseOptions: Apollo.QueryHookOptions<QmrFileNameDownloadImDfmReportPageQuery, QmrFileNameDownloadImDfmReportPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QmrFileNameDownloadImDfmReportPageQuery, QmrFileNameDownloadImDfmReportPageQueryVariables>(QmrFileNameDownloadImDfmReportPageDocument, options);
      }
export function useQmrFileNameDownloadImDfmReportPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QmrFileNameDownloadImDfmReportPageQuery, QmrFileNameDownloadImDfmReportPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QmrFileNameDownloadImDfmReportPageQuery, QmrFileNameDownloadImDfmReportPageQueryVariables>(QmrFileNameDownloadImDfmReportPageDocument, options);
        }
export type QmrFileNameDownloadImDfmReportPageQueryHookResult = ReturnType<typeof useQmrFileNameDownloadImDfmReportPageQuery>;
export type QmrFileNameDownloadImDfmReportPageLazyQueryHookResult = ReturnType<typeof useQmrFileNameDownloadImDfmReportPageLazyQuery>;
export type QmrFileNameDownloadImDfmReportPageQueryResult = Apollo.QueryResult<QmrFileNameDownloadImDfmReportPageQuery, QmrFileNameDownloadImDfmReportPageQueryVariables>;
export function refetchQmrFileNameDownloadImDfmReportPageQuery(variables: QmrFileNameDownloadImDfmReportPageQueryVariables) {
      return { query: QmrFileNameDownloadImDfmReportPageDocument, variables: variables }
    }
export const UpdateQuoteStatusToSentToPunchoutDocument = gql`
    mutation updateQuoteStatusToSentToPunchout($id: UUID!) {
  updateQuoteStatusToSentToPunchout(id: $id) {
    id
  }
}
    `;
export type UpdateQuoteStatusToSentToPunchoutMutationFn = Apollo.MutationFunction<UpdateQuoteStatusToSentToPunchoutMutation, UpdateQuoteStatusToSentToPunchoutMutationVariables>;

/**
 * __useUpdateQuoteStatusToSentToPunchoutMutation__
 *
 * To run a mutation, you first call `useUpdateQuoteStatusToSentToPunchoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuoteStatusToSentToPunchoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuoteStatusToSentToPunchoutMutation, { data, loading, error }] = useUpdateQuoteStatusToSentToPunchoutMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateQuoteStatusToSentToPunchoutMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuoteStatusToSentToPunchoutMutation, UpdateQuoteStatusToSentToPunchoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuoteStatusToSentToPunchoutMutation, UpdateQuoteStatusToSentToPunchoutMutationVariables>(UpdateQuoteStatusToSentToPunchoutDocument, options);
      }
export type UpdateQuoteStatusToSentToPunchoutMutationHookResult = ReturnType<typeof useUpdateQuoteStatusToSentToPunchoutMutation>;
export type UpdateQuoteStatusToSentToPunchoutMutationResult = Apollo.MutationResult<UpdateQuoteStatusToSentToPunchoutMutation>;
export type UpdateQuoteStatusToSentToPunchoutMutationOptions = Apollo.BaseMutationOptions<UpdateQuoteStatusToSentToPunchoutMutation, UpdateQuoteStatusToSentToPunchoutMutationVariables>;
export const QuoteQmrDataDocument = gql`
    query QuoteQMRData($quoteId: UUID!) {
  quote(id: $quoteId) {
    isCpqQuote
    quoteItems {
      items {
        ...QMRItem
      }
    }
  }
}
    ${QmrItemFragmentDoc}`;

/**
 * __useQuoteQmrDataQuery__
 *
 * To run a query within a React component, call `useQuoteQmrDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteQmrDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteQmrDataQuery({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useQuoteQmrDataQuery(baseOptions: Apollo.QueryHookOptions<QuoteQmrDataQuery, QuoteQmrDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteQmrDataQuery, QuoteQmrDataQueryVariables>(QuoteQmrDataDocument, options);
      }
export function useQuoteQmrDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteQmrDataQuery, QuoteQmrDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteQmrDataQuery, QuoteQmrDataQueryVariables>(QuoteQmrDataDocument, options);
        }
export type QuoteQmrDataQueryHookResult = ReturnType<typeof useQuoteQmrDataQuery>;
export type QuoteQmrDataLazyQueryHookResult = ReturnType<typeof useQuoteQmrDataLazyQuery>;
export type QuoteQmrDataQueryResult = Apollo.QueryResult<QuoteQmrDataQuery, QuoteQmrDataQueryVariables>;
export function refetchQuoteQmrDataQuery(variables: QuoteQmrDataQueryVariables) {
      return { query: QuoteQmrDataDocument, variables: variables }
    }
export const CreatePurchaseOrderDocument = gql`
    mutation createPurchaseOrder($input: PurchaseOrderInput!, $userId: Int) {
  createPurchaseOrder(input: $input, userId: $userId) {
    id
    referenceId
    fileName
    createdAt
    updatedAt
    attachment {
      id
      uploadUrl
      downloadUrl
      fileName
      extension
      mimeType
      sizeInKb
      createdAt
      updatedAt
    }
  }
}
    `;
export type CreatePurchaseOrderMutationFn = Apollo.MutationFunction<CreatePurchaseOrderMutation, CreatePurchaseOrderMutationVariables>;

/**
 * __useCreatePurchaseOrderMutation__
 *
 * To run a mutation, you first call `useCreatePurchaseOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePurchaseOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPurchaseOrderMutation, { data, loading, error }] = useCreatePurchaseOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCreatePurchaseOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreatePurchaseOrderMutation, CreatePurchaseOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePurchaseOrderMutation, CreatePurchaseOrderMutationVariables>(CreatePurchaseOrderDocument, options);
      }
export type CreatePurchaseOrderMutationHookResult = ReturnType<typeof useCreatePurchaseOrderMutation>;
export type CreatePurchaseOrderMutationResult = Apollo.MutationResult<CreatePurchaseOrderMutation>;
export type CreatePurchaseOrderMutationOptions = Apollo.BaseMutationOptions<CreatePurchaseOrderMutation, CreatePurchaseOrderMutationVariables>;
export const MarkUploadedAttachmentPurchaseOrderPdfUploaderDocument = gql`
    mutation markUploadedAttachmentPurchaseOrderPdfUploader($attachmentId: UUID!) {
  markUploadedAttachment(id: $attachmentId) {
    id
    fileName
    downloadUrl
  }
}
    `;
export type MarkUploadedAttachmentPurchaseOrderPdfUploaderMutationFn = Apollo.MutationFunction<MarkUploadedAttachmentPurchaseOrderPdfUploaderMutation, MarkUploadedAttachmentPurchaseOrderPdfUploaderMutationVariables>;

/**
 * __useMarkUploadedAttachmentPurchaseOrderPdfUploaderMutation__
 *
 * To run a mutation, you first call `useMarkUploadedAttachmentPurchaseOrderPdfUploaderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkUploadedAttachmentPurchaseOrderPdfUploaderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markUploadedAttachmentPurchaseOrderPdfUploaderMutation, { data, loading, error }] = useMarkUploadedAttachmentPurchaseOrderPdfUploaderMutation({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useMarkUploadedAttachmentPurchaseOrderPdfUploaderMutation(baseOptions?: Apollo.MutationHookOptions<MarkUploadedAttachmentPurchaseOrderPdfUploaderMutation, MarkUploadedAttachmentPurchaseOrderPdfUploaderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkUploadedAttachmentPurchaseOrderPdfUploaderMutation, MarkUploadedAttachmentPurchaseOrderPdfUploaderMutationVariables>(MarkUploadedAttachmentPurchaseOrderPdfUploaderDocument, options);
      }
export type MarkUploadedAttachmentPurchaseOrderPdfUploaderMutationHookResult = ReturnType<typeof useMarkUploadedAttachmentPurchaseOrderPdfUploaderMutation>;
export type MarkUploadedAttachmentPurchaseOrderPdfUploaderMutationResult = Apollo.MutationResult<MarkUploadedAttachmentPurchaseOrderPdfUploaderMutation>;
export type MarkUploadedAttachmentPurchaseOrderPdfUploaderMutationOptions = Apollo.BaseMutationOptions<MarkUploadedAttachmentPurchaseOrderPdfUploaderMutation, MarkUploadedAttachmentPurchaseOrderPdfUploaderMutationVariables>;
export const ConsultativeDfmConfigurationDocument = gql`
    query consultativeDfmConfiguration {
  listDFMConsultationRequestOptions {
    commentsMaxLength
    sections {
      sectionKey
      title
      subtitle
      separatorAfter
      minChecked
      options {
        key
        label
      }
    }
  }
}
    `;

/**
 * __useConsultativeDfmConfigurationQuery__
 *
 * To run a query within a React component, call `useConsultativeDfmConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultativeDfmConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultativeDfmConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useConsultativeDfmConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<ConsultativeDfmConfigurationQuery, ConsultativeDfmConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsultativeDfmConfigurationQuery, ConsultativeDfmConfigurationQueryVariables>(ConsultativeDfmConfigurationDocument, options);
      }
export function useConsultativeDfmConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsultativeDfmConfigurationQuery, ConsultativeDfmConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsultativeDfmConfigurationQuery, ConsultativeDfmConfigurationQueryVariables>(ConsultativeDfmConfigurationDocument, options);
        }
export type ConsultativeDfmConfigurationQueryHookResult = ReturnType<typeof useConsultativeDfmConfigurationQuery>;
export type ConsultativeDfmConfigurationLazyQueryHookResult = ReturnType<typeof useConsultativeDfmConfigurationLazyQuery>;
export type ConsultativeDfmConfigurationQueryResult = Apollo.QueryResult<ConsultativeDfmConfigurationQuery, ConsultativeDfmConfigurationQueryVariables>;
export function refetchConsultativeDfmConfigurationQuery(variables?: ConsultativeDfmConfigurationQueryVariables) {
      return { query: ConsultativeDfmConfigurationDocument, variables: variables }
    }
export const CreateDfmConsultationRequestDocument = gql`
    mutation CreateDfmConsultationRequest($qmrId: UUID, $quoteId: UUID, $sections: [DfmConsultationRequestSectionInput], $notes: String) {
  createDFMConsultationRequest(
    qmrId: $qmrId
    quoteId: $quoteId
    sections: $sections
    notes: $notes
  )
}
    `;
export type CreateDfmConsultationRequestMutationFn = Apollo.MutationFunction<CreateDfmConsultationRequestMutation, CreateDfmConsultationRequestMutationVariables>;

/**
 * __useCreateDfmConsultationRequestMutation__
 *
 * To run a mutation, you first call `useCreateDfmConsultationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDfmConsultationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDfmConsultationRequestMutation, { data, loading, error }] = useCreateDfmConsultationRequestMutation({
 *   variables: {
 *      qmrId: // value for 'qmrId'
 *      quoteId: // value for 'quoteId'
 *      sections: // value for 'sections'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useCreateDfmConsultationRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateDfmConsultationRequestMutation, CreateDfmConsultationRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDfmConsultationRequestMutation, CreateDfmConsultationRequestMutationVariables>(CreateDfmConsultationRequestDocument, options);
      }
export type CreateDfmConsultationRequestMutationHookResult = ReturnType<typeof useCreateDfmConsultationRequestMutation>;
export type CreateDfmConsultationRequestMutationResult = Apollo.MutationResult<CreateDfmConsultationRequestMutation>;
export type CreateDfmConsultationRequestMutationOptions = Apollo.BaseMutationOptions<CreateDfmConsultationRequestMutation, CreateDfmConsultationRequestMutationVariables>;
export const UpsertQmrAttachmentAnnotationsDocument = gql`
    mutation upsertQmrAttachmentAnnotations($quoteId: UUID!, $attachmentId: UUID!, $qmrId: UUID!, $qmrAttachmentAnnotationsInput: QmrAttachmentAnnotationsInput!) {
  upsertQmrAttachmentAnnotations(
    quoteId: $quoteId
    attachmentId: $attachmentId
    qmrId: $qmrId
    qmrAttachmentAnnotationsInput: $qmrAttachmentAnnotationsInput
  ) {
    id
    annotationsDataDownloadUrl
    quoteModelRevisionId
  }
}
    `;
export type UpsertQmrAttachmentAnnotationsMutationFn = Apollo.MutationFunction<UpsertQmrAttachmentAnnotationsMutation, UpsertQmrAttachmentAnnotationsMutationVariables>;

/**
 * __useUpsertQmrAttachmentAnnotationsMutation__
 *
 * To run a mutation, you first call `useUpsertQmrAttachmentAnnotationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertQmrAttachmentAnnotationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertQmrAttachmentAnnotationsMutation, { data, loading, error }] = useUpsertQmrAttachmentAnnotationsMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      attachmentId: // value for 'attachmentId'
 *      qmrId: // value for 'qmrId'
 *      qmrAttachmentAnnotationsInput: // value for 'qmrAttachmentAnnotationsInput'
 *   },
 * });
 */
export function useUpsertQmrAttachmentAnnotationsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertQmrAttachmentAnnotationsMutation, UpsertQmrAttachmentAnnotationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertQmrAttachmentAnnotationsMutation, UpsertQmrAttachmentAnnotationsMutationVariables>(UpsertQmrAttachmentAnnotationsDocument, options);
      }
export type UpsertQmrAttachmentAnnotationsMutationHookResult = ReturnType<typeof useUpsertQmrAttachmentAnnotationsMutation>;
export type UpsertQmrAttachmentAnnotationsMutationResult = Apollo.MutationResult<UpsertQmrAttachmentAnnotationsMutation>;
export type UpsertQmrAttachmentAnnotationsMutationOptions = Apollo.BaseMutationOptions<UpsertQmrAttachmentAnnotationsMutation, UpsertQmrAttachmentAnnotationsMutationVariables>;
export const ImColorsDocument = gql`
    query imColors($materialId: String!) {
  colors(materialId: $materialId) {
    id
    name
  }
}
    `;

/**
 * __useImColorsQuery__
 *
 * To run a query within a React component, call `useImColorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useImColorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImColorsQuery({
 *   variables: {
 *      materialId: // value for 'materialId'
 *   },
 * });
 */
export function useImColorsQuery(baseOptions: Apollo.QueryHookOptions<ImColorsQuery, ImColorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImColorsQuery, ImColorsQueryVariables>(ImColorsDocument, options);
      }
export function useImColorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImColorsQuery, ImColorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImColorsQuery, ImColorsQueryVariables>(ImColorsDocument, options);
        }
export type ImColorsQueryHookResult = ReturnType<typeof useImColorsQuery>;
export type ImColorsLazyQueryHookResult = ReturnType<typeof useImColorsLazyQuery>;
export type ImColorsQueryResult = Apollo.QueryResult<ImColorsQuery, ImColorsQueryVariables>;
export function refetchImColorsQuery(variables: ImColorsQueryVariables) {
      return { query: ImColorsDocument, variables: variables }
    }
export const ImFinishDropdownDocument = gql`
    query imFinishDropdown($processId: String!) {
  textures(processId: $processId) {
    id
    name
    category
  }
}
    `;

/**
 * __useImFinishDropdownQuery__
 *
 * To run a query within a React component, call `useImFinishDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useImFinishDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImFinishDropdownQuery({
 *   variables: {
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useImFinishDropdownQuery(baseOptions: Apollo.QueryHookOptions<ImFinishDropdownQuery, ImFinishDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImFinishDropdownQuery, ImFinishDropdownQueryVariables>(ImFinishDropdownDocument, options);
      }
export function useImFinishDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImFinishDropdownQuery, ImFinishDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImFinishDropdownQuery, ImFinishDropdownQueryVariables>(ImFinishDropdownDocument, options);
        }
export type ImFinishDropdownQueryHookResult = ReturnType<typeof useImFinishDropdownQuery>;
export type ImFinishDropdownLazyQueryHookResult = ReturnType<typeof useImFinishDropdownLazyQuery>;
export type ImFinishDropdownQueryResult = Apollo.QueryResult<ImFinishDropdownQuery, ImFinishDropdownQueryVariables>;
export function refetchImFinishDropdownQuery(variables: ImFinishDropdownQueryVariables) {
      return { query: ImFinishDropdownDocument, variables: variables }
    }
export const ImMaterialsDropdownDocument = gql`
    query imMaterialsDropdown($processId: String!) {
  materials(processId: $processId) {
    id
    name
    materialCategory
  }
}
    `;

/**
 * __useImMaterialsDropdownQuery__
 *
 * To run a query within a React component, call `useImMaterialsDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useImMaterialsDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImMaterialsDropdownQuery({
 *   variables: {
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useImMaterialsDropdownQuery(baseOptions: Apollo.QueryHookOptions<ImMaterialsDropdownQuery, ImMaterialsDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImMaterialsDropdownQuery, ImMaterialsDropdownQueryVariables>(ImMaterialsDropdownDocument, options);
      }
export function useImMaterialsDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImMaterialsDropdownQuery, ImMaterialsDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImMaterialsDropdownQuery, ImMaterialsDropdownQueryVariables>(ImMaterialsDropdownDocument, options);
        }
export type ImMaterialsDropdownQueryHookResult = ReturnType<typeof useImMaterialsDropdownQuery>;
export type ImMaterialsDropdownLazyQueryHookResult = ReturnType<typeof useImMaterialsDropdownLazyQuery>;
export type ImMaterialsDropdownQueryResult = Apollo.QueryResult<ImMaterialsDropdownQuery, ImMaterialsDropdownQueryVariables>;
export function refetchImMaterialsDropdownQuery(variables: ImMaterialsDropdownQueryVariables) {
      return { query: ImMaterialsDropdownDocument, variables: variables }
    }
export const ImUserEnteredMaterialsDropdownDocument = gql`
    query imUserEnteredMaterialsDropdown {
  me {
    id
    userEnteredMaterials {
      id
      name
      process {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useImUserEnteredMaterialsDropdownQuery__
 *
 * To run a query within a React component, call `useImUserEnteredMaterialsDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useImUserEnteredMaterialsDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImUserEnteredMaterialsDropdownQuery({
 *   variables: {
 *   },
 * });
 */
export function useImUserEnteredMaterialsDropdownQuery(baseOptions?: Apollo.QueryHookOptions<ImUserEnteredMaterialsDropdownQuery, ImUserEnteredMaterialsDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImUserEnteredMaterialsDropdownQuery, ImUserEnteredMaterialsDropdownQueryVariables>(ImUserEnteredMaterialsDropdownDocument, options);
      }
export function useImUserEnteredMaterialsDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImUserEnteredMaterialsDropdownQuery, ImUserEnteredMaterialsDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImUserEnteredMaterialsDropdownQuery, ImUserEnteredMaterialsDropdownQueryVariables>(ImUserEnteredMaterialsDropdownDocument, options);
        }
export type ImUserEnteredMaterialsDropdownQueryHookResult = ReturnType<typeof useImUserEnteredMaterialsDropdownQuery>;
export type ImUserEnteredMaterialsDropdownLazyQueryHookResult = ReturnType<typeof useImUserEnteredMaterialsDropdownLazyQuery>;
export type ImUserEnteredMaterialsDropdownQueryResult = Apollo.QueryResult<ImUserEnteredMaterialsDropdownQuery, ImUserEnteredMaterialsDropdownQueryVariables>;
export function refetchImUserEnteredMaterialsDropdownQuery(variables?: ImUserEnteredMaterialsDropdownQueryVariables) {
      return { query: ImUserEnteredMaterialsDropdownDocument, variables: variables }
    }
export const ImMaterialConfigurationOptionsDocument = gql`
    query imMaterialConfigurationOptions($materialId: String!) {
  materialConfigurationOptions(materialId: $materialId) {
    id
    colorId
    colorName
    shoreId
    shoreName
  }
}
    `;

/**
 * __useImMaterialConfigurationOptionsQuery__
 *
 * To run a query within a React component, call `useImMaterialConfigurationOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useImMaterialConfigurationOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImMaterialConfigurationOptionsQuery({
 *   variables: {
 *      materialId: // value for 'materialId'
 *   },
 * });
 */
export function useImMaterialConfigurationOptionsQuery(baseOptions: Apollo.QueryHookOptions<ImMaterialConfigurationOptionsQuery, ImMaterialConfigurationOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImMaterialConfigurationOptionsQuery, ImMaterialConfigurationOptionsQueryVariables>(ImMaterialConfigurationOptionsDocument, options);
      }
export function useImMaterialConfigurationOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImMaterialConfigurationOptionsQuery, ImMaterialConfigurationOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImMaterialConfigurationOptionsQuery, ImMaterialConfigurationOptionsQueryVariables>(ImMaterialConfigurationOptionsDocument, options);
        }
export type ImMaterialConfigurationOptionsQueryHookResult = ReturnType<typeof useImMaterialConfigurationOptionsQuery>;
export type ImMaterialConfigurationOptionsLazyQueryHookResult = ReturnType<typeof useImMaterialConfigurationOptionsLazyQuery>;
export type ImMaterialConfigurationOptionsQueryResult = Apollo.QueryResult<ImMaterialConfigurationOptionsQuery, ImMaterialConfigurationOptionsQueryVariables>;
export function refetchImMaterialConfigurationOptionsQuery(variables: ImMaterialConfigurationOptionsQueryVariables) {
      return { query: ImMaterialConfigurationOptionsDocument, variables: variables }
    }
export const AddManuallyQuotedSecondaryProcessForBuilderDocument = gql`
    mutation addManuallyQuotedSecondaryProcessForBuilder($ids: [UUID!]!, $processId: String!) {
  addManuallyQuotedSecondaryProcessForBuilder(ids: $ids, processId: $processId)
}
    `;
export type AddManuallyQuotedSecondaryProcessForBuilderMutationFn = Apollo.MutationFunction<AddManuallyQuotedSecondaryProcessForBuilderMutation, AddManuallyQuotedSecondaryProcessForBuilderMutationVariables>;

/**
 * __useAddManuallyQuotedSecondaryProcessForBuilderMutation__
 *
 * To run a mutation, you first call `useAddManuallyQuotedSecondaryProcessForBuilderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddManuallyQuotedSecondaryProcessForBuilderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addManuallyQuotedSecondaryProcessForBuilderMutation, { data, loading, error }] = useAddManuallyQuotedSecondaryProcessForBuilderMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useAddManuallyQuotedSecondaryProcessForBuilderMutation(baseOptions?: Apollo.MutationHookOptions<AddManuallyQuotedSecondaryProcessForBuilderMutation, AddManuallyQuotedSecondaryProcessForBuilderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddManuallyQuotedSecondaryProcessForBuilderMutation, AddManuallyQuotedSecondaryProcessForBuilderMutationVariables>(AddManuallyQuotedSecondaryProcessForBuilderDocument, options);
      }
export type AddManuallyQuotedSecondaryProcessForBuilderMutationHookResult = ReturnType<typeof useAddManuallyQuotedSecondaryProcessForBuilderMutation>;
export type AddManuallyQuotedSecondaryProcessForBuilderMutationResult = Apollo.MutationResult<AddManuallyQuotedSecondaryProcessForBuilderMutation>;
export type AddManuallyQuotedSecondaryProcessForBuilderMutationOptions = Apollo.BaseMutationOptions<AddManuallyQuotedSecondaryProcessForBuilderMutation, AddManuallyQuotedSecondaryProcessForBuilderMutationVariables>;
export const AdminUpdateImProcessConfigsOnQmrsDocument = gql`
    mutation adminUpdateIMProcessConfigsOnQmrs($ids: [UUID!]!, $primaryProcessConfig: PrimaryProcessConfigInput!, $secondaryProcessConfigs: [SecondaryProcessConfigInput!]!, $removeManuallyQuotedSecondaryProcesses: Boolean, $additionalConfig: AdditionalConfigInput) {
  updateProcessConfigsOnQuoteModelRevisions(
    ids: $ids
    primaryProcessConfig: $primaryProcessConfig
    secondaryProcessConfigs: $secondaryProcessConfigs
    removeManuallyQuotedSecondaryProcesses: $removeManuallyQuotedSecondaryProcesses
    additionalConfig: $additionalConfig
  ) {
    id
    fileName
    version
    updatedAt
    state
    processesDetails {
      ...processesDetailsDeprecated
    }
    modelConfiguration {
      ...adminImModelConfiguration
    }
    dfmFeedback(includeDraft: true) {
      ...dfmFeedbackDeprecated
    }
  }
}
    ${ProcessesDetailsDeprecatedFragmentDoc}
${AdminImModelConfigurationFragmentDoc}
${DfmFeedbackDeprecatedFragmentDoc}`;
export type AdminUpdateImProcessConfigsOnQmrsMutationFn = Apollo.MutationFunction<AdminUpdateImProcessConfigsOnQmrsMutation, AdminUpdateImProcessConfigsOnQmrsMutationVariables>;

/**
 * __useAdminUpdateImProcessConfigsOnQmrsMutation__
 *
 * To run a mutation, you first call `useAdminUpdateImProcessConfigsOnQmrsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateImProcessConfigsOnQmrsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateImProcessConfigsOnQmrsMutation, { data, loading, error }] = useAdminUpdateImProcessConfigsOnQmrsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      primaryProcessConfig: // value for 'primaryProcessConfig'
 *      secondaryProcessConfigs: // value for 'secondaryProcessConfigs'
 *      removeManuallyQuotedSecondaryProcesses: // value for 'removeManuallyQuotedSecondaryProcesses'
 *      additionalConfig: // value for 'additionalConfig'
 *   },
 * });
 */
export function useAdminUpdateImProcessConfigsOnQmrsMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateImProcessConfigsOnQmrsMutation, AdminUpdateImProcessConfigsOnQmrsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateImProcessConfigsOnQmrsMutation, AdminUpdateImProcessConfigsOnQmrsMutationVariables>(AdminUpdateImProcessConfigsOnQmrsDocument, options);
      }
export type AdminUpdateImProcessConfigsOnQmrsMutationHookResult = ReturnType<typeof useAdminUpdateImProcessConfigsOnQmrsMutation>;
export type AdminUpdateImProcessConfigsOnQmrsMutationResult = Apollo.MutationResult<AdminUpdateImProcessConfigsOnQmrsMutation>;
export type AdminUpdateImProcessConfigsOnQmrsMutationOptions = Apollo.BaseMutationOptions<AdminUpdateImProcessConfigsOnQmrsMutation, AdminUpdateImProcessConfigsOnQmrsMutationVariables>;
export const UpdateOvermoldRequirementDocument = gql`
    mutation updateOvermoldRequirement($id: UUID!, $requiresOvermold: Boolean!) {
  updateOvermoldRequirement(id: $id, requiresOvermold: $requiresOvermold) {
    id
    modelConfiguration {
      id
      requiresOvermold
    }
  }
}
    `;
export type UpdateOvermoldRequirementMutationFn = Apollo.MutationFunction<UpdateOvermoldRequirementMutation, UpdateOvermoldRequirementMutationVariables>;

/**
 * __useUpdateOvermoldRequirementMutation__
 *
 * To run a mutation, you first call `useUpdateOvermoldRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOvermoldRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOvermoldRequirementMutation, { data, loading, error }] = useUpdateOvermoldRequirementMutation({
 *   variables: {
 *      id: // value for 'id'
 *      requiresOvermold: // value for 'requiresOvermold'
 *   },
 * });
 */
export function useUpdateOvermoldRequirementMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOvermoldRequirementMutation, UpdateOvermoldRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOvermoldRequirementMutation, UpdateOvermoldRequirementMutationVariables>(UpdateOvermoldRequirementDocument, options);
      }
export type UpdateOvermoldRequirementMutationHookResult = ReturnType<typeof useUpdateOvermoldRequirementMutation>;
export type UpdateOvermoldRequirementMutationResult = Apollo.MutationResult<UpdateOvermoldRequirementMutation>;
export type UpdateOvermoldRequirementMutationOptions = Apollo.BaseMutationOptions<UpdateOvermoldRequirementMutation, UpdateOvermoldRequirementMutationVariables>;
export const UpdateImProcessConfigsOnQmrsDocument = gql`
    mutation updateIMProcessConfigsOnQmrs($ids: [UUID!]!, $primaryProcessConfig: PrimaryProcessConfigInput!, $secondaryProcessConfigs: [SecondaryProcessConfigInput!]!, $removeManuallyQuotedSecondaryProcesses: Boolean, $additionalConfig: AdditionalConfigInput) {
  updateProcessConfigsOnQuoteModelRevisions(
    ids: $ids
    primaryProcessConfig: $primaryProcessConfig
    secondaryProcessConfigs: $secondaryProcessConfigs
    removeManuallyQuotedSecondaryProcesses: $removeManuallyQuotedSecondaryProcesses
    additionalConfig: $additionalConfig
  ) {
    id
    modelConfiguration {
      ...builderImModelConfiguration
    }
    processesDetails {
      primaryProcess {
        process {
          id
          name
          platformProcessTypeId
        }
        price {
          ... on ExactPrice {
            priceInCents
            unitPriceInCents
          }
          ... on EstimatedPrice {
            lowPriceInCents
            lowUnitPriceInCents
            highPriceInCents
            highUnitPriceInCents
          }
        }
      }
      postProcesses {
        postProcess {
          id
          name
        }
        unitPriceInCents
        postProcessLeadTimeInDays
        postProcessThickness {
          id
        }
        postProcessColor {
          id
        }
        postProcessNumParts
        postProcessInspectionCriteria
      }
      secondaryProcesses {
        process {
          id
          name
        }
        unitPriceInCents
        leadTimeInDays
        notes
      }
      totalPrice {
        ... on ExactPrice {
          priceInCents
          unitPriceInCents
        }
        ... on EstimatedPrice {
          lowPriceInCents
          lowUnitPriceInCents
          highPriceInCents
          highUnitPriceInCents
        }
      }
    }
  }
}
    ${BuilderImModelConfigurationFragmentDoc}`;
export type UpdateImProcessConfigsOnQmrsMutationFn = Apollo.MutationFunction<UpdateImProcessConfigsOnQmrsMutation, UpdateImProcessConfigsOnQmrsMutationVariables>;

/**
 * __useUpdateImProcessConfigsOnQmrsMutation__
 *
 * To run a mutation, you first call `useUpdateImProcessConfigsOnQmrsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImProcessConfigsOnQmrsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImProcessConfigsOnQmrsMutation, { data, loading, error }] = useUpdateImProcessConfigsOnQmrsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      primaryProcessConfig: // value for 'primaryProcessConfig'
 *      secondaryProcessConfigs: // value for 'secondaryProcessConfigs'
 *      removeManuallyQuotedSecondaryProcesses: // value for 'removeManuallyQuotedSecondaryProcesses'
 *      additionalConfig: // value for 'additionalConfig'
 *   },
 * });
 */
export function useUpdateImProcessConfigsOnQmrsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateImProcessConfigsOnQmrsMutation, UpdateImProcessConfigsOnQmrsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateImProcessConfigsOnQmrsMutation, UpdateImProcessConfigsOnQmrsMutationVariables>(UpdateImProcessConfigsOnQmrsDocument, options);
      }
export type UpdateImProcessConfigsOnQmrsMutationHookResult = ReturnType<typeof useUpdateImProcessConfigsOnQmrsMutation>;
export type UpdateImProcessConfigsOnQmrsMutationResult = Apollo.MutationResult<UpdateImProcessConfigsOnQmrsMutation>;
export type UpdateImProcessConfigsOnQmrsMutationOptions = Apollo.BaseMutationOptions<UpdateImProcessConfigsOnQmrsMutation, UpdateImProcessConfigsOnQmrsMutationVariables>;
export const RemoveImManuallyQuotedSecondaryProcessDocument = gql`
    mutation removeIMManuallyQuotedSecondaryProcess($ids: [UUID!]!, $processId: String) {
  removeManuallyQuotedSecondaryProcess(ids: $ids, processId: $processId)
}
    `;
export type RemoveImManuallyQuotedSecondaryProcessMutationFn = Apollo.MutationFunction<RemoveImManuallyQuotedSecondaryProcessMutation, RemoveImManuallyQuotedSecondaryProcessMutationVariables>;

/**
 * __useRemoveImManuallyQuotedSecondaryProcessMutation__
 *
 * To run a mutation, you first call `useRemoveImManuallyQuotedSecondaryProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveImManuallyQuotedSecondaryProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeImManuallyQuotedSecondaryProcessMutation, { data, loading, error }] = useRemoveImManuallyQuotedSecondaryProcessMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useRemoveImManuallyQuotedSecondaryProcessMutation(baseOptions?: Apollo.MutationHookOptions<RemoveImManuallyQuotedSecondaryProcessMutation, RemoveImManuallyQuotedSecondaryProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveImManuallyQuotedSecondaryProcessMutation, RemoveImManuallyQuotedSecondaryProcessMutationVariables>(RemoveImManuallyQuotedSecondaryProcessDocument, options);
      }
export type RemoveImManuallyQuotedSecondaryProcessMutationHookResult = ReturnType<typeof useRemoveImManuallyQuotedSecondaryProcessMutation>;
export type RemoveImManuallyQuotedSecondaryProcessMutationResult = Apollo.MutationResult<RemoveImManuallyQuotedSecondaryProcessMutation>;
export type RemoveImManuallyQuotedSecondaryProcessMutationOptions = Apollo.BaseMutationOptions<RemoveImManuallyQuotedSecondaryProcessMutation, RemoveImManuallyQuotedSecondaryProcessMutationVariables>;
export const RequestImEstimateSlackNotificationDocument = gql`
    mutation requestImEstimateSlackNotification($qmrId: UUID!) {
  requestImEstimateSlackNotification(qmrId: $qmrId) {
    qmrId
  }
}
    `;
export type RequestImEstimateSlackNotificationMutationFn = Apollo.MutationFunction<RequestImEstimateSlackNotificationMutation, RequestImEstimateSlackNotificationMutationVariables>;

/**
 * __useRequestImEstimateSlackNotificationMutation__
 *
 * To run a mutation, you first call `useRequestImEstimateSlackNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestImEstimateSlackNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestImEstimateSlackNotificationMutation, { data, loading, error }] = useRequestImEstimateSlackNotificationMutation({
 *   variables: {
 *      qmrId: // value for 'qmrId'
 *   },
 * });
 */
export function useRequestImEstimateSlackNotificationMutation(baseOptions?: Apollo.MutationHookOptions<RequestImEstimateSlackNotificationMutation, RequestImEstimateSlackNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestImEstimateSlackNotificationMutation, RequestImEstimateSlackNotificationMutationVariables>(RequestImEstimateSlackNotificationDocument, options);
      }
export type RequestImEstimateSlackNotificationMutationHookResult = ReturnType<typeof useRequestImEstimateSlackNotificationMutation>;
export type RequestImEstimateSlackNotificationMutationResult = Apollo.MutationResult<RequestImEstimateSlackNotificationMutation>;
export type RequestImEstimateSlackNotificationMutationOptions = Apollo.BaseMutationOptions<RequestImEstimateSlackNotificationMutation, RequestImEstimateSlackNotificationMutationVariables>;
export const GetPartEstimatedPriceForNonImModelsDocument = gql`
    query GetPartEstimatedPriceForNonImModels($qmrIds: [String!]!, $quantity: Int) {
  getPartEstimatedPriceForNonImModels(qmrIds: $qmrIds, quantity: $quantity) {
    partPrice {
      highUnitPriceInCents
      lowUnitPriceInCents
    }
  }
}
    `;

/**
 * __useGetPartEstimatedPriceForNonImModelsQuery__
 *
 * To run a query within a React component, call `useGetPartEstimatedPriceForNonImModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartEstimatedPriceForNonImModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartEstimatedPriceForNonImModelsQuery({
 *   variables: {
 *      qmrIds: // value for 'qmrIds'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useGetPartEstimatedPriceForNonImModelsQuery(baseOptions: Apollo.QueryHookOptions<GetPartEstimatedPriceForNonImModelsQuery, GetPartEstimatedPriceForNonImModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartEstimatedPriceForNonImModelsQuery, GetPartEstimatedPriceForNonImModelsQueryVariables>(GetPartEstimatedPriceForNonImModelsDocument, options);
      }
export function useGetPartEstimatedPriceForNonImModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartEstimatedPriceForNonImModelsQuery, GetPartEstimatedPriceForNonImModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartEstimatedPriceForNonImModelsQuery, GetPartEstimatedPriceForNonImModelsQueryVariables>(GetPartEstimatedPriceForNonImModelsDocument, options);
        }
export type GetPartEstimatedPriceForNonImModelsQueryHookResult = ReturnType<typeof useGetPartEstimatedPriceForNonImModelsQuery>;
export type GetPartEstimatedPriceForNonImModelsLazyQueryHookResult = ReturnType<typeof useGetPartEstimatedPriceForNonImModelsLazyQuery>;
export type GetPartEstimatedPriceForNonImModelsQueryResult = Apollo.QueryResult<GetPartEstimatedPriceForNonImModelsQuery, GetPartEstimatedPriceForNonImModelsQueryVariables>;
export function refetchGetPartEstimatedPriceForNonImModelsQuery(variables: GetPartEstimatedPriceForNonImModelsQueryVariables) {
      return { query: GetPartEstimatedPriceForNonImModelsDocument, variables: variables }
    }
export const GetQuoteModelRevisionImClassificationScoreDocument = gql`
    query GetQuoteModelRevisionImClassificationScore($qmrIds: [UUID]!) {
  getQuoteModelRevisionImClassificationScore(qmrIds: $qmrIds) {
    score
    qmrId
  }
}
    `;

/**
 * __useGetQuoteModelRevisionImClassificationScoreQuery__
 *
 * To run a query within a React component, call `useGetQuoteModelRevisionImClassificationScoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteModelRevisionImClassificationScoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteModelRevisionImClassificationScoreQuery({
 *   variables: {
 *      qmrIds: // value for 'qmrIds'
 *   },
 * });
 */
export function useGetQuoteModelRevisionImClassificationScoreQuery(baseOptions: Apollo.QueryHookOptions<GetQuoteModelRevisionImClassificationScoreQuery, GetQuoteModelRevisionImClassificationScoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuoteModelRevisionImClassificationScoreQuery, GetQuoteModelRevisionImClassificationScoreQueryVariables>(GetQuoteModelRevisionImClassificationScoreDocument, options);
      }
export function useGetQuoteModelRevisionImClassificationScoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuoteModelRevisionImClassificationScoreQuery, GetQuoteModelRevisionImClassificationScoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuoteModelRevisionImClassificationScoreQuery, GetQuoteModelRevisionImClassificationScoreQueryVariables>(GetQuoteModelRevisionImClassificationScoreDocument, options);
        }
export type GetQuoteModelRevisionImClassificationScoreQueryHookResult = ReturnType<typeof useGetQuoteModelRevisionImClassificationScoreQuery>;
export type GetQuoteModelRevisionImClassificationScoreLazyQueryHookResult = ReturnType<typeof useGetQuoteModelRevisionImClassificationScoreLazyQuery>;
export type GetQuoteModelRevisionImClassificationScoreQueryResult = Apollo.QueryResult<GetQuoteModelRevisionImClassificationScoreQuery, GetQuoteModelRevisionImClassificationScoreQueryVariables>;
export function refetchGetQuoteModelRevisionImClassificationScoreQuery(variables: GetQuoteModelRevisionImClassificationScoreQueryVariables) {
      return { query: GetQuoteModelRevisionImClassificationScoreDocument, variables: variables }
    }
export const QuoteModelRevisionWithHolesDocument = gql`
    query quoteModelRevisionWithHoles($id: UUID!, $showDeleted: Boolean) {
  quoteModelRevision(id: $id, showDeleted: $showDeleted) {
    id
    quoteModel {
      id
      quote {
        id
      }
    }
    dfmReports {
      quoteAttachmentRevisionId
      asset {
        id
        createdAt
        downloadUrl
        fileName
      }
      isPublished
      uploaderEmail
      source
    }
    holes {
      id
      groupKey
      patches {
        id
      }
      type
      depth
      diameter
      isBlind
      tipAngle
      counterboreDepth
      counterboreDiameter
      countersinkAngle
      countersinkDepth
      countersinkDiameter
      direction
      endPoint
      startPoint
      tapOptions {
        id
        maxDepth
        commonName
      }
      tapAnnotation {
        id
        depth
        tapOption {
          id
          maxDepth
          commonName
        }
      }
    }
  }
}
    `;

/**
 * __useQuoteModelRevisionWithHolesQuery__
 *
 * To run a query within a React component, call `useQuoteModelRevisionWithHolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteModelRevisionWithHolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteModelRevisionWithHolesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      showDeleted: // value for 'showDeleted'
 *   },
 * });
 */
export function useQuoteModelRevisionWithHolesQuery(baseOptions: Apollo.QueryHookOptions<QuoteModelRevisionWithHolesQuery, QuoteModelRevisionWithHolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteModelRevisionWithHolesQuery, QuoteModelRevisionWithHolesQueryVariables>(QuoteModelRevisionWithHolesDocument, options);
      }
export function useQuoteModelRevisionWithHolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteModelRevisionWithHolesQuery, QuoteModelRevisionWithHolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteModelRevisionWithHolesQuery, QuoteModelRevisionWithHolesQueryVariables>(QuoteModelRevisionWithHolesDocument, options);
        }
export type QuoteModelRevisionWithHolesQueryHookResult = ReturnType<typeof useQuoteModelRevisionWithHolesQuery>;
export type QuoteModelRevisionWithHolesLazyQueryHookResult = ReturnType<typeof useQuoteModelRevisionWithHolesLazyQuery>;
export type QuoteModelRevisionWithHolesQueryResult = Apollo.QueryResult<QuoteModelRevisionWithHolesQuery, QuoteModelRevisionWithHolesQueryVariables>;
export function refetchQuoteModelRevisionWithHolesQuery(variables: QuoteModelRevisionWithHolesQueryVariables) {
      return { query: QuoteModelRevisionWithHolesDocument, variables: variables }
    }
export const GetQmrAttachmentAnnotationsDocument = gql`
    query getQmrAttachmentAnnotations($attachmentId: UUID!, $quoteModelRevisionId: UUID) {
  getQmrAttachmentAnnotations(
    attachmentId: $attachmentId
    quoteModelRevisionId: $quoteModelRevisionId
  ) {
    id
    annotationsDataDownloadUrl
    attachmentId
    createdAt
    createdBy {
      id
      displayName
    }
    updatedAt
    updatedBy {
      id
      displayName
    }
  }
}
    `;

/**
 * __useGetQmrAttachmentAnnotationsQuery__
 *
 * To run a query within a React component, call `useGetQmrAttachmentAnnotationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQmrAttachmentAnnotationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQmrAttachmentAnnotationsQuery({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *   },
 * });
 */
export function useGetQmrAttachmentAnnotationsQuery(baseOptions: Apollo.QueryHookOptions<GetQmrAttachmentAnnotationsQuery, GetQmrAttachmentAnnotationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQmrAttachmentAnnotationsQuery, GetQmrAttachmentAnnotationsQueryVariables>(GetQmrAttachmentAnnotationsDocument, options);
      }
export function useGetQmrAttachmentAnnotationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQmrAttachmentAnnotationsQuery, GetQmrAttachmentAnnotationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQmrAttachmentAnnotationsQuery, GetQmrAttachmentAnnotationsQueryVariables>(GetQmrAttachmentAnnotationsDocument, options);
        }
export type GetQmrAttachmentAnnotationsQueryHookResult = ReturnType<typeof useGetQmrAttachmentAnnotationsQuery>;
export type GetQmrAttachmentAnnotationsLazyQueryHookResult = ReturnType<typeof useGetQmrAttachmentAnnotationsLazyQuery>;
export type GetQmrAttachmentAnnotationsQueryResult = Apollo.QueryResult<GetQmrAttachmentAnnotationsQuery, GetQmrAttachmentAnnotationsQueryVariables>;
export function refetchGetQmrAttachmentAnnotationsQuery(variables: GetQmrAttachmentAnnotationsQueryVariables) {
      return { query: GetQmrAttachmentAnnotationsDocument, variables: variables }
    }
export const GetInspectionPointCountDocument = gql`
    query getInspectionPointCount($attachmentId: UUID!) {
  getInspectionPointCount(attachmentId: $attachmentId) {
    db
    s3
    autoInspectionPoint
  }
}
    `;

/**
 * __useGetInspectionPointCountQuery__
 *
 * To run a query within a React component, call `useGetInspectionPointCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInspectionPointCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInspectionPointCountQuery({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useGetInspectionPointCountQuery(baseOptions: Apollo.QueryHookOptions<GetInspectionPointCountQuery, GetInspectionPointCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInspectionPointCountQuery, GetInspectionPointCountQueryVariables>(GetInspectionPointCountDocument, options);
      }
export function useGetInspectionPointCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInspectionPointCountQuery, GetInspectionPointCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInspectionPointCountQuery, GetInspectionPointCountQueryVariables>(GetInspectionPointCountDocument, options);
        }
export type GetInspectionPointCountQueryHookResult = ReturnType<typeof useGetInspectionPointCountQuery>;
export type GetInspectionPointCountLazyQueryHookResult = ReturnType<typeof useGetInspectionPointCountLazyQuery>;
export type GetInspectionPointCountQueryResult = Apollo.QueryResult<GetInspectionPointCountQuery, GetInspectionPointCountQueryVariables>;
export function refetchGetInspectionPointCountQuery(variables: GetInspectionPointCountQueryVariables) {
      return { query: GetInspectionPointCountDocument, variables: variables }
    }
export const CreateAutoGenerateUser2DDrawingDocument = gql`
    mutation createAutoGenerateUser2DDrawing($qmrId: UUID!, $quoteId: UUID!) {
  createAutoGenerateUserDrawing(qmrId: $qmrId, quoteId: $quoteId) {
    id
  }
}
    `;
export type CreateAutoGenerateUser2DDrawingMutationFn = Apollo.MutationFunction<CreateAutoGenerateUser2DDrawingMutation, CreateAutoGenerateUser2DDrawingMutationVariables>;

/**
 * __useCreateAutoGenerateUser2DDrawingMutation__
 *
 * To run a mutation, you first call `useCreateAutoGenerateUser2DDrawingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAutoGenerateUser2DDrawingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAutoGenerateUser2DDrawingMutation, { data, loading, error }] = useCreateAutoGenerateUser2DDrawingMutation({
 *   variables: {
 *      qmrId: // value for 'qmrId'
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useCreateAutoGenerateUser2DDrawingMutation(baseOptions?: Apollo.MutationHookOptions<CreateAutoGenerateUser2DDrawingMutation, CreateAutoGenerateUser2DDrawingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAutoGenerateUser2DDrawingMutation, CreateAutoGenerateUser2DDrawingMutationVariables>(CreateAutoGenerateUser2DDrawingDocument, options);
      }
export type CreateAutoGenerateUser2DDrawingMutationHookResult = ReturnType<typeof useCreateAutoGenerateUser2DDrawingMutation>;
export type CreateAutoGenerateUser2DDrawingMutationResult = Apollo.MutationResult<CreateAutoGenerateUser2DDrawingMutation>;
export type CreateAutoGenerateUser2DDrawingMutationOptions = Apollo.BaseMutationOptions<CreateAutoGenerateUser2DDrawingMutation, CreateAutoGenerateUser2DDrawingMutationVariables>;
export const RemoveQmrAttachmentDocument = gql`
    mutation removeQmrAttachment($quoteModelRevisionId: UUID!, $quoteAttachmentRevisionId: UUID!, $quoteId: UUID) {
  removeQuoteModelRevisionAttachment(
    quoteModelRevisionId: $quoteModelRevisionId
    quoteAttachmentRevisionId: $quoteAttachmentRevisionId
    quoteId: $quoteId
  ) {
    id
    quoteModelRevision {
      id
    }
  }
}
    `;
export type RemoveQmrAttachmentMutationFn = Apollo.MutationFunction<RemoveQmrAttachmentMutation, RemoveQmrAttachmentMutationVariables>;

/**
 * __useRemoveQmrAttachmentMutation__
 *
 * To run a mutation, you first call `useRemoveQmrAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveQmrAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeQmrAttachmentMutation, { data, loading, error }] = useRemoveQmrAttachmentMutation({
 *   variables: {
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *      quoteAttachmentRevisionId: // value for 'quoteAttachmentRevisionId'
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useRemoveQmrAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveQmrAttachmentMutation, RemoveQmrAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveQmrAttachmentMutation, RemoveQmrAttachmentMutationVariables>(RemoveQmrAttachmentDocument, options);
      }
export type RemoveQmrAttachmentMutationHookResult = ReturnType<typeof useRemoveQmrAttachmentMutation>;
export type RemoveQmrAttachmentMutationResult = Apollo.MutationResult<RemoveQmrAttachmentMutation>;
export type RemoveQmrAttachmentMutationOptions = Apollo.BaseMutationOptions<RemoveQmrAttachmentMutation, RemoveQmrAttachmentMutationVariables>;
export const QueryIsDfmAnnoDocument = gql`
    query queryIsDfmAnno($id: Int!) {
  user(id: $id) {
    id
    isDfmAnnotationsEnabled
  }
}
    `;

/**
 * __useQueryIsDfmAnnoQuery__
 *
 * To run a query within a React component, call `useQueryIsDfmAnnoQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryIsDfmAnnoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryIsDfmAnnoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQueryIsDfmAnnoQuery(baseOptions: Apollo.QueryHookOptions<QueryIsDfmAnnoQuery, QueryIsDfmAnnoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryIsDfmAnnoQuery, QueryIsDfmAnnoQueryVariables>(QueryIsDfmAnnoDocument, options);
      }
export function useQueryIsDfmAnnoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryIsDfmAnnoQuery, QueryIsDfmAnnoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryIsDfmAnnoQuery, QueryIsDfmAnnoQueryVariables>(QueryIsDfmAnnoDocument, options);
        }
export type QueryIsDfmAnnoQueryHookResult = ReturnType<typeof useQueryIsDfmAnnoQuery>;
export type QueryIsDfmAnnoLazyQueryHookResult = ReturnType<typeof useQueryIsDfmAnnoLazyQuery>;
export type QueryIsDfmAnnoQueryResult = Apollo.QueryResult<QueryIsDfmAnnoQuery, QueryIsDfmAnnoQueryVariables>;
export function refetchQueryIsDfmAnnoQuery(variables: QueryIsDfmAnnoQueryVariables) {
      return { query: QueryIsDfmAnnoDocument, variables: variables }
    }
export const RecommendedQuantitiesToHitDeliveryDateDocument = gql`
    query RecommendedQuantitiesToHitDeliveryDate($quoteId: UUID!, $currentEstimatedDeliveryDate: Date!, $desiredDeliveryDate: Date) {
  recommendedQuantitiesToHitDeliveryDate(
    quoteId: $quoteId
    currentEstimatedDeliveryDate: $currentEstimatedDeliveryDate
    desiredDeliveryDate: $desiredDeliveryDate
  ) {
    quoteModelRevisionId
    qty
    success
  }
}
    `;

/**
 * __useRecommendedQuantitiesToHitDeliveryDateQuery__
 *
 * To run a query within a React component, call `useRecommendedQuantitiesToHitDeliveryDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendedQuantitiesToHitDeliveryDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendedQuantitiesToHitDeliveryDateQuery({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      currentEstimatedDeliveryDate: // value for 'currentEstimatedDeliveryDate'
 *      desiredDeliveryDate: // value for 'desiredDeliveryDate'
 *   },
 * });
 */
export function useRecommendedQuantitiesToHitDeliveryDateQuery(baseOptions: Apollo.QueryHookOptions<RecommendedQuantitiesToHitDeliveryDateQuery, RecommendedQuantitiesToHitDeliveryDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecommendedQuantitiesToHitDeliveryDateQuery, RecommendedQuantitiesToHitDeliveryDateQueryVariables>(RecommendedQuantitiesToHitDeliveryDateDocument, options);
      }
export function useRecommendedQuantitiesToHitDeliveryDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecommendedQuantitiesToHitDeliveryDateQuery, RecommendedQuantitiesToHitDeliveryDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecommendedQuantitiesToHitDeliveryDateQuery, RecommendedQuantitiesToHitDeliveryDateQueryVariables>(RecommendedQuantitiesToHitDeliveryDateDocument, options);
        }
export type RecommendedQuantitiesToHitDeliveryDateQueryHookResult = ReturnType<typeof useRecommendedQuantitiesToHitDeliveryDateQuery>;
export type RecommendedQuantitiesToHitDeliveryDateLazyQueryHookResult = ReturnType<typeof useRecommendedQuantitiesToHitDeliveryDateLazyQuery>;
export type RecommendedQuantitiesToHitDeliveryDateQueryResult = Apollo.QueryResult<RecommendedQuantitiesToHitDeliveryDateQuery, RecommendedQuantitiesToHitDeliveryDateQueryVariables>;
export function refetchRecommendedQuantitiesToHitDeliveryDateQuery(variables: RecommendedQuantitiesToHitDeliveryDateQueryVariables) {
      return { query: RecommendedQuantitiesToHitDeliveryDateDocument, variables: variables }
    }
export const DfmTopicsTableDocument = gql`
    query dfmTopicsTable($id: UUID!) {
  quoteModelRevision(id: $id) {
    id
    dfmFeedback {
      id
      status
      title
      acceptedAt
      topic {
        id
        label
      }
    }
  }
}
    `;

/**
 * __useDfmTopicsTableQuery__
 *
 * To run a query within a React component, call `useDfmTopicsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useDfmTopicsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDfmTopicsTableQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDfmTopicsTableQuery(baseOptions: Apollo.QueryHookOptions<DfmTopicsTableQuery, DfmTopicsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DfmTopicsTableQuery, DfmTopicsTableQueryVariables>(DfmTopicsTableDocument, options);
      }
export function useDfmTopicsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DfmTopicsTableQuery, DfmTopicsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DfmTopicsTableQuery, DfmTopicsTableQueryVariables>(DfmTopicsTableDocument, options);
        }
export type DfmTopicsTableQueryHookResult = ReturnType<typeof useDfmTopicsTableQuery>;
export type DfmTopicsTableLazyQueryHookResult = ReturnType<typeof useDfmTopicsTableLazyQuery>;
export type DfmTopicsTableQueryResult = Apollo.QueryResult<DfmTopicsTableQuery, DfmTopicsTableQueryVariables>;
export function refetchDfmTopicsTableQuery(variables: DfmTopicsTableQueryVariables) {
      return { query: DfmTopicsTableDocument, variables: variables }
    }
export const QuoteStatusDocument = gql`
    query quoteStatus($id: UUID!) {
  quote(id: $id) {
    id
    status
    isLocked
  }
}
    `;

/**
 * __useQuoteStatusQuery__
 *
 * To run a query within a React component, call `useQuoteStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuoteStatusQuery(baseOptions: Apollo.QueryHookOptions<QuoteStatusQuery, QuoteStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteStatusQuery, QuoteStatusQueryVariables>(QuoteStatusDocument, options);
      }
export function useQuoteStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteStatusQuery, QuoteStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteStatusQuery, QuoteStatusQueryVariables>(QuoteStatusDocument, options);
        }
export type QuoteStatusQueryHookResult = ReturnType<typeof useQuoteStatusQuery>;
export type QuoteStatusLazyQueryHookResult = ReturnType<typeof useQuoteStatusLazyQuery>;
export type QuoteStatusQueryResult = Apollo.QueryResult<QuoteStatusQuery, QuoteStatusQueryVariables>;
export function refetchQuoteStatusQuery(variables: QuoteStatusQueryVariables) {
      return { query: QuoteStatusDocument, variables: variables }
    }
export const ImDfmModalHeaderQueryDocument = gql`
    query imDfmModalHeaderQuery($id: UUID!) {
  quoteModelRevision(id: $id) {
    id
    fileName
    partRevision {
      id
    }
    version
    quoteModel {
      selectedQuoteModelRevision {
        version
        id
      }
      quote {
        id
        user {
          id
        }
      }
    }
    dfmFeedback {
      id
    }
  }
}
    `;

/**
 * __useImDfmModalHeaderQueryQuery__
 *
 * To run a query within a React component, call `useImDfmModalHeaderQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useImDfmModalHeaderQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImDfmModalHeaderQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useImDfmModalHeaderQueryQuery(baseOptions: Apollo.QueryHookOptions<ImDfmModalHeaderQueryQuery, ImDfmModalHeaderQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImDfmModalHeaderQueryQuery, ImDfmModalHeaderQueryQueryVariables>(ImDfmModalHeaderQueryDocument, options);
      }
export function useImDfmModalHeaderQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImDfmModalHeaderQueryQuery, ImDfmModalHeaderQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImDfmModalHeaderQueryQuery, ImDfmModalHeaderQueryQueryVariables>(ImDfmModalHeaderQueryDocument, options);
        }
export type ImDfmModalHeaderQueryQueryHookResult = ReturnType<typeof useImDfmModalHeaderQueryQuery>;
export type ImDfmModalHeaderQueryLazyQueryHookResult = ReturnType<typeof useImDfmModalHeaderQueryLazyQuery>;
export type ImDfmModalHeaderQueryQueryResult = Apollo.QueryResult<ImDfmModalHeaderQueryQuery, ImDfmModalHeaderQueryQueryVariables>;
export function refetchImDfmModalHeaderQueryQuery(variables: ImDfmModalHeaderQueryQueryVariables) {
      return { query: ImDfmModalHeaderQueryDocument, variables: variables }
    }
export const GetSlideAttachmentAnnotationsDocument = gql`
    query getSlideAttachmentAnnotations($attachmentId: UUID!, $quoteModelRevisionId: UUID) {
  getQmrAttachmentAnnotations(
    attachmentId: $attachmentId
    quoteModelRevisionId: $quoteModelRevisionId
  ) {
    id
    annotationsDataDownloadUrl
  }
}
    `;

/**
 * __useGetSlideAttachmentAnnotationsQuery__
 *
 * To run a query within a React component, call `useGetSlideAttachmentAnnotationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSlideAttachmentAnnotationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSlideAttachmentAnnotationsQuery({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *   },
 * });
 */
export function useGetSlideAttachmentAnnotationsQuery(baseOptions: Apollo.QueryHookOptions<GetSlideAttachmentAnnotationsQuery, GetSlideAttachmentAnnotationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSlideAttachmentAnnotationsQuery, GetSlideAttachmentAnnotationsQueryVariables>(GetSlideAttachmentAnnotationsDocument, options);
      }
export function useGetSlideAttachmentAnnotationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSlideAttachmentAnnotationsQuery, GetSlideAttachmentAnnotationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSlideAttachmentAnnotationsQuery, GetSlideAttachmentAnnotationsQueryVariables>(GetSlideAttachmentAnnotationsDocument, options);
        }
export type GetSlideAttachmentAnnotationsQueryHookResult = ReturnType<typeof useGetSlideAttachmentAnnotationsQuery>;
export type GetSlideAttachmentAnnotationsLazyQueryHookResult = ReturnType<typeof useGetSlideAttachmentAnnotationsLazyQuery>;
export type GetSlideAttachmentAnnotationsQueryResult = Apollo.QueryResult<GetSlideAttachmentAnnotationsQuery, GetSlideAttachmentAnnotationsQueryVariables>;
export function refetchGetSlideAttachmentAnnotationsQuery(variables: GetSlideAttachmentAnnotationsQueryVariables) {
      return { query: GetSlideAttachmentAnnotationsDocument, variables: variables }
    }
export const ImDfmSlidesPanelDocument = gql`
    query imDfmSlidesPanel($id: UUID!) {
  quoteModelRevision(id: $id) {
    id
    version
    dfmFeedback {
      id
      acceptedAt
      acceptedBy {
        id
        email
      }
      status
      attachment {
        id
      }
      message
      title
      modelViewerSnapshots {
        id
        snapshot {
          camera {
            position
            zoom
            up
            target
          }
          part {
            transparent
            patches {
              color
              hashcode
            }
          }
          rotation
          dfm {
            color
            threshold
            feature
            direction
          }
          annotations {
            position
          }
          crossSection {
            position
            rotation
          }
          pointToPoint {
            customPoints
            selectedPoints {
              index
              type
            }
          }
        }
      }
      sourceType
      status
      topic {
        id
        label
      }
    }
    quoteModel {
      selectedQuoteModelRevision {
        id
        version
      }
      quote {
        isCpqOwned
        type
      }
    }
  }
}
    `;

/**
 * __useImDfmSlidesPanelQuery__
 *
 * To run a query within a React component, call `useImDfmSlidesPanelQuery` and pass it any options that fit your needs.
 * When your component renders, `useImDfmSlidesPanelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImDfmSlidesPanelQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useImDfmSlidesPanelQuery(baseOptions: Apollo.QueryHookOptions<ImDfmSlidesPanelQuery, ImDfmSlidesPanelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImDfmSlidesPanelQuery, ImDfmSlidesPanelQueryVariables>(ImDfmSlidesPanelDocument, options);
      }
export function useImDfmSlidesPanelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImDfmSlidesPanelQuery, ImDfmSlidesPanelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImDfmSlidesPanelQuery, ImDfmSlidesPanelQueryVariables>(ImDfmSlidesPanelDocument, options);
        }
export type ImDfmSlidesPanelQueryHookResult = ReturnType<typeof useImDfmSlidesPanelQuery>;
export type ImDfmSlidesPanelLazyQueryHookResult = ReturnType<typeof useImDfmSlidesPanelLazyQuery>;
export type ImDfmSlidesPanelQueryResult = Apollo.QueryResult<ImDfmSlidesPanelQuery, ImDfmSlidesPanelQueryVariables>;
export function refetchImDfmSlidesPanelQuery(variables: ImDfmSlidesPanelQueryVariables) {
      return { query: ImDfmSlidesPanelDocument, variables: variables }
    }
export const QmrImDfmModal3dViewerDocument = gql`
    query qmrImDfmModal3dViewer($qmrId: UUID!, $showDeleted: Boolean) {
  quoteModelRevision(id: $qmrId, showDeleted: $showDeleted) {
    id
    dfmFeedback {
      id
      modelViewerSnapshots {
        id
        snapshot {
          camera {
            position
            zoom
            up
            target
          }
          part {
            transparent
            patches {
              color
              hashcode
            }
          }
          rotation
          dfm {
            color
            threshold
            feature
            direction
          }
          annotations {
            position
          }
          crossSection {
            position
            rotation
          }
          pointToPoint {
            customPoints
            selectedPoints {
              index
              type
            }
          }
        }
      }
      sourceType
    }
    holes {
      id
      groupKey
      type
      depth
      diameter
      isBlind
      tipAngle
      counterboreDepth
      counterboreDiameter
      countersinkAngle
      countersinkDepth
      countersinkDiameter
      direction
      endPoint
      startPoint
      patches {
        id
      }
      tapOptions {
        id
        maxDepth
        commonName
      }
      tapAnnotation {
        id
        depth
        tapOption {
          id
          maxDepth
          commonName
        }
      }
    }
    partRevision {
      id
      sceneBundle
    }
  }
}
    `;

/**
 * __useQmrImDfmModal3dViewerQuery__
 *
 * To run a query within a React component, call `useQmrImDfmModal3dViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useQmrImDfmModal3dViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQmrImDfmModal3dViewerQuery({
 *   variables: {
 *      qmrId: // value for 'qmrId'
 *      showDeleted: // value for 'showDeleted'
 *   },
 * });
 */
export function useQmrImDfmModal3dViewerQuery(baseOptions: Apollo.QueryHookOptions<QmrImDfmModal3dViewerQuery, QmrImDfmModal3dViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QmrImDfmModal3dViewerQuery, QmrImDfmModal3dViewerQueryVariables>(QmrImDfmModal3dViewerDocument, options);
      }
export function useQmrImDfmModal3dViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QmrImDfmModal3dViewerQuery, QmrImDfmModal3dViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QmrImDfmModal3dViewerQuery, QmrImDfmModal3dViewerQueryVariables>(QmrImDfmModal3dViewerDocument, options);
        }
export type QmrImDfmModal3dViewerQueryHookResult = ReturnType<typeof useQmrImDfmModal3dViewerQuery>;
export type QmrImDfmModal3dViewerLazyQueryHookResult = ReturnType<typeof useQmrImDfmModal3dViewerLazyQuery>;
export type QmrImDfmModal3dViewerQueryResult = Apollo.QueryResult<QmrImDfmModal3dViewerQuery, QmrImDfmModal3dViewerQueryVariables>;
export function refetchQmrImDfmModal3dViewerQuery(variables: QmrImDfmModal3dViewerQueryVariables) {
      return { query: QmrImDfmModal3dViewerDocument, variables: variables }
    }
export const ImDfmPdfViewerModalQueryDocument = gql`
    query imDfmPdfViewerModalQuery($dfmFeedbackId: UUID!) {
  dfmFeedback(id: $dfmFeedbackId) {
    id
    attachment {
      id
      fileName
      downloadUrl
    }
  }
}
    `;

/**
 * __useImDfmPdfViewerModalQueryQuery__
 *
 * To run a query within a React component, call `useImDfmPdfViewerModalQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useImDfmPdfViewerModalQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImDfmPdfViewerModalQueryQuery({
 *   variables: {
 *      dfmFeedbackId: // value for 'dfmFeedbackId'
 *   },
 * });
 */
export function useImDfmPdfViewerModalQueryQuery(baseOptions: Apollo.QueryHookOptions<ImDfmPdfViewerModalQueryQuery, ImDfmPdfViewerModalQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImDfmPdfViewerModalQueryQuery, ImDfmPdfViewerModalQueryQueryVariables>(ImDfmPdfViewerModalQueryDocument, options);
      }
export function useImDfmPdfViewerModalQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImDfmPdfViewerModalQueryQuery, ImDfmPdfViewerModalQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImDfmPdfViewerModalQueryQuery, ImDfmPdfViewerModalQueryQueryVariables>(ImDfmPdfViewerModalQueryDocument, options);
        }
export type ImDfmPdfViewerModalQueryQueryHookResult = ReturnType<typeof useImDfmPdfViewerModalQueryQuery>;
export type ImDfmPdfViewerModalQueryLazyQueryHookResult = ReturnType<typeof useImDfmPdfViewerModalQueryLazyQuery>;
export type ImDfmPdfViewerModalQueryQueryResult = Apollo.QueryResult<ImDfmPdfViewerModalQueryQuery, ImDfmPdfViewerModalQueryQueryVariables>;
export function refetchImDfmPdfViewerModalQueryQuery(variables: ImDfmPdfViewerModalQueryQueryVariables) {
      return { query: ImDfmPdfViewerModalQueryDocument, variables: variables }
    }
export const QmrsInfoFilteredByHasDfmDocument = gql`
    query qmrsInfoFilteredByHasDfm($quoteId: UUID, $orderId: String) {
  qmrsInfoFilteredByHasDfm(quoteId: $quoteId, orderId: $orderId) {
    id
    fileName
    thumbnailUri
  }
}
    `;

/**
 * __useQmrsInfoFilteredByHasDfmQuery__
 *
 * To run a query within a React component, call `useQmrsInfoFilteredByHasDfmQuery` and pass it any options that fit your needs.
 * When your component renders, `useQmrsInfoFilteredByHasDfmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQmrsInfoFilteredByHasDfmQuery({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useQmrsInfoFilteredByHasDfmQuery(baseOptions?: Apollo.QueryHookOptions<QmrsInfoFilteredByHasDfmQuery, QmrsInfoFilteredByHasDfmQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QmrsInfoFilteredByHasDfmQuery, QmrsInfoFilteredByHasDfmQueryVariables>(QmrsInfoFilteredByHasDfmDocument, options);
      }
export function useQmrsInfoFilteredByHasDfmLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QmrsInfoFilteredByHasDfmQuery, QmrsInfoFilteredByHasDfmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QmrsInfoFilteredByHasDfmQuery, QmrsInfoFilteredByHasDfmQueryVariables>(QmrsInfoFilteredByHasDfmDocument, options);
        }
export type QmrsInfoFilteredByHasDfmQueryHookResult = ReturnType<typeof useQmrsInfoFilteredByHasDfmQuery>;
export type QmrsInfoFilteredByHasDfmLazyQueryHookResult = ReturnType<typeof useQmrsInfoFilteredByHasDfmLazyQuery>;
export type QmrsInfoFilteredByHasDfmQueryResult = Apollo.QueryResult<QmrsInfoFilteredByHasDfmQuery, QmrsInfoFilteredByHasDfmQueryVariables>;
export function refetchQmrsInfoFilteredByHasDfmQuery(variables?: QmrsInfoFilteredByHasDfmQueryVariables) {
      return { query: QmrsInfoFilteredByHasDfmDocument, variables: variables }
    }
export const SalesOrderIdQmrNavigationDocument = gql`
    query salesOrderIdQmrNavigation($name: String!) {
  salesOrder(name: $name) {
    id
  }
}
    `;

/**
 * __useSalesOrderIdQmrNavigationQuery__
 *
 * To run a query within a React component, call `useSalesOrderIdQmrNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesOrderIdQmrNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesOrderIdQmrNavigationQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSalesOrderIdQmrNavigationQuery(baseOptions: Apollo.QueryHookOptions<SalesOrderIdQmrNavigationQuery, SalesOrderIdQmrNavigationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesOrderIdQmrNavigationQuery, SalesOrderIdQmrNavigationQueryVariables>(SalesOrderIdQmrNavigationDocument, options);
      }
export function useSalesOrderIdQmrNavigationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesOrderIdQmrNavigationQuery, SalesOrderIdQmrNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesOrderIdQmrNavigationQuery, SalesOrderIdQmrNavigationQueryVariables>(SalesOrderIdQmrNavigationDocument, options);
        }
export type SalesOrderIdQmrNavigationQueryHookResult = ReturnType<typeof useSalesOrderIdQmrNavigationQuery>;
export type SalesOrderIdQmrNavigationLazyQueryHookResult = ReturnType<typeof useSalesOrderIdQmrNavigationLazyQuery>;
export type SalesOrderIdQmrNavigationQueryResult = Apollo.QueryResult<SalesOrderIdQmrNavigationQuery, SalesOrderIdQmrNavigationQueryVariables>;
export function refetchSalesOrderIdQmrNavigationQuery(variables: SalesOrderIdQmrNavigationQueryVariables) {
      return { query: SalesOrderIdQmrNavigationDocument, variables: variables }
    }
export const AcceptDfmFeedbackSlideActionPanelDocument = gql`
    mutation acceptDfmFeedbackSlideActionPanel($dfmFeedbackId: UUID!) {
  acceptDfmFeedback(id: $dfmFeedbackId) {
    id
    acceptedAt
    acceptedBy {
      id
      email
    }
    status
  }
}
    `;
export type AcceptDfmFeedbackSlideActionPanelMutationFn = Apollo.MutationFunction<AcceptDfmFeedbackSlideActionPanelMutation, AcceptDfmFeedbackSlideActionPanelMutationVariables>;

/**
 * __useAcceptDfmFeedbackSlideActionPanelMutation__
 *
 * To run a mutation, you first call `useAcceptDfmFeedbackSlideActionPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptDfmFeedbackSlideActionPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptDfmFeedbackSlideActionPanelMutation, { data, loading, error }] = useAcceptDfmFeedbackSlideActionPanelMutation({
 *   variables: {
 *      dfmFeedbackId: // value for 'dfmFeedbackId'
 *   },
 * });
 */
export function useAcceptDfmFeedbackSlideActionPanelMutation(baseOptions?: Apollo.MutationHookOptions<AcceptDfmFeedbackSlideActionPanelMutation, AcceptDfmFeedbackSlideActionPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptDfmFeedbackSlideActionPanelMutation, AcceptDfmFeedbackSlideActionPanelMutationVariables>(AcceptDfmFeedbackSlideActionPanelDocument, options);
      }
export type AcceptDfmFeedbackSlideActionPanelMutationHookResult = ReturnType<typeof useAcceptDfmFeedbackSlideActionPanelMutation>;
export type AcceptDfmFeedbackSlideActionPanelMutationResult = Apollo.MutationResult<AcceptDfmFeedbackSlideActionPanelMutation>;
export type AcceptDfmFeedbackSlideActionPanelMutationOptions = Apollo.BaseMutationOptions<AcceptDfmFeedbackSlideActionPanelMutation, AcceptDfmFeedbackSlideActionPanelMutationVariables>;
export const QmrRevisionRefetchDocument = gql`
    query qmrRevisionRefetch($id: UUID!) {
  quoteModelRevision(id: $id) {
    id
    dfmFeedback {
      id
      status
    }
    partRevision {
      id
      thumbnailUri
    }
    quoteModel {
      id
      quote {
        id
        status
      }
      quoteModelRevisions {
        id
        modelConfiguration {
          id
          process {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useQmrRevisionRefetchQuery__
 *
 * To run a query within a React component, call `useQmrRevisionRefetchQuery` and pass it any options that fit your needs.
 * When your component renders, `useQmrRevisionRefetchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQmrRevisionRefetchQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQmrRevisionRefetchQuery(baseOptions: Apollo.QueryHookOptions<QmrRevisionRefetchQuery, QmrRevisionRefetchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QmrRevisionRefetchQuery, QmrRevisionRefetchQueryVariables>(QmrRevisionRefetchDocument, options);
      }
export function useQmrRevisionRefetchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QmrRevisionRefetchQuery, QmrRevisionRefetchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QmrRevisionRefetchQuery, QmrRevisionRefetchQueryVariables>(QmrRevisionRefetchDocument, options);
        }
export type QmrRevisionRefetchQueryHookResult = ReturnType<typeof useQmrRevisionRefetchQuery>;
export type QmrRevisionRefetchLazyQueryHookResult = ReturnType<typeof useQmrRevisionRefetchLazyQuery>;
export type QmrRevisionRefetchQueryResult = Apollo.QueryResult<QmrRevisionRefetchQuery, QmrRevisionRefetchQueryVariables>;
export function refetchQmrRevisionRefetchQuery(variables: QmrRevisionRefetchQueryVariables) {
      return { query: QmrRevisionRefetchDocument, variables: variables }
    }
export const DfmFeedbackImDfmModalDocument = gql`
    query dfmFeedbackImDfmModal($dfmFeedbackId: UUID!) {
  dfmFeedback(id: $dfmFeedbackId) {
    id
    attachment {
      id
    }
  }
}
    `;

/**
 * __useDfmFeedbackImDfmModalQuery__
 *
 * To run a query within a React component, call `useDfmFeedbackImDfmModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useDfmFeedbackImDfmModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDfmFeedbackImDfmModalQuery({
 *   variables: {
 *      dfmFeedbackId: // value for 'dfmFeedbackId'
 *   },
 * });
 */
export function useDfmFeedbackImDfmModalQuery(baseOptions: Apollo.QueryHookOptions<DfmFeedbackImDfmModalQuery, DfmFeedbackImDfmModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DfmFeedbackImDfmModalQuery, DfmFeedbackImDfmModalQueryVariables>(DfmFeedbackImDfmModalDocument, options);
      }
export function useDfmFeedbackImDfmModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DfmFeedbackImDfmModalQuery, DfmFeedbackImDfmModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DfmFeedbackImDfmModalQuery, DfmFeedbackImDfmModalQueryVariables>(DfmFeedbackImDfmModalDocument, options);
        }
export type DfmFeedbackImDfmModalQueryHookResult = ReturnType<typeof useDfmFeedbackImDfmModalQuery>;
export type DfmFeedbackImDfmModalLazyQueryHookResult = ReturnType<typeof useDfmFeedbackImDfmModalLazyQuery>;
export type DfmFeedbackImDfmModalQueryResult = Apollo.QueryResult<DfmFeedbackImDfmModalQuery, DfmFeedbackImDfmModalQueryVariables>;
export function refetchDfmFeedbackImDfmModalQuery(variables: DfmFeedbackImDfmModalQueryVariables) {
      return { query: DfmFeedbackImDfmModalDocument, variables: variables }
    }
export const GetQmrAttachmentAnnotationsImDfmModalDocument = gql`
    query getQmrAttachmentAnnotationsImDfmModal($attachmentId: UUID!, $quoteModelRevisionId: UUID) {
  getQmrAttachmentAnnotations(
    attachmentId: $attachmentId
    quoteModelRevisionId: $quoteModelRevisionId
  ) {
    id
    annotationsDataDownloadUrl
  }
}
    `;

/**
 * __useGetQmrAttachmentAnnotationsImDfmModalQuery__
 *
 * To run a query within a React component, call `useGetQmrAttachmentAnnotationsImDfmModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQmrAttachmentAnnotationsImDfmModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQmrAttachmentAnnotationsImDfmModalQuery({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *   },
 * });
 */
export function useGetQmrAttachmentAnnotationsImDfmModalQuery(baseOptions: Apollo.QueryHookOptions<GetQmrAttachmentAnnotationsImDfmModalQuery, GetQmrAttachmentAnnotationsImDfmModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQmrAttachmentAnnotationsImDfmModalQuery, GetQmrAttachmentAnnotationsImDfmModalQueryVariables>(GetQmrAttachmentAnnotationsImDfmModalDocument, options);
      }
export function useGetQmrAttachmentAnnotationsImDfmModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQmrAttachmentAnnotationsImDfmModalQuery, GetQmrAttachmentAnnotationsImDfmModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQmrAttachmentAnnotationsImDfmModalQuery, GetQmrAttachmentAnnotationsImDfmModalQueryVariables>(GetQmrAttachmentAnnotationsImDfmModalDocument, options);
        }
export type GetQmrAttachmentAnnotationsImDfmModalQueryHookResult = ReturnType<typeof useGetQmrAttachmentAnnotationsImDfmModalQuery>;
export type GetQmrAttachmentAnnotationsImDfmModalLazyQueryHookResult = ReturnType<typeof useGetQmrAttachmentAnnotationsImDfmModalLazyQuery>;
export type GetQmrAttachmentAnnotationsImDfmModalQueryResult = Apollo.QueryResult<GetQmrAttachmentAnnotationsImDfmModalQuery, GetQmrAttachmentAnnotationsImDfmModalQueryVariables>;
export function refetchGetQmrAttachmentAnnotationsImDfmModalQuery(variables: GetQmrAttachmentAnnotationsImDfmModalQueryVariables) {
      return { query: GetQmrAttachmentAnnotationsImDfmModalDocument, variables: variables }
    }
export const UpsertDfmAttachmentAnnotationsImDfmModalDocument = gql`
    mutation upsertDfmAttachmentAnnotationsImDfmModal($attachmentId: UUID!, $qmrAttachmentAnnotationsInput: DfmAttachmentAnnotationsInput!, $newAnnotationsAdded: Boolean) {
  upsertDfmAttachmentAnnotations(
    attachmentId: $attachmentId
    qmrAttachmentAnnotationsInput: $qmrAttachmentAnnotationsInput
    newAnnotationsAdded: $newAnnotationsAdded
  ) {
    id
    annotationsDataDownloadUrl
    attachmentId
    createdAt
    createdBy {
      id
      displayName
    }
    updatedAt
    updatedBy {
      id
      displayName
    }
  }
}
    `;
export type UpsertDfmAttachmentAnnotationsImDfmModalMutationFn = Apollo.MutationFunction<UpsertDfmAttachmentAnnotationsImDfmModalMutation, UpsertDfmAttachmentAnnotationsImDfmModalMutationVariables>;

/**
 * __useUpsertDfmAttachmentAnnotationsImDfmModalMutation__
 *
 * To run a mutation, you first call `useUpsertDfmAttachmentAnnotationsImDfmModalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDfmAttachmentAnnotationsImDfmModalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDfmAttachmentAnnotationsImDfmModalMutation, { data, loading, error }] = useUpsertDfmAttachmentAnnotationsImDfmModalMutation({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *      qmrAttachmentAnnotationsInput: // value for 'qmrAttachmentAnnotationsInput'
 *      newAnnotationsAdded: // value for 'newAnnotationsAdded'
 *   },
 * });
 */
export function useUpsertDfmAttachmentAnnotationsImDfmModalMutation(baseOptions?: Apollo.MutationHookOptions<UpsertDfmAttachmentAnnotationsImDfmModalMutation, UpsertDfmAttachmentAnnotationsImDfmModalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertDfmAttachmentAnnotationsImDfmModalMutation, UpsertDfmAttachmentAnnotationsImDfmModalMutationVariables>(UpsertDfmAttachmentAnnotationsImDfmModalDocument, options);
      }
export type UpsertDfmAttachmentAnnotationsImDfmModalMutationHookResult = ReturnType<typeof useUpsertDfmAttachmentAnnotationsImDfmModalMutation>;
export type UpsertDfmAttachmentAnnotationsImDfmModalMutationResult = Apollo.MutationResult<UpsertDfmAttachmentAnnotationsImDfmModalMutation>;
export type UpsertDfmAttachmentAnnotationsImDfmModalMutationOptions = Apollo.BaseMutationOptions<UpsertDfmAttachmentAnnotationsImDfmModalMutation, UpsertDfmAttachmentAnnotationsImDfmModalMutationVariables>;
export const NotifyAdminDocument = gql`
    mutation notifyAdmin($quoteId: UUID!, $userId: Int!) {
  notifyAdmin(quoteId: $quoteId, userId: $userId) {
    id
  }
}
    `;
export type NotifyAdminMutationFn = Apollo.MutationFunction<NotifyAdminMutation, NotifyAdminMutationVariables>;

/**
 * __useNotifyAdminMutation__
 *
 * To run a mutation, you first call `useNotifyAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyAdminMutation, { data, loading, error }] = useNotifyAdminMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useNotifyAdminMutation(baseOptions?: Apollo.MutationHookOptions<NotifyAdminMutation, NotifyAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotifyAdminMutation, NotifyAdminMutationVariables>(NotifyAdminDocument, options);
      }
export type NotifyAdminMutationHookResult = ReturnType<typeof useNotifyAdminMutation>;
export type NotifyAdminMutationResult = Apollo.MutationResult<NotifyAdminMutation>;
export type NotifyAdminMutationOptions = Apollo.BaseMutationOptions<NotifyAdminMutation, NotifyAdminMutationVariables>;
export const NotifyAdminOnOdpDocument = gql`
    mutation notifyAdminOnOdp($userId: Int!, $orderId: String) {
  notifyAdmin(userId: $userId, orderId: $orderId) {
    id
  }
}
    `;
export type NotifyAdminOnOdpMutationFn = Apollo.MutationFunction<NotifyAdminOnOdpMutation, NotifyAdminOnOdpMutationVariables>;

/**
 * __useNotifyAdminOnOdpMutation__
 *
 * To run a mutation, you first call `useNotifyAdminOnOdpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyAdminOnOdpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyAdminOnOdpMutation, { data, loading, error }] = useNotifyAdminOnOdpMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useNotifyAdminOnOdpMutation(baseOptions?: Apollo.MutationHookOptions<NotifyAdminOnOdpMutation, NotifyAdminOnOdpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotifyAdminOnOdpMutation, NotifyAdminOnOdpMutationVariables>(NotifyAdminOnOdpDocument, options);
      }
export type NotifyAdminOnOdpMutationHookResult = ReturnType<typeof useNotifyAdminOnOdpMutation>;
export type NotifyAdminOnOdpMutationResult = Apollo.MutationResult<NotifyAdminOnOdpMutation>;
export type NotifyAdminOnOdpMutationOptions = Apollo.BaseMutationOptions<NotifyAdminOnOdpMutation, NotifyAdminOnOdpMutationVariables>;
export const QmrsGroupedByDfmCategoryDocument = gql`
    query qmrsGroupedByDfmCategory($quoteId: UUID, $orderId: String) {
  qmrsGroupedByDfmCategory(quoteId: $quoteId, orderId: $orderId) {
    category
    qmrs {
      id
      fileName
      version
      attachmentLink {
        id
        quoteAttachmentRevision {
          id
          attachment {
            id
            fileName
          }
        }
      }
      partRevision {
        id
        thumbnailUri
      }
      dfmFeedback {
        id
        isPublished
      }
    }
  }
}
    `;

/**
 * __useQmrsGroupedByDfmCategoryQuery__
 *
 * To run a query within a React component, call `useQmrsGroupedByDfmCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useQmrsGroupedByDfmCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQmrsGroupedByDfmCategoryQuery({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useQmrsGroupedByDfmCategoryQuery(baseOptions?: Apollo.QueryHookOptions<QmrsGroupedByDfmCategoryQuery, QmrsGroupedByDfmCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QmrsGroupedByDfmCategoryQuery, QmrsGroupedByDfmCategoryQueryVariables>(QmrsGroupedByDfmCategoryDocument, options);
      }
export function useQmrsGroupedByDfmCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QmrsGroupedByDfmCategoryQuery, QmrsGroupedByDfmCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QmrsGroupedByDfmCategoryQuery, QmrsGroupedByDfmCategoryQueryVariables>(QmrsGroupedByDfmCategoryDocument, options);
        }
export type QmrsGroupedByDfmCategoryQueryHookResult = ReturnType<typeof useQmrsGroupedByDfmCategoryQuery>;
export type QmrsGroupedByDfmCategoryLazyQueryHookResult = ReturnType<typeof useQmrsGroupedByDfmCategoryLazyQuery>;
export type QmrsGroupedByDfmCategoryQueryResult = Apollo.QueryResult<QmrsGroupedByDfmCategoryQuery, QmrsGroupedByDfmCategoryQueryVariables>;
export function refetchQmrsGroupedByDfmCategoryQuery(variables?: QmrsGroupedByDfmCategoryQueryVariables) {
      return { query: QmrsGroupedByDfmCategoryDocument, variables: variables }
    }
export const MoveToNewQuoteDocument = gql`
    mutation moveToNewQuote($quoteModelRevisionIds: [UUID]!, $newQuoteName: String, $userId: Int) {
  moveToNewQuote(
    quoteModelRevisionIds: $quoteModelRevisionIds
    newQuoteName: $newQuoteName
    userId: $userId
  ) {
    id
    name
  }
}
    `;
export type MoveToNewQuoteMutationFn = Apollo.MutationFunction<MoveToNewQuoteMutation, MoveToNewQuoteMutationVariables>;

/**
 * __useMoveToNewQuoteMutation__
 *
 * To run a mutation, you first call `useMoveToNewQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveToNewQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveToNewQuoteMutation, { data, loading, error }] = useMoveToNewQuoteMutation({
 *   variables: {
 *      quoteModelRevisionIds: // value for 'quoteModelRevisionIds'
 *      newQuoteName: // value for 'newQuoteName'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useMoveToNewQuoteMutation(baseOptions?: Apollo.MutationHookOptions<MoveToNewQuoteMutation, MoveToNewQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveToNewQuoteMutation, MoveToNewQuoteMutationVariables>(MoveToNewQuoteDocument, options);
      }
export type MoveToNewQuoteMutationHookResult = ReturnType<typeof useMoveToNewQuoteMutation>;
export type MoveToNewQuoteMutationResult = Apollo.MutationResult<MoveToNewQuoteMutation>;
export type MoveToNewQuoteMutationOptions = Apollo.BaseMutationOptions<MoveToNewQuoteMutation, MoveToNewQuoteMutationVariables>;
export const MoveToExistingQuoteDocument = gql`
    mutation moveToExistingQuote($quoteModelRevisionIds: [UUID]!, $destinationQuoteId: UUID!, $userId: Int) {
  moveToExistingQuote(
    quoteModelRevisionIds: $quoteModelRevisionIds
    destinationQuoteId: $destinationQuoteId
    userId: $userId
  ) {
    id
    name
  }
}
    `;
export type MoveToExistingQuoteMutationFn = Apollo.MutationFunction<MoveToExistingQuoteMutation, MoveToExistingQuoteMutationVariables>;

/**
 * __useMoveToExistingQuoteMutation__
 *
 * To run a mutation, you first call `useMoveToExistingQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveToExistingQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveToExistingQuoteMutation, { data, loading, error }] = useMoveToExistingQuoteMutation({
 *   variables: {
 *      quoteModelRevisionIds: // value for 'quoteModelRevisionIds'
 *      destinationQuoteId: // value for 'destinationQuoteId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useMoveToExistingQuoteMutation(baseOptions?: Apollo.MutationHookOptions<MoveToExistingQuoteMutation, MoveToExistingQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveToExistingQuoteMutation, MoveToExistingQuoteMutationVariables>(MoveToExistingQuoteDocument, options);
      }
export type MoveToExistingQuoteMutationHookResult = ReturnType<typeof useMoveToExistingQuoteMutation>;
export type MoveToExistingQuoteMutationResult = Apollo.MutationResult<MoveToExistingQuoteMutation>;
export type MoveToExistingQuoteMutationOptions = Apollo.BaseMutationOptions<MoveToExistingQuoteMutation, MoveToExistingQuoteMutationVariables>;
export const QuotesListMoveToQuoteModalDocument = gql`
    query quotesListMoveToQuoteModal {
  me {
    id
    quotes(limit: 1000, sort: "LAST_MODIFIED_DESC") {
      items {
        ... on Quote {
          id
          name
          type
          status
          lastModified
          requestedAt
          quoteModels {
            totalCount
          }
          project {
            isSecurePlus
            name
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useQuotesListMoveToQuoteModalQuery__
 *
 * To run a query within a React component, call `useQuotesListMoveToQuoteModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuotesListMoveToQuoteModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuotesListMoveToQuoteModalQuery({
 *   variables: {
 *   },
 * });
 */
export function useQuotesListMoveToQuoteModalQuery(baseOptions?: Apollo.QueryHookOptions<QuotesListMoveToQuoteModalQuery, QuotesListMoveToQuoteModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuotesListMoveToQuoteModalQuery, QuotesListMoveToQuoteModalQueryVariables>(QuotesListMoveToQuoteModalDocument, options);
      }
export function useQuotesListMoveToQuoteModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuotesListMoveToQuoteModalQuery, QuotesListMoveToQuoteModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuotesListMoveToQuoteModalQuery, QuotesListMoveToQuoteModalQueryVariables>(QuotesListMoveToQuoteModalDocument, options);
        }
export type QuotesListMoveToQuoteModalQueryHookResult = ReturnType<typeof useQuotesListMoveToQuoteModalQuery>;
export type QuotesListMoveToQuoteModalLazyQueryHookResult = ReturnType<typeof useQuotesListMoveToQuoteModalLazyQuery>;
export type QuotesListMoveToQuoteModalQueryResult = Apollo.QueryResult<QuotesListMoveToQuoteModalQuery, QuotesListMoveToQuoteModalQueryVariables>;
export function refetchQuotesListMoveToQuoteModalQuery(variables?: QuotesListMoveToQuoteModalQueryVariables) {
      return { query: QuotesListMoveToQuoteModalDocument, variables: variables }
    }
export const UpdateQuoteLevelLeadTimesQuoteDetailPageDocument = gql`
    mutation updateQuoteLevelLeadTimesQuoteDetailPage($quoteId: UUID!, $productionDays: Int!, $region: QuoteLevelLeadTimesRegion!) {
  updateQuoteLeadTimes(
    quoteId: $quoteId
    productionDays: $productionDays
    region: $region
  ) {
    id
  }
}
    `;
export type UpdateQuoteLevelLeadTimesQuoteDetailPageMutationFn = Apollo.MutationFunction<UpdateQuoteLevelLeadTimesQuoteDetailPageMutation, UpdateQuoteLevelLeadTimesQuoteDetailPageMutationVariables>;

/**
 * __useUpdateQuoteLevelLeadTimesQuoteDetailPageMutation__
 *
 * To run a mutation, you first call `useUpdateQuoteLevelLeadTimesQuoteDetailPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuoteLevelLeadTimesQuoteDetailPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuoteLevelLeadTimesQuoteDetailPageMutation, { data, loading, error }] = useUpdateQuoteLevelLeadTimesQuoteDetailPageMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      productionDays: // value for 'productionDays'
 *      region: // value for 'region'
 *   },
 * });
 */
export function useUpdateQuoteLevelLeadTimesQuoteDetailPageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuoteLevelLeadTimesQuoteDetailPageMutation, UpdateQuoteLevelLeadTimesQuoteDetailPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuoteLevelLeadTimesQuoteDetailPageMutation, UpdateQuoteLevelLeadTimesQuoteDetailPageMutationVariables>(UpdateQuoteLevelLeadTimesQuoteDetailPageDocument, options);
      }
export type UpdateQuoteLevelLeadTimesQuoteDetailPageMutationHookResult = ReturnType<typeof useUpdateQuoteLevelLeadTimesQuoteDetailPageMutation>;
export type UpdateQuoteLevelLeadTimesQuoteDetailPageMutationResult = Apollo.MutationResult<UpdateQuoteLevelLeadTimesQuoteDetailPageMutation>;
export type UpdateQuoteLevelLeadTimesQuoteDetailPageMutationOptions = Apollo.BaseMutationOptions<UpdateQuoteLevelLeadTimesQuoteDetailPageMutation, UpdateQuoteLevelLeadTimesQuoteDetailPageMutationVariables>;
export const QuoteLevelLeadTimesWithShippingOptionsDocument = gql`
    query QuoteLevelLeadTimesWithShippingOptions($quoteId: UUID!, $address: AddressInput) {
  quote(id: $quoteId) {
    id
    quoteLevelLeadTimesWithShippingOptions(address: $address) {
      domesticFastest {
        ...QlltOption
      }
      domesticStandard {
        ...QlltOption
      }
      domesticCostEffective {
        ...QlltOption
      }
      overseasFastest {
        ...QlltOption
      }
      overseasStandard {
        ...QlltOption
      }
      overseasCostEffective {
        ...QlltOption
      }
    }
  }
}
    ${QlltOptionFragmentDoc}`;

/**
 * __useQuoteLevelLeadTimesWithShippingOptionsQuery__
 *
 * To run a query within a React component, call `useQuoteLevelLeadTimesWithShippingOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteLevelLeadTimesWithShippingOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteLevelLeadTimesWithShippingOptionsQuery({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      address: // value for 'address'
 *   },
 * });
 */
export function useQuoteLevelLeadTimesWithShippingOptionsQuery(baseOptions: Apollo.QueryHookOptions<QuoteLevelLeadTimesWithShippingOptionsQuery, QuoteLevelLeadTimesWithShippingOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteLevelLeadTimesWithShippingOptionsQuery, QuoteLevelLeadTimesWithShippingOptionsQueryVariables>(QuoteLevelLeadTimesWithShippingOptionsDocument, options);
      }
export function useQuoteLevelLeadTimesWithShippingOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteLevelLeadTimesWithShippingOptionsQuery, QuoteLevelLeadTimesWithShippingOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteLevelLeadTimesWithShippingOptionsQuery, QuoteLevelLeadTimesWithShippingOptionsQueryVariables>(QuoteLevelLeadTimesWithShippingOptionsDocument, options);
        }
export type QuoteLevelLeadTimesWithShippingOptionsQueryHookResult = ReturnType<typeof useQuoteLevelLeadTimesWithShippingOptionsQuery>;
export type QuoteLevelLeadTimesWithShippingOptionsLazyQueryHookResult = ReturnType<typeof useQuoteLevelLeadTimesWithShippingOptionsLazyQuery>;
export type QuoteLevelLeadTimesWithShippingOptionsQueryResult = Apollo.QueryResult<QuoteLevelLeadTimesWithShippingOptionsQuery, QuoteLevelLeadTimesWithShippingOptionsQueryVariables>;
export function refetchQuoteLevelLeadTimesWithShippingOptionsQuery(variables: QuoteLevelLeadTimesWithShippingOptionsQueryVariables) {
      return { query: QuoteLevelLeadTimesWithShippingOptionsDocument, variables: variables }
    }
export const DestroyTapsThreadsTagDocument = gql`
    mutation destroyTapsThreadsTag($quoteModelRevisionId: UUID!, $holesList: [String!]!) {
  destroyQuoteModelRevisionTapOnHoles(
    quoteModelRevisionId: $quoteModelRevisionId
    holesList: $holesList
  ) {
    quoteModelRevisionId
    hole {
      id
      tapAnnotation {
        id
        tapOption {
          id
          commonName
        }
      }
    }
  }
}
    `;
export type DestroyTapsThreadsTagMutationFn = Apollo.MutationFunction<DestroyTapsThreadsTagMutation, DestroyTapsThreadsTagMutationVariables>;

/**
 * __useDestroyTapsThreadsTagMutation__
 *
 * To run a mutation, you first call `useDestroyTapsThreadsTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyTapsThreadsTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyTapsThreadsTagMutation, { data, loading, error }] = useDestroyTapsThreadsTagMutation({
 *   variables: {
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *      holesList: // value for 'holesList'
 *   },
 * });
 */
export function useDestroyTapsThreadsTagMutation(baseOptions?: Apollo.MutationHookOptions<DestroyTapsThreadsTagMutation, DestroyTapsThreadsTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroyTapsThreadsTagMutation, DestroyTapsThreadsTagMutationVariables>(DestroyTapsThreadsTagDocument, options);
      }
export type DestroyTapsThreadsTagMutationHookResult = ReturnType<typeof useDestroyTapsThreadsTagMutation>;
export type DestroyTapsThreadsTagMutationResult = Apollo.MutationResult<DestroyTapsThreadsTagMutation>;
export type DestroyTapsThreadsTagMutationOptions = Apollo.BaseMutationOptions<DestroyTapsThreadsTagMutation, DestroyTapsThreadsTagMutationVariables>;
export const RemoveQmrAttachmentDrawingTagDocument = gql`
    mutation removeQmrAttachmentDrawingTag($quoteModelRevisionId: UUID!, $quoteAttachmentRevisionId: UUID!, $quoteId: UUID) {
  removeQuoteModelRevisionAttachment(
    quoteModelRevisionId: $quoteModelRevisionId
    quoteAttachmentRevisionId: $quoteAttachmentRevisionId
    quoteId: $quoteId
  ) {
    id
    quoteModelRevision {
      id
    }
  }
}
    `;
export type RemoveQmrAttachmentDrawingTagMutationFn = Apollo.MutationFunction<RemoveQmrAttachmentDrawingTagMutation, RemoveQmrAttachmentDrawingTagMutationVariables>;

/**
 * __useRemoveQmrAttachmentDrawingTagMutation__
 *
 * To run a mutation, you first call `useRemoveQmrAttachmentDrawingTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveQmrAttachmentDrawingTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeQmrAttachmentDrawingTagMutation, { data, loading, error }] = useRemoveQmrAttachmentDrawingTagMutation({
 *   variables: {
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *      quoteAttachmentRevisionId: // value for 'quoteAttachmentRevisionId'
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useRemoveQmrAttachmentDrawingTagMutation(baseOptions?: Apollo.MutationHookOptions<RemoveQmrAttachmentDrawingTagMutation, RemoveQmrAttachmentDrawingTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveQmrAttachmentDrawingTagMutation, RemoveQmrAttachmentDrawingTagMutationVariables>(RemoveQmrAttachmentDrawingTagDocument, options);
      }
export type RemoveQmrAttachmentDrawingTagMutationHookResult = ReturnType<typeof useRemoveQmrAttachmentDrawingTagMutation>;
export type RemoveQmrAttachmentDrawingTagMutationResult = Apollo.MutationResult<RemoveQmrAttachmentDrawingTagMutation>;
export type RemoveQmrAttachmentDrawingTagMutationOptions = Apollo.BaseMutationOptions<RemoveQmrAttachmentDrawingTagMutation, RemoveQmrAttachmentDrawingTagMutationVariables>;
export const UpdateCustomerToolNameDocument = gql`
    mutation updateCustomerToolName($moldToolId: UUID!, $customerToolName: String) {
  updateCustomerToolName(moldId: $moldToolId, customerToolName: $customerToolName) {
    id
    name
    customerToolName
  }
}
    `;
export type UpdateCustomerToolNameMutationFn = Apollo.MutationFunction<UpdateCustomerToolNameMutation, UpdateCustomerToolNameMutationVariables>;

/**
 * __useUpdateCustomerToolNameMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerToolNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerToolNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerToolNameMutation, { data, loading, error }] = useUpdateCustomerToolNameMutation({
 *   variables: {
 *      moldToolId: // value for 'moldToolId'
 *      customerToolName: // value for 'customerToolName'
 *   },
 * });
 */
export function useUpdateCustomerToolNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerToolNameMutation, UpdateCustomerToolNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerToolNameMutation, UpdateCustomerToolNameMutationVariables>(UpdateCustomerToolNameDocument, options);
      }
export type UpdateCustomerToolNameMutationHookResult = ReturnType<typeof useUpdateCustomerToolNameMutation>;
export type UpdateCustomerToolNameMutationResult = Apollo.MutationResult<UpdateCustomerToolNameMutation>;
export type UpdateCustomerToolNameMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerToolNameMutation, UpdateCustomerToolNameMutationVariables>;
export const ProductionLeadTimesDropdownDocument = gql`
    query productionLeadTimesDropdown($id: UUID!) {
  productionLeadTimes(quoteModelRevisionId: $id) {
    id
    priorityId
    productionDays
    primaryProductionDays
  }
}
    `;

/**
 * __useProductionLeadTimesDropdownQuery__
 *
 * To run a query within a React component, call `useProductionLeadTimesDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductionLeadTimesDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductionLeadTimesDropdownQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductionLeadTimesDropdownQuery(baseOptions: Apollo.QueryHookOptions<ProductionLeadTimesDropdownQuery, ProductionLeadTimesDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductionLeadTimesDropdownQuery, ProductionLeadTimesDropdownQueryVariables>(ProductionLeadTimesDropdownDocument, options);
      }
export function useProductionLeadTimesDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductionLeadTimesDropdownQuery, ProductionLeadTimesDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductionLeadTimesDropdownQuery, ProductionLeadTimesDropdownQueryVariables>(ProductionLeadTimesDropdownDocument, options);
        }
export type ProductionLeadTimesDropdownQueryHookResult = ReturnType<typeof useProductionLeadTimesDropdownQuery>;
export type ProductionLeadTimesDropdownLazyQueryHookResult = ReturnType<typeof useProductionLeadTimesDropdownLazyQuery>;
export type ProductionLeadTimesDropdownQueryResult = Apollo.QueryResult<ProductionLeadTimesDropdownQuery, ProductionLeadTimesDropdownQueryVariables>;
export function refetchProductionLeadTimesDropdownQuery(variables: ProductionLeadTimesDropdownQueryVariables) {
      return { query: ProductionLeadTimesDropdownDocument, variables: variables }
    }
export const CreateQuoteAttachmentRevisionFilesTabDocument = gql`
    mutation createQuoteAttachmentRevisionFilesTab($uploadMetadata: AttachmentInput!, $quoteId: UUID!, $quoteAttachmentId: UUID, $attachmentType: String, $productAttachmentId: String) {
  createQuoteAttachmentRevision(
    uploadMetadata: $uploadMetadata
    quoteId: $quoteId
    quoteAttachmentId: $quoteAttachmentId
    attachmentType: $attachmentType
    productAttachmentId: $productAttachmentId
  ) {
    id
    attachment {
      ... on Attachment {
        id
        fileName
        uploadUrl
      }
    }
    asset {
      id
      fileName
      uploadUrl
    }
  }
}
    `;
export type CreateQuoteAttachmentRevisionFilesTabMutationFn = Apollo.MutationFunction<CreateQuoteAttachmentRevisionFilesTabMutation, CreateQuoteAttachmentRevisionFilesTabMutationVariables>;

/**
 * __useCreateQuoteAttachmentRevisionFilesTabMutation__
 *
 * To run a mutation, you first call `useCreateQuoteAttachmentRevisionFilesTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuoteAttachmentRevisionFilesTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuoteAttachmentRevisionFilesTabMutation, { data, loading, error }] = useCreateQuoteAttachmentRevisionFilesTabMutation({
 *   variables: {
 *      uploadMetadata: // value for 'uploadMetadata'
 *      quoteId: // value for 'quoteId'
 *      quoteAttachmentId: // value for 'quoteAttachmentId'
 *      attachmentType: // value for 'attachmentType'
 *      productAttachmentId: // value for 'productAttachmentId'
 *   },
 * });
 */
export function useCreateQuoteAttachmentRevisionFilesTabMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuoteAttachmentRevisionFilesTabMutation, CreateQuoteAttachmentRevisionFilesTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuoteAttachmentRevisionFilesTabMutation, CreateQuoteAttachmentRevisionFilesTabMutationVariables>(CreateQuoteAttachmentRevisionFilesTabDocument, options);
      }
export type CreateQuoteAttachmentRevisionFilesTabMutationHookResult = ReturnType<typeof useCreateQuoteAttachmentRevisionFilesTabMutation>;
export type CreateQuoteAttachmentRevisionFilesTabMutationResult = Apollo.MutationResult<CreateQuoteAttachmentRevisionFilesTabMutation>;
export type CreateQuoteAttachmentRevisionFilesTabMutationOptions = Apollo.BaseMutationOptions<CreateQuoteAttachmentRevisionFilesTabMutation, CreateQuoteAttachmentRevisionFilesTabMutationVariables>;
export const CreateQuoteModelRevisionDocument = gql`
    mutation createQuoteModelRevision($uploadMetadata: QuoteModelRevisionUploadInput!, $quoteId: UUID!, $quoteModelId: UUID, $setAsSelectedForQuoteModel: Boolean!, $userId: Int) {
  createQuoteModelRevision(
    uploadMetadata: $uploadMetadata
    quoteId: $quoteId
    quoteModelId: $quoteModelId
    setAsSelectedForQuoteModel: $setAsSelectedForQuoteModel
    userId: $userId
  ) {
    id
    uploadUrl
    partRevision {
      id
      partId
      thumbnailUri
    }
  }
}
    `;
export type CreateQuoteModelRevisionMutationFn = Apollo.MutationFunction<CreateQuoteModelRevisionMutation, CreateQuoteModelRevisionMutationVariables>;

/**
 * __useCreateQuoteModelRevisionMutation__
 *
 * To run a mutation, you first call `useCreateQuoteModelRevisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuoteModelRevisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuoteModelRevisionMutation, { data, loading, error }] = useCreateQuoteModelRevisionMutation({
 *   variables: {
 *      uploadMetadata: // value for 'uploadMetadata'
 *      quoteId: // value for 'quoteId'
 *      quoteModelId: // value for 'quoteModelId'
 *      setAsSelectedForQuoteModel: // value for 'setAsSelectedForQuoteModel'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCreateQuoteModelRevisionMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuoteModelRevisionMutation, CreateQuoteModelRevisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuoteModelRevisionMutation, CreateQuoteModelRevisionMutationVariables>(CreateQuoteModelRevisionDocument, options);
      }
export type CreateQuoteModelRevisionMutationHookResult = ReturnType<typeof useCreateQuoteModelRevisionMutation>;
export type CreateQuoteModelRevisionMutationResult = Apollo.MutationResult<CreateQuoteModelRevisionMutation>;
export type CreateQuoteModelRevisionMutationOptions = Apollo.BaseMutationOptions<CreateQuoteModelRevisionMutation, CreateQuoteModelRevisionMutationVariables>;
export const DestroyQuoteModelDocument = gql`
    mutation destroyQuoteModel($id: UUID!) {
  destroyQuoteModel(id: $id) {
    id
  }
}
    `;
export type DestroyQuoteModelMutationFn = Apollo.MutationFunction<DestroyQuoteModelMutation, DestroyQuoteModelMutationVariables>;

/**
 * __useDestroyQuoteModelMutation__
 *
 * To run a mutation, you first call `useDestroyQuoteModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyQuoteModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyQuoteModelMutation, { data, loading, error }] = useDestroyQuoteModelMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDestroyQuoteModelMutation(baseOptions?: Apollo.MutationHookOptions<DestroyQuoteModelMutation, DestroyQuoteModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroyQuoteModelMutation, DestroyQuoteModelMutationVariables>(DestroyQuoteModelDocument, options);
      }
export type DestroyQuoteModelMutationHookResult = ReturnType<typeof useDestroyQuoteModelMutation>;
export type DestroyQuoteModelMutationResult = Apollo.MutationResult<DestroyQuoteModelMutation>;
export type DestroyQuoteModelMutationOptions = Apollo.BaseMutationOptions<DestroyQuoteModelMutation, DestroyQuoteModelMutationVariables>;
export const DestroyQuoteModelsDocument = gql`
    mutation destroyQuoteModels($ids: [UUID!]!) {
  destroyQuoteModels(ids: $ids) {
    id
  }
}
    `;
export type DestroyQuoteModelsMutationFn = Apollo.MutationFunction<DestroyQuoteModelsMutation, DestroyQuoteModelsMutationVariables>;

/**
 * __useDestroyQuoteModelsMutation__
 *
 * To run a mutation, you first call `useDestroyQuoteModelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyQuoteModelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyQuoteModelsMutation, { data, loading, error }] = useDestroyQuoteModelsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDestroyQuoteModelsMutation(baseOptions?: Apollo.MutationHookOptions<DestroyQuoteModelsMutation, DestroyQuoteModelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroyQuoteModelsMutation, DestroyQuoteModelsMutationVariables>(DestroyQuoteModelsDocument, options);
      }
export type DestroyQuoteModelsMutationHookResult = ReturnType<typeof useDestroyQuoteModelsMutation>;
export type DestroyQuoteModelsMutationResult = Apollo.MutationResult<DestroyQuoteModelsMutation>;
export type DestroyQuoteModelsMutationOptions = Apollo.BaseMutationOptions<DestroyQuoteModelsMutation, DestroyQuoteModelsMutationVariables>;
export const FilesTabFinalizeUploadAndProcessPartDocument = gql`
    mutation filesTabFinalizeUploadAndProcessPart($partId: Int!) {
  finalizeUploadAndProcessPart(partId: $partId) {
    partId
    status
    reason
  }
}
    `;
export type FilesTabFinalizeUploadAndProcessPartMutationFn = Apollo.MutationFunction<FilesTabFinalizeUploadAndProcessPartMutation, FilesTabFinalizeUploadAndProcessPartMutationVariables>;

/**
 * __useFilesTabFinalizeUploadAndProcessPartMutation__
 *
 * To run a mutation, you first call `useFilesTabFinalizeUploadAndProcessPartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFilesTabFinalizeUploadAndProcessPartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [filesTabFinalizeUploadAndProcessPartMutation, { data, loading, error }] = useFilesTabFinalizeUploadAndProcessPartMutation({
 *   variables: {
 *      partId: // value for 'partId'
 *   },
 * });
 */
export function useFilesTabFinalizeUploadAndProcessPartMutation(baseOptions?: Apollo.MutationHookOptions<FilesTabFinalizeUploadAndProcessPartMutation, FilesTabFinalizeUploadAndProcessPartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FilesTabFinalizeUploadAndProcessPartMutation, FilesTabFinalizeUploadAndProcessPartMutationVariables>(FilesTabFinalizeUploadAndProcessPartDocument, options);
      }
export type FilesTabFinalizeUploadAndProcessPartMutationHookResult = ReturnType<typeof useFilesTabFinalizeUploadAndProcessPartMutation>;
export type FilesTabFinalizeUploadAndProcessPartMutationResult = Apollo.MutationResult<FilesTabFinalizeUploadAndProcessPartMutation>;
export type FilesTabFinalizeUploadAndProcessPartMutationOptions = Apollo.BaseMutationOptions<FilesTabFinalizeUploadAndProcessPartMutation, FilesTabFinalizeUploadAndProcessPartMutationVariables>;
export const MarkQuoteAttachmentRevisionUploadedFilesTabDocument = gql`
    mutation markQuoteAttachmentRevisionUploadedFilesTab($id: UUID!) {
  markQuoteAttachmentRevisionUploaded(id: $id) {
    id
    attachment {
      ... on Attachment {
        id
        fileName
        downloadUrl
      }
    }
  }
}
    `;
export type MarkQuoteAttachmentRevisionUploadedFilesTabMutationFn = Apollo.MutationFunction<MarkQuoteAttachmentRevisionUploadedFilesTabMutation, MarkQuoteAttachmentRevisionUploadedFilesTabMutationVariables>;

/**
 * __useMarkQuoteAttachmentRevisionUploadedFilesTabMutation__
 *
 * To run a mutation, you first call `useMarkQuoteAttachmentRevisionUploadedFilesTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkQuoteAttachmentRevisionUploadedFilesTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markQuoteAttachmentRevisionUploadedFilesTabMutation, { data, loading, error }] = useMarkQuoteAttachmentRevisionUploadedFilesTabMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkQuoteAttachmentRevisionUploadedFilesTabMutation(baseOptions?: Apollo.MutationHookOptions<MarkQuoteAttachmentRevisionUploadedFilesTabMutation, MarkQuoteAttachmentRevisionUploadedFilesTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkQuoteAttachmentRevisionUploadedFilesTabMutation, MarkQuoteAttachmentRevisionUploadedFilesTabMutationVariables>(MarkQuoteAttachmentRevisionUploadedFilesTabDocument, options);
      }
export type MarkQuoteAttachmentRevisionUploadedFilesTabMutationHookResult = ReturnType<typeof useMarkQuoteAttachmentRevisionUploadedFilesTabMutation>;
export type MarkQuoteAttachmentRevisionUploadedFilesTabMutationResult = Apollo.MutationResult<MarkQuoteAttachmentRevisionUploadedFilesTabMutation>;
export type MarkQuoteAttachmentRevisionUploadedFilesTabMutationOptions = Apollo.BaseMutationOptions<MarkQuoteAttachmentRevisionUploadedFilesTabMutation, MarkQuoteAttachmentRevisionUploadedFilesTabMutationVariables>;
export const RemoveQuoteAttachmentFilesTabDocument = gql`
    mutation removeQuoteAttachmentFilesTab($quoteId: UUID!, $attachmentId: UUID!) {
  removeQuoteAttachment(quoteId: $quoteId, attachmentId: $attachmentId) {
    id
  }
}
    `;
export type RemoveQuoteAttachmentFilesTabMutationFn = Apollo.MutationFunction<RemoveQuoteAttachmentFilesTabMutation, RemoveQuoteAttachmentFilesTabMutationVariables>;

/**
 * __useRemoveQuoteAttachmentFilesTabMutation__
 *
 * To run a mutation, you first call `useRemoveQuoteAttachmentFilesTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveQuoteAttachmentFilesTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeQuoteAttachmentFilesTabMutation, { data, loading, error }] = useRemoveQuoteAttachmentFilesTabMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useRemoveQuoteAttachmentFilesTabMutation(baseOptions?: Apollo.MutationHookOptions<RemoveQuoteAttachmentFilesTabMutation, RemoveQuoteAttachmentFilesTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveQuoteAttachmentFilesTabMutation, RemoveQuoteAttachmentFilesTabMutationVariables>(RemoveQuoteAttachmentFilesTabDocument, options);
      }
export type RemoveQuoteAttachmentFilesTabMutationHookResult = ReturnType<typeof useRemoveQuoteAttachmentFilesTabMutation>;
export type RemoveQuoteAttachmentFilesTabMutationResult = Apollo.MutationResult<RemoveQuoteAttachmentFilesTabMutation>;
export type RemoveQuoteAttachmentFilesTabMutationOptions = Apollo.BaseMutationOptions<RemoveQuoteAttachmentFilesTabMutation, RemoveQuoteAttachmentFilesTabMutationVariables>;
export const UserEnteredMaterialsDocument = gql`
    query userEnteredMaterials {
  me {
    id
    userEnteredMaterials {
      id
      name
      process {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useUserEnteredMaterialsQuery__
 *
 * To run a query within a React component, call `useUserEnteredMaterialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserEnteredMaterialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserEnteredMaterialsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserEnteredMaterialsQuery(baseOptions?: Apollo.QueryHookOptions<UserEnteredMaterialsQuery, UserEnteredMaterialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserEnteredMaterialsQuery, UserEnteredMaterialsQueryVariables>(UserEnteredMaterialsDocument, options);
      }
export function useUserEnteredMaterialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserEnteredMaterialsQuery, UserEnteredMaterialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserEnteredMaterialsQuery, UserEnteredMaterialsQueryVariables>(UserEnteredMaterialsDocument, options);
        }
export type UserEnteredMaterialsQueryHookResult = ReturnType<typeof useUserEnteredMaterialsQuery>;
export type UserEnteredMaterialsLazyQueryHookResult = ReturnType<typeof useUserEnteredMaterialsLazyQuery>;
export type UserEnteredMaterialsQueryResult = Apollo.QueryResult<UserEnteredMaterialsQuery, UserEnteredMaterialsQueryVariables>;
export function refetchUserEnteredMaterialsQuery(variables?: UserEnteredMaterialsQueryVariables) {
      return { query: UserEnteredMaterialsDocument, variables: variables }
    }
export const ProductionLocationOptionsDocument = gql`
    query productionLocationOptions {
  imQuotePreferences {
    label
    name
    value
  }
}
    `;

/**
 * __useProductionLocationOptionsQuery__
 *
 * To run a query within a React component, call `useProductionLocationOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductionLocationOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductionLocationOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductionLocationOptionsQuery(baseOptions?: Apollo.QueryHookOptions<ProductionLocationOptionsQuery, ProductionLocationOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductionLocationOptionsQuery, ProductionLocationOptionsQueryVariables>(ProductionLocationOptionsDocument, options);
      }
export function useProductionLocationOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductionLocationOptionsQuery, ProductionLocationOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductionLocationOptionsQuery, ProductionLocationOptionsQueryVariables>(ProductionLocationOptionsDocument, options);
        }
export type ProductionLocationOptionsQueryHookResult = ReturnType<typeof useProductionLocationOptionsQuery>;
export type ProductionLocationOptionsLazyQueryHookResult = ReturnType<typeof useProductionLocationOptionsLazyQuery>;
export type ProductionLocationOptionsQueryResult = Apollo.QueryResult<ProductionLocationOptionsQuery, ProductionLocationOptionsQueryVariables>;
export function refetchProductionLocationOptionsQuery(variables?: ProductionLocationOptionsQueryVariables) {
      return { query: ProductionLocationOptionsDocument, variables: variables }
    }
export const UpdateImQuoteRequirementsDocument = gql`
    mutation updateIMQuoteRequirements($quoteId: UUID!, $input: ImQuoteRequirementsInput!) {
  updateIMQuoteRequirements(quoteId: $quoteId, input: $input) {
    id
    imQuoteRequirements {
      deliveryDate
      developmentStage
      productionRateForecast {
        quantity
        timeScale
      }
      toolLife
      toolTypeNotes
      additionalRequirementNotes
    }
  }
}
    `;
export type UpdateImQuoteRequirementsMutationFn = Apollo.MutationFunction<UpdateImQuoteRequirementsMutation, UpdateImQuoteRequirementsMutationVariables>;

/**
 * __useUpdateImQuoteRequirementsMutation__
 *
 * To run a mutation, you first call `useUpdateImQuoteRequirementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImQuoteRequirementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImQuoteRequirementsMutation, { data, loading, error }] = useUpdateImQuoteRequirementsMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateImQuoteRequirementsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateImQuoteRequirementsMutation, UpdateImQuoteRequirementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateImQuoteRequirementsMutation, UpdateImQuoteRequirementsMutationVariables>(UpdateImQuoteRequirementsDocument, options);
      }
export type UpdateImQuoteRequirementsMutationHookResult = ReturnType<typeof useUpdateImQuoteRequirementsMutation>;
export type UpdateImQuoteRequirementsMutationResult = Apollo.MutationResult<UpdateImQuoteRequirementsMutation>;
export type UpdateImQuoteRequirementsMutationOptions = Apollo.BaseMutationOptions<UpdateImQuoteRequirementsMutation, UpdateImQuoteRequirementsMutationVariables>;
export const CostAndLeadTimeOptionsDocument = gql`
    query costAndLeadTimeOptions {
  imQuoteCostAndLeadTimePreferences {
    ...im_quote_cost_and_lead_time_preferences
  }
}
    ${Im_Quote_Cost_And_Lead_Time_PreferencesFragmentDoc}`;

/**
 * __useCostAndLeadTimeOptionsQuery__
 *
 * To run a query within a React component, call `useCostAndLeadTimeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCostAndLeadTimeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCostAndLeadTimeOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCostAndLeadTimeOptionsQuery(baseOptions?: Apollo.QueryHookOptions<CostAndLeadTimeOptionsQuery, CostAndLeadTimeOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CostAndLeadTimeOptionsQuery, CostAndLeadTimeOptionsQueryVariables>(CostAndLeadTimeOptionsDocument, options);
      }
export function useCostAndLeadTimeOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CostAndLeadTimeOptionsQuery, CostAndLeadTimeOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CostAndLeadTimeOptionsQuery, CostAndLeadTimeOptionsQueryVariables>(CostAndLeadTimeOptionsDocument, options);
        }
export type CostAndLeadTimeOptionsQueryHookResult = ReturnType<typeof useCostAndLeadTimeOptionsQuery>;
export type CostAndLeadTimeOptionsLazyQueryHookResult = ReturnType<typeof useCostAndLeadTimeOptionsLazyQuery>;
export type CostAndLeadTimeOptionsQueryResult = Apollo.QueryResult<CostAndLeadTimeOptionsQuery, CostAndLeadTimeOptionsQueryVariables>;
export function refetchCostAndLeadTimeOptionsQuery(variables?: CostAndLeadTimeOptionsQueryVariables) {
      return { query: CostAndLeadTimeOptionsDocument, variables: variables }
    }
export const QuoteImProjectRequirementsDocument = gql`
    query quoteImProjectRequirements($id: UUID!) {
  quote(id: $id) {
    id
    imQuoteRequirements {
      deliveryDate
      developmentStage
      preferences {
        ...QuoteImProjectRequirements_Quote_ImQuoteRequirements_Preferences
      }
      productionRateForecast {
        ...QuoteImProjectRequirements_Quote_ImQuoteRequirements_ProductionRateForecast
      }
      costAndLeadTimePreferences {
        ...QuoteImProjectRequirements_Quote_ImQuoteRequirements_Preferences
      }
      toolLife
      toolTypeNotes
      additionalRequirementNotes
    }
  }
}
    ${QuoteImProjectRequirements_Quote_ImQuoteRequirements_PreferencesFragmentDoc}
${QuoteImProjectRequirements_Quote_ImQuoteRequirements_ProductionRateForecastFragmentDoc}`;

/**
 * __useQuoteImProjectRequirementsQuery__
 *
 * To run a query within a React component, call `useQuoteImProjectRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteImProjectRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteImProjectRequirementsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuoteImProjectRequirementsQuery(baseOptions: Apollo.QueryHookOptions<QuoteImProjectRequirementsQuery, QuoteImProjectRequirementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteImProjectRequirementsQuery, QuoteImProjectRequirementsQueryVariables>(QuoteImProjectRequirementsDocument, options);
      }
export function useQuoteImProjectRequirementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteImProjectRequirementsQuery, QuoteImProjectRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteImProjectRequirementsQuery, QuoteImProjectRequirementsQueryVariables>(QuoteImProjectRequirementsDocument, options);
        }
export type QuoteImProjectRequirementsQueryHookResult = ReturnType<typeof useQuoteImProjectRequirementsQuery>;
export type QuoteImProjectRequirementsLazyQueryHookResult = ReturnType<typeof useQuoteImProjectRequirementsLazyQuery>;
export type QuoteImProjectRequirementsQueryResult = Apollo.QueryResult<QuoteImProjectRequirementsQuery, QuoteImProjectRequirementsQueryVariables>;
export function refetchQuoteImProjectRequirementsQuery(variables: QuoteImProjectRequirementsQueryVariables) {
      return { query: QuoteImProjectRequirementsDocument, variables: variables }
    }
export const QuoteModelRevisionReorderViewerDocument = gql`
    query quoteModelRevisionReorderViewer($id: UUID!) {
  quoteModelRevision(id: $id) {
    id
    quoteModel {
      id
      quote {
        id
      }
    }
    holes {
      id
      groupKey
      patches {
        id
      }
      type
      depth
      diameter
      isBlind
      tipAngle
      counterboreDepth
      counterboreDiameter
      countersinkAngle
      countersinkDepth
      countersinkDiameter
      direction
      endPoint
      startPoint
      tapOptions {
        id
        maxDepth
        commonName
      }
      tapAnnotation {
        id
        depth
        tapOption {
          id
          maxDepth
          commonName
        }
      }
    }
    dfmFeedback {
      id
      severity
      message
      title
      link
      accepted
      modelViewerSnapshots {
        id
        position
        target
        feature
        type
        snapshot {
          camera {
            zoom
            position
            up
            target
          }
          dfm {
            feature
            threshold
            direction
          }
          annotations {
            position
          }
          rotation
          part {
            transparent
            patches {
              color
              hashcode
            }
          }
          crossSection {
            position
            rotation
          }
          pointToPoint {
            customPoints
            selectedPoints {
              index
              type
            }
          }
        }
        createdAt
        updatedAt
        deletedAt
      }
    }
    partRevision {
      id
      analysisErrorCode
      downloadUri
      version
      modelFileName
      status
      thumbnailUri
      sceneBundle
      scene {
        featureMapping {
          url
        }
        geometry {
          url
        }
      }
      updatedAt
      boundingBox {
        x
        y
        z
      }
    }
  }
}
    `;

/**
 * __useQuoteModelRevisionReorderViewerQuery__
 *
 * To run a query within a React component, call `useQuoteModelRevisionReorderViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteModelRevisionReorderViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteModelRevisionReorderViewerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuoteModelRevisionReorderViewerQuery(baseOptions: Apollo.QueryHookOptions<QuoteModelRevisionReorderViewerQuery, QuoteModelRevisionReorderViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteModelRevisionReorderViewerQuery, QuoteModelRevisionReorderViewerQueryVariables>(QuoteModelRevisionReorderViewerDocument, options);
      }
export function useQuoteModelRevisionReorderViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteModelRevisionReorderViewerQuery, QuoteModelRevisionReorderViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteModelRevisionReorderViewerQuery, QuoteModelRevisionReorderViewerQueryVariables>(QuoteModelRevisionReorderViewerDocument, options);
        }
export type QuoteModelRevisionReorderViewerQueryHookResult = ReturnType<typeof useQuoteModelRevisionReorderViewerQuery>;
export type QuoteModelRevisionReorderViewerLazyQueryHookResult = ReturnType<typeof useQuoteModelRevisionReorderViewerLazyQuery>;
export type QuoteModelRevisionReorderViewerQueryResult = Apollo.QueryResult<QuoteModelRevisionReorderViewerQuery, QuoteModelRevisionReorderViewerQueryVariables>;
export function refetchQuoteModelRevisionReorderViewerQuery(variables: QuoteModelRevisionReorderViewerQueryVariables) {
      return { query: QuoteModelRevisionReorderViewerDocument, variables: variables }
    }
export const CreateOdooQuoteDocument = gql`
    mutation createOdooQuote($quoteId: UUID!, $moldToolRevisionIds: [String]) {
  createOdooQuote(quoteId: $quoteId, moldToolRevisionIds: $moldToolRevisionIds) {
    id
    status
  }
}
    `;
export type CreateOdooQuoteMutationFn = Apollo.MutationFunction<CreateOdooQuoteMutation, CreateOdooQuoteMutationVariables>;

/**
 * __useCreateOdooQuoteMutation__
 *
 * To run a mutation, you first call `useCreateOdooQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOdooQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOdooQuoteMutation, { data, loading, error }] = useCreateOdooQuoteMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      moldToolRevisionIds: // value for 'moldToolRevisionIds'
 *   },
 * });
 */
export function useCreateOdooQuoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateOdooQuoteMutation, CreateOdooQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOdooQuoteMutation, CreateOdooQuoteMutationVariables>(CreateOdooQuoteDocument, options);
      }
export type CreateOdooQuoteMutationHookResult = ReturnType<typeof useCreateOdooQuoteMutation>;
export type CreateOdooQuoteMutationResult = Apollo.MutationResult<CreateOdooQuoteMutation>;
export type CreateOdooQuoteMutationOptions = Apollo.BaseMutationOptions<CreateOdooQuoteMutation, CreateOdooQuoteMutationVariables>;
export const UpdateQuoteDocument = gql`
    mutation updateQuote($id: UUID!, $name: String!) {
  updateQuote(id: $id, input: {name: $name}) {
    id
    name
  }
}
    `;
export type UpdateQuoteMutationFn = Apollo.MutationFunction<UpdateQuoteMutation, UpdateQuoteMutationVariables>;

/**
 * __useUpdateQuoteMutation__
 *
 * To run a mutation, you first call `useUpdateQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuoteMutation, { data, loading, error }] = useUpdateQuoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateQuoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuoteMutation, UpdateQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuoteMutation, UpdateQuoteMutationVariables>(UpdateQuoteDocument, options);
      }
export type UpdateQuoteMutationHookResult = ReturnType<typeof useUpdateQuoteMutation>;
export type UpdateQuoteMutationResult = Apollo.MutationResult<UpdateQuoteMutation>;
export type UpdateQuoteMutationOptions = Apollo.BaseMutationOptions<UpdateQuoteMutation, UpdateQuoteMutationVariables>;
export const UpdateFpqDesignationDocument = gql`
    mutation updateFPQDesignation($quoteId: UUID!, $isFpq: Boolean!) {
  updateFPQDesignation(quoteId: $quoteId, isFPQ: $isFpq) {
    isFlexiblePriceQuote
  }
}
    `;
export type UpdateFpqDesignationMutationFn = Apollo.MutationFunction<UpdateFpqDesignationMutation, UpdateFpqDesignationMutationVariables>;

/**
 * __useUpdateFpqDesignationMutation__
 *
 * To run a mutation, you first call `useUpdateFpqDesignationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFpqDesignationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFpqDesignationMutation, { data, loading, error }] = useUpdateFpqDesignationMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      isFpq: // value for 'isFpq'
 *   },
 * });
 */
export function useUpdateFpqDesignationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFpqDesignationMutation, UpdateFpqDesignationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFpqDesignationMutation, UpdateFpqDesignationMutationVariables>(UpdateFpqDesignationDocument, options);
      }
export type UpdateFpqDesignationMutationHookResult = ReturnType<typeof useUpdateFpqDesignationMutation>;
export type UpdateFpqDesignationMutationResult = Apollo.MutationResult<UpdateFpqDesignationMutation>;
export type UpdateFpqDesignationMutationOptions = Apollo.BaseMutationOptions<UpdateFpqDesignationMutation, UpdateFpqDesignationMutationVariables>;
export const GetQuoteIdFromQmrIdDocument = gql`
    query getQuoteIdFromQmrId($id: UUID!) {
  quoteModelRevision(id: $id) {
    quoteModel {
      id
      quote {
        id
        project {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetQuoteIdFromQmrIdQuery__
 *
 * To run a query within a React component, call `useGetQuoteIdFromQmrIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteIdFromQmrIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteIdFromQmrIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetQuoteIdFromQmrIdQuery(baseOptions: Apollo.QueryHookOptions<GetQuoteIdFromQmrIdQuery, GetQuoteIdFromQmrIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuoteIdFromQmrIdQuery, GetQuoteIdFromQmrIdQueryVariables>(GetQuoteIdFromQmrIdDocument, options);
      }
export function useGetQuoteIdFromQmrIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuoteIdFromQmrIdQuery, GetQuoteIdFromQmrIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuoteIdFromQmrIdQuery, GetQuoteIdFromQmrIdQueryVariables>(GetQuoteIdFromQmrIdDocument, options);
        }
export type GetQuoteIdFromQmrIdQueryHookResult = ReturnType<typeof useGetQuoteIdFromQmrIdQuery>;
export type GetQuoteIdFromQmrIdLazyQueryHookResult = ReturnType<typeof useGetQuoteIdFromQmrIdLazyQuery>;
export type GetQuoteIdFromQmrIdQueryResult = Apollo.QueryResult<GetQuoteIdFromQmrIdQuery, GetQuoteIdFromQmrIdQueryVariables>;
export function refetchGetQuoteIdFromQmrIdQuery(variables: GetQuoteIdFromQmrIdQueryVariables) {
      return { query: GetQuoteIdFromQmrIdDocument, variables: variables }
    }
export const QmrDfmFeedbackDocument = gql`
    query qmrDfmFeedback($id: UUID!) {
  quoteModelRevision(id: $id) {
    ...QmrDfmFeedback_QuoteModelRevision
  }
}
    ${QmrDfmFeedback_QuoteModelRevisionFragmentDoc}`;

/**
 * __useQmrDfmFeedbackQuery__
 *
 * To run a query within a React component, call `useQmrDfmFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useQmrDfmFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQmrDfmFeedbackQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQmrDfmFeedbackQuery(baseOptions: Apollo.QueryHookOptions<QmrDfmFeedbackQuery, QmrDfmFeedbackQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QmrDfmFeedbackQuery, QmrDfmFeedbackQueryVariables>(QmrDfmFeedbackDocument, options);
      }
export function useQmrDfmFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QmrDfmFeedbackQuery, QmrDfmFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QmrDfmFeedbackQuery, QmrDfmFeedbackQueryVariables>(QmrDfmFeedbackDocument, options);
        }
export type QmrDfmFeedbackQueryHookResult = ReturnType<typeof useQmrDfmFeedbackQuery>;
export type QmrDfmFeedbackLazyQueryHookResult = ReturnType<typeof useQmrDfmFeedbackLazyQuery>;
export type QmrDfmFeedbackQueryResult = Apollo.QueryResult<QmrDfmFeedbackQuery, QmrDfmFeedbackQueryVariables>;
export function refetchQmrDfmFeedbackQuery(variables: QmrDfmFeedbackQueryVariables) {
      return { query: QmrDfmFeedbackDocument, variables: variables }
    }
export const QuoteDetailsDocument = gql`
    query quoteDetails($id: UUID!, $isImMaafcoEnabled: Boolean = false) {
  quote(id: $id) {
    ...QuoteDetails_Quote
  }
}
    ${QuoteDetails_QuoteFragmentDoc}`;

/**
 * __useQuoteDetailsQuery__
 *
 * To run a query within a React component, call `useQuoteDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      isImMaafcoEnabled: // value for 'isImMaafcoEnabled'
 *   },
 * });
 */
export function useQuoteDetailsQuery(baseOptions: Apollo.QueryHookOptions<QuoteDetailsQuery, QuoteDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteDetailsQuery, QuoteDetailsQueryVariables>(QuoteDetailsDocument, options);
      }
export function useQuoteDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteDetailsQuery, QuoteDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteDetailsQuery, QuoteDetailsQueryVariables>(QuoteDetailsDocument, options);
        }
export type QuoteDetailsQueryHookResult = ReturnType<typeof useQuoteDetailsQuery>;
export type QuoteDetailsLazyQueryHookResult = ReturnType<typeof useQuoteDetailsLazyQuery>;
export type QuoteDetailsQueryResult = Apollo.QueryResult<QuoteDetailsQuery, QuoteDetailsQueryVariables>;
export function refetchQuoteDetailsQuery(variables: QuoteDetailsQueryVariables) {
      return { query: QuoteDetailsDocument, variables: variables }
    }
export const QuoteShipStatusDocument = gql`
    query quoteShipStatus($id: UUID!) {
  quote(id: $id) {
    id
    isQuotePurchasable
    earliestValidUntilDate
    slowestShipDateEstimate
  }
}
    `;

/**
 * __useQuoteShipStatusQuery__
 *
 * To run a query within a React component, call `useQuoteShipStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteShipStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteShipStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuoteShipStatusQuery(baseOptions: Apollo.QueryHookOptions<QuoteShipStatusQuery, QuoteShipStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteShipStatusQuery, QuoteShipStatusQueryVariables>(QuoteShipStatusDocument, options);
      }
export function useQuoteShipStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteShipStatusQuery, QuoteShipStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteShipStatusQuery, QuoteShipStatusQueryVariables>(QuoteShipStatusDocument, options);
        }
export type QuoteShipStatusQueryHookResult = ReturnType<typeof useQuoteShipStatusQuery>;
export type QuoteShipStatusLazyQueryHookResult = ReturnType<typeof useQuoteShipStatusLazyQuery>;
export type QuoteShipStatusQueryResult = Apollo.QueryResult<QuoteShipStatusQuery, QuoteShipStatusQueryVariables>;
export function refetchQuoteShipStatusQuery(variables: QuoteShipStatusQueryVariables) {
      return { query: QuoteShipStatusDocument, variables: variables }
    }
export const CreateOpenInviteOnQuoteDocument = gql`
    mutation createOpenInviteOnQuote($id: UUID!, $senderId: Int) {
  createOpenInviteOnQuote(quoteId: $id, senderId: $senderId) {
    id
    openEndedInviteUrl(senderId: $senderId)
  }
}
    `;
export type CreateOpenInviteOnQuoteMutationFn = Apollo.MutationFunction<CreateOpenInviteOnQuoteMutation, CreateOpenInviteOnQuoteMutationVariables>;

/**
 * __useCreateOpenInviteOnQuoteMutation__
 *
 * To run a mutation, you first call `useCreateOpenInviteOnQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOpenInviteOnQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOpenInviteOnQuoteMutation, { data, loading, error }] = useCreateOpenInviteOnQuoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      senderId: // value for 'senderId'
 *   },
 * });
 */
export function useCreateOpenInviteOnQuoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateOpenInviteOnQuoteMutation, CreateOpenInviteOnQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOpenInviteOnQuoteMutation, CreateOpenInviteOnQuoteMutationVariables>(CreateOpenInviteOnQuoteDocument, options);
      }
export type CreateOpenInviteOnQuoteMutationHookResult = ReturnType<typeof useCreateOpenInviteOnQuoteMutation>;
export type CreateOpenInviteOnQuoteMutationResult = Apollo.MutationResult<CreateOpenInviteOnQuoteMutation>;
export type CreateOpenInviteOnQuoteMutationOptions = Apollo.BaseMutationOptions<CreateOpenInviteOnQuoteMutation, CreateOpenInviteOnQuoteMutationVariables>;
export const SubmitQuoteChangeRequestDocument = gql`
    mutation SubmitQuoteChangeRequest($submitQuoteChangeRequestId: UUID!, $changeRequestInput: ChangeRequestInput!) {
  submitQuoteChangeRequest(
    id: $submitQuoteChangeRequestId
    ChangeRequestInput: $changeRequestInput
  ) {
    id
    isLocked
  }
}
    `;
export type SubmitQuoteChangeRequestMutationFn = Apollo.MutationFunction<SubmitQuoteChangeRequestMutation, SubmitQuoteChangeRequestMutationVariables>;

/**
 * __useSubmitQuoteChangeRequestMutation__
 *
 * To run a mutation, you first call `useSubmitQuoteChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitQuoteChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitQuoteChangeRequestMutation, { data, loading, error }] = useSubmitQuoteChangeRequestMutation({
 *   variables: {
 *      submitQuoteChangeRequestId: // value for 'submitQuoteChangeRequestId'
 *      changeRequestInput: // value for 'changeRequestInput'
 *   },
 * });
 */
export function useSubmitQuoteChangeRequestMutation(baseOptions?: Apollo.MutationHookOptions<SubmitQuoteChangeRequestMutation, SubmitQuoteChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitQuoteChangeRequestMutation, SubmitQuoteChangeRequestMutationVariables>(SubmitQuoteChangeRequestDocument, options);
      }
export type SubmitQuoteChangeRequestMutationHookResult = ReturnType<typeof useSubmitQuoteChangeRequestMutation>;
export type SubmitQuoteChangeRequestMutationResult = Apollo.MutationResult<SubmitQuoteChangeRequestMutation>;
export type SubmitQuoteChangeRequestMutationOptions = Apollo.BaseMutationOptions<SubmitQuoteChangeRequestMutation, SubmitQuoteChangeRequestMutationVariables>;
export const QuoteModelHistoryDocument = gql`
    query quoteModelHistory($id: UUID!) {
  quoteModelRevision(id: $id) {
    id
    fileName
    modelConfiguration {
      process {
        platformProcessTypeId
        name
        id
      }
    }
    partRevision {
      id
      analysisErrorCode
      downloadUri
      modelFileName
      status
      sceneBundle
      thumbnailUri
      updatedAt
      boundingBox {
        x
        y
        z
      }
    }
    quoteModel {
      id
      quote {
        id
        user {
          id
        }
        status
        type
        isQuoteIMReorder
        isLocked
      }
      selectedQuoteModelRevision {
        id
        fileName
        version
      }
      quoteModelRevisions {
        id
        fileName
        version
        createdAt
        updatedAt
        revisionNotes
        dfmReports {
          asset {
            id
            fileName
            downloadUrl
            createdAt
          }
          isPublished
          source
          uploaderEmail
        }
        dfmFeedback {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useQuoteModelHistoryQuery__
 *
 * To run a query within a React component, call `useQuoteModelHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteModelHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteModelHistoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuoteModelHistoryQuery(baseOptions: Apollo.QueryHookOptions<QuoteModelHistoryQuery, QuoteModelHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteModelHistoryQuery, QuoteModelHistoryQueryVariables>(QuoteModelHistoryDocument, options);
      }
export function useQuoteModelHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteModelHistoryQuery, QuoteModelHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteModelHistoryQuery, QuoteModelHistoryQueryVariables>(QuoteModelHistoryDocument, options);
        }
export type QuoteModelHistoryQueryHookResult = ReturnType<typeof useQuoteModelHistoryQuery>;
export type QuoteModelHistoryLazyQueryHookResult = ReturnType<typeof useQuoteModelHistoryLazyQuery>;
export type QuoteModelHistoryQueryResult = Apollo.QueryResult<QuoteModelHistoryQuery, QuoteModelHistoryQueryVariables>;
export function refetchQuoteModelHistoryQuery(variables: QuoteModelHistoryQueryVariables) {
      return { query: QuoteModelHistoryDocument, variables: variables }
    }
export const PunchoutSessionDocument = gql`
    query PunchoutSession($punchoutSessionId: UUID!) {
  punchoutSession(sessionId: $punchoutSessionId) {
    ...PunchoutSessionData
  }
}
    ${PunchoutSessionDataFragmentDoc}`;

/**
 * __usePunchoutSessionQuery__
 *
 * To run a query within a React component, call `usePunchoutSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePunchoutSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePunchoutSessionQuery({
 *   variables: {
 *      punchoutSessionId: // value for 'punchoutSessionId'
 *   },
 * });
 */
export function usePunchoutSessionQuery(baseOptions: Apollo.QueryHookOptions<PunchoutSessionQuery, PunchoutSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PunchoutSessionQuery, PunchoutSessionQueryVariables>(PunchoutSessionDocument, options);
      }
export function usePunchoutSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PunchoutSessionQuery, PunchoutSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PunchoutSessionQuery, PunchoutSessionQueryVariables>(PunchoutSessionDocument, options);
        }
export type PunchoutSessionQueryHookResult = ReturnType<typeof usePunchoutSessionQuery>;
export type PunchoutSessionLazyQueryHookResult = ReturnType<typeof usePunchoutSessionLazyQuery>;
export type PunchoutSessionQueryResult = Apollo.QueryResult<PunchoutSessionQuery, PunchoutSessionQueryVariables>;
export function refetchPunchoutSessionQuery(variables: PunchoutSessionQueryVariables) {
      return { query: PunchoutSessionDocument, variables: variables }
    }
export const QuotesTotalCountQuoteDropzonePageQueryDocument = gql`
    query quotesTotalCountQuoteDropzonePageQuery {
  me {
    id
    quotes {
      totalCount
    }
  }
}
    `;

/**
 * __useQuotesTotalCountQuoteDropzonePageQueryQuery__
 *
 * To run a query within a React component, call `useQuotesTotalCountQuoteDropzonePageQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuotesTotalCountQuoteDropzonePageQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuotesTotalCountQuoteDropzonePageQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useQuotesTotalCountQuoteDropzonePageQueryQuery(baseOptions?: Apollo.QueryHookOptions<QuotesTotalCountQuoteDropzonePageQueryQuery, QuotesTotalCountQuoteDropzonePageQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuotesTotalCountQuoteDropzonePageQueryQuery, QuotesTotalCountQuoteDropzonePageQueryQueryVariables>(QuotesTotalCountQuoteDropzonePageQueryDocument, options);
      }
export function useQuotesTotalCountQuoteDropzonePageQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuotesTotalCountQuoteDropzonePageQueryQuery, QuotesTotalCountQuoteDropzonePageQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuotesTotalCountQuoteDropzonePageQueryQuery, QuotesTotalCountQuoteDropzonePageQueryQueryVariables>(QuotesTotalCountQuoteDropzonePageQueryDocument, options);
        }
export type QuotesTotalCountQuoteDropzonePageQueryQueryHookResult = ReturnType<typeof useQuotesTotalCountQuoteDropzonePageQueryQuery>;
export type QuotesTotalCountQuoteDropzonePageQueryLazyQueryHookResult = ReturnType<typeof useQuotesTotalCountQuoteDropzonePageQueryLazyQuery>;
export type QuotesTotalCountQuoteDropzonePageQueryQueryResult = Apollo.QueryResult<QuotesTotalCountQuoteDropzonePageQueryQuery, QuotesTotalCountQuoteDropzonePageQueryQueryVariables>;
export function refetchQuotesTotalCountQuoteDropzonePageQueryQuery(variables?: QuotesTotalCountQuoteDropzonePageQueryQueryVariables) {
      return { query: QuotesTotalCountQuoteDropzonePageQueryDocument, variables: variables }
    }
export const ObouserQuotesTotalCountQuoteDropzonePageQueryDocument = gql`
    query obouserQuotesTotalCountQuoteDropzonePageQuery($userId: Int!) {
  user(id: $userId) {
    id
    quotes {
      totalCount
    }
  }
}
    `;

/**
 * __useObouserQuotesTotalCountQuoteDropzonePageQueryQuery__
 *
 * To run a query within a React component, call `useObouserQuotesTotalCountQuoteDropzonePageQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useObouserQuotesTotalCountQuoteDropzonePageQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObouserQuotesTotalCountQuoteDropzonePageQueryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useObouserQuotesTotalCountQuoteDropzonePageQueryQuery(baseOptions: Apollo.QueryHookOptions<ObouserQuotesTotalCountQuoteDropzonePageQueryQuery, ObouserQuotesTotalCountQuoteDropzonePageQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ObouserQuotesTotalCountQuoteDropzonePageQueryQuery, ObouserQuotesTotalCountQuoteDropzonePageQueryQueryVariables>(ObouserQuotesTotalCountQuoteDropzonePageQueryDocument, options);
      }
export function useObouserQuotesTotalCountQuoteDropzonePageQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ObouserQuotesTotalCountQuoteDropzonePageQueryQuery, ObouserQuotesTotalCountQuoteDropzonePageQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ObouserQuotesTotalCountQuoteDropzonePageQueryQuery, ObouserQuotesTotalCountQuoteDropzonePageQueryQueryVariables>(ObouserQuotesTotalCountQuoteDropzonePageQueryDocument, options);
        }
export type ObouserQuotesTotalCountQuoteDropzonePageQueryQueryHookResult = ReturnType<typeof useObouserQuotesTotalCountQuoteDropzonePageQueryQuery>;
export type ObouserQuotesTotalCountQuoteDropzonePageQueryLazyQueryHookResult = ReturnType<typeof useObouserQuotesTotalCountQuoteDropzonePageQueryLazyQuery>;
export type ObouserQuotesTotalCountQuoteDropzonePageQueryQueryResult = Apollo.QueryResult<ObouserQuotesTotalCountQuoteDropzonePageQueryQuery, ObouserQuotesTotalCountQuoteDropzonePageQueryQueryVariables>;
export function refetchObouserQuotesTotalCountQuoteDropzonePageQueryQuery(variables: ObouserQuotesTotalCountQuoteDropzonePageQueryQueryVariables) {
      return { query: ObouserQuotesTotalCountQuoteDropzonePageQueryDocument, variables: variables }
    }
export const IsUserPotentialNuaDocument = gql`
    query isUserPotentialNua($id: Int!) {
  user(id: $id) {
    id
    email
    isNUA
  }
}
    `;

/**
 * __useIsUserPotentialNuaQuery__
 *
 * To run a query within a React component, call `useIsUserPotentialNuaQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsUserPotentialNuaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsUserPotentialNuaQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIsUserPotentialNuaQuery(baseOptions: Apollo.QueryHookOptions<IsUserPotentialNuaQuery, IsUserPotentialNuaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsUserPotentialNuaQuery, IsUserPotentialNuaQueryVariables>(IsUserPotentialNuaDocument, options);
      }
export function useIsUserPotentialNuaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsUserPotentialNuaQuery, IsUserPotentialNuaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsUserPotentialNuaQuery, IsUserPotentialNuaQueryVariables>(IsUserPotentialNuaDocument, options);
        }
export type IsUserPotentialNuaQueryHookResult = ReturnType<typeof useIsUserPotentialNuaQuery>;
export type IsUserPotentialNuaLazyQueryHookResult = ReturnType<typeof useIsUserPotentialNuaLazyQuery>;
export type IsUserPotentialNuaQueryResult = Apollo.QueryResult<IsUserPotentialNuaQuery, IsUserPotentialNuaQueryVariables>;
export function refetchIsUserPotentialNuaQuery(variables: IsUserPotentialNuaQueryVariables) {
      return { query: IsUserPotentialNuaDocument, variables: variables }
    }
export const RequestOdooQuoteDocument = gql`
    mutation requestOdooQuote($quoteId: UUID!, $userId: Int, $isOdooRequest: Boolean) {
  requestOdooQuote(
    quoteId: $quoteId
    userId: $userId
    isOdooRequest: $isOdooRequest
  ) {
    id
    status
  }
}
    `;
export type RequestOdooQuoteMutationFn = Apollo.MutationFunction<RequestOdooQuoteMutation, RequestOdooQuoteMutationVariables>;

/**
 * __useRequestOdooQuoteMutation__
 *
 * To run a mutation, you first call `useRequestOdooQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestOdooQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestOdooQuoteMutation, { data, loading, error }] = useRequestOdooQuoteMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      userId: // value for 'userId'
 *      isOdooRequest: // value for 'isOdooRequest'
 *   },
 * });
 */
export function useRequestOdooQuoteMutation(baseOptions?: Apollo.MutationHookOptions<RequestOdooQuoteMutation, RequestOdooQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestOdooQuoteMutation, RequestOdooQuoteMutationVariables>(RequestOdooQuoteDocument, options);
      }
export type RequestOdooQuoteMutationHookResult = ReturnType<typeof useRequestOdooQuoteMutation>;
export type RequestOdooQuoteMutationResult = Apollo.MutationResult<RequestOdooQuoteMutation>;
export type RequestOdooQuoteMutationOptions = Apollo.BaseMutationOptions<RequestOdooQuoteMutation, RequestOdooQuoteMutationVariables>;
export const CreateQuoteDropzoneDocument = gql`
    mutation createQuoteDropzone($name: String, $description: String, $userId: Int, $quoteType: QuoteType, $teamId: Int, $processId: String) {
  createQuote(
    input: {name: $name, description: $description}
    userId: $userId
    type: $quoteType
    teamId: $teamId
    processId: $processId
  ) {
    id
    name
  }
}
    `;
export type CreateQuoteDropzoneMutationFn = Apollo.MutationFunction<CreateQuoteDropzoneMutation, CreateQuoteDropzoneMutationVariables>;

/**
 * __useCreateQuoteDropzoneMutation__
 *
 * To run a mutation, you first call `useCreateQuoteDropzoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuoteDropzoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuoteDropzoneMutation, { data, loading, error }] = useCreateQuoteDropzoneMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      userId: // value for 'userId'
 *      quoteType: // value for 'quoteType'
 *      teamId: // value for 'teamId'
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useCreateQuoteDropzoneMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuoteDropzoneMutation, CreateQuoteDropzoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuoteDropzoneMutation, CreateQuoteDropzoneMutationVariables>(CreateQuoteDropzoneDocument, options);
      }
export type CreateQuoteDropzoneMutationHookResult = ReturnType<typeof useCreateQuoteDropzoneMutation>;
export type CreateQuoteDropzoneMutationResult = Apollo.MutationResult<CreateQuoteDropzoneMutation>;
export type CreateQuoteDropzoneMutationOptions = Apollo.BaseMutationOptions<CreateQuoteDropzoneMutation, CreateQuoteDropzoneMutationVariables>;
export const CreateQmrDropzoneDocument = gql`
    mutation createQmrDropzone($uploadMetadata: QuoteModelRevisionUploadInput!, $quoteId: UUID!, $quoteModelId: UUID, $setAsSelectedForQuoteModel: Boolean!, $userId: Int) {
  createQuoteModelRevision(
    uploadMetadata: $uploadMetadata
    quoteId: $quoteId
    quoteModelId: $quoteModelId
    setAsSelectedForQuoteModel: $setAsSelectedForQuoteModel
    userId: $userId
  ) {
    id
    uploadUrl
    partRevision {
      id
      partId
      thumbnailUri
    }
  }
}
    `;
export type CreateQmrDropzoneMutationFn = Apollo.MutationFunction<CreateQmrDropzoneMutation, CreateQmrDropzoneMutationVariables>;

/**
 * __useCreateQmrDropzoneMutation__
 *
 * To run a mutation, you first call `useCreateQmrDropzoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQmrDropzoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQmrDropzoneMutation, { data, loading, error }] = useCreateQmrDropzoneMutation({
 *   variables: {
 *      uploadMetadata: // value for 'uploadMetadata'
 *      quoteId: // value for 'quoteId'
 *      quoteModelId: // value for 'quoteModelId'
 *      setAsSelectedForQuoteModel: // value for 'setAsSelectedForQuoteModel'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCreateQmrDropzoneMutation(baseOptions?: Apollo.MutationHookOptions<CreateQmrDropzoneMutation, CreateQmrDropzoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQmrDropzoneMutation, CreateQmrDropzoneMutationVariables>(CreateQmrDropzoneDocument, options);
      }
export type CreateQmrDropzoneMutationHookResult = ReturnType<typeof useCreateQmrDropzoneMutation>;
export type CreateQmrDropzoneMutationResult = Apollo.MutationResult<CreateQmrDropzoneMutation>;
export type CreateQmrDropzoneMutationOptions = Apollo.BaseMutationOptions<CreateQmrDropzoneMutation, CreateQmrDropzoneMutationVariables>;
export const CreateQuoteAttachmentRevisionDropzoneDocument = gql`
    mutation createQuoteAttachmentRevisionDropzone($uploadMetadata: AttachmentInput!, $quoteId: UUID!, $quoteAttachmentId: UUID, $attachmentType: String, $productAttachmentId: String) {
  createQuoteAttachmentRevision(
    uploadMetadata: $uploadMetadata
    quoteId: $quoteId
    quoteAttachmentId: $quoteAttachmentId
    attachmentType: $attachmentType
    productAttachmentId: $productAttachmentId
  ) {
    id
    attachment {
      ... on Attachment {
        id
        fileName
        uploadUrl
      }
    }
    asset {
      id
      fileName
      uploadUrl
    }
  }
}
    `;
export type CreateQuoteAttachmentRevisionDropzoneMutationFn = Apollo.MutationFunction<CreateQuoteAttachmentRevisionDropzoneMutation, CreateQuoteAttachmentRevisionDropzoneMutationVariables>;

/**
 * __useCreateQuoteAttachmentRevisionDropzoneMutation__
 *
 * To run a mutation, you first call `useCreateQuoteAttachmentRevisionDropzoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuoteAttachmentRevisionDropzoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuoteAttachmentRevisionDropzoneMutation, { data, loading, error }] = useCreateQuoteAttachmentRevisionDropzoneMutation({
 *   variables: {
 *      uploadMetadata: // value for 'uploadMetadata'
 *      quoteId: // value for 'quoteId'
 *      quoteAttachmentId: // value for 'quoteAttachmentId'
 *      attachmentType: // value for 'attachmentType'
 *      productAttachmentId: // value for 'productAttachmentId'
 *   },
 * });
 */
export function useCreateQuoteAttachmentRevisionDropzoneMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuoteAttachmentRevisionDropzoneMutation, CreateQuoteAttachmentRevisionDropzoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuoteAttachmentRevisionDropzoneMutation, CreateQuoteAttachmentRevisionDropzoneMutationVariables>(CreateQuoteAttachmentRevisionDropzoneDocument, options);
      }
export type CreateQuoteAttachmentRevisionDropzoneMutationHookResult = ReturnType<typeof useCreateQuoteAttachmentRevisionDropzoneMutation>;
export type CreateQuoteAttachmentRevisionDropzoneMutationResult = Apollo.MutationResult<CreateQuoteAttachmentRevisionDropzoneMutation>;
export type CreateQuoteAttachmentRevisionDropzoneMutationOptions = Apollo.BaseMutationOptions<CreateQuoteAttachmentRevisionDropzoneMutation, CreateQuoteAttachmentRevisionDropzoneMutationVariables>;
export const DropZoneFinalizeUploadAndProcessPartDocument = gql`
    mutation dropZoneFinalizeUploadAndProcessPart($partId: Int!) {
  finalizeUploadAndProcessPart(partId: $partId) {
    partId
    status
    reason
  }
}
    `;
export type DropZoneFinalizeUploadAndProcessPartMutationFn = Apollo.MutationFunction<DropZoneFinalizeUploadAndProcessPartMutation, DropZoneFinalizeUploadAndProcessPartMutationVariables>;

/**
 * __useDropZoneFinalizeUploadAndProcessPartMutation__
 *
 * To run a mutation, you first call `useDropZoneFinalizeUploadAndProcessPartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDropZoneFinalizeUploadAndProcessPartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dropZoneFinalizeUploadAndProcessPartMutation, { data, loading, error }] = useDropZoneFinalizeUploadAndProcessPartMutation({
 *   variables: {
 *      partId: // value for 'partId'
 *   },
 * });
 */
export function useDropZoneFinalizeUploadAndProcessPartMutation(baseOptions?: Apollo.MutationHookOptions<DropZoneFinalizeUploadAndProcessPartMutation, DropZoneFinalizeUploadAndProcessPartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DropZoneFinalizeUploadAndProcessPartMutation, DropZoneFinalizeUploadAndProcessPartMutationVariables>(DropZoneFinalizeUploadAndProcessPartDocument, options);
      }
export type DropZoneFinalizeUploadAndProcessPartMutationHookResult = ReturnType<typeof useDropZoneFinalizeUploadAndProcessPartMutation>;
export type DropZoneFinalizeUploadAndProcessPartMutationResult = Apollo.MutationResult<DropZoneFinalizeUploadAndProcessPartMutation>;
export type DropZoneFinalizeUploadAndProcessPartMutationOptions = Apollo.BaseMutationOptions<DropZoneFinalizeUploadAndProcessPartMutation, DropZoneFinalizeUploadAndProcessPartMutationVariables>;
export const MarkQuoteAttachmentRevisionUploadedDropzoneDocument = gql`
    mutation markQuoteAttachmentRevisionUploadedDropzone($id: UUID!) {
  markQuoteAttachmentRevisionUploaded(id: $id) {
    id
    attachment {
      ... on Attachment {
        id
        fileName
        downloadUrl
      }
    }
  }
}
    `;
export type MarkQuoteAttachmentRevisionUploadedDropzoneMutationFn = Apollo.MutationFunction<MarkQuoteAttachmentRevisionUploadedDropzoneMutation, MarkQuoteAttachmentRevisionUploadedDropzoneMutationVariables>;

/**
 * __useMarkQuoteAttachmentRevisionUploadedDropzoneMutation__
 *
 * To run a mutation, you first call `useMarkQuoteAttachmentRevisionUploadedDropzoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkQuoteAttachmentRevisionUploadedDropzoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markQuoteAttachmentRevisionUploadedDropzoneMutation, { data, loading, error }] = useMarkQuoteAttachmentRevisionUploadedDropzoneMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkQuoteAttachmentRevisionUploadedDropzoneMutation(baseOptions?: Apollo.MutationHookOptions<MarkQuoteAttachmentRevisionUploadedDropzoneMutation, MarkQuoteAttachmentRevisionUploadedDropzoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkQuoteAttachmentRevisionUploadedDropzoneMutation, MarkQuoteAttachmentRevisionUploadedDropzoneMutationVariables>(MarkQuoteAttachmentRevisionUploadedDropzoneDocument, options);
      }
export type MarkQuoteAttachmentRevisionUploadedDropzoneMutationHookResult = ReturnType<typeof useMarkQuoteAttachmentRevisionUploadedDropzoneMutation>;
export type MarkQuoteAttachmentRevisionUploadedDropzoneMutationResult = Apollo.MutationResult<MarkQuoteAttachmentRevisionUploadedDropzoneMutation>;
export type MarkQuoteAttachmentRevisionUploadedDropzoneMutationOptions = Apollo.BaseMutationOptions<MarkQuoteAttachmentRevisionUploadedDropzoneMutation, MarkQuoteAttachmentRevisionUploadedDropzoneMutationVariables>;
export const QuotesListDocument = gql`
    query quotesList($limit: Int!, $sort: CreatedAtSortKey, $offset: Int, $filter: QuoteAttributeFilterType, $isCpqFlagV2Enabled: Boolean = false) {
  me {
    id
    hasSecurePlusMemberships
    quotes(limit: $limit, sort: $sort, offset: $offset, filter: $filter) {
      totalCount
      items {
        ... on Quote {
          id
          name
          type
          status
          lastModified
          isEligibleForFreeShipping
          platformOrder {
            id
            name
            purchaserEmail
            purchasedDate
            purchaserUserId
          }
          subTotalInCents
          earliestValidUntilDate
          slowestShipDateEstimate
          isOverseasShipping
          isQuotePurchasable
          isLocked
          isCpqOwned
          isCpqQuote @include(if: $isCpqFlagV2Enabled)
          cpqQuote @include(if: $isCpqFlagV2Enabled) {
            sfdcId
            platformQuote {
              id
            }
            quotePdfUrl
            orderTotal
            partsCount
            moldCount
            orderQuantity
          }
          beganCheckoutAt
          isExpired
          expiration
          depositInCents
          productionPartsSubtotalInCents
          moldToolSubtotalInCents
          isQuoteInRfqState
          zipCode
          isTaxExempt
          partsSummary
          numberOfParts
          user {
            id
            email
          }
          team {
            id
            name
          }
          businessAccountDiscount {
            id
            percent
            isActive
            endAt
          }
          quoteAttachments {
            totalCount
            items {
              id
              latestAttachmentRevision {
                id
              }
            }
          }
          quoteModels(limit: 5) {
            totalCount
            items {
              id
              selectedQuoteModelRevision {
                id
                state
                fileName
                dfmFeedback {
                  id
                  accepted
                  severity
                }
                attachmentLink {
                  id
                  quoteAttachmentRevision {
                    id
                  }
                }
                processesDetails {
                  totalPrice {
                    ... on ExactPrice {
                      unitPriceInCents
                      priceInCents
                    }
                    ... on EstimatedPrice {
                      lowPriceInCents
                      lowUnitPriceInCents
                      highPriceInCents
                      highUnitPriceInCents
                    }
                  }
                }
                quantityRangeStatus
                modelConfiguration {
                  id
                  productionLeadTime {
                    productionDays
                  }
                  material {
                    ... on Material {
                      id
                      name
                    }
                    ... on UserEnteredMaterial {
                      id
                      name
                      process {
                        id
                        name
                      }
                    }
                  }
                  process {
                    id
                    name
                  }
                  color {
                    id
                    name
                  }
                  colorCode
                  quantity
                }
              }
            }
          }
          project {
            id
            name
            isSecurePlus
          }
        }
        ... on BasicQuote {
          id
          name
          project {
            isSecurePlus
            name
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useQuotesListQuery__
 *
 * To run a query within a React component, call `useQuotesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuotesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuotesListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *      isCpqFlagV2Enabled: // value for 'isCpqFlagV2Enabled'
 *   },
 * });
 */
export function useQuotesListQuery(baseOptions: Apollo.QueryHookOptions<QuotesListQuery, QuotesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuotesListQuery, QuotesListQueryVariables>(QuotesListDocument, options);
      }
export function useQuotesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuotesListQuery, QuotesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuotesListQuery, QuotesListQueryVariables>(QuotesListDocument, options);
        }
export type QuotesListQueryHookResult = ReturnType<typeof useQuotesListQuery>;
export type QuotesListLazyQueryHookResult = ReturnType<typeof useQuotesListLazyQuery>;
export type QuotesListQueryResult = Apollo.QueryResult<QuotesListQuery, QuotesListQueryVariables>;
export function refetchQuotesListQuery(variables: QuotesListQueryVariables) {
      return { query: QuotesListDocument, variables: variables }
    }
export const DestroyQuoteDocument = gql`
    mutation destroyQuote($id: UUID!) {
  destroyQuote(id: $id) {
    id
  }
}
    `;
export type DestroyQuoteMutationFn = Apollo.MutationFunction<DestroyQuoteMutation, DestroyQuoteMutationVariables>;

/**
 * __useDestroyQuoteMutation__
 *
 * To run a mutation, you first call `useDestroyQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyQuoteMutation, { data, loading, error }] = useDestroyQuoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDestroyQuoteMutation(baseOptions?: Apollo.MutationHookOptions<DestroyQuoteMutation, DestroyQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroyQuoteMutation, DestroyQuoteMutationVariables>(DestroyQuoteDocument, options);
      }
export type DestroyQuoteMutationHookResult = ReturnType<typeof useDestroyQuoteMutation>;
export type DestroyQuoteMutationResult = Apollo.MutationResult<DestroyQuoteMutation>;
export type DestroyQuoteMutationOptions = Apollo.BaseMutationOptions<DestroyQuoteMutation, DestroyQuoteMutationVariables>;
export const OrderActivityQueryDocument = gql`
    query orderActivityQuery($saleOrderId: Int, $limit: Int!, $offset: Int!) {
  orderActivity(saleOrderId: $saleOrderId, limit: $limit, offset: $offset) {
    totalCount
    items {
      ...OrderActivityItem
    }
  }
}
    ${OrderActivityItemFragmentDoc}`;

/**
 * __useOrderActivityQueryQuery__
 *
 * To run a query within a React component, call `useOrderActivityQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderActivityQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderActivityQueryQuery({
 *   variables: {
 *      saleOrderId: // value for 'saleOrderId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useOrderActivityQueryQuery(baseOptions: Apollo.QueryHookOptions<OrderActivityQueryQuery, OrderActivityQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderActivityQueryQuery, OrderActivityQueryQueryVariables>(OrderActivityQueryDocument, options);
      }
export function useOrderActivityQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderActivityQueryQuery, OrderActivityQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderActivityQueryQuery, OrderActivityQueryQueryVariables>(OrderActivityQueryDocument, options);
        }
export type OrderActivityQueryQueryHookResult = ReturnType<typeof useOrderActivityQueryQuery>;
export type OrderActivityQueryLazyQueryHookResult = ReturnType<typeof useOrderActivityQueryLazyQuery>;
export type OrderActivityQueryQueryResult = Apollo.QueryResult<OrderActivityQueryQuery, OrderActivityQueryQueryVariables>;
export function refetchOrderActivityQueryQuery(variables: OrderActivityQueryQueryVariables) {
      return { query: OrderActivityQueryDocument, variables: variables }
    }
export const QuoteActivityQueryDocument = gql`
    query quoteActivityQuery($quoteId: String, $limit: Int!, $offset: Int!, $showDetailedLogs: Boolean) {
  quoteActivity(
    quoteId: $quoteId
    limit: $limit
    offset: $offset
    showDetailedLogs: $showDetailedLogs
  ) {
    totalCount
    items {
      ...QuoteActivityItem
    }
  }
}
    ${QuoteActivityItemFragmentDoc}`;

/**
 * __useQuoteActivityQueryQuery__
 *
 * To run a query within a React component, call `useQuoteActivityQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteActivityQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteActivityQueryQuery({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      showDetailedLogs: // value for 'showDetailedLogs'
 *   },
 * });
 */
export function useQuoteActivityQueryQuery(baseOptions: Apollo.QueryHookOptions<QuoteActivityQueryQuery, QuoteActivityQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteActivityQueryQuery, QuoteActivityQueryQueryVariables>(QuoteActivityQueryDocument, options);
      }
export function useQuoteActivityQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteActivityQueryQuery, QuoteActivityQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteActivityQueryQuery, QuoteActivityQueryQueryVariables>(QuoteActivityQueryDocument, options);
        }
export type QuoteActivityQueryQueryHookResult = ReturnType<typeof useQuoteActivityQueryQuery>;
export type QuoteActivityQueryLazyQueryHookResult = ReturnType<typeof useQuoteActivityQueryLazyQuery>;
export type QuoteActivityQueryQueryResult = Apollo.QueryResult<QuoteActivityQueryQuery, QuoteActivityQueryQueryVariables>;
export function refetchQuoteActivityQueryQuery(variables: QuoteActivityQueryQueryVariables) {
      return { query: QuoteActivityQueryDocument, variables: variables }
    }
export const QuoteDetailsForInviteAndMemberDocument = gql`
    query quoteDetailsForInviteAndMember($id: UUID!, $senderId: Int) {
  quote(id: $id) {
    id
    openEndedQuoteInviteUrl(senderId: $senderId)
    isQuotePurchasable
    user {
      id
      email
      firstName
      lastName
      enabled
    }
    members {
      items {
        id
        role
        user {
          id
          displayName
          firstName
          lastName
          email
          enabled
        }
      }
    }
    team {
      id
      name
    }
    invites(limit: 100) {
      totalCount
      items {
        id
        status
        email
        isOpenEnded
        createdAt
        deletedAt
      }
    }
  }
}
    `;

/**
 * __useQuoteDetailsForInviteAndMemberQuery__
 *
 * To run a query within a React component, call `useQuoteDetailsForInviteAndMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteDetailsForInviteAndMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteDetailsForInviteAndMemberQuery({
 *   variables: {
 *      id: // value for 'id'
 *      senderId: // value for 'senderId'
 *   },
 * });
 */
export function useQuoteDetailsForInviteAndMemberQuery(baseOptions: Apollo.QueryHookOptions<QuoteDetailsForInviteAndMemberQuery, QuoteDetailsForInviteAndMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteDetailsForInviteAndMemberQuery, QuoteDetailsForInviteAndMemberQueryVariables>(QuoteDetailsForInviteAndMemberDocument, options);
      }
export function useQuoteDetailsForInviteAndMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteDetailsForInviteAndMemberQuery, QuoteDetailsForInviteAndMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteDetailsForInviteAndMemberQuery, QuoteDetailsForInviteAndMemberQueryVariables>(QuoteDetailsForInviteAndMemberDocument, options);
        }
export type QuoteDetailsForInviteAndMemberQueryHookResult = ReturnType<typeof useQuoteDetailsForInviteAndMemberQuery>;
export type QuoteDetailsForInviteAndMemberLazyQueryHookResult = ReturnType<typeof useQuoteDetailsForInviteAndMemberLazyQuery>;
export type QuoteDetailsForInviteAndMemberQueryResult = Apollo.QueryResult<QuoteDetailsForInviteAndMemberQuery, QuoteDetailsForInviteAndMemberQueryVariables>;
export function refetchQuoteDetailsForInviteAndMemberQuery(variables: QuoteDetailsForInviteAndMemberQueryVariables) {
      return { query: QuoteDetailsForInviteAndMemberDocument, variables: variables }
    }
export const RemoveQuoteTeamMembershipDocument = gql`
    mutation RemoveQuoteTeamMembership($quoteId: UUID!, $teamId: Int!, $userId: Int) {
  removeQuoteTeamMembership(quoteId: $quoteId, teamId: $teamId, userId: $userId) {
    id
  }
}
    `;
export type RemoveQuoteTeamMembershipMutationFn = Apollo.MutationFunction<RemoveQuoteTeamMembershipMutation, RemoveQuoteTeamMembershipMutationVariables>;

/**
 * __useRemoveQuoteTeamMembershipMutation__
 *
 * To run a mutation, you first call `useRemoveQuoteTeamMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveQuoteTeamMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeQuoteTeamMembershipMutation, { data, loading, error }] = useRemoveQuoteTeamMembershipMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      teamId: // value for 'teamId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveQuoteTeamMembershipMutation(baseOptions?: Apollo.MutationHookOptions<RemoveQuoteTeamMembershipMutation, RemoveQuoteTeamMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveQuoteTeamMembershipMutation, RemoveQuoteTeamMembershipMutationVariables>(RemoveQuoteTeamMembershipDocument, options);
      }
export type RemoveQuoteTeamMembershipMutationHookResult = ReturnType<typeof useRemoveQuoteTeamMembershipMutation>;
export type RemoveQuoteTeamMembershipMutationResult = Apollo.MutationResult<RemoveQuoteTeamMembershipMutation>;
export type RemoveQuoteTeamMembershipMutationOptions = Apollo.BaseMutationOptions<RemoveQuoteTeamMembershipMutation, RemoveQuoteTeamMembershipMutationVariables>;
export const AddTeamMembersDocument = gql`
    mutation addTeamMembers($members: [String]!, $teamId: Int!, $userId: Int!) {
  addTeamMembers(members: $members, teamId: $teamId, userId: $userId) {
    errors {
      email
      error
    }
    userTeamMemberships {
      id
    }
  }
}
    `;
export type AddTeamMembersMutationFn = Apollo.MutationFunction<AddTeamMembersMutation, AddTeamMembersMutationVariables>;

/**
 * __useAddTeamMembersMutation__
 *
 * To run a mutation, you first call `useAddTeamMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTeamMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTeamMembersMutation, { data, loading, error }] = useAddTeamMembersMutation({
 *   variables: {
 *      members: // value for 'members'
 *      teamId: // value for 'teamId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddTeamMembersMutation(baseOptions?: Apollo.MutationHookOptions<AddTeamMembersMutation, AddTeamMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTeamMembersMutation, AddTeamMembersMutationVariables>(AddTeamMembersDocument, options);
      }
export type AddTeamMembersMutationHookResult = ReturnType<typeof useAddTeamMembersMutation>;
export type AddTeamMembersMutationResult = Apollo.MutationResult<AddTeamMembersMutation>;
export type AddTeamMembersMutationOptions = Apollo.BaseMutationOptions<AddTeamMembersMutation, AddTeamMembersMutationVariables>;
export const RemoveTeamMemberDocument = gql`
    mutation removeTeamMember($email: String!, $teamId: Int!, $userId: Int!) {
  removeTeamMember(email: $email, teamId: $teamId, userId: $userId) {
    email
    removed
    failureReason
    __typename
  }
}
    `;
export type RemoveTeamMemberMutationFn = Apollo.MutationFunction<RemoveTeamMemberMutation, RemoveTeamMemberMutationVariables>;

/**
 * __useRemoveTeamMemberMutation__
 *
 * To run a mutation, you first call `useRemoveTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTeamMemberMutation, { data, loading, error }] = useRemoveTeamMemberMutation({
 *   variables: {
 *      email: // value for 'email'
 *      teamId: // value for 'teamId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTeamMemberMutation, RemoveTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTeamMemberMutation, RemoveTeamMemberMutationVariables>(RemoveTeamMemberDocument, options);
      }
export type RemoveTeamMemberMutationHookResult = ReturnType<typeof useRemoveTeamMemberMutation>;
export type RemoveTeamMemberMutationResult = Apollo.MutationResult<RemoveTeamMemberMutation>;
export type RemoveTeamMemberMutationOptions = Apollo.BaseMutationOptions<RemoveTeamMemberMutation, RemoveTeamMemberMutationVariables>;
export const UserBusinessAccountMembershipDateDocument = gql`
    query userBusinessAccountMembershipDate($id: Int!) {
  user(id: $id) {
    id
    businessAccountMembership {
      businessAccount {
        id
        name
        isEnabled
        isTeamsFeatureEnabled
        discount {
          isActive
        }
      }
      user {
        id
        enabled
      }
    }
  }
}
    `;

/**
 * __useUserBusinessAccountMembershipDateQuery__
 *
 * To run a query within a React component, call `useUserBusinessAccountMembershipDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserBusinessAccountMembershipDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserBusinessAccountMembershipDateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserBusinessAccountMembershipDateQuery(baseOptions: Apollo.QueryHookOptions<UserBusinessAccountMembershipDateQuery, UserBusinessAccountMembershipDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserBusinessAccountMembershipDateQuery, UserBusinessAccountMembershipDateQueryVariables>(UserBusinessAccountMembershipDateDocument, options);
      }
export function useUserBusinessAccountMembershipDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserBusinessAccountMembershipDateQuery, UserBusinessAccountMembershipDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserBusinessAccountMembershipDateQuery, UserBusinessAccountMembershipDateQueryVariables>(UserBusinessAccountMembershipDateDocument, options);
        }
export type UserBusinessAccountMembershipDateQueryHookResult = ReturnType<typeof useUserBusinessAccountMembershipDateQuery>;
export type UserBusinessAccountMembershipDateLazyQueryHookResult = ReturnType<typeof useUserBusinessAccountMembershipDateLazyQuery>;
export type UserBusinessAccountMembershipDateQueryResult = Apollo.QueryResult<UserBusinessAccountMembershipDateQuery, UserBusinessAccountMembershipDateQueryVariables>;
export function refetchUserBusinessAccountMembershipDateQuery(variables: UserBusinessAccountMembershipDateQueryVariables) {
      return { query: UserBusinessAccountMembershipDateDocument, variables: variables }
    }
export const TeamSpendByTimeDocument = gql`
    query teamSpendByTime($teamId: Int!, $userId: Int!, $dateRange: DateRangeInput!, $timezoneOffset: Int) {
  teamSpendByTime(
    teamId: $teamId
    dateRange: $dateRange
    timezoneOffset: $timezoneOffset
    userId: $userId
  ) {
    teamTotals {
      orders
      spend
      actualSavings
      potentialSavings
    }
    teamSpendByTime {
      ...TeamSpendByTimeItem
    }
  }
}
    ${TeamSpendByTimeItemFragmentDoc}`;

/**
 * __useTeamSpendByTimeQuery__
 *
 * To run a query within a React component, call `useTeamSpendByTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamSpendByTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamSpendByTimeQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      userId: // value for 'userId'
 *      dateRange: // value for 'dateRange'
 *      timezoneOffset: // value for 'timezoneOffset'
 *   },
 * });
 */
export function useTeamSpendByTimeQuery(baseOptions: Apollo.QueryHookOptions<TeamSpendByTimeQuery, TeamSpendByTimeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamSpendByTimeQuery, TeamSpendByTimeQueryVariables>(TeamSpendByTimeDocument, options);
      }
export function useTeamSpendByTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamSpendByTimeQuery, TeamSpendByTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamSpendByTimeQuery, TeamSpendByTimeQueryVariables>(TeamSpendByTimeDocument, options);
        }
export type TeamSpendByTimeQueryHookResult = ReturnType<typeof useTeamSpendByTimeQuery>;
export type TeamSpendByTimeLazyQueryHookResult = ReturnType<typeof useTeamSpendByTimeLazyQuery>;
export type TeamSpendByTimeQueryResult = Apollo.QueryResult<TeamSpendByTimeQuery, TeamSpendByTimeQueryVariables>;
export function refetchTeamSpendByTimeQuery(variables: TeamSpendByTimeQueryVariables) {
      return { query: TeamSpendByTimeDocument, variables: variables }
    }
export const TeamOrdersDocument = gql`
    query TeamOrders($teamId: Int!, $userId: Int, $filters: TeamQuoteAndOrderFilterInput, $limit: Int, $offset: Int, $sort: TeamQuotesAndOrdersSortInput) {
  teamOrders(
    teamId: $teamId
    userId: $userId
    filters: $filters
    limit: $limit
    offset: $offset
    sort: $sort
  ) {
    totalCount
    items {
      ... on SalesOrder {
        id
        name
        deliveryStatus
        orderDate
        createdAt
        fictivEstimatedDeliveryDate
        paymentDetails {
          paidBy {
            id
            email
          }
          paymentType
          purchaseOrderNumber
        }
        totalAmount
        salesOrderLines(limit: 4) {
          totalCount
          items {
            id
            revision {
              thumbnailUri
            }
          }
        }
        shipments {
          items {
            trackingData {
              estDeliveryDate
              trackingDetails {
                status
                datetime
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTeamOrdersQuery__
 *
 * To run a query within a React component, call `useTeamOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamOrdersQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      userId: // value for 'userId'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useTeamOrdersQuery(baseOptions: Apollo.QueryHookOptions<TeamOrdersQuery, TeamOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamOrdersQuery, TeamOrdersQueryVariables>(TeamOrdersDocument, options);
      }
export function useTeamOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamOrdersQuery, TeamOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamOrdersQuery, TeamOrdersQueryVariables>(TeamOrdersDocument, options);
        }
export type TeamOrdersQueryHookResult = ReturnType<typeof useTeamOrdersQuery>;
export type TeamOrdersLazyQueryHookResult = ReturnType<typeof useTeamOrdersLazyQuery>;
export type TeamOrdersQueryResult = Apollo.QueryResult<TeamOrdersQuery, TeamOrdersQueryVariables>;
export function refetchTeamOrdersQuery(variables: TeamOrdersQueryVariables) {
      return { query: TeamOrdersDocument, variables: variables }
    }
export const TeamQuotesDocument = gql`
    query TeamQuotes($teamId: Int!, $filters: TeamQuoteAndOrderFilterInput, $limit: Int, $offset: Int, $userId: Int) {
  teamQuotes(
    teamId: $teamId
    filters: $filters
    limit: $limit
    offset: $offset
    userId: $userId
  ) {
    items {
      id
      lastModified
      name
      createdAt
      user {
        email
        id
      }
      quoteModels(limit: 4) {
        totalCount
        items {
          id
          quoteModelRevisions {
            partRevision {
              thumbnailUri
            }
          }
        }
      }
      subTotalInCents
    }
    totalCount
  }
}
    `;

/**
 * __useTeamQuotesQuery__
 *
 * To run a query within a React component, call `useTeamQuotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamQuotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamQuotesQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useTeamQuotesQuery(baseOptions: Apollo.QueryHookOptions<TeamQuotesQuery, TeamQuotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamQuotesQuery, TeamQuotesQueryVariables>(TeamQuotesDocument, options);
      }
export function useTeamQuotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamQuotesQuery, TeamQuotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamQuotesQuery, TeamQuotesQueryVariables>(TeamQuotesDocument, options);
        }
export type TeamQuotesQueryHookResult = ReturnType<typeof useTeamQuotesQuery>;
export type TeamQuotesLazyQueryHookResult = ReturnType<typeof useTeamQuotesLazyQuery>;
export type TeamQuotesQueryResult = Apollo.QueryResult<TeamQuotesQuery, TeamQuotesQueryVariables>;
export function refetchTeamQuotesQuery(variables: TeamQuotesQueryVariables) {
      return { query: TeamQuotesDocument, variables: variables }
    }
export const TeamDocument = gql`
    query team($teamId: Int!, $userId: Int) {
  team(teamId: $teamId, userId: $userId) {
    id
    name
    businessAccountId
    totalMembers
    totalQuotes
    totalSalesOrders
    createdAt
    createdBy {
      id
      displayName
      email
      createdAt
      updatedAt
      enabled
    }
    updatedAt
    updatedBy {
      id
      displayName
      email
      createdAt
      updatedAt
      enabled
    }
    salesOrders {
      totalCount
    }
  }
}
    `;

/**
 * __useTeamQuery__
 *
 * To run a query within a React component, call `useTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useTeamQuery(baseOptions: Apollo.QueryHookOptions<TeamQuery, TeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamQuery, TeamQueryVariables>(TeamDocument, options);
      }
export function useTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamQuery, TeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamQuery, TeamQueryVariables>(TeamDocument, options);
        }
export type TeamQueryHookResult = ReturnType<typeof useTeamQuery>;
export type TeamLazyQueryHookResult = ReturnType<typeof useTeamLazyQuery>;
export type TeamQueryResult = Apollo.QueryResult<TeamQuery, TeamQueryVariables>;
export function refetchTeamQuery(variables: TeamQueryVariables) {
      return { query: TeamDocument, variables: variables }
    }
export const RequestTeamAccessDocument = gql`
    mutation requestTeamAccess($teamId: Int!, $userId: Int) {
  requestTeamAccess(teamId: $teamId, userId: $userId) {
    email
    userId
    teamId
    teamName
    businessAccountId
  }
}
    `;
export type RequestTeamAccessMutationFn = Apollo.MutationFunction<RequestTeamAccessMutation, RequestTeamAccessMutationVariables>;

/**
 * __useRequestTeamAccessMutation__
 *
 * To run a mutation, you first call `useRequestTeamAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestTeamAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestTeamAccessMutation, { data, loading, error }] = useRequestTeamAccessMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRequestTeamAccessMutation(baseOptions?: Apollo.MutationHookOptions<RequestTeamAccessMutation, RequestTeamAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestTeamAccessMutation, RequestTeamAccessMutationVariables>(RequestTeamAccessDocument, options);
      }
export type RequestTeamAccessMutationHookResult = ReturnType<typeof useRequestTeamAccessMutation>;
export type RequestTeamAccessMutationResult = Apollo.MutationResult<RequestTeamAccessMutation>;
export type RequestTeamAccessMutationOptions = Apollo.BaseMutationOptions<RequestTeamAccessMutation, RequestTeamAccessMutationVariables>;
export const WorkspacesDocument = gql`
    query Workspaces($filters: TeamsFilterInput, $limit: Int, $offset: Int, $memberFilters: TeamsMembersFilterInput) {
  teams(filters: $filters, limit: $limit, offset: $offset) {
    totalCount
    items {
      id
      name
      members(filters: $memberFilters) {
        items {
          ...WorkspaceMember
        }
      }
      createdBy {
        displayName
        id
      }
      totalQuotes
      totalSalesOrders
    }
  }
}
    ${WorkspaceMemberFragmentDoc}`;

/**
 * __useWorkspacesQuery__
 *
 * To run a query within a React component, call `useWorkspacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspacesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      memberFilters: // value for 'memberFilters'
 *   },
 * });
 */
export function useWorkspacesQuery(baseOptions?: Apollo.QueryHookOptions<WorkspacesQuery, WorkspacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspacesQuery, WorkspacesQueryVariables>(WorkspacesDocument, options);
      }
export function useWorkspacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspacesQuery, WorkspacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspacesQuery, WorkspacesQueryVariables>(WorkspacesDocument, options);
        }
export type WorkspacesQueryHookResult = ReturnType<typeof useWorkspacesQuery>;
export type WorkspacesLazyQueryHookResult = ReturnType<typeof useWorkspacesLazyQuery>;
export type WorkspacesQueryResult = Apollo.QueryResult<WorkspacesQuery, WorkspacesQueryVariables>;
export function refetchWorkspacesQuery(variables?: WorkspacesQueryVariables) {
      return { query: WorkspacesDocument, variables: variables }
    }
export const ApproveTeamAccessRequestDocument = gql`
    mutation ApproveTeamAccessRequest($requestId: Int!) {
  approveTeamAccessRequest(requestId: $requestId)
}
    `;
export type ApproveTeamAccessRequestMutationFn = Apollo.MutationFunction<ApproveTeamAccessRequestMutation, ApproveTeamAccessRequestMutationVariables>;

/**
 * __useApproveTeamAccessRequestMutation__
 *
 * To run a mutation, you first call `useApproveTeamAccessRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveTeamAccessRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveTeamAccessRequestMutation, { data, loading, error }] = useApproveTeamAccessRequestMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useApproveTeamAccessRequestMutation(baseOptions?: Apollo.MutationHookOptions<ApproveTeamAccessRequestMutation, ApproveTeamAccessRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveTeamAccessRequestMutation, ApproveTeamAccessRequestMutationVariables>(ApproveTeamAccessRequestDocument, options);
      }
export type ApproveTeamAccessRequestMutationHookResult = ReturnType<typeof useApproveTeamAccessRequestMutation>;
export type ApproveTeamAccessRequestMutationResult = Apollo.MutationResult<ApproveTeamAccessRequestMutation>;
export type ApproveTeamAccessRequestMutationOptions = Apollo.BaseMutationOptions<ApproveTeamAccessRequestMutation, ApproveTeamAccessRequestMutationVariables>;
export const DenyTeamAccessRequestDocument = gql`
    mutation denyTeamAccessRequest($requestId: Int!) {
  denyTeamAccessRequest(requestId: $requestId)
}
    `;
export type DenyTeamAccessRequestMutationFn = Apollo.MutationFunction<DenyTeamAccessRequestMutation, DenyTeamAccessRequestMutationVariables>;

/**
 * __useDenyTeamAccessRequestMutation__
 *
 * To run a mutation, you first call `useDenyTeamAccessRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDenyTeamAccessRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [denyTeamAccessRequestMutation, { data, loading, error }] = useDenyTeamAccessRequestMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useDenyTeamAccessRequestMutation(baseOptions?: Apollo.MutationHookOptions<DenyTeamAccessRequestMutation, DenyTeamAccessRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DenyTeamAccessRequestMutation, DenyTeamAccessRequestMutationVariables>(DenyTeamAccessRequestDocument, options);
      }
export type DenyTeamAccessRequestMutationHookResult = ReturnType<typeof useDenyTeamAccessRequestMutation>;
export type DenyTeamAccessRequestMutationResult = Apollo.MutationResult<DenyTeamAccessRequestMutation>;
export type DenyTeamAccessRequestMutationOptions = Apollo.BaseMutationOptions<DenyTeamAccessRequestMutation, DenyTeamAccessRequestMutationVariables>;
export const UserTeamMembersDocument = gql`
    query userTeamMembers($filters: UserTeamMembersFilterInput) {
  userTeamMembers(filters: $filters) {
    items {
      ...TeamMember
    }
    totalCount
  }
}
    ${TeamMemberFragmentDoc}`;

/**
 * __useUserTeamMembersQuery__
 *
 * To run a query within a React component, call `useUserTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTeamMembersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useUserTeamMembersQuery(baseOptions?: Apollo.QueryHookOptions<UserTeamMembersQuery, UserTeamMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserTeamMembersQuery, UserTeamMembersQueryVariables>(UserTeamMembersDocument, options);
      }
export function useUserTeamMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserTeamMembersQuery, UserTeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserTeamMembersQuery, UserTeamMembersQueryVariables>(UserTeamMembersDocument, options);
        }
export type UserTeamMembersQueryHookResult = ReturnType<typeof useUserTeamMembersQuery>;
export type UserTeamMembersLazyQueryHookResult = ReturnType<typeof useUserTeamMembersLazyQuery>;
export type UserTeamMembersQueryResult = Apollo.QueryResult<UserTeamMembersQuery, UserTeamMembersQueryVariables>;
export function refetchUserTeamMembersQuery(variables?: UserTeamMembersQueryVariables) {
      return { query: UserTeamMembersDocument, variables: variables }
    }
export const SendEmailVerificationDocument = gql`
    mutation sendEmailVerification($userId: Int!) {
  user(id: $userId) {
    sendEmailVerification {
      verificationUrl
      user {
        id
      }
    }
  }
}
    `;
export type SendEmailVerificationMutationFn = Apollo.MutationFunction<SendEmailVerificationMutation, SendEmailVerificationMutationVariables>;

/**
 * __useSendEmailVerificationMutation__
 *
 * To run a mutation, you first call `useSendEmailVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailVerificationMutation, { data, loading, error }] = useSendEmailVerificationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSendEmailVerificationMutation(baseOptions?: Apollo.MutationHookOptions<SendEmailVerificationMutation, SendEmailVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEmailVerificationMutation, SendEmailVerificationMutationVariables>(SendEmailVerificationDocument, options);
      }
export type SendEmailVerificationMutationHookResult = ReturnType<typeof useSendEmailVerificationMutation>;
export type SendEmailVerificationMutationResult = Apollo.MutationResult<SendEmailVerificationMutation>;
export type SendEmailVerificationMutationOptions = Apollo.BaseMutationOptions<SendEmailVerificationMutation, SendEmailVerificationMutationVariables>;
export const DeleteAccountUserProfileDocument = gql`
    mutation deleteAccountUserProfile($id: Int!) {
  user(id: $id) {
    deleteAccount {
      id
      email
      updatedAt
    }
  }
}
    `;
export type DeleteAccountUserProfileMutationFn = Apollo.MutationFunction<DeleteAccountUserProfileMutation, DeleteAccountUserProfileMutationVariables>;

/**
 * __useDeleteAccountUserProfileMutation__
 *
 * To run a mutation, you first call `useDeleteAccountUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountUserProfileMutation, { data, loading, error }] = useDeleteAccountUserProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAccountUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountUserProfileMutation, DeleteAccountUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountUserProfileMutation, DeleteAccountUserProfileMutationVariables>(DeleteAccountUserProfileDocument, options);
      }
export type DeleteAccountUserProfileMutationHookResult = ReturnType<typeof useDeleteAccountUserProfileMutation>;
export type DeleteAccountUserProfileMutationResult = Apollo.MutationResult<DeleteAccountUserProfileMutation>;
export type DeleteAccountUserProfileMutationOptions = Apollo.BaseMutationOptions<DeleteAccountUserProfileMutation, DeleteAccountUserProfileMutationVariables>;
export const UpdateUserProfileDocument = gql`
    mutation updateUserProfile($id: Int!, $profileInput: UserProfileInput!) {
  user(id: $id) {
    editGeneralInfo(profileInput: $profileInput) {
      id
      firstName
      lastName
      phoneNumber
    }
  }
}
    `;
export type UpdateUserProfileMutationFn = Apollo.MutationFunction<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;

/**
 * __useUpdateUserProfileMutation__
 *
 * To run a mutation, you first call `useUpdateUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfileMutation, { data, loading, error }] = useUpdateUserProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      profileInput: // value for 'profileInput'
 *   },
 * });
 */
export function useUpdateUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>(UpdateUserProfileDocument, options);
      }
export type UpdateUserProfileMutationHookResult = ReturnType<typeof useUpdateUserProfileMutation>;
export type UpdateUserProfileMutationResult = Apollo.MutationResult<UpdateUserProfileMutation>;
export type UpdateUserProfileMutationOptions = Apollo.BaseMutationOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const UserPhoneNumberUserProfileDocument = gql`
    query userPhoneNumberUserProfile {
  me {
    id
    phoneNumber
  }
}
    `;

/**
 * __useUserPhoneNumberUserProfileQuery__
 *
 * To run a query within a React component, call `useUserPhoneNumberUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPhoneNumberUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPhoneNumberUserProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserPhoneNumberUserProfileQuery(baseOptions?: Apollo.QueryHookOptions<UserPhoneNumberUserProfileQuery, UserPhoneNumberUserProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPhoneNumberUserProfileQuery, UserPhoneNumberUserProfileQueryVariables>(UserPhoneNumberUserProfileDocument, options);
      }
export function useUserPhoneNumberUserProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPhoneNumberUserProfileQuery, UserPhoneNumberUserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPhoneNumberUserProfileQuery, UserPhoneNumberUserProfileQueryVariables>(UserPhoneNumberUserProfileDocument, options);
        }
export type UserPhoneNumberUserProfileQueryHookResult = ReturnType<typeof useUserPhoneNumberUserProfileQuery>;
export type UserPhoneNumberUserProfileLazyQueryHookResult = ReturnType<typeof useUserPhoneNumberUserProfileLazyQuery>;
export type UserPhoneNumberUserProfileQueryResult = Apollo.QueryResult<UserPhoneNumberUserProfileQuery, UserPhoneNumberUserProfileQueryVariables>;
export function refetchUserPhoneNumberUserProfileQuery(variables?: UserPhoneNumberUserProfileQueryVariables) {
      return { query: UserPhoneNumberUserProfileDocument, variables: variables }
    }
export const FileUploaderFinalizeUploadAndProcessPartDocument = gql`
    mutation fileUploaderFinalizeUploadAndProcessPart($partId: Int!) {
  finalizeUploadAndProcessPart(partId: $partId) {
    partId
    status
    reason
  }
}
    `;
export type FileUploaderFinalizeUploadAndProcessPartMutationFn = Apollo.MutationFunction<FileUploaderFinalizeUploadAndProcessPartMutation, FileUploaderFinalizeUploadAndProcessPartMutationVariables>;

/**
 * __useFileUploaderFinalizeUploadAndProcessPartMutation__
 *
 * To run a mutation, you first call `useFileUploaderFinalizeUploadAndProcessPartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFileUploaderFinalizeUploadAndProcessPartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fileUploaderFinalizeUploadAndProcessPartMutation, { data, loading, error }] = useFileUploaderFinalizeUploadAndProcessPartMutation({
 *   variables: {
 *      partId: // value for 'partId'
 *   },
 * });
 */
export function useFileUploaderFinalizeUploadAndProcessPartMutation(baseOptions?: Apollo.MutationHookOptions<FileUploaderFinalizeUploadAndProcessPartMutation, FileUploaderFinalizeUploadAndProcessPartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FileUploaderFinalizeUploadAndProcessPartMutation, FileUploaderFinalizeUploadAndProcessPartMutationVariables>(FileUploaderFinalizeUploadAndProcessPartDocument, options);
      }
export type FileUploaderFinalizeUploadAndProcessPartMutationHookResult = ReturnType<typeof useFileUploaderFinalizeUploadAndProcessPartMutation>;
export type FileUploaderFinalizeUploadAndProcessPartMutationResult = Apollo.MutationResult<FileUploaderFinalizeUploadAndProcessPartMutation>;
export type FileUploaderFinalizeUploadAndProcessPartMutationOptions = Apollo.BaseMutationOptions<FileUploaderFinalizeUploadAndProcessPartMutation, FileUploaderFinalizeUploadAndProcessPartMutationVariables>;
export const CreateQuoteFileUploaderDocument = gql`
    mutation createQuoteFileUploader($name: String, $description: String) {
  createQuote(input: {name: $name, description: $description}) {
    id
    name
  }
}
    `;
export type CreateQuoteFileUploaderMutationFn = Apollo.MutationFunction<CreateQuoteFileUploaderMutation, CreateQuoteFileUploaderMutationVariables>;

/**
 * __useCreateQuoteFileUploaderMutation__
 *
 * To run a mutation, you first call `useCreateQuoteFileUploaderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuoteFileUploaderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuoteFileUploaderMutation, { data, loading, error }] = useCreateQuoteFileUploaderMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreateQuoteFileUploaderMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuoteFileUploaderMutation, CreateQuoteFileUploaderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuoteFileUploaderMutation, CreateQuoteFileUploaderMutationVariables>(CreateQuoteFileUploaderDocument, options);
      }
export type CreateQuoteFileUploaderMutationHookResult = ReturnType<typeof useCreateQuoteFileUploaderMutation>;
export type CreateQuoteFileUploaderMutationResult = Apollo.MutationResult<CreateQuoteFileUploaderMutation>;
export type CreateQuoteFileUploaderMutationOptions = Apollo.BaseMutationOptions<CreateQuoteFileUploaderMutation, CreateQuoteFileUploaderMutationVariables>;
export const CreateQmrFileUploaderDocument = gql`
    mutation createQmrFileUploader($uploadMetadata: QuoteModelRevisionUploadInput!, $quoteId: UUID!, $quoteModelId: UUID, $setAsSelectedForQuoteModel: Boolean!) {
  createQuoteModelRevision(
    uploadMetadata: $uploadMetadata
    quoteId: $quoteId
    quoteModelId: $quoteModelId
    setAsSelectedForQuoteModel: $setAsSelectedForQuoteModel
  ) {
    id
    uploadUrl
    partRevision {
      id
      partId
      thumbnailUri
    }
  }
}
    `;
export type CreateQmrFileUploaderMutationFn = Apollo.MutationFunction<CreateQmrFileUploaderMutation, CreateQmrFileUploaderMutationVariables>;

/**
 * __useCreateQmrFileUploaderMutation__
 *
 * To run a mutation, you first call `useCreateQmrFileUploaderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQmrFileUploaderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQmrFileUploaderMutation, { data, loading, error }] = useCreateQmrFileUploaderMutation({
 *   variables: {
 *      uploadMetadata: // value for 'uploadMetadata'
 *      quoteId: // value for 'quoteId'
 *      quoteModelId: // value for 'quoteModelId'
 *      setAsSelectedForQuoteModel: // value for 'setAsSelectedForQuoteModel'
 *   },
 * });
 */
export function useCreateQmrFileUploaderMutation(baseOptions?: Apollo.MutationHookOptions<CreateQmrFileUploaderMutation, CreateQmrFileUploaderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQmrFileUploaderMutation, CreateQmrFileUploaderMutationVariables>(CreateQmrFileUploaderDocument, options);
      }
export type CreateQmrFileUploaderMutationHookResult = ReturnType<typeof useCreateQmrFileUploaderMutation>;
export type CreateQmrFileUploaderMutationResult = Apollo.MutationResult<CreateQmrFileUploaderMutation>;
export type CreateQmrFileUploaderMutationOptions = Apollo.BaseMutationOptions<CreateQmrFileUploaderMutation, CreateQmrFileUploaderMutationVariables>;
export const CreateQuoteAttachmentRevisionFileUploaderDocument = gql`
    mutation createQuoteAttachmentRevisionFileUploader($uploadMetadata: AttachmentInput!, $quoteId: UUID!, $quoteAttachmentId: UUID, $attachmentType: String, $productAttachmentId: String, $adminReplaced: Boolean, $userId: Int) {
  createQuoteAttachmentRevision(
    uploadMetadata: $uploadMetadata
    quoteId: $quoteId
    quoteAttachmentId: $quoteAttachmentId
    attachmentType: $attachmentType
    productAttachmentId: $productAttachmentId
    adminReplaced: $adminReplaced
    userId: $userId
  ) {
    id
    attachment {
      ... on Attachment {
        id
        fileName
        uploadUrl
      }
    }
    asset {
      id
      fileName
      uploadUrl
    }
  }
}
    `;
export type CreateQuoteAttachmentRevisionFileUploaderMutationFn = Apollo.MutationFunction<CreateQuoteAttachmentRevisionFileUploaderMutation, CreateQuoteAttachmentRevisionFileUploaderMutationVariables>;

/**
 * __useCreateQuoteAttachmentRevisionFileUploaderMutation__
 *
 * To run a mutation, you first call `useCreateQuoteAttachmentRevisionFileUploaderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuoteAttachmentRevisionFileUploaderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuoteAttachmentRevisionFileUploaderMutation, { data, loading, error }] = useCreateQuoteAttachmentRevisionFileUploaderMutation({
 *   variables: {
 *      uploadMetadata: // value for 'uploadMetadata'
 *      quoteId: // value for 'quoteId'
 *      quoteAttachmentId: // value for 'quoteAttachmentId'
 *      attachmentType: // value for 'attachmentType'
 *      productAttachmentId: // value for 'productAttachmentId'
 *      adminReplaced: // value for 'adminReplaced'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCreateQuoteAttachmentRevisionFileUploaderMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuoteAttachmentRevisionFileUploaderMutation, CreateQuoteAttachmentRevisionFileUploaderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuoteAttachmentRevisionFileUploaderMutation, CreateQuoteAttachmentRevisionFileUploaderMutationVariables>(CreateQuoteAttachmentRevisionFileUploaderDocument, options);
      }
export type CreateQuoteAttachmentRevisionFileUploaderMutationHookResult = ReturnType<typeof useCreateQuoteAttachmentRevisionFileUploaderMutation>;
export type CreateQuoteAttachmentRevisionFileUploaderMutationResult = Apollo.MutationResult<CreateQuoteAttachmentRevisionFileUploaderMutation>;
export type CreateQuoteAttachmentRevisionFileUploaderMutationOptions = Apollo.BaseMutationOptions<CreateQuoteAttachmentRevisionFileUploaderMutation, CreateQuoteAttachmentRevisionFileUploaderMutationVariables>;
export const MarkQuoteAttachmentRevisionUploadedFileUploaderDocument = gql`
    mutation markQuoteAttachmentRevisionUploadedFileUploader($id: UUID!, $userId: Int) {
  markQuoteAttachmentRevisionUploaded(id: $id, userId: $userId) {
    id
    attachment {
      ... on Attachment {
        id
        fileName
        downloadUrl
      }
    }
  }
}
    `;
export type MarkQuoteAttachmentRevisionUploadedFileUploaderMutationFn = Apollo.MutationFunction<MarkQuoteAttachmentRevisionUploadedFileUploaderMutation, MarkQuoteAttachmentRevisionUploadedFileUploaderMutationVariables>;

/**
 * __useMarkQuoteAttachmentRevisionUploadedFileUploaderMutation__
 *
 * To run a mutation, you first call `useMarkQuoteAttachmentRevisionUploadedFileUploaderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkQuoteAttachmentRevisionUploadedFileUploaderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markQuoteAttachmentRevisionUploadedFileUploaderMutation, { data, loading, error }] = useMarkQuoteAttachmentRevisionUploadedFileUploaderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useMarkQuoteAttachmentRevisionUploadedFileUploaderMutation(baseOptions?: Apollo.MutationHookOptions<MarkQuoteAttachmentRevisionUploadedFileUploaderMutation, MarkQuoteAttachmentRevisionUploadedFileUploaderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkQuoteAttachmentRevisionUploadedFileUploaderMutation, MarkQuoteAttachmentRevisionUploadedFileUploaderMutationVariables>(MarkQuoteAttachmentRevisionUploadedFileUploaderDocument, options);
      }
export type MarkQuoteAttachmentRevisionUploadedFileUploaderMutationHookResult = ReturnType<typeof useMarkQuoteAttachmentRevisionUploadedFileUploaderMutation>;
export type MarkQuoteAttachmentRevisionUploadedFileUploaderMutationResult = Apollo.MutationResult<MarkQuoteAttachmentRevisionUploadedFileUploaderMutation>;
export type MarkQuoteAttachmentRevisionUploadedFileUploaderMutationOptions = Apollo.BaseMutationOptions<MarkQuoteAttachmentRevisionUploadedFileUploaderMutation, MarkQuoteAttachmentRevisionUploadedFileUploaderMutationVariables>;
export const CreateQmrAttachmentMutationDocument = gql`
    mutation createQMRAttachmentMutation($quoteModelRevisionId: UUID!, $quoteAttachmentRevisionId: UUID!, $userId: Int) {
  createQuoteModelRevisionAttachment(
    quoteModelRevisionId: $quoteModelRevisionId
    quoteAttachmentRevisionId: $quoteAttachmentRevisionId
    userId: $userId
  ) {
    quoteModelRevision {
      id
    }
    id
  }
}
    `;
export type CreateQmrAttachmentMutationMutationFn = Apollo.MutationFunction<CreateQmrAttachmentMutationMutation, CreateQmrAttachmentMutationMutationVariables>;

/**
 * __useCreateQmrAttachmentMutationMutation__
 *
 * To run a mutation, you first call `useCreateQmrAttachmentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQmrAttachmentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQmrAttachmentMutationMutation, { data, loading, error }] = useCreateQmrAttachmentMutationMutation({
 *   variables: {
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *      quoteAttachmentRevisionId: // value for 'quoteAttachmentRevisionId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCreateQmrAttachmentMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateQmrAttachmentMutationMutation, CreateQmrAttachmentMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQmrAttachmentMutationMutation, CreateQmrAttachmentMutationMutationVariables>(CreateQmrAttachmentMutationDocument, options);
      }
export type CreateQmrAttachmentMutationMutationHookResult = ReturnType<typeof useCreateQmrAttachmentMutationMutation>;
export type CreateQmrAttachmentMutationMutationResult = Apollo.MutationResult<CreateQmrAttachmentMutationMutation>;
export type CreateQmrAttachmentMutationMutationOptions = Apollo.BaseMutationOptions<CreateQmrAttachmentMutationMutation, CreateQmrAttachmentMutationMutationVariables>;
export const UpdateGeneratedDrawingMutationDocument = gql`
    mutation updateGeneratedDrawingMutation($id: UUID!, $attachment: AttachmentInput!) {
  updateGeneratedDrawing(id: $id, attachment: $attachment) {
    id
    attachment {
      id
      fileName
      uploadUrl
    }
  }
}
    `;
export type UpdateGeneratedDrawingMutationMutationFn = Apollo.MutationFunction<UpdateGeneratedDrawingMutationMutation, UpdateGeneratedDrawingMutationMutationVariables>;

/**
 * __useUpdateGeneratedDrawingMutationMutation__
 *
 * To run a mutation, you first call `useUpdateGeneratedDrawingMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGeneratedDrawingMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGeneratedDrawingMutationMutation, { data, loading, error }] = useUpdateGeneratedDrawingMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attachment: // value for 'attachment'
 *   },
 * });
 */
export function useUpdateGeneratedDrawingMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGeneratedDrawingMutationMutation, UpdateGeneratedDrawingMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGeneratedDrawingMutationMutation, UpdateGeneratedDrawingMutationMutationVariables>(UpdateGeneratedDrawingMutationDocument, options);
      }
export type UpdateGeneratedDrawingMutationMutationHookResult = ReturnType<typeof useUpdateGeneratedDrawingMutationMutation>;
export type UpdateGeneratedDrawingMutationMutationResult = Apollo.MutationResult<UpdateGeneratedDrawingMutationMutation>;
export type UpdateGeneratedDrawingMutationMutationOptions = Apollo.BaseMutationOptions<UpdateGeneratedDrawingMutationMutation, UpdateGeneratedDrawingMutationMutationVariables>;
export const MarkUploadedAttachmentMutationDocument = gql`
    mutation markUploadedAttachmentMutation($id: UUID!) {
  markUploadedAttachment(id: $id) {
    id
    fileName
    downloadUrl
  }
}
    `;
export type MarkUploadedAttachmentMutationMutationFn = Apollo.MutationFunction<MarkUploadedAttachmentMutationMutation, MarkUploadedAttachmentMutationMutationVariables>;

/**
 * __useMarkUploadedAttachmentMutationMutation__
 *
 * To run a mutation, you first call `useMarkUploadedAttachmentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkUploadedAttachmentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markUploadedAttachmentMutationMutation, { data, loading, error }] = useMarkUploadedAttachmentMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkUploadedAttachmentMutationMutation(baseOptions?: Apollo.MutationHookOptions<MarkUploadedAttachmentMutationMutation, MarkUploadedAttachmentMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkUploadedAttachmentMutationMutation, MarkUploadedAttachmentMutationMutationVariables>(MarkUploadedAttachmentMutationDocument, options);
      }
export type MarkUploadedAttachmentMutationMutationHookResult = ReturnType<typeof useMarkUploadedAttachmentMutationMutation>;
export type MarkUploadedAttachmentMutationMutationResult = Apollo.MutationResult<MarkUploadedAttachmentMutationMutation>;
export type MarkUploadedAttachmentMutationMutationOptions = Apollo.BaseMutationOptions<MarkUploadedAttachmentMutationMutation, MarkUploadedAttachmentMutationMutationVariables>;
export const GetUserBusinessAccountStatusDocument = gql`
    query GetUserBusinessAccountStatus($userId: Int!) {
  getUserBusinessAccountStatus(userId: $userId) {
    businessAccountId
    businessAccountName
    businessAccountInviteStatus
    isBusinessAccountMember
    isEmailVerified
    isLTOFeatureEnabled
    isPOFeatureEnabled
    isSalesforceContact
    isTeamsFeatureEnabled
    isConsultativeDfmFeatureEnabled
    userId
  }
}
    `;

/**
 * __useGetUserBusinessAccountStatusQuery__
 *
 * To run a query within a React component, call `useGetUserBusinessAccountStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserBusinessAccountStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserBusinessAccountStatusQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserBusinessAccountStatusQuery(baseOptions: Apollo.QueryHookOptions<GetUserBusinessAccountStatusQuery, GetUserBusinessAccountStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserBusinessAccountStatusQuery, GetUserBusinessAccountStatusQueryVariables>(GetUserBusinessAccountStatusDocument, options);
      }
export function useGetUserBusinessAccountStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserBusinessAccountStatusQuery, GetUserBusinessAccountStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserBusinessAccountStatusQuery, GetUserBusinessAccountStatusQueryVariables>(GetUserBusinessAccountStatusDocument, options);
        }
export type GetUserBusinessAccountStatusQueryHookResult = ReturnType<typeof useGetUserBusinessAccountStatusQuery>;
export type GetUserBusinessAccountStatusLazyQueryHookResult = ReturnType<typeof useGetUserBusinessAccountStatusLazyQuery>;
export type GetUserBusinessAccountStatusQueryResult = Apollo.QueryResult<GetUserBusinessAccountStatusQuery, GetUserBusinessAccountStatusQueryVariables>;
export function refetchGetUserBusinessAccountStatusQuery(variables: GetUserBusinessAccountStatusQueryVariables) {
      return { query: GetUserBusinessAccountStatusDocument, variables: variables }
    }
export const CreateStripeClientSecretDocument = gql`
    mutation CreateStripeClientSecret($id: Int!, $supportedPaymentTypes: [String!]) {
  user(id: $id) {
    createStripeClientSecret(paymentTypes: $supportedPaymentTypes)
  }
}
    `;
export type CreateStripeClientSecretMutationFn = Apollo.MutationFunction<CreateStripeClientSecretMutation, CreateStripeClientSecretMutationVariables>;

/**
 * __useCreateStripeClientSecretMutation__
 *
 * To run a mutation, you first call `useCreateStripeClientSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStripeClientSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStripeClientSecretMutation, { data, loading, error }] = useCreateStripeClientSecretMutation({
 *   variables: {
 *      id: // value for 'id'
 *      supportedPaymentTypes: // value for 'supportedPaymentTypes'
 *   },
 * });
 */
export function useCreateStripeClientSecretMutation(baseOptions?: Apollo.MutationHookOptions<CreateStripeClientSecretMutation, CreateStripeClientSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStripeClientSecretMutation, CreateStripeClientSecretMutationVariables>(CreateStripeClientSecretDocument, options);
      }
export type CreateStripeClientSecretMutationHookResult = ReturnType<typeof useCreateStripeClientSecretMutation>;
export type CreateStripeClientSecretMutationResult = Apollo.MutationResult<CreateStripeClientSecretMutation>;
export type CreateStripeClientSecretMutationOptions = Apollo.BaseMutationOptions<CreateStripeClientSecretMutation, CreateStripeClientSecretMutationVariables>;
export const CreateZipDownloadDocument = gql`
    mutation createZipDownload($name: String!, $folderId: UUID, $revisionIds: [UUID!], $attachmentIds: [UUID!], $quoteModelRevisionIds: [UUID!], $quoteAttachmentRevisionIds: [UUID!], $estimateItemIds: [UUID!]) {
  createZipDownload(
    name: $name
    folderId: $folderId
    revisionIds: $revisionIds
    attachmentIds: $attachmentIds
    quoteModelRevisionIds: $quoteModelRevisionIds
    quoteAttachmentRevisionIds: $quoteAttachmentRevisionIds
    estimateItemIds: $estimateItemIds
  ) {
    id
    jobStartDate
    jobCompleteDate
    name
    error
    url
  }
}
    `;
export type CreateZipDownloadMutationFn = Apollo.MutationFunction<CreateZipDownloadMutation, CreateZipDownloadMutationVariables>;

/**
 * __useCreateZipDownloadMutation__
 *
 * To run a mutation, you first call `useCreateZipDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateZipDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createZipDownloadMutation, { data, loading, error }] = useCreateZipDownloadMutation({
 *   variables: {
 *      name: // value for 'name'
 *      folderId: // value for 'folderId'
 *      revisionIds: // value for 'revisionIds'
 *      attachmentIds: // value for 'attachmentIds'
 *      quoteModelRevisionIds: // value for 'quoteModelRevisionIds'
 *      quoteAttachmentRevisionIds: // value for 'quoteAttachmentRevisionIds'
 *      estimateItemIds: // value for 'estimateItemIds'
 *   },
 * });
 */
export function useCreateZipDownloadMutation(baseOptions?: Apollo.MutationHookOptions<CreateZipDownloadMutation, CreateZipDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateZipDownloadMutation, CreateZipDownloadMutationVariables>(CreateZipDownloadDocument, options);
      }
export type CreateZipDownloadMutationHookResult = ReturnType<typeof useCreateZipDownloadMutation>;
export type CreateZipDownloadMutationResult = Apollo.MutationResult<CreateZipDownloadMutation>;
export type CreateZipDownloadMutationOptions = Apollo.BaseMutationOptions<CreateZipDownloadMutation, CreateZipDownloadMutationVariables>;
export const CreateEstimateItemZipDownloadDocument = gql`
    mutation createEstimateItemZipDownload($name: String!, $estimateItemIds: [UUID!]!, $mode: EstimateItemZipMode!) {
  createEstimateItemZipDownload(
    name: $name
    estimateItemIds: $estimateItemIds
    mode: $mode
  ) {
    id
    error
    url
    name
    jobStartDate
    jobCompleteDate
  }
}
    `;
export type CreateEstimateItemZipDownloadMutationFn = Apollo.MutationFunction<CreateEstimateItemZipDownloadMutation, CreateEstimateItemZipDownloadMutationVariables>;

/**
 * __useCreateEstimateItemZipDownloadMutation__
 *
 * To run a mutation, you first call `useCreateEstimateItemZipDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEstimateItemZipDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEstimateItemZipDownloadMutation, { data, loading, error }] = useCreateEstimateItemZipDownloadMutation({
 *   variables: {
 *      name: // value for 'name'
 *      estimateItemIds: // value for 'estimateItemIds'
 *      mode: // value for 'mode'
 *   },
 * });
 */
export function useCreateEstimateItemZipDownloadMutation(baseOptions?: Apollo.MutationHookOptions<CreateEstimateItemZipDownloadMutation, CreateEstimateItemZipDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEstimateItemZipDownloadMutation, CreateEstimateItemZipDownloadMutationVariables>(CreateEstimateItemZipDownloadDocument, options);
      }
export type CreateEstimateItemZipDownloadMutationHookResult = ReturnType<typeof useCreateEstimateItemZipDownloadMutation>;
export type CreateEstimateItemZipDownloadMutationResult = Apollo.MutationResult<CreateEstimateItemZipDownloadMutation>;
export type CreateEstimateItemZipDownloadMutationOptions = Apollo.BaseMutationOptions<CreateEstimateItemZipDownloadMutation, CreateEstimateItemZipDownloadMutationVariables>;
export const QuoteAttachmentRevisionDocument = gql`
    query quoteAttachmentRevision($id: UUID!) {
  quoteAttachmentRevision(id: $id) {
    id
    attachment {
      ... on Attachment {
        id
        downloadUrl
        uploadUrl
        fileName
        annotated {
          id
          downloadUrl
          fileName
        }
      }
    }
  }
}
    `;

/**
 * __useQuoteAttachmentRevisionQuery__
 *
 * To run a query within a React component, call `useQuoteAttachmentRevisionQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteAttachmentRevisionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteAttachmentRevisionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuoteAttachmentRevisionQuery(baseOptions: Apollo.QueryHookOptions<QuoteAttachmentRevisionQuery, QuoteAttachmentRevisionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteAttachmentRevisionQuery, QuoteAttachmentRevisionQueryVariables>(QuoteAttachmentRevisionDocument, options);
      }
export function useQuoteAttachmentRevisionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteAttachmentRevisionQuery, QuoteAttachmentRevisionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteAttachmentRevisionQuery, QuoteAttachmentRevisionQueryVariables>(QuoteAttachmentRevisionDocument, options);
        }
export type QuoteAttachmentRevisionQueryHookResult = ReturnType<typeof useQuoteAttachmentRevisionQuery>;
export type QuoteAttachmentRevisionLazyQueryHookResult = ReturnType<typeof useQuoteAttachmentRevisionLazyQuery>;
export type QuoteAttachmentRevisionQueryResult = Apollo.QueryResult<QuoteAttachmentRevisionQuery, QuoteAttachmentRevisionQueryVariables>;
export function refetchQuoteAttachmentRevisionQuery(variables: QuoteAttachmentRevisionQueryVariables) {
      return { query: QuoteAttachmentRevisionDocument, variables: variables }
    }
export const Disable2FaMyAccountDocument = gql`
    mutation disable2FAMyAccount($id: Int!, $password: String) {
  user(id: $id) {
    disable2FA(password: $password) {
      id
      email
      is2faEnabled
    }
  }
}
    `;
export type Disable2FaMyAccountMutationFn = Apollo.MutationFunction<Disable2FaMyAccountMutation, Disable2FaMyAccountMutationVariables>;

/**
 * __useDisable2FaMyAccountMutation__
 *
 * To run a mutation, you first call `useDisable2FaMyAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisable2FaMyAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disable2FaMyAccountMutation, { data, loading, error }] = useDisable2FaMyAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useDisable2FaMyAccountMutation(baseOptions?: Apollo.MutationHookOptions<Disable2FaMyAccountMutation, Disable2FaMyAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Disable2FaMyAccountMutation, Disable2FaMyAccountMutationVariables>(Disable2FaMyAccountDocument, options);
      }
export type Disable2FaMyAccountMutationHookResult = ReturnType<typeof useDisable2FaMyAccountMutation>;
export type Disable2FaMyAccountMutationResult = Apollo.MutationResult<Disable2FaMyAccountMutation>;
export type Disable2FaMyAccountMutationOptions = Apollo.BaseMutationOptions<Disable2FaMyAccountMutation, Disable2FaMyAccountMutationVariables>;
export const GetIs2faEnabledMyAccountDocument = gql`
    query getIs2faEnabledMyAccount {
  me {
    id
    is2faEnabled
  }
}
    `;

/**
 * __useGetIs2faEnabledMyAccountQuery__
 *
 * To run a query within a React component, call `useGetIs2faEnabledMyAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIs2faEnabledMyAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIs2faEnabledMyAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIs2faEnabledMyAccountQuery(baseOptions?: Apollo.QueryHookOptions<GetIs2faEnabledMyAccountQuery, GetIs2faEnabledMyAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIs2faEnabledMyAccountQuery, GetIs2faEnabledMyAccountQueryVariables>(GetIs2faEnabledMyAccountDocument, options);
      }
export function useGetIs2faEnabledMyAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIs2faEnabledMyAccountQuery, GetIs2faEnabledMyAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIs2faEnabledMyAccountQuery, GetIs2faEnabledMyAccountQueryVariables>(GetIs2faEnabledMyAccountDocument, options);
        }
export type GetIs2faEnabledMyAccountQueryHookResult = ReturnType<typeof useGetIs2faEnabledMyAccountQuery>;
export type GetIs2faEnabledMyAccountLazyQueryHookResult = ReturnType<typeof useGetIs2faEnabledMyAccountLazyQuery>;
export type GetIs2faEnabledMyAccountQueryResult = Apollo.QueryResult<GetIs2faEnabledMyAccountQuery, GetIs2faEnabledMyAccountQueryVariables>;
export function refetchGetIs2faEnabledMyAccountQuery(variables?: GetIs2faEnabledMyAccountQueryVariables) {
      return { query: GetIs2faEnabledMyAccountDocument, variables: variables }
    }
export const GetQrCodeMyAccountPageDocument = gql`
    mutation getQRCodeMyAccountPage($id: Int!) {
  user(id: $id) {
    enable2FA
  }
}
    `;
export type GetQrCodeMyAccountPageMutationFn = Apollo.MutationFunction<GetQrCodeMyAccountPageMutation, GetQrCodeMyAccountPageMutationVariables>;

/**
 * __useGetQrCodeMyAccountPageMutation__
 *
 * To run a mutation, you first call `useGetQrCodeMyAccountPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetQrCodeMyAccountPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getQrCodeMyAccountPageMutation, { data, loading, error }] = useGetQrCodeMyAccountPageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetQrCodeMyAccountPageMutation(baseOptions?: Apollo.MutationHookOptions<GetQrCodeMyAccountPageMutation, GetQrCodeMyAccountPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetQrCodeMyAccountPageMutation, GetQrCodeMyAccountPageMutationVariables>(GetQrCodeMyAccountPageDocument, options);
      }
export type GetQrCodeMyAccountPageMutationHookResult = ReturnType<typeof useGetQrCodeMyAccountPageMutation>;
export type GetQrCodeMyAccountPageMutationResult = Apollo.MutationResult<GetQrCodeMyAccountPageMutation>;
export type GetQrCodeMyAccountPageMutationOptions = Apollo.BaseMutationOptions<GetQrCodeMyAccountPageMutation, GetQrCodeMyAccountPageMutationVariables>;
export const Verify2FaMyAccountPageDocument = gql`
    mutation verify2FAMyAccountPage($id: Int!, $code: String!) {
  user(id: $id) {
    verify2FA(code: $code) {
      id
      email
      is2faEnabled
    }
  }
}
    `;
export type Verify2FaMyAccountPageMutationFn = Apollo.MutationFunction<Verify2FaMyAccountPageMutation, Verify2FaMyAccountPageMutationVariables>;

/**
 * __useVerify2FaMyAccountPageMutation__
 *
 * To run a mutation, you first call `useVerify2FaMyAccountPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerify2FaMyAccountPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verify2FaMyAccountPageMutation, { data, loading, error }] = useVerify2FaMyAccountPageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useVerify2FaMyAccountPageMutation(baseOptions?: Apollo.MutationHookOptions<Verify2FaMyAccountPageMutation, Verify2FaMyAccountPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Verify2FaMyAccountPageMutation, Verify2FaMyAccountPageMutationVariables>(Verify2FaMyAccountPageDocument, options);
      }
export type Verify2FaMyAccountPageMutationHookResult = ReturnType<typeof useVerify2FaMyAccountPageMutation>;
export type Verify2FaMyAccountPageMutationResult = Apollo.MutationResult<Verify2FaMyAccountPageMutation>;
export type Verify2FaMyAccountPageMutationOptions = Apollo.BaseMutationOptions<Verify2FaMyAccountPageMutation, Verify2FaMyAccountPageMutationVariables>;
export const SetBusinessAccountExcludedCountriesDocument = gql`
    mutation setBusinessAccountExcludedCountries($businessAccountId: UUID!, $excludedCountryIDs: [BusinessAccountExcludedCountriesInput]) {
  setBusinessAccountExcludedCountries(
    businessAccountId: $businessAccountId
    excludedCountryIDs: $excludedCountryIDs
  ) {
    id
    excludedCountries {
      name
      value
    }
  }
}
    `;
export type SetBusinessAccountExcludedCountriesMutationFn = Apollo.MutationFunction<SetBusinessAccountExcludedCountriesMutation, SetBusinessAccountExcludedCountriesMutationVariables>;

/**
 * __useSetBusinessAccountExcludedCountriesMutation__
 *
 * To run a mutation, you first call `useSetBusinessAccountExcludedCountriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBusinessAccountExcludedCountriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBusinessAccountExcludedCountriesMutation, { data, loading, error }] = useSetBusinessAccountExcludedCountriesMutation({
 *   variables: {
 *      businessAccountId: // value for 'businessAccountId'
 *      excludedCountryIDs: // value for 'excludedCountryIDs'
 *   },
 * });
 */
export function useSetBusinessAccountExcludedCountriesMutation(baseOptions?: Apollo.MutationHookOptions<SetBusinessAccountExcludedCountriesMutation, SetBusinessAccountExcludedCountriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetBusinessAccountExcludedCountriesMutation, SetBusinessAccountExcludedCountriesMutationVariables>(SetBusinessAccountExcludedCountriesDocument, options);
      }
export type SetBusinessAccountExcludedCountriesMutationHookResult = ReturnType<typeof useSetBusinessAccountExcludedCountriesMutation>;
export type SetBusinessAccountExcludedCountriesMutationResult = Apollo.MutationResult<SetBusinessAccountExcludedCountriesMutation>;
export type SetBusinessAccountExcludedCountriesMutationOptions = Apollo.BaseMutationOptions<SetBusinessAccountExcludedCountriesMutation, SetBusinessAccountExcludedCountriesMutationVariables>;
export const AcceptDfmFeedbackDocument = gql`
    mutation acceptDfmFeedback($id: UUID!) {
  acceptDfmFeedback(id: $id) {
    id
  }
}
    `;
export type AcceptDfmFeedbackMutationFn = Apollo.MutationFunction<AcceptDfmFeedbackMutation, AcceptDfmFeedbackMutationVariables>;

/**
 * __useAcceptDfmFeedbackMutation__
 *
 * To run a mutation, you first call `useAcceptDfmFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptDfmFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptDfmFeedbackMutation, { data, loading, error }] = useAcceptDfmFeedbackMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAcceptDfmFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<AcceptDfmFeedbackMutation, AcceptDfmFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptDfmFeedbackMutation, AcceptDfmFeedbackMutationVariables>(AcceptDfmFeedbackDocument, options);
      }
export type AcceptDfmFeedbackMutationHookResult = ReturnType<typeof useAcceptDfmFeedbackMutation>;
export type AcceptDfmFeedbackMutationResult = Apollo.MutationResult<AcceptDfmFeedbackMutation>;
export type AcceptDfmFeedbackMutationOptions = Apollo.BaseMutationOptions<AcceptDfmFeedbackMutation, AcceptDfmFeedbackMutationVariables>;
export const AcceptOpenInviteDocument = gql`
    mutation acceptOpenInvite($token: String!) {
  acceptOpenInvite(token: $token) {
    id
  }
}
    `;
export type AcceptOpenInviteMutationFn = Apollo.MutationFunction<AcceptOpenInviteMutation, AcceptOpenInviteMutationVariables>;

/**
 * __useAcceptOpenInviteMutation__
 *
 * To run a mutation, you first call `useAcceptOpenInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptOpenInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptOpenInviteMutation, { data, loading, error }] = useAcceptOpenInviteMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAcceptOpenInviteMutation(baseOptions?: Apollo.MutationHookOptions<AcceptOpenInviteMutation, AcceptOpenInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptOpenInviteMutation, AcceptOpenInviteMutationVariables>(AcceptOpenInviteDocument, options);
      }
export type AcceptOpenInviteMutationHookResult = ReturnType<typeof useAcceptOpenInviteMutation>;
export type AcceptOpenInviteMutationResult = Apollo.MutationResult<AcceptOpenInviteMutation>;
export type AcceptOpenInviteMutationOptions = Apollo.BaseMutationOptions<AcceptOpenInviteMutation, AcceptOpenInviteMutationVariables>;
export const AcceptQuoteInviteDocument = gql`
    mutation acceptQuoteInvite($token: String!) {
  acceptInvite(token: $token) {
    id
  }
}
    `;
export type AcceptQuoteInviteMutationFn = Apollo.MutationFunction<AcceptQuoteInviteMutation, AcceptQuoteInviteMutationVariables>;

/**
 * __useAcceptQuoteInviteMutation__
 *
 * To run a mutation, you first call `useAcceptQuoteInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptQuoteInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptQuoteInviteMutation, { data, loading, error }] = useAcceptQuoteInviteMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAcceptQuoteInviteMutation(baseOptions?: Apollo.MutationHookOptions<AcceptQuoteInviteMutation, AcceptQuoteInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptQuoteInviteMutation, AcceptQuoteInviteMutationVariables>(AcceptQuoteInviteDocument, options);
      }
export type AcceptQuoteInviteMutationHookResult = ReturnType<typeof useAcceptQuoteInviteMutation>;
export type AcceptQuoteInviteMutationResult = Apollo.MutationResult<AcceptQuoteInviteMutation>;
export type AcceptQuoteInviteMutationOptions = Apollo.BaseMutationOptions<AcceptQuoteInviteMutation, AcceptQuoteInviteMutationVariables>;
export const AddCustomerShippingAccountDocument = gql`
    mutation addCustomerShippingAccount($name: String, $provider: Carrier!, $accountNumber: String!, $country: String!, $postalCode: String!, $userId: Int) {
  createCarrierAccount(
    userId: $userId
    account: {name: $name, provider: $provider, accountNumber: $accountNumber, country: $country, postalCode: $postalCode}
  ) {
    id
    provider
  }
}
    `;
export type AddCustomerShippingAccountMutationFn = Apollo.MutationFunction<AddCustomerShippingAccountMutation, AddCustomerShippingAccountMutationVariables>;

/**
 * __useAddCustomerShippingAccountMutation__
 *
 * To run a mutation, you first call `useAddCustomerShippingAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCustomerShippingAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCustomerShippingAccountMutation, { data, loading, error }] = useAddCustomerShippingAccountMutation({
 *   variables: {
 *      name: // value for 'name'
 *      provider: // value for 'provider'
 *      accountNumber: // value for 'accountNumber'
 *      country: // value for 'country'
 *      postalCode: // value for 'postalCode'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddCustomerShippingAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddCustomerShippingAccountMutation, AddCustomerShippingAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCustomerShippingAccountMutation, AddCustomerShippingAccountMutationVariables>(AddCustomerShippingAccountDocument, options);
      }
export type AddCustomerShippingAccountMutationHookResult = ReturnType<typeof useAddCustomerShippingAccountMutation>;
export type AddCustomerShippingAccountMutationResult = Apollo.MutationResult<AddCustomerShippingAccountMutation>;
export type AddCustomerShippingAccountMutationOptions = Apollo.BaseMutationOptions<AddCustomerShippingAccountMutation, AddCustomerShippingAccountMutationVariables>;
export const AdminAddOrModifyShippingAddressForUserAdminUserQuoteCheckoutPageDocument = gql`
    mutation adminAddOrModifyShippingAddressForUserAdminUserQuoteCheckoutPage($userId: Int!, $shippingAddressInput: ShippingAddressInput!) {
  adminUser(userId: $userId) {
    modifyShippingAddress(shippingAddressInput: $shippingAddressInput) {
      ...ShippingAddressesItem
    }
  }
}
    ${ShippingAddressesItemFragmentDoc}`;
export type AdminAddOrModifyShippingAddressForUserAdminUserQuoteCheckoutPageMutationFn = Apollo.MutationFunction<AdminAddOrModifyShippingAddressForUserAdminUserQuoteCheckoutPageMutation, AdminAddOrModifyShippingAddressForUserAdminUserQuoteCheckoutPageMutationVariables>;

/**
 * __useAdminAddOrModifyShippingAddressForUserAdminUserQuoteCheckoutPageMutation__
 *
 * To run a mutation, you first call `useAdminAddOrModifyShippingAddressForUserAdminUserQuoteCheckoutPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminAddOrModifyShippingAddressForUserAdminUserQuoteCheckoutPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminAddOrModifyShippingAddressForUserAdminUserQuoteCheckoutPageMutation, { data, loading, error }] = useAdminAddOrModifyShippingAddressForUserAdminUserQuoteCheckoutPageMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      shippingAddressInput: // value for 'shippingAddressInput'
 *   },
 * });
 */
export function useAdminAddOrModifyShippingAddressForUserAdminUserQuoteCheckoutPageMutation(baseOptions?: Apollo.MutationHookOptions<AdminAddOrModifyShippingAddressForUserAdminUserQuoteCheckoutPageMutation, AdminAddOrModifyShippingAddressForUserAdminUserQuoteCheckoutPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminAddOrModifyShippingAddressForUserAdminUserQuoteCheckoutPageMutation, AdminAddOrModifyShippingAddressForUserAdminUserQuoteCheckoutPageMutationVariables>(AdminAddOrModifyShippingAddressForUserAdminUserQuoteCheckoutPageDocument, options);
      }
export type AdminAddOrModifyShippingAddressForUserAdminUserQuoteCheckoutPageMutationHookResult = ReturnType<typeof useAdminAddOrModifyShippingAddressForUserAdminUserQuoteCheckoutPageMutation>;
export type AdminAddOrModifyShippingAddressForUserAdminUserQuoteCheckoutPageMutationResult = Apollo.MutationResult<AdminAddOrModifyShippingAddressForUserAdminUserQuoteCheckoutPageMutation>;
export type AdminAddOrModifyShippingAddressForUserAdminUserQuoteCheckoutPageMutationOptions = Apollo.BaseMutationOptions<AdminAddOrModifyShippingAddressForUserAdminUserQuoteCheckoutPageMutation, AdminAddOrModifyShippingAddressForUserAdminUserQuoteCheckoutPageMutationVariables>;
export const AdminDeactivateBusinessAccountMemberDocument = gql`
    mutation adminDeactivateBusinessAccountMember($businessAccountId: String!, $userId: Int!) {
  deactivateBusinessAccountMember(
    businessAccountId: $businessAccountId
    userId: $userId
  )
}
    `;
export type AdminDeactivateBusinessAccountMemberMutationFn = Apollo.MutationFunction<AdminDeactivateBusinessAccountMemberMutation, AdminDeactivateBusinessAccountMemberMutationVariables>;

/**
 * __useAdminDeactivateBusinessAccountMemberMutation__
 *
 * To run a mutation, you first call `useAdminDeactivateBusinessAccountMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeactivateBusinessAccountMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeactivateBusinessAccountMemberMutation, { data, loading, error }] = useAdminDeactivateBusinessAccountMemberMutation({
 *   variables: {
 *      businessAccountId: // value for 'businessAccountId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminDeactivateBusinessAccountMemberMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeactivateBusinessAccountMemberMutation, AdminDeactivateBusinessAccountMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeactivateBusinessAccountMemberMutation, AdminDeactivateBusinessAccountMemberMutationVariables>(AdminDeactivateBusinessAccountMemberDocument, options);
      }
export type AdminDeactivateBusinessAccountMemberMutationHookResult = ReturnType<typeof useAdminDeactivateBusinessAccountMemberMutation>;
export type AdminDeactivateBusinessAccountMemberMutationResult = Apollo.MutationResult<AdminDeactivateBusinessAccountMemberMutation>;
export type AdminDeactivateBusinessAccountMemberMutationOptions = Apollo.BaseMutationOptions<AdminDeactivateBusinessAccountMemberMutation, AdminDeactivateBusinessAccountMemberMutationVariables>;
export const AdminRemoveShippingAddressForUserAdminUserQuoteCheckoutPageDocument = gql`
    mutation adminRemoveShippingAddressForUserAdminUserQuoteCheckoutPage($userId: Int!, $id: Int!) {
  adminUser(userId: $userId) {
    removeShippingAddress(id: $id) {
      ...ShippingAddressesItem
    }
  }
}
    ${ShippingAddressesItemFragmentDoc}`;
export type AdminRemoveShippingAddressForUserAdminUserQuoteCheckoutPageMutationFn = Apollo.MutationFunction<AdminRemoveShippingAddressForUserAdminUserQuoteCheckoutPageMutation, AdminRemoveShippingAddressForUserAdminUserQuoteCheckoutPageMutationVariables>;

/**
 * __useAdminRemoveShippingAddressForUserAdminUserQuoteCheckoutPageMutation__
 *
 * To run a mutation, you first call `useAdminRemoveShippingAddressForUserAdminUserQuoteCheckoutPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRemoveShippingAddressForUserAdminUserQuoteCheckoutPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRemoveShippingAddressForUserAdminUserQuoteCheckoutPageMutation, { data, loading, error }] = useAdminRemoveShippingAddressForUserAdminUserQuoteCheckoutPageMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminRemoveShippingAddressForUserAdminUserQuoteCheckoutPageMutation(baseOptions?: Apollo.MutationHookOptions<AdminRemoveShippingAddressForUserAdminUserQuoteCheckoutPageMutation, AdminRemoveShippingAddressForUserAdminUserQuoteCheckoutPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminRemoveShippingAddressForUserAdminUserQuoteCheckoutPageMutation, AdminRemoveShippingAddressForUserAdminUserQuoteCheckoutPageMutationVariables>(AdminRemoveShippingAddressForUserAdminUserQuoteCheckoutPageDocument, options);
      }
export type AdminRemoveShippingAddressForUserAdminUserQuoteCheckoutPageMutationHookResult = ReturnType<typeof useAdminRemoveShippingAddressForUserAdminUserQuoteCheckoutPageMutation>;
export type AdminRemoveShippingAddressForUserAdminUserQuoteCheckoutPageMutationResult = Apollo.MutationResult<AdminRemoveShippingAddressForUserAdminUserQuoteCheckoutPageMutation>;
export type AdminRemoveShippingAddressForUserAdminUserQuoteCheckoutPageMutationOptions = Apollo.BaseMutationOptions<AdminRemoveShippingAddressForUserAdminUserQuoteCheckoutPageMutation, AdminRemoveShippingAddressForUserAdminUserQuoteCheckoutPageMutationVariables>;
export const AdminUpdateProcessConfigsOnQmrsDocument = gql`
    mutation adminUpdateProcessConfigsOnQmrs($ids: [UUID!]!, $primaryProcessConfig: PrimaryProcessConfigInput!, $secondaryProcessConfigs: [SecondaryProcessConfigInput!]!, $removeManuallyQuotedSecondaryProcesses: Boolean) {
  updateProcessConfigsOnQuoteModelRevisions(
    ids: $ids
    primaryProcessConfig: $primaryProcessConfig
    secondaryProcessConfigs: $secondaryProcessConfigs
    removeManuallyQuotedSecondaryProcesses: $removeManuallyQuotedSecondaryProcesses
  ) {
    id
    fileName
    version
    updatedAt
    state
    quantityRangeStatus
    processesDetails {
      ...ProcessesDetails
    }
    modelConfiguration {
      ...AdminModelConfiguration
    }
    dfmFeedback(includeDraft: true) {
      ...DfmFeedback
    }
  }
}
    ${ProcessesDetailsFragmentDoc}
${AdminModelConfigurationFragmentDoc}
${DfmFeedbackFragmentDoc}`;
export type AdminUpdateProcessConfigsOnQmrsMutationFn = Apollo.MutationFunction<AdminUpdateProcessConfigsOnQmrsMutation, AdminUpdateProcessConfigsOnQmrsMutationVariables>;

/**
 * __useAdminUpdateProcessConfigsOnQmrsMutation__
 *
 * To run a mutation, you first call `useAdminUpdateProcessConfigsOnQmrsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateProcessConfigsOnQmrsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateProcessConfigsOnQmrsMutation, { data, loading, error }] = useAdminUpdateProcessConfigsOnQmrsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      primaryProcessConfig: // value for 'primaryProcessConfig'
 *      secondaryProcessConfigs: // value for 'secondaryProcessConfigs'
 *      removeManuallyQuotedSecondaryProcesses: // value for 'removeManuallyQuotedSecondaryProcesses'
 *   },
 * });
 */
export function useAdminUpdateProcessConfigsOnQmrsMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateProcessConfigsOnQmrsMutation, AdminUpdateProcessConfigsOnQmrsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateProcessConfigsOnQmrsMutation, AdminUpdateProcessConfigsOnQmrsMutationVariables>(AdminUpdateProcessConfigsOnQmrsDocument, options);
      }
export type AdminUpdateProcessConfigsOnQmrsMutationHookResult = ReturnType<typeof useAdminUpdateProcessConfigsOnQmrsMutation>;
export type AdminUpdateProcessConfigsOnQmrsMutationResult = Apollo.MutationResult<AdminUpdateProcessConfigsOnQmrsMutation>;
export type AdminUpdateProcessConfigsOnQmrsMutationOptions = Apollo.BaseMutationOptions<AdminUpdateProcessConfigsOnQmrsMutation, AdminUpdateProcessConfigsOnQmrsMutationVariables>;
export const AdminUpsertManuallyQuotedSecondaryProcessesConfigDocument = gql`
    mutation adminUpsertManuallyQuotedSecondaryProcessesConfig($id: UUID!, $manuallyQuotedSecondaryProcessConfig: ManuallyQuotedSecondaryProcessConfigInput!) {
  upsertManuallyQuotedSecondaryProcessesConfig(
    id: $id
    quotedProcessConfig: $manuallyQuotedSecondaryProcessConfig
  ) {
    id
  }
}
    `;
export type AdminUpsertManuallyQuotedSecondaryProcessesConfigMutationFn = Apollo.MutationFunction<AdminUpsertManuallyQuotedSecondaryProcessesConfigMutation, AdminUpsertManuallyQuotedSecondaryProcessesConfigMutationVariables>;

/**
 * __useAdminUpsertManuallyQuotedSecondaryProcessesConfigMutation__
 *
 * To run a mutation, you first call `useAdminUpsertManuallyQuotedSecondaryProcessesConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpsertManuallyQuotedSecondaryProcessesConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpsertManuallyQuotedSecondaryProcessesConfigMutation, { data, loading, error }] = useAdminUpsertManuallyQuotedSecondaryProcessesConfigMutation({
 *   variables: {
 *      id: // value for 'id'
 *      manuallyQuotedSecondaryProcessConfig: // value for 'manuallyQuotedSecondaryProcessConfig'
 *   },
 * });
 */
export function useAdminUpsertManuallyQuotedSecondaryProcessesConfigMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpsertManuallyQuotedSecondaryProcessesConfigMutation, AdminUpsertManuallyQuotedSecondaryProcessesConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpsertManuallyQuotedSecondaryProcessesConfigMutation, AdminUpsertManuallyQuotedSecondaryProcessesConfigMutationVariables>(AdminUpsertManuallyQuotedSecondaryProcessesConfigDocument, options);
      }
export type AdminUpsertManuallyQuotedSecondaryProcessesConfigMutationHookResult = ReturnType<typeof useAdminUpsertManuallyQuotedSecondaryProcessesConfigMutation>;
export type AdminUpsertManuallyQuotedSecondaryProcessesConfigMutationResult = Apollo.MutationResult<AdminUpsertManuallyQuotedSecondaryProcessesConfigMutation>;
export type AdminUpsertManuallyQuotedSecondaryProcessesConfigMutationOptions = Apollo.BaseMutationOptions<AdminUpsertManuallyQuotedSecondaryProcessesConfigMutation, AdminUpsertManuallyQuotedSecondaryProcessesConfigMutationVariables>;
export const ClaimEmailVerificationDocument = gql`
    mutation ClaimEmailVerification($token: String!, $userId: Int!) {
  user(id: $userId) {
    claimEmailVerification(token: $token) {
      addedToBusinessAccount
      isPremiumTrialActivated
      user {
        id
      }
    }
  }
}
    `;
export type ClaimEmailVerificationMutationFn = Apollo.MutationFunction<ClaimEmailVerificationMutation, ClaimEmailVerificationMutationVariables>;

/**
 * __useClaimEmailVerificationMutation__
 *
 * To run a mutation, you first call `useClaimEmailVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimEmailVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimEmailVerificationMutation, { data, loading, error }] = useClaimEmailVerificationMutation({
 *   variables: {
 *      token: // value for 'token'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useClaimEmailVerificationMutation(baseOptions?: Apollo.MutationHookOptions<ClaimEmailVerificationMutation, ClaimEmailVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClaimEmailVerificationMutation, ClaimEmailVerificationMutationVariables>(ClaimEmailVerificationDocument, options);
      }
export type ClaimEmailVerificationMutationHookResult = ReturnType<typeof useClaimEmailVerificationMutation>;
export type ClaimEmailVerificationMutationResult = Apollo.MutationResult<ClaimEmailVerificationMutation>;
export type ClaimEmailVerificationMutationOptions = Apollo.BaseMutationOptions<ClaimEmailVerificationMutation, ClaimEmailVerificationMutationVariables>;
export const CreateBusinessAccountDocument = gql`
    mutation createBusinessAccount($salesforceAccountId: String!, $enabled: Boolean!) {
  createBusinessAccount(
    salesforceAccountId: $salesforceAccountId
    enabled: $enabled
  ) {
    id
    name
    isEnabled
  }
}
    `;
export type CreateBusinessAccountMutationFn = Apollo.MutationFunction<CreateBusinessAccountMutation, CreateBusinessAccountMutationVariables>;

/**
 * __useCreateBusinessAccountMutation__
 *
 * To run a mutation, you first call `useCreateBusinessAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBusinessAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBusinessAccountMutation, { data, loading, error }] = useCreateBusinessAccountMutation({
 *   variables: {
 *      salesforceAccountId: // value for 'salesforceAccountId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useCreateBusinessAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateBusinessAccountMutation, CreateBusinessAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBusinessAccountMutation, CreateBusinessAccountMutationVariables>(CreateBusinessAccountDocument, options);
      }
export type CreateBusinessAccountMutationHookResult = ReturnType<typeof useCreateBusinessAccountMutation>;
export type CreateBusinessAccountMutationResult = Apollo.MutationResult<CreateBusinessAccountMutation>;
export type CreateBusinessAccountMutationOptions = Apollo.BaseMutationOptions<CreateBusinessAccountMutation, CreateBusinessAccountMutationVariables>;
export const CreateOrUpdateShippingAddressQuoteCheckoutPageDocument = gql`
    mutation createOrUpdateShippingAddressQuoteCheckoutPage($userId: Int!, $shippingAddressInput: ShippingAddressInput!) {
  user(id: $userId) {
    modifyShippingAddress(shippingAddressInput: $shippingAddressInput) {
      ...ShippingAddressesItem
    }
  }
}
    ${ShippingAddressesItemFragmentDoc}`;
export type CreateOrUpdateShippingAddressQuoteCheckoutPageMutationFn = Apollo.MutationFunction<CreateOrUpdateShippingAddressQuoteCheckoutPageMutation, CreateOrUpdateShippingAddressQuoteCheckoutPageMutationVariables>;

/**
 * __useCreateOrUpdateShippingAddressQuoteCheckoutPageMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateShippingAddressQuoteCheckoutPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateShippingAddressQuoteCheckoutPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateShippingAddressQuoteCheckoutPageMutation, { data, loading, error }] = useCreateOrUpdateShippingAddressQuoteCheckoutPageMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      shippingAddressInput: // value for 'shippingAddressInput'
 *   },
 * });
 */
export function useCreateOrUpdateShippingAddressQuoteCheckoutPageMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateShippingAddressQuoteCheckoutPageMutation, CreateOrUpdateShippingAddressQuoteCheckoutPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateShippingAddressQuoteCheckoutPageMutation, CreateOrUpdateShippingAddressQuoteCheckoutPageMutationVariables>(CreateOrUpdateShippingAddressQuoteCheckoutPageDocument, options);
      }
export type CreateOrUpdateShippingAddressQuoteCheckoutPageMutationHookResult = ReturnType<typeof useCreateOrUpdateShippingAddressQuoteCheckoutPageMutation>;
export type CreateOrUpdateShippingAddressQuoteCheckoutPageMutationResult = Apollo.MutationResult<CreateOrUpdateShippingAddressQuoteCheckoutPageMutation>;
export type CreateOrUpdateShippingAddressQuoteCheckoutPageMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateShippingAddressQuoteCheckoutPageMutation, CreateOrUpdateShippingAddressQuoteCheckoutPageMutationVariables>;
export const CreateQmrAttachmentDocument = gql`
    mutation createQmrAttachment($quoteModelRevisionId: UUID!, $quoteAttachmentRevisionId: UUID!) {
  createQuoteModelRevisionAttachment(
    quoteModelRevisionId: $quoteModelRevisionId
    quoteAttachmentRevisionId: $quoteAttachmentRevisionId
  ) {
    quoteModelRevision {
      id
    }
    id
  }
}
    `;
export type CreateQmrAttachmentMutationFn = Apollo.MutationFunction<CreateQmrAttachmentMutation, CreateQmrAttachmentMutationVariables>;

/**
 * __useCreateQmrAttachmentMutation__
 *
 * To run a mutation, you first call `useCreateQmrAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQmrAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQmrAttachmentMutation, { data, loading, error }] = useCreateQmrAttachmentMutation({
 *   variables: {
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *      quoteAttachmentRevisionId: // value for 'quoteAttachmentRevisionId'
 *   },
 * });
 */
export function useCreateQmrAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateQmrAttachmentMutation, CreateQmrAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQmrAttachmentMutation, CreateQmrAttachmentMutationVariables>(CreateQmrAttachmentDocument, options);
      }
export type CreateQmrAttachmentMutationHookResult = ReturnType<typeof useCreateQmrAttachmentMutation>;
export type CreateQmrAttachmentMutationResult = Apollo.MutationResult<CreateQmrAttachmentMutation>;
export type CreateQmrAttachmentMutationOptions = Apollo.BaseMutationOptions<CreateQmrAttachmentMutation, CreateQmrAttachmentMutationVariables>;
export const CreateQmrAttachmentAdditionalRequirementsDocument = gql`
    mutation createQmrAttachmentAdditionalRequirements($quoteModelRevisionId: UUID!, $quoteAttachmentRevisionId: UUID!) {
  createQuoteModelRevisionAttachment(
    quoteModelRevisionId: $quoteModelRevisionId
    quoteAttachmentRevisionId: $quoteAttachmentRevisionId
  ) {
    id
    quoteModelRevision {
      id
    }
    quoteAttachmentRevision {
      id
      attachment {
        ... on Attachment {
          id
          fileName
          downloadUrl
        }
      }
    }
  }
}
    `;
export type CreateQmrAttachmentAdditionalRequirementsMutationFn = Apollo.MutationFunction<CreateQmrAttachmentAdditionalRequirementsMutation, CreateQmrAttachmentAdditionalRequirementsMutationVariables>;

/**
 * __useCreateQmrAttachmentAdditionalRequirementsMutation__
 *
 * To run a mutation, you first call `useCreateQmrAttachmentAdditionalRequirementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQmrAttachmentAdditionalRequirementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQmrAttachmentAdditionalRequirementsMutation, { data, loading, error }] = useCreateQmrAttachmentAdditionalRequirementsMutation({
 *   variables: {
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *      quoteAttachmentRevisionId: // value for 'quoteAttachmentRevisionId'
 *   },
 * });
 */
export function useCreateQmrAttachmentAdditionalRequirementsMutation(baseOptions?: Apollo.MutationHookOptions<CreateQmrAttachmentAdditionalRequirementsMutation, CreateQmrAttachmentAdditionalRequirementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQmrAttachmentAdditionalRequirementsMutation, CreateQmrAttachmentAdditionalRequirementsMutationVariables>(CreateQmrAttachmentAdditionalRequirementsDocument, options);
      }
export type CreateQmrAttachmentAdditionalRequirementsMutationHookResult = ReturnType<typeof useCreateQmrAttachmentAdditionalRequirementsMutation>;
export type CreateQmrAttachmentAdditionalRequirementsMutationResult = Apollo.MutationResult<CreateQmrAttachmentAdditionalRequirementsMutation>;
export type CreateQmrAttachmentAdditionalRequirementsMutationOptions = Apollo.BaseMutationOptions<CreateQmrAttachmentAdditionalRequirementsMutation, CreateQmrAttachmentAdditionalRequirementsMutationVariables>;
export const CreateQmrAttachmentAutoAttachDocument = gql`
    mutation createQmrAttachmentAutoAttach($quoteModelRevisionId: UUID!, $quoteAttachmentRevisionId: UUID!) {
  createQuoteModelRevisionAttachment(
    quoteModelRevisionId: $quoteModelRevisionId
    quoteAttachmentRevisionId: $quoteAttachmentRevisionId
  ) {
    id
  }
}
    `;
export type CreateQmrAttachmentAutoAttachMutationFn = Apollo.MutationFunction<CreateQmrAttachmentAutoAttachMutation, CreateQmrAttachmentAutoAttachMutationVariables>;

/**
 * __useCreateQmrAttachmentAutoAttachMutation__
 *
 * To run a mutation, you first call `useCreateQmrAttachmentAutoAttachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQmrAttachmentAutoAttachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQmrAttachmentAutoAttachMutation, { data, loading, error }] = useCreateQmrAttachmentAutoAttachMutation({
 *   variables: {
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *      quoteAttachmentRevisionId: // value for 'quoteAttachmentRevisionId'
 *   },
 * });
 */
export function useCreateQmrAttachmentAutoAttachMutation(baseOptions?: Apollo.MutationHookOptions<CreateQmrAttachmentAutoAttachMutation, CreateQmrAttachmentAutoAttachMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQmrAttachmentAutoAttachMutation, CreateQmrAttachmentAutoAttachMutationVariables>(CreateQmrAttachmentAutoAttachDocument, options);
      }
export type CreateQmrAttachmentAutoAttachMutationHookResult = ReturnType<typeof useCreateQmrAttachmentAutoAttachMutation>;
export type CreateQmrAttachmentAutoAttachMutationResult = Apollo.MutationResult<CreateQmrAttachmentAutoAttachMutation>;
export type CreateQmrAttachmentAutoAttachMutationOptions = Apollo.BaseMutationOptions<CreateQmrAttachmentAutoAttachMutation, CreateQmrAttachmentAutoAttachMutationVariables>;
export const CreateQmrRevisionDocument = gql`
    mutation createQmrRevision($uploadMetadata: QuoteModelRevisionUploadInput!, $quoteId: UUID!, $quoteModelId: UUID, $setAsSelectedForQuoteModel: Boolean!, $revisionNotes: String) {
  createQuoteModelRevision(
    uploadMetadata: $uploadMetadata
    quoteId: $quoteId
    quoteModelId: $quoteModelId
    setAsSelectedForQuoteModel: $setAsSelectedForQuoteModel
    revisionNotes: $revisionNotes
  ) {
    id
    uploadUrl
    partRevision {
      id
      partId
      downloadUri
    }
  }
}
    `;
export type CreateQmrRevisionMutationFn = Apollo.MutationFunction<CreateQmrRevisionMutation, CreateQmrRevisionMutationVariables>;

/**
 * __useCreateQmrRevisionMutation__
 *
 * To run a mutation, you first call `useCreateQmrRevisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQmrRevisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQmrRevisionMutation, { data, loading, error }] = useCreateQmrRevisionMutation({
 *   variables: {
 *      uploadMetadata: // value for 'uploadMetadata'
 *      quoteId: // value for 'quoteId'
 *      quoteModelId: // value for 'quoteModelId'
 *      setAsSelectedForQuoteModel: // value for 'setAsSelectedForQuoteModel'
 *      revisionNotes: // value for 'revisionNotes'
 *   },
 * });
 */
export function useCreateQmrRevisionMutation(baseOptions?: Apollo.MutationHookOptions<CreateQmrRevisionMutation, CreateQmrRevisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQmrRevisionMutation, CreateQmrRevisionMutationVariables>(CreateQmrRevisionDocument, options);
      }
export type CreateQmrRevisionMutationHookResult = ReturnType<typeof useCreateQmrRevisionMutation>;
export type CreateQmrRevisionMutationResult = Apollo.MutationResult<CreateQmrRevisionMutation>;
export type CreateQmrRevisionMutationOptions = Apollo.BaseMutationOptions<CreateQmrRevisionMutation, CreateQmrRevisionMutationVariables>;
export const CreateQuoteAttachmentRevisionDocument = gql`
    mutation createQuoteAttachmentRevision($uploadMetadata: AttachmentInput!, $quoteId: UUID!, $quoteAttachmentId: UUID, $attachmentType: String, $productAttachmentId: String) {
  createQuoteAttachmentRevision(
    uploadMetadata: $uploadMetadata
    quoteId: $quoteId
    quoteAttachmentId: $quoteAttachmentId
    attachmentType: $attachmentType
    productAttachmentId: $productAttachmentId
  ) {
    id
    attachment {
      ... on Attachment {
        id
        fileName
        uploadUrl
      }
    }
    asset {
      id
      fileName
      uploadUrl
    }
  }
}
    `;
export type CreateQuoteAttachmentRevisionMutationFn = Apollo.MutationFunction<CreateQuoteAttachmentRevisionMutation, CreateQuoteAttachmentRevisionMutationVariables>;

/**
 * __useCreateQuoteAttachmentRevisionMutation__
 *
 * To run a mutation, you first call `useCreateQuoteAttachmentRevisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuoteAttachmentRevisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuoteAttachmentRevisionMutation, { data, loading, error }] = useCreateQuoteAttachmentRevisionMutation({
 *   variables: {
 *      uploadMetadata: // value for 'uploadMetadata'
 *      quoteId: // value for 'quoteId'
 *      quoteAttachmentId: // value for 'quoteAttachmentId'
 *      attachmentType: // value for 'attachmentType'
 *      productAttachmentId: // value for 'productAttachmentId'
 *   },
 * });
 */
export function useCreateQuoteAttachmentRevisionMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuoteAttachmentRevisionMutation, CreateQuoteAttachmentRevisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuoteAttachmentRevisionMutation, CreateQuoteAttachmentRevisionMutationVariables>(CreateQuoteAttachmentRevisionDocument, options);
      }
export type CreateQuoteAttachmentRevisionMutationHookResult = ReturnType<typeof useCreateQuoteAttachmentRevisionMutation>;
export type CreateQuoteAttachmentRevisionMutationResult = Apollo.MutationResult<CreateQuoteAttachmentRevisionMutation>;
export type CreateQuoteAttachmentRevisionMutationOptions = Apollo.BaseMutationOptions<CreateQuoteAttachmentRevisionMutation, CreateQuoteAttachmentRevisionMutationVariables>;
export const CreateQuoteModelRevisionAttachmentDocument = gql`
    mutation createQuoteModelRevisionAttachment($quoteModelRevisionId: UUID!, $quoteAttachmentRevisionId: UUID!) {
  createQuoteModelRevisionAttachment(
    quoteModelRevisionId: $quoteModelRevisionId
    quoteAttachmentRevisionId: $quoteAttachmentRevisionId
  ) {
    id
  }
}
    `;
export type CreateQuoteModelRevisionAttachmentMutationFn = Apollo.MutationFunction<CreateQuoteModelRevisionAttachmentMutation, CreateQuoteModelRevisionAttachmentMutationVariables>;

/**
 * __useCreateQuoteModelRevisionAttachmentMutation__
 *
 * To run a mutation, you first call `useCreateQuoteModelRevisionAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuoteModelRevisionAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuoteModelRevisionAttachmentMutation, { data, loading, error }] = useCreateQuoteModelRevisionAttachmentMutation({
 *   variables: {
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *      quoteAttachmentRevisionId: // value for 'quoteAttachmentRevisionId'
 *   },
 * });
 */
export function useCreateQuoteModelRevisionAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuoteModelRevisionAttachmentMutation, CreateQuoteModelRevisionAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuoteModelRevisionAttachmentMutation, CreateQuoteModelRevisionAttachmentMutationVariables>(CreateQuoteModelRevisionAttachmentDocument, options);
      }
export type CreateQuoteModelRevisionAttachmentMutationHookResult = ReturnType<typeof useCreateQuoteModelRevisionAttachmentMutation>;
export type CreateQuoteModelRevisionAttachmentMutationResult = Apollo.MutationResult<CreateQuoteModelRevisionAttachmentMutation>;
export type CreateQuoteModelRevisionAttachmentMutationOptions = Apollo.BaseMutationOptions<CreateQuoteModelRevisionAttachmentMutation, CreateQuoteModelRevisionAttachmentMutationVariables>;
export const CreateTeamDocument = gql`
    mutation createTeam($businessAccountId: UUID!, $name: String!, $userId: Int!) {
  createTeam(businessAccountId: $businessAccountId, name: $name, userId: $userId) {
    team {
      id
    }
  }
}
    `;
export type CreateTeamMutationFn = Apollo.MutationFunction<CreateTeamMutation, CreateTeamMutationVariables>;

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      businessAccountId: // value for 'businessAccountId'
 *      name: // value for 'name'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCreateTeamMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamMutation, CreateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(CreateTeamDocument, options);
      }
export type CreateTeamMutationHookResult = ReturnType<typeof useCreateTeamMutation>;
export type CreateTeamMutationResult = Apollo.MutationResult<CreateTeamMutation>;
export type CreateTeamMutationOptions = Apollo.BaseMutationOptions<CreateTeamMutation, CreateTeamMutationVariables>;
export const DeleteCustomerShippingAccountDocument = gql`
    mutation deleteCustomerShippingAccount($id: UUID!, $userId: Int) {
  destroyCarrierAccount(id: $id, userId: $userId) {
    id
  }
}
    `;
export type DeleteCustomerShippingAccountMutationFn = Apollo.MutationFunction<DeleteCustomerShippingAccountMutation, DeleteCustomerShippingAccountMutationVariables>;

/**
 * __useDeleteCustomerShippingAccountMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerShippingAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerShippingAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerShippingAccountMutation, { data, loading, error }] = useDeleteCustomerShippingAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteCustomerShippingAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomerShippingAccountMutation, DeleteCustomerShippingAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomerShippingAccountMutation, DeleteCustomerShippingAccountMutationVariables>(DeleteCustomerShippingAccountDocument, options);
      }
export type DeleteCustomerShippingAccountMutationHookResult = ReturnType<typeof useDeleteCustomerShippingAccountMutation>;
export type DeleteCustomerShippingAccountMutationResult = Apollo.MutationResult<DeleteCustomerShippingAccountMutation>;
export type DeleteCustomerShippingAccountMutationOptions = Apollo.BaseMutationOptions<DeleteCustomerShippingAccountMutation, DeleteCustomerShippingAccountMutationVariables>;
export const DeletePaymentOptionDocument = gql`
    mutation deletePaymentOption($id: Int!, $cardId: String!) {
  user(id: $id) {
    removeCreditCard(cardId: $cardId) {
      ...PaymentOption
    }
  }
}
    ${PaymentOptionFragmentDoc}`;
export type DeletePaymentOptionMutationFn = Apollo.MutationFunction<DeletePaymentOptionMutation, DeletePaymentOptionMutationVariables>;

/**
 * __useDeletePaymentOptionMutation__
 *
 * To run a mutation, you first call `useDeletePaymentOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentOptionMutation, { data, loading, error }] = useDeletePaymentOptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function useDeletePaymentOptionMutation(baseOptions?: Apollo.MutationHookOptions<DeletePaymentOptionMutation, DeletePaymentOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePaymentOptionMutation, DeletePaymentOptionMutationVariables>(DeletePaymentOptionDocument, options);
      }
export type DeletePaymentOptionMutationHookResult = ReturnType<typeof useDeletePaymentOptionMutation>;
export type DeletePaymentOptionMutationResult = Apollo.MutationResult<DeletePaymentOptionMutation>;
export type DeletePaymentOptionMutationOptions = Apollo.BaseMutationOptions<DeletePaymentOptionMutation, DeletePaymentOptionMutationVariables>;
export const DeleteTeamDocument = gql`
    mutation DeleteTeam($teamId: Int!, $userId: Int!) {
  deleteTeam(teamId: $teamId, userId: $userId) {
    id
  }
}
    `;
export type DeleteTeamMutationFn = Apollo.MutationFunction<DeleteTeamMutation, DeleteTeamMutationVariables>;

/**
 * __useDeleteTeamMutation__
 *
 * To run a mutation, you first call `useDeleteTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamMutation, { data, loading, error }] = useDeleteTeamMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteTeamMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTeamMutation, DeleteTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTeamMutation, DeleteTeamMutationVariables>(DeleteTeamDocument, options);
      }
export type DeleteTeamMutationHookResult = ReturnType<typeof useDeleteTeamMutation>;
export type DeleteTeamMutationResult = Apollo.MutationResult<DeleteTeamMutation>;
export type DeleteTeamMutationOptions = Apollo.BaseMutationOptions<DeleteTeamMutation, DeleteTeamMutationVariables>;
export const DestroyInviteDocument = gql`
    mutation destroyInvite($id: UUID!, $actorOverrideId: Int) {
  destroyInvite(id: $id, actorOverrideId: $actorOverrideId) {
    id
  }
}
    `;
export type DestroyInviteMutationFn = Apollo.MutationFunction<DestroyInviteMutation, DestroyInviteMutationVariables>;

/**
 * __useDestroyInviteMutation__
 *
 * To run a mutation, you first call `useDestroyInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyInviteMutation, { data, loading, error }] = useDestroyInviteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      actorOverrideId: // value for 'actorOverrideId'
 *   },
 * });
 */
export function useDestroyInviteMutation(baseOptions?: Apollo.MutationHookOptions<DestroyInviteMutation, DestroyInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroyInviteMutation, DestroyInviteMutationVariables>(DestroyInviteDocument, options);
      }
export type DestroyInviteMutationHookResult = ReturnType<typeof useDestroyInviteMutation>;
export type DestroyInviteMutationResult = Apollo.MutationResult<DestroyInviteMutation>;
export type DestroyInviteMutationOptions = Apollo.BaseMutationOptions<DestroyInviteMutation, DestroyInviteMutationVariables>;
export const DestroyQuoteModelRevisionTapOnHoleDocument = gql`
    mutation destroyQuoteModelRevisionTapOnHole($quoteModelRevisionId: UUID!, $holeId: String!) {
  destroyQuoteModelRevisionTapOnHole(
    quoteModelRevisionId: $quoteModelRevisionId
    holeId: $holeId
  ) {
    quoteModelRevisionId
    hole {
      id
      tapAnnotation {
        id
        tapOption {
          id
          commonName
        }
      }
    }
  }
}
    `;
export type DestroyQuoteModelRevisionTapOnHoleMutationFn = Apollo.MutationFunction<DestroyQuoteModelRevisionTapOnHoleMutation, DestroyQuoteModelRevisionTapOnHoleMutationVariables>;

/**
 * __useDestroyQuoteModelRevisionTapOnHoleMutation__
 *
 * To run a mutation, you first call `useDestroyQuoteModelRevisionTapOnHoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyQuoteModelRevisionTapOnHoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyQuoteModelRevisionTapOnHoleMutation, { data, loading, error }] = useDestroyQuoteModelRevisionTapOnHoleMutation({
 *   variables: {
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *      holeId: // value for 'holeId'
 *   },
 * });
 */
export function useDestroyQuoteModelRevisionTapOnHoleMutation(baseOptions?: Apollo.MutationHookOptions<DestroyQuoteModelRevisionTapOnHoleMutation, DestroyQuoteModelRevisionTapOnHoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroyQuoteModelRevisionTapOnHoleMutation, DestroyQuoteModelRevisionTapOnHoleMutationVariables>(DestroyQuoteModelRevisionTapOnHoleDocument, options);
      }
export type DestroyQuoteModelRevisionTapOnHoleMutationHookResult = ReturnType<typeof useDestroyQuoteModelRevisionTapOnHoleMutation>;
export type DestroyQuoteModelRevisionTapOnHoleMutationResult = Apollo.MutationResult<DestroyQuoteModelRevisionTapOnHoleMutation>;
export type DestroyQuoteModelRevisionTapOnHoleMutationOptions = Apollo.BaseMutationOptions<DestroyQuoteModelRevisionTapOnHoleMutation, DestroyQuoteModelRevisionTapOnHoleMutationVariables>;
export const DestroyQuoteModelRevisionTapOnHolesDocument = gql`
    mutation destroyQuoteModelRevisionTapOnHoles($quoteModelRevisionId: UUID!, $holesList: [String!]!) {
  destroyQuoteModelRevisionTapOnHoles(
    quoteModelRevisionId: $quoteModelRevisionId
    holesList: $holesList
  ) {
    quoteModelRevisionId
    hole {
      id
      tapAnnotation {
        id
        tapOption {
          id
          commonName
        }
      }
    }
  }
}
    `;
export type DestroyQuoteModelRevisionTapOnHolesMutationFn = Apollo.MutationFunction<DestroyQuoteModelRevisionTapOnHolesMutation, DestroyQuoteModelRevisionTapOnHolesMutationVariables>;

/**
 * __useDestroyQuoteModelRevisionTapOnHolesMutation__
 *
 * To run a mutation, you first call `useDestroyQuoteModelRevisionTapOnHolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyQuoteModelRevisionTapOnHolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyQuoteModelRevisionTapOnHolesMutation, { data, loading, error }] = useDestroyQuoteModelRevisionTapOnHolesMutation({
 *   variables: {
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *      holesList: // value for 'holesList'
 *   },
 * });
 */
export function useDestroyQuoteModelRevisionTapOnHolesMutation(baseOptions?: Apollo.MutationHookOptions<DestroyQuoteModelRevisionTapOnHolesMutation, DestroyQuoteModelRevisionTapOnHolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroyQuoteModelRevisionTapOnHolesMutation, DestroyQuoteModelRevisionTapOnHolesMutationVariables>(DestroyQuoteModelRevisionTapOnHolesDocument, options);
      }
export type DestroyQuoteModelRevisionTapOnHolesMutationHookResult = ReturnType<typeof useDestroyQuoteModelRevisionTapOnHolesMutation>;
export type DestroyQuoteModelRevisionTapOnHolesMutationResult = Apollo.MutationResult<DestroyQuoteModelRevisionTapOnHolesMutation>;
export type DestroyQuoteModelRevisionTapOnHolesMutationOptions = Apollo.BaseMutationOptions<DestroyQuoteModelRevisionTapOnHolesMutation, DestroyQuoteModelRevisionTapOnHolesMutationVariables>;
export const DisableTeamsMutationConfirmationModalDocument = gql`
    mutation disableTeamsMutationConfirmationModal($businessAccountId: String!) {
  disableTeams(businessAccountId: $businessAccountId) {
    isEnabled
  }
}
    `;
export type DisableTeamsMutationConfirmationModalMutationFn = Apollo.MutationFunction<DisableTeamsMutationConfirmationModalMutation, DisableTeamsMutationConfirmationModalMutationVariables>;

/**
 * __useDisableTeamsMutationConfirmationModalMutation__
 *
 * To run a mutation, you first call `useDisableTeamsMutationConfirmationModalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableTeamsMutationConfirmationModalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableTeamsMutationConfirmationModalMutation, { data, loading, error }] = useDisableTeamsMutationConfirmationModalMutation({
 *   variables: {
 *      businessAccountId: // value for 'businessAccountId'
 *   },
 * });
 */
export function useDisableTeamsMutationConfirmationModalMutation(baseOptions?: Apollo.MutationHookOptions<DisableTeamsMutationConfirmationModalMutation, DisableTeamsMutationConfirmationModalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableTeamsMutationConfirmationModalMutation, DisableTeamsMutationConfirmationModalMutationVariables>(DisableTeamsMutationConfirmationModalDocument, options);
      }
export type DisableTeamsMutationConfirmationModalMutationHookResult = ReturnType<typeof useDisableTeamsMutationConfirmationModalMutation>;
export type DisableTeamsMutationConfirmationModalMutationResult = Apollo.MutationResult<DisableTeamsMutationConfirmationModalMutation>;
export type DisableTeamsMutationConfirmationModalMutationOptions = Apollo.BaseMutationOptions<DisableTeamsMutationConfirmationModalMutation, DisableTeamsMutationConfirmationModalMutationVariables>;
export const EnableBusinessAccountMutationConfirmationModalDocument = gql`
    mutation enableBusinessAccountMutationConfirmationModal($businessAccountId: String!) {
  enableBusinessAccount(businessAccountId: $businessAccountId) {
    id
  }
}
    `;
export type EnableBusinessAccountMutationConfirmationModalMutationFn = Apollo.MutationFunction<EnableBusinessAccountMutationConfirmationModalMutation, EnableBusinessAccountMutationConfirmationModalMutationVariables>;

/**
 * __useEnableBusinessAccountMutationConfirmationModalMutation__
 *
 * To run a mutation, you first call `useEnableBusinessAccountMutationConfirmationModalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableBusinessAccountMutationConfirmationModalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableBusinessAccountMutationConfirmationModalMutation, { data, loading, error }] = useEnableBusinessAccountMutationConfirmationModalMutation({
 *   variables: {
 *      businessAccountId: // value for 'businessAccountId'
 *   },
 * });
 */
export function useEnableBusinessAccountMutationConfirmationModalMutation(baseOptions?: Apollo.MutationHookOptions<EnableBusinessAccountMutationConfirmationModalMutation, EnableBusinessAccountMutationConfirmationModalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableBusinessAccountMutationConfirmationModalMutation, EnableBusinessAccountMutationConfirmationModalMutationVariables>(EnableBusinessAccountMutationConfirmationModalDocument, options);
      }
export type EnableBusinessAccountMutationConfirmationModalMutationHookResult = ReturnType<typeof useEnableBusinessAccountMutationConfirmationModalMutation>;
export type EnableBusinessAccountMutationConfirmationModalMutationResult = Apollo.MutationResult<EnableBusinessAccountMutationConfirmationModalMutation>;
export type EnableBusinessAccountMutationConfirmationModalMutationOptions = Apollo.BaseMutationOptions<EnableBusinessAccountMutationConfirmationModalMutation, EnableBusinessAccountMutationConfirmationModalMutationVariables>;
export const EnableTeamsMutationConfirmationModalDocument = gql`
    mutation enableTeamsMutationConfirmationModal($businessAccountId: String!) {
  enableTeams(businessAccountId: $businessAccountId) {
    isEnabled
  }
}
    `;
export type EnableTeamsMutationConfirmationModalMutationFn = Apollo.MutationFunction<EnableTeamsMutationConfirmationModalMutation, EnableTeamsMutationConfirmationModalMutationVariables>;

/**
 * __useEnableTeamsMutationConfirmationModalMutation__
 *
 * To run a mutation, you first call `useEnableTeamsMutationConfirmationModalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableTeamsMutationConfirmationModalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableTeamsMutationConfirmationModalMutation, { data, loading, error }] = useEnableTeamsMutationConfirmationModalMutation({
 *   variables: {
 *      businessAccountId: // value for 'businessAccountId'
 *   },
 * });
 */
export function useEnableTeamsMutationConfirmationModalMutation(baseOptions?: Apollo.MutationHookOptions<EnableTeamsMutationConfirmationModalMutation, EnableTeamsMutationConfirmationModalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableTeamsMutationConfirmationModalMutation, EnableTeamsMutationConfirmationModalMutationVariables>(EnableTeamsMutationConfirmationModalDocument, options);
      }
export type EnableTeamsMutationConfirmationModalMutationHookResult = ReturnType<typeof useEnableTeamsMutationConfirmationModalMutation>;
export type EnableTeamsMutationConfirmationModalMutationResult = Apollo.MutationResult<EnableTeamsMutationConfirmationModalMutation>;
export type EnableTeamsMutationConfirmationModalMutationOptions = Apollo.BaseMutationOptions<EnableTeamsMutationConfirmationModalMutation, EnableTeamsMutationConfirmationModalMutationVariables>;
export const FinalizeUploadAndProcessPartDocument = gql`
    mutation finalizeUploadAndProcessPart($partId: Int!) {
  finalizeUploadAndProcessPart(partId: $partId) {
    partId
    status
    reason
  }
}
    `;
export type FinalizeUploadAndProcessPartMutationFn = Apollo.MutationFunction<FinalizeUploadAndProcessPartMutation, FinalizeUploadAndProcessPartMutationVariables>;

/**
 * __useFinalizeUploadAndProcessPartMutation__
 *
 * To run a mutation, you first call `useFinalizeUploadAndProcessPartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeUploadAndProcessPartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeUploadAndProcessPartMutation, { data, loading, error }] = useFinalizeUploadAndProcessPartMutation({
 *   variables: {
 *      partId: // value for 'partId'
 *   },
 * });
 */
export function useFinalizeUploadAndProcessPartMutation(baseOptions?: Apollo.MutationHookOptions<FinalizeUploadAndProcessPartMutation, FinalizeUploadAndProcessPartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalizeUploadAndProcessPartMutation, FinalizeUploadAndProcessPartMutationVariables>(FinalizeUploadAndProcessPartDocument, options);
      }
export type FinalizeUploadAndProcessPartMutationHookResult = ReturnType<typeof useFinalizeUploadAndProcessPartMutation>;
export type FinalizeUploadAndProcessPartMutationResult = Apollo.MutationResult<FinalizeUploadAndProcessPartMutation>;
export type FinalizeUploadAndProcessPartMutationOptions = Apollo.BaseMutationOptions<FinalizeUploadAndProcessPartMutation, FinalizeUploadAndProcessPartMutationVariables>;
export const MarkQuoteAttachmentRevisionUploadedDocument = gql`
    mutation markQuoteAttachmentRevisionUploaded($id: UUID!) {
  markQuoteAttachmentRevisionUploaded(id: $id) {
    id
    attachment {
      ... on Attachment {
        id
        fileName
        downloadUrl
      }
    }
  }
}
    `;
export type MarkQuoteAttachmentRevisionUploadedMutationFn = Apollo.MutationFunction<MarkQuoteAttachmentRevisionUploadedMutation, MarkQuoteAttachmentRevisionUploadedMutationVariables>;

/**
 * __useMarkQuoteAttachmentRevisionUploadedMutation__
 *
 * To run a mutation, you first call `useMarkQuoteAttachmentRevisionUploadedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkQuoteAttachmentRevisionUploadedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markQuoteAttachmentRevisionUploadedMutation, { data, loading, error }] = useMarkQuoteAttachmentRevisionUploadedMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkQuoteAttachmentRevisionUploadedMutation(baseOptions?: Apollo.MutationHookOptions<MarkQuoteAttachmentRevisionUploadedMutation, MarkQuoteAttachmentRevisionUploadedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkQuoteAttachmentRevisionUploadedMutation, MarkQuoteAttachmentRevisionUploadedMutationVariables>(MarkQuoteAttachmentRevisionUploadedDocument, options);
      }
export type MarkQuoteAttachmentRevisionUploadedMutationHookResult = ReturnType<typeof useMarkQuoteAttachmentRevisionUploadedMutation>;
export type MarkQuoteAttachmentRevisionUploadedMutationResult = Apollo.MutationResult<MarkQuoteAttachmentRevisionUploadedMutation>;
export type MarkQuoteAttachmentRevisionUploadedMutationOptions = Apollo.BaseMutationOptions<MarkQuoteAttachmentRevisionUploadedMutation, MarkQuoteAttachmentRevisionUploadedMutationVariables>;
export const MoveOrderTeamDocument = gql`
    mutation MoveOrderTeam($teamId: Int!, $erpSaleOrderId: Int, $platformOrderId: Int, $userId: Int) {
  moveOrderTeam(
    teamId: $teamId
    erpSaleOrderId: $erpSaleOrderId
    platformOrderId: $platformOrderId
    userId: $userId
  ) {
    id
  }
}
    `;
export type MoveOrderTeamMutationFn = Apollo.MutationFunction<MoveOrderTeamMutation, MoveOrderTeamMutationVariables>;

/**
 * __useMoveOrderTeamMutation__
 *
 * To run a mutation, you first call `useMoveOrderTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveOrderTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveOrderTeamMutation, { data, loading, error }] = useMoveOrderTeamMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      erpSaleOrderId: // value for 'erpSaleOrderId'
 *      platformOrderId: // value for 'platformOrderId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useMoveOrderTeamMutation(baseOptions?: Apollo.MutationHookOptions<MoveOrderTeamMutation, MoveOrderTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveOrderTeamMutation, MoveOrderTeamMutationVariables>(MoveOrderTeamDocument, options);
      }
export type MoveOrderTeamMutationHookResult = ReturnType<typeof useMoveOrderTeamMutation>;
export type MoveOrderTeamMutationResult = Apollo.MutationResult<MoveOrderTeamMutation>;
export type MoveOrderTeamMutationOptions = Apollo.BaseMutationOptions<MoveOrderTeamMutation, MoveOrderTeamMutationVariables>;
export const PlaceOrderDocument = gql`
    mutation placeOrder($orderInput: OrderInput!, $userId: Int) {
  placeOrder(orderInput: $orderInput, userId: $userId) {
    id
    name
  }
}
    `;
export type PlaceOrderMutationFn = Apollo.MutationFunction<PlaceOrderMutation, PlaceOrderMutationVariables>;

/**
 * __usePlaceOrderMutation__
 *
 * To run a mutation, you first call `usePlaceOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaceOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [placeOrderMutation, { data, loading, error }] = usePlaceOrderMutation({
 *   variables: {
 *      orderInput: // value for 'orderInput'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function usePlaceOrderMutation(baseOptions?: Apollo.MutationHookOptions<PlaceOrderMutation, PlaceOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlaceOrderMutation, PlaceOrderMutationVariables>(PlaceOrderDocument, options);
      }
export type PlaceOrderMutationHookResult = ReturnType<typeof usePlaceOrderMutation>;
export type PlaceOrderMutationResult = Apollo.MutationResult<PlaceOrderMutation>;
export type PlaceOrderMutationOptions = Apollo.BaseMutationOptions<PlaceOrderMutation, PlaceOrderMutationVariables>;
export const ReactivateBusinessAccountMemberDocument = gql`
    mutation ReactivateBusinessAccountMember($businessAccountId: String!, $userId: Int!) {
  reactivateBusinessAccountMember(
    businessAccountId: $businessAccountId
    userId: $userId
  )
}
    `;
export type ReactivateBusinessAccountMemberMutationFn = Apollo.MutationFunction<ReactivateBusinessAccountMemberMutation, ReactivateBusinessAccountMemberMutationVariables>;

/**
 * __useReactivateBusinessAccountMemberMutation__
 *
 * To run a mutation, you first call `useReactivateBusinessAccountMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateBusinessAccountMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateBusinessAccountMemberMutation, { data, loading, error }] = useReactivateBusinessAccountMemberMutation({
 *   variables: {
 *      businessAccountId: // value for 'businessAccountId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useReactivateBusinessAccountMemberMutation(baseOptions?: Apollo.MutationHookOptions<ReactivateBusinessAccountMemberMutation, ReactivateBusinessAccountMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactivateBusinessAccountMemberMutation, ReactivateBusinessAccountMemberMutationVariables>(ReactivateBusinessAccountMemberDocument, options);
      }
export type ReactivateBusinessAccountMemberMutationHookResult = ReturnType<typeof useReactivateBusinessAccountMemberMutation>;
export type ReactivateBusinessAccountMemberMutationResult = Apollo.MutationResult<ReactivateBusinessAccountMemberMutation>;
export type ReactivateBusinessAccountMemberMutationOptions = Apollo.BaseMutationOptions<ReactivateBusinessAccountMemberMutation, ReactivateBusinessAccountMemberMutationVariables>;
export const RecordBeganCheckoutEventMutationDocument = gql`
    mutation recordBeganCheckoutEventMutation($quoteId: UUID!) {
  recordSystemEvent(id: $quoteId, name: CHECKOUT_BEGAN)
}
    `;
export type RecordBeganCheckoutEventMutationMutationFn = Apollo.MutationFunction<RecordBeganCheckoutEventMutationMutation, RecordBeganCheckoutEventMutationMutationVariables>;

/**
 * __useRecordBeganCheckoutEventMutationMutation__
 *
 * To run a mutation, you first call `useRecordBeganCheckoutEventMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordBeganCheckoutEventMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordBeganCheckoutEventMutationMutation, { data, loading, error }] = useRecordBeganCheckoutEventMutationMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useRecordBeganCheckoutEventMutationMutation(baseOptions?: Apollo.MutationHookOptions<RecordBeganCheckoutEventMutationMutation, RecordBeganCheckoutEventMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordBeganCheckoutEventMutationMutation, RecordBeganCheckoutEventMutationMutationVariables>(RecordBeganCheckoutEventMutationDocument, options);
      }
export type RecordBeganCheckoutEventMutationMutationHookResult = ReturnType<typeof useRecordBeganCheckoutEventMutationMutation>;
export type RecordBeganCheckoutEventMutationMutationResult = Apollo.MutationResult<RecordBeganCheckoutEventMutationMutation>;
export type RecordBeganCheckoutEventMutationMutationOptions = Apollo.BaseMutationOptions<RecordBeganCheckoutEventMutationMutation, RecordBeganCheckoutEventMutationMutationVariables>;
export const RemoveBusinessAccountMembershipDocument = gql`
    mutation removeBusinessAccountMembership($removeBusinessAccountMembershipId: UUID!) {
  removeBusinessAccountMembership(id: $removeBusinessAccountMembershipId) {
    id
  }
}
    `;
export type RemoveBusinessAccountMembershipMutationFn = Apollo.MutationFunction<RemoveBusinessAccountMembershipMutation, RemoveBusinessAccountMembershipMutationVariables>;

/**
 * __useRemoveBusinessAccountMembershipMutation__
 *
 * To run a mutation, you first call `useRemoveBusinessAccountMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBusinessAccountMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBusinessAccountMembershipMutation, { data, loading, error }] = useRemoveBusinessAccountMembershipMutation({
 *   variables: {
 *      removeBusinessAccountMembershipId: // value for 'removeBusinessAccountMembershipId'
 *   },
 * });
 */
export function useRemoveBusinessAccountMembershipMutation(baseOptions?: Apollo.MutationHookOptions<RemoveBusinessAccountMembershipMutation, RemoveBusinessAccountMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveBusinessAccountMembershipMutation, RemoveBusinessAccountMembershipMutationVariables>(RemoveBusinessAccountMembershipDocument, options);
      }
export type RemoveBusinessAccountMembershipMutationHookResult = ReturnType<typeof useRemoveBusinessAccountMembershipMutation>;
export type RemoveBusinessAccountMembershipMutationResult = Apollo.MutationResult<RemoveBusinessAccountMembershipMutation>;
export type RemoveBusinessAccountMembershipMutationOptions = Apollo.BaseMutationOptions<RemoveBusinessAccountMembershipMutation, RemoveBusinessAccountMembershipMutationVariables>;
export const RemoveManuallyQuotedSecondaryProcessDocument = gql`
    mutation removeManuallyQuotedSecondaryProcess($ids: [UUID!]!, $processId: String) {
  removeManuallyQuotedSecondaryProcess(ids: $ids, processId: $processId)
}
    `;
export type RemoveManuallyQuotedSecondaryProcessMutationFn = Apollo.MutationFunction<RemoveManuallyQuotedSecondaryProcessMutation, RemoveManuallyQuotedSecondaryProcessMutationVariables>;

/**
 * __useRemoveManuallyQuotedSecondaryProcessMutation__
 *
 * To run a mutation, you first call `useRemoveManuallyQuotedSecondaryProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveManuallyQuotedSecondaryProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeManuallyQuotedSecondaryProcessMutation, { data, loading, error }] = useRemoveManuallyQuotedSecondaryProcessMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useRemoveManuallyQuotedSecondaryProcessMutation(baseOptions?: Apollo.MutationHookOptions<RemoveManuallyQuotedSecondaryProcessMutation, RemoveManuallyQuotedSecondaryProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveManuallyQuotedSecondaryProcessMutation, RemoveManuallyQuotedSecondaryProcessMutationVariables>(RemoveManuallyQuotedSecondaryProcessDocument, options);
      }
export type RemoveManuallyQuotedSecondaryProcessMutationHookResult = ReturnType<typeof useRemoveManuallyQuotedSecondaryProcessMutation>;
export type RemoveManuallyQuotedSecondaryProcessMutationResult = Apollo.MutationResult<RemoveManuallyQuotedSecondaryProcessMutation>;
export type RemoveManuallyQuotedSecondaryProcessMutationOptions = Apollo.BaseMutationOptions<RemoveManuallyQuotedSecondaryProcessMutation, RemoveManuallyQuotedSecondaryProcessMutationVariables>;
export const RemoveMembershipDocument = gql`
    mutation removeMembership($id: UUID!, $actorOverrideId: Int) {
  removeMembership(id: $id, actorOverrideId: $actorOverrideId) {
    id
  }
}
    `;
export type RemoveMembershipMutationFn = Apollo.MutationFunction<RemoveMembershipMutation, RemoveMembershipMutationVariables>;

/**
 * __useRemoveMembershipMutation__
 *
 * To run a mutation, you first call `useRemoveMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMembershipMutation, { data, loading, error }] = useRemoveMembershipMutation({
 *   variables: {
 *      id: // value for 'id'
 *      actorOverrideId: // value for 'actorOverrideId'
 *   },
 * });
 */
export function useRemoveMembershipMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMembershipMutation, RemoveMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMembershipMutation, RemoveMembershipMutationVariables>(RemoveMembershipDocument, options);
      }
export type RemoveMembershipMutationHookResult = ReturnType<typeof useRemoveMembershipMutation>;
export type RemoveMembershipMutationResult = Apollo.MutationResult<RemoveMembershipMutation>;
export type RemoveMembershipMutationOptions = Apollo.BaseMutationOptions<RemoveMembershipMutation, RemoveMembershipMutationVariables>;
export const RemoveOrderTeamMembershipDocument = gql`
    mutation RemoveOrderTeamMembership($teamId: Int!, $platformOrderId: Int, $erpSaleOrderId: Int, $userId: Int) {
  removeOrderTeamMembership(
    teamId: $teamId
    platformOrderId: $platformOrderId
    erpSaleOrderId: $erpSaleOrderId
    userId: $userId
  ) {
    id
  }
}
    `;
export type RemoveOrderTeamMembershipMutationFn = Apollo.MutationFunction<RemoveOrderTeamMembershipMutation, RemoveOrderTeamMembershipMutationVariables>;

/**
 * __useRemoveOrderTeamMembershipMutation__
 *
 * To run a mutation, you first call `useRemoveOrderTeamMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOrderTeamMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOrderTeamMembershipMutation, { data, loading, error }] = useRemoveOrderTeamMembershipMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      platformOrderId: // value for 'platformOrderId'
 *      erpSaleOrderId: // value for 'erpSaleOrderId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveOrderTeamMembershipMutation(baseOptions?: Apollo.MutationHookOptions<RemoveOrderTeamMembershipMutation, RemoveOrderTeamMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveOrderTeamMembershipMutation, RemoveOrderTeamMembershipMutationVariables>(RemoveOrderTeamMembershipDocument, options);
      }
export type RemoveOrderTeamMembershipMutationHookResult = ReturnType<typeof useRemoveOrderTeamMembershipMutation>;
export type RemoveOrderTeamMembershipMutationResult = Apollo.MutationResult<RemoveOrderTeamMembershipMutation>;
export type RemoveOrderTeamMembershipMutationOptions = Apollo.BaseMutationOptions<RemoveOrderTeamMembershipMutation, RemoveOrderTeamMembershipMutationVariables>;
export const RemoveQmrAttachmentAdditionalRequirementsDocument = gql`
    mutation removeQmrAttachmentAdditionalRequirements($quoteModelRevisionId: UUID!, $quoteAttachmentRevisionId: UUID!, $userId: Int, $quoteId: UUID) {
  removeQuoteModelRevisionAttachment(
    quoteModelRevisionId: $quoteModelRevisionId
    quoteAttachmentRevisionId: $quoteAttachmentRevisionId
    userId: $userId
    quoteId: $quoteId
  ) {
    id
    quoteModelRevision {
      id
    }
  }
}
    `;
export type RemoveQmrAttachmentAdditionalRequirementsMutationFn = Apollo.MutationFunction<RemoveQmrAttachmentAdditionalRequirementsMutation, RemoveQmrAttachmentAdditionalRequirementsMutationVariables>;

/**
 * __useRemoveQmrAttachmentAdditionalRequirementsMutation__
 *
 * To run a mutation, you first call `useRemoveQmrAttachmentAdditionalRequirementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveQmrAttachmentAdditionalRequirementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeQmrAttachmentAdditionalRequirementsMutation, { data, loading, error }] = useRemoveQmrAttachmentAdditionalRequirementsMutation({
 *   variables: {
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *      quoteAttachmentRevisionId: // value for 'quoteAttachmentRevisionId'
 *      userId: // value for 'userId'
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useRemoveQmrAttachmentAdditionalRequirementsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveQmrAttachmentAdditionalRequirementsMutation, RemoveQmrAttachmentAdditionalRequirementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveQmrAttachmentAdditionalRequirementsMutation, RemoveQmrAttachmentAdditionalRequirementsMutationVariables>(RemoveQmrAttachmentAdditionalRequirementsDocument, options);
      }
export type RemoveQmrAttachmentAdditionalRequirementsMutationHookResult = ReturnType<typeof useRemoveQmrAttachmentAdditionalRequirementsMutation>;
export type RemoveQmrAttachmentAdditionalRequirementsMutationResult = Apollo.MutationResult<RemoveQmrAttachmentAdditionalRequirementsMutation>;
export type RemoveQmrAttachmentAdditionalRequirementsMutationOptions = Apollo.BaseMutationOptions<RemoveQmrAttachmentAdditionalRequirementsMutation, RemoveQmrAttachmentAdditionalRequirementsMutationVariables>;
export const RemoveShippingAddressQuoteCheckoutPageDocument = gql`
    mutation removeShippingAddressQuoteCheckoutPage($userId: Int!, $id: Int!) {
  user(id: $userId) {
    removeShippingAddress(id: $id) {
      ...ShippingAddressesItem
    }
  }
}
    ${ShippingAddressesItemFragmentDoc}`;
export type RemoveShippingAddressQuoteCheckoutPageMutationFn = Apollo.MutationFunction<RemoveShippingAddressQuoteCheckoutPageMutation, RemoveShippingAddressQuoteCheckoutPageMutationVariables>;

/**
 * __useRemoveShippingAddressQuoteCheckoutPageMutation__
 *
 * To run a mutation, you first call `useRemoveShippingAddressQuoteCheckoutPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveShippingAddressQuoteCheckoutPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeShippingAddressQuoteCheckoutPageMutation, { data, loading, error }] = useRemoveShippingAddressQuoteCheckoutPageMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveShippingAddressQuoteCheckoutPageMutation(baseOptions?: Apollo.MutationHookOptions<RemoveShippingAddressQuoteCheckoutPageMutation, RemoveShippingAddressQuoteCheckoutPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveShippingAddressQuoteCheckoutPageMutation, RemoveShippingAddressQuoteCheckoutPageMutationVariables>(RemoveShippingAddressQuoteCheckoutPageDocument, options);
      }
export type RemoveShippingAddressQuoteCheckoutPageMutationHookResult = ReturnType<typeof useRemoveShippingAddressQuoteCheckoutPageMutation>;
export type RemoveShippingAddressQuoteCheckoutPageMutationResult = Apollo.MutationResult<RemoveShippingAddressQuoteCheckoutPageMutation>;
export type RemoveShippingAddressQuoteCheckoutPageMutationOptions = Apollo.BaseMutationOptions<RemoveShippingAddressQuoteCheckoutPageMutation, RemoveShippingAddressQuoteCheckoutPageMutationVariables>;
export const RenameTeamDocument = gql`
    mutation RenameTeam($teamId: Int!, $name: String!, $userId: Int!) {
  renameTeam(teamId: $teamId, name: $name, userId: $userId) {
    id
  }
}
    `;
export type RenameTeamMutationFn = Apollo.MutationFunction<RenameTeamMutation, RenameTeamMutationVariables>;

/**
 * __useRenameTeamMutation__
 *
 * To run a mutation, you first call `useRenameTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameTeamMutation, { data, loading, error }] = useRenameTeamMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      name: // value for 'name'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRenameTeamMutation(baseOptions?: Apollo.MutationHookOptions<RenameTeamMutation, RenameTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameTeamMutation, RenameTeamMutationVariables>(RenameTeamDocument, options);
      }
export type RenameTeamMutationHookResult = ReturnType<typeof useRenameTeamMutation>;
export type RenameTeamMutationResult = Apollo.MutationResult<RenameTeamMutation>;
export type RenameTeamMutationOptions = Apollo.BaseMutationOptions<RenameTeamMutation, RenameTeamMutationVariables>;
export const ResendBusinessAccountInviteDocument = gql`
    mutation resendBusinessAccountInvite($businessAccountInviteId: UUID!) {
  resendBusinessAccountInvite(businessAccountInviteId: $businessAccountInviteId) {
    id
    email
    sentDate
    status
    inviteUrl
  }
}
    `;
export type ResendBusinessAccountInviteMutationFn = Apollo.MutationFunction<ResendBusinessAccountInviteMutation, ResendBusinessAccountInviteMutationVariables>;

/**
 * __useResendBusinessAccountInviteMutation__
 *
 * To run a mutation, you first call `useResendBusinessAccountInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendBusinessAccountInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendBusinessAccountInviteMutation, { data, loading, error }] = useResendBusinessAccountInviteMutation({
 *   variables: {
 *      businessAccountInviteId: // value for 'businessAccountInviteId'
 *   },
 * });
 */
export function useResendBusinessAccountInviteMutation(baseOptions?: Apollo.MutationHookOptions<ResendBusinessAccountInviteMutation, ResendBusinessAccountInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendBusinessAccountInviteMutation, ResendBusinessAccountInviteMutationVariables>(ResendBusinessAccountInviteDocument, options);
      }
export type ResendBusinessAccountInviteMutationHookResult = ReturnType<typeof useResendBusinessAccountInviteMutation>;
export type ResendBusinessAccountInviteMutationResult = Apollo.MutationResult<ResendBusinessAccountInviteMutation>;
export type ResendBusinessAccountInviteMutationOptions = Apollo.BaseMutationOptions<ResendBusinessAccountInviteMutation, ResendBusinessAccountInviteMutationVariables>;
export const RevokeBusinessAccountInvitesDocument = gql`
    mutation revokeBusinessAccountInvites($inviteIds: [UUID!]!) {
  revokeBusinessAccountInvites(inviteIds: $inviteIds) {
    id
    email
  }
}
    `;
export type RevokeBusinessAccountInvitesMutationFn = Apollo.MutationFunction<RevokeBusinessAccountInvitesMutation, RevokeBusinessAccountInvitesMutationVariables>;

/**
 * __useRevokeBusinessAccountInvitesMutation__
 *
 * To run a mutation, you first call `useRevokeBusinessAccountInvitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeBusinessAccountInvitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeBusinessAccountInvitesMutation, { data, loading, error }] = useRevokeBusinessAccountInvitesMutation({
 *   variables: {
 *      inviteIds: // value for 'inviteIds'
 *   },
 * });
 */
export function useRevokeBusinessAccountInvitesMutation(baseOptions?: Apollo.MutationHookOptions<RevokeBusinessAccountInvitesMutation, RevokeBusinessAccountInvitesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeBusinessAccountInvitesMutation, RevokeBusinessAccountInvitesMutationVariables>(RevokeBusinessAccountInvitesDocument, options);
      }
export type RevokeBusinessAccountInvitesMutationHookResult = ReturnType<typeof useRevokeBusinessAccountInvitesMutation>;
export type RevokeBusinessAccountInvitesMutationResult = Apollo.MutationResult<RevokeBusinessAccountInvitesMutation>;
export type RevokeBusinessAccountInvitesMutationOptions = Apollo.BaseMutationOptions<RevokeBusinessAccountInvitesMutation, RevokeBusinessAccountInvitesMutationVariables>;
export const SaveUserPreferencesDocument = gql`
    mutation saveUserPreferences($userId: Int!, $preferenceType: PreferenceType!, $name: String!, $value: JSON) {
  updateOrAddUserPreference(
    userId: $userId
    preferenceType: $preferenceType
    name: $name
    value: $value
  ) {
    id
    preferences
  }
}
    `;
export type SaveUserPreferencesMutationFn = Apollo.MutationFunction<SaveUserPreferencesMutation, SaveUserPreferencesMutationVariables>;

/**
 * __useSaveUserPreferencesMutation__
 *
 * To run a mutation, you first call `useSaveUserPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUserPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUserPreferencesMutation, { data, loading, error }] = useSaveUserPreferencesMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      preferenceType: // value for 'preferenceType'
 *      name: // value for 'name'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useSaveUserPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<SaveUserPreferencesMutation, SaveUserPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUserPreferencesMutation, SaveUserPreferencesMutationVariables>(SaveUserPreferencesDocument, options);
      }
export type SaveUserPreferencesMutationHookResult = ReturnType<typeof useSaveUserPreferencesMutation>;
export type SaveUserPreferencesMutationResult = Apollo.MutationResult<SaveUserPreferencesMutation>;
export type SaveUserPreferencesMutationOptions = Apollo.BaseMutationOptions<SaveUserPreferencesMutation, SaveUserPreferencesMutationVariables>;
export const ShareQuoteDocument = gql`
    mutation shareQuote($quoteId: UUID!, $emailAttributes: EmailAttributesInput, $emailSpecificInput: EmailSpecificInput!, $includePdfInput: IncludePdfInput) {
  shareQuote(
    quoteId: $quoteId
    emailSpecificInput: $emailSpecificInput
    emailAttributes: $emailAttributes
    includePdfInput: $includePdfInput
  ) {
    id
    email
    quoteUrl
  }
}
    `;
export type ShareQuoteMutationFn = Apollo.MutationFunction<ShareQuoteMutation, ShareQuoteMutationVariables>;

/**
 * __useShareQuoteMutation__
 *
 * To run a mutation, you first call `useShareQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareQuoteMutation, { data, loading, error }] = useShareQuoteMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      emailAttributes: // value for 'emailAttributes'
 *      emailSpecificInput: // value for 'emailSpecificInput'
 *      includePdfInput: // value for 'includePdfInput'
 *   },
 * });
 */
export function useShareQuoteMutation(baseOptions?: Apollo.MutationHookOptions<ShareQuoteMutation, ShareQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareQuoteMutation, ShareQuoteMutationVariables>(ShareQuoteDocument, options);
      }
export type ShareQuoteMutationHookResult = ReturnType<typeof useShareQuoteMutation>;
export type ShareQuoteMutationResult = Apollo.MutationResult<ShareQuoteMutation>;
export type ShareQuoteMutationOptions = Apollo.BaseMutationOptions<ShareQuoteMutation, ShareQuoteMutationVariables>;
export const UpdateAdditionalRequirementOnQmrDocument = gql`
    mutation updateAdditionalRequirementOnQmr($id: UUID!, $notes: String!) {
  updateAdditionalRequirementOnQmr(id: $id, notes: $notes) {
    id
    modelConfiguration {
      ...BuilderModelConfiguration
    }
  }
}
    ${BuilderModelConfigurationFragmentDoc}`;
export type UpdateAdditionalRequirementOnQmrMutationFn = Apollo.MutationFunction<UpdateAdditionalRequirementOnQmrMutation, UpdateAdditionalRequirementOnQmrMutationVariables>;

/**
 * __useUpdateAdditionalRequirementOnQmrMutation__
 *
 * To run a mutation, you first call `useUpdateAdditionalRequirementOnQmrMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdditionalRequirementOnQmrMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdditionalRequirementOnQmrMutation, { data, loading, error }] = useUpdateAdditionalRequirementOnQmrMutation({
 *   variables: {
 *      id: // value for 'id'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUpdateAdditionalRequirementOnQmrMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdditionalRequirementOnQmrMutation, UpdateAdditionalRequirementOnQmrMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdditionalRequirementOnQmrMutation, UpdateAdditionalRequirementOnQmrMutationVariables>(UpdateAdditionalRequirementOnQmrDocument, options);
      }
export type UpdateAdditionalRequirementOnQmrMutationHookResult = ReturnType<typeof useUpdateAdditionalRequirementOnQmrMutation>;
export type UpdateAdditionalRequirementOnQmrMutationResult = Apollo.MutationResult<UpdateAdditionalRequirementOnQmrMutation>;
export type UpdateAdditionalRequirementOnQmrMutationOptions = Apollo.BaseMutationOptions<UpdateAdditionalRequirementOnQmrMutation, UpdateAdditionalRequirementOnQmrMutationVariables>;
export const UpdateCustomerShippingAccountDocument = gql`
    mutation updateCustomerShippingAccount($id: UUID!, $account: TplCarrierAccountUpdateInput!, $userId: Int) {
  updateCarrierAccount(id: $id, account: $account, userId: $userId) {
    id
    provider
  }
}
    `;
export type UpdateCustomerShippingAccountMutationFn = Apollo.MutationFunction<UpdateCustomerShippingAccountMutation, UpdateCustomerShippingAccountMutationVariables>;

/**
 * __useUpdateCustomerShippingAccountMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerShippingAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerShippingAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerShippingAccountMutation, { data, loading, error }] = useUpdateCustomerShippingAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      account: // value for 'account'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateCustomerShippingAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerShippingAccountMutation, UpdateCustomerShippingAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerShippingAccountMutation, UpdateCustomerShippingAccountMutationVariables>(UpdateCustomerShippingAccountDocument, options);
      }
export type UpdateCustomerShippingAccountMutationHookResult = ReturnType<typeof useUpdateCustomerShippingAccountMutation>;
export type UpdateCustomerShippingAccountMutationResult = Apollo.MutationResult<UpdateCustomerShippingAccountMutation>;
export type UpdateCustomerShippingAccountMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerShippingAccountMutation, UpdateCustomerShippingAccountMutationVariables>;
export const UpdatePasswordUserProfileDocument = gql`
    mutation updatePasswordUserProfile($id: Int!, $currentPassword: String!, $newPassword: String!) {
  user(id: $id) {
    editPassword(currentPassword: $currentPassword, newPassword: $newPassword) {
      id
    }
  }
}
    `;
export type UpdatePasswordUserProfileMutationFn = Apollo.MutationFunction<UpdatePasswordUserProfileMutation, UpdatePasswordUserProfileMutationVariables>;

/**
 * __useUpdatePasswordUserProfileMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordUserProfileMutation, { data, loading, error }] = useUpdatePasswordUserProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      currentPassword: // value for 'currentPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useUpdatePasswordUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePasswordUserProfileMutation, UpdatePasswordUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePasswordUserProfileMutation, UpdatePasswordUserProfileMutationVariables>(UpdatePasswordUserProfileDocument, options);
      }
export type UpdatePasswordUserProfileMutationHookResult = ReturnType<typeof useUpdatePasswordUserProfileMutation>;
export type UpdatePasswordUserProfileMutationResult = Apollo.MutationResult<UpdatePasswordUserProfileMutation>;
export type UpdatePasswordUserProfileMutationOptions = Apollo.BaseMutationOptions<UpdatePasswordUserProfileMutation, UpdatePasswordUserProfileMutationVariables>;
export const UpdateProcessConfigsOnQmrsDocument = gql`
    mutation updateProcessConfigsOnQmrs($ids: [UUID!]!, $primaryProcessConfig: PrimaryProcessConfigInput!, $secondaryProcessConfigs: [SecondaryProcessConfigInput!]!, $removeManuallyQuotedSecondaryProcesses: Boolean) {
  updateProcessConfigsOnQuoteModelRevisions(
    ids: $ids
    primaryProcessConfig: $primaryProcessConfig
    secondaryProcessConfigs: $secondaryProcessConfigs
    removeManuallyQuotedSecondaryProcesses: $removeManuallyQuotedSecondaryProcesses
  ) {
    id
    modelConfiguration {
      ...BuilderModelConfiguration
    }
    quantityRangeStatus
    processesDetails {
      primaryProcess {
        process {
          id
          name
          platformProcessTypeId
        }
        price {
          ... on ExactPrice {
            priceInCents
            unitPriceInCents
          }
          ... on EstimatedPrice {
            lowPriceInCents
            lowUnitPriceInCents
            highPriceInCents
            highUnitPriceInCents
          }
        }
      }
      postProcesses {
        postProcess {
          id
          name
        }
        unitPriceInCents
        postProcessLeadTimeInDays
        postProcessThickness {
          id
        }
        postProcessColor {
          id
        }
        postProcessNumParts
        postProcessInspectionCriteria
      }
      secondaryProcesses {
        process {
          id
          name
        }
        unitPriceInCents
        leadTimeInDays
        notes
      }
      totalPrice {
        ... on ExactPrice {
          priceInCents
          unitPriceInCents
        }
        ... on EstimatedPrice {
          lowPriceInCents
          lowUnitPriceInCents
          highPriceInCents
          highUnitPriceInCents
        }
      }
    }
  }
}
    ${BuilderModelConfigurationFragmentDoc}`;
export type UpdateProcessConfigsOnQmrsMutationFn = Apollo.MutationFunction<UpdateProcessConfigsOnQmrsMutation, UpdateProcessConfigsOnQmrsMutationVariables>;

/**
 * __useUpdateProcessConfigsOnQmrsMutation__
 *
 * To run a mutation, you first call `useUpdateProcessConfigsOnQmrsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProcessConfigsOnQmrsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProcessConfigsOnQmrsMutation, { data, loading, error }] = useUpdateProcessConfigsOnQmrsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      primaryProcessConfig: // value for 'primaryProcessConfig'
 *      secondaryProcessConfigs: // value for 'secondaryProcessConfigs'
 *      removeManuallyQuotedSecondaryProcesses: // value for 'removeManuallyQuotedSecondaryProcesses'
 *   },
 * });
 */
export function useUpdateProcessConfigsOnQmrsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProcessConfigsOnQmrsMutation, UpdateProcessConfigsOnQmrsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProcessConfigsOnQmrsMutation, UpdateProcessConfigsOnQmrsMutationVariables>(UpdateProcessConfigsOnQmrsDocument, options);
      }
export type UpdateProcessConfigsOnQmrsMutationHookResult = ReturnType<typeof useUpdateProcessConfigsOnQmrsMutation>;
export type UpdateProcessConfigsOnQmrsMutationResult = Apollo.MutationResult<UpdateProcessConfigsOnQmrsMutation>;
export type UpdateProcessConfigsOnQmrsMutationOptions = Apollo.BaseMutationOptions<UpdateProcessConfigsOnQmrsMutation, UpdateProcessConfigsOnQmrsMutationVariables>;
export const UpdateQuoteStatusToDraftCheckoutSummaryDocument = gql`
    mutation updateQuoteStatusToDraftCheckoutSummary($id: UUID!) {
  updateQuoteStatusToDraft(id: $id) {
    id
    status
    isQuoteInRfqState
  }
}
    `;
export type UpdateQuoteStatusToDraftCheckoutSummaryMutationFn = Apollo.MutationFunction<UpdateQuoteStatusToDraftCheckoutSummaryMutation, UpdateQuoteStatusToDraftCheckoutSummaryMutationVariables>;

/**
 * __useUpdateQuoteStatusToDraftCheckoutSummaryMutation__
 *
 * To run a mutation, you first call `useUpdateQuoteStatusToDraftCheckoutSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuoteStatusToDraftCheckoutSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuoteStatusToDraftCheckoutSummaryMutation, { data, loading, error }] = useUpdateQuoteStatusToDraftCheckoutSummaryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateQuoteStatusToDraftCheckoutSummaryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuoteStatusToDraftCheckoutSummaryMutation, UpdateQuoteStatusToDraftCheckoutSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuoteStatusToDraftCheckoutSummaryMutation, UpdateQuoteStatusToDraftCheckoutSummaryMutationVariables>(UpdateQuoteStatusToDraftCheckoutSummaryDocument, options);
      }
export type UpdateQuoteStatusToDraftCheckoutSummaryMutationHookResult = ReturnType<typeof useUpdateQuoteStatusToDraftCheckoutSummaryMutation>;
export type UpdateQuoteStatusToDraftCheckoutSummaryMutationResult = Apollo.MutationResult<UpdateQuoteStatusToDraftCheckoutSummaryMutation>;
export type UpdateQuoteStatusToDraftCheckoutSummaryMutationOptions = Apollo.BaseMutationOptions<UpdateQuoteStatusToDraftCheckoutSummaryMutation, UpdateQuoteStatusToDraftCheckoutSummaryMutationVariables>;
export const UpdateQuoteZipTaxModalDocument = gql`
    mutation updateQuoteZipTaxModal($id: UUID!, $zipCode: String!) {
  updateQuote(id: $id, input: {zipCode: $zipCode}) {
    id
    zipCode
  }
}
    `;
export type UpdateQuoteZipTaxModalMutationFn = Apollo.MutationFunction<UpdateQuoteZipTaxModalMutation, UpdateQuoteZipTaxModalMutationVariables>;

/**
 * __useUpdateQuoteZipTaxModalMutation__
 *
 * To run a mutation, you first call `useUpdateQuoteZipTaxModalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuoteZipTaxModalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuoteZipTaxModalMutation, { data, loading, error }] = useUpdateQuoteZipTaxModalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useUpdateQuoteZipTaxModalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuoteZipTaxModalMutation, UpdateQuoteZipTaxModalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuoteZipTaxModalMutation, UpdateQuoteZipTaxModalMutationVariables>(UpdateQuoteZipTaxModalDocument, options);
      }
export type UpdateQuoteZipTaxModalMutationHookResult = ReturnType<typeof useUpdateQuoteZipTaxModalMutation>;
export type UpdateQuoteZipTaxModalMutationResult = Apollo.MutationResult<UpdateQuoteZipTaxModalMutation>;
export type UpdateQuoteZipTaxModalMutationOptions = Apollo.BaseMutationOptions<UpdateQuoteZipTaxModalMutation, UpdateQuoteZipTaxModalMutationVariables>;
export const UpdateTaxExemptFieldTaxModalDocument = gql`
    mutation updateTaxExemptFieldTaxModal($id: UUID!, $isTaxExempt: Boolean!, $userId: Int) {
  updateTaxExemptField(id: $id, isTaxExempt: $isTaxExempt, userId: $userId) {
    id
    isTaxExempt
  }
}
    `;
export type UpdateTaxExemptFieldTaxModalMutationFn = Apollo.MutationFunction<UpdateTaxExemptFieldTaxModalMutation, UpdateTaxExemptFieldTaxModalMutationVariables>;

/**
 * __useUpdateTaxExemptFieldTaxModalMutation__
 *
 * To run a mutation, you first call `useUpdateTaxExemptFieldTaxModalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaxExemptFieldTaxModalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaxExemptFieldTaxModalMutation, { data, loading, error }] = useUpdateTaxExemptFieldTaxModalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isTaxExempt: // value for 'isTaxExempt'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateTaxExemptFieldTaxModalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaxExemptFieldTaxModalMutation, UpdateTaxExemptFieldTaxModalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaxExemptFieldTaxModalMutation, UpdateTaxExemptFieldTaxModalMutationVariables>(UpdateTaxExemptFieldTaxModalDocument, options);
      }
export type UpdateTaxExemptFieldTaxModalMutationHookResult = ReturnType<typeof useUpdateTaxExemptFieldTaxModalMutation>;
export type UpdateTaxExemptFieldTaxModalMutationResult = Apollo.MutationResult<UpdateTaxExemptFieldTaxModalMutation>;
export type UpdateTaxExemptFieldTaxModalMutationOptions = Apollo.BaseMutationOptions<UpdateTaxExemptFieldTaxModalMutation, UpdateTaxExemptFieldTaxModalMutationVariables>;
export const UpsertQuoteModelRevisionTapOnHoleDocument = gql`
    mutation upsertQuoteModelRevisionTapOnHole($quoteModelRevisionId: UUID!, $holeId: String!, $tapOptionId: String!) {
  upsertQuoteModelRevisionTapOnHole(
    quoteModelRevisionId: $quoteModelRevisionId
    holeId: $holeId
    tapOptionId: $tapOptionId
  ) {
    quoteModelRevisionId
    hole {
      id
      tapAnnotation {
        id
        depth
        tapOption {
          id
          commonName
        }
      }
    }
  }
}
    `;
export type UpsertQuoteModelRevisionTapOnHoleMutationFn = Apollo.MutationFunction<UpsertQuoteModelRevisionTapOnHoleMutation, UpsertQuoteModelRevisionTapOnHoleMutationVariables>;

/**
 * __useUpsertQuoteModelRevisionTapOnHoleMutation__
 *
 * To run a mutation, you first call `useUpsertQuoteModelRevisionTapOnHoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertQuoteModelRevisionTapOnHoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertQuoteModelRevisionTapOnHoleMutation, { data, loading, error }] = useUpsertQuoteModelRevisionTapOnHoleMutation({
 *   variables: {
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *      holeId: // value for 'holeId'
 *      tapOptionId: // value for 'tapOptionId'
 *   },
 * });
 */
export function useUpsertQuoteModelRevisionTapOnHoleMutation(baseOptions?: Apollo.MutationHookOptions<UpsertQuoteModelRevisionTapOnHoleMutation, UpsertQuoteModelRevisionTapOnHoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertQuoteModelRevisionTapOnHoleMutation, UpsertQuoteModelRevisionTapOnHoleMutationVariables>(UpsertQuoteModelRevisionTapOnHoleDocument, options);
      }
export type UpsertQuoteModelRevisionTapOnHoleMutationHookResult = ReturnType<typeof useUpsertQuoteModelRevisionTapOnHoleMutation>;
export type UpsertQuoteModelRevisionTapOnHoleMutationResult = Apollo.MutationResult<UpsertQuoteModelRevisionTapOnHoleMutation>;
export type UpsertQuoteModelRevisionTapOnHoleMutationOptions = Apollo.BaseMutationOptions<UpsertQuoteModelRevisionTapOnHoleMutation, UpsertQuoteModelRevisionTapOnHoleMutationVariables>;
export const UpsertQuoteModelRevisionTapOnHolesDocument = gql`
    mutation upsertQuoteModelRevisionTapOnHoles($quoteModelRevisionId: UUID!, $holesList: [String!]!, $tapOptionId: String!) {
  upsertQuoteModelRevisionTapOnHoles(
    quoteModelRevisionId: $quoteModelRevisionId
    holesList: $holesList
    tapOptionId: $tapOptionId
  ) {
    quoteModelRevisionId
    hole {
      id
      tapAnnotation {
        id
        depth
        tapOption {
          id
          commonName
        }
      }
    }
  }
}
    `;
export type UpsertQuoteModelRevisionTapOnHolesMutationFn = Apollo.MutationFunction<UpsertQuoteModelRevisionTapOnHolesMutation, UpsertQuoteModelRevisionTapOnHolesMutationVariables>;

/**
 * __useUpsertQuoteModelRevisionTapOnHolesMutation__
 *
 * To run a mutation, you first call `useUpsertQuoteModelRevisionTapOnHolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertQuoteModelRevisionTapOnHolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertQuoteModelRevisionTapOnHolesMutation, { data, loading, error }] = useUpsertQuoteModelRevisionTapOnHolesMutation({
 *   variables: {
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *      holesList: // value for 'holesList'
 *      tapOptionId: // value for 'tapOptionId'
 *   },
 * });
 */
export function useUpsertQuoteModelRevisionTapOnHolesMutation(baseOptions?: Apollo.MutationHookOptions<UpsertQuoteModelRevisionTapOnHolesMutation, UpsertQuoteModelRevisionTapOnHolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertQuoteModelRevisionTapOnHolesMutation, UpsertQuoteModelRevisionTapOnHolesMutationVariables>(UpsertQuoteModelRevisionTapOnHolesDocument, options);
      }
export type UpsertQuoteModelRevisionTapOnHolesMutationHookResult = ReturnType<typeof useUpsertQuoteModelRevisionTapOnHolesMutation>;
export type UpsertQuoteModelRevisionTapOnHolesMutationResult = Apollo.MutationResult<UpsertQuoteModelRevisionTapOnHolesMutation>;
export type UpsertQuoteModelRevisionTapOnHolesMutationOptions = Apollo.BaseMutationOptions<UpsertQuoteModelRevisionTapOnHolesMutation, UpsertQuoteModelRevisionTapOnHolesMutationVariables>;
export const UnlockReorderQuoteDocument = gql`
    mutation unlockReorderQuote($quoteId: UUID!) {
  unlockReorderQuote(quoteId: $quoteId) {
    id
    status
  }
}
    `;
export type UnlockReorderQuoteMutationFn = Apollo.MutationFunction<UnlockReorderQuoteMutation, UnlockReorderQuoteMutationVariables>;

/**
 * __useUnlockReorderQuoteMutation__
 *
 * To run a mutation, you first call `useUnlockReorderQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockReorderQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockReorderQuoteMutation, { data, loading, error }] = useUnlockReorderQuoteMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useUnlockReorderQuoteMutation(baseOptions?: Apollo.MutationHookOptions<UnlockReorderQuoteMutation, UnlockReorderQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlockReorderQuoteMutation, UnlockReorderQuoteMutationVariables>(UnlockReorderQuoteDocument, options);
      }
export type UnlockReorderQuoteMutationHookResult = ReturnType<typeof useUnlockReorderQuoteMutation>;
export type UnlockReorderQuoteMutationResult = Apollo.MutationResult<UnlockReorderQuoteMutation>;
export type UnlockReorderQuoteMutationOptions = Apollo.BaseMutationOptions<UnlockReorderQuoteMutation, UnlockReorderQuoteMutationVariables>;
export const SalesforceAccountSearchQueryDocument = gql`
    query salesforceAccountSearchQuery($filters: SalesforceAccountSearchInput) {
  adminSearchSalesforceAccounts(filters: $filters) {
    totalCount
    items {
      ...AdminSearchSalesforceAccountItem
    }
  }
}
    ${AdminSearchSalesforceAccountItemFragmentDoc}`;

/**
 * __useSalesforceAccountSearchQueryQuery__
 *
 * To run a query within a React component, call `useSalesforceAccountSearchQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesforceAccountSearchQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesforceAccountSearchQueryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSalesforceAccountSearchQueryQuery(baseOptions?: Apollo.QueryHookOptions<SalesforceAccountSearchQueryQuery, SalesforceAccountSearchQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesforceAccountSearchQueryQuery, SalesforceAccountSearchQueryQueryVariables>(SalesforceAccountSearchQueryDocument, options);
      }
export function useSalesforceAccountSearchQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesforceAccountSearchQueryQuery, SalesforceAccountSearchQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesforceAccountSearchQueryQuery, SalesforceAccountSearchQueryQueryVariables>(SalesforceAccountSearchQueryDocument, options);
        }
export type SalesforceAccountSearchQueryQueryHookResult = ReturnType<typeof useSalesforceAccountSearchQueryQuery>;
export type SalesforceAccountSearchQueryLazyQueryHookResult = ReturnType<typeof useSalesforceAccountSearchQueryLazyQuery>;
export type SalesforceAccountSearchQueryQueryResult = Apollo.QueryResult<SalesforceAccountSearchQueryQuery, SalesforceAccountSearchQueryQueryVariables>;
export function refetchSalesforceAccountSearchQueryQuery(variables?: SalesforceAccountSearchQueryQueryVariables) {
      return { query: SalesforceAccountSearchQueryDocument, variables: variables }
    }
export const BusinessAccountMembersDocument = gql`
    query businessAccountMembers($filters: BusinessAccountMembersFilterInput, $offset: Int!, $limit: Int!) {
  businessAccountMembers(filters: $filters, offset: $offset, limit: $limit) {
    totalCount
    items {
      id
      user {
        id
        displayName
        email
        enabled
      }
      salesforceContactUrl
      createdAt
      lastLoginDate
      capabilities
    }
  }
}
    `;

/**
 * __useBusinessAccountMembersQuery__
 *
 * To run a query within a React component, call `useBusinessAccountMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessAccountMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessAccountMembersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBusinessAccountMembersQuery(baseOptions: Apollo.QueryHookOptions<BusinessAccountMembersQuery, BusinessAccountMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessAccountMembersQuery, BusinessAccountMembersQueryVariables>(BusinessAccountMembersDocument, options);
      }
export function useBusinessAccountMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessAccountMembersQuery, BusinessAccountMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessAccountMembersQuery, BusinessAccountMembersQueryVariables>(BusinessAccountMembersDocument, options);
        }
export type BusinessAccountMembersQueryHookResult = ReturnType<typeof useBusinessAccountMembersQuery>;
export type BusinessAccountMembersLazyQueryHookResult = ReturnType<typeof useBusinessAccountMembersLazyQuery>;
export type BusinessAccountMembersQueryResult = Apollo.QueryResult<BusinessAccountMembersQuery, BusinessAccountMembersQueryVariables>;
export function refetchBusinessAccountMembersQuery(variables: BusinessAccountMembersQueryVariables) {
      return { query: BusinessAccountMembersDocument, variables: variables }
    }
export const BusinessAccountPendingMembersDocument = gql`
    query businessAccountPendingMembers($filters: BusinessAccountPendingMembersFilterInput, $offset: Int!, $limit: Int!) {
  businessAccountPendingMembers(filters: $filters, offset: $offset, limit: $limit) {
    totalCount
    items {
      lastLoginDate
      salesforceContactUrl
      capabilities
      invite {
        id
        email
        sentDate
        status
      }
      user {
        id
        displayName
        email
      }
    }
  }
}
    `;

/**
 * __useBusinessAccountPendingMembersQuery__
 *
 * To run a query within a React component, call `useBusinessAccountPendingMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessAccountPendingMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessAccountPendingMembersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBusinessAccountPendingMembersQuery(baseOptions: Apollo.QueryHookOptions<BusinessAccountPendingMembersQuery, BusinessAccountPendingMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessAccountPendingMembersQuery, BusinessAccountPendingMembersQueryVariables>(BusinessAccountPendingMembersDocument, options);
      }
export function useBusinessAccountPendingMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessAccountPendingMembersQuery, BusinessAccountPendingMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessAccountPendingMembersQuery, BusinessAccountPendingMembersQueryVariables>(BusinessAccountPendingMembersDocument, options);
        }
export type BusinessAccountPendingMembersQueryHookResult = ReturnType<typeof useBusinessAccountPendingMembersQuery>;
export type BusinessAccountPendingMembersLazyQueryHookResult = ReturnType<typeof useBusinessAccountPendingMembersLazyQuery>;
export type BusinessAccountPendingMembersQueryResult = Apollo.QueryResult<BusinessAccountPendingMembersQuery, BusinessAccountPendingMembersQueryVariables>;
export function refetchBusinessAccountPendingMembersQuery(variables: BusinessAccountPendingMembersQueryVariables) {
      return { query: BusinessAccountPendingMembersDocument, variables: variables }
    }
export const MaterialColorsDocument = gql`
    query materialColors($materialId: String!) {
  colors(materialId: $materialId) {
    id
    name
  }
}
    `;

/**
 * __useMaterialColorsQuery__
 *
 * To run a query within a React component, call `useMaterialColorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialColorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialColorsQuery({
 *   variables: {
 *      materialId: // value for 'materialId'
 *   },
 * });
 */
export function useMaterialColorsQuery(baseOptions: Apollo.QueryHookOptions<MaterialColorsQuery, MaterialColorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaterialColorsQuery, MaterialColorsQueryVariables>(MaterialColorsDocument, options);
      }
export function useMaterialColorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaterialColorsQuery, MaterialColorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaterialColorsQuery, MaterialColorsQueryVariables>(MaterialColorsDocument, options);
        }
export type MaterialColorsQueryHookResult = ReturnType<typeof useMaterialColorsQuery>;
export type MaterialColorsLazyQueryHookResult = ReturnType<typeof useMaterialColorsLazyQuery>;
export type MaterialColorsQueryResult = Apollo.QueryResult<MaterialColorsQuery, MaterialColorsQueryVariables>;
export function refetchMaterialColorsQuery(variables: MaterialColorsQueryVariables) {
      return { query: MaterialColorsDocument, variables: variables }
    }
export const MaterialDensitiesDocument = gql`
    query materialDensities {
  materialDensities {
    standardDensityMaterial
    platformMaterialId
  }
}
    `;

/**
 * __useMaterialDensitiesQuery__
 *
 * To run a query within a React component, call `useMaterialDensitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialDensitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialDensitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMaterialDensitiesQuery(baseOptions?: Apollo.QueryHookOptions<MaterialDensitiesQuery, MaterialDensitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaterialDensitiesQuery, MaterialDensitiesQueryVariables>(MaterialDensitiesDocument, options);
      }
export function useMaterialDensitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaterialDensitiesQuery, MaterialDensitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaterialDensitiesQuery, MaterialDensitiesQueryVariables>(MaterialDensitiesDocument, options);
        }
export type MaterialDensitiesQueryHookResult = ReturnType<typeof useMaterialDensitiesQuery>;
export type MaterialDensitiesLazyQueryHookResult = ReturnType<typeof useMaterialDensitiesLazyQuery>;
export type MaterialDensitiesQueryResult = Apollo.QueryResult<MaterialDensitiesQuery, MaterialDensitiesQueryVariables>;
export function refetchMaterialDensitiesQuery(variables?: MaterialDensitiesQueryVariables) {
      return { query: MaterialDensitiesDocument, variables: variables }
    }
export const BusinessAccountAlertDocument = gql`
    query businessAccountAlert {
  me {
    id
    businessAccountSignupStatus
  }
}
    `;

/**
 * __useBusinessAccountAlertQuery__
 *
 * To run a query within a React component, call `useBusinessAccountAlertQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessAccountAlertQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessAccountAlertQuery({
 *   variables: {
 *   },
 * });
 */
export function useBusinessAccountAlertQuery(baseOptions?: Apollo.QueryHookOptions<BusinessAccountAlertQuery, BusinessAccountAlertQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessAccountAlertQuery, BusinessAccountAlertQueryVariables>(BusinessAccountAlertDocument, options);
      }
export function useBusinessAccountAlertLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessAccountAlertQuery, BusinessAccountAlertQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessAccountAlertQuery, BusinessAccountAlertQueryVariables>(BusinessAccountAlertDocument, options);
        }
export type BusinessAccountAlertQueryHookResult = ReturnType<typeof useBusinessAccountAlertQuery>;
export type BusinessAccountAlertLazyQueryHookResult = ReturnType<typeof useBusinessAccountAlertLazyQuery>;
export type BusinessAccountAlertQueryResult = Apollo.QueryResult<BusinessAccountAlertQuery, BusinessAccountAlertQueryVariables>;
export function refetchBusinessAccountAlertQuery(variables?: BusinessAccountAlertQueryVariables) {
      return { query: BusinessAccountAlertDocument, variables: variables }
    }
export const EmailVerificationStatusDocument = gql`
    query emailVerificationStatus {
  me {
    id
    email
    businessAccountSignupStatus
    emailVerificationStatus
    emailVerifiedDate
  }
}
    `;

/**
 * __useEmailVerificationStatusQuery__
 *
 * To run a query within a React component, call `useEmailVerificationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailVerificationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailVerificationStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmailVerificationStatusQuery(baseOptions?: Apollo.QueryHookOptions<EmailVerificationStatusQuery, EmailVerificationStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailVerificationStatusQuery, EmailVerificationStatusQueryVariables>(EmailVerificationStatusDocument, options);
      }
export function useEmailVerificationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailVerificationStatusQuery, EmailVerificationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailVerificationStatusQuery, EmailVerificationStatusQueryVariables>(EmailVerificationStatusDocument, options);
        }
export type EmailVerificationStatusQueryHookResult = ReturnType<typeof useEmailVerificationStatusQuery>;
export type EmailVerificationStatusLazyQueryHookResult = ReturnType<typeof useEmailVerificationStatusLazyQuery>;
export type EmailVerificationStatusQueryResult = Apollo.QueryResult<EmailVerificationStatusQuery, EmailVerificationStatusQueryVariables>;
export function refetchEmailVerificationStatusQuery(variables?: EmailVerificationStatusQueryVariables) {
      return { query: EmailVerificationStatusDocument, variables: variables }
    }
export const QlltWithShippingOptionsDocument = gql`
    query QlltWithShippingOptions($quoteId: UUID!, $address: AddressInput) {
  quote(id: $quoteId) {
    id
    quoteLevelLeadTimesWithShippingOptions(address: $address) {
      ...QlltWithShippingOptionsResult
    }
  }
}
    ${QlltWithShippingOptionsResultFragmentDoc}`;

/**
 * __useQlltWithShippingOptionsQuery__
 *
 * To run a query within a React component, call `useQlltWithShippingOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQlltWithShippingOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQlltWithShippingOptionsQuery({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      address: // value for 'address'
 *   },
 * });
 */
export function useQlltWithShippingOptionsQuery(baseOptions: Apollo.QueryHookOptions<QlltWithShippingOptionsQuery, QlltWithShippingOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QlltWithShippingOptionsQuery, QlltWithShippingOptionsQueryVariables>(QlltWithShippingOptionsDocument, options);
      }
export function useQlltWithShippingOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QlltWithShippingOptionsQuery, QlltWithShippingOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QlltWithShippingOptionsQuery, QlltWithShippingOptionsQueryVariables>(QlltWithShippingOptionsDocument, options);
        }
export type QlltWithShippingOptionsQueryHookResult = ReturnType<typeof useQlltWithShippingOptionsQuery>;
export type QlltWithShippingOptionsLazyQueryHookResult = ReturnType<typeof useQlltWithShippingOptionsLazyQuery>;
export type QlltWithShippingOptionsQueryResult = Apollo.QueryResult<QlltWithShippingOptionsQuery, QlltWithShippingOptionsQueryVariables>;
export function refetchQlltWithShippingOptionsQuery(variables: QlltWithShippingOptionsQueryVariables) {
      return { query: QlltWithShippingOptionsDocument, variables: variables }
    }
export const GetShippingOptionsDocument = gql`
    query getShippingOptions($id: UUID!, $address: AddressInput!, $shippingCalculatorOverrides: ShippingCalculatorOverridesInput) {
  quote(id: $id) {
    id
    shippingOptionsNew(
      shippingCalculatorOverrides: $shippingCalculatorOverrides
      address: $address
    ) {
      items {
        cost
        deliveredByDate
        deliveryDays
        id
        name
        productionPartsCost
        quoteToken
        samplesCost
      }
    }
  }
}
    `;

/**
 * __useGetShippingOptionsQuery__
 *
 * To run a query within a React component, call `useGetShippingOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShippingOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShippingOptionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      address: // value for 'address'
 *      shippingCalculatorOverrides: // value for 'shippingCalculatorOverrides'
 *   },
 * });
 */
export function useGetShippingOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetShippingOptionsQuery, GetShippingOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShippingOptionsQuery, GetShippingOptionsQueryVariables>(GetShippingOptionsDocument, options);
      }
export function useGetShippingOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShippingOptionsQuery, GetShippingOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShippingOptionsQuery, GetShippingOptionsQueryVariables>(GetShippingOptionsDocument, options);
        }
export type GetShippingOptionsQueryHookResult = ReturnType<typeof useGetShippingOptionsQuery>;
export type GetShippingOptionsLazyQueryHookResult = ReturnType<typeof useGetShippingOptionsLazyQuery>;
export type GetShippingOptionsQueryResult = Apollo.QueryResult<GetShippingOptionsQuery, GetShippingOptionsQueryVariables>;
export function refetchGetShippingOptionsQuery(variables: GetShippingOptionsQueryVariables) {
      return { query: GetShippingOptionsDocument, variables: variables }
    }
export const GetShippingWeightsDocument = gql`
    query getShippingWeights($id: UUID!, $shippingCalculatorOverrides: ShippingCalculatorOverridesInput) {
  quote(id: $id) {
    id
    weights(shippingCalculatorOverrides: $shippingCalculatorOverrides) {
      actualWeight
      shippingWeight
      dimensionalWeight
    }
  }
}
    `;

/**
 * __useGetShippingWeightsQuery__
 *
 * To run a query within a React component, call `useGetShippingWeightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShippingWeightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShippingWeightsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      shippingCalculatorOverrides: // value for 'shippingCalculatorOverrides'
 *   },
 * });
 */
export function useGetShippingWeightsQuery(baseOptions: Apollo.QueryHookOptions<GetShippingWeightsQuery, GetShippingWeightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShippingWeightsQuery, GetShippingWeightsQueryVariables>(GetShippingWeightsDocument, options);
      }
export function useGetShippingWeightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShippingWeightsQuery, GetShippingWeightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShippingWeightsQuery, GetShippingWeightsQueryVariables>(GetShippingWeightsDocument, options);
        }
export type GetShippingWeightsQueryHookResult = ReturnType<typeof useGetShippingWeightsQuery>;
export type GetShippingWeightsLazyQueryHookResult = ReturnType<typeof useGetShippingWeightsLazyQuery>;
export type GetShippingWeightsQueryResult = Apollo.QueryResult<GetShippingWeightsQuery, GetShippingWeightsQueryVariables>;
export function refetchGetShippingWeightsQuery(variables: GetShippingWeightsQueryVariables) {
      return { query: GetShippingWeightsDocument, variables: variables }
    }
export const QuoteDetailsQueryForShippingCalculatorDocument = gql`
    query quoteDetailsQueryForShippingCalculator($id: UUID!, $shippingCalculatorOverrides: ShippingCalculatorOverridesInput) {
  quote(id: $id) {
    ...QuoteDetailsQueryForShippingCalculatorQuote
  }
}
    ${QuoteDetailsQueryForShippingCalculatorQuoteFragmentDoc}`;

/**
 * __useQuoteDetailsQueryForShippingCalculatorQuery__
 *
 * To run a query within a React component, call `useQuoteDetailsQueryForShippingCalculatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteDetailsQueryForShippingCalculatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteDetailsQueryForShippingCalculatorQuery({
 *   variables: {
 *      id: // value for 'id'
 *      shippingCalculatorOverrides: // value for 'shippingCalculatorOverrides'
 *   },
 * });
 */
export function useQuoteDetailsQueryForShippingCalculatorQuery(baseOptions: Apollo.QueryHookOptions<QuoteDetailsQueryForShippingCalculatorQuery, QuoteDetailsQueryForShippingCalculatorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteDetailsQueryForShippingCalculatorQuery, QuoteDetailsQueryForShippingCalculatorQueryVariables>(QuoteDetailsQueryForShippingCalculatorDocument, options);
      }
export function useQuoteDetailsQueryForShippingCalculatorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteDetailsQueryForShippingCalculatorQuery, QuoteDetailsQueryForShippingCalculatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteDetailsQueryForShippingCalculatorQuery, QuoteDetailsQueryForShippingCalculatorQueryVariables>(QuoteDetailsQueryForShippingCalculatorDocument, options);
        }
export type QuoteDetailsQueryForShippingCalculatorQueryHookResult = ReturnType<typeof useQuoteDetailsQueryForShippingCalculatorQuery>;
export type QuoteDetailsQueryForShippingCalculatorLazyQueryHookResult = ReturnType<typeof useQuoteDetailsQueryForShippingCalculatorLazyQuery>;
export type QuoteDetailsQueryForShippingCalculatorQueryResult = Apollo.QueryResult<QuoteDetailsQueryForShippingCalculatorQuery, QuoteDetailsQueryForShippingCalculatorQueryVariables>;
export function refetchQuoteDetailsQueryForShippingCalculatorQuery(variables: QuoteDetailsQueryForShippingCalculatorQueryVariables) {
      return { query: QuoteDetailsQueryForShippingCalculatorDocument, variables: variables }
    }
export const QuoteDetailsStatusUpdateDocument = gql`
    query quoteDetailsStatusUpdate($id: UUID!) {
  quote(id: $id) {
    id
    status
  }
}
    `;

/**
 * __useQuoteDetailsStatusUpdateQuery__
 *
 * To run a query within a React component, call `useQuoteDetailsStatusUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteDetailsStatusUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteDetailsStatusUpdateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuoteDetailsStatusUpdateQuery(baseOptions: Apollo.QueryHookOptions<QuoteDetailsStatusUpdateQuery, QuoteDetailsStatusUpdateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteDetailsStatusUpdateQuery, QuoteDetailsStatusUpdateQueryVariables>(QuoteDetailsStatusUpdateDocument, options);
      }
export function useQuoteDetailsStatusUpdateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteDetailsStatusUpdateQuery, QuoteDetailsStatusUpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteDetailsStatusUpdateQuery, QuoteDetailsStatusUpdateQueryVariables>(QuoteDetailsStatusUpdateDocument, options);
        }
export type QuoteDetailsStatusUpdateQueryHookResult = ReturnType<typeof useQuoteDetailsStatusUpdateQuery>;
export type QuoteDetailsStatusUpdateLazyQueryHookResult = ReturnType<typeof useQuoteDetailsStatusUpdateLazyQuery>;
export type QuoteDetailsStatusUpdateQueryResult = Apollo.QueryResult<QuoteDetailsStatusUpdateQuery, QuoteDetailsStatusUpdateQueryVariables>;
export function refetchQuoteDetailsStatusUpdateQuery(variables: QuoteDetailsStatusUpdateQueryVariables) {
      return { query: QuoteDetailsStatusUpdateDocument, variables: variables }
    }
export const QuoteShippingOptionsQuoteCheckoutSummaryCardDocument = gql`
    query quoteShippingOptionsQuoteCheckoutSummaryCard($id: UUID!, $address: AddressInput, $carrier: Carrier) {
  quote(id: $id) {
    id
    isOverseasShipping
    weights {
      shippingWeight
    }
    shippingOptionsNew(address: $address, carrier: $carrier) {
      items {
        cost
        deliveredByDate
        deliveryDays
        id
        name
        productionPartsCost
        quoteToken
        samplesCost
      }
    }
  }
}
    `;

/**
 * __useQuoteShippingOptionsQuoteCheckoutSummaryCardQuery__
 *
 * To run a query within a React component, call `useQuoteShippingOptionsQuoteCheckoutSummaryCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteShippingOptionsQuoteCheckoutSummaryCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteShippingOptionsQuoteCheckoutSummaryCardQuery({
 *   variables: {
 *      id: // value for 'id'
 *      address: // value for 'address'
 *      carrier: // value for 'carrier'
 *   },
 * });
 */
export function useQuoteShippingOptionsQuoteCheckoutSummaryCardQuery(baseOptions: Apollo.QueryHookOptions<QuoteShippingOptionsQuoteCheckoutSummaryCardQuery, QuoteShippingOptionsQuoteCheckoutSummaryCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteShippingOptionsQuoteCheckoutSummaryCardQuery, QuoteShippingOptionsQuoteCheckoutSummaryCardQueryVariables>(QuoteShippingOptionsQuoteCheckoutSummaryCardDocument, options);
      }
export function useQuoteShippingOptionsQuoteCheckoutSummaryCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteShippingOptionsQuoteCheckoutSummaryCardQuery, QuoteShippingOptionsQuoteCheckoutSummaryCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteShippingOptionsQuoteCheckoutSummaryCardQuery, QuoteShippingOptionsQuoteCheckoutSummaryCardQueryVariables>(QuoteShippingOptionsQuoteCheckoutSummaryCardDocument, options);
        }
export type QuoteShippingOptionsQuoteCheckoutSummaryCardQueryHookResult = ReturnType<typeof useQuoteShippingOptionsQuoteCheckoutSummaryCardQuery>;
export type QuoteShippingOptionsQuoteCheckoutSummaryCardLazyQueryHookResult = ReturnType<typeof useQuoteShippingOptionsQuoteCheckoutSummaryCardLazyQuery>;
export type QuoteShippingOptionsQuoteCheckoutSummaryCardQueryResult = Apollo.QueryResult<QuoteShippingOptionsQuoteCheckoutSummaryCardQuery, QuoteShippingOptionsQuoteCheckoutSummaryCardQueryVariables>;
export function refetchQuoteShippingOptionsQuoteCheckoutSummaryCardQuery(variables: QuoteShippingOptionsQuoteCheckoutSummaryCardQueryVariables) {
      return { query: QuoteShippingOptionsQuoteCheckoutSummaryCardDocument, variables: variables }
    }
export const GetProjectIdFromQuoteItemDocument = gql`
    query getProjectIdFromQuoteItem($id: UUID!, $showDeleted: Boolean) {
  quoteItem(id: $id, showDeleted: $showDeleted) {
    id
    quote {
      id
      project {
        id
      }
    }
    quoteModelRevision {
      id
    }
  }
}
    `;

/**
 * __useGetProjectIdFromQuoteItemQuery__
 *
 * To run a query within a React component, call `useGetProjectIdFromQuoteItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectIdFromQuoteItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectIdFromQuoteItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *      showDeleted: // value for 'showDeleted'
 *   },
 * });
 */
export function useGetProjectIdFromQuoteItemQuery(baseOptions: Apollo.QueryHookOptions<GetProjectIdFromQuoteItemQuery, GetProjectIdFromQuoteItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectIdFromQuoteItemQuery, GetProjectIdFromQuoteItemQueryVariables>(GetProjectIdFromQuoteItemDocument, options);
      }
export function useGetProjectIdFromQuoteItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectIdFromQuoteItemQuery, GetProjectIdFromQuoteItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectIdFromQuoteItemQuery, GetProjectIdFromQuoteItemQueryVariables>(GetProjectIdFromQuoteItemDocument, options);
        }
export type GetProjectIdFromQuoteItemQueryHookResult = ReturnType<typeof useGetProjectIdFromQuoteItemQuery>;
export type GetProjectIdFromQuoteItemLazyQueryHookResult = ReturnType<typeof useGetProjectIdFromQuoteItemLazyQuery>;
export type GetProjectIdFromQuoteItemQueryResult = Apollo.QueryResult<GetProjectIdFromQuoteItemQuery, GetProjectIdFromQuoteItemQueryVariables>;
export function refetchGetProjectIdFromQuoteItemQuery(variables: GetProjectIdFromQuoteItemQueryVariables) {
      return { query: GetProjectIdFromQuoteItemDocument, variables: variables }
    }
export const GetSalesTaxQuoteCheckoutSummaryDocument = gql`
    query getSalesTaxQuoteCheckoutSummary($quoteId: String!, $zip: String!) {
  getTaxAmount(quoteId: $quoteId, zip: $zip) {
    taxAmount
    taxRate
    error
  }
}
    `;

/**
 * __useGetSalesTaxQuoteCheckoutSummaryQuery__
 *
 * To run a query within a React component, call `useGetSalesTaxQuoteCheckoutSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesTaxQuoteCheckoutSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesTaxQuoteCheckoutSummaryQuery({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      zip: // value for 'zip'
 *   },
 * });
 */
export function useGetSalesTaxQuoteCheckoutSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetSalesTaxQuoteCheckoutSummaryQuery, GetSalesTaxQuoteCheckoutSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesTaxQuoteCheckoutSummaryQuery, GetSalesTaxQuoteCheckoutSummaryQueryVariables>(GetSalesTaxQuoteCheckoutSummaryDocument, options);
      }
export function useGetSalesTaxQuoteCheckoutSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesTaxQuoteCheckoutSummaryQuery, GetSalesTaxQuoteCheckoutSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesTaxQuoteCheckoutSummaryQuery, GetSalesTaxQuoteCheckoutSummaryQueryVariables>(GetSalesTaxQuoteCheckoutSummaryDocument, options);
        }
export type GetSalesTaxQuoteCheckoutSummaryQueryHookResult = ReturnType<typeof useGetSalesTaxQuoteCheckoutSummaryQuery>;
export type GetSalesTaxQuoteCheckoutSummaryLazyQueryHookResult = ReturnType<typeof useGetSalesTaxQuoteCheckoutSummaryLazyQuery>;
export type GetSalesTaxQuoteCheckoutSummaryQueryResult = Apollo.QueryResult<GetSalesTaxQuoteCheckoutSummaryQuery, GetSalesTaxQuoteCheckoutSummaryQueryVariables>;
export function refetchGetSalesTaxQuoteCheckoutSummaryQuery(variables: GetSalesTaxQuoteCheckoutSummaryQueryVariables) {
      return { query: GetSalesTaxQuoteCheckoutSummaryDocument, variables: variables }
    }
export const AdditionalRequirementsRawPdfOcrDocument = gql`
    query additionalRequirementsRawPdfOcr($quoteModelRevisionId: UUID!) {
  getRawPdfOcrJson(quoteModelRevisionId: $quoteModelRevisionId) {
    ...AdditionalRequirementsRawPdfOcrData
  }
}
    ${AdditionalRequirementsRawPdfOcrDataFragmentDoc}`;

/**
 * __useAdditionalRequirementsRawPdfOcrQuery__
 *
 * To run a query within a React component, call `useAdditionalRequirementsRawPdfOcrQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdditionalRequirementsRawPdfOcrQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdditionalRequirementsRawPdfOcrQuery({
 *   variables: {
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *   },
 * });
 */
export function useAdditionalRequirementsRawPdfOcrQuery(baseOptions: Apollo.QueryHookOptions<AdditionalRequirementsRawPdfOcrQuery, AdditionalRequirementsRawPdfOcrQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdditionalRequirementsRawPdfOcrQuery, AdditionalRequirementsRawPdfOcrQueryVariables>(AdditionalRequirementsRawPdfOcrDocument, options);
      }
export function useAdditionalRequirementsRawPdfOcrLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdditionalRequirementsRawPdfOcrQuery, AdditionalRequirementsRawPdfOcrQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdditionalRequirementsRawPdfOcrQuery, AdditionalRequirementsRawPdfOcrQueryVariables>(AdditionalRequirementsRawPdfOcrDocument, options);
        }
export type AdditionalRequirementsRawPdfOcrQueryHookResult = ReturnType<typeof useAdditionalRequirementsRawPdfOcrQuery>;
export type AdditionalRequirementsRawPdfOcrLazyQueryHookResult = ReturnType<typeof useAdditionalRequirementsRawPdfOcrLazyQuery>;
export type AdditionalRequirementsRawPdfOcrQueryResult = Apollo.QueryResult<AdditionalRequirementsRawPdfOcrQuery, AdditionalRequirementsRawPdfOcrQueryVariables>;
export function refetchAdditionalRequirementsRawPdfOcrQuery(variables: AdditionalRequirementsRawPdfOcrQueryVariables) {
      return { query: AdditionalRequirementsRawPdfOcrDocument, variables: variables }
    }
export const AdminAchAccountsForUserDocument = gql`
    query adminAchAccountsForUser($userId: Int!) {
  user(id: $userId) {
    id
    achAccounts {
      ...UserAchAccountsItem
    }
  }
}
    ${UserAchAccountsItemFragmentDoc}`;

/**
 * __useAdminAchAccountsForUserQuery__
 *
 * To run a query within a React component, call `useAdminAchAccountsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminAchAccountsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminAchAccountsForUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminAchAccountsForUserQuery(baseOptions: Apollo.QueryHookOptions<AdminAchAccountsForUserQuery, AdminAchAccountsForUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminAchAccountsForUserQuery, AdminAchAccountsForUserQueryVariables>(AdminAchAccountsForUserDocument, options);
      }
export function useAdminAchAccountsForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminAchAccountsForUserQuery, AdminAchAccountsForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminAchAccountsForUserQuery, AdminAchAccountsForUserQueryVariables>(AdminAchAccountsForUserDocument, options);
        }
export type AdminAchAccountsForUserQueryHookResult = ReturnType<typeof useAdminAchAccountsForUserQuery>;
export type AdminAchAccountsForUserLazyQueryHookResult = ReturnType<typeof useAdminAchAccountsForUserLazyQuery>;
export type AdminAchAccountsForUserQueryResult = Apollo.QueryResult<AdminAchAccountsForUserQuery, AdminAchAccountsForUserQueryVariables>;
export function refetchAdminAchAccountsForUserQuery(variables: AdminAchAccountsForUserQueryVariables) {
      return { query: AdminAchAccountsForUserDocument, variables: variables }
    }
export const AdminConfigurablePostProcessesDocument = gql`
    query adminConfigurablePostProcesses($materialId: String!) {
  adminConfigurablePostProcesses(materialId: $materialId) {
    id
    name
    typeName
  }
}
    `;

/**
 * __useAdminConfigurablePostProcessesQuery__
 *
 * To run a query within a React component, call `useAdminConfigurablePostProcessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminConfigurablePostProcessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminConfigurablePostProcessesQuery({
 *   variables: {
 *      materialId: // value for 'materialId'
 *   },
 * });
 */
export function useAdminConfigurablePostProcessesQuery(baseOptions: Apollo.QueryHookOptions<AdminConfigurablePostProcessesQuery, AdminConfigurablePostProcessesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminConfigurablePostProcessesQuery, AdminConfigurablePostProcessesQueryVariables>(AdminConfigurablePostProcessesDocument, options);
      }
export function useAdminConfigurablePostProcessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminConfigurablePostProcessesQuery, AdminConfigurablePostProcessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminConfigurablePostProcessesQuery, AdminConfigurablePostProcessesQueryVariables>(AdminConfigurablePostProcessesDocument, options);
        }
export type AdminConfigurablePostProcessesQueryHookResult = ReturnType<typeof useAdminConfigurablePostProcessesQuery>;
export type AdminConfigurablePostProcessesLazyQueryHookResult = ReturnType<typeof useAdminConfigurablePostProcessesLazyQuery>;
export type AdminConfigurablePostProcessesQueryResult = Apollo.QueryResult<AdminConfigurablePostProcessesQuery, AdminConfigurablePostProcessesQueryVariables>;
export function refetchAdminConfigurablePostProcessesQuery(variables: AdminConfigurablePostProcessesQueryVariables) {
      return { query: AdminConfigurablePostProcessesDocument, variables: variables }
    }
export const AdminCreditCardsForUserDocument = gql`
    query adminCreditCardsForUser($userId: Int!) {
  user(id: $userId) {
    id
    creditCards {
      ...UserCreditCardsItem
    }
  }
}
    ${UserCreditCardsItemFragmentDoc}`;

/**
 * __useAdminCreditCardsForUserQuery__
 *
 * To run a query within a React component, call `useAdminCreditCardsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCreditCardsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCreditCardsForUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminCreditCardsForUserQuery(baseOptions: Apollo.QueryHookOptions<AdminCreditCardsForUserQuery, AdminCreditCardsForUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminCreditCardsForUserQuery, AdminCreditCardsForUserQueryVariables>(AdminCreditCardsForUserDocument, options);
      }
export function useAdminCreditCardsForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminCreditCardsForUserQuery, AdminCreditCardsForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminCreditCardsForUserQuery, AdminCreditCardsForUserQueryVariables>(AdminCreditCardsForUserDocument, options);
        }
export type AdminCreditCardsForUserQueryHookResult = ReturnType<typeof useAdminCreditCardsForUserQuery>;
export type AdminCreditCardsForUserLazyQueryHookResult = ReturnType<typeof useAdminCreditCardsForUserLazyQuery>;
export type AdminCreditCardsForUserQueryResult = Apollo.QueryResult<AdminCreditCardsForUserQuery, AdminCreditCardsForUserQueryVariables>;
export function refetchAdminCreditCardsForUserQuery(variables: AdminCreditCardsForUserQueryVariables) {
      return { query: AdminCreditCardsForUserDocument, variables: variables }
    }
export const AdminPaymentOptionsForUserAdminUserQuoteCheckoutPageDocument = gql`
    query adminPaymentOptionsForUserAdminUserQuoteCheckoutPage($id: Int!) {
  user(id: $id) {
    id
    paymentOptions {
      ...PaymentOption
    }
  }
}
    ${PaymentOptionFragmentDoc}`;

/**
 * __useAdminPaymentOptionsForUserAdminUserQuoteCheckoutPageQuery__
 *
 * To run a query within a React component, call `useAdminPaymentOptionsForUserAdminUserQuoteCheckoutPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminPaymentOptionsForUserAdminUserQuoteCheckoutPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPaymentOptionsForUserAdminUserQuoteCheckoutPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminPaymentOptionsForUserAdminUserQuoteCheckoutPageQuery(baseOptions: Apollo.QueryHookOptions<AdminPaymentOptionsForUserAdminUserQuoteCheckoutPageQuery, AdminPaymentOptionsForUserAdminUserQuoteCheckoutPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPaymentOptionsForUserAdminUserQuoteCheckoutPageQuery, AdminPaymentOptionsForUserAdminUserQuoteCheckoutPageQueryVariables>(AdminPaymentOptionsForUserAdminUserQuoteCheckoutPageDocument, options);
      }
export function useAdminPaymentOptionsForUserAdminUserQuoteCheckoutPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPaymentOptionsForUserAdminUserQuoteCheckoutPageQuery, AdminPaymentOptionsForUserAdminUserQuoteCheckoutPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPaymentOptionsForUserAdminUserQuoteCheckoutPageQuery, AdminPaymentOptionsForUserAdminUserQuoteCheckoutPageQueryVariables>(AdminPaymentOptionsForUserAdminUserQuoteCheckoutPageDocument, options);
        }
export type AdminPaymentOptionsForUserAdminUserQuoteCheckoutPageQueryHookResult = ReturnType<typeof useAdminPaymentOptionsForUserAdminUserQuoteCheckoutPageQuery>;
export type AdminPaymentOptionsForUserAdminUserQuoteCheckoutPageLazyQueryHookResult = ReturnType<typeof useAdminPaymentOptionsForUserAdminUserQuoteCheckoutPageLazyQuery>;
export type AdminPaymentOptionsForUserAdminUserQuoteCheckoutPageQueryResult = Apollo.QueryResult<AdminPaymentOptionsForUserAdminUserQuoteCheckoutPageQuery, AdminPaymentOptionsForUserAdminUserQuoteCheckoutPageQueryVariables>;
export function refetchAdminPaymentOptionsForUserAdminUserQuoteCheckoutPageQuery(variables: AdminPaymentOptionsForUserAdminUserQuoteCheckoutPageQueryVariables) {
      return { query: AdminPaymentOptionsForUserAdminUserQuoteCheckoutPageDocument, variables: variables }
    }
export const AdminUserRolesQuoteDetailSummaryCardDocument = gql`
    query adminUserRolesQuoteDetailSummaryCard($id: Int!) {
  user(id: $id) {
    ...AdminUserRoles
  }
}
    ${AdminUserRolesFragmentDoc}`;

/**
 * __useAdminUserRolesQuoteDetailSummaryCardQuery__
 *
 * To run a query within a React component, call `useAdminUserRolesQuoteDetailSummaryCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserRolesQuoteDetailSummaryCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserRolesQuoteDetailSummaryCardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminUserRolesQuoteDetailSummaryCardQuery(baseOptions: Apollo.QueryHookOptions<AdminUserRolesQuoteDetailSummaryCardQuery, AdminUserRolesQuoteDetailSummaryCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminUserRolesQuoteDetailSummaryCardQuery, AdminUserRolesQuoteDetailSummaryCardQueryVariables>(AdminUserRolesQuoteDetailSummaryCardDocument, options);
      }
export function useAdminUserRolesQuoteDetailSummaryCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminUserRolesQuoteDetailSummaryCardQuery, AdminUserRolesQuoteDetailSummaryCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminUserRolesQuoteDetailSummaryCardQuery, AdminUserRolesQuoteDetailSummaryCardQueryVariables>(AdminUserRolesQuoteDetailSummaryCardDocument, options);
        }
export type AdminUserRolesQuoteDetailSummaryCardQueryHookResult = ReturnType<typeof useAdminUserRolesQuoteDetailSummaryCardQuery>;
export type AdminUserRolesQuoteDetailSummaryCardLazyQueryHookResult = ReturnType<typeof useAdminUserRolesQuoteDetailSummaryCardLazyQuery>;
export type AdminUserRolesQuoteDetailSummaryCardQueryResult = Apollo.QueryResult<AdminUserRolesQuoteDetailSummaryCardQuery, AdminUserRolesQuoteDetailSummaryCardQueryVariables>;
export function refetchAdminUserRolesQuoteDetailSummaryCardQuery(variables: AdminUserRolesQuoteDetailSummaryCardQueryVariables) {
      return { query: AdminUserRolesQuoteDetailSummaryCardDocument, variables: variables }
    }
export const AdminUserShippingAddressAdminUserQuoteCheckoutPageDocument = gql`
    query adminUserShippingAddressAdminUserQuoteCheckoutPage($id: Int!) {
  user(id: $id) {
    id
    shippingAddresses {
      ...ShippingAddressesItem
    }
  }
}
    ${ShippingAddressesItemFragmentDoc}`;

/**
 * __useAdminUserShippingAddressAdminUserQuoteCheckoutPageQuery__
 *
 * To run a query within a React component, call `useAdminUserShippingAddressAdminUserQuoteCheckoutPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserShippingAddressAdminUserQuoteCheckoutPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserShippingAddressAdminUserQuoteCheckoutPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminUserShippingAddressAdminUserQuoteCheckoutPageQuery(baseOptions: Apollo.QueryHookOptions<AdminUserShippingAddressAdminUserQuoteCheckoutPageQuery, AdminUserShippingAddressAdminUserQuoteCheckoutPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminUserShippingAddressAdminUserQuoteCheckoutPageQuery, AdminUserShippingAddressAdminUserQuoteCheckoutPageQueryVariables>(AdminUserShippingAddressAdminUserQuoteCheckoutPageDocument, options);
      }
export function useAdminUserShippingAddressAdminUserQuoteCheckoutPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminUserShippingAddressAdminUserQuoteCheckoutPageQuery, AdminUserShippingAddressAdminUserQuoteCheckoutPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminUserShippingAddressAdminUserQuoteCheckoutPageQuery, AdminUserShippingAddressAdminUserQuoteCheckoutPageQueryVariables>(AdminUserShippingAddressAdminUserQuoteCheckoutPageDocument, options);
        }
export type AdminUserShippingAddressAdminUserQuoteCheckoutPageQueryHookResult = ReturnType<typeof useAdminUserShippingAddressAdminUserQuoteCheckoutPageQuery>;
export type AdminUserShippingAddressAdminUserQuoteCheckoutPageLazyQueryHookResult = ReturnType<typeof useAdminUserShippingAddressAdminUserQuoteCheckoutPageLazyQuery>;
export type AdminUserShippingAddressAdminUserQuoteCheckoutPageQueryResult = Apollo.QueryResult<AdminUserShippingAddressAdminUserQuoteCheckoutPageQuery, AdminUserShippingAddressAdminUserQuoteCheckoutPageQueryVariables>;
export function refetchAdminUserShippingAddressAdminUserQuoteCheckoutPageQuery(variables: AdminUserShippingAddressAdminUserQuoteCheckoutPageQueryVariables) {
      return { query: AdminUserShippingAddressAdminUserQuoteCheckoutPageDocument, variables: variables }
    }
export const AssignedSupplierQualityEngineersDocument = gql`
    query AssignedSupplierQualityEngineers($assignedTo: SqeAssignedToType) {
  assignedSupplierQualityEngineers(assignedTo: $assignedTo) {
    id
    displayName
    firstName
    lastName
    email
    createdAt
    updatedAt
    enabled
  }
}
    `;

/**
 * __useAssignedSupplierQualityEngineersQuery__
 *
 * To run a query within a React component, call `useAssignedSupplierQualityEngineersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignedSupplierQualityEngineersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignedSupplierQualityEngineersQuery({
 *   variables: {
 *      assignedTo: // value for 'assignedTo'
 *   },
 * });
 */
export function useAssignedSupplierQualityEngineersQuery(baseOptions?: Apollo.QueryHookOptions<AssignedSupplierQualityEngineersQuery, AssignedSupplierQualityEngineersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssignedSupplierQualityEngineersQuery, AssignedSupplierQualityEngineersQueryVariables>(AssignedSupplierQualityEngineersDocument, options);
      }
export function useAssignedSupplierQualityEngineersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssignedSupplierQualityEngineersQuery, AssignedSupplierQualityEngineersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssignedSupplierQualityEngineersQuery, AssignedSupplierQualityEngineersQueryVariables>(AssignedSupplierQualityEngineersDocument, options);
        }
export type AssignedSupplierQualityEngineersQueryHookResult = ReturnType<typeof useAssignedSupplierQualityEngineersQuery>;
export type AssignedSupplierQualityEngineersLazyQueryHookResult = ReturnType<typeof useAssignedSupplierQualityEngineersLazyQuery>;
export type AssignedSupplierQualityEngineersQueryResult = Apollo.QueryResult<AssignedSupplierQualityEngineersQuery, AssignedSupplierQualityEngineersQueryVariables>;
export function refetchAssignedSupplierQualityEngineersQuery(variables?: AssignedSupplierQualityEngineersQueryVariables) {
      return { query: AssignedSupplierQualityEngineersDocument, variables: variables }
    }
export const AutoCorrectMultiPostProcessesAlertDocument = gql`
    query autoCorrectMultiPostProcessesAlert($postProcessIds: [String!]!) {
  autoCorrectMultiPostProcessesOrdering(postProcessIds: $postProcessIds) {
    conflictingPostProcesses {
      id
      name
    }
  }
}
    `;

/**
 * __useAutoCorrectMultiPostProcessesAlertQuery__
 *
 * To run a query within a React component, call `useAutoCorrectMultiPostProcessesAlertQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutoCorrectMultiPostProcessesAlertQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutoCorrectMultiPostProcessesAlertQuery({
 *   variables: {
 *      postProcessIds: // value for 'postProcessIds'
 *   },
 * });
 */
export function useAutoCorrectMultiPostProcessesAlertQuery(baseOptions: Apollo.QueryHookOptions<AutoCorrectMultiPostProcessesAlertQuery, AutoCorrectMultiPostProcessesAlertQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutoCorrectMultiPostProcessesAlertQuery, AutoCorrectMultiPostProcessesAlertQueryVariables>(AutoCorrectMultiPostProcessesAlertDocument, options);
      }
export function useAutoCorrectMultiPostProcessesAlertLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutoCorrectMultiPostProcessesAlertQuery, AutoCorrectMultiPostProcessesAlertQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutoCorrectMultiPostProcessesAlertQuery, AutoCorrectMultiPostProcessesAlertQueryVariables>(AutoCorrectMultiPostProcessesAlertDocument, options);
        }
export type AutoCorrectMultiPostProcessesAlertQueryHookResult = ReturnType<typeof useAutoCorrectMultiPostProcessesAlertQuery>;
export type AutoCorrectMultiPostProcessesAlertLazyQueryHookResult = ReturnType<typeof useAutoCorrectMultiPostProcessesAlertLazyQuery>;
export type AutoCorrectMultiPostProcessesAlertQueryResult = Apollo.QueryResult<AutoCorrectMultiPostProcessesAlertQuery, AutoCorrectMultiPostProcessesAlertQueryVariables>;
export function refetchAutoCorrectMultiPostProcessesAlertQuery(variables: AutoCorrectMultiPostProcessesAlertQueryVariables) {
      return { query: AutoCorrectMultiPostProcessesAlertDocument, variables: variables }
    }
export const BuilderConfigurablePostProcessesDocument = gql`
    query builderConfigurablePostProcesses($materialId: String!, $processId: String) {
  builderConfigurablePostProcesses(materialId: $materialId, processId: $processId) {
    ...BuilderConfigurablePostProcessesData
  }
}
    ${BuilderConfigurablePostProcessesDataFragmentDoc}`;

/**
 * __useBuilderConfigurablePostProcessesQuery__
 *
 * To run a query within a React component, call `useBuilderConfigurablePostProcessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuilderConfigurablePostProcessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuilderConfigurablePostProcessesQuery({
 *   variables: {
 *      materialId: // value for 'materialId'
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useBuilderConfigurablePostProcessesQuery(baseOptions: Apollo.QueryHookOptions<BuilderConfigurablePostProcessesQuery, BuilderConfigurablePostProcessesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuilderConfigurablePostProcessesQuery, BuilderConfigurablePostProcessesQueryVariables>(BuilderConfigurablePostProcessesDocument, options);
      }
export function useBuilderConfigurablePostProcessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuilderConfigurablePostProcessesQuery, BuilderConfigurablePostProcessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuilderConfigurablePostProcessesQuery, BuilderConfigurablePostProcessesQueryVariables>(BuilderConfigurablePostProcessesDocument, options);
        }
export type BuilderConfigurablePostProcessesQueryHookResult = ReturnType<typeof useBuilderConfigurablePostProcessesQuery>;
export type BuilderConfigurablePostProcessesLazyQueryHookResult = ReturnType<typeof useBuilderConfigurablePostProcessesLazyQuery>;
export type BuilderConfigurablePostProcessesQueryResult = Apollo.QueryResult<BuilderConfigurablePostProcessesQuery, BuilderConfigurablePostProcessesQueryVariables>;
export function refetchBuilderConfigurablePostProcessesQuery(variables: BuilderConfigurablePostProcessesQueryVariables) {
      return { query: BuilderConfigurablePostProcessesDocument, variables: variables }
    }
export const CheckAdditionOfPostProcessToCurrentQmrConfigDocument = gql`
    query checkAdditionOfPostProcessToCurrentQmrConfig($id: UUID!, $postProcess: SecondaryProcessConfigInput!) {
  checkAdditionOfPostProcessToCurrentQmrConfig(id: $id, postProcess: $postProcess) {
    postProcess {
      id
    }
    postProcessColor {
      id
    }
    postProcessThickness {
      id
    }
    postProcessNumParts
    postProcessInspectionCriteria
    postProcessLeadTimeInDays
    unitPriceInCents
    postProcessOverseasOnly
  }
}
    `;

/**
 * __useCheckAdditionOfPostProcessToCurrentQmrConfigQuery__
 *
 * To run a query within a React component, call `useCheckAdditionOfPostProcessToCurrentQmrConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckAdditionOfPostProcessToCurrentQmrConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckAdditionOfPostProcessToCurrentQmrConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *      postProcess: // value for 'postProcess'
 *   },
 * });
 */
export function useCheckAdditionOfPostProcessToCurrentQmrConfigQuery(baseOptions: Apollo.QueryHookOptions<CheckAdditionOfPostProcessToCurrentQmrConfigQuery, CheckAdditionOfPostProcessToCurrentQmrConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckAdditionOfPostProcessToCurrentQmrConfigQuery, CheckAdditionOfPostProcessToCurrentQmrConfigQueryVariables>(CheckAdditionOfPostProcessToCurrentQmrConfigDocument, options);
      }
export function useCheckAdditionOfPostProcessToCurrentQmrConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckAdditionOfPostProcessToCurrentQmrConfigQuery, CheckAdditionOfPostProcessToCurrentQmrConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckAdditionOfPostProcessToCurrentQmrConfigQuery, CheckAdditionOfPostProcessToCurrentQmrConfigQueryVariables>(CheckAdditionOfPostProcessToCurrentQmrConfigDocument, options);
        }
export type CheckAdditionOfPostProcessToCurrentQmrConfigQueryHookResult = ReturnType<typeof useCheckAdditionOfPostProcessToCurrentQmrConfigQuery>;
export type CheckAdditionOfPostProcessToCurrentQmrConfigLazyQueryHookResult = ReturnType<typeof useCheckAdditionOfPostProcessToCurrentQmrConfigLazyQuery>;
export type CheckAdditionOfPostProcessToCurrentQmrConfigQueryResult = Apollo.QueryResult<CheckAdditionOfPostProcessToCurrentQmrConfigQuery, CheckAdditionOfPostProcessToCurrentQmrConfigQueryVariables>;
export function refetchCheckAdditionOfPostProcessToCurrentQmrConfigQuery(variables: CheckAdditionOfPostProcessToCurrentQmrConfigQueryVariables) {
      return { query: CheckAdditionOfPostProcessToCurrentQmrConfigDocument, variables: variables }
    }
export const CheckDomesticMaterialCertificationDocument = gql`
    query checkDomesticMaterialCertification($materialId: String!) {
  checkDomesticMaterialCertification(materialId: $materialId)
}
    `;

/**
 * __useCheckDomesticMaterialCertificationQuery__
 *
 * To run a query within a React component, call `useCheckDomesticMaterialCertificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckDomesticMaterialCertificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckDomesticMaterialCertificationQuery({
 *   variables: {
 *      materialId: // value for 'materialId'
 *   },
 * });
 */
export function useCheckDomesticMaterialCertificationQuery(baseOptions: Apollo.QueryHookOptions<CheckDomesticMaterialCertificationQuery, CheckDomesticMaterialCertificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckDomesticMaterialCertificationQuery, CheckDomesticMaterialCertificationQueryVariables>(CheckDomesticMaterialCertificationDocument, options);
      }
export function useCheckDomesticMaterialCertificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckDomesticMaterialCertificationQuery, CheckDomesticMaterialCertificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckDomesticMaterialCertificationQuery, CheckDomesticMaterialCertificationQueryVariables>(CheckDomesticMaterialCertificationDocument, options);
        }
export type CheckDomesticMaterialCertificationQueryHookResult = ReturnType<typeof useCheckDomesticMaterialCertificationQuery>;
export type CheckDomesticMaterialCertificationLazyQueryHookResult = ReturnType<typeof useCheckDomesticMaterialCertificationLazyQuery>;
export type CheckDomesticMaterialCertificationQueryResult = Apollo.QueryResult<CheckDomesticMaterialCertificationQuery, CheckDomesticMaterialCertificationQueryVariables>;
export function refetchCheckDomesticMaterialCertificationQuery(variables: CheckDomesticMaterialCertificationQueryVariables) {
      return { query: CheckDomesticMaterialCertificationDocument, variables: variables }
    }
export const CheckSupportedPriorityRegionsQueryInSpSectionDocument = gql`
    query checkSupportedPriorityRegionsQueryInSPSection($id: UUID!) {
  quoteModelRevision(id: $id) {
    supportedPriorityRegions {
      partSupportsDomestic
      partSupportsInternational
    }
  }
}
    `;

/**
 * __useCheckSupportedPriorityRegionsQueryInSpSectionQuery__
 *
 * To run a query within a React component, call `useCheckSupportedPriorityRegionsQueryInSpSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckSupportedPriorityRegionsQueryInSpSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckSupportedPriorityRegionsQueryInSpSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCheckSupportedPriorityRegionsQueryInSpSectionQuery(baseOptions: Apollo.QueryHookOptions<CheckSupportedPriorityRegionsQueryInSpSectionQuery, CheckSupportedPriorityRegionsQueryInSpSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckSupportedPriorityRegionsQueryInSpSectionQuery, CheckSupportedPriorityRegionsQueryInSpSectionQueryVariables>(CheckSupportedPriorityRegionsQueryInSpSectionDocument, options);
      }
export function useCheckSupportedPriorityRegionsQueryInSpSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckSupportedPriorityRegionsQueryInSpSectionQuery, CheckSupportedPriorityRegionsQueryInSpSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckSupportedPriorityRegionsQueryInSpSectionQuery, CheckSupportedPriorityRegionsQueryInSpSectionQueryVariables>(CheckSupportedPriorityRegionsQueryInSpSectionDocument, options);
        }
export type CheckSupportedPriorityRegionsQueryInSpSectionQueryHookResult = ReturnType<typeof useCheckSupportedPriorityRegionsQueryInSpSectionQuery>;
export type CheckSupportedPriorityRegionsQueryInSpSectionLazyQueryHookResult = ReturnType<typeof useCheckSupportedPriorityRegionsQueryInSpSectionLazyQuery>;
export type CheckSupportedPriorityRegionsQueryInSpSectionQueryResult = Apollo.QueryResult<CheckSupportedPriorityRegionsQueryInSpSectionQuery, CheckSupportedPriorityRegionsQueryInSpSectionQueryVariables>;
export function refetchCheckSupportedPriorityRegionsQueryInSpSectionQuery(variables: CheckSupportedPriorityRegionsQueryInSpSectionQueryVariables) {
      return { query: CheckSupportedPriorityRegionsQueryInSpSectionDocument, variables: variables }
    }
export const FetchIsoCountryDataDocument = gql`
    query fetchISOCountryData {
  countries {
    ...ISOCountry
  }
}
    ${IsoCountryFragmentDoc}`;

/**
 * __useFetchIsoCountryDataQuery__
 *
 * To run a query within a React component, call `useFetchIsoCountryDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchIsoCountryDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchIsoCountryDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchIsoCountryDataQuery(baseOptions?: Apollo.QueryHookOptions<FetchIsoCountryDataQuery, FetchIsoCountryDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchIsoCountryDataQuery, FetchIsoCountryDataQueryVariables>(FetchIsoCountryDataDocument, options);
      }
export function useFetchIsoCountryDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchIsoCountryDataQuery, FetchIsoCountryDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchIsoCountryDataQuery, FetchIsoCountryDataQueryVariables>(FetchIsoCountryDataDocument, options);
        }
export type FetchIsoCountryDataQueryHookResult = ReturnType<typeof useFetchIsoCountryDataQuery>;
export type FetchIsoCountryDataLazyQueryHookResult = ReturnType<typeof useFetchIsoCountryDataLazyQuery>;
export type FetchIsoCountryDataQueryResult = Apollo.QueryResult<FetchIsoCountryDataQuery, FetchIsoCountryDataQueryVariables>;
export function refetchFetchIsoCountryDataQuery(variables?: FetchIsoCountryDataQueryVariables) {
      return { query: FetchIsoCountryDataDocument, variables: variables }
    }
export const GetDownloadableQuotePdfDocument = gql`
    query getDownloadableQuotePdf($quoteId: String!) {
  getDownloadableQuotePdf(quoteId: $quoteId)
}
    `;

/**
 * __useGetDownloadableQuotePdfQuery__
 *
 * To run a query within a React component, call `useGetDownloadableQuotePdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDownloadableQuotePdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDownloadableQuotePdfQuery({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useGetDownloadableQuotePdfQuery(baseOptions: Apollo.QueryHookOptions<GetDownloadableQuotePdfQuery, GetDownloadableQuotePdfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDownloadableQuotePdfQuery, GetDownloadableQuotePdfQueryVariables>(GetDownloadableQuotePdfDocument, options);
      }
export function useGetDownloadableQuotePdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDownloadableQuotePdfQuery, GetDownloadableQuotePdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDownloadableQuotePdfQuery, GetDownloadableQuotePdfQueryVariables>(GetDownloadableQuotePdfDocument, options);
        }
export type GetDownloadableQuotePdfQueryHookResult = ReturnType<typeof useGetDownloadableQuotePdfQuery>;
export type GetDownloadableQuotePdfLazyQueryHookResult = ReturnType<typeof useGetDownloadableQuotePdfLazyQuery>;
export type GetDownloadableQuotePdfQueryResult = Apollo.QueryResult<GetDownloadableQuotePdfQuery, GetDownloadableQuotePdfQueryVariables>;
export function refetchGetDownloadableQuotePdfQuery(variables: GetDownloadableQuotePdfQueryVariables) {
      return { query: GetDownloadableQuotePdfDocument, variables: variables }
    }
export const ImQuotePartsAndMoldsCountSummaryCardDocument = gql`
    query imQuotePartsAndMoldsCountSummaryCard($id: UUID!) {
  quote(id: $id) {
    id
    quoteItems {
      totalCount
    }
    molds {
      id
    }
  }
}
    `;

/**
 * __useImQuotePartsAndMoldsCountSummaryCardQuery__
 *
 * To run a query within a React component, call `useImQuotePartsAndMoldsCountSummaryCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useImQuotePartsAndMoldsCountSummaryCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImQuotePartsAndMoldsCountSummaryCardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useImQuotePartsAndMoldsCountSummaryCardQuery(baseOptions: Apollo.QueryHookOptions<ImQuotePartsAndMoldsCountSummaryCardQuery, ImQuotePartsAndMoldsCountSummaryCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImQuotePartsAndMoldsCountSummaryCardQuery, ImQuotePartsAndMoldsCountSummaryCardQueryVariables>(ImQuotePartsAndMoldsCountSummaryCardDocument, options);
      }
export function useImQuotePartsAndMoldsCountSummaryCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImQuotePartsAndMoldsCountSummaryCardQuery, ImQuotePartsAndMoldsCountSummaryCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImQuotePartsAndMoldsCountSummaryCardQuery, ImQuotePartsAndMoldsCountSummaryCardQueryVariables>(ImQuotePartsAndMoldsCountSummaryCardDocument, options);
        }
export type ImQuotePartsAndMoldsCountSummaryCardQueryHookResult = ReturnType<typeof useImQuotePartsAndMoldsCountSummaryCardQuery>;
export type ImQuotePartsAndMoldsCountSummaryCardLazyQueryHookResult = ReturnType<typeof useImQuotePartsAndMoldsCountSummaryCardLazyQuery>;
export type ImQuotePartsAndMoldsCountSummaryCardQueryResult = Apollo.QueryResult<ImQuotePartsAndMoldsCountSummaryCardQuery, ImQuotePartsAndMoldsCountSummaryCardQueryVariables>;
export function refetchImQuotePartsAndMoldsCountSummaryCardQuery(variables: ImQuotePartsAndMoldsCountSummaryCardQueryVariables) {
      return { query: ImQuotePartsAndMoldsCountSummaryCardDocument, variables: variables }
    }
export const ListCustomerShippingAccountDocument = gql`
    query listCustomerShippingAccount($userId: Int) {
  carrierAccounts(userId: $userId) {
    ...CarrierAccount
  }
}
    ${CarrierAccountFragmentDoc}`;

/**
 * __useListCustomerShippingAccountQuery__
 *
 * To run a query within a React component, call `useListCustomerShippingAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCustomerShippingAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCustomerShippingAccountQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useListCustomerShippingAccountQuery(baseOptions?: Apollo.QueryHookOptions<ListCustomerShippingAccountQuery, ListCustomerShippingAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCustomerShippingAccountQuery, ListCustomerShippingAccountQueryVariables>(ListCustomerShippingAccountDocument, options);
      }
export function useListCustomerShippingAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCustomerShippingAccountQuery, ListCustomerShippingAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCustomerShippingAccountQuery, ListCustomerShippingAccountQueryVariables>(ListCustomerShippingAccountDocument, options);
        }
export type ListCustomerShippingAccountQueryHookResult = ReturnType<typeof useListCustomerShippingAccountQuery>;
export type ListCustomerShippingAccountLazyQueryHookResult = ReturnType<typeof useListCustomerShippingAccountLazyQuery>;
export type ListCustomerShippingAccountQueryResult = Apollo.QueryResult<ListCustomerShippingAccountQuery, ListCustomerShippingAccountQueryVariables>;
export function refetchListCustomerShippingAccountQuery(variables?: ListCustomerShippingAccountQueryVariables) {
      return { query: ListCustomerShippingAccountDocument, variables: variables }
    }
export const MatchCadFileNamesToPdfFileNamesDocument = gql`
    query matchCadFileNamesToPdfFileNames($cadNames: [String], $pdfNames: [String]) {
  matchCadFileNamesToPdfFileNames(
    cadFileNames: $cadNames
    pdfFileNames: $pdfNames
  ) {
    cadFileName
    pdfFileName
  }
}
    `;

/**
 * __useMatchCadFileNamesToPdfFileNamesQuery__
 *
 * To run a query within a React component, call `useMatchCadFileNamesToPdfFileNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchCadFileNamesToPdfFileNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchCadFileNamesToPdfFileNamesQuery({
 *   variables: {
 *      cadNames: // value for 'cadNames'
 *      pdfNames: // value for 'pdfNames'
 *   },
 * });
 */
export function useMatchCadFileNamesToPdfFileNamesQuery(baseOptions?: Apollo.QueryHookOptions<MatchCadFileNamesToPdfFileNamesQuery, MatchCadFileNamesToPdfFileNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchCadFileNamesToPdfFileNamesQuery, MatchCadFileNamesToPdfFileNamesQueryVariables>(MatchCadFileNamesToPdfFileNamesDocument, options);
      }
export function useMatchCadFileNamesToPdfFileNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchCadFileNamesToPdfFileNamesQuery, MatchCadFileNamesToPdfFileNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchCadFileNamesToPdfFileNamesQuery, MatchCadFileNamesToPdfFileNamesQueryVariables>(MatchCadFileNamesToPdfFileNamesDocument, options);
        }
export type MatchCadFileNamesToPdfFileNamesQueryHookResult = ReturnType<typeof useMatchCadFileNamesToPdfFileNamesQuery>;
export type MatchCadFileNamesToPdfFileNamesLazyQueryHookResult = ReturnType<typeof useMatchCadFileNamesToPdfFileNamesLazyQuery>;
export type MatchCadFileNamesToPdfFileNamesQueryResult = Apollo.QueryResult<MatchCadFileNamesToPdfFileNamesQuery, MatchCadFileNamesToPdfFileNamesQueryVariables>;
export function refetchMatchCadFileNamesToPdfFileNamesQuery(variables?: MatchCadFileNamesToPdfFileNamesQueryVariables) {
      return { query: MatchCadFileNamesToPdfFileNamesDocument, variables: variables }
    }
export const MaterialConfigurationOptionsDocument = gql`
    query materialConfigurationOptions($materialId: String!) {
  materialConfigurationOptions(materialId: $materialId) {
    id
    colorId
    colorName
    shoreId
    shoreName
  }
}
    `;

/**
 * __useMaterialConfigurationOptionsQuery__
 *
 * To run a query within a React component, call `useMaterialConfigurationOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialConfigurationOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialConfigurationOptionsQuery({
 *   variables: {
 *      materialId: // value for 'materialId'
 *   },
 * });
 */
export function useMaterialConfigurationOptionsQuery(baseOptions: Apollo.QueryHookOptions<MaterialConfigurationOptionsQuery, MaterialConfigurationOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaterialConfigurationOptionsQuery, MaterialConfigurationOptionsQueryVariables>(MaterialConfigurationOptionsDocument, options);
      }
export function useMaterialConfigurationOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaterialConfigurationOptionsQuery, MaterialConfigurationOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaterialConfigurationOptionsQuery, MaterialConfigurationOptionsQueryVariables>(MaterialConfigurationOptionsDocument, options);
        }
export type MaterialConfigurationOptionsQueryHookResult = ReturnType<typeof useMaterialConfigurationOptionsQuery>;
export type MaterialConfigurationOptionsLazyQueryHookResult = ReturnType<typeof useMaterialConfigurationOptionsLazyQuery>;
export type MaterialConfigurationOptionsQueryResult = Apollo.QueryResult<MaterialConfigurationOptionsQuery, MaterialConfigurationOptionsQueryVariables>;
export function refetchMaterialConfigurationOptionsQuery(variables: MaterialConfigurationOptionsQueryVariables) {
      return { query: MaterialConfigurationOptionsDocument, variables: variables }
    }
export const MaterialShoresDocument = gql`
    query materialShores($materialId: String!) {
  shores(materialId: $materialId) {
    id
    name
  }
}
    `;

/**
 * __useMaterialShoresQuery__
 *
 * To run a query within a React component, call `useMaterialShoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialShoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialShoresQuery({
 *   variables: {
 *      materialId: // value for 'materialId'
 *   },
 * });
 */
export function useMaterialShoresQuery(baseOptions: Apollo.QueryHookOptions<MaterialShoresQuery, MaterialShoresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaterialShoresQuery, MaterialShoresQueryVariables>(MaterialShoresDocument, options);
      }
export function useMaterialShoresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaterialShoresQuery, MaterialShoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaterialShoresQuery, MaterialShoresQueryVariables>(MaterialShoresDocument, options);
        }
export type MaterialShoresQueryHookResult = ReturnType<typeof useMaterialShoresQuery>;
export type MaterialShoresLazyQueryHookResult = ReturnType<typeof useMaterialShoresLazyQuery>;
export type MaterialShoresQueryResult = Apollo.QueryResult<MaterialShoresQuery, MaterialShoresQueryVariables>;
export function refetchMaterialShoresQuery(variables: MaterialShoresQueryVariables) {
      return { query: MaterialShoresDocument, variables: variables }
    }
export const MaterialsDropdownDocument = gql`
    query materialsDropdown($processId: String!) {
  materials(processId: $processId) {
    ...MaterialsDropdownMaterial
  }
}
    ${MaterialsDropdownMaterialFragmentDoc}`;

/**
 * __useMaterialsDropdownQuery__
 *
 * To run a query within a React component, call `useMaterialsDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialsDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialsDropdownQuery({
 *   variables: {
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useMaterialsDropdownQuery(baseOptions: Apollo.QueryHookOptions<MaterialsDropdownQuery, MaterialsDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaterialsDropdownQuery, MaterialsDropdownQueryVariables>(MaterialsDropdownDocument, options);
      }
export function useMaterialsDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaterialsDropdownQuery, MaterialsDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaterialsDropdownQuery, MaterialsDropdownQueryVariables>(MaterialsDropdownDocument, options);
        }
export type MaterialsDropdownQueryHookResult = ReturnType<typeof useMaterialsDropdownQuery>;
export type MaterialsDropdownLazyQueryHookResult = ReturnType<typeof useMaterialsDropdownLazyQuery>;
export type MaterialsDropdownQueryResult = Apollo.QueryResult<MaterialsDropdownQuery, MaterialsDropdownQueryVariables>;
export function refetchMaterialsDropdownQuery(variables: MaterialsDropdownQueryVariables) {
      return { query: MaterialsDropdownDocument, variables: variables }
    }
export const PreCheckoutQuotePricePreviewDownloadUrlDocument = gql`
    query preCheckoutQuotePricePreviewDownloadUrl($quoteId: UUID!, $userId: Int, $shippingMethods: [ShippingMethodInput!], $forResale: Boolean, $carrierAccountId: UUID, $isShippingOptionForCarrier: Boolean) {
  preCheckoutQuotePricePreviewDownloadUrl(
    quoteId: $quoteId
    userId: $userId
    shippingMethods: $shippingMethods
    forResale: $forResale
    carrierAccountId: $carrierAccountId
    isShippingOptionForCarrier: $isShippingOptionForCarrier
  )
}
    `;

/**
 * __usePreCheckoutQuotePricePreviewDownloadUrlQuery__
 *
 * To run a query within a React component, call `usePreCheckoutQuotePricePreviewDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreCheckoutQuotePricePreviewDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreCheckoutQuotePricePreviewDownloadUrlQuery({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      userId: // value for 'userId'
 *      shippingMethods: // value for 'shippingMethods'
 *      forResale: // value for 'forResale'
 *      carrierAccountId: // value for 'carrierAccountId'
 *      isShippingOptionForCarrier: // value for 'isShippingOptionForCarrier'
 *   },
 * });
 */
export function usePreCheckoutQuotePricePreviewDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<PreCheckoutQuotePricePreviewDownloadUrlQuery, PreCheckoutQuotePricePreviewDownloadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreCheckoutQuotePricePreviewDownloadUrlQuery, PreCheckoutQuotePricePreviewDownloadUrlQueryVariables>(PreCheckoutQuotePricePreviewDownloadUrlDocument, options);
      }
export function usePreCheckoutQuotePricePreviewDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreCheckoutQuotePricePreviewDownloadUrlQuery, PreCheckoutQuotePricePreviewDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreCheckoutQuotePricePreviewDownloadUrlQuery, PreCheckoutQuotePricePreviewDownloadUrlQueryVariables>(PreCheckoutQuotePricePreviewDownloadUrlDocument, options);
        }
export type PreCheckoutQuotePricePreviewDownloadUrlQueryHookResult = ReturnType<typeof usePreCheckoutQuotePricePreviewDownloadUrlQuery>;
export type PreCheckoutQuotePricePreviewDownloadUrlLazyQueryHookResult = ReturnType<typeof usePreCheckoutQuotePricePreviewDownloadUrlLazyQuery>;
export type PreCheckoutQuotePricePreviewDownloadUrlQueryResult = Apollo.QueryResult<PreCheckoutQuotePricePreviewDownloadUrlQuery, PreCheckoutQuotePricePreviewDownloadUrlQueryVariables>;
export function refetchPreCheckoutQuotePricePreviewDownloadUrlQuery(variables: PreCheckoutQuotePricePreviewDownloadUrlQueryVariables) {
      return { query: PreCheckoutQuotePricePreviewDownloadUrlDocument, variables: variables }
    }
export const ProcessTexturesDocument = gql`
    query processTextures($processId: String!) {
  textures(processId: $processId) {
    ...ProcessTexture
  }
}
    ${ProcessTextureFragmentDoc}`;

/**
 * __useProcessTexturesQuery__
 *
 * To run a query within a React component, call `useProcessTexturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessTexturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessTexturesQuery({
 *   variables: {
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useProcessTexturesQuery(baseOptions: Apollo.QueryHookOptions<ProcessTexturesQuery, ProcessTexturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessTexturesQuery, ProcessTexturesQueryVariables>(ProcessTexturesDocument, options);
      }
export function useProcessTexturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessTexturesQuery, ProcessTexturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessTexturesQuery, ProcessTexturesQueryVariables>(ProcessTexturesDocument, options);
        }
export type ProcessTexturesQueryHookResult = ReturnType<typeof useProcessTexturesQuery>;
export type ProcessTexturesLazyQueryHookResult = ReturnType<typeof useProcessTexturesLazyQuery>;
export type ProcessTexturesQueryResult = Apollo.QueryResult<ProcessTexturesQuery, ProcessTexturesQueryVariables>;
export function refetchProcessTexturesQuery(variables: ProcessTexturesQueryVariables) {
      return { query: ProcessTexturesDocument, variables: variables }
    }
export const ProcessesConfigFormProcessDropdownDocument = gql`
    query processesConfigFormProcessDropdown($quoteType: QuoteType) {
  processes(quoteType: $quoteType) {
    id
    name
  }
}
    `;

/**
 * __useProcessesConfigFormProcessDropdownQuery__
 *
 * To run a query within a React component, call `useProcessesConfigFormProcessDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessesConfigFormProcessDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessesConfigFormProcessDropdownQuery({
 *   variables: {
 *      quoteType: // value for 'quoteType'
 *   },
 * });
 */
export function useProcessesConfigFormProcessDropdownQuery(baseOptions?: Apollo.QueryHookOptions<ProcessesConfigFormProcessDropdownQuery, ProcessesConfigFormProcessDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessesConfigFormProcessDropdownQuery, ProcessesConfigFormProcessDropdownQueryVariables>(ProcessesConfigFormProcessDropdownDocument, options);
      }
export function useProcessesConfigFormProcessDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessesConfigFormProcessDropdownQuery, ProcessesConfigFormProcessDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessesConfigFormProcessDropdownQuery, ProcessesConfigFormProcessDropdownQueryVariables>(ProcessesConfigFormProcessDropdownDocument, options);
        }
export type ProcessesConfigFormProcessDropdownQueryHookResult = ReturnType<typeof useProcessesConfigFormProcessDropdownQuery>;
export type ProcessesConfigFormProcessDropdownLazyQueryHookResult = ReturnType<typeof useProcessesConfigFormProcessDropdownLazyQuery>;
export type ProcessesConfigFormProcessDropdownQueryResult = Apollo.QueryResult<ProcessesConfigFormProcessDropdownQuery, ProcessesConfigFormProcessDropdownQueryVariables>;
export function refetchProcessesConfigFormProcessDropdownQuery(variables?: ProcessesConfigFormProcessDropdownQueryVariables) {
      return { query: ProcessesConfigFormProcessDropdownDocument, variables: variables }
    }
export const ProjectMemberCheckDocument = gql`
    query projectMemberCheck($id: UUID!) {
  project(id: $id) {
    id
    currentUserIsMember
  }
}
    `;

/**
 * __useProjectMemberCheckQuery__
 *
 * To run a query within a React component, call `useProjectMemberCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectMemberCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectMemberCheckQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectMemberCheckQuery(baseOptions: Apollo.QueryHookOptions<ProjectMemberCheckQuery, ProjectMemberCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectMemberCheckQuery, ProjectMemberCheckQueryVariables>(ProjectMemberCheckDocument, options);
      }
export function useProjectMemberCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectMemberCheckQuery, ProjectMemberCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectMemberCheckQuery, ProjectMemberCheckQueryVariables>(ProjectMemberCheckDocument, options);
        }
export type ProjectMemberCheckQueryHookResult = ReturnType<typeof useProjectMemberCheckQuery>;
export type ProjectMemberCheckLazyQueryHookResult = ReturnType<typeof useProjectMemberCheckLazyQuery>;
export type ProjectMemberCheckQueryResult = Apollo.QueryResult<ProjectMemberCheckQuery, ProjectMemberCheckQueryVariables>;
export function refetchProjectMemberCheckQuery(variables: ProjectMemberCheckQueryVariables) {
      return { query: ProjectMemberCheckDocument, variables: variables }
    }
export const QuoteDetailsCheckoutDocument = gql`
    query quoteDetailsCheckout($id: UUID!, $address: AddressInput, $carrier: Carrier, $isCpqFlagV2Enabled: Boolean = false) {
  quote(id: $id) {
    ...QuoteDetailsCheckout
  }
}
    ${QuoteDetailsCheckoutFragmentDoc}`;

/**
 * __useQuoteDetailsCheckoutQuery__
 *
 * To run a query within a React component, call `useQuoteDetailsCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteDetailsCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteDetailsCheckoutQuery({
 *   variables: {
 *      id: // value for 'id'
 *      address: // value for 'address'
 *      carrier: // value for 'carrier'
 *      isCpqFlagV2Enabled: // value for 'isCpqFlagV2Enabled'
 *   },
 * });
 */
export function useQuoteDetailsCheckoutQuery(baseOptions: Apollo.QueryHookOptions<QuoteDetailsCheckoutQuery, QuoteDetailsCheckoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteDetailsCheckoutQuery, QuoteDetailsCheckoutQueryVariables>(QuoteDetailsCheckoutDocument, options);
      }
export function useQuoteDetailsCheckoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteDetailsCheckoutQuery, QuoteDetailsCheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteDetailsCheckoutQuery, QuoteDetailsCheckoutQueryVariables>(QuoteDetailsCheckoutDocument, options);
        }
export type QuoteDetailsCheckoutQueryHookResult = ReturnType<typeof useQuoteDetailsCheckoutQuery>;
export type QuoteDetailsCheckoutLazyQueryHookResult = ReturnType<typeof useQuoteDetailsCheckoutLazyQuery>;
export type QuoteDetailsCheckoutQueryResult = Apollo.QueryResult<QuoteDetailsCheckoutQuery, QuoteDetailsCheckoutQueryVariables>;
export function refetchQuoteDetailsCheckoutQuery(variables: QuoteDetailsCheckoutQueryVariables) {
      return { query: QuoteDetailsCheckoutDocument, variables: variables }
    }
export const QuotePricePreviewDocument = gql`
    query quotePricePreview($priceInput: PricingInput!, $userId: Int) {
  quotePricePreview(priceInput: $priceInput, userId: $userId) {
    ...QuotePricePreviewData
  }
}
    ${QuotePricePreviewDataFragmentDoc}`;

/**
 * __useQuotePricePreviewQuery__
 *
 * To run a query within a React component, call `useQuotePricePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuotePricePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuotePricePreviewQuery({
 *   variables: {
 *      priceInput: // value for 'priceInput'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useQuotePricePreviewQuery(baseOptions: Apollo.QueryHookOptions<QuotePricePreviewQuery, QuotePricePreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuotePricePreviewQuery, QuotePricePreviewQueryVariables>(QuotePricePreviewDocument, options);
      }
export function useQuotePricePreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuotePricePreviewQuery, QuotePricePreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuotePricePreviewQuery, QuotePricePreviewQueryVariables>(QuotePricePreviewDocument, options);
        }
export type QuotePricePreviewQueryHookResult = ReturnType<typeof useQuotePricePreviewQuery>;
export type QuotePricePreviewLazyQueryHookResult = ReturnType<typeof useQuotePricePreviewLazyQuery>;
export type QuotePricePreviewQueryResult = Apollo.QueryResult<QuotePricePreviewQuery, QuotePricePreviewQueryVariables>;
export function refetchQuotePricePreviewQuery(variables: QuotePricePreviewQueryVariables) {
      return { query: QuotePricePreviewDocument, variables: variables }
    }
export const QuotePricePreviewDownloadUrlDocument = gql`
    query quotePricePreviewDownloadUrl($priceInput: PricingInput!, $userId: Int) {
  quotePricePreviewDownloadUrl(priceInput: $priceInput, userId: $userId)
}
    `;

/**
 * __useQuotePricePreviewDownloadUrlQuery__
 *
 * To run a query within a React component, call `useQuotePricePreviewDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuotePricePreviewDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuotePricePreviewDownloadUrlQuery({
 *   variables: {
 *      priceInput: // value for 'priceInput'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useQuotePricePreviewDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<QuotePricePreviewDownloadUrlQuery, QuotePricePreviewDownloadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuotePricePreviewDownloadUrlQuery, QuotePricePreviewDownloadUrlQueryVariables>(QuotePricePreviewDownloadUrlDocument, options);
      }
export function useQuotePricePreviewDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuotePricePreviewDownloadUrlQuery, QuotePricePreviewDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuotePricePreviewDownloadUrlQuery, QuotePricePreviewDownloadUrlQueryVariables>(QuotePricePreviewDownloadUrlDocument, options);
        }
export type QuotePricePreviewDownloadUrlQueryHookResult = ReturnType<typeof useQuotePricePreviewDownloadUrlQuery>;
export type QuotePricePreviewDownloadUrlLazyQueryHookResult = ReturnType<typeof useQuotePricePreviewDownloadUrlLazyQuery>;
export type QuotePricePreviewDownloadUrlQueryResult = Apollo.QueryResult<QuotePricePreviewDownloadUrlQuery, QuotePricePreviewDownloadUrlQueryVariables>;
export function refetchQuotePricePreviewDownloadUrlQuery(variables: QuotePricePreviewDownloadUrlQueryVariables) {
      return { query: QuotePricePreviewDownloadUrlDocument, variables: variables }
    }
export const SecondaryProcessPricingCalculatorDocument = gql`
    query secondaryProcessPricingCalculator($quoteFields: PricingQuoteFieldsInput!, $quantity: Int!) {
  secondaryProcessPricingCalculator(
    quoteFields: $quoteFields
    quantity: $quantity
  ) {
    priceInCents
    unitPriceInCents
  }
}
    `;

/**
 * __useSecondaryProcessPricingCalculatorQuery__
 *
 * To run a query within a React component, call `useSecondaryProcessPricingCalculatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useSecondaryProcessPricingCalculatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSecondaryProcessPricingCalculatorQuery({
 *   variables: {
 *      quoteFields: // value for 'quoteFields'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useSecondaryProcessPricingCalculatorQuery(baseOptions: Apollo.QueryHookOptions<SecondaryProcessPricingCalculatorQuery, SecondaryProcessPricingCalculatorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SecondaryProcessPricingCalculatorQuery, SecondaryProcessPricingCalculatorQueryVariables>(SecondaryProcessPricingCalculatorDocument, options);
      }
export function useSecondaryProcessPricingCalculatorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SecondaryProcessPricingCalculatorQuery, SecondaryProcessPricingCalculatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SecondaryProcessPricingCalculatorQuery, SecondaryProcessPricingCalculatorQueryVariables>(SecondaryProcessPricingCalculatorDocument, options);
        }
export type SecondaryProcessPricingCalculatorQueryHookResult = ReturnType<typeof useSecondaryProcessPricingCalculatorQuery>;
export type SecondaryProcessPricingCalculatorLazyQueryHookResult = ReturnType<typeof useSecondaryProcessPricingCalculatorLazyQuery>;
export type SecondaryProcessPricingCalculatorQueryResult = Apollo.QueryResult<SecondaryProcessPricingCalculatorQuery, SecondaryProcessPricingCalculatorQueryVariables>;
export function refetchSecondaryProcessPricingCalculatorQuery(variables: SecondaryProcessPricingCalculatorQueryVariables) {
      return { query: SecondaryProcessPricingCalculatorDocument, variables: variables }
    }
export const ShippingAddresssesQuoteCheckoutPageDocument = gql`
    query shippingAddresssesQuoteCheckoutPage {
  me {
    id
    shippingAddresses {
      ...ShippingAddressesItem
    }
  }
}
    ${ShippingAddressesItemFragmentDoc}`;

/**
 * __useShippingAddresssesQuoteCheckoutPageQuery__
 *
 * To run a query within a React component, call `useShippingAddresssesQuoteCheckoutPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useShippingAddresssesQuoteCheckoutPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShippingAddresssesQuoteCheckoutPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useShippingAddresssesQuoteCheckoutPageQuery(baseOptions?: Apollo.QueryHookOptions<ShippingAddresssesQuoteCheckoutPageQuery, ShippingAddresssesQuoteCheckoutPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShippingAddresssesQuoteCheckoutPageQuery, ShippingAddresssesQuoteCheckoutPageQueryVariables>(ShippingAddresssesQuoteCheckoutPageDocument, options);
      }
export function useShippingAddresssesQuoteCheckoutPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShippingAddresssesQuoteCheckoutPageQuery, ShippingAddresssesQuoteCheckoutPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShippingAddresssesQuoteCheckoutPageQuery, ShippingAddresssesQuoteCheckoutPageQueryVariables>(ShippingAddresssesQuoteCheckoutPageDocument, options);
        }
export type ShippingAddresssesQuoteCheckoutPageQueryHookResult = ReturnType<typeof useShippingAddresssesQuoteCheckoutPageQuery>;
export type ShippingAddresssesQuoteCheckoutPageLazyQueryHookResult = ReturnType<typeof useShippingAddresssesQuoteCheckoutPageLazyQuery>;
export type ShippingAddresssesQuoteCheckoutPageQueryResult = Apollo.QueryResult<ShippingAddresssesQuoteCheckoutPageQuery, ShippingAddresssesQuoteCheckoutPageQueryVariables>;
export function refetchShippingAddresssesQuoteCheckoutPageQuery(variables?: ShippingAddresssesQuoteCheckoutPageQueryVariables) {
      return { query: ShippingAddresssesQuoteCheckoutPageDocument, variables: variables }
    }
export const UserAchAccountsDocument = gql`
    query userAchAccounts {
  me {
    id
    achAccounts {
      ...UserAchAccountsItem
    }
  }
}
    ${UserAchAccountsItemFragmentDoc}`;

/**
 * __useUserAchAccountsQuery__
 *
 * To run a query within a React component, call `useUserAchAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAchAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAchAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserAchAccountsQuery(baseOptions?: Apollo.QueryHookOptions<UserAchAccountsQuery, UserAchAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAchAccountsQuery, UserAchAccountsQueryVariables>(UserAchAccountsDocument, options);
      }
export function useUserAchAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAchAccountsQuery, UserAchAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAchAccountsQuery, UserAchAccountsQueryVariables>(UserAchAccountsDocument, options);
        }
export type UserAchAccountsQueryHookResult = ReturnType<typeof useUserAchAccountsQuery>;
export type UserAchAccountsLazyQueryHookResult = ReturnType<typeof useUserAchAccountsLazyQuery>;
export type UserAchAccountsQueryResult = Apollo.QueryResult<UserAchAccountsQuery, UserAchAccountsQueryVariables>;
export function refetchUserAchAccountsQuery(variables?: UserAchAccountsQueryVariables) {
      return { query: UserAchAccountsDocument, variables: variables }
    }
export const UserCreditCardsDocument = gql`
    query userCreditCards {
  me {
    id
    creditCards {
      ...UserCreditCardsItem
    }
  }
}
    ${UserCreditCardsItemFragmentDoc}`;

/**
 * __useUserCreditCardsQuery__
 *
 * To run a query within a React component, call `useUserCreditCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCreditCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCreditCardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserCreditCardsQuery(baseOptions?: Apollo.QueryHookOptions<UserCreditCardsQuery, UserCreditCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserCreditCardsQuery, UserCreditCardsQueryVariables>(UserCreditCardsDocument, options);
      }
export function useUserCreditCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserCreditCardsQuery, UserCreditCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserCreditCardsQuery, UserCreditCardsQueryVariables>(UserCreditCardsDocument, options);
        }
export type UserCreditCardsQueryHookResult = ReturnType<typeof useUserCreditCardsQuery>;
export type UserCreditCardsLazyQueryHookResult = ReturnType<typeof useUserCreditCardsLazyQuery>;
export type UserCreditCardsQueryResult = Apollo.QueryResult<UserCreditCardsQuery, UserCreditCardsQueryVariables>;
export function refetchUserCreditCardsQuery(variables?: UserCreditCardsQueryVariables) {
      return { query: UserCreditCardsDocument, variables: variables }
    }
export const UserEnteredMaterialsDropdownDocument = gql`
    query userEnteredMaterialsDropdown {
  me {
    id
    userEnteredMaterials {
      id
      name
      process {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useUserEnteredMaterialsDropdownQuery__
 *
 * To run a query within a React component, call `useUserEnteredMaterialsDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserEnteredMaterialsDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserEnteredMaterialsDropdownQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserEnteredMaterialsDropdownQuery(baseOptions?: Apollo.QueryHookOptions<UserEnteredMaterialsDropdownQuery, UserEnteredMaterialsDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserEnteredMaterialsDropdownQuery, UserEnteredMaterialsDropdownQueryVariables>(UserEnteredMaterialsDropdownDocument, options);
      }
export function useUserEnteredMaterialsDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserEnteredMaterialsDropdownQuery, UserEnteredMaterialsDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserEnteredMaterialsDropdownQuery, UserEnteredMaterialsDropdownQueryVariables>(UserEnteredMaterialsDropdownDocument, options);
        }
export type UserEnteredMaterialsDropdownQueryHookResult = ReturnType<typeof useUserEnteredMaterialsDropdownQuery>;
export type UserEnteredMaterialsDropdownLazyQueryHookResult = ReturnType<typeof useUserEnteredMaterialsDropdownLazyQuery>;
export type UserEnteredMaterialsDropdownQueryResult = Apollo.QueryResult<UserEnteredMaterialsDropdownQuery, UserEnteredMaterialsDropdownQueryVariables>;
export function refetchUserEnteredMaterialsDropdownQuery(variables?: UserEnteredMaterialsDropdownQueryVariables) {
      return { query: UserEnteredMaterialsDropdownDocument, variables: variables }
    }
export const UserPaymentOptionsUserProfileDocument = gql`
    query userPaymentOptionsUserProfile {
  me {
    id
    paymentOptions {
      ...PaymentOption
    }
  }
}
    ${PaymentOptionFragmentDoc}`;

/**
 * __useUserPaymentOptionsUserProfileQuery__
 *
 * To run a query within a React component, call `useUserPaymentOptionsUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPaymentOptionsUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPaymentOptionsUserProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserPaymentOptionsUserProfileQuery(baseOptions?: Apollo.QueryHookOptions<UserPaymentOptionsUserProfileQuery, UserPaymentOptionsUserProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPaymentOptionsUserProfileQuery, UserPaymentOptionsUserProfileQueryVariables>(UserPaymentOptionsUserProfileDocument, options);
      }
export function useUserPaymentOptionsUserProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPaymentOptionsUserProfileQuery, UserPaymentOptionsUserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPaymentOptionsUserProfileQuery, UserPaymentOptionsUserProfileQueryVariables>(UserPaymentOptionsUserProfileDocument, options);
        }
export type UserPaymentOptionsUserProfileQueryHookResult = ReturnType<typeof useUserPaymentOptionsUserProfileQuery>;
export type UserPaymentOptionsUserProfileLazyQueryHookResult = ReturnType<typeof useUserPaymentOptionsUserProfileLazyQuery>;
export type UserPaymentOptionsUserProfileQueryResult = Apollo.QueryResult<UserPaymentOptionsUserProfileQuery, UserPaymentOptionsUserProfileQueryVariables>;
export function refetchUserPaymentOptionsUserProfileQuery(variables?: UserPaymentOptionsUserProfileQueryVariables) {
      return { query: UserPaymentOptionsUserProfileDocument, variables: variables }
    }
export const UserTeamsDocument = gql`
    query userTeams($userId: Int!) {
  user(id: $userId) {
    id
    email
    teams(includeTeamsFeatureDisabled: true, limit: 1000) {
      items {
        ...UserTeam
      }
    }
  }
}
    ${UserTeamFragmentDoc}`;

/**
 * __useUserTeamsQuery__
 *
 * To run a query within a React component, call `useUserTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTeamsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserTeamsQuery(baseOptions: Apollo.QueryHookOptions<UserTeamsQuery, UserTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserTeamsQuery, UserTeamsQueryVariables>(UserTeamsDocument, options);
      }
export function useUserTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserTeamsQuery, UserTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserTeamsQuery, UserTeamsQueryVariables>(UserTeamsDocument, options);
        }
export type UserTeamsQueryHookResult = ReturnType<typeof useUserTeamsQuery>;
export type UserTeamsLazyQueryHookResult = ReturnType<typeof useUserTeamsLazyQuery>;
export type UserTeamsQueryResult = Apollo.QueryResult<UserTeamsQuery, UserTeamsQueryVariables>;
export function refetchUserTeamsQuery(variables: UserTeamsQueryVariables) {
      return { query: UserTeamsDocument, variables: variables }
    }
export const ValidatePostalCodeDocument = gql`
    query validatePostalCode($countryCode: String!, $zipCode: String!) {
  validateZip(countryCode: $countryCode, zipCode: $zipCode) {
    isValid
    errorMsg
  }
}
    `;

/**
 * __useValidatePostalCodeQuery__
 *
 * To run a query within a React component, call `useValidatePostalCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidatePostalCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidatePostalCodeQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useValidatePostalCodeQuery(baseOptions: Apollo.QueryHookOptions<ValidatePostalCodeQuery, ValidatePostalCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidatePostalCodeQuery, ValidatePostalCodeQueryVariables>(ValidatePostalCodeDocument, options);
      }
export function useValidatePostalCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidatePostalCodeQuery, ValidatePostalCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidatePostalCodeQuery, ValidatePostalCodeQueryVariables>(ValidatePostalCodeDocument, options);
        }
export type ValidatePostalCodeQueryHookResult = ReturnType<typeof useValidatePostalCodeQuery>;
export type ValidatePostalCodeLazyQueryHookResult = ReturnType<typeof useValidatePostalCodeLazyQuery>;
export type ValidatePostalCodeQueryResult = Apollo.QueryResult<ValidatePostalCodeQuery, ValidatePostalCodeQueryVariables>;
export function refetchValidatePostalCodeQuery(variables: ValidatePostalCodeQueryVariables) {
      return { query: ValidatePostalCodeDocument, variables: variables }
    }
export const VerifyShippingAddressDocument = gql`
    query verifyShippingAddress($selectedAddressInput: SelectedAddressInput!) {
  verifyShippingAddress(selectedAddressInput: $selectedAddressInput) {
    ...VerifiedAddress
  }
}
    ${VerifiedAddressFragmentDoc}`;

/**
 * __useVerifyShippingAddressQuery__
 *
 * To run a query within a React component, call `useVerifyShippingAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyShippingAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyShippingAddressQuery({
 *   variables: {
 *      selectedAddressInput: // value for 'selectedAddressInput'
 *   },
 * });
 */
export function useVerifyShippingAddressQuery(baseOptions: Apollo.QueryHookOptions<VerifyShippingAddressQuery, VerifyShippingAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerifyShippingAddressQuery, VerifyShippingAddressQueryVariables>(VerifyShippingAddressDocument, options);
      }
export function useVerifyShippingAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerifyShippingAddressQuery, VerifyShippingAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerifyShippingAddressQuery, VerifyShippingAddressQueryVariables>(VerifyShippingAddressDocument, options);
        }
export type VerifyShippingAddressQueryHookResult = ReturnType<typeof useVerifyShippingAddressQuery>;
export type VerifyShippingAddressLazyQueryHookResult = ReturnType<typeof useVerifyShippingAddressLazyQuery>;
export type VerifyShippingAddressQueryResult = Apollo.QueryResult<VerifyShippingAddressQuery, VerifyShippingAddressQueryVariables>;
export function refetchVerifyShippingAddressQuery(variables: VerifyShippingAddressQueryVariables) {
      return { query: VerifyShippingAddressDocument, variables: variables }
    }
export const CurrentUserIdentityDocument = gql`
    query currentUserIdentity {
  me {
    id
    createdAt
    email
    emailVerified
    emailVerifiedDate
    emailVerificationStatus
    displayName
    firstName
    lastName
    zipcode
    quotePartLimit
    flags {
      key
      variant
    }
    roles {
      id
      name
    }
    userPreferences {
      id
      preferences
    }
    businessAccountMembership {
      id
      businessAccount {
        id
        name
        isEnabled
        isTeamsFeatureEnabled
        totalTeams
        discount {
          percent
        }
      }
      createdAt
      user {
        id
        enabled
      }
    }
    businessAccountSignupStatus
    teams {
      items {
        id
      }
    }
  }
}
    `;

/**
 * __useCurrentUserIdentityQuery__
 *
 * To run a query within a React component, call `useCurrentUserIdentityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserIdentityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserIdentityQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserIdentityQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserIdentityQuery, CurrentUserIdentityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserIdentityQuery, CurrentUserIdentityQueryVariables>(CurrentUserIdentityDocument, options);
      }
export function useCurrentUserIdentityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserIdentityQuery, CurrentUserIdentityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserIdentityQuery, CurrentUserIdentityQueryVariables>(CurrentUserIdentityDocument, options);
        }
export type CurrentUserIdentityQueryHookResult = ReturnType<typeof useCurrentUserIdentityQuery>;
export type CurrentUserIdentityLazyQueryHookResult = ReturnType<typeof useCurrentUserIdentityLazyQuery>;
export type CurrentUserIdentityQueryResult = Apollo.QueryResult<CurrentUserIdentityQuery, CurrentUserIdentityQueryVariables>;
export function refetchCurrentUserIdentityQuery(variables?: CurrentUserIdentityQueryVariables) {
      return { query: CurrentUserIdentityDocument, variables: variables }
    }
export const GetByQuoteModelRevisionAttachmentIdDocument = gql`
    query getByQuoteModelRevisionAttachmentId($quoteModelRevisionAttachmentId: UUID!) {
  getModelAttachmentOcrData(
    quoteModelRevisionAttachmentId: $quoteModelRevisionAttachmentId
  ) {
    id
    callsForOffPlatformFinish
    oneSidedTolerances {
      boundingBox
      nominalCoordinate {
        page
        x
        y
      }
    }
    twoSidedTolerances {
      boundingBox
      nominalCoordinate {
        page
        x
        y
      }
    }
    standardDimensions {
      boundingBox
      text
    }
    certificateOfConformanceNotes {
      boundingBox
      text
    }
    materialCertificateNotes {
      boundingBox
      text
    }
    detectionBoundingBoxes {
      pageNumber
      xmin
      xmax
      ymax
      ymin
    }
    foundThreadsInfo {
      id
      commonName
      count
      diameter
      type
      detections {
        boundingBox
        text
      }
    }
    sanitizedBoundingBoxes {
      pageNumber
      xmax
      xmin
      ymax
      ymin
    }
    toleranceBlocks {
      nominalCoordinate {
        page
        x
        y
      }
      boundingBox
      textRaw
      symbol
    }
    allReamableOneSidedTolerances {
      boundingBox
      nominalCoordinate {
        page
        x
        y
      }
    }
    allReamableTwoSidedTolerances {
      boundingBox
      nominalCoordinate {
        page
        x
        y
      }
    }
  }
}
    `;

/**
 * __useGetByQuoteModelRevisionAttachmentIdQuery__
 *
 * To run a query within a React component, call `useGetByQuoteModelRevisionAttachmentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetByQuoteModelRevisionAttachmentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetByQuoteModelRevisionAttachmentIdQuery({
 *   variables: {
 *      quoteModelRevisionAttachmentId: // value for 'quoteModelRevisionAttachmentId'
 *   },
 * });
 */
export function useGetByQuoteModelRevisionAttachmentIdQuery(baseOptions: Apollo.QueryHookOptions<GetByQuoteModelRevisionAttachmentIdQuery, GetByQuoteModelRevisionAttachmentIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetByQuoteModelRevisionAttachmentIdQuery, GetByQuoteModelRevisionAttachmentIdQueryVariables>(GetByQuoteModelRevisionAttachmentIdDocument, options);
      }
export function useGetByQuoteModelRevisionAttachmentIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetByQuoteModelRevisionAttachmentIdQuery, GetByQuoteModelRevisionAttachmentIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetByQuoteModelRevisionAttachmentIdQuery, GetByQuoteModelRevisionAttachmentIdQueryVariables>(GetByQuoteModelRevisionAttachmentIdDocument, options);
        }
export type GetByQuoteModelRevisionAttachmentIdQueryHookResult = ReturnType<typeof useGetByQuoteModelRevisionAttachmentIdQuery>;
export type GetByQuoteModelRevisionAttachmentIdLazyQueryHookResult = ReturnType<typeof useGetByQuoteModelRevisionAttachmentIdLazyQuery>;
export type GetByQuoteModelRevisionAttachmentIdQueryResult = Apollo.QueryResult<GetByQuoteModelRevisionAttachmentIdQuery, GetByQuoteModelRevisionAttachmentIdQueryVariables>;
export function refetchGetByQuoteModelRevisionAttachmentIdQuery(variables: GetByQuoteModelRevisionAttachmentIdQueryVariables) {
      return { query: GetByQuoteModelRevisionAttachmentIdDocument, variables: variables }
    }
export const SendPrivateMessageToDriftDocument = gql`
    mutation sendPrivateMessageToDrift($message: String!, $conversationId: String!, $userId: String!) {
  sendPrivateMessageToDrift(
    message: $message
    conversationId: $conversationId
    userId: $userId
  )
}
    `;
export type SendPrivateMessageToDriftMutationFn = Apollo.MutationFunction<SendPrivateMessageToDriftMutation, SendPrivateMessageToDriftMutationVariables>;

/**
 * __useSendPrivateMessageToDriftMutation__
 *
 * To run a mutation, you first call `useSendPrivateMessageToDriftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPrivateMessageToDriftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPrivateMessageToDriftMutation, { data, loading, error }] = useSendPrivateMessageToDriftMutation({
 *   variables: {
 *      message: // value for 'message'
 *      conversationId: // value for 'conversationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSendPrivateMessageToDriftMutation(baseOptions?: Apollo.MutationHookOptions<SendPrivateMessageToDriftMutation, SendPrivateMessageToDriftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPrivateMessageToDriftMutation, SendPrivateMessageToDriftMutationVariables>(SendPrivateMessageToDriftDocument, options);
      }
export type SendPrivateMessageToDriftMutationHookResult = ReturnType<typeof useSendPrivateMessageToDriftMutation>;
export type SendPrivateMessageToDriftMutationResult = Apollo.MutationResult<SendPrivateMessageToDriftMutation>;
export type SendPrivateMessageToDriftMutationOptions = Apollo.BaseMutationOptions<SendPrivateMessageToDriftMutation, SendPrivateMessageToDriftMutationVariables>;
export const ConfigurationTabQueryDocument = gql`
    query configurationTabQuery($id: UUID!) {
  quote(id: $id) {
    hasITARRestrictions
    id
    type
    status
    name
    user {
      id
      email
    }
    project {
      id
      isSecurePlus
      name
    }
    team {
      id
      name
    }
    quoteModels(limit: 1000) {
      totalCount
      items {
        id
        quoteModelRevisions {
          id
          dfmReports {
            isPublished
          }
        }
        selectedQuoteModelRevision {
          isITARProhibitedViewing
          id
          quantityRangeStatus
          version
          state
          partRevision {
            id
            modelFileName
            downloadUri
          }
          processesDetails {
            isBusinessAccountDiscountApplied
            postProcesses {
              postProcess {
                id
                name
                typeName
              }
              postProcessThickness {
                id
                name
              }
              postProcessColor {
                id
                name
              }
            }
            totalPrice {
              ... on ExactPrice {
                priceInCents
                unitPriceInCents
              }
              ... on EstimatedPrice {
                lowPriceInCents
                lowUnitPriceInCents
                highPriceInCents
                highUnitPriceInCents
              }
            }
            secondaryProcesses {
              process {
                name
              }
            }
          }
          modelConfiguration {
            id
            process {
              id
              name
              platformProcessTypeId
            }
            materialGrade
            color {
              id
              name
            }
            colorCode
            shore {
              id
              name
            }
            texture {
              id
              name
            }
            material {
              ... on Material {
                id
                name
              }
            }
            productionLeadTime {
              priorityId
              productionDays
              shipDateEstimate {
                shippedByDate
              }
            }
            quantity
            textureCode
          }
          attachmentLink {
            id
            createdAt
            quoteAttachmentRevision {
              attachment {
                ... on Attachment {
                  id
                  fileName
                  downloadUrl
                }
              }
            }
          }
          dfmFeedback {
            id
            accepted
            severity
            message
            isPublished
          }
          dfmReports {
            quoteAttachmentRevisionId
            asset {
              id
              createdAt
              downloadUrl
              fileName
            }
            isPublished
          }
          taps {
            id
          }
          holes {
            id
            tapOptions {
              id
            }
          }
          drawingRequirements
        }
      }
    }
    quoteAttachments(limit: 1000) {
      totalCount
      items {
        id
        latestAttachmentRevision {
          id
          attachment {
            ... on Attachment {
              id
              fileName
              downloadUrl
              annotated {
                id
                fileName
                downloadUrl
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useConfigurationTabQueryQuery__
 *
 * To run a query within a React component, call `useConfigurationTabQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigurationTabQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigurationTabQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConfigurationTabQueryQuery(baseOptions: Apollo.QueryHookOptions<ConfigurationTabQueryQuery, ConfigurationTabQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfigurationTabQueryQuery, ConfigurationTabQueryQueryVariables>(ConfigurationTabQueryDocument, options);
      }
export function useConfigurationTabQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfigurationTabQueryQuery, ConfigurationTabQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfigurationTabQueryQuery, ConfigurationTabQueryQueryVariables>(ConfigurationTabQueryDocument, options);
        }
export type ConfigurationTabQueryQueryHookResult = ReturnType<typeof useConfigurationTabQueryQuery>;
export type ConfigurationTabQueryLazyQueryHookResult = ReturnType<typeof useConfigurationTabQueryLazyQuery>;
export type ConfigurationTabQueryQueryResult = Apollo.QueryResult<ConfigurationTabQueryQuery, ConfigurationTabQueryQueryVariables>;
export function refetchConfigurationTabQueryQuery(variables: ConfigurationTabQueryQueryVariables) {
      return { query: ConfigurationTabQueryDocument, variables: variables }
    }
export const CoreQuoteDetailsShippingDocument = gql`
    query coreQuoteDetailsShipping($id: UUID!, $address: AddressInput) {
  quote(id: $id) {
    id
    name
    isOverseasShipping
    zipCode
    hasITARRestrictions
    isEligibleForFreeShipping
    quoteItems(limit: 1000) {
      totalCount
      items {
        id
        quoteModelRevision {
          isITARProhibitedViewing
          id
          fileName
          mold {
            id
            leadTimeDays
            estimatedSampleDeliveryDate(address: $address)
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCoreQuoteDetailsShippingQuery__
 *
 * To run a query within a React component, call `useCoreQuoteDetailsShippingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoreQuoteDetailsShippingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoreQuoteDetailsShippingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      address: // value for 'address'
 *   },
 * });
 */
export function useCoreQuoteDetailsShippingQuery(baseOptions: Apollo.QueryHookOptions<CoreQuoteDetailsShippingQuery, CoreQuoteDetailsShippingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoreQuoteDetailsShippingQuery, CoreQuoteDetailsShippingQueryVariables>(CoreQuoteDetailsShippingDocument, options);
      }
export function useCoreQuoteDetailsShippingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoreQuoteDetailsShippingQuery, CoreQuoteDetailsShippingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoreQuoteDetailsShippingQuery, CoreQuoteDetailsShippingQueryVariables>(CoreQuoteDetailsShippingDocument, options);
        }
export type CoreQuoteDetailsShippingQueryHookResult = ReturnType<typeof useCoreQuoteDetailsShippingQuery>;
export type CoreQuoteDetailsShippingLazyQueryHookResult = ReturnType<typeof useCoreQuoteDetailsShippingLazyQuery>;
export type CoreQuoteDetailsShippingQueryResult = Apollo.QueryResult<CoreQuoteDetailsShippingQuery, CoreQuoteDetailsShippingQueryVariables>;
export function refetchCoreQuoteDetailsShippingQuery(variables: CoreQuoteDetailsShippingQueryVariables) {
      return { query: CoreQuoteDetailsShippingDocument, variables: variables }
    }
export const CoreQuoteDetailsDocument = gql`
    query coreQuoteDetails($id: UUID!, $isImMaafcoEnabled: Boolean = false, $isCpqFlagV2Enabled: Boolean = false) {
  quote(id: $id) {
    id
    name
    status
    zipCode
    isTaxExempt
    numberOfParts
    partsSummary
    needByDate
    lastModified
    isLocked
    isCpqOwned
    isQuoteInRfqState
    isQuoteIMReorder
    type
    beganCheckoutAt
    productionPartsSubtotalInCents
    moldToolSubtotalInCents
    depositInCents
    subTotalInCents
    slowestShipDateEstimate
    isOverseasShipping
    expiration
    isExpired
    isQuotePurchasable
    earliestValidUntilDate
    reorderSourceOrderName
    isFlexiblePriceQuote
    notesToCustomer
    deletedAt
    isMoldRepair
    isLocked
    isCpqQuote @include(if: $isCpqFlagV2Enabled)
    isCpqOwned
    hasITARRestrictions
    isEligibleForFreeShipping
    cpqQuote @include(if: $isCpqFlagV2Enabled) {
      sfdcId
      platformQuote {
        id
      }
      quotePdfUrl
      orderTotal
      partsCount
      moldCount
      orderQuantity
    }
    project {
      id
      isSecurePlus
      name
    }
    team {
      id
      name
    }
    isQuoteIMReorder
    platformOrder {
      name
      purchaserEmail
      purchasedDate
      purchaserUserId
    }
    purchaseInfo {
      purchaserEmail
      purchasedDate
      purchaserUserId
    }
    orderName
    businessAccountDiscount {
      id
      isActive
      endAt
      percent
    }
    user {
      id
    }
    quoteAttachments(limit: 1000) {
      totalCount
      items {
        id
        latestAttachmentRevision {
          id
          attachment {
            ... on Attachment {
              id
              fileName
              downloadUrl
              annotated {
                id
                fileName
                downloadUrl
              }
              sanitized {
                id
                fileName
                downloadUrl
              }
            }
          }
        }
      }
    }
    quoteModels(limit: 1000) {
      totalCount
      items {
        id
        quoteModelRevisions {
          id
          attachmentLink {
            id
          }
        }
        selectedQuoteModelRevision {
          isITARProhibitedViewing
          id
          fileName
          createdAt
          quantityRangeStatus
          state
          version
          taps {
            id
          }
          holes {
            id
            groupKey
            patches {
              id
            }
            tapOptions {
              id
            }
            tapAnnotation {
              id
              depth
              tapOption {
                id
              }
            }
          }
          mold {
            id
            name @include(if: $isImMaafcoEnabled)
            leadTimeDays
            customerToolName @include(if: $isImMaafcoEnabled)
            material {
              id
              name
            }
            price {
              priceInCents
            }
            toolLife
            uiIndex
            moldToolRevisionQmr @include(if: $isImMaafcoEnabled) {
              moldToolRevisionId
              quoteModelRevisionId
              cavityPerPart
            }
          }
          partRevision {
            id
            analysisErrorCode
            updatedAt
            modelFileName
            downloadUri
            thumbnailUri
            status
            sceneBundle
            boundingBox {
              x
              y
              z
            }
          }
          dfmFeedback {
            id
            accepted
            severity
            message
            isPublished
          }
          dfmReports {
            quoteAttachmentRevisionId
            asset {
              id
              createdAt
              downloadUrl
              fileName
            }
            isPublished
          }
          modelConfiguration {
            id
            dfmInspection {
              id
              inspectionData
              isPublished
            }
            productionLeadTime {
              id
              priorityId
              productionDays
            }
            material {
              ... on Material {
                id
                name
              }
              ... on UserEnteredMaterial {
                id
                name
                process {
                  id
                  name
                }
              }
            }
            color {
              id
              name
            }
            colorCode
            shore {
              id
              name
            }
            texture {
              id
              name
            }
            textureCode
            process {
              id
              name
              platformProcessTypeId
            }
            quantity
            requiresOvermold
            materialGrade
            fdmInfillPercentageCategory
            fdmInfillPercentageCategoryLabel
          }
          quoteModel {
            id
            quote {
              id
              type
            }
          }
          annotations {
            id
          }
          processesDetails {
            isBusinessAccountDiscountApplied
            primaryProcess {
              process {
                id
                name
                platformProcessTypeId
              }
            }
            postProcesses {
              postProcess {
                id
                name
                typeName
              }
              unitPriceInCents
              postProcessLeadTimeInDays
              postProcessThickness {
                id
                name
              }
              postProcessColor {
                id
                name
              }
              postProcessNumParts
              postProcessInspectionCriteria
            }
            totalPrice {
              ... on ExactPrice {
                priceInCents
                unitPriceInCents
              }
              ... on EstimatedPrice {
                lowPriceInCents
                lowUnitPriceInCents
                highPriceInCents
                highUnitPriceInCents
              }
            }
            secondaryProcesses {
              process {
                id
                name
                typeName
              }
            }
          }
          supportedPriorityRegions {
            partSupportsDomestic
            partSupportsInternational
          }
          attachmentLink {
            id
            createdAt
            isPdfOcrAutoQuotable
            quoteAttachmentRevision {
              id
              attachment {
                ... on Attachment {
                  id
                  fileName
                  downloadUrl
                  annotated {
                    id
                    fileName
                    downloadUrl
                  }
                  sanitized {
                    id
                    fileName
                    downloadUrl
                  }
                }
              }
            }
          }
          drawingRequirements
        }
      }
    }
    dfmAssets(limit: 1000) {
      totalCount
      items {
        id
        fileName
        downloadUrl
      }
    }
  }
}
    `;

/**
 * __useCoreQuoteDetailsQuery__
 *
 * To run a query within a React component, call `useCoreQuoteDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoreQuoteDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoreQuoteDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      isImMaafcoEnabled: // value for 'isImMaafcoEnabled'
 *      isCpqFlagV2Enabled: // value for 'isCpqFlagV2Enabled'
 *   },
 * });
 */
export function useCoreQuoteDetailsQuery(baseOptions: Apollo.QueryHookOptions<CoreQuoteDetailsQuery, CoreQuoteDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoreQuoteDetailsQuery, CoreQuoteDetailsQueryVariables>(CoreQuoteDetailsDocument, options);
      }
export function useCoreQuoteDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoreQuoteDetailsQuery, CoreQuoteDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoreQuoteDetailsQuery, CoreQuoteDetailsQueryVariables>(CoreQuoteDetailsDocument, options);
        }
export type CoreQuoteDetailsQueryHookResult = ReturnType<typeof useCoreQuoteDetailsQuery>;
export type CoreQuoteDetailsLazyQueryHookResult = ReturnType<typeof useCoreQuoteDetailsLazyQuery>;
export type CoreQuoteDetailsQueryResult = Apollo.QueryResult<CoreQuoteDetailsQuery, CoreQuoteDetailsQueryVariables>;
export function refetchCoreQuoteDetailsQuery(variables: CoreQuoteDetailsQueryVariables) {
      return { query: CoreQuoteDetailsDocument, variables: variables }
    }
export const DrawingAnalysisTabQueryDocument = gql`
    query drawingAnalysisTabQuery($id: UUID!) {
  quote(id: $id) {
    hasITARRestrictions
    id
    name
    status
    type
    user {
      id
    }
    quoteModels(limit: 1000) {
      items {
        id
        quoteModelRevisions {
          id
          attachmentLink {
            id
          }
        }
        selectedQuoteModelRevision {
          isITARProhibitedViewing
          id
          fileName
          state
          version
          taps {
            id
          }
          partRevision {
            id
            analysisErrorCode
            updatedAt
            modelFileName
            downloadUri
            thumbnailUri
            status
            sceneBundle
            boundingBox {
              x
              y
              z
            }
          }
          dfmFeedback {
            id
            severity
          }
          modelConfiguration {
            id
            dfmInspection {
              id
              inspectionData
            }
            productionLeadTime {
              id
              priorityId
              productionDays
            }
            material {
              ... on Material {
                id
                name
              }
            }
            color {
              id
              name
            }
            colorCode
            textureCode
            shore {
              id
              name
            }
            texture {
              id
              name
            }
            process {
              id
              name
            }
            quantity
            requiresOvermold
            materialGrade
            additionalRequirements
            hasMultipleFinishes
            userNeedsConfigHelp
          }
          annotations {
            id
          }
          processesDetails {
            primaryProcess {
              process {
                id
                name
                platformProcessTypeId
              }
            }
            postProcesses {
              postProcess {
                id
                name
                typeName
              }
              unitPriceInCents
              postProcessLeadTimeInDays
              postProcessThickness {
                id
                name
              }
              postProcessColor {
                id
                name
              }
              postProcessNumParts
              postProcessInspectionCriteria
            }
            totalPrice {
              ... on ExactPrice {
                priceInCents
                unitPriceInCents
              }
              ... on EstimatedPrice {
                lowPriceInCents
                lowUnitPriceInCents
                highPriceInCents
                highUnitPriceInCents
              }
            }
            secondaryProcesses {
              process {
                id
                name
                typeName
              }
            }
          }
          attachmentLink {
            id
            createdAt
            isPdfOcrAutoQuotable
            quoteAttachmentRevision {
              id
              attachment {
                ... on Attachment {
                  id
                  fileName
                  downloadUrl
                  annotated {
                    id
                    fileName
                    downloadUrl
                  }
                }
              }
            }
          }
          drawingRequirements
        }
      }
    }
  }
}
    `;

/**
 * __useDrawingAnalysisTabQueryQuery__
 *
 * To run a query within a React component, call `useDrawingAnalysisTabQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDrawingAnalysisTabQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDrawingAnalysisTabQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDrawingAnalysisTabQueryQuery(baseOptions: Apollo.QueryHookOptions<DrawingAnalysisTabQueryQuery, DrawingAnalysisTabQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DrawingAnalysisTabQueryQuery, DrawingAnalysisTabQueryQueryVariables>(DrawingAnalysisTabQueryDocument, options);
      }
export function useDrawingAnalysisTabQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DrawingAnalysisTabQueryQuery, DrawingAnalysisTabQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DrawingAnalysisTabQueryQuery, DrawingAnalysisTabQueryQueryVariables>(DrawingAnalysisTabQueryDocument, options);
        }
export type DrawingAnalysisTabQueryQueryHookResult = ReturnType<typeof useDrawingAnalysisTabQueryQuery>;
export type DrawingAnalysisTabQueryLazyQueryHookResult = ReturnType<typeof useDrawingAnalysisTabQueryLazyQuery>;
export type DrawingAnalysisTabQueryQueryResult = Apollo.QueryResult<DrawingAnalysisTabQueryQuery, DrawingAnalysisTabQueryQueryVariables>;
export function refetchDrawingAnalysisTabQueryQuery(variables: DrawingAnalysisTabQueryQueryVariables) {
      return { query: DrawingAnalysisTabQueryDocument, variables: variables }
    }
export const DetailsForFeedbackThreadsAddReqModalConfigTabDocument = gql`
    query detailsForFeedbackThreadsAddReqModalConfigTab($id: UUID!) {
  quote(id: $id) {
    hasITARRestrictions
    id
    type
    status
    user {
      id
    }
    project {
      isSecurePlus
    }
    quoteModels(limit: 1000) {
      items {
        id
        quoteModelRevisions {
          id
        }
        selectedQuoteModelRevision {
          isITARProhibitedViewing
          id
          state
          dfmFeedback {
            id
            accepted
            severity
          }
          partRevision {
            modelFileName
          }
          processesDetails {
            postProcesses {
              postProcess {
                id
                name
              }
            }
            secondaryProcesses {
              process {
                typeName
              }
            }
            totalPrice {
              ... on ExactPrice {
                priceInCents
                unitPriceInCents
              }
              ... on EstimatedPrice {
                lowPriceInCents
                lowUnitPriceInCents
                highPriceInCents
                highUnitPriceInCents
              }
            }
          }
          attachmentLink {
            id
            quoteAttachmentRevision {
              id
              attachment {
                ... on Attachment {
                  id
                }
              }
            }
          }
          modelConfiguration {
            id
            dfmInspection {
              id
              inspectionData
            }
            process {
              id
            }
            material {
              ... on Material {
                id
              }
            }
            productionLeadTime {
              id
              productionDays
              shipDateEstimate {
                shippedByDate
              }
            }
            additionalRequirements
          }
        }
      }
    }
  }
}
    `;

/**
 * __useDetailsForFeedbackThreadsAddReqModalConfigTabQuery__
 *
 * To run a query within a React component, call `useDetailsForFeedbackThreadsAddReqModalConfigTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetailsForFeedbackThreadsAddReqModalConfigTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetailsForFeedbackThreadsAddReqModalConfigTabQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDetailsForFeedbackThreadsAddReqModalConfigTabQuery(baseOptions: Apollo.QueryHookOptions<DetailsForFeedbackThreadsAddReqModalConfigTabQuery, DetailsForFeedbackThreadsAddReqModalConfigTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetailsForFeedbackThreadsAddReqModalConfigTabQuery, DetailsForFeedbackThreadsAddReqModalConfigTabQueryVariables>(DetailsForFeedbackThreadsAddReqModalConfigTabDocument, options);
      }
export function useDetailsForFeedbackThreadsAddReqModalConfigTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetailsForFeedbackThreadsAddReqModalConfigTabQuery, DetailsForFeedbackThreadsAddReqModalConfigTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetailsForFeedbackThreadsAddReqModalConfigTabQuery, DetailsForFeedbackThreadsAddReqModalConfigTabQueryVariables>(DetailsForFeedbackThreadsAddReqModalConfigTabDocument, options);
        }
export type DetailsForFeedbackThreadsAddReqModalConfigTabQueryHookResult = ReturnType<typeof useDetailsForFeedbackThreadsAddReqModalConfigTabQuery>;
export type DetailsForFeedbackThreadsAddReqModalConfigTabLazyQueryHookResult = ReturnType<typeof useDetailsForFeedbackThreadsAddReqModalConfigTabLazyQuery>;
export type DetailsForFeedbackThreadsAddReqModalConfigTabQueryResult = Apollo.QueryResult<DetailsForFeedbackThreadsAddReqModalConfigTabQuery, DetailsForFeedbackThreadsAddReqModalConfigTabQueryVariables>;
export function refetchDetailsForFeedbackThreadsAddReqModalConfigTabQuery(variables: DetailsForFeedbackThreadsAddReqModalConfigTabQueryVariables) {
      return { query: DetailsForFeedbackThreadsAddReqModalConfigTabDocument, variables: variables }
    }
export const DetailsForImFeedbackAddReqUnconfiguredConfigModalTabsDocument = gql`
    query detailsForIMFeedbackAddReqUnconfiguredConfigModalTabs($id: UUID!) {
  quote(id: $id) {
    hasITARRestrictions
    id
    type
    status
    user {
      id
    }
    quoteModels(limit: 1000) {
      items {
        selectedQuoteModelRevision {
          isITARProhibitedViewing
          id
          state
          version
          dfmReports {
            isPublished
          }
          partRevision {
            id
            units
          }
          modelConfiguration {
            process {
              id
            }
            quantity
            colorCode
            materialGrade
            quantity
            textureCode
            texture {
              id
            }
            material {
              ... on Material {
                id
                name
              }
              ... on UserEnteredMaterial {
                id
                name
                process {
                  id
                  name
                }
              }
            }
            color {
              id
            }
            productionLeadTime {
              productionDays
            }
            dfmInspection {
              inspectionData
            }
            additionalRequirements
          }
          dfmFeedback {
            id
            severity
          }
          processesDetails {
            postProcesses {
              postProcess {
                id
                typeName
              }
            }
            secondaryProcesses {
              process {
                id
              }
            }
          }
          attachmentLink {
            quoteAttachmentRevision {
              id
            }
          }
          quoteModel {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useDetailsForImFeedbackAddReqUnconfiguredConfigModalTabsQuery__
 *
 * To run a query within a React component, call `useDetailsForImFeedbackAddReqUnconfiguredConfigModalTabsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetailsForImFeedbackAddReqUnconfiguredConfigModalTabsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetailsForImFeedbackAddReqUnconfiguredConfigModalTabsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDetailsForImFeedbackAddReqUnconfiguredConfigModalTabsQuery(baseOptions: Apollo.QueryHookOptions<DetailsForImFeedbackAddReqUnconfiguredConfigModalTabsQuery, DetailsForImFeedbackAddReqUnconfiguredConfigModalTabsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetailsForImFeedbackAddReqUnconfiguredConfigModalTabsQuery, DetailsForImFeedbackAddReqUnconfiguredConfigModalTabsQueryVariables>(DetailsForImFeedbackAddReqUnconfiguredConfigModalTabsDocument, options);
      }
export function useDetailsForImFeedbackAddReqUnconfiguredConfigModalTabsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetailsForImFeedbackAddReqUnconfiguredConfigModalTabsQuery, DetailsForImFeedbackAddReqUnconfiguredConfigModalTabsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetailsForImFeedbackAddReqUnconfiguredConfigModalTabsQuery, DetailsForImFeedbackAddReqUnconfiguredConfigModalTabsQueryVariables>(DetailsForImFeedbackAddReqUnconfiguredConfigModalTabsDocument, options);
        }
export type DetailsForImFeedbackAddReqUnconfiguredConfigModalTabsQueryHookResult = ReturnType<typeof useDetailsForImFeedbackAddReqUnconfiguredConfigModalTabsQuery>;
export type DetailsForImFeedbackAddReqUnconfiguredConfigModalTabsLazyQueryHookResult = ReturnType<typeof useDetailsForImFeedbackAddReqUnconfiguredConfigModalTabsLazyQuery>;
export type DetailsForImFeedbackAddReqUnconfiguredConfigModalTabsQueryResult = Apollo.QueryResult<DetailsForImFeedbackAddReqUnconfiguredConfigModalTabsQuery, DetailsForImFeedbackAddReqUnconfiguredConfigModalTabsQueryVariables>;
export function refetchDetailsForImFeedbackAddReqUnconfiguredConfigModalTabsQuery(variables: DetailsForImFeedbackAddReqUnconfiguredConfigModalTabsQueryVariables) {
      return { query: DetailsForImFeedbackAddReqUnconfiguredConfigModalTabsDocument, variables: variables }
    }
export const SetNeedByDateDocument = gql`
    mutation SetNeedByDate($quoteId: UUID!, $needByDate: Date) {
  setNeedByDate(quoteId: $quoteId, needByDate: $needByDate)
}
    `;
export type SetNeedByDateMutationFn = Apollo.MutationFunction<SetNeedByDateMutation, SetNeedByDateMutationVariables>;

/**
 * __useSetNeedByDateMutation__
 *
 * To run a mutation, you first call `useSetNeedByDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNeedByDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNeedByDateMutation, { data, loading, error }] = useSetNeedByDateMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      needByDate: // value for 'needByDate'
 *   },
 * });
 */
export function useSetNeedByDateMutation(baseOptions?: Apollo.MutationHookOptions<SetNeedByDateMutation, SetNeedByDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetNeedByDateMutation, SetNeedByDateMutationVariables>(SetNeedByDateDocument, options);
      }
export type SetNeedByDateMutationHookResult = ReturnType<typeof useSetNeedByDateMutation>;
export type SetNeedByDateMutationResult = Apollo.MutationResult<SetNeedByDateMutation>;
export type SetNeedByDateMutationOptions = Apollo.BaseMutationOptions<SetNeedByDateMutation, SetNeedByDateMutationVariables>;
export const SendQlltOptimisationNotificationDocument = gql`
    mutation SendQlltOptimisationNotification($quoteId: UUID!, $userId: Int!) {
  sendQlltOptimisationNotification(quoteId: $quoteId, userId: $userId) {
    url
  }
}
    `;
export type SendQlltOptimisationNotificationMutationFn = Apollo.MutationFunction<SendQlltOptimisationNotificationMutation, SendQlltOptimisationNotificationMutationVariables>;

/**
 * __useSendQlltOptimisationNotificationMutation__
 *
 * To run a mutation, you first call `useSendQlltOptimisationNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendQlltOptimisationNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendQlltOptimisationNotificationMutation, { data, loading, error }] = useSendQlltOptimisationNotificationMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSendQlltOptimisationNotificationMutation(baseOptions?: Apollo.MutationHookOptions<SendQlltOptimisationNotificationMutation, SendQlltOptimisationNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendQlltOptimisationNotificationMutation, SendQlltOptimisationNotificationMutationVariables>(SendQlltOptimisationNotificationDocument, options);
      }
export type SendQlltOptimisationNotificationMutationHookResult = ReturnType<typeof useSendQlltOptimisationNotificationMutation>;
export type SendQlltOptimisationNotificationMutationResult = Apollo.MutationResult<SendQlltOptimisationNotificationMutation>;
export type SendQlltOptimisationNotificationMutationOptions = Apollo.BaseMutationOptions<SendQlltOptimisationNotificationMutation, SendQlltOptimisationNotificationMutationVariables>;
export const SetBusinessAccountFeatureDocument = gql`
    mutation SetBusinessAccountFeature($businessAccountId: UUID!, $featureName: BusinessAccountFeatureInput!, $isEnabled: Boolean!) {
  setBusinessAccountFeature(
    businessAccountId: $businessAccountId
    featureName: $featureName
    isEnabled: $isEnabled
  ) {
    id
    businessAccountId
    featureName
    isEnabled
  }
}
    `;
export type SetBusinessAccountFeatureMutationFn = Apollo.MutationFunction<SetBusinessAccountFeatureMutation, SetBusinessAccountFeatureMutationVariables>;

/**
 * __useSetBusinessAccountFeatureMutation__
 *
 * To run a mutation, you first call `useSetBusinessAccountFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBusinessAccountFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBusinessAccountFeatureMutation, { data, loading, error }] = useSetBusinessAccountFeatureMutation({
 *   variables: {
 *      businessAccountId: // value for 'businessAccountId'
 *      featureName: // value for 'featureName'
 *      isEnabled: // value for 'isEnabled'
 *   },
 * });
 */
export function useSetBusinessAccountFeatureMutation(baseOptions?: Apollo.MutationHookOptions<SetBusinessAccountFeatureMutation, SetBusinessAccountFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetBusinessAccountFeatureMutation, SetBusinessAccountFeatureMutationVariables>(SetBusinessAccountFeatureDocument, options);
      }
export type SetBusinessAccountFeatureMutationHookResult = ReturnType<typeof useSetBusinessAccountFeatureMutation>;
export type SetBusinessAccountFeatureMutationResult = Apollo.MutationResult<SetBusinessAccountFeatureMutation>;
export type SetBusinessAccountFeatureMutationOptions = Apollo.BaseMutationOptions<SetBusinessAccountFeatureMutation, SetBusinessAccountFeatureMutationVariables>;
export const RecordCltOptimizerViewDocument = gql`
    mutation RecordCltOptimizerView($quoteId: UUID!) {
  recordCltOptimizerView(quoteId: $quoteId) {
    id
    quoteId
    viewCount
    lastViewed
    createdAt
  }
}
    `;
export type RecordCltOptimizerViewMutationFn = Apollo.MutationFunction<RecordCltOptimizerViewMutation, RecordCltOptimizerViewMutationVariables>;

/**
 * __useRecordCltOptimizerViewMutation__
 *
 * To run a mutation, you first call `useRecordCltOptimizerViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordCltOptimizerViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordCltOptimizerViewMutation, { data, loading, error }] = useRecordCltOptimizerViewMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useRecordCltOptimizerViewMutation(baseOptions?: Apollo.MutationHookOptions<RecordCltOptimizerViewMutation, RecordCltOptimizerViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordCltOptimizerViewMutation, RecordCltOptimizerViewMutationVariables>(RecordCltOptimizerViewDocument, options);
      }
export type RecordCltOptimizerViewMutationHookResult = ReturnType<typeof useRecordCltOptimizerViewMutation>;
export type RecordCltOptimizerViewMutationResult = Apollo.MutationResult<RecordCltOptimizerViewMutation>;
export type RecordCltOptimizerViewMutationOptions = Apollo.BaseMutationOptions<RecordCltOptimizerViewMutation, RecordCltOptimizerViewMutationVariables>;
export const RecordCltOptimizationDocument = gql`
    mutation RecordCltOptimization($quoteModelRevisionId: UUID!, $operation: String!, $description: String!, $initialCostCents: Int!, $finalCostCents: Int!, $initialTimeDays: Int!, $finalTimeDays: Int!, $initialQuantity: Int!, $finalQuantity: Int!) {
  recordCltOptimization(
    quoteModelRevisionId: $quoteModelRevisionId
    operation: $operation
    description: $description
    initialCostCents: $initialCostCents
    finalCostCents: $finalCostCents
    initialTimeDays: $initialTimeDays
    finalTimeDays: $finalTimeDays
    initialQuantity: $initialQuantity
    finalQuantity: $finalQuantity
  ) {
    id
    quoteId
    quoteModelRevisionId
    userId
    businessAccountMembershipId
    operation
    description
    initialCostCents
    finalCostCents
    initialTimeDays
    finalTimeDays
    initialQuantity
    finalQuantity
    createdAt
  }
}
    `;
export type RecordCltOptimizationMutationFn = Apollo.MutationFunction<RecordCltOptimizationMutation, RecordCltOptimizationMutationVariables>;

/**
 * __useRecordCltOptimizationMutation__
 *
 * To run a mutation, you first call `useRecordCltOptimizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordCltOptimizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordCltOptimizationMutation, { data, loading, error }] = useRecordCltOptimizationMutation({
 *   variables: {
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *      operation: // value for 'operation'
 *      description: // value for 'description'
 *      initialCostCents: // value for 'initialCostCents'
 *      finalCostCents: // value for 'finalCostCents'
 *      initialTimeDays: // value for 'initialTimeDays'
 *      finalTimeDays: // value for 'finalTimeDays'
 *      initialQuantity: // value for 'initialQuantity'
 *      finalQuantity: // value for 'finalQuantity'
 *   },
 * });
 */
export function useRecordCltOptimizationMutation(baseOptions?: Apollo.MutationHookOptions<RecordCltOptimizationMutation, RecordCltOptimizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordCltOptimizationMutation, RecordCltOptimizationMutationVariables>(RecordCltOptimizationDocument, options);
      }
export type RecordCltOptimizationMutationHookResult = ReturnType<typeof useRecordCltOptimizationMutation>;
export type RecordCltOptimizationMutationResult = Apollo.MutationResult<RecordCltOptimizationMutation>;
export type RecordCltOptimizationMutationOptions = Apollo.BaseMutationOptions<RecordCltOptimizationMutation, RecordCltOptimizationMutationVariables>;
export const LogRequestAssistanceDocument = gql`
    mutation LogRequestAssistance($quoteId: UUID!) {
  logRequestAssistance(quoteId: $quoteId)
}
    `;
export type LogRequestAssistanceMutationFn = Apollo.MutationFunction<LogRequestAssistanceMutation, LogRequestAssistanceMutationVariables>;

/**
 * __useLogRequestAssistanceMutation__
 *
 * To run a mutation, you first call `useLogRequestAssistanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogRequestAssistanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logRequestAssistanceMutation, { data, loading, error }] = useLogRequestAssistanceMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useLogRequestAssistanceMutation(baseOptions?: Apollo.MutationHookOptions<LogRequestAssistanceMutation, LogRequestAssistanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogRequestAssistanceMutation, LogRequestAssistanceMutationVariables>(LogRequestAssistanceDocument, options);
      }
export type LogRequestAssistanceMutationHookResult = ReturnType<typeof useLogRequestAssistanceMutation>;
export type LogRequestAssistanceMutationResult = Apollo.MutationResult<LogRequestAssistanceMutation>;
export type LogRequestAssistanceMutationOptions = Apollo.BaseMutationOptions<LogRequestAssistanceMutation, LogRequestAssistanceMutationVariables>;
export const GenerateCltOptimizerReportDocument = gql`
    mutation GenerateCltOptimizerReport($quoteId: UUID!) {
  generateCltOptimizerReport(quoteId: $quoteId) {
    id
    quoteId
    userId
    businessAccountId
    costCentsDelta
    timeDaysDelta
    viewCount
    lastViewed
  }
}
    `;
export type GenerateCltOptimizerReportMutationFn = Apollo.MutationFunction<GenerateCltOptimizerReportMutation, GenerateCltOptimizerReportMutationVariables>;

/**
 * __useGenerateCltOptimizerReportMutation__
 *
 * To run a mutation, you first call `useGenerateCltOptimizerReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCltOptimizerReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCltOptimizerReportMutation, { data, loading, error }] = useGenerateCltOptimizerReportMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useGenerateCltOptimizerReportMutation(baseOptions?: Apollo.MutationHookOptions<GenerateCltOptimizerReportMutation, GenerateCltOptimizerReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateCltOptimizerReportMutation, GenerateCltOptimizerReportMutationVariables>(GenerateCltOptimizerReportDocument, options);
      }
export type GenerateCltOptimizerReportMutationHookResult = ReturnType<typeof useGenerateCltOptimizerReportMutation>;
export type GenerateCltOptimizerReportMutationResult = Apollo.MutationResult<GenerateCltOptimizerReportMutation>;
export type GenerateCltOptimizerReportMutationOptions = Apollo.BaseMutationOptions<GenerateCltOptimizerReportMutation, GenerateCltOptimizerReportMutationVariables>;
export const QmrLeadTimeContributionsDocument = gql`
    query QmrLeadTimeContributions($quoteModelRevisionId: UUID!) {
  qmrLeadTimeContributions(quoteModelRevisionId: $quoteModelRevisionId) {
    fastestDomesticLeadTimeBreakdown {
      additionalDays {
        longPart
        tightTolerance
        lathe
        uncommonMaterials
        reamer
        pdfAutoQuotability
        smallHoles
        undercuts
        smallTaps
        machiningTimeBasedMinimumProductionDays
      }
    }
  }
}
    `;

/**
 * __useQmrLeadTimeContributionsQuery__
 *
 * To run a query within a React component, call `useQmrLeadTimeContributionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQmrLeadTimeContributionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQmrLeadTimeContributionsQuery({
 *   variables: {
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *   },
 * });
 */
export function useQmrLeadTimeContributionsQuery(baseOptions: Apollo.QueryHookOptions<QmrLeadTimeContributionsQuery, QmrLeadTimeContributionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QmrLeadTimeContributionsQuery, QmrLeadTimeContributionsQueryVariables>(QmrLeadTimeContributionsDocument, options);
      }
export function useQmrLeadTimeContributionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QmrLeadTimeContributionsQuery, QmrLeadTimeContributionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QmrLeadTimeContributionsQuery, QmrLeadTimeContributionsQueryVariables>(QmrLeadTimeContributionsDocument, options);
        }
export type QmrLeadTimeContributionsQueryHookResult = ReturnType<typeof useQmrLeadTimeContributionsQuery>;
export type QmrLeadTimeContributionsLazyQueryHookResult = ReturnType<typeof useQmrLeadTimeContributionsLazyQuery>;
export type QmrLeadTimeContributionsQueryResult = Apollo.QueryResult<QmrLeadTimeContributionsQuery, QmrLeadTimeContributionsQueryVariables>;
export function refetchQmrLeadTimeContributionsQuery(variables: QmrLeadTimeContributionsQueryVariables) {
      return { query: QmrLeadTimeContributionsDocument, variables: variables }
    }
export const CalculateQuoteModelRevisionPendingPricesBreakdownPercentagesDocument = gql`
    query CalculateQuoteModelRevisionPendingPricesBreakdownPercentages($quoteModelRevisionId: UUID!) {
  calculateQuoteModelRevisionPendingPricesBreakdownPercentages(
    quoteModelRevisionId: $quoteModelRevisionId
  ) {
    machineCost
    materialCost
    threadCost
    setupCost
    camCost
    fixtureCost
    miscNonRecurringEngineeringCost
    toleranceCost
    toolCost
    otherCost
  }
}
    `;

/**
 * __useCalculateQuoteModelRevisionPendingPricesBreakdownPercentagesQuery__
 *
 * To run a query within a React component, call `useCalculateQuoteModelRevisionPendingPricesBreakdownPercentagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateQuoteModelRevisionPendingPricesBreakdownPercentagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateQuoteModelRevisionPendingPricesBreakdownPercentagesQuery({
 *   variables: {
 *      quoteModelRevisionId: // value for 'quoteModelRevisionId'
 *   },
 * });
 */
export function useCalculateQuoteModelRevisionPendingPricesBreakdownPercentagesQuery(baseOptions: Apollo.QueryHookOptions<CalculateQuoteModelRevisionPendingPricesBreakdownPercentagesQuery, CalculateQuoteModelRevisionPendingPricesBreakdownPercentagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateQuoteModelRevisionPendingPricesBreakdownPercentagesQuery, CalculateQuoteModelRevisionPendingPricesBreakdownPercentagesQueryVariables>(CalculateQuoteModelRevisionPendingPricesBreakdownPercentagesDocument, options);
      }
export function useCalculateQuoteModelRevisionPendingPricesBreakdownPercentagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateQuoteModelRevisionPendingPricesBreakdownPercentagesQuery, CalculateQuoteModelRevisionPendingPricesBreakdownPercentagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateQuoteModelRevisionPendingPricesBreakdownPercentagesQuery, CalculateQuoteModelRevisionPendingPricesBreakdownPercentagesQueryVariables>(CalculateQuoteModelRevisionPendingPricesBreakdownPercentagesDocument, options);
        }
export type CalculateQuoteModelRevisionPendingPricesBreakdownPercentagesQueryHookResult = ReturnType<typeof useCalculateQuoteModelRevisionPendingPricesBreakdownPercentagesQuery>;
export type CalculateQuoteModelRevisionPendingPricesBreakdownPercentagesLazyQueryHookResult = ReturnType<typeof useCalculateQuoteModelRevisionPendingPricesBreakdownPercentagesLazyQuery>;
export type CalculateQuoteModelRevisionPendingPricesBreakdownPercentagesQueryResult = Apollo.QueryResult<CalculateQuoteModelRevisionPendingPricesBreakdownPercentagesQuery, CalculateQuoteModelRevisionPendingPricesBreakdownPercentagesQueryVariables>;
export function refetchCalculateQuoteModelRevisionPendingPricesBreakdownPercentagesQuery(variables: CalculateQuoteModelRevisionPendingPricesBreakdownPercentagesQueryVariables) {
      return { query: CalculateQuoteModelRevisionPendingPricesBreakdownPercentagesDocument, variables: variables }
    }
export const CostAndLeadTimeDocument = gql`
    query CostAndLeadTime($quoteId: UUID!) {
  quote(id: $quoteId) {
    id
    name
    status
    type
    isQuotePurchasable
    reorderSourceOrderName
    user {
      id
    }
    quoteModels(limit: 1000) {
      totalCount
      items {
        selectedQuoteModelRevision {
          id
          state
          holes {
            id
            tapOptions {
              id
            }
          }
          taps {
            id
          }
          attachmentLink {
            id
            quoteAttachmentRevision {
              id
              attachment {
                ... on Attachment {
                  id
                  fileName
                  downloadUrl
                  annotated {
                    id
                    fileName
                    downloadUrl
                  }
                  sanitized {
                    id
                    fileName
                    downloadUrl
                  }
                }
              }
            }
          }
          dfmFeedback {
            id
            accepted
            severity
            message
            isPublished
          }
          modelConfiguration {
            id
            productionLeadTime {
              id
              priorityId
              productionDays
            }
            process {
              id
            }
            material {
              ... on Material {
                id
              }
              ... on UserEnteredMaterial {
                id
                process {
                  id
                }
              }
            }
            materialGrade
            textureCode
            colorCode
            productionLeadTime {
              priorityId
            }
            quantity
          }
          processesDetails {
            primaryProcess {
              price {
                ... on ExactPrice {
                  priceInCents
                }
              }
              process {
                name
                id
              }
            }
            productionLeadTime {
              shipDateEstimate {
                shippedByDate
              }
            }
            postProcesses {
              unitPriceInCents
              postProcess {
                name
                id
              }
              postProcessColor {
                id
                name
              }
              postProcessLeadTimeInDays
              postProcessInspectionCriteria
              postProcessNumParts
              postProcessThickness {
                value
              }
            }
            totalPrice {
              ... on ExactPrice {
                priceInCents
              }
            }
          }
          fileName
          partRevision {
            thumbnailUri
          }
          version
          quantityRangeStatus
        }
      }
    }
  }
}
    `;

/**
 * __useCostAndLeadTimeQuery__
 *
 * To run a query within a React component, call `useCostAndLeadTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCostAndLeadTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCostAndLeadTimeQuery({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useCostAndLeadTimeQuery(baseOptions: Apollo.QueryHookOptions<CostAndLeadTimeQuery, CostAndLeadTimeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CostAndLeadTimeQuery, CostAndLeadTimeQueryVariables>(CostAndLeadTimeDocument, options);
      }
export function useCostAndLeadTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CostAndLeadTimeQuery, CostAndLeadTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CostAndLeadTimeQuery, CostAndLeadTimeQueryVariables>(CostAndLeadTimeDocument, options);
        }
export type CostAndLeadTimeQueryHookResult = ReturnType<typeof useCostAndLeadTimeQuery>;
export type CostAndLeadTimeLazyQueryHookResult = ReturnType<typeof useCostAndLeadTimeLazyQuery>;
export type CostAndLeadTimeQueryResult = Apollo.QueryResult<CostAndLeadTimeQuery, CostAndLeadTimeQueryVariables>;
export function refetchCostAndLeadTimeQuery(variables: CostAndLeadTimeQueryVariables) {
      return { query: CostAndLeadTimeDocument, variables: variables }
    }
export const QueryDocument = gql`
    query Query {
  getAllBatchPostProcessIds
}
    `;

/**
 * __useQueryQuery__
 *
 * To run a query within a React component, call `useQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useQueryQuery(baseOptions?: Apollo.QueryHookOptions<QueryQuery, QueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryQuery, QueryQueryVariables>(QueryDocument, options);
      }
export function useQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryQuery, QueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryQuery, QueryQueryVariables>(QueryDocument, options);
        }
export type QueryQueryHookResult = ReturnType<typeof useQueryQuery>;
export type QueryLazyQueryHookResult = ReturnType<typeof useQueryLazyQuery>;
export type QueryQueryResult = Apollo.QueryResult<QueryQuery, QueryQueryVariables>;
export function refetchQueryQuery(variables?: QueryQueryVariables) {
      return { query: QueryDocument, variables: variables }
    }
export const GetQlltSlackThreadDocument = gql`
    query GetQlltSlackThread($quoteId: String!) {
  getQlltSlackThread(quoteId: $quoteId) {
    url
  }
}
    `;

/**
 * __useGetQlltSlackThreadQuery__
 *
 * To run a query within a React component, call `useGetQlltSlackThreadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQlltSlackThreadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQlltSlackThreadQuery({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useGetQlltSlackThreadQuery(baseOptions: Apollo.QueryHookOptions<GetQlltSlackThreadQuery, GetQlltSlackThreadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQlltSlackThreadQuery, GetQlltSlackThreadQueryVariables>(GetQlltSlackThreadDocument, options);
      }
export function useGetQlltSlackThreadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQlltSlackThreadQuery, GetQlltSlackThreadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQlltSlackThreadQuery, GetQlltSlackThreadQueryVariables>(GetQlltSlackThreadDocument, options);
        }
export type GetQlltSlackThreadQueryHookResult = ReturnType<typeof useGetQlltSlackThreadQuery>;
export type GetQlltSlackThreadLazyQueryHookResult = ReturnType<typeof useGetQlltSlackThreadLazyQuery>;
export type GetQlltSlackThreadQueryResult = Apollo.QueryResult<GetQlltSlackThreadQuery, GetQlltSlackThreadQueryVariables>;
export function refetchGetQlltSlackThreadQuery(variables: GetQlltSlackThreadQueryVariables) {
      return { query: GetQlltSlackThreadDocument, variables: variables }
    }
export const GetBusinessAccountFeatureDocument = gql`
    query GetBusinessAccountFeature($businessAccountId: UUID!, $featureName: BusinessAccountFeatureInput!) {
  getBusinessAccountFeature(
    businessAccountId: $businessAccountId
    featureName: $featureName
  ) {
    id
    businessAccountId
    featureName
    isEnabled
    updatedAt
  }
}
    `;

/**
 * __useGetBusinessAccountFeatureQuery__
 *
 * To run a query within a React component, call `useGetBusinessAccountFeatureQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessAccountFeatureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessAccountFeatureQuery({
 *   variables: {
 *      businessAccountId: // value for 'businessAccountId'
 *      featureName: // value for 'featureName'
 *   },
 * });
 */
export function useGetBusinessAccountFeatureQuery(baseOptions: Apollo.QueryHookOptions<GetBusinessAccountFeatureQuery, GetBusinessAccountFeatureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessAccountFeatureQuery, GetBusinessAccountFeatureQueryVariables>(GetBusinessAccountFeatureDocument, options);
      }
export function useGetBusinessAccountFeatureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessAccountFeatureQuery, GetBusinessAccountFeatureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessAccountFeatureQuery, GetBusinessAccountFeatureQueryVariables>(GetBusinessAccountFeatureDocument, options);
        }
export type GetBusinessAccountFeatureQueryHookResult = ReturnType<typeof useGetBusinessAccountFeatureQuery>;
export type GetBusinessAccountFeatureLazyQueryHookResult = ReturnType<typeof useGetBusinessAccountFeatureLazyQuery>;
export type GetBusinessAccountFeatureQueryResult = Apollo.QueryResult<GetBusinessAccountFeatureQuery, GetBusinessAccountFeatureQueryVariables>;
export function refetchGetBusinessAccountFeatureQuery(variables: GetBusinessAccountFeatureQueryVariables) {
      return { query: GetBusinessAccountFeatureDocument, variables: variables }
    }